
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kku53", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $054Kg = parcelRequire("054Kg");


var $fwDOR = parcelRequire("fwDOR");


var $hnvzE = parcelRequire("hnvzE");


var $l998X = parcelRequire("l998X");





var $2OtFZ = parcelRequire("2OtFZ");








var $dh538 = parcelRequire("dh538");





var $1yEFx = parcelRequire("1yEFx");


var $86ob4 = parcelRequire("86ob4");


var $ckkm9 = parcelRequire("ckkm9");

const $0e1691e3261af771$export$abd5de3aada5ec8b = ({ availableProducts: availableProducts, searchSessionId: searchSessionId })=>({
        eventType: 'track',
        action: 'availableProducts',
        actionSubject: 'searchPage',
        attributes: {
            additionalAttributes: {
                experienceName: 'search-page',
                availableProducts: availableProducts,
                availableProductsCount: availableProducts.length,
                searchSessionId: searchSessionId
            }
        }
    });



var $a5OFf = parcelRequire("a5OFf");


var $3CshZ = parcelRequire("3CshZ");


var $1nJM3 = parcelRequire("1nJM3");


var $gGFxq = parcelRequire("gGFxq");


var $j4ply = parcelRequire("j4ply");


var $NvPpA = parcelRequire("NvPpA");











var $bUlM5 = parcelRequire("bUlM5");

var $cwkWT = parcelRequire("cwkWT");

var $dcJ7R = parcelRequire("dcJ7R");












/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $8C5kA = parcelRequire("8C5kA");


var $4ymSL = parcelRequire("4ymSL");


var $auNCB = parcelRequire("auNCB");

const $6957b588b0d16361$export$f47dcf3d531e732f = ({ source: source, experiment: experiment, commonAttributes: commonAttributes, queryHash: queryHash, queryLength: queryLength, searchSessionId: searchSessionId, isHello: isHello, referrer: referrer })=>({
        source: source,
        eventType: 'ui',
        action: 'clicked',
        actionSubject: 'rovoNavigation',
        name: 'rovoNavigation',
        attributes: {
            commonAttributes: commonAttributes,
            queryHash: queryHash,
            queryLength: queryLength,
            searchSessionId: searchSessionId,
            isHello: isHello,
            referrer: referrer,
            additionalAttributes: {
                experiment: experiment
            }
        }
    });



var $26jni = parcelRequire("26jni");








var $4Qo4W = parcelRequire("4Qo4W");


var $djVCD = parcelRequire("djVCD");


var $a0M2t = parcelRequire("a0M2t");


var $3fzmz = parcelRequire("3fzmz");


var $cgtv4 = parcelRequire("cgtv4");

const $dad12d2a3779d6f3$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    buttonLabel: {
        id: "search-page.navigation.search.work-items",
        defaultMessage: "Search work items"
    }
});


const $e9ecd89ba2d8712f$var$REFERRER_PARAM = 'referrer=search-page'; // This is the default url when you use "Enter" on QF in Jira
const $e9ecd89ba2d8712f$var$NEW_ISSUE_NAVIGATOR_DEFAULT_URL = `/issues/?jql=${encodeURIComponent('created >= -30d order by created DESC')}&${$e9ecd89ba2d8712f$var$REFERRER_PARAM}`;
const $e9ecd89ba2d8712f$var$styles = {
    buttonLinkStyles: "_zulp12x7 _2rko12b0 _19itia51 _11c8fhey _4bfu1r31 _1hmsglyw _ajmmnqa1 _18zrutpp _1rjc1b66 _1e0c1txw _4cvr1h6o _syazazsu _c71lzwfg _1tkezwfg _bfhksm61 _o5721q9c _k48p1wq8 _p12f1178 _1053azsu _9oik1r31 _1bnxglyw _jf4cnqa1 _irr31dpa _30l3azsu"
};
const $e9ecd89ba2d8712f$export$7905e7d9062c8ee6 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const [searchQuery] = (0, $djVCD.useSearchQuery)();
    const [isHello] = (0, $j4ply.useIsHello)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const isPartOfJiraNinFpsExperiment = (0, $42omo.useMemo)(()=>(0, $26jni.serveJiraNinFpsNavigation)({
            primaryProduct: primaryProduct
        }) === 'control', [
        primaryProduct
    ]);
    const referrer = (0, $42omo.useMemo)(()=>{
        const params = new URLSearchParams(window.location.search);
        return params.get('referrer') || '';
    }, []);
    const href = (0, $42omo.useMemo)(()=>{
        const trimmedQuery = searchQuery.trim();
        try {
            if (trimmedQuery !== '') {
                const jql = (0, $3fzmz.buildJql)({
                    query: searchQuery,
                    projectARIs: [],
                    accountARIs: []
                });
                return `/issues/?jql=${jql}&${$e9ecd89ba2d8712f$var$REFERRER_PARAM}`;
            }
            return $e9ecd89ba2d8712f$var$NEW_ISSUE_NAVIGATOR_DEFAULT_URL;
        } catch  {
            return $e9ecd89ba2d8712f$var$NEW_ISSUE_NAVIGATOR_DEFAULT_URL;
        }
    }, [
        searchQuery
    ]);
    const onClick = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $6957b588b0d16361$export$f47dcf3d531e732f)({
            source: 'advancedSearchScreen',
            experiment: isPartOfJiraNinFpsExperiment ? 'control' : undefined,
            commonAttributes: commonAttributes,
            queryHash: (0, $a0M2t.sha256Hash)(searchQuery),
            queryLength: searchQuery.length,
            isHello: isHello,
            searchSessionId: searchSessionId,
            referrer: referrer
        }));
    }, [
        fireAnalyticsEvent,
        isPartOfJiraNinFpsExperiment,
        commonAttributes,
        searchQuery,
        isHello,
        searchSessionId,
        referrer
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $auNCB.default), {
        onClick: onClick,
        xcss: $e9ecd89ba2d8712f$var$styles.buttonLinkStyles,
        href: href,
        testId: "issue-navigator-cta",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ymSL))), {
                label: ""
            }),
            formatMessage((0, $dad12d2a3779d6f3$export$a7357cdd1f0b0168).buttonLabel)
        ]
    });
};

















/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 






var $u9agA = parcelRequire("u9agA");


var $5iakG = parcelRequire("5iakG");











var $gtD4K = parcelRequire("gtD4K");




var $ccHMk = parcelRequire("ccHMk");


var $ghftu = parcelRequire("ghftu");


var $lGgRw = parcelRequire("lGgRw");










var $2W0qg = parcelRequire("2W0qg");

var $1GzhS = parcelRequire("1GzhS");




var $4A7Gn = parcelRequire("4A7Gn");

var $0DTaW = parcelRequire("0DTaW");

var $k0WY4 = parcelRequire("k0WY4");


var $4EMbH = parcelRequire("4EMbH");











var $Y34Hw = parcelRequire("Y34Hw");


var $eoZmS = parcelRequire("eoZmS");


var $aRSt4 = parcelRequire("aRSt4");







const $e921223821c79c8f$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    allOptionVisualLabel: {
        id: "search-page.tab-filter.all-filter-visual-label",
        defaultMessage: "All"
    },
    allOptionAccessibleLabel: {
        id: "search-page.tab-filter.all-filter-accessible-label",
        defaultMessage: "Filter by all apps"
    },
    more: {
        id: "search-page.tab-filter.more-dropdown-label",
        defaultMessage: "More"
    },
    accessibleMoreMenuLabel: {
        id: "search-page.tab-filter.accessible-more-dropdown-label",
        defaultMessage: "Filter by more apps"
    }
});


/** The maximum number of visible tabs.
 * Higher number of app options will be rendered in a menu.
 */ const $782950564c4e1cfd$var$APP_OPTION_OVERFLOW = 4;
/**
 * The app filter.
 * Shows available products in tabs.
 */ const $782950564c4e1cfd$var$AppFilterTabsInline = ({ onSelectProduct: onSelectProduct, availableProducts: availableProducts, availableNouns: availableNouns, selectedProduct: selectedProduct, isNounsAvailable: isNounsAvailable, filterData: filterData, setAtlasNoun: setAtlasNoun, useOAuthHandlers: useOAuthHandlers, useIsUserOAuthed: useIsUserOAuthed, sideBySide: sideBySide, thirdPartyConfigs: thirdPartyConfigs })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const products = (0, $1yEFx.useProductConfigs)();
    let shouldShowNouns;
    const isWebCrawlerAvailable = availableProducts.includes((0, $1yEFx.ProductKeys).AtlassianWebCrawler);
    if (!isNounsAvailable) // Convoluting atlassian-web-crawler with nouns is a tech-debt, ideally it should be decoupled from nouns.
    shouldShowNouns = availableNouns.length > 0 || isWebCrawlerAvailable;
    else shouldShowNouns = isWebCrawlerAvailable || isNounsAvailable;
    const availableProductsWithoutAtlasAndCustomWebsitesIfNounsAvailable = shouldShowNouns ? availableProducts.filter((key)=>key !== (0, $1yEFx.ProductKeys).Atlas && key !== (0, $1yEFx.ProductKeys).AtlassianWebCrawler) : availableProducts;
    const { inlineOptions: inlineOptions, nestedOptions: nestedOptions } = (0, $42omo.useMemo)(()=>{
        let availableOptions = [
            ...availableProductsWithoutAtlasAndCustomWebsitesIfNounsAvailable
        ].filter((productKey)=>products[productKey]).sort((a, b)=>{
            const indexA = (0, $1yEFx.PRODUCTS_ORDER).indexOf(a);
            const indexB = (0, $1yEFx.PRODUCTS_ORDER).indexOf(b);
            if (indexA === -1 || indexB === -1) return 0;
            else return indexA - indexB;
        }).map((productKey)=>{
            const workspaceName = (0, $Y34Hw.getWorkspaceNameFromProduct)(productKey, thirdPartyConfigs);
            const label = workspaceName || products[productKey].displayName;
            const isSelected = productKey === selectedProduct;
            return {
                label: label,
                inlineLabel: label,
                value: productKey,
                isSelected: isSelected,
                inlineIsSelected: isSelected
            };
        });
        if (shouldShowNouns) {
            const nounsToDisplay = [
                ...availableNouns.filter((noun)=>noun !== (0, $4EMbH.NounKeys).AtlassianWebCrawler),
                ...isWebCrawlerAvailable ? [
                    (0, $1yEFx.ProductKeys).AtlassianWebCrawler
                ] : []
            ].sort((a, b)=>(0, $4EMbH.NOUNS_ORDER).indexOf(a) - (0, $4EMbH.NOUNS_ORDER).indexOf(b));
            const availableNounOptions = nounsToDisplay.map((noun)=>{
                const isAtlasSelected = selectedProduct === (0, $1yEFx.ProductKeys).Atlas;
                const isWebCrawlerSelected = selectedProduct === (0, $1yEFx.ProductKeys).AtlassianWebCrawler;
                const isSelected = (isWebCrawlerSelected && noun === (0, $4EMbH.NounKeys).AtlassianWebCrawler || isAtlasSelected && filterData?.options.find((option)=>option.queryParamValue === noun)?.isSelected) ?? false;
                const label = formatMessage((0, $4EMbH.nouns)[noun].displayNamePlural);
                return {
                    label: label,
                    inlineLabel: label,
                    value: noun,
                    isSelected: isSelected,
                    inlineIsSelected: isSelected
                };
            });
            availableOptions.push(...availableNounOptions);
        }
        return $782950564c4e1cfd$var$splitAppOptions(availableOptions, availableOptions.findIndex((option)=>option.isSelected));
    }, [
        availableNouns,
        availableProductsWithoutAtlasAndCustomWebsitesIfNounsAvailable,
        filterData?.options,
        formatMessage,
        isWebCrawlerAvailable,
        products,
        selectedProduct,
        shouldShowNouns,
        thirdPartyConfigs
    ]);
    const inlineSelectedIndex = (0, $42omo.useMemo)(()=>{
        return inlineOptions.findIndex((option)=>option.isSelected);
    }, [
        inlineOptions
    ]);
    const onSelectTab = (productOrNounKey)=>{
        if (!productOrNounKey || productOrNounKey in products) onSelectProduct(productOrNounKey);
        else if (productOrNounKey in (0, $4EMbH.nouns)) setAtlasNoun(productOrNounKey);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
        space: "space.100",
        alignBlock: "center",
        grow: "fill",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4A7Gn.default), {
            id: "app-filters-tabs",
            selected: inlineSelectedIndex + 1,
            onChange: (tabIndex)=>{
                if (tabIndex === 0) {
                    onSelectTab(undefined); // user selected "All"
                    return;
                }
                const changedOption = inlineOptions[tabIndex - 1]; // index 0 is "All"
                if (!changedOption) return;
                onSelectTab(changedOption.value);
            },
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $0DTaW.default), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)($782950564c4e1cfd$var$FilterTab, {
                        productOrNounKey: undefined,
                        "aria-label": formatMessage((0, $e921223821c79c8f$export$defe85febe8b728c).allOptionAccessibleLabel),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $e921223821c79c8f$export$defe85febe8b728c).allOptionVisualLabel
                        })
                    }),
                    inlineOptions.map((option)=>{
                        const isSmartlink = (0, $a5OFf.isProductSmartlink)({
                            productKey: option.value,
                            thirdPartyConfigs: thirdPartyConfigs
                        });
                        return /*#__PURE__*/ (0, $l998X.jsx)((0, $eoZmS.OAuthWarningWrapper), {
                            datasourceId: option.datasourceId,
                            isInline: true,
                            product: option.value,
                            trigger: ({ oAuthWarning: oAuthWarning, isDisabled: isDisabled, triggerProps: triggerProps })=>/*#__PURE__*/ (0, $l998X.jsxs)($782950564c4e1cfd$var$FilterTab, {
                                    triggerProps: triggerProps,
                                    isDisabled: isDisabled,
                                    productOrNounKey: option.value,
                                    children: [
                                        option.inlineLabel,
                                        oAuthWarning
                                    ]
                                }, option.value),
                            useOAuthHandlers: useOAuthHandlers,
                            useIsUserOAuthed: useIsUserOAuthed,
                            isSmartlink: isSmartlink,
                            oAuthSource: (0, $ckkm9.OAuthSource).searchPageFilter,
                            thirdPartyConfigs: thirdPartyConfigs
                        }, option.value);
                    }),
                    nestedOptions.length > 0 && /*#__PURE__*/ (0, $l998X.jsx)($782950564c4e1cfd$var$MoreAppsButton, {
                        nestedOptions: nestedOptions,
                        onSelectTab: onSelectTab,
                        sideBySide: sideBySide,
                        useOAuthHandlers: useOAuthHandlers,
                        useIsUserOAuthed: useIsUserOAuthed,
                        thirdPartyConfigs: thirdPartyConfigs
                    })
                ]
            })
        })
    });
};
const $782950564c4e1cfd$var$tabsTypography = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $782950564c4e1cfd$var$filterTabStyles = (0, $ecnYn.xcss)({
    background: 'none',
    ':hover': {
        background: 'none'
    }
});
const $782950564c4e1cfd$var$filterTextStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    paddingRight: 'space.025'
});
const $782950564c4e1cfd$var$filterNounTestStyles = (0, $ecnYn.xcss)({
    paddingBottom: 'space.025'
});
const $782950564c4e1cfd$var$moreAppsMenuStyles = (0, $ecnYn.xcss)({
    width: '330px'
});
const $782950564c4e1cfd$var$moreAppsMenuButtonStyles = (0, $ecnYn.xcss)({
    width: '100%'
});
const $782950564c4e1cfd$var$FilterTab = ({ productOrNounKey: productOrNounKey, children: children, isDisabled: isOnClickDisabled, triggerProps: triggerProps, ...pressableProps })=>{
    const tabAttrs = (0, $k0WY4.useTab)();
    const onClick = isOnClickDisabled ? ()=>{} : tabAttrs.onClick;
    const isNounFilter = !!productOrNounKey && !!(0, $4EMbH.nouns)[productOrNounKey];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
        xcss: [
            $782950564c4e1cfd$var$filterTabStyles,
            $782950564c4e1cfd$var$tabsTypography
        ],
        ...pressableProps,
        ...tabAttrs,
        onClick: onClick,
        ...triggerProps,
        "aria-controls": undefined,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
            alignItems: "center",
            gap: "space.050",
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    productOrNounKey && /*#__PURE__*/ (0, $l998X.jsx)((0, $aRSt4.ProductOrNounIcon), {
                        label: "",
                        size: "small",
                        productOrNounKey: productOrNounKey
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: [
                            isNounFilter && $782950564c4e1cfd$var$filterNounTestStyles,
                            $782950564c4e1cfd$var$filterTextStyles
                        ],
                        children: children
                    })
                ]
            })
        })
    });
};
const $782950564c4e1cfd$var$MoreAppsMenu = ({ options: options, onSelectTab: onSelectTab, useOAuthHandlers: useOAuthHandlers, useIsUserOAuthed: useIsUserOAuthed, thirdPartyConfigs: thirdPartyConfigs })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $782950564c4e1cfd$var$moreAppsMenuStyles,
        padding: "space.100",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1GzhS.default), {
            space: "space.050",
            children: options.map((option)=>{
                const isSmartlink = (0, $a5OFf.isProductSmartlink)({
                    productKey: option.value,
                    thirdPartyConfigs: thirdPartyConfigs
                });
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $eoZmS.OAuthWarningWrapper), {
                    datasourceId: option.datasourceId,
                    product: option.value,
                    trigger: ({ isDisabled: isDisabled, oAuthWarning: oAuthWarning, triggerProps: triggerProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                            xcss: $782950564c4e1cfd$var$moreAppsMenuButtonStyles,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                shouldFitContainer: true,
                                appearance: "subtle",
                                onClick: ()=>{
                                    !isDisabled && onSelectTab(option.value);
                                },
                                iconBefore: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $aRSt4.ProductOrNounIcon), {
                                        label: "",
                                        size: "small",
                                        productOrNounKey: option.value
                                    }),
                                ...triggerProps,
                                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
                                    templateColumns: "1fr auto",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
                                            alignInline: "start",
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                                paddingInlineStart: "space.050",
                                                children: option.label
                                            })
                                        }),
                                        oAuthWarning
                                    ]
                                })
                            }, option.value)
                        }),
                    useOAuthHandlers: useOAuthHandlers,
                    useIsUserOAuthed: useIsUserOAuthed,
                    isSmartlink: isSmartlink,
                    oAuthSource: (0, $ckkm9.OAuthSource).searchPageFilter,
                    thirdPartyConfigs: thirdPartyConfigs
                });
            })
        })
    });
};
const $782950564c4e1cfd$var$MoreAppsButton = ({ nestedOptions: nestedOptions, onSelectTab: onSelectTab, useOAuthHandlers: useOAuthHandlers, useIsUserOAuthed: useIsUserOAuthed, thirdPartyConfigs: thirdPartyConfigs, sideBySide: sideBySide })=>{
    const tabAttrs = (0, $k0WY4.useTab)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const renderContent = ()=>sideBySide ? /*#__PURE__*/ (0, $l998X.jsx)($782950564c4e1cfd$var$MoreAppsMenu, {
            options: nestedOptions,
            onSelectTab: (value)=>{
                onSelectTab(value);
                setIsOpen(false);
            },
            useOAuthHandlers: useOAuthHandlers,
            useIsUserOAuthed: useIsUserOAuthed,
            thirdPartyConfigs: thirdPartyConfigs
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $86ob4.Hide), {
            target: "layout",
            above: "sm",
            children: /*#__PURE__*/ (0, $l998X.jsx)($782950564c4e1cfd$var$MoreAppsMenu, {
                options: nestedOptions,
                onSelectTab: (value)=>{
                    onSelectTab(value);
                    setIsOpen(false);
                },
                useOAuthHandlers: useOAuthHandlers,
                useIsUserOAuthed: useIsUserOAuthed,
                thirdPartyConfigs: thirdPartyConfigs
            })
        });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        content: renderContent,
        placement: "bottom-start",
        shouldRenderToParent: true,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
                xcss: [
                    $782950564c4e1cfd$var$filterTabStyles,
                    $782950564c4e1cfd$var$tabsTypography
                ],
                "aria-label": formatMessage((0, $e921223821c79c8f$export$defe85febe8b728c).accessibleMoreMenuLabel),
                ...tabAttrs,
                ...triggerProps,
                onClick: ()=>setIsOpen(!isOpen),
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                    alignItems: "center",
                    gap: "space.100",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $e921223821c79c8f$export$defe85febe8b728c).more
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                            color: "currentColor",
                            label: "",
                            size: "small"
                        })
                    ]
                })
            })
    });
};
const $782950564c4e1cfd$var$splitAppOptions = (appOptions, selectedIndex)=>{
    let inlineOptions = appOptions.slice(0, $782950564c4e1cfd$var$APP_OPTION_OVERFLOW);
    // if the selected item isn't in the inline options, replace the last item
    if (selectedIndex >= 0 && !inlineOptions.find((inline)=>inline.value === appOptions[selectedIndex].value)) {
        inlineOptions = appOptions.slice(0, $782950564c4e1cfd$var$APP_OPTION_OVERFLOW - 1);
        inlineOptions.push(appOptions[selectedIndex]);
    }
    // The nestedOptions is then simply the filter of the whole list by what is shown inline
    let inlineValues = inlineOptions.map((i)=>i.value);
    const nestedOptions = appOptions.filter((a)=>!inlineValues.includes(a.value));
    return {
        inlineOptions: inlineOptions,
        nestedOptions: nestedOptions
    };
};
var $782950564c4e1cfd$export$2e2bcd8739ae039 = $782950564c4e1cfd$var$AppFilterTabsInline;






var $7sS82 = parcelRequire("7sS82");

const $9afb3d504f643405$export$f0fed4b0765d7314 = ()=>{
    try {
        return (0, $7sS82.useIntercom)();
    } catch (err) {
        return;
    }
};






var $5cssW = parcelRequire("5cssW");













/**
 * Render search page product filters as tabs.
 */ const $e4fe1f08c79fe0b9$var$AppFilterInline = ()=>{
    const [{ products: availableProducts, nouns: availableNouns, thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [isNounsAvailable] = (0, $j4ply.useIsNounsAvailable)();
    const [universalTypeFilterData] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $5iakG.universalTypeFilterId)
    });
    const { selectProductFilter: selectProductFilter, unselectProductFilter: unselectProductFilter, unsafe_setAtlasNouns: unsafe_setAtlasNouns } = (0, $djVCD.useSearchActions)();
    const intercom = (0, $9afb3d504f643405$export$f0fed4b0765d7314)();
    const [features] = (0, $4Qo4W.useFeatures)();
    // Trigger an exposure once when the component is mounted.
    (0, $42omo.useEffect)(()=>{
        (0, $2OtFZ.triggerExposureForRightRailImprovements)();
    }, []);
    const appFilterProps = (0, $42omo.useMemo)(()=>({
            sideBySide: features?.sideBySide?.enabled,
            availableProducts: availableProducts,
            availableNouns: availableNouns,
            selectedProduct: selectedProduct,
            isNounsAvailable: isNounsAvailable,
            filterData: universalTypeFilterData,
            setAtlasNoun: unsafe_setAtlasNouns,
            onSelectProduct: (newProduct)=>{
                if (newProduct === selectedProduct) // do nothing when the same product is selected
                return;
                if (!newProduct && selectedProduct) {
                    unselectProductFilter();
                    return;
                }
                selectProductFilter(newProduct);
                if (newProduct && (0, $1yEFx.is3pProductKey)(newProduct)) intercom?.trackEvent('product_filter_clicked_3p', {
                    product_filter: newProduct
                });
                else intercom?.trackEvent('product_filter_clicked', {
                    product_filter: newProduct
                });
            },
            useOAuthHandlers: $gGFxq.useOAuthHandlers,
            useIsUserOAuthed: $gGFxq.useIsUserOAuthed,
            thirdPartyConfigs: thirdPartyConfigs
        }), [
        features,
        availableProducts,
        availableNouns,
        selectedProduct,
        isNounsAvailable,
        universalTypeFilterData,
        unsafe_setAtlasNouns,
        selectProductFilter,
        unselectProductFilter,
        intercom,
        thirdPartyConfigs
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        space: "space.100",
        shouldWrap: true,
        grow: "fill",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
            section: "SearchPageAppFilterInline",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $782950564c4e1cfd$export$2e2bcd8739ae039), {
                ...appFilterProps
            })
        })
    });
};
var $e4fe1f08c79fe0b9$export$2e2bcd8739ae039 = $e4fe1f08c79fe0b9$var$AppFilterInline;





parcelRequire("42omo");






const $219be4dffff6bd41$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    gap: 'space.100',
    paddingTop: 'space.100'
});
const $219be4dffff6bd41$var$filterStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: 'radius.small',
    height: 'size.300',
    width: 'size.600'
});
const $219be4dffff6bd41$export$d5722e1c0b3e12f1 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $219be4dffff6bd41$var$containerStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $219be4dffff6bd41$var$filterStyles
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $219be4dffff6bd41$var$filterStyles
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $219be4dffff6bd41$var$filterStyles
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $219be4dffff6bd41$var$filterStyles
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $219be4dffff6bd41$var$filterStyles
            })
        ]
    });
};



var $ayBYg = parcelRequire("ayBYg");

const $99686144b211a11b$var$filterRowStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    position: 'relative',
    paddingBlock: 'space.050',
    paddingInline: 'space.050'
});
const $99686144b211a11b$var$Filters = ()=>{
    const [bootstrapLoading] = (0, $j4ply.useBootstrapLoading)();
    const [features] = (0, $4Qo4W.useFeatures)();
    const filterContainerRef = (0, $42omo.useRef)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    if (bootstrapLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
        name: "search-page-filters-loading",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $219be4dffff6bd41$export$d5722e1c0b3e12f1), {})
    });
    const productFiltersWithClear = /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
        space: "space.100",
        ref: filterContainerRef,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
            name: "search-page-product-filters",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ayBYg.default), {
                containerRef: filterContainerRef
            })
        })
    });
    // Side by side always gets the "responsive below sm" version
    if (features?.sideBySide?.enabled) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
        direction: "column",
        gap: "space.200",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
                name: "search-page-sbs-app-filter-inline",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e4fe1f08c79fe0b9$export$2e2bcd8739ae039), {})
            }),
            productFiltersWithClear
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
        templateColumns: "1fr auto",
        alignItems: "center",
        gap: "space.150",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                direction: "column",
                gap: "space.200",
                xcss: $99686144b211a11b$var$filterRowStyles,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $86ob4.Hide), {
                        target: "layout",
                        above: "sm",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
                            name: "search-page-app-filter-inline",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e4fe1f08c79fe0b9$export$2e2bcd8739ae039), {})
                        })
                    }),
                    productFiltersWithClear
                ]
            }),
            // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $dh538.fg)('rovo_fps_nin_cta') && ((0, $26jni.serveJiraNinFpsNavigation)({
                primaryProduct: primaryProduct
            }) === 'control' || !(0, $26jni.serveJiraNinFpsNavigation)({
                primaryProduct: primaryProduct
            })) && primaryProduct === (0, $1yEFx.ProductKeys).Jira && /*#__PURE__*/ (0, $l998X.jsx)((0, $e9ecd89ba2d8712f$export$7905e7d9062c8ee6), {})
        ]
    });
};
const $99686144b211a11b$var$FiltersWithErrorBoundary = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
        section: "SearchPageFilters",
        children: /*#__PURE__*/ (0, $l998X.jsx)($99686144b211a11b$var$Filters, {})
    });
};
var $99686144b211a11b$export$2e2bcd8739ae039 = $99686144b211a11b$var$FiltersWithErrorBoundary;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $fFa3V = parcelRequire("fFa3V");













var $icqFF = parcelRequire("icqFF");


var $6yNqK = parcelRequire("6yNqK");

const $c8c12c8e63822f48$export$900d08b010253a5e = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'ui',
        actionSubject: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}Dropdown`,
        action: 'closed',
        attributes: {
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });





const $94068ad8452530ec$export$c8d721b69c7e30be = ({ commonAttributes: commonAttributes })=>({
        name: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}Dropdown`,
        attributes: {
            commonAttributes: commonAttributes
        }
    });









var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $25a8b9613a265659$export$d4c72bab9d6cc13a = {
    showDropdown: false,
    dropdownLoading: true,
    activeQueryFilterId: '',
    prefetchedRecentViewsResults: undefined,
    prefetchedRecentSearchResults: [],
    peopleAndTeamsResults: {
        results: [],
        duration: -1
    },
    recentViewsResults: [],
    autoSuggestionResults: {
        results: [],
        duration: -1
    },
    recentSearchResults: [],
    resultCount: {
        peopleAndTeams: 0,
        autoSuggestion: 0,
        recentSearch: 0,
        recentViews: 0
    },
    selectedInputFilters: []
};
const $25a8b9613a265659$var$actions = {
    setShowDropdown: (showDropdown)=>({ setState: setState })=>{
            setState({
                showDropdown: showDropdown
            });
        },
    setDropdownLoading: (dropdownLoading)=>({ setState: setState })=>{
            setState({
                dropdownLoading: dropdownLoading
            });
        },
    setActiveQueryFilterId: (activeQueryFilterId)=>({ setState: setState })=>{
            setState({
                activeQueryFilterId: activeQueryFilterId
            });
        },
    setPeopleAndTeamsResults: (peopleAndTeamsResults)=>({ setState: setState })=>{
            setState({
                peopleAndTeamsResults: peopleAndTeamsResults
            });
        },
    setRecentViewsResults: (recentViewsResults)=>({ setState: setState })=>{
            setState({
                recentViewsResults: recentViewsResults
            });
        },
    setAutoSuggestionResults: (autoSuggestionResults)=>({ setState: setState })=>{
            setState({
                autoSuggestionResults: autoSuggestionResults
            });
        },
    setRecentSearchResults: (recentSearchResults)=>({ setState: setState })=>{
            setState({
                recentSearchResults: recentSearchResults
            });
        },
    setResultCount: (resultCount)=>({ setState: setState })=>{
            setState({
                resultCount: resultCount
            });
        },
    setPrefetchedRecentViewsResults: (prefetchedRecentViewsResults)=>({ setState: setState })=>{
            setState({
                prefetchedRecentViewsResults: prefetchedRecentViewsResults
            });
        },
    setPrefetchedRecentSearchResults: (prefetchedRecentSearchResults)=>({ setState: setState })=>{
            setState({
                prefetchedRecentSearchResults: prefetchedRecentSearchResults
            });
        },
    setSelectedInputFilters: (selectedInputFilters)=>({ setState: setState })=>{
            setState({
                selectedInputFilters: selectedInputFilters
            });
        }
};
// Keep store private and use hooks to access state and actions
const $25a8b9613a265659$var$Store = (0, $1P1Tu.createStore)({
    initialState: $25a8b9613a265659$export$d4c72bab9d6cc13a,
    actions: $25a8b9613a265659$var$actions,
    name: 'dropdown'
});
const $25a8b9613a265659$export$4e8b5ffe8cfc8886 = (0, $9zUhf.createActionsHook)($25a8b9613a265659$var$Store);
const $25a8b9613a265659$export$8c32fdb3462273b4 = (0, $9zUhf.createHook)($25a8b9613a265659$var$Store, {
    selector: (state)=>state.showDropdown
});
const $25a8b9613a265659$export$41ba39ed718e7414 = (0, $9zUhf.createHook)($25a8b9613a265659$var$Store, {
    selector: (state)=>state.dropdownLoading
});
const $25a8b9613a265659$export$988aa64982b6032c = (0, $9zUhf.createHook)($25a8b9613a265659$var$Store, {
    selector: (state)=>state.activeQueryFilterId
});
const $25a8b9613a265659$export$c30c238644aa02ee = (0, $9zUhf.createHook)($25a8b9613a265659$var$Store, {
    selector: (state)=>state.peopleAndTeamsResults
});
const $25a8b9613a265659$export$f53e0f96bec5ea4d = (0, $9zUhf.createHook)($25a8b9613a265659$var$Store, {
    selector: (state)=>state.recentViewsResults
});
const $25a8b9613a265659$export$30ecbc19a2297251 = (0, $9zUhf.createHook)($25a8b9613a265659$var$Store, {
    selector: (state)=>state.autoSuggestionResults
});
const $25a8b9613a265659$export$970bfa0ee111b06 = (0, $9zUhf.createHook)($25a8b9613a265659$var$Store, {
    selector: (state)=>state.recentSearchResults
});
const $25a8b9613a265659$export$22da568447791223 = (0, $9zUhf.createHook)($25a8b9613a265659$var$Store, {
    selector: (state)=>state.resultCount
});
const $25a8b9613a265659$export$a7f7068aa342db89 = (0, $9zUhf.createHook)($25a8b9613a265659$var$Store, {
    selector: (state)=>state.prefetchedRecentViewsResults
});
const $25a8b9613a265659$export$8fdf7942b5f23117 = (0, $9zUhf.createHook)($25a8b9613a265659$var$Store, {
    selector: (state)=>state.prefetchedRecentSearchResults
});
const $25a8b9613a265659$export$5a795cafef59146c = (0, $9zUhf.createHook)($25a8b9613a265659$var$Store, {
    selector: (state)=>state.selectedInputFilters
});



var $f8oYd = parcelRequire("f8oYd");







parcelRequire("42omo");


var $1SV4e = parcelRequire("1SV4e");


var $jjjIy = parcelRequire("jjjIy");

const $62cf4e492e3f8cd7$export$7a283d45f414521b = (primaryProduct, userId)=>{
    if (userId && primaryProduct) {
        const recentSearches = (0, $1SV4e.getRecentSearches)(userId, primaryProduct, (0, $1SV4e.RECENT_SEARCH_KEY)).map((searchTitle)=>({
                title: searchTitle,
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
                onClick: ()=>null
            }));
        return recentSearches;
    }
    return [];
};
const $62cf4e492e3f8cd7$export$9770ca05e8d4f1fe = (recentSearches, inputQuery)=>{
    if (inputQuery.length === 0) return recentSearches;
    return (0, $jjjIy.filterSearchResultsWithHighlighting)(recentSearches, inputQuery, inputQuery.length < 3 ? 3 : 2, true);
};



var $ja8yA = parcelRequire("ja8yA");











var $2v58P = parcelRequire("2v58P");


var $5yCDo = parcelRequire("5yCDo");


var $hWR4v = parcelRequire("hWR4v");


var $3E8x9 = parcelRequire("3E8x9");







/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ // Copied from confluence/next/packages/navigation-search-dialog/src/suppliers/utils/ConfluenceResultMeta.tsx







var $gMc0m = parcelRequire("gMc0m");





var $3ro6F = parcelRequire("3ro6F");

var $kGnTD = parcelRequire("kGnTD");





var $gzcCN = parcelRequire("gzcCN");




const $e404dc00fe6cf4ff$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    liveDoc: {
        id: "live_doc_type",
        defaultMessage: "Live Doc"
    }
});


const $3f5fa33f99028861$var$ConfluenceResultMetaWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx2vrvc _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $3f5fa33f99028861$var$BreadcrumbsWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_ca0qv77o _1yijwadc _1xbjidpf _1gmmidpf _fggvidpf _86yhidpf _95px1osq _fu36glyw _1bir1h6o _n1rrwadc _gyc2idpf _uzb6idpf _jnu2idpf _2gatidpf _1jn1glyw _1t771h6o _19301osq _1700idpf _10kk1b66 _ceouidpf _rq3g1b66 _1iev1y44 _1hjc1q9c _1bf67vkz",
            __cmplp.className
        ])
    });
});
const $3f5fa33f99028861$var$ConfluenceTypeWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_syazazsu _1p1d1dk0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3f5fa33f99028861$var$ConfluenceMetaSpacerWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_syazazsu _19pkidpf _2hwx1b66 _otyridpf _18u01b66",
            __cmplp.className
        ])
    });
});
const $3f5fa33f99028861$export$9138e703d4b4585b = ({ resultContentType: resultContentType, resultContentSubtype: resultContentSubtype, resultAncestors: resultAncestors, resultSpace: resultSpace })=>{
    const breadcrumbs = $3f5fa33f99028861$export$ed9f69ac7e699c53(resultAncestors, resultSpace);
    const isLiveDoc = resultContentSubtype === (0, $gzcCN.SearchConfluenceSubtype).LIVE && (0, $dh538.fg)('confluence_live_pages_open_beta_trait_opted_in');
    return /*#__PURE__*/ (0, $l998X.jsxs)($3f5fa33f99028861$var$ConfluenceResultMetaWrapper, {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($3f5fa33f99028861$var$ConfluenceTypeWrapper, {
                children: "Confluence"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($3f5fa33f99028861$var$ConfluenceMetaSpacerWrapper, {
                children: "\u2022"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($3f5fa33f99028861$var$ConfluenceTypeWrapper, {
                children: isLiveDoc ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $e404dc00fe6cf4ff$export$defe85febe8b728c).liveDoc
                }) : resultContentType
            }),
            breadcrumbs?.length && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)($3f5fa33f99028861$var$ConfluenceMetaSpacerWrapper, {
                        children: "\u2022"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)($3f5fa33f99028861$var$BreadcrumbsWrapper, {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kGnTD.default), {
                            maxItems: 2,
                            isExpanded: false,
                            onExpand: (e)=>e.preventDefault(),
                            children: breadcrumbs.map(({ id: id, title: title }, itemIndex)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3ro6F.default), {
                                    text: title || '',
                                    truncationWidth: itemIndex === breadcrumbs.length - 1 || itemIndex === 0 ? 130 : 50
                                }, id))
                        })
                    })
                ]
            })
        ]
    });
};
const $3f5fa33f99028861$export$ed9f69ac7e699c53 = (ancestors, space)=>{
    let breadcrumbs = [];
    if (space) {
        const spaceBreadcrumb = {
            id: space?.id,
            title: space?.name
        };
        if (!ancestors || ancestors.length === 0) breadcrumbs = [
            spaceBreadcrumb
        ];
        else if (ancestors.length >= 1) breadcrumbs = [
            spaceBreadcrumb,
            ...ancestors.slice(1)
        ];
    }
    return breadcrumbs;
};


const $f99740509791cca4$var$CONTEXT_PATH = '/wiki/spaces';
const $f99740509791cca4$export$7192bcb9a5864aaa = (edge, thirdPartyConfigs)=>{
    const item = edge.node;
    const iconLabel = `${item.object.product} ${item.object.type}`;
    if ((0, $hWR4v.is1PActivity)(item.object)) switch(item.object.product){
        case 'jira':
            return {
                title: `${item.object.data?.key}: ${(item.object.data?.fieldsById?.edges || [
                    {}
                ])[0].node?.text}` || '',
                description: `Jira ${item.object.type}`,
                subheading: /*#__PURE__*/ (0, $l998X.jsx)((0, $3E8x9.EventTypeMessage), {
                    timestamp: item.event.timestamp,
                    eventType: item.event.eventType,
                    isMyActivityData: true
                }),
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $2v58P.default), {
                    label: iconLabel
                }),
                onClick: ()=>{},
                navigationUrl: item.object.data?.webUrl || ''
            };
        case 'confluence':
            return {
                title: item.object.data?.title || '',
                description: /*#__PURE__*/ (0, $l998X.jsx)((0, $3f5fa33f99028861$export$9138e703d4b4585b), {
                    resultContentType: item.object.type,
                    resultContentSubtype: item.object.data?.subtype,
                    resultAncestors: item.object.data?.ancestors,
                    resultSpace: item.object.data?.space
                }),
                subheading: /*#__PURE__*/ (0, $l998X.jsx)((0, $3E8x9.EventTypeMessage), {
                    timestamp: item.event.timestamp,
                    eventType: item.event.eventType,
                    isMyActivityData: true
                }),
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $5yCDo.default), {
                    label: iconLabel
                }),
                onClick: ()=>{},
                navigationUrl: `${item.object.data?.links?.base || $f99740509791cca4$var$CONTEXT_PATH}${item.object.data?.links?.webUi || ''}`
            };
        case 'townsquare':
            return {
                title: `${item.object.data?.key}: ${item.object.data?.name}` || '',
                description: `Atlas ${item.object.type}`,
                subheading: /*#__PURE__*/ (0, $l998X.jsx)((0, $3E8x9.EventTypeMessage), {
                    timestamp: item.event.timestamp,
                    eventType: item.event.eventType,
                    isMyActivityData: true
                }),
                icon: /*#__PURE__*/ (0, $l998X.jsx)("img", {
                    width: 24,
                    height: 24,
                    src: item.object.data?.iconData || '',
                    alt: `${item.object.product} ${item.object.type}`
                }),
                onClick: ()=>{},
                navigationUrl: item.object.data?.url || '',
                meta: `Atlas ${item.object.type}`
            };
        default:
            return {
                title: '',
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
                onClick: ()=>{
                    return;
                }
            };
    }
    else if ((0, $hWR4v.isGraphActivity)(item.object)) {
        if ((0, $hWR4v.isDocumentActivity)(item.object)) {
            const providerId = item.object.data?.provider?.providerId;
            const product = (0, $Y34Hw.getProductFromProviderId)(thirdPartyConfigs, providerId);
            return {
                title: `${item.object.data?.displayName}` || '',
                description: `${product} ${item.object.data?.type?.category}`,
                subheading: /*#__PURE__*/ (0, $l998X.jsx)((0, $3E8x9.EventTypeMessage), {
                    timestamp: item.event.timestamp,
                    eventType: item.event.eventType,
                    isMyActivityData: true
                }),
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $aRSt4.ProductIcon), {
                    size: "small",
                    product: product
                }),
                onClick: ()=>{},
                navigationUrl: item.object.data?.url || ''
            };
        } else return {
            title: '',
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
            onClick: ()=>{
                return;
            }
        };
    } else return {
        title: '',
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
        onClick: ()=>{
            return;
        }
    };
};


const $f4f28935e73c0254$export$ba7d28c6aa777ec8 = async (cloudId, onError, thirdPartyConfigs)=>{
    const fetchData = async (filteredProducts, filteredObjectTypes, filteredRootContainerIds, filteredEventTypes, itemsLimit)=>{
        const response = await (0, $ja8yA.recentActivitiesQuery)({
            variables: {
                filteredProducts: filteredProducts,
                filteredObjectTypes: filteredObjectTypes,
                filteredEventTypes: filteredEventTypes,
                filteredRootContainerIds: filteredRootContainerIds,
                itemsLimit: itemsLimit
            }
        }).catch((error)=>{
            onError(error);
        });
        const data = response && response.data;
        const edges = data?.activity?.myActivity?.all?.edges || [];
        return edges?.filter((edge)=>edge.node?.object?.data).map((edge)=>(0, $f99740509791cca4$export$7192bcb9a5864aaa)(edge, thirdPartyConfigs));
    };
    return await fetchData([
        'confluence',
        'jira',
        'townsquare'
    ], [
        'page',
        'issue',
        'project'
    ], [
        `ari:cloud:platform::site/${cloudId}`,
        `ari:cloud:townsquare::site/${cloudId}`
    ], [], 200);
};
const $f4f28935e73c0254$export$c8394dd336252c18 = (recentViews, inputQuery)=>{
    if (inputQuery.length === 0) return recentViews;
    return recentViews && (0, $jjjIy.filterSearchResultsWithHighlighting)(recentViews, inputQuery);
};


const $4219044a34e95c55$export$11133d09694420f7 = ()=>{
    const [{ user: user, primaryProduct: primaryProduct, cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const { setPrefetchedRecentSearchResults: setPrefetchedRecentSearchResults, setPrefetchedRecentViewsResults: setPrefetchedRecentViewsResults } = (0, $25a8b9613a265659$export$4e8b5ffe8cfc8886)();
    const viewsResultsFetched = (0, $42omo.useRef)(false);
    const searchResultsFetched = (0, $42omo.useRef)(false);
    const logException = (0, $f8oYd.useLogException)();
    (0, $42omo.useEffect)(()=>{
        async function fetchRecentViewsResults() {
            // Only fetch once
            if (!cloudId || viewsResultsFetched.current) return;
            viewsResultsFetched.current = true;
            const recentViewsResults = await (0, $f4f28935e73c0254$export$ba7d28c6aa777ec8)(cloudId, logException, thirdPartyConfigs);
            setPrefetchedRecentViewsResults(recentViewsResults);
        }
        fetchRecentViewsResults();
    }, [
        setPrefetchedRecentViewsResults,
        cloudId,
        logException,
        thirdPartyConfigs
    ]);
    (0, $42omo.useEffect)(()=>{
        if (searchResultsFetched.current) return;
        searchResultsFetched.current = true;
        const recentSearchResults = (0, $62cf4e492e3f8cd7$export$7a283d45f414521b)(primaryProduct, user?.id);
        if (recentSearchResults.length > 0) setPrefetchedRecentSearchResults(recentSearchResults);
    }, [
        primaryProduct,
        user,
        setPrefetchedRecentSearchResults
    ]);
};























parcelRequire("42omo");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss



parcelRequire("42omo");






const $901e25dc7e018c2c$var$searchLinkWithDescriptionStyles = (0, $ecnYn.xcss)({
    width: 'fill',
    padding: 'space.100',
    display: 'grid',
    columnGap: 'space.100',
    gridTemplateColumns: 'auto 1fr',
    gridTemplateAreas: `
    "icon title"
    "icon description"
  `,
    alignItems: 'center',
    height: '50px',
    borderRadius: 'radius.large'
});
const $901e25dc7e018c2c$var$iconSkeleton = (0, $ecnYn.xcss)({
    gridArea: 'icon',
    backgroundColor: 'color.background.neutral',
    width: '24px',
    height: '24px',
    borderRadius: 'radius.xsmall'
});
const $901e25dc7e018c2c$var$titleSkeleton = (0, $ecnYn.xcss)({
    gridArea: 'title',
    backgroundColor: 'color.background.neutral',
    width: '260px',
    height: '14px',
    borderRadius: 'radius.xsmall'
});
const $901e25dc7e018c2c$var$descriptionSkeleton = (0, $ecnYn.xcss)({
    gridArea: 'description',
    backgroundColor: 'color.background.neutral',
    width: '150px',
    height: '10px',
    borderRadius: 'radius.xsmall'
});
const $901e25dc7e018c2c$export$f2db87eaff19de11 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $901e25dc7e018c2c$var$searchLinkWithDescriptionStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $901e25dc7e018c2c$var$iconSkeleton
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $901e25dc7e018c2c$var$titleSkeleton
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $901e25dc7e018c2c$var$descriptionSkeleton
            })
        ]
    });
};


const $ced8ec59864e4e14$export$772547de01833b56 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $901e25dc7e018c2c$export$f2db87eaff19de11), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $901e25dc7e018c2c$export$f2db87eaff19de11), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $901e25dc7e018c2c$export$f2db87eaff19de11), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $901e25dc7e018c2c$export$f2db87eaff19de11), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $901e25dc7e018c2c$export$f2db87eaff19de11), {})
        ]
    });
};





const $98ef75abab6f287f$export$88efc7c63a8a4724 = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, dwellTime: dwellTime })=>({
        eventType: 'track',
        actionSubject: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}Dropdown`,
        action: 'dwelled',
        attributes: {
            additionalAttributes: {
                dwellTime: dwellTime
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });









var $czt8s = parcelRequire("czt8s");




const $86a123e1e6e984a8$export$afebbafde0a7a4ec = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, count: count, duration: duration })=>({
        eventType: 'track',
        actionSubject: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}DropdownResults`,
        action: 'shown',
        attributes: {
            additionalAttributes: {
                count: count,
                duration: duration
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });















const $6dd92f60995cb7a0$export$e292df53a75b4e9b = (inputQuery, count)=>{
    let { peopleAndTeams: peopleAndTeams, autoSuggestion: autoSuggestion, recentSearch: recentSearch, recentViews: recentViews } = count;
    // case 1: pre-query
    let maxDisplayed = {
        peopleAndTeams: 0,
        autoSuggestion: 0,
        recentSearch: 3,
        recentViews: 5
    };
    // case 2: 1-2 characters in query
    if (inputQuery.length === 1 || inputQuery.length === 2) {
        // with recent search match (same as pre-query)
        if (recentSearch > 0) ;
        else if (autoSuggestion > 0) maxDisplayed = {
            peopleAndTeams: 0,
            autoSuggestion: 8 - Math.min(5, recentViews),
            recentSearch: 0,
            recentViews: 5
        };
        else maxDisplayed = {
            peopleAndTeams: 0,
            autoSuggestion: 0,
            recentSearch: 0,
            recentViews: 7
        };
    }
    // case 3: 3+ characters in query
    if (inputQuery.length >= 3) {
        // with no person match
        if (peopleAndTeams === 0) {
            // with no person match, with recent search
            if (recentSearch) maxDisplayed = {
                peopleAndTeams: 0,
                autoSuggestion: 3,
                recentSearch: 2,
                recentViews: 3
            };
            else maxDisplayed = {
                peopleAndTeams: 0,
                autoSuggestion: 4,
                recentSearch: 0,
                recentViews: 4
            };
        } else maxDisplayed = {
            peopleAndTeams: 2,
            autoSuggestion: recentSearch > 0 ? 1 : 3,
            recentSearch: 3,
            recentViews: 3
        };
    }
    return {
        peopleAndTeams: Math.min(maxDisplayed.peopleAndTeams, peopleAndTeams),
        autoSuggestion: Math.min(maxDisplayed.autoSuggestion, autoSuggestion),
        recentSearch: Math.min(maxDisplayed.recentSearch, recentSearch),
        recentViews: Math.min(maxDisplayed.recentViews, recentViews)
    };
};



var $c6GJD = parcelRequire("c6GJD");


var $1z61g = parcelRequire("1z61g");

const $6315d0ad4d04ad6a$export$2d543e88c46c0c38 = (query, bootstrap, onError)=>{
    const autoSuggestionFilters = {
        entities: [
            'query-suggestion.query-suggestion-item'
        ],
        locations: [
            `ari:cloud:confluence::site/${bootstrap.cloudId}`
        ]
    };
    const primaryProduct = bootstrap.primaryProduct;
    const fetchData = async (query)=>{
        // Disable auto-suggestion for Confluence
        if (primaryProduct === 'confluence') return {
            results: [],
            duration: 0
        };
        // Atlas killswitch
        if (primaryProduct === 'townsquare' && !(0, $c6GJD.default).checkGate('atlas_enable_query_suggestion_dropdown')) return {
            results: [],
            duration: 0
        };
        performance.mark('fetchAutoSuggestionResultsStart');
        const response = await (0, $1z61g.autoSuggestionQuery)({
            variables: {
                limit: 10,
                filters: autoSuggestionFilters,
                query: query
            }
        }).catch((error)=>{
            onError(error);
        });
        performance.mark('fetchAutoSuggestionResultsEnd');
        const { duration: duration } = performance.measure('fetchAutoSuggestionResultsDuration', 'fetchAutoSuggestionResultsStart', 'fetchAutoSuggestionResultsEnd');
        return {
            results: response?.data?.suggest?.suggest?.nodes || [],
            duration: duration
        };
    };
    return fetchData(query);
};



var $1L3gY = parcelRequire("1L3gY");

var $c5JjN = parcelRequire("c5JjN");

const $6701285ebb022f4c$export$290039782fc4e47 = (query, bootstrap, onError)=>{
    const fetchData = async (query)=>{
        performance.mark('fetchPeopleAndTeamsResultsStart');
        // Map townsquare scope as URS does not support townsquare as a primary product
        const productKey = bootstrap.primaryProduct === 'townsquare' ? 'people' : bootstrap.primaryProduct;
        const recommendations = await (0, $1L3gY.default)({
            query: query,
            context: {
                contextType: 'full_page_search',
                siteId: bootstrap.cloudId || '',
                productKey: productKey || '',
                principalId: bootstrap.user?.id || '',
                organizationId: bootstrap.orgId || ''
            },
            includeUsers: true,
            includeTeams: true,
            includeGroups: false,
            maxNumberOfResults: 3,
            performSearchQueryOnly: false,
            searchQuery: {
                filter: 'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:app)',
                teamSearchFields: [
                    (0, $c5JjN.TeamSearchField).NAME
                ]
            }
        }).catch((error)=>{
            onError(error);
            return [];
        });
        performance.mark('fetchPeopleAndTeamsResultsEnd');
        const { duration: duration } = performance.measure('fetchPeopleAndTeamsResultsDuration', 'fetchPeopleAndTeamsResultsStart', 'fetchPeopleAndTeamsResultsEnd');
        return {
            results: recommendations,
            duration: duration
        };
    };
    return fetchData(query);
};




const $295a673e2b594ca9$var$fetchAll = async (query, bootstrap, onError)=>{
    return Promise.all([
        (0, $6701285ebb022f4c$export$290039782fc4e47)(query, bootstrap, onError),
        (0, $6315d0ad4d04ad6a$export$2d543e88c46c0c38)(query, bootstrap, onError)
    ]);
};
const $295a673e2b594ca9$export$4e2bef15a5b74b17 = ()=>{
    const [inputQuery] = (0, $djVCD.useInputQuery)();
    const [bootstrap] = (0, $j4ply.useBootstrap)();
    const [dropdownLoading] = (0, $25a8b9613a265659$export$41ba39ed718e7414)();
    const requestRef = (0, $42omo.useRef)();
    const [currentInputQuery, setCurrentInputQuery] = (0, $42omo.useState)(inputQuery);
    const [recentSearchResults] = (0, $25a8b9613a265659$export$8fdf7942b5f23117)();
    const [recentViewsResults] = (0, $25a8b9613a265659$export$a7f7068aa342db89)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const logException = (0, $f8oYd.useLogException)();
    const { setPeopleAndTeamsResults: setPeopleAndTeamsResults, setRecentViewsResults: setRecentViewsResults, setAutoSuggestionResults: setAutoSuggestionResults, setRecentSearchResults: setRecentSearchResults, setDropdownLoading: setDropdownLoading, setResultCount: setResultCount } = (0, $25a8b9613a265659$export$4e8b5ffe8cfc8886)();
    const debounceTimeout = (0, $42omo.useRef)(null);
    const fetchData = (0, $42omo.useCallback)(async (query, bootstrap)=>{
        setCurrentInputQuery(inputQuery);
        if (requestRef.current) // If there is an existing fetchAll promise, cancel it
        requestRef.current.cancel();
        setDropdownLoading(true);
        // Set the fetchAll promise
        requestRef.current = new (0, $czt8s.CancellablePromise)($295a673e2b594ca9$var$fetchAll(query, bootstrap, logException));
        try {
            const [peopleAndTeamsResults, autoSuggestionResults] = await requestRef.current.promise();
            // update store
            setPeopleAndTeamsResults(peopleAndTeamsResults);
            setAutoSuggestionResults(autoSuggestionResults);
            const filteredRecentSearchResults = (0, $62cf4e492e3f8cd7$export$9770ca05e8d4f1fe)(recentSearchResults, query);
            setRecentSearchResults(filteredRecentSearchResults);
            const filteredRecentViewsResults = (0, $f4f28935e73c0254$export$c8394dd336252c18)(recentViewsResults ?? [], query);
            setRecentViewsResults(filteredRecentViewsResults);
            const resultCounts = (0, $6dd92f60995cb7a0$export$e292df53a75b4e9b)(query, {
                peopleAndTeams: peopleAndTeamsResults.results.length,
                autoSuggestion: autoSuggestionResults.results.length,
                recentSearch: filteredRecentSearchResults.length,
                recentViews: filteredRecentViewsResults.length
            });
            setResultCount(resultCounts);
            const queryDurations = {
                peopleAndTeams: peopleAndTeamsResults.duration,
                autoSuggestion: autoSuggestionResults.duration
            };
            fireAnalyticsEvent(// TODO: Move this to where the results are actually rendered
            (0, $86a123e1e6e984a8$export$afebbafde0a7a4ec)({
                commonAttributes: commonAttributes,
                nonPrivacySafeAttributes: nonPrivacySafeAttributes,
                count: resultCounts,
                duration: queryDurations
            }));
            // stop loading
            setDropdownLoading(false);
        } catch (error) {
            if (!(error instanceof (0, $czt8s.CancelError))) {
                // stop loading
                setDropdownLoading(false);
                // log error
                logException(error);
            }
        }
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        inputQuery,
        logException,
        nonPrivacySafeAttributes,
        recentSearchResults,
        recentViewsResults,
        setAutoSuggestionResults,
        setDropdownLoading,
        setPeopleAndTeamsResults,
        setRecentSearchResults,
        setRecentViewsResults,
        setResultCount
    ]);
    (0, $42omo.useEffect)(()=>{
        if ((inputQuery !== currentInputQuery || dropdownLoading && !requestRef.current) && recentViewsResults !== undefined) {
            if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
            debounceTimeout.current = setTimeout(()=>{
                fetchData(inputQuery, bootstrap);
            }, 300);
        }
    }, [
        inputQuery,
        bootstrap,
        currentInputQuery,
        dropdownLoading,
        recentViewsResults,
        fetchData
    ]);
};













var $jluld = parcelRequire("jluld");







var $bloXB = parcelRequire("bloXB");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $inPa6 = parcelRequire("inPa6");







var $9lW6K = parcelRequire("9lW6K");










const $d3a29e104f21b211$export$6766232a164d1444 = (pressType, title, applicationMode)=>{
    return {
        type: 'sendUIEvent',
        data: {
            actionSubject: 'keyboard',
            action: 'pressed',
            source: 'fullPageSearch',
            attributes: {
                pressType: pressType,
                title: title,
                mode: applicationMode
            }
        }
    };
};
const $d3a29e104f21b211$export$efeec3c53a35b71b = (index, applicationMode)=>{
    return {
        type: 'sendUIEvent',
        data: {
            actionSubject: 'keyboard',
            action: 'highlighted',
            source: 'fullPageSearch',
            attributes: {
                index: index,
                mode: applicationMode
            }
        }
    };
};



var $jAenQ = parcelRequire("jAenQ");

const $6d18f2976733d256$var$searchLinkStyles = (0, $ecnYn.xcss)({
    width: 'fill',
    padding: 'space.100',
    display: 'grid',
    columnGap: 'space.100',
    gridTemplateColumns: 'auto 1fr auto',
    gridTemplateAreas: `
    "icon title subheading"
  `,
    alignItems: 'center',
    height: '40px',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    borderRadius: 'radius.large',
    cursor: 'pointer'
});
const $6d18f2976733d256$var$searchLinkWithDescriptionStyles = (0, $ecnYn.xcss)({
    width: 'fill',
    padding: 'space.100',
    display: 'grid',
    columnGap: 'space.100',
    gridTemplateColumns: 'auto 1fr',
    gridTemplateAreas: `
    "icon title subheading"
    "icon description subheading"
  `,
    alignItems: 'center',
    height: '50px',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    borderRadius: 'radius.large',
    cursor: 'pointer'
});
const $6d18f2976733d256$var$iconStyles = (0, $ecnYn.xcss)({
    gridArea: 'icon'
});
const $6d18f2976733d256$var$titleStyles = (0, $ecnYn.xcss)({
    gridArea: 'title',
    color: 'color.text',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $6d18f2976733d256$var$descriptionStyles = (0, $ecnYn.xcss)({
    gridArea: 'description',
    display: 'flex',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'inherit',
    color: 'color.text.subtle',
    paddingTop: 'space.075'
});
const $6d18f2976733d256$var$subheadingStyles = (0, $ecnYn.xcss)({
    gridArea: 'subheading',
    display: 'flex',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtle',
    alignItems: 'center',
    gap: 'space.050'
});
const $6d18f2976733d256$var$DropdownResultContent = ({ title: title, description: description, subheading: subheading, icon: icon, onClick: onClick, highlightedTitle: highlightedTitle, rightPanel: rightPanel, linkRef: linkRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const onSubmit = (e, target)=>{
        if (e.key === 'Enter') {
            createAnalyticsEvent((0, $d3a29e104f21b211$export$6766232a164d1444)(e.key, title, applicationMode)).fire();
            onClick({
                target: target
            });
            if (linkRef?.current) linkRef.current.click();
        }
    };
    const onHighlighted = (index)=>{
        createAnalyticsEvent((0, $d3a29e104f21b211$export$efeec3c53a35b71b)(index, applicationMode)).fire();
    };
    const [isKeyboardHighlighted, setRef] = (0, $icqFF.useKeyboardNavigation)({
        onKeydownCallback: onSubmit,
        onHighlightedCallback: onHighlighted
    });
    const [isMouseHighlighted, setIsMouseHighlighted] = (0, $42omo.useState)(false);
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        ref: setRef,
        xcss: description ? $6d18f2976733d256$var$searchLinkWithDescriptionStyles : $6d18f2976733d256$var$searchLinkStyles,
        backgroundColor: isKeyboardHighlighted ? 'color.background.neutral.subtle.hovered' : 'color.background.neutral.subtle',
        onClick: onClick,
        onMouseDown: (e)=>e.preventDefault(),
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
        "aria-label": "Search Link",
        onMouseOver: ()=>setIsMouseHighlighted(true),
        onMouseLeave: ()=>setIsMouseHighlighted(false),
        testId: "search-page-dropdown-result",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $6d18f2976733d256$var$iconStyles,
                children: icon
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $6d18f2976733d256$var$titleStyles,
                children: highlightedTitle ? (0, $9lW6K.enrichResultTitle)(highlightedTitle) : title
            }),
            subheading && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $6d18f2976733d256$var$subheadingStyles,
                children: subheading
            }),
            description && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $6d18f2976733d256$var$descriptionStyles,
                children: description
            }),
            rightPanel && (isKeyboardHighlighted || isMouseHighlighted) && rightPanel
        ]
    }));
};
const $6d18f2976733d256$export$5b6118e2ff142a50 = (props)=>{
    const linkRef = (0, $42omo.useRef)(null);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jAenQ.Link), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            textDecoration: 'none',
            color: 'inherit'
        },
        ref: linkRef,
        href: props.navigationUrl || '',
        testId: "search-page-dropdown-result-link",
        children: /*#__PURE__*/ (0, $l998X.jsx)($6d18f2976733d256$var$DropdownResultContent, {
            ...props,
            linkRef: linkRef
        })
    });
};
const $6d18f2976733d256$export$f12258e0b62ed378 = (props)=>{
    const [features] = (0, $4Qo4W.useFeatures)();
    const onClick = (0, $42omo.useCallback)(()=>{
        if (!features?.chromeExtension?.enabled) return;
        const { onInputDropdownResultSelect: onInputDropdownResultSelect } = features.chromeExtension;
        onInputDropdownResultSelect({
            title: props.title,
            url: props.navigationUrl
        });
    }, [
        features?.chromeExtension,
        props.title,
        props.navigationUrl
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($6d18f2976733d256$var$DropdownResultContent, {
        ...props,
        onClick: onClick
    });
};
const $6d18f2976733d256$export$bbedf2c4ad87789c = (props)=>{
    const [features] = (0, $4Qo4W.useFeatures)();
    if (features?.chromeExtension?.enabled) return /*#__PURE__*/ (0, $l998X.jsx)($6d18f2976733d256$export$f12258e0b62ed378, {
        ...props
    });
    else if (props.navigationUrl) return /*#__PURE__*/ (0, $l998X.jsx)($6d18f2976733d256$export$5b6118e2ff142a50, {
        ...props
    });
    else return /*#__PURE__*/ (0, $l998X.jsx)($6d18f2976733d256$var$DropdownResultContent, {
        ...props
    });
};


var $c54c3c289a186d1e$export$29f60e5970ae74d2 = /*#__PURE__*/ function(SearchLinkTypes) {
    SearchLinkTypes["RecentViews"] = "RECENT_VIEWS";
    SearchLinkTypes["RecentSearches"] = "RECENT_SEARCHES";
    SearchLinkTypes["PeopleAndTeams"] = "PEOPLE_AND_TEAMS";
    SearchLinkTypes["MimicQuery"] = "MIMIC_QUERY";
    SearchLinkTypes["GenerateAnswer"] = "GENERATE_ANSWER";
    SearchLinkTypes["AutoSuggestion"] = "AUTO_SUGGESTION";
    return SearchLinkTypes;
}({});





const $71cd44a664d39200$export$dd7618150e1396d8 = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, resultType: resultType, duration: duration, index: index })=>({
        eventType: 'ui',
        actionSubject: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}DropdownResult`,
        action: 'clicked',
        attributes: {
            additionalAttributes: {
                resultType: resultType,
                index: index,
                duration: duration
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });












const $529978d8b5bb2c60$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    searchIconLabel: {
        id: "dropdown_search_icon_label",
        defaultMessage: "Search"
    }
});


const $a089d7e31d906b62$var$iconStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.xsmall',
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $a089d7e31d906b62$export$14bd3dc13236b3f1 = ({ getElementIndex: getElementIndex })=>{
    const [inputQuery, { setSearchQuery: setSearchQuery }] = (0, $djVCD.useInputQuery)();
    const [, { setShowDropdown: setShowDropdown }] = (0, $25a8b9613a265659$export$8c32fdb3462273b4)();
    const intl = (0, $8C5kA.default)();
    const [recentSearchResults] = (0, $25a8b9613a265659$export$970bfa0ee111b06)();
    const [autoSuggestionResults] = (0, $25a8b9613a265659$export$30ecbc19a2297251)();
    const [resultCount] = (0, $25a8b9613a265659$export$22da568447791223)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const recentSearchTitles = recentSearchResults.slice(0, resultCount.recentSearch).map((search)=>search.title.toLowerCase());
    const filteredAutoSuggestions = autoSuggestionResults.results.filter((suggestion)=>{
        return !recentSearchTitles.includes(suggestion.title.toLowerCase()) && suggestion.title !== inputQuery.toLowerCase();
    }).slice(0, resultCount.autoSuggestion);
    const fireAnalytics = (0, $42omo.useCallback)((event)=>{
        const index = event.target && getElementIndex ? getElementIndex(event.target) : undefined;
        fireAnalyticsEvent((0, $71cd44a664d39200$export$dd7618150e1396d8)({
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            resultType: (0, $c54c3c289a186d1e$export$29f60e5970ae74d2).AutoSuggestion,
            duration: autoSuggestionResults.duration,
            ...index !== undefined ? {
                index: index
            } : {}
        }));
    }, [
        getElementIndex,
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes,
        autoSuggestionResults.duration
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: filteredAutoSuggestions.map((suggestion, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6d18f2976733d256$export$bbedf2c4ad87789c), {
                title: suggestion.title || '',
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $a089d7e31d906b62$var$iconStyles,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                        color: "currentColor",
                        label: intl.formatMessage((0, $529978d8b5bb2c60$export$defe85febe8b728c).searchIconLabel)
                    })
                }),
                onClick: (event)=>{
                    setSearchQuery(suggestion.title || '');
                    setShowDropdown(false);
                    fireAnalytics(event);
                },
                highlightedTitle: (0, $bloXB.highlightMatchedText)(suggestion.title, inputQuery.split(' ')).negatedHighlightedTitle
            }, `${index}-${suggestion.title}`))
    });
};



















// Copied from packages/search/search-dialog/src/icons/square-return-icon.tsx



parcelRequire("42omo");


var $6fnsQ = parcelRequire("6fnsQ");

const $b06cfc8e8811599c$export$4501fc029b186da8 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "20",
                height: "20",
                rx: "3",
                fill: `var(--ds-background-neutral, ${(0, $6fnsQ.N30)})`
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "nonzero",
                d: "M7.99707 14.7949C7.86035 14.7949 7.70312 14.7266 7.59375 14.624L4.47656 11.582C4.35352 11.459 4.29199 11.3154 4.29199 11.165C4.29199 11.0146 4.35352 10.8711 4.47656 10.7549L7.59375 7.71289C7.70312 7.60352 7.86035 7.54199 7.99707 7.54199C8.3252 7.54199 8.53711 7.76074 8.53711 8.08203C8.53711 8.23926 8.48926 8.3623 8.38672 8.45801L6.9375 9.86621L5.95996 10.6797L7.23145 10.6182H13.835C14.3887 10.6182 14.6006 10.3994 14.6006 9.8457V6.71484C14.6006 6.16797 14.3887 5.94922 13.835 5.94922H11.0117C10.6699 5.94922 10.4512 5.70312 10.4512 5.40234C10.4512 5.09473 10.6699 4.84863 11.0117 4.84863H13.835C15.1748 4.84863 15.708 5.375 15.708 6.71484V9.8457C15.708 11.124 15.1748 11.7188 13.835 11.7188H7.23145L5.95996 11.6572L6.9375 12.4707L8.38672 13.8721C8.48926 13.9746 8.53711 14.0908 8.53711 14.248C8.53711 14.5693 8.3252 14.7949 7.99707 14.7949Z",
                fill: `var(--ds-icon-subtle, ${(0, $6fnsQ.N700)})`
            })
        ]
    });















const $c72e99dd0c00bff5$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    search: {
        id: "dropdown_search",
        defaultMessage: "Search"
    },
    searchIconLabel: {
        id: "dropdown_search_icon_label",
        defaultMessage: "Search"
    }
});


const $a25554042533c6c0$var$iconStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.xsmall',
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $a25554042533c6c0$var$subheadingTextWrapper = (0, $ecnYn.xcss)({
    marginRight: 'space.100'
});
const $a25554042533c6c0$export$4a7d659f3bdb9018 = ({ getElementIndex: getElementIndex })=>{
    const intl = (0, $8C5kA.default)();
    const [inputQuery] = (0, $djVCD.useInputQuery)();
    const { triggerSearch: triggerSearch } = (0, $djVCD.useSearchActions)();
    const { setShowDropdown: setShowDropdown } = (0, $25a8b9613a265659$export$4e8b5ffe8cfc8886)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const fireAnalytics = (0, $42omo.useCallback)((event)=>{
        const index = event.target && getElementIndex ? getElementIndex(event.target) : undefined;
        fireAnalyticsEvent((0, $71cd44a664d39200$export$dd7618150e1396d8)({
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            resultType: (0, $c54c3c289a186d1e$export$29f60e5970ae74d2).MimicQuery,
            ...index !== undefined ? {
                index: index
            } : {}
        }));
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes,
        getElementIndex
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: inputQuery.length > 0 && /*#__PURE__*/ (0, $l998X.jsx)((0, $6d18f2976733d256$export$bbedf2c4ad87789c), {
            title: inputQuery,
            subheading: /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $a25554042533c6c0$var$subheadingTextWrapper,
                        children: intl.formatMessage((0, $c72e99dd0c00bff5$export$defe85febe8b728c).search)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $b06cfc8e8811599c$export$4501fc029b186da8), {})
                ]
            }),
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $a25554042533c6c0$var$iconStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                    color: "currentColor",
                    label: intl.formatMessage((0, $c72e99dd0c00bff5$export$defe85febe8b728c).searchIconLabel)
                })
            }),
            onClick: (event)=>{
                fireAnalytics(event);
                setShowDropdown(false);
                triggerSearch();
            }
        })
    });
};












var $esRft = parcelRequire("esRft");










var $aU479 = parcelRequire("aU479");



















const $4804aa5dcd4f4be5$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    teamLabel: {
        id: "team",
        defaultMessage: "Team"
    },
    avatarLabel: {
        id: "avatar",
        defaultMessage: "Avatar"
    }
});


const $4eec9a3bd06cc380$export$9d052a57a86e166 = ({ getElementIndex: getElementIndex })=>{
    const intl = (0, $8C5kA.default)();
    const [cloudId] = (0, $4Qo4W.useCloudId)();
    const [orgId] = (0, $4Qo4W.useOrgId)();
    const [inputQuery] = (0, $djVCD.useInputQuery)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const [, { setShowDropdown: setShowDropdown }] = (0, $25a8b9613a265659$export$8c32fdb3462273b4)();
    const [resultCount] = (0, $25a8b9613a265659$export$22da568447791223)();
    const [peopleAndTeamsResults] = (0, $25a8b9613a265659$export$c30c238644aa02ee)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const fireAnalytics = (0, $42omo.useCallback)((event)=>{
        const index = event.target && getElementIndex ? getElementIndex(event.target) : undefined;
        fireAnalyticsEvent((0, $71cd44a664d39200$export$dd7618150e1396d8)({
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            resultType: (0, $c54c3c289a186d1e$export$29f60e5970ae74d2).PeopleAndTeams,
            duration: peopleAndTeamsResults.duration,
            ...index !== undefined ? {
                index: index
            } : {}
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        getElementIndex,
        nonPrivacySafeAttributes,
        peopleAndTeamsResults.duration
    ]);
    const onClick = (event)=>{
        setShowDropdown(false);
        fireAnalytics(event);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: peopleAndTeamsResults.results.slice(0, resultCount.peopleAndTeams).map((result, index)=>{
            if (result.entityType === (0, $c5JjN.EntityType).USER && result.name) {
                const navigationUrl = primaryProduct && cloudId && orgId && (0, $aU479.getUserPath)(result.id, primaryProduct, orgId, cloudId);
                return /*#__PURE__*/ (0, $l998X.jsx)($4eec9a3bd06cc380$var$PeopleAndTeamsLink, {
                    title: result.name,
                    description: result.title,
                    avatarUrl: result.avatarUrl,
                    onClick: onClick,
                    inputQuery: inputQuery,
                    navigationUrl: navigationUrl || ''
                }, `${index}-${result.name}`);
            } else if (result.entityType === (0, $c5JjN.EntityType).TEAM && result.displayName) {
                const navigationUrl = primaryProduct && cloudId && orgId && (0, $aU479.getTeamPath)(result.id, primaryProduct, orgId, cloudId);
                return /*#__PURE__*/ (0, $l998X.jsx)($4eec9a3bd06cc380$var$PeopleAndTeamsLink, {
                    title: result.displayName,
                    description: intl.formatMessage((0, $4804aa5dcd4f4be5$export$defe85febe8b728c).teamLabel),
                    avatarUrl: result?.smallAvatarImageUrl,
                    onClick: onClick,
                    inputQuery: inputQuery,
                    navigationUrl: navigationUrl || ''
                }, `${index}-${result.name}`);
            }
        })
    });
};
const $4eec9a3bd06cc380$var$iconStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.full',
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $4eec9a3bd06cc380$var$PeopleAndTeamsLink = ({ title: title, description: description = '', avatarUrl: avatarUrl = '', inputQuery: inputQuery, onClick: onClick, navigationUrl: navigationUrl })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6d18f2976733d256$export$bbedf2c4ad87789c), {
        title: title,
        description: description,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $4eec9a3bd06cc380$var$iconStyles,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
                src: avatarUrl,
                size: "small"
            })
        }),
        onClick: onClick,
        highlightedTitle: (0, $bloXB.highlightMatchedText)(title, inputQuery.split(' ')).highlightedTitle,
        navigationUrl: navigationUrl
    });












var $1qfLF = parcelRequire("1qfLF");


var $kevJM = parcelRequire("kevJM");


var $hmuev = parcelRequire("hmuev");

























const $733d7b55e292e9ea$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    recentSearchIconLabel: {
        id: "dropdown_recent_icon_label",
        defaultMessage: "Recent"
    },
    removeRecentSearchIcon: {
        id: "search-result.remove-recent-search",
        defaultMessage: "Remove recent search icon"
    },
    removeRecentSearchSubheading: {
        id: "search-result.remove-recent-search-result-subheading",
        defaultMessage: "Recent search"
    }
});


const $f861466ae6de5322$var$iconStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.xsmall',
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $f861466ae6de5322$export$e4bc6828df5bf4e8 = ({ getElementIndex: getElementIndex })=>{
    const { setSearchQuery: setSearchQuery } = (0, $djVCD.useSearchActions)();
    const [resultCount] = (0, $25a8b9613a265659$export$22da568447791223)();
    const [, { setShowDropdown: setShowDropdown }] = (0, $25a8b9613a265659$export$8c32fdb3462273b4)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const fireAnalytics = (0, $42omo.useCallback)((event)=>{
        const index = event.target && getElementIndex ? getElementIndex(event.target) : undefined;
        fireAnalyticsEvent((0, $71cd44a664d39200$export$dd7618150e1396d8)({
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            resultType: (0, $c54c3c289a186d1e$export$29f60e5970ae74d2).RecentSearches,
            ...index !== undefined ? {
                index: index
            } : {}
        }));
    }, [
        getElementIndex,
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes
    ]);
    const onClick = (query, event)=>{
        setShowDropdown(false);
        fireAnalytics(event);
        setSearchQuery(query);
    };
    const [recentSearches] = (0, $25a8b9613a265659$export$970bfa0ee111b06)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: recentSearches.slice(0, resultCount.recentSearch).map((result, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6d18f2976733d256$export$bbedf2c4ad87789c), {
                title: result.title,
                icon: /*#__PURE__*/ (0, $l998X.jsx)($f861466ae6de5322$export$aa64f88f83123fb7, {}),
                onClick: (event)=>onClick(result.title, event),
                rightPanel: /*#__PURE__*/ (0, $l998X.jsx)($f861466ae6de5322$export$ea04c1e9e2b7cc14, {
                    title: result.title
                })
            }, `${index}-${result.title}`))
    });
};
const $f861466ae6de5322$export$aa64f88f83123fb7 = ()=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $f861466ae6de5322$var$iconStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
            color: "currentColor",
            label: intl.formatMessage((0, $733d7b55e292e9ea$export$defe85febe8b728c).recentSearchIconLabel),
            spacing: "spacious"
        })
    });
};
const $f861466ae6de5322$var$recentSearchRightPanelStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $f861466ae6de5322$var$subheadingStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.150'
});
const $f861466ae6de5322$export$ea04c1e9e2b7cc14 = ({ title: title })=>{
    const intl = (0, $8C5kA.default)();
    const [{ user: user, primaryProduct: primaryProduct }] = (0, $j4ply.useBootstrap)();
    const { setRecentSearchResults: setRecentSearchResults } = (0, $25a8b9613a265659$export$4e8b5ffe8cfc8886)();
    const onClick = (0, $42omo.useCallback)((event)=>{
        event.stopPropagation();
        if (user?.id && primaryProduct) {
            const newRecentSearches = (0, $1SV4e.removeRecentSearch)(title, user.id, primaryProduct, (0, $1SV4e.RECENT_SEARCH_KEY)).map((searchTitle)=>({
                    // Todo: cleanup this so that we only need to pass the search title.
                    title: searchTitle,
                    icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
                    onClick: ()=>null
                }));
            setRecentSearchResults(newRecentSearches);
        }
    }, [
        primaryProduct,
        title,
        setRecentSearchResults,
        user?.id
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $f861466ae6de5322$var$recentSearchRightPanelStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                as: "span",
                xcss: $f861466ae6de5322$var$subheadingStyles,
                children: intl.formatMessage((0, $733d7b55e292e9ea$export$defe85febe8b728c).removeRecentSearchSubheading)
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                        ...iconProps,
                        label: intl.formatMessage((0, $733d7b55e292e9ea$export$defe85febe8b728c).removeRecentSearchIcon),
                        color: "currentColor"
                    }),
                spacing: 'compact',
                onClick: onClick,
                label: intl.formatMessage((0, $733d7b55e292e9ea$export$defe85febe8b728c).removeRecentSearchIcon),
                appearance: 'subtle'
            })
        ]
    });
};




















const $d21d59b632bece95$var$iconStyles = (0, $ecnYn.xcss)({
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $d21d59b632bece95$export$c68af787f8f88afe = ({ getElementIndex: getElementIndex })=>{
    const [recentViewsResults] = (0, $25a8b9613a265659$export$f53e0f96bec5ea4d)();
    const { setShowDropdown: setShowDropdown } = (0, $25a8b9613a265659$export$4e8b5ffe8cfc8886)();
    const [resultCount] = (0, $25a8b9613a265659$export$22da568447791223)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const fireAnalytics = (0, $42omo.useCallback)((event)=>{
        const index = event.target && getElementIndex ? getElementIndex(event.target) : undefined;
        fireAnalyticsEvent((0, $71cd44a664d39200$export$dd7618150e1396d8)({
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            resultType: (0, $c54c3c289a186d1e$export$29f60e5970ae74d2).RecentViews,
            ...index !== undefined ? {
                index: index
            } : {}
        }));
    }, [
        getElementIndex,
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes
    ]);
    const onClick = (event)=>{
        setShowDropdown(false);
        fireAnalytics(event);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: recentViewsResults?.slice(0, resultCount.recentViews).map((result, index)=>{
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $6d18f2976733d256$export$bbedf2c4ad87789c), {
                title: result.title,
                description: result.description,
                subheading: result.subheading,
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $d21d59b632bece95$var$iconStyles,
                    children: result.icon
                }),
                onClick: onClick,
                highlightedTitle: result.highlightedTitle,
                navigationUrl: result.navigationUrl
            }, `${index}-${result.title}`);
        })
    });
};


const $355509f988cf3833$var$searchDropdownStyles = (0, $ecnYn.xcss)({
    padding: 'space.100',
    gap: 'space.025',
    boxShadow: 'elevation.shadow.overlay',
    borderWidth: '0',
    boxSizing: 'border-box'
});
const $355509f988cf3833$export$e33d60b8f4099ae = ({ inputWidth: inputWidth })=>{
    (0, $295a673e2b594ca9$export$4e2bef15a5b74b17)();
    const [dropdownLoading] = (0, $25a8b9613a265659$export$41ba39ed718e7414)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const containerRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const start = Date.now();
        return ()=>{
            const end = Date.now();
            const msElapsed = end - start;
            fireAnalyticsEvent((0, $98ef75abab6f287f$export$88efc7c63a8a4724)({
                commonAttributes: commonAttributes,
                nonPrivacySafeAttributes: nonPrivacySafeAttributes,
                dwellTime: msElapsed
            }));
        };
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        nonPrivacySafeAttributes
    ]);
    const getElementIndex = (0, $42omo.useCallback)((eventTarget)=>{
        if (!eventTarget || !containerRef.current) return;
        const currentChildNodes = containerRef.current.childNodes;
        const childNodeList = [];
        for(let i = 0; i < currentChildNodes.length; i++)childNodeList.push(currentChildNodes.item(i));
        // Find which index the selected target is from the childNodes of this component
        const childIndex = childNodeList.findIndex((child)=>{
            return child.isSameNode(eventTarget) || child.contains(eventTarget);
        });
        return childIndex === -1 ? undefined : childIndex;
    }, [
        containerRef
    ]);
    // The direct childNodes of this component are used to get the analytics element index of each
    // SearchLink. Nesting two SearchLinks together into a single direct childNode will result in
    // an incorrect element index. See `getElementIndex` for logic.
    const content = dropdownLoading ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $a25554042533c6c0$export$4a7d659f3bdb9018), {
                getElementIndex: getElementIndex
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $ced8ec59864e4e14$export$772547de01833b56), {})
        ]
    }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $a25554042533c6c0$export$4a7d659f3bdb9018), {
                getElementIndex: getElementIndex
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $a089d7e31d906b62$export$14bd3dc13236b3f1), {
                getElementIndex: getElementIndex
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $f861466ae6de5322$export$e4bc6828df5bf4e8), {
                getElementIndex: getElementIndex
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $4eec9a3bd06cc380$export$9d052a57a86e166), {
                getElementIndex: getElementIndex
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $d21d59b632bece95$export$c68af787f8f88afe), {
                getElementIndex: getElementIndex
            })
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $355509f988cf3833$var$searchDropdownStyles,
        style: {
            width: `${inputWidth}px`
        },
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
        "aria-label": 'Search Suggestions Dropdown',
        testId: 'search-suggestions-dropdown',
        ref: containerRef,
        children: content
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 




























var $9hlns = parcelRequire("9hlns");


var $4noo5 = parcelRequire("4noo5");





var $9vOy1 = parcelRequire("9vOy1");


var $lwP5K = parcelRequire("lwP5K");


var $7WbA8 = parcelRequire("7WbA8");


var $fm8DG = parcelRequire("fm8DG");





var $kIdP4 = parcelRequire("kIdP4");










const $afacec520190eeee$export$a622d365e8995608 = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, location: location })=>({
        eventType: 'ui',
        actionSubject: 'button',
        actionSubjectId: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}CopyLinkButton`,
        action: 'clicked',
        attributes: {
            additionalAttributes: {
                location: location
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });






var $1ymk3 = parcelRequire("1ymk3");







const $e31123e898a81d94$export$9f6a79d85aed5338 = (location)=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const { queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    return (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $afacec520190eeee$export$a622d365e8995608)({
            commonAttributes: {
                ...commonAttributes,
                ...primaryProduct && (0, $2OtFZ.serveSearchPageRelayExp)(primaryProduct, false, queryParams) ? (0, $1ymk3.getExtensionData)(commonAttributes.isCQL) : {}
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            location: location
        }));
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes,
        location,
        primaryProduct,
        queryParams
    ]);
};











const $8564e7e83701040c$export$613310893a9f5d54 = (0, $cgtv4.defineMessages)({
    inputPlaceholderDefault: {
        id: "input_placeholder_default",
        defaultMessage: "Search for anything"
    },
    inputPlaceholderNav3: {
        id: "input_placeholder_nav3",
        defaultMessage: "Search"
    },
    inputPlaceholder: {
        id: "input_placeholder",
        defaultMessage: "Search"
    }
});
const $8564e7e83701040c$export$6593fbebf10a44f4 = (0, $cgtv4.defineMessages)({
    inputPlaceholderWithAtlassianIntelligence: {
        id: "input_placeholder_with_atlassian_intelligence",
        defaultMessage: "Search or ask anything"
    },
    inputPlaceholderWithRovo: {
        id: "input_placeholder_with_rovo",
        defaultMessage: "Search or ask Rovo"
    },
    searchAcrossProducts: {
        id: "input_placeholder_ghost_text_search_across",
        defaultMessage: "Search across {products}, and more"
    },
    submitExpenseQuestion: {
        id: "input_placeholder_ghost_text_submit_expense",
        defaultMessage: "Ask a question like \"How do I submit an expense?\""
    },
    kpiAcronymSearch: {
        id: "input_placeholder_ghost_text_kpi_acronym",
        defaultMessage: "Search any acronym, like \"KPI\""
    },
    mentionTeammatesSearch: {
        id: "input_placeholder_ghost_text_mention_teammates",
        defaultMessage: "@mention a teammate to see their work"
    },
    searchTeammateName: {
        id: "input_placeholder_ghost_text_search_teammate",
        defaultMessage: "Search the name of a teammate"
    }
});






var $5G9KX = parcelRequire("5G9KX");


const { searchAcrossProducts: $29bbc9a782c07566$var$searchAcrossProducts, submitExpenseQuestion: $29bbc9a782c07566$var$submitExpenseQuestion, kpiAcronymSearch: $29bbc9a782c07566$var$kpiAcronymSearch, mentionTeammatesSearch: $29bbc9a782c07566$var$mentionTeammatesSearch, searchTeammateName: $29bbc9a782c07566$var$searchTeammateName } = (0, $8564e7e83701040c$export$6593fbebf10a44f4);
const $29bbc9a782c07566$export$80bfcd0b41a91527 = [
    // First session
    [
        $29bbc9a782c07566$var$searchAcrossProducts,
        $29bbc9a782c07566$var$submitExpenseQuestion,
        $29bbc9a782c07566$var$kpiAcronymSearch
    ],
    // Second session
    [
        $29bbc9a782c07566$var$submitExpenseQuestion,
        $29bbc9a782c07566$var$mentionTeammatesSearch,
        $29bbc9a782c07566$var$searchAcrossProducts
    ],
    // etc...
    [
        $29bbc9a782c07566$var$kpiAcronymSearch,
        $29bbc9a782c07566$var$searchAcrossProducts,
        $29bbc9a782c07566$var$submitExpenseQuestion
    ],
    [
        $29bbc9a782c07566$var$searchTeammateName,
        $29bbc9a782c07566$var$submitExpenseQuestion,
        $29bbc9a782c07566$var$searchAcrossProducts
    ],
    [
        $29bbc9a782c07566$var$mentionTeammatesSearch,
        $29bbc9a782c07566$var$searchAcrossProducts,
        $29bbc9a782c07566$var$submitExpenseQuestion
    ]
];
const $29bbc9a782c07566$export$c8250431df989e51 = (session, index)=>{
    // Reset index to 0 to guarantee that something will be displayed in the placeholder
    const sessionIndex = session % $29bbc9a782c07566$export$80bfcd0b41a91527.length;
    const ghostTextIndex = index % $29bbc9a782c07566$export$80bfcd0b41a91527[sessionIndex].length;
    return $29bbc9a782c07566$export$80bfcd0b41a91527[sessionIndex][ghostTextIndex];
};
const $29bbc9a782c07566$var$QUICK_FIND_GHOST_TEXT_KEY = 'quick-find-ghost-text';
const $29bbc9a782c07566$var$DEFAULT_GHOST_TEXT_STATE = {
    ghostTextSessionCount: undefined
};
const $29bbc9a782c07566$export$d6c611f7f67115e6 = (params)=>{
    const [{ ghostTextSessionCount: ghostTextSessionCount }, setState] = (0, $42omo.useState)((0, $5G9KX.getLocalStorageItem)($29bbc9a782c07566$var$QUICK_FIND_GHOST_TEXT_KEY) || $29bbc9a782c07566$var$DEFAULT_GHOST_TEXT_STATE);
    const sessionCount = ghostTextSessionCount === undefined ? params.initialValue : ghostTextSessionCount;
    const incrementSession = (0, $42omo.useCallback)(()=>{
        const newState = {
            ghostTextSessionCount: (sessionCount + 1) % params.maxCount
        };
        setState(newState);
        (0, $5G9KX.setLocalStorageItem)($29bbc9a782c07566$var$QUICK_FIND_GHOST_TEXT_KEY, JSON.stringify(newState));
    }, [
        sessionCount,
        params.maxCount,
        setState
    ]);
    return [
        sessionCount,
        {
            incrementSession: incrementSession
        }
    ];
};


const $6891f76f64ebebfd$export$3bfd2296a37df616 = ({})=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [ghostTextSession, { incrementSession: incrementSession }] = (0, $29bbc9a782c07566$export$d6c611f7f67115e6)({
        initialValue: 0,
        maxCount: (0, $29bbc9a782c07566$export$80bfcd0b41a91527).length
    });
    const placeholder = (0, $42omo.useMemo)(()=>{
        return formatMessage((0, $8564e7e83701040c$export$613310893a9f5d54).inputPlaceholder);
    }, [
        formatMessage
    ]);
    return {
        placeholder: placeholder,
        incrementSession: incrementSession,
        ghostTextSession: ghostTextSession
    };
};















const $d1f083be19fc31e1$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    searchIconLabel: {
        id: "input_search_icon_label",
        defaultMessage: "Search"
    },
    clearIconLabel: {
        id: "input_clear_icon_label",
        defaultMessage: "Clear search"
    },
    copyLinkIconLabel: {
        id: "input_copy_link_icon_label",
        defaultMessage: "Copy link"
    },
    inputPlaceholderDefault: {
        id: "input_placeholder_default",
        defaultMessage: "Search for anything"
    },
    inputPlaceholderWithAtlassianIntelligence: {
        id: "input_placeholder_with_atlassian_intelligence",
        defaultMessage: "Search or ask anything"
    },
    inputPlaceholderWithRovo: {
        id: "input_placeholder_with_rovo",
        defaultMessage: "Search or ask Rovo"
    }
});


const $60ee798dd775f6bb$var$textFieldBoxStyles = (0, $ecnYn.xcss)({
    height: 'space.500',
    flexGrow: 1
});
const $60ee798dd775f6bb$var$cssOverrideWrapperStyles = null;
const $60ee798dd775f6bb$var$searchIconWrapperStyles = (0, $ecnYn.xcss)({
    minWidth: 'size.200',
    minHeight: 'size.200',
    marginLeft: 'space.150',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $60ee798dd775f6bb$var$rightIconStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.100'
});
const $60ee798dd775f6bb$export$fb8d8fbc0c4c1705 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { localQuery: localQuery, setLocalQuery: setLocalQuery, onSubmit: onSubmit } = props;
    const intl = (0, $8C5kA.default)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams, isAdminHubAIEnabled: isAdminHubAIEnabled, isNav4Enabled: isNav4Enabled } = (0, $7WbA8.useAppContext)(); // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [isLoading] = (0, $djVCD.useIsLoading)();
    const [searchQuery, { setInputQuery: setInputQuery, triggerSearch: triggerSearch }] = (0, $djVCD.useSearchQuery)();
    const [{ primaryProduct: primaryProduct, user: user }] = (0, $j4ply.useBootstrap)();
    const [userWithStatus] = (0, $4Qo4W.useUser)();
    const [showDropdown, { setShowDropdown: setShowDropdown }] = (0, $25a8b9613a265659$export$8c32fdb3462273b4)();
    const [features] = (0, $4Qo4W.useFeatures)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const fireCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchInput');
    const isUserAuthenticated = userWithStatus.status === (0, $lwP5K.UserStatus).Authenticated;
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const { placeholder: placeholder } = (0, $6891f76f64ebebfd$export$3bfd2296a37df616)({
        applicationMode: applicationMode,
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        availableProducts: availableProducts,
        isNav4Enabled: isNav4Enabled,
        quickFindOpen: true // We only consider the open state for FPS
    });
    let hasReceivedFocus = (0, $42omo.useMemo)(()=>props.hasReceivedFocus ? props.hasReceivedFocus : ()=>{}, [
        props.hasReceivedFocus
    ]); // Sync local query with input query
    (0, $42omo.useEffect)(()=>{
        setInputQuery(localQuery);
    }, [
        setInputQuery,
        localQuery
    ]); // Sync search query with local query
    // on search query change, determine intent / get smart answer route
    (0, $42omo.useEffect)(()=>{
        setLocalQuery(searchQuery);
    }, [
        searchQuery,
        setLocalQuery
    ]);
    const handleOnSubmit = ()=>{
        // Store search in recent searches
        if (localQuery.trim() !== '' && user && user.id && primaryProduct) (0, $1SV4e.addRecentSearch)(localQuery, user.id, primaryProduct, (0, $1SV4e.RECENT_SEARCH_KEY));
        if (onSubmit) onSubmit();
        if (features?.chromeExtension?.enabled) features.chromeExtension.onInputSubmit({
            query: localQuery
        });
        else triggerSearch();
    };
    const onChange = (0, $42omo.useCallback)((e)=>{
        setLocalQuery(e.currentTarget.value);
        hasReceivedFocus();
        if (e.currentTarget.value === '' && !isUserAuthenticated) setShowDropdown(false);
        else if (e.currentTarget.value !== '') setShowDropdown(true);
    }, [
        hasReceivedFocus,
        isUserAuthenticated,
        setLocalQuery,
        setShowDropdown
    ]);
    const onClick = ()=>{
        hasReceivedFocus();
        if (localQuery === '' && !isUserAuthenticated) setShowDropdown(false);
    };
    const onKeyPress = (event)=>{
        if (event.key === 'Enter') {
            handleOnSubmit();
            event.currentTarget.blur();
        }
    };
    const onKeyDown = (event)=>{
        if (event.key === 'ArrowDown') hasReceivedFocus();
        if (showDropdown && event.key === 'Tab') {
            if (onSubmit) onSubmit();
        }
    };
    const searchBoxRef = (0, $42omo.useRef)(null);
    (0, $86ob4.useWidthObserverRegistration)('search-box', searchBoxRef);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $60ee798dd775f6bb$var$textFieldBoxStyles,
        ref: (0, $kIdP4.mergeRefs)(ref, searchBoxRef),
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                "_zbay1qi0 _1r6fe4h9 _k8em1ylp"
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default), {
                ref: props.keyboardRef,
                id: "text-query-input",
                testId: "text-query-input",
                value: localQuery,
                onKeyPress: (event)=>onKeyPress(event),
                onKeyDown: (event)=>onKeyDown(event),
                onChange: onChange,
                onClick: onClick,
                autoComplete: "off",
                placeholder: placeholder,
                elemBeforeInput: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $60ee798dd775f6bb$var$searchIconWrapperStyles,
                    children: isLoading ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                        testId: "search-page-input-spinner",
                        size: "small"
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                        color: "currentColor",
                        label: intl.formatMessage((0, $d1f083be19fc31e1$export$defe85febe8b728c).searchIconLabel)
                    })
                }),
                elemAfterInput: localQuery && /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                    space: "space.050",
                    xcss: $60ee798dd775f6bb$var$rightIconStyles,
                    children: [
                        applicationMode === (0, $9vOy1.ApplicationModes).Rovo && /*#__PURE__*/ (0, $l998X.jsx)((0, $fm8DG.CopyLinkButton), {
                            fullResultUrl: ()=>generateSearchUrl({
                                    ...queryParams,
                                    text: localQuery
                                }),
                            showSuccess: true,
                            isButton: true,
                            onClick: fireCopyLinkButtonClicked,
                            testId: "search-input-copy-link-button"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                                    ...iconProps,
                                    color: "currentColor",
                                    size: "small"
                                }),
                            spacing: "compact",
                            onClick: ()=>setLocalQuery(''),
                            label: intl.formatMessage((0, $d1f083be19fc31e1$export$defe85febe8b728c).clearIconLabel),
                            appearance: "subtle"
                        })
                    ]
                }),
                autoFocus: true
            })
        })
    });
});


const $7f479a12f1edc810$var$textFieldBoxStyles = (0, $ecnYn.xcss)({
    height: 'space.500',
    flexGrow: 1
});
const $7f479a12f1edc810$export$f5b8910cec6cf069 = ()=>{
    const [showDropdown, { setShowDropdown: setShowDropdown }] = (0, $25a8b9613a265659$export$8c32fdb3462273b4)();
    const inputBoxRef = (0, $42omo.useRef)(null);
    const inputRef = (0, $42omo.useRef)(null);
    const [searchQuery] = (0, $djVCD.useSearchQuery)();
    (0, $4219044a34e95c55$export$11133d09694420f7)();
    const [_, setInputWidth] = (0, $42omo.useState)(inputBoxRef.current?.offsetWidth);
    const [localQuery, setLocalQuery] = (0, $42omo.useState)(searchQuery);
    const { fireAnalyticsEvent: fireAnalyticsEvent, fireAnalyticsScreenEvent: fireAnalyticsScreenEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    (0, $42omo.useEffect)(()=>{
        const listener = ()=>setInputWidth(inputBoxRef.current?.offsetWidth);
        const unbind = (0, $fFa3V.bind)(window, {
            type: 'resize',
            listener: listener
        });
        return unbind;
    }, []);
    const closeDropdown = (0, $42omo.useCallback)(()=>{
        if (showDropdown) {
            setShowDropdown(false);
            fireAnalyticsEvent((0, $c8c12c8e63822f48$export$900d08b010253a5e)({
                commonAttributes: commonAttributes,
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
        }
    }, [
        showDropdown,
        setShowDropdown,
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes
    ]);
    const trigger = (0, $42omo.useCallback)((triggerProps)=>{
        // When the SearchTextField receives a submit/enter
        const hasSubmitted = ()=>{
            closeDropdown();
        };
        // When the SearchTextField receives focus - simple API for multiple events that cause this
        const inputHasReceivedFocus = ()=>{
            if (!showDropdown) {
                fireAnalyticsScreenEvent((0, $94068ad8452530ec$export$c8d721b69c7e30be)({
                    commonAttributes: commonAttributes
                }));
                setShowDropdown(true);
            }
        };
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $7f479a12f1edc810$var$textFieldBoxStyles,
            ref: inputBoxRef,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $60ee798dd775f6bb$export$fb8d8fbc0c4c1705), {
                keyboardRef: inputRef,
                ...triggerProps,
                ref: triggerProps.ref,
                onSubmit: hasSubmitted,
                hasReceivedFocus: inputHasReceivedFocus,
                localQuery: localQuery,
                setLocalQuery: setLocalQuery
            })
        });
    }, [
        localQuery,
        closeDropdown,
        showDropdown,
        fireAnalyticsScreenEvent,
        commonAttributes,
        setShowDropdown
    ]);
    const content = /*#__PURE__*/ (0, $l998X.jsx)((0, $icqFF.KeyboardHighlightProvider), {
        listenerNode: inputRef?.current,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $355509f988cf3833$export$e33d60b8f4099ae), {
            inputWidth: inputBoxRef.current?.offsetWidth || 0,
            setLocalQuery: setLocalQuery
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.Popup), {
        shouldReturnFocus: false,
        content: ()=>content,
        isOpen: showDropdown,
        autoFocus: false,
        placement: "bottom-start",
        trigger: trigger,
        onClose: closeDropdown
    });
};
const $7f479a12f1edc810$var$FallbackInput = ()=>{
    const [localQuery, setLocalQuery] = (0, $42omo.useState)('');
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $60ee798dd775f6bb$export$fb8d8fbc0c4c1705), {
        localQuery: localQuery,
        setLocalQuery: setLocalQuery
    });
};
const $7f479a12f1edc810$var$InputWithErrorBoundary = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)($7f479a12f1edc810$var$FallbackInput, {}),
        section: "SearchPageInput",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
            name: "search-page-input",
            children: /*#__PURE__*/ (0, $l998X.jsx)($7f479a12f1edc810$export$f5b8910cec6cf069, {})
        })
    });
};
var $7f479a12f1edc810$export$2e2bcd8739ae039 = $7f479a12f1edc810$var$InputWithErrorBoundary;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $dpPtd = parcelRequire("dpPtd");


var $gdv5Z = parcelRequire("gdv5Z");










/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ 























parcelRequire("42omo");






const $9524713bd8d2fe7c$var$contentContainerStyles = (0, $ecnYn.xcss)({
    margin: 'auto',
    maxWidth: '70rem',
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    boxSizing: 'content-box'
});
const $9524713bd8d2fe7c$export$9d2b4227a95687cc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $9524713bd8d2fe7c$var$contentContainerStyles,
        children: children
    });
};





const $3bfa803c3f388465$var$RightPanelContainerStyles = (0, $ecnYn.xcss)({
    width: '100%',
    display: 'inline'
});
const $3bfa803c3f388465$var$bodyStackStyles = (0, $ecnYn.xcss)({
    // By default, elements with display: flex will have a width of auto, which
    // means they will not shrink below the width of their content. By setting
    // this to 0, it ensures that this stack will not grow beyond its width.
    minWidth: '0'
});
const $3bfa803c3f388465$var$gridStyles = (0, $ecnYn.xcss)({
    grid: '1fr / 100fr'
});
const $3bfa803c3f388465$var$gridStylesSmall = (0, $ecnYn.xcss)({
    grid: '1fr / 70fr 30fr'
});
const $3bfa803c3f388465$var$gridStylesMedium = (0, $ecnYn.xcss)({
    grid: '1fr / 100fr 250px'
}); // Prevent the smart answers dialog from z-indexing above the dialog, filters etc
const $3bfa803c3f388465$var$smartAnswersWrapperStyles = null;
const $3bfa803c3f388465$export$36cf6d64005c1ddf = ({ components: components })=>{
    const { smartAnswers: smartAnswers, results: resultsComponent, autoCorrection: autoCorrection, messageBanner: messageBanner } = components;
    (0, $42omo.useEffect)(()=>{
        // The scroll is on the window level so we have to scroll window to 0,0 to reset the scroller
        window.scrollTo(0, 0);
    }, [
        smartAnswers,
        resultsComponent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_1pbyidpf _p12f1f38"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
            space: "space.200",
            xcss: $3bfa803c3f388465$var$bodyStackStyles,
            children: [
                autoCorrection,
                smartAnswers,
                messageBanner,
                resultsComponent
            ]
        })
    });
};
const $3bfa803c3f388465$export$4b2c32e08f77ff18 = ({ components: components })=>{
    const { rightPanel: rightPanel } = components;
    const width = (0, $86ob4.useElementWidth)('layout'); // Primary use case for this is side-by-side which does not set a rightPanel
    if (!rightPanel) return /*#__PURE__*/ (0, $l998X.jsx)((0, $9524713bd8d2fe7c$export$9d2b4227a95687cc), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cwkWT.default), {
            gap: "space.400",
            templateColumns: '100fr',
            children: /*#__PURE__*/ (0, $l998X.jsx)($3bfa803c3f388465$export$36cf6d64005c1ddf, {
                components: components
            })
        })
    });
    else if (width > 0) {
        const isAboveMedium = (0, $86ob4.isBreakpointActive)({
            width: width,
            above: 'md'
        });
        const isAboveSmall = (0, $86ob4.isBreakpointActive)({
            width: width,
            above: 'sm'
        });
        let className = $3bfa803c3f388465$var$gridStyles;
        if (isAboveMedium) className = $3bfa803c3f388465$var$gridStylesMedium;
        else if (isAboveSmall) className = $3bfa803c3f388465$var$gridStylesSmall;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $9524713bd8d2fe7c$export$9d2b4227a95687cc), {
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
                gap: "space.1000",
                xcss: className,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)($3bfa803c3f388465$export$36cf6d64005c1ddf, {
                        components: components
                    }),
                    isAboveSmall && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $3bfa803c3f388465$var$RightPanelContainerStyles,
                        children: rightPanel
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
        name: "search-page-body-layout-width"
    });
};


/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ 













var $6F6hl = parcelRequire("6F6hl");








const $b23ade25aad3d226$var$baseHeaderStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface',
    width: '100%',
    marginBottom: 'space.250'
});
const $b23ade25aad3d226$var$keylineStyles = (0, $ecnYn.xcss)({
    borderBottom: `solid ${"var(--ds-border-width, 1px)"} ${"var(--ds-border, #0B120E24)"}`
});
const $b23ade25aad3d226$var$headerGridStyles = (0, $ecnYn.xcss)({
    paddingBottom: 'space.250'
});
const $b23ade25aad3d226$var$headerPaddingTopStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.300'
});
const $b23ade25aad3d226$var$inputGridAreaStyles = (0, $ecnYn.xcss)({
    gridArea: 'input',
    display: 'flex',
    alignItems: 'center'
});
const $b23ade25aad3d226$var$filtersGridAreaStyles = (0, $ecnYn.xcss)({
    gridArea: 'filters'
});
const $b23ade25aad3d226$var$Header = ({ components: components })=>{
    const { input: input, filters: filters } = components;
    const { isNav4Enabled: isNav4Enabled } = (0, $7WbA8.useAppContext)();
    const [stickyHeaderStyles, setStickyHeaderStyles] = (0, $42omo.useState)();
    const referenceRef = (0, $42omo.useRef)(null);
    const headerRef = (0, $42omo.useRef)(null);
    // Use the reference element's position to set the sticky styles on the
    // header. This allows `top` to always be correct.
    (0, $42omo.useEffect)(()=>{
        if (!referenceRef.current) return;
        // QS-5148
        // referenceY is a measure of how far the top of search-page is from the top of the scrolling context. This works in old nav, because the scroll matches the viewport
        // In Nav 4, the scroll is the content region and the nav is outside of it
        // This is a temporary fix to unblock Nav4 dogfooding
        let referenceY = referenceRef.current.getBoundingClientRect().top;
        // If the Nav4 feature prop is enabled, we set the referenceY to 0 as the layout doesn't require an offset
        if (isNav4Enabled) referenceY = 0;
        const scrollY = window.scrollY;
        const top = referenceY + scrollY;
        setStickyHeaderStyles((0, $ecnYn.xcss)({
            position: 'sticky',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            top: `${top}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundClip: 'padding-box'
        }));
    }, [
        setStickyHeaderStyles,
        isNav4Enabled
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                ref: referenceRef,
                testId: "search-page-header-reference"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $b23ade25aad3d226$var$baseHeaderStyles,
                    stickyHeaderStyles,
                    $b23ade25aad3d226$var$keylineStyles
                ],
                testId: "search-page-header",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    zIndex: 3
                },
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9524713bd8d2fe7c$export$9d2b4227a95687cc), {
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
                        ref: headerRef,
                        xcss: [
                            $b23ade25aad3d226$var$headerGridStyles,
                            !isNav4Enabled && $b23ade25aad3d226$var$headerPaddingTopStyles
                        ],
                        columnGap: "space.200",
                        rowGap: "space.200",
                        templateAreas: [
                            'input .',
                            'filters filters'
                        ],
                        templateColumns: "65fr 35fr",
                        children: [
                            !isNav4Enabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                xcss: $b23ade25aad3d226$var$inputGridAreaStyles,
                                children: input
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                xcss: $b23ade25aad3d226$var$filtersGridAreaStyles,
                                children: filters
                            })
                        ]
                    })
                })
            }),
            isNav4Enabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                children: input
            })
        ]
    });
};
const $b23ade25aad3d226$var$HeaderWithErrorBoundary = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $b23ade25aad3d226$var$headerGridStyles,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9524713bd8d2fe7c$export$9d2b4227a95687cc), {
                children: props.components.input
            })
        }),
        section: "SearchPageHeader",
        children: /*#__PURE__*/ (0, $l998X.jsx)($b23ade25aad3d226$var$Header, {
            ...props
        })
    });
};
var $b23ade25aad3d226$export$2e2bcd8739ae039 = $b23ade25aad3d226$var$HeaderWithErrorBoundary;





parcelRequire("42omo");







const $96f3bfaa6b8f4687$var$baseHeaderStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface',
    width: '100%'
});
const $96f3bfaa6b8f4687$var$headerGridStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.400',
    paddingBottom: 'space.200'
});
const $96f3bfaa6b8f4687$var$HeaderSideBySide = ({ components: components })=>{
    const { filters: filters } = components;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: [
                $96f3bfaa6b8f4687$var$baseHeaderStyles
            ],
            testId: "search-page-header",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                zIndex: 10
            },
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9524713bd8d2fe7c$export$9d2b4227a95687cc), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $96f3bfaa6b8f4687$var$headerGridStyles,
                    children: filters
                })
            })
        })
    });
};
var $96f3bfaa6b8f4687$export$2e2bcd8739ae039 = $96f3bfaa6b8f4687$var$HeaderSideBySide;


const $ae52891585221a98$export$cd95088e3160fae9 = ({ components: { input: input, filters: filters, results: results, smartAnswers: smartAnswers, oauthContainer: oauthContainer, rightPanel: rightPanel, autoCorrection: autoCorrection, messageBanner: messageBanner, bulkConnectModal: bulkConnectModal } })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $86ob4.WidthObserverElement), {
        id: "layout",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
            testId: "search-page-layout",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $b23ade25aad3d226$export$2e2bcd8739ae039), {
                    components: {
                        input: input,
                        filters: filters
                    }
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3bfa803c3f388465$export$4b2c32e08f77ff18), {
                    components: {
                        results: results,
                        smartAnswers: smartAnswers,
                        rightPanel: rightPanel,
                        oauthContainer: oauthContainer,
                        autoCorrection: autoCorrection,
                        messageBanner: messageBanner
                    }
                }),
                (0, $2OtFZ.serve3PBulkConnectWithoutExposure)() && bulkConnectModal
            ]
        })
    });
};
const $ae52891585221a98$export$c84671f46d6a1ca = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: "search-page-layout",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dpPtd.FlagsProvider), {
            children: /*#__PURE__*/ (0, $l998X.jsx)($ae52891585221a98$export$cd95088e3160fae9, {
                components: props.components
            })
        })
    });
const $ae52891585221a98$export$8ac1fb3f3f89d5bf = ({ components: { filters: filters, results: results, smartAnswers: smartAnswers, oauthContainer: oauthContainer, autoCorrection: autoCorrection } })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: "search-page-sbs-layout",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
            testId: "search-page-layout",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $96f3bfaa6b8f4687$export$2e2bcd8739ae039), {
                    components: {
                        filters: filters
                    }
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3bfa803c3f388465$export$4b2c32e08f77ff18), {
                    components: {
                        results: results,
                        smartAnswers: smartAnswers,
                        oauthContainer: oauthContainer,
                        autoCorrection: autoCorrection
                    }
                })
            ]
        })
    });






var $bVltF = parcelRequire("bVltF");




const $eebd889499df8cd4$export$4501d5ed63e0d41d = ()=>{
    const [successCalled, setSuccessCalled] = (0, $42omo.useState)(false);
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    (0, $42omo.useEffect)(()=>{
        if (successCalled) return;
        if (primaryProduct && (0, $bVltF.searchPageLoadUFOExperience).state.id === 'STARTED') {
            (0, $bVltF.searchPageLoadUFOExperience).success();
            setSuccessCalled(true);
        }
    }, [
        primaryProduct,
        successCalled
    ]);
    return null;
};









var $7bZ3i = parcelRequire("7bZ3i");
















var $k4HRJ = parcelRequire("k4HRJ");


var $6h3V2 = parcelRequire("6h3V2");


var $hB77E = parcelRequire("hB77E");

var $d264f14dd361aa2b$exports = {};
$d264f14dd361aa2b$exports = new URL("error-dark.43e0a164.svg", import.meta.url).toString();


var $6df538e2e254fd26$exports = {};
$6df538e2e254fd26$exports = new URL("error-light.02ef2e6f.svg", import.meta.url).toString();






var $fZ3l2 = parcelRequire("fZ3l2");





const $c7e627886411fcb9$export$add61e2630a21f9 = 'cachedImageErrorLight';
const $c7e627886411fcb9$export$4be43fd067fd9d7f = 'cachedImageErrorDark';
const $c7e627886411fcb9$export$7f23364af4709df5 = async (url, key)=>{
    const response = await fetch(url);
    const blob = await response.blob();
    const reader = new FileReader();
    const base64data = await new Promise((resolve, reject)=>{
        reader.onloadend = ()=>{
            resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
    (0, $5G9KX.setLocalStorageItem)(key, base64data);
};
const $c7e627886411fcb9$export$5e3e5ca9e3ba891b = async (isOnline, imageLight, lightImageKey, imageDark, darkImageKey)=>{
    if (isOnline) {
        await $c7e627886411fcb9$export$7f23364af4709df5(imageLight, lightImageKey);
        await $c7e627886411fcb9$export$7f23364af4709df5(imageDark, darkImageKey);
    }
};
const $c7e627886411fcb9$export$ce969d199fe2c04e = (key)=>{
    return (0, $5G9KX.getLocalStorageItemAsString)(key);
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 















var $1bY7o = parcelRequire("1bY7o");








var $kpYGL = parcelRequire("kpYGL");


var $hpUsb = parcelRequire("hpUsb");

var $5TXU5 = parcelRequire("5TXU5");

var $5znEc = parcelRequire("5znEc");










const $514d99dea8b7ae4b$var$fallbackComponentStyles = null;
const $514d99dea8b7ae4b$var$styles = null;
const $514d99dea8b7ae4b$var$cardList = {
    base: "_zulpv47k _1e0c1txw _2lx21bp4",
    hidden: "_tzy4idpf _kqswstnw _154iidpf",
    appended: "_ca0q1b66",
    notAppended: "_ca0qpxbi"
}; /**
    * Smart cards lazy load when they are in the viewport. This is a behavior that is
    * not desired in this experience. To circumvent this, we set the position of the
    * card to absolute and hide it until the link is resolved. This allows the card to
    * be rendered in the DOM without lazy loading, while still being hidden from view
    * until the link is resolved.
    */ 
const $514d99dea8b7ae4b$var$card = {
    hidden: "_tzy4idpf _kqswstnw _154iidpf"
};
const $514d99dea8b7ae4b$var$skeleton = {
    grid: "_zulpu2gc _1e0c11p5 _1lmcyw1n _yv0e1p7m _2z051d08",
    iconArea: "_nd5l2ec4",
    titleArea: "_nd5l1cy2",
    metaArea: "_nd5l8bpj"
};
const $514d99dea8b7ae4b$export$dffce0f8d8968f9c = ({ links: links = [], isLinkedResults: isLinkedResults, indexOffset: indexOffset, parentPosition: parentPosition, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [linksLoading, setLinksLoading] = (0, $42omo.useState)(links);
    const [linkProductKeys, setLinkProductKeys] = (0, $42omo.useState)(new Map());
    const cards = links.map((link, index)=>{
        const resolveLink = (productKey)=>{
            if (productKey) setLinkProductKeys((prev)=>{
                // Only update if the value has changed to prevent infinite re-renders
                if (prev.get(link) !== productKey) {
                    const newMap = new Map(prev);
                    newMap.set(link, productKey);
                    return newMap;
                }
                return prev;
            });
            if (linksLoading.includes(link)) setLinksLoading((prev)=>prev.filter((l)=>l !== link));
        };
        return /*#__PURE__*/ (0, $l998X.jsx)("div", {
            role: "button",
            tabIndex: 0,
            onContextMenu: (e)=>{
                e.preventDefault();
                if (isLinkedResults) {
                    const productKey = linkProductKeys.get(link);
                    const fanoutProduct = (0, $dh538.fg)('expose-product-details-from-smart-card') ? $514d99dea8b7ae4b$var$getProductKey(productKey) : 'feExtractedLink';
                    onResultContextMenu?.({
                        sublistPosition: index + (indexOffset ?? 0),
                        linkDocContentType: (0, $lwP5K.LinkDocContentType).extractedLink,
                        fanoutProduct: fanoutProduct
                    });
                }
            },
            className: (0, $gMc0m.default)([
                linksLoading.length && $514d99dea8b7ae4b$var$card.hidden
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hpUsb.Card), {
                url: link,
                appearance: "inline",
                ui: {
                    hideElevation: true,
                    hideBackground: true,
                    hidePadding: true,
                    size: (0, $5TXU5.SmartLinkSize).Medium
                },
                onResolve: ({ extensionKey: extensionKey })=>{
                    resolveLink(extensionKey);
                },
                onError: ({ status: status, url: url, err: err })=>{
                    resolveLink();
                    createAnalyticsEvent({
                        type: 'sendTrackEvent',
                        data: {
                            action: 'error',
                            actionSubject: `${(0, $6yNqK.ACTION_SUBJECT_PREFIX)}SearchResultSmartCard`,
                            source: (0, $6yNqK.EVENT_SOURCE),
                            attributes: {
                                status: status
                            }
                        }
                    }).fire();
                },
                onClick: ()=>{
                    window.open(link, '_blank', 'noopener,noreferrer');
                    const productKey = linkProductKeys.get(link);
                    const fanoutProduct = (0, $dh538.fg)('expose-product-details-from-smart-card') ? $514d99dea8b7ae4b$var$getProductKey(productKey) : 'feExtractedLink';
                    createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            action: 'clicked',
                            actionSubject: `${(0, $6yNqK.ACTION_SUBJECT_PREFIX)}SearchResultSmartCard`,
                            source: (0, $6yNqK.EVENT_SOURCE),
                            attributes: {
                                position: parentPosition,
                                sublistPosition: indexOffset !== undefined ? index + indexOffset : undefined
                            }
                        }
                    }).fire();
                    if (isLinkedResults) onResultClicked?.({
                        sublistPosition: index + (indexOffset ?? 0),
                        linkDocContentType: (0, $lwP5K.LinkDocContentType).extractedLink,
                        fanoutProduct: fanoutProduct
                    });
                },
                placeholder: " ",
                fallbackComponent: ()=>/*#__PURE__*/ (0, $l998X.jsxs)("div", {
                        className: (0, $gMc0m.default)([
                            "_zulp1b66 _1e0c1txw _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                                label: "",
                                size: "small"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
                                href: link,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: link
                            })
                        ]
                    }),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5znEc.default), {
                    hideRetry: true,
                    hideIconLoadingSkeleton: true,
                    maxLines: 1,
                    metadata: [
                        {
                            name: (0, $5TXU5.ElementName).State
                        }
                    ],
                    subtitle: [
                        {
                            name: (0, $5TXU5.ElementName).CreatedBy
                        },
                        {
                            name: (0, $5TXU5.ElementName).ModifiedOn
                        }
                    ],
                    metadataPosition: (0, $5TXU5.SmartLinkPosition).Top,
                    position: (0, $5TXU5.SmartLinkPosition).Top
                })
            })
        }, link);
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        className: (0, $gMc0m.default)([
            "_kqswh2mm _19bvutpp"
        ]),
        children: [
            linksLoading.length > 0 && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $514d99dea8b7ae4b$var$cardList.base
                ]),
                children: links.map((link)=>/*#__PURE__*/ (0, $l998X.jsxs)("div", {
                        className: (0, $gMc0m.default)([
                            $514d99dea8b7ae4b$var$skeleton.grid
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                className: (0, $gMc0m.default)([
                                    $514d99dea8b7ae4b$var$skeleton.iconArea
                                ]),
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                    height: "16px",
                                    width: "16px",
                                    borderRadius: "4px",
                                    isShimmering: true
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                className: (0, $gMc0m.default)([
                                    $514d99dea8b7ae4b$var$skeleton.titleArea
                                ]),
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                    height: "16px",
                                    width: "50%",
                                    isShimmering: true
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                className: (0, $gMc0m.default)([
                                    $514d99dea8b7ae4b$var$skeleton.metaArea
                                ]),
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                    height: "16px",
                                    width: "85%",
                                    isShimmering: true
                                })
                            })
                        ]
                    }, link))
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $514d99dea8b7ae4b$var$cardList.base,
                    linksLoading.length && $514d99dea8b7ae4b$var$cardList.hidden,
                    isLinkedResults ? $514d99dea8b7ae4b$var$cardList.appended : $514d99dea8b7ae4b$var$cardList.notAppended
                ]),
                children: cards
            })
        ]
    });
};
const $514d99dea8b7ae4b$export$a414b3d5a172e15b = (text)=>{
    const urlPattern = /(https?:\/\/[^\s|>)\]]+)/g;
    const invalidEndingPattern = /\.{2,}|[.,;!?]+$/;
    const cleanedText = text.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
    let matches = cleanedText.match(urlPattern)?.map(String) || []; // Check if the text ends with a URL - if so, exclude it as it might be truncated
    if (matches.length > 0) {
        const lastMatch = matches[matches.length - 1];
        const lastMatchIndex = cleanedText.lastIndexOf(lastMatch);
        const textEndsWithLastMatch = lastMatchIndex + lastMatch.length === cleanedText.length; // If the text ends with a URL, exclude the last url match
        if (textEndsWithLastMatch) matches = matches.slice(0, -1);
    } // Filter out URLs that end with invalid patterns like "...", ".", ",", etc.
    const validMatches = matches.filter((url)=>!invalidEndingPattern.test(url)); // Deduplicate (helpful for markdown like [https://example.com](https://example.com) )
    return [
        ...new Set(validMatches)
    ];
};
const $514d99dea8b7ae4b$var$getProductKey = (key)=>{
    if (!key) return 'unknown';
    const foundKey1P = (0, $1yEFx.all1pProductKeys).find((productKey)=>key.includes(productKey));
    if (foundKey1P) return foundKey1P;
    const foundKey3P = (0, $1yEFx.all3pProductKeys).find((productKey)=>key.includes(productKey));
    if (foundKey3P) return foundKey3P;
    return 'unknown';
};
const $514d99dea8b7ae4b$export$47614749115bca3d = (0, $cgtv4.defineMessage)({
    id: "link-attachments.button.label",
    defaultMessage: "{count, plural, one {# link} other {# links}}"
});


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


















var $69PnT = parcelRequire("69PnT");










/**
 * Domain patterns for different products
 * Maps domain patterns to ProductKeys (both 1P and 3P)
 */ const $21d2cd4cc2a842d3$var$DOMAIN_TO_PRODUCT_MAP = [
    // First-party Atlassian products
    {
        pattern: /^(.*\.)?atlassian\.net$/i,
        product: 'confluence'
    },
    {
        pattern: /^(.*\.)?atlassian\.com$/i,
        product: 'confluence'
    },
    {
        pattern: /^(.*\.)?trello\.com$/i,
        product: 'trello'
    },
    {
        pattern: /^(.*\.)?bitbucket\.org$/i,
        product: 'bitbucket'
    },
    // Google products (3P)
    {
        pattern: /^(.*\.)?drive\.google\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).GoogleDrive
    },
    {
        pattern: /^(.*\.)?docs\.google\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).GoogleDrive
    },
    {
        pattern: /^(.*\.)?sheets\.google\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).GoogleDrive
    },
    {
        pattern: /^(.*\.)?slides\.google\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).GoogleDrive
    },
    {
        pattern: /^(.*\.)?calendar\.google\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).GoogleCalendar
    },
    {
        pattern: /^(.*\.)?mail\.google\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Gmail
    },
    {
        pattern: /^(.*\.)?gmail\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Gmail
    },
    // Microsoft products (3P)
    {
        pattern: /^(.*\.)?sharepoint\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Sharepoint
    },
    {
        pattern: /^(.*\.)?onedrive\.live\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).OneDrive
    },
    {
        pattern: /^(.*\.)?1drv\.ms$/i,
        product: (0, $1yEFx.ProductKeys3P).OneDrive
    },
    {
        pattern: /^(.*\.)?teams\.microsoft\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Teams
    },
    {
        pattern: /^(.*\.)?outlook\.live\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).OutlookMail
    },
    {
        pattern: /^(.*\.)?outlook\.office\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).OutlookCalendar
    },
    // Other popular products (3P)
    {
        pattern: /^(.*\.)?slack\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Slack
    },
    {
        pattern: /^(.*\.)?dropbox\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Dropbox
    },
    {
        pattern: /^(.*\.)?github\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Github
    },
    {
        pattern: /^(.*\.)?figma\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Figma
    },
    {
        pattern: /^(.*\.)?loom\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Loom
    },
    {
        pattern: /^(.*\.)?notion\.so$/i,
        product: (0, $1yEFx.ProductKeys3P).Notion
    },
    {
        pattern: /^(.*\.)?asana\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Asana
    },
    {
        pattern: /^(.*\.)?airtable\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Airtable
    },
    {
        pattern: /^(.*\.)?smartsheet\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Smartsheet
    },
    {
        pattern: /^(.*\.)?zendesk\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Zendesk
    },
    {
        pattern: /^(.*\.)?miro\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Miro
    },
    {
        pattern: /^(.*\.)?docusign\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Docusign
    },
    {
        pattern: /^(.*\.)?lucidchart\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Lucid
    },
    {
        pattern: /^(.*\.)?lucidspark\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Lucid
    },
    {
        pattern: /^(.*\.)?monday\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Monday
    },
    {
        pattern: /^(.*\.)?dev\.azure\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).AzureDevops
    },
    {
        pattern: /^(.*\.)?visualstudio\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).AzureDevops
    },
    {
        pattern: /^(.*\.)?gitlab\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Gitlab
    },
    {
        pattern: /^(.*\.)?canva\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Canva
    },
    {
        pattern: /^(.*\.)?box\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Box
    },
    {
        pattern: /^(.*\.)?zeplin\.io$/i,
        product: (0, $1yEFx.ProductKeys3P).Zeplin
    },
    {
        pattern: /^(.*\.)?servicenow\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).ServiceNow
    },
    {
        pattern: /^(.*\.)?freshservice\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Freshservice
    },
    {
        pattern: /^(.*\.)?powerbi\.microsoft\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).PowerBI
    },
    {
        pattern: /^(.*\.)?clickup\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).ClickUp
    },
    {
        pattern: /^(.*\.)?amplitude\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Amplitude
    },
    {
        pattern: /^(.*\.)?stripe\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Stripe
    },
    {
        pattern: /^(.*\.)?adobe\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).AdobeXD
    },
    // Could be AdobeSign too
    {
        pattern: /^(.*\.)?aha\.io$/i,
        product: (0, $1yEFx.ProductKeys3P).Aha
    },
    {
        pattern: /^(.*\.)?mural\.co$/i,
        product: (0, $1yEFx.ProductKeys3P).Mural
    },
    {
        pattern: /^(.*\.)?webex\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Webex
    },
    {
        pattern: /^(.*\.)?todoist\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Todoist
    },
    {
        pattern: /^(.*\.)?pagerduty\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).PagerDuty
    },
    {
        pattern: /^(.*\.)?pipedrive\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Pipedrive
    },
    {
        pattern: /^(.*\.)?hubspot\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Hubspot
    },
    {
        pattern: /^(.*\.)?dovetailapp\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Dovetail
    },
    {
        pattern: /^(.*\.)?launchdarkly\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).LaunchDarkly
    },
    {
        pattern: /^(.*\.)?salesforce\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Salesforce
    },
    {
        pattern: /^(.*\.)?sentry\.io$/i,
        product: (0, $1yEFx.ProductKeys3P).Sentry
    },
    {
        pattern: /^(.*\.)?gitbook\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).Gitbook
    },
    {
        pattern: /^(.*\.)?amazonaws\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).AWSS3
    },
    {
        pattern: /^(.*\.)?s3\..*\.amazonaws\.com$/i,
        product: (0, $1yEFx.ProductKeys3P).AWSS3
    }
];
/**
 * Extracts the domain from a URL
 */ function $21d2cd4cc2a842d3$var$extractDomain(url) {
    try {
        const urlObj = new URL(url);
        return urlObj.hostname;
    } catch  {
        return null;
    }
}
/**
 * Predicts the product type based on the URL domain
 */ function $21d2cd4cc2a842d3$var$predictProductFromDomain(url) {
    const domain = $21d2cd4cc2a842d3$var$extractDomain(url);
    if (!domain) return null;
    for (const { pattern: pattern, product: product } of $21d2cd4cc2a842d3$var$DOMAIN_TO_PRODUCT_MAP){
        if (pattern.test(domain)) return product;
    }
    return null;
}
/**
 * Classifies a URL into its type and product category
 */ function $21d2cd4cc2a842d3$var$classifyLink(url) {
    const product = $21d2cd4cc2a842d3$var$predictProductFromDomain(url);
    let linkType;
    if (product && (0, $1yEFx.is3pProductKey)(product)) linkType = '3p';
    else if (product && (0, $1yEFx.is1pProductKey)(product)) linkType = '1p';
    else linkType = 'unknown';
    return {
        url: url,
        product: product,
        linkType: linkType
    };
}
/**
 * Gets the tier priority for a link classification
 * Special case: Loom is treated as 1P even though it's in ProductsOrder3P
 */ function $21d2cd4cc2a842d3$var$getTierPriority(item) {
    // Special case: Loom should be treated as 1P
    if (item.product === (0, $1yEFx.ProductKeys3P).Loom) return 1; // Treat Loom as 1P priority
    if (item.linkType === '3p') return 0;
     // 3P links first
    if (item.linkType === '1p') return 1;
     // 1P links second
    return 2; // Unknown links last
}
function $21d2cd4cc2a842d3$export$396d67700f1fa04e(urls) {
    // Create order maps for faster lookup
    const fullProductOrderMap = new Map();
    (0, $1yEFx.PRODUCTS_ORDER).forEach((product, index)=>{
        fullProductOrderMap.set(product, index);
    });
    // Classify URLs by their type and product
    const classifiedUrls = urls.map((url)=>$21d2cd4cc2a842d3$var$classifyLink(url));
    // Sort URLs based on two-tier priority system
    classifiedUrls.sort((a, b)=>{
        // First tier: 3P vs 1P vs Unknown
        const tierA = $21d2cd4cc2a842d3$var$getTierPriority(a);
        const tierB = $21d2cd4cc2a842d3$var$getTierPriority(b);
        if (tierA !== tierB) return tierA - tierB;
        // Second tier: Within same tier, sort by product order
        if (a.linkType === '3p' && b.linkType === '3p' && a.product && b.product) {
            // For 3P products, use ProductsOrder3P ordering
            const order3pA = (0, $1yEFx.ProductsOrder3P).indexOf(a.product);
            const order3pB = (0, $1yEFx.ProductsOrder3P).indexOf(b.product);
            const priorityA = order3pA !== -1 ? order3pA : Number.MAX_SAFE_INTEGER;
            const priorityB = order3pB !== -1 ? order3pB : Number.MAX_SAFE_INTEGER;
            if (priorityA !== priorityB) return priorityA - priorityB;
        } else if (a.linkType === '1p' && b.linkType === '1p' && a.product && b.product || a.product === (0, $1yEFx.ProductKeys3P).Loom || b.product === (0, $1yEFx.ProductKeys3P).Loom) {
            // For 1P products or Loom (treated as 1P), use PRODUCTS_ORDER ordering
            // Special handling for Loom: position it right after Confluence
            let orderA;
            let orderB;
            if (a.product === (0, $1yEFx.ProductKeys3P).Loom) // Position Loom right after Confluence (index 0), so give it index 0.5
            orderA = 0.5;
            else orderA = fullProductOrderMap.get(a.product) ?? Number.MAX_SAFE_INTEGER;
            if (b.product === (0, $1yEFx.ProductKeys3P).Loom) orderB = 0.5;
            else orderB = fullProductOrderMap.get(b.product) ?? Number.MAX_SAFE_INTEGER;
            if (orderA !== orderB) return orderA - orderB;
        }
        // Third tier: If same type and product (or both unknown), maintain original order
        return 0;
    });
    return classifiedUrls.map((item)=>item.url);
}


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



















const $664c8ed2681bd434$var$styles = {
    base: "_ca0qu2gc",
    buttonText: "_19bvv77o"
};
function $664c8ed2681bd434$export$49bd1dfb0ad29c40({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        children: children
    });
}
const $664c8ed2681bd434$export$6b89e3fa6be10ffa = ({ children: children, defaultExpandedIndex: defaultExpandedIndex = -1, parentPosition: parentPosition, buttonType: buttonType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [activeId, setActiveId] = (0, $42omo.useState)(defaultExpandedIndex);
    // Sync activeId when defaultExpandedIndex changes (e.g., when position changes due to filtering)
    (0, $42omo.useEffect)(()=>{
        setActiveId(defaultExpandedIndex);
    }, [
        defaultExpandedIndex
    ]);
    const handleExpand = (expandId)=>setActiveId((prev)=>prev === expandId ? -1 : expandId);
    const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children).filter((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)).filter((child)=>child.props.attachmentCount > 0);
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
                space: "space.100",
                children: childrenArray.map((child, index)=>{
                    const isExpanded = activeId === index;
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $664c8ed2681bd434$var$styles.base,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            iconBefore: child.props.icon,
                            onClick: ()=>{
                                handleExpand(index);
                                createAnalyticsEvent({
                                    type: 'sendUIEvent',
                                    data: {
                                        action: 'clicked',
                                        actionSubject: `${(0, $6yNqK.ACTION_SUBJECT_PREFIX)}ExpandAttachmentButton`,
                                        source: (0, $6yNqK.EVENT_SOURCE),
                                        attributes: {
                                            attachmentType: child.props.attachmentType,
                                            attachmentCount: child.props.attachmentCount,
                                            position: parentPosition,
                                            buttonType: buttonType
                                        }
                                    }
                                }).fire();
                            },
                            isSelected: isExpanded,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                xcss: $664c8ed2681bd434$var$styles.buttonText,
                                children: child.props.label
                            })
                        }, child.props.label)
                    });
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                paddingBlock: "space.100",
                children: childrenArray[activeId]
            })
        ]
    });
};



/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $lAFHW = parcelRequire("lAFHW");




var $d8SNb = parcelRequire("d8SNb");













parcelRequire("42omo");








var $9d9t8 = parcelRequire("9d9t8");

const $235a70ab221836e5$var$MICROSOFT_INTEGRATION_KEY = 'microsoft';
const $235a70ab221836e5$var$SHAREPOINT_SUPPORTED_RESOURCE_TYPES = [
    'document'
];
const $235a70ab221836e5$var$TEAMS_SUPPORTED_RESOURCE_TYPES = [
    'message',
    'conversation',
    'video'
];
const $235a70ab221836e5$export$6582c9566971e750 = ({ product: product, resourceType: resourceType, size: size, thirdPartyConfigs: thirdPartyConfigs })=>{
    const products = (0, $1yEFx.useProductConfigs)();
    if (!product) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
        color: "currentColor",
        spacing: "spacious",
        label: ""
    });
    let productKey = product === 'google' ? (0, $1yEFx.ProductKeys).GoogleDrive : product;
    /**
	 * Temporary fix for Microsoft integrationKey
	 */ if (product === $235a70ab221836e5$var$MICROSOFT_INTEGRATION_KEY && $235a70ab221836e5$var$SHAREPOINT_SUPPORTED_RESOURCE_TYPES.includes(resourceType)) productKey = (0, $1yEFx.ProductKeys).Sharepoint;
    else if (product === $235a70ab221836e5$var$MICROSOFT_INTEGRATION_KEY && $235a70ab221836e5$var$TEAMS_SUPPORTED_RESOURCE_TYPES.includes(resourceType)) productKey = (0, $1yEFx.ProductKeys).Teams;
    let IconComponent;
    // For Forge connectors, prioritize dynamic API icons over static hardcoded ones
    if ((0, $9d9t8.isForgeConnectorProductKey)(productKey)) {
        const dynamicConfig = thirdPartyConfigs[productKey];
        if (dynamicConfig) IconComponent = dynamicConfig.searchResultIcon || dynamicConfig.icon;
    }
    // Fallback to static products (for non-Forge or if dynamic config not found)
    if (!IconComponent) IconComponent = products[productKey]?.SearchResultIcon || products[productKey]?.Icon;
    return IconComponent ? /*#__PURE__*/ (0, $l998X.jsx)(IconComponent, {
        label: "",
        size: size
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
        color: "currentColor",
        spacing: "spacious",
        label: ""
    });
};





parcelRequire("42omo");






var $a2dru = parcelRequire("a2dru");





var $3gadb = parcelRequire("3gadb");







const $0c09b7eff2986caa$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    lastModified: {
        id: "search-result.last-modified",
        defaultMessage: "Updated {formattedDate}"
    }
});


const $2ba9d06a8e432719$export$e6747eee8f26f8c0 = ({ lastModified: lastModified, message: message = (0, $0c09b7eff2986caa$export$defe85febe8b728c).lastModified })=>{
    if (!lastModified) return null;
    const lastModifiedDate = new Date(lastModified);
    const { value: value, unit: unit } = (0, $Y34Hw.getRelativeTimeSince)(lastModifiedDate);
    const absoluteDate = /*#__PURE__*/ (0, $l998X.jsx)((0, $cgtv4.FormattedDate), {
        value: lastModified,
        month: "short",
        day: "numeric",
        year: "numeric"
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: absoluteDate,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                ...tooltipProps,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...message,
                    values: {
                        formattedDate: /*#__PURE__*/ (0, $l998X.jsx)((0, $a2dru.default), {
                            value: -value,
                            unit: unit
                        })
                    }
                })
            })
    });
};



var $cORSX = parcelRequire("cORSX");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 














var $h7sRY = parcelRequire("h7sRY");


var $mdlgz = parcelRequire("mdlgz");


var $gCEkV = parcelRequire("gCEkV");

const $5f3358d8816326cd$var$styles = {
    subheading: "_11c8wadc _nd5l1wdz _1reo15vq _18m915vq _syazazsu _1e0c1txw _4cvr1h6o _o5721q9c _1bto1l2s _19bv1b66",
    inline: "_16jlkb7n _1o9zidpf _i0dl1wug _kqswstnw _1pbyb4wl _4cvr1h6o",
    hiddenReferenceInline: "_16jlkb7n _1o9zidpf _i0dl1wug _3um015vq _kqswh2mm _1pbykb7n _4cvr1h6o",
    metadataItem: "_1e0c116y _4cvr1h6o"
};
const $5f3358d8816326cd$var$renderParts = (part, spacer)=>{
    const [key, value] = Array.isArray(part) ? part : [
        part,
        part
    ];
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            value,
            spacer && /*#__PURE__*/ (0, $l998X.jsx)((0, $mdlgz.Spacer), {})
        ]
    }, key);
};
const $5f3358d8816326cd$var$filterPart = (part)=>{
    if (Array.isArray(part)) return !!part[1];
    return !!part;
};
const $5f3358d8816326cd$export$112d13beb34a0b82 = (parts, allowedKeys)=>{
    return parts.filter((part)=>{
        if (Array.isArray(part)) {
            const [key] = part;
            return allowedKeys.includes(key);
        }
        // For string parts, we keep them as they don't have keys
        return typeof part === 'string';
    });
};
const $5f3358d8816326cd$var$SearchMetadataWithOverflowObserver = ({ metadataItems: metadataItems, searchResultId: searchResultId, containerRef: containerRef })=>{
    const headerMetadataWithIds = metadataItems.map((item, index)=>{
        const prefix = searchResultId || 'default';
        return {
            id: `metadata-${prefix}-${index}`,
            content: item
        };
    });
    const headerMetadataRefs = (0, $42omo.useRef)([]);
    headerMetadataRefs.current = headerMetadataWithIds.map((_, i)=>headerMetadataRefs.current[i] ?? /*#__PURE__*/ (0, $42omo.createRef)());
    const visibleItems = (0, $gCEkV.useOverflowObserver)({
        containerRef: containerRef,
        itemRefs: headerMetadataRefs,
        itemIds: headerMetadataWithIds.map((item)=>item.id)
    });
    const hasHiddenItems = headerMetadataWithIds.length > visibleItems.length;
    const processVisibleItems = ()=>{
        const visibleMetadata = headerMetadataWithIds.filter((item)=>visibleItems.includes(item.id));
        // If we have hidden items, remove spacer from last visible item
        if (hasHiddenItems && visibleMetadata.length > 0) {
            const lastIndex = visibleMetadata.length - 1;
            visibleMetadata[lastIndex] = {
                ...visibleMetadata[lastIndex],
                content: (0, $Y34Hw.filterSpacer)(visibleMetadata[lastIndex].content)
            };
        }
        return visibleMetadata;
    };
    const processedVisibleItems = processVisibleItems();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $5f3358d8816326cd$var$styles.subheading,
        testId: "search-page-linked-result-metadata",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                xcss: $5f3358d8816326cd$var$styles.hiddenReferenceInline,
                testId: "search-page-linked-result-metadata-hidden",
                children: headerMetadataWithIds.map((item, index)=>{
                    const elementId = `reference:${item.id}`;
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        id: elementId,
                        ref: headerMetadataRefs.current[index],
                        xcss: $5f3358d8816326cd$var$styles.metadataItem,
                        children: item.content
                    }, elementId);
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                xcss: $5f3358d8816326cd$var$styles.inline,
                testId: "search-page-linked-result-metadata-visible",
                children: [
                    processedVisibleItems.map((item)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $5f3358d8816326cd$var$styles.metadataItem,
                            children: item.content
                        }, `visible-${item.id}`)),
                    hasHiddenItems && /*#__PURE__*/ (0, $l998X.jsx)((0, $h7sRY.MetadataPopupButton), {
                        metadata: headerMetadataWithIds.filter((item)=>!visibleItems.includes(item.id)).map((item)=>item.content),
                        isFirstElement: processedVisibleItems.length === 0
                    })
                ]
            })
        ]
    });
};
const $5f3358d8816326cd$export$fe43dae6529505e9 = ({ searchResultId: searchResultId, parts: defaultParts = [], displaySpacer: displaySpacer = true, containerRef: containerRef })=>{
    // Filter to only keep parts with keys 'type' and 'last-modified'
    const filteredParts = $5f3358d8816326cd$export$112d13beb34a0b82(defaultParts, [
        'type',
        'last-modified'
    ]);
    const parts = filteredParts.filter($5f3358d8816326cd$var$filterPart);
    const metadataItems = parts.map((m, i)=>$5f3358d8816326cd$var$renderParts(m, displaySpacer && i < parts.length - 1));
    // If we don't have a containerRef, we don't want to use the overflow observer
    return containerRef ? /*#__PURE__*/ (0, $l998X.jsx)($5f3358d8816326cd$var$SearchMetadataWithOverflowObserver, {
        metadataItems: metadataItems,
        searchResultId: searchResultId,
        containerRef: containerRef
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: metadataItems
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");




var $1s5hv = parcelRequire("1s5hv");










var $976IZ = parcelRequire("976IZ");

const $5a3f247da11d2140$var$styles = {
    headingArea: "_nd5laoqn _11c8fhey _1ul91x4w",
    title: "_1reo15vq _18m915vq _1e0c116y _19bv1b66",
    titleText: "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
    visitedLink: "_5bd61r31 _13jxglyw _xatrnqa1 _1xteglyw _10531ra0 _9oik1r31 _1bnx8stv _jf4cnqa1 _1vhv17z1",
    visitedLinkPatch: "_syaz1ra0 _9h8h17z1",
    grid: "_zulpxy5q _yv0ed3ry"
};
const $5a3f247da11d2140$export$b98262479e3660fe = (props)=>{
    const { id: id, title: title, url: url, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, sublistPosition: sublistPosition, provider: provider, category: category } = props;
    /**
   * A dynamic search_id query param and queryHash is appended to the document URL for 1P search results.
   * As result we are unable to use the browser's visited links history to determine if a link has been visited.
   * This is workaround until we have a better solution.
   */ const visitedLinks = (0, $976IZ.getVisitedLinks)();
    const isVisitedLink = id ? (0, $976IZ.isVisited)(visitedLinks, id) : false;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $5a3f247da11d2140$var$styles.headingArea,
        onClick: ()=>{
            if (id) {
                onResultClicked?.({
                    fromLinksSeeAll: false,
                    sublistPosition: sublistPosition,
                    provider: provider,
                    fanoutProduct: provider,
                    linkDocId: id,
                    linkDocContentType: (0, $lwP5K.LinkDocContentType).boostedLink,
                    fanoutLinkCategory: category
                });
                (0, $976IZ.addVisitedLink)(id);
            }
        },
        onContextMenu: ()=>{
            if (id) onResultContextMenu?.({
                sublistPosition: sublistPosition,
                fanoutProduct: provider,
                linkDocId: id,
                linkDocContentType: (0, $lwP5K.LinkDocContentType).boostedLink,
                fanoutLinkCategory: category
            });
        },
        children: id && url ? /*#__PURE__*/ (0, $l998X.jsx)((0, $d8SNb.default), {
            xcss: $5a3f247da11d2140$var$styles.grid,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                alignItems: "center",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jAenQ.Link), {
                    xcss: (0, $1Whri.cx)($5a3f247da11d2140$var$styles.visitedLink, isVisitedLink && $5a3f247da11d2140$var$styles.visitedLinkPatch, $5a3f247da11d2140$var$styles.title),
                    href: url,
                    testId: "search-page-linked-result-link",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $5a3f247da11d2140$var$styles.titleText,
                        children: title
                    })
                })
            })
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $5a3f247da11d2140$var$styles.title,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $5a3f247da11d2140$var$styles.titleText,
                children: title
            })
        })
    });
};


const $55195f091cb52b39$var$getLinkedResultIcon = (category, productKey3P, resultAri, thirdPartyConfigs)=>{
    // When 1P mentions 3P: category is 'MENTIONS'
    // Return the correct 3P icon for the linked result
    if (category?.toLocaleUpperCase() === 'MENTIONS' && thirdPartyConfigs) return /*#__PURE__*/ (0, $l998X.jsx)((0, $235a70ab221836e5$export$6582c9566971e750), {
        product: productKey3P,
        resourceType: resultAri.resourceType,
        size: 'xxsmall',
        thirdPartyConfigs: thirdPartyConfigs
    });
    else if (category?.toLocaleUpperCase() === 'MENTIONEDBY') {
        const icon1P = resultAri.resourceOwner in (0, $1yEFx.products1P) ? (0, $1yEFx.products1P)[resultAri.resourceOwner].Icon : undefined;
        return icon1P ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(icon1P, {
                size: 'xxsmall'
            })
        }) : null;
    } else if (category?.toLocaleUpperCase() === 'SIMILAR') {
        if (productKey3P && thirdPartyConfigs) return /*#__PURE__*/ (0, $l998X.jsx)((0, $235a70ab221836e5$export$6582c9566971e750), {
            product: productKey3P,
            resourceType: resultAri.resourceType,
            size: 'xxsmall',
            thirdPartyConfigs: thirdPartyConfigs
        });
        else return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.ConfluenceIcon), {
            size: "xxsmall",
            shouldUseNewLogoDesign: true
        });
    }
};
/**
 * Returns the appropriate message for linked results based on the category.
 *
 * @param category - The linked result category ('MENTIONS', 'MENTIONEDBY', or 'SIMILAR')
 * @param subtype - The subtype for MENTIONS category
 * @param type - The type for MENTIONEDBY or SIMILAR categories
 * @returns The message object from the messages lookup
 */ const $55195f091cb52b39$var$getLinkedResultMessage = (category, subtype, type)=>{
    if (category?.toLocaleUpperCase() === 'MENTIONS') return subtype && subtype in (0, $cORSX.messages) ? (0, $cORSX.messages)[subtype] : (0, $cORSX.messages).unrecognised;
    else if (category?.toLocaleUpperCase() === 'MENTIONEDBY' || category?.toLocaleUpperCase() === 'SIMILAR') return type && type in (0, $cORSX.messages) ? (0, $cORSX.messages)[type] : (0, $cORSX.messages).unrecognised;
    return (0, $cORSX.messages).unrecognised;
};
const $55195f091cb52b39$var$styles = {
    iconArea: "_nd5l2ec4 _1e0c1txw _4cvr1y6m _1bah1h6o _1bsb7vkz",
    newIcon: "_ca0qv77o",
    grid: "_yv0e5bpd _1lmc1pyr _gy1p1b66 _1p571b66 _19bvutpp"
};
const $55195f091cb52b39$export$cd7ef6aecb1db96c = ({ sublistPosition: sublistPosition, linkedResult: linkedResult, category: category, thirdPartyConfigs: thirdPartyConfigs, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, type: linkedResultType })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const containerRef = (0, $42omo.useRef)(null);
    const { id: id, title: title, url: url, providerId: providerId, integrationId: integrationId, lastModifiedDate: lastModifiedDate, subtype: subtype, type: type } = linkedResult;
    const resultAri = (0, $k4HRJ.AnyAri).parse(id);
    const product = (0, $Y34Hw.getProductFromProviderId)(thirdPartyConfigs, providerId);
    const integrationKey = (0, $Y34Hw.getIntegrationKey)(integrationId);
    const thirdPartyProduct = product || integrationKey;
    const firstPartyProduct = resultAri.resourceOwner;
    const productKey = thirdPartyProduct || firstPartyProduct;
    const icon = $55195f091cb52b39$var$getLinkedResultIcon(category, thirdPartyProduct, resultAri, thirdPartyConfigs);
    const message = $55195f091cb52b39$var$getLinkedResultMessage(category, subtype, type);
    const metadataParts = [
        [
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                children: linkedResultType || formatMessage(message)
            })
        ],
        [
            'last-modified',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                lastModified: lastModifiedDate
            })
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        ref: containerRef,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $d8SNb.default), {
            xcss: $55195f091cb52b39$var$styles.grid,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $55195f091cb52b39$var$styles.iconArea,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $55195f091cb52b39$var$styles.newIcon,
                        children: icon
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $5a3f247da11d2140$export$b98262479e3660fe), {
                    sublistPosition: sublistPosition,
                    onResultClicked: onResultClicked,
                    onResultContextMenu: onResultContextMenu,
                    category: category,
                    provider: productKey,
                    id: id,
                    title: (0, $Y34Hw.enrichExcerpt)(title),
                    url: url
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $5f3358d8816326cd$export$fe43dae6529505e9), {
                    searchResultId: id,
                    parts: metadataParts,
                    containerRef: containerRef
                })
            ]
        })
    });
};





const $bdba1b2023ea1225$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    foundIn: {
        id: "search-page.linked-results.found-in",
        defaultMessage: "Found in"
    },
    similar: {
        id: "search-page.linked-results.similar",
        defaultMessage: "{count} similar"
    },
    related: {
        id: "search-page.linked-results.related",
        defaultMessage: "Related links"
    }
});


var $b7a5d3c4b4eaddeb$var$Category = /*#__PURE__*/ function(Category) {
    Category["MENTIONS"] = "MENTIONS";
    Category["MENTIONEDBY"] = "MENTIONEDBY";
    Category["SIMILAR"] = "SIMILAR";
    return Category;
}($b7a5d3c4b4eaddeb$var$Category || {})/**
   * Deduplicates URLs by removing any links that already exist in linkedResults
   * @param links - Array of URL strings
   * @param linkedResults - Array of linked result objects that have a url property
   * @returns Array of deduplicated URL strings
   */ ;
const $b7a5d3c4b4eaddeb$var$deduplicateLinksAgainstLinkedResults = (links, linkedResults)=>{
    if (!linkedResults || linkedResults.length === 0) return links;
    const linkedResultUrls = new Set(linkedResults.map((result)=>result.url)); // Filter out links that exist in linkedResults
    return links.filter((link)=>!linkedResultUrls.has(link));
};
const $b7a5d3c4b4eaddeb$var$linkedResultsStyles = {
    base: "_zulputpp _kqswh2mm _ca0q1b66 _1e0c1txw _2lx21bp4",
    showMoreButton: "_1wpz1y6m"
};
const $b7a5d3c4b4eaddeb$export$d6b2e1eb75e7aa51 = (props)=>{
    const { links: links, linkedResults: linkedResults, url: parentUrl, thirdPartyConfigs: thirdPartyConfigs, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, position: position, showSeeAllButton: showSeeAllButton, product: product, type: type } = props;
    const [showAll, setShowAll] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)(); // Deduplicate links against linkedResults first, then reorder
    const deduplicatedLinks = $b7a5d3c4b4eaddeb$var$deduplicateLinksAgainstLinkedResults(links ?? [], linkedResults);
    const orderedLinks = (0, $21d2cd4cc2a842d3$export$396d67700f1fa04e)(deduplicatedLinks);
    const linkedResultsCount = linkedResults?.length || 0;
    const linksCount = orderedLinks?.length || 0;
    const totalItemsCount = linkedResultsCount + linksCount;
    if (totalItemsCount === 0) return null;
    const initialResults = 2;
    const maxExpandedResults = 5;
    const hasMoreInitialResults = totalItemsCount > initialResults;
    const hasMoreExpandedResults = totalItemsCount > maxExpandedResults;
    const maxItemsToShow = showAll ? maxExpandedResults : initialResults; // Show linkedResults first, then links, respecting the total limit
    const linkedResultsToShow = linkedResults?.slice(0, Math.min(linkedResultsCount, maxItemsToShow)) || [];
    const remainingSlots = maxItemsToShow - linkedResultsToShow.length;
    const linksToShow = remainingSlots > 0 ? orderedLinks?.slice(0, remainingSlots) || [] : [];
    const components = [
        ...linkedResultsToShow.map((linkedResult, index)=>{
            return /*#__PURE__*/ (0, $l998X.jsx)("div", {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $55195f091cb52b39$export$cd7ef6aecb1db96c), {
                    linkedResult: linkedResult,
                    thirdPartyConfigs: thirdPartyConfigs,
                    category: linkedResult.category,
                    sublistPosition: index,
                    onResultClicked: onResultClicked,
                    onResultContextMenu: onResultContextMenu,
                    product: product,
                    type: type
                })
            }, `${linkedResult.id}-${index}`);
        }),
        // Render LinkAttachments component if there are links to show
        ...linksToShow.length > 0 ? [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $514d99dea8b7ae4b$export$dffce0f8d8968f9c), {
                    links: linksToShow,
                    isLinkedResults: true,
                    indexOffset: linkedResultsToShow.length,
                    parentPosition: position,
                    onResultClicked: onResultClicked,
                    onResultContextMenu: onResultContextMenu
                })
            }, "link-attachments")
        ] : []
    ];
    const remainingCount = showAll ? totalItemsCount - maxExpandedResults : totalItemsCount - initialResults;
    const showMoreX = Math.min(maxExpandedResults - initialResults, remainingCount);
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        className: (0, $gMc0m.default)([
            $b7a5d3c4b4eaddeb$var$linkedResultsStyles.base
        ]),
        children: [
            components,
            hasMoreInitialResults && !showAll && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $b7a5d3c4b4eaddeb$var$linkedResultsStyles.showMoreButton
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $ccHMk.default), {
                    onClick: ()=>{
                        createAnalyticsEvent({
                            type: 'sendUIEvent',
                            data: {
                                action: 'clicked',
                                actionSubject: `searchPageLinkedResultShowMoreButton`,
                                source: (0, $6yNqK.EVENT_SOURCE),
                                attributes: {
                                    moreShownCount: showMoreX
                                }
                            }
                        }).fire();
                        return setShowAll(true);
                    },
                    spacing: "compact",
                    children: [
                        "Show ",
                        showMoreX,
                        " more"
                    ]
                })
            }),
            showSeeAllButton && showAll && hasMoreExpandedResults && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $b7a5d3c4b4eaddeb$var$linkedResultsStyles.showMoreButton
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $ccHMk.default), {
                    onClick: ()=>{
                        onResultClicked?.({
                            fromLinksSeeAll: true
                        });
                        return window.open(parentUrl, '_blank');
                    },
                    spacing: "compact",
                    children: [
                        "See all ",
                        /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($69PnT))), {
                            label: "External link"
                        })
                    ]
                })
            })
        ]
    });
};
const $b7a5d3c4b4eaddeb$export$641545414024a53b = ({ linkedResults: linkedResults, thirdPartyConfigs: thirdPartyConfigs, partial: partial, url: url, position: position, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, isAllProductSelected: isAllProductSelected })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const shouldShowLinkedResults = partial.linkedResults && partial.linkedResults.length > 0 && isAllProductSelected; // expanded linked results for the first 5 results by default
    const shouldExpandLinkedResults = position !== undefined && position <= $b7a5d3c4b4eaddeb$export$f0079efc6806b623 ? 0 : undefined;
    const mentionedByLinkedResults = linkedResults.filter((linkedResult)=>linkedResult.category.toLocaleUpperCase() === "MENTIONEDBY");
    return shouldShowLinkedResults && /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$6b89e3fa6be10ffa), {
        defaultExpandedIndex: shouldExpandLinkedResults,
        parentPosition: position,
        buttonType: "MENTIONEDBY",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$49bd1dfb0ad29c40), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
            attachmentCount: mentionedByLinkedResults?.length ?? 0,
            attachmentType: "url",
            label: formatMessage((0, $bdba1b2023ea1225$export$defe85febe8b728c).related),
            children: /*#__PURE__*/ (0, $l998X.jsx)($b7a5d3c4b4eaddeb$export$d6b2e1eb75e7aa51, {
                ...partial,
                url: url,
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
                thirdPartyConfigs: thirdPartyConfigs,
                linkedResults: mentionedByLinkedResults,
                onSeeAllClicked: onResultClicked,
                onResultClicked: onResultClicked,
                onResultContextMenu: onResultContextMenu,
                position: position
            })
        })
    });
};
const $b7a5d3c4b4eaddeb$export$f0079efc6806b623 = 4;
const $b7a5d3c4b4eaddeb$export$82bce033e6b355fc = 2;
const $b7a5d3c4b4eaddeb$export$695e5a3ae2478b3 = ({ linkedResults: linkedResults, thirdPartyConfigs: thirdPartyConfigs, partial: partial, url: url, position: position, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, isAllProductSelected: isAllProductSelected })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const extractedLinksFromText = (0, $514d99dea8b7ae4b$export$a414b3d5a172e15b)(partial.description);
    const hasLinkedResults = partial.linkedResults && partial.linkedResults.length > 0;
    const hasExtractedLinks = extractedLinksFromText && extractedLinksFromText.length > 0;
    const mentionsLinkedResults = linkedResults.filter((linkedResult)=>linkedResult.category.toLocaleUpperCase() === "MENTIONS"); // expanded linked results for the first 5 results by default
    const shouldExpandLinkedResults = position !== undefined && position <= $b7a5d3c4b4eaddeb$export$f0079efc6806b623 ? 0 : undefined;
    const shouldShowLinkedResults = (hasExtractedLinks || hasLinkedResults) && isAllProductSelected;
    const totalLinksLength = (mentionsLinkedResults?.length ?? 0) + extractedLinksFromText.length;
    return shouldShowLinkedResults && /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$6b89e3fa6be10ffa), {
        defaultExpandedIndex: shouldExpandLinkedResults,
        parentPosition: position,
        buttonType: "MENTIONS",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$49bd1dfb0ad29c40), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
            attachmentCount: totalLinksLength,
            attachmentType: "url",
            label: formatMessage((0, $bdba1b2023ea1225$export$defe85febe8b728c).related),
            children: /*#__PURE__*/ (0, $l998X.jsx)($b7a5d3c4b4eaddeb$export$d6b2e1eb75e7aa51, {
                ...partial,
                links: extractedLinksFromText,
                linkedResults: mentionsLinkedResults,
                url: url,
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
                thirdPartyConfigs: thirdPartyConfigs,
                onResultClicked: onResultClicked,
                onResultContextMenu: onResultContextMenu,
                position: position,
                showSeeAllButton: true
            })
        })
    });
};
const $b7a5d3c4b4eaddeb$export$59c57a80401f0a6 = ({ linkedResults: linkedResults, thirdPartyConfigs: thirdPartyConfigs, partial: partial, url: url, position: position, onResultClicked: onResultClicked, isAllProductSelected: isAllProductSelected = false, onResultContextMenu: onResultContextMenu, is3pGroupingEnabled: is3pGroupingEnabled, product: product, type: type })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isFallbackCase = (is3pGroupingEnabled === undefined || is3pGroupingEnabled === false) && isAllProductSelected;
    const shouldShowLinkedResults = partial.linkedResults?.length > 0 && (is3pGroupingEnabled || isFallbackCase); // expanded linked results for the first 5 results by default
    const shouldExpandLinkedResults = position !== undefined && position <= $b7a5d3c4b4eaddeb$export$f0079efc6806b623 ? 0 : undefined;
    const similarLinkedResults = linkedResults.filter((linkedResult)=>linkedResult.category.toLocaleUpperCase() === "SIMILAR");
    return shouldShowLinkedResults && /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$6b89e3fa6be10ffa), {
        defaultExpandedIndex: shouldExpandLinkedResults,
        parentPosition: position,
        buttonType: "SIMILAR",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$49bd1dfb0ad29c40), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
            attachmentCount: similarLinkedResults?.length ?? 0,
            attachmentType: "url",
            label: formatMessage((0, $bdba1b2023ea1225$export$defe85febe8b728c).related),
            children: /*#__PURE__*/ (0, $l998X.jsx)($b7a5d3c4b4eaddeb$export$d6b2e1eb75e7aa51, {
                ...partial,
                url: url,
                thirdPartyConfigs: thirdPartyConfigs,
                linkedResults: similarLinkedResults,
                onResultClicked: onResultClicked,
                onResultContextMenu: onResultContextMenu,
                position: position,
                product: product,
                type: type
            })
        })
    });
};





parcelRequire("42omo");







var $1hlFx = parcelRequire("1hlFx");

const $e0d9e2bc48f29be1$var$resultsListGridAreaStyles = (0, $ecnYn.xcss)({
    gridArea: 'results-list',
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.200'
});
const $e0d9e2bc48f29be1$export$18a2402e95ebb069 = ({ rowCount: rowCount = 7 })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        role: "list",
        xcss: $e0d9e2bc48f29be1$var$resultsListGridAreaStyles,
        testId: "search-page-results-loading",
        children: Array.from({
            length: rowCount
        }).map((_, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1hlFx.SearchResultSkeleton), {}, index))
    });
};





parcelRequire("42omo");










parcelRequire("42omo");


var $gj7hi = parcelRequire("gj7hi");




var $5dK2X = parcelRequire("5dK2X");



const $330959ad09458c13$var$resultStateContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 'space.1000',
    textAlign: 'center'
});
const $330959ad09458c13$var$ImageContainerStyles = (0, $ecnYn.xcss)({
    marginBottom: 'space.150',
    width: '124px',
    height: '124px'
});
const $330959ad09458c13$var$primaryTextContainerStyles = (0, $ecnYn.xcss)({
    marginBottom: 'space.150',
    font: 'font.heading.medium',
    fontWeight: 'font.weight.medium'
});
const $330959ad09458c13$var$secondaryTextContainerStyles = (0, $ecnYn.xcss)({
    marginBottom: 'space.200'
});
const $330959ad09458c13$export$d9172702747fb4bc = ({ imageSrcLight: imageSrcLight, imageSrcDark: imageSrcDark, primaryText: primaryText, secondaryText: secondaryText, callToAction: callToAction, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $330959ad09458c13$var$resultStateContainerStyles,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $330959ad09458c13$var$ImageContainerStyles,
                children: imageSrcLight && imageSrcDark && // eslint-disable-next-line @atlassian/a11y/alt-text -- See https://go/a11y-alt-text for more details
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                    src: imageSrcLight,
                    srcDark: imageSrcDark,
                    role: "presentation"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $330959ad09458c13$var$primaryTextContainerStyles,
                children: primaryText
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $330959ad09458c13$var$secondaryTextContainerStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                    children: secondaryText
                })
            }),
            callToAction && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                children: callToAction
            })
        ]
    });
};


var $032e51db6ad284d6$exports = {};
$032e51db6ad284d6$exports = new URL("no-results-dark.a00ae47b.svg", import.meta.url).toString();


var $948ce8c27c9b9ce5$exports = {};
$948ce8c27c9b9ce5$exports = new URL("no-results-light.5ca83755.svg", import.meta.url).toString();





const $bdbc32362c41e292$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    noResultsPrimary: {
        id: "no_results_primary",
        defaultMessage: "We couldn't find anything matching your search"
    },
    noResultsSecondary: {
        id: "no_results_secondary_no_filters",
        defaultMessage: "Try again with a different term."
    },
    noResultsSecondaryFilters: {
        id: "no_results_secondary_some_filters_applied",
        defaultMessage: "Looks like you have some filters applied. You could try clearing them."
    },
    noResultsClearFilters: {
        id: "no_results_clear_filters",
        defaultMessage: "Clear filters"
    }
});


const $88900765e2dbc6d9$export$f8a5875a19110e65 = ({ filtersEnabled: filtersEnabled, clearFilters: clearFilters })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $330959ad09458c13$export$d9172702747fb4bc), {
        imageSrcLight: (0, (/*@__PURE__*/$parcel$interopDefault($948ce8c27c9b9ce5$exports))),
        imageSrcDark: (0, (/*@__PURE__*/$parcel$interopDefault($032e51db6ad284d6$exports))),
        primaryText: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $bdbc32362c41e292$export$defe85febe8b728c).noResultsPrimary
        }),
        secondaryText: filtersEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $bdbc32362c41e292$export$defe85febe8b728c).noResultsSecondaryFilters
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $bdbc32362c41e292$export$defe85febe8b728c).noResultsSecondary
        }),
        callToAction: filtersEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
            appearance: "primary",
            onClick: clearFilters,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $bdbc32362c41e292$export$defe85febe8b728c).noResultsClearFilters
            })
        }) : undefined
    });
};














const $0f1906aa6a6024a0$export$4b73689f2f9f3dd3 = ({ queryState: queryState, numResults: numResults, shownCount: shownCount, are3pResultsShown: are3pResultsShown, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, searchAndResult: searchAndResult, resultsShown: resultsShown, socialSignalsAttributes: socialSignalsAttributes, requestedBackendExperiments: requestedBackendExperiments, referrer: referrer, isPaginatedQuery: isPaginatedQuery, isBulkConnectBannerShown: isBulkConnectBannerShown, productsWithTimeout: productsWithTimeout })=>({
        eventType: 'track',
        action: 'shown',
        actionSubject: 'advancedSearchResults',
        attributes: {
            additionalAttributes: {
                queryState: queryState,
                numResults: numResults,
                numberOfResultsShown: shownCount,
                noResultsFetched: numResults === 0,
                numberOfDocs: numResults,
                are3pResultsShown: are3pResultsShown,
                searchAndResult: searchAndResult,
                resultsShown: resultsShown,
                is3PFilter: commonAttributes.productSelected !== (0, $6yNqK.ALL_PRODUCTS_STRING) && (0, $1yEFx.is3pProductKeyForAnalytics)(commonAttributes.productSelected),
                isPaginatedQuery: isPaginatedQuery,
                isBulkConnectBannerShown: isBulkConnectBannerShown,
                referrer: referrer,
                ...socialSignalsAttributes,
                ...(0, $dh538.fg)('relay_results_analytics_refactor') ? {
                    backendExperiments: {
                        experimentLayers: requestedBackendExperiments.backendExperiments?.experimentLayers?.map(({ analyticsDefinitions: analyticsDefinitions, ...layer })=>{
                            return {
                                ...layer,
                                definitions: analyticsDefinitions
                            };
                        })
                    }
                } : requestedBackendExperiments,
                productsWithTimeout: productsWithTimeout
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });


const $00671a63acd7458c$export$8b03bfde0d56431b = ({ success: success, commonAttributes: commonAttributes })=>({
        eventType: 'operational',
        action: success ? 'taskSuccess' : 'taskFail',
        actionSubject: 'ui',
        attributes: {
            commonAttributes: commonAttributes,
            additionalAttributes: {
                task: 'unifiedSearch',
                capability: 'fullPageSearchResult',
                // This edition is not exact matching the need for the AutoHots
                // A follow up is to find the current primary product edition and log that.
                // Currently we only have confluence edition in the productEdition object, so logging the entire object for now.
                edition: commonAttributes.productEdition,
                // Confirmed with AutoHots team this is mandatory
                // and base on "Can I log this" doc, we can log this.
                // https://hello.atlassian.net/wiki/spaces/Monitoring/pages/5816497997/Vitalstats+Onboarding+contract?focusedCommentId=5864073069
                // https://hello.atlassian.net/wiki/spaces/SECURITY/pages/236070634/Can+I+Log+This
                hostname: window.location.hostname
            }
        }
    });







var $9wmQG = parcelRequire("9wmQG");





var $kQT7c = parcelRequire("kQT7c");











var $6yCpa = parcelRequire("6yCpa");

var $1VCtc = parcelRequire("1VCtc");

var $4FsX0 = parcelRequire("4FsX0");


var $7ZetK = parcelRequire("7ZetK");


var $idpYy = parcelRequire("idpYy");











var $4VkIo = parcelRequire("4VkIo");







/**
 * Retrieves a product from ATI, but also supports legacy ATIs that don't follow the standard format.
 */ const $dd52a0ba4dde52e0$var$parseProductFromAti = (ati)=>{
    const legacyAtiToProductMap = {
        [(0, $idpYy.CONFLUENCE_CALENDAR_ENTITY_ATI)]: (0, $1yEFx.ProductKeys).Confluence,
        [(0, $idpYy.CONFLUENCE_SPACE_CALENDAR_ENTITY_ATI)]: (0, $1yEFx.ProductKeys).Confluence,
        [(0, $idpYy.CONFLUENCE_ANSWER_ENTITY_ATI)]: (0, $1yEFx.ProductKeys).Confluence,
        [(0, $idpYy.CONFLUENCE_QUESTION_ENTITY_ATI)]: (0, $1yEFx.ProductKeys).Confluence,
        [(0, $idpYy.CONFLUENCE_GLIFFY_ENTITY_ATI)]: (0, $1yEFx.ProductKeys).Confluence
    };
    try {
        return (0, $6yCpa.Ati).parse(ati).resourceOwner;
    } catch (e) {
        if (e instanceof (0, $4FsX0.ValidationError)) return legacyAtiToProductMap[ati] || null;
        throw e;
    }
};
const $dd52a0ba4dde52e0$export$771e1c85614a020d = (relayResults)=>{
    const [{ thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    // When cleaning up search_page_relay_exp remove the `useResults` hook from this function
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [rssResults] = (0, $djVCD.useResults)();
    const { selectedFilters: selectedFilters, entities: entities } = (0, $4VkIo.useSelectedFilters)({});
    const productsFromEntitiesSearchedFor = entities.map((entity)=>$dd52a0ba4dde52e0$var$parseProductFromAti(entity)).filter((productName)=>!!productName);
    const thirdPartyProductsSearchedFor = selectedFilters.thirdPartyFilters.thirdPartyProducts?.map((filter)=>filter.product) || [];
    const productsSearchedFor = [
        ...new Set([
            ...productsFromEntitiesSearchedFor,
            ...thirdPartyProductsSearchedFor
        ])
    ].filter((product)=>product !== 'graph');
    const wasAny3PSearched = (selectedFilters.thirdPartyFilters.integrations?.length || 0) > 0 || productsFromEntitiesSearchedFor.includes('graph');
    let productKeys = [];
    let authorized3PProducts = [];
    let notAuthorized3PProducts = [];
    if (thirdPartyConfigs) {
        productKeys = Object.keys(thirdPartyConfigs);
        authorized3PProducts = productKeys.filter((product)=>!thirdPartyConfigs[product]?.userNeedsOAuth);
        notAuthorized3PProducts = productKeys.filter((product)=>thirdPartyConfigs[product]?.userNeedsOAuth);
    }
    const { productsFirstResultPositions: productsFirstResultPositions, smartLinkProductsFirstResultPositions: smartLinkProductsFirstResultPositions, is3PInTop10Results: is3PInTop10Results, is3PResultPresentInResultSet: is3PResultPresentInResultSet, is3PSmartLinkInTop10Results: is3PSmartLinkInTop10Results, is3PSmartLinkPresentInResultSet: is3PSmartLinkPresentInResultSet } = $dd52a0ba4dde52e0$export$53d00de621f3e600(relayResults ? relayResults : rssResults, thirdPartyConfigs);
    const productsInResults = Object.keys(productsFirstResultPositions);
    return {
        searchAndResult: {
            productsFirstResultPositions: productsFirstResultPositions,
            productsInResults: productsInResults,
            is3PInTop10Results: is3PInTop10Results,
            is3PResultPresentInResultSet: is3PResultPresentInResultSet,
            is3PSmartLinkInTop10Results: is3PSmartLinkInTop10Results,
            is3PSmartLinkPresentInResultSet: is3PSmartLinkPresentInResultSet,
            smartLinkProductsFirstResultPositions: smartLinkProductsFirstResultPositions,
            authorized3PProducts: authorized3PProducts,
            notAuthorized3PProducts: notAuthorized3PProducts,
            productsSearchedFor: productsSearchedFor,
            wasAny3PSearched: wasAny3PSearched
        }
    };
};
function $dd52a0ba4dde52e0$export$53d00de621f3e600(results, thirdPartyConfigs) {
    return (0, $42omo.useMemo)(()=>{
        let is3PInTop10Results = false;
        let is3PSmartLinkInTop10Results = false;
        let is3PSmartLinkPresentInResultSet = false;
        let is3PResultPresentInResultSet = false;
        const { productsFirstResultPositions: productsFirstResultPositions, smartLinkProductsFirstResultPositions: smartLinkProductsFirstResultPositions } = results?.edges?.reduce((acc, result, index)=>{
            const product = (0, $k4HRJ.AnyAri).parse(result.node.id).resourceOwner;
            // this is always true for graph nodes
            if (acc.productsFirstResultPositions[product] === undefined) {
                if (product === 'graph' && (0, $7ZetK.isSearchResultGraphEntity)(result.node) && result.node.integrationId) {
                    const thirdPartyProductKey = (0, $Y34Hw.getProductFromProviderId)(thirdPartyConfigs, result.node.providerId) || (0, $1VCtc.PlatformIntegrationAri).parse(result.node.integrationId).integrationKey;
                    if (acc.productsFirstResultPositions[thirdPartyProductKey] === undefined) acc.productsFirstResultPositions[thirdPartyProductKey] = index + 1;
                    // this assumes only graph nodes can be 3p
                    if ((0, $1yEFx.is3pProductKeyForAnalytics)(thirdPartyProductKey)) {
                        if (!is3PResultPresentInResultSet) {
                            is3PResultPresentInResultSet = true;
                            is3PInTop10Results = index < 10;
                        }
                        if ((0, $kQT7c.isResultSmartLink)({
                            resultAri: result.node.id,
                            thirdPartyConfigs: thirdPartyConfigs,
                            productKey: thirdPartyProductKey,
                            connectorType: result.node.connectorType
                        })) {
                            if (!is3PSmartLinkPresentInResultSet) {
                                is3PSmartLinkPresentInResultSet = true;
                                is3PSmartLinkInTop10Results = index < 10;
                            }
                            if (acc.smartLinkProductsFirstResultPositions[thirdPartyProductKey] === undefined) acc.smartLinkProductsFirstResultPositions[thirdPartyProductKey] = index + 1;
                        }
                    }
                } else acc.productsFirstResultPositions[product] = index + 1;
            }
            return acc;
        }, {
            productsFirstResultPositions: {},
            smartLinkProductsFirstResultPositions: {}
        }) || {
            productsFirstResultPositions: {},
            smartLinkProductsFirstResultPositions: {}
        };
        return {
            productsFirstResultPositions: productsFirstResultPositions,
            smartLinkProductsFirstResultPositions: smartLinkProductsFirstResultPositions,
            is3PInTop10Results: is3PInTop10Results,
            is3PResultPresentInResultSet: is3PResultPresentInResultSet,
            is3PSmartLinkInTop10Results: is3PSmartLinkInTop10Results,
            is3PSmartLinkPresentInResultSet: is3PSmartLinkPresentInResultSet
        };
    }, [
        results,
        thirdPartyConfigs
    ]);
}



var $4TTdD = parcelRequire("4TTdD");




const $9df153e29ffddcb7$export$7d33b74a4ce5a7db = (relayResults)=>{
    // When cleaning up search_page_relay_exp remove the `useResults` hook from this function
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [rssResults] = (0, $djVCD.useResults)();
    return {
        numberOfSocialSignalsShown: $9df153e29ffddcb7$var$countSocialSignalsShown(relayResults ? relayResults : rssResults),
        numberOfSocialSignalsShownTop10: $9df153e29ffddcb7$var$countSocialSignalsShownTop10(relayResults ? relayResults : rssResults),
        socialSignalSearchResultPositions: $9df153e29ffddcb7$var$getSocialSignalSearchResultPositions(relayResults ? relayResults : rssResults)
    };
};
const $9df153e29ffddcb7$var$countSocialSignalsShown = (results)=>results?.edges.filter(({ node: node })=>(0, $4TTdD.isSearchConfluencePartial)(node) && node.socialSignal).length || 0;
const $9df153e29ffddcb7$var$countSocialSignalsShownTop10 = (results)=>results?.edges.slice(0, 10).filter(({ node: node })=>(0, $4TTdD.isSearchConfluencePartial)(node) && node.socialSignal).length || 0;
const $9df153e29ffddcb7$var$getSocialSignalSearchResultPositions = (results)=>results?.edges.reduce((acc, { node: node }, index)=>{
        if ((0, $4TTdD.isSearchConfluencePartial)(node) && node.socialSignal) acc.push(index + 1);
        return acc;
    }, []) || [];











/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 









var $eEA8O = parcelRequire("eEA8O");





var $4u5NT = parcelRequire("4u5NT");











const $8c82ce48fc53c798$export$bbc0f837b34857b7 = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>{
    return {
        name: (0, $6yNqK.ERROR_SCREEN_NAME),
        attributes: {
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    };
};




var $bQSQw = parcelRequire("bQSQw");




























function $6b38ac5f99e2f44f$export$e56e03f775f4eedc({ searchSessionId: searchSessionId, fireAnalyticsEvent: fireAnalyticsEvent, fullPageSearchNetworkRefs: fullPageSearchNetworkRefs }) {
    const isEnabled = ()=>Boolean(searchSessionId) && (0, $dh538.fg)('rovo-search-vitalstats-fullpage-search-network');
    const getTimeTaken = ()=>{
        const startAt = fullPageSearchNetworkRefs.current.startAt;
        return startAt ? Math.max(0, performance.now() - startAt) : undefined;
    };
    return {
        onNetworkSuccess: (resultCount)=>{
            if (!isEnabled()) return;
            const state = fullPageSearchNetworkRefs.current.state;
            if (state.state !== 'started' || !state.taskId) return;
            // Update state BEFORE firing event (prevents duplicates under re-entrancy)
            fullPageSearchNetworkRefs.current.state = {
                ...state,
                state: 'completed'
            };
            fireAnalyticsEvent((0, $bQSQw.onTaskSuccess)({
                searchSessionId: searchSessionId ?? '',
                taskId: state.taskId,
                task: (0, $bQSQw.TASK_NAMES).SEARCH_PAGE_FULL_PAGE_SEARCH_RESULTS_NETWORK,
                moreContext: {
                    uxTaskId: state.uxTaskId,
                    resultCount: resultCount,
                    timeTaken: getTimeTaken(),
                    cacheAvailable: state.cacheAvailable
                }
            }));
        },
        onNetworkFail: (errorName, errorMessage)=>{
            if (!isEnabled()) return;
            const state = fullPageSearchNetworkRefs.current.state;
            if (state.state !== 'started' || !state.taskId) return;
            // Update state BEFORE firing event (prevents duplicates under re-entrancy)
            fullPageSearchNetworkRefs.current.state = {
                ...state,
                state: 'failed'
            };
            fireAnalyticsEvent((0, $bQSQw.onTaskFail)({
                searchSessionId: searchSessionId ?? '',
                taskId: state.taskId,
                task: (0, $bQSQw.TASK_NAMES).SEARCH_PAGE_FULL_PAGE_SEARCH_RESULTS_NETWORK,
                moreContext: {
                    uxTaskId: state.uxTaskId,
                    errorName: errorName,
                    errorMessage: errorMessage,
                    timeTaken: getTimeTaken(),
                    cacheAvailable: state.cacheAvailable
                }
            }));
        },
        onNetworkAbort: (reason)=>{
            if (!isEnabled()) return;
            const state = fullPageSearchNetworkRefs.current.state;
            if (state.state !== 'started' || !state.taskId) return;
            fullPageSearchNetworkRefs.current.state = {
                ...state,
                state: 'aborted'
            };
            fireAnalyticsEvent((0, $bQSQw.onTaskAbort)({
                searchSessionId: searchSessionId ?? '',
                taskId: state.taskId,
                task: (0, $bQSQw.TASK_NAMES).SEARCH_PAGE_FULL_PAGE_SEARCH_RESULTS_NETWORK,
                moreContext: {
                    uxTaskId: state.uxTaskId,
                    reason: reason,
                    cacheAvailable: state.cacheAvailable
                }
            }));
        }
    };
}
function $6b38ac5f99e2f44f$export$1ef754039accea4b({ searchSessionId: searchSessionId, fireAnalyticsEvent: fireAnalyticsEvent, fullPageSearchTaskIdRef: fullPageSearchTaskIdRef, fullPageSearchNetworkRefs: fullPageSearchNetworkRefs, cacheAvailable: cacheAvailable, isNetworkMode: isNetworkMode }) {
    const startUxTask = (uxTaskId)=>{
        fullPageSearchTaskIdRef.current = uxTaskId;
        if (searchSessionId && (0, $dh538.fg)('rovo-search-vitalstats-fullpage-search-ux')) fireAnalyticsEvent((0, $bQSQw.onTaskStart)({
            searchSessionId: searchSessionId,
            taskId: uxTaskId,
            task: (0, $bQSQw.TASK_NAMES).SEARCH_PAGE_FULL_PAGE_SEARCH_RESULTS_UX
        }));
    };
    const abortSupersededNetworkTaskIfNeeded = ()=>{
        if (!searchSessionId || !isNetworkMode) return;
        $6b38ac5f99e2f44f$export$e56e03f775f4eedc({
            searchSessionId: searchSessionId,
            fireAnalyticsEvent: fireAnalyticsEvent,
            fullPageSearchNetworkRefs: fullPageSearchNetworkRefs
        }).onNetworkAbort('superseded');
    };
    const startNetworkTask = (uxTaskId)=>{
        if (!searchSessionId || !isNetworkMode || !(0, $dh538.fg)('rovo-search-vitalstats-fullpage-search-network')) return;
        const networkTaskId = crypto.randomUUID();
        fullPageSearchNetworkRefs.current.taskId = networkTaskId;
        fullPageSearchNetworkRefs.current.startAt = performance.now();
        // Update state BEFORE firing event
        fullPageSearchNetworkRefs.current.state = {
            taskId: networkTaskId,
            uxTaskId: uxTaskId,
            cacheAvailable: cacheAvailable,
            state: 'started'
        };
        fireAnalyticsEvent((0, $bQSQw.onTaskStart)({
            searchSessionId: searchSessionId,
            taskId: networkTaskId,
            task: (0, $bQSQw.TASK_NAMES).SEARCH_PAGE_FULL_PAGE_SEARCH_RESULTS_NETWORK,
            moreContext: {
                uxTaskId: uxTaskId,
                cacheAvailable: cacheAvailable
            }
        }));
    };
    return {
        /**
		 * Called when a new search is initiated.
		 * Handles:
		 * - UX taskStart
		 * - Network taskAbort (superseded)
		 * - Network taskStart
		 */ onSearchStart: ()=>{
            const uxTaskId = crypto.randomUUID();
            startUxTask(uxTaskId);
            abortSupersededNetworkTaskIfNeeded();
            startNetworkTask(uxTaskId);
            return uxTaskId;
        }
    };
}








const $3f9016d1e452d4e9$export$d8aa641030aec4f4 = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $3f9016d1e452d4e9$export$119dcb5621de506f = ({ children: children })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { searchSessionId: searchSessionId } = (0, $4Qo4W.useBootstrapState)((state)=>state);
    // UX VitalStats task id ref (full page search)
    const uxTaskIdRef = (0, $42omo.useRef)(null);
    // Consolidated ref for Network VitalStats (taskId, startAt, state share same lifecycle)
    const fullPageSearchNetworkRefs = (0, $42omo.useRef)({
        taskId: null,
        startAt: 0,
        state: {
            taskId: null,
            uxTaskId: null,
            cacheAvailable: false,
            state: 'idle'
        }
    });
    // Refs to avoid stale closures in unmount cleanup
    const searchSessionIdRef = (0, $42omo.useRef)(undefined);
    const fireAnalyticsEventRef = (0, $42omo.useRef)(fireAnalyticsEvent);
    // Keep refs in sync for unmount cleanup (avoids stale closures)
    (0, $42omo.useEffect)(()=>{
        searchSessionIdRef.current = searchSessionId;
    }, [
        searchSessionId
    ]);
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsEventRef.current = fireAnalyticsEvent;
    }, [
        fireAnalyticsEvent
    ]);
    // Helper to create network vitalstats instance with current refs
    const getNetworkVitalStats = ()=>(0, $6b38ac5f99e2f44f$export$e56e03f775f4eedc)({
            searchSessionId: searchSessionIdRef.current ?? '',
            fireAnalyticsEvent: fireAnalyticsEventRef.current,
            fullPageSearchNetworkRefs: fullPageSearchNetworkRefs
        });
    // Network VitalStats unmount cleanup - fire taskAbort if task is in progress
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if ((0, $dh538.fg)('rovo-search-vitalstats-fullpage-search-network')) getNetworkVitalStats().onNetworkAbort('unmounted');
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Memoized API that doesn't change identity (prevents re-renders)
    const api = (0, $42omo.useMemo)(()=>{
        // Use a ref-based approach so the API object identity is stable
        // but always uses the latest values from refs
        return {
            onSearchStart: ({ cacheAvailable: cacheAvailable, isNetworkMode: isNetworkMode })=>{
                const vitalStats = (0, $6b38ac5f99e2f44f$export$1ef754039accea4b)({
                    searchSessionId: searchSessionIdRef.current,
                    fireAnalyticsEvent: fireAnalyticsEventRef.current,
                    fullPageSearchTaskIdRef: uxTaskIdRef,
                    fullPageSearchNetworkRefs: fullPageSearchNetworkRefs,
                    cacheAvailable: cacheAvailable,
                    isNetworkMode: isNetworkMode
                });
                return vitalStats.onSearchStart();
            },
            onNetworkSuccess: (resultCount)=>{
                getNetworkVitalStats().onNetworkSuccess(resultCount);
            },
            onNetworkFail: (errorName, errorMessage)=>{
                getNetworkVitalStats().onNetworkFail(errorName, errorMessage);
            },
            onNetworkAbort: (reason)=>{
                getNetworkVitalStats().onNetworkAbort(reason);
            },
            getUxTaskId: ()=>uxTaskIdRef.current,
            getNetworkRefs: ()=>fullPageSearchNetworkRefs,
            getUxTaskIdRef: ()=>uxTaskIdRef
        };
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)($3f9016d1e452d4e9$export$d8aa641030aec4f4.Provider, {
        value: api,
        children: children
    });
};
const $3f9016d1e452d4e9$export$586800522161402 = ()=>{
    const context = (0, $42omo.useContext)($3f9016d1e452d4e9$export$d8aa641030aec4f4);
    if (!context) throw new Error('useFullPageSearchVitalStats must be used within a FullPageSearchVitalStatsProvider');
    return context;
};





const $b1b8cd94fb9f7ea3$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    errorPrimary: {
        id: "error_primary",
        defaultMessage: "We're having trouble searching"
    },
    errorSecondary: {
        id: "error_secondary",
        defaultMessage: "It might just be a hiccup. The best thing to do is to <btn>try again</btn>."
    }
});


// Global set to track which task IDs have already fired taskFail
// This prevents duplicate taskFail events when multiple Error components mount simultaneously
// The Set is cleared when a new search starts (keeping only the current task ID)
const $e0e03289eec21c4f$var$firedTaskFailIds = new Set();
const $e0e03289eec21c4f$export$ca07aa59d198dca6 = ()=>{
    $e0e03289eec21c4f$var$firedTaskFailIds.clear();
};
const $e0e03289eec21c4f$export$edf27be85e5f6da0 = ({ fetchResults: fetchResults, error: error })=>{
    const vitalStats = (0, $3f9016d1e452d4e9$export$586800522161402)();
    $e0e03289eec21c4f$var$useFireAnalytics(error, vitalStats.getUxTaskId(), vitalStats.onNetworkFail);
    (0, $42omo.useMemo)(()=>(0, $4u5NT.addErrorToAll)('search-page-results-error', null, // this is used internally, can be null
        'interaction error', error?.message || 'generic error'), [
        error
    ]);
    const ImageErrorLight = (0, $c7e627886411fcb9$export$ce969d199fe2c04e)('cachedImageErrorLight') || (0, (/*@__PURE__*/$parcel$interopDefault($6df538e2e254fd26$exports)));
    const ImageErrorDark = (0, $c7e627886411fcb9$export$ce969d199fe2c04e)('cachedImageErrorDark') || (0, (/*@__PURE__*/$parcel$interopDefault($d264f14dd361aa2b$exports)));
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $330959ad09458c13$export$d9172702747fb4bc), {
        imageSrcLight: ImageErrorLight,
        imageSrcDark: ImageErrorDark,
        primaryText: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $b1b8cd94fb9f7ea3$export$defe85febe8b728c).errorPrimary
        }),
        secondaryText: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $b1b8cd94fb9f7ea3$export$defe85febe8b728c).errorSecondary,
            values: {
                btn: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                        appearance: "link",
                        spacing: "none",
                        onClick: fetchResults,
                        children: chunks
                    })
            }
        }),
        testId: "search-page-error"
    });
};
const $e0e03289eec21c4f$var$useFireAnalytics = (error, fullPageSearchTaskId, onNetworkFail)=>{
    const { fireAnalyticsScreenEvent: fireAnalyticsScreenEvent, fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttrs, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProductStore)();
    const { queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    (0, $42omo.useEffect)(()=>{
        // Prevent duplicate taskFail events for the same task ID (multiple Error components may render)
        if (fullPageSearchTaskId && $e0e03289eec21c4f$var$firedTaskFailIds.has(fullPageSearchTaskId)) return;
        // Mark this task ID as having fired taskFail and clean up old task IDs
        if (fullPageSearchTaskId) {
            // Clear old task IDs to prevent unbounded memory growth
            // Keep only the current task ID (in case multiple Error components mount)
            $e0e03289eec21c4f$var$firedTaskFailIds.clear();
            $e0e03289eec21c4f$var$firedTaskFailIds.add(fullPageSearchTaskId);
        }
        const commonAttributes = {
            ...commonAttrs,
            ...primaryProduct && (0, $2OtFZ.serveSearchPageRelayExp)(primaryProduct, false, queryParams) ? (0, $1ymk3.getExtensionData)(commonAttrs.isCQL) : {}
        };
        fireAnalyticsScreenEvent((0, $8c82ce48fc53c798$export$bbc0f837b34857b7)({
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
        fireAnalyticsEvent((0, $00671a63acd7458c$export$8b03bfde0d56431b)({
            success: false,
            commonAttributes: commonAttributes
        }));
        // Fire vital stats taskFail event when error screen is shown (gated by feature flag)
        if (fullPageSearchTaskId && commonAttrs.searchSessionId && (0, $dh538.fg)('rovo-search-vitalstats-fullpage-search-ux')) fireAnalyticsEvent((0, $bQSQw.onTaskFail)({
            searchSessionId: commonAttrs.searchSessionId,
            taskId: fullPageSearchTaskId,
            task: (0, $bQSQw.TASK_NAMES).SEARCH_PAGE_FULL_PAGE_SEARCH_RESULTS_UX,
            moreContext: {
                errorName: error?.name || 'Error',
                errorMessage: error?.message || 'generic error'
            }
        }));
        // Fire Network VitalStats taskFail event - gated by feature flag
        if (onNetworkFail && (0, $dh538.fg)('rovo-search-vitalstats-fullpage-search-network')) onNetworkFail(error?.name || 'Error', error?.message || 'generic error');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};





parcelRequire("42omo");








var $6VXu9 = parcelRequire("6VXu9");


var $hW5DR = parcelRequire("hW5DR");







parcelRequire("42omo");




const $919e914043a539a1$var$ApplicationModeSpecificComponent = ({ rovoComponent: rovoComponent, unifiedComponent: unifiedComponent, applicationMode: applicationMode })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            applicationMode === (0, $9vOy1.ApplicationModes).Rovo && rovoComponent,
            applicationMode === (0, $9vOy1.ApplicationModes).Unified && unifiedComponent
        ]
    });
};
var $919e914043a539a1$export$2e2bcd8739ae039 = $919e914043a539a1$var$ApplicationModeSpecificComponent;









const $f98628c683f59657$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    landingPrimary: {
        id: "landing_primary",
        defaultMessage: "Seek and you shall find"
    },
    landingSecondaryRovo: {
        id: "landing_secondary_rovo",
        defaultMessage: "Search or ask Rovo what you're looking for in your Atlassian and connected apps"
    },
    landingSecondaryUnifiedWithSAIN: {
        id: "landing_secondary_unified_with_sain",
        defaultMessage: "Search or ask anything across your Atlassian apps"
    },
    landingSecondaryUnifiedWithoutSAIN: {
        id: "landing_secondary_unified_without_sain",
        defaultMessage: "Search for anything across your Atlassian apps"
    },
    landingSecondary: {
        id: "landing_secondary",
        defaultMessage: "Search for what you're looking for in your Atlassian and connected apps"
    },
    landingSecondaryWithAI: {
        id: "landing_secondary_with_atlassian_intelligence",
        defaultMessage: "Search or ask what you're looking for in your Atlassian and connected apps"
    }
});


const $28c89da883c58c8b$var$getMessage = (isAIEnabled)=>isAIEnabled ? (0, $f98628c683f59657$export$defe85febe8b728c).landingSecondaryWithAI : (0, $f98628c683f59657$export$defe85febe8b728c).landingSecondary;
const $28c89da883c58c8b$var$SecondaryText = ()=>{
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $7WbA8.useAppContext)();
    if ((0, $dh538.fg)('rovo_search_updated_entitlement_checks_for_team_25')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $919e914043a539a1$export$2e2bcd8739ae039), {
        rovoComponent: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$28c89da883c58c8b$var$getMessage(isRovoLLMEnabled)
        }),
        unifiedComponent: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$28c89da883c58c8b$var$getMessage(isAdminHubAIEnabled)
        }),
        applicationMode: applicationMode
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $919e914043a539a1$export$2e2bcd8739ae039), {
        rovoComponent: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $f98628c683f59657$export$defe85febe8b728c).landingSecondaryRovo
        }),
        unifiedComponent: isAdminHubAIEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $f98628c683f59657$export$defe85febe8b728c).landingSecondaryUnifiedWithSAIN
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $f98628c683f59657$export$defe85febe8b728c).landingSecondaryUnifiedWithoutSAIN
        }),
        applicationMode: applicationMode
    });
};
const $28c89da883c58c8b$export$12449a31c6671d53 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $330959ad09458c13$export$d9172702747fb4bc), {
        testId: "search-page-landing",
        imageSrcLight: (0, (/*@__PURE__*/$parcel$interopDefault($hW5DR))),
        imageSrcDark: (0, (/*@__PURE__*/$parcel$interopDefault($6VXu9))),
        primaryText: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $f98628c683f59657$export$defe85febe8b728c).landingPrimary
        }),
        secondaryText: /*#__PURE__*/ (0, $l998X.jsx)($28c89da883c58c8b$var$SecondaryText, {})
    });
};

















var $l3paI = parcelRequire("l3paI");

var $7jIfa = parcelRequire("7jIfa");

var $b8N8h = parcelRequire("b8N8h");



var $8LSUr = parcelRequire("8LSUr");

var $HOiSI = parcelRequire("HOiSI");

var $fLF8J = parcelRequire("fLF8J");



var $fhFN4 = parcelRequire("fhFN4");

var $aXWlG = parcelRequire("aXWlG");





var $5Lref = parcelRequire("5Lref");














var $dsrEB = parcelRequire("dsrEB");





var $PGaF8 = parcelRequire("PGaF8");







const $fe78820344aa1a37$export$97e18a3547cfead = ({ dwellData: dwellData, searchSessionId: searchSessionId, searchQuery: searchQuery, applicationMode: applicationMode })=>{
    const queryHash = (0, $a0M2t.sha256Hash)(searchQuery);
    return {
        ...dwellData,
        source: (0, $6yNqK.EVENT_SOURCE),
        actionSubject: 'searchPage',
        attributes: {
            additionalAttributes: {
                ...dwellData.attributes,
                searchSessionId: searchSessionId,
                queryHash: queryHash,
                mode: applicationMode
            }
        },
        eventType: 'track'
    };
};











const $320af85988d7ec69$var$useDwellTime = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [searchQuery] = (0, $djVCD.useSearchQuery)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    (0, $42omo.useEffect)(()=>{
        const dwellTimer = new (0, $PGaF8.default)((dwellData)=>{
            fireAnalyticsEvent((0, $fe78820344aa1a37$export$97e18a3547cfead)({
                dwellData: dwellData,
                searchQuery: searchQuery,
                searchSessionId: searchSessionId,
                applicationMode: applicationMode
            }));
        }, // These actually get overridden in onAdvancedSearchDwelled, but the DwellTimeHelper code path requires them to be set anyway, so we do.
        {
            source: 'source',
            actionSubject: 'actionSubject'
        }, searchSessionId);
        dwellTimer.start();
        return ()=>{
            dwellTimer.stop();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
var $320af85988d7ec69$export$2e2bcd8739ae039 = $320af85988d7ec69$var$useDwellTime;














const $71988ef00edd4050$export$5c2913b6a4d1611c = ()=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $7WbA8.useAppContext)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    // TODO: QS-6660 clean up the Unified Mode condition once it's decommissioned
    if (applicationMode === (0, $9vOy1.ApplicationModes).Unified) return isAdminHubAIEnabled;
    if ((0, $dh538.fg)('rovo_search_updated_entitlement_checks_for_team_25')) return isRovoLLMEnabled;
    return true;
};


























parcelRequire("42omo");





var $cO1el = parcelRequire("cO1el");


























const $875248bc25579340$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    relatedSearch: {
        id: "leap-query.title.related-search",
        defaultMessage: "Related searches"
    },
    teammatesAlsoAsk: {
        id: "leap-query.title.teammates-also-ask",
        defaultMessage: "Your teammates also ask"
    }
});


const $39e2a93ffdbf67f4$var$candidateStyles = (0, $ecnYn.xcss)({
    height: '100%',
    borderRadius: 'radius.full',
    ':hover': {
        backgroundColor: 'color.background.neutral.hovered'
    }
});
const $39e2a93ffdbf67f4$var$candidateContentStyles = (0, $ecnYn.xcss)({
    height: '100%'
});
const $39e2a93ffdbf67f4$var$linkStyles = (0, $ecnYn.xcss)({
    color: 'color.text',
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'none',
        color: 'color.text'
    },
    ':visited': {
        textDecoration: 'none',
        color: 'color.text'
    },
    ':focus': {
        textDecoration: 'none',
        color: 'color.text'
    }
});
const $39e2a93ffdbf67f4$var$candidatesGridStyle = (0, $ecnYn.xcss)({
    gridAutoRows: '1fr'
});
const $39e2a93ffdbf67f4$var$Candidate = ({ candidate: candidate, candidateIndex: candidateIndex, handleCandidateClicked: handleCandidateClicked })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jAenQ.Link), {
        href: candidate.href,
        xcss: $39e2a93ffdbf67f4$var$linkStyles,
        onClick: ()=>{
            if (handleCandidateClicked) handleCandidateClicked(candidateIndex);
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            paddingBlock: "space.150",
            paddingInline: "space.300",
            backgroundColor: "color.background.neutral",
            xcss: $39e2a93ffdbf67f4$var$candidateStyles,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                space: "space.150",
                alignBlock: "center",
                alignInline: "start",
                xcss: $39e2a93ffdbf67f4$var$candidateContentStyles,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                        label: `search ${candidate}`
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                        children: candidate.label
                    })
                ]
            })
        })
    });
};
const $39e2a93ffdbf67f4$var$Candidates = ({ candidates: candidates, titleIndex: titleIndex, handleCandidateClicked: handleCandidateClicked })=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
        space: "space.200",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                size: "small",
                children: intl.formatMessage($39e2a93ffdbf67f4$var$titleMessagesArray[titleIndex])
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $cwkWT.default), {
                rowGap: "space.200",
                columnGap: "space.400",
                templateColumns: "1fr 1fr",
                xcss: $39e2a93ffdbf67f4$var$candidatesGridStyle,
                children: candidates.map((candidate, index)=>/*#__PURE__*/ (0, $l998X.jsx)($39e2a93ffdbf67f4$var$Candidate, {
                        candidate: candidate,
                        candidateIndex: index,
                        handleCandidateClicked: handleCandidateClicked
                    }, index))
            })
        ]
    });
};
const $39e2a93ffdbf67f4$var$CandidatesSkeleton = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
        space: "space.200",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                width: 100,
                height: 20
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
                rowGap: "space.200",
                columnGap: "space.400",
                templateColumns: "1fr 1fr",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                        width: '100%',
                        height: 44,
                        borderRadius: 22
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                        width: '100%',
                        height: 44,
                        borderRadius: 22
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                        width: '100%',
                        height: 44,
                        borderRadius: 22
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                        width: '100%',
                        height: 44,
                        borderRadius: 22
                    })
                ]
            })
        ]
    });
};
const $39e2a93ffdbf67f4$var$titleMessagesArray = [
    (0, $875248bc25579340$export$defe85febe8b728c).relatedSearch,
    (0, $875248bc25579340$export$defe85febe8b728c).teammatesAlsoAsk
];
const $39e2a93ffdbf67f4$var$LeapQuery = ({ candidates: candidates, loading: loading, titleIndex: titleIndex = 0, handleCandidateClicked: handleCandidateClicked })=>{
    // The `titleIndex` prop is used to specify which title to display.
    // `titleMessagesArray` is in the order that we aligned with backend engineers who maintains the leap query API.
    return loading ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        padding: "space.100",
        children: /*#__PURE__*/ (0, $l998X.jsx)($39e2a93ffdbf67f4$var$CandidatesSkeleton, {})
    }) : candidates.length > 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        padding: "space.100",
        children: /*#__PURE__*/ (0, $l998X.jsx)($39e2a93ffdbf67f4$var$Candidates, {
            candidates: candidates,
            titleIndex: titleIndex,
            handleCandidateClicked: handleCandidateClicked
        })
    }) : null;
};
var $39e2a93ffdbf67f4$export$2e2bcd8739ae039 = $39e2a93ffdbf67f4$var$LeapQuery;





const $5402f5bed179af85$export$cdb486deb3bf42a6 = ({ candidateIndex: candidateIndex, titleIndex: titleIndex, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'ui',
        actionSubject: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}LeapQueryCandidate`,
        action: 'clicked',
        attributes: {
            additionalAttributes: {
                leapQueryCandidateIndex: candidateIndex,
                lastQueryTitleIndex: titleIndex
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });


const $e40b2724d9f27471$export$4f8c03bff03c2688 = ({ candidatesCount: candidatesCount, titleIndex: titleIndex, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'track',
        action: 'shown',
        actionSubject: 'leapQuery',
        attributes: {
            additionalAttributes: {
                leapQueryCandidatesCount: candidatesCount,
                lastQueryTitleIndex: titleIndex
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

















var $3paC4 = parcelRequire("3paC4");

var $7YExv = parcelRequire("7YExv");

var $l5Hqz = parcelRequire("l5Hqz");

var $johDC = parcelRequire("johDC");

















var $8RFAN = parcelRequire("8RFAN");


var $gQ44d = parcelRequire("gQ44d");










var $fUcm0 = parcelRequire("fUcm0");

const $e44d8aa657338d97$export$760fa94addcbe07 = (edges)=>{
    // Fetch extra fields for Issues
    const issueKeys = [];
    // Fetch team names associated with the teamIds in Compass results
    const teamIds = [];
    if (edges && edges.length > 0) edges.forEach((edge)=>{
        if ((0, $8LSUr.isSearchResultJiraIssue)(edge.node)) {
            const issueKey = edge.node.issue?.webUrl?.split('/').at(-1) || edge.node.url.split('/').at(-1);
            if (!!issueKey) issueKeys.push(issueKey);
        } else if ((0, $b8N8h.isSearchCompassPartial)(edge.node)) {
            const teamId = (0, $fUcm0.getTeamId)(edge.node.ownerId);
            if (teamId && !teamIds.includes(teamId)) teamIds.push(teamId);
        }
    });
    return {
        issueKeys: issueKeys,
        teamIds: teamIds
    };
};
const $e44d8aa657338d97$export$cccb245f65b623d9 = (searchQuery, selectedProduct, searchCountResponse)=>{
    const counts = searchCountResponse.data?.search?.results.totalCounts || [];
    // Only Confluence allows an empty query so we should only return the count for Confluence
    if (selectedProduct === (0, $1yEFx.ProductKeys).Confluence && searchQuery === '') return counts.filter((count)=>count.product === (0, $1yEFx.ProductKeys).Confluence);
    return counts;
};

















var $4mLNH = parcelRequire("4mLNH");





var $h4dmn = parcelRequire("h4dmn");

var $6gi58 = parcelRequire("6gi58");



var $2zuvB = parcelRequire("2zuvB");








var $dOOW1 = parcelRequire("dOOW1");

const $11256674f3e3aa30$var$MULTISITE_SUPPORTED_PRODUCTS_WITH_CONTRIBUTORS_FILTER = [
    (0, $1yEFx.ProductKeys).Confluence,
    (0, $1yEFx.ProductKeys).Jira,
    (0, $1yEFx.ProductKeys).JiraServiceManagement,
    (0, $1yEFx.ProductKeys).JiraProductDiscovery
];
const $11256674f3e3aa30$export$1c6c59e9d0403280 = ({ cloudId: cloudId, selectedFilters: selectedFilters, selectedProduct: selectedProduct, linkedCloudARIs: linkedCloudARIs, sourceProduct: sourceProduct })=>{
    const isProductSupportedForMultiSiteWithContributorsFilter = selectedProduct ? $11256674f3e3aa30$var$MULTISITE_SUPPORTED_PRODUCTS_WITH_CONTRIBUTORS_FILTER.includes(selectedProduct) : false;
    const contributorsFilter = selectedFilters?.commonFilters.contributorsFilter;
    const hasContributorsFilter = Array.isArray(contributorsFilter) && contributorsFilter.length > 0;
    const hasLinkedCloudARIs = Array.isArray(linkedCloudARIs) && linkedCloudARIs.length > 0;
    // Rovo being rolled out for townsquare, mercury
    // and all of them using confluence ARI, we keep using confluence ARI for them.
    // However, for jira, we use jira ARI as there was a known issue when using confluence ARI, it applied Confluence ip restrictions to Jira.
    // Leave linkedCloudARIs as is, as it is used for multi-site search, and comes from config data.
    const fallbackCloudARI = sourceProduct === (0, $1yEFx.PrimaryProductKeys).Jira && (0, $dh538.fg)('jira_site_ari_query_enabled') ? `ari:cloud:jira::site/${cloudId}` : `ari:cloud:confluence::site/${cloudId}`;
    // Fall back to single site search when using contributors filter with unsupported products
    if (!isProductSupportedForMultiSiteWithContributorsFilter && hasContributorsFilter) return fallbackCloudARI;
    // Use multi-site search with linked cloud ARIs if available
    if (hasLinkedCloudARIs) return linkedCloudARIs;
    return fallbackCloudARI;
};
const $11256674f3e3aa30$export$46f82b8a3ce2a183 = async ({ cql: cql, query: query, originalQuery: originalQuery, entities: entities, selectedFilters: selectedFilters, cloudId: cloudId, aggAbsoluteUrl: aggAbsoluteUrl, searchSessionId: searchSessionId, sessionId: sessionId, sort: sort, sourceProduct: sourceProduct, experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers, after: after, limit: limit, enableHighlighting: enableHighlighting, skip3pEntityHydration: skip3pEntityHydration, fanoutExperimentCohort: fanoutExperimentCohort, includeSpaceSubtype: includeSpaceSubtype = false, linkedCloudARIs: linkedCloudARIs, selectedProduct: selectedProduct })=>{
    if (cql) {
        const response = (0, $h4dmn.confluenceCQLQuery)({
            cql: cql,
            first: limit,
            after: after
        }, cloudId);
        return response;
    }
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, jiraFilters: jiraFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, thirdPartyFilters: thirdPartyFilters, assetsFilters: assetsFilters } = selectedFilters || (0, $dOOW1.getEmptySelectedFilters)();
    const sortVariables = sort.field === (0, $2zuvB.SORT_FIELD_KEY).RELEVANCE ? [] : [
        sort
    ];
    // If the original query param is present, we want to disable query replacement
    const disableQueryReplacement = !!originalQuery;
    // Determine the appropriate cloud ARI based on filters and linked cloudARIs
    const cloudIdARI = $11256674f3e3aa30$export$1c6c59e9d0403280({
        cloudId: cloudId,
        selectedFilters: selectedFilters,
        selectedProduct: selectedProduct,
        linkedCloudARIs: linkedCloudARIs,
        sourceProduct: sourceProduct
    });
    const variables = {
        query: query,
        queryVersion: 1,
        cloudIdARI: cloudIdARI,
        tenantId: cloudId,
        limit: limit,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        jiraFilters: jiraFilters,
        mercuryFilters: mercuryFilters,
        compassFilters: compassFilters,
        thirdPartyFilters: thirdPartyFilters,
        assetsFilters: assetsFilters,
        entities: entities,
        searchSessionId: searchSessionId,
        sessionId: sessionId,
        sort: sortVariables,
        sourceProduct: sourceProduct,
        experimentId: experimentId,
        shadowExperimentId: shadowExperimentId,
        experimentLayers: experimentLayers?.map(({ name: name, layerId: layerId, shadowId: shadowId, definitions: definitions })=>({
                name: name,
                layerId: layerId,
                shadowId: shadowId,
                definitions: definitions
            })),
        after: after,
        disableQueryReplacement: disableQueryReplacement,
        enableHighlighting: enableHighlighting,
        skip3pEntityHydration: skip3pEntityHydration,
        includeSocialSignals: true,
        fanoutExperimentCohort: fanoutExperimentCohort,
        includeSpaceSubtype: includeSpaceSubtype,
        includeIssueTypeAvatarUrl: true,
        includeAssigneeField: (0, $dh538.fg)('rovo_search_assignee_field_fps')
    };
    if (entities.length === 0) throw new (0, $gQ44d.EmptyEntitiesError)();
    const response = (0, $johDC.searchPageQuery)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        originalQuery: originalQuery
    });
    // TODO: QS-6145 maybe here is a good place to merge results into cache store as HTTP response parts come in ?
    // const deferredResponse = deferredSearchPageQuery({ variables, aggAbsoluteUrl, originalQuery });
    // If the original query param is not present, we want to cache the response with the replacement query
    if (!originalQuery && (0, $dh538.fg)('rovo-search-spelling-correction')) {
        const value = await response;
        const queryInfo = value.data?.search?.results?.queryInfo;
        if (queryInfo && queryInfo.replacementQuery && queryInfo.originalQuery && queryInfo.replacementQuery !== queryInfo.originalQuery) (0, $johDC.cache).set((0, $johDC.generateCacheKey)({
            ...variables,
            query: queryInfo.replacementQuery
        }, queryInfo.originalQuery), response);
    }
    return response;
};
const $11256674f3e3aa30$export$6405a4ba66d50345 = async ({ issueKeys: issueKeys, cloudId: cloudId, aggAbsoluteUrl: aggAbsoluteUrl })=>{
    const variables = {
        issueKeys: issueKeys,
        cloudId: cloudId
    };
    const response = (0, $6gi58.fetchJiraFieldsQuery)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl
    });
    return response;
};



var $gY9AU = parcelRequire("gY9AU");

const $389fa27b7e70fb9c$export$62c31c0f13603e08 = (jiraFilters, availableProducts)=>{
    const allAvailableJiraProductTypes = Object.keys((0, $gY9AU.JiraProductProjectFilterKey)).reduce((acc, productKey)=>{
        const jiraProductKey = productKey;
        if (!availableProducts || availableProducts.includes(jiraProductKey)) acc.push(...(0, $gY9AU.JiraProductProjectFilterKey)[jiraProductKey]);
        return acc;
    }, []);
    return {
        ...jiraFilters,
        projectFilter: {
            ...jiraFilters.projectFilter,
            projectTypes: allAvailableJiraProductTypes
        }
    };
};


const $922c14edc5967a62$export$60bd4eb259acb432 = ()=>{
    const [{ cloudId: cloudId = '', aggregatorHostName: aggregatorHostName }] = (0, $j4ply.useBootstrap)();
    const [searchQuery] = (0, $djVCD.useSearchQuery)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [, { setAutoCorrection: setAutoCorrection }] = (0, $djVCD.useAutoCorrection)();
    (0, $42omo.useEffect)(()=>{
        const searchClient = (0, $3paC4.createClient)({
            cloudId: cloudId,
            aggregatorHostName: aggregatorHostName
        });
        const containsSearchQuery = searchQuery !== '';
        const shouldGetAutoCorrection = containsSearchQuery;
        if (!shouldGetAutoCorrection) return;
        searchClient.getAutoCorrection({
            query: searchQuery
        }).then((autoCorrection)=>{
            setAutoCorrection(autoCorrection);
        });
    }, [
        searchQuery,
        cloudId,
        setAutoCorrection,
        aggregatorHostName
    ]);
};
const $922c14edc5967a62$export$a40373be8d8f006f = ()=>{
    const [{ cloudId: cloudId = '', aggAbsoluteUrl: aggAbsoluteUrl, primaryProduct: primaryProduct, thirdPartyConfigs: thirdPartyConfigs, products: products }] = (0, $j4ply.useBootstrap)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [{ order: order, field: field }] = (0, $djVCD.useResultsSort)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const fetchFromCursor = (0, $djVCD.useFetchFromCursor)();
    const { selectedFilters: selectedFilters, unselectedProductsThirdPartyFilters: unselectedProductsThirdPartyFilters, selectedEntities: selectedEntities, entities: entities, hasFiltersSelected: hasFiltersSelected, entitiesForResultsCountQuery: entitiesForResultsCountQuery } = (0, $4VkIo.useSelectedFilters)({});
    const cql = (0, $djVCD.useCQL)();
    const [searchQuery] = (0, $djVCD.useSearchQuery)();
    const [originalQuery] = (0, $djVCD.useOriginalQuery)();
    const [backendExperiment] = (0, $j4ply.useBackendExperiment)({
        entities: entities,
        thirdPartyFilters: selectedFilters.thirdPartyFilters
    });
    const { experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers } = backendExperiment || {};
    const [frontendExperiments] = (0, $j4ply.useFrontendExperiments)();
    const [selectedInputFilters] = (0, $25a8b9613a265659$export$5a795cafef59146c)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const [linkedCloudARIs] = (0, $j4ply.useLinkedCloudARIs)();
    const sessionId = (0, $a0M2t.getSessionIdFromLocalStorage)();
    const is3pGroupingEnabled = (0, $dh538.fg)('fps_3p_grouping_rollout_gate');
    (0, $8RFAN.serveFederatedSlackExperiment)(selectedProduct, undefined, {
        fireExperimentExposure: true
    }, thirdPartyConfigs);
    const fanoutExperimentCohort = (()=>{
        if (is3pGroupingEnabled === false) return !selectedProduct ? 'boosted-and-smartlinks' : undefined;
        else return 'enable-v2';
    })();
    // We compare these via deep value equality, as currently the objects are regenerated
    // The bug this fixes is that when adding a filter from a dropdown, we shouldn't cause a search to run or load
    // TODO refactor this so we can go back to Object.is dependency equality on these objects
    const selectedFiltersValueEquality = JSON.stringify(selectedFilters);
    const selectedEntitiesValueEquality = JSON.stringify(selectedEntities);
    const entitiesValueEquality = JSON.stringify(entities);
    const frontendExperimentsValueEquality = JSON.stringify(frontendExperiments);
    const experimentLayersValueEquality = JSON.stringify(experimentLayers);
    const unselectedProductsThirdPartyFiltersValueEquality = JSON.stringify(unselectedProductsThirdPartyFilters);
    const entitiesForResultsCountQueryValueEquality = JSON.stringify(entitiesForResultsCountQuery);
    const productsValueEquality = JSON.stringify(products);
    return (0, $42omo.useMemo)(()=>({
            cql: cql,
            cloudId: cloudId,
            aggAbsoluteUrl: aggAbsoluteUrl,
            primaryProduct: primaryProduct,
            thirdPartyConfigs: thirdPartyConfigs,
            searchSessionId: searchSessionId,
            sessionId: sessionId,
            order: order,
            field: field,
            selectedProduct: selectedProduct,
            fetchFromCursor: fetchFromCursor,
            selectedFilters: selectedFilters,
            selectedEntities: selectedEntities,
            entities: entities,
            unselectedProductsThirdPartyFilters: unselectedProductsThirdPartyFilters,
            entitiesForResultsCountQuery: entitiesForResultsCountQuery,
            hasFiltersSelected: hasFiltersSelected,
            searchQuery: searchQuery,
            originalQuery: originalQuery,
            experimentId: experimentId,
            shadowExperimentId: shadowExperimentId,
            experimentLayers: experimentLayers,
            frontendExperiments: frontendExperiments,
            selectedInputFilters: selectedInputFilters,
            applicationMode: applicationMode,
            linkedCloudARIs: linkedCloudARIs,
            products: products,
            fanoutExperimentCohort: fanoutExperimentCohort
        }), // Note! Dependencies ending with ValueEquality are used to compare the values of the objects
    // and not the references. This is because the objects are regenerated on every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        cql,
        cloudId,
        aggAbsoluteUrl,
        primaryProduct,
        thirdPartyConfigs,
        searchSessionId,
        sessionId,
        order,
        field,
        selectedProduct,
        fetchFromCursor,
        selectedFiltersValueEquality,
        selectedEntitiesValueEquality,
        entitiesValueEquality,
        unselectedProductsThirdPartyFiltersValueEquality,
        entitiesForResultsCountQueryValueEquality,
        hasFiltersSelected,
        searchQuery,
        originalQuery,
        experimentId,
        shadowExperimentId,
        experimentLayersValueEquality,
        frontendExperimentsValueEquality,
        selectedInputFilters,
        applicationMode,
        linkedCloudARIs,
        productsValueEquality,
        fanoutExperimentCohort
    ]);
};
const $922c14edc5967a62$export$29a58dac8cb98481 = {
    current: undefined
};
const $922c14edc5967a62$export$c7eeb53d50673e29 = ({ cql: cql, searchQuery: searchQuery, selectedProduct: selectedProduct, hasFiltersSelected: hasFiltersSelected, originalQuery: originalQuery, entities: entities, selectedFilters: selectedFilters, aggAbsoluteUrl: aggAbsoluteUrl, cloudId: cloudId, searchSessionId: searchSessionId, sessionId: sessionId, primaryProduct: primaryProduct, order: order, field: field, experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers, fetchFromCursor: fetchFromCursor, linkedCloudARIs: linkedCloudARIs, beforeFetch: beforeFetch })=>{
    // Cancel the inflight request if there is one
    if ($922c14edc5967a62$export$29a58dac8cb98481.current) $922c14edc5967a62$export$29a58dac8cb98481.current.cancel();
    // Reset results when...
    // 1. There is no search query
    // 2. There is no selected product or the selected product is not Confluence
    // 3. There are no selected child filters
    const containsSearchQuery = searchQuery !== '';
    const confluenceIsSelected = selectedProduct === 'confluence';
    const shouldTriggerNonCQLSearch = containsSearchQuery || containsSearchQuery && hasFiltersSelected || confluenceIsSelected;
    // Reset results and cancel inflight requests if we are not searching
    if (!shouldTriggerNonCQLSearch && !cql) // Reset results
    return Promise.resolve(undefined);
    // Run fetching results if exists
    beforeFetch?.();
    $922c14edc5967a62$export$29a58dac8cb98481.current = new (0, $czt8s.CancellablePromise)((0, $11256674f3e3aa30$export$46f82b8a3ce2a183)({
        cql: shouldTriggerNonCQLSearch ? undefined : cql,
        query: searchQuery,
        originalQuery: originalQuery,
        entities: entities,
        selectedFilters: selectedFilters,
        aggAbsoluteUrl: aggAbsoluteUrl,
        cloudId: cloudId,
        searchSessionId: searchSessionId,
        sessionId: sessionId,
        sort: {
            order: order,
            field: field
        },
        sourceProduct: primaryProduct,
        experimentId: experimentId,
        shadowExperimentId: shadowExperimentId,
        experimentLayers: experimentLayers,
        after: fetchFromCursor,
        limit: entities.length === (0, $idpYy.getDefaultEntityAti)().length ? (0, $idpYy.RESULT_LIMIT_FOR_MULTIPLE_PRODUCTS) : (0, $idpYy.RESULT_LIMIT_FOR_SINGLE_PRODUCT),
        // TODO: This is a temporary variable to rollout highlighting to all users
        // with this variable, we can rollout frontend changes and apply backend highlighting atomically
        // and without affecting existing users
        enableHighlighting: true,
        skip3pEntityHydration: !!(0, $dh538.fg)('exclude_3p_entity_in_search_results'),
        includeSpaceSubtype: !!(0, $dh538.fg)('is_jsm_dc_enabled_in_ui'),
        linkedCloudARIs: linkedCloudARIs,
        selectedProduct: selectedProduct
    }));
    return $922c14edc5967a62$export$29a58dac8cb98481.current.promise();
};
const $922c14edc5967a62$export$24130b4c57261b7f = {
    current: undefined
};
const $922c14edc5967a62$export$bd03b51ca03b110 = (props)=>{
    const { cql: cql, searchQuery: searchQuery, selectedProduct: selectedProduct, hasFiltersSelected: hasFiltersSelected, originalQuery: originalQuery, entities: entities, selectedFilters: selectedFilters, aggAbsoluteUrl: aggAbsoluteUrl, cloudId: cloudId, searchSessionId: searchSessionId, sessionId: sessionId, primaryProduct: primaryProduct, order: order, field: field, experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers, fetchFromCursor: fetchFromCursor, linkedCloudARIs: linkedCloudARIs, fanoutExperimentCohort: fanoutExperimentCohort, beforeFetch: beforeFetch } = props;
    // Cancel the inflight request if there is one
    if ($922c14edc5967a62$export$24130b4c57261b7f.current) $922c14edc5967a62$export$24130b4c57261b7f.current.cancel();
    // Reset results when...
    // 1. There is no search query
    // 2. There is no selected product or the selected product is not Confluence
    // 3. There are no selected child filters
    const containsSearchQuery = searchQuery !== '';
    const confluenceIsSelected = selectedProduct === 'confluence';
    const shouldTriggerNonCQLSearch = containsSearchQuery || containsSearchQuery && hasFiltersSelected || confluenceIsSelected;
    // Reset results and cancel inflight requests if we are not searching
    if (!shouldTriggerNonCQLSearch && !cql) // Reset results
    return Promise.resolve([
        undefined,
        undefined
    ]);
    // Run fetching results if exists
    beforeFetch?.();
    $922c14edc5967a62$export$24130b4c57261b7f.current = new (0, $czt8s.CancellablePromise)(Promise.all([
        (0, $11256674f3e3aa30$export$46f82b8a3ce2a183)({
            cql: shouldTriggerNonCQLSearch ? undefined : cql,
            query: searchQuery,
            originalQuery: originalQuery,
            entities: entities,
            selectedFilters: selectedFilters,
            aggAbsoluteUrl: aggAbsoluteUrl,
            cloudId: cloudId,
            searchSessionId: searchSessionId,
            sessionId: sessionId,
            sort: {
                order: order,
                field: field
            },
            sourceProduct: primaryProduct,
            experimentId: experimentId,
            shadowExperimentId: shadowExperimentId,
            experimentLayers: experimentLayers,
            after: fetchFromCursor,
            limit: entities.length === (0, $idpYy.getDefaultEntityAti)().length ? (0, $idpYy.RESULT_LIMIT_FOR_MULTIPLE_PRODUCTS) : (0, $idpYy.RESULT_LIMIT_FOR_SINGLE_PRODUCT),
            // TODO: This is a temporary variable to rollout highlighting to all users
            // with this variable, we can rollout frontend changes and apply backend highlighting atomically
            // and without affecting existing users
            enableHighlighting: true,
            skip3pEntityHydration: !!(0, $dh538.fg)('exclude_3p_entity_in_search_results'),
            includeSpaceSubtype: !!(0, $dh538.fg)('is_jsm_dc_enabled_in_ui'),
            linkedCloudARIs: linkedCloudARIs,
            selectedProduct: selectedProduct,
            fanoutExperimentCohort: fanoutExperimentCohort
        }),
        $922c14edc5967a62$export$26a4dce521cea6a5(props)
    ]));
    return $922c14edc5967a62$export$24130b4c57261b7f.current.promise();
};
const $922c14edc5967a62$export$26a4dce521cea6a5 = ({ selectedFilters: selectedFilters, searchQuery: searchQuery, cloudId: cloudId, unselectedProductsThirdPartyFilters: unselectedProductsThirdPartyFilters, entitiesForResultsCountQuery: entitiesForResultsCountQuery, searchSessionId: searchSessionId, primaryProduct: primaryProduct, aggAbsoluteUrl: aggAbsoluteUrl, originalQuery: originalQuery, products: products })=>{
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, jiraFilters: jiraFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, assetsFilters: assetsFilters } = selectedFilters;
    const isEmptyQuery = !searchQuery || searchQuery.trim() === '';
    const availableProducts = products.filter(// If the query is empty, only some products are valid
    (product)=>!isEmptyQuery || (0, $1yEFx.productsSupportingEmptyQuery).includes(product));
    // Rovo being rolled out for townsquare, mercury
    // and all of them using confluence ARI, we keep using confluence ARI for them.
    // However, for jira, we use jira ARI as there was a known issue when using confluence ARI, it applied Confluence ip restrictions to Jira.
    const cloudIdARI = primaryProduct === (0, $1yEFx.PrimaryProductKeys).Jira && (0, $dh538.fg)('jira_site_ari_query_enabled') ? `ari:cloud:jira::site/${cloudId}` : `ari:cloud:confluence::site/${cloudId}`;
    const resultsCountVariables = {
        query: searchQuery,
        queryVersion: 1,
        cloudIdARI: cloudIdARI,
        limit: 0,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        jiraFilters: (0, $389fa27b7e70fb9c$export$62c31c0f13603e08)(jiraFilters, availableProducts),
        mercuryFilters: mercuryFilters,
        compassFilters: compassFilters,
        thirdPartyFilters: unselectedProductsThirdPartyFilters,
        entities: entitiesForResultsCountQuery,
        searchSessionId: searchSessionId,
        sort: [],
        sourceProduct: primaryProduct,
        assetsFilters: assetsFilters
    };
    return (0, $johDC.resultsCountQuery)({
        variables: resultsCountVariables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        originalQuery: originalQuery
    });
};
const $922c14edc5967a62$export$10418e8440ec79f4 = ({ results: results, cloudId: cloudId, aggAbsoluteUrl: aggAbsoluteUrl, jiraFields: jiraFields, teamsBulk: teamsBulk, logException: logException })=>{
    const { issueKeys: issueKeys, teamIds: teamIds } = (0, $e44d8aa657338d97$export$760fa94addcbe07)(results?.edges);
    // Fetch extra fields for Issues
    if (issueKeys.length > 0) {
        jiraFields?.before?.();
        (0, $11256674f3e3aa30$export$6405a4ba66d50345)({
            issueKeys: issueKeys,
            cloudId: cloudId,
            aggAbsoluteUrl: aggAbsoluteUrl
        }).then((results)=>jiraFields?.complete(results.data?.jira.issuesByKey || [])).catch(logException).finally(jiraFields?.finally);
    }
    // Fetch team names associated with the teamIds in Compass results
    if (teamIds.length > 0) {
        teamsBulk?.before?.();
        (0, $7YExv.fetchTeamsBulk)({
            siteId: cloudId,
            teamIds: teamIds
        }, logException).then((results)=>teamsBulk?.complete(results.teams || [])).finally(teamsBulk?.finally);
    }
};
const $922c14edc5967a62$var$useSetSearchResultsPostActions = ()=>{
    const [{ cloudId: cloudId = '', aggAbsoluteUrl: aggAbsoluteUrl }] = (0, $j4ply.useBootstrap)();
    const { setJiraIssueDetails: setJiraIssueDetails, setJiraIssueFieldsLoading: setJiraIssueFieldsLoading, setCompassTeams: setCompassTeams, setCompassTeamsLoading: setCompassTeamsLoading } = (0, $djVCD.useSearchActions)();
    const logException = (0, $f8oYd.useLogException)();
    return (0, $42omo.useCallback)((aggResults)=>$922c14edc5967a62$export$10418e8440ec79f4({
            results: aggResults.data?.search?.results,
            cloudId: cloudId,
            aggAbsoluteUrl: aggAbsoluteUrl,
            jiraFields: {
                complete: setJiraIssueDetails,
                before: ()=>setJiraIssueFieldsLoading(true),
                finally: ()=>setJiraIssueFieldsLoading(false)
            },
            teamsBulk: {
                complete: setCompassTeams,
                before: ()=>setCompassTeamsLoading(true),
                finally: ()=>setCompassTeamsLoading(false)
            },
            logException: logException
        }), [
        cloudId,
        aggAbsoluteUrl,
        setJiraIssueDetails,
        setCompassTeams,
        setJiraIssueFieldsLoading,
        setCompassTeamsLoading,
        logException
    ]);
};
const $922c14edc5967a62$var$useSetSearchResults = ()=>{
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const fetchFromCursor = (0, $djVCD.useFetchFromCursor)();
    const { setResults: setResults, appendMoreResults: appendMoreResults } = (0, $djVCD.useSearchActions)();
    const logException = (0, $f8oYd.useLogException)();
    return (0, $42omo.useCallback)((aggResults)=>{
        const { data: data, extensions: extensions, errors: errors } = aggResults;
        const errorMessage = errors?.[0]?.message;
        const resultsFetchError = errorMessage ? new (0, $gQ44d.ResultsFetchError)(errorMessage) : undefined;
        if (fetchFromCursor && fetchFromCursor !== '') appendMoreResults(data?.search?.results);
        else setResults(data?.search?.results, resultsFetchError, extensions?.gateway?.request_id || undefined, extensions?.gateway?.trace_id || undefined);
        if (resultsFetchError) logException(resultsFetchError);
    }, [
        fetchFromCursor,
        setResults,
        appendMoreResults,
        logException
    ]);
};
const $922c14edc5967a62$var$useTrackIntercomEvents = ()=>{
    const intercom = (0, $9afb3d504f643405$export$f0fed4b0765d7314)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    return (0, $42omo.useCallback)(()=>{
        if (selectedProduct && (0, $1yEFx.is3pProductKey)(selectedProduct)) intercom?.trackEvent('search_requested_3p', {
            product_filter: selectedProduct
        });
        else intercom?.trackEvent('search_requested');
    }, [
        selectedProduct,
        intercom
    ]);
};
const $922c14edc5967a62$var$useRestartUFOExperience = ()=>{
    const applicationMode = (0, $j4ply.useApplicationMode)();
    return (0, $42omo.useCallback)(async ()=>{
        // resultsRef is nevert unset. Is this working as intended?
        // We should probably provide a way to check if the inlfight
        // promise is still active
        if ($922c14edc5967a62$export$29a58dac8cb98481.current) await (0, $bVltF.searchResultsLoadUFOExperience).abort({
            metadata: {
                applicationMode: applicationMode
            }
        });
        await (0, $bVltF.searchResultsLoadUFOExperience).start();
        (0, $bVltF.searchResultsLoadUFOExperience).mark('request_start');
    }, [
        applicationMode
    ]);
};
const $922c14edc5967a62$var$useSetLoadingFetchResults = ()=>{
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const fetchFromCursor = (0, $djVCD.useFetchFromCursor)();
    const { setIsLoadingMore: setIsLoadingMore, setIsLoading: setIsLoading } = (0, $djVCD.useSearchActions)();
    return (0, $42omo.useCallback)(()=>{
        if (fetchFromCursor && fetchFromCursor !== '') setIsLoadingMore(true);
        else setIsLoading(true);
    }, [
        fetchFromCursor,
        setIsLoadingMore,
        setIsLoading
    ]);
};
const $922c14edc5967a62$var$useHandleFetchResultsError = ()=>{
    const { setResults: setResults } = (0, $djVCD.useSearchActions)();
    const { setProductResultCount: setProductResultCount } = (0, $djVCD.useSearchActions)();
    const trackIntercomEvents = $922c14edc5967a62$var$useTrackIntercomEvents();
    return (0, $42omo.useCallback)((e)=>{
        if (e instanceof (0, $gQ44d.EmptyEntitiesError)) setResults(undefined, e);
        else if (!(e instanceof (0, $czt8s.CancelError))) {
            setResults(undefined, new (0, $gQ44d.ResultsFetchError)(e.message));
            trackIntercomEvents();
        }
        setProductResultCount();
        return undefined;
    }, [
        setResults,
        trackIntercomEvents,
        setProductResultCount
    ]);
};
const $922c14edc5967a62$export$c199ac7e412a5a11 = ()=>{
    const props = $922c14edc5967a62$export$a40373be8d8f006f();
    const { setQueryUpdatedTime: setQueryUpdatedTime, resetResults: resetResults, setProductResultCount: setProductResultCount, setRequestedBackendExperiments: setRequestedBackendExperiments } = (0, $djVCD.useSearchActions)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const isSearchReady = (0, $djVCD.useIsSearchReady)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [retryCount] = (0, $djVCD.useRetryCount)();
    // Get current results and product count map for Slack special handling
    // we can add eslint disable rule here because this is not a relay code path and will be deprecated very soon once we fully move to relay
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [currentResults] = (0, $djVCD.useResults)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [productResultCountMap] = (0, $djVCD.useProductResultCountMap)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const fetchPostActions = $922c14edc5967a62$var$useSetSearchResultsPostActions();
    const setSearchResults = $922c14edc5967a62$var$useSetSearchResults();
    const setLoading = $922c14edc5967a62$var$useSetLoadingFetchResults();
    const trackIntercomEvents = $922c14edc5967a62$var$useTrackIntercomEvents();
    const restartUFOExperience = $922c14edc5967a62$var$useRestartUFOExperience();
    const handleFetchResultsError = $922c14edc5967a62$var$useHandleFetchResultsError();
    const logException = (0, $f8oYd.useLogException)();
    const { onSearchResultsShown: onSearchResultsShownCallback } = (0, $7WbA8.useAppContext)();
    const onSearchResultsShown = (0, $42omo.useCallback)((fetchedResults)=>{
        if (onSearchResultsShownCallback && fetchedResults.length > 0) try {
            const results = (0, $4mLNH.transformSearchPageConfluenceResults)(fetchedResults);
            if (results.length > 0) onSearchResultsShownCallback(results);
        } catch (error) {
            logException(error);
        }
    }, [
        onSearchResultsShownCallback,
        logException
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isSearchReady) return;
        // Fetch search results
        const { searchQuery: searchQuery, selectedProduct: selectedProduct } = props;
        $922c14edc5967a62$export$bd03b51ca03b110({
            ...props,
            beforeFetch: ()=>{
                setProductResultCount();
                restartUFOExperience();
                setLoading();
                setQueryUpdatedTime();
                setRequestedBackendExperiments({
                    experimentLayers: props.experimentLayers
                });
            }
        }).then(([aggResults, aggResultsCount])=>{
            if (aggResults) {
                setSearchResults(aggResults);
                trackIntercomEvents();
                // Mark UFO experience loading times
                (0, $bVltF.searchResultsLoadUFOExperience).mark('request_end');
                (0, $bVltF.searchResultsLoadUFOExperience).mark('render_start');
                fetchPostActions(aggResults);
                onSearchResultsShown(aggResults.data?.search?.results?.edges || []);
            } else resetResults();
            setProductResultCount(aggResultsCount ? (0, $e44d8aa657338d97$export$cccb245f65b623d9)(searchQuery, selectedProduct, aggResultsCount) : undefined);
        }).catch(handleFetchResultsError);
    }, [
        isSearchReady,
        setProductResultCount,
        restartUFOExperience,
        setLoading,
        setQueryUpdatedTime,
        fetchPostActions,
        handleFetchResultsError,
        resetResults,
        setSearchResults,
        trackIntercomEvents,
        setRequestedBackendExperiments,
        retryCount,
        props,
        onSearchResultsShown
    ]);
    // Special handling for Slack: Update count map with actual displayed results count
    (0, $42omo.useEffect)(()=>{
        const isSlackFederatedSearchEnabled = (0, $8RFAN.serveFederatedSlackExperiment)(selectedProduct, undefined, {
            fireExperimentExposure: false
        }) || (0, $dh538.fg)('ai_3p_slack_federated_search_enabled');
        if (!isSlackFederatedSearchEnabled) return;
        if (selectedProduct === (0, $1yEFx.ProductKeys).Slack && currentResults?.edges && productResultCountMap) {
            const slackResultsCount = currentResults.edges.length;
            if (productResultCountMap[(0, $1yEFx.ProductKeys).Slack] !== slackResultsCount) {
                const updatedCounts = Object.entries({
                    ...productResultCountMap,
                    [(0, $1yEFx.ProductKeys).Slack]: slackResultsCount
                }).map(([product, count])=>({
                        product: product,
                        count: count
                    }));
                setProductResultCount(updatedCounts);
            }
        }
    }, [
        selectedProduct,
        currentResults,
        productResultCountMap,
        setProductResultCount
    ]);
};
const $922c14edc5967a62$export$a858a666a1f95b7 = ()=>{
    const [searchQuery] = (0, $djVCD.useSearchQuery)();
    const { setLeapQuery: setLeapQuery } = (0, $djVCD.useSearchActions)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const { loading: loading, candidates: candidates, titleIndex: titleIndex } = (0, $djVCD.useLeapQueryResult)();
    (0, $42omo.useEffect)(()=>{
        if (searchQuery === '') setLeapQuery({
            candidates: [],
            titleIndex: 0,
            loading: false
        });
        setLeapQuery({
            candidates: [],
            titleIndex: 0,
            loading: true
        });
        (0, $l5Hqz.getLeapQuery)({
            query: searchQuery,
            product: (0, $1yEFx.ProductKeys).Confluence
        }).then((response)=>{
            setLeapQuery({
                candidates: response.candidates,
                titleIndex: response.title,
                loading: false
            });
        }).catch(()=>{
            setLeapQuery({
                candidates: [],
                titleIndex: 0,
                loading: false
            });
        });
    }, [
        searchQuery,
        setLeapQuery
    ]);
    return {
        loading: loading,
        candidates: candidates,
        titleIndex: titleIndex
    };
};





const $b62a6edcfe9a416a$var$LeapQuery = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [queryInfo] = (0, $djVCD.useQueryInfo)();
    const { loading: loading, candidates: candidates, titleIndex: titleIndex } = (0, $922c14edc5967a62$export$a858a666a1f95b7)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const { originalQuery: originalQuery } = queryInfo || {};
    const mappedCandidates = (0, $42omo.useMemo)(()=>candidates.slice(0, 4).map((candidate)=>({
                label: candidate,
                href: generateSearchUrl({
                    ...queryParams,
                    text: candidate,
                    originalQuery: originalQuery
                })
            })), [
        candidates,
        generateSearchUrl,
        originalQuery,
        queryParams
    ]);
    const handleCandidateClicked = (candidateIndex)=>{
        fireAnalyticsEvent((0, $5402f5bed179af85$export$cdb486deb3bf42a6)({
            candidateIndex: candidateIndex,
            titleIndex: titleIndex,
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    };
    (0, $42omo.useEffect)(()=>{
        if (loading || candidates.length === 0) return;
        fireAnalyticsEvent((0, $e40b2724d9f27471$export$4f8c03bff03c2688)({
            candidatesCount: candidates.length,
            titleIndex: titleIndex,
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        candidates.length,
        loading
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $39e2a93ffdbf67f4$export$2e2bcd8739ae039), {
        candidates: mappedCandidates,
        loading: loading,
        titleIndex: titleIndex,
        handleCandidateClicked: handleCandidateClicked
    });
};
const $b62a6edcfe9a416a$export$4c364b51dbcd9c2 = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
        section: "SearchPageLeapQuery",
        children: /*#__PURE__*/ (0, $l998X.jsx)($b62a6edcfe9a416a$var$LeapQuery, {})
    });
var $b62a6edcfe9a416a$export$2e2bcd8739ae039 = $b62a6edcfe9a416a$var$LeapQuery;









var $226KS = parcelRequire("226KS");







var $iXCQx = parcelRequire("iXCQx");












parcelRequire("42omo");






const $0d63697edde98d0a$var$descriptionBodyStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    lineClamp: 2,
    WebkitBoxOrient: 'vertical'
});
const $0d63697edde98d0a$export$780f34b9b2f156ca = ({ description: description })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $0d63697edde98d0a$var$descriptionBodyStyles,
        children: description
    });
};





var $2waBy = parcelRequire("2waBy");


var $9WEcF = parcelRequire("9WEcF");


var $kXlQy = parcelRequire("kXlQy");





var $bOpS4 = parcelRequire("bOpS4");










const $93586e46c0b180da$export$c7c0ac9713d05b8e = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'ui',
        actionSubject: 'button',
        actionSubjectId: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}ContextMenuButton`,
        action: 'clicked',
        attributes: {
            additionalAttributes: {
                location: 'searchResultTitle'
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });














const $3808426f0faae55b$export$ede80662f98c6d00 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const { queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    return (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $93586e46c0b180da$export$c7c0ac9713d05b8e)({
            commonAttributes: {
                ...commonAttributes,
                ...primaryProduct && (0, $2OtFZ.serveSearchPageRelayExp)(primaryProduct, false, queryParams) ? (0, $1ymk3.getExtensionData)(commonAttributes.isCQL) : {}
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes,
        primaryProduct,
        queryParams
    ]);
};











const $e7c87e3ee203b05c$export$822017e4f08ebe1e = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'ui',
        actionSubject: 'button',
        actionSubjectId: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}ContextMenuCopyButton`,
        action: 'clicked',
        attributes: {
            additionalAttributes: {
                location: 'searchResultTitle'
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });














const $2719c743fbe13cbd$export$875f4c2863f9261e = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const { queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    return (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $e7c87e3ee203b05c$export$822017e4f08ebe1e)({
            commonAttributes: {
                ...commonAttributes,
                ...primaryProduct && (0, $2OtFZ.serveSearchPageRelayExp)(primaryProduct, false, queryParams) ? (0, $1ymk3.getExtensionData)(commonAttributes.isCQL) : {}
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes,
        primaryProduct,
        queryParams
    ]);
};












const $7854452482d3991b$export$640da93e7e078b14 = ({ metadata: metadata, position: position, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, socialSignal: socialSignal, fromLinksSeeAll: fromLinksSeeAll, sublistPosition: sublistPosition, provider: provider, linkDocId: linkDocId, linkDocContentType: linkDocContentType, fanoutProduct: fanoutProduct, fanoutLinkCategory: fanoutLinkCategory, isImpersonated: isImpersonated = false, hasRelatedLinks: hasRelatedLinks, is3PClickIngestionEnabled: is3PClickIngestionEnabled, thirdPartyId: thirdPartyId, isAuxClick: isAuxClick = false, isSummarizeClick: isSummarizeClick = false })=>{
    const { product: metadataProduct, ...restMetadata } = metadata;
    const product = fanoutProduct || metadataProduct;
    return {
        eventType: 'ui',
        action: 'clicked',
        actionSubject: 'advancedSearchResultLink',
        attributes: {
            additionalAttributes: {
                position: position,
                metadata: {
                    ...restMetadata,
                    product: product,
                    ...fanoutProduct && {
                        parentProduct: metadataProduct
                    },
                    ...fanoutLinkCategory && {
                        fanoutLinkCategory: fanoutLinkCategory
                    },
                    is3PLink: (0, $1yEFx.is3pProductKeyForAnalytics)(product),
                    fromLinksSeeAll: fromLinksSeeAll,
                    sublistPosition: sublistPosition,
                    provider: provider,
                    linkDocId: linkDocId,
                    linkDocContentType: linkDocContentType,
                    hasRelatedLinks: hasRelatedLinks,
                    thirdPartyId: thirdPartyId
                },
                isImpersonated: isImpersonated,
                socialSignal: socialSignal,
                is3PClickIngestionEnabled: is3PClickIngestionEnabled,
                isAuxClick: isAuxClick,
                isSummarizeClick: isSummarizeClick
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    };
};
const $7854452482d3991b$export$a72fc3c2887a9000 = ({ metadata: metadata, position: position, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, socialSignal: socialSignal, sublistPosition: sublistPosition, linkDocId: linkDocId, linkDocContentType: linkDocContentType, fanoutProduct: fanoutProduct, fanoutLinkCategory: fanoutLinkCategory, isImpersonated: isImpersonated = false, is3PClickIngestionEnabled: is3PClickIngestionEnabled, thirdPartyId: thirdPartyId })=>{
    const { product: metadataProduct, ...restMetadata } = metadata;
    const product = fanoutProduct || metadataProduct;
    return {
        eventType: 'ui',
        action: 'contextMenuClicked',
        actionSubject: 'advancedSearchResultLink',
        attributes: {
            additionalAttributes: {
                position: position,
                metadata: {
                    ...restMetadata,
                    product: product,
                    ...fanoutProduct && {
                        parentProduct: metadataProduct
                    },
                    ...fanoutLinkCategory && {
                        fanoutLinkCategory: fanoutLinkCategory
                    },
                    is3PLink: (0, $1yEFx.is3pProductKeyForAnalytics)(product),
                    sublistPosition: sublistPosition,
                    linkDocId: linkDocId,
                    linkDocContentType: linkDocContentType,
                    thirdPartyId: thirdPartyId
                },
                isImpersonated: isImpersonated,
                socialSignal: socialSignal,
                is3PClickIngestionEnabled: is3PClickIngestionEnabled
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    };
};














const $29cf2c8a5cfa1059$export$b9038cd1b8a570da = ({ metadata: metadata, position: position, socialSignal: socialSignal, isImpersonated: isImpersonated = false, is3PClickIngestionEnabled: is3PClickIngestionEnabled })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const { queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    return (0, $42omo.useCallback)((params = {})=>{
        const { fromLinksSeeAll: fromLinksSeeAll, sublistPosition: sublistPosition, provider: provider, linkDocId: linkDocId, linkDocContentType: linkDocContentType, fanoutProduct: fanoutProduct, fanoutLinkCategory: fanoutLinkCategory, hasRelatedLinks: hasRelatedLinks, thirdPartyId: thirdPartyId, isAuxClick: isAuxClick, isSummarizeClick: isSummarizeClick } = params;
        const analyticsPayload = (0, $7854452482d3991b$export$640da93e7e078b14)({
            metadata: metadata,
            position: position,
            socialSignal: socialSignal,
            commonAttributes: {
                ...commonAttributes,
                ...primaryProduct && (0, $2OtFZ.serveSearchPageRelayExp)(primaryProduct, false, queryParams) ? (0, $1ymk3.getExtensionData)(commonAttributes.isCQL) : {}
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            fromLinksSeeAll: fromLinksSeeAll,
            sublistPosition: sublistPosition,
            provider: provider,
            fanoutProduct: fanoutProduct,
            linkDocId: linkDocId,
            linkDocContentType: linkDocContentType,
            fanoutLinkCategory: fanoutLinkCategory,
            isImpersonated: isImpersonated,
            hasRelatedLinks: hasRelatedLinks,
            is3PClickIngestionEnabled: is3PClickIngestionEnabled,
            thirdPartyId: thirdPartyId,
            isAuxClick: isAuxClick,
            isSummarizeClick: isSummarizeClick
        });
        fireAnalyticsEvent(analyticsPayload);
    }, [
        fireAnalyticsEvent,
        metadata,
        position,
        socialSignal,
        commonAttributes,
        nonPrivacySafeAttributes,
        isImpersonated,
        is3PClickIngestionEnabled,
        primaryProduct,
        queryParams
    ]);
};





















const $add774a162708af3$export$8839bf4972090a38 = ({ metadata: metadata, position: position, socialSignal: socialSignal, isImpersonated: isImpersonated = false, is3PClickIngestionEnabled: is3PClickIngestionEnabled })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const { queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    return (0, $42omo.useCallback)((params = {})=>{
        const { sublistPosition: sublistPosition, linkDocId: linkDocId, provider: provider, linkDocContentType: linkDocContentType, fanoutProduct: fanoutProduct, fanoutLinkCategory: fanoutLinkCategory, thirdPartyId: thirdPartyId } = params;
        const analyticsPayload = (0, $7854452482d3991b$export$a72fc3c2887a9000)({
            metadata: metadata,
            position: position,
            fanoutProduct: fanoutProduct,
            fanoutLinkCategory: fanoutLinkCategory,
            socialSignal: socialSignal,
            commonAttributes: {
                ...commonAttributes,
                ...primaryProduct && (0, $2OtFZ.serveSearchPageRelayExp)(primaryProduct, false, queryParams) ? (0, $1ymk3.getExtensionData)(commonAttributes.isCQL) : {}
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            sublistPosition: sublistPosition,
            provider: provider,
            linkDocId: linkDocId,
            linkDocContentType: linkDocContentType,
            isImpersonated: isImpersonated ?? false,
            is3PClickIngestionEnabled: is3PClickIngestionEnabled,
            thirdPartyId: thirdPartyId
        });
        fireAnalyticsEvent(analyticsPayload);
    }, [
        fireAnalyticsEvent,
        metadata,
        position,
        socialSignal,
        commonAttributes,
        nonPrivacySafeAttributes,
        isImpersonated,
        primaryProduct,
        queryParams,
        is3PClickIngestionEnabled
    ]);
};











const $43a335bf303e6216$export$1c710fc72952b57e = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, location: location, metadata: metadata, position: position })=>({
        eventType: 'ui',
        actionSubject: 'button',
        actionSubjectId: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}SummarizeInChatButton`,
        action: 'clicked',
        attributes: {
            additionalAttributes: {
                location: location,
                metadata: metadata,
                position: position
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });














const $bbb097a890bbf9c9$export$5ce6946676179c6b = ({ location: location, metadata: metadata, position: position })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const { queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    return (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $43a335bf303e6216$export$1c710fc72952b57e)({
            commonAttributes: {
                ...commonAttributes,
                ...primaryProduct && (0, $2OtFZ.serveSearchPageRelayExp)(primaryProduct, false, queryParams) ? (0, $1ymk3.getExtensionData)(commonAttributes.isCQL) : {}
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            location: location,
            metadata: metadata,
            position: position
        }));
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes,
        location,
        metadata,
        position,
        primaryProduct,
        queryParams
    ]);
};











const $3d88c2efff54240a$var$SchemaMetadata = ({ schemaName: schemaName })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.050",
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($226KS))), {
                size: "small",
                label: ""
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                color: "inherit",
                children: schemaName
            })
        ]
    });
};
const $3d88c2efff54240a$export$bdb84dba2a405f14 = ({ partial: partial, position: position })=>{
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const [{ cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const [searchQuery] = (0, $djVCD.useSearchQuery)();
    const appMode = (0, $j4ply.useApplicationMode)();
    const { id: id, title: title, type: type, description: description, lastModifiedDate: lastModifiedDate } = partial;
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(id);
        return {
            id: id,
            containerId: null,
            spaceId: null,
            contentType: type,
            entityType: type,
            contentId: contentId,
            product: product
        };
    }, [
        id,
        type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const getLastModified = (0, $42omo.useMemo)(()=>{
        if (!lastModifiedDate) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
            lastModified: lastModifiedDate
        });
    }, [
        lastModifiedDate
    ]);
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(title, searchQuery.split(' '));
        if (!highlightedTitle) return title;
        return (0, $Y34Hw.enrichExcerpt)(title);
    }, [
        title,
        searchQuery
    ]);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        const reducedDescription = (0, $bOpS4.truncateTextWithQuery)(description, searchQuery);
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(reducedDescription, searchQuery.split(' '));
        if (!highlightedTitle) return reducedDescription;
        return (0, $Y34Hw.processExcerpt)(highlightedTitle);
    }, [
        description,
        searchQuery
    ]);
    const headerMetadataParts = (0, $42omo.useMemo)(()=>{
        if (!(0, $l3paI.isSearchResultAssetsObjectSchema)(partial)) return [
            [
                'type',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                    type: metadata.entityType
                })
            ],
            [
                'schema',
                /*#__PURE__*/ (0, $l998X.jsx)($3d88c2efff54240a$var$SchemaMetadata, {
                    schemaName: partial.objectSchemaEntity.name
                })
            ],
            [
                'lastModified',
                getLastModified
            ]
        ];
        return [
            [
                'type',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                    type: metadata.entityType
                })
            ],
            [
                'lastModified',
                getLastModified
            ]
        ];
    }, [
        partial,
        metadata.entityType,
        getLastModified
    ]);
    const getUrl = (partial)=>{
        if ((0, $l3paI.isSearchResultAssetsObjectSchema)(partial)) return partial.objectSchemaEntity.links.web;
        else if ((0, $l3paI.isSearchResultAssetsObjectType)(partial)) return partial.objectSchemaEntity.links.web;
        else return partial.objectEntity.links.web;
    };
    const getIcon = ()=>{
        if ((0, $l3paI.isSearchResultAssetsObjectSchema)(partial)) return (0, $2waBy.getAssetsEntityIcon)({
            iconUrl: null,
            type: partial.type,
            size: 'medium'
        });
        else if ((0, $l3paI.isSearchResultAssetsObjectType)(partial)) return (0, $2waBy.getAssetsEntityIcon)({
            iconUrl: partial.objectTypeEntity.icon.url48,
            type: partial.type,
            size: 'medium'
        });
        else if ((0, $l3paI.isSearchResultAssetsObject)(partial)) return (0, $2waBy.getAssetsEntityIcon)({
            iconUrl: partial.objectEntity.avatar.url48,
            type: partial.type,
            size: 'medium'
        });
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.AssetsIcon), {
            size: "medium"
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...partial,
        product: metadata.product,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: getUrl(partial),
        icon: getIcon(),
        title: enrichedTitle,
        headerMetadataParts: headerMetadataParts,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: enrichedDescription
        }),
        cloudId: cloudId,
        position: position,
        appMode: appMode,
        footer: /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$695e5a3ae2478b3), {
            linkedResults: partial.linkedResults || [],
            thirdPartyConfigs: thirdPartyConfigs,
            partial: partial,
            url: getUrl(partial),
            position: position,
            onResultClicked: onResultClicked,
            onResultContextMenu: onResultCtxMenuClicked
        })
    });
};

























var $icWhS = parcelRequire("icWhS");









parcelRequire("42omo");





var $5nBzc = parcelRequire("5nBzc");









const $b9d6f88287920668$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    for: {
        id: "search-page.atlas.for",
        defaultMessage: "for"
    }
});


const $f2f03c9fb6d1a105$var$lozengeStyleMapping = {
    onTrack: {
        default: {
            backgroundColor: `${"var(--ds-background-accent-green-subtle, #4BCE97)"}`,
            color: `${"var(--ds-text, #292A2E)"}`
        },
        withScore: {
            backgroundColor: `${"var(--ds-background-accent-lime-subtler, #D3F1A7)"}`,
            secondaryBackgroundColor: `${"var(--ds-background-accent-lime-subtle, #94C748)"}`,
            color: `${"var(--ds-text, #292A2E)"}`
        }
    },
    atRisk: {
        default: {
            backgroundColor: `${"var(--ds-background-accent-yellow-subtle, #EED12B)"}`,
            color: `${"var(--ds-text, #292A2E)"}`
        },
        withScore: {
            backgroundColor: `${"var(--ds-background-accent-yellow-subtler, #F5E989)"}`,
            secondaryBackgroundColor: `${"var(--ds-background-accent-yellow-subtle, #EED12B)"}`,
            color: `${"var(--ds-text, #292A2E)"}`
        }
    },
    offTrack: {
        default: {
            backgroundColor: `${"var(--ds-background-accent-red-subtle, #F87168)"}`,
            color: `${"var(--ds-text, #292A2E)"}`
        },
        withScore: {
            backgroundColor: `${"var(--ds-background-accent-red-subtle, #F87168)"}`,
            secondaryBackgroundColor: `${"var(--ds-border-accent-red, #E2483D)"}`,
            color: `${"var(--ds-text, #292A2E)"}`
        }
    },
    date: {
        default: {
            backgroundColor: `${"var(--ds-background-neutral-subtle, #00000000)"}`,
            color: `${"var(--ds-text, #292A2E)"}`
        }
    },
    default: {
        default: {
            backgroundColor: `${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
            color: `${"var(--ds-text, #292A2E)"}`
        },
        withScore: {
            backgroundColor: `${"var(--ds-background-neutral, #0515240F)"}`,
            secondaryBackgroundColor: `${"var(--ds-background-inverse-subtle, #00000029)"}`,
            color: `${"var(--ds-text, #292A2E)"}`
        }
    }
};
const $f2f03c9fb6d1a105$export$e9a2c2b0ecc25ba5 = (statusType, hasScore)=>{
    switch(statusType){
        case 'on_track':
            return hasScore ? $f2f03c9fb6d1a105$var$lozengeStyleMapping.onTrack.withScore : $f2f03c9fb6d1a105$var$lozengeStyleMapping.onTrack.default;
        case 'at_risk':
            return hasScore ? $f2f03c9fb6d1a105$var$lozengeStyleMapping.atRisk.withScore : $f2f03c9fb6d1a105$var$lozengeStyleMapping.atRisk.default;
        case 'off_track':
            return hasScore ? $f2f03c9fb6d1a105$var$lozengeStyleMapping.offTrack.withScore : $f2f03c9fb6d1a105$var$lozengeStyleMapping.offTrack.default;
        case 'date':
            return $f2f03c9fb6d1a105$var$lozengeStyleMapping.date.default;
        default:
            return hasScore ? $f2f03c9fb6d1a105$var$lozengeStyleMapping.default.withScore : $f2f03c9fb6d1a105$var$lozengeStyleMapping.default.default;
    }
};
const $f2f03c9fb6d1a105$var$statusAndScoreStyles = (0, $ecnYn.xcss)({
    display: 'inline-flex'
});
const $f2f03c9fb6d1a105$var$statusStyles = (0, $ecnYn.xcss)({
    position: 'relative',
    top: 'space.negative.025',
    left: 'space.050',
    clipPath: 'inset(0 6px 0 0)'
});
const $f2f03c9fb6d1a105$var$scoreStyles = (0, $ecnYn.xcss)({
    position: 'relative',
    top: 'space.negative.025',
    right: 'space.050',
    clipPath: 'inset(0 0 0 2px)'
});
const $f2f03c9fb6d1a105$var$statusAndDateContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.100'
});
const $f2f03c9fb6d1a105$var$vrStatusDateStyles = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtlest',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $f2f03c9fb6d1a105$export$689bde3f7e9a94ec = ({ statusValue: statusValue, statusLabel: statusLabel, statusScore: statusScore, date: date })=>{
    const hasScore = statusScore !== null;
    const { backgroundColor: backgroundColor, secondaryBackgroundColor: secondaryBackgroundColor, color: color } = $f2f03c9fb6d1a105$export$e9a2c2b0ecc25ba5(statusValue, hasScore);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $f2f03c9fb6d1a105$var$statusAndDateContainerStyles,
        children: [
            hasScore ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                xcss: $f2f03c9fb6d1a105$var$statusAndScoreStyles,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $f2f03c9fb6d1a105$var$statusStyles,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                            style: {
                                backgroundColor: backgroundColor,
                                color: color
                            },
                            isBold: true,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                paddingInlineEnd: "space.075",
                                children: statusLabel
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $f2f03c9fb6d1a105$var$scoreStyles,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                            style: {
                                backgroundColor: secondaryBackgroundColor,
                                color: color
                            },
                            isBold: true,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                paddingInlineStart: "space.025",
                                children: statusScore
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                    style: {
                        backgroundColor: backgroundColor,
                        color: color
                    },
                    isBold: true,
                    children: statusLabel
                })
            }),
            date && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $f2f03c9fb6d1a105$var$vrStatusDateStyles,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $b9d6f88287920668$export$defe85febe8b728c).for
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                        style: $f2f03c9fb6d1a105$export$e9a2c2b0ecc25ba5('date', false),
                        children: date
                    })
                ]
            })
        ]
    });
};












parcelRequire("42omo");





var $9Q2dU = parcelRequire("9Q2dU");










const $a5f8781bd2cf4516$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    restrictedTooltip: {
        id: "search-page.results.restricted-result-tooltip",
        defaultMessage: "Only visible to specific people"
    },
    privateTooltip: {
        id: "search-page.results.private-result-tooltip",
        defaultMessage: "Only visible to you"
    }
});


const $df2d84bd02793768$var$defaultIconColor = "var(--ds-icon, #292A2E)";
const $df2d84bd02793768$export$3aad690c5eb10b93 = 'restricted-lozenge';
const $df2d84bd02793768$export$fb0d481c8f77ba99 = ({ permissionLevel: permissionLevel, iconColour: iconColour })=>{
    if (!permissionLevel || permissionLevel === 'public') return null;
    const tooltipText = permissionLevel === 'private' ? (0, $a5f8781bd2cf4516$export$defe85febe8b728c).privateTooltip : (0, $a5f8781bd2cf4516$export$defe85febe8b728c).restrictedTooltip;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...tooltipText
        }),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            testId: $df2d84bd02793768$export$3aad690c5eb10b93,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
                label: "",
                color: iconColour ?? $df2d84bd02793768$var$defaultIconColor,
                size: "small"
            })
        })
    });
};



var $a7nUd = parcelRequire("a7nUd");




























const $8c293ab40c7a52a4$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    for: {
        id: "search-page.atlas.for",
        defaultMessage: "for"
    },
    'townsquare.api.goal-state.archived': {
        id: "townsquare.api.goal-state.archived",
        defaultMessage: "Archived"
    },
    'townsquare.api.goal-state.off-track': {
        id: "townsquare.api.goal-state.off-track",
        defaultMessage: "Off track"
    },
    'townsquare.api.goal-state.at-risk': {
        id: "townsquare.api.goal-state.at-risk",
        defaultMessage: "At risk"
    },
    'townsquare.api.goal-state.on-track': {
        id: "townsquare.api.goal-state.on-track",
        defaultMessage: "On track"
    },
    'townsquare.api.goal-state.pending': {
        id: "townsquare.api.goal-state.pending",
        defaultMessage: "Pending"
    },
    'townsquare.api.goal-state.paused': {
        id: "townsquare.api.goal-state.paused",
        defaultMessage: "Paused"
    },
    'townsquare.api.goal-state.completed': {
        id: "townsquare.api.goal-state.completed",
        defaultMessage: "Completed"
    },
    'townsquare.api.goal-state.cancelled': {
        id: "townsquare.api.goal-state.cancelled",
        defaultMessage: "Cancelled"
    }
});


const $5612c8f904dc5381$var$getKey = (partial)=>{
    if ((0, $7jIfa.isSearchResultAtlasProjectPartial)(partial)) return partial.project?.key;
    else if ((0, $7jIfa.isSearchResultAtlasGoalPartial)(partial)) return partial.goal?.key;
    else return null;
};
const $5612c8f904dc5381$var$getStatusAndDate = (partial)=>{
    let statusLabel = null;
    let statusValue;
    let statusScore = null;
    let date = null;
    if ((0, $7jIfa.isSearchResultAtlasProjectPartial)(partial)) {
        statusLabel = partial.project?.state?.label;
        statusValue = partial.project?.state?.value;
        date = partial.project?.dueDate?.label;
    } else if ((0, $7jIfa.isSearchResultAtlasGoalPartial)(partial)) {
        const messageKey = partial.goal?.status?.localizedLabel?.messageId;
        statusLabel = (0, $8c293ab40c7a52a4$export$defe85febe8b728c)[messageKey] ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $8c293ab40c7a52a4$export$defe85febe8b728c)[messageKey]
        }) : null;
        statusValue = partial.goal?.status?.value;
        statusScore = partial.goal?.status?.score ? partial.goal?.status?.score : null;
        date = partial.goal?.targetDate?.label;
    }
    if (!statusLabel || !statusValue) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $f2f03c9fb6d1a105$export$689bde3f7e9a94ec), {
        statusValue: statusValue,
        statusLabel: statusLabel,
        statusScore: statusScore,
        date: date
    });
};
const $5612c8f904dc5381$var$descriptionContainerStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    maxHeight: '60px'
});
const $5612c8f904dc5381$var$getDescription = (partial)=>{
    let description = '';
    if ((0, $7jIfa.isSearchResultAtlasGoalPartial)(partial) && partial.goal?.description) {
        const parsedDescrption = JSON.parse(partial.goal.description);
        // Recursive function to build the description. Traversal occurs in DFS
        // order. The base case is when the node is a text node, in which case
        // the text is appended to the description.
        const buildDescription = (goalDescription)=>{
            if (goalDescription.content) goalDescription.content.forEach(buildDescription);
            else if (goalDescription.type === 'text') description += goalDescription.text;
        };
        if (parsedDescrption.content) buildDescription(parsedDescrption);
    }
    return description;
};
const $5612c8f904dc5381$var$getExcerptDescription = (partial)=>{
    let description = '';
    if (((0, $7jIfa.isSearchResultAtlasGoalPartial)(partial) || (0, $7jIfa.isSearchResultAtlasProjectPartial)(partial)) && partial.description) description = partial.description;
    return description;
};
const $5612c8f904dc5381$var$isPrivateProject = (partial)=>{
    if ((0, $7jIfa.isSearchResultAtlasProjectPartial)(partial)) return partial.project?.isPrivate;
    return undefined;
};
const $5612c8f904dc5381$export$a97c0c8e95f01322 = ({ partial: partial, position: position })=>{
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [searchQuery] = (0, $djVCD.useSearchQuery)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const appMode = (0, $j4ply.useApplicationMode)();
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(partial.id);
        return {
            id: partial.id,
            containerId: null,
            spaceId: null,
            contentType: partial.type,
            entityType: partial.type,
            contentId: contentId,
            product: product
        };
    }, [
        partial.id,
        partial.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        const prefix = $5612c8f904dc5381$var$getKey(partial);
        if (prefix) return (0, $Y34Hw.enrichExcerpt)(prefix.concat('\u2002', partial.title));
        return (0, $Y34Hw.enrichExcerpt)(partial.title);
    }, [
        partial
    ]);
    const description = $5612c8f904dc5381$var$getDescription(partial);
    const excerptDescription = $5612c8f904dc5381$var$getExcerptDescription(partial);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        if (excerptDescription) return (0, $Y34Hw.enrichExcerpt)(excerptDescription);
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(description, searchQuery.split(' '));
        if (!highlightedTitle) return description;
        return (0, $Y34Hw.processExcerpt)(highlightedTitle);
    }, [
        description,
        excerptDescription,
        searchQuery
    ]);
    const url = (0, $42omo.useMemo)(()=>{
        return (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
            url: partial.url,
            searchSessionId: searchSessionId
        });
    }, [
        partial,
        searchSessionId
    ]);
    const titleMetadataParts = [
        [
            'is-private-project',
            $5612c8f904dc5381$var$isPrivateProject(partial) && /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
                permissionLevel: "restricted",
                iconColour: "var(--ds-icon-accent-red, #C9372C)"
            })
        ],
        [
            'status',
            $5612c8f904dc5381$var$getStatusAndDate(partial)
        ]
    ];
    const headerMetadataParts = [
        [
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                type: partial.type
            })
        ]
    ];
    let icon;
    if ((0, $dh538.fg)('rovo_search_confluence_icons_fps')) icon = (0, $2waBy.getAtlasEntityIcon)({
        iconUrl: partial.iconUrl,
        type: partial.type,
        size: 'medium'
    });
    else icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $aRSt4.ProductIcon), {
        product: (0, $1yEFx.ProductKeys).Atlas,
        label: "Atlas"
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...partial,
        product: (0, $1yEFx.ProductKeys).Atlas,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        icon: icon,
        headerMetadataParts: headerMetadataParts,
        titleMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $a7nUd.SearchMetadata), {
            parts: titleMetadataParts,
            displaySpacer: false
        }),
        title: enrichedTitle,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $5612c8f904dc5381$var$descriptionContainerStyles,
            testId: "search-page-atlas-result-description",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
                description: enrichedDescription
            })
        }),
        position: position,
        partial: partial,
        appMode: appMode
    });
};










































parcelRequire("42omo");




const $fcee77680d43964f$var$stateLozengePropsMap = {
    ACTIVE: {
        appearance: 'success'
    },
    ARCHIVED: {
        appearance: 'default'
    },
    PENDING: {
        appearance: 'default'
    }
};
const $fcee77680d43964f$export$e21059a573e71ec0 = ({ state: state })=>{
    if (!state) return null;
    const lozengeProps = {
        appearance: 'default',
        isBold: true,
        ...state ? $fcee77680d43964f$var$stateLozengePropsMap?.[state] : {}
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
        ...lozengeProps,
        children: state
    });
};
































const $5333d9ffec209597$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    tier: {
        id: "search-page.compass.tier",
        defaultMessage: "Tier {tier}"
    },
    ownerName: {
        id: "search-page.compass.owner-name",
        defaultMessage: "Owned by {ownerName}"
    }
});


const $9b8945bd21cb38d9$var$owningTeamStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '200px'
});
const $9b8945bd21cb38d9$export$cc23f5d092bb479f = ({ partial: partial, position: position })=>{
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const [{ cloudId: cloudId }] = (0, $j4ply.useBootstrap)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const isCompassTeamsLoading = (0, $djVCD.useIsCompassTeamsLoading)();
    const [searchQuery] = (0, $djVCD.useSearchQuery)();
    const appMode = (0, $j4ply.useApplicationMode)();
    const { id: id, title: title, url: url, tier: tier, component: component, lastModifiedDate: lastModifiedDate, type: type, ownerName: ownerName, description: description } = partial;
    const { state: state, description: componentDescription } = component || {};
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(id);
        return {
            id: id,
            containerId: null,
            spaceId: null,
            contentType: type,
            entityType: type,
            contentId: contentId,
            product: product
        };
    }, [
        id,
        type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const getLastModified = (0, $42omo.useMemo)(()=>{
        if (!lastModifiedDate) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
            lastModified: lastModifiedDate
        });
    }, [
        lastModifiedDate
    ]);
    const getComponentState = (0, $42omo.useMemo)(()=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $fcee77680d43964f$export$e21059a573e71ec0), {
            state: state
        });
    }, [
        state
    ]);
    const getTier = (0, $42omo.useMemo)(()=>{
        if (!tier) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
            appearance: 'default',
            children: formatMessage((0, $5333d9ffec209597$export$defe85febe8b728c).tier, {
                tier: tier
            })
        });
    }, [
        tier,
        formatMessage
    ]);
    const getOwnerName = (0, $42omo.useMemo)(()=>{
        if (ownerName) return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $9b8945bd21cb38d9$var$owningTeamStyles,
            children: formatMessage((0, $5333d9ffec209597$export$defe85febe8b728c).ownerName, {
                ownerName: ownerName
            })
        });
        if (isCompassTeamsLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $1hlFx.MetaDataItemSkeletonWide), {});
    }, [
        ownerName,
        formatMessage,
        isCompassTeamsLoading
    ]);
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        return (0, $Y34Hw.enrichExcerpt)(title);
    }, [
        title
    ]);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        if (description) return (0, $Y34Hw.processExcerpt)(description);
        const reducedDescription = (0, $bOpS4.truncateTextWithQuery)(componentDescription, searchQuery);
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(reducedDescription, searchQuery.split(' '));
        if (!highlightedTitle) return reducedDescription;
        return (0, $Y34Hw.processExcerpt)(highlightedTitle);
    }, [
        componentDescription,
        description,
        searchQuery
    ]);
    const headerMetadataParts = [
        [
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                type: type
            })
        ],
        [
            'ownerName',
            getOwnerName
        ],
        [
            'lastModified',
            getLastModified
        ]
    ];
    const titleMetadataParts = [
        [
            'componentState',
            getComponentState
        ],
        [
            'tier',
            getTier
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...partial,
        product: (0, $1yEFx.ProductKeys).Compass,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.CompassIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        title: enrichedTitle,
        headerMetadataParts: headerMetadataParts,
        titleMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $a7nUd.SearchMetadata), {
            parts: titleMetadataParts,
            displaySpacer: false
        }),
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: enrichedDescription
        }),
        cloudId: cloudId,
        position: position,
        appMode: appMode
    });
};



























var $cVtio = parcelRequire("cVtio");


var $4Zqgi = parcelRequire("4Zqgi");

const $aeeeab3e75e5afd4$export$7a0403e8f12fc1bc = (props)=>{
    const { starter: starterText, isSummarize: isSummarize, isShowMore: isShowMore, isShowLess: isShowLess } = props.starter;
    try {
        return {
            action: 'clicked',
            actionSubject: 'aiConvoStarter',
            eventType: 'ui',
            attributes: {
                ...props.analyticsAttributes,
                starterIndex: props.starterIndex,
                isSummarize: isSummarize,
                isShowMore: isShowMore,
                isShowLess: isShowLess
            },
            nonPrivacySafeAttributes: {
                starter: starterText
            }
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onConversationStarterClick'
        });
        return {};
    }
};
const $aeeeab3e75e5afd4$export$d163ffe93667d9e7 = (props)=>{
    try {
        return {
            action: 'shown',
            actionSubject: 'aiConvoStarters',
            eventType: 'track',
            attributes: {
                ...props.analyticsAttributes,
                startersCount: props.starters.length
            },
            nonPrivacySafeAttributes: {
                starters: props.starters
            }
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onConvoStarterShown'
        });
        return {};
    }
};
const $aeeeab3e75e5afd4$export$b93b2183babcd11e = (props)=>{
    try {
        return {
            action: 'failed',
            actionSubject: 'aiConvoStarters',
            eventType: 'track',
            attributes: {
                ...props.analyticsAttributes,
                error: props.error
            }
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onConvoStartersFailed'
        });
        return {};
    }
};




















var $2AytZ = parcelRequire("2AytZ");


var $cOQz3 = parcelRequire("cOQz3");







var $i25hX = parcelRequire("i25hX");

const $719cb442948fe6b0$var$messages = {
    summarize: {
        id: 'search-ai.conversation-starters.summarize',
        defaultMessage: 'Summarize',
        description: 'Button text for AI summarize action'
    },
    showLess: {
        id: 'search-ai.conversation-starters.show-less',
        defaultMessage: 'Show less',
        description: 'Button text for showing less conversation starters'
    },
    showMore: {
        id: 'search-ai.conversation-starters.show-more',
        defaultMessage: 'Show more',
        description: 'Button text for showing more conversation starters'
    }
};
const $719cb442948fe6b0$export$ea338c37011da44c = ({ conversationStarters: conversationStarters, onConversationStarterClick: onConversationStarterClick, url: url })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const [showMore, setShowMore] = (0, $42omo.useState)(false);
    const handleConversationStarterClick = (0, $42omo.useCallback)((starter, index)=>{
        publish({
            type: 'browser-context-payload',
            source: 'search-result',
            data: {
                context: {
                    browserUrl: url
                }
            }
        });
        publish({
            type: 'chat-new',
            source: 'search-result',
            data: {
                name: starter.starter,
                prompt: `${starter.starter} ${url}`,
                dialogues: []
            }
        });
        onConversationStarterClick(starter, index);
    }, [
        publish,
        onConversationStarterClick,
        url
    ]);
    const handleShowMoreClick = (0, $42omo.useCallback)(()=>{
        setShowMore((s)=>!s);
        const analyticsPayload = {
            starter: '',
            // Empty since this isn't a real conversation starter
            [showMore ? 'isShowLess' : 'isShowMore']: true
        };
        onConversationStarterClick(analyticsPayload, -1);
    }, [
        showMore,
        onConversationStarterClick
    ]);
    const summarizeText = formatMessage($719cb442948fe6b0$var$messages.summarize);
    // Create array with summarize button first, then conversation starters
    const allItems = [
        {
            starter: summarizeText,
            isSummarize: true,
            originalIndex: 0
        },
        ...conversationStarters.map((starter, index)=>({
                ...starter,
                isSummarize: false,
                originalIndex: index + 1
            }))
    ];
    const visibleItems = allItems.slice(0, 2);
    const shouldShowExpandButton = allItems.length > 2;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "start",
        shouldWrap: true,
        children: [
            (showMore ? allItems : visibleItems).map((item)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($cOQz3))),
                        onClick: ()=>{
                            const analyticsPayload = {
                                starter: item.starter,
                                isSummarize: item.isSummarize || false
                            };
                            handleConversationStarterClick(analyticsPayload, item.originalIndex);
                        },
                        children: item.starter
                    })
                }, item.starter)),
            shouldShowExpandButton && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    onClick: handleShowMoreClick,
                    icon: showMore ? (0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))) : (0, (/*@__PURE__*/$parcel$interopDefault($ghftu))),
                    label: showMore ? formatMessage($719cb442948fe6b0$var$messages.showLess) : formatMessage($719cb442948fe6b0$var$messages.showMore)
                })
            })
        ]
    });
};


const $383edc9b6c74463d$export$3ea53827ed349b2e = (locale)=>{
    const lowerCaseLocale = locale.toLowerCase();
    // English locale or starts with 'en-', `en-US`, `en-GB`, etc.
    return lowerCaseLocale === 'en' || lowerCaseLocale.startsWith('en-');
};
const $383edc9b6c74463d$var$getConversationStarters = async ({ ari: ari, product: product, cloudId: cloudId })=>{
    const requestBody = {
        ai_feature_input: {
            documents: [
                {
                    ari: ari
                }
            ]
        }
    };
    const response = await fetch('/gateway/api/assist/api/ai/v2/ai-feature/convo-starters', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Experience-Id': 'convo-starter-for-search',
            'X-Product': product,
            'X-Cloudid': cloudId
        },
        body: JSON.stringify(requestBody)
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    return await response.json();
};
const $383edc9b6c74463d$export$89b2b22a9acd6d75 = ({ primaryProduct: primaryProduct, cloudId: cloudId, searchResult: searchResult, analyticsAttributes: analyticsAttributes })=>{
    const [{ conversationStarters: conversationStarters, loading: loading }, setConversationStarters] = (0, $42omo.useState)(()=>{
        return {
            conversationStarters: [],
            loading: false
        };
    });
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const memoizedAnalyticsAttributes = (0, $42omo.useMemo)(()=>analyticsAttributes, [
        analyticsAttributes
    ]);
    const handleConversationStarterClick = (0, $42omo.useCallback)((starter, index)=>{
        fireAnalyticsEvent((0, $aeeeab3e75e5afd4$export$7a0403e8f12fc1bc)({
            starter: starter,
            analyticsAttributes: memoizedAnalyticsAttributes,
            starterIndex: index
        }));
    }, [
        fireAnalyticsEvent,
        memoizedAnalyticsAttributes
    ]);
    const handleConversationStartersShown = (0, $42omo.useCallback)((starters)=>{
        const startersWithSummarize = [
            'Summarize',
            ...starters
        ];
        fireAnalyticsEvent((0, $aeeeab3e75e5afd4$export$d163ffe93667d9e7)({
            starters: startersWithSummarize,
            analyticsAttributes: memoizedAnalyticsAttributes
        }));
    }, [
        fireAnalyticsEvent,
        memoizedAnalyticsAttributes
    ]);
    const handleConversationStartersFailed = (0, $42omo.useCallback)((error)=>{
        fireAnalyticsEvent((0, $aeeeab3e75e5afd4$export$b93b2183babcd11e)({
            analyticsAttributes: memoizedAnalyticsAttributes,
            error: error.message
        }));
    }, [
        fireAnalyticsEvent,
        memoizedAnalyticsAttributes
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!searchResult?.ari || conversationStarters.length > 0 || loading) return;
        setConversationStarters((prevState)=>({
                ...prevState,
                loading: true
            }));
        $383edc9b6c74463d$var$getConversationStarters({
            ari: searchResult.ari,
            product: primaryProduct ?? '',
            cloudId: cloudId ?? ''
        }).then((response)=>{
            setConversationStarters({
                conversationStarters: response.ai_feature_output?.results[0]?.convo_starters || [],
                loading: false
            });
            handleConversationStartersShown(response.ai_feature_output?.results[0]?.convo_starters.map((starter)=>starter.starter) || []);
        }).catch((error)=>{
            setConversationStarters({
                conversationStarters: [],
                loading: false
            });
            handleConversationStartersFailed(error);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $719cb442948fe6b0$export$ea338c37011da44c), {
            conversationStarters: conversationStarters || [],
            onConversationStarterClick: handleConversationStarterClick,
            url: searchResult.url
        })
    });
};
const $383edc9b6c74463d$export$10e76ebde8d3ea11 = ({ primaryProduct: primaryProduct, cloudId: cloudId, searchResult: searchResult, analyticsAttributes: analyticsAttributes })=>{
    const { locale: locale } = (0, $8C5kA.default)();
    if (!$383edc9b6c74463d$export$3ea53827ed349b2e(locale)) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)($383edc9b6c74463d$export$89b2b22a9acd6d75, {
        primaryProduct: primaryProduct,
        cloudId: cloudId,
        searchResult: searchResult,
        analyticsAttributes: analyticsAttributes
    });
};



var $eUEtI = parcelRequire("eUEtI");




















parcelRequire("42omo");





var $1yB28 = parcelRequire("1yB28");









const $f71581c8beb50ce0$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    commentIconLabel: {
        id: "search-page.comment-icon-label",
        defaultMessage: "Comment"
    }
});


const $8ca12d73b6c4215d$export$f4c1466e6fdd07b = ({ numberOfComments: numberOfComments })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
        space: "space.050",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                label: formatMessage((0, $f71581c8beb50ce0$export$a7357cdd1f0b0168).commentIconLabel)
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                size: "small",
                color: "color.text.subtlest",
                children: numberOfComments
            })
        ]
    });
};
const $8ca12d73b6c4215d$export$e03b3a8fca9c958d = (numberOfComments)=>{
    if (!numberOfComments || numberOfComments === 0) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)($8ca12d73b6c4215d$export$f4c1466e6fdd07b, {
        numberOfComments: numberOfComments
    });
};





parcelRequire("42omo");







var $1XDdH = parcelRequire("1XDdH");




parcelRequire("42omo");






const $5dbea7e9699c6e46$var$styles = (0, $ecnYn.xcss)({
    display: 'inline-block',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtlest',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
});
const $5dbea7e9699c6e46$var$SearchMetadataGeneric = ({ label: label })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $5dbea7e9699c6e46$var$styles,
        children: label
    });
};
var $5dbea7e9699c6e46$export$2e2bcd8739ae039 = $5dbea7e9699c6e46$var$SearchMetadataGeneric;





parcelRequire("42omo");


var $fpGTa = parcelRequire("fpGTa");



const $655681e89d0ffd52$var$anchorStyles = (0, $ecnYn.xcss)({
    display: 'inline-block',
    overflow: 'hidden',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtlest',
    textDecoration: 'none',
    ':hover': {
        color: 'color.text.subtlest'
    },
    ':visited': {
        color: 'color.text.subtlest'
    },
    ':focus': {
        color: 'color.text.subtlest'
    },
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
const $655681e89d0ffd52$var$SearchMetadataLink = ({ label: label, href: href })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
        href: href,
        xcss: $655681e89d0ffd52$var$anchorStyles,
        testId: "search-page-result-metadata-link",
        children: label
    });
};
var $655681e89d0ffd52$export$2e2bcd8739ae039 = $655681e89d0ffd52$var$SearchMetadataLink;


const $e6acefe6e798f052$var$breadcrumbsContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    height: 'size.100',
    maxWidth: '246px'
});
const $e6acefe6e798f052$export$9138e703d4b4585b = ({ url: url, name: name, webUiLink: webUiLink })=>{
    const baseUrl = url && (0, $1XDdH.getBaseUrl)(url);
    const href = `${baseUrl}/wiki${webUiLink}`;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
        xcss: $e6acefe6e798f052$var$breadcrumbsContainerStyles,
        children: href ? /*#__PURE__*/ (0, $l998X.jsx)((0, $655681e89d0ffd52$export$2e2bcd8739ae039), {
            label: name,
            href: `${baseUrl}/wiki${webUiLink}`
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $5dbea7e9699c6e46$export$2e2bcd8739ae039), {
            label: name
        })
    });
};










parcelRequire("42omo");









parcelRequire("42omo");

const $b79e8443c320d4b1$export$db3737f3b54fe9a0 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M15.536 7.96266C15.536 7.7391 15.4827 7.52932 15.3933 7.33866C14.7973 5.41599 12.0071 5.55643 8.03823 5.46266C7.37468 5.4471 7.75423 4.66355 7.98712 2.94355C8.13868 1.82488 7.41734 0.107101 6.2049 0.107101C4.20579 0.107101 6.1289 1.68399 4.36134 5.58355C3.4169 7.6671 1.30579 6.49999 1.30579 8.59288V13.3569C1.30579 14.1715 1.38579 14.9547 2.53156 15.0835C3.64223 15.2084 3.39245 16 4.99468 16H13.0142C13.8311 16 14.4956 15.3351 14.4956 14.5182C14.4956 14.1795 14.3769 13.8711 14.1853 13.6213C14.6387 13.3675 14.9498 12.8884 14.9498 12.3329C14.9498 11.9951 14.8316 11.6867 14.6405 11.4373C15.0951 11.184 15.4071 10.7044 15.4071 10.148C15.4071 9.74399 15.2436 9.37777 14.98 9.10977C15.3165 8.83821 15.536 8.42755 15.536 7.96266Z",
                fill: "#FFDB5E"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M10.2311 9.44401H14.0551C14.5751 9.44401 15.0631 9.16578 15.3289 8.71823C15.4382 8.53378 15.3773 8.29512 15.1925 8.18534C15.008 8.07556 14.7693 8.13734 14.6596 8.32178C14.5338 8.53467 14.3013 8.66623 14.0547 8.66623H10.1391C9.75113 8.66623 9.43557 8.35067 9.43557 7.96267C9.43557 7.57467 9.75113 7.25912 10.1391 7.25912H12.7556C12.9702 7.25912 13.1445 7.08489 13.1445 6.87023C13.1445 6.65556 12.9702 6.48134 12.7556 6.48134H10.1387C9.32179 6.48134 8.65735 7.14578 8.65735 7.96267C8.65735 8.41823 8.86846 8.82134 9.1929 9.09334C8.91957 9.36223 8.74935 9.73556 8.74935 10.148C8.74935 10.6049 8.96179 11.0093 9.28802 11.2809C9.01646 11.5493 8.84802 11.9213 8.84802 12.3329C8.84802 12.8307 9.09646 13.2698 9.47424 13.5387C9.24135 13.8004 9.09557 14.1413 9.09557 14.5182C9.09557 15.3351 9.76002 15.9996 10.5769 15.9996H13.0142C13.5342 15.9996 14.0227 15.7218 14.2885 15.2742C14.3982 15.0898 14.3373 14.8511 14.1529 14.7413C13.968 14.6325 13.7293 14.6924 13.62 14.8769C13.4933 15.0898 13.2609 15.2218 13.0142 15.2218H10.5769C10.1889 15.2218 9.87335 14.9062 9.87335 14.5182C9.87335 14.1302 10.1889 13.8147 10.5769 13.8147H13.4685C13.9885 13.8147 14.4773 13.5365 14.7427 13.0889C14.8525 12.904 14.7916 12.6653 14.6071 12.556C14.4209 12.4444 14.1831 12.5071 14.0742 12.6916C13.9458 12.908 13.7191 13.0369 13.4685 13.0369H10.3293C9.94135 13.0369 9.62579 12.7209 9.62579 12.3329C9.62579 11.9449 9.94135 11.6293 10.3293 11.6293H13.9253C14.4453 11.6293 14.9338 11.3516 15.1996 10.904C15.3093 10.7196 15.2485 10.4809 15.064 10.3711C14.8787 10.2618 14.6405 10.3222 14.5311 10.5067C14.4027 10.7227 14.176 10.8516 13.9253 10.8516H10.2311C9.84313 10.8516 9.52757 10.536 9.52757 10.148C9.52757 9.76001 9.84268 9.44401 10.2311 9.44401Z",
                fill: "#EE9547"
            })
        ]
    });


const $f70284887e2e1865$export$1bd444ba34dbd512 = ({ numberOfLikes: numberOfLikes })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
        space: "space.050",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $b79e8443c320d4b1$export$db3737f3b54fe9a0), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                size: "small",
                color: "color.text.subtlest",
                children: numberOfLikes
            })
        ]
    });
const $f70284887e2e1865$export$b52fa2ff0823604f = (numberOfLikes)=>{
    if (!numberOfLikes || numberOfLikes === 0) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)($f70284887e2e1865$export$1bd444ba34dbd512, {
        numberOfLikes: numberOfLikes
    });
};















parcelRequire("42omo");

const $567e21a7779a7988$var$messages = {
    'ari:cloud:confluence::site/a436116f-02ce-4520-8fbb-7301462a1674': 'Hello',
    'ari:cloud:confluence::site/DUMMY-158c8204-ff3b-47c2-adbb-a0906ccc722b': 'Product Fabric',
    'ari:cloud:confluence::site/4d7f3154-1d7b-4a16-b859-f1904a19b11f': 'Security Team',
    'ari:cloud:confluence::site/12e73ff5-8b07-4b31-be8e-67ee0666fc43': 'Software Teams'
};
const $567e21a7779a7988$export$68c7835f320e80a5 = ({ cloudARI: cloudARI })=>{
    const siteId = cloudARI.split(':')[3];
    const messageKey = `ari:cloud:confluence::site/${siteId}`;
    const message = $567e21a7779a7988$var$messages[messageKey];
    if (!message) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: message
    });
};






























var $7p4As = parcelRequire("7p4As");





var $1Zr9M = parcelRequire("1Zr9M");


var $ldfch = parcelRequire("ldfch");


var $9M4aB = parcelRequire("9M4aB");








/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 













/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 








const $034f80c7bef66068$var$textColor = "var(--ds-text, #292A2E)";
const $034f80c7bef66068$var$initialsAvatarColor = "var(--ds-background-neutral, #0515240F)"; /** Shown when name is empty or whitespace-only (External Person) */ 
const $034f80c7bef66068$var$DEFAULT_INITIALS = 'EP';
const $034f80c7bef66068$var$initialsCss = null;
const $034f80c7bef66068$export$8f045b5892495218 = ({ name: name })=>{
    const initials = (0, $42omo.useMemo)(()=>$034f80c7bef66068$var$getInitials(name), [
        name
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        className: (0, $gMc0m.default)([
            "_1bsb1osq _4t3i1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "10",
                cy: "10",
                r: "10",
                fill: $034f80c7bef66068$var$initialsAvatarColor
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("text", {
                x: "50%",
                y: "55%",
                fontFamily: "SF Pro Text, sans-serif",
                dominantBaseline: "middle",
                textAnchor: "middle",
                fontSize: "11",
                fontWeight: "400",
                fill: $034f80c7bef66068$var$textColor,
                children: initials
            })
        ]
    });
};
function $034f80c7bef66068$var$getInitials(name) {
    const trimmed = name.trim();
    if (!trimmed) return $034f80c7bef66068$var$DEFAULT_INITIALS;
    const names = trimmed.split(/\s+/).filter(Boolean);
    const lastName = names.length > 1 ? names[names.length - 1] : '';
    const firstInitial = names[0][0].toUpperCase();
    const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : '';
    return firstInitial + lastInitial;
}


const $e0a3a41d6257d9b3$var$initialsAvatarCSS = (0, $ecnYn.xcss)({
    alignItems: 'center',
    display: 'flex'
});
const $e0a3a41d6257d9b3$var$profilePicAvatarCSS = (0, $ecnYn.xcss)({
    alignItems: 'center',
    display: 'flex',
    borderRadius: 'radius.full',
    overflow: 'hidden'
});
const $e0a3a41d6257d9b3$var$profilePicXcss = null; /** Adapted from @atlaskit/avatar */ 
const $e0a3a41d6257d9b3$var$AVATAR_SIZES = {
    xsmall: (0, $ecnYn.xcss)({
        width: "var(--ds-space-200, 16px)",
        height: "var(--ds-space-200, 16px)"
    }),
    // custom smaller size of 20px
    smaller: (0, $ecnYn.xcss)({
        width: "var(--ds-space-250, 20px)",
        height: "var(--ds-space-250, 20px)"
    }),
    small: (0, $ecnYn.xcss)({
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)"
    }),
    medium: (0, $ecnYn.xcss)({
        width: "var(--ds-space-400, 32px)",
        height: "var(--ds-space-400, 32px)"
    }),
    large: (0, $ecnYn.xcss)({
        width: "var(--ds-space-500, 40px)",
        height: "var(--ds-space-500, 40px)"
    }),
    xlarge: (0, $ecnYn.xcss)({
        width: `calc(${"var(--ds-space-600, 48px)"} * 2)`,
        height: `calc(${"var(--ds-space-600, 48px)"} * 2)`
    }),
    xxlarge: (0, $ecnYn.xcss)({
        width: `calc(${"var(--ds-space-800, 64px)"} * 2)`,
        height: `calc(${"var(--ds-space-800, 64px)"} * 2)`
    })
};
const $e0a3a41d6257d9b3$export$e2255cf6045e8d47 = ({ variant: variant, size: size = 'medium' })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $42omo.useState)(false);
    if (variant.type === 'profile-pic' && !hasImageErrored) {
        const { src: src } = variant;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            "aria-hidden": true,
            testId: "search-ui-avatar",
            xcss: [
                $e0a3a41d6257d9b3$var$profilePicAvatarCSS,
                $e0a3a41d6257d9b3$var$AVATAR_SIZES[size]
            ],
            children: /*#__PURE__*/ (0, $l998X.jsx)("img", {
                src: src,
                onError: ()=>setHasImageErrored(true),
                className: (0, $gMc0m.default)([
                    "_1bsb1osq _4t3i1osq"
                ])
            })
        });
    }
    const { name: name } = variant;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        "aria-hidden": true,
        testId: "search-ui-avatar",
        xcss: [
            $e0a3a41d6257d9b3$var$initialsAvatarCSS,
            $e0a3a41d6257d9b3$var$AVATAR_SIZES[size]
        ],
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $034f80c7bef66068$export$8f045b5892495218), {
            name: name
        })
    });
};





parcelRequire("42omo");





var $dE1p6 = parcelRequire("dE1p6");




parcelRequire("42omo");

const $d5bc004e7a8c7c68$export$8f6c6f317abe37f6 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0_259_44146)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M13.7812 10H18.2369C18.6578 10 18.9991 10.3403 18.9991 10.76V14.8068C18.9991 16.3494 17.7449 17.6 16.1978 17.6H16.1845C14.6374 17.6002 13.383 16.3498 13.3828 14.8072C13.3828 14.8071 13.3828 14.8069 13.3828 14.8068V10.3972C13.3828 10.1778 13.5612 10 13.7812 10Z",
                        fill: "#5059C9"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M16.7935 9.19961C17.7905 9.19961 18.5987 8.39372 18.5987 7.39961C18.5987 6.4055 17.7905 5.59961 16.7935 5.59961C15.7965 5.59961 14.9883 6.4055 14.9883 7.39961C14.9883 8.39372 15.7965 9.19961 16.7935 9.19961Z",
                        fill: "#5059C9"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M11.1779 9.20001C12.618 9.20001 13.7854 8.03594 13.7854 6.6C13.7854 5.16406 12.618 4 11.1779 4C9.73776 4 8.57031 5.16406 8.57031 6.6C8.57031 8.03594 9.73776 9.20001 11.1779 9.20001Z",
                        fill: "#7B83EB"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M14.654 10H7.29908C6.88313 10.0103 6.5541 10.3545 6.56375 10.7692V15.3848C6.50566 17.8737 8.48048 19.9391 10.9765 20C13.4726 19.9391 15.4474 17.8737 15.3893 15.3848V10.7692C15.399 10.3545 15.0699 10.0103 14.654 10Z",
                        fill: "#7B83EB"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.1",
                        d: "M11.3767 10V16.468C11.3747 16.7646 11.1944 17.0311 10.9193 17.144C10.8318 17.1809 10.7376 17.2 10.6425 17.2H6.91574C6.86359 17.068 6.81545 16.936 6.77533 16.8C6.6349 16.341 6.56325 15.8639 6.56271 15.384V10.768C6.55306 10.3539 6.88156 10.0103 7.29683 10H11.3767Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M10.9755 10V16.868C10.9755 16.9628 10.9564 17.0567 10.9193 17.144C10.8061 17.4183 10.5388 17.598 10.2414 17.6H7.10428C7.03608 17.468 6.9719 17.336 6.91574 17.2C6.85957 17.064 6.81545 16.936 6.77533 16.8C6.6349 16.341 6.56325 15.8639 6.56271 15.384V10.768C6.55306 10.3539 6.88156 10.0103 7.29683 10H10.9755Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M10.9755 10V16.068C10.9724 16.471 10.6456 16.797 10.2414 16.8H6.77533C6.6349 16.341 6.56325 15.8639 6.56271 15.384V10.768C6.55306 10.3539 6.88156 10.0103 7.29683 10H10.9755Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M10.5743 10V16.068C10.5713 16.471 10.2444 16.797 9.8402 16.8H6.77533C6.6349 16.341 6.56325 15.8639 6.56271 15.384V10.768C6.55306 10.3539 6.88156 10.0103 7.29683 10H10.5743Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.1",
                        d: "M11.3766 7.93219V9.19219C11.3084 9.19619 11.2442 9.20019 11.176 9.20019C11.1078 9.20019 11.0436 9.19619 10.9754 9.19219C10.84 9.18323 10.7057 9.16181 10.5742 9.12819C9.76187 8.93637 9.09074 8.3683 8.769 7.60019C8.71364 7.4712 8.67066 7.33727 8.64062 7.2002H10.6424C11.0472 7.20172 11.375 7.52855 11.3766 7.93219Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M10.9759 8.3316V9.1916C10.8405 9.18264 10.7062 9.16122 10.5748 9.12761C9.76241 8.93578 9.09127 8.36772 8.76953 7.59961H10.2418C10.6466 7.60114 10.9744 7.92797 10.9759 8.3316Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M10.9759 8.3316V9.1916C10.8405 9.18264 10.7062 9.16122 10.5748 9.12761C9.76241 8.93578 9.09127 8.36772 8.76953 7.59961H10.2418C10.6466 7.60114 10.9744 7.92797 10.9759 8.3316Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M10.5748 8.33161V9.12761C9.76241 8.93578 9.09127 8.36772 8.76953 7.59961H9.84064C10.2454 7.60115 10.5732 7.92798 10.5748 8.33161Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M2.48533 7.59961H9.84024C10.2464 7.59961 10.5756 7.92788 10.5756 8.33281V15.6664C10.5756 16.0713 10.2464 16.3996 9.84024 16.3996H2.48533C2.07921 16.3996 1.75 16.0713 1.75 15.6664V8.33281C1.75 7.92788 2.07922 7.59961 2.48533 7.59961Z",
                        fill: "url(#paint0_linear_259_44146)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M8.09698 10.3916H6.62671V14.3836H5.69V10.3916H4.22656V9.61719H8.09698V10.3916Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint0_linear_259_44146",
                        x1: "3.28318",
                        y1: "7.0267",
                        x2: "9.01736",
                        y2: "16.9869",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "#5A62C3"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.5",
                                stopColor: "#4D55BD"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "#3940AB"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                        id: "clip0_259_44146",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            width: "17.25",
                            height: "16",
                            fill: "white",
                            transform: "translate(1.75 4)"
                        })
                    })
                ]
            })
        ]
    });





parcelRequire("42omo");

const $d15e8e694a23f0d0$export$b33fb54b08bb6422 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.86632 4C8.98186 4.00065 8.26606 4.71698 8.26671 5.59967C8.26606 6.48236 8.98251 7.19869 9.86697 7.19935H11.4672V5.60033C11.4679 4.71763 10.7514 4.0013 9.86632 4C9.86697 4 9.86697 4 9.86632 4V4ZM9.86632 8.26667H5.60026C4.7158 8.26732 3.99935 8.98365 4 9.86634C3.99869 10.749 4.71515 11.4654 5.59961 11.4667H9.86632C10.7508 11.466 11.4672 10.7497 11.4666 9.86699C11.4672 8.98365 10.7508 8.26732 9.86632 8.26667Z",
                fill: "#36C5F0"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.9999 9.86634C20.0005 8.98365 19.2841 8.26732 18.3996 8.26667C17.5151 8.26732 16.7987 8.98365 16.7993 9.86634V11.4667H18.3996C19.2841 11.466 20.0005 10.7497 19.9999 9.86634ZM15.7331 9.86634V5.59967C15.7338 4.71763 15.018 4.0013 14.1335 4C13.2491 4.00065 12.5326 4.71698 12.5333 5.59967V9.86634C12.532 10.749 13.2484 11.4654 14.1329 11.4667C15.0173 11.466 15.7338 10.7497 15.7331 9.86634Z",
                fill: "#2EB67D"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.133 19.9998C15.0174 19.9992 15.7339 19.2828 15.7333 18.4001C15.7339 17.5174 15.0174 16.8011 14.133 16.8005H12.5327V18.4001C12.5321 19.2822 13.2485 19.9985 14.133 19.9998ZM14.133 15.7325H18.3997C19.2842 15.7318 20.0006 15.0155 20 14.1328C20.0013 13.2501 19.2848 12.5338 18.4004 12.5325H14.1336C13.2492 12.5331 12.5327 13.2495 12.5334 14.1322C12.5327 15.0155 13.2485 15.7318 14.133 15.7325Z",
                fill: "#ECB22E"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.00012 14.1335C3.99947 15.0162 4.71593 15.7325 5.60039 15.7332C6.48485 15.7325 7.2013 15.0162 7.20065 14.1335V12.5338H5.60039C4.71593 12.5345 3.99947 13.2508 4.00012 14.1335ZM8.26684 14.1335V18.4002C8.26553 19.2829 8.98199 19.9992 9.86645 20.0005C10.7509 19.9999 11.4674 19.2835 11.4667 18.4008V14.1348C11.468 13.2521 10.7516 12.5358 9.86711 12.5345C8.98199 12.5345 8.26619 13.2508 8.26684 14.1335C8.26684 14.1341 8.26684 14.1335 8.26684 14.1335Z",
                fill: "#E01E5A"
            })
        ]
    });





const $ccffef27afc66230$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    openDmButtonLabel: {
        id: "search-page.social-signals.user-card.open-dm-button-label",
        defaultMessage: "Direct message"
    }
});


const $8ba86ca7710e8cf5$export$628b037ae7bb4a39 = ({ integrationInfo: integrationInfo })=>{
    const { integration: integration, openDmUrl: openDmUrl } = integrationInfo;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dE1p6.default), {
        target: "_blank",
        rel: "noopener noreferrer",
        href: openDmUrl,
        icon: integration === 'ms-teams' ? (0, $d5bc004e7a8c7c68$export$8f6c6f317abe37f6) : (0, $d15e8e694a23f0d0$export$b33fb54b08bb6422),
        label: formatMessage((0, $ccffef27afc66230$export$defe85febe8b728c).openDmButtonLabel),
        isTooltipDisabled: false
    });
};





const $0a5741db56043cfe$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    viewProfile: {
        id: "search-page.social-signals.user-card.view-profile",
        defaultMessage: "View profile"
    },
    emailButtonLabel: {
        id: "search-page.social-signals.user-card.email-button-label",
        defaultMessage: "Copy email address"
    }
});
const $0a5741db56043cfe$export$6bab030fe17f656d = (0, $cgtv4.defineMessages)({
    share: {
        id: "search-page.social-signals.user-card.shared-time-unit-ago-by",
        defaultMessage: "Shared {relativeDate} by"
    },
    comment: {
        id: "search-page.social-signals.user-card.commented-time-unit-ago-by",
        defaultMessage: "Commented {relativeDate} by"
    },
    edit: {
        id: "search-page.social-signals.user-card.edited-time-unit-ago-by",
        defaultMessage: "Edited {relativeDate} by"
    }
});


const $168e8abba0f0ce48$var$cardXcss = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface.raised',
    borderRadius: "var(--ds-radius-large, 8px)",
    padding: 'space.200',
    minWidth: '214px',
    width: 'fit-content'
});
const $168e8abba0f0ce48$var$headerXcss = (0, $ecnYn.xcss)({
    font: 'font.body.UNSAFE_small',
    fontWeight: 'font.weight.semibold'
});
const $168e8abba0f0ce48$var$userNameXcss = (0, $ecnYn.xcss)({
    font: 'font.body.large',
    fontWeight: 'font.weight.semibold',
    textAlign: 'center',
    maxWidth: '214px',
    overflowWrap: 'break-word'
});
const $168e8abba0f0ce48$var$userSubheadingXcss = (0, $ecnYn.xcss)({
    font: 'font.body',
    textAlign: 'center',
    maxWidth: '214px',
    overflowWrap: 'break-word'
});
const $168e8abba0f0ce48$export$4c094c8f61edecb4 = ({ signalDate: signalDate, signalType: signalType, user: user, onCopyEmail: onCopyEmail, externalMessageIntegration: externalMessageIntegration })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
        direction: "column",
        alignItems: "center",
        gap: "space.200",
        xcss: $168e8abba0f0ce48$var$cardXcss,
        testId: "search-person-card",
        children: [
            signalDate && signalType && /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
                xcss: $168e8abba0f0ce48$var$headerXcss,
                alignItems: "center",
                gap: "space.075",
                children: /*#__PURE__*/ (0, $l998X.jsx)($168e8abba0f0ce48$export$4a6f3cfec60dc525, {
                    signalDate: signalDate,
                    signalType: signalType
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e0a3a41d6257d9b3$export$e2255cf6045e8d47), {
                    variant: user.profilePicUrl ? {
                        type: 'profile-pic',
                        src: user.profilePicUrl,
                        name: user.name
                    } : {
                        type: 'initials',
                        name: user.name
                    },
                    size: "xlarge"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                direction: "column",
                alignItems: "center",
                gap: "space.100",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $168e8abba0f0ce48$var$userNameXcss,
                        children: user.name
                    }),
                    user.jobTitle && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $168e8abba0f0ce48$var$userSubheadingXcss,
                        children: user.jobTitle
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                gap: "space.050",
                children: [
                    externalMessageIntegration && /*#__PURE__*/ (0, $l998X.jsx)((0, $8ba86ca7710e8cf5$export$628b037ae7bb4a39), {
                        integrationInfo: externalMessageIntegration
                    }),
                    onCopyEmail && /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ldfch))),
                        label: formatMessage((0, $0a5741db56043cfe$export$defe85febe8b728c).emailButtonLabel),
                        isTooltipDisabled: false,
                        onClick: onCopyEmail
                    }),
                    user.profileUrl && /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
                        href: user.profileUrl,
                        target: "_blank",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $0a5741db56043cfe$export$defe85febe8b728c).viewProfile
                        })
                    })
                ]
            })
        ]
    });
};
const $168e8abba0f0ce48$var$SECONDS_IN_A_DAY = 86400;
const $168e8abba0f0ce48$var$SECONDS_IN_AN_HOUR = 3600;
function $168e8abba0f0ce48$export$e603bc8e48e0cfbb(signalDate) {
    const secondsSinceUpdate = (Date.now() - signalDate.getTime()) / 1000;
    const daysSinceUpdate = Math.floor(secondsSinceUpdate / $168e8abba0f0ce48$var$SECONDS_IN_A_DAY);
    /** Seconds that don't fit into a whole day */ const remainingSecondsInAnHour = secondsSinceUpdate % $168e8abba0f0ce48$var$SECONDS_IN_A_DAY;
    const leftoverHoursSinceUpdate = Math.floor(remainingSecondsInAnHour / $168e8abba0f0ce48$var$SECONDS_IN_AN_HOUR);
    const minutesSinceUpdate = Math.floor(secondsSinceUpdate / 60);
    return {
        daysSinceUpdate: daysSinceUpdate,
        leftoverHoursSinceUpdate: leftoverHoursSinceUpdate,
        minutesSinceUpdate: minutesSinceUpdate
    };
}
const $168e8abba0f0ce48$var$SOCIAL_SIGNAL_ICONS = {
    comment: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
        label: "",
        color: "currentColor"
    }),
    edit: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
        label: "",
        color: "currentColor"
    }),
    share: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9M4aB))), {
        label: "",
        color: "currentColor"
    })
};
const $168e8abba0f0ce48$export$4a6f3cfec60dc525 = ({ signalDate: signalDate, signalType: signalType })=>{
    const icon = $168e8abba0f0ce48$var$SOCIAL_SIGNAL_ICONS[signalType];
    const timeUnitAgoMessage = (0, $0a5741db56043cfe$export$6bab030fe17f656d)[signalType];
    const { unit: unit, value: value } = (0, $42omo.useMemo)(()=>{
        const { daysSinceUpdate: daysSinceUpdate, leftoverHoursSinceUpdate: leftoverHoursSinceUpdate, minutesSinceUpdate: minutesSinceUpdate } = $168e8abba0f0ce48$export$e603bc8e48e0cfbb(signalDate);
        return $168e8abba0f0ce48$var$getTimeValues(daysSinceUpdate, leftoverHoursSinceUpdate, minutesSinceUpdate);
    }, [
        signalDate
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            icon,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $a2dru.default), {
                value: -value,
                style: "long",
                unit: unit,
                numeric: "auto",
                children: (formattedTime)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...timeUnitAgoMessage,
                        values: {
                            relativeDate: formattedTime
                        }
                    })
            })
        ]
    });
};
const $168e8abba0f0ce48$var$getTimeValues = (daysSinceUpdate, leftoverHoursSinceUpdate, minutesSinceUpdate)=>{
    if (daysSinceUpdate === 0) {
        if (leftoverHoursSinceUpdate < 1) return {
            unit: 'minute',
            value: minutesSinceUpdate
        };
        return {
            unit: 'hour',
            value: leftoverHoursSinceUpdate
        };
    }
    return {
        unit: 'day',
        value: daysSinceUpdate
    };
};























const $7e40d1495048d124$export$1ebf25a5760ae3d6 = (0, $cgtv4.defineMessages)({
    share: {
        id: "search-ui.social-signals.user-card-trigger.shared",
        defaultMessage: "{name} shared"
    },
    edit: {
        id: "search-ui.social-signals.user-card-trigger.edited",
        defaultMessage: "{name} edited"
    },
    comment: {
        id: "search-ui.social-signals.user-card-trigger.commented",
        defaultMessage: "{name} commented"
    }
});


const $8f4f6b5c57107ce5$var$signalTextXcss = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    ':hover': {
        textDecoration: 'underline'
    },
    ':focus-visible': {
        textDecoration: 'underline'
    },
    background: 'none',
    padding: '0'
});
const $8f4f6b5c57107ce5$export$b3c2c65aed2f6e98 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ avatarUrl: avatarUrl, userName: userName, onClick: onClick, socialSignalType: socialSignalType, testId: testId, componentName: componentName, analyticsContext: analyticsContext }, ref)=>{
    const firstName = (0, $42omo.useMemo)(()=>userName.split(' ')[0], [
        userName
    ]);
    const message = (0, $7e40d1495048d124$export$1ebf25a5760ae3d6)[socialSignalType];
    if (!message) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
        ref: ref,
        onClick: onClick,
        xcss: $8f4f6b5c57107ce5$var$signalTextXcss,
        testId: testId,
        componentName: componentName,
        analyticsContext: analyticsContext,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
            gap: "space.075",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $e0a3a41d6257d9b3$export$e2255cf6045e8d47), {
                    variant: {
                        type: 'profile-pic',
                        src: avatarUrl,
                        name: userName
                    },
                    size: "xsmall"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                    color: "color.text.subtlest",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...message,
                        values: {
                            name: firstName
                        }
                    })
                })
            ]
        })
    });
});




const $6a8b466b77e29197$export$b2199c37e85de4a7 = (text)=>{
    const callback = (0, $42omo.useCallback)(()=>{
        if (text) navigator.clipboard.writeText(text);
    }, [
        text
    ]);
    if (text) return callback;
};








const $cdccb8e2c3df7374$export$f9c37c834f90de21 = ({ commonAttributes: commonAttributes, socialSignal: socialSignal })=>({
        eventType: 'ui',
        source: (0, $6yNqK.EVENT_SOURCE),
        attributes: {
            ...commonAttributes,
            isFullPageSearch: true,
            socialSignal: socialSignal
        }
    });








const $e46c71a22c4ed891$export$2530a1964f2c1c12 = ({ partial: partial, commonAttributes: commonAttributes })=>{
    const copyEmailToClipboard = (0, $6a8b466b77e29197$export$b2199c37e85de4a7)(partial.socialSignal?.user?.email ?? '');
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { mapUserIdToProfileUrl: mapUserIdToProfileUrl } = (0, $7WbA8.useAppContext)();
    const { socialSignal: socialSignal } = partial;
    if (!socialSignal || !socialSignal.user || !socialSignal.signal || !$e46c71a22c4ed891$var$isSupportedSocialSignal(socialSignal.signal)) return null;
    const { signal: signal, timestamp: timestamp, user: user } = socialSignal;
    const userProfileUrl = mapUserIdToProfileUrl(user.accountId);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        trigger: (triggerProps)=>{
            const extensionData = (0, $1ymk3.getExtensionData)(commonAttributes.isCQL);
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $8f4f6b5c57107ce5$export$b3c2c65aed2f6e98), {
                ...triggerProps,
                userName: user.name,
                socialSignalType: signal,
                avatarUrl: user.picture,
                onClick: ()=>{
                    setIsOpen((open)=>!open);
                },
                testId: "search-page-social-signal",
                componentName: `${(0, $6yNqK.ACTION_SUBJECT_PREFIX)}SocialSignal`,
                analyticsContext: (0, $cdccb8e2c3df7374$export$f9c37c834f90de21)({
                    commonAttributes: {
                        ...commonAttributes,
                        // traceId is only available on extensionData when using Relay
                        ...extensionData.traceId ? extensionData : {}
                    },
                    socialSignal: signal
                })
            });
        },
        content: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $168e8abba0f0ce48$export$4c094c8f61edecb4), {
                user: {
                    name: user.name,
                    profilePicUrl: user.picture,
                    jobTitle: user.extendedProfile?.jobTitle,
                    profileUrl: userProfileUrl
                },
                onCopyEmail: copyEmailToClipboard,
                signalDate: timestamp ? new Date(timestamp) : undefined,
                signalType: signal
            })
    });
};
const $e46c71a22c4ed891$var$supportedSignals = [
    'edit',
    'share',
    'comment'
];
function $e46c71a22c4ed891$var$isSupportedSocialSignal(signalFromApi) {
    return $e46c71a22c4ed891$var$supportedSignals.includes(signalFromApi);
}
const $e46c71a22c4ed891$export$229f0558b2da716c = ({ userAccountId: userAccountId, userName: userName, userEmail: userEmail, userPicture: userPicture, userJobTitle: userJobTitle, signal: signal, timestamp: timestamp, commonAttributes: commonAttributes })=>{
    const copyEmailToClipboard = (0, $6a8b466b77e29197$export$b2199c37e85de4a7)(userEmail);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { mapUserIdToProfileUrl: mapUserIdToProfileUrl } = (0, $7WbA8.useAppContext)();
    if (!userAccountId || !userName || !userPicture || !signal || !$e46c71a22c4ed891$var$isSupportedSocialSignal(signal)) return null;
    const userProfileUrl = mapUserIdToProfileUrl(userAccountId);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        trigger: (triggerProps)=>{
            const extensionData = (0, $1ymk3.getExtensionData)(commonAttributes.isCQL);
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $8f4f6b5c57107ce5$export$b3c2c65aed2f6e98), {
                ...triggerProps,
                userName: userName,
                socialSignalType: signal,
                avatarUrl: userPicture,
                onClick: ()=>{
                    setIsOpen((open)=>!open);
                },
                testId: "search-page-social-signal",
                componentName: `${(0, $6yNqK.ACTION_SUBJECT_PREFIX)}SocialSignal`,
                analyticsContext: (0, $cdccb8e2c3df7374$export$f9c37c834f90de21)({
                    commonAttributes: {
                        ...commonAttributes,
                        // traceId is only available on extensionData when using Relay
                        ...extensionData.traceId ? extensionData : {}
                    },
                    socialSignal: signal
                })
            });
        },
        content: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $168e8abba0f0ce48$export$4c094c8f61edecb4), {
                user: {
                    name: userName,
                    profilePicUrl: userPicture,
                    jobTitle: userJobTitle,
                    profileUrl: userProfileUrl
                },
                onCopyEmail: copyEmailToClipboard,
                signalDate: timestamp ? new Date(timestamp) : undefined,
                signalType: signal
            })
    });
};












var $bh5s2 = parcelRequire("bh5s2");












const $62efe42719bc0caf$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    verifiedIconLabel: {
        id: "search-page.verified-icon-label",
        defaultMessage: "Verified"
    },
    verifiedIconTooltipMessage: {
        id: "search-page.verified-icon-tooltip-message",
        defaultMessage: "This page has been verified by an owner or admin."
    }
});


const $436f4269638928bb$var$TooltipTagStyles = (0, $ecnYn.xcss)({
    display: 'flex'
});
const $436f4269638928bb$export$48d215ae75c54231 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        as: "div",
        xcss: $436f4269638928bb$var$TooltipTagStyles,
        ref: ref,
        ...props
    }));
const $436f4269638928bb$export$eb413699769dd9b1 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: formatMessage((0, $62efe42719bc0caf$export$a7357cdd1f0b0168).verifiedIconTooltipMessage),
        tag: $436f4269638928bb$export$48d215ae75c54231,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh5s2))), {
            label: formatMessage((0, $62efe42719bc0caf$export$a7357cdd1f0b0168).verifiedIconLabel),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        })
    });
};
























const $e3cddeb5c5430cf7$var$getTitle = (partial)=>{
    return (0, $Y34Hw.enrichExcerpt)(partial.title);
};
const $e3cddeb5c5430cf7$var$getLastModified = (partial, serveUserShardUI)=>{
    // Check if user action data is available and feature flag is enabled
    if (serveUserShardUI && partial.latestUserAction && partial.latestUserActionTs) return /*#__PURE__*/ (0, $l998X.jsx)((0, $3E8x9.EventTypeMessage), {
        eventType: partial.latestUserAction,
        timestamp: partial.latestUserActionTs,
        isMyActivityData: true
    });
    // Fall back to lastModified if available
    if (partial.lastModified) return /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: partial.lastModified
    });
    return null;
};
const $e3cddeb5c5430cf7$var$getBreadcrumbs = (partial)=>{
    if (!(0, $4TTdD.isSearchConfluencePageBlogAttachment)(partial)) return null;
    const name = partial.space?.name;
    if (!name) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $e6acefe6e798f052$export$9138e703d4b4585b), {
        name: name,
        url: partial.url,
        webUiLink: partial.space?.webUiLink
    });
};
const $e3cddeb5c5430cf7$var$getVerifiedIcon = (partial)=>{
    if ((0, $4TTdD.isSearchConfluencePageBlogAttachment)(partial) && partial.isVerified) return /*#__PURE__*/ (0, $l998X.jsx)((0, $436f4269638928bb$export$eb413699769dd9b1), {});
    return null;
};
const $e3cddeb5c5430cf7$var$getCommentCount = (partial)=>{
    if (!(0, $4TTdD.isSearchConfluencePageBlogAttachment)(partial)) return null;
    const numberOfComments = partial.confluenceEntity?.commentCountSummary?.total ?? 0;
    if (numberOfComments === 0) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8ca12d73b6c4215d$export$f4c1466e6fdd07b), {
        numberOfComments: numberOfComments
    });
};
const $e3cddeb5c5430cf7$var$getLikeCount = (partial)=>{
    if (!(0, $4TTdD.isSearchConfluencePageBlogAttachment)(partial)) return null;
    const numberOfLikes = partial.confluenceEntity?.likesSummary?.count ?? 0;
    if (numberOfLikes === 0) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $f70284887e2e1865$export$1bd444ba34dbd512), {
        numberOfLikes: numberOfLikes
    });
};
const $e3cddeb5c5430cf7$var$getDescription = (partial)=>{
    return (0, $Y34Hw.processExcerpt)(partial.description);
};
const $e3cddeb5c5430cf7$export$30adeb861c31a5ed = ({ partial: partial, position: position })=>{
    const [{ cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const [features] = (0, $4Qo4W.useFeatures)();
    const [query] = (0, $djVCD.useSearchQuery)();
    const { commonAttributes: commonAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const multiSiteSearchInRovo = (0, $j4ply.useMultiSiteSearchInRovo)();
    const userShardUI = (0, $j4ply.useUserShardUI)();
    const areLLMPoweredFeaturesEnabled = (0, $71988ef00edd4050$export$5c2913b6a4d1611c)();
    const is3pGroupingEnabled = (0, $dh538.fg)('fps_3p_grouping_rollout_gate');
    const isSideBySideEnabled = features?.sideBySide?.enabled;
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(partial.id);
        let containerId = null;
        if ((0, $4TTdD.isSearchConfluencePageBlogAttachment)(partial) && partial.space?.id) {
            const [, , , spaceId] = (0, $6h3V2.getProductAndIDFromARI)(partial.space.id);
            containerId = spaceId;
        }
        return {
            id: partial.id,
            containerId: containerId,
            spaceId: containerId,
            contentType: partial.type,
            entityType: partial.type,
            contentId: contentId,
            product: product,
            isSideBySideEnabled: isSideBySideEnabled
        };
    }, [
        partial,
        isSideBySideEnabled
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position,
        socialSignal: partial.socialSignal?.signal || undefined
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position,
        socialSignal: partial.socialSignal?.signal || undefined
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const subtype = (0, $4TTdD.isSearchConfluencePageBlogAttachment)(partial) ? partial.confluenceEntity?.subtype : undefined;
    const metadataParts = [
        [
            'site-name',
            multiSiteSearchInRovo ? /*#__PURE__*/ (0, $l998X.jsx)((0, $567e21a7779a7988$export$68c7835f320e80a5), {
                cloudARI: partial.id
            }) : null
        ],
        [
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                type: partial.type,
                subtype: subtype
            })
        ],
        [
            'breadcrumbs',
            $e3cddeb5c5430cf7$var$getBreadcrumbs(partial)
        ],
        [
            'last-modified',
            $e3cddeb5c5430cf7$var$getLastModified(partial, userShardUI)
        ]
    ];
    const socialMetadataParts = [
        [
            'comment-count',
            $e3cddeb5c5430cf7$var$getCommentCount(partial)
        ],
        [
            'like-count',
            $e3cddeb5c5430cf7$var$getLikeCount(partial)
        ]
    ];
    const titleMetadataParts = [
        [
            'verified',
            $e3cddeb5c5430cf7$var$getVerifiedIcon(partial)
        ]
    ];
    if (partial.socialSignal && applicationMode === (0, $9vOy1.ApplicationModes).Rovo && ((0, $dh538.fg)('search-plex-jira-social-signal') || !(0, $4TTdD.isSearchConfluenceSpace)(partial))) socialMetadataParts.push([
        'social-signal',
        /*#__PURE__*/ (0, $l998X.jsx)((0, $e46c71a22c4ed891$export$2530a1964f2c1c12), {
            partial: partial,
            commonAttributes: commonAttributes
        })
    ]);
    const hasSimilarResults = partial.linkedResults?.some((linkedResult)=>linkedResult.category?.toUpperCase() === 'SIMILAR');
    const { serveExperiment: serveConversationStartersExperiment } = (0, $eUEtI.getSAINLayerFrontendExperiment)({
        abTestId: 'kd_convo_starters_in_search'
    });
    const isConversationStartersEnabled = (0, $dh538.fg)('kd_convo_starters_dogfooding');
    const conversationStartersIfEnabled = applicationMode === (0, $9vOy1.ApplicationModes).Rovo && !!(serveConversationStartersExperiment || isConversationStartersEnabled) && position === 0 && areLLMPoweredFeaturesEnabled && [
        'page',
        'blogpost'
    ].includes(partial.type) ? {
        ari: partial.id,
        url: (0, $icWhS.getConfluenceUrlWithAnalyticsQueryParams)({
            url: partial.url,
            query: query,
            searchSessionId: searchSessionId
        })
    } : null;
    let icon;
    if ((0, $dh538.fg)('rovo_search_confluence_icons_fps')) {
        const isLiveDoc = (0, $4TTdD.isSearchConfluencePageBlogAttachment)(partial) && partial.confluenceEntity?.subtype === (0, $gzcCN.SearchConfluenceSubtype).LIVE;
        icon = (0, $2waBy.getConfluenceEntityIcon)({
            iconUrl: partial.iconUrl,
            type: partial.type,
            size: 'medium',
            isLiveDoc: isLiveDoc
        });
    } else icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.ConfluenceIcon), {
        size: "medium",
        shouldUseNewLogoDesign: true
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...partial,
        product: (0, $1yEFx.ProductKeys).Confluence,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: (0, $icWhS.getConfluenceUrlWithAnalyticsQueryParams)({
            url: partial.url,
            query: query,
            searchSessionId: searchSessionId
        }),
        title: $e3cddeb5c5430cf7$var$getTitle(partial),
        icon: icon,
        headerMetadataParts: metadataParts,
        headerMetadataSocialParts: socialMetadataParts,
        titleMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $a7nUd.SearchMetadata), {
            parts: titleMetadataParts,
            displaySpacer: false
        }),
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: $e3cddeb5c5430cf7$var$getDescription(partial)
        }),
        hideSummarizeInChat: !!conversationStartersIfEnabled,
        cloudId: cloudId,
        position: position,
        partial: partial,
        appMode: applicationMode,
        footer: cloudId && conversationStartersIfEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $383edc9b6c74463d$export$10e76ebde8d3ea11), {
            primaryProduct: primaryProduct,
            cloudId: cloudId,
            searchResult: conversationStartersIfEnabled,
            analyticsAttributes: {
                resultMetadata: metadata,
                ...commonAttributes
            }
        }) : hasSimilarResults ? /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$59c57a80401f0a6), {
            linkedResults: partial.linkedResults || [],
            thirdPartyConfigs: thirdPartyConfigs,
            partial: partial,
            url: (0, $icWhS.getConfluenceUrlWithAnalyticsQueryParams)({
                url: partial.url,
                query: query,
                searchSessionId: searchSessionId
            }),
            position: position,
            onResultClicked: onResultClicked,
            isAllProductSelected: !selectedProduct,
            onResultContextMenu: onResultCtxMenuClicked,
            is3pGroupingEnabled: is3pGroupingEnabled
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$695e5a3ae2478b3), {
            linkedResults: partial.linkedResults || [],
            thirdPartyConfigs: thirdPartyConfigs,
            partial: partial,
            url: (0, $icWhS.getConfluenceUrlWithAnalyticsQueryParams)({
                url: partial.url,
                query: query,
                searchSessionId: searchSessionId
            }),
            position: position,
            onResultClicked: onResultClicked,
            onResultContextMenu: onResultCtxMenuClicked
        })
    });
};































parcelRequire("42omo");










var $eyWa4 = parcelRequire("eyWa4");









const $6c7cd866f40b6bfc$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    assignee: {
        id: "search-page.jira-assignee.assignee",
        defaultMessage: "Assignee: {assigneeName}"
    },
    unassigned: {
        id: "search-page.jira-assignee.unassigned",
        defaultMessage: "Unassigned"
    }
});


const $157d4b2b9c0ccedc$export$361f73eba39649ac = ({ user: user })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const tooltipText = user ? formatMessage((0, $6c7cd866f40b6bfc$export$defe85febe8b728c).assignee, {
        assigneeName: user.name
    }) : formatMessage((0, $6c7cd866f40b6bfc$export$defe85febe8b728c).unassigned);
    const name = user ? user.name : formatMessage((0, $6c7cd866f40b6bfc$export$defe85febe8b728c).unassigned);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.025",
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                content: tooltipText,
                children: (tooltipProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                        alignBlock: "center",
                        ...tooltipProps,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
                            src: user?.picture,
                            appearance: "circle",
                            size: "xsmall",
                            name: name
                        })
                    })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                color: "color.text.subtlest",
                maxLines: 1,
                children: name
            })
        ]
    });
};



var $aKt88 = parcelRequire("aKt88");

















































parcelRequire("42omo");









const $06a5035ae8ab47df$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'inline-block',
    maxWidth: '215px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $06a5035ae8ab47df$export$47d2cbdccded0b18 = ({ project: project })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: project,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $06a5035ae8ab47df$var$containerStyles,
                testId: "project-metadata",
                ...tooltipProps,
                children: project
            })
    });
};


const $70161bcb1c1c3bc5$var$findProject = (partial)=>{
    if (!partial.issue) return;
    for (const field of partial.issue.fieldsById.edges){
        if ((0, $8LSUr.isJiraProjectField)(field.node)) return field.node;
    }
};
const $70161bcb1c1c3bc5$var$getIssueOrProjectKey = (partial)=>{
    if ((0, $8LSUr.isSearchResultJiraIssue)(partial)) return partial.issue?.key;
    if ((0, $8LSUr.isSearchResultJiraProject)(partial)) return partial.projectKey;
    return null;
};
const $70161bcb1c1c3bc5$var$addJiraQueryParams = (url, partial, searchSessionId, projectId)=>{
    return (0, $icWhS.getJiraUrlWithAnalyticsQueryParams)({
        url: url,
        searchSessionId: searchSessionId,
        resultId: partial.id,
        projectId: projectId
    });
};
const $70161bcb1c1c3bc5$var$getContentString = (adf, level = 0)=>{
    let aggregatedString = '';
    if (adf.content) adf.content.forEach((node)=>{
        if (node.type === 'text') aggregatedString += node.text;
        else if (node.content && level < 15) aggregatedString += ' ' + $70161bcb1c1c3bc5$var$getContentString(node, ++level);
    });
    return aggregatedString;
};
const $70161bcb1c1c3bc5$var$getDescription = (description, query)=>{
    /**
	 * This description can be either a complicated JSON which is actually an ADF (Atlassian Document Format) schema of the entire content of the jira issue.
	 * or it could be a simple excerpt. This uncertainity is due to the progressive development of the BE feature and rolling it out.
	 */ try {
        const adf = JSON.parse(description);
        const text = $70161bcb1c1c3bc5$var$getContentString(adf);
        return (0, $bOpS4.truncateTextWithQuery)(text, query);
    } catch  {
        return description.length > (0, $bOpS4.MAX_CHARACTERS_IN_EXCERPT) ? description.substring(0, (0, $bOpS4.MAX_CHARACTERS_IN_EXCERPT)) + '...' : description.substring(0, (0, $bOpS4.MAX_CHARACTERS_IN_EXCERPT));
    }
};
const $70161bcb1c1c3bc5$export$3c36ba6ceaed3437 = ({ partial: partial, position: position })=>{
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [searchQuery] = (0, $djVCD.useSearchQuery)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const [{ cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const isHydrationLoading = (0, $djVCD.useIsJiraHydrationLoading)();
    const { description: description } = partial;
    const { commonAttributes: commonAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const logException = (0, $f8oYd.useLogException)();
    let project = '';
    let projectId;
    let Status = null;
    let Assignee = null;
    let SocialSignal = null;
    if ((0, $8LSUr.isSearchResultJiraIssue)(partial)) {
        const projectField = $70161bcb1c1c3bc5$var$findProject(partial);
        project = projectField?.project.name || '';
        projectId = projectField?.project.id;
        Status = (0, $aKt88.getStatus)(partial.status?.name, partial.status?.colorName, isHydrationLoading);
        Assignee = (0, $dh538.fg)('rovo_search_assignee_field_fps') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $157d4b2b9c0ccedc$export$361f73eba39649ac), {
            user: partial.issue?.assigneeField?.user
        }) : null;
    }
    const url = (0, $42omo.useMemo)(()=>{
        let resultUrl;
        if ((0, $8LSUr.isSearchResultJiraBoard)(partial)) {
            const notDummyUrl = (0, $1XDdH.isDummyBoardUrl)(partial.url) ? '' : partial.url;
            resultUrl = partial.board?.boardFrontendUrl || notDummyUrl;
        } else resultUrl = partial.url;
        return resultUrl ? $70161bcb1c1c3bc5$var$addJiraQueryParams(resultUrl, partial, searchSessionId, projectId) : '';
    }, [
        partial,
        searchSessionId,
        projectId
    ]);
    if (applicationMode === (0, $9vOy1.ApplicationModes).Rovo && // social signals are only displayed for jira projects
    (0, $8LSUr.isSearchResultJiraProject)(partial) && partial.socialSignal && (0, $dh538.fg)('search-plex-jira-social-signal')) SocialSignal = /*#__PURE__*/ (0, $l998X.jsx)((0, $e46c71a22c4ed891$export$2530a1964f2c1c12), {
        partial: partial,
        commonAttributes: commonAttributes
    });
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(partial.id);
        return {
            id: partial.id,
            containerId: null,
            spaceId: null,
            contentType: partial.type,
            entityType: partial.type,
            contentId: contentId,
            product: product
        };
    }, [
        partial.id,
        partial.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        const prefix = $70161bcb1c1c3bc5$var$getIssueOrProjectKey(partial);
        if ((0, $dh538.fg)('enable_jira_result_highlighting')) {
            if (prefix && !partial.title.startsWith(prefix)) return (0, $Y34Hw.enrichExcerpt)(prefix.concat(': ', partial.title));
            return (0, $Y34Hw.enrichExcerpt)(partial.title);
        }
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(partial.title, searchQuery.split(' '));
        if (prefix && !(highlightedTitle?.startsWith(prefix) || partial.title.startsWith(prefix))) return !highlightedTitle ? prefix.concat(': ', partial.title) : (0, $Y34Hw.enrichExcerpt)(prefix.concat(': ', highlightedTitle));
        return !highlightedTitle ? partial.title : (0, $Y34Hw.enrichExcerpt)(highlightedTitle);
    }, [
        partial,
        searchQuery
    ]);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        if ((0, $dh538.fg)('enable_jira_result_highlighting')) return (0, $Y34Hw.processExcerpt)(description);
        const reducedDescription = $70161bcb1c1c3bc5$var$getDescription(description, searchQuery);
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(reducedDescription, searchQuery.split(' '));
        if (!highlightedTitle) return reducedDescription;
        return (0, $Y34Hw.processExcerpt)(highlightedTitle);
    }, [
        description,
        searchQuery
    ]);
    const getLastModified = (0, $42omo.useMemo)(()=>{
        if (!((0, $8LSUr.isSearchResultJiraIssue)(partial) || (0, $8LSUr.isSearchResultJiraProject)(partial))) return null;
        if (partial.lastModifiedDate) return /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
            lastModified: partial.lastModifiedDate
        });
        return null;
    }, [
        partial
    ]);
    // TODO: Remove this check once backend is fixed to not return boards with dummy URLs
    if (!url && (0, $8LSUr.isSearchResultJiraBoard)(partial)) {
        // If it is a Jira board with no URL, we don't render it
        logException(new Error(String(`Jira Board search result has no URL. Result ID: ${partial.id}`)));
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {});
    }
    const metadataParts = [
        [
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                type: (0, $Y34Hw.getJiraSearchResultTypeMetadata)(partial.type)
            })
        ],
        project ? [
            'project',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $06a5035ae8ab47df$export$47d2cbdccded0b18), {
                project: project
            })
        ] : null,
        [
            'lastModified',
            getLastModified
        ],
        [
            'assignee',
            Assignee
        ],
        [
            'social-signal',
            SocialSignal
        ]
    ].filter(Boolean);
    const titleMetadataParts = [
        [
            'status',
            Status
        ]
    ];
    const isIssue = (0, $8LSUr.isSearchResultJiraIssue)(partial);
    const issueIconUrl = isIssue && partial.issue?.issueTypeAvatarUrl;
    const boardIconUrl = (0, $8LSUr.isSearchResultJiraBoard)(partial) && partial.board?.iconUrl;
    const iconUrl = issueIconUrl || boardIconUrl || partial.iconUrl;
    const icon = (0, $2waBy.getJiraEntityIcon)({
        iconUrl: iconUrl,
        type: partial.type,
        isIssue: isIssue,
        size: 'medium'
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...partial,
        product: (0, $1yEFx.ProductKeys).Jira,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        icon: icon,
        title: enrichedTitle,
        headerMetadataParts: metadataParts,
        titleMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $a7nUd.SearchMetadata), {
            parts: titleMetadataParts
        }),
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: enrichedDescription
        }),
        cloudId: cloudId,
        position: position,
        partial: partial,
        appMode: applicationMode,
        footer: /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$695e5a3ae2478b3), {
            linkedResults: partial.linkedResults || [],
            thirdPartyConfigs: thirdPartyConfigs,
            partial: partial,
            url: url,
            position: position,
            onResultClicked: onResultClicked,
            onResultContextMenu: onResultCtxMenuClicked
        })
    });
};



































parcelRequire("42omo");




















const $b41425164bb8bebe$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    restrictedLabel: {
        id: "search-page.results.restricted-result-label",
        defaultMessage: "Restricted"
    },
    restrictedTooltip: {
        id: "search-page.results.restricted-result-tooltip",
        defaultMessage: "Only visible to specific people"
    },
    privateLabel: {
        id: "search-page.results.private-result-label",
        defaultMessage: "Private"
    },
    privateTooltip: {
        id: "search-page.results.private-result-tooltip",
        defaultMessage: "Only visible to you"
    }
});


const $5c2df34c79a6120f$var$container = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 'space.050',
    backgroundColor: 'color.background.neutral',
    paddingLeft: 'space.100',
    paddingRight: 'space.150',
    // different to paddingLeft for visual balance
    paddingTop: 'space.025',
    paddingBottom: 'space.025',
    borderRadius: 'radius.small',
    cursor: 'default' // so that it doesn't change to the text-selecting looking one
});
const $5c2df34c79a6120f$var$iconColor = "var(--ds-icon, #292A2E)";
const $5c2df34c79a6120f$export$3aad690c5eb10b93 = 'restricted-lozenge';
const $5c2df34c79a6120f$export$3eac322cb0b365da = ({ restriction: restriction })=>{
    if (!restriction || restriction === 'public') return null;
    const label = restriction === 'private' ? (0, $b41425164bb8bebe$export$defe85febe8b728c).privateLabel : (0, $b41425164bb8bebe$export$defe85febe8b728c).restrictedLabel;
    const tooltipText = restriction === 'private' ? (0, $b41425164bb8bebe$export$defe85febe8b728c).privateTooltip : (0, $b41425164bb8bebe$export$defe85febe8b728c).restrictedTooltip;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...tooltipText
        }),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
            xcss: $5c2df34c79a6120f$var$container,
            testId: $5c2df34c79a6120f$export$3aad690c5eb10b93,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
                    label: "",
                    color: $5c2df34c79a6120f$var$iconColor,
                    size: "small"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                    color: "color.text",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...label
                    })
                })
            ]
        })
    });
};























































parcelRequire("42omo");





var $4wwVl = parcelRequire("4wwVl");










const $821eab66233151f6$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    personAvatarLabel: {
        id: "search-page.profile-avatar.label",
        defaultMessage: "Person Avatar"
    }
});


const $678a8075b20296fe$var$personAvatarColor = "var(--ds-icon, #292A2E)";
const $678a8075b20296fe$var$defaultAvatarCSS = (0, $ecnYn.xcss)({
    padding: 'space.025',
    alignItems: 'center',
    display: 'flex'
});
const $678a8075b20296fe$var$avatarCSS = (0, $ecnYn.xcss)({
    alignItems: 'center',
    display: 'flex',
    marginInlineEnd: 'space.025'
});
const $678a8075b20296fe$export$3778be82376b06d7 = ({ name: name, picture: picture })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    if (name) return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        testId: "3p-message-avatar",
        xcss: $678a8075b20296fe$var$avatarCSS,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e0a3a41d6257d9b3$export$e2255cf6045e8d47), {
            variant: picture ? {
                type: 'profile-pic',
                src: picture,
                name: name
            } : {
                type: 'initials',
                name: name
            },
            size: "smaller"
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $678a8075b20296fe$var$defaultAvatarCSS,
        testId: "3p-message-avatar",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4wwVl))), {
            label: formatMessage((0, $821eab66233151f6$export$defe85febe8b728c).personAvatarLabel),
            color: $678a8075b20296fe$var$personAvatarColor
        })
    });
};


























const $10ea7a224748bb91$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    workItemLabel: {
        id: "jira-dc.work-item.label",
        defaultMessage: "Work item"
    },
    issueLabel: {
        id: "jira-dc.work-item-task.issue",
        defaultMessage: "Issue"
    },
    for: {
        id: "jira-dc.work-item-status.for",
        defaultMessage: "{statusLozenge} for {dateLozenge}"
    },
    isAssigned: {
        id: "jira-dc.work-item-assignee.assigned",
        defaultMessage: "{isAssigned, select, internal {{firstName} is assigned} other {External person is assigned}}"
    },
    created: {
        id: "jira-dc.work-item-creator.created",
        defaultMessage: "{created, select, internal {{firstName} created} other {External person created}}"
    }
});


const $131e1a4c9fbdc51d$var$nameContainer = (0, $ecnYn.xcss)({
    whiteSpace: 'nowrap'
});
const $131e1a4c9fbdc51d$var$statusAndDateContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.100'
});
const $131e1a4c9fbdc51d$var$getStatusLozengeAppearance = (label)=>{
    label = label.replace(/[\s]+/g, '').toLowerCase();
    switch(true){
        case [
            'onhold'
        ].includes(label):
            return 'default';
        // gray
        case [
            'solved',
            'complete'
        ].includes(label):
            return 'success';
        // green
        case [
            'open',
            'offtrack'
        ].includes(label):
            return 'removed';
        // red
        case [
            'new',
            'atrisk'
        ].includes(label):
            return 'moved';
        // yellow
        case [
            'pending',
            'ontrack'
        ].includes(label):
            return 'inprogress';
    }
    return 'inprogress'; // blue for custom status labels
};
const $131e1a4c9fbdc51d$var$getStatusAndDate = (status, dueDate)=>{
    if (!status) return null;
    const statusLabel = status.replace(/[-_]+/g, ' ');
    const statusLozenge = /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
        appearance: $131e1a4c9fbdc51d$var$getStatusLozengeAppearance(statusLabel),
        children: statusLabel
    });
    const dateLozenge = /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cgtv4.FormattedDate), {
            value: dueDate,
            month: "short",
            day: "numeric"
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $131e1a4c9fbdc51d$var$statusAndDateContainerStyles,
        children: dueDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $10ea7a224748bb91$export$defe85febe8b728c).for,
            values: {
                statusLozenge: statusLozenge,
                dateLozenge: dateLozenge
            }
        }) : statusLozenge
    });
};
const $131e1a4c9fbdc51d$var$getAssigneeOrCreator = (formatMessage, assignee, createdBy)=>{
    let actionLabel;
    const fullName = assignee?.thirdPartyUser?.name || createdBy?.thirdPartyUser?.name || '';
    const firstName = fullName?.split(' ')?.[0];
    if (assignee?.thirdPartyUser?.name) actionLabel = formatMessage((0, $10ea7a224748bb91$export$defe85febe8b728c).isAssigned, {
        firstName: firstName,
        isAssigned: firstName ? 'internal' : 'external'
    });
    else actionLabel = formatMessage((0, $10ea7a224748bb91$export$defe85febe8b728c).created, {
        firstName: firstName,
        created: firstName ? 'internal' : 'external'
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
        space: "space.025",
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $678a8075b20296fe$export$3778be82376b06d7), {
                name: fullName
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $131e1a4c9fbdc51d$var$nameContainer,
                children: actionLabel
            })
        ]
    });
};
const $131e1a4c9fbdc51d$var$formatKey = (key)=>key ? key + ' ' : '';
const $131e1a4c9fbdc51d$export$65248e01d9f51226 = ({ partial: partial, position: position, icon: icon, product: product, onResultClicked: onResultClicked, onResultCtxMenuClicked: onResultCtxMenuClicked })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const [{ cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const appMode = (0, $j4ply.useApplicationMode)();
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(partial.id);
        return {
            id: partial.id,
            containerId: null,
            spaceId: null,
            contentType: partial.type,
            entityType: partial.type,
            contentId: contentId,
            product: product
        };
    }, [
        partial.id,
        partial.type
    ]);
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, entity: entity, excerpt: excerpt, title: title } = partial;
    const { assignee: assignee, createdBy: createdBy, dueDate: dueDate, status: status, subtype: subtype, team: team } = entity || {};
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const padlockIcon = (0, $Y34Hw.isNonPublic)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const subtypeMap = {
        work_item: (0, $10ea7a224748bb91$export$defe85febe8b728c).workItemLabel,
        issue: (0, $10ea7a224748bb91$export$defe85febe8b728c).issueLabel,
        other: (0, $10ea7a224748bb91$export$defe85febe8b728c).workItemLabel
    };
    const label = formatMessage(subtypeMap[subtype?.toLowerCase() ?? 'other'] || (0, $10ea7a224748bb91$export$defe85febe8b728c).workItemLabel);
    // Find the specific datasource for this result based on its integrationId
    const resultDatasource = thirdPartyConfigs?.[(0, $1yEFx.ProductKeys).JiraDC]?.datasources?.find((ds)=>ds.integrationId === partial.integrationId) || null;
    const site = resultDatasource?.workspaceName || thirdPartyConfigs?.[(0, $1yEFx.ProductKeys).JiraDC]?.workspaceName || null;
    const containerName = entity?.container?.displayName;
    const containerUrl = entity?.container?.url;
    const container = containerUrl && containerName ? /*#__PURE__*/ (0, $l998X.jsx)((0, $655681e89d0ffd52$export$2e2bcd8739ae039), {
        label: containerName,
        href: containerUrl
    }) : containerName;
    const headerMetadataParts = [
        label,
        [
            'site',
            site
        ],
        [
            'container',
            container
        ],
        [
            'last-modified',
            lastModifiedComponent
        ],
        [
            'padlock',
            padlockIcon
        ],
        [
            'status',
            $131e1a4c9fbdc51d$var$getStatusAndDate(status, dueDate)
        ],
        [
            'person',
            $131e1a4c9fbdc51d$var$getAssigneeOrCreator(formatMessage, assignee, createdBy)
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: partial.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: (0, $Y34Hw.processExcerpt)(excerpt, true)
        }),
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title, $131e1a4c9fbdc51d$var$formatKey(team)),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial,
        appMode: appMode
    });
};
const $131e1a4c9fbdc51d$export$d7baa484f865afc6 = ({ partial: partial, position: position, icon: icon, product: product, onResultClicked: onResultClicked, onResultCtxMenuClicked: onResultCtxMenuClicked })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const [{ cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const appMode = (0, $j4ply.useApplicationMode)();
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(partial.id);
        return {
            id: partial.id,
            containerId: null,
            spaceId: null,
            contentType: partial.type,
            entityType: partial.type,
            contentId: contentId,
            product: product
        };
    }, [
        partial.id,
        partial.type
    ]);
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, entity: entity, excerpt: excerpt, title: title } = partial;
    const { assignee: assignee, createdBy: createdBy, dueDate: dueDate, status: status, key: key } = entity || {};
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const padlockIcon = (0, $Y34Hw.isNonPublic)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const label = formatMessage((0, $10ea7a224748bb91$export$defe85febe8b728c).issueLabel);
    // Find the specific datasource for this result based on its integrationId
    const resultDatasource = thirdPartyConfigs?.[(0, $1yEFx.ProductKeys).JiraDC]?.datasources?.find((ds)=>ds.integrationId === partial.integrationId) || null;
    const site = resultDatasource?.workspaceName || thirdPartyConfigs?.[(0, $1yEFx.ProductKeys).JiraDC]?.workspaceName || null;
    const containerName = entity?.container?.displayName;
    const containerUrl = entity?.container?.url;
    const container = containerUrl && containerName ? /*#__PURE__*/ (0, $l998X.jsx)((0, $655681e89d0ffd52$export$2e2bcd8739ae039), {
        label: containerName,
        href: containerUrl
    }) : containerName;
    const headerMetadataParts = [
        label,
        [
            'site',
            site
        ],
        [
            'container',
            container
        ],
        [
            'last-modified',
            lastModifiedComponent
        ],
        [
            'padlock',
            padlockIcon
        ],
        [
            'status',
            $131e1a4c9fbdc51d$var$getStatusAndDate(status, dueDate)
        ],
        [
            'person',
            $131e1a4c9fbdc51d$var$getAssigneeOrCreator(formatMessage, assignee, createdBy)
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: partial.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: (0, $Y34Hw.processExcerpt)(excerpt, true)
        }),
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title, $131e1a4c9fbdc51d$var$formatKey(key)),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial,
        appMode: appMode
    });
};





const $ba3d69474b3be4da$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    project: {
        id: "jira-dc.project-result.label",
        defaultMessage: "Project"
    },
    space: {
        id: "jira-dc.space-result.label",
        defaultMessage: "Space"
    },
    issue: {
        id: "jira-dc.issue-result.label",
        defaultMessage: "Work item"
    },
    commment: {
        id: "jira-dc.comment-result.label",
        defaultMessage: "Comment"
    }
});


const $6a6b6eb1f6bb6683$var$JIRA_DC_INTEGRATION_IDS = [
    'ari:cloud:platform::integration/jira-dc',
    'ari:cloud:platform::integration/jira-dc-secondary',
    'ari:cloud:platform::integration/jira-dc-tertiary'
];
const $6a6b6eb1f6bb6683$export$aa3a06102a04532d = (partial)=>{
    return (0, $7ZetK.isSearchResultGraphEntity)(partial) && $6a6b6eb1f6bb6683$var$JIRA_DC_INTEGRATION_IDS.includes(partial?.integrationId ?? '');
};
const $6a6b6eb1f6bb6683$var$footerContainer = (0, $ecnYn.xcss)({
    paddingTop: 'space.100'
});
const $6a6b6eb1f6bb6683$var$typeLabelContainer = (0, $ecnYn.xcss)({
    '::first-letter': {
        textTransform: 'capitalize'
    }
});
const $6a6b6eb1f6bb6683$var$PROJECT_SUBTYPES = [
    'software',
    'service_desk',
    'business',
    'project' //to be removed once implementation is finalised
];
const $6a6b6eb1f6bb6683$var$SERVICE_DESK = 'service_desk';
const $6a6b6eb1f6bb6683$var$SUBTYPE_PROJECT = 'project';
const $6a6b6eb1f6bb6683$var$SUBTYPE_COMMENT = 'comment';
const $6a6b6eb1f6bb6683$var$SUBTYPE_ISSUE = 'issue';
const $6a6b6eb1f6bb6683$var$JIRA_DC_LABELS = {
    [$6a6b6eb1f6bb6683$var$SUBTYPE_PROJECT]: (0, $ba3d69474b3be4da$export$defe85febe8b728c).project,
    [$6a6b6eb1f6bb6683$var$SUBTYPE_COMMENT]: (0, $ba3d69474b3be4da$export$defe85febe8b728c).comment,
    [$6a6b6eb1f6bb6683$var$SUBTYPE_ISSUE]: (0, $ba3d69474b3be4da$export$defe85febe8b728c).issue
};
const $6a6b6eb1f6bb6683$var$getLabel = (subtype)=>{
    if ($6a6b6eb1f6bb6683$var$PROJECT_SUBTYPES.includes(subtype)) return (0, $ba3d69474b3be4da$export$defe85febe8b728c).project;
    return $6a6b6eb1f6bb6683$var$JIRA_DC_LABELS[subtype];
};
const $6a6b6eb1f6bb6683$var$isJsmIcon = (containerType)=>{
    return (0, $dh538.fg)('is_jsm_dc_enabled_in_ui') && containerType?.toLowerCase() === $6a6b6eb1f6bb6683$var$SERVICE_DESK;
};
const $6a6b6eb1f6bb6683$export$e39b36c2009dde1b = ({ partial: partial, position: position })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const [{ cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const appMode = (0, $j4ply.useApplicationMode)();
    const resultAri = (0, $k4HRJ.AnyAri).parse(partial.id);
    const metadata = (0, $42omo.useMemo)(()=>{
        return {
            id: partial.id,
            containerId: null,
            spaceId: null,
            contentType: partial.subtype,
            entityType: resultAri.resourceType,
            contentId: resultAri.resourceId,
            product: (0, $1yEFx.ProductKeys).JiraDC
        };
    }, [
        partial,
        resultAri
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, title: title, excerpt: excerpt } = partial;
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const jiraIcon = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.JiraIcon), {
        size: "medium",
        shouldUseNewLogoDesign: true
    });
    const jsmIcon = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.JiraServiceManagementIcon), {
        size: "medium",
        shouldUseNewLogoDesign: true
    });
    let icon = jiraIcon;
    // Find the specific datasource for this result based on its integrationId/providerId
    const resultDatasource = thirdPartyConfigs?.[metadata.product]?.datasources?.find((ds)=>ds.integrationId === partial.integrationId) || null;
    // Use the result's datasource workspace name, fallback to main config
    const site = resultDatasource?.workspaceName || thirdPartyConfigs?.[metadata.product]?.workspaceName;
    const entityToLabelMap = {
        space: 'space',
        'work-item': 'issue',
        project: 'issue',
        comment: 'comment'
    };
    const resultType = partial.subtype || (entityToLabelMap[metadata.entityType] ?? metadata.entityType);
    const labelMessage = $6a6b6eb1f6bb6683$var$getLabel(resultType);
    const label = labelMessage ? formatMessage(labelMessage) : resultType;
    const isNotPublic = (0, $Y34Hw.isNonPublic)(permissionLevel);
    if ((0, $7ZetK.isProjectEntity)(partial)) {
        if ($6a6b6eb1f6bb6683$var$isJsmIcon(partial.entity?.container?.subtype)) icon = jsmIcon;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $131e1a4c9fbdc51d$export$d7baa484f865afc6), {
            partial: partial,
            position: position,
            icon: icon,
            product: metadata.product,
            onResultClicked: onResultClicked,
            onResultCtxMenuClicked: onResultCtxMenuClicked
        });
    }
    if ((0, $7ZetK.isWorkItemEntity)(partial)) {
        if ($6a6b6eb1f6bb6683$var$isJsmIcon(partial.entity?.container?.subtype)) icon = jsmIcon;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $131e1a4c9fbdc51d$export$65248e01d9f51226), {
            partial: partial,
            position: position,
            icon: icon,
            product: metadata.product,
            onResultClicked: onResultClicked,
            onResultCtxMenuClicked: onResultCtxMenuClicked
        });
    }
    let container;
    if ((0, $7ZetK.isCommentEntity)(partial)) {
        if ($6a6b6eb1f6bb6683$var$isJsmIcon(partial.entity?.container?.subtype)) icon = jsmIcon;
        const { entity: entity } = partial;
        const containerName = entity?.container?.displayName;
        const containerUrl = entity?.container?.url;
        container = containerUrl && containerName ? /*#__PURE__*/ (0, $l998X.jsx)((0, $655681e89d0ffd52$export$2e2bcd8739ae039), {
            label: containerName,
            href: containerUrl
        }) : containerName;
    } else if ($6a6b6eb1f6bb6683$var$isJsmIcon(partial.subtype)) icon = jsmIcon;
    const headerMetadataParts = [
        [
            'label',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $6a6b6eb1f6bb6683$var$typeLabelContainer,
                children: label
            })
        ],
        [
            'site',
            site
        ],
        [
            'container',
            container
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    // space noun (project in the UI) and comment use default result component
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: partial.id,
        product: metadata.product,
        productSelected: true,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        description: (0, $Y34Hw.processExcerpt)(excerpt),
        icon: icon,
        headerMetadataParts: headerMetadataParts,
        footer: isNotPublic && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $6a6b6eb1f6bb6683$var$footerContainer,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5c2df34c79a6120f$export$3eac322cb0b365da), {
                restriction: permissionLevel
            })
        }),
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial,
        appMode: appMode
    });
};








































parcelRequire("42omo");

const $01817a1a99cb392d$export$72cad736eff3158c = ()=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            stroke: "currentcolor",
            strokeWidth: "1.5",
            d: "M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"
        })
    });













var $92zSJ = parcelRequire("92zSJ");



















const $cc59e5ecfdbc01be$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    for: {
        id: "search-page.mercury.for",
        defaultMessage: "for"
    },
    statusUpdateTitle: {
        id: "search-page.mercury.focus-area-status-update.title",
        defaultMessage: "Update for {focusAreaName}"
    }
});


const $381b478f065a8b1d$var$getStatusApperanceFromKey = (key)=>{
    switch(key){
        case 'off_track':
        case 'red':
            return 'removed';
        case 'at_risk':
        case 'yellow':
            return 'moved';
        case 'on_track':
        case 'green':
            return 'success';
        case 'completed':
        case 'paused':
        case 'pending':
        default:
            return 'default';
    }
};
const $381b478f065a8b1d$export$1da174cfafc04271 = (partial)=>{
    const { focusArea: focusArea } = partial;
    const displayedStatus = focusArea?.status?.key === 'in_progress' ? focusArea?.health?.displayName : focusArea?.status?.displayName;
    const displayedStatusAppearance = $381b478f065a8b1d$var$getStatusApperanceFromKey(focusArea?.health?.color.toLowerCase() || focusArea?.health?.key || focusArea?.status?.key);
    return {
        displayedStatus: displayedStatus,
        displayedStatusAppearance: displayedStatusAppearance
    };
};



var $3Vbz9 = parcelRequire("3Vbz9");


var $5eayg = parcelRequire("5eayg");


var $dWCFT = parcelRequire("dWCFT");


var $9tcaE = parcelRequire("9tcaE");


var $cPLkE = parcelRequire("cPLkE");

const $f5c861fe9abda3f5$var$DEFAULT_DATE_FNS_OPTIONS = {
    weekStartsOn: 1
};
// Wrap a date-fns method with default options param
// eslint-disable-next-line no-unused-vars
/* eslint-disable-next-line  @typescript-eslint/no-explicit-any */ const $f5c861fe9abda3f5$var$mixinDefaultOptions = (fn)=>{
    /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */ return function(...theArgs) {
        const lastIndex = fn.length - 1;
        if (fn.length === theArgs.length) theArgs[lastIndex] = {
            ...$f5c861fe9abda3f5$var$DEFAULT_DATE_FNS_OPTIONS,
            ...theArgs[lastIndex]
        };
        else theArgs[lastIndex] = $f5c861fe9abda3f5$var$DEFAULT_DATE_FNS_OPTIONS;
        return fn.apply(this, theArgs);
    };
};
const $f5c861fe9abda3f5$var$SAME_YEAR_FORMAT = 'd MMM';
const $f5c861fe9abda3f5$var$DIFF_YEAR_FORMAT = 'd MMM yyyy';
const $f5c861fe9abda3f5$var$MONTH_ONLY_FORMAT = 'MMMM';
const $f5c861fe9abda3f5$var$MONTH_ONLY_FORMAT_SHORT = 'MMM';
const $f5c861fe9abda3f5$var$MONTH_ONLY_FORMAT_DIFF_YEAR = 'MMM yyyy';
const $f5c861fe9abda3f5$var$format = $f5c861fe9abda3f5$var$mixinDefaultOptions((0, $dWCFT.default));
const $f5c861fe9abda3f5$export$6f9eb5ad232629d8 = (partial)=>{
    const { focusArea: focusArea } = partial;
    if (!focusArea?.targetDate) return null;
    const date = (0, $3Vbz9.toDate)(focusArea.targetDate.targetDate);
    let displayedTargetDate = '';
    if (focusArea?.targetDate.targetDateType === 'DAY') displayedTargetDate = $f5c861fe9abda3f5$var$format(date, (0, $9tcaE.default)(date) ? $f5c861fe9abda3f5$var$SAME_YEAR_FORMAT : $f5c861fe9abda3f5$var$DIFF_YEAR_FORMAT);
    else if (focusArea?.targetDate.targetDateType === 'MONTH') displayedTargetDate = $f5c861fe9abda3f5$var$format(date, (0, $9tcaE.default)(date) ? $f5c861fe9abda3f5$var$MONTH_ONLY_FORMAT : $f5c861fe9abda3f5$var$MONTH_ONLY_FORMAT_DIFF_YEAR);
    else if (focusArea?.targetDate.targetDateType === 'QUARTER') displayedTargetDate = `${$f5c861fe9abda3f5$var$format((0, $cPLkE.default)(date), $f5c861fe9abda3f5$var$MONTH_ONLY_FORMAT_SHORT)}-${$f5c861fe9abda3f5$var$format((0, $5eayg.default)(date), (0, $9tcaE.default)(date) ? $f5c861fe9abda3f5$var$MONTH_ONLY_FORMAT_SHORT : $f5c861fe9abda3f5$var$MONTH_ONLY_FORMAT_DIFF_YEAR)}`;
    return displayedTargetDate;
};


const $450900e213a04b17$var$getType = (partial)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
            type: partial.type
        })
    });
};
const $450900e213a04b17$var$getFocusAreaType = (partial)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        children: partial.focusArea?.focusAreaType?.name
    });
};
const $450900e213a04b17$var$getOwner = (partial)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        children: partial.focusArea?.owner?.name
    });
};
const $450900e213a04b17$var$getLastModified = (partial)=>{
    if (partial.lastModifiedDate) return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
            lastModified: partial.lastModifiedDate
        })
    });
    return null;
};
const $450900e213a04b17$var$statusAndTargetDateXcss = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.100'
});
const $450900e213a04b17$var$targetDateForXcss = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtlest'
});
const $450900e213a04b17$var$getStatusAndTargetDate = (partial)=>{
    const { displayedStatus: displayedStatus, displayedStatusAppearance: displayedStatusAppearance } = (0, $381b478f065a8b1d$export$1da174cfafc04271)(partial);
    const displayedTargetDate = (0, $f5c861fe9abda3f5$export$6f9eb5ad232629d8)(partial);
    if (!displayedStatus) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $450900e213a04b17$var$statusAndTargetDateXcss,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                appearance: displayedStatusAppearance,
                children: displayedStatus
            }),
            displayedTargetDate && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $450900e213a04b17$var$targetDateForXcss,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $cc59e5ecfdbc01be$export$defe85febe8b728c).for
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                            alignBlock: "center",
                            space: "space.050",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $01817a1a99cb392d$export$72cad736eff3158c), {}),
                                displayedTargetDate
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
const $450900e213a04b17$export$c9d05a539ddcce32 = ({ partial: partial, position: position })=>{
    const [{ cloudId: cloudId }] = (0, $j4ply.useBootstrap)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const [searchQuery] = (0, $djVCD.useSearchQuery)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const intl = (0, $8C5kA.default)();
    const { id: id, url: url, type: type } = partial;
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, contentId] = (0, $6h3V2.getProductAndIDFromARI)(id);
        return {
            id: id,
            containerId: null,
            spaceId: null,
            contentType: type,
            entityType: type,
            contentId: contentId,
            product: product
        };
    }, [
        id,
        type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    let title = '';
    let description = '';
    let headerMetadataParts = [];
    if ((0, $HOiSI.isSearchResultMercuryFocusAreaPartial)(partial)) {
        title = (0, $Y34Hw.enrichExcerpt)(partial.title);
        description = $450900e213a04b17$var$getStatusAndTargetDate(partial);
        headerMetadataParts = [
            [
                'type',
                $450900e213a04b17$var$getType(partial)
            ],
            [
                'focusAreaType',
                $450900e213a04b17$var$getFocusAreaType(partial)
            ],
            partial.focusArea?.owner ? [
                'owner',
                $450900e213a04b17$var$getOwner(partial)
            ] : null,
            [
                'last-modified',
                $450900e213a04b17$var$getLastModified(partial)
            ]
        ];
    }
    if ((0, $HOiSI.isSearchResultMercuryFocusAreaStatusUpdatePartial)(partial)) {
        title = intl.formatMessage((0, $cc59e5ecfdbc01be$export$defe85febe8b728c).statusUpdateTitle, {
            focusAreaName: partial.focusArea?.name
        });
        description = (0, $92zSJ.getSummarizedAdfContent)(partial.description, searchQuery);
        headerMetadataParts = [
            [
                'type',
                $450900e213a04b17$var$getType(partial)
            ],
            [
                'last-modified',
                $450900e213a04b17$var$getLastModified(partial)
            ]
        ];
    }
    if ((0, $HOiSI.isSearchResultSpfAskPartial)(partial) && (0, $dh538.fg)('platform_passionfruit_search_onboarding_enabled')) {
        title = (0, $Y34Hw.enrichExcerpt)(partial.title);
        headerMetadataParts = [
            [
                'type',
                $450900e213a04b17$var$getType(partial)
            ],
            [
                'last-modified',
                $450900e213a04b17$var$getLastModified(partial)
            ]
        ];
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...partial,
        product: (0, $1yEFx.ProductKeys).Focus,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        title: title,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.FocusIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        headerMetadataParts: headerMetadataParts,
        description: description,
        cloudId: cloudId,
        position: position,
        partial: partial,
        appMode: applicationMode
    });
};



































parcelRequire("42omo");























const $7d0e0c616492704f$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    resultLabel: {
        id: "github-branch-result.label",
        defaultMessage: "Branch"
    }
});


const $a04021a7d100dc0c$export$5620ef5d10869020 = ({ partial: partial, position: position, icon: icon, product: product, onResultClicked: onResultClicked, onResultCtxMenuClicked: onResultCtxMenuClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const [{ cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const appMode = (0, $j4ply.useApplicationMode)();
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, entity: entity } = partial;
    const { name: branchName, container: container } = entity || {};
    const label = formatMessage((0, $7d0e0c616492704f$export$defe85febe8b728c).resultLabel);
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const padlockIcon = (0, $Y34Hw.isNonPublic)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const headerMetadataParts = [
        label,
        [
            'repository-name',
            container?.name ?? null
        ],
        [
            'padlock',
            padlockIcon
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: partial.id,
        product: product,
        productSelected: true,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: '',
        headerMetadataParts: headerMetadataParts,
        title: branchName,
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial,
        appMode: appMode,
        footer: /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
            linkedResults: partial.linkedResults || [],
            thirdPartyConfigs: thirdPartyConfigs,
            partial: partial,
            url: url,
            position: position,
            onResultClicked: onResultClicked || (()=>{}),
            onResultContextMenu: onResultCtxMenuClicked
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars















var $lE8sM = parcelRequire("lE8sM");


var $8DN9t = parcelRequire("8DN9t");





var $6R5uz = parcelRequire("6R5uz");


var $2Yaht = parcelRequire("2Yaht");




















parcelRequire("42omo");




const $e050b981814f4361$export$10f53ee736dae147 = ({ date: date })=>{
    if (!date) return null;
    const event = new Date(date);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $cgtv4.FormattedDate), {
        value: event,
        month: "short",
        day: "numeric",
        year: "numeric"
    });
};











/**
 * Returns a date and time range based on two date strings
 * @example 10-11 AM
 */ const $428ad5ad3a150038$export$abc17c795ac8b09b = ({ from: from, to: to })=>{
    const fromDate = new Date(from);
    const toDate = new Date(to);
    const dateTimeFormat = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        minute: 'numeric'
    });
    const fromDateParts = dateTimeFormat.format(fromDate);
    const toDateParts = dateTimeFormat.format(toDate);
    return `${fromDateParts} - ${toDateParts}`;
};


















const $28391d0ed56d0c04$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    eventLabel: {
        id: "calendar-event-search-result.calendar-label",
        defaultMessage: "Calendar"
    },
    meetingLink: {
        id: "calendar-event-search-result.meeting-link",
        defaultMessage: "Meeting link"
    },
    joinMeetingLink: {
        id: "calendar-event-search-result.join-meeting-link",
        defaultMessage: "Join meeting"
    },
    meetingLinkIcon: {
        id: "calendar-event-search-result.meeting-link-icon",
        defaultMessage: "Join meeting"
    },
    recurringEventIcon: {
        id: "calendar-event-search-result.recurring-event-icon",
        defaultMessage: "Recurring event"
    },
    recurringMetadataLabel: {
        id: "calendar-event-search-result.recurring-event-label",
        defaultMessage: "Recurring"
    },
    upcomingEventsButton: {
        id: "calendar-event-search-result.upcoming-events-button",
        defaultMessage: "Upcoming events"
    },
    pastEventsButton: {
        id: "calendar-event-search-result.past-events-button",
        defaultMessage: "Past events"
    },
    created: {
        id: "calendar-event-search-result.created.placeholder",
        defaultMessage: "{person} created"
    },
    externalPerson: {
        id: "calendar-event-search-result.external-person",
        defaultMessage: "External person"
    }
});


const $b5ce93e1775f73b6$var$RELATED_EVENTS_STATE = {
    UPCOMING: 'upcoming',
    PAST: 'past',
    CLOSED: 'closed'
};
const $b5ce93e1775f73b6$export$137e3167f558cbc3 = ({ fromDate: fromDate, toDate: toDate, meetingLink: meetingLink })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    if (!fromDate || !meetingLink || !toDate) return null;
    const currentDate = new Date();
    const startDate = new Date(fromDate);
    startDate.setHours(startDate.getHours() - 2); // Checks if the event is within 2 hours
    const endDate = new Date(toDate);
    const eventIsWithin2hoursOrIsOngoing = startDate < currentDate && currentDate < endDate;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
        iconBefore: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Yaht))), {
                color: "var(--ds-icon-subtle)",
                label: ''
            }),
        href: meetingLink,
        children: eventIsWithin2hoursOrIsOngoing ? formatMessage((0, $28391d0ed56d0c04$export$defe85febe8b728c).joinMeetingLink) : formatMessage((0, $28391d0ed56d0c04$export$defe85febe8b728c).meetingLink)
    });
};
const $b5ce93e1775f73b6$var$calendarEventLinkStyles = (0, $ecnYn.xcss)({
    color: 'color.link',
    textDecoration: 'none',
    ':hover': {
        color: 'color.link',
        textDecoration: 'underline'
    },
    ':active': {
        textDecoration: 'none'
    },
    ':visited': {
        color: 'color.link.visited'
    },
    ':visited:active': {
        color: 'color.link.visited.pressed'
    },
    display: 'flex'
});
const $b5ce93e1775f73b6$var$relatedCalendarEventMetadataStyles = (0, $ecnYn.xcss)({
    gridColumn: 2,
    alignItems: 'center'
});
const $b5ce93e1775f73b6$var$nameContainer = (0, $ecnYn.xcss)({
    whiteSpace: 'nowrap'
});
const $b5ce93e1775f73b6$var$RelatedCalendarEvents = ({ calendarEvents: calendarEvents })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $cwkWT.default), {
        gap: "space.200",
        children: calendarEvents.map((calendarEvent)=>{
            const { entity: entity, title: title, url: url } = calendarEvent;
            const labelMessageComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                size: "small",
                children: formatMessage((0, $28391d0ed56d0c04$export$defe85febe8b728c).eventLabel)
            });
            const eventDateComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                size: "small",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e050b981814f4361$export$10f53ee736dae147), {
                    date: entity.eventStartTime
                })
            });
            const eventTimeComponent = entity.eventStartTime && entity.eventEndTime ? /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                size: "small",
                children: (0, $428ad5ad3a150038$export$abc17c795ac8b09b)({
                    from: entity.eventStartTime,
                    to: entity.eventEndTime
                })
            }) : null;
            const meetingLink = entity.videoMeetingUrl ? /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                size: "small",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
                    xcss: $b5ce93e1775f73b6$var$calendarEventLinkStyles,
                    href: entity.videoMeetingUrl,
                    children: formatMessage((0, $28391d0ed56d0c04$export$defe85febe8b728c).meetingLink)
                })
            }) : null;
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
                templateColumns: "min-content 1fr",
                alignItems: "center",
                columnGap: "space.100",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $lE8sM.default), {
                        size: "16",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))),
                        label: formatMessage((0, $28391d0ed56d0c04$export$defe85febe8b728c).recurringEventIcon),
                        appearance: "blue"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                        size: "small",
                        weight: "semibold",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
                            xcss: $b5ce93e1775f73b6$var$calendarEventLinkStyles,
                            href: url,
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
                        xcss: $b5ce93e1775f73b6$var$relatedCalendarEventMetadataStyles,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a7nUd.SearchMetadata), {
                            parts: [
                                [
                                    'calendar-label',
                                    labelMessageComponent
                                ],
                                [
                                    'event-date',
                                    eventDateComponent
                                ],
                                [
                                    'event-time',
                                    eventTimeComponent
                                ],
                                [
                                    'meeting-link',
                                    meetingLink
                                ]
                            ]
                        })
                    })
                ]
            });
        })
    });
};
const $b5ce93e1775f73b6$var$calendarEventActionStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    gap: 'space.100'
});
const $b5ce93e1775f73b6$var$CalendarEventActions = ({ fromDate: fromDate, toDate: toDate, meetingLink: meetingLink, linkedEntities: linkedEntities })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [relatedEventsState, setEventsToDisplay] = (0, $42omo.useState)($b5ce93e1775f73b6$var$RELATED_EVENTS_STATE.CLOSED);
    const isUpcomingEventsSelected = relatedEventsState === $b5ce93e1775f73b6$var$RELATED_EVENTS_STATE.UPCOMING;
    const isPastEventsSelected = relatedEventsState === $b5ce93e1775f73b6$var$RELATED_EVENTS_STATE.PAST;
    const data = (0, $42omo.useMemo)(()=>{
        const currentDate = new Date();
        const linkedCalendarEvents = linkedEntities.flatMap((linkedEntity)=>linkedEntity.entity ? [
                {
                    title: linkedEntity.title,
                    url: linkedEntity.url,
                    entity: linkedEntity.entity
                }
            ] : []);
        const [pastEvents, upcomingEvents] = linkedCalendarEvents.reduce((events, currentEvent)=>{
            const isPastEvent = new Date(currentEvent.entity.eventStartTime) < currentDate;
            if (isPastEvent) return [
                events[0].concat(currentEvent),
                events[1]
            ];
            return [
                events[0],
                events[1].concat(currentEvent)
            ];
        }, [
            [],
            []
        ]);
        return {
            pastEvents: pastEvents,
            upcomingEvents: upcomingEvents
        };
    }, [
        linkedEntities
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
        gap: "space.200",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                xcss: $b5ce93e1775f73b6$var$calendarEventActionStyles,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)($b5ce93e1775f73b6$export$137e3167f558cbc3, {
                        fromDate: fromDate,
                        toDate: toDate,
                        meetingLink: meetingLink
                    }),
                    !!data.upcomingEvents.length && /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        iconAfter: (iconProps)=>isUpcomingEventsSelected ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                                ...iconProps,
                                size: "small"
                            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                                ...iconProps,
                                size: "small"
                            }),
                        onClick: ()=>setEventsToDisplay(isUpcomingEventsSelected ? $b5ce93e1775f73b6$var$RELATED_EVENTS_STATE.CLOSED : $b5ce93e1775f73b6$var$RELATED_EVENTS_STATE.UPCOMING),
                        isSelected: isUpcomingEventsSelected,
                        children: formatMessage((0, $28391d0ed56d0c04$export$defe85febe8b728c).upcomingEventsButton)
                    }),
                    !!data.pastEvents.length && /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        iconAfter: (iconProps)=>isPastEventsSelected ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                                ...iconProps,
                                size: "small"
                            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                                ...iconProps,
                                size: "small"
                            }),
                        onClick: ()=>setEventsToDisplay(isPastEventsSelected ? $b5ce93e1775f73b6$var$RELATED_EVENTS_STATE.CLOSED : $b5ce93e1775f73b6$var$RELATED_EVENTS_STATE.PAST),
                        isSelected: isPastEventsSelected,
                        children: formatMessage((0, $28391d0ed56d0c04$export$defe85febe8b728c).pastEventsButton)
                    })
                ]
            }),
            relatedEventsState === $b5ce93e1775f73b6$var$RELATED_EVENTS_STATE.UPCOMING && /*#__PURE__*/ (0, $l998X.jsx)($b5ce93e1775f73b6$var$RelatedCalendarEvents, {
                calendarEvents: data.upcomingEvents
            }),
            relatedEventsState === $b5ce93e1775f73b6$var$RELATED_EVENTS_STATE.PAST && /*#__PURE__*/ (0, $l998X.jsx)($b5ce93e1775f73b6$var$RelatedCalendarEvents, {
                calendarEvents: data.pastEvents
            })
        ]
    });
};
const $b5ce93e1775f73b6$export$2d6c717667f5157c = ({ partial: partial, position: position, icon: icon, product: product, onResultClicked: onResultClicked, onResultCtxMenuClicked: onResultCtxMenuClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, isAllProductSelected: isAllProductSelected, grouping3pCohort: grouping3pCohort })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const [{ cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const appMode = (0, $j4ply.useApplicationMode)();
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const { url: url, permissionLevel: permissionLevel, entity: entity, title: title, linkedEntities: linkedEntities, excerpt: excerpt } = partial;
    const calendarEvent = (0, $42omo.useMemo)(()=>{
        const eventTime = entity?.eventStartTime && entity?.eventEndTime ? (0, $428ad5ad3a150038$export$abc17c795ac8b09b)({
            from: entity?.eventStartTime,
            to: entity?.eventEndTime
        }) : null;
        const recurringEvent = entity?.recurringEventId ? formatMessage((0, $28391d0ed56d0c04$export$defe85febe8b728c).recurringMetadataLabel) : null;
        const getCreator = ()=>{
            const fullName = entity?.createdBy?.thirdPartyUser?.name || '';
            const firstName = fullName?.split(' ')?.[0] || formatMessage((0, $28391d0ed56d0c04$export$defe85febe8b728c).externalPerson);
            const actionLabel = formatMessage((0, $28391d0ed56d0c04$export$defe85febe8b728c).created, {
                person: firstName
            });
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                space: "space.025",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $678a8075b20296fe$export$3778be82376b06d7), {
                        name: fullName
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $b5ce93e1775f73b6$var$nameContainer,
                        children: actionLabel
                    })
                ]
            });
        };
        return {
            labelMessage: formatMessage((0, $28391d0ed56d0c04$export$defe85febe8b728c).eventLabel),
            eventTime: eventTime,
            recurringEvent: recurringEvent,
            createdBy: getCreator()
        };
    }, [
        entity,
        formatMessage
    ]);
    const eventDateComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $e050b981814f4361$export$10f53ee736dae147), {
        date: entity?.eventStartTime
    });
    const body = /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        paddingBlockEnd: "space.100",
        children: partial.description
    });
    const padlockIcon = (0, $Y34Hw.isNonPublic)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const headerMetadataParts = [
        calendarEvent.labelMessage,
        [
            'event-date',
            eventDateComponent
        ],
        [
            'event-time',
            calendarEvent.eventTime
        ],
        calendarEvent.recurringEvent,
        [
            'padlock',
            padlockIcon
        ],
        [
            'createdBy',
            calendarEvent.createdBy
        ]
    ];
    const isAllowedCohort = grouping3pCohort === 'enable-v2';
    const isFallbackCase = (grouping3pCohort === undefined || grouping3pCohort === 'control') && isAllProductSelected;
    const shouldShowLinkedResults = partial.linkedResults && partial.linkedResults.length > 0 && (isAllowedCohort || isFallbackCase);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: partial.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: excerpt ? (0, $Y34Hw.processExcerpt)(excerpt, true) : body
        }),
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial,
        appMode: appMode,
        footer: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: shouldShowLinkedResults ? /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
                linkedResults: partial.linkedResults || [],
                thirdPartyConfigs: thirdPartyConfigs,
                partial: partial,
                url: url,
                position: position,
                onResultClicked: onResultClicked || (()=>{}),
                onResultContextMenu: onResultCtxMenuClicked,
                isAllProductSelected: isAllProductSelected
            }) : /*#__PURE__*/ (0, $l998X.jsx)($b5ce93e1775f73b6$var$CalendarEventActions, {
                meetingLink: entity?.videoMeetingUrl,
                fromDate: entity?.eventStartTime,
                toDate: entity?.eventEndTime,
                linkedEntities: linkedEntities ?? []
            })
        }),
        hasRelatedLinks: shouldShowLinkedResults || false
    });
};





parcelRequire("42omo");



























const $d7e46d50a3345a17$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    resultLabel: {
        id: "comment-result.label",
        defaultMessage: "Comment"
    }
});


const $28a43cd9dc1edcd6$export$dabe1ea20b5cf75b = ({ partial: partial, icon: icon, product: product, position: position, onResultClicked: onResultClicked, onResultCtxMenuClicked: onResultCtxMenuClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, isAllProductSelected: isAllProductSelected })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [{ cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const appMode = (0, $j4ply.useApplicationMode)();
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const { lastModifiedDate: lastModifiedDate, url: url, title: title, excerpt: excerpt, entity: entity } = partial;
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const label = formatMessage((0, $d7e46d50a3345a17$export$defe85febe8b728c).resultLabel);
    const containerName = entity?.container?.displayName;
    const containerUrl = entity?.container?.url;
    const container = containerUrl && containerName ? /*#__PURE__*/ (0, $l998X.jsx)((0, $655681e89d0ffd52$export$2e2bcd8739ae039), {
        label: containerName,
        href: containerUrl
    }) : containerName;
    // only include site if DC product
    // NOTE: jira-dc results now go through JiraDcSearchResult component
    // this component can be removed once a custom ConfluenceDcSearchResult component is made
    const site = (()=>{
        if (product === 'jira-dc') {
            // For JiraDC, find the specific datasource by integrationId
            const resultDatasource = thirdPartyConfigs?.[product]?.datasources?.find((ds)=>ds.integrationId === partial.integrationId) || null;
            return resultDatasource?.workspaceName || thirdPartyConfigs?.[product]?.workspaceName || null;
        } else if (product === 'confluence-dc') // For ConfluenceDC, use the old method (main workspace name)
        return thirdPartyConfigs?.[product]?.workspaceName || null;
        return null;
    })();
    const metadataParts = [
        [
            'label',
            label
        ],
        [
            'site',
            site
        ],
        [
            'container',
            container
        ],
        [
            'lastModified',
            lastModifiedComponent
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: partial.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        headerMetadataParts: metadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: (0, $Y34Hw.processExcerpt)(excerpt)
        }),
        primaryProduct: primaryProduct,
        cloudId: cloudId,
        position: position,
        partial: partial,
        appMode: appMode,
        footer: /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
            linkedResults: partial.linkedResults || [],
            thirdPartyConfigs: thirdPartyConfigs,
            partial: partial,
            url: url,
            position: position,
            onResultClicked: onResultClicked || (()=>{}),
            onResultContextMenu: onResultCtxMenuClicked,
            isAllProductSelected: isAllProductSelected
        })
    });
};





parcelRequire("42omo");






























const $f6d1ee2961926251$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    resultLabel: {
        id: "github-commit-result.label",
        defaultMessage: "Commit"
    }
});


const $1dcf33d1bcde1fcc$export$35c708bc36dbd879 = ({ partial: partial, position: position, icon: icon, product: product, onResultClicked: onResultClicked, onResultCtxMenuClicked: onResultCtxMenuClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, isAllProductSelected: isAllProductSelected })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const [{ cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const appMode = (0, $j4ply.useApplicationMode)();
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, title: title, excerpt: excerpt, entity: entity } = partial;
    const { author: author, container: container } = entity || {};
    const label = formatMessage((0, $f6d1ee2961926251$export$defe85febe8b728c).resultLabel);
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const padlockIcon = (0, $Y34Hw.isNonPublic)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    let messageDescription;
    if (author?.user) messageDescription = /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
        space: "space.025",
        alignBlock: "start",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $678a8075b20296fe$export$3778be82376b06d7), {
                name: author.user.name,
                picture: author.user.picture
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                children: (0, $Y34Hw.processExcerpt)(excerpt, true, `${author.user.name}: `)
            })
        ]
    });
    else messageDescription = /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
        description: (0, $Y34Hw.processExcerpt)(excerpt, true)
    });
    const headerMetadataParts = [
        label,
        [
            'repository-name',
            container?.name ?? null
        ],
        [
            'padlock',
            padlockIcon
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: partial.id,
        product: product,
        productSelected: true,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: messageDescription,
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial,
        appMode: appMode,
        footer: /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
            linkedResults: partial.linkedResults || [],
            thirdPartyConfigs: thirdPartyConfigs,
            partial: partial,
            url: url,
            position: position,
            onResultClicked: onResultClicked || (()=>{}),
            onResultContextMenu: onResultCtxMenuClicked,
            isAllProductSelected: isAllProductSelected
        })
    });
};








































const $7700f068b01cef9b$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    pageLabel: {
        id: "confluence-data-center-search-result.document.pageLabel",
        defaultMessage: "Page"
    },
    spaceLabel: {
        id: "confluence-data-center-search-result.document.spaceLabel",
        defaultMessage: "Space"
    },
    blogpostLabel: {
        id: "confluence-data-center-search-result.document.blogpostLabel",
        defaultMessage: "Blog Post"
    },
    commentLabel: {
        id: "confluence-data-center-search-result.document.commentLabel",
        defaultMessage: "Comment"
    },
    attachmentLabel: {
        id: "confluence-data-center-search-result.document.attachmentLabel",
        defaultMessage: "Attachment"
    }
});


const $f96f5381b81323f1$var$SUBTYPE_PAGE = 'page';
const $f96f5381b81323f1$var$SUBTYPE_BLOGPOST = 'blogpost';
const $f96f5381b81323f1$var$LIKE_REACTION_TYPE = 'like';
const $f96f5381b81323f1$var$CONFLUENCE_DC_LABELS = {
    [$f96f5381b81323f1$var$SUBTYPE_PAGE]: (0, $7700f068b01cef9b$export$defe85febe8b728c).pageLabel,
    [$f96f5381b81323f1$var$SUBTYPE_BLOGPOST]: (0, $7700f068b01cef9b$export$defe85febe8b728c).blogpostLabel
};
const $f96f5381b81323f1$var$ATTACHMENT_SUBTYPES = [
    'archive',
    'audio',
    'code',
    'document',
    'image',
    'pdf',
    'presentation',
    'spreadsheet',
    'video',
    'web-page',
    'other'
];
const $f96f5381b81323f1$var$getLabel = (subtype)=>{
    if ($f96f5381b81323f1$var$ATTACHMENT_SUBTYPES.includes(subtype)) return (0, $7700f068b01cef9b$export$defe85febe8b728c).attachmentLabel;
    return $f96f5381b81323f1$var$CONFLUENCE_DC_LABELS[subtype];
};
const $f96f5381b81323f1$export$7582ed16f17b3410 = ({ partial: partial, position: position, product: product, onResultClicked: onResultClicked, onResultCtxMenuClicked: onResultCtxMenuClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked })=>{
    const [{ cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const appMode = (0, $j4ply.useApplicationMode)();
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const { lastModifiedDate: lastModifiedDate, url: url, title: title, excerpt: excerpt, subtype: subtype, entity: entity } = partial;
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const label = subtype ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...$f96f5381b81323f1$var$getLabel(subtype)
    }) : null;
    const site = thirdPartyConfigs?.[(0, $hB77E.ProductKeys3P).ConfluenceDC]?.workspaceName;
    const spaceName = entity?.container?.displayName;
    const spaceUrl = entity?.container?.url;
    const space = spaceUrl && spaceName ? /*#__PURE__*/ (0, $l998X.jsx)((0, $655681e89d0ffd52$export$2e2bcd8739ae039), {
        label: spaceName,
        href: spaceUrl
    }) : spaceName;
    const metadataParts = [
        [
            'label',
            label
        ],
        [
            'site',
            site
        ],
        [
            'space',
            space
        ],
        [
            'lastModified',
            lastModifiedComponent
        ]
    ];
    const getNumberOfLikes = (partial)=>{
        const likeReactionObject = partial.entity?.reactions?.find((reaction)=>reaction.reactionType?.toLowerCase() === $f96f5381b81323f1$var$LIKE_REACTION_TYPE);
        const numberOfLikes = likeReactionObject?.total ?? 0;
        if (numberOfLikes === 0) return null;
        return numberOfLikes;
    };
    const likeCount = (0, $42omo.useMemo)(()=>(0, $f70284887e2e1865$export$b52fa2ff0823604f)(getNumberOfLikes(partial)), [
        partial
    ]);
    const socialMetadataParts = [
        [
            'like-count',
            likeCount
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: partial.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.ConfluenceIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        headerMetadataParts: metadataParts,
        headerMetadataSocialParts: socialMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: (0, $Y34Hw.processExcerpt)(excerpt)
        }),
        primaryProduct: primaryProduct,
        cloudId: cloudId,
        position: position,
        partial: partial,
        appMode: appMode
    });
};





parcelRequire("42omo");










/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $e6pbP = parcelRequire("e6pbP");




function $4dd635508e197aad$export$7e4bcd4afb389edb(markdown) {
    if (!markdown) return ''; // Handle the case where markdown is null or undefined
    // Convert headers to plain text
    markdown = markdown.replace(/^#+\s*(.+?)\s*$/gm, '$1');
    // Convert bold and italic text to plain text
    markdown = markdown.replace(/\*\*(.+?)\*\*/g, '$1');
    markdown = markdown.replace(/__(.+?)__/g, '$1');
    markdown = markdown.replace(/\*(.+?)\*/g, '$1');
    markdown = markdown.replace(/_(.+?)_/g, '$1');
    // Convert strikethrough text to plain text
    markdown = markdown.replace(/~~(.+?)~~/g, '$1');
    // Convert inline code to plain text
    markdown = markdown.replace(/`(.+?)`/g, '$1');
    // Remove code blocks
    markdown = markdown.replace(/```[\s\S]*?/g, '');
    // Convert links to plain text by keeping only the link text
    markdown = markdown.replace(/\[(.+?)\]\((.+?)\)/g, '$1');
    // Convert autolinks to plain text
    markdown = markdown.replace(/<(?![@#]|!.*>)([^>|\s]+)>/g, '$1');
    // Handle autolinks with display text, like <http://example.com|example.com>
    markdown = markdown.replace(/<([^|>]+)\|([^>]+)>/g, '$2');
    // Fix broken autolinks
    markdown = markdown.replace(/<(?![@#]|!.*>)([^>|\s]+)>?/g, '$1');
    // Remove images, keeping only the alt text
    markdown = markdown.replace(/!\[(.+?)\]\((.+?)\)/g, '$1');
    // Remove blockquotes, preserving the quoted text
    markdown = markdown.replace(/^\s*>\s+(.+?)\s*$/gm, '$1');
    // Preserve list items as plain text, removing the list markers
    markdown = markdown.replace(/^\s*[\*\+-]\s+(.+?)\s*$/gm, '$1');
    markdown = markdown.replace(/^\s*\d+\.\s+(.+?)\s*$/gm, '$1');
    // Remove horizontal lines
    markdown = markdown.replace(/^\s*[-*_]{3,}\s*$/gm, '');
    // Replace multiple newlines with a single newline
    markdown = markdown.replace(/\n\s*\n/g, '\n');
    return markdown.trim();
}


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




const $67d6edeabc4ca933$var$SPACE = ' ';
const $67d6edeabc4ca933$var$channelStyle = null;
const $67d6edeabc4ca933$export$cfdacaa37f9b4dd7 = ({ children: children, associations: associations, noSpace: noSpace })=>{
    const channelId = children?.[0];
    const channelAssociation = associations?.filter((edge)=>edge?.node?.entity?.__typename === 'ExternalConversation').find((edge)=>Boolean(channelId) && channelId === edge.node.entity.channelId);
    if (!channelAssociation) return null;
    const entity = channelAssociation?.node?.entity;
    return /*#__PURE__*/ (0, $l998X.jsxs)("span", {
        className: (0, $gMc0m.default)([
            "_o5721q9c"
        ]),
        children: [
            noSpace ? '' : $67d6edeabc4ca933$var$SPACE,
            "#",
            entity?.displayName || channelAssociation?.node?.title
        ]
    });
};





parcelRequire("42omo");
















/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 








const $136ad0dff93ca4d5$var$styles = {
    root: "_2rko1rr0 _ca0qidpf _u5f3zjw7 _n3tdyh40 _19bv1poh _vchhusvi _syazazsu _bfhki8nm _uiztglyw _o5721jtm _80omtlke _irr3plhp",
    focusRing: "_ymio1r31 _ypr0glyw _zcxs1o36 _nt751v1w _mizu1v1w _1bg4v77o _1ah3v77o _49pcnqa1 _ra3xnqa1 _1hvwdkaa _128mdkaa _qa7m1r31 _1cvmnqa1 _4davt94y"
};
const $136ad0dff93ca4d5$export$e891316fea657d90 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ name: name, prefix: prefix = '@', testId: testId, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("span", {
        ...htmlAttributes,
        "data-testid": testId,
        ref: ref,
        className: (0, $gMc0m.default)([
            $136ad0dff93ca4d5$var$styles.root,
            $136ad0dff93ca4d5$var$styles.focusRing
        ]),
        children: [
            prefix,
            name
        ]
    });
});


const $f3accdd0219154ae$export$4d833b6a2de3de88 = ({ isOpen: open = false, content: content, ...mentionProps })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(open);
    (0, $42omo.useEffect)(()=>setIsOpen(open), [
        open
    ]);
    function handleKeyPress(event) {
        if (event.code === 'Space' || event.code === 'Enter' || event.code === 'NumpadEnter') {
            event.preventDefault();
            setIsOpen((isOpenState)=>!isOpenState);
        }
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $136ad0dff93ca4d5$export$e891316fea657d90), {
                role: "button",
                tabIndex: 0,
                onClick: ()=>setIsOpen((open)=>!open),
                onKeyUp: (event)=>handleKeyPress(event),
                ...mentionProps,
                ...triggerProps
            }),
        content: (contentProps)=>content({
                ...mentionProps,
                ...contentProps
            })
    });
};









const $da00d5b2bdfcf57e$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    externalPersonLabel: {
        id: "search-result.user-mention.external-person",
        defaultMessage: "External person"
    }
});


/**
 * The whitespace in between aliases <!here> <!channel> is removed
 * This constant prevent the alias from being pushed together ex: "@here@channel"
 * We are using this constant rather than adding a space through CSS because it adds
 * a real space character that does not break up the text when selecting.
 * */ const $d5c75e15b5879fe7$var$SPACE = ' ';
const $d5c75e15b5879fe7$export$6ae462bff574866a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("span", {
        children: [
            $d5c75e15b5879fe7$var$SPACE,
            "@",
            children
        ]
    });
};
const $d5c75e15b5879fe7$export$85d6e42a90e882cb = ({ children: children, associations: associations, integrationId: integrationId, allContributors: allContributors })=>{
    const userId = children?.[0];
    let name;
    let entity;
    if ((0, $dh538.fg)('exclude_3p_entity_in_search_results')) entity = allContributors?.find((contributor)=>Boolean(userId) && userId === contributor?.externalId);
    else {
        const userAssociation = associations?.find((edge)=>Boolean(userId) && userId === edge?.node?.entity?.externalId);
        entity = userAssociation?.node?.entity;
    }
    name = entity?.nickname || entity?.name;
    const email = entity?.email;
    const copyToClipboard = (0, $6a8b466b77e29197$export$b2199c37e85de4a7)(email);
    if (entity && name) {
        const user = (0, $Y34Hw.getUserData)(entity);
        if (user) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                $d5c75e15b5879fe7$var$SPACE,
                /*#__PURE__*/ (0, $l998X.jsx)((0, $f3accdd0219154ae$export$4d833b6a2de3de88), {
                    name: name,
                    content: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $168e8abba0f0ce48$export$4c094c8f61edecb4), {
                            onCopyEmail: copyToClipboard,
                            user: user,
                            externalMessageIntegration: (0, $Y34Hw.getExternalMessageDmIntegrationInfo)(integrationId, entity)
                        })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)($d5c75e15b5879fe7$export$6ae462bff574866a, {
        children: name || /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $da00d5b2bdfcf57e$export$defe85febe8b728c).externalPersonLabel
        })
    });
};


/**
 * The whitespace in between aliases <!here> <!channel> is removed
 * This constant prevent the alias from being pushed together ex: "@here@channel"
 * We are using this constant rather than adding a space through CSS because it adds
 * a real space character that does not break up the text when selecting.
 * */ const $83bd5e81ca6cbfef$var$SPACE = ' ';
const $83bd5e81ca6cbfef$export$95e34c5d2bf14b09 = (inputString)=>{
    if (!inputString) return '';
    const processed = (0, $4dd635508e197aad$export$7e4bcd4afb389edb)(inputString)// removing * or _, which can cause massive slowdown when processed by markdown-to-jsx's Markdown component
    .replace(/[*_]/g, '')//Slack User
    .replace(/<@(\w+)>/g, '<Mention>$1</Mention>')//Teams User
    .replace(/<@([a-zA-Z0-9-]+)>/g, '<Mention>$1</Mention>')//Slack Channel
    .replace(/<#(\w+)\|?>/g, '<Channel>$1</Channel>')//Teams Channel variation 1
    .replace(/<#teamId\/[a-f0-9-]+\/channelId\/teamId\/([a-f0-9-]+)\/channelId\/([0-9a-zA-Z:@._-]+)>/g, '<Channel>teamId/$1/channelId/$2</Channel>')// Teams Channel variation 2
    .replace(/<[@#]teamId\/([a-f0-9-]+)\/channelId\/([0-9a-zA-Z:@._-]+)>/g, '<Channel>teamId/$1/channelId/$2</Channel>').replace(/<\!subteam\^(\w+)>/g, '<Subteam>$1</Subteam>').replace(/<\!(\w+)>/g, '<Alias>$1</Alias>')// emojis, works for those that have repeating pattern as well. eg: :word-word-word:
    .replace(/:((@@@hl@@@.+?@@@endhl@@@)(-@@@hl@@@.+?@@@endhl@@@)*):/g, (match)=>{
        const words = match.match(/@@@hl@@@(.+?)@@@endhl@@@/g)?.map((m)=>m.replace(/@@@hl@@@|@@@endhl@@@/g, '')) || [];
        return `<Highlight>:${words.join('-')}:</Highlight>`;
    }).replace(/@@@hl@@@(.+?)@@@endhl@@@/g, '<Highlight>$1</Highlight>').replace(/<@<Highlight>(.+?)<\/Highlight>>/g, '<Highlight><Mention>$1</Mention></Highlight>').replace(/<#<Highlight>(.+?)<\/Highlight>\|>/g, '<Highlight><Channel>$1</Channel></Highlight>');
    // .replace(/\:(\w+)\:/g, '<Emoji>$1</Emoji>') Support for emojis coming soon
    // Check if the processed string starts with a channel tag and replace the first occurrence with ChannelWithoutSpace
    if (processed.startsWith('<Highlight><Channel>')) return processed.replace('<Highlight><Channel>', '<HighlightWithoutSpace><ChannelWithoutSpace>').replace('</Channel></Highlight>', '</ChannelWithoutSpace></HighlightWithoutSpace>');
    // Check if the processed string starts with a highlight tag and replace the first occurrence with HighlightWithoutSpace
    if (processed.startsWith('<Highlight>')) return processed.replace('<Highlight>', '<HighlightWithoutSpace>').replace('</Highlight>', '</HighlightWithoutSpace>');
    return processed;
};
const $83bd5e81ca6cbfef$var$PlainText = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
const $83bd5e81ca6cbfef$var$Highlight = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
        as: "strong",
        children: [
            $83bd5e81ca6cbfef$var$SPACE,
            children
        ]
    });
const $83bd5e81ca6cbfef$var$HighlightWithoutSpace = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
        as: "strong",
        children: children
    });
const $83bd5e81ca6cbfef$var$ChannelWithoutSpace = ({ children: children, ...props })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $67d6edeabc4ca933$export$cfdacaa37f9b4dd7), {
        ...props,
        noSpace: true,
        children: children
    });
const $83bd5e81ca6cbfef$export$bf780c85e04b8810 = (excerpt, description)=>{
    if (excerpt.length === 0 || description.length === 0 || excerpt === description) return excerpt;
    var modifiedExcerpt = excerpt;
    // regex which has the starting tag of a mention, but not the end
    const startTagRegex = /<[@#][^> ]*$/g;
    const startTagMatch = modifiedExcerpt.match(startTagRegex);
    if (startTagMatch) {
        // theoretically, there should only be one match at max
        const partialMention = startTagMatch[startTagMatch.length - 1];
        // the partialMention can appear several times in the string. We need to find the correct one
        const partialMentionInExcerptCount = excerpt.split(partialMention).length - 1;
        const splitDescription = description.split(partialMention);
        // check if partial mention is found in description
        if (splitDescription.length >= 2) {
            const splitByClosingTag = splitDescription[partialMentionInExcerptCount].split('>');
            // check if closing tag is found
            if (splitByClosingTag.length >= 2) {
                const restOfString = splitByClosingTag[0];
                modifiedExcerpt = modifiedExcerpt + restOfString + '>';
            }
        }
    }
    // const endTagRegex = /^[^< ]*\.tacv2>/g; This works on channel mentions that I have observed
    // weaker regex which tries to capture the ending tag of a mention (assuming it always ends with >), but not the start
    const weakEndTagRegex = /^[^< ]*>/g;
    const weakEndTagMatch = modifiedExcerpt.match(weakEndTagRegex);
    if (weakEndTagMatch) {
        // theoretically, there should only be one match at max
        const partialMention = weakEndTagMatch[0];
        const splitDescription = description.split(partialMention);
        // partialMention not found in description
        if (splitDescription.length >= 2) {
            const splitByOpeningTag = splitDescription[0].split('<');
            // opening tag found
            if (splitByOpeningTag.length >= 2) {
                const restOfString = splitByOpeningTag[splitByOpeningTag.length - 1];
                modifiedExcerpt = '<' + restOfString + modifiedExcerpt;
            }
        }
    }
    return modifiedExcerpt;
};
const $83bd5e81ca6cbfef$export$41910d2944957acd = (body)=>{
    const hlStartTag = '@@@hl@@@';
    // if cannot find hl tag, return the original body
    if (!body.includes('@@@hl@@@')) return body;
    const highlightStringAndRemainder = body.substring(body.indexOf(hlStartTag));
    let cursorPosition = body.indexOf(hlStartTag) - 1;
    let numChars = 0;
    let prefix = '';
    let currentWord = '';
    let numWords = 0;
    // get all words before cursorPosition, less than 15 characters
    while(numChars < 15 && cursorPosition > 0){
        currentWord = body[cursorPosition] + currentWord;
        cursorPosition--;
        numChars++;
        if (body[cursorPosition] === ' ') {
            prefix = currentWord + prefix;
            currentWord = '';
            numWords++;
        }
    }
    if (cursorPosition <= 0) return body;
    else if (numWords === 0) return '...' + currentWord + highlightStringAndRemainder;
    else return '...' + prefix + highlightStringAndRemainder;
};
const $83bd5e81ca6cbfef$export$a2b4a2fe7cc1ea4c = ({ partial: partial, integrationId: integrationId })=>{
    // in ConversationSearchResult, partial.excerpt is used as the body
    if (partial.excerpt) partial.excerpt = $83bd5e81ca6cbfef$export$bf780c85e04b8810(partial.excerpt, partial?.entity?.description ?? '');
    let body = partial.excerpt || partial?.entity?.description || '';
    body = $83bd5e81ca6cbfef$export$41910d2944957acd(body);
    /**
   * Even though we remove markdown from the body, we still use this component
   * to render mentions and highlighted text */ return /*#__PURE__*/ (0, $l998X.jsx)((0, $e6pbP.default), {
        options: {
            forceInline: true,
            overrides: {
                a: $83bd5e81ca6cbfef$var$PlainText,
                Highlight: $83bd5e81ca6cbfef$var$Highlight,
                HighlightWithoutSpace: $83bd5e81ca6cbfef$var$HighlightWithoutSpace,
                Alias: (0, $d5c75e15b5879fe7$export$6ae462bff574866a),
                Mention: {
                    component: (0, $d5c75e15b5879fe7$export$85d6e42a90e882cb),
                    props: {
                        associations: partial?.entity?.associatedWith?.edges,
                        integrationId: integrationId,
                        allContributors: partial?.allContributors
                    }
                },
                Channel: {
                    component: (0, $67d6edeabc4ca933$export$cfdacaa37f9b4dd7),
                    props: {
                        associations: partial?.entity?.associatedWith?.edges
                    }
                },
                ChannelWithoutSpace: {
                    component: $83bd5e81ca6cbfef$var$ChannelWithoutSpace,
                    props: {
                        associations: partial?.entity?.associatedWith?.edges
                    }
                }
            }
        },
        children: $83bd5e81ca6cbfef$export$95e34c5d2bf14b09(body)
    });
};















const $073d996bdfc881b1$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    label: {
        id: "search-page.results.product-results.third-party.conversation-search-result.label",
        defaultMessage: "Channel"
    },
    memberCount: {
        id: "search-page.results.product-results.third-party.conversation-search-result.member-count",
        defaultMessage: "{count, plural, one {# member} other {# members}}"
    },
    lastActive: {
        id: "search-page.results.product-results.third-party.conversation-search-result.time-since-label",
        defaultMessage: "Last active {formattedDate}"
    },
    unknownChannel: {
        id: "search-page.results.product-results.third-party.conversation-search-result.unknown-channel",
        defaultMessage: "unknown-channel"
    },
    privateChannel: {
        id: "search-page.results.product-results.third-party.conversation-search-result.private-channel",
        defaultMessage: "Private channel"
    }
});


const $2762432c767ed179$export$4534f971846d5b0b = ({ partial: partial, icon: icon, position: position, onClick: onClick, onClickCtxMenu: onClickCtxMenu, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, product: product, cloudId: cloudId, isAllProductSelected: isAllProductSelected })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { entity: entity, url: url } = partial;
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const appMode = (0, $j4ply.useApplicationMode)();
    const [{ thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const memberCount = entity?.memberCount || entity?.members?.length;
    const parts = [
        [
            'label',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $073d996bdfc881b1$export$a7357cdd1f0b0168).label
            })
        ],
        [
            'memberCount',
            memberCount && /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $073d996bdfc881b1$export$a7357cdd1f0b0168).memberCount,
                values: {
                    count: memberCount
                }
            })
        ]
    ];
    let privateChannelName;
    if (partial.subtype === 'private-channel') privateChannelName = /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
                label: formatMessage((0, $073d996bdfc881b1$export$a7357cdd1f0b0168).privateChannel),
                size: "small"
            }),
            entity?.displayName
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: partial.id,
        product: product,
        productSelected: true,
        onResultClicked: onClick,
        onResultContextMenu: onClickCtxMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $83bd5e81ca6cbfef$export$a2b4a2fe7cc1ea4c), {
            partial: partial,
            integrationId: partial.integrationId
        }),
        icon: icon,
        headerMetadataParts: parts,
        title: privateChannelName || `#${entity?.displayName || formatMessage((0, $073d996bdfc881b1$export$a7357cdd1f0b0168).unknownChannel)}`,
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial,
        appMode: appMode,
        footer: /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
            linkedResults: partial.linkedResults || [],
            thirdPartyConfigs: thirdPartyConfigs,
            partial: partial,
            url: url,
            position: position,
            onResultClicked: onClick,
            onResultContextMenu: onClickCtxMenu,
            isAllProductSelected: isAllProductSelected
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");

































const $d210c14c6aeee743$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    eventLabel: {
        id: "customer-org-search-result.customer-org-label",
        defaultMessage: "Customer Organization"
    }
});


const $3fd3fe1407893067$var$subheadingStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body'
});
const $3fd3fe1407893067$export$6a520dc8ab8b1037 = ({ partial: partial, position: position, icon: icon, product: product, onResultClicked: onResultClicked, onResultCtxMenuClicked: onResultCtxMenuClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, isAllProductSelected: isAllProductSelected })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const [{ cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const appMode = (0, $j4ply.useApplicationMode)();
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const { url: url, entity: entity, title: title, lastModifiedDate: lastModifiedDate } = partial;
    const lastModifiedComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    });
    const getOwnerName = ()=>{
        if (entity?.contributors?.length && entity.contributors[0]?.thirdPartyUser?.name) return entity?.contributors[0].thirdPartyUser.name;
    };
    const body = /*#__PURE__*/ (0, $l998X.jsx)((0, $1GzhS.default), {
        children: entity?.customerOrgLastActivity?.event
    });
    const description = /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
                description: body
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $3fd3fe1407893067$var$subheadingStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                    lastModified: entity?.customerOrgLastActivity?.lastActivityAt
                })
            })
        ]
    });
    const parent = entity?.parent?.displayName;
    const headerMetadataParts = [
        formatMessage((0, $d210c14c6aeee743$export$defe85febe8b728c).eventLabel),
        [
            'parent',
            parent
        ],
        [
            'owner',
            getOwnerName()
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: partial.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: description,
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial,
        appMode: appMode,
        footer: /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
            linkedResults: partial.linkedResults || [],
            thirdPartyConfigs: thirdPartyConfigs,
            partial: partial,
            url: url,
            position: position,
            onResultClicked: onResultClicked || (()=>{}),
            onResultContextMenu: onResultCtxMenuClicked,
            isAllProductSelected: isAllProductSelected
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");
























const $793d93322aa57700$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    eventLabel: {
        id: "dashboard-search-result.dashboard-label",
        defaultMessage: "Dashboard"
    }
});


const $15499219b9c2bd65$export$30a1341f2d7490be = ({ partial: partial, position: position, icon: icon, product: product, onResultClicked: onResultClicked, onResultCtxMenuClicked: onResultCtxMenuClicked })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const [{ cloudId: cloudId }] = (0, $j4ply.useBootstrap)();
    const appMode = (0, $j4ply.useApplicationMode)();
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const { url: url, entity: entity, title: title, lastModifiedDate: lastModifiedDate, excerpt: excerpt } = partial;
    const lastModifiedComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    });
    const getOwnerName = ()=>{
        if (!entity?.owners || !Array.isArray(entity.owners) || entity.owners.length === 0) return undefined;
        return entity.owners[0]?.thirdPartyUser?.name;
    };
    const workspaceName = entity?.workspaceName;
    const ownerName = getOwnerName();
    const headerMetadataParts = [
        formatMessage((0, $793d93322aa57700$export$defe85febe8b728c).eventLabel),
        [
            'workspaceName',
            workspaceName
        ],
        ...workspaceName && ownerName && workspaceName === ownerName ? [] : ownerName ? [
            [
                'owner',
                ownerName
            ]
        ] : [],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: partial.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        icon: icon,
        description: (0, $Y34Hw.processExcerpt)(excerpt),
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial,
        appMode: appMode
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");
























const $2b90caab10bb075f$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    eventLabel: {
        id: "data-table-search-result.data-table-label",
        defaultMessage: "Data Table"
    }
});


const $c4099c5d258f55d7$export$e73a42f27181882e = ({ partial: partial, position: position, icon: icon, product: product, onResultClicked: onResultClicked, onResultCtxMenuClicked: onResultCtxMenuClicked })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const [{ cloudId: cloudId }] = (0, $j4ply.useBootstrap)();
    const appMode = (0, $j4ply.useApplicationMode)();
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const { url: url, entity: entity, title: title, lastModifiedDate: lastModifiedDate, excerpt: excerpt } = partial;
    const lastModifiedComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    });
    const getOwnerName = ()=>{
        if (!entity?.owners || !Array.isArray(entity.owners) || entity.owners.length === 0) return undefined;
        return entity.owners[0]?.thirdPartyUser?.name;
    };
    const workspaceName = entity?.workspaceName;
    const ownerName = getOwnerName();
    const headerMetadataParts = [
        formatMessage((0, $2b90caab10bb075f$export$defe85febe8b728c).eventLabel),
        [
            'type',
            entity?.dataTableType
        ],
        [
            'workspaceName',
            workspaceName
        ],
        ...workspaceName && ownerName && workspaceName === ownerName ? [] : ownerName ? [
            [
                'owner',
                ownerName
            ]
        ] : [],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: partial.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        icon: icon,
        description: (0, $Y34Hw.processExcerpt)(excerpt),
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial,
        appMode: appMode
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 





















































const $5464230a7e3983de$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    eventLabel: {
        id: "deal-search-result.deal-label",
        defaultMessage: "Deal"
    },
    closedOn: {
        id: "deal-search-result.closed-on",
        defaultMessage: "Closed on {date}"
    }
});


const $364d352cbc6abda4$var$contentStyles = (0, $ecnYn.xcss)({
    padding: 'space.200'
});
const $364d352cbc6abda4$var$subheadingStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body'
});
const $364d352cbc6abda4$export$2ce7c47bd245eb7e = ({ partial: partial, position: position, icon: icon, product: product, onResultClicked: onResultClicked, onResultCtxMenuClicked: onResultCtxMenuClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, isAllProductSelected: isAllProductSelected })=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $8C5kA.default)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const [{ cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const appMode = (0, $j4ply.useApplicationMode)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const { url: url, entity: entity, title: title, lastModifiedDate: lastModifiedDate, allContributors: allContributors } = partial;
    const lastModifiedComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    });
    const formattedDate = entity?.dealClosedAt ? formatDate(new Date(entity.dealClosedAt), {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    }) : '';
    const closeOnDateComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $364d352cbc6abda4$var$contentStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $5464230a7e3983de$export$defe85febe8b728c).closedOn,
            values: {
                date: formattedDate
            }
        })
    });
    const body = /*#__PURE__*/ (0, $l998X.jsx)((0, $1GzhS.default), {
        children: entity?.lastActivity?.event
    });
    const description = /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
                description: body
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $364d352cbc6abda4$var$subheadingStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                    lastModified: entity?.lastActivity?.lastActivityAt
                })
            })
        ]
    });
    const getOwnerName = ()=>{
        if (allContributors?.length && allContributors[0]?.name) return allContributors[0].name;
    };
    const stageText = entity?.stage || '';
    const parent = entity?.parent?.displayName;
    const truncatedStageText = stageText.length > 20 ? `${stageText.slice(0, 20)}...` : stageText;
    const headerMetadataParts = [
        formatMessage((0, $5464230a7e3983de$export$defe85febe8b728c).eventLabel),
        [
            'parent',
            parent
        ],
        [
            'owner',
            getOwnerName()
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
        gap: "space.100",
        justifyContent: "start",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
                id: partial.id,
                product: product,
                productSelected: !!selectedProduct,
                onResultClicked: onResultClicked,
                onResultContextMenu: onResultCtxMenuClicked,
                onCopyLinkButtonClicked: onCopyLinkButtonClicked,
                onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
                onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
                onContextMenuButtonClicked: onContextMenuButtonClicked,
                icon: icon,
                description: description,
                headerMetadataParts: headerMetadataParts,
                title: (0, $Y34Hw.enrichExcerpt)(title),
                url: url,
                isThirdParty: true,
                cloudId: cloudId,
                primaryProduct: primaryProduct,
                position: position,
                partial: partial,
                appMode: appMode,
                footer: /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
                    linkedResults: partial.linkedResults || [],
                    thirdPartyConfigs: thirdPartyConfigs,
                    partial: partial,
                    url: url,
                    position: position,
                    onResultClicked: onResultClicked || (()=>{}),
                    onResultContextMenu: onResultCtxMenuClicked,
                    isAllProductSelected: isAllProductSelected
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
                isOpen: isOpen,
                onClose: ()=>setIsOpen(false),
                placement: "right-start",
                content: ()=>closeOnDateComponent,
                trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                        content: stageText,
                        position: "auto",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            ...triggerProps,
                            isSelected: isOpen,
                            appearance: "subtle",
                            spacing: "compact",
                            onClick: ()=>setIsOpen(!isOpen),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                paddingInlineStart: "space.800",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                                    children: truncatedStageText
                                })
                            })
                        })
                    })
            })
        ]
    });
};





parcelRequire("42omo");















/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss



parcelRequire("42omo");











const $2853273f3c22f618$var$thumbnailContainerStyles = (0, $ecnYn.xcss)({
    gridArea: 'body'
});
const $2853273f3c22f618$var$thumbnailImageStyles = null;
const $2853273f3c22f618$var$descriptionLinkStyles = (0, $ecnYn.xcss)({
    display: 'inline-block'
});
const $2853273f3c22f618$export$9acaedfb553281a4 = ({ resultUrl: resultUrl, thumbnailUrl: thumbnailUrl })=>thumbnailUrl ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
        xcss: [
            $2853273f3c22f618$var$descriptionLinkStyles
        ],
        rel: 'noreferrer',
        target: '_blank',
        href: resultUrl,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            testId: "thumbnail-container",
            xcss: $2853273f3c22f618$var$thumbnailContainerStyles,
            children: /*#__PURE__*/ (0, $l998X.jsx)("img", {
                src: thumbnailUrl,
                className: (0, $gMc0m.default)([
                    "_2rko1qi0 _189e1dm9 _1dqonqa1 _1h6d1gmx _5ral1dfr _4t3i1et3 _1bsb194s"
                ])
            })
        })
    }) : null;















const $1ef17cac32d52f0b$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    task: {
        id: "search-page.task.label",
        defaultMessage: "Task"
    },
    dashboard: {
        id: "search-page.dashboard.label",
        defaultMessage: "Dashboard"
    },
    invoice: {
        id: "search-page.invoice.label",
        defaultMessage: "Invoice"
    },
    design: {
        id: "search-page.design.label",
        defaultMessage: "Design"
    },
    deal: {
        id: "search-page.deal.label",
        defaultMessage: "Deal"
    }
});


const $0e85201f3bca4c56$var$footerContainer = (0, $ecnYn.xcss)({
    paddingTop: 'space.100'
});
const $0e85201f3bca4c56$var$typeLabelContainer = (0, $ecnYn.xcss)({
    '::first-letter': {
        textTransform: 'capitalize'
    }
});
const $0e85201f3bca4c56$var$getLabel = (entityNoun)=>entityNoun.replace(/-/g, ' ');
const $0e85201f3bca4c56$export$2917a391c04f0e93 = ({ icon: icon, partial: partial, position: position, entityType: entityType, product: product, onResultClicked: onResultClicked, onResultCtxMenuClicked: onResultCtxMenuClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, isAllProductSelected: isAllProductSelected, grouping3pCohort: grouping3pCohort })=>{
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const [{ cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const appMode = (0, $j4ply.useApplicationMode)();
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, title: title, excerpt: excerpt, entity: entity } = partial;
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const resultType = partial.subtype || entityType;
    const labelMessage = (0, $1ef17cac32d52f0b$export$defe85febe8b728c)[resultType];
    const label = resultType && labelMessage ? formatMessage(labelMessage) : $0e85201f3bca4c56$var$getLabel(resultType);
    const isNotPublic = (0, $Y34Hw.isNonPublic)(permissionLevel);
    const headerMetadataParts = [
        [
            'label',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $0e85201f3bca4c56$var$typeLabelContainer,
                children: label
            })
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    const hasThumbnail = entity && 'thumbnail' in entity && entity.thumbnail?.externalUrl && !(0, $Y34Hw.isAWSThumbnailUrlExpired)(entity.thumbnail.externalUrl);
    const isAllowedCohort = grouping3pCohort === 'enable-v2';
    const isFallbackCase = (grouping3pCohort === undefined || grouping3pCohort === 'control') && isAllProductSelected;
    const shouldShowLinkedResults = partial.linkedResults && partial.linkedResults.length > 0 && (isAllowedCohort || isFallbackCase);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: partial.id,
        product: product,
        productSelected: true,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        description: hasThumbnail ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2853273f3c22f618$export$9acaedfb553281a4), {
            resultUrl: url,
            thumbnailUrl: entity.thumbnail?.externalUrl
        }) : (0, $Y34Hw.processExcerpt)(excerpt),
        icon: icon,
        headerMetadataParts: headerMetadataParts,
        footer: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: shouldShowLinkedResults ? /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
                linkedResults: partial.linkedResults || [],
                thirdPartyConfigs: thirdPartyConfigs,
                partial: partial,
                position: position,
                url: url,
                onResultClicked: onResultClicked || (()=>{}),
                onResultContextMenu: onResultCtxMenuClicked,
                isAllProductSelected: isAllProductSelected
            }) : isNotPublic && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $0e85201f3bca4c56$var$footerContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5c2df34c79a6120f$export$3eac322cb0b365da), {
                    restriction: permissionLevel
                })
            })
        }),
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial,
        appMode: appMode,
        hasRelatedLinks: shouldShowLinkedResults || false
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");



























const $fe4a29aedee42070$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    designLabel: {
        id: "design-search-result.label",
        defaultMessage: "Design"
    }
});


const $41177e6a92ed5d4f$export$f6a73210de3b9a3b = ({ partial: partial, position: position, icon: icon, product: product, onResultClicked: onResultClicked, onResultCtxMenuClicked: onResultCtxMenuClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, isAllProductSelected: isAllProductSelected })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const [{ cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const appMode = (0, $j4ply.useApplicationMode)();
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, entity: entity, title: title } = partial;
    const thumbnailUrl = entity?.thumbnail?.externalUrl;
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const label = formatMessage((0, $fe4a29aedee42070$export$defe85febe8b728c).designLabel);
    const hasThumbnail = thumbnailUrl && !(0, $Y34Hw.isAWSThumbnailUrlExpired)(thumbnailUrl);
    const body = hasThumbnail ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2853273f3c22f618$export$9acaedfb553281a4), {
        resultUrl: url,
        thumbnailUrl: thumbnailUrl
    }) : null;
    const padlockIcon = (0, $Y34Hw.isNonPublic)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const headerMetadataParts = [
        label,
        [
            'last-modified',
            lastModifiedComponent
        ],
        [
            'padlock',
            padlockIcon
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: partial.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: body,
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial,
        appMode: appMode,
        footer: /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
            linkedResults: partial.linkedResults || [],
            thirdPartyConfigs: thirdPartyConfigs,
            partial: partial,
            position: position,
            url: url,
            onResultClicked: onResultClicked || (()=>{}),
            onResultContextMenu: onResultCtxMenuClicked,
            isAllProductSelected: isAllProductSelected
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars



parcelRequire("42omo");




















var $hP2yW = parcelRequire("hP2yW");


























const $5d5fc8de1ce32f50$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    googleDocsLabel: {
        id: "document-search-result.google-docs-label",
        defaultMessage: "Docs"
    },
    googleSlidesLabel: {
        id: "document-search-result.google-slides-label",
        defaultMessage: "Slides"
    },
    googleSheetsLabel: {
        id: "document-search-result.google-sheets-label",
        defaultMessage: "Sheets"
    },
    msWordLabel: {
        id: "document-search-result.ms-word-label",
        defaultMessage: "Word"
    },
    msPowerpointLabel: {
        id: "document-search-result.ms-powerpoint-label",
        defaultMessage: "PowerPoint"
    },
    msExcelLabel: {
        id: "document-search-result.ms-excel-label",
        defaultMessage: "Excel"
    }
});


const $8bcca2b8218ceda1$var$footerContainer = (0, $ecnYn.xcss)({
    paddingTop: 'space.100'
});
const $8bcca2b8218ceda1$var$contentIconStyles = null;
const $8bcca2b8218ceda1$var$outerContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    height: 'size.100',
    maxWidth: '246px' // Specified in the design
});
const $8bcca2b8218ceda1$var$parentNameStyles = (0, $ecnYn.xcss)({
    display: 'inline-block',
    overflow: 'hidden',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtlest',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
const $8bcca2b8218ceda1$var$typeLabelContainer = (0, $ecnYn.xcss)({
    '::first-letter': {
        textTransform: 'capitalize'
    }
});
const $8bcca2b8218ceda1$var$GOOGLE_INTEGRATION_KEY = 'google';
const $8bcca2b8218ceda1$var$MICROSOFT_INTEGRATION_KEY = 'microsoft';
const $8bcca2b8218ceda1$var$SUBTYPE_DOCUMENT = 'document';
const $8bcca2b8218ceda1$var$SUBTYPE_PRESENTATION = 'presentation';
const $8bcca2b8218ceda1$var$SUBTYPE_SPREADSHEET = 'spreadsheet';
const $8bcca2b8218ceda1$var$GOOGLE_LABELS = {
    [$8bcca2b8218ceda1$var$SUBTYPE_DOCUMENT]: (0, $5d5fc8de1ce32f50$export$defe85febe8b728c).googleDocsLabel,
    [$8bcca2b8218ceda1$var$SUBTYPE_PRESENTATION]: (0, $5d5fc8de1ce32f50$export$defe85febe8b728c).googleSlidesLabel,
    [$8bcca2b8218ceda1$var$SUBTYPE_SPREADSHEET]: (0, $5d5fc8de1ce32f50$export$defe85febe8b728c).googleSheetsLabel
};
const $8bcca2b8218ceda1$var$MICROSOFT_LABELS = {
    [$8bcca2b8218ceda1$var$SUBTYPE_DOCUMENT]: (0, $5d5fc8de1ce32f50$export$defe85febe8b728c).msWordLabel,
    [$8bcca2b8218ceda1$var$SUBTYPE_PRESENTATION]: (0, $5d5fc8de1ce32f50$export$defe85febe8b728c).msPowerpointLabel,
    [$8bcca2b8218ceda1$var$SUBTYPE_SPREADSHEET]: (0, $5d5fc8de1ce32f50$export$defe85febe8b728c).msExcelLabel
};
const $8bcca2b8218ceda1$var$getDocumentSubtypeLabel = ({ product: product, subtype: subtype })=>{
    if (!subtype) return;
    let label;
    if (product === $8bcca2b8218ceda1$var$GOOGLE_INTEGRATION_KEY) label = $8bcca2b8218ceda1$var$GOOGLE_LABELS[subtype];
    if (product === $8bcca2b8218ceda1$var$MICROSOFT_INTEGRATION_KEY) label = $8bcca2b8218ceda1$var$MICROSOFT_LABELS[subtype];
    return label;
};
const $8bcca2b8218ceda1$var$getParentName = (partial)=>{
    const parentName = partial.entity?.parent?.displayName;
    if (!parentName) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
        xcss: $8bcca2b8218ceda1$var$outerContainerStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
            xcss: $8bcca2b8218ceda1$var$parentNameStyles,
            children: parentName
        })
    });
};
const $8bcca2b8218ceda1$export$43fa1bdcdc4d31ed = ({ icon: icon, partial: partial, position: position, product: product, onResultClicked: onResultClicked, onResultCtxMenuClicked: onResultCtxMenuClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, isAllProductSelected: isAllProductSelected, grouping3pCohort: grouping3pCohort })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [{ cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, title: title, excerpt: excerpt, subtype: subtype, entity: entity } = partial;
    const appMode = (0, $j4ply.useApplicationMode)();
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle'); // This is done for Pio for Team 25
    const contentIcon = selectedProduct === 'gitbook' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $hP2yW.GitbookIcon), {}) : entity?.type?.iconUrl ? /*#__PURE__*/ (0, $l998X.jsx)("img", {
        src: entity.type.iconUrl,
        alt: "",
        className: (0, $gMc0m.default)([
            "_1bsbxy5q _4t3ixy5q _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _vchhusvi _5ral1f51"
        ])
    }) : icon;
    const label = $8bcca2b8218ceda1$var$getDocumentSubtypeLabel({
        product: product,
        subtype: subtype
    });
    const isNotPublic = (0, $Y34Hw.isNonPublic)(permissionLevel);
    const shouldShowLastModified = lastModifiedDate && product !== 'atlassian-web-crawler';
    const metadataParts = [
        [
            'label',
            label ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $8bcca2b8218ceda1$var$typeLabelContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...label
                })
            }) : subtype ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $8bcca2b8218ceda1$var$typeLabelContainer,
                children: subtype?.replace(/-/g, ' ')
            }) : null
        ],
        [
            'parentName',
            $8bcca2b8218ceda1$var$getParentName(partial)
        ],
        [
            'lastModified',
            shouldShowLastModified && /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                lastModified: lastModifiedDate
            })
        ]
    ];
    const links = (0, $514d99dea8b7ae4b$export$a414b3d5a172e15b)(partial.entity?.content?.asText || partial.excerpt || '');
    const isAllowedCohort = grouping3pCohort === 'enable-v2';
    const isFallbackCase = (grouping3pCohort === undefined || grouping3pCohort === 'control') && isAllProductSelected;
    const shouldShowLinkedResults = partial.linkedResults && partial.linkedResults.length > 0 && (isAllowedCohort || isFallbackCase);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: partial.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: (0, $Y34Hw.processExcerpt)(excerpt)
        }),
        icon: contentIcon,
        headerMetadataParts: metadataParts,
        footer: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: shouldShowLinkedResults ? /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
                linkedResults: partial.linkedResults || [],
                thirdPartyConfigs: thirdPartyConfigs,
                partial: partial,
                position: position,
                url: url,
                onResultClicked: onResultClicked || (()=>{}),
                onResultContextMenu: onResultCtxMenuClicked,
                isAllProductSelected: isAllProductSelected
            }) : links.length > 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$6b89e3fa6be10ffa), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$49bd1dfb0ad29c40), {
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
                    attachmentCount: links.length,
                    attachmentType: "url",
                    label: formatMessage((0, $514d99dea8b7ae4b$export$47614749115bca3d), {
                        count: links.length
                    }),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $514d99dea8b7ae4b$export$dffce0f8d8968f9c), {
                        links: links,
                        onResultClicked: onResultClicked
                    })
                })
            }) : isNotPublic && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $8bcca2b8218ceda1$var$footerContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5c2df34c79a6120f$export$3eac322cb0b365da), {
                    restriction: permissionLevel
                })
            })
        }),
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial,
        appMode: appMode,
        hasRelatedLinks: shouldShowLinkedResults || false
    });
};





parcelRequire("42omo");







var $9lz2c = parcelRequire("9lz2c");






































var $e3TOY = parcelRequire("e3TOY");








var $fZtQj = parcelRequire("fZtQj");


var $8jHAi = parcelRequire("8jHAi");





















const $5a03f23d11daed58$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    attachedDateLabel: {
        id: "search-result.attachments.attached-date.label",
        defaultMessage: "Attached {formattedDate}"
    },
    expandLabel: {
        id: "search-result.attachments.expand.label",
        defaultMessage: "Expand"
    },
    attachmentLabel: {
        id: "search-result.attachment-label",
        defaultMessage: "Attachment"
    },
    pdfLabel: {
        id: "search-result.attachments.pdf-label",
        defaultMessage: "PDF"
    },
    videoLabel: {
        id: "search-result.attachments.video-label",
        defaultMessage: "Video"
    },
    imageLabel: {
        id: "search-result.attachments.image-label",
        defaultMessage: "Image"
    },
    audioLabel: {
        id: "search-result.attachments.audio-label",
        defaultMessage: "Audio"
    }
});


const $e78a02be1078de47$var$footerContainer = (0, $ecnYn.xcss)({
    paddingTop: 'space.100',
    position: 'relative'
});
const $e78a02be1078de47$var$dropdownItemStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    columnGap: 'space.100',
    paddingBlock: 'space.050',
    marginTop: 'space.100'
});
const $e78a02be1078de47$var$attachmentStyles = (0, $ecnYn.xcss)({
    color: 'color.link',
    textDecoration: 'none',
    ':hover': {
        color: 'color.link',
        textDecoration: 'underline'
    },
    ':active': {
        textDecoration: 'none'
    },
    ':visited': {
        color: 'color.link.visited'
    },
    ':visited:active': {
        color: 'color.link.visited.pressed'
    }
});
const $e78a02be1078de47$var$mimeTypeToIcon = (mimeType)=>{
    if (!mimeType) return 0, (/*@__PURE__*/$parcel$interopDefault($9lz2c));
    const [type, specificType] = mimeType.split('/');
    if (specificType === 'pdf') return 0, (/*@__PURE__*/$parcel$interopDefault($8jHAi));
    switch(type){
        case 'video':
            return 0, (/*@__PURE__*/$parcel$interopDefault($2Yaht));
        case 'image':
            return 0, (/*@__PURE__*/$parcel$interopDefault($fZtQj));
        case 'audio':
            return 0, (/*@__PURE__*/$parcel$interopDefault($e3TOY));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($9lz2c));
    }
};
const $e78a02be1078de47$var$mimeTypeToLabel = (mimeType)=>{
    if (!mimeType) return (0, $5a03f23d11daed58$export$a7357cdd1f0b0168).attachmentLabel;
    const [type, specificType] = mimeType.split('/');
    if (specificType === 'pdf') return (0, $5a03f23d11daed58$export$a7357cdd1f0b0168).pdfLabel;
    switch(type){
        case 'video':
            return (0, $5a03f23d11daed58$export$a7357cdd1f0b0168).videoLabel;
        case 'image':
            return (0, $5a03f23d11daed58$export$a7357cdd1f0b0168).imageLabel;
        case 'audio':
            return (0, $5a03f23d11daed58$export$a7357cdd1f0b0168).audioLabel;
        default:
            return (0, $5a03f23d11daed58$export$a7357cdd1f0b0168).attachmentLabel;
    }
};
const $e78a02be1078de47$export$28f865e0208f513d = ({ attachments: attachments, message: message })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        children: attachments.map(({ title: title, mimeType: mimeType, url: url, thumbnailUrl: thumbnailUrl })=>{
            const truncatedUrl = url?.replace(/\/download\//g, '/');
            const viewUrl = mimeType?.includes('image') ? truncatedUrl : thumbnailUrl;
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                xcss: $e78a02be1078de47$var$dropdownItemStyles,
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                        alignBlock: "center",
                        space: "space.025",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $lE8sM.default), {
                                size: "16",
                                icon: $e78a02be1078de47$var$mimeTypeToIcon(mimeType),
                                label: "icon",
                                appearance: "blue"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                size: "medium",
                                color: "color.link",
                                weight: "medium",
                                children: viewUrl ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
                                    xcss: $e78a02be1078de47$var$attachmentStyles,
                                    href: viewUrl,
                                    rel: 'noreferrer',
                                    target: "_blank",
                                    children: title
                                }) : title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                        separator: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                            size: "small",
                            children: "\u2022"
                        }),
                        space: "space.050",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                size: "small",
                                children: formatMessage($e78a02be1078de47$var$mimeTypeToLabel(mimeType))
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                size: "small",
                                color: "color.text.subtle",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                                    lastModified: message.lastModifiedDate,
                                    message: (0, $5a03f23d11daed58$export$a7357cdd1f0b0168).attachedDateLabel
                                })
                            })
                        ]
                    })
                ]
            });
        })
    });
};
const $e78a02be1078de47$var$DropdownMenu = ({ attachments: attachments, message: message })=>{
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const attachmentWord = `attachment${attachments.length > 1 ? 's' : ''}`;
    const dropdownMessage = `${attachments.length} ${attachmentWord}`;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                iconAfter: isExpanded ? ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                        color: "currentColor",
                        label: formatMessage((0, $5a03f23d11daed58$export$a7357cdd1f0b0168).expandLabel),
                        size: "small"
                    }) : ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                        color: "currentColor",
                        label: formatMessage((0, $5a03f23d11daed58$export$a7357cdd1f0b0168).expandLabel),
                        size: "small"
                    }),
                onClick: ()=>setIsExpanded(!isExpanded),
                isSelected: isExpanded,
                children: dropdownMessage
            }),
            isExpanded && /*#__PURE__*/ (0, $l998X.jsx)($e78a02be1078de47$export$28f865e0208f513d, {
                attachments: attachments,
                message: message
            })
        ]
    });
};
const $e78a02be1078de47$export$c129802f229d9594 = ({ attachments: attachments, message: message })=>{
    if (!attachments || attachments.length === 0) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $e78a02be1078de47$var$footerContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)($e78a02be1078de47$var$DropdownMenu, {
            attachments: attachments,
            message: message
        })
    });
};





const $09f41f4e81273610$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    threadTypeLabel: {
        id: "search-result.thread-type-label",
        defaultMessage: "Thread"
    },
    messageTypeLabel: {
        id: "search-result.message-type-label",
        defaultMessage: "Message"
    },
    lastActive: {
        id: "search-result.message-last-active",
        defaultMessage: "Last active {formattedDate}"
    },
    attachedDateLabel: {
        id: "search-result.attachments.attached-date.label",
        defaultMessage: "Attached {formattedDate}"
    },
    privateChannelLabel: {
        id: "search-result.private-channel-label",
        defaultMessage: "Private Channel"
    },
    memberCount: {
        id: "search-page.results.product-results.third-party.message-search-result.member-count",
        defaultMessage: "{count, plural, one {# member} other {# members}}"
    },
    smartlinkAttachmentsExpandButtonLabel: {
        id: "search-page.results.product-results.third-party.message-search-result.smartlink-attachments-expand-button-label",
        defaultMessage: "{count, plural, one {# link} other {# links}}"
    },
    fileAttachmentsExpandButtonLabel: {
        id: "search-page.results.product-results.third-party.message-search-result.file-attachments-expand-button-label",
        defaultMessage: "{count, plural, one {# attachment} other {# attachments}}"
    }
});
























var $iA4lt = parcelRequire("iA4lt");









const $5dd5c92f651ec1b2$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    externalPersonLabel: {
        id: "externalPersonLabel",
        defaultMessage: "External person"
    }
});


const $c3070161cc9fa12d$var$threadItemCSS = (0, $ecnYn.xcss)({
    paddingBottom: 'space.050',
    paddingTop: 'space.050',
    display: 'inline-block',
    verticalAlign: 'bottom'
});
const $c3070161cc9fa12d$var$nameContainer = (0, $ecnYn.xcss)({
    whiteSpace: 'nowrap'
});
const $c3070161cc9fa12d$export$39a3a4657e687b88 = ({ partial: partial, components: components })=>{
    const linkedEntities = partial?.linkedEntities || [];
    const threadMessages = [
        partial,
        ...linkedEntities
    ].slice(0, 3).map((linkedMessage)=>/*#__PURE__*/ (0, $l998X.jsx)($c3070161cc9fa12d$var$ThreadMessage, {
            parent: partial,
            partial: linkedMessage,
            components: components
        }, linkedMessage.id));
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: threadMessages
    });
};
const $c3070161cc9fa12d$var$popupTriggerXcss = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    alignItems: 'center',
    padding: 'space.0',
    marginRight: 'space.075',
    gap: 'space.025',
    background: 'none',
    ':hover': {
        textDecoration: 'underline'
    },
    fontWeight: 'font.weight.medium',
    font: 'font.body',
    verticalAlign: 'bottom'
});
const $c3070161cc9fa12d$var$regularUserXcss = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    alignItems: 'center',
    padding: 'space.0',
    marginRight: 'space.075',
    gap: 'space.025',
    background: 'none',
    fontWeight: 'font.weight.medium',
    verticalAlign: 'bottom'
});
const { serveExperiment: $c3070161cc9fa12d$var$serveDoubleLineRenderingModifications } = (0, $iA4lt.getFrontendExperiment)({
    abTestId: 'slack_result_rendering'
});
const $c3070161cc9fa12d$var$ThreadMessage = ({ parent: parent, partial: partial, components: components })=>{
    const [isPersonPopupOpen, setIsPersonPopupOpen] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const integrationId = parent.integrationId || partial?.integrationId;
    // Check for user with email priority:
    // createdBy?.thirdPartyUser -> initialContributors with email -> allContributors
    let user = partial?.entity?.createdBy?.thirdPartyUser;
    if (!user) {
        const initialContributor = partial?.initialContributors?.[0];
        if (initialContributor?.email) user = initialContributor;
        else user = partial?.allContributors?.[0];
    }
    const currentMessageOwnerName = user?.name || formatMessage((0, $5dd5c92f651ec1b2$export$a7357cdd1f0b0168).externalPersonLabel);
    const picture = user?.picture;
    const userData = (0, $Y34Hw.getUserData)(user);
    const onCopyEmail = (0, $6a8b466b77e29197$export$b2199c37e85de4a7)(user?.email);
    const messageSender = /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $678a8075b20296fe$export$3778be82376b06d7), {
                name: currentMessageOwnerName,
                picture: picture
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $c3070161cc9fa12d$var$nameContainer,
                children: currentMessageOwnerName
            })
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $c3070161cc9fa12d$var$threadItemCSS,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $5dK2X.default), {
            maxLines: $c3070161cc9fa12d$var$serveDoubleLineRenderingModifications ? 2 : 1,
            children: [
                userData ? // if we don't have enough data to render the person card we shouldn't make the name
                //	a popup trigger
                /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
                    isOpen: isPersonPopupOpen,
                    onClose: ()=>setIsPersonPopupOpen(false),
                    content: ()=>userData ? /*#__PURE__*/ (0, $l998X.jsx)((0, $168e8abba0f0ce48$export$4c094c8f61edecb4), {
                            user: userData,
                            externalMessageIntegration: (0, $Y34Hw.getExternalMessageDmIntegrationInfo)(integrationId, user),
                            onCopyEmail: onCopyEmail
                        }) : null,
                    trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
                            xcss: $c3070161cc9fa12d$var$popupTriggerXcss,
                            onClick: ()=>setIsPersonPopupOpen(true),
                            ...triggerProps,
                            children: messageSender
                        })
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $c3070161cc9fa12d$var$regularUserXcss,
                    children: messageSender
                }),
                /*#__PURE__*/ (0, $l998X.jsx)(components.Body, {
                    partial: partial,
                    integrationId: integrationId
                })
            ]
        })
    });
};





parcelRequire("42omo");















const $359d9e728ab458fb$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    threadTitleWithOthers: {
        id: "search-result.thread-title-with-others-and-channel-name",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: " {contributorCount, plural,\n\t\t\t\t=0 {}\n\t\t\t\t=1 {{name1} in }\n\t\t\t\t=2 {{name1} and {name2} in }\n\t\t\t\t=3 {{name1}, {name2}, and {name3} in }\n\t\t\t\t=4 {{name1}, {name2}, {name3}, and {overflowContributorCount} other in }\n\t\t\t\tother {{name1}, {name2}, {name3}, and {overflowContributorCount} others in }\n\t\t\t}#{channelName} "
    },
    groupChatTitle: {
        id: "search-result.group-chat-title",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: " {contributorCount, plural,\n\t\t\t\t=0 {Group message with external users}\n\t\t\t\t=1 {{name1}}\n\t\t\t\t=2 {{name1} and {name2}}\n\t\t\t\t=3 {{name1}, {name2}, and {name3}}\n\t\t\t\t=4 {{name1}, {name2}, {name3}, and {overflowContributorCount} other}\n\t\t\t\tother {{name1}, {name2}, {name3}, and {overflowContributorCount} others}\n\t\t\t} "
    },
    externalPeopleLabel: {
        id: "externalPeopleLabel",
        defaultMessage: "External people #{channelName}"
    },
    externalPersonLabel: {
        id: "externalPersonLabel",
        defaultMessage: "External person"
    },
    unknownChannel: {
        id: "search-result.unknown-channel-in-thread",
        defaultMessage: "unknown-channel"
    },
    directMessageSingleUser: {
        id: "search-result.direct-message-single-user",
        defaultMessage: "{name1} and 1 other"
    },
    directMessageTwoUsers: {
        id: "search-result.direct-message-two-users",
        defaultMessage: "{name1} and {name2}"
    },
    groupDirectMessageUnknownNames: {
        id: "search-result.group-direct-message-unknown-names",
        defaultMessage: "{totalPeopleCount} people"
    },
    federatedGroupDirectMessage: {
        id: "search-result.federated-group-direct-message",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: " {knownNamesCount, plural,\n\t\t\t\t=1 {{name1}}\n\t\t\t\t=2 {{name1} and {name2}}\n\t\t\t\t=3 {{name1}, {name2} and {name3}}\n\t\t\t\tother {{name1}, {name2} and {name3}}\n\t\t\t} "
    },
    federatedGroupDirectMessageWithOneOther: {
        id: "search-result.federated-group-direct-message-with-one-other",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: " {knownNamesCount, plural,\n\t\t\t\t=1 {{name1} and {totalOthersCount} other}\n\t\t\t\t=2 {{name1}, {name2} and {totalOthersCount} other}\n\t\t\t\t=3 {{name1}, {name2}, {name3} and {totalOthersCount} other}\n\t\t\t\tother {{name1}, {name2}, {name3} and {totalOthersCount} other}\n\t\t\t} "
    },
    federatedGroupDirectMessageWithMultipleOthers: {
        id: "search-result.federated-group-direct-message-with-multiple-others",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: " {knownNamesCount, plural,\n\t\t\t\t=1 {{name1} and {totalOthersCount} others}\n\t\t\t\t=2 {{name1}, {name2} and {totalOthersCount} others}\n\t\t\t\t=3 {{name1}, {name2}, {name3} and {totalOthersCount} others}\n\t\t\t\tother {{name1}, {name2}, {name3} and {totalOthersCount} others}\n\t\t\t} "
    }
});


const $55cb552e81e37a3f$var$USER_DISPLAY_LIMIT = 3;
const $55cb552e81e37a3f$var$dedupUsers = (userMap, user, index)=>{
    if (!userMap[user.id]) userMap[user.id] = {
        thirdPartyUser: user,
        index: index
    };
    return userMap;
};
const $55cb552e81e37a3f$var$getTitleMessageValues = (intl, users = [])=>{
    const { formatMessage: formatMessage } = intl;
    const uniqueUsers = users?.filter((thirdPartyUser)=>Boolean(thirdPartyUser?.name))?.reduce($55cb552e81e37a3f$var$dedupUsers, {});
    const validContributors = Object.values(uniqueUsers).sort((a, b)=>a.index - b.index).map((entry)=>entry?.thirdPartyUser?.name || formatMessage((0, $359d9e728ab458fb$export$a7357cdd1f0b0168).externalPersonLabel)).map((name)=>name?.split(' ')[0]);
    const externalPersonLabel = formatMessage((0, $359d9e728ab458fb$export$a7357cdd1f0b0168).externalPersonLabel);
    const externalPersonCount = validContributors.filter((name)=>name === externalPersonLabel).length;
    let adjustedContributors = validContributors;
    if (externalPersonCount > 1) {
        adjustedContributors = validContributors.filter((name)=>name !== externalPersonLabel);
        adjustedContributors.unshift(formatMessage((0, $359d9e728ab458fb$export$a7357cdd1f0b0168).externalPeopleLabel));
    }
    const contributorCount = adjustedContributors.length;
    const namedContributors = adjustedContributors.slice(0, $55cb552e81e37a3f$var$USER_DISPLAY_LIMIT);
    const overflowContributorCount = adjustedContributors.slice($55cb552e81e37a3f$var$USER_DISPLAY_LIMIT).length;
    return {
        contributorCount: contributorCount,
        namedContributors: namedContributors,
        overflowContributorCount: overflowContributorCount
    };
};
const $55cb552e81e37a3f$var$getRegularThreadTitleValues = (partial, intl, formatMessage)=>{
    const linkedEntities = partial.linkedEntities || [];
    const threadUsers = [
        partial,
        ...linkedEntities
    ].map((linkedMessage)=>linkedMessage?.entity?.createdBy?.thirdPartyUser || linkedMessage?.initialContributors?.[0]);
    const { contributorCount: contributorCount, namedContributors: namedContributors, overflowContributorCount: overflowContributorCount } = $55cb552e81e37a3f$var$getTitleMessageValues(intl, threadUsers);
    const [name1, name2, name3] = namedContributors;
    const channelName = partial?.entity?.container?.displayName || partial?.containerName || formatMessage((0, $359d9e728ab458fb$export$a7357cdd1f0b0168).unknownChannel);
    return {
        values: {
            contributorCount: contributorCount,
            name1: name1,
            name2: name2,
            name3: name3,
            overflowContributorCount: overflowContributorCount,
            channelName: channelName
        },
        titleMessage: (0, $359d9e728ab458fb$export$a7357cdd1f0b0168).threadTitleWithOthers
    };
};
const $55cb552e81e37a3f$export$18638a7ae5c7368a = ({ partial: partial })=>{
    const intl = (0, $8C5kA.default)();
    const { formatMessage: formatMessage } = intl;
    let values = {};
    let titleMessage = (0, $359d9e728ab458fb$export$a7357cdd1f0b0168).groupChatTitle;
    const isSlackFederatedSearchEnabled = (0, $8RFAN.serveFederatedSlackExperiment)(undefined, undefined, {
        fireExperimentExposure: false
    }) || (0, $dh538.fg)('ai_3p_slack_federated_search_enabled');
    const isSlackIntegration = partial.integrationId === 'ari:cloud:platform::integration/slack';
    if (partial.containerName != null && isSlackFederatedSearchEnabled && isSlackIntegration) {
        const groupChatParticipants = partial?.initialContributors;
        // federated direct message
        if (partial.containerName === '') {
            const nonNullParticipants = groupChatParticipants?.filter((participant)=>participant?.name) || [];
            const { namedContributors: namedContributors } = $55cb552e81e37a3f$var$getTitleMessageValues(intl, nonNullParticipants);
            const [name1, name2] = namedContributors;
            if (nonNullParticipants.length === 1) {
                values = {
                    name1: name1
                };
                titleMessage = (0, $359d9e728ab458fb$export$a7357cdd1f0b0168).directMessageSingleUser;
            } else {
                values = {
                    name1: name1,
                    name2: name2
                };
                titleMessage = (0, $359d9e728ab458fb$export$a7357cdd1f0b0168).directMessageTwoUsers;
            }
        } else if (partial.containerName && /^mpdm-.+--.*-\d+$/.test(partial.containerName)) {
            // Extract number of people from containerName (format: mpdm-name1--name2--name3-1)
            const totalPeopleCount = (partial.containerName.match(/--/g) || []).length + 1;
            const nonNullParticipants = groupChatParticipants?.filter((participant)=>participant?.name) || [];
            const otherCount = totalPeopleCount - nonNullParticipants.length;
            if (nonNullParticipants.length > 0) {
                const { namedContributors: namedContributors } = $55cb552e81e37a3f$var$getTitleMessageValues(intl, nonNullParticipants);
                const displayedNames = namedContributors.slice(0, $55cb552e81e37a3f$var$USER_DISPLAY_LIMIT);
                const [name1, name2, name3] = displayedNames;
                // Calculate total others (remaining known names + unknown people)
                const totalOthersCount = nonNullParticipants.length - displayedNames.length + otherCount;
                const hasOthers = totalOthersCount > 0;
                values = {
                    knownNamesCount: nonNullParticipants.length,
                    name1: name1,
                    name2: name2,
                    name3: name3,
                    totalOthersCount: totalOthersCount
                };
                titleMessage = hasOthers ? totalOthersCount === 1 ? (0, $359d9e728ab458fb$export$a7357cdd1f0b0168).federatedGroupDirectMessageWithOneOther : (0, $359d9e728ab458fb$export$a7357cdd1f0b0168).federatedGroupDirectMessageWithMultipleOthers : (0, $359d9e728ab458fb$export$a7357cdd1f0b0168).federatedGroupDirectMessage;
            } else {
                // Fallback if no names available
                values = {
                    totalPeopleCount: totalPeopleCount
                };
                titleMessage = (0, $359d9e728ab458fb$export$a7357cdd1f0b0168).groupDirectMessageUnknownNames;
            }
        } else {
            const result = $55cb552e81e37a3f$var$getRegularThreadTitleValues(partial, intl, formatMessage);
            values = result.values;
            titleMessage = result.titleMessage;
        }
    } else if (partial?.entity?.container?.type === 'DIRECT_MESSAGE' || partial?.entity?.container?.type === 'GROUP_DIRECT_MESSAGE') {
        const groupChatParticipants = partial?.entity.container?.members?.map((member)=>member?.thirdPartyUser);
        const { contributorCount: contributorCount, namedContributors: namedContributors, overflowContributorCount: overflowContributorCount } = $55cb552e81e37a3f$var$getTitleMessageValues(intl, groupChatParticipants);
        const [name1, name2, name3] = namedContributors;
        values = {
            contributorCount: contributorCount,
            name1: name1,
            name2: name2,
            name3: name3,
            overflowContributorCount: overflowContributorCount
        };
        titleMessage = (0, $359d9e728ab458fb$export$a7357cdd1f0b0168).groupChatTitle;
    } else {
        const result = $55cb552e81e37a3f$var$getRegularThreadTitleValues(partial, intl, formatMessage);
        values = result.values;
        titleMessage = result.titleMessage;
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...titleMessage,
        values: values
    });
};


const $1cc3ec024bde8e47$export$423dfe6469a8e0dd = ({ partial: partial, position: position, icon: icon, product: product, onResultClicked: onResultClicked, onResultCtxMenuClicked: onResultCtxMenuClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, isAllProductSelected: isAllProductSelected, grouping3pCohort: grouping3pCohort })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const [{ cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const appMode = (0, $j4ply.useApplicationMode)();
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const { url: url, linkedEntities: linkedEntities = [] } = partial;
    const attachments = partial.entity?.attachments || [];
    const labelMessage = linkedEntities?.length ? (0, $09f41f4e81273610$export$a7357cdd1f0b0168).threadTypeLabel : (0, $09f41f4e81273610$export$a7357cdd1f0b0168).messageTypeLabel;
    const title = /*#__PURE__*/ (0, $l998X.jsx)((0, $55cb552e81e37a3f$export$18638a7ae5c7368a), {
        partial: partial
    });
    const body = /*#__PURE__*/ (0, $l998X.jsx)((0, $c3070161cc9fa12d$export$39a3a4657e687b88), {
        partial: partial,
        components: {
            Body: (0, $83bd5e81ca6cbfef$export$a2b4a2fe7cc1ea4c)
        }
    });
    const parts = [
        [
            'label',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...labelMessage
            })
        ]
    ];
    const conversationMemberCount = partial.entity?.container?.memberCount;
    if (conversationMemberCount) parts.push([
        'memberCount',
        /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $09f41f4e81273610$export$a7357cdd1f0b0168).memberCount,
            values: {
                count: conversationMemberCount
            }
        })
    ]);
    const lastActiveDate = partial?.entity?.lastActive || partial?.lastModifiedDate;
    if (lastActiveDate) parts.push([
        'lastActive',
        /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
            lastModified: lastActiveDate,
            message: (0, $09f41f4e81273610$export$a7357cdd1f0b0168).lastActive
        })
    ]);
    const links = [
        partial,
        ...linkedEntities || []
    ]?.map((node)=>node.entity?.description || node.excerpt)?.filter((excerpt)=>!!excerpt)?.flatMap((0, $514d99dea8b7ae4b$export$a414b3d5a172e15b)) ?? [];
    const isAllowedCohort = grouping3pCohort === 'enable-v2';
    const isFallbackCase = (grouping3pCohort === undefined || grouping3pCohort === 'control') && isAllProductSelected;
    const shouldShowLinkedResults = partial.linkedResults && partial.linkedResults.length > 0 && (isAllowedCohort || isFallbackCase);
    const shouldShowAttachmentsOrLinks = attachments.length > 0 || links.length > 0;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: partial.id,
        product: product,
        productSelected: true,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: body,
        headerMetadataParts: parts,
        footer: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: shouldShowLinkedResults ? /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
                linkedResults: partial.linkedResults || [],
                thirdPartyConfigs: thirdPartyConfigs,
                partial: partial,
                position: position,
                url: url,
                onResultClicked: onResultClicked || (()=>{}),
                onResultContextMenu: onResultCtxMenuClicked,
                isAllProductSelected: isAllProductSelected
            }) : shouldShowAttachmentsOrLinks && /*#__PURE__*/ (0, $l998X.jsxs)((0, $664c8ed2681bd434$export$6b89e3fa6be10ffa), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$49bd1dfb0ad29c40), {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9lz2c))),
                        attachmentCount: attachments.length,
                        attachmentType: "file",
                        label: formatMessage((0, $09f41f4e81273610$export$a7357cdd1f0b0168).fileAttachmentsExpandButtonLabel, {
                            count: attachments.length
                        }),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e78a02be1078de47$export$28f865e0208f513d), {
                            attachments: attachments,
                            message: partial
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$49bd1dfb0ad29c40), {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
                        attachmentCount: links.length,
                        attachmentType: "url",
                        label: formatMessage((0, $514d99dea8b7ae4b$export$47614749115bca3d), {
                            count: links.length
                        }),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $514d99dea8b7ae4b$export$dffce0f8d8968f9c), {
                            links: links,
                            onResultClicked: onResultClicked
                        })
                    })
                ]
            })
        }),
        title: title,
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial,
        appMode: appMode,
        isPrivate: partial.entity?.container?.membershipType === 'PRIVATE',
        hasRelatedLinks: shouldShowLinkedResults || false
    });
};





parcelRequire("42omo");






























const $c1f9b9f49dbe7dd6$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    resultLabel: {
        id: "github-pull-request-result.label",
        defaultMessage: "Pull request"
    }
});


const $40b46d191a45506e$export$fcb233d1869c46a3 = ({ partial: partial, position: position, icon: icon, product: product, onResultClicked: onResultClicked, onResultCtxMenuClicked: onResultCtxMenuClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, isAllProductSelected: isAllProductSelected, grouping3pCohort: grouping3pCohort })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const [{ cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const appMode = (0, $j4ply.useApplicationMode)();
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const { url: url, permissionLevel: permissionLevel, entity: entity, excerpt: excerpt, containerName: containerName, lastModifiedDate: lastModifiedDate, title: partialTitle } = partial;
    const { title: entityTitle, lastUpdate: lastUpdate, container: container, pullRequestId: pullRequestId } = entity || {};
    const label = formatMessage((0, $c1f9b9f49dbe7dd6$export$defe85febe8b728c).resultLabel);
    const lastModifiedComponent = lastModifiedDate || lastUpdate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastUpdate ?? lastModifiedDate
    }) : null;
    const padlockIcon = (0, $Y34Hw.isNonPublic)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const getDescription = (excerpt)=>{
        const markdownRemoved = (0, $4dd635508e197aad$export$7e4bcd4afb389edb)(excerpt);
        return (0, $Y34Hw.processExcerpt)(markdownRemoved, true);
    };
    const headerMetadataParts = [
        label,
        [
            'pull-request-id',
            pullRequestId ? `#${pullRequestId}` : null
        ],
        [
            'repository-name',
            containerName ?? container?.name ?? null
        ],
        [
            'padlock',
            padlockIcon
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    const links = (0, $514d99dea8b7ae4b$export$a414b3d5a172e15b)(partial.excerpt || '');
    const isAllowedCohort = grouping3pCohort === 'enable-v2';
    const isFallbackCase = (grouping3pCohort === undefined || grouping3pCohort === 'control') && isAllProductSelected;
    const shouldShowLinkedResults = partial.linkedResults && partial.linkedResults.length > 0 && (isAllowedCohort || isFallbackCase);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: partial.id,
        product: product,
        productSelected: true,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: getDescription(excerpt)
        }),
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(partialTitle ?? entityTitle),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial,
        appMode: appMode,
        footer: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: shouldShowLinkedResults ? /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
                linkedResults: partial.linkedResults || [],
                thirdPartyConfigs: thirdPartyConfigs,
                partial: partial,
                position: position,
                url: url,
                onResultClicked: onResultClicked || (()=>{}),
                onResultContextMenu: onResultCtxMenuClicked,
                isAllProductSelected: isAllProductSelected
            }) : links.length > 0 && /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$6b89e3fa6be10ffa), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$49bd1dfb0ad29c40), {
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
                    attachmentCount: links.length,
                    attachmentType: "url",
                    label: formatMessage((0, $514d99dea8b7ae4b$export$47614749115bca3d), {
                        count: links.length
                    }),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $514d99dea8b7ae4b$export$dffce0f8d8968f9c), {
                        links: links,
                        onResultClicked: onResultClicked
                    })
                })
            })
        }),
        hasRelatedLinks: shouldShowLinkedResults || false
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");

























const $22e5177aee65d568$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    repositoryLabel: {
        id: "search-result.repository-label",
        defaultMessage: "Repository"
    }
});


const $f0eafd34f05c063a$var$GITHUB_INTEGRATION_KEY = 'github';
const $f0eafd34f05c063a$export$334ba9b7628e002a = ({ partial: partial, position: position, icon: icon, product: product, onResultClicked: onResultClicked, onResultCtxMenuClicked: onResultCtxMenuClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, isAllProductSelected: isAllProductSelected })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const [{ cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const appMode = (0, $j4ply.useApplicationMode)();
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, title: title, excerpt: excerpt } = partial;
    const label = formatMessage((0, $22e5177aee65d568$export$defe85febe8b728c).repositoryLabel);
    const padlockIcon = (0, $Y34Hw.isNonPublic)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const getDescription = (excerpt)=>{
        const markdownRemoved = (0, $4dd635508e197aad$export$7e4bcd4afb389edb)(excerpt);
        return (0, $Y34Hw.processExcerpt)(markdownRemoved, true);
    };
    const lastModifiedComponent = lastModifiedDate && product !== $f0eafd34f05c063a$var$GITHUB_INTEGRATION_KEY ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const headerMetadataParts = [
        label,
        [
            'padlock',
            padlockIcon
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: partial.id,
        product: product,
        productSelected: true,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: getDescription(excerpt)
        }),
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial,
        appMode: appMode,
        footer: /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
            linkedResults: partial.linkedResults || [],
            thirdPartyConfigs: thirdPartyConfigs,
            partial: partial,
            position: position,
            url: url,
            onResultClicked: onResultClicked || (()=>{}),
            onResultContextMenu: onResultCtxMenuClicked,
            isAllProductSelected: isAllProductSelected
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



























































const $b17e7abf474ca8a3$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    videoThumbnailAltText: {
        id: "video-search-result.video-thumbnail-alt-text",
        defaultMessage: "Video thumbnail"
    },
    videoIconLabel: {
        id: "video-search-result.video-icon-label",
        defaultMessage: "video icon"
    },
    videoLabel: {
        id: "video-search-result.video-label",
        defaultMessage: "Video"
    },
    dropdownMessage: {
        id: "video-search-result.dropdown-message",
        defaultMessage: "{chapterCount, plural, one {# chapter in this video} other {# chapters in this video}}"
    },
    durationInSeconds: {
        id: "video-search-result.duration.seconds",
        defaultMessage: "{seconds} sec"
    },
    durationInMinutes: {
        id: "video-search-result.duration.minutes",
        defaultMessage: "{minutes} min"
    },
    durationInHours: {
        id: "video-search-result.duration.hours",
        defaultMessage: "{hours} hour {minutes} min"
    }
});



var $bKOxc = parcelRequire("bKOxc");









var $iA9co = parcelRequire("iA9co");

var $913c3c82f16a1c98$require$Buffer = $iA9co.Buffer;
const $913c3c82f16a1c98$export$b0d5f79a828d791e = (durationInSeconds, options)=>{
    if (durationInSeconds === undefined) return null;
    const date = (0, $bKOxc.default)(new Date(0), durationInSeconds);
    const ONE_HOUR = 3600;
    const ONE_MINUTE = 60;
    const hours = Math.floor(durationInSeconds / ONE_HOUR);
    const minutes = Math.floor(durationInSeconds % ONE_HOUR / ONE_MINUTE);
    const seconds = durationInSeconds % ONE_MINUTE;
    if (options?.readable && options.formatMessage && (0, $dh538.fg)('fix_video_duration_i18n')) {
        if (durationInSeconds < ONE_MINUTE) return options.formatMessage((0, $b17e7abf474ca8a3$export$defe85febe8b728c).durationInSeconds, {
            seconds: seconds
        });
        else if (durationInSeconds < 3600) return options.formatMessage((0, $b17e7abf474ca8a3$export$defe85febe8b728c).durationInMinutes, {
            minutes: minutes
        });
        else return options.formatMessage((0, $b17e7abf474ca8a3$export$defe85febe8b728c).durationInHours, {
            hours: hours,
            minutes: minutes
        });
    }
    if (options?.readable) {
        if (durationInSeconds < ONE_MINUTE) return `${seconds} sec`;
        else if (durationInSeconds < 3600) return `${minutes} min`;
        else return `${hours} hour ${minutes} min`;
    }
    if (durationInSeconds < ONE_HOUR) return (0, $dWCFT.default)(date, 'mm:ss');
    return (0, $dWCFT.default)(date, 'HH:mm:ss');
};
const $913c3c82f16a1c98$export$edf82fe058be01d = (url)=>{
    const urlParams = new URLSearchParams(new URL(url).search);
    const base64Policy = urlParams.get('Policy');
    if (!base64Policy) return true;
    const decodedPolicy = $913c3c82f16a1c98$require$Buffer.from(base64Policy, 'base64').toString('utf-8');
    const i = decodedPolicy.lastIndexOf('}');
    const sanitizedPolicy = decodedPolicy.substring(0, i + 1);
    let policy;
    try {
        policy = JSON.parse(sanitizedPolicy);
    } catch  {
        return true;
    }
    if (policy.Statement && policy.Statement.length > 0) {
        const statement = policy.Statement[0];
        if (statement.Condition && statement.Condition.DateLessThan) {
            const epochTime = statement.Condition.DateLessThan['AWS:EpochTime'];
            const currentTime = Math.floor(Date.now() / 1000);
            return currentTime > epochTime;
        }
    }
    //fallthrough treat as expired
    return true;
};
const $913c3c82f16a1c98$export$121bfeb3f6fb7f94 = (baseUrl, durationInSeconds)=>{
    return `${baseUrl}?t=${durationInSeconds}`;
};


const $641dac9e69ed2a91$var$thumbnailContainerStyles = (0, $ecnYn.xcss)({
    position: 'relative',
    gridArea: 'body'
});
const $641dac9e69ed2a91$var$thumbnailImageStyles = null;
const $641dac9e69ed2a91$var$bodyAreaStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    columnGap: 'space.150'
});
const $641dac9e69ed2a91$var$VideoThumbnail = ({ thumbnailUrl: thumbnailUrl, url: url })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isErrored, setIsErrored] = (0, $42omo.useState)(false);
    return !thumbnailUrl || (0, $913c3c82f16a1c98$export$edf82fe058be01d)(thumbnailUrl) || isErrored ? null : /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
        testId: "thumbnail-container",
        xcss: $641dac9e69ed2a91$var$thumbnailContainerStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
            href: url,
            rel: 'noreferrer',
            target: '_blank',
            children: /*#__PURE__*/ (0, $l998X.jsx)("img", {
                src: thumbnailUrl,
                alt: formatMessage((0, $b17e7abf474ca8a3$export$defe85febe8b728c).videoThumbnailAltText),
                onError: ()=>setIsErrored(true),
                className: (0, $gMc0m.default)([
                    "_2rko12b0 _c71l1ymo _1bsb1wug"
                ])
            })
        })
    });
};
const $641dac9e69ed2a91$var$footerContainer = (0, $ecnYn.xcss)({
    paddingTop: 'space.150',
    position: 'relative'
});
const $641dac9e69ed2a91$var$VideoChapters = ({ chapters: chapters, url: url })=>{
    if (!chapters || chapters.length === 0) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $641dac9e69ed2a91$var$footerContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)($641dac9e69ed2a91$var$DropdownMenu, {
            chapters: chapters,
            url: url
        })
    });
};
const $641dac9e69ed2a91$var$DropdownMenu = ({ chapters: chapters, url: url })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(false);
    const dropdownMessage = formatMessage((0, $b17e7abf474ca8a3$export$defe85febe8b728c).dropdownMessage, {
        chapterCount: chapters.length
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                iconAfter: (iconProps)=>isExpanded ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                        ...iconProps,
                        size: "small"
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                        ...iconProps,
                        size: "small"
                    }),
                onClick: ()=>setIsExpanded(!isExpanded),
                isSelected: isExpanded,
                children: dropdownMessage
            }),
            isExpanded && /*#__PURE__*/ (0, $l998X.jsx)($641dac9e69ed2a91$var$DropdownItems, {
                chapters: chapters,
                url: url
            })
        ]
    });
};
const $641dac9e69ed2a91$var$chapterLinkStyles = (0, $ecnYn.xcss)({
    color: 'color.link',
    textDecoration: 'none',
    ':hover': {
        color: 'color.link',
        textDecoration: 'underline'
    },
    ':active': {
        textDecoration: 'none'
    },
    ':visited': {
        color: 'color.link.visited'
    },
    ':visited:active': {
        color: 'color.link.visited.pressed'
    }
});
const $641dac9e69ed2a91$var$dropdownItemStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    columnGap: 'space.025',
    paddingBlock: 'space.050',
    marginTop: 'space.100'
});
const $641dac9e69ed2a91$var$seeAllStyles = (0, $ecnYn.xcss)({
    textDecoration: 'none',
    marginTop: 'space.150',
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $641dac9e69ed2a91$var$DropdownItems = ({ chapters: chapters, url: url })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        children: [
            chapters.map(({ title: title, startTimeInSeconds: startTimeInSeconds })=>{
                return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                    xcss: $641dac9e69ed2a91$var$dropdownItemStyles,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $lE8sM.default), {
                            size: "16",
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2Yaht))),
                            label: formatMessage((0, $b17e7abf474ca8a3$export$defe85febe8b728c).videoIconLabel),
                            appearance: "blue"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                            space: 'space.050',
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                    size: "small",
                                    weight: "medium",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
                                        xcss: $641dac9e69ed2a91$var$chapterLinkStyles,
                                        href: (0, $913c3c82f16a1c98$export$121bfeb3f6fb7f94)(url, startTimeInSeconds),
                                        rel: 'noreferrer',
                                        target: "_blank",
                                        children: (0, $913c3c82f16a1c98$export$b0d5f79a828d791e)(startTimeInSeconds)
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                    size: "small",
                                    children: title
                                })
                            ]
                        })
                    ]
                });
            }),
            chapters.length > 10 && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $641dac9e69ed2a91$var$seeAllStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
                    href: url,
                    target: "_blank",
                    xcss: $641dac9e69ed2a91$var$seeAllStyles,
                    children: "See all"
                })
            })
        ]
    });
};
const $641dac9e69ed2a91$export$d343a98cb833c8b = ({ partial: partial, position: position, icon: icon, product: product, onResultClicked: onResultClicked, onResultCtxMenuClicked: onResultCtxMenuClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const [{ cloudId: cloudId }] = (0, $j4ply.useBootstrap)();
    const appMode = (0, $j4ply.useApplicationMode)();
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, entity: entity } = partial;
    const { durationInSeconds: durationInSeconds, chapters: chapters, createdBy: createdBy, thumbnailUrl: thumbnailUrl } = entity || {};
    const creatorName = createdBy?.user?.name || createdBy?.thirdPartyUser?.name || null;
    let { title: title, excerpt: excerpt } = partial;
    const videoDuration = (0, $913c3c82f16a1c98$export$b0d5f79a828d791e)(durationInSeconds, {
        formatMessage: formatMessage,
        readable: true
    });
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const body = /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        testId: "thumbnail-container",
        xcss: $641dac9e69ed2a91$var$bodyAreaStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($641dac9e69ed2a91$var$VideoThumbnail, {
                thumbnailUrl: thumbnailUrl,
                url: url
            }),
            thumbnailUrl && !(0, $913c3c82f16a1c98$export$edf82fe058be01d)(thumbnailUrl) ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                children: [
                    (0, $Y34Hw.processExcerpt)(excerpt, true),
                    " "
                ]
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
                description: (0, $Y34Hw.processExcerpt)(excerpt, true)
            })
        ]
    });
    const padlockIcon = (0, $Y34Hw.isNonPublic)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const headerMetadataParts = [
        formatMessage((0, $b17e7abf474ca8a3$export$defe85febe8b728c).videoLabel),
        [
            'creator-name',
            creatorName
        ],
        [
            'last-modified',
            lastModifiedComponent
        ],
        [
            'video-duration',
            videoDuration
        ],
        [
            'padlock',
            padlockIcon
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: partial.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        description: body,
        icon: icon,
        headerMetadataParts: headerMetadataParts,
        footer: /*#__PURE__*/ (0, $l998X.jsx)($641dac9e69ed2a91$var$VideoChapters, {
            chapters: chapters,
            url: url
        }),
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial,
        appMode: appMode
    });
};





parcelRequire("42omo");










































const $51b4601441ffdbd7$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    workItemLabel: {
        id: "work-item.label",
        defaultMessage: "Work item"
    },
    taskLabel: {
        id: "work-item-task.label",
        defaultMessage: "Task"
    },
    epicLabel: {
        id: "work-item-task.epic",
        defaultMessage: "Epic"
    },
    bugLabel: {
        id: "work-item-task.bug",
        defaultMessage: "Bug"
    },
    storyLabel: {
        id: "work-item-task.story",
        defaultMessage: "Story"
    },
    milestoneLabel: {
        id: "work-item-task.milestone",
        defaultMessage: "Milestone"
    },
    sectionLabel: {
        id: "work-item-task.section",
        defaultMessage: "Section"
    },
    approvalLabel: {
        id: "work-item-task.approval",
        defaultMessage: "Approval"
    },
    problemLabel: {
        id: "work-item-task.problem",
        defaultMessage: "Problem"
    },
    incidentLabel: {
        id: "work-item-task.incident",
        defaultMessage: "Incident"
    },
    questionLabel: {
        id: "work-item-task.question",
        defaultMessage: "Question"
    },
    issueLabel: {
        id: "work-item-task.issue",
        defaultMessage: "Issue"
    },
    for: {
        id: "work-item-status.for",
        defaultMessage: "{statusLozenge} for {dateLozenge}"
    },
    isAssigned: {
        id: "work-item-assignee.assigned",
        defaultMessage: "{isAssigned, select, internal {{firstName} is assigned} other {External person is assigned}}"
    },
    created: {
        id: "work-item-creator.created",
        defaultMessage: "{created, select, internal {{firstName} created} other {External person created}}"
    }
});


const $8e10d0111ad583e8$var$nameContainer = (0, $ecnYn.xcss)({
    whiteSpace: 'nowrap'
});
const $8e10d0111ad583e8$var$statusAndDateContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.100'
});
const $8e10d0111ad583e8$var$getStatusLozengeAppearance = (label)=>{
    label = label.replace(/[\s]+/g, '').toLowerCase();
    switch(true){
        case [
            'onhold'
        ].includes(label):
            return 'default';
        // gray
        case [
            'solved',
            'complete'
        ].includes(label):
            return 'success';
        // green
        case [
            'open',
            'offtrack'
        ].includes(label):
            return 'removed';
        // red
        case [
            'new',
            'atrisk'
        ].includes(label):
            return 'moved';
        // yellow
        case [
            'pending',
            'ontrack'
        ].includes(label):
            return 'inprogress';
    }
    return 'inprogress'; // blue for custom status labels
};
const $8e10d0111ad583e8$export$35f8af203ce4264d = ({ partial: partial, position: position, icon: icon, product: product, onResultClicked: onResultClicked, onResultCtxMenuClicked: onResultCtxMenuClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, isAllProductSelected: isAllProductSelected })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const [{ cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const appMode = (0, $j4ply.useApplicationMode)();
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, entity: entity, excerpt: excerpt, title: title } = partial;
    const { assignee: assignee, createdBy: createdBy, dueDate: dueDate, workItemProject: workItemProject, status: status, subtype: subtype } = entity || {};
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const padlockIcon = (0, $Y34Hw.isNonPublic)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const getStatusAndDate = ()=>{
        if (!status) return null;
        const statusLabel = status.replace(/[-_]+/g, ' ');
        const statusLozenge = /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
            appearance: $8e10d0111ad583e8$var$getStatusLozengeAppearance(statusLabel),
            children: statusLabel
        });
        const dateLozenge = dueDate && /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cgtv4.FormattedDate), {
                value: dueDate,
                month: "short",
                day: "numeric"
            })
        });
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $8e10d0111ad583e8$var$statusAndDateContainerStyles,
            children: dueDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $51b4601441ffdbd7$export$defe85febe8b728c).for,
                values: {
                    statusLozenge: statusLozenge,
                    dateLozenge: dateLozenge
                }
            }) : statusLozenge
        });
    };
    const getAssigneeOrCreator = ()=>{
        let actionLabel;
        const fullName = assignee?.thirdPartyUser?.name || createdBy?.thirdPartyUser?.name || '';
        const firstName = fullName?.split(' ')?.[0];
        if (assignee?.thirdPartyUser?.name) actionLabel = formatMessage((0, $51b4601441ffdbd7$export$defe85febe8b728c).isAssigned, {
            firstName: firstName,
            isAssigned: firstName ? 'internal' : 'external'
        });
        else actionLabel = formatMessage((0, $51b4601441ffdbd7$export$defe85febe8b728c).created, {
            firstName: firstName,
            created: firstName ? 'internal' : 'external'
        });
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
            space: "space.025",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $678a8075b20296fe$export$3778be82376b06d7), {
                    name: fullName
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $8e10d0111ad583e8$var$nameContainer,
                    children: actionLabel
                })
            ]
        });
    };
    const subtypeMap = {
        task: (0, $51b4601441ffdbd7$export$defe85febe8b728c).taskLabel,
        default_task: (0, $51b4601441ffdbd7$export$defe85febe8b728c).taskLabel,
        epic: (0, $51b4601441ffdbd7$export$defe85febe8b728c).epicLabel,
        bug: (0, $51b4601441ffdbd7$export$defe85febe8b728c).bugLabel,
        story: (0, $51b4601441ffdbd7$export$defe85febe8b728c).storyLabel,
        milestone: (0, $51b4601441ffdbd7$export$defe85febe8b728c).milestoneLabel,
        section: (0, $51b4601441ffdbd7$export$defe85febe8b728c).sectionLabel,
        approval: (0, $51b4601441ffdbd7$export$defe85febe8b728c).approvalLabel,
        problem: (0, $51b4601441ffdbd7$export$defe85febe8b728c).problemLabel,
        incident: (0, $51b4601441ffdbd7$export$defe85febe8b728c).incidentLabel,
        question: (0, $51b4601441ffdbd7$export$defe85febe8b728c).questionLabel,
        work_item: (0, $51b4601441ffdbd7$export$defe85febe8b728c).workItemLabel,
        issue: (0, $51b4601441ffdbd7$export$defe85febe8b728c).issueLabel,
        other: (0, $51b4601441ffdbd7$export$defe85febe8b728c).workItemLabel
    };
    const label = formatMessage(subtypeMap[subtype?.toLowerCase() ?? 'other'] || (0, $51b4601441ffdbd7$export$defe85febe8b728c).workItemLabel);
    const headerMetadataParts = [
        label,
        [
            'project',
            workItemProject?.name
        ],
        [
            'last-modified',
            lastModifiedComponent
        ],
        [
            'padlock',
            padlockIcon
        ],
        [
            'status',
            getStatusAndDate()
        ],
        [
            'person',
            getAssigneeOrCreator()
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: partial.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: (0, $Y34Hw.processExcerpt)(excerpt, true)
        }),
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial,
        appMode: appMode,
        footer: /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
            linkedResults: partial.linkedResults || [],
            thirdPartyConfigs: thirdPartyConfigs,
            partial: partial,
            position: position,
            url: url,
            onResultClicked: onResultClicked || (()=>{}),
            onResultContextMenu: onResultCtxMenuClicked,
            isAllProductSelected: isAllProductSelected
        })
    });
};


const $1f476fcbec080a05$var$CONFLUENCE_DC_PRODUCT_KEY = 'confluence-dc';
const $1f476fcbec080a05$export$b86b424e0d4929fb = ({ partial: partial, position: position })=>{
    const [{ cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const [selectedProducts] = (0, $djVCD.useSelectedProducts)();
    const isAllProductSelected = selectedProducts !== undefined && selectedProducts.length === 0;
    const resultAri = (0, $k4HRJ.AnyAri).parse(partial.id);
    const product = (0, $Y34Hw.getProductFromProviderId)(thirdPartyConfigs, partial.providerId);
    const integrationKey = (0, $Y34Hw.getIntegrationKey)(partial.integrationId);
    const productKey = product || integrationKey;
    const icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $235a70ab221836e5$export$6582c9566971e750), {
        product: productKey,
        resourceType: resultAri.resourceType,
        thirdPartyConfigs: thirdPartyConfigs
    });
    const metadata = (0, $42omo.useMemo)(()=>{
        return {
            id: partial.id,
            containerId: null,
            spaceId: null,
            contentType: partial.subtype,
            entityType: resultAri.resourceType,
            contentId: resultAri.resourceId,
            product: productKey,
            is3PSmartLink: (0, $kQT7c.isResultSmartLink)({
                connectorType: partial.connectorType,
                resultAri: partial.id,
                productKey: productKey,
                thirdPartyConfigs: thirdPartyConfigs
            }),
            connectorType: (0, $kQT7c.getResultConnectorSource)({
                connectorType: partial.connectorType,
                resultNodeId: partial.id,
                productKey: productKey,
                thirdPartyConfigs: thirdPartyConfigs
            })
        };
    }, [
        partial,
        resultAri,
        productKey,
        thirdPartyConfigs
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    if ((0, $7ZetK.isConversationEntity)(partial)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $2762432c767ed179$export$4534f971846d5b0b), {
        partial: partial,
        position: position,
        icon: icon,
        product: productKey,
        resultAri: resultAri,
        onClick: onResultClicked,
        onClickCtxMenu: onResultCtxMenuClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        cloudId: cloudId,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        isAllProductSelected: isAllProductSelected
    });
    if ((0, $7ZetK.isDesignEntity)(partial)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $41177e6a92ed5d4f$export$f6a73210de3b9a3b), {
        partial: partial,
        position: position,
        icon: icon,
        product: metadata.product,
        onResultClicked: onResultClicked,
        onResultCtxMenuClicked: onResultCtxMenuClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        isAllProductSelected: isAllProductSelected
    });
    if ((0, $7ZetK.isBranchEntity)(partial)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $a04021a7d100dc0c$export$5620ef5d10869020), {
        partial: partial,
        position: position,
        icon: icon,
        product: metadata.product,
        onResultClicked: onResultClicked,
        onResultCtxMenuClicked: onResultCtxMenuClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked
    });
    if ((0, $7ZetK.isCommitEntity)(partial)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $1dcf33d1bcde1fcc$export$35c708bc36dbd879), {
        partial: partial,
        position: position,
        icon: icon,
        product: metadata.product,
        onResultClicked: onResultClicked,
        onResultCtxMenuClicked: onResultCtxMenuClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        isAllProductSelected: isAllProductSelected
    });
    if ((0, $7ZetK.isPullRequestEntity)(partial)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $40b46d191a45506e$export$fcb233d1869c46a3), {
        partial: partial,
        position: position,
        icon: icon,
        product: metadata.product,
        onResultClicked: onResultClicked,
        onResultCtxMenuClicked: onResultCtxMenuClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        isAllProductSelected: isAllProductSelected
    });
    if ((0, $7ZetK.isRepositoryEntity)(partial)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $f0eafd34f05c063a$export$334ba9b7628e002a), {
        partial: partial,
        position: position,
        icon: icon,
        product: metadata.product,
        onResultClicked: onResultClicked,
        onResultCtxMenuClicked: onResultCtxMenuClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        isAllProductSelected: isAllProductSelected
    });
    if ((0, $7ZetK.isVideoEntity)(partial)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $641dac9e69ed2a91$export$d343a98cb833c8b), {
        partial: partial,
        position: position,
        icon: icon,
        product: metadata.product,
        onResultClicked: onResultClicked,
        onResultCtxMenuClicked: onResultCtxMenuClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked
    });
    if ((0, $7ZetK.isMessageEntity)(partial)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $1cc3ec024bde8e47$export$423dfe6469a8e0dd), {
        partial: partial,
        position: position,
        icon: icon,
        product: metadata.product,
        onResultClicked: onResultClicked,
        onResultCtxMenuClicked: onResultCtxMenuClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        isAllProductSelected: isAllProductSelected
    });
    if ((0, $7ZetK.isCommentEntity)(partial)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $28a43cd9dc1edcd6$export$dabe1ea20b5cf75b), {
        partial: partial,
        position: position,
        icon: icon,
        product: metadata.product,
        onResultClicked: onResultClicked,
        onResultCtxMenuClicked: onResultCtxMenuClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        isAllProductSelected: isAllProductSelected
    });
    if ((0, $7ZetK.isDocumentEntity)(partial)) {
        if (productKey === $1f476fcbec080a05$var$CONFLUENCE_DC_PRODUCT_KEY) return /*#__PURE__*/ (0, $l998X.jsx)((0, $f96f5381b81323f1$export$7582ed16f17b3410), {
            partial: partial,
            position: position,
            product: metadata.product,
            onResultClicked: onResultClicked,
            onResultCtxMenuClicked: onResultCtxMenuClicked,
            onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
            onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
            onContextMenuButtonClicked: onContextMenuButtonClicked
        });
        else return /*#__PURE__*/ (0, $l998X.jsx)((0, $8bcca2b8218ceda1$export$43fa1bdcdc4d31ed), {
            partial: partial,
            position: position,
            icon: icon,
            product: metadata.product,
            onResultClicked: onResultClicked,
            onResultCtxMenuClicked: onResultCtxMenuClicked,
            onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
            onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
            onContextMenuButtonClicked: onContextMenuButtonClicked,
            isAllProductSelected: isAllProductSelected
        });
    }
    if ((0, $7ZetK.isCalendarEventEntity)(partial)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $b5ce93e1775f73b6$export$2d6c717667f5157c), {
        partial: partial,
        position: position,
        icon: icon,
        product: metadata.product,
        onResultClicked: onResultClicked,
        onResultCtxMenuClicked: onResultCtxMenuClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        isAllProductSelected: isAllProductSelected
    });
    if ((0, $7ZetK.isDealEntity)(partial)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $364d352cbc6abda4$export$2ce7c47bd245eb7e), {
        partial: partial,
        position: position,
        icon: icon,
        product: metadata.product,
        onResultClicked: onResultClicked,
        onResultCtxMenuClicked: onResultCtxMenuClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        isAllProductSelected: isAllProductSelected
    });
    if ((0, $7ZetK.isCustomerOrgEntity)(partial)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $3fd3fe1407893067$export$6a520dc8ab8b1037), {
        partial: partial,
        position: position,
        icon: icon,
        product: metadata.product,
        onResultClicked: onResultClicked,
        onResultCtxMenuClicked: onResultCtxMenuClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        isAllProductSelected: isAllProductSelected
    });
    if ((0, $7ZetK.isWorkItemEntity)(partial)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $8e10d0111ad583e8$export$35f8af203ce4264d), {
        partial: partial,
        position: position,
        icon: icon,
        product: metadata.product,
        onResultClicked: onResultClicked,
        onResultCtxMenuClicked: onResultCtxMenuClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        isAllProductSelected: isAllProductSelected
    });
    if ((0, $7ZetK.isDashboardEntity)(partial)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $15499219b9c2bd65$export$30a1341f2d7490be), {
        partial: partial,
        position: position,
        icon: icon,
        product: metadata.product,
        onResultClicked: onResultClicked,
        onResultCtxMenuClicked: onResultCtxMenuClicked
    });
    if ((0, $7ZetK.isDataTableEntity)(partial)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $c4099c5d258f55d7$export$e73a42f27181882e), {
        partial: partial,
        position: position,
        icon: icon,
        product: metadata.product,
        onResultClicked: onResultClicked,
        onResultCtxMenuClicked: onResultCtxMenuClicked
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $0e85201f3bca4c56$export$2917a391c04f0e93), {
        partial: partial,
        position: position,
        icon: icon,
        entityType: metadata.entityType,
        product: metadata.product,
        onResultClicked: onResultClicked,
        onResultCtxMenuClicked: onResultCtxMenuClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        isAllProductSelected: isAllProductSelected
    });
};




























parcelRequire("42omo");
























const $1c91a788fb243bd3$var$typeLabelContainer = (0, $ecnYn.xcss)({
    '::first-letter': {
        textTransform: 'capitalize'
    }
});
const $1c91a788fb243bd3$var$getLabel = (entityNoun)=>entityNoun.replace(/-/g, ' ');
const $1c91a788fb243bd3$export$f9c52c94e8b24d45 = ({ icon: icon, partial: partial, position: position, metadata: metadata, onResultClicked: onResultClicked, onResultCtxMenuClicked: onResultCtxMenuClicked })=>{
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const [{ cloudId: cloudId }] = (0, $j4ply.useBootstrap)();
    const appMode = (0, $j4ply.useApplicationMode)();
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const { lastModifiedDate: lastModifiedDate, url: url, title: title, description: description } = partial;
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const label = $1c91a788fb243bd3$var$getLabel(metadata.entityType);
    const headerMetadataParts = [
        [
            'label',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $1c91a788fb243bd3$var$typeLabelContainer,
                children: label
            })
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: partial.id,
        product: metadata.product,
        productSelected: true,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: (0, $Y34Hw.processExcerpt)(description)
        }),
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial,
        appMode: appMode
    });
};





parcelRequire("42omo");



































const $5417c5c3bf08f87c$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    emailLabel: {
        id: "email-search-result.email.label",
        defaultMessage: "Email"
    },
    inboxLabel: {
        id: "email-search-result.inbox.label",
        defaultMessage: "Inbox"
    },
    sentLabel: {
        id: "email-search-result.sent.label",
        defaultMessage: "{person} sent"
    },
    forwardedLabel: {
        id: "email-search-result.forwarded.label",
        defaultMessage: "{person} forwarded"
    },
    externalPersonLabel: {
        id: "email-search-result.external-person.label",
        defaultMessage: "External person"
    },
    timestampLabel: {
        id: "email-search-result.timestamp.label",
        // eslint-disable-next-line @atlassian/i18n/no-useless-message
        defaultMessage: "{formattedDate}"
    }
});


const $2e88efbfc594570b$var$nameContainer = (0, $ecnYn.xcss)({
    whiteSpace: 'nowrap'
});
const $2e88efbfc594570b$export$33c648f7c0be2103 = ({ partial: partial, position: position, icon: icon, metadata: metadata, onResultClicked: onResultClicked, onResultCtxMenuClicked: onResultCtxMenuClicked, isThirdParty: isThirdParty })=>{
    const [{ cloudId: cloudId }] = (0, $j4ply.useBootstrap)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const appMode = (0, $j4ply.useApplicationMode)();
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const { lastModifiedDate: lastModifiedDate, url: url, title: title, description: description, entity: entity } = partial;
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate,
        message: (0, $5417c5c3bf08f87c$export$defe85febe8b728c).timestampLabel
    }) : null;
    const label = /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...(0, $5417c5c3bf08f87c$export$defe85febe8b728c).emailLabel
    });
    const inboxLabel = /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...(0, $5417c5c3bf08f87c$export$defe85febe8b728c).inboxLabel
    });
    const getSender = ()=>{
        const fullName = entity?.sender?.name || '';
        const firstName = fullName?.split(' ')?.[0] || formatMessage((0, $5417c5c3bf08f87c$export$defe85febe8b728c).externalPersonLabel);
        const actionLabel = formatMessage((0, $5417c5c3bf08f87c$export$defe85febe8b728c).sentLabel, {
            person: firstName
        });
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
            space: "space.025",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $678a8075b20296fe$export$3778be82376b06d7), {
                    name: fullName
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $2e88efbfc594570b$var$nameContainer,
                    children: actionLabel
                })
            ]
        });
    };
    const metadataParts = [
        [
            'label',
            label
        ],
        [
            'inbox',
            inboxLabel
        ],
        [
            'lastModified',
            lastModifiedComponent
        ],
        [
            'sender',
            getSender()
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: partial.id,
        product: metadata.product,
        productSelected: true,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        headerMetadataParts: metadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: (0, $Y34Hw.processExcerpt)(description)
        }),
        primaryProduct: primaryProduct,
        cloudId: cloudId,
        position: position,
        partial: partial,
        appMode: appMode,
        isThirdParty: isThirdParty
    });
};


const $a1a91677a4352c86$var$FederatedIcon = ({ resourceOwner: resourceOwner, resourceType: resourceType })=>{
    const products = (0, $1yEFx.useProductConfigs)();
    let productKey;
    if (resourceOwner === 'google' && resourceType === 'email') productKey = (0, $1yEFx.ProductKeys).Gmail;
    else if (resourceOwner === 'microsoft' && resourceType === 'email') productKey = (0, $1yEFx.ProductKeys).OutlookMail;
    if (!productKey) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
        color: "currentColor",
        spacing: "spacious",
        label: ""
    });
    let IconComponent = products[productKey]?.SearchResultIcon;
    return IconComponent ? /*#__PURE__*/ (0, $l998X.jsx)(IconComponent, {
        label: ""
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
        color: "currentColor",
        spacing: "spacious",
        label: ""
    });
};
const $a1a91677a4352c86$export$110d3e0bd2e86449 = ({ partial: partial, position: position })=>{
    const resultAri = (0, $k4HRJ.AnyAri).parse(partial.id);
    const icon = $a1a91677a4352c86$var$FederatedIcon(resultAri);
    const metadata = (0, $42omo.useMemo)(()=>{
        return {
            id: partial.id,
            containerId: null,
            spaceId: null,
            contentType: resultAri.resourceType,
            entityType: resultAri.resourceType,
            contentId: resultAri.resourceId,
            product: resultAri.resourceOwner,
            // it's federated so always false in this component
            is3PSmartLink: false,
            connectorType: (0, $9d9t8.ConnectorSources).Federated
        };
    }, [
        resultAri,
        partial.id
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    if ((0, $fLF8J.isSearchFederatedEmailEntity)(partial)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $2e88efbfc594570b$export$33c648f7c0be2103), {
        partial: partial,
        position: position,
        metadata: metadata,
        icon: icon,
        onResultClicked: onResultClicked,
        onResultCtxMenuClicked: onResultCtxMenuClicked,
        isThirdParty: true
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1c91a788fb243bd3$export$f9c52c94e8b24d45), {
        partial: partial,
        position: position,
        metadata: metadata,
        icon: icon,
        onResultClicked: onResultClicked,
        onResultCtxMenuClicked: onResultCtxMenuClicked
    });
};















































const $78af6833300c1683$export$37a54a397a692113 = ({ partial: partial, position: position })=>{
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const [{ cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const [searchQuery] = (0, $djVCD.useSearchQuery)();
    const appMode = (0, $j4ply.useApplicationMode)();
    const { id: id, title: title, url: url, type: type, description: description, lastModifiedDate: lastModifiedDate } = partial;
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(id);
        return {
            id: id,
            containerId: null,
            spaceId: null,
            contentType: type === 'issue' ? 'card' : type,
            entityType: type === 'issue' ? 'card' : type,
            contentId: contentId,
            product: product
        };
    }, [
        id,
        type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const getLastModified = (0, $42omo.useMemo)(()=>{
        if (!lastModifiedDate) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
            lastModified: lastModifiedDate
        });
    }, [
        lastModifiedDate
    ]);
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(title, searchQuery.split(' '));
        if (!highlightedTitle) return title;
        return (0, $Y34Hw.enrichExcerpt)(highlightedTitle);
    }, [
        title,
        searchQuery
    ]);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        const reducedDescription = (0, $bOpS4.truncateTextWithQuery)(description, searchQuery);
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(reducedDescription, searchQuery.split(' '));
        if (!highlightedTitle) return reducedDescription;
        return (0, $Y34Hw.processExcerpt)(highlightedTitle);
    }, [
        description,
        searchQuery
    ]);
    const headerMetadataParts = [
        [
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                type: metadata.entityType
            })
        ],
        [
            'lastModified',
            getLastModified
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...partial,
        product: metadata.product,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.TrelloIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        title: enrichedTitle,
        headerMetadataParts: headerMetadataParts,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: enrichedDescription
        }),
        cloudId: cloudId,
        position: position,
        appMode: appMode,
        footer: /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$695e5a3ae2478b3), {
            linkedResults: partial.linkedResults || [],
            thirdPartyConfigs: thirdPartyConfigs,
            partial: partial,
            url: url,
            position: position,
            onResultClicked: onResultClicked,
            onResultContextMenu: onResultCtxMenuClicked,
            isAllProductSelected: !selectedProduct
        })
    });
};


const $ec0db18ecef5405c$var$resultsListGridAreaStyles = (0, $ecnYn.xcss)({
    gridArea: 'results-list',
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.300'
});
const $ec0db18ecef5405c$var$noMoreResultsStyles = (0, $ecnYn.xcss)({
    marginBottom: 'space.400'
});
// How many search results to show before the OAuth banner
const $ec0db18ecef5405c$var$RELATED_ENTITIES_BANNER_CUTOFF = 3;
const $ec0db18ecef5405c$var$OAUTH_BANNER_CUTOFF = 4;
const $ec0db18ecef5405c$var$LEAP_QUERY_BANNER_CUTOFF = 5;
const $ec0db18ecef5405c$export$f4d566390f914fd = ({ node: node, index: index })=>{
    if (!node) throw new Error('ResultRecord: node is undefined');
    if ((0, $4TTdD.isSearchConfluencePartial)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $e3cddeb5c5430cf7$export$30adeb861c31a5ed), {
        partial: node,
        position: index
    });
    if ((0, $8LSUr.isSearchResultJiraIssue)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $70161bcb1c1c3bc5$export$3c36ba6ceaed3437), {
        partial: (0, $8LSUr.mapJiraIssuePartial)(node),
        position: index
    });
    if ((0, $8LSUr.isSearchResultJiraProject)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $70161bcb1c1c3bc5$export$3c36ba6ceaed3437), {
        partial: (0, $8LSUr.mapJiraProjectPartial)(node),
        position: index
    });
    if ((0, $8LSUr.isSearchJiraPartial)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $70161bcb1c1c3bc5$export$3c36ba6ceaed3437), {
        partial: node,
        position: index
    });
    if ((0, $7jIfa.isSearchAtlasPartial)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $5612c8f904dc5381$export$a97c0c8e95f01322), {
        partial: node,
        position: index
    });
    if ((0, $b8N8h.isSearchCompassPartial)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $9b8945bd21cb38d9$export$cc23f5d092bb479f), {
        partial: node,
        position: index
    });
    if ((0, $aXWlG.isSearchTrelloPartial)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $78af6833300c1683$export$37a54a397a692113), {
        partial: node,
        position: index
    });
    if ((0, $HOiSI.isSearchMercuryPartial)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $450900e213a04b17$export$c9d05a539ddcce32), {
        partial: node,
        position: index
    });
    if ((0, $6a6b6eb1f6bb6683$export$aa3a06102a04532d)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $6a6b6eb1f6bb6683$export$e39b36c2009dde1b), {
        partial: node,
        position: index
    });
    if ((0, $fLF8J.isSearchResultFederated)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $a1a91677a4352c86$export$110d3e0bd2e86449), {
        partial: node,
        position: index
    });
    if ((0, $l3paI.isSearchAssetsPartial)(node) && (0, $dh538.fg)('assets_rovo_search_all')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $3d88c2efff54240a$export$bdb84dba2a405f14), {
        partial: node,
        position: index
    });
    if ((0, $7ZetK.isSearchResultGraphEntity)(node)) // Leave this one last
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1f476fcbec080a05$export$b86b424e0d4929fb), {
        partial: node,
        position: index
    });
    if ((0, $fhFN4.isSearchTalentPartial)(node)) /**
		 * This is a temporary fix to avoid the never ending throw causing the search page to continously re-render
		 * This is becasue Talent results will not be supported in the search page in favor of Relay Search Results.
		 */ return null;
    throw new Error(`ResultRecord: unsupported node type ${node.__typename}`);
};
const $ec0db18ecef5405c$export$248f61b89d3a7ccf = ({ fallback: fallback = null, ...props })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
        fallback: fallback,
        section: "SearchPageResultRecord",
        children: /*#__PURE__*/ (0, $l998X.jsx)($ec0db18ecef5405c$export$f4d566390f914fd, {
            ...props
        })
    });
const $ec0db18ecef5405c$export$4a34de49b46a2bfa = ()=>{
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [results] = (0, $djVCD.useResults)();
    const { setFetchFromCursor: setFetchFromCursor } = (0, $djVCD.useSearchActions)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const currentCursor = (0, $djVCD.useFetchFromCursor)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const nextFetchCursor = (0, $djVCD.usePageEndCursor)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const isLoadingMore = (0, $djVCD.useIsLoadingMore)();
    const hasNextPage = nextFetchCursor && currentCursor !== nextFetchCursor;
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const lastResultRef = (0, $42omo.useRef)(null);
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const areLLMFeaturesEnabled = (0, $71988ef00edd4050$export$5c2913b6a4d1611c)();
    const [{ thirdPartyConfigs: thirdPartyConfigs, products: availableProducts }] = (0, $j4ply.useBootstrap)();
    const [isHello] = (0, $j4ply.useIsHello)();
    const { fireAnalyticsScreenEvent: fireAnalyticsScreenEvent, fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const { getNewlyConnectedProducts: getNewlyConnectedProducts } = (0, $dsrEB.useNewlyConnectedProducts)();
    (0, $320af85988d7ec69$export$2e2bcd8739ae039)();
    (0, $42omo.useEffect)(()=>{
        const nextPageObserver = new IntersectionObserver((entries)=>{
            if (entries[0].isIntersecting) {
                if (nextFetchCursor && nextFetchCursor !== currentCursor) setFetchFromCursor(nextFetchCursor);
            }
        }, {});
        if (lastResultRef.current) nextPageObserver.observe(lastResultRef.current);
    }, [
        currentCursor,
        nextFetchCursor,
        results,
        setFetchFromCursor
    ]);
    if (!results) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {});
    const allResults = {
        ...results,
        edges: results.edges.map((edge, index)=>({
                ...edge,
                index: index
            }))
    };
    const initialResults = allResults.edges.slice(0, $ec0db18ecef5405c$var$RELATED_ENTITIES_BANNER_CUTOFF);
    const beforeOAuthBannerResults = allResults.edges.slice($ec0db18ecef5405c$var$RELATED_ENTITIES_BANNER_CUTOFF, $ec0db18ecef5405c$var$OAUTH_BANNER_CUTOFF);
    const beforeLeapQueryResults = allResults.edges.slice($ec0db18ecef5405c$var$OAUTH_BANNER_CUTOFF, $ec0db18ecef5405c$var$LEAP_QUERY_BANNER_CUTOFF);
    const remainingResults = allResults.edges.slice($ec0db18ecef5405c$var$LEAP_QUERY_BANNER_CUTOFF);
    const showLeapQuery = applicationMode === (0, $9vOy1.ApplicationModes).Rovo && areLLMFeaturesEnabled;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: [
            $ec0db18ecef5405c$var$resultsListGridAreaStyles,
            $ec0db18ecef5405c$var$noMoreResultsStyles
        ],
        role: "list",
        testId: "search-page-results-list",
        children: [
            initialResults.map(({ node: node, index: index })=>/*#__PURE__*/ (0, $l998X.jsx)($ec0db18ecef5405c$export$248f61b89d3a7ccf, {
                    node: node,
                    index: index
                }, node.id)),
            beforeOAuthBannerResults.map(({ node: node, index: index })=>/*#__PURE__*/ (0, $l998X.jsx)($ec0db18ecef5405c$export$248f61b89d3a7ccf, {
                    node: node,
                    index: index
                }, node.id)),
            !selectedProduct && ((0, $2OtFZ.serve3PBulkConnectWithoutExposure)() ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
                section: "SearchPageResultsBulkConnectBanner",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    role: "listitem",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5Lref.BulkConnectBanner), {
                        thirdPartyConfigs: thirdPartyConfigs,
                        availableProducts: availableProducts,
                        getNewlyConnectedProducts: getNewlyConnectedProducts,
                        useBulkConnectModalOpenState: (0, $dsrEB.useBulkConnectModalOpenState),
                        fireAnalyticsScreenEvent: fireAnalyticsScreenEvent,
                        fireAnalyticsEvent: fireAnalyticsEvent,
                        commonAttributes: commonAttributes
                    })
                })
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
                section: "SearchPageResultsOAuthContainer",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    role: "listitem",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a5OFf.OAuthContainer), {
                        thirdPartyConfigs: thirdPartyConfigs,
                        availableProducts: availableProducts,
                        isHello: isHello,
                        useOAuthHandlers: (0, $gGFxq.useOAuthHandlers),
                        fireAnalyticsEvent: fireAnalyticsEvent
                    })
                })
            })),
            beforeLeapQueryResults.map(({ node: node, index: index })=>/*#__PURE__*/ (0, $l998X.jsx)($ec0db18ecef5405c$export$248f61b89d3a7ccf, {
                    node: node,
                    index: index
                }, node.id)),
            showLeapQuery && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                role: "listitem",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $b62a6edcfe9a416a$export$4c364b51dbcd9c2), {})
            }),
            remainingResults.length > 0 && remainingResults.map(({ node: node, index: index })=>/*#__PURE__*/ (0, $l998X.jsx)($ec0db18ecef5405c$export$248f61b89d3a7ccf, {
                    node: node,
                    index: index
                }, node.id)),
            (hasNextPage || isLoadingMore) && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                ref: lastResultRef,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1hlFx.SearchResultSkeleton), {})
            })
        ]
    });
};


const $d45f3b43b11de587$export$52c4f256909a575e = (results)=>{
    const resultIds = results?.edges?.map((edge)=>edge.node.id);
    return resultIds ? resultIds.join(',') : '';
};


const $4571e76365892ec4$var$resultCountAndSortContainer = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 'space.050'
});
const $4571e76365892ec4$var$useFireAnalytics = (state, thirdPartyConfigs)=>{
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [results] = (0, $djVCD.useResults)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const [queryState] = (0, $djVCD.useQueryState)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const socialSignalsAttributes = (0, $9df153e29ffddcb7$export$7d33b74a4ce5a7db)();
    const { searchAndResult: searchAndResult } = (0, $dd52a0ba4dde52e0$export$771e1c85614a020d)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [requestedBackendExperiments] = (0, $djVCD.useRequestedBackendExperiments)();
    const [referrer] = (0, $j4ply.useReferrer)();
    const initialTextQueryParam = (0, $j4ply.useInitialTextQueryParam)();
    const { clearReferrer: clearReferrer } = (0, $j4ply.useBootstrapActions)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const fetchFromCursor = (0, $djVCD.useFetchFromCursor)();
    const are3pResultsShown = $4571e76365892ec4$export$87d91dbe2c36460b(results, thirdPartyConfigs);
    const resultIdsAsString = (0, $d45f3b43b11de587$export$52c4f256909a575e)(results);
    const resultsShown = $4571e76365892ec4$export$8841f6f549512fc2(results, thirdPartyConfigs);
    (0, $42omo.useEffect)(()=>{
        if (state !== (0, $fZ3l2.ResultsStates).NO_RESULTS && state !== (0, $fZ3l2.ResultsStates).RESULTS) return;
        const numResults = results?.edges.length || 0;
        const isBulkConnectBannerShown = (0, $9wmQG.getIsBulkConnectBannerShown)();
        fireAnalyticsEvent((0, $0f1906aa6a6024a0$export$4b73689f2f9f3dd3)({
            queryState: queryState,
            numResults: numResults,
            shownCount: numResults,
            are3pResultsShown: are3pResultsShown,
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            socialSignalsAttributes: socialSignalsAttributes,
            searchAndResult: searchAndResult,
            resultsShown: resultsShown,
            requestedBackendExperiments: requestedBackendExperiments,
            referrer: referrer && initialTextQueryParam ? referrer : undefined,
            isPaginatedQuery: !!fetchFromCursor,
            isBulkConnectBannerShown: isBulkConnectBannerShown,
            productsWithTimeout: undefined
        }));
        fireAnalyticsEvent((0, $00671a63acd7458c$export$8b03bfde0d56431b)({
            success: true,
            commonAttributes: commonAttributes
        }));
        // Ensure that the referrer attribute is only used once
        clearReferrer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        resultIdsAsString
    ]);
};
const $4571e76365892ec4$export$87d91dbe2c36460b = (results, thirdPartyConfigs)=>{
    return !!results?.edges?.some(({ node: node })=>{
        const productKey = (0, $Y34Hw.getProductFromProviderId)(thirdPartyConfigs, node.providerId) || (0, $Y34Hw.getIntegrationKey)(node.integrationId);
        if (!productKey) // if no integration id it's a 1p
        return false;
        return (0, $1yEFx.is3pProductKeyForAnalytics)(productKey);
    });
};
const $4571e76365892ec4$export$b4ce9e0c6695ed08 = ()=>{
    const [{ thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [results] = (0, $djVCD.useResults)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const resultsState = (0, $djVCD.useResultsState)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [requestId] = (0, $djVCD.useResultsRequestId)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [error] = (0, $djVCD.useResultsError)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const { retrySearch: retrySearch, resetSort: resetSort, clearAllFilters: clearAllFilters } = (0, $djVCD.useSearchActions)();
    const { hasFiltersSelected: hasFiltersSelected } = (0, $4VkIo.useSelectedFilters)({});
    const intercom = (0, $9afb3d504f643405$export$f0fed4b0765d7314)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    $4571e76365892ec4$var$useFireAnalytics(resultsState, thirdPartyConfigs);
    if (thirdPartyConfigs?.[(0, $hB77E.ProductKeys3P).GoogleDrive]?.impersonationEnabled && selectedProduct === undefined) (0, $2OtFZ.triggerExposureForWeakLinkExp)();
    const [isOnline, _] = (0, $42omo.useState)(navigator.onLine);
    (0, $42omo.useEffect)(()=>{
        if (results && results.edges && results.edges.length >= 0) {
            (0, $bVltF.searchResultsLoadUFOExperience).mark('render_end');
            (0, $bVltF.searchResultsLoadUFOExperience).success({
                metadata: {
                    productFilter: selectedProduct,
                    requestId: requestId,
                    applicationMode: applicationMode
                }
            });
            // Only fire intercom results shown events when there are actually results
            // as we don't know when the user has connected their 3P provider or not
            if (results.edges.length > 0) {
                if ((0, $1yEFx.is3pProductKeyForAnalytics)(selectedProduct)) intercom?.trackEvent('search_results_shown_3p', {
                    product_filter: selectedProduct
                });
                else intercom?.trackEvent('search_results_shown', {
                    product_filter: selectedProduct
                });
            }
        } else if (error && !results) (0, $bVltF.searchResultsLoadUFOExperience).failure({
            metadata: {
                productFilter: selectedProduct,
                applicationMode: applicationMode
            }
        });
    }, [
        results,
        selectedProduct,
        error,
        intercom,
        requestId,
        applicationMode
    ]);
    (0, $42omo.useEffect)(()=>{
        (0, $c7e627886411fcb9$export$5e3e5ca9e3ba891b)(isOnline, (0, (/*@__PURE__*/$parcel$interopDefault($6df538e2e254fd26$exports))), (0, $c7e627886411fcb9$export$add61e2630a21f9), (0, (/*@__PURE__*/$parcel$interopDefault($d264f14dd361aa2b$exports))), (0, $c7e627886411fcb9$export$4be43fd067fd9d7f));
    }, [
        isOnline
    ]);
    const showResultCountAndSort = (0, $42omo.useMemo)(()=>selectedProduct === (0, $1yEFx.ProductKeys).Confluence, [
        selectedProduct
    ]);
    if (resultsState === (0, $fZ3l2.ResultsStates).IS_LOADING) return /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
        name: "search-page-results-loading",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e0d9e2bc48f29be1$export$18a2402e95ebb069), {})
    });
    if (resultsState === (0, $fZ3l2.ResultsStates).INITIAL) return /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
        name: "search-page-results-landing",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $28c89da883c58c8b$export$12449a31c6671d53), {})
    });
    if (resultsState === (0, $fZ3l2.ResultsStates).RESULTS) return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: "search-page-results",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
            children: [
                showResultCountAndSort && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $4571e76365892ec4$var$resultCountAndSortContainer,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {})
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $7bZ3i.SmartCardProvider), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ec0db18ecef5405c$export$4a34de49b46a2bfa), {})
                })
            ]
        })
    });
    if (resultsState === (0, $fZ3l2.ResultsStates).NO_RESULTS) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $88900765e2dbc6d9$export$f8a5875a19110e65), {
            filtersEnabled: Boolean(selectedProduct) || hasFiltersSelected,
            clearFilters: ()=>{
                clearAllFilters();
                resetSort();
            }
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            (0, $dh538.fg)('result_error_info_in_non_prod') && /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                children: false
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $e0e03289eec21c4f$export$edf27be85e5f6da0), {
                fetchResults: retrySearch,
                error: error
            })
        ]
    });
};
const $4571e76365892ec4$export$8841f6f549512fc2 = (results, thirdPartyConfigs)=>{
    return results?.edges?.map(({ node: node }, index)=>{
        const productKey = (0, $Y34Hw.getProductFromProviderId)(thirdPartyConfigs, node.providerId) || (0, $Y34Hw.getIntegrationKey)(node.integrationId);
        const [firstPartyProduct, , , ] = (0, $6h3V2.getProductAndIDFromARI)(node.id);
        const resultAri = (0, $k4HRJ.AnyAri).parse(node?.id || '');
        let hasLinkInDescription = false;
        if (resultAri.resourceOwner in (0, $1yEFx.products1P)) {
            const links = (0, $514d99dea8b7ae4b$export$a414b3d5a172e15b)(node?.description ?? '');
            if (links && links.length > 0) hasLinkInDescription = true;
        }
        return {
            id: node.id,
            product: productKey || firstPartyProduct,
            position: index,
            metadata: {
                connectorType: (0, $kQT7c.getResultConnectorSource)({
                    connectorType: node.connectorType,
                    resultNodeId: node.id,
                    productKey: productKey,
                    thirdPartyConfigs: thirdPartyConfigs
                }),
                boostedLinksShown: node?.linkedResults ? node?.linkedResults.length > 0 && index <= (0, $b7a5d3c4b4eaddeb$export$f0079efc6806b623) : undefined,
                fanoutResultsShown: node?.linkedResults && node?.linkedResults.length > 0 && index <= (0, $b7a5d3c4b4eaddeb$export$f0079efc6806b623) ? node.linkedResults.slice(0, (0, $b7a5d3c4b4eaddeb$export$82bce033e6b355fc)).map((link)=>{
                    let is3P = false;
                    try {
                        is3P = !((0, $k4HRJ.AnyAri).parse(link.id).resourceOwner in (0, $1yEFx.products1P));
                    } catch  {
                        is3P = false;
                    }
                    return {
                        id: link.id,
                        category: link.category,
                        is3P: is3P
                    };
                }) : undefined,
                hasLinkInDescription: hasLinkInDescription
            }
        };
    }) || [];
};











































var $5XpfZ = parcelRequire("5XpfZ");


var $dS0qJ = parcelRequire("dS0qJ");





var $19BAV = parcelRequire("19BAV");









const $052357e0aba090f3$var$anchorStyles = (0, $ecnYn.xcss)({
    color: 'color.link',
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'underline'
    },
    ':active': {
        textDecoration: 'none'
    },
    ':visited': {
        color: 'color.link.visited'
    },
    ':visited:active': {
        color: 'color.link.visited.pressed'
    }
});
const $052357e0aba090f3$var$useFireClickEvent = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const [{ cloudId: cloudId }] = (0, $j4ply.useBootstrap)();
    return (additionalAttributes)=>{
        // Check if this is a hello tenant - only hello tenants can pass sensitive fields
        const isHelloTenant = (0, $5XpfZ.isHello)(cloudId);
        let filteredAttributes = {
            ...additionalAttributes
        };
        if (!isHelloTenant) // For non-hello tenants, replace fields with values to [REDACTED], keep null as null
        filteredAttributes = {
            ...filteredAttributes,
            originalQuery: additionalAttributes?.originalQuery ? '[REDACTED]' : null,
            replacementQuery: additionalAttributes?.replacementQuery ? '[REDACTED]' : null,
            suggestedQuery: additionalAttributes?.suggestedQuery ? '[REDACTED]' : null
        };
        fireAnalyticsEvent({
            eventType: 'ui',
            actionSubject: `${(0, $6yNqK.ACTION_SUBJECT_PREFIX)}AutoCorrection`,
            action: 'clicked',
            attributes: {
                commonAttributes: commonAttributes,
                additionalAttributes: filteredAttributes
            }
        });
    };
};
const $052357e0aba090f3$var$useFireShownEvent = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const [{ cloudId: cloudId }] = (0, $j4ply.useBootstrap)();
    return (additionalAttributes)=>{
        // Check if this is a hello tenant - only hello tenants can pass sensitive fields
        const isHelloTenant = (0, $5XpfZ.isHello)(cloudId);
        let filteredAttributes = {
            ...additionalAttributes
        };
        if (!isHelloTenant) // For non-hello tenants, replace fields with values to [REDACTED], keep null as null
        filteredAttributes = {
            ...filteredAttributes,
            originalQuery: additionalAttributes?.originalQuery ? '[REDACTED]' : null,
            replacementQuery: additionalAttributes?.replacementQuery ? '[REDACTED]' : null,
            suggestedQuery: additionalAttributes?.suggestedQuery ? '[REDACTED]' : null
        };
        fireAnalyticsEvent({
            eventType: 'ui',
            actionSubject: `${(0, $6yNqK.ACTION_SUBJECT_PREFIX)}AutoCorrection`,
            action: 'shown',
            attributes: {
                commonAttributes: commonAttributes,
                additionalAttributes: filteredAttributes
            }
        });
    };
};
const $052357e0aba090f3$var$AutoCorrection = ()=>{
    (0, $922c14edc5967a62$export$60bd4eb259acb432)();
    const { queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const [originalQueryUrlParam] = (0, $djVCD.useOriginalQuery)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [queryInfo] = (0, $djVCD.useQueryInfo)();
    const fireClickEvent = $052357e0aba090f3$var$useFireClickEvent();
    const fireShownEvent = $052357e0aba090f3$var$useFireShownEvent();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const resultsState = (0, $djVCD.useResultsState)();
    const hasTrackedShown = (0, $42omo.useRef)(false);
    const { generateSearchUrl: generateSearchUrl } = (0, $7WbA8.useAppContext)();
    const shouldShowAutoCorrection = resultsState === (0, $fZ3l2.ResultsStates).NO_RESULTS || resultsState === (0, $fZ3l2.ResultsStates).RESULTS;
    // Fire shown events when auto-correction is displayed
    (0, $42omo.useEffect)(()=>{
        if ((0, $dh538.fg)('rovo-search-spelling-correction')) {
            const { originalQuery: originalQuery, replacementQuery: replacementQuery, suggestedQuery: suggestedQuery, originalQueryType: originalQueryType, confidenceScore: confidenceScore, shouldTriggerAutocorrectionExperience: shouldTriggerAutocorrectionExperience } = queryInfo || {};
            const showAutoCorrection = (replacementQuery || suggestedQuery) && shouldTriggerAutocorrectionExperience;
            if (showAutoCorrection) {
                // Generate a unique key for the current auto-correction state
                // Only depend on the actual auto-correction data, not URL parameters
                const autoCorrectionKey = `${replacementQuery || ''}-${suggestedQuery || ''}`;
                if (hasTrackedShown.current !== autoCorrectionKey) {
                    hasTrackedShown.current = autoCorrectionKey;
                    if (!originalQueryUrlParam && replacementQuery) {
                        // Fire shown events for replacement and original
                        fireShownEvent({
                            autoCorrectionType: 'replacement',
                            originalQueryType: originalQueryType,
                            confidenceScore: confidenceScore,
                            originalQuery: originalQuery,
                            replacementQuery: replacementQuery,
                            suggestedQuery: null,
                            originalQueryHash: originalQuery ? (0, $a0M2t.sha256Hash)(originalQuery) : null,
                            replacementQueryHash: replacementQuery ? (0, $a0M2t.sha256Hash)(replacementQuery) : null,
                            suggestedQueryHash: null
                        });
                        fireShownEvent({
                            autoCorrectionType: 'original',
                            originalQueryType: originalQueryType,
                            confidenceScore: confidenceScore,
                            originalQuery: originalQuery,
                            replacementQuery: replacementQuery,
                            suggestedQuery: null,
                            originalQueryHash: originalQuery ? (0, $a0M2t.sha256Hash)(originalQuery) : null,
                            replacementQueryHash: replacementQuery ? (0, $a0M2t.sha256Hash)(replacementQuery) : null,
                            suggestedQueryHash: null
                        });
                    }
                    if (!replacementQuery && suggestedQuery) // Fire shown event for suggested
                    fireShownEvent({
                        autoCorrectionType: 'suggested',
                        originalQueryType: originalQueryType,
                        confidenceScore: confidenceScore,
                        originalQuery: originalQuery,
                        replacementQuery: null,
                        suggestedQuery: suggestedQuery,
                        originalQueryHash: originalQuery ? (0, $a0M2t.sha256Hash)(originalQuery) : null,
                        replacementQueryHash: null,
                        suggestedQueryHash: suggestedQuery ? (0, $a0M2t.sha256Hash)(suggestedQuery) : null
                    });
                }
            }
        }
    }, [
        queryInfo,
        fireShownEvent,
        originalQueryUrlParam
    ]);
    if (!shouldShowAutoCorrection) return null;
    if ((0, $dh538.fg)('rovo-search-spelling-correction')) {
        const { originalQuery: originalQuery, replacementQuery: replacementQuery, suggestedQuery: suggestedQuery, originalQueryType: originalQueryType, confidenceScore: confidenceScore, shouldTriggerAutocorrectionExperience: shouldTriggerAutocorrectionExperience } = queryInfo || {};
        /**
     * Show auto correction if:
     * - replacementQuery is available
     * - shouldTriggerAutocorrectionExperience is true (currently not available)
     */ const showAutoCorrection = (replacementQuery || suggestedQuery) && shouldTriggerAutocorrectionExperience;
        if (showAutoCorrection) {
            if (!originalQueryUrlParam && replacementQuery) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $5dK2X.default), {
                            size: "large",
                            weight: "medium",
                            children: [
                                "Showing results for",
                                ' ',
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $jAenQ.Link), {
                                    href: generateSearchUrl({
                                        ...queryParams,
                                        text: replacementQuery,
                                        originalQuery: originalQuery
                                    }),
                                    xcss: $052357e0aba090f3$var$anchorStyles,
                                    onClick: ()=>fireClickEvent({
                                            autoCorrectionType: 'replacement',
                                            originalQueryType: originalQueryType,
                                            confidenceScore: confidenceScore,
                                            originalQuery: originalQuery,
                                            replacementQuery: replacementQuery,
                                            suggestedQuery: null,
                                            originalQueryHash: originalQuery ? (0, $a0M2t.sha256Hash)(originalQuery) : null,
                                            replacementQueryHash: replacementQuery ? (0, $a0M2t.sha256Hash)(replacementQuery) : null,
                                            suggestedQueryHash: null
                                        }),
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                        as: "em",
                                        size: "large",
                                        weight: "medium",
                                        color: "color.link",
                                        children: replacementQuery
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $5dK2X.default), {
                            children: [
                                "Search instead for",
                                ' ',
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $jAenQ.Link), {
                                    href: generateSearchUrl({
                                        ...queryParams,
                                        text: originalQuery,
                                        originalQuery: replacementQuery
                                    }),
                                    xcss: $052357e0aba090f3$var$anchorStyles,
                                    onClick: ()=>fireClickEvent({
                                            autoCorrectionType: 'original',
                                            originalQueryType: originalQueryType,
                                            confidenceScore: confidenceScore,
                                            originalQuery: originalQuery,
                                            replacementQuery: replacementQuery,
                                            suggestedQuery: null,
                                            originalQueryHash: originalQuery ? (0, $a0M2t.sha256Hash)(originalQuery) : null,
                                            replacementQueryHash: replacementQuery ? (0, $a0M2t.sha256Hash)(replacementQuery) : null,
                                            suggestedQueryHash: null
                                        }),
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                        as: "em",
                                        color: "color.link",
                                        children: originalQuery
                                    })
                                })
                            ]
                        })
                    })
                ]
            });
            if (!replacementQuery && suggestedQuery) return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $5dK2X.default), {
                    size: "large",
                    weight: "medium",
                    children: [
                        "Did you mean",
                        ' ',
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $jAenQ.Link), {
                            // TODO: Why changing the query using query params and not Store actions?
                            href: generateSearchUrl({
                                ...queryParams,
                                text: suggestedQuery,
                                originalQuery: originalQuery
                            }),
                            xcss: $052357e0aba090f3$var$anchorStyles,
                            onClick: ()=>fireClickEvent({
                                    autoCorrectionType: 'suggested',
                                    originalQueryType: originalQueryType,
                                    confidenceScore: confidenceScore,
                                    originalQuery: originalQuery,
                                    replacementQuery: null,
                                    suggestedQuery: suggestedQuery,
                                    originalQueryHash: originalQuery ? (0, $a0M2t.sha256Hash)(originalQuery) : null,
                                    replacementQueryHash: null,
                                    suggestedQueryHash: suggestedQuery ? (0, $a0M2t.sha256Hash)(suggestedQuery) : null
                                }),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                as: "em",
                                size: "large",
                                weight: "medium",
                                color: "color.link",
                                children: suggestedQuery
                            })
                        })
                    ]
                })
            });
        }
    }
    return null;
};
const $052357e0aba090f3$var$AutoCorrectionIfEligible = ()=>{
    const { locale: locale } = (0, $8C5kA.default)();
    const areLLMFeaturesEnabled = (0, $71988ef00edd4050$export$5c2913b6a4d1611c)();
    if (!(0, $dS0qJ.isEnglishLocale)(locale) || !areLLMFeaturesEnabled) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $19BAV.default), {
        requiredMode: (0, $9vOy1.ApplicationModes).Rovo,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
            name: "search-page-auto-correction",
            children: /*#__PURE__*/ (0, $l998X.jsx)($052357e0aba090f3$var$AutoCorrection, {})
        })
    });
};
var $052357e0aba090f3$export$2e2bcd8739ae039 = $052357e0aba090f3$var$AutoCorrectionIfEligible;





parcelRequire("42omo");





var $eXmBZ = parcelRequire("eXmBZ");


var $2Nwuj = parcelRequire("2Nwuj");













const $568e46a0202ac34d$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    dismissMessage: {
        id: "new-product-message-banner-dismiss-message",
        defaultMessage: "Dismiss"
    },
    assetsAsAnAppBannerText: {
        id: "assets-search-available-soon-message-banner",
        defaultMessage: "<bold>Assets will be available here soon</bold>. For now, try <assetsSearchLink>Assets search</assetsSearchLink>."
    }
});


const $26a950b385d21113$var$containerStyles = (0, $ecnYn.xcss)({
    wordBreak: 'break-word',
    borderRadius: 'radius.small',
    backgroundColor: 'color.background.information',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    paddingTop: 'space.150',
    paddingBottom: 'space.150'
});
const $26a950b385d21113$var$AssetsAppMessageBanner = ({ testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
            alignItems: "center",
            templateAreas: [
                'icon text cta'
            ],
            templateColumns: "min-content 1fr auto",
            columnGap: "space.150",
            testId: testId,
            xcss: $26a950b385d21113$var$containerStyles,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                    label: "information",
                    color: "var(--ds-icon-brand)"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
                    space: "space.050",
                    alignBlock: "center",
                    shouldWrap: true,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                        size: "medium",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $568e46a0202ac34d$export$defe85febe8b728c).assetsAsAnAppBannerText,
                            values: {
                                assetsSearchLink: (children)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                        href: "/jira/assets?showSearch=true",
                                        children: children
                                    }),
                                bold: (children)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                        weight: "bold",
                                        children: children
                                    })
                            }
                        })
                    })
                })
            ]
        })
    });
};
var $26a950b385d21113$export$2e2bcd8739ae039 = $26a950b385d21113$var$AssetsAppMessageBanner;



















































var $7yOcR = parcelRequire("7yOcR");


var $8UOsA = parcelRequire("8UOsA");





var $7Yuqm = parcelRequire("7Yuqm");

const $cc710e5633c22833$var$messages = (0, $cgtv4.defineMessages)({
    giveFeedbackText: {
        id: "give_feedback_text",
        defaultMessage: "Give feedback"
    }
});
/**
 * Renders a give feedback button and controls whether to display the feedback form.
 */ const $cc710e5633c22833$var$Feedback = ({ cloudId: cloudId, primaryProduct: primaryProduct, experimentConfig: experimentConfig, selectedProducts: selectedProducts, user: user, applicationMode: applicationMode, source: source, appearance: appearance, buttonRef: buttonRef, requestId: requestId, traceId: traceId, isCQL: isCQL })=>{
    const intl = (0, $8C5kA.default)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [traceIdForFeedbackCollector, setTraceIdForFeedbackCollector] = (0, $42omo.useState)('');
    const [requestIdForFeedbackCollector, setRequestIdForFeedbackCollector] = (0, $42omo.useState)('');
    (0, $42omo.useEffect)(()=>{
        if (traceId) setTraceIdForFeedbackCollector(traceId);
    }, [
        traceId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (requestId) setRequestIdForFeedbackCollector(requestId);
    }, [
        requestId
    ]);
    const updateTraceAndRequestIdFromRelay = (0, $42omo.useCallback)(()=>{
        const { traceId: traceIdForRelay } = (0, $1ymk3.getExtensionData)(isCQL || false);
        if (traceIdForRelay && traceIdForRelay !== traceIdForFeedbackCollector) {
            setTraceIdForFeedbackCollector(traceIdForRelay);
            // using traceId for now, for backwards compatibility, this will be updated with integration test later
            setRequestIdForFeedbackCollector(traceIdForRelay);
        }
    }, [
        traceIdForFeedbackCollector,
        isCQL
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            appearance === 'subtle' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                appearance: "subtle",
                onClick: (e)=>{
                    updateTraceAndRequestIdFromRelay();
                    e.preventDefault();
                    setIsOpen(true);
                },
                iconBefore: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7yOcR))), {
                        color: "currentColor",
                        label: "Give feedback"
                    }),
                ref: buttonRef,
                children: intl.formatMessage($cc710e5633c22833$var$messages.giveFeedbackText)
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $8UOsA.FeedbackButton), {
                onClick: (e)=>{
                    updateTraceAndRequestIdFromRelay();
                    e.preventDefault();
                    setIsOpen(true);
                }
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $7Yuqm.default), {
                cloudId: cloudId || '',
                experimentConfig: experimentConfig,
                isOpen: isOpen,
                primaryProduct: primaryProduct || '',
                product: selectedProducts.length ? selectedProducts.join(', ') : 'no product filter',
                source: source,
                setIsOpen: setIsOpen,
                userId: user.id || '',
                userName: user.name || '',
                mode: applicationMode,
                requestId: requestIdForFeedbackCollector,
                traceId: traceIdForFeedbackCollector
            })
        ]
    });
};
var $cc710e5633c22833$export$2e2bcd8739ae039 = $cc710e5633c22833$var$Feedback;





const $e6f52813e1dbd344$export$975b2b7393cd0143 = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: (0, $6yNqK.EVENT_SOURCE),
        eventType: 'ui',
        action: 'dismissed',
        actionSubject: 'inlineMessageBanner',
        attributes: {
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });




















const $371a77e5c2a47d4b$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    bannerText: {
        id: "new-product-message-banner",
        defaultMessage: "{product} was only recently added and we're still tweaking the results."
    },
    dismissMessage: {
        id: "new-product-message-banner-dismiss-message",
        defaultMessage: "Dismiss"
    }
});


const $683ceb08130b194d$var$containerStyles = (0, $ecnYn.xcss)({
    wordBreak: 'break-word',
    borderRadius: 'radius.small',
    backgroundColor: 'color.background.information',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    paddingTop: 'space.150',
    paddingBottom: 'space.150'
});
const $683ceb08130b194d$var$actionsContainer = (0, $ecnYn.xcss)({
    flexBasis: 'fit-content'
});
const $683ceb08130b194d$var$actionStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.150',
    paddingRight: 'space.150'
});
const $683ceb08130b194d$var$newProducts = {
    [(0, $1yEFx.ProductKeys).Bitbucket]: 'Bitbucket',
    [(0, $1yEFx.ProductKeys).JiraProductDiscovery]: 'Jira Product Discovery',
    [(0, $1yEFx.ProductKeys).JiraServiceManagement]: 'Jira Service Management'
};
const $683ceb08130b194d$var$NewProductMessageBanner = ({ testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [searchQuery] = (0, $djVCD.useSearchQuery)();
    const [trackSearchQuery, setTrackSearchQuery] = (0, $42omo.useState)(searchQuery);
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [cloudId] = (0, $4Qo4W.useCloudId)();
    const [experimentConfig] = (0, $j4ply.useExperimentConfig)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const [selectedProducts] = (0, $djVCD.useSelectedProducts)();
    const [user] = (0, $4Qo4W.useUser)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const [showProductBanner, setShowProductBanner] = (0, $42omo.useState)({
        [(0, $1yEFx.ProductKeys).Bitbucket]: true,
        [(0, $1yEFx.ProductKeys).JiraProductDiscovery]: true,
        [(0, $1yEFx.ProductKeys).JiraServiceManagement]: true
    });
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [requestId] = (0, $djVCD.useResultsRequestId)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const traceId = (0, $djVCD.useResultsTraceId)();
    (0, $42omo.useEffect)(()=>{
        // reset to default state
        if (searchQuery !== trackSearchQuery) {
            setShowProductBanner({
                [(0, $1yEFx.ProductKeys).Bitbucket]: true,
                [(0, $1yEFx.ProductKeys).JiraProductDiscovery]: true,
                [(0, $1yEFx.ProductKeys).JiraServiceManagement]: true
            });
            setTrackSearchQuery(searchQuery);
        }
    }, [
        searchQuery,
        trackSearchQuery
    ]);
    const onDismiss = ()=>{
        fireAnalyticsEvent((0, $e6f52813e1dbd344$export$975b2b7393cd0143)({
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
        setShowProductBanner((prev)=>({
                ...prev,
                [selectedProduct]: false
            }));
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: selectedProduct in showProductBanner && showProductBanner[selectedProduct] && /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
            alignItems: "center",
            templateAreas: [
                'icon text cta'
            ],
            templateColumns: "min-content 1fr auto",
            columnGap: "space.150",
            testId: testId,
            xcss: $683ceb08130b194d$var$containerStyles,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                    label: "information",
                    color: "var(--ds-icon-brand)"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
                    space: "space.050",
                    alignBlock: "center",
                    shouldWrap: true,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                        size: "medium",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $371a77e5c2a47d4b$export$defe85febe8b728c).bannerText,
                            values: {
                                product: /*#__PURE__*/ (0, $l998X.jsx)("b", {
                                    children: $683ceb08130b194d$var$newProducts[selectedProduct]
                                })
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                    testId: testId && `${testId}--actions`,
                    space: "space.150",
                    rowSpace: "space.0",
                    alignBlock: "center",
                    xcss: $683ceb08130b194d$var$actionsContainer,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                            xcss: $683ceb08130b194d$var$actionStyles,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
                                section: "SearchPageNewProductMessageBanner",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cc710e5633c22833$export$2e2bcd8739ae039), {
                                    source: "search-page-new-product-banner",
                                    cloudId: cloudId || '',
                                    experimentConfig: experimentConfig,
                                    primaryProduct: primaryProduct,
                                    user: user,
                                    applicationMode: applicationMode,
                                    selectedProducts: selectedProducts,
                                    requestId: requestId || '',
                                    traceId: traceId
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
                            onClick: onDismiss,
                            label: formatMessage((0, $371a77e5c2a47d4b$export$defe85febe8b728c).dismissMessage),
                            appearance: 'subtle',
                            spacing: 'compact'
                        })
                    ]
                })
            ]
        })
    });
};
var $683ceb08130b194d$export$2e2bcd8739ae039 = $683ceb08130b194d$var$NewProductMessageBanner;


/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ 




























/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 

































var $i2RLU = parcelRequire("i2RLU");


var $2zyFZ = parcelRequire("2zyFZ");




const $d9ccd4ce0db98dc8$export$296e0cc1e82f1480 = ()=>({
        source: (0, $6yNqK.EVENT_SOURCE),
        eventType: 'ui',
        actionSubject: 'link',
        action: 'clicked',
        actionSubjectId: 'browserExtensionCTA',
        attributes: {
            additionalAttributes: {
                componentName: 'BrowserExtensionBanner'
            }
        }
    });








const $b2ac47778ad6ae54$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    title: {
        id: "search-page.browser-extension-banner.title",
        defaultMessage: "Use Rovo wherever you are"
    },
    linkText: {
        id: "search-page.browser-extension-banner.link-text",
        defaultMessage: "Get the browser extension"
    },
    closeButtonLabel: {
        id: "search-page.browser-extension-banner.close-button-label",
        defaultMessage: "Close browser extension banner"
    }
});


const $b0ebf52c770dccf7$var$styles = {
    banner: "_2rko12b0 _189ee4h9 _1dqonqa1 _1h6d1l7x _1mouu2gc _kqswh2mm _1tke1et3 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _1itk3whj",
    content: "_kqswh2mm _4t3i1osq _1e0c1txw _2lx21bp4 _1bah1yb4",
    header: "_zulputpp _1e0c1txw _2lx21bp4 _4cvr1y6m _otyru2gc _1o9zidpf",
    title: "_11c81qyo _k48p1pd9 _syazi7uo _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _slp31hna _1i4q1hna _ct361wug",
    closeButtonContainer: "_kqswstnw _154ize3t _1xi2ze3t _1pbykb7n",
    linkContainer: "_zulp1b66 _1e0c1txw _4cvr1h6o _1o9zidpf _19pk1wug"
};
const $b0ebf52c770dccf7$var$isGoogleChromeBrowser = ()=>{
    if (typeof navigator === 'undefined') return false;
    const uaData = navigator.userAgentData;
    const brands = uaData?.brands?.map((b)=>b.brand) ?? [];
    if (brands.length) {
        const result = brands.includes('Google Chrome') && !brands.some((b)=>/(Microsoft Edge|Opera)/i.test(b));
        return result;
    }
    const ua = navigator.userAgent || '';
    const isDesktopChrome = /Chrome\/\d+/.test(ua) && !/(Edg|OPR|Chromium)\//.test(ua);
    const isIOS = /\b(iPad|iPhone|iPod)\b/.test(ua) || /CriOS\/\d+/.test(ua);
    return isDesktopChrome && !isIOS;
};
const $b0ebf52c770dccf7$var$isRovoExtensionInstalled = ()=>{
    try {
        // Check for the rovoExtension object that the extension injects
        return typeof window?.rovoExtension?.openChat === 'function';
    } catch  {
        return false;
    }
};
const $b0ebf52c770dccf7$var$STORAGE_KEY = 'search-page-rovo-browser-extension-banner-state';
const $b0ebf52c770dccf7$var$getBannerState = ()=>{
    const state = (0, $5G9KX.getLocalStorageItem)($b0ebf52c770dccf7$var$STORAGE_KEY);
    return state || {
        isCTAClicked: false,
        isDismissed: false
    };
};
const $b0ebf52c770dccf7$var$setBannerState = (updates)=>{
    const currentState = $b0ebf52c770dccf7$var$getBannerState();
    const newState = {
        ...currentState,
        ...updates
    };
    (0, $5G9KX.setLocalStorageItem)($b0ebf52c770dccf7$var$STORAGE_KEY, JSON.stringify(newState));
};
const $b0ebf52c770dccf7$var$hasUserDismissedBanner = ()=>{
    return $b0ebf52c770dccf7$var$getBannerState().isDismissed;
};
const $b0ebf52c770dccf7$var$hasUserClickedCTA = ()=>{
    return $b0ebf52c770dccf7$var$getBannerState().isCTAClicked;
};
const $b0ebf52c770dccf7$export$246e5924b4316cdf = ()=>{
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $7WbA8.useAppContext)();
    (0, $42omo.useEffect)(()=>{
        // Check if AI/LLM features are enabled based on entitlements
        const areLLMPoweredFeaturesEnabled = (0, $dh538.fg)('rovo_search_updated_entitlement_checks_for_team_25') ? isRovoLLMEnabled : isAdminHubAIEnabled;
        const extensionInstalled = $b0ebf52c770dccf7$var$isRovoExtensionInstalled();
        const userDismissed = $b0ebf52c770dccf7$var$hasUserDismissedBanner();
        const userClickedCTA = $b0ebf52c770dccf7$var$hasUserClickedCTA();
        const isChrome = $b0ebf52c770dccf7$var$isGoogleChromeBrowser();
        const shouldShow = areLLMPoweredFeaturesEnabled && isChrome && !extensionInstalled && !userDismissed && !userClickedCTA && (0, $c6GJD.default).getExperimentValue('rovo-expansion-fps-extension-install-exp', 'isEnabled', false);
        setIsVisible(shouldShow);
    }, [
        isAdminHubAIEnabled,
        isRovoLLMEnabled
    ]);
    const markAsDismissed = ()=>{
        $b0ebf52c770dccf7$var$setBannerState({
            isDismissed: true
        });
        setIsVisible(false);
    };
    const markCTAClicked = ()=>{
        $b0ebf52c770dccf7$var$setBannerState({
            isCTAClicked: true
        });
        setIsVisible(false);
    };
    return {
        isVisible: isVisible,
        markAsDismissed: markAsDismissed,
        markCTAClicked: markCTAClicked
    };
};
const $b0ebf52c770dccf7$export$8316e1225e2e8973 = ({ testId: testId = 'browser-extension-banner', fireAnalyticsEvent: fireAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { isVisible: isVisible, markAsDismissed: markAsDismissed, markCTAClicked: markCTAClicked } = $b0ebf52c770dccf7$export$246e5924b4316cdf();
    const handleDismiss = ()=>{
        markAsDismissed(); // Fire analytics event for banner dismissal
        if (fireAnalyticsEvent) fireAnalyticsEvent((0, $i2RLU.onBannerDismissed)({
            componentName: 'BrowserExtensionBanner'
        }));
    };
    const handleCTAClick = ()=>{
        markCTAClicked(); // Fire analytics event for CTA click
        if (fireAnalyticsEvent) fireAnalyticsEvent((0, $d9ccd4ce0db98dc8$export$296e0cc1e82f1480)());
    };
    (0, $42omo.useEffect)(()=>{
        if (isVisible && fireAnalyticsEvent) fireAnalyticsEvent((0, $2zyFZ.onBannerShown)({
            componentName: 'BrowserExtensionBanner'
        }));
    }, [
        fireAnalyticsEvent,
        isVisible
    ]);
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $b0ebf52c770dccf7$var$styles.banner,
        testId: testId,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
            xcss: $b0ebf52c770dccf7$var$styles.content,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $b0ebf52c770dccf7$var$styles.closeButtonContainer,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        spacing: "compact",
                        appearance: "subtle",
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                                size: "small",
                                label: ""
                            }),
                        label: formatMessage((0, $b2ac47778ad6ae54$export$defe85febe8b728c).closeButtonLabel),
                        onClick: handleDismiss,
                        testId: `${testId}-close`
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    xcss: $b0ebf52c770dccf7$var$styles.header,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.RovoIcon), {
                            appearance: "brand",
                            shouldUseNewLogoDesign: true,
                            size: "small"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $b0ebf52c770dccf7$var$styles.title,
                            children: formatMessage((0, $b2ac47778ad6ae54$export$defe85febe8b728c).title)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $b0ebf52c770dccf7$var$styles.linkContainer,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                        href: "https://chromewebstore.google.com/detail/npbjhobkibekbklkghlhfhieggcggpdb?utm_source=confluence-full-page-search&utm_medium=persistent-banner&utm_campaign=rovo_extension_confluence_fps_install_cta",
                        target: "_blank",
                        appearance: "default",
                        testId: `${testId}-link`,
                        onClick: handleCTAClick,
                        children: formatMessage((0, $b2ac47778ad6ae54$export$defe85febe8b728c).linkText)
                    })
                })
            ]
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");










const $5e9cfc142ef96d2f$var$styles = null;
const $5e9cfc142ef96d2f$var$NAV3_HEIGHT = 56;
const $5e9cfc142ef96d2f$var$NAV4_HEIGHT = 48;
const $5e9cfc142ef96d2f$var$HEADER_FILTER_HEIGHT_WITH_NAV3 = 140;
const $5e9cfc142ef96d2f$var$HEADER_FILTER_HEIGHT_WITH_NAV4 = 76;
const $5e9cfc142ef96d2f$export$f39f3f768bc98e3d = ({ ariaLabel: ariaLabel, testId: testId, children: children })=>{
    const { isNav4Enabled: isNav4Enabled } = (0, $7WbA8.useAppContext)();
    const navHeight = isNav4Enabled ? $5e9cfc142ef96d2f$var$NAV4_HEIGHT : $5e9cfc142ef96d2f$var$NAV3_HEIGHT;
    const headerFilterHeight = (0, $2OtFZ.serveRightRailImprovementsWithoutExposure)() ? isNav4Enabled ? $5e9cfc142ef96d2f$var$HEADER_FILTER_HEIGHT_WITH_NAV4 : $5e9cfc142ef96d2f$var$HEADER_FILTER_HEIGHT_WITH_NAV3 : 0;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "group",
        "aria-label": ariaLabel,
        "data-testid": testId,
        style: {
            height: `calc(100vh - ${navHeight}px - ${headerFilterHeight}px)`
        },
        className: (0, $gMc0m.default)([
            "_1rjcv47k _18zr1b66 _1e0c1txw _vchhusvi _2lx21bp4 _18m91wug _1reo15vq _1bahv2br"
        ]),
        children: children
    });
};





parcelRequire("42omo");






const $1ee81a6dccb3a778$var$filterOptionListGridAreaStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.200',
    width: '100%'
});
const $1ee81a6dccb3a778$var$filterOptionStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    gap: 'space.100',
    alignItems: 'center',
    paddingInline: 'space.150'
});
const $1ee81a6dccb3a778$var$baseStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: 'radius.small'
});
const $1ee81a6dccb3a778$var$iconStyles = (0, $ecnYn.xcss)({
    width: 'size.200',
    height: 'size.200'
});
const $1ee81a6dccb3a778$var$contentStyles = (0, $ecnYn.xcss)({
    height: "var(--ds-space-200, 16px)"
});
const $1ee81a6dccb3a778$var$textStyles = (0, $ecnYn.xcss)({
    flex: 'auto'
});
const $1ee81a6dccb3a778$var$countStyles = (0, $ecnYn.xcss)({
    width: 'size.300'
});
const $1ee81a6dccb3a778$var$FilterOptionSkeleton = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $1ee81a6dccb3a778$var$filterOptionStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $1ee81a6dccb3a778$var$baseStyles,
                    $1ee81a6dccb3a778$var$iconStyles
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $1ee81a6dccb3a778$var$baseStyles,
                    $1ee81a6dccb3a778$var$contentStyles,
                    $1ee81a6dccb3a778$var$textStyles
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $1ee81a6dccb3a778$var$baseStyles,
                    $1ee81a6dccb3a778$var$contentStyles,
                    $1ee81a6dccb3a778$var$countStyles
                ]
            })
        ]
    });
};
const $1ee81a6dccb3a778$export$c597ff09df837ae9 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $1ee81a6dccb3a778$var$filterOptionListGridAreaStyles,
        testId: "app-filter-sidebar-loading",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($1ee81a6dccb3a778$var$FilterOptionSkeleton, {}),
            /*#__PURE__*/ (0, $l998X.jsx)($1ee81a6dccb3a778$var$FilterOptionSkeleton, {}),
            /*#__PURE__*/ (0, $l998X.jsx)($1ee81a6dccb3a778$var$FilterOptionSkeleton, {}),
            /*#__PURE__*/ (0, $l998X.jsx)($1ee81a6dccb3a778$var$FilterOptionSkeleton, {}),
            /*#__PURE__*/ (0, $l998X.jsx)($1ee81a6dccb3a778$var$FilterOptionSkeleton, {}),
            /*#__PURE__*/ (0, $l998X.jsx)($1ee81a6dccb3a778$var$FilterOptionSkeleton, {}),
            /*#__PURE__*/ (0, $l998X.jsx)($1ee81a6dccb3a778$var$FilterOptionSkeleton, {}),
            /*#__PURE__*/ (0, $l998X.jsx)($1ee81a6dccb3a778$var$FilterOptionSkeleton, {}),
            /*#__PURE__*/ (0, $l998X.jsx)($1ee81a6dccb3a778$var$FilterOptionSkeleton, {}),
            /*#__PURE__*/ (0, $l998X.jsx)($1ee81a6dccb3a778$var$FilterOptionSkeleton, {})
        ]
    });
};























































var $4Nwes = parcelRequire("4Nwes");




var $9yyKc = parcelRequire("9yyKc");




const $767c61a72117c665$export$8debfec283cb37b9 = {
    Confluence: 'confluence',
    Atlas: 'atlas',
    Jira: 'jira',
    JiraServiceManagement: 'jira-servicedesk'
};
const $767c61a72117c665$export$a4919093f6d1d650 = {
    [$767c61a72117c665$export$8debfec283cb37b9.Confluence]: {
        productCategory: $767c61a72117c665$export$8debfec283cb37b9.Confluence,
        displayName: 'Confluence',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.ConfluenceIcon), 'Confluence'),
        products: [
            (0, $1yEFx.ProductKeys).Confluence,
            (0, $1yEFx.ProductKeys).ConfluenceDC
        ]
    },
    [$767c61a72117c665$export$8debfec283cb37b9.Atlas]: {
        productCategory: $767c61a72117c665$export$8debfec283cb37b9.Atlas,
        displayName: 'Atlas',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $4Nwes.AtlassianIcon), 'Atlas'),
        products: [
            (0, $1yEFx.ProductKeys).Atlas,
            (0, $1yEFx.ProductKeys).AtlassianWebCrawler
        ]
    },
    [$767c61a72117c665$export$8debfec283cb37b9.Jira]: {
        productCategory: $767c61a72117c665$export$8debfec283cb37b9.Jira,
        displayName: 'Jira',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.JiraIcon), 'Jira'),
        products: [
            (0, $1yEFx.ProductKeys).Jira,
            (0, $1yEFx.ProductKeys).JiraDC
        ]
    },
    [$767c61a72117c665$export$8debfec283cb37b9.JiraServiceManagement]: {
        productCategory: $767c61a72117c665$export$8debfec283cb37b9.JiraServiceManagement,
        displayName: 'Jira Service Management',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.JiraServiceManagementIcon), 'Jira Service Management'),
        products: [
            (0, $1yEFx.ProductKeys).JiraServiceManagement,
            (0, $1yEFx.ProductKeys).JsmDC
        ]
    }
};
const $767c61a72117c665$export$a7242197dd5e4d4a = (productKey)=>{
    return Object.values($767c61a72117c665$export$a4919093f6d1d650).find((categoryConfig)=>categoryConfig.productCategory === productKey);
};








const $f6a925dc3308ab80$export$1b49510872e7246c = 'platform.search-platform.rovo-changeboarding-app-selectors';
const $f6a925dc3308ab80$export$d2ea4f931a71a509 = 'plex-filters-changeboarding-rovo-free';












var $6Gk8m = parcelRequire("6Gk8m");


















const $2d40e93801a0fc92$var$getComponentId = (groupId)=>`filter-group-${groupId.toLowerCase()}`;
const $2d40e93801a0fc92$var$AccordionContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    defaultIsExpanded: false,
    isOpen: false,
    setIsOpen: ()=>{},
    displayChevron: false,
    hasSelection: false
});
const $2d40e93801a0fc92$var$accordionPressableStyles = (0, $ecnYn.xcss)({
    background: 'none',
    display: 'flex',
    width: '100%',
    padding: '0'
});
const $2d40e93801a0fc92$var$accordionItemsStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.150'
});
const $2d40e93801a0fc92$export$d99097c13d4dac9f = ({ children: children, triggerComponent: triggerComponent, onClick: onClick, groupId: groupId, defaultIsExpanded: defaultIsExpanded = false, hasSelection: hasSelection = false })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(defaultIsExpanded);
    const [displayChevron, setDisplayChevron] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        setIsOpen(defaultIsExpanded);
    }, [
        defaultIsExpanded
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)($2d40e93801a0fc92$var$AccordionProvider, {
        defaultIsExpanded: defaultIsExpanded,
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        displayChevron: displayChevron,
        hasSelection: hasSelection,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
                "aria-expanded": isOpen,
                "aria-current": !isOpen && hasSelection,
                id: $2d40e93801a0fc92$var$getComponentId(groupId),
                testId: $2d40e93801a0fc92$var$getComponentId(groupId),
                xcss: $2d40e93801a0fc92$var$accordionPressableStyles,
                onBlur: ()=>setDisplayChevron(false),
                onFocus: ()=>setDisplayChevron(true),
                onMouseOver: ()=>setDisplayChevron(true),
                onMouseLeave: ()=>setDisplayChevron(false),
                onClick: ()=>{
                    const newIsOpen = !isOpen;
                    setIsOpen(()=>newIsOpen);
                    if (onClick && newIsOpen) onClick(newIsOpen);
                },
                children: triggerComponent
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                role: "list",
                xcss: $2d40e93801a0fc92$var$accordionItemsStyles,
                children: isOpen && children
            })
        ]
    });
};
function $2d40e93801a0fc92$var$AccordionProvider(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)($2d40e93801a0fc92$var$AccordionContext.Provider, {
        value: props,
        children: props.children
    });
}
function $2d40e93801a0fc92$export$35e88b08325f7140() {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($2d40e93801a0fc92$var$AccordionContext);
    if (context === undefined) throw new Error('useAccordion must be used within a AccordionContext');
    return context;
}









var $5izcQ = parcelRequire("5izcQ");





















var $5RBJ9 = parcelRequire("5RBJ9");











var $cclHy = parcelRequire("cclHy");



const $b3bd4a67e85b92b5$var$initialState = {
    spotlight: {
        state: 'hidden'
    }
};
const $b3bd4a67e85b92b5$var$actions = {
    start: ()=>({ getState: getState, setState: setState })=>{
            const { spotlight: spotlight } = getState();
            if (spotlight.state !== 'hidden') return;
            setState({
                spotlight: {
                    state: 'visible',
                    activeSpotlight: 0
                }
            });
        },
    end: ()=>({ setState: setState })=>{
            setState({
                spotlight: {
                    state: 'seen'
                }
            });
        },
    dismiss: ()=>({ setState: setState })=>{
            setState({
                spotlight: {
                    state: 'dismiss'
                }
            });
        }
};
const $b3bd4a67e85b92b5$var$SpotlightStore = (0, $1P1Tu.createStore)({
    initialState: $b3bd4a67e85b92b5$var$initialState,
    actions: $b3bd4a67e85b92b5$var$actions,
    name: 'SpotlightStore'
});
const $b3bd4a67e85b92b5$export$d52beefead77af4c = (0, $9zUhf.createActionsHook)($b3bd4a67e85b92b5$var$SpotlightStore);
const $b3bd4a67e85b92b5$export$42b1420c4bc8ee20 = (0, $9zUhf.createHook)($b3bd4a67e85b92b5$var$SpotlightStore);
const $b3bd4a67e85b92b5$export$a771c137b2620ff2 = (0, $9zUhf.createHook)($b3bd4a67e85b92b5$var$SpotlightStore, {
    selector: (0, $cclHy.createSelector)((state)=>state.spotlight, (spotlightState)=>spotlightState)
});





var $ab59ce683a834372$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    ok: {
        id: "rovo-onboarding-ok",
        defaultMessage: "OK"
    },
    onboardingStep1Heading: {
        id: "rovo-onboarding-step-1-heading",
        defaultMessage: "Search across company apps"
    },
    onboardingStep1Description: {
        id: "rovo-onboarding-step-1-description",
        defaultMessage: "Choose an app to get more relevant results and filters. For example, filter by Space in Confluence."
    }
});


const $63f7e261fffd03d9$var$spotlightAnalyticsPayload = (action, attributes)=>({
        actionSubject: 'rovoChangeboardingSpotlight',
        attributes: {
            additionalAttributes: attributes
        },
        eventType: 'ui',
        action: action
    });
const $63f7e261fffd03d9$export$af2c08784ffc2e37 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [spotlight, { dismiss: dismiss }] = (0, $b3bd4a67e85b92b5$export$a771c137b2620ff2)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const renderSpotlight = spotlight.state === 'visible' && availableProducts.length > 0; // Only render the spotlight after available products have been fetched
    (0, $42omo.useEffect)(()=>{
        if (renderSpotlight) fireAnalyticsEvent($63f7e261fffd03d9$var$spotlightAnalyticsPayload('view spotlight', {
            step: spotlight.activeSpotlight + 1 // activeSpotlight starts at 0
        }));
    }, [
        fireAnalyticsEvent,
        renderSpotlight,
        spotlight
    ]);
    if (!renderSpotlight) return null;
    const renderActiveSpotlight = ()=>{
        const spotlights = [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5RBJ9.default), {
                actions: [
                    {
                        onClick: ()=>{
                            dismiss();
                            fireAnalyticsEvent($63f7e261fffd03d9$var$spotlightAnalyticsPayload('click ok', {
                                step: spotlight.activeSpotlight + 1 // activeSpotlight starts at 0
                            }));
                        },
                        text: formatMessage((0, $ab59ce683a834372$export$2e2bcd8739ae039).ok),
                        appearance: 'subtle'
                    }
                ],
                heading: formatMessage((0, $ab59ce683a834372$export$2e2bcd8739ae039).onboardingStep1Heading),
                target: (0, $f6a925dc3308ab80$export$1b49510872e7246c),
                dialogWidth: 275,
                dialogPlacement: "left top",
                targetRadius: 8,
                children: formatMessage((0, $ab59ce683a834372$export$2e2bcd8739ae039).onboardingStep1Description)
            }, (0, $f6a925dc3308ab80$export$1b49510872e7246c))
        ];
        return spotlights[spotlight.activeSpotlight];
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
        children: renderActiveSpotlight()
    });
};


const $8dc422bc1cdea1f9$var$gridOverlapStyles = (0, $ecnYn.xcss)({
    gridRow: 1,
    gridColumn: 1
});
const $8dc422bc1cdea1f9$var$spotlightFillStyles = (0, $ecnYn.xcss)({
    height: '100%',
    width: '100%'
});
const $8dc422bc1cdea1f9$var$isAboveSmBreakpoint = ()=>window.innerWidth > 768;
const $8dc422bc1cdea1f9$export$95d78afe1ba1dce1 = ({ children: children, name: name })=>{
    const [displaySpotlight] = (0, $42omo.useState)($8dc422bc1cdea1f9$var$isAboveSmBreakpoint());
    if (!displaySpotlight) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $8dc422bc1cdea1f9$var$gridOverlapStyles,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5izcQ.default), {
                            name: name,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                xcss: $8dc422bc1cdea1f9$var$spotlightFillStyles
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $8dc422bc1cdea1f9$var$gridOverlapStyles,
                        children: children
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
                name: "search-page-onboarding-spotlight",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $63f7e261fffd03d9$export$af2c08784ffc2e37), {})
            })
        ]
    });
};





/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






























parcelRequire("42omo");











const $d8565f7ad7385d82$var$styles = (0, $ecnYn.xcss)({
    marginLeft: 'auto'
});
const $d8565f7ad7385d82$export$bb17ebbbeb7ce35d = (option)=>{
    const { count: count, isSelected: isSelected, resultCountLimit: resultCountLimit } = option;
    if (count === undefined) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {});
    const countExceedsLimit = !!(resultCountLimit && count >= resultCountLimit);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $d8565f7ad7385d82$var$styles,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $5dK2X.default), {
            color: isSelected ? 'color.text.accent.blue' : 'color.text.subtlest',
            size: "small",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $cgtv4.FormattedNumber), {
                    value: countExceedsLimit ? resultCountLimit : count,
                    notation: 'compact'
                }),
                countExceedsLimit && /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                    children: "+"
                })
            ]
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");







const $7b53561762001049$var$styles = {
    countLoading: "_2rko12b0 _bfhkysee _4t3i7vkz _1bsbzwfg"
};
const $7b53561762001049$export$d279ab0e61c6c87b = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($7b53561762001049$var$styles.countLoading),
        testId: "result-count-loading"
    });
};


const $42c79e2f0c046f7e$var$accordionFilterTriggerStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    display: 'flex',
    width: '100%',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    color: 'color.text',
    gap: 'space.100',
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    }
});
const $42c79e2f0c046f7e$var$accordionFilterTriggerSelectedStyles = (0, $ecnYn.xcss)({
    color: 'color.text.accent.blue',
    background: "var(--ds-background-selected, #E9F2FE)",
    ':hover': {
        color: 'color.text.accent.blue',
        background: "var(--ds-background-selected, #E9F2FE)"
    }
});
const $42c79e2f0c046f7e$var$iconStyles = (0, $ecnYn.xcss)({
    minWidth: '24px',
    minHeight: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $42c79e2f0c046f7e$var$contentStyles = (0, $ecnYn.xcss)({
    width: '100%',
    flex: 1
});
const $42c79e2f0c046f7e$var$labelStyles = {
    truncated: "_3fcw1q9c _1reo15vq _18m915vq _1bto1l2s _y3gnv2br"
};
const $42c79e2f0c046f7e$export$fd50ae2bcf5da2e1 = ({ icon: icon, label: label, count: count, countLoading: countLoading })=>{
    const { displayChevron: displayChevron, isOpen: isOpen, hasSelection: hasSelection } = (0, $2d40e93801a0fc92$export$35e88b08325f7140)();
    const labelRef = (0, $42omo.useRef)(null);
    const shouldTooltipAppear = ()=>(labelRef.current?.offsetWidth ?? 0) < (labelRef.current?.scrollWidth ?? 0);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: [
            $42c79e2f0c046f7e$var$accordionFilterTriggerStyles,
            hasSelection && !isOpen && $42c79e2f0c046f7e$var$accordionFilterTriggerSelectedStyles
        ],
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                xcss: $42c79e2f0c046f7e$var$iconStyles,
                "aria-hidden": true,
                children: [
                    displayChevron && isOpen && /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                        label: "",
                        size: "small"
                    }),
                    displayChevron && !isOpen && /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                        label: "",
                        size: "small"
                    }),
                    !displayChevron && icon
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $42c79e2f0c046f7e$var$contentStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    content: label,
                    delay: 300,
                    canAppear: shouldTooltipAppear,
                    hideTooltipOnClick: true,
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
                        templateColumns: "1fr max-content",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "space.100",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                xcss: (0, $1Whri.cx)($42c79e2f0c046f7e$var$labelStyles.truncated),
                                ref: labelRef,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                    color: "inherit",
                                    children: label
                                })
                            }),
                            countLoading ? /*#__PURE__*/ (0, $l998X.jsx)((0, $7b53561762001049$export$d279ab0e61c6c87b), {}) : /*#__PURE__*/ (0, $l998X.jsx)((0, $d8565f7ad7385d82$export$bb17ebbbeb7ce35d), {
                                count: count,
                                isSelected: hasSelection
                            })
                        ]
                    })
                })
            })
        ]
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 

































parcelRequire("42omo");








var $aRCWA = parcelRequire("aRCWA");


var $9VJDA = parcelRequire("9VJDA");


var $56M4r = parcelRequire("56M4r");

var $7rvPL = parcelRequire("7rvPL");














const $681c93d9b8abe194$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    menuTriggerLabel: {
        id: "search-page.app-filter-sidebar.filter-menu.trigger",
        defaultMessage: "Show more options"
    },
    hideMenuItemLabel: {
        id: "search-page.app-filter-sidebar.filter-menu.menu-item.hide",
        defaultMessage: "Hide app"
    }
});


const $16ecf1ad5ce5b545$var$overflowMenu = (0, $ecnYn.xcss)({
    opacity: 0,
    width: '0px',
    // hide it by making it very small. We need it in the DOM so that it's focusable
    ':focus-within': {
        opacity: 1,
        width: 'auto'
    }
});
const $16ecf1ad5ce5b545$var$overflowMenuVisible = (0, $ecnYn.xcss)({
    opacity: 1,
    width: 'auto',
    marginLeft: 'space.100'
});
const $16ecf1ad5ce5b545$var$FilterMenu = ({ isVisible: isVisible, isMenuOpen: isMenuOpen = false, onClick: onClick, onClickMenuItem: onClickMenuItem, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: [
            isVisible ? $16ecf1ad5ce5b545$var$overflowMenuVisible : $16ecf1ad5ce5b545$var$overflowMenu
        ],
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
            isOpen: isMenuOpen,
            onClose: onClose,
            placement: "bottom-end",
            content: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1GzhS.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7rvPL.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aRCWA))), {
                                label: ""
                            }),
                            onClick: (ev)=>{
                                ev.stopPropagation();
                                onClickMenuItem?.(ev, 'hide');
                                onClose?.(ev);
                            },
                            children: formatMessage((0, $681c93d9b8abe194$export$defe85febe8b728c).hideMenuItemLabel)
                        })
                    })
                }),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    ...triggerProps,
                    onClick: onClick,
                    label: formatMessage((0, $681c93d9b8abe194$export$defe85febe8b728c).menuTriggerLabel),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                    appearance: "subtle",
                    spacing: "compact"
                })
        })
    });
};
var $16ecf1ad5ce5b545$export$2e2bcd8739ae039 = $16ecf1ad5ce5b545$var$FilterMenu;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 




















var $i6xGB = parcelRequire("i6xGB");










var $afneb = parcelRequire("afneb");




const $7dab2c2c5855389e$export$4088a37018960a0f = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, product: product })=>({
        eventType: 'track',
        action: 'clicked',
        actionSubject: 'filterOptionTimeoutButton',
        attributes: {
            additionalAttributes: {
                product: product
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });





const $23e66b0e1267ac0f$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    timeoutTooltip: {
        id: "search-page.app-filter-sidebar.product-timeout-tooltip",
        defaultMessage: "{product} results were too slow to show"
    },
    timeoutPrimaryText: {
        id: "search-page.app-filter-sidebar.product-timeout-primary-text",
        defaultMessage: "{product} results took too long to show"
    },
    timeoutSecondaryText: {
        id: "search-page.app-filter-sidebar.product-timeout-secondary-text",
        defaultMessage: "Try again by filtering just for {product}."
    },
    timeoutButtonText: {
        id: "search-page.app-filter-sidebar.product-timeout-button-text",
        defaultMessage: "See only {product} results"
    }
});


const $bca72fe813e6693a$var$styles = {
    trigggerContainer: "_2hwxr5cr",
    tooltip: "_2rkofajl _11c8wadc _vchhusvi _p12f1ns9 _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _85i51b66 _1q511b66 _y4ti12x7 _bozg12x7 _slp31hna",
    popupContainer: "_2rko12b0 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _1e0c1txw _2lx21bp4",
    popupPrimaryText: "_11c8fhey _k48p1wq8 _1wpz1y6m",
    popupSecondaryText: "_11c8fhey _k48pi7a9 _1wpz1y6m _19pkv77o _otyrv77o",
    buttonContainer: "_1wpzesu3 _19pkpxbi"
};
const $bca72fe813e6693a$var$TimeoutTooltip = /*#__PURE__*/ (0, $42omo.forwardRef)(function CustomTooltip({ children: children, className: className, ...rest }, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $afneb.default), {
        ...rest,
        // https://atlassian.design/components/tooltip/examples
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $gMc0m.default)([
            $bca72fe813e6693a$var$styles.tooltip,
            className
        ]),
        ref: ref,
        children: children
    });
});
const $bca72fe813e6693a$export$433d5c9b4b3a90fa = ({ option: option, setIsMouseOver: setIsMouseOver })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const trigger = (triggerProps)=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($bca72fe813e6693a$var$styles.trigggerContainer),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                component: $bca72fe813e6693a$var$TimeoutTooltip,
                content: formatMessage((0, $23e66b0e1267ac0f$export$defe85febe8b728c).timeoutTooltip, {
                    product: option.label
                }),
                position: "bottom",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    testId: `search-page-filter-option-timeout-${option.value}`,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($i6xGB))),
                    appearance: "subtle",
                    spacing: "compact",
                    label: formatMessage((0, $23e66b0e1267ac0f$export$defe85febe8b728c).timeoutTooltip, {
                        product: option.label
                    }),
                    isSelected: isOpen,
                    onClick: (event)=>{
                        event.stopPropagation();
                        setIsOpen(!isOpen);
                    },
                    ...triggerProps
                })
            })
        });
    };
    const content = ()=>{
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($bca72fe813e6693a$var$styles.popupContainer),
            onPointerDown: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: (0, $1Whri.cx)($bca72fe813e6693a$var$styles.popupPrimaryText),
                    children: formatMessage((0, $23e66b0e1267ac0f$export$defe85febe8b728c).timeoutPrimaryText, {
                        product: option.label
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: (0, $1Whri.cx)($bca72fe813e6693a$var$styles.popupSecondaryText),
                    children: formatMessage((0, $23e66b0e1267ac0f$export$defe85febe8b728c).timeoutSecondaryText, {
                        product: option.label
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: (0, $1Whri.cx)($bca72fe813e6693a$var$styles.buttonContainer),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        testId: `search-page-filter-option-timeout-button-${option.value}`,
                        appearance: "primary",
                        onClick: (event)=>{
                            event.stopPropagation();
                            setIsOpen(false);
                            option.onSelect?.();
                            setIsMouseOver(false);
                            fireAnalyticsEvent((0, $7dab2c2c5855389e$export$4088a37018960a0f)({
                                commonAttributes: commonAttributes,
                                nonPrivacySafeAttributes: nonPrivacySafeAttributes,
                                product: option.value
                            }));
                        },
                        children: formatMessage((0, $23e66b0e1267ac0f$export$defe85febe8b728c).timeoutButtonText, {
                            product: option.label
                        })
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        isOpen: isOpen,
        content: content,
        trigger: trigger,
        placement: "bottom-end",
        onClose: ()=>setIsOpen(false)
    });
};





const $f50a0b647d44470a$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    groupLabel: {
        id: "search-page.app-filter-sidebar.group",
        defaultMessage: "Filter search by app"
    },
    allFilterLabel: {
        id: "search-page.app-filter-sidebar.all",
        defaultMessage: "All"
    },
    noMatchingResultsTooltip: {
        id: "search-page.app-filter-sidebar.no-matching-results-tooltip",
        defaultMessage: "No matching results in {product}"
    }
});




const $73f6cd01fde76615$var$baseStyles = (0, $ecnYn.xcss)({
    height: '36px',
    paddingInline: 'space.150',
    width: '100%',
    color: 'color.text',
    background: 'none'
});
const $73f6cd01fde76615$var$selectedStyles = (0, $ecnYn.xcss)({
    color: 'color.text.accent.blue',
    background: "var(--ds-background-selected, #E9F2FE)",
    ':hover': {
        color: 'color.text.accent.blue',
        background: "var(--ds-background-selected, #E9F2FE)"
    }
}); // NOTE: When cleaning up rovo_filters_discoverability FG, add borderLeft attribute to selectedStyles above
const $73f6cd01fde76615$var$selectedStyleBorder = (0, $ecnYn.xcss)({
    // @ts-ignore
    // - Don't want to use borderLeft because it takes up space
    // - Can't use outline because we can't only target the left side to have the outline
    // - We'd rather ignore the TS error than add a new div with margin or position hacks
    boxShadow: `inset ${"var(--ds-space-025, 2px)"} 0px ${"var(--ds-border-selected, #1868DB)"}`
});
const $73f6cd01fde76615$var$containerStyles = (0, $ecnYn.xcss)({
    position: 'relative',
    paddingBottom: 'space.025',
    width: '100%',
    ':hover': {
        color: 'color.text',
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    }
});
const $73f6cd01fde76615$var$containerStylesZeroCount = (0, $ecnYn.xcss)({
    opacity: 0.5
});
const $73f6cd01fde76615$var$inlineStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.075'
}); // Spacer to reserve space for the FilterMenu when it's visible in the overlay.
// This maintains the same label truncation as when FilterMenu was inside the grid.
// Matches the visible FilterMenu: 32px (compact IconButton) + 8px marginLeft.
const $73f6cd01fde76615$var$filterMenuSpacerStyles = (0, $ecnYn.xcss)({
    width: '32px',
    marginLeft: 'space.100',
    height: '0px'
});
const $73f6cd01fde76615$var$interactiveOverlayStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    right: 'space.150',
    // Adjust for paddingBottom on container to align with Pressable content center
    top: 'calc(50% - 1px)',
    transform: 'translateY(-50%)',
    display: 'flex',
    alignItems: 'center'
});
const $73f6cd01fde76615$var$labelStyles = {
    truncated: "_1reo15vq _18m915vq _3fcw1q9c _11c8fhey _1bto1l2s _y3gn1e5h _1o9zkb7n"
};
const $73f6cd01fde76615$var$gridStyles = (0, $ecnYn.xcss)({
    width: '100%'
});
const $73f6cd01fde76615$var$testIdGenerator = (value, isShowMore)=>{
    if (isShowMore) return 'search-page-app-filter-sidebar-show-more';
    if (value) return `filter-${value}`;
    return 'filter-all';
};
const $73f6cd01fde76615$var$FilterOption = ({ option: option, isDisabled: isDisabled, oAuthWarning: oAuthWarning = null, triggerProps: triggerProps, onClickMenuItem: onClickMenuItem, onClick: onClick, ariaRole: ariaRole, isHidden: isHidden, isShowMore: isShowMore = false })=>{
    const [isMouseOver, setIsMouseOver] = (0, $42omo.useState)(false);
    const [isMenuOpen, setIsMenuOpen] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isConnector = Boolean(option.value) && option.value !== 'goal' && option.value !== 'project' && option.value !== 'atlassian-web-crawler';
    const isMenuTriggerVisible = !isHidden && isConnector && (isMouseOver || isMenuOpen) && !(option.isPrimaryProduct || false);
    const noMatchingResults = option?.count === 0;
    const shouldBeGreyedOut = !option.isSelected && noMatchingResults && !isDisabled;
    const labelRef = (0, $42omo.useRef)(null);
    const canTooltipAppear = (0, $42omo.useCallback)(()=>noMatchingResults || !isMenuOpen && (labelRef.current?.offsetWidth ?? 0) < (labelRef.current?.scrollWidth ?? 0), [
        noMatchingResults,
        isMenuOpen
    ]);
    const tooltipContent = noMatchingResults ? formatMessage((0, $f50a0b647d44470a$export$defe85febe8b728c).noMatchingResultsTooltip, {
        product: option.label
    }) : option.label; // Determine which interactive element to show in the overlay (outside the button)
    const showTimeoutOverlay = !oAuthWarning && !option.countLoading && option.timeout && !option.isSelected;
    const showFilterMenuOverlay = !isHidden && !isShowMore && !(option.timeout && !option.isSelected) && !option.countLoading; // Show non-interactive content inside the button only when no interactive overlay is visible
    const showResultCount = !oAuthWarning && !option.countLoading && !(option.timeout && !option.isSelected) && !isMenuTriggerVisible;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: [
            $73f6cd01fde76615$var$containerStyles,
            shouldBeGreyedOut && $73f6cd01fde76615$var$containerStylesZeroCount
        ],
        onMouseEnter: ()=>setIsMouseOver(true),
        onMouseLeave: ()=>{
            setIsMouseOver(false);
        },
        onFocus: ()=>setIsMouseOver(true),
        onBlur: ()=>setIsMouseOver(false),
        role: ariaRole,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                content: tooltipContent,
                delay: 300,
                canAppear: canTooltipAppear,
                hideTooltipOnClick: true,
                children: /*#__PURE__*/ (0, $42omo.createElement)((0, $2W0qg.default), {
                    ...triggerProps,
                    key: option.value,
                    onClick: isDisabled ? ()=>{} : onClick,
                    xcss: [
                        $73f6cd01fde76615$var$baseStyles,
                        option.isSelected && $73f6cd01fde76615$var$selectedStyles,
                        option.isSelected && $73f6cd01fde76615$var$selectedStyleBorder
                    ],
                    padding: "space.0",
                    testId: $73f6cd01fde76615$var$testIdGenerator(option.value, isShowMore),
                    "aria-current": option.isSelected
                }, /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
                    templateColumns: "auto 1fr auto",
                    gap: "space.100",
                    alignItems: "center",
                    justifyContent: "start",
                    xcss: $73f6cd01fde76615$var$gridStyles,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $aRSt4.IconDecider), {
                            productOrNounKey: option.value,
                            isShowMore: isShowMore,
                            label: "",
                            size: "small",
                            isSelected: option.isSelected
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                            as: "div",
                            ref: labelRef,
                            xcss: (0, $1Whri.cx)($73f6cd01fde76615$var$labelStyles.truncated),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                color: option.isSelected ? 'color.text.accent.blue' : 'color.text',
                                align: "start",
                                children: option.label
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                            alignBlock: "center",
                            xcss: $73f6cd01fde76615$var$inlineStyles,
                            children: [
                                oAuthWarning ? oAuthWarning : option.countLoading ? /*#__PURE__*/ (0, $l998X.jsx)((0, $7b53561762001049$export$d279ab0e61c6c87b), {}) : showResultCount ? /*#__PURE__*/ (0, $l998X.jsx)((0, $d8565f7ad7385d82$export$bb17ebbbeb7ce35d), {
                                    count: option.count,
                                    isSelected: option.isSelected
                                }) : null,
                                isMenuTriggerVisible && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                    xcss: $73f6cd01fde76615$var$filterMenuSpacerStyles,
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    ]
                }))
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                xcss: $73f6cd01fde76615$var$interactiveOverlayStyles,
                children: [
                    showTimeoutOverlay && /*#__PURE__*/ (0, $l998X.jsx)((0, $bca72fe813e6693a$export$433d5c9b4b3a90fa), {
                        option: option,
                        setIsMouseOver: setIsMouseOver
                    }),
                    showFilterMenuOverlay && /*#__PURE__*/ (0, $l998X.jsx)((0, $16ecf1ad5ce5b545$export$2e2bcd8739ae039), {
                        isVisible: isMenuTriggerVisible,
                        onClickMenuItem: onClickMenuItem,
                        isMenuOpen: isMenuOpen,
                        onClick: (event)=>{
                            event.stopPropagation();
                            setIsMenuOpen(!isMenuOpen);
                        },
                        onClose: ()=>setIsMenuOpen(false)
                    })
                ]
            })
        ]
    });
};
var $73f6cd01fde76615$export$2e2bcd8739ae039 = $73f6cd01fde76615$var$FilterOption;



/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



























const $c395f352fa4770d3$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    showMoreLabel: {
        id: "search-page.app-filter-sidebar.show-more.button.label",
        defaultMessage: "Show more"
    },
    filterPlaceholder: {
        id: "search-page.app-filter-sidebar.show-more.filter.placeholder",
        defaultMessage: "Find apps"
    }
});


const $862f29a1de109ab0$var$TRIGGER_HEIGHT_OFFSET = 24;
const $862f29a1de109ab0$var$styles = {
    showMoreApps: "_c71l1dty _18m91wug"
};
const $862f29a1de109ab0$var$ShowMoreAppsDialog = ({ options: options = [], useIsUserOAuthed: useIsUserOAuthed, useOAuthHandlers: useOAuthHandlers, thirdPartyConfigs: thirdPartyConfigs, oAuthSource: oAuthSource })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [filter, setFilter] = (0, $42omo.useState)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    if (!options.length) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        content: ()=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                paddingBlock: "space.100",
                xcss: $862f29a1de109ab0$var$styles.showMoreApps,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        paddingInline: "space.100",
                        paddingBlockEnd: "space.150",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default), {
                            placeholder: formatMessage((0, $c395f352fa4770d3$export$defe85febe8b728c).filterPlaceholder),
                            onChange: (ev)=>setFilter(new RegExp(ev.currentTarget.value, 'i'))
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        role: "list",
                        children: options.filter((option)=>!filter || typeof option.label === 'string' && filter.test(option.label)).map((option)=>{
                            const isSmartlink = (0, $a5OFf.isProductSmartlink)({
                                productKey: option.value,
                                thirdPartyConfigs: thirdPartyConfigs
                            });
                            const reactKey = option.compositeKey || option.value;
                            return /*#__PURE__*/ (0, $l998X.jsx)((0, $eoZmS.OAuthWarningWrapper), {
                                datasourceId: option.datasourceId,
                                product: option.value,
                                trigger: ({ oAuthWarning: oAuthWarning, triggerProps: triggerProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $73f6cd01fde76615$export$2e2bcd8739ae039), {
                                        oAuthWarning: oAuthWarning,
                                        triggerProps: triggerProps,
                                        isHidden: true,
                                        option: option,
                                        onClick: ()=>{
                                            if (!oAuthWarning) {
                                                option.showFilter();
                                                option.onSelect();
                                                setIsOpen(false);
                                            }
                                        },
                                        ariaRole: "listitem"
                                    }, reactKey),
                                useOAuthHandlers: useOAuthHandlers,
                                useIsUserOAuthed: useIsUserOAuthed,
                                option: option,
                                isSmartlink: isSmartlink,
                                oAuthSource: oAuthSource,
                                thirdPartyConfigs: thirdPartyConfigs
                            }, reactKey);
                        })
                    })
                ]
            }),
        isOpen: isOpen,
        onClose: ()=>{
            setIsOpen(false);
            setFilter(undefined);
        },
        placement: "bottom-start",
        shouldFitContainer: true,
        offset: [
            0,
            -$862f29a1de109ab0$var$TRIGGER_HEIGHT_OFFSET
        ],
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $73f6cd01fde76615$export$2e2bcd8739ae039), {
                oAuthWarning: null,
                triggerProps: triggerProps,
                isDisabled: false,
                isShowMore: true,
                option: {
                    label: formatMessage((0, $c395f352fa4770d3$export$defe85febe8b728c).showMoreLabel),
                    isSelected: false,
                    value: undefined
                },
                onClick: ()=>{
                    setIsOpen(true);
                    setFilter(undefined);
                }
            }),
        modifiers: [
            {
                name: 'computeStyles',
                options: {
                    // Prevent use of 3D transforms to avoid creating a new stacking context for fixed position children
                    // This allows the connection prompt popup to appear to the left of this dialog
                    gpuAcceleration: false
                }
            }
        ]
    });
};
var $862f29a1de109ab0$export$2e2bcd8739ae039 = $862f29a1de109ab0$var$ShowMoreAppsDialog;






var $78e9ef1c2d2db925$export$285cbcdb788689a9 = /*#__PURE__*/ function(Sections) {
    Sections["VISIBLE_PRIMARY_PRODUCTS"] = "visible-primary-products";
    Sections["VISIBLE_PRODUCTS_WITH_RESULTS"] = "visible-products-with-results";
    Sections["VISIBLE_PRODUCTS_TO_AUTH"] = "visible-products-to-auth";
    Sections["HIDDEN_PRODUCTS"] = "hidden-products";
    Sections["NESTED_PRODUCTS"] = "nested-products";
    return Sections;
}({});
const $78e9ef1c2d2db925$var$PRODUCTS_WITH_RESULTS_DISPLAY_LIMIT = 10;
const $78e9ef1c2d2db925$var$PRODUCTS_TO_AUTH_DISPLAY_LIMIT = 3;
const $78e9ef1c2d2db925$var$sortByResultCount = (productResultCountMap)=>(a, b)=>{
        const aCount = productResultCountMap[a];
        const bCount = productResultCountMap[b];
        if (aCount === undefined) return 1;
        if (bCount === undefined) return -1;
        return bCount - aCount;
    };
const $78e9ef1c2d2db925$var$isPrimaryProduct = (productKey, primaryProduct)=>{
    const isAtlas = primaryProduct === (0, $1yEFx.ProductKeys).Atlas;
    if (isAtlas) return productKey === (0, $1yEFx.ProductKeys).Confluence || productKey === (0, $1yEFx.ProductKeys).Jira;
    return productKey === primaryProduct;
};
// Type guard to check if a string is a ProductKeys
function $78e9ef1c2d2db925$var$isProductKey(availableProducts, key) {
    return availableProducts.includes(key);
}
const $78e9ef1c2d2db925$export$beb7df217e8a6731 = ()=>{
    const nestedProducts = new Set();
    Object.values((0, $767c61a72117c665$export$a4919093f6d1d650)).forEach((categoryConfig)=>{
        categoryConfig.products.forEach((productKey)=>{
            // Skip the primary product of the category, only hide the nested ones
            if (productKey !== categoryConfig.productCategory) nestedProducts.add(productKey);
        });
    });
    return nestedProducts;
};
/**
 * Creates an aggregated count map where counts are summed up for individual products and their
 * nested products (e.g. Confluence = Confluence + Confluence DC).
 */ const $78e9ef1c2d2db925$var$createAggregatedCountMap = (productResultCountMap, availableProducts)=>{
    const aggregatedCountMap = {
        ...productResultCountMap
    };
    // For each product category, aggregate counts to the primary product
    Object.values((0, $767c61a72117c665$export$a4919093f6d1d650)).forEach((categoryConfig)=>{
        const primaryProductKey = categoryConfig.productCategory;
        let aggregatedCount = 0;
        categoryConfig.products.forEach((productKey)=>{
            const count = productResultCountMap[productKey] || 0;
            aggregatedCount += count;
        });
        // Only set aggregated count if the primary product is available
        if (availableProducts.includes(primaryProductKey) && aggregatedCount > 0) aggregatedCountMap[primaryProductKey] = aggregatedCount;
    });
    return aggregatedCountMap;
};
const $78e9ef1c2d2db925$export$53f40d04a46cef05 = ({ primaryProduct: primaryProduct, availableProducts: availableProducts, productResultCountMap: productResultCountMap, thirdPartyConfigs: thirdPartyConfigs, isProductHiddenByUser: isProductHiddenByUser, ignoreCounts: ignoreCounts = false, recommended3pApps: recommended3pApps })=>{
    const sections = new Map([
        [
            "visible-primary-products",
            []
        ],
        [
            "visible-products-with-results",
            []
        ],
        [
            "visible-products-to-auth",
            []
        ],
        [
            "hidden-products",
            []
        ],
        [
            "nested-products",
            []
        ]
    ]);
    const nestedProducts = $78e9ef1c2d2db925$export$beb7df217e8a6731();
    // Create aggregated count map which reflects both the individual product and nested DC products
    const aggregatedCountMap = $78e9ef1c2d2db925$var$createAggregatedCountMap(productResultCountMap, availableProducts);
    // Separate variable since we need to slice these later up to the limit
    const productsWithResults = [];
    const productsToAuth = [];
    // Iterate over all products and do an initial categorisation into sections.
    // For VISIBLE_PRODUCTS_WITH_RESULTS and VISIBLE_PRODUCTS_TO_AUTH we will do a second pass to enforce limits.
    for (const productKey of availableProducts){
        if ($78e9ef1c2d2db925$var$isPrimaryProduct(productKey, primaryProduct)) sections.get("visible-primary-products").push(productKey);
        else if (isProductHiddenByUser(productKey)) // Check hidden products after primary product check so that primary product is never hidden.
        sections.get("hidden-products").push(productKey);
        else if (nestedProducts.has(productKey)) sections.get("nested-products").push(productKey);
        else if (thirdPartyConfigs[productKey]?.userNeedsOAuth) productsToAuth.push(productKey);
        else if (ignoreCounts || (aggregatedCountMap[productKey] ?? 0) > 0) productsWithResults.push(productKey);
        else sections.get("hidden-products").push(productKey);
    }
    // A util to sort by counts (using aggregated counts)
    const sortByCountIfNeeded = ignoreCounts ? ()=>0 : $78e9ef1c2d2db925$var$sortByResultCount(aggregatedCountMap);
    // Products with results- sort, extract the TOP N and push the overflow to HIDDEN_PRODUCTS
    productsWithResults.sort(sortByCountIfNeeded);
    // TODO: we should include NESTED_PRODUCTS count when calculating how many items to show here
    sections.set("visible-products-with-results", productsWithResults.slice(0, $78e9ef1c2d2db925$var$PRODUCTS_WITH_RESULTS_DISPLAY_LIMIT));
    sections.get("hidden-products").push(...productsWithResults.slice($78e9ef1c2d2db925$var$PRODUCTS_WITH_RESULTS_DISPLAY_LIMIT));
    if (recommended3pApps.length > 0) {
        const recommendedAppsToAuth = recommended3pApps.filter((app)=>$78e9ef1c2d2db925$var$isProductKey(availableProducts, app)).filter((app)=>productsToAuth.includes(app));
        const otherAppsToAuth = productsToAuth.filter((app)=>!recommended3pApps.includes(app));
        const recommendationsAndDefault3pOrder = [
            ...recommendedAppsToAuth,
            ...otherAppsToAuth
        ];
        sections.set("visible-products-to-auth", recommendationsAndDefault3pOrder.slice(0, $78e9ef1c2d2db925$var$PRODUCTS_TO_AUTH_DISPLAY_LIMIT));
        sections.get("hidden-products").push(...recommendationsAndDefault3pOrder.slice($78e9ef1c2d2db925$var$PRODUCTS_TO_AUTH_DISPLAY_LIMIT));
    } else {
        // Products to auth - extract the TOP N and push the overflow to HIDDEN_PRODUCTS
        sections.set("visible-products-to-auth", productsToAuth.slice(0, $78e9ef1c2d2db925$var$PRODUCTS_TO_AUTH_DISPLAY_LIMIT));
        sections.get("hidden-products").push(...productsToAuth.slice($78e9ef1c2d2db925$var$PRODUCTS_TO_AUTH_DISPLAY_LIMIT));
    }
    // Finally sort HIDDEN_PRODUCTS section by count
    sections.get("hidden-products").sort(sortByCountIfNeeded);
    return sections;
};





const $66fdf3be8fc8b85e$export$63d5998c4291558c = (selectedProduct, selectedDatasource, productFilters, thirdPartyConfigs, onSelectProduct)=>{
    const fanoutProduct = productFilters.find((option)=>option.value === selectedProduct && option.value && option.value in thirdPartyConfigs && thirdPartyConfigs[option.value]?.fanOutConnectorSources);
    if (!fanoutProduct || !selectedDatasource) return null;
    return {
        ...fanoutProduct,
        label: selectedDatasource.workspaceName || fanoutProduct.label,
        compositeKey: `${fanoutProduct.value}-${selectedDatasource.datasourceId}`,
        onSelect: ()=>onSelectProduct(fanoutProduct.value, selectedDatasource),
        isSelected: true,
        datasourceId: selectedDatasource.datasourceId
    };
};
/**
 * Checks if an option supports fanout (multiple datasources)
 */ const $66fdf3be8fc8b85e$var$isFanoutEnabled = (option, thirdPartyConfigs)=>{
    return !!(option.value && option.value in thirdPartyConfigs && thirdPartyConfigs[option.value]?.fanOutConnectorSources);
};
const $66fdf3be8fc8b85e$export$a655af3e5904d3b1 = (hiddenApps, thirdPartyConfigs, selectedProduct, selectedDatasource, onSelectProduct)=>{
    // Create a Set for O(1) lookup of the selected datasource
    const selectedDatasourceId = selectedDatasource?.datasourceId;
    const selectedDatasourceSet = selectedDatasourceId ? new Set([
        selectedDatasourceId
    ]) : new Set();
    return hiddenApps.flatMap((option)=>{
        if ($66fdf3be8fc8b85e$var$isFanoutEnabled(option, thirdPartyConfigs)) {
            const datasources = thirdPartyConfigs[option.value].datasources || [];
            // Use a for loop for better performance when filtering
            const filteredDatasources = [];
            for(let i = 0; i < datasources.length; i++){
                const datasource = datasources[i];
                // If this product is selected with a specific datasource, exclude that datasource from hidden apps
                // (it's already in visible apps)
                if (option.value === selectedProduct && selectedDatasourceSet.has(datasource.datasourceId)) continue;
                filteredDatasources.push(datasource);
            }
            return filteredDatasources.map((datasource)=>{
                const compositeKey = `${option.value}-${datasource.datasourceId}`;
                return {
                    ...option,
                    label: datasource.workspaceName || option.label,
                    // Show count for fanout products if feature flag is enabled, otherwise undefined
                    count: (0, $dh538.fg)('result-count-for-fanned-out-connectors-enabled') ? option.count : undefined,
                    compositeKey: compositeKey,
                    onSelect: onSelectProduct ? ()=>onSelectProduct(option.value, datasource) : option.onSelect,
                    isSelected: option.value === selectedProduct && datasource.datasourceId === selectedDatasourceId,
                    datasourceId: datasource.datasourceId
                };
            });
        }
        return [
            option
        ];
    });
};
const $66fdf3be8fc8b85e$export$5f7dec9d1a00b559 = (option, thirdPartyConfigs, selectedProduct, selectedDatasource, onSelectProduct)=>{
    if (option.value && option.value in thirdPartyConfigs && thirdPartyConfigs[option.value]?.fanOutConnectorSources) {
        // Fanout: create options for each datasource
        const datasources = thirdPartyConfigs[option.value].datasources || [];
        // Show all datasources for this product, not just the selected one
        const filteredDatasources = datasources;
        return filteredDatasources.map((datasource)=>({
                ...option,
                label: datasource.workspaceName || option.label,
                // Show count for fanout products if feature flag is enabled, otherwise undefined
                // (it would show the aggregate count for all datasources, not the specific datasource count)
                count: (0, $dh538.fg)('result-count-for-fanned-out-connectors-enabled') ? option.count : undefined,
                compositeKey: `${option.value}-${datasource.datasourceId}`,
                onSelect: onSelectProduct ? ()=>onSelectProduct(option.value, datasource) : option.onSelect,
                isSelected: option.value === selectedProduct && datasource.datasourceId === selectedDatasource?.datasourceId,
                datasourceId: datasource.datasourceId
            }));
    }
    // Base case: use the original option
    return [
        option
    ];
};


const $ecaec232d474cc0a$var$dividerStyles = (0, $ecnYn.xcss)({
    width: '100%',
    borderBlockEnd: 'none',
    borderBlockStart: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    borderInline: 'none',
    marginTop: 'space.075',
    marginBottom: 'space.100'
});
const $ecaec232d474cc0a$export$2e0a83ec2e27ecbb = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $ecaec232d474cc0a$var$dividerStyles
    });
const $ecaec232d474cc0a$export$4fc9b866c5c60225 = (productResultCountMap, searchQuery, selectedProduct)=>{
    // Only Confluence allows an empty query so we should only return the count for Confluence
    if (selectedProduct === (0, $1yEFx.ProductKeys).Confluence && searchQuery === '') return undefined;
    return Object.keys(productResultCountMap).reduce((count, key)=>count += productResultCountMap[key], 0) || undefined;
};
const $ecaec232d474cc0a$var$MAX_VISIBLE_APP_FILTERS = 10;
const $ecaec232d474cc0a$var$NEW_MAX_VISIBLE_APP_FILTERS = 15;
const $ecaec232d474cc0a$var$getMaxVisibleAppFilters = ()=>{
    return (0, $2OtFZ.serveRightRailImprovementsWithoutExposure)() ? $ecaec232d474cc0a$var$NEW_MAX_VISIBLE_APP_FILTERS : $ecaec232d474cc0a$var$MAX_VISIBLE_APP_FILTERS;
};
/**
 * Checks if any datasource for a product is connected (doesn't need OAuth)
 * This is a utility function that avoids using hooks in loops
 */ const $ecaec232d474cc0a$var$hasAnyAuthedDatasource = (productKey, thirdPartyConfigs)=>{
    const productConfig = thirdPartyConfigs[productKey];
    return productConfig?.datasources?.some((ds)=>!ds?.userNeedsOAuth) ?? false;
};
const $ecaec232d474cc0a$export$ca41603276fc834c = ({ onSelectProduct: onSelectProduct, recommended3pApps: recommended3pApps, availableProducts: availableProducts, availableNouns: availableNouns, selectedProduct: selectedProduct, selectedDatasource: selectedDatasource, isNounsAvailable: isNounsAvailable, useOAuthHandlers: useOAuthHandlers, useIsUserOAuthed: useIsUserOAuthed, productResultCountMap: productResultCountMap = {}, sidebarStoredState: sidebarStoredState, onFilterHide: onFilterHide, onFilterShow: onFilterShow, thirdPartyConfigs: thirdPartyConfigs, searchQuery: searchQuery, primaryProduct: primaryProduct, isInitialState: isInitialState, onVisibleProductsToAuthShown: onVisibleProductsToAuthShown, personalisedProductSections: personalisedProductSections, setPersonalisedProductSections: setPersonalisedProductSections, productsWithTimeout: productsWithTimeout, resultCountsLoading: resultCountsLoading })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const products = (0, $1yEFx.useProductConfigs)();
    const visibleFiltersCount = (0, $42omo.useMemo)(()=>{
        return Object.values(sidebarStoredState?.filters ?? {}).filter((filter)=>{
            return filter && typeof filter === 'object' && 'hidden' in filter && !filter.hidden;
        }).length;
    }, [
        sidebarStoredState?.filters
    ]);
    const isProductHiddenByUser = (0, $42omo.useMemo)(()=>(productKey)=>{
            return !!sidebarStoredState?.filters?.[productKey]?.hidden;
        }, [
        sidebarStoredState?.filters
    ]);
    const productFilters = (0, $42omo.useMemo)(()=>{
        // Calculate shouldShowNouns inside the useMemo hook
        let shouldShowNouns;
        if (!isNounsAvailable) // Convoluting atlassian-web-crawler with nouns is a tech-debt, ideally it should be decoupled from nouns.
        shouldShowNouns = availableNouns.length > 0 || availableProducts.includes((0, $1yEFx.ProductKeys).AtlassianWebCrawler);
        else shouldShowNouns = availableProducts.includes((0, $1yEFx.ProductKeys).AtlassianWebCrawler) || isNounsAvailable;
        const availableProductsWithoutAtlasAndCustomWebsitesIfNounsAvailable = shouldShowNouns ? availableProducts.filter((key)=>thirdPartyConfigs[(0, $1yEFx.ProductKeys).AtlassianWebCrawler]?.fanOutConnectorSources ? key !== (0, $1yEFx.ProductKeys).Atlas : key !== (0, $1yEFx.ProductKeys).Atlas && key !== (0, $1yEFx.ProductKeys).AtlassianWebCrawler) : availableProducts;
        const createProductOption = (productKey, section)=>{
            const workspaceName = (0, $Y34Hw.getWorkspaceNameFromProduct)(productKey, thirdPartyConfigs);
            const isSelected = productKey === selectedProduct && !selectedDatasource;
            // workspaceName is available for Forge connectors and products with displayWorkspaceNameAsProductName
            // Otherwise fall back to displayName from products map
            const label = workspaceName || products[productKey]?.displayName || productKey;
            const count = productResultCountMap[productKey];
            const isPrimaryProduct = productKey === primaryProduct;
            return {
                label: label,
                count: count,
                value: productKey,
                isSelected: isSelected,
                isPrimaryProduct: isPrimaryProduct,
                productCategory: (0, $767c61a72117c665$export$a7242197dd5e4d4a)(productKey),
                onSelect: ()=>onSelectProduct(productKey),
                hideFilter: ()=>{
                    onFilterHide(productKey);
                    onSelectProduct(undefined);
                },
                showFilter: ()=>{
                    if (visibleFiltersCount >= $ecaec232d474cc0a$var$getMaxVisibleAppFilters()) return;
                    return onFilterShow(productKey);
                },
                resultCountLimit: productKey === (0, $1yEFx.ProductKeys).Trello ? 30 : undefined,
                section: section,
                countLoading: resultCountsLoading,
                timeout: productsWithTimeout?.includes(productKey)
            };
        };
        const productsOrder = (0, $6Gk8m.getProductsOrderByPrimaryProduct)(primaryProduct);
        const availableProductsInDefaultOrder = availableProductsWithoutAtlasAndCustomWebsitesIfNounsAvailable.filter((productKey)=>{
            // Forge connectors are dynamically added and won't be in the static products map
            if ((0, $9d9t8.isForgeConnectorProductKey)(productKey) && (0, $dh538.fg)('rovo-search-dynamic-forge-config')) return true;
            // For hardcoded products, check if they exist in the products map
            return !!products[productKey];
        }).sort((a, b)=>(0, $6Gk8m.getProductOrder)(a, b, productsOrder));
        let productOptions;
        if ((0, $dh538.fg)('rovo-search-right-rail-personalisation')) {
            // Ignore counts if:
            //  - we're in the initial state (to show the default order)
            //  - when counts are missing- we want to fall back to the default order and show all apps
            const ignoreCounts = isInitialState || Object.keys(productResultCountMap).length === 0;
            let productOrderWithDynamicSections = new Map();
            if ((0, $2OtFZ.serveSearchPageTimeoutsUX)()) {
                if (!personalisedProductSections) {
                    productOrderWithDynamicSections = (0, $78e9ef1c2d2db925$export$53f40d04a46cef05)({
                        primaryProduct: primaryProduct,
                        availableProducts: availableProductsInDefaultOrder,
                        productResultCountMap: productResultCountMap,
                        thirdPartyConfigs: thirdPartyConfigs,
                        isProductHiddenByUser: isProductHiddenByUser,
                        ignoreCounts: ignoreCounts,
                        recommended3pApps: recommended3pApps
                    });
                    // Store the order of the personalised sections for future use
                    // but only after a successful search has been made
                    if (!isInitialState) setPersonalisedProductSections?.(productOrderWithDynamicSections);
                } else productOrderWithDynamicSections = personalisedProductSections;
            } else productOrderWithDynamicSections = (0, $78e9ef1c2d2db925$export$53f40d04a46cef05)({
                primaryProduct: primaryProduct,
                availableProducts: availableProductsInDefaultOrder,
                productResultCountMap: productResultCountMap,
                thirdPartyConfigs: thirdPartyConfigs,
                isProductHiddenByUser: isProductHiddenByUser,
                ignoreCounts: ignoreCounts,
                recommended3pApps: recommended3pApps
            });
            // Convert to options
            productOptions = Array.from(productOrderWithDynamicSections.entries()).flatMap(([section, products])=>products.map((productKey)=>createProductOption(productKey, section)));
        } else productOptions = availableProductsInDefaultOrder.map((productKey)=>createProductOption(productKey));
        return [
            // All filter
            {
                count: $ecaec232d474cc0a$export$4fc9b866c5c60225(productResultCountMap, searchQuery, selectedProduct),
                label: formatMessage((0, $f50a0b647d44470a$export$defe85febe8b728c).allFilterLabel),
                value: undefined,
                isSelected: !selectedProduct,
                productCategory: undefined,
                onSelect: ()=>onSelectProduct(undefined, undefined),
                hideFilter: ()=>{},
                showFilter: ()=>{},
                countLoading: resultCountsLoading
            },
            ...productOptions
        ];
    }, [
        availableProducts,
        availableNouns,
        isNounsAvailable,
        formatMessage,
        onSelectProduct,
        selectedProduct,
        selectedDatasource,
        productResultCountMap,
        onFilterHide,
        onFilterShow,
        thirdPartyConfigs,
        products,
        visibleFiltersCount,
        searchQuery,
        primaryProduct,
        isInitialState,
        isProductHiddenByUser,
        recommended3pApps,
        personalisedProductSections,
        setPersonalisedProductSections,
        productsWithTimeout,
        resultCountsLoading
    ]);
    const allApps = (0, $42omo.useMemo)(()=>{
        const { visibleApps: visibleApps, hiddenApps: hiddenApps } = productFilters.reduce((acc, option)=>{
            const visibility = $ecaec232d474cc0a$export$87241c4456b8fd64(option, sidebarStoredState, acc.visibleApps, onFilterHide, selectedProduct, selectedDatasource, thirdPartyConfigs);
            if (visibility === 'visible') acc.visibleApps.push(option);
            else acc.hiddenApps.push(option);
            return acc;
        }, {
            visibleApps: [],
            hiddenApps: []
        });
        // Note: Special handling for selected datasource is now done in the fanout rendering logic
        // to preserve the original ordering position of the product
        const nestedProducts = (0, $78e9ef1c2d2db925$export$beb7df217e8a6731)();
        const appsToDisplaySet = new Set();
        const visibleAppsWithCategories = visibleApps.filter((visibleApp)=>visibleApp != null).filter((visibleApp)=>{
            if ((0, $dh538.fg)('rovo-search-right-rail-personalisation')) // Exclude nested products from the main list since they'll be shown within their category.
            // This also mean the nested products (eg. DC) will not be shown in the dropdown- only their parent.
            return !nestedProducts.has(visibleApp.value);
            return true;
        }).map((visibleApp)=>{
            return {
                ...visibleApp,
                nestedApps: // Populate products within its respective category
                visibleApp.productCategory?.products.flatMap((productWithinCategory)=>{
                    const nestedApp = visibleApps.find((app)=>app && app.value === productWithinCategory);
                    if (!nestedApp) return [];
                    // Apply fanout logic to nested apps to get correct selection state
                    const hasFanout = thirdPartyConfigs[nestedApp.value]?.fanOutConnectorSources;
                    if (hasFanout) {
                        // For fanout products, use the fanout options to get correct selection state
                        const fanoutOptions = (0, $66fdf3be8fc8b85e$export$5f7dec9d1a00b559)(nestedApp, thirdPartyConfigs, selectedProduct, selectedDatasource, onSelectProduct);
                        // Otherwise return the first fanout option (which will have the correct base state)
                        return fanoutOptions;
                    }
                    return [
                        nestedApp
                    ];
                }) ?? []
            };
        }).filter((visibleApp)=>{
            // The 'All' case should always be displayed
            if (!visibleApp.value) return true;
            // Don't display apps that are already in a nested category
            if (appsToDisplaySet.has(visibleApp.value)) return false;
            visibleApp.nestedApps.forEach((nestedApp)=>nestedApp?.value && appsToDisplaySet.add(nestedApp.value));
            return true;
        });
        // Apply fanout logic to hidden apps for show more popup
        const hiddenAppsWithFanout = (0, $66fdf3be8fc8b85e$export$a655af3e5904d3b1)(hiddenApps, thirdPartyConfigs, selectedProduct, selectedDatasource, onSelectProduct);
        return {
            visibleApps: visibleAppsWithCategories,
            hiddenApps: hiddenAppsWithFanout
        };
    }, [
        productFilters,
        sidebarStoredState,
        onFilterHide,
        thirdPartyConfigs,
        selectedProduct,
        selectedDatasource,
        onSelectProduct
    ]);
    onVisibleProductsToAuthShown(allApps.visibleApps.filter((o)=>o !== undefined && o.value !== undefined && o.section === (0, $78e9ef1c2d2db925$export$285cbcdb788689a9).VISIBLE_PRODUCTS_TO_AUTH).map((o)=>o.value).filter((o)=>o !== undefined), recommended3pApps);
    // Memoize the OAuth connection states to avoid recalculating on every render
    const oAuthConnectionStates = (0, $42omo.useMemo)(()=>({
            anyConnectedConfluenceDC: $ecaec232d474cc0a$var$hasAnyAuthedDatasource((0, $1yEFx.ProductKeys).ConfluenceDC, thirdPartyConfigs),
            anyConnectedJiraDC: $ecaec232d474cc0a$var$hasAnyAuthedDatasource((0, $1yEFx.ProductKeys).JiraDC, thirdPartyConfigs),
            anyConnectedJsmDC: $ecaec232d474cc0a$var$hasAnyAuthedDatasource((0, $1yEFx.ProductKeys).JsmDC, thirdPartyConfigs)
        }), [
        thirdPartyConfigs
    ]);
    const { anyConnectedConfluenceDC: anyConnectedConfluenceDC, anyConnectedJiraDC: anyConnectedJiraDC, anyConnectedJsmDC: anyConnectedJsmDC } = oAuthConnectionStates;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: "search-page-app-filters",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8dc422bc1cdea1f9$export$95d78afe1ba1dce1), {
            name: (0, $f6a925dc3308ab80$export$1b49510872e7246c),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                role: "list",
                children: [
                    allApps.visibleApps.map((option, index)=>{
                        if (option.nestedApps.length > 1 && option.productCategory) {
                            const FilterTriggerIcon = option.productCategory.Icon;
                            const hasSelection = option.nestedApps.find((nestedApp)=>nestedApp?.isSelected)?.isSelected;
                            const totalCount = option.nestedApps.reduce((prev, curr)=>curr.count === undefined ? prev : (prev ?? 0) + curr.count, undefined // Stays undefined if all counts are undefined
                            );
                            const accordionCategory = option.productCategory.productCategory;
                            let defaultIsExpanded = false;
                            if ((0, $dh538.fg)('rovo-search-right-rail-personalisation')) {
                                // Expand only sections that match the primary product (for Atlas, expand both Jira and Confluence)
                                const isPrimaryProductToExpand = primaryProduct === option.value;
                                defaultIsExpanded = hasSelection || isPrimaryProductToExpand;
                            } else {
                                const expandConfluenceApps = accordionCategory === (0, $1yEFx.ProductKeys).Confluence && anyConnectedConfluenceDC;
                                const expandJiraApps = accordionCategory === (0, $1yEFx.ProductKeys).Jira && anyConnectedJiraDC;
                                const expandJSMApps = accordionCategory === (0, $1yEFx.ProductKeys).JiraServiceManagement && anyConnectedJsmDC;
                                defaultIsExpanded = hasSelection || expandConfluenceApps || expandJiraApps || expandJSMApps;
                            }
                            return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                role: "listitem",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2d40e93801a0fc92$export$d99097c13d4dac9f), {
                                    triggerComponent: /*#__PURE__*/ (0, $l998X.jsx)((0, $42c79e2f0c046f7e$export$fd50ae2bcf5da2e1), {
                                        icon: /*#__PURE__*/ (0, $l998X.jsx)(FilterTriggerIcon, {
                                            size: "small"
                                        }),
                                        label: option.productCategory.displayName,
                                        count: totalCount,
                                        countLoading: resultCountsLoading
                                    }),
                                    groupId: option.value || 'unknown',
                                    defaultIsExpanded: defaultIsExpanded,
                                    hasSelection: hasSelection,
                                    onClick: (openState)=>{
                                        // If we're opening the selector
                                        if (!openState) return;
                                        // And no nested apps are selected
                                        if (option.nestedApps.find((nested)=>nested.isSelected)) return;
                                        // Select the first one
                                        option.nestedApps[0]?.onSelect();
                                    },
                                    children: option.nestedApps.map((nestedOption)=>{
                                        const isSmartlink = (0, $a5OFf.isProductSmartlink)({
                                            productKey: nestedOption.value,
                                            thirdPartyConfigs: thirdPartyConfigs
                                        });
                                        return /*#__PURE__*/ (0, $l998X.jsx)((0, $eoZmS.OAuthWarningWrapper), {
                                            datasourceId: nestedOption.datasourceId,
                                            product: nestedOption.value,
                                            trigger: ({ isDisabled: isDisabled, oAuthWarning: oAuthWarning, triggerProps: triggerProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $73f6cd01fde76615$export$2e2bcd8739ae039), {
                                                    oAuthWarning: oAuthWarning,
                                                    triggerProps: triggerProps,
                                                    isDisabled: isDisabled,
                                                    option: nestedOption,
                                                    onClick: nestedOption.onSelect,
                                                    onClickMenuItem: (_, action)=>{
                                                        if (action === 'hide') nestedOption.hideFilter();
                                                    },
                                                    ariaRole: "listitem"
                                                }, nestedOption.compositeKey || nestedOption.value),
                                            useOAuthHandlers: useOAuthHandlers,
                                            useIsUserOAuthed: useIsUserOAuthed,
                                            isSmartlink: isSmartlink,
                                            oAuthSource: (0, $ckkm9.OAuthSource).searchPageFilter,
                                            thirdPartyConfigs: thirdPartyConfigs
                                        }, nestedOption.compositeKey || nestedOption.value);
                                    })
                                })
                            }, accordionCategory);
                        }
                        // Check if this product has fanout enabled
                        const hasFanout = thirdPartyConfigs[option.value]?.fanOutConnectorSources;
                        if (hasFanout) {
                            // Apply fanout only to products that have it enabled
                            let optionsToRender = (0, $66fdf3be8fc8b85e$export$5f7dec9d1a00b559)(option, thirdPartyConfigs, selectedProduct, selectedDatasource, onSelectProduct);
                            // Special handling for webcrawler products:
                            // When a webcrawler product is selected with fanout enabled and show more is enabled,
                            if (option.value === (0, $1yEFx.ProductKeys).AtlassianWebCrawler && option.value === selectedProduct && selectedDatasource && allApps.hiddenApps.length > 0) optionsToRender = optionsToRender.filter((renderOption)=>renderOption.isSelected);
                            const isSmartlink = (0, $a5OFf.isProductSmartlink)({
                                productKey: option.value,
                                thirdPartyConfigs: thirdPartyConfigs
                            });
                            return optionsToRender.map((renderOption)=>{
                                const key = renderOption.compositeKey || renderOption.value;
                                return /*#__PURE__*/ (0, $l998X.jsx)((0, $eoZmS.OAuthWarningWrapper), {
                                    datasourceId: renderOption.datasourceId,
                                    product: option.value,
                                    trigger: ({ isDisabled: isDisabled, oAuthWarning: oAuthWarning, triggerProps: triggerProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $73f6cd01fde76615$export$2e2bcd8739ae039), {
                                            oAuthWarning: oAuthWarning,
                                            triggerProps: triggerProps,
                                            isDisabled: isDisabled,
                                            option: renderOption,
                                            onClick: renderOption.onSelect,
                                            onClickMenuItem: (_, action)=>{
                                                if (action === 'hide') renderOption.hideFilter();
                                            },
                                            ariaRole: "listitem"
                                        }, key),
                                    index: index,
                                    useOAuthHandlers: useOAuthHandlers,
                                    useIsUserOAuthed: useIsUserOAuthed,
                                    isSmartlink: isSmartlink,
                                    oAuthSource: (0, $ckkm9.OAuthSource).searchPageFilter,
                                    thirdPartyConfigs: thirdPartyConfigs
                                }, key);
                            });
                        } else {
                            // Regular product rendering (no fanout)
                            const isSmartlink = (0, $a5OFf.isProductSmartlink)({
                                productKey: option.value,
                                thirdPartyConfigs: thirdPartyConfigs
                            });
                            return /*#__PURE__*/ (0, $l998X.jsx)((0, $eoZmS.OAuthWarningWrapper), {
                                datasourceId: selectedDatasource?.datasourceId,
                                product: option.value,
                                trigger: ({ isDisabled: isDisabled, oAuthWarning: oAuthWarning, triggerProps: triggerProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $73f6cd01fde76615$export$2e2bcd8739ae039), {
                                        oAuthWarning: oAuthWarning,
                                        triggerProps: triggerProps,
                                        isDisabled: isDisabled,
                                        option: option,
                                        onClick: option.onSelect,
                                        onClickMenuItem: (_, action)=>{
                                            if (action === 'hide') option.hideFilter();
                                        },
                                        ariaRole: "listitem"
                                    }, option.value),
                                index: index,
                                useOAuthHandlers: useOAuthHandlers,
                                useIsUserOAuthed: useIsUserOAuthed,
                                isSmartlink: isSmartlink,
                                oAuthSource: (0, $ckkm9.OAuthSource).searchPageFilter,
                                thirdPartyConfigs: thirdPartyConfigs
                            }, option.value || 'all');
                        }
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $862f29a1de109ab0$export$2e2bcd8739ae039), {
                        options: allApps.hiddenApps,
                        useIsUserOAuthed: useIsUserOAuthed,
                        useOAuthHandlers: useOAuthHandlers,
                        thirdPartyConfigs: thirdPartyConfigs,
                        oAuthSource: (0, $ckkm9.OAuthSource).searchPageFilter
                    })
                ]
            })
        })
    });
};
const $ecaec232d474cc0a$export$87241c4456b8fd64 = (option, sidebarStoredState, visibleApps, onFilterHide, selectedProduct, selectedDatasource, thirdPartyConfigs)=>{
    // Always show "All" option or already selected options
    if (option.label === 'All' || option.isSelected) return 'visible';
    // Check if this product matches the selected product
    if (option.value === selectedProduct) {
        const hasFanout = thirdPartyConfigs?.[option.value]?.fanOutConnectorSources;
        if (hasFanout) // For fanout products, keep the base product visible to maintain ordering
        // The fanout rendering logic will handle showing the selected datasource
        return 'visible';
        else // For regular products, only show if no datasource is selected
        return !selectedDatasource ? 'visible' : 'hidden';
    }
    // Logic for the new dynamic sections
    if (option.section === (0, $78e9ef1c2d2db925$export$285cbcdb788689a9).VISIBLE_PRIMARY_PRODUCTS || option.section === (0, $78e9ef1c2d2db925$export$285cbcdb788689a9).VISIBLE_PRODUCTS_WITH_RESULTS || option.section === (0, $78e9ef1c2d2db925$export$285cbcdb788689a9).VISIBLE_PRODUCTS_TO_AUTH) return 'visible';
    if (option.section === (0, $78e9ef1c2d2db925$export$285cbcdb788689a9).NESTED_PRODUCTS) // Make it visible since it will be rendered within its category.
    return 'visible';
    if (option.section === (0, $78e9ef1c2d2db925$export$285cbcdb788689a9).HIDDEN_PRODUCTS) return 'hidden';
    // Always show primary product in the non-dynamic version of right-rail
    if (option.isPrimaryProduct) return 'visible';
    // Check if the user has manually hidden this option
    if (option.value && sidebarStoredState?.filters?.[option.value]?.hidden) return 'hidden';
    if (option.value && visibleApps.length > $ecaec232d474cc0a$var$getMaxVisibleAppFilters()) {
        if (!(0, $2OtFZ.serveRightRailImprovementsWithoutExposure)()) // We should not call this callback since it's meant for user actions only.
        onFilterHide(option.value);
        return 'hidden';
    } else return 'visible';
};






















var $9zZIW = parcelRequire("9zZIW");











const $5c2e577797240fed$var$dividerStyles = (0, $ecnYn.xcss)({
    width: '100%',
    borderBlockEnd: 'none',
    borderBlockStart: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    borderInline: 'none',
    marginTop: 'space.075',
    marginBottom: 'space.100'
});
const $5c2e577797240fed$export$2e0a83ec2e27ecbb = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $5c2e577797240fed$var$dividerStyles
    });
const $5c2e577797240fed$export$ea8986aeb9fc460a = ({ availableProducts: availableProducts, availableNouns: availableNouns, selectedProduct: selectedProduct, setAtlasNoun: setAtlasNoun, setWebPageType: setWebPageType, isNounsAvailable: isNounsAvailable, filterData: filterData, productResultCountMap: productResultCountMap = {}, resultCountsLoading: resultCountsLoading = false })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const shouldShowNouns = (0, $42omo.useMemo)(()=>{
        if (!isNounsAvailable) return availableNouns.length > 0;
        else return isNounsAvailable;
    }, [
        isNounsAvailable,
        availableNouns
    ]);
    const nounFilters = (0, $42omo.useMemo)(()=>{
        if ((0, $9zZIW.atlassianWebCrawlerConfig).fanOutConnectorSources) {
            const isAtlasSelected = selectedProduct === (0, $1yEFx.ProductKeys).Atlas;
            const isNounSelected = (noun)=>{
                return (isAtlasSelected && filterData?.options.find((option)=>option.queryParamValue === noun)?.isSelected) ?? false;
            };
            let nounsToDisplay;
            if (!isNounsAvailable) nounsToDisplay = (0, $4EMbH.NOUNS_ORDER).filter((noun)=>availableNouns.includes(noun));
            else nounsToDisplay = [
                (0, $4EMbH.NounKeys).goal,
                (0, $4EMbH.NounKeys).project
            ];
            return nounsToDisplay.map((noun)=>({
                    label: formatMessage((0, $4EMbH.nouns)[noun].displayNamePlural),
                    value: noun,
                    isSelected: isNounSelected(noun),
                    onSelect: ()=>setAtlasNoun(noun)
                }));
        } else {
            const isWebCrawlerAvailable = availableProducts.includes((0, $1yEFx.ProductKeys).AtlassianWebCrawler);
            const isAtlasSelected = selectedProduct === (0, $1yEFx.ProductKeys).Atlas;
            const isWebCrawlerSelected = selectedProduct === (0, $1yEFx.ProductKeys).AtlassianWebCrawler;
            const isNounSelected = (noun)=>{
                const result = (isWebCrawlerSelected && noun === (0, $4EMbH.NounKeys).AtlassianWebCrawler || isAtlasSelected && filterData?.options.find((option)=>option.queryParamValue === noun)?.isSelected) ?? false;
                return result;
            };
            const NOUNS_ORDER_WITH_WEBCRAWLER = isWebCrawlerAvailable ? (0, $4EMbH.NOUNS_ORDER) : (0, $4EMbH.NOUNS_ORDER).filter((noun)=>noun !== (0, $4EMbH.NounKeys).AtlassianWebCrawler);
            let atlasNouns;
            let nounsToDisplay;
            if (!isNounsAvailable) {
                atlasNouns = availableNouns;
                nounsToDisplay = NOUNS_ORDER_WITH_WEBCRAWLER.filter((noun)=>atlasNouns.includes(noun) || isWebCrawlerAvailable && noun === (0, $4EMbH.NounKeys).AtlassianWebCrawler);
            } else {
                atlasNouns = [
                    (0, $4EMbH.NounKeys).goal,
                    (0, $4EMbH.NounKeys).project
                ];
                nounsToDisplay = isNounsAvailable ? NOUNS_ORDER_WITH_WEBCRAWLER : isWebCrawlerAvailable ? [
                    (0, $4EMbH.NounKeys).AtlassianWebCrawler
                ] : [];
            }
            const shouldServeNounResultCounts = (0, $2OtFZ.serveNounResultCounts)();
            return nounsToDisplay.map((noun)=>{
                const isSelected = isNounSelected(noun);
                const shouldShowCount = shouldServeNounResultCounts || noun === (0, $4EMbH.NounKeys).AtlassianWebCrawler && (0, $dh538.fg)('rovosearch_web_pages_result_counts');
                return {
                    label: formatMessage((0, $4EMbH.nouns)[noun].displayNamePlural),
                    value: noun,
                    isSelected: isSelected,
                    count: shouldShowCount ? productResultCountMap[noun] : undefined,
                    countLoading: shouldShowCount ? resultCountsLoading : false,
                    //web crawler is rendered as a noun, but queried as a product
                    onSelect: noun === (0, $4EMbH.NounKeys).AtlassianWebCrawler ? ()=>setWebPageType() : ()=>setAtlasNoun(noun)
                };
            });
        }
    }, [
        setAtlasNoun,
        setWebPageType,
        isNounsAvailable,
        selectedProduct,
        filterData,
        availableProducts,
        availableNouns,
        formatMessage,
        resultCountsLoading,
        productResultCountMap
    ]);
    if (!shouldShowNouns || !nounFilters.length) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($5c2e577797240fed$export$2e0a83ec2e27ecbb, {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                role: "list",
                children: nounFilters.map((option)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $73f6cd01fde76615$export$2e2bcd8739ae039), {
                        option: option,
                        onClick: option.onSelect,
                        ariaRole: "listitem"
                    }, option.value))
            })
        ]
    });
};





parcelRequire("42omo");


















var $NwuTK = parcelRequire("NwuTK");





const $21806c766532a692$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    improveSearch: {
        id: "search-page.app-filter-sidebar.improve-search",
        defaultMessage: "Improve search"
    }
});


const $6f007caa1e941263$var$dividerStyles = (0, $ecnYn.xcss)({
    borderTop: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    height: '1px',
    marginBlock: 'space.075',
    marginInline: 'space.150'
});
const $6f007caa1e941263$var$wrapperStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    display: 'flex',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    gap: 'space.075',
    marginTop: 'space.100',
    paddingBlock: 'space.050',
    paddingLeft: 'space.150'
});
const $6f007caa1e941263$var$feedbackIconContainer = (0, $ecnYn.xcss)({
    padding: 'space.050',
    justifyContent: 'center'
});
const $6f007caa1e941263$export$ae377d31562bc30 = ({ cloudId: cloudId, primaryProduct: primaryProduct, experimentConfig: experimentConfig, selectedProducts: selectedProducts, user: user, appMode: appMode, requestId: requestId, traceId: traceId, isCQL: isCQL })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $hnvzE.default), {
        name: "search-page-feedback",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $6f007caa1e941263$var$dividerStyles
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                xcss: [
                    $6f007caa1e941263$var$wrapperStyles
                ],
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $6f007caa1e941263$var$feedbackIconContainer,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7yOcR))), {
                            color: "currentColor",
                            label: "Give feedback"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                        children: formatMessage((0, $21806c766532a692$export$defe85febe8b728c).improveSearch)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $cc710e5633c22833$export$2e2bcd8739ae039), {
                        cloudId: cloudId,
                        primaryProduct: primaryProduct,
                        experimentConfig: experimentConfig,
                        selectedProducts: selectedProducts,
                        user: (0, $NwuTK.getUser)(user),
                        applicationMode: appMode,
                        source: "search-page",
                        appearance: "link",
                        requestId: requestId || '',
                        traceId: traceId || '',
                        isCQL: isCQL
                    })
                ]
            })
        ]
    });
};

















const $ab2e247364ac3575$export$bfc9fede3294c124 = ()=>{
    const [storedState, setStoredState] = (0, $42omo.useState)((0, $5G9KX.getLocalStorageItem)((0, $5iakG.getSearchPageFilterConfigKey)()) || {});
    const setFilterHidden = (0, $42omo.useCallback)((productKey, value)=>{
        const newValue = {
            ...storedState,
            filters: {
                ...storedState?.filters,
                [productKey]: {
                    hidden: value
                }
            }
        };
        setStoredState(newValue);
        (0, $5G9KX.setLocalStorageItem)((0, $5iakG.getSearchPageFilterConfigKey)(), JSON.stringify(newValue));
    }, [
        storedState,
        setStoredState
    ]);
    return [
        storedState,
        {
            setFilterHidden: setFilterHidden
        }
    ];
};
const $ab2e247364ac3575$export$e594597d68c75e56 = ({ thirdPartyConfigs: thirdPartyConfigs, storedState: storedState, setFilterHidden: setFilterHidden })=>{
    (0, $42omo.useEffect)(()=>{
        // Do NOT hide smart link filters by default for the Test cohort.
        if ((0, $2OtFZ.serveRightRailImprovementsWithoutExposure)()) return;
        Object.entries(thirdPartyConfigs).forEach(([productKey, config])=>{
            const hasFilter = storedState?.filters && storedState.filters[productKey] !== undefined;
            if (config?.resourceType?.includes((0, $9d9t8.SMARTLINKS_RESOURCE_TYPE_PREFIX)) && !hasFilter) setFilterHidden(productKey, true);
        });
    }, [
        thirdPartyConfigs,
        storedState?.filters,
        setFilterHidden
    ]);
};





const $871ab8347ae20fda$export$99516ac3f2ff068f = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, productKey: productKey, hidden: hidden })=>({
        eventType: 'ui',
        actionSubject: 'button',
        actionSubjectId: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}AppFilterShowHideButton`,
        action: 'clicked',
        attributes: {
            additionalAttributes: {
                productKey: productKey,
                hidden: hidden
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });










var $lvsjl = parcelRequire("lvsjl");

const $2d30f39b051b7418$export$9154573ddadf513c = ({ searchSessionId: searchSessionId, reason: reason })=>({
        eventType: 'track',
        actionSubject: 'searchPage',
        action: '3pRecommendationStatus',
        attributes: {
            additionalAttributes: {
                status: 'DEGRADED',
                searchSessionId: searchSessionId,
                reason: reason
            }
        }
    });
const $2d30f39b051b7418$export$bf964e46bf8194b2 = ({ searchSessionId: searchSessionId, hit: hit })=>({
        eventType: 'track',
        actionSubject: 'searchPage',
        action: '3pRecommendationStatus',
        attributes: {
            additionalAttributes: {
                status: hit ? 'CACHE_HIT' : 'CACHE_MISS',
                searchSessionId: searchSessionId
            }
        }
    });
const $2d30f39b051b7418$export$67cdecee1ba002c3 = ({ searchSessionId: searchSessionId })=>({
        eventType: 'track',
        actionSubject: 'searchPage',
        action: '3pRecommendationStatus',
        attributes: {
            additionalAttributes: {
                status: 'NO_IDENTIFIER',
                searchSessionId: searchSessionId
            }
        }
    });
const $2d30f39b051b7418$export$78d8344b0db57ca9 = ({ searchSessionId: searchSessionId, visibleProductsToAuth: visibleProductsToAuth, recommended3pApps: recommended3pApps })=>({
        eventType: 'track',
        actionSubject: 'searchPage',
        action: '3pRecommendationServed',
        attributes: {
            additionalAttributes: {
                searchSessionId: searchSessionId,
                visibleProductsToAuth: visibleProductsToAuth,
                recommended3pApps: recommended3pApps
            }
        }
    });





const $4b4d6fff8ba3907a$export$a954cbc46095ce6a = 300;
function $4b4d6fff8ba3907a$export$eabd66cde5dba12f(visibleProductsToAuth, recommended3pApps) {
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    // Guard against double-invocation and ensure we fire only on change
    const [debouncedAnalytics] = (0, $lvsjl.default)(()=>fireAnalyticsEvent((0, $2d30f39b051b7418$export$78d8344b0db57ca9)({
            visibleProductsToAuth: visibleProductsToAuth,
            recommended3pApps: recommended3pApps
        })), $4b4d6fff8ba3907a$export$a954cbc46095ce6a);
    return debouncedAnalytics();
}















var $aAJEF = parcelRequire("aAJEF");








function $2a8d6d6445842483$export$a718b8eb2c469b45({ userId: userId, showRecommendations: showRecommendations }) {
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [recommended3pApps, setRecommended3pApps] = (0, $42omo.useState)([]);
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const analyticsCallback = (0, $42omo.useCallback)(async (state)=>{
        try {
            fireAnalyticsEvent((0, $2d30f39b051b7418$export$bf964e46bf8194b2)({
                searchSessionId: searchSessionId,
                hit: state.hit
            }));
        } catch  {}
    }, [
        fireAnalyticsEvent,
        searchSessionId
    ]);
    const degradationCallback = (0, $42omo.useCallback)((reason)=>{
        try {
            fireAnalyticsEvent((0, $2d30f39b051b7418$export$9154573ddadf513c)({
                searchSessionId: searchSessionId,
                reason: reason
            }));
        } catch  {}
    }, [
        fireAnalyticsEvent,
        searchSessionId
    ]);
    const fetchRecs = (0, $42omo.useCallback)(async ()=>{
        if (!showRecommendations) {
            setRecommended3pApps([]);
            setLoading(false);
            return;
        } else if (!userId) {
            setRecommended3pApps([]);
            setLoading(false);
            fireAnalyticsEvent((0, $2d30f39b051b7418$export$67cdecee1ba002c3)({
                searchSessionId: searchSessionId
            }));
            return;
        } else {
            setLoading(true);
            try {
                const recs = await (0, $aAJEF.getRightPanelRecommendations)({
                    userId: userId,
                    analyticsCallback: analyticsCallback,
                    degradationCallback: degradationCallback
                });
                setRecommended3pApps(Array.isArray(recs) ? recs : []);
            } finally{
                setLoading(false);
            }
        }
    }, [
        fireAnalyticsEvent,
        userId,
        searchSessionId,
        showRecommendations,
        analyticsCallback,
        degradationCallback
    ]);
    (0, $42omo.useEffect)(()=>{
        fetchRecs();
    }, [
        fetchRecs
    ]);
    return (0, $42omo.useMemo)(()=>({
            recommended3pApps: recommended3pApps,
            loading: loading
        }), [
        recommended3pApps,
        loading
    ]);
}














const $685c25747f94db4b$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    groupLabel: {
        id: "search-page.app-filter-sidebar.group",
        defaultMessage: "Filter search by app"
    }
});


const $d28cc1bef0cccb80$var$AppFilter = ({ top: top, isScrollable: isScrollable })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [{ cloudId: cloudId, experimentConfig: experimentConfig, user: user, products: availableProducts, nouns: availableNouns, thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [selectedDatasource] = (0, $djVCD.useSelectedDatasource)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [productResultCountMap] = (0, $djVCD.useProductResultCountMap)();
    const [searchQuery] = (0, $djVCD.useSearchQuery)();
    const { selectProductFilter: selectProductFilter, unselectProductFilter: unselectProductFilter, unsafe_setAtlasNouns: unsafe_setAtlasNouns, unsafe_setWebPageType: unsafe_setWebPageType } = (0, $djVCD.useSearchActions)();
    const intercom = (0, $9afb3d504f643405$export$f0fed4b0765d7314)();
    const [storedState, { setFilterHidden: setFilterHidden }] = (0, $ab2e247364ac3575$export$bfc9fede3294c124)();
    (0, $ab2e247364ac3575$export$e594597d68c75e56)({
        thirdPartyConfigs: thirdPartyConfigs,
        storedState: storedState,
        setFilterHidden: setFilterHidden
    });
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const [selectedProducts] = (0, $djVCD.useSelectedProducts)();
    const appMode = (0, $j4ply.useApplicationMode)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [requestId] = (0, $djVCD.useResultsRequestId)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const resultsState = (0, $djVCD.useResultsState)();
    const [isNounsAvailable] = (0, $j4ply.useIsNounsAvailable)();
    const [universalTypeFilterData] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $5iakG.universalTypeFilterId)
    });
    const appFilterSidebarStyles = (0, $42omo.useMemo)(()=>(0, $ecnYn.xcss)({
            overflowY: 'auto',
            overflowX: 'hidden',
            // https://hello.atlassian.net/wiki/x/tA0p-Q
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            height: `calc(100vh - ${top}px - 20px)`,
            padding: 'space.050',
            margin: 'space.negative.050',
            justifyContent: 'start'
        }), [
        top
    ]);
    // Trigger an exposure once when the component is mounted.
    (0, $42omo.useEffect)(()=>{
        (0, $2OtFZ.triggerExposureForRightRailImprovements)();
    }, []);
    const { recommended3pApps: recommended3pApps } = (0, $2a8d6d6445842483$export$a718b8eb2c469b45)({
        userId: user?.id,
        showRecommendations: (0, $2OtFZ.serveRightRailRecommendationsImprovementsWithExposure)()
    });
    const appFilterProps = (0, $42omo.useMemo)(()=>{
        const props = {
            searchQuery: searchQuery,
            thirdPartyConfigs: thirdPartyConfigs,
            availableProducts: availableProducts,
            availableNouns: availableNouns,
            selectedProduct: selectedProduct,
            primaryProduct: primaryProduct,
            selectedDatasource: selectedDatasource,
            isNounsAvailable: isNounsAvailable,
            filterData: universalTypeFilterData,
            setAtlasNoun: unsafe_setAtlasNouns,
            setWebPageType: unsafe_setWebPageType,
            onSelectProduct: (newProduct, datasource)=>{
                if (!newProduct && selectedProduct) {
                    unselectProductFilter();
                    return;
                } else {
                    selectProductFilter(newProduct, datasource);
                    if (newProduct && (0, $1yEFx.is3pProductKey)(newProduct)) intercom?.trackEvent('product_filter_clicked_3p', {
                        product_filter: newProduct
                    });
                    else intercom?.trackEvent('product_filter_clicked', {
                        product_filter: newProduct
                    });
                }
            },
            recommended3pApps: recommended3pApps,
            onVisibleProductsToAuthShown: (0, $4b4d6fff8ba3907a$export$eabd66cde5dba12f),
            productResultCountMap: productResultCountMap ?? {},
            top: top,
            sidebarStoredState: storedState,
            onFilterHide: (productKey)=>{
                setFilterHidden(productKey, true);
                fireAnalyticsEvent((0, $871ab8347ae20fda$export$99516ac3f2ff068f)({
                    commonAttributes: commonAttributes,
                    nonPrivacySafeAttributes: nonPrivacySafeAttributes,
                    productKey: productKey,
                    hidden: true
                }));
            },
            onFilterShow: (productKey)=>{
                setFilterHidden(productKey, false);
                fireAnalyticsEvent((0, $871ab8347ae20fda$export$99516ac3f2ff068f)({
                    commonAttributes: commonAttributes,
                    nonPrivacySafeAttributes: nonPrivacySafeAttributes,
                    productKey: productKey,
                    hidden: false
                }));
            },
            useOAuthHandlers: $gGFxq.useOAuthHandlers,
            useIsUserOAuthed: $gGFxq.useIsUserOAuthed,
            ErrorBoundary: $1nJM3.ErrorBoundary,
            isInitialState: resultsState === (0, $fZ3l2.ResultsStates).INITIAL
        };
        return props;
    }, [
        availableProducts,
        availableNouns,
        selectedProduct,
        selectedDatasource,
        unselectProductFilter,
        selectProductFilter,
        intercom,
        isNounsAvailable,
        universalTypeFilterData,
        unsafe_setAtlasNouns,
        unsafe_setWebPageType,
        productResultCountMap,
        top,
        storedState,
        setFilterHidden,
        thirdPartyConfigs,
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes,
        searchQuery,
        primaryProduct,
        resultsState,
        recommended3pApps
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
        role: "group",
        "aria-label": formatMessage((0, $685c25747f94db4b$export$defe85febe8b728c).groupLabel),
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: [
            isScrollable && appFilterSidebarStyles
        ],
        testId: "app-filter-sidebar",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
                section: "SearchPageAppFilter",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ecaec232d474cc0a$export$ca41603276fc834c), {
                    ...appFilterProps
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5c2e577797240fed$export$ea8986aeb9fc460a), {
                ...appFilterProps,
                onSelectProduct: (newProduct)=>{
                    if (!newProduct && selectedProduct) {
                        unselectProductFilter();
                        return;
                    } else {
                        selectProductFilter(newProduct);
                        if (newProduct && (0, $1yEFx.is3pProductKey)(newProduct)) intercom?.trackEvent('product_filter_clicked_3p', {
                            product_filter: newProduct
                        });
                        else intercom?.trackEvent('product_filter_clicked', {
                            product_filter: newProduct
                        });
                    }
                }
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f007caa1e941263$export$ae377d31562bc30), {
                cloudId: cloudId,
                primaryProduct: primaryProduct,
                experimentConfig: experimentConfig,
                selectedProducts: selectedProducts,
                user: user,
                appMode: appMode,
                requestId: requestId
            })
        ]
    });
};
var $d28cc1bef0cccb80$export$2e2bcd8739ae039 = $d28cc1bef0cccb80$var$AppFilter;





const $c2fcde7689d903b4$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    groupLabel: {
        id: "search-page.app-filter-sidebar.group",
        defaultMessage: "Filter search by app"
    }
});


const $39dda3505e8b980a$var$baseStyles = (0, $ecnYn.xcss)({});
const $39dda3505e8b980a$export$98c4d2ac9cd9730 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $5e9cfc142ef96d2f$export$f39f3f768bc98e3d), {
        ariaLabel: formatMessage((0, $c2fcde7689d903b4$export$defe85febe8b728c).groupLabel),
        "data-testid": "app-filter-sidebar-loading",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1ee81a6dccb3a778$export$c597ff09df837ae9), {})
    });
};
const $39dda3505e8b980a$var$RightPanel = ()=>{
    const [stickyPanelStyles, setStickyPanelStyles] = (0, $42omo.useState)();
    const referenceRef = (0, $42omo.useRef)(null);
    const [topReference, setTopReference] = (0, $42omo.useState)(0);
    const layoutWidth = (0, $86ob4.useElementWidth)('layout');
    const isAboveSmall = (0, $86ob4.isBreakpointActive)({
        width: layoutWidth,
        above: 'sm'
    });
    const { isNav4Enabled: isNav4Enabled } = (0, $7WbA8.useAppContext)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    // TODO: instead of the results state we should track results count state.
    // As part of this we should review the behaviour of useProductResultCountMap() which returns null when the app filter changes.
    // This is to prevent a bug where the right rail re-load when the app filter is change (even if the query remains the same).
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const resultsState = (0, $djVCD.useResultsState)();
    // Use the reference element's position to set the sticky styles on the
    // header. This allows `top` to always be correct.
    (0, $42omo.useEffect)(()=>{
        if (!referenceRef.current) return;
        // QS-5148
        // referenceY is a measure of how far the top of search-page is from the top of the scrolling context. This works in old nav, because the scroll matches the viewport
        // In Nav 4, the scroll is the content region and the nav is outside of it
        // This is a temporary fix to unblock Nav4 dogfooding
        let referenceY = referenceRef.current.getBoundingClientRect().top;
        if ((0, $dh538.fg)('confluence_nav_4')) referenceY = referenceRef.current.offsetTop;
        // If the Nav4 feature prop is enabled, we set the referenceY to 0 as the layout doesn't require an offset
        if (isNav4Enabled) referenceY = 0;
        const scrollY = window.scrollY;
        const top = referenceY + scrollY;
        setTopReference(top);
        setStickyPanelStyles((0, $ecnYn.xcss)({
            position: 'sticky',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            top: `${top}px`
        }));
    // By including isAboveSmall in the dependency array, we force the sticky panel to resize when the breakpoint changes.
    // This fixes a small bug where the sticky panel doesn't resize on breakpoint change.
    }, [
        setTopReference,
        setStickyPanelStyles,
        isAboveSmall,
        isNav4Enabled
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                ref: referenceRef,
                testId: "search-page-sticky-reference"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $39dda3505e8b980a$var$baseStyles,
                    stickyPanelStyles
                ],
                children: availableProducts.length === 0 || resultsState === (0, $fZ3l2.ResultsStates).IS_LOADING && (0, $dh538.fg)('rovo-search-right-rail-personalisation') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
                    name: "search-page-right-panel-loading",
                    children: /*#__PURE__*/ (0, $l998X.jsx)($39dda3505e8b980a$export$98c4d2ac9cd9730, {})
                }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $hnvzE.default), {
                    name: "search-page-right-panel",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $b0ebf52c770dccf7$export$8316e1225e2e8973), {}),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $d28cc1bef0cccb80$export$2e2bcd8739ae039), {
                            top: topReference,
                            isScrollable: true
                        })
                    ]
                })
            })
        ]
    });
};
var $39dda3505e8b980a$export$2e2bcd8739ae039 = $39dda3505e8b980a$var$RightPanel;









var $6cnUO = parcelRequire("6cnUO");




var $4OGlb = parcelRequire("4OGlb");


var $hHl3d = parcelRequire("hHl3d");




// referenced from confluence/next/packages/error-boundary/src/ErrorComponent.tsx

















var $aoVih = parcelRequire("aoVih");

var $iHPbg = parcelRequire("iHPbg");

// Code referenced from confluence/next/packages/monitoring/src/error-attributes.ts
// referenced from confluence/next/packages/network/src/getTraceIdFromResponse.ts
const $ad189a387c307ba4$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-b3-traceid') || response?.headers?.get('atl-traceid') || null;


// code referenced from confluence/next/packages/network/src/BadStatusError.ts

class $1e41a9366b8ff075$export$12c8b3d0a1a46f87 extends Error {
    get traceId() {
        return (0, $ad189a387c307ba4$export$9f229e40eb65abfc)(this.response);
    }
    static isBadStatusError(value) {
        return value instanceof $1e41a9366b8ff075$export$12c8b3d0a1a46f87;
    }
    constructor(message, response){
        super(message);
        this.response = void 0;
        this.name = 'BadStatusError';
        this.response = response;
    }
}


const $d29e73b15d9cce60$var$REACT_ERROR_CONTEXT_SYMBOL = Symbol('React error context');
const $d29e73b15d9cce60$export$8b5fa6128aa81e5e = (error)=>{
    if (typeof error === 'object' && error !== null) return error[$d29e73b15d9cce60$var$REACT_ERROR_CONTEXT_SYMBOL];
    return undefined;
};
const $d29e73b15d9cce60$var$GRAPHQL_ERROR_CONTEXT_SYMBOL = Symbol('Graphql error context');
const $d29e73b15d9cce60$var$getGraphqlErrorAttributes = (error)=>{
    if (typeof error !== 'object' || error === null) return undefined;
    if (error[$d29e73b15d9cce60$var$GRAPHQL_ERROR_CONTEXT_SYMBOL]) return error[$d29e73b15d9cce60$var$GRAPHQL_ERROR_CONTEXT_SYMBOL];
};
const $d29e73b15d9cce60$var$SLA_ERROR_CONTEXT_SYMBOL = Symbol('SLA error context');
const $d29e73b15d9cce60$var$getSlaErrorAttributes = (error)=>{
    if (typeof error === 'object' && error !== null) return error[$d29e73b15d9cce60$var$SLA_ERROR_CONTEXT_SYMBOL];
    return undefined;
};
const $d29e73b15d9cce60$var$getBadStatusErrorAttributes = (error)=>{
    if (!(error instanceof (0, $1e41a9366b8ff075$export$12c8b3d0a1a46f87))) return undefined;
    return {
        statusCode: error.response.status,
        traceId: (0, $ad189a387c307ba4$export$9f229e40eb65abfc)(error.response)
    };
};
const $d29e73b15d9cce60$var$CONTENT_ERROR_CONTEXT_SYMBOL = Symbol('Content error context');
function $d29e73b15d9cce60$export$bc010311f017b17c(error) {
    if (typeof error === 'object' && error !== null) return error[$d29e73b15d9cce60$var$CONTENT_ERROR_CONTEXT_SYMBOL];
    return undefined;
}
const $d29e73b15d9cce60$var$LOADABLE_ERROR_CONTEXT_SYMBOL = Symbol('Loadable error context');
const $d29e73b15d9cce60$var$getLoadableErrorAttributes = (error)=>{
    if (typeof error === 'object' && error !== null) return error[$d29e73b15d9cce60$var$LOADABLE_ERROR_CONTEXT_SYMBOL];
    return undefined;
};
const $d29e73b15d9cce60$export$d08bac32cb78075f = (error)=>{
    if (!error || typeof error !== 'object') return {};
    return {
        ...$d29e73b15d9cce60$export$8b5fa6128aa81e5e(error),
        ...$d29e73b15d9cce60$var$getGraphqlErrorAttributes(error),
        ...$d29e73b15d9cce60$var$getSlaErrorAttributes(error),
        ...$d29e73b15d9cce60$export$bc010311f017b17c(error),
        ...$d29e73b15d9cce60$var$getLoadableErrorAttributes(error),
        ...$d29e73b15d9cce60$var$getBadStatusErrorAttributes(error)
    };
};

















const $48ae26af81a9c654$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    atlassianSupportLink: {
        id: "error-boundary.description.support-link",
        defaultMessage: "Atlassian Support"
    }
});


const $b89a004dfc5e6c32$export$98c2bfe563916273 = 'https://support.atlassian.com/contact/#/';
const $b89a004dfc5e6c32$var$getLinkText = (showHostname)=>showHostname ? new URL($b89a004dfc5e6c32$export$98c2bfe563916273).hostname : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...(0, $48ae26af81a9c654$export$a7357cdd1f0b0168).atlassianSupportLink
    });
const $b89a004dfc5e6c32$export$f1bb9e069c7d2c = ({ showHostname: showHostname, children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
        href: $b89a004dfc5e6c32$export$98c2bfe563916273,
        target: "_blank",
        children: (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) ? children : $b89a004dfc5e6c32$var$getLinkText(showHostname)
    });


// referenced from confluence/next/packages/error-boundary/src/DevErrorDetail.tsx













var $4JDbp = parcelRequire("4JDbp");


// If any changes are made here, they should also be made in that file.
const $2d2c706c5260f6d5$var$getUrlForQuery = (query)=>`https://splunk.paas-inf.net/en-US/app/search/search?q=search%20${encodeURIComponent(query)}&display.page.search.mode=smart`;
function $2d2c706c5260f6d5$export$902f232e663144b5({ error: error, errorInfo: errorInfo }) {
    const reactErrorAttributes = (0, $d29e73b15d9cce60$export$8b5fa6128aa81e5e)(error);
    const errorHashCode = reactErrorAttributes ? reactErrorAttributes.errorHashCode : undefined;
    const traceId = (0, $d29e73b15d9cce60$export$d08bac32cb78075f)(error).traceId;
    let splunkQueryText;
    let splunkQueryHref;
    if (errorHashCode) {
        splunkQueryText = `ext.event.attributes.errorHashCode="${errorHashCode}"`;
        splunkQueryHref = $2d2c706c5260f6d5$var$getUrlForQuery([
            'eventtype="micros_analytics-service"',
            'ext.event.product=confluence',
            splunkQueryText
        ].join('\n'));
    }
    const [width, setWidth] = (0, $42omo.useState)(0);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $4JDbp.WidthObserver), {
                setWidth: setWidth
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
                children: [
                    "You can also discuss this in the",
                    ' ',
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                        target: "_blank",
                        href: "https://atlassian.slack.com/messages/CFG8QANL9",
                        children: "#search-plex"
                    }),
                    ' ',
                    "Slack channel."
                ]
            }),
            splunkQueryText && splunkQueryHref ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
                children: [
                    "You can search",
                    ' ',
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                        href: splunkQueryHref,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            children: "Splunk"
                        })
                    }),
                    ' ',
                    "for ",
                    /*#__PURE__*/ (0, $l998X.jsx)("b", {
                        children: splunkQueryText
                    }),
                    ". g",
                    ' '
                ]
            }) : null,
            traceId ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
                children: [
                    "Trace ID: ",
                    /*#__PURE__*/ (0, $l998X.jsx)("b", {
                        children: traceId
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
                children: [
                    "Error:",
                    width ? // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        style: {
                            overflow: 'scroll',
                            width: width
                        },
                        children: /*#__PURE__*/ (0, $l998X.jsxs)("pre", {
                            children: [
                                `${error.message || String(error)}`,
                                errorInfo && `${errorInfo.componentStack}`
                            ]
                        })
                    }) : null
                ]
            })
        ]
    });
}


// referenced from confluence/next/packages/error-boundary/src/ErrorComponent.tsx



const $f09899ff43583193$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    actionReloadPage: {
        id: "error-boundary.reload-page",
        defaultMessage: "Refresh page"
    },
    description: {
        id: "error-boundary.description",
        defaultMessage: "The issue should resolve on its own, but if it keeps happening, ask your admin to contact {atlassianSupportLink} and give them:"
    },
    title: {
        id: "error-boundary.title",
        defaultMessage: "We've hit a snag"
    },
    code: {
        id: "error-boundary.code",
        defaultMessage: "The code associated with this error: {code}"
    },
    url: {
        id: "error-boundary.url",
        defaultMessage: "The URL of this page"
    },
    supportLinkText: {
        id: "error-boundary.support-link-text",
        defaultMessage: "our support team"
    }
});


const $b30d5c5335be09a9$var$ContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'center'
});
const $b30d5c5335be09a9$var$SectionMessageContainerStyles = (0, $ecnYn.xcss)({
    maxWidth: '600px'
});
const $b30d5c5335be09a9$export$65db35c377fab04b = ({ error: error, errorInfo: errorInfo })=>{
    const intl = (0, $8C5kA.default)();
    const [showDevErrorDetail, setShowDevErrorDetail] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        focusError();
    }, []);
    const focusError = ()=>{
        const error = document.querySelector(`#error-container`);
        return error?.focus();
    };
    const title = intl.formatMessage((0, $f09899ff43583193$export$a7357cdd1f0b0168).title);
    let errorDetail = /*#__PURE__*/ (0, $l998X.jsx)($b30d5c5335be09a9$var$ErrorDetail, {
        error: error,
        errorInfo: errorInfo
    });
    const actions = [
        {
            key: 'error-boundary.reload-page',
            text: intl.formatMessage((0, $f09899ff43583193$export$a7357cdd1f0b0168).actionReloadPage),
            appearance: 'danger',
            autoFocus: true,
            onClick () {
                window.location.reload();
            }
        }
    ];
    if (showDevErrorDetail) errorDetail = /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            errorDetail,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $2d2c706c5260f6d5$export$902f232e663144b5), {
                error: error,
                errorInfo: errorInfo
            })
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $b30d5c5335be09a9$var$ContainerStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $b30d5c5335be09a9$var$SectionMessageContainerStyles,
            testId: "error-container-with-error-details",
            id: "error-container",
            tabIndex: 0,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aoVih.default), {
                appearance: "error",
                actions: actions.map(({ onClick: onClick, key: key, text: text })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $iHPbg.default), {
                        onClick: onClick,
                        children: text
                    }, key)),
                title: title,
                children: errorDetail
            })
        })
    });
};
function $b30d5c5335be09a9$var$ErrorDetail(props) {
    const reactErrorAttributes = (0, $d29e73b15d9cce60$export$8b5fa6128aa81e5e)(props.error);
    const errorHashCode = reactErrorAttributes ? reactErrorAttributes.errorHashCode : undefined;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $f09899ff43583193$export$a7357cdd1f0b0168).description,
                tagName: "p",
                values: {
                    atlassianSupportLink: /*#__PURE__*/ (0, $l998X.jsx)((0, $b89a004dfc5e6c32$export$f1bb9e069c7d2c), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $f09899ff43583193$export$a7357cdd1f0b0168).supportLinkText
                        })
                    })
                }
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("li", {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $f09899ff43583193$export$a7357cdd1f0b0168).url
                        })
                    }),
                    errorHashCode ? /*#__PURE__*/ (0, $l998X.jsx)("li", {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $f09899ff43583193$export$a7357cdd1f0b0168).code,
                            values: {
                                code: /*#__PURE__*/ (0, $l998X.jsx)("b", {
                                    children: errorHashCode || ''
                                })
                            }
                        })
                    }) : null
                ]
            })
        ]
    });
}



var $2lmJQ = parcelRequire("2lmJQ");







const $f516b8d1f224d864$export$30fd472c870047da = (searchSessionId, referrer)=>({
        name: 'advancedSearchScreen',
        attributes: {
            additionalAttributes: {
                searchSessionId: // we're not passing the application mode since this event is triggered before the application mode is set
                searchSessionId,
                referrer: referrer
            }
        }
    });








const $d6c71ab59cbce7e1$export$cb48c45f3598fb8 = ()=>{
    const { fireAnalyticsScreenEvent: fireAnalyticsScreenEvent } = (0, $3CshZ.useAnalytics)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [referrer] = (0, $j4ply.useReferrer)();
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsScreenEvent((0, $f516b8d1f224d864$export$30fd472c870047da)(searchSessionId, referrer));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};























const $10ae4d7be0130777$export$2025f1e19c7d8520 = ()=>{
    const [{ cloudId: cloudId }] = (0, $j4ply.useBootstrap)();
    const intl = (0, $8C5kA.default)();
    const isTypeFilteredToIncident = (0, $j4ply.useIsTypeFilteredToIncident)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const jiraIssueTypeFilters = (0, $djVCD.useJsmIncidentFilterIds)();
    const isFetching = (0, $42omo.useRef)(false);
    const { setJsmIncidentFilterIds: setJsmIncidentFilterIds } = (0, $djVCD.useSearchActions)();
    const logException = (0, $f8oYd.useLogException)();
    const hasJiraIssueTypeFilters = jiraIssueTypeFilters.length > 0;
    (0, $42omo.useEffect)(()=>{
        async function fetchJiraIssueTypesFilter() {
            // Only fetch when filtered to incident
            if (!isTypeFilteredToIncident) return;
            // Only fetch if not yet available (don't over-fetch!)
            if (isFetching.current || hasJiraIssueTypeFilters) return;
            isFetching.current = true;
            try {
                const jsmIncidentId = await (0, $gY9AU.getJiraIssueTypesFilter)(cloudId, intl, 'incident');
                setJsmIncidentFilterIds([
                    jsmIncidentId
                ]);
            } catch (e) {
                logException(e);
            } finally{
                isFetching.current = false;
            }
        }
        fetchJiraIssueTypesFilter();
    }, [
        cloudId,
        intl,
        isTypeFilteredToIncident,
        hasJiraIssueTypeFilters,
        logException,
        setJsmIncidentFilterIds
    ]);
    return null;
};









var $1662I = parcelRequire("1662I");


var $8lMgE = parcelRequire("8lMgE");








var $2urbH = parcelRequire("2urbH");




const $e407d87f2e9f371a$export$7eaa56945d1970dc = 'kkvkd7ql';














const $814d53f457d71a8a$var$generateSearchPageVisitedString = ()=>{
    const currentDate = new Date();
    const year = (0, $8lMgE.default)(currentDate);
    const week = (0, $1662I.default)(currentDate);
    return `search_page_visited_${year}_week_${week}`;
};
const $814d53f457d71a8a$export$2a1369f17c026393 = ({ children: children })=>{
    const { boot: boot, shutdown: shutdown, trackEvent: trackEvent } = (0, $7sS82.useIntercom)();
    const [intercomHmac] = (0, $j4ply.useIntercomHmac)();
    const [userWithStatus] = (0, $4Qo4W.useUser)();
    const [features] = (0, $4Qo4W.useFeatures)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const isUserUnauthenticated = userWithStatus.status === (0, $lwP5K.UserStatus).Unauthenticated;
    (0, $42omo.useEffect)(()=>{
        // Do not boot if sideBySide feature is enabled
        if (features?.sideBySide?.enabled) return;
        // Do not boot if user details are not available
        if (isUserUnauthenticated || !userWithStatus.name || !userWithStatus.email || !intercomHmac) return;
        // Do not boot if there are no products available
        if (availableProducts.length === 0) return;
        const thirdPartyProducts = availableProducts.filter((product)=>(0, $1yEFx.is3pProductKey)(product));
        boot({
            userId: userWithStatus.id ?? undefined,
            name: userWithStatus.name,
            email: userWithStatus.email,
            userHash: intercomHmac,
            customAttributes: {
                // Some intercom users were registered without an email and succeeding
                // bootstrap calls did not update their email.
                // This change is temporary to ensure all users have an attribute that
                // actually stores the email for them :fried_angry_lol_cry:
                atlassian_account_email: userWithStatus.email,
                connected_third_parties: thirdPartyProducts.join(',')
            }
        });
        // A new intercom event will be created each week of the year.
        // Example: search_page_visited_2024_week_29
        // Events: https://app.intercom.com/a/apps/kkvkd7ql/settings/data/people?tab=events
        const eventString = $814d53f457d71a8a$var$generateSearchPageVisitedString();
        trackEvent(eventString);
        trackEvent('search_page_visited');
        return ()=>{
            shutdown();
        };
    }, [
        availableProducts,
        boot,
        features?.sideBySide?.enabled,
        intercomHmac,
        shutdown,
        isUserUnauthenticated,
        userWithStatus.id,
        userWithStatus.name,
        userWithStatus.email,
        trackEvent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
        children: children
    });
};
const $814d53f457d71a8a$var$Intercom = ({ children: children })=>{
    const [intercomAllowed, setIntercomAllowed] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        (0, $2urbH.checkThirdParty)('intercom', async ()=>setIntercomAllowed(true), async ()=>setIntercomAllowed(false));
    }, []);
    if (!intercomAllowed) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7sS82.IntercomProvider), {
        appId: (0, $e407d87f2e9f371a$export$7eaa56945d1970dc),
        children: /*#__PURE__*/ (0, $l998X.jsx)($814d53f457d71a8a$export$2a1369f17c026393, {
            children: children
        })
    });
};
const $814d53f457d71a8a$var$IntercomWithErrorBoundary = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
        fallback: children,
        section: "SearchPageIntercom",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
            name: "search-page-intercom",
            children: /*#__PURE__*/ (0, $l998X.jsx)($814d53f457d71a8a$var$Intercom, {
                children: children
            })
        })
    });
};
var $814d53f457d71a8a$export$2e2bcd8739ae039 = $814d53f457d71a8a$var$IntercomWithErrorBoundary;








const $aec377272259e0f9$export$6a93826c3e88a7f6 = ()=>{
    const logException = (0, $f8oYd.useLogException)();
    (0, $42omo.useEffect)(()=>{
        try {
            const url = new URL(window.location.href);
            const searchParams = new URLSearchParams(url.search);
            if (!searchParams.has('referrer')) return;
            searchParams.delete('referrer');
            url.search = searchParams.toString();
            const { href: href } = url;
            window.history.replaceState(null, '', href);
        } catch (error) {
            logException(error);
        }
    }, [
        logException
    ]);
    return null;
};



var $8aC7e = parcelRequire("8aC7e");


var $bHLTK = parcelRequire("bHLTK");




parcelRequire("42omo");






var $5loD0 = parcelRequire("5loD0");





var $aXjWU = parcelRequire("aXjWU");









const $14f459c4dfcc6b1a$export$f86c748bd13d5f7a = ()=>{
    const [cloudId] = (0, $4Qo4W.useCloudId)();
    const [spotlight, { start: start, end: end }] = (0, $b3bd4a67e85b92b5$export$a771c137b2620ff2)();
    const requestRef = (0, $42omo.useRef)();
    const hasRequestedMessageRef = (0, $42omo.useRef)(false);
    const { requestMessageStart: requestMessageStart, dismissMessage: dismissMessage, hasMessageStarted: hasMessageStarted } = (0, $aXjWU.usePostOfficeExernalMessageProxy)((0, $f6a925dc3308ab80$export$d2ea4f931a71a509));
    const coordinationClient = (0, $42omo.useMemo)(()=>{
        if (!cloudId || cloudId === '') return {
            start: ()=>Promise.resolve(false),
            stop: ()=>Promise.resolve(false)
        };
        const client = new (0, $5loD0.default)({
            cloudId: cloudId,
            stargateUrl: '/gateway/api'
        });
        return client;
    }, [
        cloudId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!(0, $dh538.fg)('rovo-fps-changeboarding-spotlight-po-migration')) return;
        if (!hasRequestedMessageRef.current) {
            requestMessageStart();
            hasRequestedMessageRef.current = true;
            return;
        }
        // If spotlight should be shown within Post Office logic
        if (hasMessageStarted) start();
    }, [
        hasMessageStarted,
        requestMessageStart,
        start
    ]);
    // Delete the useEffect when cleaning up rovo-fps-changeboarding-spotlight-po-migration
    (0, $42omo.useEffect)(()=>{
        if ((0, $dh538.fg)('rovo-fps-changeboarding-spotlight-po-migration')) return;
        if (requestRef.current) return;
        requestRef.current = new (0, $czt8s.CancellablePromise)(coordinationClient.start((0, $f6a925dc3308ab80$export$d2ea4f931a71a509)));
        requestRef.current.promise().then((displaySpotlight)=>{
            displaySpotlight ? start() : end();
        }).catch(()=>{
            end();
        });
    // The network request for the spotlight exposure should only ever be called once.
    // Otherwise, it will cause conflicts and the spotlight will never be rendered.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (spotlight.state === 'dismiss') {
            if ((0, $dh538.fg)('rovo-fps-changeboarding-spotlight-po-migration')) dismissMessage();
            else coordinationClient.stop((0, $f6a925dc3308ab80$export$d2ea4f931a71a509));
        }
    }, [
        coordinationClient,
        dismissMessage,
        spotlight.state
    ]);
};
const $14f459c4dfcc6b1a$export$d076c6f78afb0ebc = ()=>{
    $14f459c4dfcc6b1a$export$f86c748bd13d5f7a();
    return null;
};


const $89db46b3ee074a75$export$b8027369fa44ddb6 = ()=>{
    (0, $922c14edc5967a62$export$c199ac7e412a5a11)();
    return null;
};
const $89db46b3ee074a75$export$da0f89c65081f644 = ({ children: children })=>{
    (0, $14f459c4dfcc6b1a$export$f86c748bd13d5f7a)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};


const $10f79ecb05a6930a$export$794614fa392eb573 = ({ children: children, ...props })=>{
    const { mapUserIdToProfileUrl: mapUserIdToProfileUrl, generateSearchUrl: generateSearchUrl, queryParams: queryParams, onNavigate: onNavigate, isNav4Enabled: isNav4Enabled, isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled, onSearchResultsShown: onSearchResultsShown, primaryProduct: primaryProduct } = props;
    const getFrontendExperiment = (0, $iA4lt.createFrontendExperimentHandler)(props.features?.sideBySide?.experiments);
    const getFrontendGate = (0, $iA4lt.createFeatureGateHandler)(props.features?.sideBySide?.experiments);
    // hold on to the first function reference passed to the package to
    // avoid excessive re-rendering if the consumer doesn't pass in
    // a stable function
    const mapUserIdToProfileUrlRef = (0, $42omo.useRef)(mapUserIdToProfileUrl);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8aC7e.default), {
        ...props,
        statsigLayer: (0, $4OGlb.STATSIG_FULL_PAGE_SEARCH_LAYER),
        experience: (0, $hHl3d.SearchExperience).SEARCH_PAGE,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $bHLTK.SearchStoreProvider), {
            experience: (0, $hHl3d.SearchExperience).SEARCH_PAGE,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $d6c71ab59cbce7e1$export$cb48c45f3598fb8), {}),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $aec377272259e0f9$export$6a93826c3e88a7f6), {}),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6cnUO.default), {
                    blanketIsTinted: false,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $89db46b3ee074a75$export$da0f89c65081f644), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $814d53f457d71a8a$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $7WbA8.AppContextProvider), {
                                mapUserIdToProfileUrl: mapUserIdToProfileUrlRef.current,
                                generateSearchUrl: generateSearchUrl,
                                queryParams: queryParams,
                                onNavigate: onNavigate,
                                getFrontendExperiment: getFrontendExperiment,
                                getFeatureGate: getFrontendGate,
                                isNav4Enabled: isNav4Enabled,
                                isAdminHubAIEnabled: isAdminHubAIEnabled,
                                isRovoLLMEnabled: isRovoLLMEnabled,
                                onSearchResultsShown: onSearchResultsShown,
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $10ae4d7be0130777$export$2025f1e19c7d8520), {}),
                                    (0, $2OtFZ.serveSearchPageRelayExp)(primaryProduct, false, queryParams) ? null : /*#__PURE__*/ (0, $l998X.jsx)((0, $89db46b3ee074a75$export$b8027369fa44ddb6), {}),
                                    children
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
};
const $10f79ecb05a6930a$var$ShellWithErrorBoundary = (props)=>{
    const { children: children } = props;
    const shell = (0, $42omo.useMemo)(()=>/*#__PURE__*/ (0, $l998X.jsx)($10f79ecb05a6930a$export$794614fa392eb573, {
            ...props,
            children: children
        }), [
        children,
        props
    ]);
    const renderWithErrorInfo = (0, $42omo.useCallback)((props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $b30d5c5335be09a9$export$65db35c377fab04b), {
            ...props
        }), []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
        renderWithErrorInfo: renderWithErrorInfo,
        section: "SearchPageShell",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2lmJQ.default), {
            experience: (0, $hHl3d.SearchExperience).SEARCH_PAGE,
            children: shell
        })
    });
};
var $10f79ecb05a6930a$export$2e2bcd8739ae039 = $10f79ecb05a6930a$var$ShellWithErrorBoundary;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


















var $2cEww = parcelRequire("2cEww");


var $cbc8g = parcelRequire("cbc8g");








var $7Zbm6 = parcelRequire("7Zbm6");

var $4rtnp = parcelRequire("4rtnp");

var $dxjDr = parcelRequire("dxjDr");

var $3Opgu = parcelRequire("3Opgu");














var $2Rith = parcelRequire("2Rith");





var $14qs9 = parcelRequire("14qs9");


var $6CITI = parcelRequire("6CITI");


var $f7lNm = parcelRequire("f7lNm");

/* add-pin-card.tsx generated by @compiled/babel-plugin v0.36.1 */ 






























var $4dSc8 = parcelRequire("4dSc8");


var $8d7Su = parcelRequire("8d7Su");


var $3NkqS = parcelRequire("3NkqS");

const $f3c680f674639682$var$styles = {
    container: "_nd5l1b0a _2rko12b0 _zulputpp _1e0c1txw _2lx21bp4 _ca0qu2gc _n3tdu2gc _19bvpxbi _u5f3pxbi _bfhk1s93",
    grid: "_gy1pze3t _1lmclxlj _yv0e1ghl",
    cardCopy: "_nd5l16yo",
    addPin: "_nd5l1uoe _10fpesu3 _1wpz1h6o",
    linkContainer: "_nd5l16yl"
};
const $f3c680f674639682$var$LEARN_MORE_URL = 'https://support.atlassian.com/organization-administration/docs/add-or-edit-rovo-search-bookmarks/';
const $f3c680f674639682$export$5cc0b8a7a0e0e4df = /*#__PURE__*/ (0, $42omo.memo)(({ query: query, orgId: orgId, cloudId: cloudId, callbacks: callbacks, hasAdminhubAccess: hasAdminhubAccess, workspaceId: workspaceId, product: product })=>{
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [showModal, setShowModal] = (0, $42omo.useState)(false);
    const onDismissClicked = ()=>callbacks.onDismissCallback();
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsEvent((0, $8d7Su.onAddBookmarkShown)({
            query: query
        }));
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $14qs9.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $f3c680f674639682$var$styles.container,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $d8SNb.default), {
                    xcss: $f3c680f674639682$var$styles.grid,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $f3c680f674639682$var$styles.cardCopy,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                children: formatMessage((0, $3NkqS.messages).add_pin_card_copy)
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $f3c680f674639682$var$styles.addPin,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                spacing: "compact",
                                onClick: ()=>setShowModal(true),
                                children: formatMessage((0, $3NkqS.messages).add_pin_button_label)
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $f3c680f674639682$var$styles.linkContainer,
                            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                space: "space.100",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                        href: $f3c680f674639682$var$LEARN_MORE_URL,
                                        onClick: ()=>fireAnalyticsEvent((0, $8d7Su.onLearnMoreAboutPinsClick)()),
                                        children: formatMessage((0, $3NkqS.messages).learn_about_pins)
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        children: "\u2022"
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                        href: "",
                                        onClick: onDismissClicked,
                                        children: formatMessage((0, $3NkqS.messages).dismiss)
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            showModal && /*#__PURE__*/ (0, $l998X.jsx)((0, $4dSc8.AddPinModal), {
                query: query,
                handleClose: ()=>setShowModal(false),
                orgId: orgId,
                cloudId: cloudId,
                hasAdminhubAccess: hasAdminhubAccess,
                onSuccessCallback: callbacks.onSuccessCallback,
                workspaceId: workspaceId,
                product: product,
                source: "adminOnboarding"
            })
        ]
    });
});











const $5c40ea1dddca0440$var$DEFAULT_TTL = 300000;
class $5c40ea1dddca0440$var$InMemCache {
    static setCacheData(key, data) {
        this.cache[key] = {
            ttl: Date.now() + $5c40ea1dddca0440$var$DEFAULT_TTL,
            data: data
        };
    }
    static getCacheData(key) {
        return key in this.cache && Date.now() < this.cache[key].ttl ? this.cache[key].data : undefined;
    }
}
$5c40ea1dddca0440$var$InMemCache.cache = {};
const $5c40ea1dddca0440$export$eda8930120443143 = ({ cloudId: cloudId, orgId: orgId })=>{
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const [hasBookmarkCreationAccess, setBookmarkCreationAccess] = (0, $42omo.useState)(false);
    const [hasAdminhubAccess, setHasAdminhubAccess] = (0, $42omo.useState)(false);
    const key = `${orgId}:${cloudId}`;
    const resource = (0, $42omo.useMemo)(()=>{
        return {
            orgAdmin: `ari:cloud:platform::org/${orgId}`,
            confluenceAdmin: `ari:cloud:confluence::site/${cloudId}`,
            jiraAdmin: `ari:cloud:jira::site/${cloudId}`,
            siteAdmin: `ari:cloud:platform::site/${cloudId}`
        };
    }, [
        orgId,
        cloudId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!cloudId || !orgId) return;
        const callApi = async ()=>{
            setLoading(true);
            try {
                let data = $5c40ea1dddca0440$var$InMemCache.getCacheData(key);
                if (!data) {
                    const response = await fetch('/gateway/api/permissions/bulk/permitted', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify([
                            {
                                permissionId: 'manage/org',
                                resourceId: resource.orgAdmin
                            },
                            {
                                permissionId: 'manage',
                                resourceId: resource.confluenceAdmin
                            },
                            {
                                permissionId: 'manage',
                                resourceId: resource.jiraAdmin
                            },
                            {
                                permissionId: 'manage',
                                resourceId: resource.siteAdmin
                            }
                        ])
                    });
                    data = await response.json();
                    if (!Array.isArray(data)) throw new Error(data?.errorDetail || '/permissions/bulk/permitted failure');
                    $5c40ea1dddca0440$var$InMemCache.setCacheData(key, data);
                }
                setLoading(false);
                return data;
            } catch (error) {
                (0, $4Zqgi.logger).error({
                    error: error,
                    functionName: 'useAdminPermissions'
                });
                setLoading(false);
                return [];
            }
        };
        const checkPermissions = async ()=>{
            const permissions = await callApi();
            let userIsSomeAdmin = false;
            let userIsOrgAdmin = false;
            if (!permissions?.length) return;
            for (const permission of permissions){
                // allow creation of bookmarks if the user is any type of admin
                if (permission.permitted) userIsSomeAdmin = true;
                if (permission.resourceId === resource.orgAdmin && permission.permitted) userIsOrgAdmin = true;
            }
            setBookmarkCreationAccess(userIsSomeAdmin);
            setHasAdminhubAccess(userIsOrgAdmin);
        };
        checkPermissions();
    }, [
        cloudId,
        orgId,
        key,
        resource
    ]);
    return {
        hasBookmarkCreationAccess: hasBookmarkCreationAccess,
        hasAdminhubAccess: hasAdminhubAccess,
        loading: loading
    };
};



var $6yuru = parcelRequire("6yuru");


var $9EFEY = parcelRequire("9EFEY");

const $f105b5d9df5babad$export$2a78b23d2a3ac84b = 'KnowledgeDiscoveryBookmark';
const $f105b5d9df5babad$export$2464d968d37100c9 = `
	query ${$f105b5d9df5babad$export$2a78b23d2a3ac84b}($cloudId: String!, $keyPhrase: String!) {
		knowledgeDiscovery {
			bookmark(cloudId: $cloudId, keyPhrase: $keyPhrase) {
				__typename
				... on KnowledgeDiscoveryBookmark {
					id
					properties {
						url
						title
						description
						bookmarkState
						lastModifierAccountId
						keyPhrase
						parentAdminhubBookmarkId
					}
				}
				... on QueryError {
					identifier
					message
					extensions {
						errorType
						statusCode
						... on GenericQueryErrorExtension {
							errorType
							statusCode
						}
					}
				}
			}
		}
	}
`;


var $907ac179b537c87a$export$e12e02cef8635961 = /*#__PURE__*/ function(BookmarkState) {
    BookmarkState["ACTIVE"] = "ACTIVE";
    BookmarkState["SUGGESTED"] = "SUGGESTED";
    return BookmarkState;
}({});
const $907ac179b537c87a$export$7a8af96e1dd8695b = async (variables, workspaceId, product)=>{
    return (0, $9EFEY.fetchAggResponse)({
        graphQuery: (0, $f105b5d9df5babad$export$2464d968d37100c9),
        variables: variables,
        operationName: (0, $f105b5d9df5babad$export$2a78b23d2a3ac84b),
        headers: (0, $6yuru.createAtlAttributionHeader)({
            atlWorkspaceId: workspaceId,
            tenantId: variables.cloudId,
            product: product
        })
    }).then((response)=>response.data?.knowledgeDiscovery?.bookmark);
};
const $907ac179b537c87a$export$e912848e2176a2d7 = async (variables, workspaceId, product)=>{
    return (0, $9EFEY.fetchAggResponse)({
        graphQuery: (0, $f105b5d9df5babad$export$2464d968d37100c9),
        variables: variables,
        operationName: (0, $f105b5d9df5babad$export$2a78b23d2a3ac84b),
        headers: (0, $6yuru.createAtlAttributionHeader)({
            atlWorkspaceId: workspaceId,
            tenantId: variables.cloudId,
            product: product
        })
    }).then((response)=>{
        return {
            data: response.data?.knowledgeDiscovery?.bookmark,
            requestId: response.extensions?.gateway?.request_id ?? null
        };
    });
};


/* bookmark-knowledge-card.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $6uGcC = parcelRequire("6uGcC");


var $x4n5k = parcelRequire("x4n5k");























var $fYQcF = parcelRequire("fYQcF");


var $4xTru = parcelRequire("4xTru");


var $4jIuc = parcelRequire("4jIuc");








var $lsDB7 = parcelRequire("lsDB7");





var $fJBWn = parcelRequire("fJBWn");


var $01aV7 = parcelRequire("01aV7");


var $9lp28 = parcelRequire("9lp28");


var $df7ed = parcelRequire("df7ed");





/* bookmark-invisible-link.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




const $fe4d5bca7ad2879a$var$styles = {
    root: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _1itkglyw _bfhk1j28 _r06hglyw"
};
const $fe4d5bca7ad2879a$export$d0f9d04b7863337a = ({ url: url, onClick: onClick, onMouseEnter: onMouseEnter = ()=>{}, onMouseLeave: onMouseLeave = ()=>{}, label: label, testId: testId = 'bookmark-card-link' })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
        href: url,
        xcss: $fe4d5bca7ad2879a$var$styles.root,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        "aria-label": label,
        tabIndex: -1,
        "data-testId": testId
    });














var $7gpC4 = parcelRequire("7gpC4");


const $3f7da56acd6df247$var$AkFeedbackCollector = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6yoZS")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $3f7da56acd6df247$var$FEEDBACK_ENTRYPOINT_ID_BOOKMARKS = 'f32dde59-8eb1-4974-8839-20183d163480';
const $3f7da56acd6df247$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $3f7da56acd6df247$var$messages = (0, $cgtv4.defineMessages)({
    bookmark_feedback_consent_checkbox_label: {
        id: "search_ai.bookmark_feedback_consent_checkbox_label",
        defaultMessage: "Include my last prompt and response in the feedback."
    }
});
const $3f7da56acd6df247$export$f8d5d13de6379210 = ({ setShowFeedbackModal: setShowFeedbackModal, setShowDisplayFlag: setShowDisplayFlag, query: query, url: url, userDetails: userDetails })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $8C5kA.default)();
    const [hasConsent, setConsent] = (0, $42omo.useState)(false);
    const feedbackContextObject = {
        searchTerm: query,
        bookmarkUrl: url
    };
    const feedbackContext = Object.entries(feedbackContextObject).map(([key, value])=>`${key}: ${value}`).join(', ');
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
            fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
            children: /*#__PURE__*/ (0, $l998X.jsx)($3f7da56acd6df247$var$AkFeedbackCollector, {
                locale: locale,
                onClose: ()=>setShowFeedbackModal(false),
                onSubmit: ()=>{
                    setShowDisplayFlag(true);
                },
                atlassianAccountId: userDetails?.id,
                name: userDetails?.name,
                customContent: /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                    label: formatMessage($3f7da56acd6df247$var$messages.bookmark_feedback_consent_checkbox_label),
                    onChange: ()=>setConsent(!hasConsent),
                    isChecked: hasConsent
                }),
                entrypointId: $3f7da56acd6df247$var$FEEDBACK_ENTRYPOINT_ID_BOOKMARKS,
                showTypeField: false,
                additionalFields: [
                    {
                        id: $3f7da56acd6df247$var$FEEDBACK_CONTEXT_CF,
                        value: feedbackContext
                    }
                ]
            })
        })
    });
};






var $eqPcP = parcelRequire("eqPcP");


const $3ede785c84f921db$var$AkFeedbackFlag = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6yoZS")).then(({ FeedbackFlag: FeedbackFlag })=>{
        return {
            default: FeedbackFlag
        };
    }));
const $3ede785c84f921db$var$styles = {
    container: "_2rko12b0 _189ee4h9 _1dqonqa1 _1h6d1l7x _ca0qpxbi _u5f3pxbi _19bvpxbi _n3tdpxbi _kqswh2mm",
    headingUnderline: "_4bfu1r31 _1hms8stv _ajmmnqa1 _4bfu6x5g _1keg1lya"
};
const $3ede785c84f921db$export$91f5ac95cb52dd60 = /*#__PURE__*/ (0, $42omo.memo)(({ query: query, bookmarkId: bookmarkId, url: url, title: title, description: description, orgId: orgId, cloudId: cloudId, bookmarkState: bookmarkState = (0, $907ac179b537c87a$export$e12e02cef8635961).ACTIVE, searchSessionId: searchSessionId, source: source, brand: brand, hasBookmarkCreationAccess: hasBookmarkCreationAccess, hasAdminhubAccess: hasAdminhubAccess, userDetails: userDetails, workspaceId: workspaceId, product: product, requestId: requestId })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $8C5kA.default)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { trackAIInteractionInit: trackAIInteractionInit } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const [bookmarkDescription, setBookmarkDescription] = (0, $42omo.useState)(description);
    const [hovered, setHovered] = (0, $42omo.useState)(false);
    const [showAddBookmarkModal, setShowAddBookmarkModal] = (0, $42omo.useState)(false);
    const [showFeedbackModal, setShowFeedbackModal] = (0, $42omo.useState)(false);
    const [showFeedbackFlag, setShowFeedbackFlag] = (0, $42omo.useState)(false);
    const cardRef = (0, $42omo.useRef)(null);
    const initialLoadTs = (0, $42omo.useRef)(Date.now()).current; // Dwell tracker for viewport exit detection
    if ((0, $dh538.fg)('kd_add_ssrv3_attributes')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $lsDB7.useDwellTracker)({
        elementRef: cardRef,
        onDwellEnd: (dwellTime)=>{
            fireSAINUsageEvent({
                metCriteria: (0, $4jIuc.SainAction).FMP_RESULT_EXITED,
                dwellTime: dwellTime,
                commonAttributes: bookmarkAttributes
            });
        }
    });
    const bookmarkAttributes = (0, $42omo.useMemo)(()=>({
            cloudId: cloudId,
            orgId: orgId,
            source: source,
            query: query,
            queryHash: (0, $01aV7.sha256Hash)(query),
            baseQueryHash: (0, $01aV7.sha256Hash)(query),
            searchSessionId: searchSessionId,
            answerString: '',
            answerLength: 0,
            answerWordCount: 0,
            answerFormat: null,
            answerCardType: (0, $f7lNm.AnswerCardType).BOOKMARK_KNOWLEDGE_CARD,
            sources: [],
            followUps: [],
            errorState: null,
            errorStateSuggestedQueries: [],
            bookmarkId: bookmarkId,
            bookmarkUrl: bookmarkId,
            extraAttributes: {
                bookmarkId: bookmarkId,
                bookmarkUrl: bookmarkId,
                isFullPageSearch: true,
                bookmarkState: bookmarkState,
                ...(0, $dh538.fg)('kd_fix_sain_mau_instrumentation') ? {
                    requestId: requestId
                } : {}
            },
            apiSource: 'xp-knowledge-discovery',
            workspaceId: '',
            sessionId: searchSessionId,
            brand: brand
        }), [
        bookmarkId,
        brand,
        cloudId,
        orgId,
        query,
        searchSessionId,
        source,
        bookmarkState,
        requestId
    ]);
    (0, $42omo.useEffect)(()=>{
        const fmpLoadTime = Date.now() - initialLoadTs;
        trackAIInteractionInit();
        fireSAINUsageEvent({
            commonAttributes: bookmarkAttributes
        });
        fireAnalyticsEvent((0, $4xTru.onAIAnswerResultShown)({
            ...bookmarkAttributes,
            isStreamed: false,
            ...(0, $dh538.fg)('kd_add_ssrv3_attributes') && {
                fmpLoadTime: fmpLoadTime
            }
        }));
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, $42omo.useEffect)(()=>{
        const getSmartLinkDescription = async ()=>{
            try {
                if (!bookmarkDescription) {
                    const objectResolver = await (0, $eqPcP.fetchObjectResolver)(url);
                    setBookmarkDescription(objectResolver?.summary ?? '');
                }
            } catch (error) {
                (0, $4Zqgi.logger).error({
                    error: error,
                    functionName: 'getSmartLinkDescription'
                });
            }
        };
        getSmartLinkDescription();
    }, [
        bookmarkDescription,
        url
    ]);
    const sanitizeUrl = ()=>{
        let pattern = /^(http|https):\/\//;
        let result = url;
        if (!pattern.test(url)) result = `https://${url}`;
        return result;
    };
    const onSearchPinOpened = ()=>{
        fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardLinkClick)({
            ...bookmarkAttributes,
            location: 'bookmarkKnowledgeCard'
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).BOOKMARK_CLICKED,
            commonAttributes: bookmarkAttributes
        });
    };
    const openAddPinModal = (e)=>{
        e.stopPropagation();
        setShowAddBookmarkModal(true);
    };
    const bookmarkTitle = title ?? query;
    const isSuggestedBookmark = bookmarkState === (0, $907ac179b537c87a$export$e12e02cef8635961).SUGGESTED;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                ref: cardRef,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $df7ed.KnowledgeCard), {
                    name: "smart-answers-bookmark-knowledge-card",
                    size: "full",
                    containerStyles: $3ede785c84f921db$var$styles.container,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $fe4d5bca7ad2879a$export$d0f9d04b7863337a), {
                            url: sanitizeUrl(),
                            onClick: onSearchPinOpened,
                            label: bookmarkTitle,
                            onMouseEnter: ()=>setHovered(true),
                            onMouseLeave: ()=>setHovered(false)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                            space: "space.150",
                            grow: "fill",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                    alignBlock: "center",
                                    spread: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                            alignBlock: "center",
                                            space: "space.100",
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($x4n5k))), {
                                                    label: "",
                                                    size: "small",
                                                    color: "var(--ds-icon-subtle, #505258)"
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                    color: "color.text.subtle",
                                                    children: isSuggestedBookmark ? formatMessage((0, $3NkqS.messages).pin_title_suggested) : formatMessage((0, $3NkqS.messages).pin_title)
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                                                    content: isSuggestedBookmark ? formatMessage((0, $3NkqS.messages).pinSuggestedTooltip) : formatMessage((0, $3NkqS.messages).pinCompanyAddedTooltip),
                                                    position: "bottom",
                                                    children: (tooltipProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                            ...tooltipProps,
                                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                                                                label: "",
                                                                size: "small",
                                                                color: "var(--ds-icon-subtle, #505258)"
                                                            })
                                                        })
                                                })
                                            ]
                                        }),
                                        hasBookmarkCreationAccess && /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                            spacing: "compact",
                                            onClick: openAddPinModal,
                                            testId: "admin-create-bookmark-button",
                                            children: formatMessage((0, $3NkqS.messages).add_another_pin_button_label)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                    href: sanitizeUrl(),
                                    appearance: "subtle",
                                    onClick: onSearchPinOpened,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                        xcss: hovered ? $3ede785c84f921db$var$styles.headingUnderline : undefined,
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                            size: "large",
                                            color: "color.link",
                                            weight: "semibold",
                                            children: bookmarkTitle
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    children: bookmarkDescription
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $9lp28.AIDisclaimerAndFeedback), {
                                    showAIUsageDisclaimer: false,
                                    showFeedbackButtons: true
                                })
                            ]
                        })
                    ]
                })
            }),
            showAddBookmarkModal && /*#__PURE__*/ (0, $l998X.jsx)((0, $4dSc8.AddPinModal), {
                handleClose: ()=>setShowAddBookmarkModal(false),
                orgId: orgId,
                cloudId: cloudId,
                hasAdminhubAccess: hasAdminhubAccess,
                workspaceId: workspaceId,
                product: product
            }),
            showFeedbackModal && /*#__PURE__*/ (0, $l998X.jsx)((0, $3f7da56acd6df247$export$f8d5d13de6379210), {
                setShowDisplayFlag: setShowFeedbackFlag,
                setShowFeedbackModal: setShowFeedbackModal,
                userDetails: userDetails,
                query: query,
                url: url
            }),
            showFeedbackFlag && /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
                onDismissed: ()=>setShowFeedbackFlag(false),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                    fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
                    children: /*#__PURE__*/ (0, $l998X.jsx)($3ede785c84f921db$var$AkFeedbackFlag, {
                        locale: locale,
                        description: formatMessage((0, $3NkqS.messages).pinFeedbackSubmittedFlagMessage)
                    })
                })
            })
        ]
    });
});



var $9sNt3 = parcelRequire("9sNt3");

const $f1f3e476fc2c8b82$var$DISMISS_STATUS_KEY = 'add-new-pin-card-dismissed';
const $f1f3e476fc2c8b82$export$301ef70c5c7bdf65 = /*#__PURE__*/ (0, $42omo.memo)(({ query: query, cloudId: cloudId, orgId: orgId, bookmarkId: bookmarkId, bookmarkState: bookmarkState, url: url, title: title, description: description, hasBookmarkCreationAccess: hasBookmarkCreationAccess = false, hasAdminhubAccess: hasAdminhubAccess = false, searchSessionId: searchSessionId = '', source: source = '', brand: brand = (0, $f7lNm.AiBrand).AI, userDetails: userDetails, product: product, workspaceId: workspaceId, lastModifierAccountId: lastModifierAccountId, keyPhrase: keyPhrase, parentAdminhubBookmarkId: parentAdminhubBookmarkId, requestId: requestId })=>{
    const [viewType, setViewType] = (0, $42omo.useState)('none');
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    (0, $5c40ea1dddca0440$export$eda8930120443143)({
        cloudId: cloudId,
        orgId: orgId
    });
    // hide the card when a new pin is created via AddPinCard
    const onNewPinCreated = ()=>setViewType('none');
    // handle dismiss CTA clicked on add new pin card
    const onDismissCallback = ()=>{
        fireAnalyticsEvent((0, $8d7Su.onAddPinDismissClick)());
        (0, $6CITI.localStore).setString($f1f3e476fc2c8b82$var$DISMISS_STATUS_KEY, 'true');
        setViewType('none');
    };
    const hasBookmarkCreationAccessWithFg = hasBookmarkCreationAccess && (0, $dh538.fg)('adminhub_search_pins_settings');
    (0, $42omo.useEffect)(()=>{
        if (url) // show the bookmark card when a url exists
        setViewType('view');
        else if (!url && (0, $6CITI.localStore).getString($f1f3e476fc2c8b82$var$DISMISS_STATUS_KEY) !== 'true' && hasBookmarkCreationAccessWithFg) // show the add bookmark card if a user is some kind of admin & bookmark for this query doesn't exist
        setViewType('add');
    }, [
        hasBookmarkCreationAccessWithFg,
        url
    ]);
    const commonBookmarkProps = {
        query: query,
        bookmarkState: bookmarkState,
        url: url,
        bookmarkId: bookmarkId,
        orgId: orgId,
        cloudId: cloudId,
        description: description,
        searchSessionId: searchSessionId,
        source: source,
        title: title,
        hasBookmarkCreationAccess: hasBookmarkCreationAccessWithFg,
        hasAdminhubAccess: hasAdminhubAccess,
        brand: brand,
        userDetails: userDetails,
        workspaceId: workspaceId,
        product: product ?? '',
        lastModifierAccountId: lastModifierAccountId,
        keyPhrase: keyPhrase,
        parentAdminhubBookmarkId: parentAdminhubBookmarkId,
        requestId: requestId
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $14qs9.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dpPtd.FlagsProvider), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Rith.AIEventsInstrumentationProvider), {
                config: {
                    product: product ?? 'unknown',
                    subproduct: 'search-page',
                    aiFeatureName: 'smartAnswers',
                    aiExperienceName: 'bookmarks',
                    proactiveGeneratedAI: bookmarkState === (0, $907ac179b537c87a$export$e12e02cef8635961).ACTIVE ? 0 : 1,
                    userGeneratedAI: bookmarkState === (0, $907ac179b537c87a$export$e12e02cef8635961).ACTIVE ? 1 : 0,
                    isAIFeature: 1,
                    source: source,
                    channel: (0, $f7lNm.DEFAULT_GAS_CHANNEL)
                },
                children: viewType === 'view' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3ede785c84f921db$export$91f5ac95cb52dd60), {
                    ...commonBookmarkProps
                }) : viewType === 'add' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $f3c680f674639682$export$5cc0b8a7a0e0e4df), {
                    query: query,
                    orgId: orgId,
                    cloudId: cloudId,
                    hasAdminhubAccess: hasAdminhubAccess,
                    callbacks: {
                        onSuccessCallback: onNewPinCreated,
                        onDismissCallback: onDismissCallback
                    },
                    workspaceId: workspaceId,
                    product: product ?? ''
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {})
            })
        })
    });
});




















const $018c8be6a4352dfb$export$714730cd5e58741b = ({ cloudId: cloudId, query: query, workspaceId: workspaceId, product: product, isStandaloneBookmark: isStandaloneBookmark, applicationMode: applicationMode, isRovoLLMEnabled: isRovoLLMEnabled })=>{
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const [isError, setIsError] = (0, $42omo.useState)(false);
    const [refetchCounter, setRefetchCounter] = (0, $42omo.useState)(1);
    const [id, setId] = (0, $42omo.useState)('');
    const [url, setUrl] = (0, $42omo.useState)('');
    const [title, setTitle] = (0, $42omo.useState)('');
    const [description, setDescription] = (0, $42omo.useState)();
    const [bookmarkState, setBookmarkState] = (0, $42omo.useState)((0, $907ac179b537c87a$export$e12e02cef8635961).ACTIVE);
    const [lastModifierAccountId, setLastModifierAccountId] = (0, $42omo.useState)('');
    const [keyPhrase, setKeyPhrase] = (0, $42omo.useState)('');
    const [parentAdminhubBookmarkId, setParentAdminhubBookmarkId] = (0, $42omo.useState)('');
    const [requestId, setRequestId] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        const callApi = async ()=>{
            try {
                let data;
                let requestId = null;
                if ((0, $dh538.fg)('kd_fix_sain_mau_instrumentation')) {
                    const response = await (0, $907ac179b537c87a$export$e912848e2176a2d7)({
                        cloudId: cloudId,
                        keyPhrase: query
                    }, workspaceId, product);
                    data = response.data;
                    requestId = response.requestId;
                } else data = await (0, $907ac179b537c87a$export$7a8af96e1dd8695b)({
                    cloudId: cloudId,
                    keyPhrase: query
                }, workspaceId, product);
                if (!data || data.extensions && data.extensions.length > 0 && data.extensions[0].statusCode !== 404) {
                    fireAnalyticsEvent((0, $8d7Su.onBookmarkFetchFailed)());
                    (0, $4Zqgi.logger).error({
                        error: data?.extensions || 'Bookmark Fetch Error',
                        functionName: isStandaloneBookmark ? 'useBookmarkQueryStandaloneBookmark' : 'useBookmarkQuery'
                    });
                    setIsError(true);
                    return;
                }
                setId(data?.id || '');
                setUrl(data?.properties?.url || '');
                setDescription(data?.properties?.description || '');
                setTitle(data?.properties?.title || '');
                setBookmarkState(data?.properties?.bookmarkState || (0, $907ac179b537c87a$export$e12e02cef8635961).ACTIVE);
                setLastModifierAccountId(data?.properties?.lastModifierAccountId ?? '');
                setKeyPhrase(data?.properties?.keyPhrase ?? '');
                setParentAdminhubBookmarkId(data?.properties?.parentAdminhubBookmarkId ?? '');
                setRequestId(requestId);
            } catch (error) {
                fireAnalyticsEvent((0, $8d7Su.onBookmarkFetchFailed)());
                (0, $4Zqgi.logger).error({
                    error: error,
                    functionName: isStandaloneBookmark ? 'useBookmarkQueryStandaloneBookmark' : 'useBookmarkQuery'
                });
                setIsError(true);
            } finally{
                setLoading(false);
            }
        };
        if (!!query && ((0, $dh538.fg)('kd_bookmarks_for_rovo_non_ai') ? applicationMode === 'rovo' : isRovoLLMEnabled)) {
            setLoading(true);
            callApi();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cloudId,
        query,
        refetchCounter
    ]);
    const refetch = ()=>setRefetchCounter(refetchCounter + 1);
    return {
        loading: loading,
        isError: isError,
        id: id,
        bookmarkState: bookmarkState,
        url: url,
        title: title,
        description: description,
        refetch: refetch,
        lastModifierAccountId: lastModifierAccountId,
        keyPhrase: keyPhrase,
        parentAdminhubBookmarkId: parentAdminhubBookmarkId,
        requestId: requestId
    };
};






var $5Ymlp = parcelRequire("5Ymlp");










const $c3679052fdea2dcd$export$96282d4f091b522d = 'KnowledgeDiscoveryPopularSearchQuery';
const $c3679052fdea2dcd$export$a0d468182ff3d4cd = `
	query ${$c3679052fdea2dcd$export$96282d4f091b522d}($cloudId: String!, $searchQuery: String!) {
		knowledgeDiscovery @optIn(to: "KnowledgeDiscovery Get Popular Search Query") {
			popularSearchQuery(cloudId: $cloudId, searchQuery: $searchQuery) {
				__typename
				... on KnowledgeDiscoveryPopularSearchQuery {
        	isPopular
				}
				... on QueryError {
					message
					extensions {
						errorType
						statusCode
					}
				}
			}
		}
	}
`;


const $730b365431664b49$var$fetchIsSearchQueryPopular = async (variables)=>{
    return (0, $9EFEY.fetchAggResponse)({
        graphQuery: (0, $c3679052fdea2dcd$export$a0d468182ff3d4cd),
        variables: variables,
        operationName: (0, $c3679052fdea2dcd$export$96282d4f091b522d)
    }).then((response)=>response.data?.knowledgeDiscovery?.popularSearchQuery.isPopular);
};
const $730b365431664b49$export$6c5130d45c1357c5 = ({ cloudId: cloudId, searchQuery: searchQuery, isEnabled: isEnabled })=>{
    const [isPopular, setIsPopular] = (0, $42omo.useState)(false);
    const [loading, setIsLoading] = (0, $42omo.useState)(true);
    const [error, setError] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        const fetchIsPopular = async ()=>{
            try {
                setIsLoading(true);
                const isPopular = await $730b365431664b49$var$fetchIsSearchQueryPopular({
                    cloudId: cloudId,
                    searchQuery: searchQuery
                });
                setIsPopular(isPopular ?? false);
            } catch (err) {
                (0, $4Zqgi.logger).error({
                    error: err,
                    functionName: 'fetchIsSearchQueryPopular'
                });
                setError(true);
            } finally{
                setIsLoading(false);
            }
        };
        if (!!searchQuery && cloudId && isEnabled) fetchIsPopular();
    }, [
        cloudId,
        searchQuery,
        isEnabled
    ]);
    return {
        isPopular: isPopular,
        loading: loading,
        error: error
    };
};



var $epS7s = parcelRequire("epS7s");


var $hm6w9 = parcelRequire("hm6w9");













var $3R0ts = parcelRequire("3R0ts");
















function $3d5e1f52b831d793$export$5cae361ad82dce8b(value, { count: count }) {
    const ref = (0, $42omo.useRef)([]);
    (0, $42omo.useEffect)(()=>{
        if (ref.current[ref.current.length - 1] === value) return;
        // Keep the size of the array equal to the count
        ref.current = [
            ...ref.current.slice(ref.current.length > count - 1 ? 1 : 0),
            value
        ];
    }, [
        count,
        value
    ]);
    return ref.current;
}


























var $5w7WU = parcelRequire("5w7WU");

var $c2fn3 = parcelRequire("c2fn3");










var $2XcmP = parcelRequire("2XcmP");

const $010d1da313d06b34$export$bf345c00a520ed89 = 'DUMMY-a5a01d21-1cc3-4f29-9565-f2bb8cd969f5';
const $010d1da313d06b34$export$91b38aefeb22cc42 = 'a436116f-02ce-4520-8fbb-7301462a1674';
const $010d1da313d06b34$export$57570b1603cf6adb = (cloudId)=>{
    switch(cloudId){
        case '':
        case undefined:
            return 'none';
        case $010d1da313d06b34$export$bf345c00a520ed89:
            return 'pug';
        case $010d1da313d06b34$export$91b38aefeb22cc42:
            return 'hello';
        default:
            return 'production';
    }
};


const $e4ad42dfad2cbd14$export$8ee41d4b861fc655 = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, cloudId: cloudId })=>({
        eventType: 'track',
        actionSubject: `smartAnswersQueryIntent`,
        action: 'failed',
        attributes: {
            commonAttributes: commonAttributes,
            environment: (0, $010d1da313d06b34$export$57570b1603cf6adb)(cloudId)
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });
const $e4ad42dfad2cbd14$export$743c1c20c92a931f = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'track',
        actionSubject: `smartAnswersQueryIntent`,
        action: 'fired',
        attributes: {
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });











const $30704138a28a6cd1$export$bd1c6954a81c5a8a = ()=>{
    const intl = (0, $8C5kA.default)();
    const [searchQuery] = (0, $djVCD.useSearchQuery)();
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const [queryIntent, setQueryIntent] = (0, $42omo.useState)((0, $f7lNm.QueryIntent).DEFAULT);
    const [transformedQuery, setTransformedQuery] = (0, $42omo.useState)('');
    const [queryIntentClassificationData, setQueryIntentClassificationData] = (0, $42omo.useState)();
    const [requestId, setRequestId] = (0, $42omo.useState)();
    const [traceId, setTraceId] = (0, $42omo.useState)();
    const [{ analyticsAttributes: analyticsAttributes, cloudId: cloudId, primaryProduct: primaryProduct, orgId: orgId }] = (0, $j4ply.useBootstrap)();
    const siteARI = `ari:cloud:${primaryProduct}::site/${cloudId}`;
    // plex code uses "jira" as the primary product key but we need to use "jira-software" instead for intent detection
    const jiraSiteARI = `ari:cloud:jira-software::site/${cloudId}`;
    const workspaceId = analyticsAttributes?.activationId ? `ari:cloud:${primaryProduct}:${cloudId}:workspace/${analyticsAttributes.activationId}` : '';
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const numberOfRecentDocuments = (0, $42omo.useMemo)(()=>{
        if (!(0, $dh538.fg)('kd_recent_activity_intent') || !searchQuery) return undefined;
        return Number((0, $6CITI.localStore).getString('recent-activity-count'));
    }, [
        searchQuery
    ]);
    const metadata = !!numberOfRecentDocuments ? {
        numberOfRecentDocuments: numberOfRecentDocuments
    } : undefined;
    const isIntentDetectionV2OnHelloEnabled = (0, $dh538.fg)('kd_intent_v2_exp_gate');
    const isIntentDetectionV2CustomerTestCohort = (0, $eUEtI.hasSAINLayerParamValue)('intent_v2_cohort', 'test') && (0, $dh538.fg)('kd_intent_v2_customer_exp_gate');
    const onQueryIntentFailed = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $e4ad42dfad2cbd14$export$8ee41d4b861fc655)({
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            cloudId: cloudId
        }));
        if ((0, $2XcmP.isQuestion)({
            query: searchQuery,
            locale: intl.locale
        })) setQueryIntent((0, $f7lNm.QueryIntent).NATURAL_LANGUAGE_QUERY);
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes,
        intl.locale,
        searchQuery,
        cloudId
    ]);
    const onQueryIntentFire = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $e4ad42dfad2cbd14$export$743c1c20c92a931f)({
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!searchQuery) return;
        const callGetSmartAnswerRoute = async ()=>{
            // this key targets only jira_web so it should be false for other products
            const actualSiteId = primaryProduct === 'jira' && (0, $dh538.fg)('kd_fix_jira_intent_siteid') ? jiraSiteARI : siteARI;
            setLoading(true);
            onQueryIntentFire();
            // getQueryIntent and getSmartAnswerRoute internally catches and
            // sets queryIntent,transformedQuery to defaults when errored
            // no need for a try catch here
            if (isIntentDetectionV2OnHelloEnabled || isIntentDetectionV2CustomerTestCohort) await (0, $5w7WU.getQueryIntent)({
                query: searchQuery,
                locale: intl.locale,
                siteId: actualSiteId,
                orgId: orgId ?? '',
                workspaceId: workspaceId,
                cloudId: cloudId ?? '',
                product: primaryProduct || '',
                setQueryIntent: setQueryIntent,
                setTransformedQuery: setTransformedQuery,
                setIntentData: setQueryIntentClassificationData,
                onError: onQueryIntentFailed,
                setRequestId: setRequestId,
                setTraceId: setTraceId,
                metadata: metadata
            });
            else await (0, $c2fn3.getSmartAnswerRoute)({
                query: searchQuery,
                locale: intl.locale,
                siteId: actualSiteId,
                orgId: orgId ?? '',
                workspaceId: workspaceId,
                cloudId: cloudId ?? '',
                product: primaryProduct || '',
                setQueryIntent: setQueryIntent,
                setTransformedQuery: setTransformedQuery,
                onError: onQueryIntentFailed,
                metadata: metadata
            });
            setLoading(false);
        };
        callGetSmartAnswerRoute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        siteARI,
        intl.locale,
        searchQuery
    ]);
    return {
        loading: loading,
        transformedQuery: transformedQuery,
        queryIntent: queryIntent,
        queryIntentClassificationData: queryIntentClassificationData,
        requestId: requestId,
        traceId: traceId
    };
};











const $ed340a232d40a52e$var$NAV_BOOST_SCORE_THRESHOLD = 0.5;
const $ed340a232d40a52e$var$initialState = {
    workspaceId: null,
    intentClassificationData: null
};
// Singleton state shared across all components
const $ed340a232d40a52e$var$sharedState = {
    current: {
        ...$ed340a232d40a52e$var$initialState
    }
};
const $ed340a232d40a52e$export$ff55966aa7474110 = ()=>{
    const state = $ed340a232d40a52e$var$sharedState;
    const setWorkspaceId = (0, $42omo.useCallback)((workspaceId)=>{
        state.current.workspaceId = workspaceId;
    }, [
        state
    ]);
    const getWorkspaceId = (0, $42omo.useCallback)(()=>{
        return state.current.workspaceId;
    }, [
        state
    ]);
    const setQueryIntentClassificationData = (0, $42omo.useCallback)((intentClassificationData)=>{
        state.current.intentClassificationData = intentClassificationData;
    }, [
        state
    ]);
    const clearStore = (0, $42omo.useCallback)(()=>{
        state.current = {
            ...$ed340a232d40a52e$var$initialState
        };
    }, [
        state
    ]);
    const isSAINNavigationalExperienceEligible = (0, $42omo.useCallback)(({ position: position, url: url, navBoostScore: navBoostScore })=>{
        if (position === 0 && (0, $dh538.fg)('kd_enable_sain_hero_nav')) {
            const queryIntentClassificationData = state.current.intentClassificationData;
            // use the URL check for nav content intent
            if (queryIntentClassificationData && (0, $4rtnp.isNavContentIntent)(queryIntentClassificationData)) {
                const navContentUrl = queryIntentClassificationData.url;
                if (navContentUrl === url) return true;
            }
            // use the nav boost score check for navigational intent or nav content intent if we missed the document
            // because the URL returned is not for the first result
            if (queryIntentClassificationData && ((0, $4rtnp.isNavigationalIntent)(queryIntentClassificationData) || (0, $4rtnp.isNavContentIntent)(queryIntentClassificationData))) {
                if (navBoostScore && navBoostScore > $ed340a232d40a52e$var$NAV_BOOST_SCORE_THRESHOLD) return true;
            }
        }
        return false;
    }, [
        state
    ]);
    return {
        setWorkspaceId: setWorkspaceId,
        getWorkspaceId: getWorkspaceId,
        setQueryIntentClassificationData: setQueryIntentClassificationData,
        isSAINNavigationalExperienceEligible: isSAINNavigationalExperienceEligible,
        clearStore: clearStore
    };
};











/**
 * this reflects the entites convo-ai uses when making requests to search,
 * we us it to fetch backend search relevance experiment configs to be sent to SAIN's streaming endpoint
 */ const $c072dc2e9e093511$export$9681e147410b3859 = [
    'ati:cloud:compass:component',
    'ati:cloud:confluence:attachment',
    'ati:cloud:confluence:page',
    'ati:cloud:confluence:blogpost',
    'ati:cloud:jira:issue',
    'ati:cloud:townsquare:project',
    'ati:cloud:townsquare:goal',
    'ati:cloud:trello:card',
    // 3p sources
    'ati:cloud:graph:document',
    'ati:cloud:graph:message',
    'ati:cloud:graph:remote-link',
    'ati:cloud:graph:video',
    'ari:cloud:graph:design'
];


const $67b57d653d71bae7$export$1625b883b0fea34d = (filters)=>{
    const selectedFilters = [];
    if (!filters) return selectedFilters;
    if (filters.spacesFilter.length > 0) selectedFilters.push({
        '@type': 'spaces',
        spaceKeys: filters.spacesFilter
    });
    if (filters.isVerified) selectedFilters.push({
        '@type': 'isVerified',
        isVerified: filters.isVerified
    });
    if (filters.contributorsFilter.length > 0) selectedFilters.push({
        '@type': 'contributors',
        accountIds: filters.contributorsFilter
    });
    if (filters.range.length > 0) selectedFilters.push({
        '@type': 'lastModified',
        from: filters.range[0].gt,
        to: filters.range[0].lt
    });
    if (filters.ancestorIdsFilter.length > 0) selectedFilters.push({
        '@type': 'ancestorIds',
        ancestorIds: filters.ancestorIdsFilter
    });
    if (filters.labelsFilter.length > 0) selectedFilters.push({
        '@type': 'labels',
        labelIds: filters.labelsFilter
    });
    return selectedFilters;
};
const $67b57d653d71bae7$export$e9b2fbad5ce470cd = function mapSelectedFiltersToAggregator(selectedFilters) {
    const mappedFilters = {
        commonFilters: [],
        confluenceFilters: []
    };
    if (!selectedFilters) return mappedFilters;
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters } = selectedFilters;
    if (commonFilters && Object.keys(commonFilters).length > 0) {
        if (commonFilters.range?.lastModified) {
            if (commonFilters.range.lastModified.gt && commonFilters.range.lastModified.lt) mappedFilters.commonFilters.push({
                '@type': 'lastUpdated',
                from: commonFilters.range.lastModified.gt,
                to: commonFilters.range.lastModified.lt
            });
            else if (commonFilters.range.lastModified.gt) mappedFilters.commonFilters.push({
                '@type': 'lastUpdated',
                from: commonFilters.range.lastModified.gt
            });
            else if (commonFilters.range.lastModified.lt) mappedFilters.commonFilters.push({
                '@type': 'lastUpdated',
                to: commonFilters.range.lastModified.lt
            });
        }
        if (commonFilters.contributorsFilter && commonFilters.contributorsFilter.length > 0) mappedFilters.commonFilters.push({
            '@type': 'contributors',
            accountIds: commonFilters.contributorsFilter
        });
    }
    if (confluenceFilters && Object.keys(confluenceFilters).length > 0) mappedFilters.confluenceFilters = $67b57d653d71bae7$export$1625b883b0fea34d(confluenceFilters);
    return mappedFilters;
};


const $524a29b68b6bf0ee$var$wrapperStyles = {
    root: "_fiawglyw",
    wrapper: "_1bsb1osq _19pkv77o _fiawglyw"
};
const $524a29b68b6bf0ee$var$smartAnswersPortalStyles = {
    root: "_fiawglyw",
    hidden: "_1e0cglyw"
};
const $524a29b68b6bf0ee$var$handleNavigateDummyFunction = ()=>{};
const $524a29b68b6bf0ee$var$SmartAnswerDialogWrapper = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $524a29b68b6bf0ee$var$wrapperStyles.wrapper,
        children: children
    });
const $524a29b68b6bf0ee$export$df149e1510f7d09e = ({ isRovoLLMEnabled: isRovoLLMEnabled, applicationMode: applicationMode })=>{
    if ((0, $dh538.fg)('rovo_search_updated_entitlement_checks_for_team_25')) {
        if (applicationMode === (0, $9vOy1.ApplicationModes).Unified) return false;
        return isRovoLLMEnabled;
    }
    return applicationMode === (0, $9vOy1.ApplicationModes).Rovo;
};
const $524a29b68b6bf0ee$export$ba5404e9c41a327c = (props)=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $7WbA8.useAppContext)();
    const [{ cloudId: cloudId, user: user, orgId: orgId, SAINHostName: SAINHostName, analyticsAttributes: analyticsAttributes, experimentConfig: experimentConfig, productEdition: productEdition, productDataRegions: productDataRegions, isJiraIssueIndexed: isJiraIssueIndexed, thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [query, { setSearchQuery: setSearchQuery }] = (0, $djVCD.useSearchQuery)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const { hasFiltersSelected: hasFiltersSelected, selectedFilters: selectedFilters } = (0, $4VkIo.useSelectedFilters)({});
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const mappedProductFilter = (0, $1yEFx.MapProductToKnowledgeSources)[selectedProduct];
    const [previousMappedProductFilter] = (0, $3d5e1f52b831d793$export$5cae361ad82dce8b)(mappedProductFilter, {
        count: 1
    });
    const { commonAttributes: { has3pProducts: has3pProducts, is3pSearch: is3pSearch, mode: mode, availableProducts: availableProducts } } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const { clearStore: clearSearchResultStore, setQueryIntentClassificationData: setQueryIntentClassificationData, setWorkspaceId: setWorkspaceId } = (0, $ed340a232d40a52e$export$ff55966aa7474110)();
    const intercom = (0, $9afb3d504f643405$export$f0fed4b0765d7314)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [results] = (0, $djVCD.useResults)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [error] = (0, $djVCD.useResultsError)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const resultsState = (0, $djVCD.useResultsState)();
    let resultsLoaded = resultsState === (0, $fZ3l2.ResultsStates).RESULTS;
    if (props.isRelayEnabled) resultsLoaded = props?.resultsState === (0, $fZ3l2.ResultsStates).RESULTS;
    const { loading: queryIntentLoading, transformedQuery: transformedQuery, queryIntent: queryIntent, queryIntentClassificationData: queryIntentClassificationData, requestId: queryIntentRequestId, traceId: queryIntentTraceId } = (0, $30704138a28a6cd1$export$bd1c6954a81c5a8a)();
    const cloudIdARI = `ari:cloud:confluence::site/${cloudId}`;
    const workspaceId = analyticsAttributes?.activationId ? `ari:cloud:${primaryProduct}:${cloudId}:workspace/${analyticsAttributes.activationId}` : '';
    const xProduct = applicationMode === (0, $9vOy1.ApplicationModes).Rovo ? 'rovo' : undefined;
    // Get dialog referrer tracking from sessionStorage
    const dialogReferrer = (0, $epS7s.getSessionItem)((0, $3R0ts.SEARCH_DIALOG_AI_DIALOG_REFERER_KEY));
    // Clear the dialog referrer tracking after analytics events are fired
    const handleAnalyticsFired = (0, $42omo.useCallback)(()=>{
        // Clear the dialog referrer from sessionStorage
        (0, $epS7s.deleteSessionItem)((0, $3R0ts.SEARCH_DIALOG_AI_DIALOG_REFERER_KEY));
    }, []);
    let showBookmark = false;
    let bookmarkResult = {
        bookmarkState: 'ACTIVE',
        url: '',
        loading: false,
        id: '',
        isError: false,
        title: '',
        description: undefined,
        lastModifierAccountId: '',
        keyPhrase: '',
        parentAdminhubBookmarkId: '',
        requestId: null
    };
    // consume the bookmark data from the intent API instead of calling the bookmark API,
    // when the SAIN nav card is enabled
    if ((0, $dh538.fg)('kd_enable_sain_hero_nav')) {
        if (queryIntentClassificationData && (0, $4rtnp.isBookmarkIntent)(queryIntentClassificationData)) {
            const { bookmark: bookmark } = queryIntentClassificationData;
            bookmarkResult = {
                bookmarkState: bookmark?.bookmarkState,
                url: bookmark?.url,
                loading: false,
                id: bookmark?.id,
                isError: false,
                title: bookmark?.title,
                description: bookmark?.description,
                lastModifierAccountId: bookmark?.lastModifierAccountId,
                keyPhrase: bookmark?.keyPhrase ?? '',
                parentAdminhubBookmarkId: bookmark?.parentAdminhubBookmarkId ?? '',
                requestId: queryIntentRequestId ?? null
            };
        }
    } else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const bookmarkData = (0, $018c8be6a4352dfb$export$714730cd5e58741b)({
            cloudId: cloudId || '',
            query: query,
            workspaceId: workspaceId,
            product: primaryProduct || '',
            applicationMode: applicationMode,
            isRovoLLMEnabled: isRovoLLMEnabled
        });
        bookmarkResult = {
            ...bookmarkData
        };
    }
    const { hasBookmarkCreationAccess: hasBookmarkCreationAccess, hasAdminhubAccess: hasAdminhubAccess } = (0, $5c40ea1dddca0440$export$eda8930120443143)({
        cloudId: cloudId || '',
        orgId: orgId || ''
    });
    const { isPopular: isSearchQueryPopular, loading: isSearchQueryPopularLoading, error: isSearchQueryPopularError } = (0, $730b365431664b49$export$6c5130d45c1357c5)({
        cloudId: cloudId ?? '',
        searchQuery: query,
        isEnabled: (0, $dh538.fg)('kd_user_created_bookmarks')
    });
    // if SAIN nav card is enabled, we show the nav card if the query intent is NAV_CONTENT or NAVIGATIONAL
    // for NAVIGATIONAL intents, we use the nav boost score from the FPS search results, which is checked inside the store
    const showNavCard = (queryIntent === (0, $f7lNm.QueryIntent).NAV_CONTENT || queryIntent === (0, $f7lNm.QueryIntent).NAVIGATIONAL) && (0, $dh538.fg)('kd_enable_sain_hero_nav');
    const parsedFilters = (0, $dh538.fg)('kd_add_common_filters_support_to_sain') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $42omo.useMemo)(()=>(0, $67b57d653d71bae7$export$e9b2fbad5ce470cd)(selectedFilters), [
        selectedFilters
    ]) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $42omo.useMemo)(()=>(0, $67b57d653d71bae7$export$1625b883b0fea34d)(selectedFilters.confluenceFilters), [
        selectedFilters.confluenceFilters
    ]);
    (0, $42omo.useEffect)(()=>{
        // clear the search result store when the query changes or component unmounts
        // this prevents stale nav card data from persisting when transitioning between intents
        (0, $dh538.fg)('kd_enable_sain_hero_nav') && clearSearchResultStore();
        return ()=>{
            (0, $dh538.fg)('kd_enable_sain_hero_nav') && clearSearchResultStore();
        };
    }, [
        query,
        clearSearchResultStore
    ]);
    if ((0, $dh538.fg)('kd_hide_sain_for_unsupported_product_filters')) // fg check is stable between renders and won't cause issues with hook calls
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $42omo.useEffect)(()=>{
        if (previousMappedProductFilter && previousMappedProductFilter !== mappedProductFilter) (0, $epS7s.deleteSessionItem)((0, $f7lNm.SEARCH_AI_ANSWER_CACHE_KEY));
    }, [
        previousMappedProductFilter,
        mappedProductFilter
    ]);
    const tracingHeaders = (0, $42omo.useMemo)(()=>{
        if (!(0, $dh538.fg)('kd_sain_pass_traceid')) return undefined;
        // Use trace headers from intent detection, use arbitraty span id since its needed to propagate trace id
        if (queryIntentTraceId) {
            const spanId = crypto.randomUUID().replace(/-/g, '').slice(0, 16);
            return {
                'X-B3-TraceId': queryIntentTraceId,
                'X-B3-SpanId': spanId
            };
        }
        return undefined;
    }, [
        queryIntentTraceId
    ]);
    const requestId = tracingHeaders?.['X-B3-TraceId'];
    // A callback needed to parse the streaming response, ideally it should be defined inside @atlassian/search-ai
    const aiSearchStreamingFunction = (0, $42omo.useCallback)(({ variables: variables })=>{
        return {
            type: (0, $7Zbm6.AIAnswerAPIType).STREAM,
            stream: (0, $5Ymlp.sainStreamFetchConvoAIService)({
                variables: {
                    ...variables,
                    cloudIdARI: cloudIdARI
                },
                fetchConfig: {
                    hostName: SAINHostName,
                    credentials: 'include',
                    headers: {
                        'X-Cloudid': cloudId || '',
                        ...xProduct ? {
                            'X-Product': xProduct
                        } : {},
                        ...tracingHeaders ?? {}
                    }
                },
                isReadingAids: false
            })
        };
    }, [
        SAINHostName,
        cloudIdARI,
        cloudId,
        xProduct,
        tracingHeaders
    ]);
    const backendExperiment = (0, $42omo.useMemo)(()=>(0, $hm6w9.getBackendExperiment)({
            experimentConfig: experimentConfig,
            entities: (0, $c072dc2e9e093511$export$9681e147410b3859),
            productEdition: productEdition,
            isHello: (0, $5XpfZ.isHello)(cloudId),
            productDataRegions: productDataRegions,
            experience: 'sain',
            tenantId: cloudId,
            isJiraIssueIndexed: isJiraIssueIndexed,
            thirdPartyFilters: selectedFilters.thirdPartyFilters
        }), [
        experimentConfig,
        productEdition,
        cloudId,
        productDataRegions,
        isJiraIssueIndexed,
        selectedFilters
    ]);
    const { experimentLayers: experimentLayers } = backendExperiment || {};
    const extraAnalyticsAttributes = (0, $42omo.useMemo)(()=>({
            isFullPageSearch: true,
            has3pProducts: has3pProducts,
            is3pSearch: is3pSearch,
            mode: mode,
            availableProducts: availableProducts,
            referrer: dialogReferrer,
            originalQuery: query,
            transformedQuery: transformedQuery,
            requestId: requestId
        }), [
        has3pProducts,
        is3pSearch,
        mode,
        availableProducts,
        dialogReferrer,
        query,
        transformedQuery,
        requestId
    ]);
    const intercomCallbacks = (0, $42omo.useMemo)(()=>({
            onAIAnswerSourceClick: ()=>intercom?.trackEvent('ai_answer_source_clicked'),
            onFollowUpSuggestionClick: ()=>intercom?.trackEvent('ai_follow_up_suggestion_clicked'),
            onAIAnswerAnalyticsFired: ()=>handleAnalyticsFired()
        }), [
        intercom,
        handleAnalyticsFired
    ]);
    const userDetail = (0, $42omo.useMemo)(()=>({
            id: user?.id || '',
            name: user?.name || ''
        }), [
        user
    ]);
    if (props.isRelayEnabled && (props.resultsState === (0, $fZ3l2.ResultsStates).NO_RESULTS || props.resultsState === (0, $fZ3l2.ResultsStates).ERROR)) return null;
    else if (error && !results) // Do not show smart answers when there are errors, or empty results
    return null;
    // Do not show smart answers when the required data is not available
    if (!cloudId || !query) return null;
    // Do not show smart answers or bookmarks if query intent isn't set or is loading
    if (queryIntent === (0, $f7lNm.QueryIntent).DEFAULT || queryIntentLoading) {
        // If loading, register a UFO hold
        if (queryIntentLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
            name: "query-intent"
        });
        return null;
    }
    // if the SAIN nav card is enabled,
    // we rely on the intent detection API to determine if we should show the bookmark component
    // this prevents both the nav card and bookmark from being shown at the same time,
    // since there's a high overlap for these two components
    if ((0, $dh538.fg)('kd_enable_sain_hero_nav')) showBookmark = Boolean(queryIntent === (0, $f7lNm.QueryIntent).BOOKMARK && queryIntentClassificationData && (0, $4rtnp.isBookmarkIntent)(queryIntentClassificationData) && !selectedProduct && resultsLoaded);
    else showBookmark = !bookmarkResult.loading && !bookmarkResult.isError && queryIntent !== (0, $f7lNm.QueryIntent).PERSON && !selectedProduct && resultsLoaded;
    if (showNavCard && queryIntentClassificationData) {
        setWorkspaceId(workspaceId ?? '');
        setQueryIntentClassificationData(queryIntentClassificationData);
    }
    const showPopularQuerySuggestion = isSearchQueryPopular && !isSearchQueryPopularLoading && !isSearchQueryPopularError && showBookmark && (queryIntent === (0, $f7lNm.QueryIntent).NAVIGATIONAL || queryIntent === (0, $f7lNm.QueryIntent).KEYWORD_OR_ACRONYM) && (0, $dh538.fg)('kd_user_created_bookmarks');
    const aiBrand = applicationMode === (0, $9vOy1.ApplicationModes).Rovo ? (0, $f7lNm.AiBrand).ROVO : (0, $f7lNm.AiBrand).AI;
    const hideTopicCard = queryIntent === (0, $f7lNm.QueryIntent).TOPIC && !!bookmarkResult.url;
    // No need to check for loaded results before showing SAIN (decision made by PM and team)
    const showSmartAnswer = queryIntent !== (0, $f7lNm.QueryIntent).NONE && queryIntent !== (0, $f7lNm.QueryIntent).NAVIGATIONAL && queryIntent !== (0, $f7lNm.QueryIntent).NAV_CONTENT && queryIntent !== (0, $f7lNm.QueryIntent).BOOKMARK && !bookmarkResult.loading && !hideTopicCard && ((0, $dh538.fg)('kd_hide_sain_for_unsupported_product_filters') ? // check either if no product filter is selected or a supported product filter is selected
    (!selectedProduct || mappedProductFilter !== undefined) && !hasFiltersSelected : true);
    // Show Jira Issue Card with priority for JIRA_ISSUE query intent
    if (queryIntent === (0, $f7lNm.QueryIntent).JIRA_ISSUE) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $hnvzE.default), {
        name: "search-ai-dialog",
        children: [
            (0, $dh538.fg)('platform_ufo_custom_cohort_data_migration') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2cEww.default), {
                        dataKey: "hasSAINComponent",
                        value: true
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2cEww.default), {
                        dataKey: "sainExperienceName",
                        value: "Jira Issue Card"
                    })
                ]
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $cbc8g.default), {
                data: {
                    hasSAINComponent: true,
                    sainExperienceName: 'Jira Issue Card'
                }
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($524a29b68b6bf0ee$var$SmartAnswerDialogWrapper, {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dxjDr.JiraIssueSmartCard), {
                    issueKeyQuery: query,
                    cloudId: cloudId,
                    aiBrand: aiBrand,
                    searchSessionId: searchSessionId,
                    workspaceId: workspaceId,
                    product: primaryProduct ?? '',
                    source: (0, $6yNqK.EVENT_SOURCE)
                })
            })
        ]
    });
    // If a bookmark exists & can be shown, prioritize showing bookmark only
    // If a bookmark doesn't exist & query isn't answerable by SAIN, show the bookmark component to admins
    if (showBookmark && !!bookmarkResult.url || !showSmartAnswer && showBookmark && hasBookmarkCreationAccess) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $hnvzE.default), {
        name: "search-ai-dialog",
        children: [
            (0, $dh538.fg)('platform_ufo_custom_cohort_data_migration') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2cEww.default), {
                        dataKey: "hasSAINComponent",
                        value: true
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2cEww.default), {
                        dataKey: "sainExperienceName",
                        value: "Bookmark"
                    })
                ]
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $cbc8g.default), {
                data: {
                    hasSAINComponent: true,
                    sainExperienceName: 'Bookmark'
                }
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $f1f3e476fc2c8b82$export$301ef70c5c7bdf65), {
                query: query,
                cloudId: cloudId,
                bookmarkId: bookmarkResult.id,
                bookmarkState: bookmarkResult.bookmarkState,
                url: bookmarkResult.url,
                orgId: orgId || '',
                searchSessionId: searchSessionId,
                source: (0, $6yNqK.EVENT_SOURCE),
                brand: aiBrand,
                title: bookmarkResult.title || '',
                description: bookmarkResult.description || '',
                hasAdminhubAccess: hasAdminhubAccess,
                hasBookmarkCreationAccess: hasBookmarkCreationAccess,
                userDetails: userDetail,
                product: primaryProduct,
                workspaceId: workspaceId,
                lastModifierAccountId: bookmarkResult.lastModifierAccountId,
                keyPhrase: bookmarkResult.keyPhrase,
                parentAdminhubBookmarkId: bookmarkResult.parentAdminhubBookmarkId,
                requestId: bookmarkResult.requestId
            })
        ]
    });
    if (showPopularQuerySuggestion) return /*#__PURE__*/ (0, $l998X.jsx)((0, $9sNt3.BookmarkSuggestionCard), {
        suggestedTerm: query,
        cloudId: cloudId,
        orgId: orgId ?? '',
        hasAdminhubAccess: hasAdminhubAccess,
        product: primaryProduct ?? 'unknown',
        workspaceId: workspaceId,
        userDetails: userDetail,
        searchSessionId: searchSessionId,
        source: (0, $6yNqK.EVENT_SOURCE)
    });
    else if (showSmartAnswer) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsxs)($524a29b68b6bf0ee$var$SAINIntercomWrapper, {
            children: [
                showBookmark && hasBookmarkCreationAccess ? // If bookmark *could* be shown but doesn't exist, show the bookmark component to admins
                /*#__PURE__*/ (0, $l998X.jsx)((0, $f1f3e476fc2c8b82$export$301ef70c5c7bdf65), {
                    query: query,
                    cloudId: cloudId,
                    bookmarkId: bookmarkResult.id,
                    url: bookmarkResult.url,
                    orgId: orgId || '',
                    searchSessionId: searchSessionId,
                    source: (0, $6yNqK.EVENT_SOURCE),
                    brand: aiBrand,
                    title: bookmarkResult.title || '',
                    description: bookmarkResult.description || '',
                    hasAdminhubAccess: hasAdminhubAccess,
                    hasBookmarkCreationAccess: hasBookmarkCreationAccess,
                    product: primaryProduct,
                    workspaceId: workspaceId,
                    lastModifierAccountId: bookmarkResult.lastModifierAccountId,
                    keyPhrase: bookmarkResult.keyPhrase,
                    parentAdminhubBookmarkId: bookmarkResult.parentAdminhubBookmarkId,
                    requestId: bookmarkResult.requestId
                }) : null,
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3Opgu.SearchAIDialog), {
                    query: transformedQuery || query,
                    cloudId: cloudId,
                    orgId: orgId,
                    getAIAnswer: aiSearchStreamingFunction,
                    onNavigate: $524a29b68b6bf0ee$var$handleNavigateDummyFunction,
                    userDetails: userDetail,
                    source: (0, $6yNqK.EVENT_SOURCE),
                    extraAnalyticsAttributes: extraAnalyticsAttributes,
                    wrapper: $524a29b68b6bf0ee$var$SmartAnswerDialogWrapper,
                    loadingWrapper: $524a29b68b6bf0ee$var$SmartAnswerDialogWrapper,
                    setQuery: setSearchQuery,
                    followUpsEnabled: true,
                    searchSessionId: searchSessionId,
                    selectedFilters: selectedFilters,
                    parsedFilters: parsedFilters,
                    selectedProduct: selectedProduct,
                    mappedProductFilter: mappedProductFilter,
                    smartAnswersRoute: queryIntent,
                    cardTemplate: (0, $f7lNm.CardTemplate).SMART_ANSWER,
                    baseQuery: query,
                    brand: aiBrand,
                    callbacks: intercomCallbacks,
                    workspaceId: workspaceId,
                    isAdminHubAIEnabled: isAdminHubAIEnabled,
                    sourceProduct: primaryProduct,
                    showChatFollowUps: $524a29b68b6bf0ee$export$df149e1510f7d09e({
                        isRovoLLMEnabled: isRovoLLMEnabled,
                        applicationMode: applicationMode
                    }),
                    queryIntentClassificationData: queryIntentClassificationData,
                    ...(0, $dh538.fg)('kd_sain_backend_exp_context') ? {
                        experimentContext: {
                            // The experiment layers are mapped to ensure permitted attributes are sent into search requests.
                            experimentLayers: (experimentLayers || []).map(({ name: name, layerId: layerId, shadowId: shadowId, definitions: definitions })=>({
                                    name: name,
                                    layerId: layerId,
                                    shadowId: shadowId,
                                    definitions: definitions
                                }))
                        }
                    } : {},
                    referrer: dialogReferrer,
                    useOAuthHandlers: (0, $gGFxq.useOAuthHandlers),
                    thirdPartyConfigs: thirdPartyConfigs,
                    traceHeaders: tracingHeaders
                })
            ]
        })
    });
    return null;
};
const $524a29b68b6bf0ee$export$39017662cee16e4e = (props)=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $7WbA8.useAppContext)();
    const [{ cloudId: cloudId, user: user, orgId: orgId, analyticsAttributes: analyticsAttributes }] = (0, $j4ply.useBootstrap)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [query] = (0, $djVCD.useSearchQuery)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const workspaceId = analyticsAttributes?.activationId ? `ari:cloud:${primaryProduct}:${cloudId}:workspace/${analyticsAttributes.activationId}` : '';
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [results] = (0, $djVCD.useResults)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [error] = (0, $djVCD.useResultsError)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const resultsState = (0, $djVCD.useResultsState)();
    let resultsLoaded = resultsState === (0, $fZ3l2.ResultsStates).RESULTS;
    if (props.isRelayEnabled) resultsLoaded = props.resultsState === (0, $fZ3l2.ResultsStates).RESULTS;
    const { bookmarkState: bookmarkState, url: bookmarkUrl, loading: bookmarkLoading, id: bookmarkId, isError: isError, title: title, description: description, lastModifierAccountId: lastModifierAccountId, keyPhrase: keyPhrase, parentAdminhubBookmarkId: parentAdminhubBookmarkId, requestId: bookmarkRequestId } = (0, $018c8be6a4352dfb$export$714730cd5e58741b)({
        cloudId: cloudId || '',
        query: query,
        workspaceId: workspaceId,
        product: primaryProduct || '',
        isStandaloneBookmark: true,
        applicationMode: applicationMode,
        isRovoLLMEnabled: isRovoLLMEnabled
    });
    const { hasBookmarkCreationAccess: hasBookmarkCreationAccess, hasAdminhubAccess: hasAdminhubAccess } = (0, $5c40ea1dddca0440$export$eda8930120443143)({
        cloudId: cloudId || '',
        orgId: orgId || ''
    });
    const userDetail = (0, $42omo.useMemo)(()=>({
            id: user?.id || '',
            name: user?.name || ''
        }), [
        user
    ]);
    if (props.isRelayEnabled && (props.resultsState === (0, $fZ3l2.ResultsStates).NO_RESULTS || props.resultsState === (0, $fZ3l2.ResultsStates).ERROR)) return null;
    else if (error && !results) // Do not show smart answers when there are errors, or empty results
    return null;
    // Do not show smart answers when the required data is not available
    if (!cloudId || !query) return null;
    const showBookmark = !bookmarkLoading && !isError && !selectedProduct && resultsLoaded;
    // If a bookmark exists & can be shown, prioritize showing bookmark only
    // If a bookmark doesn't exist & query isn't answerable by SAIN, show the bookmark component to admins
    if (showBookmark && !!bookmarkUrl || showBookmark && hasBookmarkCreationAccess) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $hnvzE.default), {
        name: "search-ai-dialog",
        children: [
            (0, $dh538.fg)('platform_ufo_custom_cohort_data_migration') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2cEww.default), {
                        dataKey: "hasSAINComponent",
                        value: true
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2cEww.default), {
                        dataKey: "sainExperienceName",
                        value: "Bookmark"
                    })
                ]
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $cbc8g.default), {
                data: {
                    hasSAINComponent: true,
                    sainExperienceName: 'Bookmark'
                }
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $f1f3e476fc2c8b82$export$301ef70c5c7bdf65), {
                query: query,
                cloudId: cloudId,
                bookmarkId: bookmarkId,
                bookmarkState: bookmarkState,
                url: bookmarkUrl,
                orgId: orgId || '',
                searchSessionId: searchSessionId,
                source: (0, $6yNqK.EVENT_SOURCE),
                brand: applicationMode === (0, $9vOy1.ApplicationModes).Rovo ? (0, $f7lNm.AiBrand).ROVO : (0, $f7lNm.AiBrand).AI,
                title: title || '',
                description: description || '',
                hasAdminhubAccess: hasAdminhubAccess,
                hasBookmarkCreationAccess: hasBookmarkCreationAccess,
                userDetails: userDetail,
                product: primaryProduct,
                workspaceId: workspaceId,
                lastModifierAccountId: lastModifierAccountId,
                keyPhrase: keyPhrase,
                parentAdminhubBookmarkId: parentAdminhubBookmarkId,
                requestId: bookmarkRequestId
            })
        ]
    });
    return null;
};
const $524a29b68b6bf0ee$var$SAINIntercomWrapper = ({ children: children })=>{
    const intercom = (0, $9afb3d504f643405$export$f0fed4b0765d7314)();
    const { queryIntent: queryIntent } = (0, $30704138a28a6cd1$export$bd1c6954a81c5a8a)();
    (0, $42omo.useEffect)(()=>{
        intercom?.trackEvent('smart_answers_shown', {
            query_intent: queryIntent
        });
    }, [
        intercom,
        queryIntent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
const $524a29b68b6bf0ee$export$6d2f0eb8aa322ad7 = (props)=>{
    const [userWithStatus] = (0, $4Qo4W.useUser)();
    const [primaryProduct] = (0, $4Qo4W.usePrimaryProduct)();
    const [query] = (0, $djVCD.useSearchQuery)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $7WbA8.useAppContext)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const areLLMFeaturesEnabled = (0, $71988ef00edd4050$export$5c2913b6a4d1611c)();
    const [{ cloudId: cloudId }] = (0, $j4ply.useBootstrap)();
    const isUserAuthenticated = userWithStatus.status === (0, $lwP5K.UserStatus).Authenticated;
    const isPrimaryProductEligible = primaryProduct === (0, $1yEFx.ProductKeys).Confluence || primaryProduct === (0, $1yEFx.ProductKeys).Atlas || primaryProduct === (0, $1yEFx.ProductKeys).Jira;
    if (!isUserAuthenticated || !isPrimaryProductEligible || !query) return null;
    // Experiment to disable SAIN based on: https://atlassian.slack.com/archives/C06K9T53N66/p1757961269661659?thread_ts=1754004619.291609&cid=C06K9T53N66
    // skip hello users for SAIN holdback exp
    if (!(0, $5XpfZ.isHello)(cloudId) && (0, $dh538.fg)('kd_disable_sain_experiment_fg')) {
        const layer = (0, $c6GJD.default).getLayer((0, $4OGlb.STATSIG_SEARCH_BACKEND_NON_OVERLAPPING_DOMAIN));
        const abTestId = layer.get('abTestId', 'no_ab_test_id');
        if (abTestId === 'kd_disable_sain_experiment') {
            const backendExperimentData = layer.get('backendChanges', {
                sain: true
            });
            if (!backendExperimentData?.sain) return null;
        }
    }
    if ((0, $dh538.fg)('rovo_search_updated_entitlement_checks_for_team_25')) {
        if (areLLMFeaturesEnabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
            name: "search-page-smart-answers",
            children: /*#__PURE__*/ (0, $l998X.jsx)($524a29b68b6bf0ee$export$ba5404e9c41a327c, {
                ...props
            })
        });
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
            name: "search-page-smart-answers",
            children: /*#__PURE__*/ (0, $l998X.jsx)($524a29b68b6bf0ee$export$39017662cee16e4e, {
                ...props
            })
        });
    } else {
        if (isAdminHubAIEnabled || applicationMode === (0, $9vOy1.ApplicationModes).Rovo) return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
            name: "search-page-smart-answers",
            children: /*#__PURE__*/ (0, $l998X.jsx)($524a29b68b6bf0ee$export$ba5404e9c41a327c, {
                ...props
            })
        });
    }
    return null;
};
/**
 * A wrapper for the entire smart answers component in the search page,
 * which wraps the component in a div with a specific id. This is used
 * to calculate VC90 of the search page ignoring smart answers by filtering
 * out mutations that occur on descendants of this div during VC90 calculation.
 *
 * The specific metric this is used for is:
 * https://tools.atlassian.com/glance/experience/confluence.fe.page-load.ufo-search-page-ignoring-smart-answers
 */ const $524a29b68b6bf0ee$var$SmartAnswersWrapper = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        id: "search-page-smart-answers",
        xcss: $524a29b68b6bf0ee$var$wrapperStyles.root,
        children: children
    });
const $524a29b68b6bf0ee$var$SmartAnswersWithErrorBoundary = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
        section: "SearchPageSmartAnswers",
        children: /*#__PURE__*/ (0, $l998X.jsxs)($524a29b68b6bf0ee$var$SmartAnswersWrapper, {
            children: [
                (0, $dh538.fg)('kd_enable_sain_hero_nav') && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: (0, $1Whri.cx)($524a29b68b6bf0ee$var$smartAnswersPortalStyles.root, // Hide the SAIN portal when the results state is not RESULTS
                    // This is to prevent the SAIN portal from showing the previous nav card
                    props.resultsState !== (0, $fZ3l2.ResultsStates).RESULTS && $524a29b68b6bf0ee$var$smartAnswersPortalStyles.hidden),
                    ref: props.smartAnswersPortalRef,
                    testId: "sain-nav-card-portal"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)($524a29b68b6bf0ee$export$6d2f0eb8aa322ad7, {
                    ...props
                })
            ]
        })
    });
var $524a29b68b6bf0ee$export$2e2bcd8739ae039 = $524a29b68b6bf0ee$var$SmartAnswersWithErrorBoundary;


const $976e51335fad9db5$export$a54ec244c8863715 = ({ shell: shell, callbacks: callbacks, mapUserIdToProfileUrl: mapUserIdToProfileUrl, generateSearchUrl: generateSearchUrl, onNavigate: onNavigate, onSearchResultsShown: onSearchResultsShown })=>{
    const [{ thirdPartyConfigs: thirdPartyConfigs, products: availableProducts }] = (0, $j4ply.useBootstrap)();
    const { searchSessionId: searchSessionId } = shell;
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const [isHello] = (0, $j4ply.useIsHello)();
    const [hasRecordedAvailableProducts, setHasRecordedAvailableProducts] = (0, $42omo.useState)(false);
    // Log a health metric for accessible products
    (0, $42omo.useEffect)(()=>{
        if ((0, $dh538.fg)('rovo-search-accessible-products-healthmetric')) // When null or empty bootstrap isn't ready. Even failed bootstrap will have primaryProduct in the set
        {
            if (availableProducts && availableProducts.length > 0 && !hasRecordedAvailableProducts) {
                fireAnalyticsEvent((0, $0e1691e3261af771$export$abd5de3aada5ec8b)({
                    availableProducts: availableProducts,
                    searchSessionId: searchSessionId
                }));
                setHasRecordedAvailableProducts(true);
            }
        }
    }, [
        availableProducts,
        hasRecordedAvailableProducts,
        fireAnalyticsEvent,
        searchSessionId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: "search-page",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $10f79ecb05a6930a$export$2e2bcd8739ae039), {
            ...shell,
            callbacks: callbacks,
            mapUserIdToProfileUrl: mapUserIdToProfileUrl,
            generateSearchUrl: generateSearchUrl,
            onNavigate: onNavigate,
            onSearchResultsShown: onSearchResultsShown,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $86ob4.WidthObserverProvider), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ae52891585221a98$export$c84671f46d6a1ca), {
                        components: {
                            input: /*#__PURE__*/ (0, $l998X.jsx)((0, $7f479a12f1edc810$export$2e2bcd8739ae039), {}),
                            filters: /*#__PURE__*/ (0, $l998X.jsx)((0, $99686144b211a11b$export$2e2bcd8739ae039), {}),
                            results: /*#__PURE__*/ (0, $l998X.jsx)((0, $4571e76365892ec4$export$b4ce9e0c6695ed08), {}),
                            smartAnswers: /*#__PURE__*/ (0, $l998X.jsx)((0, $524a29b68b6bf0ee$export$2e2bcd8739ae039), {}),
                            oauthContainer: /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
                                section: "SearchPageOAuthContainer",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a5OFf.OAuthContainer), {
                                    thirdPartyConfigs: thirdPartyConfigs,
                                    availableProducts: availableProducts,
                                    isHello: isHello,
                                    useOAuthHandlers: (0, $gGFxq.useOAuthHandlers),
                                    fireAnalyticsEvent: fireAnalyticsEvent
                                })
                            }),
                            rightPanel: /*#__PURE__*/ (0, $l998X.jsx)((0, $39dda3505e8b980a$export$2e2bcd8739ae039), {}),
                            autoCorrection: /*#__PURE__*/ (0, $l998X.jsx)((0, $052357e0aba090f3$export$2e2bcd8739ae039), {}),
                            messageBanner: /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                children: [
                                    !(0, $dh538.fg)('assets_rovo_search_all') && shell.primaryProduct === (0, $1yEFx.PrimaryProductKeys).Assets && /*#__PURE__*/ (0, $l998X.jsx)((0, $26a950b385d21113$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $683ceb08130b194d$export$2e2bcd8739ae039), {})
                                ]
                            }),
                            bulkConnectModal: /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
                                section: "SearchPageBulkConnectModal",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $NvPpA.BulkConnectModal), {
                                    isOnSearchDialog: false,
                                    oAuthSource: (0, $ckkm9.OAuthSource).searchPageBulkConnect
                                })
                            })
                        }
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $eebd889499df8cd4$export$4501d5ed63e0d41d), {})
            ]
        })
    });
};
const $976e51335fad9db5$export$2194eaf953b87e28 = ({ shell: shell, callbacks: callbacks, mapUserIdToProfileUrl: mapUserIdToProfileUrl, experiments: experiments })=>{
    const [{ thirdPartyConfigs: thirdPartyConfigs, products: availableProducts }] = (0, $j4ply.useBootstrap)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const [isHello] = (0, $j4ply.useIsHello)();
    const shellWithSideBySide = (0, $42omo.useMemo)(()=>({
            ...shell,
            features: {
                sideBySide: {
                    enabled: true,
                    experiments: experiments
                }
            }
        }), [
        shell,
        experiments
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: "search-page-sbs",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $10f79ecb05a6930a$export$794614fa392eb573), {
            ...shellWithSideBySide,
            callbacks: callbacks,
            mapUserIdToProfileUrl: mapUserIdToProfileUrl,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $86ob4.WidthObserverProvider), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ae52891585221a98$export$8ac1fb3f3f89d5bf), {
                        components: {
                            filters: /*#__PURE__*/ (0, $l998X.jsx)((0, $99686144b211a11b$export$2e2bcd8739ae039), {}),
                            results: /*#__PURE__*/ (0, $l998X.jsx)((0, $4571e76365892ec4$export$b4ce9e0c6695ed08), {}),
                            smartAnswers: /*#__PURE__*/ (0, $l998X.jsx)((0, $524a29b68b6bf0ee$export$2e2bcd8739ae039), {}),
                            oauthContainer: /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
                                section: "SearchPageSideBySideOAuthContainer",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a5OFf.OAuthContainer), {
                                    isOnSearchDialog: true,
                                    thirdPartyConfigs: thirdPartyConfigs,
                                    availableProducts: availableProducts,
                                    isHello: isHello,
                                    useOAuthHandlers: (0, $gGFxq.useOAuthHandlers),
                                    fireAnalyticsEvent: fireAnalyticsEvent
                                })
                            }),
                            autoCorrection: /*#__PURE__*/ (0, $l998X.jsx)((0, $052357e0aba090f3$export$2e2bcd8739ae039), {})
                        }
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $eebd889499df8cd4$export$4501d5ed63e0d41d), {})
            ]
        })
    });
};
const $976e51335fad9db5$export$30c29f149712af8a = ({ shell: shell, callbacks: callbacks, mapUserIdToProfileUrl: mapUserIdToProfileUrl, onInputDropdownResultSelect: onInputDropdownResultSelect = ()=>{}, onInputSubmit: onInputSubmit = ()=>{} })=>{
    const shellWithChromeExtension = (0, $42omo.useMemo)(()=>({
            ...shell,
            thirdPartyDisabled: true,
            features: {
                chromeExtension: {
                    enabled: true,
                    onInputDropdownResultSelect: onInputDropdownResultSelect,
                    onInputSubmit: onInputSubmit
                }
            }
        }), [
        onInputDropdownResultSelect,
        onInputSubmit,
        shell
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: "search-page-browser-extension",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $10f79ecb05a6930a$export$794614fa392eb573), {
            ...shellWithChromeExtension,
            callbacks: callbacks,
            mapUserIdToProfileUrl: mapUserIdToProfileUrl,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $86ob4.WidthObserverProvider), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7f479a12f1edc810$export$2e2bcd8739ae039), {})
            })
        })
    });
};





















var $4xBBd = parcelRequire("4xBBd");


var $gWF6I = parcelRequire("gWF6I");














































const $2bb9aeea11dbc94b$export$f6a06b563a614935 = ({ children: children, ...props })=>{
    const renderWithErrorInfo = (0, $42omo.useCallback)((props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $b30d5c5335be09a9$export$65db35c377fab04b), {
            ...props
        }), []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
        renderWithErrorInfo: renderWithErrorInfo,
        section: "SearchPageRelayBootstrap",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8aC7e.default), {
            ...props,
            statsigLayer: (0, $4OGlb.STATSIG_FULL_PAGE_SEARCH_LAYER),
            experience: (0, $hHl3d.SearchExperience).SEARCH_PAGE,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $bHLTK.SearchStoreProvider), {
                experience: (0, $hHl3d.SearchExperience).SEARCH_PAGE,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $d6c71ab59cbce7e1$export$cb48c45f3598fb8), {}),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $aec377272259e0f9$export$6a93826c3e88a7f6), {}),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $14f459c4dfcc6b1a$export$d076c6f78afb0ebc), {}),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $10ae4d7be0130777$export$2025f1e19c7d8520), {}),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $814d53f457d71a8a$export$2e2bcd8739ae039), {
                        children: children
                    })
                ]
            })
        })
    });
};


/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 






var $irOoi = parcelRequire("irOoi");














var $aaNIP = parcelRequire("aaNIP");

















const $f43a1e29196bf274$export$3c6a6c4c70845302 = ({ setProductsWithTimeout: setProductsWithTimeout })=>{
    (0, $42omo.useEffect)(()=>{
        if (!(0, $2OtFZ.serveSearchPageTimeoutsUX)()) return;
        setProductsWithTimeout(undefined);
    }, [
        setProductsWithTimeout
    ]);
    return null;
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");












var $5e5cd8421dca6bae$exports = {};
$5e5cd8421dca6bae$exports = new URL("landing-dark.4ee27e71.svg", import.meta.url).toString();


var $bbbf2953c1e88da3$exports = {};
$bbbf2953c1e88da3$exports = new URL("landing-light.0988f0a2.svg", import.meta.url).toString();





const $30ab1532ab66340a$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    landingPrimary: {
        id: "landing_primary",
        defaultMessage: "Seek and you shall find"
    },
    landingSecondaryRovo: {
        id: "landing_secondary_rovo",
        defaultMessage: "Search or ask Rovo what you're looking for in your Atlassian and connected apps"
    },
    landingSecondaryUnifiedWithSAIN: {
        id: "landing_secondary_unified_with_sain",
        defaultMessage: "Search or ask anything across your Atlassian apps"
    },
    landingSecondaryUnifiedWithoutSAIN: {
        id: "landing_secondary_unified_without_sain",
        defaultMessage: "Search for anything across your Atlassian apps"
    },
    landingSecondary: {
        id: "landing_secondary",
        defaultMessage: "Search for what you're looking for in your Atlassian and connected apps"
    },
    landingSecondaryWithAI: {
        id: "landing_secondary_with_atlassian_intelligence",
        defaultMessage: "Search or ask what you're looking for in your Atlassian and connected apps"
    }
});


const $448d3451574c04df$var$styles = {
    headingWrapper: "_11c81af2 _k48p1wq8"
};
const $448d3451574c04df$var$getMessage = (isAIEnabled)=>isAIEnabled ? (0, $30ab1532ab66340a$export$defe85febe8b728c).landingSecondaryWithAI : (0, $30ab1532ab66340a$export$defe85febe8b728c).landingSecondary;
const $448d3451574c04df$var$SecondaryText = ({ applicationMode: applicationMode, isAdminHubAIEnabled: isAdminHubAIEnabled = false, isRovoLLMEnabled: isRovoLLMEnabled = false })=>{
    if ((0, $dh538.fg)('rovo_search_updated_entitlement_checks_for_team_25')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $919e914043a539a1$export$2e2bcd8739ae039), {
        rovoComponent: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$448d3451574c04df$var$getMessage(isRovoLLMEnabled)
        }),
        unifiedComponent: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$448d3451574c04df$var$getMessage(isAdminHubAIEnabled)
        }),
        applicationMode: applicationMode
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $919e914043a539a1$export$2e2bcd8739ae039), {
        rovoComponent: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $30ab1532ab66340a$export$defe85febe8b728c).landingSecondaryRovo
        }),
        unifiedComponent: isAdminHubAIEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $30ab1532ab66340a$export$defe85febe8b728c).landingSecondaryUnifiedWithSAIN
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $30ab1532ab66340a$export$defe85febe8b728c).landingSecondaryUnifiedWithoutSAIN
        }),
        applicationMode: applicationMode
    });
};
const $448d3451574c04df$export$12449a31c6671d53 = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $330959ad09458c13$export$d9172702747fb4bc), {
        testId: "search-page-landing",
        imageSrcLight: (0, (/*@__PURE__*/$parcel$interopDefault($bbbf2953c1e88da3$exports))),
        imageSrcDark: (0, (/*@__PURE__*/$parcel$interopDefault($5e5cd8421dca6bae$exports))),
        primaryText: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $448d3451574c04df$var$styles.headingWrapper,
            as: "h2",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $30ab1532ab66340a$export$defe85febe8b728c).landingPrimary
            })
        }),
        secondaryText: /*#__PURE__*/ (0, $l998X.jsx)($448d3451574c04df$var$SecondaryText, {
            ...props
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 




















const $849ee461ff61ea47$var$styles = {
    layout: "_1reo15vq _18m915vq _1e0c1txw _2lx21bp4"
};
const $849ee461ff61ea47$var$NAV3_HEIGHT = 56;
const $849ee461ff61ea47$var$NAV4_HEIGHT = 48;
// 48px (tabs) + 1px (border)
const $849ee461ff61ea47$var$FPS_NIN_TABS_HEIGHT = 49;
const $849ee461ff61ea47$var$FPS_NIN_BUTTON_ICONS_HEIGHT = 56;
const $849ee461ff61ea47$export$c84671f46d6a1ca = ({ children: children, primaryProduct: primaryProduct })=>{
    const { isNav4Enabled: isNav4Enabled } = (0, $7WbA8.useAppContext)();
    const rovoNavigationHeight = (0, $42omo.useMemo)(()=>{
        const cohort = (0, $26jni.serveJiraNinFpsNavigation)({
            primaryProduct: primaryProduct,
            fireLayerExposure: false
        });
        if (cohort === 'tabs') return $849ee461ff61ea47$var$FPS_NIN_TABS_HEIGHT;
        if (cohort === 'button' || cohort === 'icons') return $849ee461ff61ea47$var$FPS_NIN_BUTTON_ICONS_HEIGHT;
        return 0;
    }, [
        primaryProduct
    ]);
    const navHeight = (isNav4Enabled ? $849ee461ff61ea47$var$NAV4_HEIGHT : $849ee461ff61ea47$var$NAV3_HEIGHT) + rovoNavigationHeight;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: "search-page-layout",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $86ob4.WidthObserverElement), {
            id: "layout",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                testId: "search-page-layout",
                xcss: $849ee461ff61ea47$var$styles.layout,
                // Can be moved to CSS when nav4 is GA
                style: {
                    height: `calc(100vh - ${navHeight}px)`
                },
                children: children
            })
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






















const $f8be7d82aac68e80$var$styles = {
    container: "_18m915zi",
    contentContainer: "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _19bvu2gc _u5f3u2gc _4cvr1yb4 _b8yq1a8x",
    contentContainerWithTabs: "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _19bv1ejb _u5f31ejb _4cvr1yb4 _b8yq1a8x",
    mainContent: "_zulppxbi _1rjcv47k _1e0c1txw _2lx21bp4 _1bah1fhb _16jlkb7n _p12fbxu3 _1pbyidpf",
    rightPanelWrapper: "_1e0cglyw _181n1ule",
    rightPanel: "_kqsw1if8 _154iidpf _1bsbde1w"
};
const $f8be7d82aac68e80$export$4b2c32e08f77ff18 = ({ selectedProduct: selectedProduct, rightPanel: rightPanel, children: children, bodyRef: bodyRef, mainContentRef: mainContentRef, setMainContentWidth: setMainContentWidth, primaryProduct: primaryProduct })=>{
    const { isNav4Enabled: isNav4Enabled } = (0, $7WbA8.useAppContext)();
    const fpsNinNavigationCohort = (0, $26jni.serveJiraNinFpsNavigation)({
        primaryProduct: primaryProduct,
        fireLayerExposure: false
    });
    (0, $42omo.useEffect)(()=>{
        bodyRef?.current?.scrollTo?.(0, 0);
    }, [
        selectedProduct,
        bodyRef,
        isNav4Enabled
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!(0, $2OtFZ.serveSearchPageRenderingOptimisations)()) return;
        const callback = ()=>{
            if (mainContentRef.current) setMainContentWidth(mainContentRef.current.offsetWidth);
        };
        const resizeObserver = new ResizeObserver(callback);
        if (mainContentRef.current) {
            resizeObserver.observe(mainContentRef.current); // Set initial width
            callback();
        }
        return ()=>{
            resizeObserver.disconnect();
        }; // These dependencies should never change
    }, [
        mainContentRef,
        setMainContentWidth
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: bodyRef,
        "data-testid": "search-page-body",
        className: (0, $gMc0m.default)([
            $f8be7d82aac68e80$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            space: "space.800",
            xcss: fpsNinNavigationCohort === 'tabs' ? $f8be7d82aac68e80$var$styles.contentContainerWithTabs : $f8be7d82aac68e80$var$styles.contentContainer,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    ref: mainContentRef,
                    "data-testid": "search-page-body-main-content",
                    className: (0, $gMc0m.default)([
                        $f8be7d82aac68e80$var$styles.mainContent
                    ]),
                    children: children
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $f8be7d82aac68e80$var$styles.rightPanelWrapper,
                    children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            $f8be7d82aac68e80$var$styles.rightPanel
                        ]),
                        children: rightPanel
                    })
                })
            ]
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


















const $3867e15ac7e3b5d9$var$styles = {
    base: "_kqsw1if8 _154iidpf _bfhkvuon _1bsb1osq _1y1m1u8q _1pbykb7n",
    contentContainer: "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _19bvu2gc _u5f3u2gc _4cvr1yb4 _b8yq1a8x",
    contentContainerWithTabs: "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _19bv1ejb _u5f31ejb _4cvr1yb4 _b8yq1a8x",
    keyline: "_n7zlia51",
    grid: "_1lmc19pt _yv0e1k1g _n3tdv47k",
    paddingTop: "_ca0q1ejb",
    inputGridArea: "_nd5l1hq5 _1e0c1txw _4cvr1h6o",
    filtersGridArea: "_nd5l12xr"
};
const $3867e15ac7e3b5d9$export$8b251419efc915eb = ({ input: input, filters: filters, primaryProduct: primaryProduct })=>{
    const { isNav4Enabled: isNav4Enabled } = (0, $7WbA8.useAppContext)();
    const cohort = (0, $26jni.serveJiraNinFpsNavigation)({
        primaryProduct: primaryProduct,
        fireLayerExposure: false
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($3867e15ac7e3b5d9$var$styles.base, $3867e15ac7e3b5d9$var$styles.keyline),
                testId: "search-page-header",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: cohort === 'tabs' ? $3867e15ac7e3b5d9$var$styles.contentContainerWithTabs : $3867e15ac7e3b5d9$var$styles.contentContainer,
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $d8SNb.default), {
                        xcss: (0, $1Whri.cx)($3867e15ac7e3b5d9$var$styles.grid, !isNav4Enabled && $3867e15ac7e3b5d9$var$styles.paddingTop),
                        columnGap: "space.200",
                        rowGap: "space.200",
                        children: [
                            !isNav4Enabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $3867e15ac7e3b5d9$var$styles.inputGridArea,
                                children: input
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $3867e15ac7e3b5d9$var$styles.filtersGridArea,
                                children: filters
                            })
                        ]
                    })
                })
            }),
            isNav4Enabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                children: input
            })
        ]
    });
};
















const $dc3d3be87137607c$export$cfd0a4eecdb5b49d = (b)=>{
    return {
        cloudId: b.cloudId,
        primaryProduct: b.primaryProduct,
        searchSessionId: b.searchSessionId,
        isRovoEnabled: b.isRovoEnabled,
        allFilterExcludedProducts: b.allFilterExcludedProducts,
        thirdPartyConfigs: b.thirdPartyConfigs,
        experimentConfig: b.experimentConfig,
        experimentLayers: b.experimentLayers,
        products: b.products,
        isJiraIssueIndexed: b.isJiraIssueIndexed,
        user: b.user,
        nouns: b.nouns,
        isNounsAvailable: b.isNounsAvailable,
        referrer: b.referrer,
        productDataRegions: b.productDataRegions,
        productEdition: b.productEdition
    };
};
const $dc3d3be87137607c$export$3761754c69bcbfc2 = (s)=>{
    return {
        searchQuery: s.searchQuery,
        originalQuery: s.originalQuery,
        resultsSort: s.resultsSort,
        filters: s.filters,
        selectedProducts: s.selectedProducts,
        selectedDatasource: s.selectedDatasource,
        jsmIncidentFilterIds: s.jsmIncidentFilterIds,
        paginationTokens: s.paginationTokens,
        availableProducts: s.availableProducts,
        requestId: s.requestId,
        traceId: s.traceId,
        cql: s.cql
    };
};



var $20r3r = parcelRequire("20r3r");
































parcelRequire("42omo");















/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




const $338fbb43846ae3b0$var$styles = {
    grid: "_2rko12b0 _1lmc1b06 _yv0e5lfm _1nmz1hna _bfhk19ip _19bvutpp _u5f3utpp _ca0qutpp _n3tdutpp"
};
const $338fbb43846ae3b0$export$c9c949013c9343de = ({ testId: testId, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d8SNb.default), {
        alignItems: "center",
        columnGap: "space.150",
        testId: testId,
        xcss: $338fbb43846ae3b0$var$styles.grid,
        children: children
    });
};





const $3f34d0c7590b02ef$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    dismissMessage: {
        id: "assets-app-message-banner-dismiss-message",
        defaultMessage: "Dismiss"
    },
    assetsAsAnAppBannerText: {
        id: "assets-app-message-banner-available-soon",
        defaultMessage: "<bold>Assets will be available here soon</bold>. For now, try <assetsSearchLink>Assets search</assetsSearchLink>."
    }
});


const $d7417ff36c8b22bc$export$8d42f71dae8efa55 = ({ testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $338fbb43846ae3b0$export$c9c949013c9343de), {
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                label: "information",
                color: "var(--ds-icon-brand)"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                space: "space.050",
                alignBlock: "center",
                shouldWrap: true,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    size: "medium",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...(0, $3f34d0c7590b02ef$export$defe85febe8b728c).assetsAsAnAppBannerText,
                        values: {
                            assetsSearchLink: (children)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                    href: "/jira/assets?showSearch=true",
                                    children: children
                                }),
                            bold: (children)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    weight: "bold",
                                    children: children
                                })
                        }
                    })
                })
            })
        ]
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









































const $dd6b7d3483332917$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    bannerText: {
        id: "new-product-message-banner-text",
        defaultMessage: "{product} was only recently added and we're still tweaking the results."
    },
    dismissMessage: {
        id: "new-product-message-banner-dismiss-message-button",
        defaultMessage: "Dismiss"
    }
});


const $c00f6725a09cf8c9$var$styles = {
    actions: "_i0dl1ns9",
    action: "_19bvutpp _u5f3utpp"
};
const $c00f6725a09cf8c9$var$newProducts = {
    [(0, $1yEFx.ProductKeys).Bitbucket]: 'Bitbucket',
    [(0, $1yEFx.ProductKeys).JiraProductDiscovery]: 'Jira Product Discovery',
    [(0, $1yEFx.ProductKeys).JiraServiceManagement]: 'Jira Service Management'
};
const $c00f6725a09cf8c9$export$37ce7744bd1ee394 = ({ searchQuery: searchQuery, selectedProduct: selectedProduct, selectedProducts: selectedProducts, primaryProduct: primaryProduct, cloudId: cloudId, experimentConfig: experimentConfig, user: user, applicationMode: applicationMode, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const [trackSearchQuery, setTrackSearchQuery] = (0, $42omo.useState)(searchQuery);
    const [showProductBanner, setShowProductBanner] = (0, $42omo.useState)({
        [(0, $1yEFx.ProductKeys).Bitbucket]: true,
        [(0, $1yEFx.ProductKeys).JiraProductDiscovery]: true,
        [(0, $1yEFx.ProductKeys).JiraServiceManagement]: true
    });
    (0, $42omo.useEffect)(()=>{
        // reset to default state
        if (searchQuery !== trackSearchQuery) {
            setShowProductBanner({
                [(0, $1yEFx.ProductKeys).Bitbucket]: true,
                [(0, $1yEFx.ProductKeys).JiraProductDiscovery]: true,
                [(0, $1yEFx.ProductKeys).JiraServiceManagement]: true
            });
            setTrackSearchQuery(searchQuery);
        }
    }, [
        searchQuery,
        trackSearchQuery
    ]);
    const onDismiss = ()=>{
        fireAnalyticsEvent((0, $e6f52813e1dbd344$export$975b2b7393cd0143)({
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
        setShowProductBanner((prev)=>({
                ...prev,
                [selectedProduct]: false
            }));
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: selectedProduct in showProductBanner && showProductBanner[selectedProduct] && /*#__PURE__*/ (0, $l998X.jsxs)((0, $338fbb43846ae3b0$export$c9c949013c9343de), {
            testId: testId,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                    label: "information",
                    color: "var(--ds-icon-brand)"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                    space: "space.050",
                    alignBlock: "center",
                    shouldWrap: true,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        size: "medium",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $dd6b7d3483332917$export$defe85febe8b728c).bannerText,
                            values: {
                                product: /*#__PURE__*/ (0, $l998X.jsx)("b", {
                                    children: $c00f6725a09cf8c9$var$newProducts[selectedProduct]
                                })
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    testId: testId && `${testId}--actions`,
                    space: "space.150",
                    rowSpace: "space.0",
                    alignBlock: "center",
                    xcss: $c00f6725a09cf8c9$var$styles.actions,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $c00f6725a09cf8c9$var$styles.action,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
                                section: "SearchPageNewProductMessageBanner",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cc710e5633c22833$export$2e2bcd8739ae039), {
                                    source: "search-page-new-product-banner",
                                    cloudId: cloudId || '',
                                    experimentConfig: experimentConfig,
                                    primaryProduct: primaryProduct,
                                    user: user,
                                    applicationMode: applicationMode,
                                    selectedProducts: selectedProducts,
                                    isCQL: commonAttributes.isCQL
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
                            onClick: onDismiss,
                            label: formatMessage((0, $dd6b7d3483332917$export$defe85febe8b728c).dismissMessage),
                            appearance: 'subtle',
                            spacing: 'compact'
                        })
                    ]
                })
            ]
        })
    });
};


/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ // Note: The above eslint-disable is needed because this module imports from parent directories.
// This is acceptable here as query-plan is tightly coupled to search-page-relay.




var $hL7bb = parcelRequire("hL7bb");

















var $2XqLN = parcelRequire("2XqLN");
















const $eb4a02b80e2ab764$export$3afecd2a83596299 = (appMode, isAdminHubAIEnabled, isRovoLLMEnabled)=>{
    // TODO: QS-6660 clean up the Unified Mode condition once it's decommissioned
    if (appMode === (0, $9vOy1.ApplicationModes).Unified) return isAdminHubAIEnabled;
    if ((0, $dh538.fg)('rovo_search_updated_entitlement_checks_for_team_25')) return isRovoLLMEnabled;
    return true;
};


function $63bf09322ac8b111$export$ccfe5b970c8b72a3(promise) {
    let isResolved = false;
    let isRejected = false;
    let cachedValue;
    // Create a new promise that tracks the resolution or rejection
    const trackedPromise = promise.then((value)=>{
        isResolved = true;
        cachedValue = value;
        return value;
    }, (reason)=>{
        isRejected = true;
        throw reason;
    });
    // Add methods to check the state
    trackedPromise.isResolved = ()=>isResolved;
    trackedPromise.isRejected = ()=>isRejected;
    trackedPromise.isSettled = ()=>isResolved || isRejected;
    // Add a method to get the cached value
    trackedPromise.getValue = ()=>cachedValue;
    return trackedPromise;
}
function $63bf09322ac8b111$export$aa6b1e6f46173ae2(fn) {
    return (...args)=>{
        const originalPromise = fn(...args);
        return $63bf09322ac8b111$export$ccfe5b970c8b72a3(originalPromise);
    };
}


const $126976b62166fe6c$export$1aafcd2cfb41dc92 = (0, $2XqLN.default)((0, $63bf09322ac8b111$export$aa6b1e6f46173ae2)((0, $l5Hqz.getLeapQuery)), (0, (/*@__PURE__*/$parcel$interopDefault($hL7bb))));
const $126976b62166fe6c$export$383dd888028aa640 = (appMode, isAdminHubAIEnabled, isRovoLLMEnabled)=>appMode === (0, $9vOy1.ApplicationModes).Rovo && (0, $eb4a02b80e2ab764$export$3afecd2a83596299)(appMode, isAdminHubAIEnabled, isRovoLLMEnabled);
const $126976b62166fe6c$export$d46c29e4fffab5ed = ({ searchQuery: searchQuery, primaryProduct: primaryProduct, isRovoEnabled: isRovoEnabled, isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled }, logError)=>{
    // load leap query if search query changes
    if (primaryProduct && searchQuery && $126976b62166fe6c$export$383dd888028aa640((0, $NwuTK.getApplicationMode)({
        isRovoEnabled: isRovoEnabled
    }), isAdminHubAIEnabled, isRovoLLMEnabled)) // Loading state handled in the LeapQuery component
    return $126976b62166fe6c$export$1aafcd2cfb41dc92({
        query: searchQuery,
        product: primaryProduct
    }).catch((e)=>{
        logError?.(e);
    });
};













const $40b6880ea7365c64$export$efc22d0a8971b841 = 60;
const $40b6880ea7365c64$export$96e202f323d22c8c = 24;
const $40b6880ea7365c64$export$2db639ca606fdc06 = (containerHeight)=>{
    // This formula comes from solving for x, where x is the number of results to show
    // containerHeight = x * MINIMUM_RESULT_HEIGHT_PX + (x - 1) * RESULT_GAP_PX
    // containerHeight = x * MINIMUM_RESULT_HEIGHT_PX + x * RESULT_GAP_PX - RESULT_GAP_PX
    // containerHeight + RESULT_GAP_PX = x * MINIMUM_RESULT_HEIGHT_PX + x * RESULT_GAP_PX
    // containerHeight + RESULT_GAP_PX = x * (MINIMUM_RESULT_HEIGHT_PX + RESULT_GAP_PX)
    // x = (containerHeight + RESULT_GAP_PX) / (MINIMUM_RESULT_HEIGHT_PX + RESULT_GAP_PX)
    return Math.ceil((containerHeight + $40b6880ea7365c64$export$96e202f323d22c8c) / ($40b6880ea7365c64$export$efc22d0a8971b841 + $40b6880ea7365c64$export$96e202f323d22c8c));
};



var $chwej = parcelRequire("chwej");




function $d0b07f1b6ca90690$export$1bb1cb0a9da0a635(bootstrap) {
    if ((0, $2OtFZ.serveRegionSteeringExperiment)()) {
        const edgeRegionHint = bootstrap.primaryProduct && bootstrap.productDataRegions ? (0, $chwej.getEdgeRegionHint)(bootstrap.primaryProduct, bootstrap.productDataRegions) : undefined;
        return {
            networkCacheConfig: {
                metadata: {
                    headers: {
                        'atl-edge-region-hint': edgeRegionHint
                    }
                }
            }
        };
    } else return undefined;
}





const $8a16a41870dcc4f0$export$68339b3094913cd4 = (availableProducts, selectedProduct, searchQuery = '')=>{
    const isSearchReady = availableProducts && availableProducts.length > 0;
    const isEmptyQuerySearchable = selectedProduct ? (0, $1yEFx.productsSupportingEmptyQuery).includes(selectedProduct) : false;
    const isEmptyQuery = !searchQuery || searchQuery.trim() === '';
    const isSearchable = isEmptyQuery && isEmptyQuerySearchable || !isEmptyQuery;
    return isSearchReady && isSearchable;
};


function $411ad342376b971d$export$87ba7e4f15231598(args) {
    // If bootstrap is not ready, we can only show config-loading skeletons.
    if (!args.bootstrapReady) return 'BOOTSTRAP_LOADING';
    // CQL is only used when there's no non-CQL query (searchQuery or selected filters takes precedence if either are present).
    const hasSearchQuery = args.searchQuery.trim() !== '';
    if (args.cql && !hasSearchQuery && !args.hasAnyFilterSelected) return 'CQL_RESULTS';
    // If the current search is valid, use results
    if ((0, $8a16a41870dcc4f0$export$68339b3094913cd4)(args.availableProducts, args.selectedProduct, args.searchQuery)) return 'RESULTS';
    // Fallback for invalid searches.
    return 'LANDING';
}















var $4cq9O = parcelRequire("4cq9O");











var $ci6Zg = parcelRequire("ci6Zg");











const $b949ab575c0025c4$export$a39eddd73bba62c1 = (bootstrap, search, _selectedInputFilters, overrideSearchSessionId)=>{
    const { cloudId: cloudId = '', primaryProduct: primaryProduct, thirdPartyConfigs: thirdPartyConfigs, experimentConfig: experimentConfig, products: products, allFilterExcludedProducts: allFilterExcludedProducts, productEdition: productEdition, productDataRegions: productDataRegions, isJiraIssueIndexed: isJiraIssueIndexed, user: user } = bootstrap;
    const { searchQuery: searchQuery, originalQuery: originalQuery, resultsSort: sort, filters: filters, selectedProducts: selectedProducts, selectedDatasource: selectedDatasource, jsmIncidentFilterIds: jsmIncidentFilterIds, paginationTokens: paginationTokens } = search;
    const searchSessionId = overrideSearchSessionId || bootstrap.searchSessionId;
    const fetchFromCursor = paginationTokens[0]?.cursor;
    const isEmptyQuery = !searchQuery || searchQuery.trim() === '';
    const availableProducts = products.filter(// If the query is empty, only some products are valid
    (product)=>!isEmptyQuery || (0, $1yEFx.productsSupportingEmptyQuery).includes(product));
    const { selectedFilters: selectedFilters, entities: entities, unselectedProductsThirdPartyFilters: unselectedProductsThirdPartyFilters, entitiesForResultsCountQuery: entitiesForResultsCountQuery } = (0, $4VkIo.getSelectedFilters)({
        filters: filters,
        selectedProducts: selectedProducts,
        selectedDatasource: selectedDatasource,
        availableProducts: products,
        allFilterExcludedProducts: allFilterExcludedProducts,
        thirdPartyConfigs: thirdPartyConfigs,
        jsmIncidentFilterIds: jsmIncidentFilterIds,
        currentUserId: user?.id
    });
    const backendExperiment = (0, $hm6w9.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $5XpfZ.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: (0, $4cq9O.SEARCH_PAGE),
        tenantId: cloudId,
        isJiraIssueIndexed: isJiraIssueIndexed,
        thirdPartyFilters: selectedFilters.thirdPartyFilters
    });
    const { experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers } = backendExperiment || {};
    const limit = entities.length === (0, $idpYy.getDefaultEntityAti)().length ? (0, $idpYy.RESULT_LIMIT_FOR_MULTIPLE_PRODUCTS) : (0, $idpYy.RESULT_LIMIT_FOR_SINGLE_PRODUCT);
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, jiraFilters: jiraFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, thirdPartyFilters: thirdPartyFilters, assetsFilters: assetsFilters, talentFilters: talentFilters } = selectedFilters;
    const sortVariables = sort.field === (0, $2zuvB.SORT_FIELD_KEY).RELEVANCE ? [] : [
        sort
    ];
    // If the original query param is present, we want to disable query replacement
    const disableQueryReplacement = !!originalQuery;
    const queryVersion = 1;
    const cloudIdARI = primaryProduct === (0, $1yEFx.PrimaryProductKeys).Jira && (0, $dh538.fg)('jira_site_ari_query_enabled') ? `ari:cloud:jira::site/${cloudId}` : `ari:cloud:confluence::site/${cloudId}`;
    const experience = (0, $4cq9O.SEARCH_PAGE);
    const tenantId = cloudId;
    const sessionId = (0, $a0M2t.getSessionIdFromLocalStorage)();
    const is3pGroupingEnabled = (0, $dh538.fg)('fps_3p_grouping_rollout_gate');
    (0, $8RFAN.serveFederatedSlackExperiment)(undefined, selectedProducts, {
        fireExperimentExposure: true
    }, thirdPartyConfigs);
    const fanoutExperimentCohort = (()=>{
        if (is3pGroupingEnabled === false) return selectedProducts.length === 0 ? 'boosted-and-smartlinks' : undefined;
        else return 'enable-v2';
    })();
    // To ensure rightPanel query matches as much as possible, we inherit+override both from shared variables
    const sharedQueryVariables = {
        cloudIdARI: cloudIdARI,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        entities: entities,
        experience: experience,
        jiraFilters: jiraFilters,
        limit: limit,
        mercuryFilters: mercuryFilters,
        compassFilters: compassFilters,
        query: searchQuery,
        queryVersion: queryVersion,
        searchSessionId: searchSessionId,
        sort: sortVariables,
        sourceProduct: primaryProduct,
        thirdPartyFilters: thirdPartyFilters,
        sessionId: sessionId,
        tenantId: tenantId,
        disableQueryReplacement: disableQueryReplacement,
        ...(0, $dh538.fg)('assets_rovo_search_all') ? {
            assetsFilters: assetsFilters
        } : {},
        ...(0, $dh538.fg)('talent_global_search') ? {
            talentFilters: talentFilters
        } : {}
    };
    const searchResultsQueryVariables = {
        ...sharedQueryVariables,
        // pagination is only valid for results
        after: fetchFromCursor,
        // highlighting is only useful for results
        enableHighlighting: true,
        experimentId: // Experimentation is only valid in results section. Note that experiments can differ based on selected entites/products, so if we include experiments in counts, the counts will change as filters change
        experimentId,
        experimentLayers: experimentLayers?.map(({ name: name, layerId: layerId, shadowId: shadowId, definitions: definitions })=>({
                name: name,
                layerId: layerId,
                shadowId: shadowId,
                definitions: definitions
            })),
        shadowExperimentId: shadowExperimentId,
        fanoutExperimentCohort: fanoutExperimentCohort,
        includeAssigneeField: (0, $dh538.fg)('rovo_search_assignee_field_fps'),
        includeAutoAppliedFilters: (0, $ci6Zg.serveAutoAppliedFiltersExperiment)(),
        includeIconUrl: (0, $dh538.fg)('rovo_search_confluence_icons_fps'),
        includePositions: (0, $dh538.fg)('talent_global_search'),
        includeThirdPartyId: (0, $2OtFZ.serve3PClickIngestionExperiment)(thirdPartyConfigs, {
            fireExperimentExposure: false
        }),
        includePassionfruitAsk: (0, $dh538.fg)('platform_passionfruit_search_onboarding_enabled'),
        includeNavBoostScore: (0, $dh538.fg)('kd_enable_nav_boost_score')
    };
    const rightPanelQueryVariables = {
        ...sharedQueryVariables,
        // Limit and sort are irrelevant for counts
        limit: 0,
        sort: [],
        // Counts searches for approx all entities (see getSelectedFilters for edge cases)
        entities: entitiesForResultsCountQuery,
        thirdPartyFilters: unselectedProductsThirdPartyFilters,
        // We need to search for all jira product types to support counts in Jira/JSM/JPD correctly
        jiraFilters: (0, $389fa27b7e70fb9c$export$62c31c0f13603e08)(jiraFilters, availableProducts)
    };
    return [
        searchResultsQueryVariables,
        rightPanelQueryVariables,
        backendExperiment
    ];
};


// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $cUcZ5 = parcelRequire("cUcZ5");


var $fXT59 = parcelRequire("fXT59");

const $8ec58c33150c42f9$export$e9ddc0ee913bbcbd = (0, $fXT59.disposableValue)();
// DJB2 hash function for JSON objects
function $8ec58c33150c42f9$var$hashJsonObjectDJB2(jsonObject) {
    // Convert the JSON object to a string
    const jsonString = JSON.stringify(jsonObject);
    // Initialize hash value
    let hash = 5381;
    // Iterate over each character in the string
    for(let i = 0; i < jsonString.length; i++){
        const char = jsonString.charCodeAt(i);
        hash = hash * 33 ^ char; // XOR and multiply by 33
    }
    // Ensure the hash is a positive 32-bit integer
    return (hash >>> 0).toString(16);
}
const $8ec58c33150c42f9$var$sessionIdsMap = new Map();
function $8ec58c33150c42f9$export$8b9832780ea0337b(variables) {
    if ($8ec58c33150c42f9$var$sessionIdsMap.size > 1000) $8ec58c33150c42f9$var$sessionIdsMap.clear();
    const { sessionId: sessionId, searchSessionId: searchSessionId, ...vars } = variables;
    const queryKey = $8ec58c33150c42f9$var$hashJsonObjectDJB2(vars);
    const existingSession = $8ec58c33150c42f9$var$sessionIdsMap.get(queryKey);
    if (existingSession) return existingSession;
    $8ec58c33150c42f9$var$sessionIdsMap.set(queryKey, [
        sessionId,
        searchSessionId
    ]);
    return [
        sessionId,
        searchSessionId
    ];
}
function $8ec58c33150c42f9$export$77a5fc99991cbb57() {
    $8ec58c33150c42f9$var$sessionIdsMap.clear();
}
const $8ec58c33150c42f9$export$966bb5e577b5d521 = (forceUpdate = false)=>{
    const sessionId = $8ec58c33150c42f9$export$e9ddc0ee913bbcbd.value();
    if (!sessionId || forceUpdate) // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    $8ec58c33150c42f9$export$e9ddc0ee913bbcbd.update((0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))());
};



/**
 * Common setup for search modes (RESULTS and CQL_RESULTS).
 * Handles task ID generation, analytics, error boundary reset, and scroll behavior.
 */ function $522e970424cd3461$var$setupSearchExecution({ onSearchStart: onSearchStart, resetErrorBoundary: resetErrorBoundary, setQueryUpdatedTime: setQueryUpdatedTime, bodyRef: bodyRef, setMaxResultsToShow: setMaxResultsToShow, cacheAvailable: cacheAvailable, isNetworkMode: isNetworkMode }) {
    // VitalStats: fires UX taskStart + Network taskStart (and superseded abort)
    // This also sets the UX task ID ref internally via context
    onSearchStart({
        cacheAvailable: cacheAvailable,
        isNetworkMode: isNetworkMode
    });
    // Reset error boundary and query timestamp
    resetErrorBoundary?.();
    setQueryUpdatedTime();
    // Scroll to top and update max results
    bodyRef.current?.scrollTo?.(0, 0);
    if ((0, $2OtFZ.serveSearchPageRenderingOptimisations)()) setMaxResultsToShow((0, $40b6880ea7365c64$export$2db639ca606fdc06)(window.innerHeight));
}
/**
 * Load LeapQuery as a non-CQL enhancement (errors are non-fatal and should not block results).
 */ function $522e970424cd3461$var$loadLeapQuery({ bootstrap: bootstrap, searchQuery: searchQuery, isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled, logError: logError }) {
    const { primaryProduct: primaryProduct, isRovoEnabled: isRovoEnabled } = bootstrap;
    if (primaryProduct && searchQuery && (0, $126976b62166fe6c$export$383dd888028aa640)((0, $NwuTK.getApplicationMode)({
        isRovoEnabled: isRovoEnabled
    }), isAdminHubAIEnabled, isRovoLLMEnabled)) // Loading state handled in the LeapQuery component.
    (0, $126976b62166fe6c$export$1aafcd2cfb41dc92)({
        query: searchQuery,
        product: primaryProduct
    }).catch((e)=>{
        logError(e);
    });
}
/**
 * Executes the query plan: loads/disposes queries, fires analytics, and updates state.
 * This is the single point where we orchestrate all query loading based on the derived mode.
 */ function $522e970424cd3461$var$executeQueryPlan({ plan: plan, loadSearchResultsQuery: loadSearchResultsQuery, loadRightPanelQuery: loadRightPanelQuery, loadSearchResultsCQLQuery: loadSearchResultsCQLQuery, disposeSearchResultsQuery: disposeSearchResultsQuery, disposeSearchResultsCQLQuery: disposeSearchResultsCQLQuery, disposeRightPanelQuery: disposeRightPanelQuery, setBootstrap: setBootstrap, setSearch: setSearch, setResultsState: setResultsState, resetErrorBoundary: resetErrorBoundary, setMaxResultsToShow: setMaxResultsToShow, bodyRef: bodyRef, backendExperimentRef: backendExperimentRef, vitalStats: vitalStats, isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled, logError: logError }) {
    const { mode: mode, bootstrap: bootstrap, search: search, selectedInputFilters: selectedInputFilters } = plan;
    const relayFetchOptions = (0, $d0b07f1b6ca90690$export$1bb1cb0a9da0a635)(bootstrap);
    // RESULTS: load results + counts + leapQuery; ensure CQL ref is disposed.
    if (mode === 'RESULTS') {
        disposeSearchResultsCQLQuery();
        const [searchResultsVars, rightPanelVars, backendExperiment] = (0, $b949ab575c0025c4$export$a39eddd73bba62c1)(bootstrap, search, selectedInputFilters);
        if (backendExperiment) backendExperimentRef.current = backendExperiment;
        // Hack to ensure sessionId/searchSessionId doesn't break the cache.
        const [sessionId, searchSessionId] = (0, $8ec58c33150c42f9$export$8b9832780ea0337b)(searchResultsVars);
        const searchResultsVarsWithSession = {
            ...searchResultsVars,
            sessionId: sessionId,
            searchSessionId: searchSessionId
        };
        const rightPanelVarsWithSession = {
            ...rightPanelVars,
            sessionId: sessionId,
            searchSessionId: searchSessionId
        };
        (0, $bVltF.searchResultsLoadUFOExperienceStart)();
        // Used for smart answers to track results state.
        setResultsState((0, $fZ3l2.ResultsStates).IS_LOADING);
        // Note: cacheAvailable is always false because Relay's store-or-network policy
        // always makes network requests. The label is kept for future use if we change fetch policy.
        const cacheAvailable = false;
        $522e970424cd3461$var$setupSearchExecution({
            onSearchStart: vitalStats.onSearchStart,
            resetErrorBoundary: resetErrorBoundary,
            setQueryUpdatedTime: $20r3r.setQueryUpdatedTime,
            bodyRef: bodyRef,
            setMaxResultsToShow: setMaxResultsToShow,
            cacheAvailable: cacheAvailable,
            isNetworkMode: true
        });
        loadSearchResultsQuery(searchResultsVarsWithSession, relayFetchOptions);
        loadRightPanelQuery(rightPanelVarsWithSession, relayFetchOptions);
        // Load LeapQuery after kicking off the core queries.
        $522e970424cd3461$var$loadLeapQuery({
            bootstrap: bootstrap,
            searchQuery: search.searchQuery,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            isRovoLLMEnabled: isRovoLLMEnabled,
            logError: logError
        });
    }
    // CQL_RESULTS: load CQL results; ensure non-CQL refs are disposed.
    if (mode === 'CQL_RESULTS') {
        disposeRightPanelQuery();
        disposeSearchResultsQuery();
        $522e970424cd3461$var$setupSearchExecution({
            onSearchStart: vitalStats.onSearchStart,
            resetErrorBoundary: resetErrorBoundary,
            setQueryUpdatedTime: $20r3r.setQueryUpdatedTime,
            bodyRef: bodyRef,
            setMaxResultsToShow: setMaxResultsToShow,
            cacheAvailable: false,
            isNetworkMode: false
        });
        // `mode` guarantees cql exists here.
        loadSearchResultsCQLQuery({
            cql: search.cql,
            first: 30,
            after: null
        }, relayFetchOptions);
    }
    // LANDING: invalidate all query refs so stale results can't render/suspend.
    if (mode === 'LANDING') {
        disposeSearchResultsQuery();
        disposeRightPanelQuery();
        disposeSearchResultsCQLQuery();
    }
    // Keep local mirrors in sync for rendering.
    setSearch(search);
    setBootstrap(bootstrap);
}
function $522e970424cd3461$export$68c6db5b1ec6ba65({ loadSearchResultsQuery: loadSearchResultsQuery, disposeSearchResultsQuery: disposeSearchResultsQuery, loadRightPanelQuery: loadRightPanelQuery, disposeRightPanelQuery: disposeRightPanelQuery, loadSearchResultsCQLQuery: loadSearchResultsCQLQuery, disposeSearchResultsCQLQuery: disposeSearchResultsCQLQuery, setBootstrap: setBootstrap, setSearch: setSearch, setResultsState: setResultsState, resetErrorBoundary: resetErrorBoundary, bodyRef: bodyRef, setMaxResultsToShow: setMaxResultsToShow, backendExperimentRef: backendExperimentRef, isAdminHubAIEnabled: isAdminHubAIEnabled = false, isRovoLLMEnabled: isRovoLLMEnabled = false, logError: logError }) {
    const vitalStats = (0, $3f9016d1e452d4e9$export$586800522161402)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const search = (0, $djVCD.useSearchState)((0, $dc3d3be87137607c$export$3761754c69bcbfc2));
    const bootstrap = (0, $4Qo4W.useBootstrapState)((0, $dc3d3be87137607c$export$cfd0a4eecdb5b49d));
    const [selectedInputFilters] = (0, $25a8b9613a265659$export$5a795cafef59146c)();
    const bootstrapReady = search.availableProducts.length > 0;
    const hasAnyFilterSelected = Boolean(search.selectedProducts[0]) || Object.values(search.filters).some((filter)=>filter?.hasSelection);
    const mode = (0, $411ad342376b971d$export$87ba7e4f15231598)({
        bootstrapReady: bootstrapReady,
        availableProducts: search.availableProducts,
        selectedProduct: search.selectedProducts[0],
        searchQuery: search.searchQuery,
        hasAnyFilterSelected: hasAnyFilterSelected,
        cql: search.cql
    });
    const previousPlanRef = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        if (!bootstrapReady) return;
        const nextPlan = {
            mode: mode,
            bootstrap: bootstrap,
            search: search,
            selectedInputFilters: selectedInputFilters
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hL7bb)))(previousPlanRef.current, nextPlan)) return;
        previousPlanRef.current = nextPlan;
        $522e970424cd3461$var$executeQueryPlan({
            plan: nextPlan,
            loadSearchResultsQuery: loadSearchResultsQuery,
            loadRightPanelQuery: loadRightPanelQuery,
            loadSearchResultsCQLQuery: loadSearchResultsCQLQuery,
            disposeSearchResultsQuery: disposeSearchResultsQuery,
            disposeSearchResultsCQLQuery: disposeSearchResultsCQLQuery,
            disposeRightPanelQuery: disposeRightPanelQuery,
            setBootstrap: setBootstrap,
            setSearch: setSearch,
            setResultsState: setResultsState,
            resetErrorBoundary: resetErrorBoundary,
            setMaxResultsToShow: setMaxResultsToShow,
            bodyRef: bodyRef,
            backendExperimentRef: backendExperimentRef,
            vitalStats: vitalStats,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            isRovoLLMEnabled: isRovoLLMEnabled,
            logError: logError
        });
    }, [
        bootstrap,
        search,
        selectedInputFilters,
        bootstrapReady,
        mode,
        loadSearchResultsQuery,
        loadRightPanelQuery,
        loadSearchResultsCQLQuery,
        disposeSearchResultsQuery,
        disposeSearchResultsCQLQuery,
        disposeRightPanelQuery,
        setBootstrap,
        setSearch,
        setResultsState,
        resetErrorBoundary,
        setMaxResultsToShow,
        bodyRef,
        backendExperimentRef,
        vitalStats,
        isAdminHubAIEnabled,
        isRovoLLMEnabled,
        logError
    ]);
    return {
        mode: mode,
        bootstrap: bootstrap,
        search: search,
        selectedInputFilters: selectedInputFilters
    };
}
function $522e970424cd3461$export$d152b66e844f2488(args) {
    $522e970424cd3461$export$68c6db5b1ec6ba65(args);
    return null;
}





/**
 * @generated SignedSource<<a826bdd0117d75e8c77d5e8eec3cd7b8>>
 * @relayHash 75ec887ee22b87fff1e6a8cbc04f765f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f711da52c9d546b458e4081e59e2519ac2fbf265affee91689828bfddb8494fc
const $71b133da64a47244$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "assetsFilters"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudIdARI"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commonFilters"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "compassFilters"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "confluenceFilters"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "disableQueryReplacement"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entities"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experience"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experimentId"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experimentLayers"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraFilters"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "mercuryFilters"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "query"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryVersion"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchSessionId"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sessionId"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shadowExperimentId"
    }, v18 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sort"
    }, v19 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceProduct"
    }, v20 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "talentFilters"
    }, v21 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "thirdPartyFilters"
    }, v22 = [
        {
            "concreteType": "SearchQueryAPI",
            "kind": "LinkedField",
            "name": "search",
            "plural": false,
            "selections": [
                {
                    "alias": "results",
                    "args": [
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "queryVersion",
                                    "variableName": "queryVersion"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "searchSessionId",
                                    "variableName": "searchSessionId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "sessionId",
                                    "variableName": "sessionId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "sourceProduct",
                                    "variableName": "sourceProduct"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "analytics"
                        },
                        {
                            "kind": "Variable",
                            "name": "disableQueryReplacement",
                            "variableName": "disableQueryReplacement"
                        },
                        {
                            "kind": "Variable",
                            "name": "experience",
                            "variableName": "experience"
                        },
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "experimentId",
                                    "variableName": "experimentId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "experimentLayers",
                                    "variableName": "experimentLayers"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "shadowExperimentId",
                                    "variableName": "shadowExperimentId"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "experimentContext"
                        },
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "assetsFilters",
                                    "variableName": "assetsFilters"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "commonFilters",
                                    "variableName": "commonFilters"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "compassFilters",
                                    "variableName": "compassFilters"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "confluenceFilters",
                                    "variableName": "confluenceFilters"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "entities",
                                    "variableName": "entities"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "jiraFilters",
                                    "variableName": "jiraFilters"
                                },
                                {
                                    "items": [
                                        {
                                            "kind": "Variable",
                                            "name": "locations.0",
                                            "variableName": "cloudIdARI"
                                        }
                                    ],
                                    "kind": "ListValue",
                                    "name": "locations"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "mercuryFilters",
                                    "variableName": "mercuryFilters"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "talentFilters",
                                    "variableName": "talentFilters"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "thirdPartyFilters",
                                    "variableName": "thirdPartyFilters"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "filters"
                        },
                        {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "limit"
                        },
                        {
                            "kind": "Variable",
                            "name": "query",
                            "variableName": "query"
                        },
                        {
                            "kind": "Variable",
                            "name": "sort",
                            "variableName": "sort"
                        }
                    ],
                    "concreteType": "SearchItemConnection",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SearchProductCount",
                            "kind": "LinkedField",
                            "name": "totalCounts",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "product"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "count"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "rightPanelQuery",
            "selections": v22 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v13 /*: any*/ ,
                v1 /*: any*/ ,
                v11 /*: any*/ ,
                v6 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v10 /*: any*/ ,
                v0 /*: any*/ ,
                v12 /*: any*/ ,
                v20 /*: any*/ ,
                v3 /*: any*/ ,
                v21 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v8 /*: any*/ ,
                v17 /*: any*/ ,
                v9 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "rightPanelQuery",
            "selections": v22 /*: any*/ 
        },
        "params": {
            "id": "f711da52c9d546b458e4081e59e2519ac2fbf265affee91689828bfddb8494fc",
            "metadata": {},
            "name": "rightPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$71b133da64a47244$var$node.hash = "3e753a7ad74216369453ac3610b91186";
var $71b133da64a47244$export$2e2bcd8739ae039 = $71b133da64a47244$var$node;























































const $73bb113f5f79cbc2$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    groupLabel: {
        id: "search-page.app-filter-sidebar.group",
        defaultMessage: "Filter search by app"
    }
});


const $7cc050d1a4a09085$export$98c4d2ac9cd9730 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $5e9cfc142ef96d2f$export$f39f3f768bc98e3d), {
        ariaLabel: formatMessage((0, $73bb113f5f79cbc2$export$defe85febe8b728c).groupLabel),
        "data-testid": "app-filter-sidebar-loading",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1ee81a6dccb3a778$export$c597ff09df837ae9), {})
    });
};
const $7cc050d1a4a09085$export$364a989a35814102 = ({ data: data, cloudId: cloudId, searchQuery: searchQuery, primaryProduct: primaryProduct, experimentConfig: experimentConfig, selectedProducts: selectedProducts, user: user, appMode: appMode, thirdPartyConfigs: thirdPartyConfigs, availableProducts: availableProducts, availableNouns: availableNouns, selectedProduct: selectedProduct, selectedDatasource: selectedDatasource, isNounsAvailable: isNounsAvailable = false, federatedSlackCount: federatedSlackCount, federatedOutlookMailCount: federatedOutlookMailCount, personalisedProductSections: personalisedProductSections, setPersonalisedProductSections: setPersonalisedProductSections, productsWithTimeout: productsWithTimeout, resultCountsLoading: resultCountsLoading })=>{
    (0, $42omo.useEffect)(()=>{
        (0, $2OtFZ.serveNounResultCounts)(true);
        (0, $2OtFZ.serveWebPagesInTypeFilter)(true);
    }, []);
    const totalCounts = data?.search?.results?.totalCounts;
    const productResultCountMap = (0, $42omo.useMemo)(()=>{
        if (!totalCounts) return {};
        const countMap = totalCounts.reduce((prev, { product: product, count: count })=>({
                ...prev,
                [product]: count
            }), {});
        // the backend returns townsquare-goals and townsquare-projects but the
        // frontend expects goal and project, so we need to map them here.
        if ((0, $2OtFZ.serveNounResultCounts)()) {
            if ('townsquare-goal' in countMap) {
                countMap['goal'] = countMap['townsquare-goal'];
                delete countMap['townsquare-goal'];
            }
            if ('townsquare-project' in countMap) {
                countMap['project'] = countMap['townsquare-project'];
                delete countMap['townsquare-project'];
            }
        }
        // Combine passionfruit counts with mercury (Focus product)
        if ('passionfruit' in countMap && (0, $dh538.fg)('platform_passionfruit_search_onboarding_enabled')) {
            countMap['mercury'] = countMap['mercury'] + countMap['passionfruit'];
            delete countMap['passionfruit'];
        }
        // Special handling for Slack: use federatedSlackCount when available
        const isSlackFederatedSearchEnabled = (0, $8RFAN.serveFederatedSlackExperiment)(selectedProduct, undefined, {
            fireExperimentExposure: false
        }, thirdPartyConfigs) || (0, $dh538.fg)('ai_3p_slack_federated_search_enabled');
        if (federatedSlackCount !== null && federatedSlackCount !== undefined && 'slack' in countMap && isSlackFederatedSearchEnabled) countMap['slack'] = federatedSlackCount;
        // Special handling for Outlook Mail: use federatedOutlookMailCount when available
        if (federatedOutlookMailCount !== null && federatedOutlookMailCount !== undefined && 'outlook-mail' in countMap) countMap['outlook-mail'] = federatedOutlookMailCount;
        return countMap;
    }, [
        totalCounts,
        federatedSlackCount,
        federatedOutlookMailCount,
        selectedProduct,
        thirdPartyConfigs
    ]);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { selectProductFilter: selectProductFilter, unselectProductFilter: unselectProductFilter, unsafe_setAtlasNouns: unsafe_setAtlasNouns, unsafe_setWebPageType: unsafe_setWebPageType } = (0, $djVCD.useSearchActions)();
    const intercom = (0, $9afb3d504f643405$export$f0fed4b0765d7314)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const [universalTypeFilterData] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $5iakG.universalTypeFilterId)
    });
    const [filters, { setFilterHidden: setFilterHidden }] = (0, $ab2e247364ac3575$export$bfc9fede3294c124)();
    const { recommended3pApps: recommended3pApps } = (0, $2a8d6d6445842483$export$a718b8eb2c469b45)({
        userId: user?.id,
        showRecommendations: (0, $2OtFZ.serveRightRailRecommendationsImprovementsWithExposure)()
    });
    (0, $ab2e247364ac3575$export$e594597d68c75e56)({
        thirdPartyConfigs: thirdPartyConfigs,
        storedState: filters,
        setFilterHidden: setFilterHidden
    });
    // In the prequery state (aka initial state), there is no data from the query
    const isInitialState = !data;
    const appFilterProps = (0, $42omo.useMemo)(()=>({
            searchQuery: searchQuery,
            thirdPartyConfigs: thirdPartyConfigs,
            availableProducts: availableProducts,
            availableNouns: availableNouns,
            selectedProduct: selectedProduct,
            selectedDatasource: selectedDatasource,
            isNounsAvailable: isNounsAvailable,
            primaryProduct: primaryProduct,
            filterData: universalTypeFilterData,
            setAtlasNoun: unsafe_setAtlasNouns,
            setWebPageType: unsafe_setWebPageType,
            onSelectProduct: (newProduct, datasource)=>{
                if (!newProduct && selectedProduct) {
                    unselectProductFilter();
                    return;
                } else {
                    selectProductFilter(newProduct, datasource);
                    if (newProduct && (0, $1yEFx.is3pProductKey)(newProduct)) intercom?.trackEvent('product_filter_clicked_3p', {
                        product_filter: newProduct
                    });
                    else intercom?.trackEvent('product_filter_clicked', {
                        product_filter: newProduct
                    });
                }
            },
            productResultCountMap: productResultCountMap ?? {},
            sidebarStoredState: filters,
            onFilterHide: (productKey)=>{
                setFilterHidden(productKey, true);
                fireAnalyticsEvent((0, $871ab8347ae20fda$export$99516ac3f2ff068f)({
                    commonAttributes: commonAttributes,
                    nonPrivacySafeAttributes: nonPrivacySafeAttributes,
                    productKey: productKey,
                    hidden: true
                }));
            },
            onFilterShow: (productKey)=>{
                setFilterHidden(productKey, false);
                fireAnalyticsEvent((0, $871ab8347ae20fda$export$99516ac3f2ff068f)({
                    commonAttributes: commonAttributes,
                    nonPrivacySafeAttributes: nonPrivacySafeAttributes,
                    productKey: productKey,
                    hidden: false
                }));
            },
            useOAuthHandlers: $gGFxq.useOAuthHandlers,
            useIsUserOAuthed: $gGFxq.useIsUserOAuthed,
            ErrorBoundary: $1nJM3.ErrorBoundary,
            isInitialState: isInitialState,
            recommended3pApps: recommended3pApps,
            onVisibleProductsToAuthShown: (0, $4b4d6fff8ba3907a$export$eabd66cde5dba12f),
            personalisedProductSections: personalisedProductSections,
            setPersonalisedProductSections: setPersonalisedProductSections,
            productsWithTimeout: productsWithTimeout,
            resultCountsLoading: resultCountsLoading
        }), [
        availableProducts,
        availableNouns,
        selectedProduct,
        selectedDatasource,
        unselectProductFilter,
        selectProductFilter,
        unsafe_setWebPageType,
        intercom,
        isNounsAvailable,
        universalTypeFilterData,
        unsafe_setAtlasNouns,
        productResultCountMap,
        filters,
        setFilterHidden,
        thirdPartyConfigs,
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes,
        searchQuery,
        primaryProduct,
        isInitialState,
        recommended3pApps,
        personalisedProductSections,
        setPersonalisedProductSections,
        productsWithTimeout,
        resultCountsLoading
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $5e9cfc142ef96d2f$export$f39f3f768bc98e3d), {
        ariaLabel: formatMessage((0, $73bb113f5f79cbc2$export$defe85febe8b728c).groupLabel),
        "data-testid": "app-filter-sidebar",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $b0ebf52c770dccf7$export$8316e1225e2e8973), {
                fireAnalyticsEvent: fireAnalyticsEvent
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
                section: "SearchPageAppFilter",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ecaec232d474cc0a$export$ca41603276fc834c), {
                    ...appFilterProps
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5c2e577797240fed$export$ea8986aeb9fc460a), {
                ...appFilterProps,
                onSelectProduct: (newProduct, datasource)=>{
                    if (!newProduct && selectedProduct) {
                        unselectProductFilter();
                        return;
                    } else {
                        selectProductFilter(newProduct, datasource);
                        if (newProduct && (0, $1yEFx.is3pProductKey)(newProduct)) intercom?.trackEvent('product_filter_clicked_3p', {
                            product_filter: newProduct
                        });
                        else intercom?.trackEvent('product_filter_clicked', {
                            product_filter: newProduct
                        });
                    }
                }
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f007caa1e941263$export$ae377d31562bc30), {
                cloudId: cloudId,
                primaryProduct: primaryProduct,
                experimentConfig: experimentConfig,
                selectedProducts: selectedProducts,
                user: user,
                appMode: appMode,
                isCQL: commonAttributes.isCQL
            })
        ]
    });
};
const $7cc050d1a4a09085$export$e37cfb5282d612c2 = ({ rightPanelQuery: rightPanelQuery, ...props })=>{
    const queryData = (0, $irOoi.usePreloadedQuery)((0, $71b133da64a47244$export$2e2bcd8739ae039), rightPanelQuery);
    return /*#__PURE__*/ (0, $l998X.jsx)($7cc050d1a4a09085$export$364a989a35814102, {
        ...props,
        data: queryData
    });
};




var $atY36 = parcelRequire("atY36");


var $7Ngf7 = parcelRequire("7Ngf7");




/**
 * @generated SignedSource<<e4ea9e0b51d9bfff5411e2b9c1309d80>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
/**
 * @generated SignedSource<<88b60711bc4f275424712b132bd017b6>>
 * @relayHash f575dc64545fb876bfc33782ac2e4fd6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 32474d1e52ea5c2cf4b07a58f58a362ee7c0df1ae703a8f5d1f5820e1daef329

var $5SuoG = parcelRequire("5SuoG");


var $aqtD4 = parcelRequire("aqtD4");


var $4PNBt = parcelRequire("4PNBt");


var $jYilw = parcelRequire("jYilw");

const $05232064a3df46d5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "assetsFilters"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudIdARI"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commonFilters"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "compassFilters"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "confluenceFilters"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "disableQueryReplacement"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "enableHighlighting"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entities"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experience"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experimentId"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experimentLayers"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fanoutExperimentCohort"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeAssets"
    }, v14 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeAssigneeField"
    }, v15 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeAutoAppliedFilters"
    }, v16 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeIconUrl"
    }, v17 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeNavBoostScore"
    }, v18 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includePassionfruitAsk"
    }, v19 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includePositions"
    }, v20 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeThirdPartyId"
    }, v21 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraFilters"
    }, v22 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v23 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "mercuryFilters"
    }, v24 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "query"
    }, v25 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryVersion"
    }, v26 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchSessionId"
    }, v27 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sessionId"
    }, v28 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shadowExperimentId"
    }, v29 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sort"
    }, v30 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceProduct"
    }, v31 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "talentFilters"
    }, v32 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "tenantId"
    }, v33 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "thirdPartyFilters"
    }, v34 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "queryVersion",
                    "variableName": "queryVersion"
                },
                {
                    "kind": "Variable",
                    "name": "searchSessionId",
                    "variableName": "searchSessionId"
                },
                {
                    "kind": "Variable",
                    "name": "sessionId",
                    "variableName": "sessionId"
                },
                {
                    "kind": "Variable",
                    "name": "sourceProduct",
                    "variableName": "sourceProduct"
                }
            ],
            "kind": "ObjectValue",
            "name": "analytics"
        },
        {
            "kind": "Variable",
            "name": "disableQueryReplacement",
            "variableName": "disableQueryReplacement"
        },
        {
            "kind": "Variable",
            "name": "enableHighlighting",
            "variableName": "enableHighlighting"
        },
        {
            "kind": "Variable",
            "name": "experience",
            "variableName": "experience"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "experimentId",
                    "variableName": "experimentId"
                },
                {
                    "kind": "Variable",
                    "name": "experimentLayers",
                    "variableName": "experimentLayers"
                },
                {
                    "kind": "Variable",
                    "name": "shadowExperimentId",
                    "variableName": "shadowExperimentId"
                }
            ],
            "kind": "ObjectValue",
            "name": "experimentContext"
        },
        {
            "kind": "Variable",
            "name": "fanoutExperimentCohort",
            "variableName": "fanoutExperimentCohort"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "assetsFilters",
                    "variableName": "assetsFilters"
                },
                {
                    "kind": "Variable",
                    "name": "commonFilters",
                    "variableName": "commonFilters"
                },
                {
                    "kind": "Variable",
                    "name": "compassFilters",
                    "variableName": "compassFilters"
                },
                {
                    "kind": "Variable",
                    "name": "confluenceFilters",
                    "variableName": "confluenceFilters"
                },
                {
                    "kind": "Variable",
                    "name": "entities",
                    "variableName": "entities"
                },
                {
                    "kind": "Variable",
                    "name": "jiraFilters",
                    "variableName": "jiraFilters"
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "locations.0",
                            "variableName": "cloudIdARI"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "locations"
                },
                {
                    "kind": "Variable",
                    "name": "mercuryFilters",
                    "variableName": "mercuryFilters"
                },
                {
                    "kind": "Variable",
                    "name": "talentFilters",
                    "variableName": "talentFilters"
                },
                {
                    "kind": "Variable",
                    "name": "thirdPartyFilters",
                    "variableName": "thirdPartyFilters"
                }
            ],
            "kind": "ObjectValue",
            "name": "filters"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
        },
        {
            "kind": "Variable",
            "name": "sort",
            "variableName": "sort"
        }
    ], v35 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v36 = {
        "kind": "ScalarField",
        "name": "id"
    }, v37 = {
        "kind": "ScalarField",
        "name": "description"
    }, v38 = {
        "kind": "ScalarField",
        "name": "connectorType"
    }, v39 = {
        "kind": "ScalarField",
        "name": "title"
    }, v40 = {
        "kind": "ScalarField",
        "name": "url"
    }, v41 = {
        "kind": "ScalarField",
        "name": "type"
    }, v42 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    }, v43 = {
        "kind": "ScalarField",
        "name": "subtype"
    }, v44 = {
        "kind": "ScalarField",
        "name": "integrationId"
    }, v45 = {
        "kind": "ScalarField",
        "name": "providerId"
    }, v46 = {
        "kind": "ScalarField",
        "name": "value"
    }, v47 = {
        "kind": "ScalarField",
        "name": "label"
    }, v48 = [
        v47 /*: any*/ 
    ], v49 = {
        "kind": "ScalarField",
        "name": "key"
    }, v50 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v51 = [
        v50 /*: any*/ 
    ], v52 = {
        "condition": "includeIconUrl",
        "kind": "Condition",
        "passingValue": true,
        "selections": v51 /*: any*/ 
    }, v53 = {
        "kind": "ScalarField",
        "name": "name"
    }, v54 = [
        v53 /*: any*/ 
    ], v55 = {
        "kind": "ScalarField",
        "name": "lastModified"
    }, v56 = {
        "kind": "ScalarField",
        "name": "total"
    }, v57 = {
        "kind": "InlineFragment",
        "selections": [
            v36 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v58 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v59 = {
        "kind": "ScalarField",
        "name": "email"
    }, v60 = [
        {
            "kind": "ScalarField",
            "name": "jobTitle"
        }
    ], v61 = {
        "args": [
            {
                "kind": "Variable",
                "name": "tenantId",
                "variableName": "tenantId"
            }
        ],
        "concreteType": "SocialSignalSearch",
        "kind": "LinkedField",
        "name": "socialSignal",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "signal"
            },
            {
                "kind": "ScalarField",
                "name": "timestamp"
            },
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v35 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v53 /*: any*/ ,
                    v58 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v59 /*: any*/ ,
                            {
                                "concreteType": "AtlassianAccountUserExtendedProfile",
                                "kind": "LinkedField",
                                "name": "extendedProfile",
                                "plural": false,
                                "selections": v60 /*: any*/ 
                            }
                        ],
                        "type": "AtlassianAccountUser"
                    },
                    v36 /*: any*/ 
                ]
            }
        ]
    }, v62 = {
        "kind": "LinkedField",
        "name": "container",
        "plural": false,
        "selections": [
            v35 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v54 /*: any*/ ,
                "type": "ExternalRepository"
            },
            v57 /*: any*/ 
        ]
    }, v63 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v64 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            v35 /*: any*/ ,
            v53 /*: any*/ ,
            v58 /*: any*/ ,
            v36 /*: any*/ 
        ]
    }, v65 = {
        "kind": "LinkedField",
        "name": "container",
        "plural": false,
        "selections": [
            v35 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    v63 /*: any*/ ,
                    v40 /*: any*/ 
                ],
                "type": "ExternalSpace"
            },
            v57 /*: any*/ 
        ]
    }, v66 = {
        "kind": "ScalarField",
        "name": "externalId"
    }, v67 = {
        "kind": "ScalarField",
        "name": "nickname"
    }, v68 = {
        "concreteType": "ThirdPartyUserExtendedProfile",
        "kind": "LinkedField",
        "name": "extendedProfile",
        "plural": false,
        "selections": v60 /*: any*/ 
    }, v69 = [
        v66 /*: any*/ ,
        v53 /*: any*/ ,
        v67 /*: any*/ ,
        v59 /*: any*/ ,
        v58 /*: any*/ ,
        v68 /*: any*/ ,
        v36 /*: any*/ 
    ], v70 = {
        "concreteType": "ExternalAssociationConnection",
        "kind": "LinkedField",
        "name": "associatedWith",
        "plural": false,
        "selections": [
            {
                "concreteType": "ExternalAssociationEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "ExternalAssociation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "entity",
                                "plural": false,
                                "selections": [
                                    v35 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": v69 /*: any*/ ,
                                        "type": "ThirdPartyUser"
                                    },
                                    v57 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "alias": "channelId",
                                                "kind": "ScalarField",
                                                "name": "externalId"
                                            },
                                            v63 /*: any*/ 
                                        ],
                                        "type": "ExternalConversation"
                                    }
                                ]
                            },
                            v36 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v71 = {
        "kind": "ScalarField",
        "name": "thumbnailUrl"
    }, v72 = [
        v36 /*: any*/ ,
        v53 /*: any*/ ,
        v59 /*: any*/ ,
        v58 /*: any*/ ,
        v66 /*: any*/ ,
        v68 /*: any*/ 
    ], v73 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": [
            {
                "concreteType": "ThirdPartyUser",
                "kind": "LinkedField",
                "name": "thirdPartyUser",
                "plural": false,
                "selections": v72 /*: any*/ 
            }
        ]
    }, v74 = [
        v36 /*: any*/ ,
        v53 /*: any*/ 
    ], v75 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "thirdPartyUser",
        "plural": false,
        "selections": v74 /*: any*/ 
    }, v76 = [
        v75 /*: any*/ 
    ], v77 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "members",
        "plural": true,
        "selections": v76 /*: any*/ 
    }, v78 = {
        "kind": "ScalarField",
        "name": "memberCount"
    }, v79 = [
        v53 /*: any*/ ,
        v36 /*: any*/ 
    ], v80 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "owners",
        "plural": true,
        "selections": [
            {
                "concreteType": "ThirdPartyUser",
                "kind": "LinkedField",
                "name": "thirdPartyUser",
                "plural": false,
                "selections": v79 /*: any*/ 
            }
        ]
    }, v81 = [
        v80 /*: any*/ 
    ], v82 = {
        "kind": "LinkedField",
        "name": "parent",
        "plural": false,
        "selections": [
            v35 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    v36 /*: any*/ ,
                    v63 /*: any*/ 
                ],
                "type": "ExternalCustomerOrg"
            },
            v57 /*: any*/ 
        ]
    }, v83 = [
        {
            "kind": "ScalarField",
            "name": "lastActivityAt"
        },
        {
            "kind": "ScalarField",
            "name": "event"
        }
    ], v84 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "assignee",
        "plural": false,
        "selections": v76 /*: any*/ 
    }, v85 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": v76 /*: any*/ 
    }, v86 = {
        "kind": "ScalarField",
        "name": "dueDate"
    }, v87 = {
        "kind": "ScalarField",
        "name": "status"
    }, v88 = {
        "condition": "__relay_internal__pv__jsmdcenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "container",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v43 /*: any*/ 
                        ],
                        "type": "ExternalSpace"
                    }
                ]
            }
        ]
    }, v89 = [
        v35 /*: any*/ ,
        v53 /*: any*/ ,
        v36 /*: any*/ 
    ], v90 = {
        "kind": "ScalarField",
        "name": "workspaceName"
    }, v91 = {
        "kind": "ScalarField",
        "name": "excerpt"
    }, v92 = {
        "kind": "ScalarField",
        "name": "eventEndTime"
    }, v93 = {
        "kind": "ScalarField",
        "name": "eventStartTime"
    }, v94 = {
        "kind": "ScalarField",
        "name": "videoMeetingUrl"
    }, v95 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "initialContributors",
        "plural": true,
        "selections": v72 /*: any*/ 
    }, v96 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "allContributors",
        "plural": true,
        "selections": v69 /*: any*/ 
    }, v97 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "allContributors",
        "plural": true,
        "selections": [
            v53 /*: any*/ ,
            v67 /*: any*/ ,
            v59 /*: any*/ ,
            v58 /*: any*/ ,
            v66 /*: any*/ ,
            v68 /*: any*/ ,
            v36 /*: any*/ 
        ]
    }, v98 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v99 = [
        v42 /*: any*/ ,
        v50 /*: any*/ 
    ], v100 = [
        v42 /*: any*/ 
    ], v101 = {
        "concreteType": "AssetsLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "web"
            }
        ]
    }, v102 = {
        "concreteType": "AssetsSchema",
        "kind": "LinkedField",
        "name": "objectSchemaEntity",
        "plural": false,
        "selections": v79 /*: any*/ 
    }, v103 = [
        {
            "kind": "ScalarField",
            "name": "url48"
        }
    ], v104 = [
        v49 /*: any*/ ,
        v36 /*: any*/ 
    ], v105 = {
        "kind": "ScalarField",
        "name": "combination"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                v25 /*: any*/ ,
                v26 /*: any*/ ,
                v27 /*: any*/ ,
                v28 /*: any*/ ,
                v29 /*: any*/ ,
                v30 /*: any*/ ,
                v31 /*: any*/ ,
                v32 /*: any*/ ,
                v33 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SearchResultsPaginationQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "includeAssigneeField",
                            "variableName": "includeAssigneeField"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeAutoAppliedFilters",
                            "variableName": "includeAutoAppliedFilters"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeIconUrl",
                            "variableName": "includeIconUrl"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeNavBoostScore",
                            "variableName": "includeNavBoostScore"
                        },
                        {
                            "kind": "Variable",
                            "name": "includePassionfruitAsk",
                            "variableName": "includePassionfruitAsk"
                        },
                        {
                            "kind": "Variable",
                            "name": "includePositions",
                            "variableName": "includePositions"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeThirdPartyId",
                            "variableName": "includeThirdPartyId"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "searchResults_AtlassianSearchPage"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                v25 /*: any*/ ,
                v26 /*: any*/ ,
                v27 /*: any*/ ,
                v28 /*: any*/ ,
                v29 /*: any*/ ,
                v30 /*: any*/ ,
                v31 /*: any*/ ,
                v32 /*: any*/ ,
                v33 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__isassetsenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__isdealownersenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__jsmdcenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "SearchResultsPaginationQuery",
            "selections": [
                {
                    "concreteType": "SearchQueryAPI",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": [
                        {
                            "args": v34 /*: any*/ ,
                            "concreteType": "SearchItemConnection",
                            "kind": "LinkedField",
                            "name": "search",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "SearchResultItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v35 /*: any*/ ,
                                                v36 /*: any*/ ,
                                                v37 /*: any*/ ,
                                                {
                                                    "concreteType": "SearchLinkedResult",
                                                    "kind": "LinkedField",
                                                    "name": "linkedResults",
                                                    "plural": true,
                                                    "selections": [
                                                        v36 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "category"
                                                        },
                                                        v38 /*: any*/ ,
                                                        v39 /*: any*/ ,
                                                        v40 /*: any*/ ,
                                                        v41 /*: any*/ ,
                                                        v37 /*: any*/ ,
                                                        v42 /*: any*/ ,
                                                        v43 /*: any*/ ,
                                                        v44 /*: any*/ ,
                                                        v45 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isSearchResult"
                                                },
                                                v39 /*: any*/ ,
                                                v41 /*: any*/ ,
                                                v40 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareGoal",
                                                            "kind": "LinkedField",
                                                            "name": "goal",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareLocalizationField",
                                                                            "kind": "LinkedField",
                                                                            "name": "localizedLabel",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "messageId"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v46 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "score"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareTargetDate",
                                                                    "kind": "LinkedField",
                                                                    "name": "targetDate",
                                                                    "plural": false,
                                                                    "selections": v48 /*: any*/ 
                                                                },
                                                                v36 /*: any*/ ,
                                                                v49 /*: any*/ ,
                                                                v37 /*: any*/ 
                                                            ]
                                                        },
                                                        v52 /*: any*/ 
                                                    ],
                                                    "type": "SearchResultAtlasGoal"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareProject",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isPrivate"
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareTargetDate",
                                                                    "kind": "LinkedField",
                                                                    "name": "dueDate",
                                                                    "plural": false,
                                                                    "selections": v48 /*: any*/ 
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareProjectState",
                                                                    "kind": "LinkedField",
                                                                    "name": "state",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v47 /*: any*/ ,
                                                                        v46 /*: any*/ 
                                                                    ]
                                                                },
                                                                v36 /*: any*/ ,
                                                                v49 /*: any*/ 
                                                            ]
                                                        },
                                                        v52 /*: any*/ 
                                                    ],
                                                    "type": "SearchResultAtlasProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v42 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "entity",
                                                            "plural": false,
                                                            "selections": [
                                                                v35 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "SearchFederatedEmailUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "sender",
                                                                            "plural": false,
                                                                            "selections": v54 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "SearchFederatedEmailEntity"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchResultFederated"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v42 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "tier"
                                                        },
                                                        {
                                                            "concreteType": "CompassComponent",
                                                            "kind": "LinkedField",
                                                            "name": "component",
                                                            "plural": false,
                                                            "selections": [
                                                                v37 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "state"
                                                                },
                                                                v36 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "ownerId"
                                                        }
                                                    ],
                                                    "type": "SearchResultCompassComponent"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v55 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isVerified"
                                                        },
                                                        {
                                                            "concreteType": "SearchConfluenceResultSpace",
                                                            "kind": "LinkedField",
                                                            "name": "space",
                                                            "plural": false,
                                                            "selections": [
                                                                v36 /*: any*/ ,
                                                                v53 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "webUiLink"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "confluenceEntity",
                                                            "plural": false,
                                                            "selections": [
                                                                v35 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v43 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ConfluenceCommentCountSummary",
                                                                            "kind": "LinkedField",
                                                                            "name": "commentCountSummary",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v56 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "ConfluenceLikesSummary",
                                                                            "kind": "LinkedField",
                                                                            "name": "likesSummary",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "count"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ConfluencePage"
                                                                },
                                                                v57 /*: any*/ 
                                                            ]
                                                        },
                                                        v61 /*: any*/ ,
                                                        v52 /*: any*/ ,
                                                        {
                                                            "condition": "includeNavBoostScore",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "navBoostScore"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchConfluencePageBlogAttachment"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v55 /*: any*/ ,
                                                        v52 /*: any*/ 
                                                    ],
                                                    "type": "SearchConfluenceSpace"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v45 /*: any*/ ,
                                                        v38 /*: any*/ ,
                                                        v44 /*: any*/ ,
                                                        v43 /*: any*/ ,
                                                        v42 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "permissionLevel"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "entity",
                                                            "plural": false,
                                                            "selections": [
                                                                v35 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v53 /*: any*/ ,
                                                                        v62 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalBranch"
                                                                },
                                                                v57 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "container",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v35 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v63 /*: any*/ ,
                                                                                        v40 /*: any*/ ,
                                                                                        v43 /*: any*/ 
                                                                                    ],
                                                                                    "type": "ExternalSpace"
                                                                                },
                                                                                v57 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalComment"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "author",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v64 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v62 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalCommit"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v65 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalReaction",
                                                                            "kind": "LinkedField",
                                                                            "name": "reactions",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "reactionType"
                                                                                },
                                                                                v56 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "includeThirdPartyId",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "thirdPartyId"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalDocumentType",
                                                                            "kind": "LinkedField",
                                                                            "name": "type",
                                                                            "plural": false,
                                                                            "selections": v51 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "parent",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v35 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v63 /*: any*/ 
                                                                                    ],
                                                                                    "type": "ExternalDocument"
                                                                                },
                                                                                v57 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalDocument"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v66 /*: any*/ ,
                                                                        v70 /*: any*/ ,
                                                                        v37 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalAttachment",
                                                                            "kind": "LinkedField",
                                                                            "name": "attachments",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v39 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "mimeType"
                                                                                },
                                                                                v40 /*: any*/ ,
                                                                                v71 /*: any*/ ,
                                                                                v35 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v73 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "container",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v35 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v63 /*: any*/ ,
                                                                                        v77 /*: any*/ ,
                                                                                        v41 /*: any*/ ,
                                                                                        v36 /*: any*/ ,
                                                                                        v78 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "membershipType"
                                                                                        }
                                                                                    ],
                                                                                    "type": "ExternalConversation"
                                                                                },
                                                                                v57 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "lastActive"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "reactionCount"
                                                                        }
                                                                    ],
                                                                    "type": "ExternalMessage"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v37 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v78 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "members",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v35 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalConversation"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v63 /*: any*/ ,
                                                                        {
                                                                            "condition": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "ExternalUser",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "contributors",
                                                                                    "plural": true,
                                                                                    "selections": v76 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v81 /*: any*/ 
                                                                        },
                                                                        v82 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalCustomerOrgLastActivity",
                                                                            "kind": "LinkedField",
                                                                            "name": "customerOrgLastActivity",
                                                                            "plural": false,
                                                                            "selections": v83 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ExternalCustomerOrg"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "stage"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "dealClosedAt"
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalDealLastActivity",
                                                                            "kind": "LinkedField",
                                                                            "name": "lastActivity",
                                                                            "plural": false,
                                                                            "selections": v83 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__isdealownersenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v81 /*: any*/ 
                                                                        },
                                                                        v82 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalDeal"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v84 /*: any*/ ,
                                                                        v85 /*: any*/ ,
                                                                        v86 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v87 /*: any*/ ,
                                                                        v65 /*: any*/ ,
                                                                        v88 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalProject"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v84 /*: any*/ ,
                                                                        v85 /*: any*/ ,
                                                                        v86 /*: any*/ ,
                                                                        v87 /*: any*/ ,
                                                                        v43 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "team"
                                                                        },
                                                                        v65 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalWorkItemProject",
                                                                            "kind": "LinkedField",
                                                                            "name": "workItemProject",
                                                                            "plural": false,
                                                                            "selections": v74 /*: any*/ 
                                                                        },
                                                                        v88 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalWorkItem"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v39 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "lastUpdate"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "pullRequestId"
                                                                        },
                                                                        v62 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalPullRequest"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "durationInSeconds"
                                                                        },
                                                                        v71 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalChapter",
                                                                            "kind": "LinkedField",
                                                                            "name": "chapters",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v39 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "startTimeInSeconds"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "createdBy",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v75 /*: any*/ ,
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "user",
                                                                                    "plural": false,
                                                                                    "selections": v89 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalVideo"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v36 /*: any*/ ,
                                                                        v40 /*: any*/ ,
                                                                        v90 /*: any*/ ,
                                                                        v80 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalDashboard"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v36 /*: any*/ ,
                                                                        v40 /*: any*/ ,
                                                                        {
                                                                            "alias": "dataTableType",
                                                                            "kind": "ScalarField",
                                                                            "name": "type"
                                                                        },
                                                                        v90 /*: any*/ ,
                                                                        v80 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalDataTable"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v63 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "accountName"
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "contactUser",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "ThirdPartyUser",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "thirdPartyUser",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v68 /*: any*/ ,
                                                                                        v36 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalCustomerContact"
                                                                }
                                                            ]
                                                        },
                                                        v91 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "entity",
                                                            "plural": false,
                                                            "selections": [
                                                                v35 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v85 /*: any*/ ,
                                                                        v92 /*: any*/ ,
                                                                        v93 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "recurringEventId"
                                                                        },
                                                                        v94 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalCalendarEvent"
                                                                },
                                                                v57 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ExternalThumbnail",
                                                                            "kind": "LinkedField",
                                                                            "name": "thumbnail",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "externalUrl"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalDesign"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "SearchResultGraphDocument",
                                                            "kind": "LinkedField",
                                                            "name": "linkedEntities",
                                                            "plural": true,
                                                            "selections": [
                                                                v36 /*: any*/ ,
                                                                v39 /*: any*/ ,
                                                                v40 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "entity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v35 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v93 /*: any*/ ,
                                                                                v92 /*: any*/ ,
                                                                                v94 /*: any*/ 
                                                                            ],
                                                                            "type": "ExternalCalendarEvent"
                                                                        },
                                                                        v57 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v73 /*: any*/ ,
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "container",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v35 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v77 /*: any*/ ,
                                                                                                v41 /*: any*/ 
                                                                                            ],
                                                                                            "type": "ExternalConversation"
                                                                                        },
                                                                                        v57 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v66 /*: any*/ ,
                                                                                v70 /*: any*/ ,
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "ExternalMessage"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "ExternalConversation"
                                                                        }
                                                                    ]
                                                                },
                                                                v95 /*: any*/ ,
                                                                v96 /*: any*/ ,
                                                                v91 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v97 /*: any*/ 
                                                            ]
                                                        },
                                                        v96 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "containerName"
                                                        },
                                                        v95 /*: any*/ ,
                                                        v97 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "linkedEntitiesType"
                                                        }
                                                    ],
                                                    "type": "SearchResultGraphDocument"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v42 /*: any*/ ,
                                                        v50 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "issue",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "issueTypeAvatarUrl"
                                                                },
                                                                v98 /*: any*/ ,
                                                                v49 /*: any*/ ,
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "ids",
                                                                            "value": [
                                                                                "project"
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldsById",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v35 /*: any*/ ,
                                                                                        v53 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": v74 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraProjectField"
                                                                                        },
                                                                                        v36 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "fieldsById(ids:[\"project\"])"
                                                                },
                                                                {
                                                                    "condition": "includeAssigneeField",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSingleSelectUserPickerField",
                                                                            "kind": "LinkedField",
                                                                            "name": "assigneeField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v64 /*: any*/ ,
                                                                                v36 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v36 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchResultJiraIssue"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectKey"
                                                        },
                                                        v42 /*: any*/ ,
                                                        v50 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                v98 /*: any*/ ,
                                                                v36 /*: any*/ 
                                                            ]
                                                        },
                                                        v61 /*: any*/ 
                                                    ],
                                                    "type": "SearchResultJiraProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v99 /*: any*/ ,
                                                    "type": "SearchResultJiraPlan"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v42 /*: any*/ ,
                                                        v50 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraBoard",
                                                            "kind": "LinkedField",
                                                            "name": "board",
                                                            "plural": false,
                                                            "selections": [
                                                                v50 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "boardFrontendUrl"
                                                                },
                                                                v36 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchResultJiraBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v99 /*: any*/ ,
                                                    "type": "SearchResultJiraDashboard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v99 /*: any*/ ,
                                                    "type": "SearchResultJiraFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "MercuryFocusArea",
                                                            "kind": "LinkedField",
                                                            "name": "focusArea",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "MercuryFocusAreaStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v49 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MercuryFocusAreaHealth",
                                                                    "kind": "LinkedField",
                                                                    "name": "health",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v49 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "color"
                                                                        },
                                                                        v63 /*: any*/ ,
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MercuryTargetDate",
                                                                    "kind": "LinkedField",
                                                                    "name": "targetDate",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "targetDate"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "targetDateType"
                                                                        }
                                                                    ]
                                                                },
                                                                v36 /*: any*/ ,
                                                                v53 /*: any*/ ,
                                                                {
                                                                    "concreteType": "MercuryFocusAreaType",
                                                                    "kind": "LinkedField",
                                                                    "name": "focusAreaType",
                                                                    "plural": false,
                                                                    "selections": v74 /*: any*/ 
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "owner",
                                                                    "plural": false,
                                                                    "selections": v89 /*: any*/ 
                                                                }
                                                            ]
                                                        },
                                                        v42 /*: any*/ 
                                                    ],
                                                    "type": "SearchResultMercuryFocusArea"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v42 /*: any*/ ,
                                                        {
                                                            "concreteType": "MercuryFocusArea",
                                                            "kind": "LinkedField",
                                                            "name": "focusArea",
                                                            "plural": false,
                                                            "selections": v79 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "SearchResultMercuryFocusAreaStatusUpdate"
                                                },
                                                {
                                                    "condition": "includePassionfruitAsk",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v100 /*: any*/ ,
                                                            "type": "SearchResultSpfAsk"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v100 /*: any*/ ,
                                                    "type": "SearchResultTrelloBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v100 /*: any*/ ,
                                                    "type": "SearchResultTrelloCard"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__isassetsenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v42 /*: any*/ ,
                                                                {
                                                                    "concreteType": "AssetsSchema",
                                                                    "kind": "LinkedField",
                                                                    "name": "objectSchemaEntity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v101 /*: any*/ ,
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultAssetsObjectSchema"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v42 /*: any*/ ,
                                                                v102 /*: any*/ ,
                                                                {
                                                                    "concreteType": "AssetsObjectType",
                                                                    "kind": "LinkedField",
                                                                    "name": "objectTypeEntity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "AssetsIcon",
                                                                            "kind": "LinkedField",
                                                                            "name": "icon",
                                                                            "plural": false,
                                                                            "selections": v103 /*: any*/ 
                                                                        },
                                                                        v101 /*: any*/ ,
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultAssetsObjectType"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v42 /*: any*/ ,
                                                                v102 /*: any*/ ,
                                                                {
                                                                    "concreteType": "AssetsObject",
                                                                    "kind": "LinkedField",
                                                                    "name": "objectEntity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "AssetsAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": v103 /*: any*/ 
                                                                        },
                                                                        v101 /*: any*/ ,
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultAssetsObject"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "includePositions",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "RadarPosition",
                                                                    "kind": "LinkedField",
                                                                    "name": "position",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v35 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "RadarWorker",
                                                                            "kind": "LinkedField",
                                                                            "name": "worker",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "preferredName"
                                                                                },
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "user",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v35 /*: any*/ ,
                                                                                        v58 /*: any*/ ,
                                                                                        v36 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v36 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "fieldIdIsIn",
                                                                                    "value": [
                                                                                        "positionId",
                                                                                        "positionStatus",
                                                                                        "positionJobTitle",
                                                                                        "positionPositionTitle",
                                                                                        "positionKey",
                                                                                        "positionExternalPositionKey",
                                                                                        "positionWorker",
                                                                                        "focusArea"
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "concreteType": "RadarFieldValueIdPair",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldValues",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "fieldId"
                                                                                },
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldValue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v35 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": "stringValue",
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "value"
                                                                                                }
                                                                                            ],
                                                                                            "type": "RadarStringFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "value",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v53 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "MercuryFocusAreaStatus",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "status",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v104 /*: any*/ 
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "MercuryFocusAreaHealth",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "health",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v104 /*: any*/ 
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "MercuryFocusArea"
                                                                                                        },
                                                                                                        v57 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "RadarAriFieldValue"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "fieldValues(fieldIdIsIn:[\"positionId\",\"positionStatus\",\"positionJobTitle\",\"positionPositionTitle\",\"positionKey\",\"positionExternalPositionKey\",\"positionWorker\",\"focusArea\"])"
                                                                        },
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultTalentPosition"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "SearchQueryInfo",
                                    "kind": "LinkedField",
                                    "name": "queryInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "originalQuery"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "replacementQuery"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "suggestedQuery"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "originalQueryType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "confidenceScore"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "shouldTriggerAutocorrectionExperience"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "SearchError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "statusCode"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "product"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "integration"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeAutoAppliedFilters",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "SearchFilterOutput",
                                            "kind": "LinkedField",
                                            "name": "autoAppliedFilters",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "SearchCommonFilterOutput",
                                                    "kind": "LinkedField",
                                                    "name": "commonFilters",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "SearchCommonRangeFilterOutput",
                                                            "kind": "LinkedField",
                                                            "name": "range",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "SearchCommonRangeFilterFieldsOutput",
                                                                    "kind": "LinkedField",
                                                                    "name": "lastModified",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "gt"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "lt"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "SearchParticipantsOutput",
                                                            "kind": "LinkedField",
                                                            "name": "participants",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "SearchParticipantOutput",
                                                                    "kind": "LinkedField",
                                                                    "name": "items",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v41 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "users"
                                                                        },
                                                                        v105 /*: any*/ 
                                                                    ]
                                                                },
                                                                v105 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v34 /*: any*/ ,
                            "filters": [
                                "experience",
                                "enableHighlighting",
                                "query",
                                "sort",
                                "disableQueryReplacement",
                                "fanoutExperimentCohort",
                                "filters",
                                "analytics",
                                "experimentContext"
                            ],
                            "handle": "connection",
                            "key": "SearchResultsPagination__search",
                            "kind": "LinkedHandle",
                            "name": "search"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "32474d1e52ea5c2cf4b07a58f58a362ee7c0df1ae703a8f5d1f5820e1daef329",
            "metadata": {},
            "name": "SearchResultsPaginationQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "includeAssets": (0, $5SuoG.default),
                "__relay_internal__pv__isassetsenabledrelayprovider": (0, $5SuoG.default),
                "__relay_internal__pv__iscustomerorgownersenabledrelayprovider": (0, $aqtD4.default),
                "__relay_internal__pv__isdealownersenabledrelayprovider": (0, $4PNBt.default),
                "__relay_internal__pv__jsmdcenabledrelayprovider": (0, $jYilw.default)
            }
        }
    };
}();
$05232064a3df46d5$var$node.hash = "59aef00e42b63d5ea421113a751705d3";
var $05232064a3df46d5$export$2e2bcd8739ae039 = $05232064a3df46d5$var$node;


const $8c8aedab4d13b6fb$var$node = function() {
    var v0 = [
        "search",
        "search"
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "connectorType"
    }, v3 = {
        "kind": "ScalarField",
        "name": "combination"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__isassetsenabledrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "assetsFilters"
            },
            {
                "kind": "RootArgument",
                "name": "cloudIdARI"
            },
            {
                "kind": "RootArgument",
                "name": "commonFilters"
            },
            {
                "kind": "RootArgument",
                "name": "compassFilters"
            },
            {
                "kind": "RootArgument",
                "name": "confluenceFilters"
            },
            {
                "kind": "RootArgument",
                "name": "disableQueryReplacement"
            },
            {
                "kind": "RootArgument",
                "name": "enableHighlighting"
            },
            {
                "kind": "RootArgument",
                "name": "entities"
            },
            {
                "kind": "RootArgument",
                "name": "experience"
            },
            {
                "kind": "RootArgument",
                "name": "experimentId"
            },
            {
                "kind": "RootArgument",
                "name": "experimentLayers"
            },
            {
                "kind": "RootArgument",
                "name": "fanoutExperimentCohort"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeAssigneeField"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeAutoAppliedFilters"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeIconUrl"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeNavBoostScore"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includePassionfruitAsk"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includePositions"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeThirdPartyId"
            },
            {
                "kind": "RootArgument",
                "name": "jiraFilters"
            },
            {
                "kind": "RootArgument",
                "name": "limit"
            },
            {
                "kind": "RootArgument",
                "name": "mercuryFilters"
            },
            {
                "kind": "RootArgument",
                "name": "query"
            },
            {
                "kind": "RootArgument",
                "name": "queryVersion"
            },
            {
                "kind": "RootArgument",
                "name": "searchSessionId"
            },
            {
                "kind": "RootArgument",
                "name": "sessionId"
            },
            {
                "kind": "RootArgument",
                "name": "shadowExperimentId"
            },
            {
                "kind": "RootArgument",
                "name": "sort"
            },
            {
                "kind": "RootArgument",
                "name": "sourceProduct"
            },
            {
                "kind": "RootArgument",
                "name": "talentFilters"
            },
            {
                "kind": "RootArgument",
                "name": "tenantId"
            },
            {
                "kind": "RootArgument",
                "name": "thirdPartyFilters"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "limit",
                    "cursor": "after",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "limit",
                        "cursor": "after"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $05232064a3df46d5$export$2e2bcd8739ae039)
            }
        },
        "name": "searchResults_AtlassianSearchPage",
        "selections": [
            {
                "concreteType": "SearchQueryAPI",
                "kind": "LinkedField",
                "name": "search",
                "plural": false,
                "selections": [
                    {
                        "alias": "search",
                        "args": [
                            {
                                "fields": [
                                    {
                                        "kind": "Variable",
                                        "name": "queryVersion",
                                        "variableName": "queryVersion"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "searchSessionId",
                                        "variableName": "searchSessionId"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "sessionId",
                                        "variableName": "sessionId"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "sourceProduct",
                                        "variableName": "sourceProduct"
                                    }
                                ],
                                "kind": "ObjectValue",
                                "name": "analytics"
                            },
                            {
                                "kind": "Variable",
                                "name": "disableQueryReplacement",
                                "variableName": "disableQueryReplacement"
                            },
                            {
                                "kind": "Variable",
                                "name": "enableHighlighting",
                                "variableName": "enableHighlighting"
                            },
                            {
                                "kind": "Variable",
                                "name": "experience",
                                "variableName": "experience"
                            },
                            {
                                "fields": [
                                    {
                                        "kind": "Variable",
                                        "name": "experimentId",
                                        "variableName": "experimentId"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "experimentLayers",
                                        "variableName": "experimentLayers"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "shadowExperimentId",
                                        "variableName": "shadowExperimentId"
                                    }
                                ],
                                "kind": "ObjectValue",
                                "name": "experimentContext"
                            },
                            {
                                "kind": "Variable",
                                "name": "fanoutExperimentCohort",
                                "variableName": "fanoutExperimentCohort"
                            },
                            {
                                "fields": [
                                    {
                                        "kind": "Variable",
                                        "name": "assetsFilters",
                                        "variableName": "assetsFilters"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "commonFilters",
                                        "variableName": "commonFilters"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "compassFilters",
                                        "variableName": "compassFilters"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "confluenceFilters",
                                        "variableName": "confluenceFilters"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "entities",
                                        "variableName": "entities"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "jiraFilters",
                                        "variableName": "jiraFilters"
                                    },
                                    {
                                        "items": [
                                            {
                                                "kind": "Variable",
                                                "name": "locations.0",
                                                "variableName": "cloudIdARI"
                                            }
                                        ],
                                        "kind": "ListValue",
                                        "name": "locations"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "mercuryFilters",
                                        "variableName": "mercuryFilters"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "talentFilters",
                                        "variableName": "talentFilters"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "thirdPartyFilters",
                                        "variableName": "thirdPartyFilters"
                                    }
                                ],
                                "kind": "ObjectValue",
                                "name": "filters"
                            },
                            {
                                "kind": "Variable",
                                "name": "query",
                                "variableName": "query"
                            },
                            {
                                "kind": "Variable",
                                "name": "sort",
                                "variableName": "sort"
                            }
                        ],
                        "concreteType": "SearchItemConnection",
                        "kind": "LinkedField",
                        "name": "__SearchResultsPagination__search_connection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "SearchResultItemEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__typename"
                                            },
                                            v1 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "description"
                                            },
                                            {
                                                "concreteType": "SearchLinkedResult",
                                                "kind": "LinkedField",
                                                "name": "linkedResults",
                                                "plural": true,
                                                "selections": [
                                                    v1 /*: any*/ ,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "category"
                                                    },
                                                    v2 /*: any*/ 
                                                ]
                                            },
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "includeAssets",
                                                        "variableName": "__relay_internal__pv__isassetsenabledrelayprovider"
                                                    },
                                                    {
                                                        "kind": "Variable",
                                                        "name": "includeAssigneeField",
                                                        "variableName": "includeAssigneeField"
                                                    },
                                                    {
                                                        "kind": "Variable",
                                                        "name": "includeIconUrl",
                                                        "variableName": "includeIconUrl"
                                                    },
                                                    {
                                                        "kind": "Variable",
                                                        "name": "includeNavBoostScore",
                                                        "variableName": "includeNavBoostScore"
                                                    },
                                                    {
                                                        "kind": "Variable",
                                                        "name": "includePassionfruitAsk",
                                                        "variableName": "includePassionfruitAsk"
                                                    },
                                                    {
                                                        "kind": "Variable",
                                                        "name": "includePositions",
                                                        "variableName": "includePositions"
                                                    },
                                                    {
                                                        "kind": "Variable",
                                                        "name": "includeThirdPartyId",
                                                        "variableName": "includeThirdPartyId"
                                                    }
                                                ],
                                                "kind": "FragmentSpread",
                                                "name": "searchResult_AtlassianSearchPage"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "providerId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "integrationId"
                                                    },
                                                    v2 /*: any*/ 
                                                ],
                                                "type": "SearchResultGraphDocument"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "ownerId"
                                                    }
                                                ],
                                                "type": "SearchResultCompassComponent"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "url"
                                                    },
                                                    {
                                                        "concreteType": "JiraIssue",
                                                        "kind": "LinkedField",
                                                        "name": "issue",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "webUrl"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "SearchResultJiraIssue"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "args": [
                                                            {
                                                                "kind": "Variable",
                                                                "name": "tenantId",
                                                                "variableName": "tenantId"
                                                            }
                                                        ],
                                                        "concreteType": "SocialSignalSearch",
                                                        "kind": "LinkedField",
                                                        "name": "socialSignal",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "signal"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "SearchConfluencePageBlogAttachment"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "cursor"
                                    }
                                ]
                            },
                            {
                                "concreteType": "SearchQueryInfo",
                                "kind": "LinkedField",
                                "name": "queryInfo",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "originalQuery"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "autoCorrection_AtlassianSearchPage"
                                    }
                                ]
                            },
                            {
                                "condition": "includeAutoAppliedFilters",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "concreteType": "SearchFilterOutput",
                                        "kind": "LinkedField",
                                        "name": "autoAppliedFilters",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "SearchCommonFilterOutput",
                                                "kind": "LinkedField",
                                                "name": "commonFilters",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "SearchCommonRangeFilterOutput",
                                                        "kind": "LinkedField",
                                                        "name": "range",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "SearchCommonRangeFilterFieldsOutput",
                                                                "kind": "LinkedField",
                                                                "name": "lastModified",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "gt"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "lt"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "SearchParticipantsOutput",
                                                        "kind": "LinkedField",
                                                        "name": "participants",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "SearchParticipantOutput",
                                                                "kind": "LinkedField",
                                                                "name": "items",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "type"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "users"
                                                                    },
                                                                    v3 /*: any*/ 
                                                                ]
                                                            },
                                                            v3 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "endCursor"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "hasNextPage"
                                    }
                                ]
                            },
                            {
                                "concreteType": "SearchError",
                                "kind": "LinkedField",
                                "name": "errors",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "statusCode"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "product"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "integration"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$8c8aedab4d13b6fb$var$node.hash = "59aef00e42b63d5ea421113a751705d3";
var $8c8aedab4d13b6fb$export$2e2bcd8739ae039 = $8c8aedab4d13b6fb$var$node;









var $jTxSS = parcelRequire("jTxSS");










































const $26867d7ca0c8f2ad$export$edb9b52ab3f1abbb = (ref)=>{
    const observerRef = (0, $42omo.useRef)(null);
    const [isOnScreen, setIsOnScreen] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!observerRef.current) observerRef.current = new IntersectionObserver(([entry])=>{
            setIsOnScreen(entry.isIntersecting);
        });
        const element = ref.current;
        if (element && observerRef.current) observerRef.current.observe(element);
        return ()=>{
            if (observerRef.current && element) observerRef.current.unobserve(element);
        };
    }, [
        ref
    ]);
    // Cleanup observer on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (observerRef.current) observerRef.current.disconnect();
        };
    }, []);
    return isOnScreen;
};


/**
 * In relay we re-render this pagination footer too fast, such that we end up paginating twice if the viewport remains at the bottom of the scroll height during the n+1 fetch!
 * This is because this component re-renders with the new paginationCursor/isLoading=false props from the fetch query, but before it has been pushed off the screen by the other results rendering.
 * We use an `isPaginatingRef` flag to prevent duplicate pagination requests by tracking when a pagination is already in progress.
 * The flag is set when pagination starts and reset when loading completes, ensuring only one pagination request at a time.
 */ const $3d6c58437980e8c0$var$hiddenBoxStyles = (0, $ecnYn.xcss)({
    display: 'none'
});
const $3d6c58437980e8c0$var$ResultsPaginationFooter = ({ cursor: currentCursor, fetchNextPage: fetchNextPage, isLoading: isLoading })=>{
    const paginationRef = (0, $42omo.useRef)(null);
    const isOnScreen = (0, $26867d7ca0c8f2ad$export$edb9b52ab3f1abbb)(paginationRef);
    const [lastCursor, setLastCursor] = (0, $42omo.useState)(null);
    const isPaginatingRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        // Start pagination if conditions are met and not already paginating
        if (isOnScreen && currentCursor && currentCursor !== lastCursor && !isPaginatingRef.current) {
            isPaginatingRef.current = true;
            setLastCursor(currentCursor);
            fetchNextPage(currentCursor);
        }
    }, [
        isOnScreen,
        currentCursor,
        lastCursor,
        fetchNextPage
    ]);
    // Separate effect to reset pagination flag when loading completes
    (0, $42omo.useEffect)(()=>{
        if (!isLoading) isPaginatingRef.current = false;
    }, [
        isLoading
    ]);
    // Reset lastCursor when currentCursor becomes null to ensure proper state reset
    (0, $42omo.useEffect)(()=>{
        if (!currentCursor) {
            setLastCursor(null);
            isPaginatingRef.current = false;
        }
    }, [
        currentCursor
    ]);
    // If there is no cursor, we can't paginate - render invisible element to maintain hook state
    if (!currentCursor) return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        ref: paginationRef,
        xcss: $3d6c58437980e8c0$var$hiddenBoxStyles,
        testId: "search-page-pagination-footer-hidden"
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        ref: paginationRef,
        testId: "search-page-pagination-footer",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1hlFx.SearchResultSkeleton), {})
    });
};
var $3d6c58437980e8c0$export$2e2bcd8739ae039 = $3d6c58437980e8c0$var$ResultsPaginationFooter;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 














const $280ef4355050ad69$var$styles = {
    resultsListGridArea: "_nd5l1b0a _zulp1ejb _1e0c1txw _2lx21bp4",
    noMoreResults: "_otyrxy5q"
};
const $280ef4355050ad69$export$92697b2a267ec7ef = ({ children: children, containsSearchResults: containsSearchResults })=>{
    (0, $42omo.useEffect)(()=>{
        if (containsSearchResults) (0, $2OtFZ.triggerExposureForEngagementTrackingImprovementsExperiment)();
    }, [
        containsSearchResults
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($280ef4355050ad69$var$styles.resultsListGridArea, $280ef4355050ad69$var$styles.noMoreResults),
        testId: "search-page-results-list",
        ...containsSearchResults && {
            role: 'list'
        },
        children: children
    });
};
























/**
 * @generated SignedSource<<a8aa6392d2a105c6b65f7faa2a0e67be>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $285a05f8e46adb50$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "autoCorrection_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "originalQuery"
        },
        {
            "kind": "ScalarField",
            "name": "replacementQuery"
        },
        {
            "kind": "ScalarField",
            "name": "suggestedQuery"
        },
        {
            "kind": "ScalarField",
            "name": "originalQueryType"
        },
        {
            "kind": "ScalarField",
            "name": "confidenceScore"
        },
        {
            "kind": "ScalarField",
            "name": "shouldTriggerAutocorrectionExperience"
        }
    ],
    "type": "SearchQueryInfo"
};
$285a05f8e46adb50$var$node.hash = "c10236f368a121324971f6864af67d34";
var $285a05f8e46adb50$export$2e2bcd8739ae039 = $285a05f8e46adb50$var$node;











































const $7d957fe130cc1584$var$anchorStyles = (0, $ecnYn.xcss)({
    color: 'color.link',
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'underline'
    },
    ':active': {
        textDecoration: 'none'
    },
    ':visited': {
        color: 'color.link.visited'
    },
    ':visited:active': {
        color: 'color.link.visited.pressed'
    }
});
const $7d957fe130cc1584$var$useFireClickEvent = (cloudId)=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    return (additionalAttributes)=>{
        // Check if this is a hello tenant - only hello tenants can pass sensitive fields
        const isHelloTenant = (0, $5XpfZ.isHello)(cloudId);
        let filteredAttributes = {
            ...additionalAttributes
        };
        if (!isHelloTenant) // For non-hello tenants, replace fields with values to [REDACTED], keep null as null
        filteredAttributes = {
            ...filteredAttributes,
            originalQuery: additionalAttributes?.originalQuery ? '[REDACTED]' : null,
            replacementQuery: additionalAttributes?.replacementQuery ? '[REDACTED]' : null,
            suggestedQuery: additionalAttributes?.suggestedQuery ? '[REDACTED]' : null
        };
        fireAnalyticsEvent({
            eventType: 'ui',
            actionSubject: `${(0, $6yNqK.ACTION_SUBJECT_PREFIX)}AutoCorrection`,
            action: 'clicked',
            attributes: {
                commonAttributes: commonAttributes,
                additionalAttributes: filteredAttributes
            }
        });
    };
};
const $7d957fe130cc1584$var$useFireShownEvent = (cloudId)=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    return (additionalAttributes)=>{
        // Check if this is a hello tenant - only hello tenants can pass sensitive fields
        const isHelloTenant = (0, $5XpfZ.isHello)(cloudId);
        let filteredAttributes = {
            ...additionalAttributes
        };
        if (!isHelloTenant) // For non-hello tenants, replace fields with values to [REDACTED], keep null as null
        filteredAttributes = {
            ...filteredAttributes,
            originalQuery: additionalAttributes?.originalQuery ? '[REDACTED]' : null,
            replacementQuery: additionalAttributes?.replacementQuery ? '[REDACTED]' : null,
            suggestedQuery: additionalAttributes?.suggestedQuery ? '[REDACTED]' : null
        };
        fireAnalyticsEvent({
            eventType: 'ui',
            actionSubject: `${(0, $6yNqK.ACTION_SUBJECT_PREFIX)}AutoCorrection`,
            action: 'shown',
            attributes: {
                commonAttributes: commonAttributes,
                additionalAttributes: filteredAttributes
            }
        });
    };
};
const $7d957fe130cc1584$var$isEnglishLocale = (locale)=>{
    const lowerCaseLocale = locale.toLowerCase();
    // English locale or starts with 'en-', `en-US`, `en-GB`, etc.
    return lowerCaseLocale === 'en' || lowerCaseLocale.startsWith('en-');
};
const $7d957fe130cc1584$var$AutoCorrection = ({ node: node, cloudId: cloudId })=>{
    const queryInfo = (0, $irOoi.useFragment)((0, $285a05f8e46adb50$export$2e2bcd8739ae039), node);
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const fireClickEvent = $7d957fe130cc1584$var$useFireClickEvent(cloudId);
    const fireShownEvent = $7d957fe130cc1584$var$useFireShownEvent(cloudId);
    const hasTrackedShown = (0, $42omo.useRef)(false);
    const originalQueryUrlParam = queryParams.originalQuery;
    const { originalQuery: originalQuery, replacementQuery: replacementQuery, suggestedQuery: suggestedQuery, originalQueryType: originalQueryType, confidenceScore: confidenceScore, shouldTriggerAutocorrectionExperience: shouldTriggerAutocorrectionExperience } = queryInfo || {};
    /**
   * Show auto correction if:
   * - replacementQuery is available
   * - shouldTriggerAutocorrectionExperience is true (currently not available)
   */ const showAutoCorrection = (replacementQuery || suggestedQuery) && shouldTriggerAutocorrectionExperience;
    // Fire shown events when auto-correction is displayed
    (0, $42omo.useEffect)(()=>{
        const { originalQuery: originalQuery, replacementQuery: replacementQuery, suggestedQuery: suggestedQuery, originalQueryType: originalQueryType, confidenceScore: confidenceScore, shouldTriggerAutocorrectionExperience: shouldTriggerAutocorrectionExperience } = queryInfo || {};
        const showAutoCorrection = (replacementQuery || suggestedQuery) && shouldTriggerAutocorrectionExperience;
        if (showAutoCorrection) {
            // Generate a unique key for the current auto-correction state
            // Only depend on the actual auto-correction data, not URL parameters
            const autoCorrectionKey = `${replacementQuery || ''}-${suggestedQuery || ''}`;
            if (hasTrackedShown.current !== autoCorrectionKey) {
                hasTrackedShown.current = autoCorrectionKey;
                // Fire shown events based on what's actually displayed
                if (!originalQueryUrlParam && replacementQuery) {
                    // Fire shown events for replacement and original
                    fireShownEvent({
                        autoCorrectionType: 'replacement',
                        originalQueryType: originalQueryType,
                        confidenceScore: confidenceScore,
                        originalQuery: originalQuery,
                        replacementQuery: replacementQuery,
                        suggestedQuery: null,
                        originalQueryHash: originalQuery ? (0, $a0M2t.sha256Hash)(originalQuery) : null,
                        replacementQueryHash: replacementQuery ? (0, $a0M2t.sha256Hash)(replacementQuery) : null,
                        suggestedQueryHash: null
                    });
                    fireShownEvent({
                        autoCorrectionType: 'original',
                        originalQueryType: originalQueryType,
                        confidenceScore: confidenceScore,
                        originalQuery: originalQuery,
                        replacementQuery: replacementQuery,
                        suggestedQuery: null,
                        originalQueryHash: originalQuery ? (0, $a0M2t.sha256Hash)(originalQuery) : null,
                        replacementQueryHash: replacementQuery ? (0, $a0M2t.sha256Hash)(replacementQuery) : null,
                        suggestedQueryHash: null
                    });
                }
                if (!replacementQuery && suggestedQuery) // Fire shown event for suggested
                fireShownEvent({
                    autoCorrectionType: 'suggested',
                    originalQueryType: originalQueryType,
                    confidenceScore: confidenceScore,
                    originalQuery: originalQuery,
                    replacementQuery: null,
                    suggestedQuery: suggestedQuery,
                    originalQueryHash: originalQuery ? (0, $a0M2t.sha256Hash)(originalQuery) : null,
                    replacementQueryHash: null,
                    suggestedQueryHash: suggestedQuery ? (0, $a0M2t.sha256Hash)(suggestedQuery) : null
                });
            }
        }
    }, [
        queryInfo,
        fireShownEvent,
        originalQueryUrlParam
    ]);
    if (showAutoCorrection) {
        if (!originalQueryUrlParam && replacementQuery) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $5dK2X.default), {
                        size: "large",
                        weight: "medium",
                        children: [
                            "Showing results for",
                            ' ',
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $jAenQ.Link), {
                                href: generateSearchUrl({
                                    ...queryParams,
                                    text: replacementQuery,
                                    originalQuery: originalQuery
                                }),
                                xcss: $7d957fe130cc1584$var$anchorStyles,
                                onClick: ()=>fireClickEvent({
                                        autoCorrectionType: 'replacement',
                                        originalQueryType: originalQueryType,
                                        confidenceScore: confidenceScore,
                                        originalQuery: originalQuery,
                                        replacementQuery: replacementQuery,
                                        suggestedQuery: null,
                                        originalQueryHash: originalQuery ? (0, $a0M2t.sha256Hash)(originalQuery) : null,
                                        replacementQueryHash: replacementQuery ? (0, $a0M2t.sha256Hash)(replacementQuery) : null,
                                        suggestedQueryHash: null
                                    }),
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                    as: "em",
                                    size: "large",
                                    weight: "medium",
                                    color: "color.link",
                                    children: replacementQuery
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $5dK2X.default), {
                        children: [
                            "Search instead for",
                            ' ',
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $jAenQ.Link), {
                                href: generateSearchUrl({
                                    ...queryParams,
                                    text: originalQuery,
                                    originalQuery: replacementQuery
                                }),
                                xcss: $7d957fe130cc1584$var$anchorStyles,
                                onClick: ()=>fireClickEvent({
                                        autoCorrectionType: 'original',
                                        originalQueryType: originalQueryType,
                                        confidenceScore: confidenceScore,
                                        originalQuery: originalQuery,
                                        replacementQuery: replacementQuery,
                                        suggestedQuery: null,
                                        originalQueryHash: originalQuery ? (0, $a0M2t.sha256Hash)(originalQuery) : null,
                                        replacementQueryHash: replacementQuery ? (0, $a0M2t.sha256Hash)(replacementQuery) : null,
                                        suggestedQueryHash: null
                                    }),
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                    as: "em",
                                    color: "color.link",
                                    children: originalQuery
                                })
                            })
                        ]
                    })
                })
            ]
        });
        if (!replacementQuery && suggestedQuery) return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $5dK2X.default), {
                size: "large",
                weight: "medium",
                children: [
                    "Did you mean",
                    ' ',
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $jAenQ.Link), {
                        // TODO: Why changing the query using query params and not Store actions?
                        href: generateSearchUrl({
                            ...queryParams,
                            text: suggestedQuery,
                            originalQuery: originalQuery
                        }),
                        xcss: $7d957fe130cc1584$var$anchorStyles,
                        onClick: ()=>fireClickEvent({
                                autoCorrectionType: 'suggested',
                                originalQueryType: originalQueryType,
                                confidenceScore: confidenceScore,
                                originalQuery: originalQuery,
                                replacementQuery: null,
                                suggestedQuery: suggestedQuery,
                                originalQueryHash: originalQuery ? (0, $a0M2t.sha256Hash)(originalQuery) : null,
                                replacementQueryHash: null,
                                suggestedQueryHash: suggestedQuery ? (0, $a0M2t.sha256Hash)(suggestedQuery) : null
                            }),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                            as: "em",
                            size: "large",
                            weight: "medium",
                            color: "color.link",
                            children: suggestedQuery
                        })
                    })
                ]
            })
        });
    }
    return null;
};
const $7d957fe130cc1584$var$AutoCorrectionIfEligible = ({ appMode: appMode, node: node, cloudId: cloudId })=>{
    const { locale: locale } = (0, $8C5kA.default)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $7WbA8.useAppContext)();
    if (!$7d957fe130cc1584$var$isEnglishLocale(locale) || !(0, $eb4a02b80e2ab764$export$3afecd2a83596299)(appMode, isAdminHubAIEnabled, isRovoLLMEnabled) || appMode !== (0, $9vOy1.ApplicationModes).Rovo) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: "search-page-auto-correction",
        children: /*#__PURE__*/ (0, $l998X.jsx)($7d957fe130cc1584$var$AutoCorrection, {
            node: node,
            cloudId: cloudId
        })
    });
};
var $7d957fe130cc1584$export$2e2bcd8739ae039 = $7d957fe130cc1584$var$AutoCorrectionIfEligible;





/**
 * @generated SignedSource<<0ac0fa38af40dfc4aa77d89df70b4c34>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1cc2f6a902ce7bda$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "includeAssets"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "includeAssigneeField"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "includeIconUrl"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "includeNavBoostScore"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "includePassionfruitAsk"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "includePositions"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "includeThirdPartyId"
        }
    ],
    "kind": "Fragment",
    "name": "searchResult_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "includeAssets",
                    "variableName": "includeAssets"
                },
                {
                    "kind": "Variable",
                    "name": "includeAssigneeField",
                    "variableName": "includeAssigneeField"
                },
                {
                    "kind": "Variable",
                    "name": "includeIconUrl",
                    "variableName": "includeIconUrl"
                },
                {
                    "kind": "Variable",
                    "name": "includeNavBoostScore",
                    "variableName": "includeNavBoostScore"
                },
                {
                    "kind": "Variable",
                    "name": "includePassionfruitAsk",
                    "variableName": "includePassionfruitAsk"
                },
                {
                    "kind": "Variable",
                    "name": "includePositions",
                    "variableName": "includePositions"
                },
                {
                    "kind": "Variable",
                    "name": "includeThirdPartyId",
                    "variableName": "includeThirdPartyId"
                }
            ],
            "kind": "FragmentSpread",
            "name": "searchResultRenderer_AtlassianSearchPage"
        }
    ],
    "type": "SearchResult",
    "abstractKey": "__isSearchResult"
};
$1cc2f6a902ce7bda$var$node.hash = "357a9a65a9ef836dbd146b53259e9fd2";
var $1cc2f6a902ce7bda$export$2e2bcd8739ae039 = $1cc2f6a902ce7bda$var$node;


parcelRequire("42omo");














parcelRequire("42omo");




























const $14f5a0c0b568e7eb$export$df17046610238203 = ({ cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs, selectedProduct: selectedProduct, availableProducts: availableProducts })=>{
    const { fireAnalyticsScreenEvent: fireAnalyticsScreenEvent, fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const { getNewlyConnectedProducts: getNewlyConnectedProducts } = (0, $dsrEB.useNewlyConnectedProducts)();
    if (!selectedProduct) {
        if ((0, $2OtFZ.serve3PBulkConnectWithoutExposure)()) return /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
            section: "SearchPageRelayResultsBulkConnectBanner",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                role: "listitem",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5Lref.BulkConnectBanner), {
                    thirdPartyConfigs: thirdPartyConfigs,
                    availableProducts: availableProducts,
                    getNewlyConnectedProducts: getNewlyConnectedProducts,
                    useBulkConnectModalOpenState: (0, $dsrEB.useBulkConnectModalOpenState),
                    fireAnalyticsScreenEvent: fireAnalyticsScreenEvent,
                    fireAnalyticsEvent: fireAnalyticsEvent,
                    commonAttributes: commonAttributes
                })
            })
        });
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
            section: "SearchPageRelayResultsOAuthContainer",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                role: "listitem",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a5OFf.OAuthContainer), {
                    thirdPartyConfigs: thirdPartyConfigs,
                    availableProducts: availableProducts,
                    isHello: (0, $5XpfZ.isHello)(cloudId),
                    useOAuthHandlers: (0, $gGFxq.useOAuthHandlers),
                    fireAnalyticsEvent: fireAnalyticsEvent
                })
            })
        });
    }
    return null;
};
























const $c87f95dd2abf5b51$var$LeapQuery = ({ searchQuery: searchQuery, originalQuery: originalQuery, primaryProduct: primaryProduct, logError: logError })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const [{ candidates: candidates, titleIndex: titleIndex, loading: loading }, setLeapQuery] = (0, $42omo.useState)(()=>{
        const response = searchQuery && primaryProduct ? (0, $126976b62166fe6c$export$1aafcd2cfb41dc92)({
            query: searchQuery,
            product: primaryProduct
        }).getValue() : undefined;
        return {
            candidates: response?.candidates || [],
            titleIndex: response?.title || 0,
            loading: searchQuery && primaryProduct ? !response : false
        };
    });
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const hasCandidates = candidates.length > 0;
    const analyticsDataRef = (0, $42omo.useRef)({
        fireAnalyticsEvent: fireAnalyticsEvent,
        commonAttributes: commonAttributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes,
        titleIndex: titleIndex
    });
    // Hack to ensure that the analytics data is not stale
    analyticsDataRef.current = {
        fireAnalyticsEvent: fireAnalyticsEvent,
        commonAttributes: commonAttributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes,
        titleIndex: titleIndex
    };
    (0, $42omo.useEffect)(()=>{
        if (!searchQuery || !primaryProduct || hasCandidates) return;
        setLeapQuery((prevState)=>({
                ...prevState,
                loading: true
            }));
        (0, $126976b62166fe6c$export$1aafcd2cfb41dc92)({
            query: searchQuery,
            product: primaryProduct
        }).then((response)=>{
            setLeapQuery({
                candidates: response.candidates,
                titleIndex: response.title,
                loading: false
            });
        }).catch((e)=>{
            setLeapQuery({
                candidates: [],
                titleIndex: 0,
                loading: false
            });
            logError(e);
        });
    }, [
        hasCandidates,
        searchQuery,
        primaryProduct,
        setLeapQuery,
        logError
    ]);
    const mappedCandidates = (0, $42omo.useMemo)(()=>candidates.slice(0, 4).map((candidate)=>({
                label: candidate,
                href: generateSearchUrl({
                    ...queryParams,
                    text: candidate,
                    originalQuery: originalQuery
                })
            })), [
        candidates,
        generateSearchUrl,
        originalQuery,
        queryParams
    ]);
    const handleCandidateClicked = (candidateIndex)=>{
        fireAnalyticsEvent((0, $5402f5bed179af85$export$cdb486deb3bf42a6)({
            candidateIndex: candidateIndex,
            titleIndex: titleIndex,
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    };
    (0, $42omo.useEffect)(()=>{
        if (loading || mappedCandidates.length === 0) return;
        const { fireAnalyticsEvent: fireAnalyticsEvent, titleIndex: titleIndex, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = analyticsDataRef.current;
        fireAnalyticsEvent((0, $e40b2724d9f27471$export$4f8c03bff03c2688)({
            candidatesCount: mappedCandidates.length,
            titleIndex: titleIndex,
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        mappedCandidates.length,
        loading,
        analyticsDataRef
    ]);
    if (!loading && mappedCandidates.length === 0) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        role: "listitem",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $39e2a93ffdbf67f4$export$2e2bcd8739ae039), {
            candidates: mappedCandidates,
            loading: loading,
            titleIndex: titleIndex,
            handleCandidateClicked: handleCandidateClicked
        })
    });
};
const $c87f95dd2abf5b51$export$9b91afdfe0a13e1a = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
        section: "SearchPageLeapQuery",
        children: /*#__PURE__*/ (0, $l998X.jsx)($c87f95dd2abf5b51$var$LeapQuery, {
            ...props
        })
    });





/**
 * @generated SignedSource<<be1726c8b565ae8014912141c09b1fdb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f2155b61e0619eb7$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "includeIconUrl",
        "variableName": "includeIconUrl"
    }, v1 = [
        v0 /*: any*/ 
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeAssets"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeAssigneeField"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeIconUrl"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeNavBoostScore"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includePassionfruitAsk"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includePositions"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeThirdPartyId"
            }
        ],
        "kind": "Fragment",
        "name": "searchResultRenderer_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "args": v1 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "searchAtlasGoal_AtlassianSearchPage"
            },
            {
                "args": v1 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "searchAtlasProject_AtlassianSearchPage"
            },
            {
                "kind": "FragmentSpread",
                "name": "searchFederatedResult_AtlassianSearchPage"
            },
            {
                "kind": "FragmentSpread",
                "name": "searchCompassComponent_AtlassianSearchPage"
            },
            {
                "args": [
                    v0 /*: any*/ ,
                    {
                        "kind": "Variable",
                        "name": "includeNavBoostScore",
                        "variableName": "includeNavBoostScore"
                    }
                ],
                "kind": "FragmentSpread",
                "name": "searchConfluencePageBlogAttachment_AtlassianSearchPage"
            },
            {
                "args": v1 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "searchConfluenceSpace_AtlassianSearchPage"
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "includeThirdPartyId",
                        "variableName": "includeThirdPartyId"
                    }
                ],
                "kind": "FragmentSpread",
                "name": "searchGraphResult_AtlassianSearchPage"
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "includeAssigneeField",
                        "variableName": "includeAssigneeField"
                    }
                ],
                "kind": "FragmentSpread",
                "name": "searchJiraIssue_AtlassianSearchPage"
            },
            {
                "kind": "FragmentSpread",
                "name": "searchJiraProject_AtlassianSearchPage"
            },
            {
                "kind": "FragmentSpread",
                "name": "searchJiraPlan_AtlassianSearchPage"
            },
            {
                "kind": "FragmentSpread",
                "name": "searchJiraBoard_AtlassianSearchPage"
            },
            {
                "kind": "FragmentSpread",
                "name": "searchJiraDashboard_AtlassianSearchPage"
            },
            {
                "kind": "FragmentSpread",
                "name": "searchJiraFilter_AtlassianSearchPage"
            },
            {
                "kind": "FragmentSpread",
                "name": "searchMercuryFocusArea_AtlassianSearchPage"
            },
            {
                "kind": "FragmentSpread",
                "name": "searchMercuryFocusAreaUpdate_AtlassianSearchPage"
            },
            {
                "condition": "includePassionfruitAsk",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "searchPassionfruitAsk_AtlassianSearchPage"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "searchTrello_AtlassianSearchPage"
            },
            {
                "condition": "includeAssets",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "searchAssetsObjectSchema_AtlassianSearchPage"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "searchAssetsObjectType_AtlassianSearchPage"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "searchAssetsObject_AtlassianSearchPage"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "searchDefaultRenderer_AtlassianSearchPage"
            },
            {
                "condition": "includePositions",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "searchTalentPosition_AtlassianSearchPage"
                    }
                ]
            }
        ],
        "type": "SearchResult",
        "abstractKey": "__isSearchResult"
    };
}();
$f2155b61e0619eb7$var$node.hash = "de93a8650efc9696fc8f74517df97c82";
var $f2155b61e0619eb7$export$2e2bcd8739ae039 = $f2155b61e0619eb7$var$node;


parcelRequire("42omo");













/**
 * @generated SignedSource<<64ad9ded13ce559d96ecf4b738a2e6bd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fe1d7af275809cbe$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "searchAssetsObject_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "lastModifiedDate"
        },
        {
            "concreteType": "AssetsSchema",
            "kind": "LinkedField",
            "name": "objectSchemaEntity",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        },
        {
            "concreteType": "AssetsObject",
            "kind": "LinkedField",
            "name": "objectEntity",
            "plural": false,
            "selections": [
                {
                    "concreteType": "AssetsAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "url48"
                        }
                    ]
                },
                {
                    "concreteType": "AssetsLinks",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "web"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "SearchResultAssetsObject"
};
$fe1d7af275809cbe$var$node.hash = "0eea183c12ea41b63de705e78bddf666";
var $fe1d7af275809cbe$export$2e2bcd8739ae039 = $fe1d7af275809cbe$var$node;













































const $def5c503597c8977$var$SchemaMetadata = ({ schemaName: schemaName })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.050",
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($226KS))), {
                size: "small",
                label: ""
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                color: "inherit",
                children: schemaName
            })
        ]
    });
};
const $def5c503597c8977$export$7afb78c1a6844ab6 = ({ node: node, position: position, searchSessionId: searchSessionId, primaryProduct: primaryProduct, selectedProduct: selectedProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $fe1d7af275809cbe$export$2e2bcd8739ae039), node);
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const url = (0, $42omo.useMemo)(()=>{
        const webUrl = data.objectEntity?.links?.web;
        if (!webUrl) return null;
        return (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
            url: webUrl,
            searchSessionId: searchSessionId
        });
    }, [
        data.objectEntity?.links?.web,
        searchSessionId
    ]);
    const getLastModified = (0, $42omo.useMemo)(()=>{
        if (!data.lastModifiedDate) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
            lastModified: data.lastModifiedDate
        });
    }, [
        data.lastModifiedDate
    ]);
    const headerMetadataParts = [
        [
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                type: data.type
            })
        ],
        ...data.objectSchemaEntity?.name ? [
            [
                'schema',
                /*#__PURE__*/ (0, $l998X.jsx)($def5c503597c8977$var$SchemaMetadata, {
                    schemaName: data.objectSchemaEntity.name
                })
            ]
        ] : [],
        [
            'lastModified',
            getLastModified
        ]
    ];
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        return (0, $Y34Hw.enrichExcerpt)(data.title);
    }, [
        data.title
    ]);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        return (0, $Y34Hw.enrichExcerpt)(data.description);
    }, [
        data.description
    ]);
    const icon = (0, $42omo.useMemo)(()=>{
        return (0, $2waBy.getAssetsEntityIcon)({
            iconUrl: data.objectEntity?.avatar?.url48,
            type: data.type,
            size: 'medium'
        });
    }, [
        data.objectEntity?.avatar?.url48,
        data.type
    ]);
    if (!url) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Assets,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        icon: icon,
        headerMetadataParts: headerMetadataParts,
        title: enrichedTitle,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: enrichedDescription
        }),
        position: position,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $def5c503597c8977$export$4cdaf9794367deaa = (node)=>{
    return node?.__typename === 'SearchResultAssetsObject';
};





/**
 * @generated SignedSource<<6a4db8c788f61658f991d203d719bd43>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $89b45b1aab34744d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "searchAssetsObjectSchema_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "lastModifiedDate"
        },
        {
            "concreteType": "AssetsSchema",
            "kind": "LinkedField",
            "name": "objectSchemaEntity",
            "plural": false,
            "selections": [
                {
                    "concreteType": "AssetsLinks",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "web"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "SearchResultAssetsObjectSchema"
};
$89b45b1aab34744d$var$node.hash = "34ba06a2a15f2dcbbea5dad1112fecb2";
var $89b45b1aab34744d$export$2e2bcd8739ae039 = $89b45b1aab34744d$var$node;





































const $b28fdd1f3658a84e$export$33645cba5cb4e74d = ({ node: node, position: position, searchSessionId: searchSessionId, primaryProduct: primaryProduct, selectedProduct: selectedProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $89b45b1aab34744d$export$2e2bcd8739ae039), node);
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const url = (0, $42omo.useMemo)(()=>{
        const webUrl = data.objectSchemaEntity?.links?.web;
        if (!webUrl) return null;
        return (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
            url: webUrl,
            searchSessionId: searchSessionId
        });
    }, [
        data.objectSchemaEntity?.links?.web,
        searchSessionId
    ]);
    const getLastModified = (0, $42omo.useMemo)(()=>{
        if (!data.lastModifiedDate) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
            lastModified: data.lastModifiedDate
        });
    }, [
        data.lastModifiedDate
    ]);
    const headerMetadataParts = [
        [
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                type: data.type
            })
        ],
        [
            'lastModified',
            getLastModified
        ]
    ];
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        return (0, $Y34Hw.enrichExcerpt)(data.title);
    }, [
        data.title
    ]);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        return (0, $Y34Hw.enrichExcerpt)(data.description);
    }, [
        data.description
    ]);
    if (!url) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Assets,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        icon: (0, $2waBy.getAssetsEntityIcon)({
            iconUrl: null,
            type: data.type,
            size: 'medium'
        }),
        headerMetadataParts: headerMetadataParts,
        title: enrichedTitle,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: enrichedDescription
        }),
        position: position,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $b28fdd1f3658a84e$export$7b84b51bda14a6a0 = (node)=>{
    return node?.__typename === 'SearchResultAssetsObjectSchema';
};





/**
 * @generated SignedSource<<eb3e6b3b9f69b79b0658c3d6588e4b21>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0f388f25e3fcca4e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "searchAssetsObjectType_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "lastModifiedDate"
        },
        {
            "concreteType": "AssetsSchema",
            "kind": "LinkedField",
            "name": "objectSchemaEntity",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        },
        {
            "concreteType": "AssetsObjectType",
            "kind": "LinkedField",
            "name": "objectTypeEntity",
            "plural": false,
            "selections": [
                {
                    "concreteType": "AssetsIcon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "url48"
                        }
                    ]
                },
                {
                    "concreteType": "AssetsLinks",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "web"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "SearchResultAssetsObjectType"
};
$0f388f25e3fcca4e$var$node.hash = "413e6bbad4a1a59e111fea1b1a76dab9";
var $0f388f25e3fcca4e$export$2e2bcd8739ae039 = $0f388f25e3fcca4e$var$node;













































const $3910a17689cc33ca$var$SchemaMetadata = ({ schemaName: schemaName })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.050",
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($226KS))), {
                size: "small",
                label: ""
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                color: "inherit",
                children: schemaName
            })
        ]
    });
};
const $3910a17689cc33ca$export$9f67e5fd0627a72b = ({ node: node, position: position, searchSessionId: searchSessionId, primaryProduct: primaryProduct, selectedProduct: selectedProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $0f388f25e3fcca4e$export$2e2bcd8739ae039), node);
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const url = (0, $42omo.useMemo)(()=>{
        const webUrl = data.objectTypeEntity?.links?.web;
        if (!webUrl) return null;
        return (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
            url: webUrl,
            searchSessionId: searchSessionId
        });
    }, [
        data.objectTypeEntity?.links?.web,
        searchSessionId
    ]);
    const getLastModified = (0, $42omo.useMemo)(()=>{
        if (!data.lastModifiedDate) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
            lastModified: data.lastModifiedDate
        });
    }, [
        data.lastModifiedDate
    ]);
    const headerMetadataParts = [
        [
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                type: data.type
            })
        ],
        ...data.objectSchemaEntity?.name ? [
            [
                'schema',
                /*#__PURE__*/ (0, $l998X.jsx)($3910a17689cc33ca$var$SchemaMetadata, {
                    schemaName: data.objectSchemaEntity.name
                })
            ]
        ] : [],
        [
            'lastModified',
            getLastModified
        ]
    ];
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        return (0, $Y34Hw.enrichExcerpt)(data.title);
    }, [
        data.title
    ]);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        return (0, $Y34Hw.enrichExcerpt)(data.description);
    }, [
        data.description
    ]);
    const icon = (0, $42omo.useMemo)(()=>{
        return (0, $2waBy.getAssetsEntityIcon)({
            iconUrl: data.objectTypeEntity?.icon?.url48,
            type: data.type,
            size: 'medium'
        });
    }, [
        data.objectTypeEntity?.icon?.url48,
        data.type
    ]);
    if (!url) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Assets,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        icon: icon,
        headerMetadataParts: headerMetadataParts,
        title: enrichedTitle,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: enrichedDescription
        }),
        position: position,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $3910a17689cc33ca$export$510b7ec52c081a20 = (node)=>{
    return node?.__typename === 'SearchResultAssetsObjectType';
};





/**
 * @generated SignedSource<<a026ebde5307fa9a101b345aaf2974d4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $43dfb553b2241053$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "description"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeIconUrl"
            }
        ],
        "kind": "Fragment",
        "name": "searchAtlasGoal_AtlassianSearchPage",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "goalTitleMetadata_AtlassianSearchPage"
            },
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "ScalarField",
                "name": "title"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "url"
            },
            {
                "condition": "includeIconUrl",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    }
                ]
            },
            {
                "concreteType": "TownsquareGoal",
                "kind": "LinkedField",
                "name": "goal",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    v0 /*: any*/ 
                ]
            }
        ],
        "type": "SearchResultAtlasGoal"
    };
}();
$43dfb553b2241053$var$node.hash = "5d37968657dd4ac5331c73def0a72966";
var $43dfb553b2241053$export$2e2bcd8739ae039 = $43dfb553b2241053$var$node;




















































/**
 * @generated SignedSource<<051ca75b05babe7abff7c6a2766d0b31>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $21524b73e3a6a6c6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "goalTitleMetadata_AtlassianSearchPage",
    "selections": [
        {
            "concreteType": "TownsquareGoal",
            "kind": "LinkedField",
            "name": "goal",
            "plural": false,
            "selections": [
                {
                    "concreteType": "TownsquareStatus",
                    "kind": "LinkedField",
                    "name": "status",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "TownsquareLocalizationField",
                            "kind": "LinkedField",
                            "name": "localizedLabel",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "messageId"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "score"
                        }
                    ]
                },
                {
                    "concreteType": "TownsquareTargetDate",
                    "kind": "LinkedField",
                    "name": "targetDate",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "label"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "SearchResultAtlasGoal"
};
$21524b73e3a6a6c6$var$node.hash = "c30318c731fc2ff06bbb542cb5aa234a";
var $21524b73e3a6a6c6$export$2e2bcd8739ae039 = $21524b73e3a6a6c6$var$node;


parcelRequire("42omo");














const $70dc1f0f601efdf3$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    for: {
        id: "search-page.atlas.goal.for",
        defaultMessage: "for"
    },
    'townsquare.api.goal-state.archived': {
        id: "seaech-page.townsquare.api.goal-state.archived",
        defaultMessage: "Archived"
    },
    'townsquare.api.goal-state.off-track': {
        id: "seaech-page.townsquare.api.goal-state.off-track",
        defaultMessage: "Off track"
    },
    'townsquare.api.goal-state.at-risk': {
        id: "seaech-page.townsquare.api.goal-state.at-risk",
        defaultMessage: "At risk"
    },
    'townsquare.api.goal-state.on-track': {
        id: "seaech-page.townsquare.api.goal-state.on-track",
        defaultMessage: "On track"
    },
    'townsquare.api.goal-state.pending': {
        id: "seaech-page.townsquare.api.goal-state.pending",
        defaultMessage: "Pending"
    },
    'townsquare.api.goal-state.paused': {
        id: "seaech-page.townsquare.api.goal-state.paused",
        defaultMessage: "Paused"
    },
    'townsquare.api.goal-state.completed': {
        id: "seaech-page.townsquare.api.goal-state.completed",
        defaultMessage: "Completed"
    },
    'townsquare.api.goal-state.cancelled': {
        id: "seaech-page.townsquare.api.goal-state.cancelled",
        defaultMessage: "Cancelled"
    }
});


const $a32c5e145f28a188$export$4c3ec08c664f4c95 = ({ metadata: metadata })=>{
    const data = (0, $irOoi.useFragment)((0, $21524b73e3a6a6c6$export$2e2bcd8739ae039), metadata);
    let statusLozenge = null;
    const messageKey = data.goal?.status?.localizedLabel?.messageId;
    const statusLabel = (0, $70dc1f0f601efdf3$export$defe85febe8b728c)[messageKey] ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...(0, $70dc1f0f601efdf3$export$defe85febe8b728c)[messageKey]
    }) : null;
    const statusValue = data.goal?.status?.value;
    const statusScore = data.goal?.status?.score ?? null;
    const date = data.goal?.targetDate?.label;
    if (statusLabel && statusValue) statusLozenge = /*#__PURE__*/ (0, $l998X.jsx)((0, $f2f03c9fb6d1a105$export$689bde3f7e9a94ec), {
        statusValue: statusValue,
        statusLabel: statusLabel,
        statusScore: statusScore,
        date: date
    });
    const titleMetadataParts = [
        [
            'status',
            statusLozenge
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a7nUd.SearchMetadata), {
        parts: titleMetadataParts,
        displaySpacer: false
    });
};


const $5b3efb581ea6b58d$export$bd12cc2939091aab = ({ node: node, position: position, searchQuery: searchQuery, searchSessionId: searchSessionId, primaryProduct: primaryProduct, selectedProduct: selectedProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $43dfb553b2241053$export$2e2bcd8739ae039), node);
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const url = (0, $42omo.useMemo)(()=>{
        return (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
            url: data.url,
            searchSessionId: searchSessionId
        });
    }, [
        data.url,
        searchSessionId
    ]);
    const headerMetadataParts = [
        [
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                type: data.type
            })
        ]
    ];
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        const prefix = data.goal?.key;
        if (prefix) return (0, $Y34Hw.enrichExcerpt)(prefix.concat('\u2002', data.title));
        return (0, $Y34Hw.enrichExcerpt)(data.title);
    }, [
        data.title,
        data.goal?.key
    ]);
    const description = $5b3efb581ea6b58d$var$getDescription(data);
    const excerptDescription = data.description;
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        if (excerptDescription) return (0, $Y34Hw.enrichExcerpt)(excerptDescription);
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(description, searchQuery.split(' '));
        if (!highlightedTitle) return description;
        return (0, $Y34Hw.processExcerpt)(highlightedTitle);
    }, [
        description,
        excerptDescription,
        searchQuery
    ]);
    let icon;
    if ((0, $dh538.fg)('rovo_search_confluence_icons_fps')) icon = (0, $2waBy.getAtlasEntityIcon)({
        iconUrl: data.iconUrl,
        type: data.type,
        size: 'medium'
    });
    else icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $aRSt4.ProductIcon), {
        product: (0, $1yEFx.ProductKeys).Atlas,
        label: "Atlas"
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Atlas,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        icon: icon,
        headerMetadataParts: headerMetadataParts,
        titleMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $a32c5e145f28a188$export$4c3ec08c664f4c95), {
            metadata: data
        }),
        title: enrichedTitle,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $5b3efb581ea6b58d$var$descriptionContainerStyles,
            testId: "search-page-atlas-result-description",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
                description: enrichedDescription
            })
        }),
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $5b3efb581ea6b58d$export$e232933b3399051b = (node)=>{
    return node?.id?.includes('townsquare') && node?.__typename === 'SearchResultAtlasGoal';
};
const $5b3efb581ea6b58d$var$descriptionContainerStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    maxHeight: '60px'
});
const $5b3efb581ea6b58d$var$getDescription = (data)=>{
    let description = '';
    if (!data.goal?.description) return '';
    const parsedDescrption = JSON.parse(data.goal.description);
    // Recursive function to build the description. Traversal occurs in DFS
    // order. The base case is when the node is a text node, in which case
    // the text is appended to the description.
    const buildDescription = (goalDescription)=>{
        if (goalDescription.content) goalDescription.content.forEach(buildDescription);
        else if (goalDescription.type === 'text') description += goalDescription.text;
    };
    if (parsedDescrption.content) buildDescription(parsedDescrption);
    return description;
};





/**
 * @generated SignedSource<<210d27cdc68a4ccef4f47abadb13c9dd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a8823c5e0fe3b2bf$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "includeIconUrl"
        }
    ],
    "kind": "Fragment",
    "name": "searchAtlasProject_AtlassianSearchPage",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "projectTitleMetadata_AtlassianSearchPage"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        },
        {
            "condition": "includeIconUrl",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "iconUrl"
                }
            ]
        },
        {
            "concreteType": "TownsquareProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                }
            ]
        }
    ],
    "type": "SearchResultAtlasProject"
};
$a8823c5e0fe3b2bf$var$node.hash = "5648bed532cee859541b1023161a3504";
var $a8823c5e0fe3b2bf$export$2e2bcd8739ae039 = $a8823c5e0fe3b2bf$var$node;












































/**
 * @generated SignedSource<<07d65e14805f69dd4d948c910445d6fa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0ae82f3cd79894a4$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "label"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "projectTitleMetadata_AtlassianSearchPage",
        "selections": [
            {
                "concreteType": "TownsquareProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isPrivate"
                    },
                    {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "dueDate",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "TownsquareProjectState",
                        "kind": "LinkedField",
                        "name": "state",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "SearchResultAtlasProject"
    };
}();
$0ae82f3cd79894a4$var$node.hash = "e1cfd426806d5804439f761565129f8f";
var $0ae82f3cd79894a4$export$2e2bcd8739ae039 = $0ae82f3cd79894a4$var$node;


parcelRequire("42omo");









const $bba4b470addb2f7e$export$f20eb787e62d666a = ({ metadata: metadata })=>{
    const data = (0, $irOoi.useFragment)((0, $0ae82f3cd79894a4$export$2e2bcd8739ae039), metadata);
    let statusLozenge = null;
    if (data.project?.state?.label && data.project?.state?.value) statusLozenge = /*#__PURE__*/ (0, $l998X.jsx)((0, $f2f03c9fb6d1a105$export$689bde3f7e9a94ec), {
        statusValue: data.project.state.value,
        statusLabel: data.project.state.label,
        statusScore: null,
        date: data.project.dueDate?.label
    });
    const titleMetadataParts = [
        [
            'is-private-project',
            data.project?.isPrivate && /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
                permissionLevel: "restricted",
                iconColour: "var(--ds-icon-accent-red, #C9372C)"
            })
        ],
        [
            'status',
            statusLozenge
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a7nUd.SearchMetadata), {
        parts: titleMetadataParts,
        displaySpacer: false
    });
};


const $e69dcf232ee4a7ce$export$a77407ffacf1d445 = ({ node: node, position: position, searchSessionId: searchSessionId, primaryProduct: primaryProduct, selectedProduct: selectedProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $a8823c5e0fe3b2bf$export$2e2bcd8739ae039), node);
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        const prefix = data.project?.key;
        if (prefix) return (0, $Y34Hw.enrichExcerpt)(prefix.concat('\u2002', data.title));
        return (0, $Y34Hw.enrichExcerpt)(data.title);
    }, [
        data.title,
        data.project?.key
    ]);
    const url = (0, $42omo.useMemo)(()=>{
        return (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
            url: data.url,
            searchSessionId: searchSessionId
        });
    }, [
        data.url,
        searchSessionId
    ]);
    const headerMetadataParts = [
        [
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                type: data.type
            })
        ]
    ];
    let icon;
    if ((0, $dh538.fg)('rovo_search_confluence_icons_fps')) icon = (0, $2waBy.getAtlasEntityIcon)({
        iconUrl: data.iconUrl,
        type: data.type,
        size: 'medium'
    });
    else icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $aRSt4.ProductIcon), {
        product: (0, $1yEFx.ProductKeys).Atlas,
        label: "Atlas"
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Atlas,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        icon: icon,
        headerMetadataParts: headerMetadataParts,
        titleMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $bba4b470addb2f7e$export$f20eb787e62d666a), {
            metadata: data
        }),
        title: enrichedTitle,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $e69dcf232ee4a7ce$export$eb74eda5abb6ce2f = (node)=>{
    return node?.id?.includes('townsquare') && node?.__typename === 'SearchResultAtlasProject';
};





/**
 * @generated SignedSource<<9197ea5d60c5b86469743dc448ff733b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5e8fd04d68dc4ae1$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "description"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchCompassComponent_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "ScalarField",
                "name": "title"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "url"
            },
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "kind": "ScalarField",
                "name": "tier"
            },
            {
                "concreteType": "CompassComponent",
                "kind": "LinkedField",
                "name": "component",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "state"
                    }
                ]
            }
        ],
        "type": "SearchResultCompassComponent"
    };
}();
$5e8fd04d68dc4ae1$var$node.hash = "c2a052c4a3d75d6d671dbff5b4efcf18";
var $5e8fd04d68dc4ae1$export$2e2bcd8739ae039 = $5e8fd04d68dc4ae1$var$node;





















































parcelRequire("42omo");















const $b0cdd31dcea0fac6$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    ownerName: {
        id: "search-page.relay.compass.owner-name",
        defaultMessage: "Owned by {ownerName}"
    }
});


const $7b7252988bd42ac9$export$2e647dc980bb160 = ({ displayName: displayName, isLoading: isLoading = false })=>{
    if (displayName) return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $7b7252988bd42ac9$var$owningTeamStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $b0cdd31dcea0fac6$export$defe85febe8b728c).ownerName,
            values: {
                ownerName: displayName
            }
        })
    });
    if (isLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $1hlFx.MetaDataItemSkeletonWide), {});
};
const $7b7252988bd42ac9$var$owningTeamStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '200px'
});





const $dc82fcf7bf8dd4c4$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    tier: {
        id: "search-page.relay.compass.tier",
        defaultMessage: "Tier {tier}"
    }
});


const $e4107ff9b0892e16$export$e206de30029925c0 = ({ node: node, position: position, searchQuery: searchQuery, searchSessionId: searchSessionId, primaryProduct: primaryProduct, selectedProduct: selectedProduct, appMode: appMode, cloudId: cloudId, compassTeamName: compassTeamName, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $5e8fd04d68dc4ae1$export$2e2bcd8739ae039), node);
    const { id: id, title: title, tier: tier, component: component, lastModifiedDate: lastModifiedDate, type: type, description: description } = data;
    const { state: state, description: componentDescription } = component || {};
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(id);
        return {
            id: id,
            containerId: null,
            spaceId: null,
            contentType: type,
            entityType: type,
            contentId: contentId,
            product: product
        };
    }, [
        id,
        type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const url = (0, $42omo.useMemo)(()=>{
        return (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
            url: data.url,
            searchSessionId: searchSessionId
        });
    }, [
        data.url,
        searchSessionId
    ]);
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        return (0, $Y34Hw.enrichExcerpt)(title);
    }, [
        title
    ]);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        if (description) return (0, $Y34Hw.processExcerpt)(description);
        const reducedDescription = (0, $bOpS4.truncateTextWithQuery)(componentDescription, searchQuery);
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(reducedDescription, searchQuery.split(' '));
        if (!highlightedTitle) return reducedDescription;
        return (0, $Y34Hw.processExcerpt)(highlightedTitle);
    }, [
        componentDescription,
        description,
        searchQuery
    ]);
    const titleMetadataParts = (0, $42omo.useMemo)(()=>[
            [
                'componentState',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $fcee77680d43964f$export$e21059a573e71ec0), {
                    state: state
                })
            ],
            [
                'tier',
                tier ? /*#__PURE__*/ (0, $l998X.jsx)($e4107ff9b0892e16$var$Tier, {
                    tier: tier
                }) : null
            ]
        ], [
        state,
        tier
    ]);
    const headerMetadataParts = (0, $42omo.useMemo)(()=>[
            [
                'type',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                    type: type
                })
            ],
            [
                'ownerName',
                compassTeamName || compassTeamName === undefined ? // we need to pass data.ownerName here rather than unconditionally rendering this component
                // as sometimes there is no owner to render, which results in `• •` showing up in the metadata
                /*#__PURE__*/ (0, $l998X.jsx)((0, $7b7252988bd42ac9$export$2e647dc980bb160), {
                    displayName: compassTeamName,
                    isLoading: compassTeamName === undefined
                }) : null
            ],
            [
                'lastModified',
                lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                    lastModified: lastModifiedDate
                }) : null
            ]
        ], [
        type,
        compassTeamName,
        lastModifiedDate
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Compass,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        url: url,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.CompassIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        title: enrichedTitle,
        titleMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $a7nUd.SearchMetadata), {
            parts: titleMetadataParts,
            displaySpacer: false
        }),
        headerMetadataParts: headerMetadataParts,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: enrichedDescription
        }),
        cloudId: cloudId,
        position: position,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $e4107ff9b0892e16$export$3ea06079dfb7d39c = (node)=>{
    return node?.__typename === 'SearchResultCompassComponent';
};
const $e4107ff9b0892e16$var$Tier = ({ tier: tier })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
        appearance: 'default',
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $dc82fcf7bf8dd4c4$export$defe85febe8b728c).tier,
            values: {
                tier: tier
            }
        })
    });





/**
 * @generated SignedSource<<66f6bbddd0067bd9f5f81957cd39c8cb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e0ddc7b382b65af0$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "description"
    }, v2 = {
        "kind": "ScalarField",
        "name": "title"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "ScalarField",
        "name": "url"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "subtype"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeIconUrl"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeNavBoostScore"
            },
            {
                "kind": "RootArgument",
                "name": "tenantId"
            }
        ],
        "kind": "Fragment",
        "name": "searchConfluencePageBlogAttachment_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "lastModified"
            },
            {
                "kind": "ScalarField",
                "name": "isVerified"
            },
            {
                "condition": "includeIconUrl",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    }
                ]
            },
            {
                "condition": "includeNavBoostScore",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "navBoostScore"
                    }
                ]
            },
            {
                "concreteType": "SearchConfluenceResultSpace",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "webUiLink"
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "name": "confluenceEntity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v6 /*: any*/ ,
                            {
                                "concreteType": "ConfluenceCommentCountSummary",
                                "kind": "LinkedField",
                                "name": "commentCountSummary",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "total"
                                    }
                                ]
                            },
                            {
                                "concreteType": "ConfluenceLikesSummary",
                                "kind": "LinkedField",
                                "name": "likesSummary",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "count"
                                    }
                                ]
                            }
                        ],
                        "type": "ConfluencePage"
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "tenantId",
                        "variableName": "tenantId"
                    }
                ],
                "concreteType": "SocialSignalSearch",
                "kind": "LinkedField",
                "name": "socialSignal",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "signal"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "timestamp"
                    },
                    {
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "accountId"
                            },
                            v5 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "picture"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "email"
                                    },
                                    {
                                        "concreteType": "AtlassianAccountUserExtendedProfile",
                                        "kind": "LinkedField",
                                        "name": "extendedProfile",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "jobTitle"
                                            }
                                        ]
                                    }
                                ],
                                "type": "AtlassianAccountUser"
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v2 /*: any*/ ,
                    v4 /*: any*/ ,
                    v3 /*: any*/ ,
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "lastModifiedDate"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    v6 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchConfluencePageBlogAttachment"
    };
}();
$e0ddc7b382b65af0$var$node.hash = "8a2e47b7232da07cc9c5817ff662b1e1";
var $e0ddc7b382b65af0$export$2e2bcd8739ae039 = $e0ddc7b382b65af0$var$node;



























parcelRequire("42omo");







/* ConfluenceResultCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $bYRk6 = parcelRequire("bYRk6");
















var $eMz0l = parcelRequire("eMz0l");
























var $kF5LJ = parcelRequire("kF5LJ");
















const $761cfb03749ba18a$export$e67cfd67e64df0f4 = 'KnowledgeDiscoveryConfluencePageContributorsQuery';
const $761cfb03749ba18a$export$2603e533e340cb6b = `
query KnowledgeDiscoveryConfluencePageContributorsQuery($id: ID!) {
  contributorsLinkedToConfluencePageV2(pageId: $id) {
    queryResult {
      rows {
        __typename
        rowItems {
          key
          value {
            id
            data {
              __typename
              ... on AtlassianAccountUser {
                __typename
                name
                picture
                accountId
                canonicalAccountId
              }
            }
          }
        }
      }
    }
  }
}
`;


const $faf08354a609221e$export$200e3b64ac0020f0 = async ({ id: id, workspaceId: workspaceId, cloudId: cloudId, product: product })=>{
    try {
        const contributors = [];
        const { data: data, errors: errors } = await (0, $9EFEY.fetchAggResponse)({
            graphQuery: (0, $761cfb03749ba18a$export$2603e533e340cb6b),
            variables: {
                id: id
            },
            operationName: (0, $761cfb03749ba18a$export$e67cfd67e64df0f4),
            headers: {
                ...(0, $6yuru.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: cloudId,
                    product: product
                }),
                'X-Query-Context': workspaceId
            }
        });
        if (errors) {
            (0, $4Zqgi.logger).error({
                error: errors[0],
                functionName: 'getConfluenceContributors'
            });
            return null;
        }
        data?.contributorsLinkedToConfluencePageV2.queryResult.rows.forEach((row)=>{
            row.rowItems.forEach((item, index)=>{
                const type = row.rowItems[index].key;
                if (item.value && item.value.length > 0 && (type === 'creator' || type === 'owner' || type === 'editor' || type === 'commentor' || type === 'tagged')) item.value.forEach((contributor)=>{
                    contributors.push({
                        ...contributor,
                        type: type
                    });
                });
            });
        });
        return contributors;
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'getConfluenceContributors'
        });
        return null;
    }
};











const $ea64f11ff5214fe6$export$84a5087b650d8963 = 'KnowledgeDiscoveryConfluencePageOutgoingLinksQuery';
const $ea64f11ff5214fe6$export$f0f6c9d061558c7c = `
query KnowledgeDiscoveryConfluencePageOutgoingLinksQuery($id: ID!) {
  linksOutgoingFromConfluencePage(pageId: $id) {
    queryResult {
      rows {
        __typename
        rowItems {
          key
          value {
            id
            data {
              __typename
              ... on ConfluencePage {
                __typename
                id
                title
                latestVersion {
                  createdAt
                }
                links {
                  base
                  webUi
                }
                author {
                  user {
                    name
                    picture
                    canonicalAccountId
                  }
                }
              }
              ... on JiraIssue {
                __typename
                id
                summary
                issueTypeAvatarUrl
                updatedField {
                  dateTime
                }
                reporter {
                  name
                  picture
                  canonicalAccountId
                }
                webUrl
              }
            }
          }
        }
      }
    }
  }
}
`;


const $6edc5dd1f640e937$export$a65921bf7e72ea90 = (item)=>{
    const itemData = item.value[0].data;
    if (!itemData) return undefined;
    else if (itemData.__typename === 'ConfluencePage') return Boolean(itemData.links?.base) && Boolean(itemData.links?.webUi) ? `${itemData.links.base}${itemData.links.webUi}` : undefined;
    else if (itemData.__typename === 'JiraIssue') return itemData.webUrl;
};


const $57cda4ad3af70dd3$export$9375c293fc837eed = async ({ id: id, workspaceId: workspaceId, cloudId: cloudId, product: product })=>{
    try {
        const urls = [];
        const { data: data, errors: errors } = await (0, $9EFEY.fetchAggResponse)({
            graphQuery: (0, $ea64f11ff5214fe6$export$f0f6c9d061558c7c),
            variables: {
                id: id
            },
            operationName: (0, $ea64f11ff5214fe6$export$84a5087b650d8963),
            headers: {
                ...(0, $6yuru.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: cloudId,
                    product: product
                }),
                'X-Query-Context': workspaceId
            }
        });
        if (errors) {
            (0, $4Zqgi.logger).error({
                error: errors[0],
                functionName: 'getConfluenceOutgoingLinks'
            });
            return null;
        }
        data?.linksOutgoingFromConfluencePage.queryResult.rows.forEach((row)=>{
            row.rowItems.forEach((item)=>{
                const link = (0, $6edc5dd1f640e937$export$a65921bf7e72ea90)(item);
                if (link) urls.push(link);
            });
        });
        return urls;
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'getConfluenceOutgoingLinks'
        });
        return null;
    }
};


const $7af60c4a5978bce8$export$6ed38de17ee0fdc9 = ({ workspaceId: workspaceId, cloudId: cloudId, product: product, contentId: contentId })=>{
    const [loading, setIsLoading] = (0, $42omo.useState)(true);
    const [error, setError] = (0, $42omo.useState)(false);
    const [contributors, setContributors] = (0, $42omo.useState)([]);
    const [outgoingLinks, setOutgoingLinks] = (0, $42omo.useState)([]);
    (0, $42omo.useEffect)(()=>{
        const getLinkedResults = async ()=>{
            await Promise.allSettled([
                (0, $faf08354a609221e$export$200e3b64ac0020f0)({
                    id: contentId,
                    workspaceId: workspaceId,
                    cloudId: cloudId,
                    product: product
                }),
                (0, $57cda4ad3af70dd3$export$9375c293fc837eed)({
                    id: contentId,
                    workspaceId: workspaceId,
                    cloudId: cloudId,
                    product: product
                })
            ]).then(([contributorsResult, outgoingLinksResult])=>{
                setContributors(contributorsResult.status === 'fulfilled' ? contributorsResult.value || [] : []);
                setOutgoingLinks(outgoingLinksResult.status === 'fulfilled' ? outgoingLinksResult.value || [] : []);
                if (contributorsResult.status === 'rejected' && outgoingLinksResult.status === 'rejected') {
                    (0, $4Zqgi.logger).error({
                        error: contributorsResult.reason || outgoingLinksResult.reason || new Error('Failed to fetch contributors and outgoing links'),
                        functionName: 'useTwgSources'
                    });
                    setError(true);
                }
            }).catch((error)=>{
                (0, $4Zqgi.logger).error({
                    error: error,
                    functionName: 'useTwgSources'
                });
                setError(true);
            }).finally(()=>{
                setIsLoading(false);
            });
        };
        if (Boolean(contentId)) {
            setIsLoading(true);
            getLinkedResults();
        }
    }, [
        cloudId,
        contentId,
        workspaceId,
        product
    ]);
    return {
        loading: loading,
        error: error,
        contributors: contributors,
        outgoingLinks: outgoingLinks
    };
};


/* AdditionInfoSection.tsx generated by @compiled/babel-plugin v0.36.1 */ 



















const $872baa6c44f00b3c$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    sources_icon_stack_text: {
        id: "search_ai.sources_icon_stack_text",
        defaultMessage: "+{count} more"
    },
    contributors_avatar_stack_text: {
        id: "search_ai.contributors_avatar_stack_text",
        defaultMessage: "+{count} more"
    },
    related_links_title: {
        id: "search_ai.related_links_title",
        defaultMessage: "Related Links"
    },
    contributors_title: {
        id: "search_ai.contributors_title",
        defaultMessage: "Collaborators"
    },
    contributors_card_subtitle: {
        id: "search_ai.contributors_card_subtitle",
        defaultMessage: "{type, select, tagged {tagged on this page} other {{type} of this page}}"
    },
    show_less_button_label: {
        id: "search_ai.show_less_button_label",
        defaultMessage: "Show less"
    },
    page_icon_label: {
        id: "search_ai.page_icon_label",
        defaultMessage: "Page Icon"
    },
    globe_icon_label: {
        id: "search_ai.globe_icon_label",
        defaultMessage: "Globe Icon"
    },
    confluence_product_name: {
        id: "search_ai.confluence_product_name",
        defaultMessage: "Confluence"
    },
    webpage_label: {
        id: "search_ai.webpage_label",
        defaultMessage: "Web page"
    },
    contributors_card_hover_profile_link: {
        id: "search_ai.contributors_card_hover_profile_link",
        defaultMessage: "View profile"
    }
});


/* Contributors.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");















/* ContributorAvatarStack.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $2Pg7f = parcelRequire("2Pg7f");






var $fVUfS = parcelRequire("fVUfS");







const $dbb5a6cff0b3b351$var$DEFAULT_MAX_CONTRIBUTORS_IN_STACK = 3;
const $dbb5a6cff0b3b351$var$styles = {
    pressable: "_bfhk1j28",
    avatarGroup: "_t9ec18p1"
};
const $dbb5a6cff0b3b351$export$68ba394a09a9d437 = ({ contributors: contributors, onClick: onClick, isLoading: isLoading, singleColumnLayout: singleColumnLayout = false })=>{
    if (isLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
        height: "20px",
        width: "100px",
        isShimmering: true,
        testId: "contributors-avatar-stack-skeleton"
    });
    const maxContributors = $dbb5a6cff0b3b351$var$DEFAULT_MAX_CONTRIBUTORS_IN_STACK; // Transform to avatar group data format
    const avatarData = contributors.map((contributor, index)=>({
            key: contributor.data.accountId,
            name: contributor.data.name,
            src: contributor.data.picture,
            appearance: 'circle',
            testId: `contributor-avatar-${index}`
        }));
    const remainingContributorsInStack = singleColumnLayout ? avatarData.slice(1, 3) : avatarData.slice(3, 6);
    const remainingContributorsCount = singleColumnLayout ? avatarData.slice(1).length : avatarData.slice(3).length;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        onClick: onClick,
        xcss: $dbb5a6cff0b3b351$var$styles.pressable,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.0",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $dbb5a6cff0b3b351$var$styles.avatarGroup,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Pg7f.default), {
                        appearance: "stack",
                        data: remainingContributorsInStack,
                        size: "small",
                        maxCount: maxContributors,
                        isTooltipDisabled: true,
                        testId: "contributors-avatargroup"
                    })
                }),
                remainingContributorsInStack.length > 0 && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    color: "color.text.subtle",
                    testId: "contributors-avatar-stack-remaining-count",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...(0, $872baa6c44f00b3c$export$defe85febe8b728c).contributors_avatar_stack_text,
                        values: {
                            count: remainingContributorsCount
                        }
                    })
                })
            ]
        })
    });
};


/* ContributorCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 

























var $8j9VY = parcelRequire("8j9VY");


var $ckCUa = parcelRequire("ckCUa");


var $6aPlH = parcelRequire("6aPlH");


var $5iH4l = parcelRequire("5iH4l");


const $a568b3c1722569fb$var$styles = {
    pressable: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _bfhksm61",
    contributorCard: "_4t3i1ylp",
    contributorCardContent: "_y3gn1e5h",
    contributorsCardSubtitle: "_299m1dk0"
};
const $a568b3c1722569fb$export$3f45fa6d1e6fb5fe = ({ contributor: contributor, cloudId: cloudId, onContributorClick: onContributorClick })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { toUser: toUser } = (0, $6aPlH.useTeamsAppLinks)({
        type: (0, $ckCUa.KnowledgeCardsIntentType).PERSON,
        currentUserId: contributor.data.accountId || '',
        cloudId: cloudId
    });
    const profileClient = (0, $42omo.useMemo)(()=>(0, $5iH4l.createProfileClient)(cloudId), [
        cloudId
    ]);
    const onContributorClickHandler = (e)=>{
        onContributorClick('collaborator-link');
        toUser(contributor.data.accountId || '').onNavigate(e);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8j9VY.default), {
        userId: (0, $5iH4l.trimARI)(contributor.data.accountId || ''),
        resourceClient: profileClient,
        actions: [
            {
                label: formatMessage((0, $872baa6c44f00b3c$export$defe85febe8b728c).contributors_card_hover_profile_link),
                link: toUser(contributor.data.accountId || '').href,
                callback: onContributorClickHandler
            }
        ],
        ariaLabel: contributor.data.name,
        position: "bottom-end",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
            onClick: onContributorClickHandler,
            xcss: $a568b3c1722569fb$var$styles.pressable,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.100",
                xcss: $a568b3c1722569fb$var$styles.contributorCard,
                testId: "contributor-card",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
                        size: "small",
                        name: contributor.data.name,
                        src: contributor.data.picture
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                        xcss: $a568b3c1722569fb$var$styles.contributorCardContent,
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                color: "color.text",
                                maxLines: 1,
                                children: contributor.data.name
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $a568b3c1722569fb$var$styles.contributorsCardSubtitle,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    size: "small",
                                    color: "color.text.subtlest",
                                    maxLines: 1,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                        ...(0, $872baa6c44f00b3c$export$defe85febe8b728c).contributors_card_subtitle,
                                        values: {
                                            type: contributor.type
                                        }
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};


const $191637e8e278d6c0$var$DEFAULT_CONTRIBUTORS_TO_DISPLAY_WHEN_COLLAPSED = 3;
const $191637e8e278d6c0$var$MAX_CONTRIBUTORS_TO_DISPLAY = 15;
const $191637e8e278d6c0$var$styles = {
    contributorsTitleContainer: "_otyr1b66",
    singleColumnLayout: "_yv0ehkll",
    multiColumnLayout: "_yv0e16hb"
};
const $191637e8e278d6c0$export$5360f064464e9211 = ({ contributors: contributors, cloudId: cloudId, isExpanded: isExpanded, onExpandToggle: onExpandToggle, onContributorClick: onContributorClick, singleColumnLayout: singleColumnLayout = false })=>{
    const truncatedContributors = contributors.slice(0, $191637e8e278d6c0$var$MAX_CONTRIBUTORS_TO_DISPLAY);
    const contributorsToDisplayWhenCollapsed = singleColumnLayout ? 1 : $191637e8e278d6c0$var$DEFAULT_CONTRIBUTORS_TO_DISPLAY_WHEN_COLLAPSED;
    const contributorsToDisplay = isExpanded ? truncatedContributors : truncatedContributors.slice(0, contributorsToDisplayWhenCollapsed);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                spread: "space-between",
                alignBlock: "center",
                xcss: $191637e8e278d6c0$var$styles.contributorsTitleContainer,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        color: "color.text.subtle",
                        weight: "medium",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $872baa6c44f00b3c$export$defe85febe8b728c).contributors_title
                        })
                    }),
                    truncatedContributors.length > contributorsToDisplayWhenCollapsed && /*#__PURE__*/ (0, $l998X.jsx)((0, $dbb5a6cff0b3b351$export$68ba394a09a9d437), {
                        contributors: truncatedContributors,
                        onClick: onExpandToggle,
                        singleColumnLayout: singleColumnLayout
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $d8SNb.default), {
                rowGap: "space.200",
                columnGap: "space.400",
                xcss: (0, $1Whri.cx)(singleColumnLayout ? $191637e8e278d6c0$var$styles.singleColumnLayout : $191637e8e278d6c0$var$styles.multiColumnLayout),
                children: contributorsToDisplay?.map((contributor)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $a568b3c1722569fb$export$3f45fa6d1e6fb5fe), {
                        contributor: contributor,
                        cloudId: cloudId,
                        onContributorClick: onContributorClick
                    }, contributor.data.accountId))
            })
        ]
    });
};


/* RelatedLinks.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");















/* LinkCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $buthI = parcelRequire("buthI");























const $93ce23c5e9bc03a8$var$styles = {
    link: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz13af _105313af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnx8stv _jf4cnqa1 _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8h12zz",
    iconContainer: "_ca0qv77o"
};
const $93ce23c5e9bc03a8$var$FallbackComponent = ({ url: url, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
        href: url,
        target: "_blank",
        xcss: $93ce23c5e9bc03a8$var$styles.link,
        onClick: (e)=>onClick({
                event: e,
                resourceUrl: url,
                location: 'related-link'
            }),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            alignBlock: "start",
            space: "space.100",
            alignInline: "start",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $93ce23c5e9bc03a8$var$styles.iconContainer,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($buthI))), {
                        label: formatMessage((0, $872baa6c44f00b3c$export$defe85febe8b728c).globe_icon_label),
                        size: "medium"
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.050",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "medium",
                            maxLines: 1,
                            color: "color.link",
                            children: url
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "small",
                            maxLines: 1,
                            color: "color.text.subtle",
                            children: formatMessage((0, $872baa6c44f00b3c$export$defe85febe8b728c).webpage_label)
                        })
                    ]
                })
            ]
        })
    });
};
const $93ce23c5e9bc03a8$export$2c381a86421d5abf = ({ url: url, onClick: onClick })=>{
    const [isReady, setIsReady] = (0, $42omo.useState)(false);
    const [forceFallback, setForceFallback] = (0, $42omo.useState)(false);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    transition: 'visibility 0.3s ease-in-out, opacity 0.3s ease-in-out',
                    visibility: isReady ? 'hidden' : 'visible',
                    opacity: isReady ? 0 : 1,
                    pointerEvents: isReady ? 'none' : 'auto',
                    height: isReady ? 0 : 'auto',
                    width: isReady ? 0 : '100%'
                },
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                    height: 32,
                    width: 200,
                    isShimmering: true
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    transition: 'visibility 0.3s ease-in-out, opacity 0.3s ease-in-out',
                    visibility: isReady ? 'visible' : 'hidden',
                    opacity: isReady ? 1 : 0,
                    pointerEvents: isReady ? 'auto' : 'none',
                    height: isReady ? 'auto' : 0,
                    width: isReady ? '100%' : 0
                },
                children: forceFallback ? /*#__PURE__*/ (0, $l998X.jsx)($93ce23c5e9bc03a8$var$FallbackComponent, {
                    url: url,
                    onClick: onClick
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $hpUsb.Card), {
                    url: url,
                    ui: {
                        removeBlockRestriction: true,
                        hidePadding: true,
                        hideElevation: true,
                        hideBackground: true
                    },
                    appearance: "block",
                    onClick: (e)=>{
                        onClick({
                            event: e,
                            resourceUrl: url,
                            location: 'related-link'
                        });
                    },
                    onResolve: ()=>setIsReady(true),
                    onError: ()=>{
                        setForceFallback(true);
                        setIsReady(true);
                    },
                    fallbackComponent: ()=>/*#__PURE__*/ (0, $l998X.jsx)($93ce23c5e9bc03a8$var$FallbackComponent, {
                            url: url,
                            onClick: onClick
                        }),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5znEc.default), {
                        size: (0, $5TXU5.SmartLinkSize).Medium,
                        subtitle: [
                            {
                                name: (0, $5TXU5.ElementName).ModifiedOn
                            }
                        ],
                        maxLines: 1
                    })
                })
            })
        ]
    });
};


/* LinkIconStack.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




















var $JBlXx = parcelRequire("JBlXx");


var $ehPkL = parcelRequire("ehPkL");


var $dN2lk = parcelRequire("dN2lk");


const $3d12974a4e287534$var$DEFAULT_MAX_SOURCES_IN_STACK = 3;
const $3d12974a4e287534$var$styles = {
    pressable: "_bfhk1j28"
};
const $3d12974a4e287534$export$c1e33b78dff82c3c = ({ sources: sources, onClick: onClick, maxSourcesInStack: maxSourcesInStack, singleColumnLayout: singleColumnLayout = false })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { objectResolverData: resolvedLinks, isLoading: objectResolverLoading } = (0, $JBlXx.useFetchSmartLinkData)({
        urls: sources
    });
    const sourcesForIconStack = [];
    const sourceNamesMap = {};
    maxSourcesInStack = maxSourcesInStack ?? $3d12974a4e287534$var$DEFAULT_MAX_SOURCES_IN_STACK;
    for(let i = 0; i < resolvedLinks.length; i++){
        const source = resolvedLinks[i];
        if (source.generator?.name && !sourceNamesMap[source.generator?.name]) {
            sourcesForIconStack.push(source.generator.name);
            sourceNamesMap[source.generator.name] = true;
        }
        if (sourcesForIconStack.length === maxSourcesInStack) break;
    }
    const remainingSourcesCount = singleColumnLayout ? sources.slice(1).length : sources.slice(2).length;
    if (objectResolverLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
        height: "20px",
        width: "100px",
        isShimmering: true,
        testId: "contributors-avatar-stack-skeleton"
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        onClick: onClick,
        xcss: $3d12974a4e287534$var$styles.pressable,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.050",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $dN2lk.IconStack), {
                    children: sourcesForIconStack.map((source, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $ehPkL.AppIcon), {
                            app: source,
                            size: "xxsmall",
                            fallbackIcon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($buthI))), {
                                label: formatMessage((0, $872baa6c44f00b3c$export$defe85febe8b728c).globe_icon_label),
                                size: "medium"
                            })
                        }, index))
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    color: "color.text.subtle",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...(0, $872baa6c44f00b3c$export$defe85febe8b728c).sources_icon_stack_text,
                        values: {
                            count: remainingSourcesCount
                        }
                    })
                })
            ]
        })
    });
};


const $96012d3f013bc30d$var$DEFAULT_LINKS_TO_DISPLAY_WHEN_COLLAPSED = 2;
const $96012d3f013bc30d$var$MAX_LINKS_TO_DISPLAY = 10;
const $96012d3f013bc30d$var$styles = {
    relatedLinksGrid: "_19pk1b66",
    singleColumnLayout: "_yv0ehkll",
    dualColumnLayout: "_yv0ewxkt",
    relatedLinksTitle: "_4t3i1ul9"
};
const $96012d3f013bc30d$export$a7ff6651352b415b = ({ links: links, isExpanded: isExpanded, onExpandToggle: onExpandToggle, onResourceClick: onResourceClick, singleColumnLayout: singleColumnLayout = false })=>{
    const linksToDisplayWhenCollapsed = singleColumnLayout ? 1 : $96012d3f013bc30d$var$DEFAULT_LINKS_TO_DISPLAY_WHEN_COLLAPSED;
    const truncatedLinks = links.slice(0, $96012d3f013bc30d$var$MAX_LINKS_TO_DISPLAY);
    const linksToDisplay = isExpanded ? truncatedLinks : truncatedLinks.slice(0, linksToDisplayWhenCollapsed);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                spread: "space-between",
                alignBlock: "center",
                xcss: $96012d3f013bc30d$var$styles.relatedLinksTitle,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        color: "color.text.subtle",
                        weight: "medium",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $872baa6c44f00b3c$export$defe85febe8b728c).related_links_title
                        })
                    }),
                    links.length > linksToDisplayWhenCollapsed && /*#__PURE__*/ (0, $l998X.jsx)((0, $3d12974a4e287534$export$c1e33b78dff82c3c), {
                        sources: truncatedLinks,
                        onClick: onExpandToggle,
                        singleColumnLayout: singleColumnLayout
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $d8SNb.default), {
                rowGap: "space.200",
                columnGap: "space.400",
                xcss: (0, $1Whri.cx)($96012d3f013bc30d$var$styles.relatedLinksGrid, singleColumnLayout ? $96012d3f013bc30d$var$styles.singleColumnLayout : $96012d3f013bc30d$var$styles.dualColumnLayout),
                children: linksToDisplay.map((link, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $93ce23c5e9bc03a8$export$2c381a86421d5abf), {
                        url: link,
                        onClick: onResourceClick
                    }, index))
            })
        ]
    });
};


const $c2ee2b5f73ff8eda$var$styles = {
    showLessButtonContainer: "_1e0c1txw _4cvr1h6o _1bah1h6o",
    dualColumnLayout: "_yv0ewxkt"
};
const $c2ee2b5f73ff8eda$export$62500b33cee05471 = ({ links: links, contributors: contributors, cloudId: cloudId, onResourceClick: onResourceClick, onContributorClick: onContributorClick, onExpandClicked: onExpandClicked })=>{
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(false);
    let layout = 'single-column';
    const handleExpandToggle = ()=>{
        if (!isExpanded) onExpandClicked(layout);
        setIsExpanded(!isExpanded);
    };
    if (links.length === 0 && contributors.length === 0) return null;
     // we need to decide the layout based on the number of items
    // if we have lesser that 5 links and contributors each, we need to show them in a dual column
    // if we have only one of them, we need to show them in a single column
    // if we have more than 5 links or contributors, we need to show them in a single column
    // of the above: we show links first and then contributors if there are no links
    if (links.length > 0 && links.length <= 5 && contributors.length > 0 && contributors.length <= 5) layout = 'dual-column';
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            layout === 'dual-column' ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $d8SNb.default), {
                columnGap: "space.400",
                xcss: $c2ee2b5f73ff8eda$var$styles.dualColumnLayout,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $96012d3f013bc30d$export$a7ff6651352b415b), {
                            links: links,
                            singleColumnLayout: true,
                            isExpanded: isExpanded,
                            onExpandToggle: handleExpandToggle,
                            onResourceClick: onResourceClick
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $191637e8e278d6c0$export$5360f064464e9211), {
                            singleColumnLayout: true,
                            contributors: contributors,
                            cloudId: cloudId,
                            isExpanded: isExpanded,
                            onExpandToggle: handleExpandToggle,
                            onContributorClick: onContributorClick
                        })
                    })
                ]
            }) : links.length > 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, $96012d3f013bc30d$export$a7ff6651352b415b), {
                links: links,
                isExpanded: isExpanded,
                onExpandToggle: handleExpandToggle,
                onResourceClick: onResourceClick
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $191637e8e278d6c0$export$5360f064464e9211), {
                contributors: contributors,
                isExpanded: isExpanded,
                onContributorClick: onContributorClick,
                onExpandToggle: handleExpandToggle,
                cloudId: cloudId
            }),
            isExpanded && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $c2ee2b5f73ff8eda$var$styles.showLessButtonContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                    appearance: "subtle",
                    onClick: ()=>setIsExpanded(false),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...(0, $872baa6c44f00b3c$export$defe85febe8b728c).show_less_button_label
                    })
                })
            })
        ]
    });
};


const $b4536d1ff2577c9e$export$16bf99dc0596865c = (contributors)=>{
    if (contributors.length === 0) return [];
    const seen = new Set();
    const uniqueContributors = [];
    for (const contributor of contributors)if (!seen.has(contributor.id)) {
        uniqueContributors.push(contributor);
        seen.add(contributor.id);
    }
    return uniqueContributors;
};


/* ConfluenceFlexibleSmartCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 


















var $9RVmI = parcelRequire("9RVmI");


















var $1lLfV = parcelRequire("1lLfV");


















const $34a8fe3a8e97a3b4$export$e6e3b13f99e77224 = 'KnowledgeDiscoveryAiSnippetQuery';
const $34a8fe3a8e97a3b4$export$1c9bc8dcd3da6ba1 = `
query KnowledgeDiscoveryAiSnippetQuery($cloudId: ID!, $id: ID!) {
  singleContent(cloudId: $cloudId, id: $id) {
    aiProperty(objectType: snippet_v2) {
      objectData
    }
  }
}
`;


const $4754ffae30f7064c$var$fetchConfluenceAiSnippet = async ({ variables: variables, workspaceId: workspaceId, product: product })=>{
    return (0, $9EFEY.fetchAggResponse)({
        variables: variables,
        graphQuery: (0, $34a8fe3a8e97a3b4$export$1c9bc8dcd3da6ba1),
        operationName: (0, $34a8fe3a8e97a3b4$export$e6e3b13f99e77224),
        headers: (0, $6yuru.createAtlAttributionHeader)({
            atlWorkspaceId: workspaceId,
            tenantId: variables.cloudId,
            product: product
        })
    }).then((response)=>response.data).catch((error)=>{
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'useConfluenceAiSnippet'
        });
        // rethrow error to be handled by the caller
        throw error;
    });
};
const $4754ffae30f7064c$export$c1ef9bcd7a0f276c = ({ cloudId: cloudId, id: id, workspaceId: workspaceId, product: product })=>{
    const [loading, setIsLoading] = (0, $42omo.useState)(false);
    const [error, setError] = (0, $42omo.useState)(false);
    const [aiSnippet, setAiSnippet] = (0, $42omo.useState)();
    (0, $42omo.useEffect)(()=>{
        const fetchData = async ()=>{
            try {
                setIsLoading(true);
                const data = await $4754ffae30f7064c$var$fetchConfluenceAiSnippet({
                    variables: {
                        cloudId: cloudId,
                        id: id
                    },
                    workspaceId: workspaceId,
                    product: product
                });
                setAiSnippet(data?.singleContent?.aiProperty?.objectData || '');
            } catch (e) {
                (0, $4Zqgi.logger).error({
                    error: e,
                    functionName: 'useConfluenceAiSnippet'
                });
                setError(true);
            } finally{
                setIsLoading(false);
            }
        };
        if (id && cloudId && workspaceId && product) fetchData();
    }, [
        cloudId,
        id,
        workspaceId,
        product
    ]);
    return {
        aiSnippet: aiSnippet,
        loading: loading,
        error: error
    };
};



const $7f560cb8e964d6f3$var$unboundedStyles = {
    titleBlock: "_1r031e3o",
    metadataContainer: "_1v57z0dk _17bh1b66 _13ehz0dk _1fx71b66"
};
const $7f560cb8e964d6f3$var$styles = {
    titleBlock: "_1bsb1osq",
    titleIconContainer: "_1e0c1txw _1wpz1y6m _ca0qu2gc",
    metadataContainer: "_19pkr5cr",
    productNameContainer: "_1e0c1txw _4cvr1q9y",
    snippetContainer: "_19pk1b66"
}; // using vanilla css because primitives don't allow assinging 'color.border' to color which linking platform uses as a separator for metadata
const $7f560cb8e964d6f3$var$separatorStyle = {
    display: 'inline',
    color: "var(--ds-border, #0B120E24)",
    paddingLeft: "var(--ds-space-050, 4px)",
    paddingRight: "var(--ds-space-050, 4px)",
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $7f560cb8e964d6f3$var$ConfluenceFlexibleSmartCardUnmemoized = ({ url: url, cloudId: cloudId, contentId: contentId, contentType: contentType, description: description, areLLMPoweredFeaturesEnabled: areLLMPoweredFeaturesEnabled, onLoad: onLoad, onClick: onClick, onActionButtonClicked: onActionButtonClicked, searchPageAnalyticsCallbacks: searchPageAnalyticsCallbacks, workspaceId: workspaceId, product: product })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isReady, setIsReady] = (0, $42omo.useState)(false);
    const { aiSnippet: aiSnippet, loading: aiSnippetLoading, error: aiSnippetError } = (0, $4754ffae30f7064c$export$c1ef9bcd7a0f276c)({
        cloudId: cloudId,
        id: contentId,
        workspaceId: workspaceId,
        product: product
    });
    const fallbackContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
        maxLines: 2,
        testId: "fallback-description",
        children: `...${(0, $aU479.cleanExcerpt)(description).trim()}...`
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    transition: 'visibility 0.3s ease-in-out, opacity 0.3s ease-in-out',
                    visibility: isReady ? 'hidden' : 'visible',
                    opacity: isReady ? 0 : 1,
                    pointerEvents: isReady ? 'none' : 'auto',
                    height: isReady ? 0 : 'auto',
                    width: isReady ? 0 : '100%'
                },
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.150",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            alignBlock: "center",
                            space: "space.150",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $7f560cb8e964d6f3$var$styles.titleIconContainer,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                        height: 32,
                                        width: 32,
                                        isShimmering: true,
                                        testId: "skeleton"
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                                    xcss: $7f560cb8e964d6f3$var$styles.titleBlock,
                                    space: "space.100",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                            height: 32,
                                            width: 200,
                                            isShimmering: true,
                                            testId: "skeleton"
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                            height: 20,
                                            width: 200,
                                            isShimmering: true,
                                            testId: "skeleton"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                height: 20,
                                width: "100%",
                                isShimmering: true,
                                testId: "skeleton"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    transition: 'visibility 0.3s ease-in-out, opacity 0.3s ease-in-out',
                    visibility: isReady ? 'visible' : 'hidden',
                    opacity: isReady ? 1 : 0,
                    pointerEvents: isReady ? 'auto' : 'none',
                    height: isReady ? 'auto' : 0,
                    width: isReady ? '100%' : 0
                },
                onContextMenu: searchPageAnalyticsCallbacks.onResultContextMenu,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $hpUsb.Card), {
                    url: url,
                    ui: {
                        removeBlockRestriction: true,
                        hidePadding: true,
                        hideElevation: true,
                        hideBackground: true,
                        clickableContainer: true
                    },
                    appearance: "block",
                    onClick: (e)=>{
                        onClick({
                            event: e,
                            resourceUrl: url,
                            location: 'page-link'
                        });
                        searchPageAnalyticsCallbacks.onResultClicked();
                    },
                    onResolve: ()=>{
                        setIsReady(true);
                        onLoad();
                    },
                    onError: ()=>setIsReady(true),
                    testId: "smart-card",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            alignBlock: "center",
                            space: "space.150",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $7f560cb8e964d6f3$var$styles.titleIconContainer,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lE8sM.default), {
                                        icon: contentType === 'blogpost' ? (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))) : (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
                                        label: formatMessage((0, $872baa6c44f00b3c$export$defe85febe8b728c).page_icon_label),
                                        appearance: "blue",
                                        size: "medium"
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                                    xcss: (0, $1Whri.cx)($7f560cb8e964d6f3$var$styles.titleBlock, $7f560cb8e964d6f3$var$unboundedStyles.titleBlock),
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $5znEc.default), {
                                            hideIcon: true,
                                            actions: [
                                                {
                                                    name: (0, $5TXU5.ActionName).CopyLinkAction,
                                                    onClick: ()=>{
                                                        onActionButtonClicked((0, $5TXU5.ActionName).CopyLinkAction);
                                                        searchPageAnalyticsCallbacks.onCopyLinkButtonClicked();
                                                    },
                                                    hideContent: true
                                                },
                                                {
                                                    name: (0, $5TXU5.ActionName).PreviewAction,
                                                    onClick: ()=>onActionButtonClicked((0, $5TXU5.ActionName).PreviewAction),
                                                    hideContent: true
                                                }
                                            ],
                                            maxLines: 1
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                            alignBlock: "baseline",
                                            xcss: (0, $1Whri.cx)($7f560cb8e964d6f3$var$styles.metadataContainer, $7f560cb8e964d6f3$var$unboundedStyles.metadataContainer),
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                                                    xcss: (0, $1Whri.cx)($7f560cb8e964d6f3$var$styles.productNameContainer),
                                                    children: [
                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                            size: "small",
                                                            color: "color.text.subtle",
                                                            children: formatMessage((0, $872baa6c44f00b3c$export$defe85febe8b728c).confluence_product_name)
                                                        }),
                                                        /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                                            style: $7f560cb8e964d6f3$var$separatorStyle,
                                                            children: "\u2022"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $1lLfV.default), {
                                                    primary: [
                                                        {
                                                            name: (0, $5TXU5.ElementName).CreatedBy
                                                        },
                                                        {
                                                            name: (0, $5TXU5.ElementName).ModifiedOn
                                                        },
                                                        {
                                                            name: (0, $5TXU5.ElementName).ViewCount
                                                        },
                                                        {
                                                            name: (0, $5TXU5.ElementName).CommentCount
                                                        },
                                                        {
                                                            name: (0, $5TXU5.ElementName).ReactCount
                                                        },
                                                        {
                                                            name: (0, $5TXU5.ElementName).VoteCount
                                                        }
                                                    ],
                                                    size: (0, $5TXU5.SmartLinkSize).Small,
                                                    maxLines: 1
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $7f560cb8e964d6f3$var$styles.snippetContainer,
                            children: areLLMPoweredFeaturesEnabled ? aiSnippetLoading ? /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                height: 20,
                                width: "90%",
                                isShimmering: true,
                                testId: "skeleton"
                            }) : aiSnippetError ? fallbackContent : aiSnippet ? /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                maxLines: 2,
                                children: aiSnippet
                            }) : fallbackContent : fallbackContent
                        })
                    ]
                })
            })
        ]
    });
};
const $7f560cb8e964d6f3$export$446a917ae3eb13bc = /*#__PURE__*/ (0, $42omo.memo)($7f560cb8e964d6f3$var$ConfluenceFlexibleSmartCardUnmemoized);


/*
* This file contains the utilities for navigating to a link from a confluence result card.
* We mainly want to support SPA navigation if search-page provides its own onNavigate function
* inspired by
*  - /platform/packages/search/search-page/src/common/ui/link-component/index.tsx
*  - /platform/packages/search/search-page/src/common/utils/url.ts
*/ 


const $ad22036b26d138b6$var$defaultOnNavigate = {
    callback: (url)=>{
        window.location.href = url;
    },
    options: {
        alwaysUseOnLinkClick: false
    }
};
const $ad22036b26d138b6$export$c22fd8ed236ca380 = ({ event: event, url: url, onNavigate: onNavigate = $ad22036b26d138b6$var$defaultOnNavigate })=>{
    try {
        const metaPressed = event.ctrlKey || event.metaKey || event.shiftKey;
        const sameOrigin = window.location.origin === new URL(url).origin;
        const useOnNavigate = sameOrigin && !metaPressed;
        if (useOnNavigate) {
            event.preventDefault();
            // Handles SPA navigation if search-page provides own onNavigate
            const onNavigateCallback = typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
            onNavigateCallback(url, 'push');
        } else $ad22036b26d138b6$var$defaultOnNavigate.callback(url);
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'navigateToLink'
        });
        $ad22036b26d138b6$var$defaultOnNavigate.callback(url);
    }
};


const $22c94c8e6129496b$var$styles = {
    disclaimerSpacer: "_4t3i14no",
    root: "_2rko12b0 _1h6d1l7x _1dqonqa1 _189ee4h9 _1bsb1osq",
    smartCardContainer: "_1tkes0l4 _ca0qutpp _n3tdpxbi",
    additionalInfoSectionContainer: "_1tke168d _ca0qutpp _n3tdpxbi",
    conversationStartersContainer: "_ca0qutpp _n3tdutpp",
    borderBottomSeparator: "_1il9nqa1 _1doce4h9 _1o3i1l7x",
    sidePadding: "_19bvpxbi _u5f3pxbi",
    feedbackContainer: "_ca0q1b66 _n3tdu2gc"
};
const $22c94c8e6129496b$export$94b7dbb53a4cb787 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $eMz0l.AnimatedWrapper), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kF5LJ.SmartAnswerCardBodyGenerating), {
                    heightOverride: "navigationalCard"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $22c94c8e6129496b$var$styles.disclaimerSpacer
            })
        ]
    });
const $22c94c8e6129496b$var$ConfluenceCardComponent = ({ searchResultData: searchResultData, workspaceId: workspaceId, source: source, searchPageAnalyticsCallbacks: searchPageAnalyticsCallbacks, onNavigate: onNavigate })=>{
    const renderStartTime = (0, $42omo.useRef)(performance.now());
    const hasFiredNavCardLoaded = (0, $42omo.useRef)(false);
    const { query: query, url: url, cloudId: cloudId, searchSessionId: searchSessionId, id: contentId, type: contentType, description: description, areLLMPoweredFeaturesEnabled: areLLMPoweredFeaturesEnabled, primaryProduct: primaryProduct, linkedResults: linkedResults, extractedLinks: extractedLinks } = searchResultData;
    const { trackAIInteractionInit: trackAIInteractionInit } = (0, $fYQcF.useAIEventsInstrumentation)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { loading: twgSourcesLoading, contributors: contributors, outgoingLinks: outgoingLinks } = (0, $7af60c4a5978bce8$export$6ed38de17ee0fdc9)({
        contentId: contentId,
        workspaceId: workspaceId || '',
        cloudId: cloudId || '',
        product: primaryProduct || ''
    });
    const deduplicatedContributors = (0, $42omo.useMemo)(()=>(0, $b4536d1ff2577c9e$export$16bf99dc0596865c)(contributors), [
        contributors
    ]);
    /**
   * The priority for how we show the related links in the UI:
   * P1: BE(these are part of the search results) related links coming from search-page
   * P2: FE(these are extracted from the description) related links coming from search-page
   * P3: Outgoing links from the TWG API (pages mentioned in the confluence page)
   */ const links = (0, $42omo.useMemo)(()=>{
        return [
            ...linkedResults?.map((result)=>result.url) || [],
            ...extractedLinks || [],
            ...outgoingLinks || []
        ].slice(0, 50); // Limit the number of links to 50 to avoid errors from Object Resolver
    }, [
        linkedResults,
        extractedLinks,
        outgoingLinks
    ]);
    const analyticsAttributes = (0, $42omo.useMemo)(()=>({
            searchSessionId: searchSessionId,
            queryHash: (0, $01aV7.sha256Hash)(query),
            brand: (0, $f7lNm.AiBrand).ROVO,
            source: source,
            query: query,
            answerString: url || '',
            answerCardType: (0, $f7lNm.AnswerCardType).NAV_CONTENT
        }), [
        searchSessionId,
        query,
        url,
        source
    ]);
    // removing UGC attributes
    const analyticsAttributesWithoutUGC = (0, $42omo.useMemo)(()=>({
            searchSessionId: searchSessionId,
            queryHash: (0, $01aV7.sha256Hash)(query),
            brand: (0, $f7lNm.AiBrand).ROVO,
            source: source,
            answerCardType: (0, $f7lNm.AnswerCardType).NAV_CONTENT
        }), [
        query,
        searchSessionId,
        source
    ]);
    const fireNavCardLoaded = (0, $42omo.useCallback)(()=>{
        if (hasFiredNavCardLoaded.current) return;
        hasFiredNavCardLoaded.current = true;
        const apiLoadedTime = performance.now();
        const totalDuration = apiLoadedTime - renderStartTime.current;
        fireAnalyticsEvent((0, $4xTru.onNonGenerativeAIAnswerResultShown)({
            ...analyticsAttributes,
            fmpLoadTime: totalDuration,
            resourceType: 'confluence'
        }));
    }, [
        fireAnalyticsEvent,
        analyticsAttributes
    ]);
    (0, $42omo.useEffect)(()=>{
        trackAIInteractionInit();
        fireSAINUsageEvent({});
    }, [
        fireSAINUsageEvent,
        trackAIInteractionInit
    ]);
    const handleLinkClick = (0, $42omo.useCallback)(({ event: event, resourceUrl: resourceUrl, location: location })=>{
        event.preventDefault();
        fireAnalyticsEvent((0, $fJBWn.onNonGenerativeKnowledgeCardLinkClick)({
            ...analyticsAttributes,
            location: location
        }));
        fireSAINUsageEvent({});
        (0, $ad22036b26d138b6$export$c22fd8ed236ca380)({
            event: event,
            url: resourceUrl,
            onNavigate: onNavigate
        });
    }, [
        fireAnalyticsEvent,
        analyticsAttributes,
        fireSAINUsageEvent,
        onNavigate
    ]);
    const fireAnalyticsEventAndUsage = (0, $42omo.useCallback)((action)=>{
        fireAnalyticsEvent((0, $fJBWn.onNonGenerativeKnowledgeCardLinkClick)({
            ...analyticsAttributes,
            location: action
        }));
        fireSAINUsageEvent({});
    }, [
        fireAnalyticsEvent,
        analyticsAttributes,
        fireSAINUsageEvent
    ]);
    const fireAnalyticsEventAndUsageForExpand = (0, $42omo.useCallback)((layout)=>{
        fireAnalyticsEvent((0, $fJBWn.onNonGenerativeKnowledgeCardLinkClick)({
            ...analyticsAttributes,
            location: `expand-${layout}`
        }));
        fireSAINUsageEvent({});
    }, [
        fireAnalyticsEvent,
        analyticsAttributes,
        fireSAINUsageEvent
    ]);
    if (twgSourcesLoading) return /*#__PURE__*/ (0, $l998X.jsx)($22c94c8e6129496b$export$94b7dbb53a4cb787, {});
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
        data: {
            attributes: {
                location: (0, $4xTru.SmartLinksAnalyticsContextLocation).SEARCH_RESULT_CONFLUENCE_CARD,
                ...analyticsAttributesWithoutUGC
            },
            location: (0, $4xTru.SmartLinksAnalyticsContextLocation).SEARCH_RESULT_CONFLUENCE_CARD
        },
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $7bZ3i.SmartCardProvider), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    xcss: $22c94c8e6129496b$var$styles.root,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)($22c94c8e6129496b$var$styles.smartCardContainer, $22c94c8e6129496b$var$styles.borderBottomSeparator, $22c94c8e6129496b$var$styles.sidePadding),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7f560cb8e964d6f3$export$446a917ae3eb13bc), {
                                url: url,
                                cloudId: cloudId,
                                contentId: contentId,
                                contentType: contentType,
                                description: description,
                                areLLMPoweredFeaturesEnabled: areLLMPoweredFeaturesEnabled,
                                workspaceId: workspaceId || '',
                                product: primaryProduct || '',
                                onLoad: fireNavCardLoaded,
                                onClick: handleLinkClick,
                                onActionButtonClicked: fireAnalyticsEventAndUsage,
                                searchPageAnalyticsCallbacks: searchPageAnalyticsCallbacks
                            })
                        }),
                        (links.length > 0 || deduplicatedContributors.length > 0) && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)($22c94c8e6129496b$var$styles.additionalInfoSectionContainer, $22c94c8e6129496b$var$styles.borderBottomSeparator, $22c94c8e6129496b$var$styles.sidePadding),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $c2ee2b5f73ff8eda$export$62500b33cee05471), {
                                links: links,
                                contributors: deduplicatedContributors,
                                cloudId: cloudId,
                                onResourceClick: handleLinkClick,
                                onContributorClick: fireAnalyticsEventAndUsage,
                                onExpandClicked: fireAnalyticsEventAndUsageForExpand
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)($22c94c8e6129496b$var$styles.conversationStartersContainer, $22c94c8e6129496b$var$styles.sidePadding),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $383edc9b6c74463d$export$10e76ebde8d3ea11), {
                                primaryProduct: primaryProduct,
                                cloudId: cloudId,
                                searchResult: {
                                    ari: contentId,
                                    url: url
                                },
                                analyticsAttributes: analyticsAttributesWithoutUGC
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $22c94c8e6129496b$var$styles.feedbackContainer,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9lp28.AIDisclaimerAndFeedback), {
                        showFeedbackButtons: true,
                        showAIUsageDisclaimer: areLLMPoweredFeaturesEnabled
                    })
                })
            ]
        })
    });
};
const $22c94c8e6129496b$var$ConfluenceCardComponentMemoized = /*#__PURE__*/ (0, $42omo.memo)($22c94c8e6129496b$var$ConfluenceCardComponent);
const $22c94c8e6129496b$export$b769a864d98cccb0 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)($22c94c8e6129496b$var$ConfluenceCardComponentMemoized, {
        ...props
    });


const $6406541fb8ffe635$export$b8e08e4af5c98a73 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2Rith.AIEventsInstrumentationProvider), {
        config: {
            product: props.searchResultData?.product || '',
            subproduct: props.subproduct ?? 'unknown',
            aiFeatureName: 'smartAnswers',
            aiExperienceName: (0, $f7lNm.AiExperienceName).NAVIGATIONAL_SEARCH_RESULT_CARD,
            // TODO: update this section once we have agreement on how we track this card towards SAIN
            proactiveGeneratedAI: 0,
            userGeneratedAI: 0,
            isAIFeature: 0,
            source: props.source,
            channel: (0, $f7lNm.DEFAULT_GAS_CHANNEL)
        },
        children: props.searchResultData?.__typename === 'SearchConfluencePageBlogAttachment' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $22c94c8e6129496b$export$b769a864d98cccb0), {
            ...props
        }) : null
    });


































































const $328ff6efa3a7a420$export$c89c057fd480d10c = (node)=>{
    return node?.__typename === 'SearchConfluencePageBlogAttachment';
};
const $328ff6efa3a7a420$export$1e8aa22a53a15ada = ({ node: node, position: position, cloudId: cloudId, searchQuery: query, searchSessionId: searchSessionId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, thirdPartyConfigs: thirdPartyConfigs, is3pGroupingEnabled: is3pGroupingEnabled, smartAnswersPortalRef: smartAnswersPortalRef, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $e0ddc7b382b65af0$export$2e2bcd8739ae039), node);
    const [features] = (0, $4Qo4W.useFeatures)();
    const { commonAttributes: commonAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const { getFeatureGate: getFeatureGate, isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled, onNavigate: onNavigate } = (0, $7WbA8.useAppContext)();
    const { isSAINNavigationalExperienceEligible: isSAINNavigationalExperienceEligible, getWorkspaceId: getWorkspaceId } = (0, $ed340a232d40a52e$export$ff55966aa7474110)();
    const isSideBySideEnabled = features?.sideBySide?.enabled;
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        let containerId = null;
        if (data.space?.id) {
            const [, , , spaceId] = (0, $6h3V2.getProductAndIDFromARI)(data.space.id);
            containerId = spaceId;
        }
        return {
            id: data.id,
            containerId: containerId,
            spaceId: containerId,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product,
            isSideBySideEnabled: isSideBySideEnabled
        };
    }, [
        data,
        isSideBySideEnabled
    ]);
    const isSAINNavigationalExperienceEnabled = isSAINNavigationalExperienceEligible({
        position: position,
        url: data.url,
        navBoostScore: data.navBoostScore
    });
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position,
        socialSignal: data.socialSignal?.signal || undefined
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position,
        socialSignal: data.socialSignal?.signal || undefined
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const subtype = data.confluenceEntity?.subtype;
    const metadataParts = [
        [
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                type: data.type,
                subtype: subtype
            })
        ],
        [
            'breadcrumbs',
            data.space?.name && /*#__PURE__*/ (0, $l998X.jsx)((0, $e6acefe6e798f052$export$9138e703d4b4585b), {
                name: data.space.name,
                url: data.url,
                webUiLink: data.space?.webUiLink
            })
        ],
        [
            'last-modified',
            data.lastModified && /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                lastModified: data.lastModified
            })
        ]
    ];
    const socialMetadataParts = [
        [
            'comment-count',
            (0, $8ca12d73b6c4215d$export$e03b3a8fca9c958d)(data.confluenceEntity?.commentCountSummary?.total)
        ],
        [
            'like-count',
            (0, $f70284887e2e1865$export$b52fa2ff0823604f)(data.confluenceEntity?.likesSummary?.count)
        ]
    ];
    const titleMetadataParts = [
        [
            'verified',
            data.isVerified && /*#__PURE__*/ (0, $l998X.jsx)((0, $436f4269638928bb$export$eb413699769dd9b1), {})
        ]
    ];
    if (data.socialSignal && appMode === (0, $9vOy1.ApplicationModes).Rovo) {
        const { user: user, signal: signal, timestamp: timestamp } = data.socialSignal;
        socialMetadataParts.push([
            'social-signal',
            user?.email && /*#__PURE__*/ (0, $l998X.jsx)((0, $e46c71a22c4ed891$export$229f0558b2da716c), {
                userAccountId: user.accountId,
                userName: user.name,
                userEmail: user.email,
                userPicture: user.picture,
                userJobTitle: user.extendedProfile?.jobTitle,
                signal: signal,
                timestamp: timestamp,
                commonAttributes: commonAttributes
            })
        ]);
    }
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const hasSimilarResults = linkedResults?.some((linkedResult)=>linkedResult.category?.toUpperCase() === 'SIMILAR');
    const extractedLinksFromText = (0, $514d99dea8b7ae4b$export$a414b3d5a172e15b)(data.description);
    const hasExtractedLinks = extractedLinksFromText && extractedLinksFromText.length > 0;
    const hasRelatedLinks = linkedResults && linkedResults.length > 0 || hasExtractedLinks;
    const { serveExperiment: serveConversationStartersExperiment } = (0, $eUEtI.getSAINLayerFrontendExperiment)({
        abTestId: 'kd_convo_starters_in_search'
    });
    const isConversationStartersEnabled = getFeatureGate('kd_convo_starters_dogfooding');
    const conversationStartersIfEnabled = position === 0 && appMode === (0, $9vOy1.ApplicationModes).Rovo && (0, $eb4a02b80e2ab764$export$3afecd2a83596299)(appMode, isAdminHubAIEnabled, isRovoLLMEnabled) && [
        'page',
        'blogpost'
    ].includes(data.type) && !!(serveConversationStartersExperiment || isConversationStartersEnabled) ? {
        ari: data.id,
        url: data.url
    } : null;
    let icon;
    if ((0, $dh538.fg)('rovo_search_confluence_icons_fps')) icon = (0, $2waBy.getConfluenceEntityIcon)({
        iconUrl: data.iconUrl,
        type: data.type,
        size: 'medium',
        isLiveDoc: data.confluenceEntity?.subtype === (0, $gzcCN.SearchConfluenceSubtype).LIVE
    });
    else icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.ConfluenceIcon), {
        size: "medium",
        shouldUseNewLogoDesign: true
    });
    const searchResultComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Confluence,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: (0, $icWhS.getConfluenceUrlWithAnalyticsQueryParams)({
            url: data.url,
            query: query,
            searchSessionId: searchSessionId
        }),
        title: (0, $Y34Hw.enrichExcerpt)(data.title),
        icon: icon,
        headerMetadataParts: metadataParts,
        headerMetadataSocialParts: socialMetadataParts,
        titleMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $a7nUd.SearchMetadata), {
            parts: titleMetadataParts,
            displaySpacer: false
        }),
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: (0, $Y34Hw.processExcerpt)(data.description)
        }),
        hideSummarizeInChat: !!conversationStartersIfEnabled,
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        hasRelatedLinks: hasRelatedLinks,
        footer: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
            children: [
                cloudId && conversationStartersIfEnabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $383edc9b6c74463d$export$10e76ebde8d3ea11), {
                    primaryProduct: primaryProduct,
                    cloudId: cloudId,
                    searchResult: conversationStartersIfEnabled,
                    analyticsAttributes: {
                        resultMetadata: metadata,
                        ...commonAttributes
                    }
                }),
                hasSimilarResults ? /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$59c57a80401f0a6), {
                    linkedResults: linkedResults || [],
                    thirdPartyConfigs: thirdPartyConfigs,
                    partial: data,
                    url: (0, $icWhS.getConfluenceUrlWithAnalyticsQueryParams)({
                        url: data.url,
                        query: query,
                        searchSessionId: searchSessionId
                    }),
                    position: position,
                    onResultClicked: onResultClicked,
                    isAllProductSelected: !selectedProduct,
                    onResultContextMenu: onResultCtxMenuClicked,
                    is3pGroupingEnabled: is3pGroupingEnabled,
                    product: (0, $1yEFx.ProductKeys).Confluence
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$695e5a3ae2478b3), {
                    linkedResults: linkedResults || [],
                    thirdPartyConfigs: thirdPartyConfigs,
                    partial: data,
                    url: (0, $icWhS.getConfluenceUrlWithAnalyticsQueryParams)({
                        url: data.url,
                        query: query,
                        searchSessionId: searchSessionId
                    }),
                    position: position,
                    onResultClicked: onResultClicked,
                    onResultContextMenu: onResultCtxMenuClicked,
                    isAllProductSelected: !selectedProduct
                })
            ]
        }),
        mainContentWidth: mainContentWidth
    });
    // the SAIN Hero Nav card is rendered at the top of the search results via a portal replacing the first blue link
    if (isSAINNavigationalExperienceEnabled && smartAnswersPortalRef?.current) {
        const workspaceId = getWorkspaceId();
        return /*#__PURE__*/ (0, $jTxSS.createPortal)(/*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
            section: "search-page-smart-answers-nav-card",
            fallback: searchResultComponent,
            onException: (error)=>{
                (0, $f8oYd.logException)(error);
            },
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                id: "search-page-smart-answers",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6406541fb8ffe635$export$b8e08e4af5c98a73), {
                    searchResultData: {
                        ...data,
                        url: (0, $icWhS.getConfluenceUrlWithAnalyticsQueryParams)({
                            url: data.url,
                            query: query,
                            searchSessionId: searchSessionId
                        }),
                        query: query,
                        searchSessionId: searchSessionId,
                        cloudId: cloudId || '',
                        areLLMPoweredFeaturesEnabled: (0, $eb4a02b80e2ab764$export$3afecd2a83596299)(appMode, isAdminHubAIEnabled, isRovoLLMEnabled),
                        primaryProduct: primaryProduct ?? 'unknown',
                        extractedLinks: (0, $514d99dea8b7ae4b$export$a414b3d5a172e15b)(data.description),
                        linkedResults: linkedResults
                    },
                    onNavigate: onNavigate,
                    source: (0, $6yNqK.EVENT_SOURCE),
                    workspaceId: workspaceId ?? '',
                    navBoostScore: (0, $dh538.fg)('kd_enable_nav_boost_score') ? data.navBoostScore : undefined,
                    searchPageAnalyticsCallbacks: {
                        onResultClicked: onResultClicked,
                        onResultContextMenu: onResultCtxMenuClicked,
                        onCopyLinkButtonClicked: onCopyLinkButtonClicked
                    }
                })
            })
        }), smartAnswersPortalRef.current, 'search-page-smart-answers-nav-card');
    }
    return searchResultComponent;
};





/**
 * @generated SignedSource<<c7a04651a5495eb7bfb979227e91653a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2ae640618ea5e94a$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "includeIconUrl"
        }
    ],
    "kind": "Fragment",
    "name": "searchConfluenceSpace_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        },
        {
            "condition": "includeIconUrl",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "iconUrl"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "lastModified"
        }
    ],
    "type": "SearchConfluenceSpace"
};
$2ae640618ea5e94a$var$node.hash = "0c267c1ef1d1bacf6c1b9971a73d0911";
var $2ae640618ea5e94a$export$2e2bcd8739ae039 = $2ae640618ea5e94a$var$node;














































const $38a1e03191a959a6$export$4619f000f23ee8d1 = (node)=>{
    return node?.__typename === 'SearchConfluenceSpace';
};
const $38a1e03191a959a6$export$f3b885cf8bfefc5f = ({ node: node, position: position, cloudId: cloudId, searchQuery: query, searchSessionId: searchSessionId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $2ae640618ea5e94a$export$2e2bcd8739ae039), node);
    const [features] = (0, $4Qo4W.useFeatures)();
    const isSideBySideEnabled = features?.sideBySide?.enabled;
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        let containerId = null;
        return {
            id: data.id,
            containerId: containerId,
            spaceId: containerId,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product,
            isSideBySideEnabled: isSideBySideEnabled
        };
    }, [
        data,
        isSideBySideEnabled
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const metadataParts = [
        [
            'type',
            (0, $kXlQy.getSearchResultType)(data.type)
        ],
        [
            'last-modified',
            data.lastModified && /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                lastModified: data.lastModified
            })
        ]
    ];
    let icon;
    if ((0, $dh538.fg)('rovo_search_confluence_icons_fps')) icon = (0, $2waBy.getConfluenceEntityIcon)({
        iconUrl: data.iconUrl,
        type: data.type,
        size: 'medium'
    });
    else icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.ConfluenceIcon), {
        size: "medium",
        shouldUseNewLogoDesign: true
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Confluence,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: (0, $icWhS.getConfluenceUrlWithAnalyticsQueryParams)({
            url: data.url,
            query: query,
            searchSessionId: searchSessionId
        }),
        title: (0, $Y34Hw.enrichExcerpt)(data.title),
        icon: icon,
        headerMetadataParts: metadataParts,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: (0, $Y34Hw.processExcerpt)(data.description)
        }),
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<fa8fa1b0650c3eb501b64443ffe224d1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $187ddf73ef2601a7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "searchDefaultRenderer_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        }
    ],
    "type": "SearchResult",
    "abstractKey": "__isSearchResult"
};
$187ddf73ef2601a7$var$node.hash = "d7dbec072d57a60ae7acb966e96f70e5";
var $187ddf73ef2601a7$export$2e2bcd8739ae039 = $187ddf73ef2601a7$var$node;



























const $d75f7c12f192fdc3$export$7397c326dc16df01 = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $187ddf73ef2601a7$export$2e2bcd8739ae039), node);
    const { id: id, url: url, type: type, title: title, description: description } = data;
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(id);
        return {
            id: id,
            containerId: null,
            spaceId: null,
            contentType: type,
            entityType: type,
            contentId: contentId,
            product: product
        };
    }, [
        id,
        type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const enrichedTitle = (0, $Y34Hw.enrichExcerpt)(title);
    const encrichedBody = description && /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
        description: (0, $Y34Hw.processExcerpt)(description)
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        title: enrichedTitle,
        icon: /*#__PURE__*/ (0, $l998X.jsx)($d75f7c12f192fdc3$export$cd8dc052ba8808af, {}),
        headerMetadataParts: [],
        description: encrichedBody,
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $d75f7c12f192fdc3$export$cd8dc052ba8808af = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
        color: "currentColor",
        spacing: "spacious",
        label: ""
    });





/**
 * @generated SignedSource<<fb1e35cf5bb5bf4799a915c0b06e3d98>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $733a2991b57ecebd$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "searchFederatedResult_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "lastModifiedDate"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchFederatedEmail_AtlassianSearchPage"
        }
    ],
    "type": "SearchResultFederated"
};
$733a2991b57ecebd$var$node.hash = "54b396c04e9434e8bfcf5a97cc47d5fa";
var $733a2991b57ecebd$export$2e2bcd8739ae039 = $733a2991b57ecebd$var$node;





















parcelRequire("42omo");







const $5d3d637dc8569dd3$export$7819ed9db7396ac5 = ({ product: product, resourceType: resourceType })=>{
    const products = (0, $1yEFx.useProductConfigs)();
    let productKey;
    if (product === 'google' && resourceType === 'email') productKey = (0, $1yEFx.ProductKeys).Gmail;
    else if (product === 'microsoft' && resourceType === 'email') productKey = (0, $1yEFx.ProductKeys).OutlookMail;
    if (!productKey) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
        color: "currentColor",
        spacing: "spacious",
        label: ""
    });
    let IconComponent = products[productKey]?.SearchResultIcon;
    return IconComponent ? /*#__PURE__*/ (0, $l998X.jsx)(IconComponent, {
        label: ""
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
        color: "currentColor",
        spacing: "spacious",
        label: ""
    });
};





















/**
 * @generated SignedSource<<a666a555bbdf24fac913ade0e402c11c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b0d3940576703a81$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "searchFederatedEmail_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        },
        {
            "kind": "ScalarField",
            "name": "lastModifiedDate"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "LinkedField",
            "name": "entity",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "concreteType": "SearchFederatedEmailUser",
                            "kind": "LinkedField",
                            "name": "sender",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ],
                    "type": "SearchFederatedEmailEntity"
                }
            ]
        }
    ],
    "type": "SearchResultFederated"
};
$b0d3940576703a81$var$node.hash = "fe6e2341012e955a1fe71d28c0a79382";
var $b0d3940576703a81$export$2e2bcd8739ae039 = $b0d3940576703a81$var$node;


parcelRequire("42omo");


























const $d3beec6ca8114fa5$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    emailLabel: {
        id: "search-federated-result.email.label",
        defaultMessage: "Email"
    },
    inboxLabel: {
        id: "search-federated-result.inbox.label",
        defaultMessage: "Inbox"
    },
    sentLabel: {
        id: "search-federated-result.sent.label",
        defaultMessage: "{person} sent"
    },
    forwardedLabel: {
        id: "search-federated-result.forwarded.label",
        defaultMessage: "{person} forwarded"
    },
    externalPersonLabel: {
        id: "search-federated-result.external-person.label",
        defaultMessage: "External person"
    },
    timestampLabel: {
        id: "search-federated-result.timestamp.label",
        // eslint-disable-next-line @atlassian/i18n/no-useless-message
        defaultMessage: "{formattedDate}"
    }
});


const $e3908224cc055321$var$styles = {
    nameContainer: "_o5721q9c"
};
const $e3908224cc055321$export$5376c8ad9cf3a7c7 = ({ node: node, position: position, product: product, icon: icon, cloudId: cloudId, appMode: appMode, selectedProduct: selectedProduct, primaryProduct: primaryProduct, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $b0d3940576703a81$export$2e2bcd8739ae039), node);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { id: id, lastModifiedDate: lastModifiedDate, url: url, title: title, description: description, entity: entity } = data;
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate,
        message: (0, $d3beec6ca8114fa5$export$defe85febe8b728c).timestampLabel
    }) : null;
    const label = /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...(0, $d3beec6ca8114fa5$export$defe85febe8b728c).emailLabel
    });
    const inboxLabel = /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...(0, $d3beec6ca8114fa5$export$defe85febe8b728c).inboxLabel
    });
    const fullName = entity?.sender?.name || '';
    const firstName = fullName?.split(' ')?.[0] || formatMessage((0, $d3beec6ca8114fa5$export$defe85febe8b728c).externalPersonLabel);
    const actionLabel = formatMessage((0, $d3beec6ca8114fa5$export$defe85febe8b728c).sentLabel, {
        person: firstName
    });
    const metadataParts = [
        [
            'label',
            label
        ],
        [
            'inbox',
            inboxLabel
        ],
        [
            'lastModified',
            lastModifiedComponent
        ],
        [
            'sender',
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.025",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $678a8075b20296fe$export$3778be82376b06d7), {
                        name: fullName
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $e3908224cc055321$var$styles.nameContainer,
                        children: actionLabel
                    })
                ]
            })
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        headerMetadataParts: metadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: (0, $Y34Hw.processExcerpt)(description)
        }),
        primaryProduct: primaryProduct,
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        isThirdParty: true,
        mainContentWidth: mainContentWidth
    });
};


const $64821cc7b4fbd082$var$styles = {
    typeLabelContainer: "_299m1dk0"
};
const $64821cc7b4fbd082$var$getLabel = (entityNoun)=>entityNoun.replace(/-/g, ' ');
var $64821cc7b4fbd082$var$ResourceType = /*#__PURE__*/ function(ResourceType) {
    ResourceType["EMAIL"] = "email";
    return ResourceType;
}($64821cc7b4fbd082$var$ResourceType || {});
const $64821cc7b4fbd082$export$b3f67b85a605a606 = ({ node: node, position: position, cloudId: cloudId, primaryProduct: primaryProduct, appMode: appMode, selectedProduct: selectedProduct, searchQuery: searchQuery, searchSessionId: searchSessionId, mainContentWidth: mainContentWidth, thirdPartyConfigs: thirdPartyConfigs })=>{
    const data = (0, $irOoi.useFragment)((0, $733a2991b57ecebd$export$2e2bcd8739ae039), node);
    const { resourceId: resourceId, resourceOwner: product, resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(data.id);
    const metadata = (0, $42omo.useMemo)(()=>{
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: resourceType,
            entityType: resourceType,
            contentId: resourceId,
            product: product,
            // it's federated so always false in this component
            is3PSmartLink: false,
            connectorType: (0, $9d9t8.ConnectorSources).Federated
        };
    }, [
        resourceId,
        product,
        resourceType,
        data.id
    ]);
    const is3PClickIngestionEnabled = (0, $2OtFZ.serve3PClickIngestionExperiment)(thirdPartyConfigs || {}, {
        fireExperimentExposure: false
    });
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position,
        is3PClickIngestionEnabled: is3PClickIngestionEnabled
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position,
        is3PClickIngestionEnabled: is3PClickIngestionEnabled
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $5d3d637dc8569dd3$export$7819ed9db7396ac5), {
        product: product,
        resourceType: resourceType
    });
    if (resourceType === "email") return /*#__PURE__*/ (0, $l998X.jsx)((0, $e3908224cc055321$export$5376c8ad9cf3a7c7), {
        node: data,
        position: position,
        product: product,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        selectedProduct: selectedProduct,
        searchQuery: searchQuery,
        searchSessionId: searchSessionId,
        appMode: appMode,
        icon: icon,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        mainContentWidth: mainContentWidth
    });
    const { id: id, lastModifiedDate: lastModifiedDate, url: url, title: title, description: description } = data;
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const label = $64821cc7b4fbd082$var$getLabel(metadata.entityType);
    const headerMetadataParts = [
        [
            'label',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $64821cc7b4fbd082$var$styles.typeLabelContainer,
                children: label
            })
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: (0, $Y34Hw.processExcerpt)(description)
        }),
        icon: icon,
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $64821cc7b4fbd082$export$59a100e12914442b = (node)=>{
    return node?.__typename === 'SearchResultFederated';
};





/**
 * @generated SignedSource<<eea353c225d7b05859b0a85da3e3ea1d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bc37e735c0a85c0e$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": true,
            "kind": "LocalArgument",
            "name": "includeThirdPartyId"
        }
    ],
    "kind": "Fragment",
    "name": "searchGraphResult_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "providerId"
        },
        {
            "kind": "ScalarField",
            "name": "connectorType"
        },
        {
            "kind": "ScalarField",
            "name": "integrationId"
        },
        {
            "kind": "ScalarField",
            "name": "subtype"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphBranch_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphCalendar_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphComment_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphCommit_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphConfluenceDc_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphConversation_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphCustomerOrg_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphDeal_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphDefault_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphDesign_AtlassianSearchPage"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "includeThirdPartyId",
                    "variableName": "includeThirdPartyId"
                }
            ],
            "kind": "FragmentSpread",
            "name": "searchGraphDocument_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphMessage_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphJiraDc_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphPullRequest_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphRepository_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphVideo_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphWorkItem_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphDashboard_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphDataTable_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphCustomerContact_AtlassianSearchPage"
        }
    ],
    "type": "SearchResultGraphDocument"
};
$bc37e735c0a85c0e$var$node.hash = "411380182e4a765bff79b96addae7abd";
var $bc37e735c0a85c0e$export$2e2bcd8739ae039 = $bc37e735c0a85c0e$var$node;







































/**
 * @generated SignedSource<<1ca5e68bdd641d5f9ee4bfaa2dfc7a4d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $54951185c35bf8b1$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    }, v2 = {
        "kind": "ScalarField",
        "name": "url"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphBranch_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionLevel"
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v3 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "container",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v3 /*: any*/ 
                                        ],
                                        "type": "ExternalRepository"
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalBranch"
                    }
                ]
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "title"
                    },
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$54951185c35bf8b1$var$node.hash = "18a24dc86d2787d5d678dbcfc92fb480";
var $54951185c35bf8b1$export$2e2bcd8739ae039 = $54951185c35bf8b1$var$node;


parcelRequire("42omo");



















const $9cd64de2d6b50ca9$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    resultLabel: {
        id: "search-branch-result.label",
        defaultMessage: "Branch"
    }
});


const $c04256cd812d51cc$export$e7f66f0a0905935e = ({ node: node, position: position, cloudId: cloudId, primaryProduct: primaryProduct, selectedProduct: selectedProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $54951185c35bf8b1$export$2e2bcd8739ae039), node);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, entity: entity } = data;
    const { name: branchName, container: container } = entity || {};
    const label = formatMessage((0, $9cd64de2d6b50ca9$export$defe85febe8b728c).resultLabel);
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const padlockIcon = (0, $Y34Hw.isNonPublic)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const headerMetadataParts = [
        label,
        [
            'repository-name',
            container?.name ?? null
        ],
        [
            'padlock',
            padlockIcon
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const footerComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
        linkedResults: linkedResults || [],
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data,
        url: url,
        position: position,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        isAllProductSelected: !selectedProduct
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: data.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: '',
        headerMetadataParts: headerMetadataParts,
        title: branchName,
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: data,
        appMode: appMode,
        hasRelatedLinks: !!linkedResults && linkedResults.length > 0,
        mainContentWidth: mainContentWidth,
        footer: footerComponent
    });
};





/**
 * @generated SignedSource<<5d454bb69afbfda137603ccda57b422e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $abce0ea31e67f251$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "title"
    }, v2 = {
        "kind": "ScalarField",
        "name": "url"
    }, v3 = {
        "kind": "ScalarField",
        "name": "description"
    }, v4 = {
        "kind": "ScalarField",
        "name": "integrationId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "eventEndTime"
    }, v6 = {
        "kind": "ScalarField",
        "name": "eventStartTime"
    }, v7 = {
        "kind": "ScalarField",
        "name": "videoMeetingUrl"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphCalendar_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            {
                "kind": "ScalarField",
                "name": "permissionLevel"
            },
            v4 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "createdBy",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "ThirdPartyUser",
                                        "kind": "LinkedField",
                                        "name": "thirdPartyUser",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "name"
                                            }
                                        ]
                                    }
                                ]
                            },
                            v5 /*: any*/ ,
                            v6 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "recurringEventId"
                            },
                            v7 /*: any*/ 
                        ],
                        "type": "ExternalCalendarEvent"
                    }
                ]
            },
            {
                "concreteType": "SearchResultGraphDocument",
                "kind": "LinkedField",
                "name": "linkedEntities",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    {
                        "kind": "LinkedField",
                        "name": "entity",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v6 /*: any*/ ,
                                    v5 /*: any*/ ,
                                    v7 /*: any*/ 
                                ],
                                "type": "ExternalCalendarEvent"
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    v3 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "lastModifiedDate"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    },
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$abce0ea31e67f251$var$node.hash = "fe83f0e60cf642e25009d9ac9051f446";
var $abce0ea31e67f251$export$2e2bcd8739ae039 = $abce0ea31e67f251$var$node;
































































const $a6e233594fbb8ba2$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    eventLabel: {
        id: "search-graph-calendar.calendar-label",
        defaultMessage: "Calendar"
    },
    meetingLink: {
        id: "search-graph-calendar.meeting-link",
        defaultMessage: "Meeting link"
    },
    joinMeetingLink: {
        id: "search-graph-calendar.join-meeting-link",
        defaultMessage: "Join meeting"
    },
    meetingLinkIcon: {
        id: "search-graph-calendar.meeting-link-icon",
        defaultMessage: "Join meeting"
    },
    recurringEventIcon: {
        id: "search-graph-calendar.recurring-event-icon",
        defaultMessage: "Recurring event"
    },
    recurringMetadataLabel: {
        id: "search-graph-calendar.recurring-event-label",
        defaultMessage: "Recurring"
    },
    upcomingEventsButton: {
        id: "search-graph-calendar.upcoming-events-button",
        defaultMessage: "Upcoming events"
    },
    pastEventsButton: {
        id: "search-graph-calendar.past-events-button",
        defaultMessage: "Past events"
    },
    created: {
        id: "search-graph-calendar.created.placeholder",
        defaultMessage: "{person} created"
    },
    externalPerson: {
        id: "search-graph-calendar.external-person",
        defaultMessage: "External person"
    }
});


const $c25124bad4c60a80$var$RELATED_EVENTS_STATE = {
    UPCOMING: 'upcoming',
    PAST: 'past',
    CLOSED: 'closed'
};
const $c25124bad4c60a80$export$137e3167f558cbc3 = ({ fromDate: fromDate, toDate: toDate, meetingLink: meetingLink })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    if (!fromDate || !meetingLink || !toDate) return null;
    const currentDate = new Date();
    const startDate = new Date(fromDate);
    startDate.setHours(startDate.getHours() - 2); // Checks if the event is within 2 hours
    const endDate = new Date(toDate);
    const eventIsWithin2hoursOrIsOngoing = startDate < currentDate && currentDate < endDate;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
        iconBefore: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Yaht))), {
                color: "var(--ds-icon-subtle)",
                label: ''
            }),
        href: meetingLink,
        children: eventIsWithin2hoursOrIsOngoing ? formatMessage((0, $a6e233594fbb8ba2$export$defe85febe8b728c).joinMeetingLink) : formatMessage((0, $a6e233594fbb8ba2$export$defe85febe8b728c).meetingLink)
    });
};
const $c25124bad4c60a80$var$calendarEventLinkStyles = (0, $ecnYn.xcss)({
    color: 'color.link',
    textDecoration: 'none',
    ':hover': {
        color: 'color.link',
        textDecoration: 'underline'
    },
    ':active': {
        textDecoration: 'none'
    },
    ':visited': {
        color: 'color.link.visited'
    },
    ':visited:active': {
        color: 'color.link.visited.pressed'
    },
    display: 'flex'
});
const $c25124bad4c60a80$var$relatedCalendarEventMetadataStyles = (0, $ecnYn.xcss)({
    gridColumn: 2,
    alignItems: 'center'
});
const $c25124bad4c60a80$var$nameContainer = (0, $ecnYn.xcss)({
    whiteSpace: 'nowrap'
});
const $c25124bad4c60a80$var$RelatedCalendarEvents = ({ calendarEvents: calendarEvents })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $cwkWT.default), {
        gap: "space.200",
        children: calendarEvents.map((calendarEvent)=>{
            const { id: id, entity: entity, title: title, url: url } = calendarEvent;
            if (!entity) return null;
            const labelMessageComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                size: "small",
                children: formatMessage((0, $a6e233594fbb8ba2$export$defe85febe8b728c).eventLabel)
            });
            const eventDateComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                size: "small",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e050b981814f4361$export$10f53ee736dae147), {
                    date: entity.eventStartTime
                })
            });
            const eventTimeComponent = entity.eventStartTime && entity.eventEndTime ? /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                size: "small",
                children: (0, $428ad5ad3a150038$export$abc17c795ac8b09b)({
                    from: entity.eventStartTime,
                    to: entity.eventEndTime
                })
            }) : null;
            const meetingLink = entity.videoMeetingUrl ? /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                size: "small",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
                    xcss: $c25124bad4c60a80$var$calendarEventLinkStyles,
                    href: entity.videoMeetingUrl,
                    children: formatMessage((0, $a6e233594fbb8ba2$export$defe85febe8b728c).meetingLink)
                })
            }) : null;
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
                templateColumns: "min-content 1fr",
                alignItems: "center",
                columnGap: "space.100",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $lE8sM.default), {
                        size: "16",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))),
                        label: formatMessage((0, $a6e233594fbb8ba2$export$defe85febe8b728c).recurringEventIcon),
                        appearance: "blue"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                        size: "small",
                        weight: "semibold",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
                            xcss: $c25124bad4c60a80$var$calendarEventLinkStyles,
                            href: url,
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
                        xcss: $c25124bad4c60a80$var$relatedCalendarEventMetadataStyles,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a7nUd.SearchMetadata), {
                            parts: [
                                [
                                    'calendar-label',
                                    labelMessageComponent
                                ],
                                [
                                    'event-date',
                                    eventDateComponent
                                ],
                                [
                                    'event-time',
                                    eventTimeComponent
                                ],
                                [
                                    'meeting-link',
                                    meetingLink
                                ]
                            ]
                        })
                    })
                ]
            }, id);
        })
    });
};
const $c25124bad4c60a80$var$calendarEventActionStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    gap: 'space.100'
});
const $c25124bad4c60a80$var$CalendarEventActions = ({ fromDate: fromDate, toDate: toDate, meetingLink: meetingLink, linkedEntities: linkedEntities })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [relatedEventsState, setEventsToDisplay] = (0, $42omo.useState)($c25124bad4c60a80$var$RELATED_EVENTS_STATE.CLOSED);
    const isUpcomingEventsSelected = relatedEventsState === $c25124bad4c60a80$var$RELATED_EVENTS_STATE.UPCOMING;
    const isPastEventsSelected = relatedEventsState === $c25124bad4c60a80$var$RELATED_EVENTS_STATE.PAST;
    const data = (0, $42omo.useMemo)(()=>{
        const currentDate = new Date();
        const linkedCalendarEvents = linkedEntities.flatMap((linkedEntity)=>linkedEntity.entity ? [
                {
                    id: linkedEntity.id,
                    title: linkedEntity.title,
                    url: linkedEntity.url,
                    entity: linkedEntity.entity
                }
            ] : []);
        const [pastEvents, upcomingEvents] = linkedCalendarEvents.reduce((events, currentEvent)=>{
            const isPastEvent = currentEvent.entity.eventStartTime && new Date(currentEvent.entity.eventStartTime) < currentDate;
            if (isPastEvent) return [
                events[0].concat(currentEvent),
                events[1]
            ];
            return [
                events[0],
                events[1].concat(currentEvent)
            ];
        }, [
            [],
            []
        ]);
        return {
            pastEvents: pastEvents,
            upcomingEvents: upcomingEvents
        };
    }, [
        linkedEntities
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
        gap: "space.200",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                xcss: $c25124bad4c60a80$var$calendarEventActionStyles,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)($c25124bad4c60a80$export$137e3167f558cbc3, {
                        fromDate: fromDate,
                        toDate: toDate,
                        meetingLink: meetingLink
                    }),
                    !!data.upcomingEvents.length && /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        iconAfter: (iconProps)=>isUpcomingEventsSelected ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                                ...iconProps,
                                size: "small"
                            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                                ...iconProps,
                                size: "small"
                            }),
                        onClick: ()=>setEventsToDisplay(isUpcomingEventsSelected ? $c25124bad4c60a80$var$RELATED_EVENTS_STATE.CLOSED : $c25124bad4c60a80$var$RELATED_EVENTS_STATE.UPCOMING),
                        isSelected: isUpcomingEventsSelected,
                        children: formatMessage((0, $a6e233594fbb8ba2$export$defe85febe8b728c).upcomingEventsButton)
                    }),
                    !!data.pastEvents.length && /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        iconAfter: (iconProps)=>isPastEventsSelected ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                                ...iconProps,
                                size: "small"
                            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                                ...iconProps,
                                size: "small"
                            }),
                        onClick: ()=>setEventsToDisplay(isPastEventsSelected ? $c25124bad4c60a80$var$RELATED_EVENTS_STATE.CLOSED : $c25124bad4c60a80$var$RELATED_EVENTS_STATE.PAST),
                        isSelected: isPastEventsSelected,
                        children: formatMessage((0, $a6e233594fbb8ba2$export$defe85febe8b728c).pastEventsButton)
                    })
                ]
            }),
            relatedEventsState === $c25124bad4c60a80$var$RELATED_EVENTS_STATE.UPCOMING && /*#__PURE__*/ (0, $l998X.jsx)($c25124bad4c60a80$var$RelatedCalendarEvents, {
                calendarEvents: data.upcomingEvents
            }),
            relatedEventsState === $c25124bad4c60a80$var$RELATED_EVENTS_STATE.PAST && /*#__PURE__*/ (0, $l998X.jsx)($c25124bad4c60a80$var$RelatedCalendarEvents, {
                calendarEvents: data.pastEvents
            })
        ]
    });
};
const $c25124bad4c60a80$export$aafb10d415667378 = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, thirdPartyConfigs: thirdPartyConfigs, is3pGroupingEnabled: is3pGroupingEnabled, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $abce0ea31e67f251$export$2e2bcd8739ae039), node);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { url: url, description: description, permissionLevel: permissionLevel, entity: entity, title: title, linkedEntities: linkedEntities, excerpt: excerpt, integrationId: integrationId } = data;
    const calendarEvent = (0, $42omo.useMemo)(()=>{
        const eventTime = entity?.eventStartTime && entity?.eventEndTime ? (0, $428ad5ad3a150038$export$abc17c795ac8b09b)({
            from: entity?.eventStartTime,
            to: entity?.eventEndTime
        }) : null;
        const recurringEvent = entity?.recurringEventId ? formatMessage((0, $a6e233594fbb8ba2$export$defe85febe8b728c).recurringMetadataLabel) : null;
        const getCreator = ()=>{
            const fullName = entity?.createdBy?.thirdPartyUser?.name || '';
            const firstName = fullName?.split(' ')?.[0] || formatMessage((0, $a6e233594fbb8ba2$export$defe85febe8b728c).externalPerson);
            const actionLabel = formatMessage((0, $a6e233594fbb8ba2$export$defe85febe8b728c).created, {
                person: firstName
            });
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                space: "space.025",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $678a8075b20296fe$export$3778be82376b06d7), {
                        name: fullName
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $c25124bad4c60a80$var$nameContainer,
                        children: actionLabel
                    })
                ]
            });
        };
        return {
            labelMessage: formatMessage((0, $a6e233594fbb8ba2$export$defe85febe8b728c).eventLabel),
            eventTime: eventTime,
            recurringEvent: recurringEvent,
            createdBy: getCreator()
        };
    }, [
        entity,
        formatMessage
    ]);
    const eventDateComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $e050b981814f4361$export$10f53ee736dae147), {
        date: entity?.eventStartTime
    });
    const body = /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        paddingBlockEnd: "space.100",
        children: description
    });
    const padlockIcon = (0, $Y34Hw.isNonPublic)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const headerMetadataParts = [
        calendarEvent.labelMessage,
        [
            'event-date',
            eventDateComponent
        ],
        [
            'event-time',
            calendarEvent.eventTime
        ],
        calendarEvent.recurringEvent,
        [
            'padlock',
            padlockIcon
        ],
        [
            'createdBy',
            calendarEvent.createdBy
        ]
    ];
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const isGoogleCalendar = integrationId === 'ari:cloud:platform::integration/google';
    const shouldRenderSimilarResults = isGoogleCalendar && linkedResults?.some((linkedResult)=>linkedResult.category?.toUpperCase() === 'SIMILAR');
    const shouldShowRelatedLinks = linkedResults && linkedResults.length > 0;
    const footerComponent = shouldShowRelatedLinks ? shouldRenderSimilarResults ? /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$59c57a80401f0a6), {
        linkedResults: linkedResults || [],
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data,
        url: url,
        position: position,
        onResultClicked: onResultClicked,
        isAllProductSelected: !selectedProduct,
        onResultContextMenu: onResultContextMenu,
        is3pGroupingEnabled: is3pGroupingEnabled,
        type: calendarEvent.labelMessage
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
        linkedResults: linkedResults || [],
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data,
        url: url,
        position: position,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        isAllProductSelected: !selectedProduct
    }) : /*#__PURE__*/ (0, $l998X.jsx)($c25124bad4c60a80$var$CalendarEventActions, {
        meetingLink: entity?.videoMeetingUrl,
        fromDate: entity?.eventStartTime,
        toDate: entity?.eventEndTime,
        linkedEntities: linkedEntities ?? []
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: data.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: excerpt ? (0, $Y34Hw.processExcerpt)(excerpt, true) : body
        }),
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: data,
        appMode: appMode,
        footer: footerComponent,
        hasRelatedLinks: !!linkedResults && linkedResults.length > 0,
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<27be2369f0ef8112d3efbd0fe3b1bb4b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $13c3fde251b8ec2f$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "title"
    }, v2 = {
        "kind": "ScalarField",
        "name": "url"
    }, v3 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphComment_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            v3 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "container",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "displayName"
                                            },
                                            v2 /*: any*/ 
                                        ],
                                        "type": "ExternalSpace"
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalComment"
                    }
                ]
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    v3 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$13c3fde251b8ec2f$var$node.hash = "b17f6d38cfefaa62af51c3cdcd08a442";
var $13c3fde251b8ec2f$export$2e2bcd8739ae039 = $13c3fde251b8ec2f$var$node;


parcelRequire("42omo");























const $463097be5d0afaf7$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    resultLabel: {
        id: "comment-result.label",
        defaultMessage: "Comment"
    }
});


const $318bc8ae651e831c$export$9c9dc84757cc5710 = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const data = (0, $irOoi.useFragment)((0, $13c3fde251b8ec2f$export$2e2bcd8739ae039), node);
    const { id: id, url: url, title: title, excerpt: excerpt, entity: entity, lastModifiedDate: lastModifiedDate } = data;
    const lastModifiedComponent = lastModifiedDate && /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    });
    const label = formatMessage((0, $463097be5d0afaf7$export$defe85febe8b728c).resultLabel);
    const containerName = entity?.container?.displayName;
    const containerUrl = entity?.container?.url;
    const container = containerUrl && containerName ? /*#__PURE__*/ (0, $l998X.jsx)((0, $655681e89d0ffd52$export$2e2bcd8739ae039), {
        label: containerName,
        href: containerUrl
    }) : containerName;
    // only include site if DC product
    // NOTE: jira-dc results now go through JiraDcSearchResult component
    // this component can be removed once a custom ConfluenceDcSearchResult component is made
    const site = product === (0, $hB77E.ProductKeys3P).ConfluenceDC ? thirdPartyConfigs?.[product]?.workspaceName || null : null;
    const headerMetadataParts = [
        [
            'label',
            label
        ],
        [
            'site',
            site
        ],
        [
            'container',
            container
        ],
        [
            'lastModified',
            lastModifiedComponent
        ]
    ];
    const enrichedTitle = (0, $Y34Hw.enrichExcerpt)(title);
    const description = excerpt && /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
        description: (0, $Y34Hw.processExcerpt)(excerpt)
    });
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const footerComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
        linkedResults: linkedResults || [],
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data,
        url: url,
        position: position,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        isAllProductSelected: !selectedProduct
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        id: id,
        product: product,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        title: enrichedTitle,
        description: description,
        headerMetadataParts: headerMetadataParts,
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        isThirdParty: true,
        icon: icon,
        footer: footerComponent,
        hasRelatedLinks: !!linkedResults && linkedResults.length > 0,
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<b6c5de4176fc8faebf102875d89083e3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a2202b2805c605b9$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "title"
    }, v2 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    }, v3 = {
        "kind": "ScalarField",
        "name": "url"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphCommit_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionLevel"
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "author",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                            v4 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "picture"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "name": "container",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v4 /*: any*/ 
                                        ],
                                        "type": "ExternalRepository"
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalCommit"
                    }
                ]
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    v3 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$a2202b2805c605b9$var$node.hash = "3b87b78b8c8f590b784f938a7fcbc314";
var $a2202b2805c605b9$export$2e2bcd8739ae039 = $a2202b2805c605b9$var$node;


parcelRequire("42omo");


























const $9ad330cd2bdd6e39$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    resultLabel: {
        id: "search-commit-result.label",
        defaultMessage: "Commit"
    }
});


const $fc7ae146ec7d2606$export$f8ac23605711b215 = ({ node: node, position: position, cloudId: cloudId, primaryProduct: primaryProduct, selectedProduct: selectedProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $a2202b2805c605b9$export$2e2bcd8739ae039), node);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, title: title, excerpt: excerpt, entity: entity } = data;
    const { author: author, container: container } = entity || {};
    const label = formatMessage((0, $9ad330cd2bdd6e39$export$defe85febe8b728c).resultLabel);
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const padlockIcon = (0, $Y34Hw.isNonPublic)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    let messageDescription;
    if (author?.user) messageDescription = /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
        space: "space.025",
        alignBlock: "start",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $678a8075b20296fe$export$3778be82376b06d7), {
                name: author.user.name,
                picture: author.user.picture
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                children: (0, $Y34Hw.processExcerpt)(excerpt, true, `${author.user.name}: `)
            })
        ]
    });
    else messageDescription = /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
        description: (0, $Y34Hw.processExcerpt)(excerpt, true)
    });
    const headerMetadataParts = [
        label,
        [
            'repository-name',
            container?.name ?? null
        ],
        [
            'padlock',
            padlockIcon
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const footerComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
        linkedResults: linkedResults || [],
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data,
        url: url,
        position: position,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        isAllProductSelected: !selectedProduct
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: data.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: messageDescription,
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: data,
        appMode: appMode,
        footer: footerComponent,
        hasRelatedLinks: !!linkedResults && linkedResults.length > 0,
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<2cd5c8f9cc778323ed9edfb5bcc08e67>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4ccbeb1508288f91$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphConfluenceDc_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "ScalarField",
                "name": "subtype"
            },
            {
                "kind": "ScalarField",
                "name": "title"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "container",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "displayName"
                                            },
                                            v0 /*: any*/ 
                                        ],
                                        "type": "ExternalSpace"
                                    }
                                ]
                            },
                            {
                                "concreteType": "ExternalReaction",
                                "kind": "LinkedField",
                                "name": "reactions",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "reactionType"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "total"
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalDocument"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$4ccbeb1508288f91$var$node.hash = "84328c11caa37465be9e406ec32593d9";
var $4ccbeb1508288f91$export$2e2bcd8739ae039 = $4ccbeb1508288f91$var$node;






























const $abcafd932f47a17f$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    pageLabel: {
        id: "search-graph-confluence-dc.document.pageLabel",
        defaultMessage: "Page"
    },
    spaceLabel: {
        id: "search-graph-confluence-dc.document.spaceLabel",
        defaultMessage: "Space"
    },
    blogpostLabel: {
        id: "search-graph-confluence-dc.document.blogpostLabel",
        defaultMessage: "Blog Post"
    },
    commentLabel: {
        id: "search-graph-confluence-dc.document.commentLabel",
        defaultMessage: "Comment"
    },
    attachmentLabel: {
        id: "search-graph-confluence-dc.document.attachmentLabel",
        defaultMessage: "Attachment"
    }
});


const $61cfa2381edf5d9d$var$SUBTYPE_PAGE = 'page';
const $61cfa2381edf5d9d$var$SUBTYPE_BLOGPOST = 'blogpost';
const $61cfa2381edf5d9d$var$LIKE_REACTION_TYPE = 'like';
const $61cfa2381edf5d9d$var$CONFLUENCE_DC_LABELS = {
    [$61cfa2381edf5d9d$var$SUBTYPE_PAGE]: (0, $abcafd932f47a17f$export$defe85febe8b728c).pageLabel,
    [$61cfa2381edf5d9d$var$SUBTYPE_BLOGPOST]: (0, $abcafd932f47a17f$export$defe85febe8b728c).blogpostLabel
};
const $61cfa2381edf5d9d$var$ATTACHMENT_SUBTYPES = new Set([
    'archive',
    'audio',
    'code',
    'document',
    'image',
    'pdf',
    'presentation',
    'spreadsheet',
    'video',
    'web-page',
    'other'
]);
const $61cfa2381edf5d9d$var$getLabel = (subtype)=>{
    if ($61cfa2381edf5d9d$var$ATTACHMENT_SUBTYPES.has(subtype)) return (0, $abcafd932f47a17f$export$defe85febe8b728c).attachmentLabel;
    return $61cfa2381edf5d9d$var$CONFLUENCE_DC_LABELS[subtype];
};
const $61cfa2381edf5d9d$export$b773c9cc5f495a3 = ({ node: node, position: position, cloudId: cloudId, primaryProduct: primaryProduct, appMode: appMode, product: product, selectedProduct: selectedProduct, thirdPartyConfigs: thirdPartyConfigs, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $4ccbeb1508288f91$export$2e2bcd8739ae039), node);
    const { id: id, lastModifiedDate: lastModifiedDate, url: url, title: title, excerpt: excerpt, subtype: subtype, entity: entity } = data;
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const label = subtype ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...$61cfa2381edf5d9d$var$getLabel(subtype)
    }) : null;
    const site = thirdPartyConfigs?.[(0, $hB77E.ProductKeys3P).ConfluenceDC]?.workspaceName;
    const spaceName = entity?.container?.displayName;
    const spaceUrl = entity?.container?.url;
    const space = spaceUrl && spaceName ? /*#__PURE__*/ (0, $l998X.jsx)((0, $655681e89d0ffd52$export$2e2bcd8739ae039), {
        label: spaceName,
        href: spaceUrl
    }) : spaceName;
    const metadataParts = [
        [
            'label',
            label
        ],
        [
            'site',
            site
        ],
        [
            'space',
            space
        ],
        [
            'lastModified',
            lastModifiedComponent
        ]
    ];
    const numberOfLikes = data.entity?.reactions?.find((reaction)=>reaction?.reactionType?.toLowerCase() === $61cfa2381edf5d9d$var$LIKE_REACTION_TYPE)?.total ?? 0;
    const likeCount = (0, $42omo.useMemo)(()=>(0, $f70284887e2e1865$export$b52fa2ff0823604f)(numberOfLikes), [
        numberOfLikes
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.ConfluenceIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        headerMetadataParts: metadataParts,
        headerMetadataSocialParts: [
            [
                'like-count',
                likeCount
            ]
        ],
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: (0, $Y34Hw.processExcerpt)(excerpt)
        }),
        primaryProduct: primaryProduct,
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<0e0d4467f24fc4b9cd518637b756b956>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4759be98858eb7d9$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "url"
    }, v2 = {
        "kind": "ScalarField",
        "name": "subtype"
    }, v3 = {
        "kind": "ScalarField",
        "name": "integrationId"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphConversation_AtlassianSearchPage",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "messageBody_AtlassianSearchPage"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "displayName"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "memberCount"
                            },
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "members",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalConversation"
                    }
                ]
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "title"
                    },
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "lastModifiedDate"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    v2 /*: any*/ ,
                    v3 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$4759be98858eb7d9$var$node.hash = "d800bf941cf1671583635a3ad0f0404f";
var $4759be98858eb7d9$export$2e2bcd8739ae039 = $4759be98858eb7d9$var$node;


parcelRequire("42omo");















/**
 * @generated SignedSource<<7ae77abbb5cf3c366d5a24cb3f7d89ee>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6b573a545d440457$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "description"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "messageBody_AtlassianSearchPage",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "mention_AtlassianSearchPage_UserMention"
            },
            {
                "kind": "FragmentSpread",
                "name": "channel_AtlassianSearchPage"
            },
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": v0 /*: any*/ ,
                        "type": "ExternalMessage"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": v0 /*: any*/ ,
                        "type": "ExternalConversation"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$6b573a545d440457$var$node.hash = "24e4e9e72573cfcbb15c7aca65aa13b6";
var $6b573a545d440457$export$2e2bcd8739ae039 = $6b573a545d440457$var$node;


parcelRequire("42omo");



















/**
 * @generated SignedSource<<8d85788156178c6d16f5e3ad86cbdd5e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b27b38637b9b254f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "channel_AtlassianSearchPage",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "entity",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "concreteType": "ExternalAssociationConnection",
                            "kind": "LinkedField",
                            "name": "associatedWith",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ExternalAssociationEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "ExternalAssociation",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "entity",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                {
                                                                    "alias": "channelId",
                                                                    "kind": "ScalarField",
                                                                    "name": "externalId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "displayName"
                                                                }
                                                            ],
                                                            "type": "ExternalConversation"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "type": "ExternalMessage"
                }
            ]
        }
    ],
    "type": "SearchResultGraphDocument"
};
$b27b38637b9b254f$var$node.hash = "65025c6fc5eb039a81cc5f05b1245093";
var $b27b38637b9b254f$export$2e2bcd8739ae039 = $b27b38637b9b254f$var$node;


parcelRequire("42omo");







const $dca8c86965c6f71e$var$SPACE = ' ';
const $dca8c86965c6f71e$var$channelStyle = null;
const $dca8c86965c6f71e$export$cfdacaa37f9b4dd7 = ({ children: children, node: node, noSpace: noSpace })=>{
    const channelId = children?.[0];
    const data = (0, $irOoi.useFragment)((0, $b27b38637b9b254f$export$2e2bcd8739ae039), node);
    const channelAssociation = data.entity?.associatedWith?.edges?.find((edge)=>edge?.node?.entity?.__typename === 'ExternalConversation' && Boolean(channelId) && channelId === edge?.node?.entity?.channelId);
    if (!channelAssociation || channelAssociation?.node?.entity?.__typename !== 'ExternalConversation') return null;
    const entity = channelAssociation?.node?.entity;
    return /*#__PURE__*/ (0, $l998X.jsxs)("span", {
        className: (0, $gMc0m.default)([
            "_o5721q9c"
        ]),
        children: [
            noSpace ? '' : $dca8c86965c6f71e$var$SPACE,
            "#",
            entity?.displayName
        ]
    });
};





/**
 * @generated SignedSource<<dfb3843f1d39aab778b4176cf2687df5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $98ec54643c336b70$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "externalId"
    }, v1 = [
        v0 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "nickname"
        },
        {
            "kind": "ScalarField",
            "name": "email"
        },
        {
            "kind": "ScalarField",
            "name": "picture"
        },
        {
            "concreteType": "ThirdPartyUserExtendedProfile",
            "kind": "LinkedField",
            "name": "extendedProfile",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "jobTitle"
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "mention_AtlassianSearchPage_UserMention",
        "selections": [
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "concreteType": "ExternalAssociationConnection",
                                "kind": "LinkedField",
                                "name": "associatedWith",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "ExternalAssociationEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "ExternalAssociation",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "entity",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v1 /*: any*/ ,
                                                                "type": "ThirdPartyUser"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalMessage"
                    }
                ]
            },
            {
                "concreteType": "ThirdPartyUser",
                "kind": "LinkedField",
                "name": "allContributors",
                "plural": true,
                "selections": v1 /*: any*/ 
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$98ec54643c336b70$var$node.hash = "0f985bc027ec0834f1a24c86f3852a30";
var $98ec54643c336b70$export$2e2bcd8739ae039 = $98ec54643c336b70$var$node;


parcelRequire("42omo");


















const $376ef8b88d296257$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    externalPersonLabel: {
        id: "search-result.user-mention.external-person",
        defaultMessage: "External person"
    }
});


/**
 * The whitespace in between aliases <!here> <!channel> is removed
 * This constant prevent the alias from being pushed together ex: "@here@channel"
 * We are using this constant rather than adding a space through CSS because it adds
 * a real space character that does not break up the text when selecting.
 * */ const $c831c43df09baf69$var$SPACE = ' ';
const $c831c43df09baf69$export$6ae462bff574866a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("span", {
        children: [
            $c831c43df09baf69$var$SPACE,
            "@",
            children
        ]
    });
};
const $c831c43df09baf69$export$85d6e42a90e882cb = ({ children: children, integrationId: integrationId, node: node })=>{
    const userId = children?.[0];
    let name;
    let entity;
    const data = (0, $irOoi.useFragment)((0, $98ec54643c336b70$export$2e2bcd8739ae039), node);
    if ((0, $dh538.fg)('exclude_3p_entity_in_search_results')) entity = data.allContributors?.find((contributor)=>Boolean(userId) && userId === contributor?.externalId);
    else {
        const userAssociation = data.entity?.associatedWith?.edges?.find((edge)=>Boolean(userId) && userId === edge?.node?.entity?.externalId);
        entity = userAssociation?.node?.entity;
    }
    name = entity?.nickname || entity?.name;
    const email = entity?.email;
    const copyToClipboard = (0, $6a8b466b77e29197$export$b2199c37e85de4a7)(email);
    if (entity && name) {
        // We are waiting for this commit ticket to complete for jobTitle & profileUrl
        // https://hello.jira.atlassian.cloud/browse/COMMIT-14774
        const user = {
            name: name,
            profilePicUrl: entity.picture,
            jobTitle: entity.extendedProfile?.jobTitle,
            profileUrl: null // not available as of late Oct 2024
        };
        if (user) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                $c831c43df09baf69$var$SPACE,
                /*#__PURE__*/ (0, $l998X.jsx)((0, $f3accdd0219154ae$export$4d833b6a2de3de88), {
                    name: name,
                    content: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $168e8abba0f0ce48$export$4c094c8f61edecb4), {
                            onCopyEmail: copyToClipboard,
                            user: user,
                            externalMessageIntegration: (0, $Y34Hw.getExternalMessageDmIntegrationInfo)(integrationId, entity)
                        })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)($c831c43df09baf69$export$6ae462bff574866a, {
        children: name || /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $376ef8b88d296257$export$defe85febe8b728c).externalPersonLabel
        })
    });
};


const $f63e4118bbf61370$var$styles = {
    title: "_1reo15vq _18m915vq _1e0c1o8l _p12fuuw1 _1bto1l2s _o5721q9c _s7n4yfq0 _syazazsu",
    separator: "_19bvu2gc _u5f3u2gc"
}; /**
    * The whitespace in between aliases <!here> <!channel> is removed
    * This constant prevent the alias from being pushed together ex: "@here@channel"
    * We are using this constant rather than adding a space through CSS because it adds
    * a real space character that does not break up the text when selecting.
    * */ 
const $f63e4118bbf61370$var$SPACE = ' ';
const $f63e4118bbf61370$export$95e34c5d2bf14b09 = (inputString)=>{
    if (!inputString) return '';
    const processed = (0, $4dd635508e197aad$export$7e4bcd4afb389edb)(inputString) // removing * or _, which can cause massive slowdown when processed by markdown-to-jsx's Markdown component
    .replace(/[*_]/g, '') //Slack User
    .replace(/<@(\w+)>/g, '<Mention>$1</Mention>') //Teams User
    .replace(/<@([a-zA-Z0-9-]+)>/g, '<Mention>$1</Mention>') //Slack Channel
    .replace(/<#(\w+)\|?>/g, '<Channel>$1</Channel>') //Teams Channel variation 1
    .replace(/<#teamId\/[a-f0-9-]+\/channelId\/teamId\/([a-f0-9-]+)\/channelId\/([0-9a-zA-Z:@._-]+)>/g, '<Channel>teamId/$1/channelId/$2</Channel>') // Teams Channel variation 2
    .replace(/<[@#]teamId\/([a-f0-9-]+)\/channelId\/([0-9a-zA-Z:@._-]+)>/g, '<Channel>teamId/$1/channelId/$2</Channel>').replace(/<\!subteam\^(\w+)>/g, '<Subteam>$1</Subteam>').replace(/<\!(\w+)>/g, '<Alias>$1</Alias>') // emojis, works for those that have repeating pattern as well. eg: :word-word-word:
    .replace(/:((@@@hl@@@.+?@@@endhl@@@)(-@@@hl@@@.+?@@@endhl@@@)*):/g, (match)=>{
        const words = match.match(/@@@hl@@@(.+?)@@@endhl@@@/g)?.map((m)=>m.replace(/@@@hl@@@|@@@endhl@@@/g, '')) || [];
        return `<Highlight>:${words.join('-')}:</Highlight>`;
    }).replace(/@@@hl@@@(.+?)@@@endhl@@@/g, '<Highlight>$1</Highlight>').replace(/<@<Highlight>(.+?)<\/Highlight>>/g, '<Highlight><Mention>$1</Mention></Highlight>').replace(/<#<Highlight>(.+?)<\/Highlight>\|>/g, '<Highlight><Channel>$1</Channel></Highlight>'); // .replace(/\:(\w+)\:/g, '<Emoji>$1</Emoji>') Support for emojis coming soon
    // Check if the processed string starts with a channel tag and replace the first occurrence with ChannelWithoutSpace
    if (processed.startsWith('<Highlight><Channel>')) return processed.replace('<Highlight><Channel>', '<HighlightWithoutSpace><ChannelWithoutSpace>').replace('</Channel></Highlight>', '</ChannelWithoutSpace></HighlightWithoutSpace>');
     // Check if the processed string starts with a highlight tag and replace the first occurrence with HighlightWithoutSpace
    if (processed.startsWith('<Highlight>')) return processed.replace('<Highlight>', '<HighlightWithoutSpace>').replace('</Highlight>', '</HighlightWithoutSpace>');
    return processed;
};
const $f63e4118bbf61370$var$PlainText = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
const $f63e4118bbf61370$var$Highlight = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
        as: "strong",
        children: [
            $f63e4118bbf61370$var$SPACE,
            children
        ]
    });
const $f63e4118bbf61370$var$HighlightWithoutSpace = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
        as: "strong",
        children: children
    });
const $f63e4118bbf61370$var$ChannelWithoutSpace = ({ children: children, ...props })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $dca8c86965c6f71e$export$cfdacaa37f9b4dd7), {
        ...props,
        noSpace: true,
        children: children
    }); // It is assumed that description is the full message and excerpt is a potentially truncated version
const $f63e4118bbf61370$export$bf780c85e04b8810 = (excerpt, description)=>{
    if (excerpt.length === 0 || description.length === 0 || excerpt === description) return excerpt;
    var modifiedExcerpt = excerpt; // regex which has the starting tag of a mention, but not the end
    const startTagRegex = /<[@#][^> ]*$/g;
    const startTagMatch = modifiedExcerpt.match(startTagRegex);
    if (startTagMatch) {
        // theoretically, there should only be one match at max
        const partialMention = startTagMatch[startTagMatch.length - 1]; // the partialMention can appear several times in the string. We need to find the correct one
        const partialMentionInExcerptCount = excerpt.split(partialMention).length - 1;
        const splitDescription = description.split(partialMention); // check if partial mention is found in description
        if (splitDescription.length >= 2) {
            const splitByClosingTag = splitDescription[partialMentionInExcerptCount].split('>'); // check if closing tag is found
            if (splitByClosingTag.length >= 2) {
                const restOfString = splitByClosingTag[0];
                modifiedExcerpt = modifiedExcerpt + restOfString + '>';
            }
        }
    } // const endTagRegex = /^[^< ]*\.tacv2>/g; This works on channel mentions that I have observed
    // weaker regex which tries to capture the ending tag of a mention (assuming it always ends with >), but not the start
    const weakEndTagRegex = /^[^< ]*>/g;
    const weakEndTagMatch = modifiedExcerpt.match(weakEndTagRegex);
    if (weakEndTagMatch) {
        // theoretically, there should only be one match at max
        const partialMention = weakEndTagMatch[0];
        const splitDescription = description.split(partialMention); // partialMention not found in description
        if (splitDescription.length >= 2) {
            const splitByOpeningTag = splitDescription[0].split('<'); // opening tag found
            if (splitByOpeningTag.length >= 2) {
                const restOfString = splitByOpeningTag[splitByOpeningTag.length - 1];
                modifiedExcerpt = '<' + restOfString + modifiedExcerpt;
            }
        }
    }
    return modifiedExcerpt;
};
const $f63e4118bbf61370$export$41910d2944957acd = (body)=>{
    const hlStartTag = '@@@hl@@@'; // if cannot find hl tag, return the original body
    if (!body.includes('@@@hl@@@')) return body;
    const highlightStringAndRemainder = body.substring(body.indexOf(hlStartTag));
    let cursorPosition = body.indexOf(hlStartTag) - 1;
    let numChars = 0;
    let prefix = '';
    let currentWord = '';
    let numWords = 0; // get all words before cursorPosition, less than 15 characters
    while(numChars < 15 && cursorPosition > 0){
        currentWord = body[cursorPosition] + currentWord;
        cursorPosition--;
        numChars++;
        if (body[cursorPosition] === ' ') {
            prefix = currentWord + prefix;
            currentWord = '';
            numWords++;
        }
    }
    if (cursorPosition <= 0) return body;
    else if (numWords === 0) return '...' + currentWord + highlightStringAndRemainder;
    else return '...' + prefix + highlightStringAndRemainder;
};
const $f63e4118bbf61370$export$36e783c4ff07cd7c = ({ node: node, integrationId: integrationId })=>{
    const data = (0, $irOoi.useFragment)((0, $6b573a545d440457$export$2e2bcd8739ae039), node); // in ConversationSearchResult, data.excerpt is used as the body
    let excerpt = data.excerpt;
    if (data.excerpt) excerpt = $f63e4118bbf61370$export$bf780c85e04b8810(data.excerpt, data?.entity?.description ?? '');
    let title = data.title || '';
    let body = excerpt || data?.entity?.description || '';
    const isMicrosoftTeams = integrationId === 'ari:cloud:platform::integration/microsoft';
    const shouldShowTitle = title && isMicrosoftTeams && (0, $dh538.fg)('search_page_enable_teams_title_message');
    title = $f63e4118bbf61370$export$41910d2944957acd(title);
    body = $f63e4118bbf61370$export$41910d2944957acd(body);
    const markdownOptions = {
        forceInline: true,
        overrides: {
            a: $f63e4118bbf61370$var$PlainText,
            Highlight: $f63e4118bbf61370$var$Highlight,
            HighlightWithoutSpace: $f63e4118bbf61370$var$HighlightWithoutSpace,
            Alias: (0, $c831c43df09baf69$export$6ae462bff574866a),
            Mention: {
                component: (0, $c831c43df09baf69$export$85d6e42a90e882cb),
                props: {
                    integrationId: integrationId,
                    node: data
                }
            },
            Channel: {
                component: (0, $dca8c86965c6f71e$export$cfdacaa37f9b4dd7),
                props: {
                    node: data
                }
            },
            ChannelWithoutSpace: {
                component: $f63e4118bbf61370$var$ChannelWithoutSpace,
                props: {
                    node: data
                }
            }
        }
    }; /**
      * Even though we remove markdown from the body, we still use this component
      * to render mentions and highlighted text */ 
    if (shouldShowTitle) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                as: "span",
                xcss: $f63e4118bbf61370$var$styles.title,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e6pbP.default), {
                    options: markdownOptions,
                    children: $f63e4118bbf61370$export$95e34c5d2bf14b09(title)
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                as: "span",
                xcss: $f63e4118bbf61370$var$styles.separator,
                children: "\xb7"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $e6pbP.default), {
                options: markdownOptions,
                children: $f63e4118bbf61370$export$95e34c5d2bf14b09(body)
            })
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $e6pbP.default), {
        options: markdownOptions,
        children: $f63e4118bbf61370$export$95e34c5d2bf14b09(body)
    });
};









const $49fb29a3608bc9fe$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    label: {
        id: "search-page-relay.results.product-results.third-party.conversation-search-result.label",
        defaultMessage: "Channel"
    },
    memberCount: {
        id: "search-page-relay.results.product-results.third-party.conversation-search-result.member-count",
        defaultMessage: "{count, plural, one {# member} other {# members}}"
    },
    lastActive: {
        id: "search-page-relay.results.product-results.third-party.conversation-search-result.time-since-label",
        defaultMessage: "Last active {formattedDate}"
    },
    unknownChannel: {
        id: "search-page-relay.results.product-results.third-party.conversation-search-result.unknown-channel",
        defaultMessage: "unknown-channel"
    },
    privateChannel: {
        id: "search-page-relay.results.product-results.third-party.conversation-search-result.private-channel",
        defaultMessage: "Private channel"
    }
});


const $3656b7fd5d879deb$export$73ee84431f6e335a = ({ node: node, position: position, cloudId: cloudId, primaryProduct: primaryProduct, selectedProduct: selectedProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const data = (0, $irOoi.useFragment)((0, $4759be98858eb7d9$export$2e2bcd8739ae039), node);
    const memberCount = data.entity?.memberCount ?? data.entity?.members?.length;
    const parts = [
        [
            'label',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $49fb29a3608bc9fe$export$a7357cdd1f0b0168).label
            })
        ],
        [
            'memberCount',
            memberCount && /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $49fb29a3608bc9fe$export$a7357cdd1f0b0168).memberCount,
                values: {
                    count: memberCount
                }
            })
        ]
    ];
    let privateChannelName;
    if (data.subtype === 'private-channel') privateChannelName = /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
                label: formatMessage((0, $49fb29a3608bc9fe$export$a7357cdd1f0b0168).privateChannel),
                size: "small"
            }),
            data.entity?.displayName
        ]
    });
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: data.id,
        product: product,
        productSelected: true,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $f63e4118bbf61370$export$36e783c4ff07cd7c), {
            integrationId: data.integrationId,
            node: data
        }),
        icon: icon,
        headerMetadataParts: parts,
        title: privateChannelName || `#${data.entity?.displayName || formatMessage((0, $49fb29a3608bc9fe$export$a7357cdd1f0b0168).unknownChannel)}`,
        url: data.url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        appMode: appMode,
        footer: /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
            linkedResults: linkedResults || [],
            thirdPartyConfigs: thirdPartyConfigs,
            partial: data,
            position: position,
            onResultClicked: onResultClicked,
            url: data.url,
            onResultContextMenu: onResultContextMenu,
            isAllProductSelected: !selectedProduct
        }),
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<87e58b2a839f3a0e386c02423408618c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3958b5e8ee8a488c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "searchGraphCustomerContact_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        },
        {
            "kind": "ScalarField",
            "name": "lastModifiedDate"
        },
        {
            "kind": "LinkedField",
            "name": "entity",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "displayName"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "accountName"
                        },
                        {
                            "concreteType": "ExternalUser",
                            "kind": "LinkedField",
                            "name": "contactUser",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ThirdPartyUser",
                                    "kind": "LinkedField",
                                    "name": "thirdPartyUser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ThirdPartyUserExtendedProfile",
                                            "kind": "LinkedField",
                                            "name": "extendedProfile",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jobTitle"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "type": "ExternalCustomerContact"
                }
            ]
        }
    ],
    "type": "SearchResultGraphDocument"
};
$3958b5e8ee8a488c$var$node.hash = "dbeb15a9aac7e4bc9e241ebc3dade593";
var $3958b5e8ee8a488c$export$2e2bcd8739ae039 = $3958b5e8ee8a488c$var$node;


parcelRequire("42omo");

















const $b46856d2bd584e9e$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    eventLabel: {
        id: "search-graph-customer-contact.customer-contact-label",
        defaultMessage: "Customer Contact"
    }
});


const $19060b73dca5ceaf$export$a3fd078d13d8ac2 = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, mainContentWidth: mainContentWidth })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const data = (0, $irOoi.useFragment)((0, $3958b5e8ee8a488c$export$2e2bcd8739ae039), node);
    const { id: id, url: url, lastModifiedDate: lastModifiedDate, entity: entity } = data;
    const lastModifiedComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    });
    const accountName = entity?.accountName;
    const thirdPartyUser = entity?.contactUser?.thirdPartyUser;
    const title = entity?.displayName;
    const headerMetadataParts = [
        formatMessage((0, $b46856d2bd584e9e$export$defe85febe8b728c).eventLabel),
        [
            'account-name',
            accountName
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: thirdPartyUser?.extendedProfile?.jobTitle,
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<ababc96d30bf5d58173de3e35aebafc4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d76a1f4103738a2d$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "title"
    }, v2 = {
        "kind": "ScalarField",
        "name": "url"
    }, v3 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider"
            }
        ],
        "kind": "Fragment",
        "name": "searchGraphCustomerOrg_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v4 /*: any*/ ,
                            {
                                "condition": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "concreteType": "ExternalUser",
                                        "kind": "LinkedField",
                                        "name": "contributors",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "ThirdPartyUser",
                                                "kind": "LinkedField",
                                                "name": "thirdPartyUser",
                                                "plural": false,
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    v5 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "condition": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "concreteType": "ExternalUser",
                                        "kind": "LinkedField",
                                        "name": "owners",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "ThirdPartyUser",
                                                "kind": "LinkedField",
                                                "name": "thirdPartyUser",
                                                "plural": false,
                                                "selections": [
                                                    v5 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "name": "parent",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v0 /*: any*/ ,
                                            v4 /*: any*/ 
                                        ],
                                        "type": "ExternalCustomerOrg"
                                    }
                                ]
                            },
                            {
                                "concreteType": "ExternalCustomerOrgLastActivity",
                                "kind": "LinkedField",
                                "name": "customerOrgLastActivity",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "lastActivityAt"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "event"
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalCustomerOrg"
                    }
                ]
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    v3 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$d76a1f4103738a2d$var$node.hash = "f865c9e7b61b842c45c871a53ff1a606";
var $d76a1f4103738a2d$export$2e2bcd8739ae039 = $d76a1f4103738a2d$var$node;


parcelRequire("42omo");
























const $2285d5346b37029f$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    eventLabel: {
        id: "search-graph-customer-org.customer-org-label",
        defaultMessage: "Customer Organization"
    }
});


const $77eea3dd744c20d3$var$styles = {
    subheading: "_11c8fhey _syaz1rpy"
};
const $77eea3dd744c20d3$export$f49280cd3d93cb86 = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const data = (0, $irOoi.useFragment)((0, $d76a1f4103738a2d$export$2e2bcd8739ae039), node);
    const { id: id, url: url, title: title, lastModifiedDate: lastModifiedDate, entity: entity } = data;
    const lastModifiedComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    });
    const body = /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
        children: entity?.customerOrgLastActivity?.event
    });
    const description = /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
                description: body
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $77eea3dd744c20d3$var$styles.subheading,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                    lastModified: entity?.customerOrgLastActivity?.lastActivityAt
                })
            })
        ]
    });
    const parent = entity?.parent?.displayName;
    const ownerFromContributors = entity?.contributors?.[0]?.thirdPartyUser?.name;
    const ownerFromOwners = ()=>{
        if (!entity?.owners || !Array.isArray(entity.owners) || entity.owners.length === 0) return undefined;
        return entity.owners[0]?.thirdPartyUser?.name;
    };
    const ownerName = ownerFromOwners() ?? ownerFromContributors;
    const headerMetadataParts = [
        formatMessage((0, $2285d5346b37029f$export$defe85febe8b728c).eventLabel),
        [
            'parent',
            parent
        ],
        [
            'owner',
            ownerName
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const footerComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
        linkedResults: linkedResults || [],
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data,
        url: url,
        position: position,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        isAllProductSelected: !selectedProduct
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: description,
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: data,
        appMode: appMode,
        footer: footerComponent,
        hasRelatedLinks: !!linkedResults && linkedResults.length > 0,
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<fce8bcb9217fe66a50f0f5d2037b6b08>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8b389320d1d2d649$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphDashboard_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "title"
            },
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v0 /*: any*/ ,
                            v1 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "workspaceName"
                            },
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "owners",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "ThirdPartyUser",
                                        "kind": "LinkedField",
                                        "name": "thirdPartyUser",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "name"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalDashboard"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$8b389320d1d2d649$var$node.hash = "a344ff8b7dc86aea8605c36b488e8de2";
var $8b389320d1d2d649$export$2e2bcd8739ae039 = $8b389320d1d2d649$var$node;


parcelRequire("42omo");

















const $6fee8e7e690f660e$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    eventLabel: {
        id: "search-graph-dashboard.dashboard-label",
        defaultMessage: "Dashboard"
    }
});


const $6bb44605052e87f7$export$5039b6acf48ea77b = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, mainContentWidth: mainContentWidth })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const partial = (0, $irOoi.useFragment)((0, $8b389320d1d2d649$export$2e2bcd8739ae039), node);
    const { url: url, entity: entity, title: title, lastModifiedDate: lastModifiedDate, excerpt: excerpt } = partial;
    const lastModifiedComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    });
    const getOwnerName = ()=>{
        if (!entity?.owners || !Array.isArray(entity.owners) || entity.owners.length === 0) return undefined;
        return entity.owners[0]?.thirdPartyUser?.name;
    };
    const workspaceName = entity?.workspaceName;
    const ownerName = getOwnerName();
    const headerMetadataParts = [
        formatMessage((0, $6fee8e7e690f660e$export$defe85febe8b728c).eventLabel),
        [
            'workspaceName',
            workspaceName
        ],
        ...workspaceName && ownerName && workspaceName === ownerName ? [] : ownerName ? [
            [
                'owner',
                ownerName
            ]
        ] : [],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: partial.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        icon: icon,
        description: (0, $Y34Hw.processExcerpt)(excerpt),
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<54298f86b59570dbeecd02edd08cfc22>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6ac31cc5ea3f0a44$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphDataTable_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "title"
            },
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v0 /*: any*/ ,
                            v1 /*: any*/ ,
                            {
                                "alias": "dataTableType",
                                "kind": "ScalarField",
                                "name": "type"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "workspaceName"
                            },
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "owners",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "ThirdPartyUser",
                                        "kind": "LinkedField",
                                        "name": "thirdPartyUser",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "name"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalDataTable"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$6ac31cc5ea3f0a44$var$node.hash = "6ff93efabe2d5f906a794ed3377fc473";
var $6ac31cc5ea3f0a44$export$2e2bcd8739ae039 = $6ac31cc5ea3f0a44$var$node;


parcelRequire("42omo");

















const $8d627c4379faf988$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    eventLabel: {
        id: "search-graph-data-table.data-table-label",
        defaultMessage: "Data table"
    }
});


const $d3b5e6118cd795f4$export$a2ac0f4098dc2a39 = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, mainContentWidth: mainContentWidth })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const partial = (0, $irOoi.useFragment)((0, $6ac31cc5ea3f0a44$export$2e2bcd8739ae039), node);
    const { url: url, entity: entity, title: title, lastModifiedDate: lastModifiedDate, excerpt: excerpt } = partial;
    const lastModifiedComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    });
    const getOwnerName = ()=>{
        if (!entity?.owners || !Array.isArray(entity.owners) || entity.owners.length === 0) return undefined;
        return entity.owners[0]?.thirdPartyUser?.name;
    };
    const workspaceName = entity?.workspaceName;
    const ownerName = getOwnerName();
    const headerMetadataParts = [
        formatMessage((0, $8d627c4379faf988$export$defe85febe8b728c).eventLabel),
        [
            'type',
            entity?.dataTableType
        ],
        [
            'workspaceName',
            workspaceName
        ],
        ...workspaceName && ownerName && workspaceName === ownerName ? [] : ownerName ? [
            [
                'owner',
                ownerName
            ]
        ] : [],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: partial.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        icon: icon,
        description: (0, $Y34Hw.processExcerpt)(excerpt),
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<f3eb0287d39c939761d8b5e5deeb92ef>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $050cd53b79465001$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "url"
    }, v2 = {
        "kind": "ScalarField",
        "name": "title"
    }, v3 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__isdealownersenabledrelayprovider"
            }
        ],
        "kind": "Fragment",
        "name": "searchGraphDeal_AtlassianSearchPage",
        "selections": [
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__isdealownersenabledrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "ThirdPartyUser",
                        "kind": "LinkedField",
                        "name": "allContributors",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            v4 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "stage"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "dealClosedAt"
                            },
                            {
                                "concreteType": "ExternalDealLastActivity",
                                "kind": "LinkedField",
                                "name": "lastActivity",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "lastActivityAt"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "event"
                                    }
                                ]
                            },
                            {
                                "condition": "__relay_internal__pv__isdealownersenabledrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "concreteType": "ExternalUser",
                                        "kind": "LinkedField",
                                        "name": "owners",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "ThirdPartyUser",
                                                "kind": "LinkedField",
                                                "name": "thirdPartyUser",
                                                "plural": false,
                                                "selections": [
                                                    v4 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "name": "parent",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "displayName"
                                            }
                                        ],
                                        "type": "ExternalCustomerOrg"
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalDeal"
                    }
                ]
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v2 /*: any*/ ,
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    v3 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$050cd53b79465001$var$node.hash = "a804b5a25f3dfff437b2874a29bf4b08";
var $050cd53b79465001$export$2e2bcd8739ae039 = $050cd53b79465001$var$node;












































const $eb4dfd021d4d6278$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    eventLabel: {
        id: "search-graph-deal.deal-label",
        defaultMessage: "Deal"
    },
    closedOn: {
        id: "search-graph-deal.closed-on",
        defaultMessage: "Closed on {date}"
    }
});


const $c295bb43a0a69b45$var$styles = {
    content: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    subheading: "_11c8fhey _syaz1rpy",
    lozengeWrapper: "_bozgxncg"
};
const $c295bb43a0a69b45$export$97947ae87dd2d3c0 = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $050cd53b79465001$export$2e2bcd8739ae039), node);
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $8C5kA.default)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { id: id, url: url, entity: entity, title: title, lastModifiedDate: lastModifiedDate, allContributors: allContributors } = data;
    const lastModifiedComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    });
    const formattedDate = entity?.dealClosedAt ? formatDate(new Date(entity.dealClosedAt), {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    }) : '';
    const closeOnDateComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $c295bb43a0a69b45$var$styles.content,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $eb4dfd021d4d6278$export$defe85febe8b728c).closedOn,
            values: {
                date: formattedDate
            }
        })
    });
    const body = /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
        children: entity?.lastActivity?.event
    });
    const description = /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
                description: body
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $c295bb43a0a69b45$var$styles.subheading,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                    lastModified: entity?.lastActivity?.lastActivityAt
                })
            })
        ]
    });
    const ownerFromContributors = allContributors?.[0]?.name;
    const ownerFromOwners = ()=>{
        if (!entity?.owners || !Array.isArray(entity.owners) || entity.owners.length === 0) return undefined;
        return entity.owners[0]?.thirdPartyUser?.name;
    };
    const ownerName = ownerFromOwners() ?? ownerFromContributors;
    const stageText = entity?.stage || '';
    const parent = entity?.parent?.displayName;
    const truncatedStageText = stageText.length > 20 ? `${stageText.slice(0, 20)}...` : stageText;
    const headerMetadataParts = [
        formatMessage((0, $eb4dfd021d4d6278$export$defe85febe8b728c).eventLabel),
        [
            'parent',
            parent
        ],
        [
            'owner',
            ownerName
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const footerComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
        linkedResults: linkedResults || [],
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data,
        url: url,
        position: position,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        isAllProductSelected: !selectedProduct
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        gap: "space.100",
        justifyContent: "start",
        role: "listitem",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
                id: id,
                product: product,
                productSelected: !!selectedProduct,
                onResultClicked: onResultClicked,
                onResultContextMenu: onResultContextMenu,
                onCopyLinkButtonClicked: onCopyLinkButtonClicked,
                onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
                onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
                onContextMenuButtonClicked: onContextMenuButtonClicked,
                icon: icon,
                description: description,
                headerMetadataParts: headerMetadataParts,
                title: (0, $Y34Hw.enrichExcerpt)(title),
                role: "none",
                url: url,
                isThirdParty: true,
                cloudId: cloudId,
                primaryProduct: primaryProduct,
                position: position,
                partial: data,
                appMode: appMode,
                footer: footerComponent,
                hasRelatedLinks: !!linkedResults && linkedResults.length > 0,
                mainContentWidth: mainContentWidth
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.Popup), {
                isOpen: isOpen,
                onClose: ()=>setIsOpen(false),
                placement: "right-start",
                content: ()=>closeOnDateComponent,
                trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                        content: stageText,
                        position: "auto",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            ...triggerProps,
                            isSelected: isOpen,
                            appearance: "subtle",
                            spacing: "compact",
                            onClick: ()=>setIsOpen(!isOpen),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $c295bb43a0a69b45$var$styles.lozengeWrapper,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                                    children: truncatedStageText
                                })
                            })
                        })
                    })
            })
        ]
    });
};





/**
 * @generated SignedSource<<acb513f7529f38ed62fbdd9729f860e0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9cf7c181e0845eab$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "title"
    }, v2 = {
        "kind": "ScalarField",
        "name": "url"
    }, v3 = {
        "kind": "ScalarField",
        "name": "subtype"
    }, v4 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphDefault_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionLevel"
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    v3 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$9cf7c181e0845eab$var$node.hash = "f94f2a94cf3a3a359423eadcef3a5758";
var $9cf7c181e0845eab$export$2e2bcd8739ae039 = $9cf7c181e0845eab$var$node;


parcelRequire("42omo");

























const $4fc3ecceff404a0a$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    task: {
        id: "search-graph-default.task.label",
        defaultMessage: "Task"
    },
    dashboard: {
        id: "search-graph-default.dashboard.label",
        defaultMessage: "Dashboard"
    },
    invoice: {
        id: "search-graph-default.invoice.label",
        defaultMessage: "Invoice"
    },
    design: {
        id: "search-graph-default.design.label",
        defaultMessage: "Design"
    },
    deal: {
        id: "search-graph-default.deal.label",
        defaultMessage: "Deal"
    }
});


const $9a45c40b46beaab7$var$footerContainer = (0, $ecnYn.xcss)({
    paddingTop: 'space.100'
});
const $9a45c40b46beaab7$var$typeLabelContainer = (0, $ecnYn.xcss)({
    '::first-letter': {
        textTransform: 'capitalize'
    }
});
const $9a45c40b46beaab7$var$getLabel = (entityNoun)=>entityNoun.replace(/-/g, ' ');
const $9a45c40b46beaab7$export$2b64796aabcbabd2 = ({ node: node, position: position, cloudId: cloudId, product: product, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, icon: icon, entityType: entityType, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $9cf7c181e0845eab$export$2e2bcd8739ae039), node);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { id: id, url: url, title: title, subtype: subtype, excerpt: excerpt, lastModifiedDate: lastModifiedDate, permissionLevel: permissionLevel } = data;
    const isNotPublic = (0, $Y34Hw.isNonPublic)(permissionLevel);
    const lastModifiedComponent = lastModifiedDate && /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    });
    const resultType = subtype || entityType;
    const labelMessage = (0, $4fc3ecceff404a0a$export$defe85febe8b728c)[resultType];
    const label = resultType && labelMessage ? formatMessage(labelMessage) : $9a45c40b46beaab7$var$getLabel(resultType);
    const headerMetadataParts = [
        [
            'label',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $9a45c40b46beaab7$var$typeLabelContainer,
                children: label
            })
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    const enrichedTitle = (0, $Y34Hw.enrichExcerpt)(title);
    const description = excerpt && /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
        description: (0, $Y34Hw.processExcerpt)(excerpt)
    });
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const shouldShowRelatedLinks = linkedResults && linkedResults.length > 0;
    const footerComponent = shouldShowRelatedLinks ? /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
        linkedResults: linkedResults || [],
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data,
        url: url,
        position: position,
        onResultContextMenu: onResultContextMenu,
        onResultClicked: onResultClicked,
        isAllProductSelected: !selectedProduct
    }) : isNotPublic && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $9a45c40b46beaab7$var$footerContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5c2df34c79a6120f$export$3eac322cb0b365da), {
            restriction: permissionLevel
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        id: id,
        product: product,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        title: enrichedTitle,
        icon: icon,
        headerMetadataParts: headerMetadataParts,
        description: description,
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        isThirdParty: true,
        footer: footerComponent,
        hasRelatedLinks: !!linkedResults && linkedResults.length > 0,
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<5e051020bb4e8006d62f9ba8bdfa5a60>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f9b486ea511c4975$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "title"
    }, v3 = {
        "kind": "ScalarField",
        "name": "url"
    }, v4 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphDesign_AtlassianSearchPage",
        "selections": [
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionLevel"
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "concreteType": "ExternalThumbnail",
                                "kind": "LinkedField",
                                "name": "thumbnail",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "externalUrl"
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalDesign"
                    }
                ]
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    v3 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$f9b486ea511c4975$var$node.hash = "33e7c4704ea491a336bc35c0ecdefe69";
var $f9b486ea511c4975$export$2e2bcd8739ae039 = $f9b486ea511c4975$var$node;


parcelRequire("42omo");




















const $30bd85a956e8089e$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    designLabel: {
        id: "design-search-result.label",
        defaultMessage: "Design"
    }
});


const $116289f16507c09c$export$81afb8005ea84971 = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const data = (0, $irOoi.useFragment)((0, $f9b486ea511c4975$export$2e2bcd8739ae039), node);
    const { id: id, url: url, title: title, entity: entity, permissionLevel: permissionLevel, lastModifiedDate: lastModifiedDate } = data;
    const lastModifiedComponent = lastModifiedDate && /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    });
    const label = formatMessage((0, $30bd85a956e8089e$export$defe85febe8b728c).designLabel);
    const padlockIcon = (0, $Y34Hw.isNonPublic)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const headerMetadataParts = [
        [
            'label',
            label
        ],
        [
            'lastModified',
            lastModifiedComponent
        ],
        [
            'padlock',
            padlockIcon
        ]
    ];
    const enrichedTitle = (0, $Y34Hw.enrichExcerpt)(title);
    const thumbnailUrl = entity?.__typename === 'ExternalDesign' && entity?.thumbnail?.externalUrl;
    const hasThumbnail = thumbnailUrl && !(0, $Y34Hw.isAWSThumbnailUrlExpired)(thumbnailUrl);
    const body = hasThumbnail ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2853273f3c22f618$export$9acaedfb553281a4), {
        resultUrl: url,
        thumbnailUrl: thumbnailUrl
    }) : null;
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const footerComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
        linkedResults: linkedResults || [],
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data,
        url: url,
        position: position,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        isAllProductSelected: !selectedProduct
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        id: id,
        product: product,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        title: enrichedTitle,
        description: body,
        headerMetadataParts: headerMetadataParts,
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        isThirdParty: true,
        icon: icon,
        footer: footerComponent,
        hasRelatedLinks: !!linkedResults && linkedResults.length > 0,
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<03d2735a588bfd52fad5c26a52e2021d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $29278d67853c092d$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "title"
    }, v2 = {
        "kind": "ScalarField",
        "name": "url"
    }, v3 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": true,
                "kind": "LocalArgument",
                "name": "includeThirdPartyId"
            }
        ],
        "kind": "Fragment",
        "name": "searchGraphDocument_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            v3 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionLevel"
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "condition": "includeThirdPartyId",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "thirdPartyId"
                                    }
                                ]
                            },
                            {
                                "concreteType": "ExternalDocumentType",
                                "kind": "LinkedField",
                                "name": "type",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "iconUrl"
                                    }
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "name": "parent",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "displayName"
                                            }
                                        ],
                                        "type": "ExternalDocument"
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalDocument"
                    }
                ]
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    v3 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$29278d67853c092d$var$node.hash = "51a12a98dbca7c9f25eb661f08675f64";
var $29278d67853c092d$export$2e2bcd8739ae039 = $29278d67853c092d$var$node;


























var $9kYXz = parcelRequire("9kYXz");











const $61039992c4292c45$var$footerContainer = (0, $ecnYn.xcss)({
    paddingTop: 'space.100'
});
const $61039992c4292c45$var$labelContainer = (0, $ecnYn.xcss)({
    '::first-letter': {
        textTransform: 'capitalize'
    }
});
const $61039992c4292c45$var$contentIconStyles = null;
const $61039992c4292c45$export$d69ae1468ab7f1da = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, subtype: subtype, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $29278d67853c092d$export$2e2bcd8739ae039), node);
    /**
   * A wrapper to include thirdPartyId in the onResultClicked callback.
   */ const onResultClickedWithThirdPartyId = (0, $42omo.useCallback)((params = {})=>{
        const thirdPartyId = data.entity?.thirdPartyId || undefined;
        return onResultClicked?.({
            ...params,
            thirdPartyId: thirdPartyId
        });
    }, [
        onResultClicked,
        data
    ]); /**
                                * A wrapper to include thirdPartyId in the onResultContextMenu callback.
                                */ 
    const onResultContextMenuWithThirdPartyId = (0, $42omo.useCallback)((params = {})=>{
        const thirdPartyId = data.entity?.thirdPartyId || undefined;
        return onResultContextMenu?.({
            ...params,
            thirdPartyId: thirdPartyId
        });
    }, [
        onResultContextMenu,
        data
    ]);
    const { id: id, url: url, title: title, excerpt: excerpt, entity: entity, lastModifiedDate: lastModifiedDate, permissionLevel: permissionLevel } = data;
    const isNotPublic = (0, $Y34Hw.isNonPublic)(permissionLevel);
    const parentName = entity?.parent?.displayName || null; // Memoized URL validation function to avoid recreation on every render
    const isValidIconUrl = (0, $42omo.useCallback)((url)=>{
        try {
            const parsedUrl = new URL(url); // Only allow https URLs for security
            return parsedUrl.protocol === 'https:';
        } catch  {
            return false;
        }
    }, []); // Get icon URL and validate it
    const iconUrl = entity?.type?.iconUrl;
    const validatedIconUrl = (0, $42omo.useMemo)(()=>{
        return iconUrl && isValidIconUrl(iconUrl) ? iconUrl : null;
    }, [
        iconUrl,
        isValidIconUrl
    ]); // State to track if the icon image failed to load
    const [iconLoadError, setIconLoadError] = (0, $42omo.useState)(false); // Handle icon load error
    const handleIconError = (0, $42omo.useCallback)(()=>{
        setIconLoadError(true);
    }, []); // Reset error state when iconUrl changes
    (0, $42omo.useEffect)(()=>{
        setIconLoadError(false);
    }, [
        validatedIconUrl
    ]); // Memoize document icon creation to avoid recreation when props haven't changed
    const documentIcon = (0, $42omo.useMemo)(()=>{
        // GitBook support - use GitbookIcon when selectedProduct is 'gitbook'
        if (selectedProduct === 'gitbook') return /*#__PURE__*/ (0, $l998X.jsx)((0, $hP2yW.GitbookIcon), {});
        if (!validatedIconUrl || iconLoadError) return icon;
        return /*#__PURE__*/ (0, $l998X.jsx)("img", {
            src: validatedIconUrl,
            onError: handleIconError,
            alt: "",
            role: "presentation",
            className: (0, $gMc0m.default)([
                "_1bsbxy5q _4t3ixy5q _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _vchhusvi _5ral1f51"
            ])
        });
    }, [
        selectedProduct,
        validatedIconUrl,
        iconLoadError,
        handleIconError,
        icon
    ]);
    const shouldShowLastModified = lastModifiedDate && product !== (0, $1yEFx.ProductKeys).AtlassianWebCrawler;
    const lastModifiedComponent = shouldShowLastModified ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null; // We overwrite some subtype labels by product, eg for presentation->PowerPoint
    const label = (0, $9kYXz.getDocumentSubtypeLabel)({
        product: product,
        subtype: subtype
    });
    const subtypeComponent = subtype && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $61039992c4292c45$var$labelContainer,
        children: subtype?.replace(/-/g, ' ')
    });
    const labelComponent = label && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $61039992c4292c45$var$labelContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...label
        })
    });
    const headerMetadataParts = [
        [
            'label',
            labelComponent || subtypeComponent || null
        ],
        [
            'parentName',
            parentName || null
        ],
        [
            'lastModified',
            lastModifiedComponent
        ]
    ];
    const enrichedTitle = (0, $Y34Hw.enrichExcerpt)(title);
    const description = excerpt && /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
        description: (0, $Y34Hw.processExcerpt)(excerpt)
    });
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const shouldShowRelatedLinks = linkedResults && linkedResults.length > 0;
    const footerComponent = shouldShowRelatedLinks ? /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
        linkedResults: linkedResults || [],
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data,
        url: url,
        onResultClicked: onResultClickedWithThirdPartyId,
        position: position,
        onResultContextMenu: onResultContextMenuWithThirdPartyId,
        isAllProductSelected: !selectedProduct
    }) : isNotPublic && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $61039992c4292c45$var$footerContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5c2df34c79a6120f$export$3eac322cb0b365da), {
            restriction: permissionLevel
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        id: id,
        product: product,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClickedWithThirdPartyId,
        onResultContextMenu: onResultContextMenuWithThirdPartyId,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        title: enrichedTitle,
        icon: documentIcon,
        headerMetadataParts: headerMetadataParts,
        description: description,
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        isThirdParty: true,
        footer: footerComponent,
        hasRelatedLinks: !!linkedResults && linkedResults.length > 0,
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<00130c2d7ca2cee24c602b5f85da6273>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0b97e21f4d37cba6$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "subtype"
    }, v1 = {
        "kind": "ScalarField",
        "name": "url"
    }, v2 = [
        {
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "displayName"
                        },
                        v1 /*: any*/ ,
                        v0 /*: any*/ 
                    ],
                    "type": "ExternalSpace"
                }
            ]
        }
    ], v3 = [
        {
            "condition": "__relay_internal__pv__jsmdcenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": v2 /*: any*/ 
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__jsmdcenabledrelayprovider"
            }
        ],
        "kind": "Fragment",
        "name": "searchGraphJiraDc_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "ScalarField",
                "name": "integrationId"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "title"
            },
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            {
                "kind": "ScalarField",
                "name": "permissionLevel"
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": v2 /*: any*/ ,
                        "type": "ExternalComment"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": v3 /*: any*/ ,
                        "type": "ExternalProject"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": v3 /*: any*/ ,
                        "type": "ExternalWorkItem"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "searchGraphJiraDcProject_AtlassianSearchPage"
            },
            {
                "kind": "FragmentSpread",
                "name": "searchGraphJiraDcWorkItem_AtlassianSearchPage"
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$0b97e21f4d37cba6$var$node.hash = "dc51dbd358c84c4dad2452e0bd3d5eb2";
var $0b97e21f4d37cba6$export$2e2bcd8739ae039 = $0b97e21f4d37cba6$var$node;


parcelRequire("42omo");


































const $60df979cd5e73233$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    project: {
        id: "search-graph-jira-dc.project-result.label",
        defaultMessage: "Project"
    },
    space: {
        id: "search-graph-jira-dc.space-result.label",
        defaultMessage: "Space"
    },
    issue: {
        id: "search-graph-jira-dc.issue-result.label",
        defaultMessage: "Work item"
    },
    commment: {
        id: "search-graph-jira-dc.comment-result.label",
        defaultMessage: "Comment"
    }
});





/**
 * @generated SignedSource<<a3acfd09e8b9d190168c0a212f7885a4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e3e0ecd21beca515$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "url"
    }, v2 = [
        {
            "concreteType": "ThirdPartyUser",
            "kind": "LinkedField",
            "name": "thirdPartyUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphJiraDcProject_AtlassianSearchPage",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "integrationId"
            },
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "kind": "ScalarField",
                "name": "subtype"
            },
            {
                "kind": "ScalarField",
                "name": "permissionLevel"
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "assignee",
                                "plural": false,
                                "selections": v2 /*: any*/ 
                            },
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "createdBy",
                                "plural": false,
                                "selections": v2 /*: any*/ 
                            },
                            {
                                "kind": "ScalarField",
                                "name": "dueDate"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "status"
                            },
                            {
                                "kind": "LinkedField",
                                "name": "container",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "displayName"
                                            },
                                            v1 /*: any*/ 
                                        ],
                                        "type": "ExternalSpace"
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalProject"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$e3e0ecd21beca515$var$node.hash = "efa0ed5362e28e5da85c6004de8eaa34";
var $e3e0ecd21beca515$export$2e2bcd8739ae039 = $e3e0ecd21beca515$var$node;























/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





















const $c8b27af5d97101db$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    for: {
        id: "relay.jira-dc.work-item-status.for",
        defaultMessage: "{statusLozenge} for {dateLozenge}"
    },
    isAssigned: {
        id: "relay.jira-dc.work-item-assignee.assigned",
        defaultMessage: "{isAssigned, select, internal {{firstName} is assigned} other {External person is assigned}}"
    },
    created: {
        id: "relay.jira-dc.work-item-creator.created",
        defaultMessage: "{created, select, internal {{firstName} created} other {External person created}}"
    }
});


const $82e2c7ad113e1592$export$e3945b9ca5ee7998 = [
    'ari:cloud:platform::integration/jira-dc',
    'ari:cloud:platform::integration/jira-dc-secondary',
    'ari:cloud:platform::integration/jira-dc-tertiary'
];
const $82e2c7ad113e1592$export$ba3533aa072a80cd = (props)=>{
    return props?.node?.__typename === 'SearchResultGraphDocument' && $82e2c7ad113e1592$export$e3945b9ca5ee7998.includes(props?.node?.integrationId ?? '');
};
const $82e2c7ad113e1592$export$9e2ad0c662b4c1bf = (key)=>key ? key + ' ' : '';
const $82e2c7ad113e1592$export$677945de1a5fba91 = (formatMessage, assigneeName, createdByName)=>{
    let actionLabel;
    const fullName = assigneeName || createdByName || '';
    if (!fullName) return null;
    const firstName = fullName?.split(' ')?.[0];
    if (assigneeName) actionLabel = formatMessage((0, $c8b27af5d97101db$export$defe85febe8b728c).isAssigned, {
        firstName: firstName,
        isAssigned: firstName ? 'internal' : 'external'
    });
    else actionLabel = formatMessage((0, $c8b27af5d97101db$export$defe85febe8b728c).created, {
        firstName: firstName,
        created: firstName ? 'internal' : 'external'
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.025",
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $678a8075b20296fe$export$3778be82376b06d7), {
                name: fullName
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($82e2c7ad113e1592$var$styles.nameContainer),
                children: actionLabel
            })
        ]
    });
};
const $82e2c7ad113e1592$export$9c8d0e44d1e8398 = (status, dueDate)=>{
    if (!status) return null;
    const statusLabel = status.replace(/[-_]+/g, ' ');
    const statusLozenge = /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
        appearance: $82e2c7ad113e1592$var$getStatusLozengeAppearance(statusLabel),
        children: statusLabel
    });
    const dateLozenge = /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cgtv4.FormattedDate), {
            value: dueDate ?? undefined,
            month: "short",
            day: "numeric"
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($82e2c7ad113e1592$var$styles.statusAndDateContainerStyles),
        children: dueDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $c8b27af5d97101db$export$defe85febe8b728c).for,
            values: {
                statusLozenge: statusLozenge,
                dateLozenge: dateLozenge
            }
        }) : statusLozenge
    });
};
const $82e2c7ad113e1592$var$getStatusLozengeAppearance = (label)=>{
    label = label.replace(/[\s]+/g, '').toLowerCase();
    switch(true){
        case [
            'onhold'
        ].includes(label):
            return 'default';
        // gray
        case [
            'solved',
            'complete'
        ].includes(label):
            return 'success';
        // green
        case [
            'open',
            'offtrack'
        ].includes(label):
            return 'removed';
        // red
        case [
            'new',
            'atrisk'
        ].includes(label):
            return 'moved';
        // yellow
        case [
            'pending',
            'ontrack'
        ].includes(label):
            return 'inprogress';
    }
    return 'inprogress'; // blue for custom status labels
};
const $82e2c7ad113e1592$var$styles = {
    nameContainer: "_o5721q9c",
    statusAndDateContainerStyles: "_zulpu2gc _1e0c1txw _4cvr1h6o"
};












const $afd10684eae12f48$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    project: {
        id: "relay.jira-dc.project-result.label",
        defaultMessage: "Project"
    },
    space: {
        id: "relay.jira-dc.space-result.label",
        defaultMessage: "Space"
    },
    issue: {
        id: "relay.jira-dc.issue-result.label",
        defaultMessage: "Work item"
    },
    commment: {
        id: "relay.jira-dc.comment-result.label",
        defaultMessage: "Comment"
    }
});


const $eec12467ab9be34f$export$a438d1545a43fbaa = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, product: product, icon: icon, thirdPartyConfigs: thirdPartyConfigs, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $e3e0ecd21beca515$export$2e2bcd8739ae039), node);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, entity: entity, excerpt: excerpt, title: title } = data;
    const { assignee: assignee, createdBy: createdBy, dueDate: dueDate, status: status, key: key } = entity || {};
    const integrationId = data.integrationId;
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const padlockIcon = (0, $Y34Hw.isNonPublic)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const entityToLabelMap = {
        space: 'space',
        'work-item': 'issue',
        project: 'issue',
        comment: 'comment'
    };
    const { resourceType: resourceType } = (0, $42omo.useMemo)(()=>(0, $k4HRJ.AnyAri).parse(data.id), [
        data.id
    ]);
    const subtype = data.subtype ? (0, $Y34Hw.getJiraSearchResultTypeMetadata)(data.subtype) : null;
    const resultType = subtype || (entityToLabelMap[resourceType] ?? resourceType);
    const labelMessage = (0, $afd10684eae12f48$export$defe85febe8b728c)[resultType];
    const label = resultType && labelMessage ? formatMessage(labelMessage) : $eec12467ab9be34f$var$getLabel(resultType);
    // Find the specific datasource for this result based on its integrationId
    const resultDatasource = thirdPartyConfigs?.[(0, $1yEFx.ProductKeys).JiraDC]?.datasources?.find((ds)=>ds.integrationId === integrationId) || null;
    const site = resultDatasource?.workspaceName || thirdPartyConfigs?.[(0, $1yEFx.ProductKeys).JiraDC]?.workspaceName || null;
    const containerName = entity?.container?.displayName;
    const containerUrl = entity?.container?.url;
    const container = containerUrl && containerName ? /*#__PURE__*/ (0, $l998X.jsx)((0, $655681e89d0ffd52$export$2e2bcd8739ae039), {
        label: containerName,
        href: containerUrl
    }) : containerName;
    const headerMetadataParts = [
        label,
        [
            'site',
            site
        ],
        [
            'container',
            container
        ],
        [
            'last-modified',
            lastModifiedComponent
        ],
        [
            'padlock',
            padlockIcon
        ],
        [
            'status',
            (0, $82e2c7ad113e1592$export$9c8d0e44d1e8398)(status, dueDate)
        ],
        [
            'person',
            (0, $82e2c7ad113e1592$export$677945de1a5fba91)(formatMessage, assignee?.thirdPartyUser?.name, createdBy?.thirdPartyUser?.name)
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: data.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: (0, $Y34Hw.processExcerpt)(excerpt ?? undefined, true)
        }),
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title, (0, $82e2c7ad113e1592$export$9e2ad0c662b4c1bf)(key)),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $eec12467ab9be34f$var$getLabel = (entityNoun)=>entityNoun.replace(/-/g, ' ');
const $eec12467ab9be34f$export$a3305511c098cb21 = (node)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(node.id);
    return node?.__typename === 'SearchResultGraphDocument' && (resourceType === (0, $7ZetK.ResourceType).PROJECT || node?.subtype === (0, $7ZetK.ResourceType).PROJECT);
};





/**
 * @generated SignedSource<<f75cba9ba4d861b8afbb228ef4e34734>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9c15493e6beb48b0$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "url"
    }, v2 = [
        {
            "concreteType": "ThirdPartyUser",
            "kind": "LinkedField",
            "name": "thirdPartyUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphJiraDcWorkItem_AtlassianSearchPage",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "title"
            },
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "integrationId"
            },
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "assignee",
                                "plural": false,
                                "selections": v2 /*: any*/ 
                            },
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "createdBy",
                                "plural": false,
                                "selections": v2 /*: any*/ 
                            },
                            {
                                "kind": "ScalarField",
                                "name": "dueDate"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "status"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "subtype"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "team"
                            },
                            {
                                "kind": "LinkedField",
                                "name": "container",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "displayName"
                                            },
                                            v1 /*: any*/ 
                                        ],
                                        "type": "ExternalSpace"
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalWorkItem"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$9c15493e6beb48b0$var$node.hash = "e5918a4fc563b65267f6c7d5107c7fb8";
var $9c15493e6beb48b0$export$2e2bcd8739ae039 = $9c15493e6beb48b0$var$node;


parcelRequire("42omo");





























const $1a4fe4da3026790a$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    workItemLabel: {
        id: "relay.jira-dc-work-item.work-item.work-item-label",
        defaultMessage: "Work item"
    },
    issueLabel: {
        id: "relay.jira-dc-work-item.issue-label",
        defaultMessage: "Issue"
    }
});


const $9eaa0238cdd4a2a9$export$ff46249c8f6d43da = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, subtype: subtype, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $9c15493e6beb48b0$export$2e2bcd8739ae039), node);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { lastModifiedDate: lastModifiedDate, url: url, entity: entity, excerpt: excerpt, title: title } = data;
    const { dueDate: dueDate, status: status, team: team } = entity || {};
    const integrationId = data.integrationId;
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const subtypeMap = {
        work_item: (0, $1a4fe4da3026790a$export$defe85febe8b728c).workItemLabel,
        issue: (0, $1a4fe4da3026790a$export$defe85febe8b728c).issueLabel,
        other: (0, $1a4fe4da3026790a$export$defe85febe8b728c).workItemLabel
    };
    const label = formatMessage(subtypeMap[subtype?.toLowerCase() ?? 'other'] || (0, $1a4fe4da3026790a$export$defe85febe8b728c).workItemLabel);
    // Find the specific datasource for this result based on its integrationId
    const resultDatasource = thirdPartyConfigs?.[(0, $1yEFx.ProductKeys).JiraDC]?.datasources?.find((ds)=>ds.integrationId === integrationId) || null;
    const site = resultDatasource?.workspaceName || thirdPartyConfigs?.[(0, $1yEFx.ProductKeys).JiraDC]?.workspaceName || null;
    const containerName = entity?.container?.displayName;
    const containerUrl = entity?.container?.url;
    const container = containerUrl && containerName ? /*#__PURE__*/ (0, $l998X.jsx)((0, $655681e89d0ffd52$export$2e2bcd8739ae039), {
        label: containerName,
        href: containerUrl
    }) : containerName;
    const headerMetadataParts = [
        label,
        [
            'site',
            site
        ],
        [
            'container',
            container
        ],
        [
            'last-modified',
            lastModifiedComponent
        ],
        [
            'status',
            (0, $82e2c7ad113e1592$export$9c8d0e44d1e8398)(status, dueDate)
        ],
        [
            'person',
            (0, $82e2c7ad113e1592$export$677945de1a5fba91)(formatMessage, data.entity?.assignee?.thirdPartyUser?.name, data.entity?.createdBy?.thirdPartyUser?.name)
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: data.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: (0, $Y34Hw.processExcerpt)(excerpt ?? undefined, true)
        }),
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title, (0, $82e2c7ad113e1592$export$9e2ad0c662b4c1bf)(team)),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $9eaa0238cdd4a2a9$export$1ac2dfe1fc47509f = (node)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(node.id);
    return node?.__typename === 'SearchResultGraphDocument' && resourceType === (0, $7ZetK.ResourceType).WORK_ITEM;
};


const $a81664d8b32e1a9b$var$SERVICE_DESK = 'service_desk';
const $a81664d8b32e1a9b$var$isJsmIcon = (containerType)=>{
    return (0, $dh538.fg)('is_jsm_dc_enabled_in_ui') && containerType?.toLowerCase() === $a81664d8b32e1a9b$var$SERVICE_DESK;
};
const $a81664d8b32e1a9b$var$styles = {
    footerContainer: "_ca0qu2gc",
    typeLabelContainer: "_299m1dk0"
};
const $a81664d8b32e1a9b$var$PROJECT_SUBTYPES = new Set([
    'software',
    'service_desk',
    'business',
    'project' //to be removed once implementation is finalised
]);
const $a81664d8b32e1a9b$var$SUBTYPE_PROJECT = 'project';
const $a81664d8b32e1a9b$var$SUBTYPE_SPACE = 'space';
const $a81664d8b32e1a9b$var$SUBTYPE_COMMENT = 'comment';
const $a81664d8b32e1a9b$var$SUBTYPE_ISSUE = 'issue';
const $a81664d8b32e1a9b$var$JIRA_DC_LABELS = {
    [$a81664d8b32e1a9b$var$SUBTYPE_SPACE]: (0, $60df979cd5e73233$export$defe85febe8b728c).space,
    [$a81664d8b32e1a9b$var$SUBTYPE_PROJECT]: (0, $60df979cd5e73233$export$defe85febe8b728c).project,
    [$a81664d8b32e1a9b$var$SUBTYPE_COMMENT]: (0, $60df979cd5e73233$export$defe85febe8b728c).comment,
    [$a81664d8b32e1a9b$var$SUBTYPE_ISSUE]: (0, $60df979cd5e73233$export$defe85febe8b728c).issue
};
const $a81664d8b32e1a9b$var$getLabel = (subtype)=>{
    if ($a81664d8b32e1a9b$var$PROJECT_SUBTYPES.has(subtype)) return (0, $60df979cd5e73233$export$defe85febe8b728c).project;
    return $a81664d8b32e1a9b$var$JIRA_DC_LABELS[subtype];
};
const $a81664d8b32e1a9b$export$3464c3355ad3f97e = ({ node: node, position: position, cloudId: cloudId, searchQuery: searchQuery, primaryProduct: primaryProduct, appMode: appMode, product: product, entityType: entityType, selectedProduct: selectedProduct, searchSessionId: searchSessionId, thirdPartyConfigs: thirdPartyConfigs, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $0b97e21f4d37cba6$export$2e2bcd8739ae039), node);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, title: title, excerpt: excerpt } = data;
    const subtype = data?.subtype || null;
    const integrationId = data.integrationId;
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const jiraIcon = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.JiraIcon), {
        size: "medium",
        shouldUseNewLogoDesign: true
    });
    const jsmIcon = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.JiraServiceManagementIcon), {
        size: "medium",
        shouldUseNewLogoDesign: true
    });
    let icon = jiraIcon; // Find the specific datasource for this result based on its integrationId
    const resultDatasource = thirdPartyConfigs?.[product]?.datasources?.find((ds)=>ds.integrationId === integrationId) || null;
    const site = resultDatasource?.workspaceName || thirdPartyConfigs?.[product]?.workspaceName;
    const entityToLabelMap = {
        space: 'space',
        'work-item': 'issue',
        project: 'issue',
        comment: 'comment'
    };
    const resultType = subtype || (entityToLabelMap[entityType] ?? entityType);
    const labelMessage = $a81664d8b32e1a9b$var$getLabel(resultType);
    const label = labelMessage ? formatMessage(labelMessage) : resultType;
    const isNotPublic = (0, $Y34Hw.isNonPublic)(permissionLevel);
    const SearchGraphJiraDcResult = (0, $eec12467ab9be34f$export$a3305511c098cb21)(data) ? (0, $eec12467ab9be34f$export$a438d1545a43fbaa) : (0, $9eaa0238cdd4a2a9$export$1ac2dfe1fc47509f)(data) ? (0, $9eaa0238cdd4a2a9$export$ff46249c8f6d43da) : null;
    if (SearchGraphJiraDcResult) {
        if ($a81664d8b32e1a9b$var$isJsmIcon(data.entity?.container?.subtype)) icon = jsmIcon;
        return /*#__PURE__*/ (0, $l998X.jsx)(SearchGraphJiraDcResult, {
            node: data,
            position: position,
            cloudId: cloudId,
            selectedProduct: selectedProduct,
            searchQuery: searchQuery,
            primaryProduct: primaryProduct,
            appMode: appMode,
            searchSessionId: searchSessionId,
            thirdPartyConfigs: thirdPartyConfigs,
            icon: icon,
            product: product,
            subtype: subtype,
            entityType: entityType,
            onCopyLinkButtonClicked: onCopyLinkButtonClicked,
            onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
            onResultClicked: onResultClicked,
            onResultContextMenu: onResultContextMenu,
            onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
            onContextMenuButtonClicked: onContextMenuButtonClicked,
            mainContentWidth: mainContentWidth
        });
    }
    let container;
    if ($a81664d8b32e1a9b$var$isCommentEntity(data)) {
        const { entity: entity } = data;
        const containerName = entity?.container?.displayName;
        const containerUrl = entity?.container?.url;
        if ($a81664d8b32e1a9b$var$isJsmIcon(entity?.container?.subtype)) icon = jsmIcon;
        container = containerUrl && containerName ? /*#__PURE__*/ (0, $l998X.jsx)((0, $655681e89d0ffd52$export$2e2bcd8739ae039), {
            label: containerName,
            href: containerUrl
        }) : containerName;
    } else if ($a81664d8b32e1a9b$var$isJsmIcon(subtype)) icon = jsmIcon;
    const headerMetadataParts = [
        [
            'label',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $a81664d8b32e1a9b$var$styles.typeLabelContainer,
                children: label
            })
        ],
        [
            'site',
            site
        ],
        [
            'container',
            container
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ]; // space noun (project in the UI) and comment use default result component
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: data.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        description: (0, $Y34Hw.processExcerpt)(excerpt),
        icon: icon,
        headerMetadataParts: headerMetadataParts,
        footer: isNotPublic && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $a81664d8b32e1a9b$var$styles.footerContainer,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5c2df34c79a6120f$export$3eac322cb0b365da), {
                restriction: permissionLevel
            })
        }),
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $a81664d8b32e1a9b$var$isCommentEntity = (node)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(node?.id);
    return resourceType === (0, $7ZetK.ResourceType).COMMENT;
};





/**
 * @generated SignedSource<<d21aec9ce7eb542d2eb1c63d704c9d07>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $983e6d707353d744$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "url"
    }, v2 = {
        "kind": "ScalarField",
        "name": "excerpt"
    }, v3 = {
        "kind": "ScalarField",
        "name": "description"
    }, v4 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphMessage_AtlassianSearchPage",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "attachmentItems_AtlassianSearchPage_DropdownItems"
            },
            {
                "kind": "FragmentSpread",
                "name": "attachments_AtlassianSearchPage"
            },
            {
                "kind": "FragmentSpread",
                "name": "threadTitle_AtlassianSearchPage"
            },
            {
                "kind": "FragmentSpread",
                "name": "threadBody_AtlassianSearchPage"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            {
                "concreteType": "SearchResultGraphDocument",
                "kind": "LinkedField",
                "name": "linkedEntities",
                "plural": true,
                "selections": [
                    v2 /*: any*/ ,
                    {
                        "kind": "LinkedField",
                        "name": "entity",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v3 /*: any*/ 
                                ],
                                "type": "ExternalMessage"
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "linkedEntitiesType"
            },
            v4 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "lastActive"
                            },
                            v3 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "reactionCount"
                            },
                            {
                                "concreteType": "ExternalAttachment",
                                "kind": "LinkedField",
                                "name": "attachments",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "name": "container",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "memberCount"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "membershipType"
                                            }
                                        ],
                                        "type": "ExternalConversation"
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalMessage"
                    }
                ]
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "title"
                    },
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    v3 /*: any*/ ,
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$983e6d707353d744$var$node.hash = "c79d29d3ab39c59b8524f7e70c484005";
var $983e6d707353d744$export$2e2bcd8739ae039 = $983e6d707353d744$var$node;


parcelRequire("42omo");





























/**
 * @generated SignedSource<<dd8b10e8f0736ae4ebaefbc5445c6f4a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f9505a375d8687a8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "attachmentItems_AtlassianSearchPage_DropdownItems",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "lastModifiedDate"
        },
        {
            "kind": "LinkedField",
            "name": "entity",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "concreteType": "ExternalAttachment",
                            "kind": "LinkedField",
                            "name": "attachments",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "title"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "mimeType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "url"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "thumbnailUrl"
                                }
                            ]
                        }
                    ],
                    "type": "ExternalMessage"
                }
            ]
        }
    ],
    "type": "SearchResultGraphDocument"
};
$f9505a375d8687a8$var$node.hash = "1d0a13f92b4b1c1eecb3772e0ddae100";
var $f9505a375d8687a8$export$2e2bcd8739ae039 = $f9505a375d8687a8$var$node;


parcelRequire("42omo");










































const $e3e44bbf05f0c8c3$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    attachedDateLabel: {
        id: "relay.search-result.attachments.attached-date.label",
        defaultMessage: "Attached {formattedDate}"
    },
    attachmentLabel: {
        id: "relay.search-result.attachment-label",
        defaultMessage: "Attachment"
    },
    pdfLabel: {
        id: "relay.search-result.attachments.pdf-label",
        defaultMessage: "PDF"
    },
    videoLabel: {
        id: "relay.search-result.attachments.video-label",
        defaultMessage: "Video"
    },
    imageLabel: {
        id: "relay.search-result.attachments.image-label",
        defaultMessage: "Image"
    },
    audioLabel: {
        id: "relay.search-result.attachments.audio-label",
        defaultMessage: "Audio"
    }
});


const $9d89d5105e50bac9$var$dropdownItemStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    columnGap: 'space.100',
    paddingBlock: 'space.050',
    marginTop: 'space.100'
});
const $9d89d5105e50bac9$var$attachmentStyles = (0, $ecnYn.xcss)({
    color: 'color.link',
    textDecoration: 'none',
    ':hover': {
        color: 'color.link',
        textDecoration: 'underline'
    },
    ':active': {
        textDecoration: 'none'
    },
    ':visited': {
        color: 'color.link.visited'
    },
    // NOTE: this selector is preventing migration to @atlaskit/css as it's not officially supported.
    // Context: https://atlassian.slack.com/archives/CFJ9DU39U/p1754279429281269
    ':active:visited': {
        color: 'color.link.visited.pressed'
    }
});
const $9d89d5105e50bac9$var$mimeTypeToIcon = (mimeType)=>{
    if (!mimeType) return 0, (/*@__PURE__*/$parcel$interopDefault($9lz2c));
    const [type, specificType] = mimeType.split('/');
    if (specificType === 'pdf') return 0, (/*@__PURE__*/$parcel$interopDefault($8jHAi));
    switch(type){
        case 'video':
            return 0, (/*@__PURE__*/$parcel$interopDefault($2Yaht));
        case 'image':
            return 0, (/*@__PURE__*/$parcel$interopDefault($fZtQj));
        case 'audio':
            return 0, (/*@__PURE__*/$parcel$interopDefault($e3TOY));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($9lz2c));
    }
};
const $9d89d5105e50bac9$var$mimeTypeToLabel = (mimeType)=>{
    if (!mimeType) return (0, $e3e44bbf05f0c8c3$export$a7357cdd1f0b0168).attachmentLabel;
    const [type, specificType] = mimeType.split('/');
    if (specificType === 'pdf') return (0, $e3e44bbf05f0c8c3$export$a7357cdd1f0b0168).pdfLabel;
    switch(type){
        case 'video':
            return (0, $e3e44bbf05f0c8c3$export$a7357cdd1f0b0168).videoLabel;
        case 'image':
            return (0, $e3e44bbf05f0c8c3$export$a7357cdd1f0b0168).imageLabel;
        case 'audio':
            return (0, $e3e44bbf05f0c8c3$export$a7357cdd1f0b0168).audioLabel;
        default:
            return (0, $e3e44bbf05f0c8c3$export$a7357cdd1f0b0168).attachmentLabel;
    }
};
const $9d89d5105e50bac9$export$28f865e0208f513d = ({ node: node })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const data = (0, $irOoi.useFragment)((0, $f9505a375d8687a8$export$2e2bcd8739ae039), node);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        children: data.entity?.attachments?.map((attachment)=>{
            if (!attachment) return null;
            const { title: title, mimeType: mimeType, url: url, thumbnailUrl: thumbnailUrl } = attachment;
            const truncatedUrl = url?.replace(/\/download\//g, '/');
            const viewUrl = mimeType?.includes('image') ? truncatedUrl : thumbnailUrl;
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                xcss: $9d89d5105e50bac9$var$dropdownItemStyles,
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                        alignBlock: "center",
                        space: "space.025",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $lE8sM.default), {
                                size: "16",
                                icon: $9d89d5105e50bac9$var$mimeTypeToIcon(mimeType),
                                label: "icon",
                                appearance: "blue"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                size: "medium",
                                color: "color.link",
                                weight: "medium",
                                children: viewUrl ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
                                    xcss: $9d89d5105e50bac9$var$attachmentStyles,
                                    href: viewUrl,
                                    rel: 'noreferrer',
                                    target: "_blank",
                                    children: title
                                }) : title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                        separator: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                            size: "small",
                            children: "\u2022"
                        }),
                        space: "space.050",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                size: "small",
                                children: formatMessage($9d89d5105e50bac9$var$mimeTypeToLabel(mimeType))
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                size: "small",
                                color: "color.text.subtle",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                                    lastModified: data.lastModifiedDate,
                                    message: (0, $e3e44bbf05f0c8c3$export$a7357cdd1f0b0168).attachedDateLabel
                                })
                            })
                        ]
                    })
                ]
            });
        })
    });
};





const $dde367fe129b91bd$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    threadTypeLabel: {
        id: "relay.search-result.thread-type-label",
        defaultMessage: "Thread"
    },
    messageTypeLabel: {
        id: "relay.search-result.message-type-label",
        defaultMessage: "Message"
    },
    lastActive: {
        id: "relay.search-result.message-last-active",
        defaultMessage: "Last active {formattedDate}"
    },
    attachedDateLabel: {
        id: "relay.search-result.attachments.attached-date.label",
        defaultMessage: "Attached {formattedDate}"
    },
    privateChannelLabel: {
        id: "relay.search-result.private-channel-label",
        defaultMessage: "Private Channel"
    },
    memberCount: {
        id: "relay.search-page.results.product-results.third-party.message-search-result.member-count",
        defaultMessage: "{count, plural, one {# member} other {# members}}"
    },
    smartlinkAttachmentsExpandButtonLabel: {
        id: "relay.search-page.results.product-results.third-party.message-search-result.smartlink-attachments-expand-button-label",
        defaultMessage: "{count, plural, one {# link} other {# links}}"
    },
    fileAttachmentsExpandButtonLabel: {
        id: "relay.search-page.results.product-results.third-party.message-search-result.file-attachments-expand-button-label",
        defaultMessage: "{count, plural, one {# attachment} other {# attachments}}"
    }
});





/**
 * @generated SignedSource<<51392d6a1372f4da4481aa1db3d6a238>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0d1fc4f1cd0a9a67$var$node = function() {
    var v0 = {
        "kind": "FragmentSpread",
        "name": "threadMessage_AtlassianSearchPage"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "threadBody_AtlassianSearchPage",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "integrationId"
            },
            {
                "concreteType": "SearchResultGraphDocument",
                "kind": "LinkedField",
                "name": "linkedEntities",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    v0 /*: any*/ 
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$0d1fc4f1cd0a9a67$var$node.hash = "a11eded9a6a51942258f01f5565479d1";
var $0d1fc4f1cd0a9a67$export$2e2bcd8739ae039 = $0d1fc4f1cd0a9a67$var$node;


parcelRequire("42omo");







/**
 * @generated SignedSource<<422ec819f95803aa9868da7f4c9b9999>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $475e109709fad377$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    }, v1 = {
        "kind": "ScalarField",
        "name": "email"
    }, v2 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v3 = {
        "kind": "ScalarField",
        "name": "externalId"
    }, v4 = {
        "concreteType": "ThirdPartyUserExtendedProfile",
        "kind": "LinkedField",
        "name": "extendedProfile",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "jobTitle"
            }
        ]
    }, v5 = [
        v0 /*: any*/ ,
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        v3 /*: any*/ ,
        v4 /*: any*/ 
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "threadMessage_AtlassianSearchPage",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "messageBody_AtlassianSearchPage"
            },
            {
                "kind": "ScalarField",
                "name": "integrationId"
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "createdBy",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "ThirdPartyUser",
                                        "kind": "LinkedField",
                                        "name": "thirdPartyUser",
                                        "plural": false,
                                        "selections": v5 /*: any*/ 
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalMessage"
                    }
                ]
            },
            {
                "concreteType": "ThirdPartyUser",
                "kind": "LinkedField",
                "name": "initialContributors",
                "plural": true,
                "selections": v5 /*: any*/ 
            },
            {
                "concreteType": "ThirdPartyUser",
                "kind": "LinkedField",
                "name": "allContributors",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "nickname"
                    },
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    v3 /*: any*/ ,
                    v4 /*: any*/ 
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$475e109709fad377$var$node.hash = "6b94ba34461c24a3fc7bdbfc660e83bd";
var $475e109709fad377$export$2e2bcd8739ae039 = $475e109709fad377$var$node;

































const $c12b90e23bc0db12$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    externalPersonLabel: {
        id: "externalPersonLabel",
        defaultMessage: "External person"
    }
});


const $d269b03fd327f70c$var$styles = {
    threadItem: "_n3td1b66 _ca0q1b66 _1e0c1o8l _s7n4yfq0",
    nameContainer: "_o5721q9c",
    popupTrigger: "_zulpv77o _11c8fhey _1e0c116y _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _2hwx12x7 _bfhk1j28 _s7n4yfq0 _9oik1r31 _1bnx8stv _jf4cnqa1",
    regularUser: "_zulpv77o _1e0c116y _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _2hwx12x7 _bfhk1j28 _s7n4yfq0"
};
const { serveExperiment: $d269b03fd327f70c$var$serveDoubleLineRenderingModifications } = (0, $iA4lt.getFrontendExperiment)({
    abTestId: 'slack_result_rendering'
});
const $d269b03fd327f70c$export$1859ac2c716ee754 = ({ parent: parent, node: node })=>{
    const [isPersonPopupOpen, setIsPersonPopupOpen] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const data = (0, $irOoi.useFragment)((0, $475e109709fad377$export$2e2bcd8739ae039), node);
    const integrationId = parent?.integrationId || data?.integrationId; // Check for user with email priority:
    // createdBy?.thirdPartyUser -> initialContributors with email -> allContributors
    let user = data?.entity?.createdBy?.thirdPartyUser;
    if (!user) {
        const initialContributor = data?.initialContributors?.[0];
        if (initialContributor?.email) user = initialContributor;
        else user = data?.allContributors?.[0];
    }
    const currentMessageOwnerName = user?.name || user?.nickname || formatMessage((0, $c12b90e23bc0db12$export$a7357cdd1f0b0168).externalPersonLabel);
    const picture = user?.picture; // We are waiting for this commit ticket to complete for jobTitle & profileUrl
    const userData = user && user.name ? {
        name: user.name,
        profilePicUrl: user.picture ?? undefined,
        jobTitle: user.extendedProfile?.jobTitle,
        profileUrl: null // not available as of late Oct 2024
    } : null;
    const onCopyEmail = (0, $6a8b466b77e29197$export$b2199c37e85de4a7)(user?.email);
    const messageSender = /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $678a8075b20296fe$export$3778be82376b06d7), {
                name: currentMessageOwnerName,
                picture: picture
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $d269b03fd327f70c$var$styles.nameContainer,
                children: currentMessageOwnerName
            })
        ]
    });
    const externalMessageIntegration = (0, $42omo.useMemo)(()=>(0, $Y34Hw.getExternalMessageDmIntegrationInfo)(integrationId, {
            email: user?.email,
            externalId: user?.externalId
        }), [
        integrationId,
        user?.email,
        user?.externalId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $d269b03fd327f70c$var$styles.threadItem,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
            maxLines: $d269b03fd327f70c$var$serveDoubleLineRenderingModifications ? 2 : 1,
            children: [
                userData ? // if we don't have enough data to render the person card we shouldn't make the name
                //	a popup trigger
                /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
                    isOpen: isPersonPopupOpen,
                    onClose: ()=>setIsPersonPopupOpen(false),
                    content: ()=>userData ? /*#__PURE__*/ (0, $l998X.jsx)((0, $168e8abba0f0ce48$export$4c094c8f61edecb4), {
                            user: userData,
                            externalMessageIntegration: externalMessageIntegration,
                            onCopyEmail: onCopyEmail
                        }) : null,
                    trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                            xcss: $d269b03fd327f70c$var$styles.popupTrigger,
                            onClick: ()=>setIsPersonPopupOpen(true),
                            ...triggerProps,
                            children: messageSender
                        })
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $d269b03fd327f70c$var$styles.regularUser,
                    children: messageSender
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $f63e4118bbf61370$export$36e783c4ff07cd7c), {
                    integrationId: integrationId,
                    node: data
                })
            ]
        })
    });
};


const $f4efdd719bd8f19d$export$39a3a4657e687b88 = ({ node: node })=>{
    const data = (0, $irOoi.useFragment)((0, $0d1fc4f1cd0a9a67$export$2e2bcd8739ae039), node);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $d269b03fd327f70c$export$1859ac2c716ee754), {
                parent: null,
                node: data
            }),
            data.linkedEntities?.slice(0, 2).map((linkedMessage)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $d269b03fd327f70c$export$1859ac2c716ee754), {
                    node: linkedMessage,
                    parent: {
                        integrationId: data.integrationId
                    }
                }, linkedMessage.id))
        ]
    });
};





/**
 * @generated SignedSource<<fc1a2ea7371fded4307d26e9b6ad7f5d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f94f2ac6c5f705b7$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ], v1 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "initialContributors",
        "plural": true,
        "selections": v0 /*: any*/ 
    }, v2 = [
        {
            "concreteType": "ThirdPartyUser",
            "kind": "LinkedField",
            "name": "thirdPartyUser",
            "plural": false,
            "selections": v0 /*: any*/ 
        }
    ], v3 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": v2 /*: any*/ 
    }, v4 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "members",
        "plural": true,
        "selections": v2 /*: any*/ 
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "threadTitle_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "containerName"
            },
            {
                "kind": "ScalarField",
                "name": "integrationId"
            },
            v1 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v3 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "container",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "displayName"
                                            },
                                            v4 /*: any*/ ,
                                            v5 /*: any*/ 
                                        ],
                                        "type": "ExternalConversation"
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalMessage"
                    }
                ]
            },
            {
                "concreteType": "SearchResultGraphDocument",
                "kind": "LinkedField",
                "name": "linkedEntities",
                "plural": true,
                "selections": [
                    v1 /*: any*/ ,
                    {
                        "kind": "LinkedField",
                        "name": "entity",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v3 /*: any*/ ,
                                    {
                                        "kind": "LinkedField",
                                        "name": "container",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v4 /*: any*/ ,
                                                    v5 /*: any*/ 
                                                ],
                                                "type": "ExternalConversation"
                                            }
                                        ]
                                    }
                                ],
                                "type": "ExternalMessage"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$f94f2ac6c5f705b7$var$node.hash = "db6ce7181376179e452d32bececf3fe6";
var $f94f2ac6c5f705b7$export$2e2bcd8739ae039 = $f94f2ac6c5f705b7$var$node;


parcelRequire("42omo");


















const $c3354863f2722b97$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    threadTitleWithOthers: {
        id: "search-result.thread-title-with-others-and-channel-name",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: " {contributorCount, plural,\n\t\t\t\t=0 {}\n\t\t\t\t=1 {{name1} in }\n\t\t\t\t=2 {{name1} and {name2} in }\n\t\t\t\t=3 {{name1}, {name2}, and {name3} in }\n\t\t\t\t=4 {{name1}, {name2}, {name3}, and {overflowContributorCount} other in }\n\t\t\t\tother {{name1}, {name2}, {name3}, and {overflowContributorCount} others in }\n\t\t\t}#{channelName} "
    },
    groupChatTitle: {
        id: "search-result.group-chat-title",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: " {contributorCount, plural,\n\t\t\t\t=0 {Group message with external users}\n\t\t\t\t=1 {{name1}}\n\t\t\t\t=2 {{name1} and {name2}}\n\t\t\t\t=3 {{name1}, {name2}, and {name3}}\n\t\t\t\t=4 {{name1}, {name2}, {name3}, and {overflowContributorCount} other}\n\t\t\t\tother {{name1}, {name2}, {name3}, and {overflowContributorCount} others}\n\t\t\t} "
    },
    externalPeopleLabel: {
        id: "externalPeopleLabel",
        defaultMessage: "External people #{channelName}"
    },
    externalPersonLabel: {
        id: "externalPersonLabel",
        defaultMessage: "External person"
    },
    unknownChannel: {
        id: "search-result.unknown-channel-in-thread",
        defaultMessage: "unknown-channel"
    },
    directMessageSingleUser: {
        id: "search-result.direct-message-single-user",
        defaultMessage: "{name1} and 1 other"
    },
    directMessageTwoUsers: {
        id: "search-result.direct-message-two-users",
        defaultMessage: "{name1} and {name2}"
    },
    groupDirectMessageUnknownNames: {
        id: "search-result.group-direct-message-unknown-names",
        defaultMessage: "{totalPeopleCount} people"
    },
    federatedGroupDirectMessage: {
        id: "search-result.federated-group-direct-message",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: " {knownNamesCount, plural,\n\t\t\t\t=1 {{name1}}\n\t\t\t\t=2 {{name1} and {name2}}\n\t\t\t\t=3 {{name1}, {name2} and {name3}}\n\t\t\t\tother {{name1}, {name2} and {name3}}\n\t\t\t} "
    },
    federatedGroupDirectMessageWithOneOther: {
        id: "search-result.federated-group-direct-message-with-one-other",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: " {knownNamesCount, plural,\n\t\t\t\t=1 {{name1} and {totalOthersCount} other}\n\t\t\t\t=2 {{name1}, {name2} and {totalOthersCount} other}\n\t\t\t\t=3 {{name1}, {name2}, {name3} and {totalOthersCount} other}\n\t\t\t\tother {{name1}, {name2}, {name3} and {totalOthersCount} other}\n\t\t\t} "
    },
    federatedGroupDirectMessageWithMultipleOthers: {
        id: "search-result.federated-group-direct-message-with-multiple-others",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: " {knownNamesCount, plural,\n\t\t\t\t=1 {{name1} and {totalOthersCount} others}\n\t\t\t\t=2 {{name1}, {name2} and {totalOthersCount} others}\n\t\t\t\t=3 {{name1}, {name2}, {name3} and {totalOthersCount} others}\n\t\t\t\tother {{name1}, {name2}, {name3} and {totalOthersCount} others}\n\t\t\t} "
    }
});


const $71f86e8ae561d577$var$USER_DISPLAY_LIMIT = 3;
const $71f86e8ae561d577$var$dedupUsers = (userMap, user, index)=>{
    if (!userMap[user.id]) userMap[user.id] = {
        thirdPartyUser: user,
        index: index
    };
    return userMap;
};
const $71f86e8ae561d577$var$getTitleMessageValues = (intl, users = [])=>{
    const { formatMessage: formatMessage } = intl;
    const uniqueUsers = users.filter((thirdPartyUser)=>Boolean(thirdPartyUser?.name)).reduce($71f86e8ae561d577$var$dedupUsers, {});
    const validContributors = Object.values(uniqueUsers).sort((a, b)=>a.index - b.index).map((entry)=>entry?.thirdPartyUser?.name || formatMessage((0, $c3354863f2722b97$export$a7357cdd1f0b0168).externalPersonLabel)).map((name)=>name?.split(' ')[0]);
    const externalPersonLabel = formatMessage((0, $c3354863f2722b97$export$a7357cdd1f0b0168).externalPersonLabel);
    const externalPersonCount = validContributors.filter((name)=>name === externalPersonLabel).length;
    let adjustedContributors = validContributors;
    if (externalPersonCount > 1) {
        adjustedContributors = validContributors.filter((name)=>name !== externalPersonLabel);
        adjustedContributors.unshift(formatMessage((0, $c3354863f2722b97$export$a7357cdd1f0b0168).externalPeopleLabel));
    }
    const contributorCount = adjustedContributors.length;
    const namedContributors = adjustedContributors.slice(0, $71f86e8ae561d577$var$USER_DISPLAY_LIMIT);
    const overflowContributorCount = adjustedContributors.slice($71f86e8ae561d577$var$USER_DISPLAY_LIMIT).length;
    return {
        contributorCount: contributorCount,
        namedContributors: namedContributors,
        overflowContributorCount: overflowContributorCount
    };
};
const $71f86e8ae561d577$var$getRegularThreadTitleValues = (data, intl, formatMessage)=>{
    const linkedEntities = data.linkedEntities || [];
    const threadUsers = [
        data,
        ...linkedEntities
    ].map((linkedMessage)=>linkedMessage?.entity?.createdBy?.thirdPartyUser || linkedMessage?.initialContributors?.[0]);
    const { contributorCount: contributorCount, namedContributors: namedContributors, overflowContributorCount: overflowContributorCount } = $71f86e8ae561d577$var$getTitleMessageValues(intl, threadUsers);
    const [name1, name2, name3] = namedContributors;
    const channelName = data?.entity?.container?.displayName || data?.containerName || formatMessage((0, $c3354863f2722b97$export$a7357cdd1f0b0168).unknownChannel);
    return {
        values: {
            contributorCount: contributorCount,
            name1: name1,
            name2: name2,
            name3: name3,
            overflowContributorCount: overflowContributorCount,
            channelName: channelName
        },
        titleMessage: (0, $c3354863f2722b97$export$a7357cdd1f0b0168).threadTitleWithOthers
    };
};
const $71f86e8ae561d577$export$18638a7ae5c7368a = ({ node: node })=>{
    const intl = (0, $8C5kA.default)();
    const { formatMessage: formatMessage } = intl;
    let values = {};
    let titleMessage = (0, $c3354863f2722b97$export$a7357cdd1f0b0168).groupChatTitle;
    const data = (0, $irOoi.useFragment)((0, $f94f2ac6c5f705b7$export$2e2bcd8739ae039), node);
    const isSlackFederatedSearchEnabled = (0, $8RFAN.serveFederatedSlackExperiment)(undefined, undefined, {
        fireExperimentExposure: false
    }) || (0, $dh538.fg)('ai_3p_slack_federated_search_enabled');
    const isSlackIntegration = data.integrationId === 'ari:cloud:platform::integration/slack';
    if (data.containerName != null && isSlackFederatedSearchEnabled && isSlackIntegration) {
        const groupChatParticipants = data?.initialContributors;
        // direct message
        if (data.containerName === '') {
            const nonNullParticipants = groupChatParticipants?.filter((participant)=>participant?.name) || [];
            const { namedContributors: namedContributors } = $71f86e8ae561d577$var$getTitleMessageValues(intl, nonNullParticipants);
            const [name1, name2] = namedContributors;
            if (nonNullParticipants.length === 1) {
                values = {
                    name1: name1
                };
                titleMessage = (0, $c3354863f2722b97$export$a7357cdd1f0b0168).directMessageSingleUser;
            } else {
                values = {
                    name1: name1,
                    name2: name2
                };
                titleMessage = (0, $c3354863f2722b97$export$a7357cdd1f0b0168).directMessageTwoUsers;
            }
        } else if (data.containerName && /^mpdm-.+--.*-\d+$/.test(data.containerName)) {
            // Extract number of people from containerName (format: mpdm-name1--name2--name3-1)
            const totalPeopleCount = (data.containerName.match(/--/g) || []).length + 1;
            const nonNullParticipants = groupChatParticipants?.filter((participant)=>participant?.name) || [];
            const otherCount = totalPeopleCount - nonNullParticipants.length;
            if (nonNullParticipants.length > 0) {
                const { namedContributors: namedContributors } = $71f86e8ae561d577$var$getTitleMessageValues(intl, nonNullParticipants);
                const displayedNames = namedContributors.slice(0, $71f86e8ae561d577$var$USER_DISPLAY_LIMIT);
                const [name1, name2, name3] = displayedNames;
                // Calculate total others (remaining known names + unknown people)
                const totalOthersCount = nonNullParticipants.length - displayedNames.length + otherCount;
                const hasOthers = totalOthersCount > 0;
                values = {
                    knownNamesCount: nonNullParticipants.length,
                    name1: name1,
                    name2: name2,
                    name3: name3,
                    totalOthersCount: totalOthersCount
                };
                titleMessage = hasOthers ? totalOthersCount === 1 ? (0, $c3354863f2722b97$export$a7357cdd1f0b0168).federatedGroupDirectMessageWithOneOther : (0, $c3354863f2722b97$export$a7357cdd1f0b0168).federatedGroupDirectMessageWithMultipleOthers : (0, $c3354863f2722b97$export$a7357cdd1f0b0168).federatedGroupDirectMessage;
            } else {
                // Fallback if no names available
                values = {
                    totalPeopleCount: totalPeopleCount
                };
                titleMessage = (0, $c3354863f2722b97$export$a7357cdd1f0b0168).groupDirectMessageUnknownNames;
            }
        } else {
            const result = $71f86e8ae561d577$var$getRegularThreadTitleValues(data, intl, formatMessage);
            values = result.values;
            titleMessage = result.titleMessage;
        }
    } else if (data?.entity?.container?.type === 'DIRECT_MESSAGE' || data?.entity?.container?.type === 'GROUP_DIRECT_MESSAGE') {
        const groupChatParticipants = data?.entity?.container?.members?.map((member)=>member?.thirdPartyUser) ?? [];
        const { contributorCount: contributorCount, namedContributors: namedContributors, overflowContributorCount: overflowContributorCount } = $71f86e8ae561d577$var$getTitleMessageValues(intl, groupChatParticipants);
        const [name1, name2, name3] = namedContributors;
        values = {
            contributorCount: contributorCount,
            name1: name1,
            name2: name2,
            name3: name3,
            overflowContributorCount: overflowContributorCount
        };
        titleMessage = (0, $c3354863f2722b97$export$a7357cdd1f0b0168).groupChatTitle;
    } else {
        const result = $71f86e8ae561d577$var$getRegularThreadTitleValues(data, intl, formatMessage);
        values = result.values;
        titleMessage = result.titleMessage;
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...titleMessage,
        values: values
    });
};


const $1cb6de7b071beecb$export$eb10cea9a7aeba8c = ({ node: node, position: position, cloudId: cloudId, primaryProduct: primaryProduct, selectedProduct: selectedProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $983e6d707353d744$export$2e2bcd8739ae039), node);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { url: url, linkedEntities: linkedEntities = [] } = data;
    const attachments = data.entity?.attachments || [];
    // Use linkedEntitiesType if available, otherwise fallback to existing logic
    const labelMessage = data.linkedEntitiesType ? data.linkedEntitiesType === 'thread' ? (0, $dde367fe129b91bd$export$defe85febe8b728c).threadTypeLabel : (0, $dde367fe129b91bd$export$defe85febe8b728c).messageTypeLabel : linkedEntities?.length ? (0, $dde367fe129b91bd$export$defe85febe8b728c).threadTypeLabel : (0, $dde367fe129b91bd$export$defe85febe8b728c).messageTypeLabel;
    const title = /*#__PURE__*/ (0, $l998X.jsx)((0, $71f86e8ae561d577$export$18638a7ae5c7368a), {
        node: data
    });
    const body = /*#__PURE__*/ (0, $l998X.jsx)((0, $f4efdd719bd8f19d$export$39a3a4657e687b88), {
        node: data
    });
    const parts = [
        [
            'label',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...labelMessage
            })
        ]
    ];
    const socialParts = [];
    const conversationMemberCount = data.entity?.container?.memberCount;
    if (conversationMemberCount) parts.push([
        'memberCount',
        /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $dde367fe129b91bd$export$defe85febe8b728c).memberCount,
            values: {
                count: conversationMemberCount
            }
        })
    ]);
    const lastActiveDate = data?.entity?.lastActive || data?.lastModifiedDate;
    if (lastActiveDate) parts.push([
        'lastActive',
        /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
            lastModified: lastActiveDate,
            message: (0, $dde367fe129b91bd$export$defe85febe8b728c).lastActive
        })
    ]);
    if ((0, $dh538.fg)('rovo_fps_enable_3p_messages_reaction_count_ui')) {
        const likeCountComponent = (0, $f70284887e2e1865$export$b52fa2ff0823604f)(data.entity?.reactionCount);
        if (likeCountComponent) socialParts.push([
            'like-count',
            likeCountComponent
        ]);
    }
    const links = [
        data,
        ...linkedEntities ?? []
    ]?.map((node)=>node.entity?.description || node.excerpt)?.filter((excerpt)=>!!excerpt)?.flatMap((0, $514d99dea8b7ae4b$export$a414b3d5a172e15b)) ?? [];
    const shouldShowAttachmentsOrLinks = attachments.length > 0 || links.length > 0;
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const shouldShowRelatedLinks = linkedResults && linkedResults.length > 0;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: data.id,
        product: product,
        productSelected: true,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: body,
        headerMetadataParts: parts,
        headerMetadataSocialParts: socialParts,
        footer: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: shouldShowRelatedLinks ? /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
                linkedResults: linkedResults || [],
                thirdPartyConfigs: thirdPartyConfigs,
                partial: data,
                url: url,
                onResultClicked: onResultClicked,
                position: position,
                onResultContextMenu: onResultContextMenu,
                isAllProductSelected: !selectedProduct
            }) : shouldShowAttachmentsOrLinks && /*#__PURE__*/ (0, $l998X.jsxs)((0, $664c8ed2681bd434$export$6b89e3fa6be10ffa), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$49bd1dfb0ad29c40), {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9lz2c))),
                        attachmentCount: attachments.length,
                        attachmentType: "file",
                        label: formatMessage((0, $dde367fe129b91bd$export$defe85febe8b728c).fileAttachmentsExpandButtonLabel, {
                            count: attachments.length
                        }),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9d89d5105e50bac9$export$28f865e0208f513d), {
                            node: data
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$49bd1dfb0ad29c40), {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
                        attachmentCount: links.length,
                        attachmentType: "url",
                        label: formatMessage((0, $514d99dea8b7ae4b$export$47614749115bca3d), {
                            count: links.length
                        }),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $514d99dea8b7ae4b$export$dffce0f8d8968f9c), {
                            links: links,
                            onResultClicked: onResultClicked
                        })
                    })
                ]
            })
        }),
        title: title,
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        appMode: appMode,
        isPrivate: data?.entity?.container?.membershipType === 'PRIVATE',
        hasRelatedLinks: !!linkedResults && linkedResults.length > 0,
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<34eefcf8eaa100197dc9c44dc42da8c4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $698bf5c47f2c99a5$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "url"
    }, v2 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphPullRequest_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionLevel"
            },
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            {
                "kind": "ScalarField",
                "name": "containerName"
            },
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v3 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "lastUpdate"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "pullRequestId"
                            },
                            {
                                "kind": "LinkedField",
                                "name": "container",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "name"
                                            }
                                        ],
                                        "type": "ExternalRepository"
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalPullRequest"
                    }
                ]
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v3 /*: any*/ ,
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$698bf5c47f2c99a5$var$node.hash = "4ab24a726d2f2072d30228378e5b8164";
var $698bf5c47f2c99a5$export$2e2bcd8739ae039 = $698bf5c47f2c99a5$var$node;


parcelRequire("42omo");


























const $60785cd45ae6de28$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    resultLabel: {
        id: "search-pull-request-result.label",
        defaultMessage: "Pull request"
    }
});


const $5d482861d79b63c5$export$ff9a66c66b5ab669 = ({ node: node, position: position, cloudId: cloudId, primaryProduct: primaryProduct, selectedProduct: selectedProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $698bf5c47f2c99a5$export$2e2bcd8739ae039), node);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { url: url, permissionLevel: permissionLevel, entity: entity, excerpt: excerpt, containerName: containerName, lastModifiedDate: lastModifiedDate, title: partialTitle } = data;
    const { title: entityTitle, lastUpdate: lastUpdate, container: container, pullRequestId: pullRequestId } = entity || {};
    const label = formatMessage((0, $60785cd45ae6de28$export$defe85febe8b728c).resultLabel);
    const lastModifiedComponent = lastModifiedDate || lastUpdate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastUpdate ?? lastModifiedDate
    }) : null;
    const padlockIcon = (0, $Y34Hw.isNonPublic)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const getDescription = (excerpt)=>{
        const markdownRemoved = (0, $4dd635508e197aad$export$7e4bcd4afb389edb)(excerpt);
        return (0, $Y34Hw.processExcerpt)(markdownRemoved, true);
    };
    const headerMetadataParts = [
        label,
        [
            'pull-request-id',
            pullRequestId ? `#${pullRequestId}` : null
        ],
        [
            'repository-name',
            container?.name ?? containerName ?? null
        ],
        [
            'padlock',
            padlockIcon
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    const links = (0, $514d99dea8b7ae4b$export$a414b3d5a172e15b)(excerpt || '');
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const shouldShowRelatedLinks = linkedResults && linkedResults.length > 0;
    const footerComponent = shouldShowRelatedLinks ? /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
        linkedResults: linkedResults || [],
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data,
        url: url,
        position: position,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        isAllProductSelected: !selectedProduct
    }) : links.length > 0 && /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$6b89e3fa6be10ffa), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$49bd1dfb0ad29c40), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
            attachmentCount: links.length,
            attachmentType: "url",
            label: formatMessage((0, $514d99dea8b7ae4b$export$47614749115bca3d), {
                count: links.length
            }),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $514d99dea8b7ae4b$export$dffce0f8d8968f9c), {
                links: links,
                onResultClicked: onResultClicked
            })
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: data.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: getDescription(excerpt)
        }),
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(partialTitle ?? entityTitle),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: data,
        appMode: appMode,
        footer: footerComponent,
        hasRelatedLinks: !!linkedResults && linkedResults.length > 0,
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<6198b180a29a02a9c0c26c3661b386b7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $000492c4a0656d4d$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    }, v2 = {
        "kind": "ScalarField",
        "name": "url"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphRepository_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionLevel"
            },
            v3 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v3 /*: any*/ ,
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$000492c4a0656d4d$var$node.hash = "ca41a20e0191caf0691caf5ec12937f3";
var $000492c4a0656d4d$export$2e2bcd8739ae039 = $000492c4a0656d4d$var$node;


parcelRequire("42omo");





















const $9b7c9a4872c9cd63$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    resultLabel: {
        id: "search-respository-result.label",
        defaultMessage: "Repository"
    }
});


const $c5ef8720fa5f1985$var$GITHUB_INTEGRATION_KEY = 'github';
const $c5ef8720fa5f1985$export$b873936a7a174976 = ({ node: node, position: position, cloudId: cloudId, primaryProduct: primaryProduct, selectedProduct: selectedProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $000492c4a0656d4d$export$2e2bcd8739ae039), node);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, title: title, excerpt: excerpt } = data;
    const label = formatMessage((0, $9b7c9a4872c9cd63$export$defe85febe8b728c).resultLabel);
    const padlockIcon = (0, $Y34Hw.isNonPublic)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const getDescription = (excerpt)=>{
        const markdownRemoved = (0, $4dd635508e197aad$export$7e4bcd4afb389edb)(excerpt);
        return (0, $Y34Hw.processExcerpt)(markdownRemoved, true);
    };
    const lastModifiedComponent = lastModifiedDate && product !== $c5ef8720fa5f1985$var$GITHUB_INTEGRATION_KEY ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const headerMetadataParts = [
        label,
        [
            'padlock',
            padlockIcon
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const footerComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
        linkedResults: linkedResults || [],
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data,
        url: url,
        position: position,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        isAllProductSelected: !selectedProduct
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: data.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: getDescription(excerpt)
        }),
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: data,
        appMode: appMode,
        footer: footerComponent,
        hasRelatedLinks: !!linkedResults && linkedResults.length > 0,
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<7cdb96db81e3e8ac212e267dbeb8302b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1bb1420b6ba035f4$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "title"
    }, v2 = {
        "kind": "ScalarField",
        "name": "url"
    }, v3 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    }, v4 = {
        "kind": "ScalarField",
        "name": "integrationId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphVideo_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            v3 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionLevel"
            },
            v4 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "durationInSeconds"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "thumbnailUrl"
                            },
                            {
                                "concreteType": "ExternalChapter",
                                "kind": "LinkedField",
                                "name": "chapters",
                                "plural": true,
                                "selections": [
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "startTimeInSeconds"
                                    }
                                ]
                            },
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "createdBy",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "ThirdPartyUser",
                                        "kind": "LinkedField",
                                        "name": "thirdPartyUser",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            v5 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                            v5 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalVideo"
                    }
                ]
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    v3 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    },
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$1bb1420b6ba035f4$var$node.hash = "5acd117695a3c880ca26ab9502e4446c";
var $1bb1420b6ba035f4$export$2e2bcd8739ae039 = $1bb1420b6ba035f4$var$node;


parcelRequire("42omo");










/* meeting-transcript-renderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





/* base-video-search-result.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 


parcelRequire("42omo");















const $2c4d0c6cf5bca3eb$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    videoThumbnailAltText: {
        id: "search-graph-video.video-thumbnail-alt-text",
        defaultMessage: "Video thumbnail"
    },
    videoIconLabel: {
        id: "search-graph-video.video-icon-label",
        defaultMessage: "video icon"
    },
    dropdownMessage: {
        id: "search-graph-video.dropdown-message",
        defaultMessage: "{chapterCount, plural, one {# chapter in this video} other {# chapters in this video}}"
    },
    videoType: {
        id: "search-graph-video.video-type",
        defaultMessage: "Video"
    },
    durationInSeconds: {
        id: "search-graph-video.duration.seconds",
        defaultMessage: "{seconds} sec"
    },
    durationInMinutes: {
        id: "search-graph-video.duration.minutes",
        defaultMessage: "{minutes} min"
    },
    durationInHours: {
        id: "search-graph-video.duration.hours",
        defaultMessage: "{hours} hour {minutes} min"
    }
});


const $3937a4926ef9c941$export$2af0427184fd7376 = ({ data: data, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, product: product, icon: icon, mainContentWidth: mainContentWidth, body: // Customization props
body, footer: footer, hasRelatedLinks: hasRelatedLinks = false, additionalMetadataParts: additionalMetadataParts = [] })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, entity: entity, title: title } = data;
    const { createdBy: createdBy } = entity || {};
    const creatorName = createdBy?.user?.name || createdBy?.thirdPartyUser?.name || null;
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const padlockIcon = (0, $Y34Hw.isNonPublic)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const headerMetadataParts = [
        formatMessage((0, $2c4d0c6cf5bca3eb$export$defe85febe8b728c).videoType),
        [
            'creator-name',
            creatorName
        ],
        [
            'last-modified',
            lastModifiedComponent
        ],
        ...additionalMetadataParts,
        [
            'padlock',
            padlockIcon
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: data.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        description: body,
        icon: icon,
        headerMetadataParts: headerMetadataParts,
        footer: footer,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: data,
        appMode: appMode,
        hasRelatedLinks: hasRelatedLinks,
        mainContentWidth: mainContentWidth
    });
};


const $fc11365f4879160a$export$96a462af0b650fcd = (props)=>{
    const { data: data } = props;
    const { excerpt: excerpt } = data;
    const body = /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
        description: (0, $Y34Hw.processExcerpt)(excerpt, true)
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3937a4926ef9c941$export$2af0427184fd7376), {
        ...props,
        body: body
    });
};


/* video-result-renderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");











/* video-chapters.tsx generated by @compiled/babel-plugin v0.36.1 */ 














































var $def528d622574573$require$Buffer = $iA9co.Buffer;
const $def528d622574573$export$b0d5f79a828d791e = (durationInSeconds, options)=>{
    if (durationInSeconds === undefined || durationInSeconds === null) return null;
    const date = (0, $bKOxc.default)(new Date(0), durationInSeconds);
    const ONE_HOUR = 3600;
    const ONE_MINUTE = 60;
    const hours = Math.floor(durationInSeconds / ONE_HOUR);
    const minutes = Math.floor(durationInSeconds % ONE_HOUR / ONE_MINUTE);
    const seconds = durationInSeconds % ONE_MINUTE;
    if (options?.readable && options.formatMessage && (0, $dh538.fg)('fix_video_duration_i18n')) {
        if (durationInSeconds < ONE_MINUTE) return options.formatMessage((0, $2c4d0c6cf5bca3eb$export$defe85febe8b728c).durationInSeconds, {
            seconds: seconds
        });
        else if (durationInSeconds < 3600) return options.formatMessage((0, $2c4d0c6cf5bca3eb$export$defe85febe8b728c).durationInMinutes, {
            minutes: minutes
        });
        else return options.formatMessage((0, $2c4d0c6cf5bca3eb$export$defe85febe8b728c).durationInHours, {
            hours: hours,
            minutes: minutes
        });
    }
    if (options?.readable) {
        if (durationInSeconds < ONE_MINUTE) return `${seconds} sec`;
        else if (durationInSeconds < 3600) return `${minutes} min`;
        else return `${hours} hour ${minutes} min`;
    }
    if (durationInSeconds < ONE_HOUR) return (0, $dWCFT.default)(date, 'mm:ss');
    return (0, $dWCFT.default)(date, 'HH:mm:ss');
};
const $def528d622574573$export$edf82fe058be01d = (url)=>{
    const urlParams = new URLSearchParams(new URL(url).search);
    const base64Policy = urlParams.get('Policy');
    if (!base64Policy) return true;
    const decodedPolicy = $def528d622574573$require$Buffer.from(base64Policy, 'base64').toString('utf-8');
    const i = decodedPolicy.lastIndexOf('}');
    const sanitizedPolicy = decodedPolicy.substring(0, i + 1);
    let policy;
    try {
        policy = JSON.parse(sanitizedPolicy);
    } catch  {
        return true;
    }
    if (policy.Statement && policy.Statement.length > 0) {
        const statement = policy.Statement[0];
        if (statement.Condition && statement.Condition.DateLessThan) {
            const epochTime = statement.Condition.DateLessThan['AWS:EpochTime'];
            const currentTime = Math.floor(Date.now() / 1000);
            return currentTime > epochTime;
        }
    }
    //fallthrough treat as expired
    return true;
};
const $def528d622574573$export$121bfeb3f6fb7f94 = (baseUrl, durationInSeconds)=>{
    return `${baseUrl}?t=${durationInSeconds}`;
};


const $607ed374734760ce$var$videoChapterStyles = {
    footerContainer: "_ca0qutpp _kqswh2mm",
    chapterLinkStyles: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz13af _10531ra0 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _1vhv17z1",
    dropdownItemStyles: "_1rjc1b66 _1e0c1txw _gy1pv77o _19pku2gc",
    seeAllStyles: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _11c8wadc _19pkutpp"
};
const $607ed374734760ce$var$DropdownItems = ({ chapters: chapters, url: url })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        children: [
            chapters.map(({ title: title, startTimeInSeconds: startTimeInSeconds })=>{
                return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    xcss: $607ed374734760ce$var$videoChapterStyles.dropdownItemStyles,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $lE8sM.default), {
                            size: "16",
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2Yaht))),
                            label: formatMessage((0, $2c4d0c6cf5bca3eb$export$defe85febe8b728c).videoIconLabel),
                            appearance: "blue"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            space: 'space.050',
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    size: "small",
                                    weight: "medium",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
                                        xcss: $607ed374734760ce$var$videoChapterStyles.chapterLinkStyles,
                                        href: (0, $def528d622574573$export$121bfeb3f6fb7f94)(url, startTimeInSeconds),
                                        rel: 'noreferrer',
                                        target: "_blank",
                                        children: (0, $def528d622574573$export$b0d5f79a828d791e)(startTimeInSeconds)
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    size: "small",
                                    children: title
                                })
                            ]
                        })
                    ]
                }, `${title}-${startTimeInSeconds}`);
            }),
            chapters.length > 10 && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $607ed374734760ce$var$videoChapterStyles.seeAllStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
                    href: url,
                    target: "_blank",
                    xcss: $607ed374734760ce$var$videoChapterStyles.seeAllStyles,
                    children: "See all"
                })
            })
        ]
    });
};
const $607ed374734760ce$var$DropdownMenu = ({ chapters: chapters, url: url })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(false);
    const dropdownMessage = formatMessage((0, $2c4d0c6cf5bca3eb$export$defe85febe8b728c).dropdownMessage, {
        chapterCount: chapters.length
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                iconAfter: (iconProps)=>isExpanded ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                        ...iconProps,
                        size: "small"
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                        ...iconProps,
                        size: "small"
                    }),
                onClick: ()=>setIsExpanded(!isExpanded),
                isSelected: isExpanded,
                children: dropdownMessage
            }),
            isExpanded && /*#__PURE__*/ (0, $l998X.jsx)($607ed374734760ce$var$DropdownItems, {
                chapters: chapters,
                url: url
            })
        ]
    });
};
const $607ed374734760ce$export$d277574e14079165 = ({ chapters: chapters, url: url })=>{
    if (!chapters || chapters.length === 0) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $607ed374734760ce$var$videoChapterStyles.footerContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)($607ed374734760ce$var$DropdownMenu, {
            chapters: chapters,
            url: url
        })
    });
}; /**
    * Type guard to filter out null/undefined chapters
    */ 
const $607ed374734760ce$export$f4f9f118e88808a5 = (chapter)=>chapter !== null && chapter !== undefined;


/* video-thumbnail.tsx generated by @compiled/babel-plugin v0.36.1 */ 


















const $06af07ec2fcc9e7d$var$styles = {
    thumbnailContainer: "_nd5l18xf _kqswh2mm",
    thumbnailImage: "_2rko12b0 _c71l1ymo _1bsb1wug"
};
const $06af07ec2fcc9e7d$export$bd4b73f15688a160 = ({ thumbnailUrl: thumbnailUrl, url: url })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isErrored, setIsErrored] = (0, $42omo.useState)(false);
    if (!thumbnailUrl || (0, $def528d622574573$export$edf82fe058be01d)(thumbnailUrl) || isErrored) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        testId: "thumbnail-container",
        xcss: $06af07ec2fcc9e7d$var$styles.thumbnailContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
            href: url,
            rel: 'noreferrer',
            target: '_blank',
            children: /*#__PURE__*/ (0, $l998X.jsx)("img", {
                src: thumbnailUrl,
                alt: formatMessage((0, $2c4d0c6cf5bca3eb$export$defe85febe8b728c).videoThumbnailAltText),
                onError: ()=>setIsErrored(true),
                className: (0, $gMc0m.default)([
                    $06af07ec2fcc9e7d$var$styles.thumbnailImage
                ])
            })
        })
    });
};



const $57520cf3a6ba1155$var$videoresultsStyles = {
    bodyAreaStyles: "_1e0c1txw _gy1putpp"
};
const $57520cf3a6ba1155$export$a0005e6573cda3b = (props)=>{
    const { data: data, formatMessage: formatMessage, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, position: position, selectedProduct: selectedProduct, product: product, is3pGroupingEnabled: is3pGroupingEnabled, thirdPartyConfigs: thirdPartyConfigs, linkedResults: linkedResults } = props;
    const { url: url, entity: entity, integrationId: integrationId } = data;
    const { durationInSeconds: durationInSeconds, chapters: chapters, thumbnailUrl: thumbnailUrl } = entity || {};
    const { excerpt: excerpt } = data;
    const videoDuration = (0, $def528d622574573$export$b0d5f79a828d791e)(durationInSeconds, {
        readable: true,
        formatMessage: formatMessage
    });
    const body = /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        testId: "thumbnail-container",
        xcss: $57520cf3a6ba1155$var$videoresultsStyles.bodyAreaStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $06af07ec2fcc9e7d$export$bd4b73f15688a160), {
                thumbnailUrl: thumbnailUrl,
                url: url
            }),
            thumbnailUrl && !(0, $def528d622574573$export$edf82fe058be01d)(thumbnailUrl) ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                children: [
                    (0, $Y34Hw.processExcerpt)(excerpt, true),
                    " "
                ]
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
                description: (0, $Y34Hw.processExcerpt)(excerpt, true)
            })
        ]
    });
    const isLoom = integrationId === 'ari:cloud:platform::integration/loom';
    const shouldRenderSimilarResults = isLoom && linkedResults?.some((linkedResult)=>linkedResult.category?.toUpperCase() === 'SIMILAR');
    const shouldShowRelatedLinks = linkedResults && linkedResults.length > 0;
    const footerComponent = shouldShowRelatedLinks ? shouldRenderSimilarResults ? /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$59c57a80401f0a6), {
        linkedResults: linkedResults || [],
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data,
        url: url,
        position: position,
        onResultClicked: onResultClicked,
        isAllProductSelected: !selectedProduct,
        onResultContextMenu: onResultContextMenu,
        is3pGroupingEnabled: is3pGroupingEnabled,
        product: product,
        type: formatMessage((0, $2c4d0c6cf5bca3eb$export$defe85febe8b728c).videoType)
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
        linkedResults: linkedResults || [],
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data,
        url: url,
        position: position,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        isAllProductSelected: !selectedProduct
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $607ed374734760ce$export$d277574e14079165), {
            chapters: (chapters ?? []).filter((0, $607ed374734760ce$export$f4f9f118e88808a5)),
            url: url
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3937a4926ef9c941$export$2af0427184fd7376), {
        ...props,
        body: body,
        footer: footerComponent,
        hasRelatedLinks: !!linkedResults && linkedResults.length > 0,
        additionalMetadataParts: [
            [
                'video-duration',
                videoDuration
            ]
        ]
    });
};


const $3cdba03374a66139$export$77e38f0db0b0632d = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, is3pGroupingEnabled: is3pGroupingEnabled, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $1bb1420b6ba035f4$export$2e2bcd8739ae039), node);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { integrationId: integrationId } = data;
    // NOTE: The integration ID is the sole indicator currently to differentiate a video entity from Loom vs MS Teams Meeting Transcript.
    // This is because both entities share the same resourceType ('video') and do not necessarily pass a subType or other identifying information.
    // For Meeting Transcripts (Microsoft Teams), we don't show video duration, thumbnail, or chapters - just the transcript excerpt.
    const isMeetingTranscript = integrationId === 'ari:cloud:platform::integration/microsoft' && (0, $dh538.fg)('rovo_fps_enable_ms_teams_meeting_type_filter');
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const rendererProps = {
        data: data,
        formatMessage: formatMessage,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        position: position,
        cloudId: cloudId,
        selectedProduct: selectedProduct,
        primaryProduct: primaryProduct,
        appMode: appMode,
        product: product,
        icon: icon,
        is3pGroupingEnabled: is3pGroupingEnabled,
        thirdPartyConfigs: thirdPartyConfigs,
        mainContentWidth: mainContentWidth,
        linkedResults: linkedResults
    };
    if (isMeetingTranscript) return /*#__PURE__*/ (0, $l998X.jsx)((0, $fc11365f4879160a$export$96a462af0b650fcd), {
        ...rendererProps
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $57520cf3a6ba1155$export$a0005e6573cda3b), {
        ...rendererProps
    });
};





/**
 * @generated SignedSource<<18d4ccb6636b3700135fddc772e0ee1c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b1fef4787f14ce26$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "title"
    }, v2 = {
        "kind": "ScalarField",
        "name": "url"
    }, v3 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    }, v4 = [
        v0 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ], v5 = [
        {
            "concreteType": "ThirdPartyUser",
            "kind": "LinkedField",
            "name": "thirdPartyUser",
            "plural": false,
            "selections": v4 /*: any*/ 
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "subtype"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphWorkItem_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            v3 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionLevel"
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "assignee",
                                "plural": false,
                                "selections": v5 /*: any*/ 
                            },
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "createdBy",
                                "plural": false,
                                "selections": v5 /*: any*/ 
                            },
                            {
                                "kind": "ScalarField",
                                "name": "dueDate"
                            },
                            {
                                "concreteType": "ExternalWorkItemProject",
                                "kind": "LinkedField",
                                "name": "workItemProject",
                                "plural": false,
                                "selections": v4 /*: any*/ 
                            },
                            {
                                "kind": "ScalarField",
                                "name": "status"
                            },
                            v6 /*: any*/ 
                        ],
                        "type": "ExternalWorkItem"
                    }
                ]
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    v3 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    v6 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$b1fef4787f14ce26$var$node.hash = "9dd7e6601b2284205ebc495ea9885d2d";
var $b1fef4787f14ce26$export$2e2bcd8739ae039 = $b1fef4787f14ce26$var$node;


parcelRequire("42omo");



































const $a84a41c1040183af$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    workItemLabel: {
        id: "search-graph-work-item.label",
        defaultMessage: "Work item"
    },
    taskLabel: {
        id: "search-graph-work-item.task.label",
        defaultMessage: "Task"
    },
    epicLabel: {
        id: "search-graph-work-item.epic.label",
        defaultMessage: "Epic"
    },
    bugLabel: {
        id: "search-graph-work-item.bug.label",
        defaultMessage: "Bug"
    },
    storyLabel: {
        id: "search-graph-work-item.story.label",
        defaultMessage: "Story"
    },
    milestoneLabel: {
        id: "search-graph-work-item.milestone.label",
        defaultMessage: "Milestone"
    },
    sectionLabel: {
        id: "search-graph-work-item.section",
        defaultMessage: "Section"
    },
    approvalLabel: {
        id: "search-graph-work-item.approval",
        defaultMessage: "Approval"
    },
    problemLabel: {
        id: "search-graph-work-item.problem",
        defaultMessage: "Problem"
    },
    incidentLabel: {
        id: "search-graph-work-item.incident",
        defaultMessage: "Incident"
    },
    questionLabel: {
        id: "search-graph-work-item.question",
        defaultMessage: "Question"
    },
    issueLabel: {
        id: "search-graph-work-item.issue",
        defaultMessage: "Issue"
    },
    for: {
        id: "work-item-status.for",
        defaultMessage: "{statusLozenge} for {dateLozenge}"
    },
    isAssigned: {
        id: "work-item-assignee.assigned",
        defaultMessage: "{isAssigned, select, internal {{firstName} is assigned} other {External person is assigned}}"
    },
    created: {
        id: "work-item-creator.created",
        defaultMessage: "{created, select, internal {{firstName} created} other {External person created}}"
    }
});


const $485beeea42bb88b1$var$nameContainer = (0, $ecnYn.xcss)({
    whiteSpace: 'nowrap'
});
const $485beeea42bb88b1$var$statusAndDateContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.100'
});
const $485beeea42bb88b1$var$getStatusLozengeAppearance = (label)=>{
    label = label.replace(/[\s]+/g, '').toLowerCase();
    switch(true){
        case [
            'onhold'
        ].includes(label):
            return 'default';
        // gray
        case [
            'solved',
            'complete'
        ].includes(label):
            return 'success';
        // green
        case [
            'open',
            'offtrack'
        ].includes(label):
            return 'removed';
        // red
        case [
            'new',
            'atrisk'
        ].includes(label):
            return 'moved';
        // yellow
        case [
            'pending',
            'ontrack'
        ].includes(label):
            return 'inprogress';
    }
    return 'inprogress'; // blue for custom status labels
};
const $485beeea42bb88b1$export$d1e5c8cc4a829640 = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $b1fef4787f14ce26$export$2e2bcd8739ae039), node);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, entity: entity, excerpt: excerpt, title: title } = data;
    const { assignee: assignee, createdBy: createdBy, dueDate: dueDate, workItemProject: workItemProject, status: status, subtype: subtype } = entity || {};
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const padlockIcon = (0, $Y34Hw.isNonPublic)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const getStatusAndDate = ()=>{
        if (!status) return null;
        const statusLabel = status.replace(/[-_]+/g, ' ');
        const statusLozenge = /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
            appearance: $485beeea42bb88b1$var$getStatusLozengeAppearance(statusLabel),
            children: statusLabel
        });
        const dateLozenge = dueDate && /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cgtv4.FormattedDate), {
                value: dueDate,
                month: "short",
                day: "numeric"
            })
        });
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $485beeea42bb88b1$var$statusAndDateContainerStyles,
            children: dueDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $a84a41c1040183af$export$defe85febe8b728c).for,
                values: {
                    statusLozenge: statusLozenge,
                    dateLozenge: dateLozenge
                }
            }) : statusLozenge
        });
    };
    const getAssigneeOrCreator = ()=>{
        let actionLabel;
        const fullName = assignee?.thirdPartyUser?.name || createdBy?.thirdPartyUser?.name || '';
        const firstName = fullName?.split(' ')?.[0];
        if (assignee?.thirdPartyUser?.name) actionLabel = formatMessage((0, $a84a41c1040183af$export$defe85febe8b728c).isAssigned, {
            firstName: firstName,
            isAssigned: firstName ? 'internal' : 'external'
        });
        else actionLabel = formatMessage((0, $a84a41c1040183af$export$defe85febe8b728c).created, {
            firstName: firstName,
            created: firstName ? 'internal' : 'external'
        });
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
            space: "space.025",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $678a8075b20296fe$export$3778be82376b06d7), {
                    name: fullName
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $485beeea42bb88b1$var$nameContainer,
                    children: actionLabel
                })
            ]
        });
    };
    const subtypeMap = {
        task: (0, $a84a41c1040183af$export$defe85febe8b728c).taskLabel,
        default_task: (0, $a84a41c1040183af$export$defe85febe8b728c).taskLabel,
        epic: (0, $a84a41c1040183af$export$defe85febe8b728c).epicLabel,
        bug: (0, $a84a41c1040183af$export$defe85febe8b728c).bugLabel,
        story: (0, $a84a41c1040183af$export$defe85febe8b728c).storyLabel,
        milestone: (0, $a84a41c1040183af$export$defe85febe8b728c).milestoneLabel,
        section: (0, $a84a41c1040183af$export$defe85febe8b728c).sectionLabel,
        approval: (0, $a84a41c1040183af$export$defe85febe8b728c).approvalLabel,
        problem: (0, $a84a41c1040183af$export$defe85febe8b728c).problemLabel,
        incident: (0, $a84a41c1040183af$export$defe85febe8b728c).incidentLabel,
        question: (0, $a84a41c1040183af$export$defe85febe8b728c).questionLabel,
        work_item: (0, $a84a41c1040183af$export$defe85febe8b728c).workItemLabel,
        issue: (0, $a84a41c1040183af$export$defe85febe8b728c).issueLabel,
        other: (0, $a84a41c1040183af$export$defe85febe8b728c).workItemLabel
    };
    const label = formatMessage(subtypeMap[subtype?.toLowerCase() ?? 'other'] || (0, $a84a41c1040183af$export$defe85febe8b728c).workItemLabel);
    const headerMetadataParts = [
        label,
        [
            'project',
            workItemProject?.name
        ],
        [
            'last-modified',
            lastModifiedComponent
        ],
        [
            'padlock',
            padlockIcon
        ],
        [
            'status',
            getStatusAndDate()
        ],
        [
            'person',
            getAssigneeOrCreator()
        ]
    ];
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const footerComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
        linkedResults: linkedResults || [],
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data,
        url: url,
        position: position,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        isAllProductSelected: !selectedProduct
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: data.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: (0, $Y34Hw.processExcerpt)(excerpt, true)
        }),
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: data,
        appMode: appMode,
        footer: footerComponent,
        hasRelatedLinks: !!linkedResults && linkedResults.length > 0,
        mainContentWidth: mainContentWidth
    });
};


const $9b59a3205d194c41$export$e84f7c0bef931609 = (props)=>{
    const logException = (0, $f8oYd.useLogException)();
    const { node: node, position: position, thirdPartyConfigs: thirdPartyConfigs } = props;
    // note that `SearchResultGraphDocument` in this fragment isn't a document type from graph, it's the base type!
    // TODO: QS-6952 optIn may not be working, entity.parent is always null
    const data = (0, $irOoi.useFragment)((0, $bc37e735c0a85c0e$export$2e2bcd8739ae039), node);
    let { id: id, providerId: providerId, integrationId: integrationId, connectorType: connectorType } = data;
    const subtype = data?.subtype || null;
    const product = (0, $Y34Hw.get3PProductFromProviderIdOrIntegrationId)({
        thirdPartyConfigs: thirdPartyConfigs,
        providerId: providerId,
        integrationId: integrationId
    });
    const { resourceType: resourceType, resourceId: resourceId } = (0, $k4HRJ.AnyAri).parse(id);
    const metadata = (0, $42omo.useMemo)(()=>{
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: subtype,
            entityType: resourceType,
            contentId: resourceId,
            product: product,
            is3PSmartLink: (0, $kQT7c.isResultSmartLink)({
                connectorType: connectorType,
                resultAri: id,
                productKey: product,
                thirdPartyConfigs: thirdPartyConfigs
            }),
            connectorType: (0, $kQT7c.getResultConnectorSource)({
                connectorType: connectorType,
                resultNodeId: id,
                productKey: product,
                thirdPartyConfigs: thirdPartyConfigs
            })
        };
    }, [
        subtype,
        resourceType,
        resourceId,
        product,
        data.id,
        connectorType,
        id,
        thirdPartyConfigs
    ]);
    const is3PClickIngestionEnabled = (0, $2OtFZ.serve3PClickIngestionExperiment)(thirdPartyConfigs, {
        fireExperimentExposure: false
    });
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position,
        isImpersonated: (0, $Y34Hw.isProductImpersonated)(product, thirdPartyConfigs),
        is3PClickIngestionEnabled: is3PClickIngestionEnabled
    });
    const onResultContextMenu = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position,
        isImpersonated: (0, $Y34Hw.isProductImpersonated)(product, thirdPartyConfigs),
        is3PClickIngestionEnabled: is3PClickIngestionEnabled
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const baseProps = {
        ...props,
        node: data,
        product: product,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        subtype: subtype,
        entityType: resourceType
    };
    const icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $235a70ab221836e5$export$6582c9566971e750), {
        product: product,
        resourceType: resourceType,
        thirdPartyConfigs: thirdPartyConfigs
    });
    try {
        if (!product) throw new Error(`SearchGraphResult: missing product for integrationId=${integrationId} providerId=${providerId}`);
        const SearchGraphRenderer = $9b59a3205d194c41$var$getGraphRenderer(product, resourceType);
        if (!SearchGraphRenderer) throw new Error(`SearchGraphResult: missing renderer for resourceType=${resourceType} product=${product}`);
        return /*#__PURE__*/ (0, $l998X.jsx)(SearchGraphRenderer, {
            ...baseProps,
            product: product,
            icon: icon
        });
    } catch (e) {
        logException(e);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $9a45c40b46beaab7$export$2b64796aabcbabd2), {
            ...baseProps,
            product: product,
            icon: icon
        });
    }
};
const $9b59a3205d194c41$var$getGraphRenderer = (product, resourceType)=>{
    if (product === (0, $1yEFx.ProductKeys3P).JiraDC) return 0, $a81664d8b32e1a9b$export$3464c3355ad3f97e;
    switch(resourceType){
        case (0, $7ZetK.ResourceType).BRANCH:
            return 0, $c04256cd812d51cc$export$e7f66f0a0905935e;
        case (0, $7ZetK.ResourceType).CALENDAR_EVENT:
            return 0, $c25124bad4c60a80$export$aafb10d415667378;
        case (0, $7ZetK.ResourceType).COMMENT:
            return 0, $318bc8ae651e831c$export$9c9dc84757cc5710;
        case (0, $7ZetK.ResourceType).COMMIT:
            return 0, $fc7ae146ec7d2606$export$f8ac23605711b215;
        case (0, $7ZetK.ResourceType).CONVERSATION:
            return 0, $3656b7fd5d879deb$export$73ee84431f6e335a;
        case (0, $7ZetK.ResourceType).CUSTOMER_CONTACT:
            return 0, $19060b73dca5ceaf$export$a3fd078d13d8ac2;
        case (0, $7ZetK.ResourceType).CUSTOMER_ORG:
            return 0, $77eea3dd744c20d3$export$f49280cd3d93cb86;
        case (0, $7ZetK.ResourceType).DEAL:
            return 0, $c295bb43a0a69b45$export$97947ae87dd2d3c0;
        case (0, $7ZetK.ResourceType).DOCUMENT:
            if (product === (0, $1yEFx.ProductKeys3P).ConfluenceDC) return 0, $61cfa2381edf5d9d$export$b773c9cc5f495a3;
            else return 0, $61039992c4292c45$export$d69ae1468ab7f1da;
        case (0, $7ZetK.ResourceType).DESIGN:
            return 0, $116289f16507c09c$export$81afb8005ea84971;
        case (0, $7ZetK.ResourceType).MESSAGE:
            return 0, $1cb6de7b071beecb$export$eb10cea9a7aeba8c;
        case (0, $7ZetK.ResourceType).PULL_REQUEST:
            return 0, $5d482861d79b63c5$export$ff9a66c66b5ab669;
        case (0, $7ZetK.ResourceType).REPOSITORY:
            return 0, $c5ef8720fa5f1985$export$b873936a7a174976;
        case (0, $7ZetK.ResourceType).VIDEO:
            return 0, $3cdba03374a66139$export$77e38f0db0b0632d;
        case (0, $7ZetK.ResourceType).WORK_ITEM:
            return 0, $485beeea42bb88b1$export$d1e5c8cc4a829640;
        case (0, $7ZetK.ResourceType).DASHBOARD:
            return 0, $6bb44605052e87f7$export$5039b6acf48ea77b;
        case (0, $7ZetK.ResourceType).DATA_TABLE:
            return 0, $d3b5e6118cd795f4$export$a2ac0f4098dc2a39;
        case (0, $7ZetK.ResourceType).REMOTE_LINK:
            return 0, $9a45c40b46beaab7$export$2b64796aabcbabd2;
        // Remote link intentionally uses the default renderer
        default:
            return null;
    }
};
const $9b59a3205d194c41$export$48471e9a17c64a92 = (node)=>{
    return node?.__typename === 'SearchResultGraphDocument';
};





/**
 * @generated SignedSource<<8b71a29d0afed6a4dd20046ecf39226a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7f16476ffb9e4f90$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchJiraBoard_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "kind": "ScalarField",
                "name": "url"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "description"
            },
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            v0 /*: any*/ ,
            {
                "concreteType": "JiraBoard",
                "kind": "LinkedField",
                "name": "board",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "boardFrontendUrl"
                    }
                ]
            }
        ],
        "type": "SearchResultJiraBoard"
    };
}();
$7f16476ffb9e4f90$var$node.hash = "4bd8e621e374695ab53532c4f4d11d01";
var $7f16476ffb9e4f90$export$2e2bcd8739ae039 = $7f16476ffb9e4f90$var$node;
















































const $ef85b0f97f42606b$export$4d44dfc3b1a588bc = ({ node: node, position: position, cloudId: cloudId, searchQuery: searchQuery, searchSessionId: searchSessionId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $7f16476ffb9e4f90$export$2e2bcd8739ae039), node);
    const logException = (0, $f8oYd.useLogException)();
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const url = (0, $42omo.useMemo)(()=>{
        const notDummyBoardUrl = (0, $1XDdH.isDummyBoardUrl)(data.url) ? undefined : data.url;
        const boardUrl = data.board?.boardFrontendUrl || notDummyBoardUrl;
        return boardUrl ? (0, $icWhS.getJiraUrlWithAnalyticsQueryParams)({
            url: boardUrl,
            searchSessionId: searchSessionId,
            resultId: data.id
        }) : '';
    }, [
        data.url,
        data.id,
        data.board,
        searchSessionId
    ]);
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(data.title, searchQuery.split(' '));
        return !highlightedTitle ? data.title : (0, $Y34Hw.enrichExcerpt)(highlightedTitle);
    }, [
        data.title,
        searchQuery
    ]);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        const reducedDescription = (0, $92zSJ.getSummarizedAdfContent)(data.description, searchQuery);
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(reducedDescription, searchQuery.split(' '));
        if (!highlightedTitle) return reducedDescription;
        return (0, $Y34Hw.processExcerpt)(highlightedTitle);
    }, [
        data.description,
        searchQuery
    ]);
    const metadataParts = (0, $42omo.useMemo)(()=>{
        const parts = [
            [
                'type',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                    type: data.type
                })
            ],
            [
                'lastModified',
                data.lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                    lastModified: data.lastModifiedDate
                }) : null
            ]
        ];
        return parts.filter(Boolean);
    }, [
        data.type,
        data.lastModifiedDate
    ]);
    // Don't render anything if there's no URL
    if (!url) {
        logException(new Error(String(`Jira Board search result has no URL. Result ID: ${data.id}`)));
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {});
    }
    const iconUrl = data.board?.iconUrl || data.iconUrl;
    const icon = (0, $2waBy.getJiraEntityIcon)({
        iconUrl: iconUrl,
        type: data.type,
        isIssue: false,
        size: 'medium'
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Jira,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        icon: icon,
        title: enrichedTitle,
        headerMetadataParts: metadataParts,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: enrichedDescription
        }),
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $ef85b0f97f42606b$export$1ac32d77bb207897 = (node)=>{
    return node?.__typename === 'SearchResultJiraBoard';
};





/**
 * @generated SignedSource<<a2481ff566980266972bdeb96efb87f8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $daf59631fbe551ff$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "searchJiraDashboard_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "ScalarField",
            "name": "lastModifiedDate"
        },
        {
            "kind": "ScalarField",
            "name": "iconUrl"
        }
    ],
    "type": "SearchResultJiraDashboard"
};
$daf59631fbe551ff$var$node.hash = "165d504f5f9abf8bec64d659ff7dcd0c";
var $daf59631fbe551ff$export$2e2bcd8739ae039 = $daf59631fbe551ff$var$node;










































const $87cf4eaba3a575c0$export$a5c532a12af1d7c8 = ({ node: node, position: position, cloudId: cloudId, searchQuery: searchQuery, searchSessionId: searchSessionId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $daf59631fbe551ff$export$2e2bcd8739ae039), node);
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const url = (0, $42omo.useMemo)(()=>{
        return (0, $icWhS.getJiraUrlWithAnalyticsQueryParams)({
            url: data.url,
            searchSessionId: searchSessionId,
            resultId: data.id
        });
    }, [
        data.url,
        data.id,
        searchSessionId
    ]);
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(data.title, searchQuery.split(' '));
        return !highlightedTitle ? data.title : (0, $Y34Hw.enrichExcerpt)(highlightedTitle);
    }, [
        data.title,
        searchQuery
    ]);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        const reducedDescription = (0, $92zSJ.getSummarizedAdfContent)(data.description, searchQuery);
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(reducedDescription, searchQuery.split(' '));
        if (!highlightedTitle) return reducedDescription;
        return (0, $Y34Hw.processExcerpt)(highlightedTitle);
    }, [
        data.description,
        searchQuery
    ]);
    const metadataParts = (0, $42omo.useMemo)(()=>{
        const parts = [
            [
                'type',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                    type: data.type
                })
            ],
            [
                'lastModified',
                data.lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                    lastModified: data.lastModifiedDate
                }) : null
            ]
        ];
        return parts.filter(Boolean);
    }, [
        data.type,
        data.lastModifiedDate
    ]);
    const icon = (0, $2waBy.getJiraEntityIcon)({
        iconUrl: data.iconUrl,
        type: data.type,
        isIssue: false,
        size: 'medium'
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Jira,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        icon: icon,
        title: enrichedTitle,
        headerMetadataParts: metadataParts,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: enrichedDescription
        }),
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $87cf4eaba3a575c0$export$8fd9ffc22de770d9 = (node)=>{
    return node?.__typename === 'SearchResultJiraDashboard';
};





/**
 * @generated SignedSource<<0a3d74256b9c7eab2ae8b49a3d6f16b9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7a7ba6d5984cc500$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "searchJiraFilter_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "ScalarField",
            "name": "lastModifiedDate"
        },
        {
            "kind": "ScalarField",
            "name": "iconUrl"
        }
    ],
    "type": "SearchResultJiraFilter"
};
$7a7ba6d5984cc500$var$node.hash = "16cb9379c0ec44d660de2e7ef7b7d063";
var $7a7ba6d5984cc500$export$2e2bcd8739ae039 = $7a7ba6d5984cc500$var$node;










































const $4fc71968c4272f25$export$7c35d70259168995 = ({ node: node, position: position, cloudId: cloudId, searchQuery: searchQuery, searchSessionId: searchSessionId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $7a7ba6d5984cc500$export$2e2bcd8739ae039), node);
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const url = (0, $42omo.useMemo)(()=>{
        return (0, $icWhS.getJiraUrlWithAnalyticsQueryParams)({
            url: data.url,
            searchSessionId: searchSessionId,
            resultId: data.id
        });
    }, [
        data.url,
        data.id,
        searchSessionId
    ]);
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(data.title, searchQuery.split(' '));
        return !highlightedTitle ? data.title : (0, $Y34Hw.enrichExcerpt)(highlightedTitle);
    }, [
        data.title,
        searchQuery
    ]);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        const reducedDescription = (0, $92zSJ.getSummarizedAdfContent)(data.description, searchQuery);
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(reducedDescription, searchQuery.split(' '));
        if (!highlightedTitle) return reducedDescription;
        return (0, $Y34Hw.processExcerpt)(highlightedTitle);
    }, [
        data.description,
        searchQuery
    ]);
    const metadataParts = (0, $42omo.useMemo)(()=>{
        const parts = [
            [
                'type',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                    type: data.type
                })
            ],
            [
                'lastModified',
                data.lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                    lastModified: data.lastModifiedDate
                }) : null
            ]
        ];
        return parts.filter(Boolean);
    }, [
        data.type,
        data.lastModifiedDate
    ]);
    const icon = (0, $2waBy.getJiraEntityIcon)({
        iconUrl: data.iconUrl,
        type: data.type,
        isIssue: false,
        size: 'medium'
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Jira,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        icon: icon,
        title: enrichedTitle,
        headerMetadataParts: metadataParts,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: enrichedDescription
        }),
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $4fc71968c4272f25$export$f78f5f7633f09cb5 = (node)=>{
    return node?.__typename === 'SearchResultJiraFilter';
};





/**
 * @generated SignedSource<<a6ca37491701dade684b4bab24882078>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f1a2103d173cf5d0$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "title"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = {
        "kind": "ScalarField",
        "name": "description"
    }, v4 = {
        "kind": "ScalarField",
        "name": "url"
    }, v5 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeAssigneeField"
            }
        ],
        "kind": "Fragment",
        "name": "searchJiraIssue_AtlassianSearchPage",
        "selections": [
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            v4 /*: any*/ ,
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "iconUrl"
            },
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "issueTypeAvatarUrl"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "webUrl"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "ids",
                                "value": [
                                    "project"
                                ]
                            }
                        ],
                        "concreteType": "JiraIssueFieldConnection",
                        "kind": "LinkedField",
                        "name": "fieldsById",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v6 /*: any*/ ,
                                            v7 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraProject",
                                                        "kind": "LinkedField",
                                                        "name": "project",
                                                        "plural": false,
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            v7 /*: any*/ 
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraProjectField"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "fieldsById(ids:[\"project\"])"
                    },
                    {
                        "condition": "includeAssigneeField",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraSingleSelectUserPickerField",
                                "kind": "LinkedField",
                                "name": "assigneeField",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                            v7 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "picture"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            v6 /*: any*/ ,
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    v4 /*: any*/ ,
                    v2 /*: any*/ ,
                    v3 /*: any*/ ,
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultJiraIssue"
    };
}();
$f1a2103d173cf5d0$var$node.hash = "44b7e703c3b69092bb679318aae00b74";
var $f1a2103d173cf5d0$export$2e2bcd8739ae039 = $f1a2103d173cf5d0$var$node;






















































parcelRequire("42omo");









const $d21ac91210a9e9f3$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'inline-block',
    maxWidth: '215px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $d21ac91210a9e9f3$export$47d2cbdccded0b18 = ({ projectName: projectName })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: projectName,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $d21ac91210a9e9f3$var$containerStyles,
                testId: "project-metadata",
                ...tooltipProps,
                children: projectName
            })
    });
};


const $73404969990abf67$export$26ac3e97753acb0e = ({ node: node, position: position, cloudId: cloudId, searchQuery: searchQuery, searchSessionId: searchSessionId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, jiraIssueStatus: jiraIssueStatus, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $f1a2103d173cf5d0$export$2e2bcd8739ae039), node);
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const projectField = (0, $42omo.useMemo)(()=>{
        if (!data.issue?.fieldsById?.edges) return;
        const fields = data?.issue?.fieldsById?.edges ?? [];
        for (const field of fields){
            if (field && field.node?.__typename === 'JiraProjectField' && field.node?.name === 'Project') return field.node;
        }
    }, [
        data.issue?.fieldsById?.edges
    ]);
    const projectName = projectField?.project?.name || '';
    const projectId = projectField?.project?.id;
    const url = (0, $42omo.useMemo)(()=>{
        const url = data.issue?.webUrl || data.url;
        return (0, $icWhS.getJiraUrlWithAnalyticsQueryParams)({
            url: url,
            searchSessionId: searchSessionId,
            resultId: data.id,
            projectId: projectId
        });
    }, [
        data.issue?.webUrl,
        data.url,
        data.id,
        searchSessionId,
        projectId
    ]);
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        return $73404969990abf67$export$b44712184b11a06(searchQuery, data.title, data.issue?.key);
    }, [
        data.title,
        data.issue?.key,
        searchQuery
    ]);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        return (0, $Y34Hw.processExcerpt)(data.description);
    }, [
        data.description
    ]);
    const metadataParts = (0, $42omo.useMemo)(()=>{
        const parts = [
            [
                'type',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                    type: data.type
                })
            ],
            projectName ? [
                'project',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $d21ac91210a9e9f3$export$47d2cbdccded0b18), {
                    projectName: projectName
                })
            ] : null,
            [
                'lastModified',
                data.lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                    lastModified: data.lastModifiedDate
                }) : null
            ],
            [
                'assignee',
                (0, $dh538.fg)('rovo_search_assignee_field_fps') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $157d4b2b9c0ccedc$export$361f73eba39649ac), {
                    user: data.issue?.assigneeField?.user ? {
                        name: data.issue.assigneeField.user.name,
                        picture: data.issue.assigneeField.user.picture
                    } : null
                }) : null
            ]
        ];
        return parts.filter(Boolean);
    }, [
        data.type,
        data.lastModifiedDate,
        projectName,
        data.issue?.assigneeField?.user
    ]);
    const titleMetadataParts = (0, $42omo.useMemo)(()=>{
        const status = jiraIssueStatus !== null && (0, $aKt88.getStatus)(jiraIssueStatus?.statusName, jiraIssueStatus?.colorName, !jiraIssueStatus);
        return status ? [
            [
                'status',
                status
            ]
        ] : [];
    }, [
        jiraIssueStatus
    ]);
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const extractedLinksFromText = (0, $514d99dea8b7ae4b$export$a414b3d5a172e15b)(data.description);
    const hasExtractedLinks = extractedLinksFromText && extractedLinksFromText.length > 0;
    const hasRelatedLinks = linkedResults && linkedResults.length > 0 || hasExtractedLinks;
    const icon = (0, $2waBy.getJiraEntityIcon)({
        iconUrl: data.iconUrl || data.issue?.issueTypeAvatarUrl,
        type: data.type,
        isIssue: true,
        size: 'medium'
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Jira,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        icon: icon,
        title: enrichedTitle,
        headerMetadataParts: metadataParts,
        titleMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $a7nUd.SearchMetadata), {
            parts: titleMetadataParts
        }),
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: enrichedDescription
        }),
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        hasRelatedLinks: hasRelatedLinks,
        footer: /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$695e5a3ae2478b3), {
            linkedResults: linkedResults || [],
            thirdPartyConfigs: thirdPartyConfigs,
            partial: data,
            url: url,
            position: position,
            onResultClicked: onResultClicked,
            onResultContextMenu: onResultCtxMenuClicked,
            isAllProductSelected: !selectedProduct
        }),
        mainContentWidth: mainContentWidth
    });
};
const $73404969990abf67$export$b9491ee18011db60 = (node)=>{
    return node?.__typename === 'SearchResultJiraIssue';
};
const $73404969990abf67$export$b44712184b11a06 = (searchQuery, title, issueKey)=>{
    const enrichedTitle = (0, $Y34Hw.enrichExcerpt)(title);
    // If there is no issueKey or the issue key is already prefixed, simply return the title
    if (!issueKey || title.startsWith(issueKey)) return enrichedTitle;
    // If the issueKey exists in its entirety in the searchQuery, highlight and prefix it
    if (searchQuery.split(' ').includes(issueKey)) {
        const { highlightedTitle: highlightedIssueKey } = (0, $bloXB.highlightMatchedText)(issueKey, searchQuery.split(' '));
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                (0, $Y34Hw.enrichExcerpt)(highlightedIssueKey),
                ": ",
                enrichedTitle
            ]
        });
    }
    // Otherwise, return the issue key unhighlighted and prefixed
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            issueKey,
            ": ",
            enrichedTitle
        ]
    });
};





/**
 * @generated SignedSource<<20fa186d666a35c57352c905e6537898>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $25c9bd63bbe470d0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "searchJiraPlan_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "ScalarField",
            "name": "lastModifiedDate"
        },
        {
            "kind": "ScalarField",
            "name": "iconUrl"
        }
    ],
    "type": "SearchResultJiraPlan"
};
$25c9bd63bbe470d0$var$node.hash = "f4e7bb97d2f9944eea527780c5518350";
var $25c9bd63bbe470d0$export$2e2bcd8739ae039 = $25c9bd63bbe470d0$var$node;










































const $480180c1ff14c088$export$24f204fc253b9cb5 = ({ node: node, position: position, cloudId: cloudId, searchQuery: searchQuery, searchSessionId: searchSessionId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $25c9bd63bbe470d0$export$2e2bcd8739ae039), node);
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const url = (0, $42omo.useMemo)(()=>{
        return (0, $icWhS.getJiraUrlWithAnalyticsQueryParams)({
            url: data.url,
            searchSessionId: searchSessionId,
            resultId: data.id
        });
    }, [
        data.url,
        data.id,
        searchSessionId
    ]);
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(data.title, searchQuery.split(' '));
        return !highlightedTitle ? data.title : (0, $Y34Hw.enrichExcerpt)(highlightedTitle);
    }, [
        data.title,
        searchQuery
    ]);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        const reducedDescription = (0, $92zSJ.getSummarizedAdfContent)(data.description, searchQuery);
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(reducedDescription, searchQuery.split(' '));
        if (!highlightedTitle) return reducedDescription;
        return (0, $Y34Hw.processExcerpt)(highlightedTitle);
    }, [
        data.description,
        searchQuery
    ]);
    const metadataParts = (0, $42omo.useMemo)(()=>{
        const parts = [
            [
                'type',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                    type: data.type
                })
            ],
            [
                'lastModified',
                data.lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                    lastModified: data.lastModifiedDate
                }) : null
            ]
        ];
        return parts.filter(Boolean);
    }, [
        data.type,
        data.lastModifiedDate
    ]);
    const icon = (0, $2waBy.getJiraEntityIcon)({
        iconUrl: data.iconUrl,
        type: data.type,
        isIssue: false,
        size: 'medium'
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Jira,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        icon: icon,
        title: enrichedTitle,
        headerMetadataParts: metadataParts,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: enrichedDescription
        }),
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $480180c1ff14c088$export$6566c83063a7eefb = (node)=>{
    return node?.__typename === 'SearchResultJiraPlan';
};





/**
 * @generated SignedSource<<17bd9a55590f8f15e05ca051dae38c79>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a232b7a197706ce7$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "tenantId"
        }
    ],
    "kind": "Fragment",
    "name": "searchJiraProject_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "ScalarField",
            "name": "projectKey"
        },
        {
            "kind": "ScalarField",
            "name": "lastModifiedDate"
        },
        {
            "kind": "ScalarField",
            "name": "iconUrl"
        },
        {
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "webUrl"
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "tenantId",
                    "variableName": "tenantId"
                }
            ],
            "concreteType": "SocialSignalSearch",
            "kind": "LinkedField",
            "name": "socialSignal",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "signal"
                },
                {
                    "kind": "ScalarField",
                    "name": "timestamp"
                },
                {
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "picture"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "email"
                                },
                                {
                                    "concreteType": "AtlassianAccountUserExtendedProfile",
                                    "kind": "LinkedField",
                                    "name": "extendedProfile",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "jobTitle"
                                        }
                                    ]
                                }
                            ],
                            "type": "AtlassianAccountUser"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "SearchResultJiraProject"
};
$a232b7a197706ce7$var$node.hash = "b446c599fd11e1752c10a1bb61e41699";
var $a232b7a197706ce7$export$2e2bcd8739ae039 = $a232b7a197706ce7$var$node;




















































const $31e547389e3910c7$export$14e63e5586bfae9b = ({ node: node, position: position, cloudId: cloudId, searchQuery: searchQuery, searchSessionId: searchSessionId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $a232b7a197706ce7$export$2e2bcd8739ae039), node);
    const { commonAttributes: commonAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const url = (0, $42omo.useMemo)(()=>{
        const initialResultUrl = data.project?.webUrl || data.url;
        return (0, $icWhS.getJiraUrlWithAnalyticsQueryParams)({
            url: initialResultUrl,
            searchSessionId: searchSessionId,
            resultId: data.id
        });
    }, [
        data.project?.webUrl,
        data.url,
        data.id,
        searchSessionId
    ]);
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        const prefix = data.projectKey;
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(data.title, searchQuery.split(' '));
        if (prefix && !(highlightedTitle?.startsWith(prefix) || data.title.startsWith(prefix))) return !highlightedTitle ? prefix.concat(': ', data.title) : (0, $Y34Hw.enrichExcerpt)(prefix.concat(': ', highlightedTitle));
        return !highlightedTitle ? data.title : (0, $Y34Hw.enrichExcerpt)(highlightedTitle);
    }, [
        data.title,
        data.projectKey,
        searchQuery
    ]);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        const reducedDescription = (0, $92zSJ.getSummarizedAdfContent)(data.description, searchQuery);
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(reducedDescription, searchQuery.split(' '));
        if (!highlightedTitle) return reducedDescription;
        return (0, $Y34Hw.processExcerpt)(highlightedTitle);
    }, [
        data.description,
        searchQuery
    ]);
    const metadataParts = (0, $42omo.useMemo)(()=>{
        const parts = [
            [
                'type',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                    type: (0, $Y34Hw.getJiraSearchResultTypeMetadata)(data.type)
                })
            ],
            [
                'lastModified',
                data.lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                    lastModified: data.lastModifiedDate
                }) : null
            ]
        ];
        if (appMode === (0, $9vOy1.ApplicationModes).Rovo && data.socialSignal?.user?.email && (0, $dh538.fg)('search-plex-jira-social-signal')) {
            const { user: user, signal: signal, timestamp: timestamp } = data.socialSignal;
            parts.push([
                'social-signal',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $e46c71a22c4ed891$export$229f0558b2da716c), {
                    userAccountId: user.accountId,
                    userName: user.name,
                    userEmail: data.socialSignal?.user?.email,
                    userPicture: user.picture,
                    userJobTitle: user.extendedProfile?.jobTitle,
                    signal: signal,
                    timestamp: timestamp,
                    commonAttributes: commonAttributes
                })
            ]);
        }
        return parts.filter(Boolean);
    }, [
        data.socialSignal,
        data.type,
        data.lastModifiedDate,
        appMode,
        commonAttributes
    ]);
    const icon = (0, $2waBy.getJiraEntityIcon)({
        iconUrl: data.iconUrl,
        type: data.type,
        isIssue: false,
        size: 'medium'
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Jira,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        icon: icon,
        title: enrichedTitle,
        headerMetadataParts: metadataParts,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: enrichedDescription
        }),
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $31e547389e3910c7$export$79503cf2fe431c3a = (node)=>{
    return node?.__typename === 'SearchResultJiraProject';
};





/**
 * @generated SignedSource<<a34395a1e28287d1d47923064f326a31>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $87a98fce03786246$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchMercuryFocusArea_AtlassianSearchPage",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "searchMercuryFocusAreaStatusTargetDate_AtlassianSearchPage"
            },
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "url"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "lastModifiedDate"
                    },
                    {
                        "concreteType": "MercuryFocusArea",
                        "kind": "LinkedField",
                        "name": "focusArea",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            v1 /*: any*/ ,
                            {
                                "concreteType": "MercuryFocusAreaType",
                                "kind": "LinkedField",
                                "name": "focusAreaType",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v1 /*: any*/ 
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "name": "owner",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "type": "SearchResultMercuryFocusArea"
            }
        ],
        "type": "SearchResult",
        "abstractKey": "__isSearchResult"
    };
}();
$87a98fce03786246$var$node.hash = "c84e3881069f1be8f1f3244bc1c9630e";
var $87a98fce03786246$export$2e2bcd8739ae039 = $87a98fce03786246$var$node;







































/**
 * @generated SignedSource<<e29fafe795e88bdc8d1297b04e165506>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9cc83d995e39230c$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "key"
    }, v1 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchMercuryFocusAreaStatusTargetDate_AtlassianSearchPage",
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "MercuryFocusArea",
                        "kind": "LinkedField",
                        "name": "focusArea",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "MercuryFocusAreaStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v1 /*: any*/ 
                                ]
                            },
                            {
                                "concreteType": "MercuryFocusAreaHealth",
                                "kind": "LinkedField",
                                "name": "health",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "color"
                                    },
                                    v1 /*: any*/ 
                                ]
                            },
                            {
                                "concreteType": "MercuryTargetDate",
                                "kind": "LinkedField",
                                "name": "targetDate",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "targetDate"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "targetDateType"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "SearchResultMercuryFocusArea"
            }
        ],
        "type": "SearchResult",
        "abstractKey": "__isSearchResult"
    };
}();
$9cc83d995e39230c$var$node.hash = "1ba6f6deb1ce6324e34fc596e49e59a6";
var $9cc83d995e39230c$export$2e2bcd8739ae039 = $9cc83d995e39230c$var$node;


parcelRequire("42omo");


var $cFEpk = parcelRequire("cFEpk");





















const $0d5628fa3bc0d007$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    for: {
        id: "search-page.mercury.target-date.for",
        defaultMessage: "for"
    }
});




















const $96a738ca6fc4ac74$var$getStatusApperanceFromKey = (key)=>{
    switch(key){
        case 'off_track':
        case 'red':
            return 'removed';
        case 'at_risk':
        case 'yellow':
            return 'moved';
        case 'on_track':
        case 'green':
            return 'success';
        case 'completed':
        case 'paused':
        case 'pending':
        default:
            return 'default';
    }
};
const $96a738ca6fc4ac74$export$1da174cfafc04271 = ({ healthColor: healthColor, healthDisplayName: healthDisplayName, healthKey: healthKey, statusDisplayName: statusDisplayName, statusKey: statusKey })=>{
    const displayedStatus = statusKey === 'in_progress' ? healthDisplayName : statusDisplayName;
    const displayedStatusAppearance = $96a738ca6fc4ac74$var$getStatusApperanceFromKey(healthColor?.toLowerCase() || healthKey || statusKey);
    return {
        displayedStatus: displayedStatus,
        displayedStatusAppearance: displayedStatusAppearance
    };
};
const $96a738ca6fc4ac74$var$DEFAULT_DATE_FNS_OPTIONS = {
    weekStartsOn: 1
};
// Wrap a date-fns method with default options param
// eslint-disable-next-line no-unused-vars
/* eslint-disable-next-line  @typescript-eslint/no-explicit-any */ const $96a738ca6fc4ac74$var$mixinDefaultOptions = (fn)=>{
    /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */ return function(...theArgs) {
        const lastIndex = fn.length - 1;
        if (fn.length === theArgs.length) theArgs[lastIndex] = {
            ...$96a738ca6fc4ac74$var$DEFAULT_DATE_FNS_OPTIONS,
            ...theArgs[lastIndex]
        };
        else theArgs[lastIndex] = $96a738ca6fc4ac74$var$DEFAULT_DATE_FNS_OPTIONS;
        return fn.apply(this, theArgs);
    };
};
const $96a738ca6fc4ac74$var$SAME_YEAR_FORMAT = 'd MMM';
const $96a738ca6fc4ac74$var$DIFF_YEAR_FORMAT = 'd MMM yyyy';
const $96a738ca6fc4ac74$var$MONTH_ONLY_FORMAT = 'MMMM';
const $96a738ca6fc4ac74$var$MONTH_ONLY_FORMAT_SHORT = 'MMM';
const $96a738ca6fc4ac74$var$MONTH_ONLY_FORMAT_DIFF_YEAR = 'MMM yyyy';
const $96a738ca6fc4ac74$var$format = $96a738ca6fc4ac74$var$mixinDefaultOptions((0, $dWCFT.default));
const $96a738ca6fc4ac74$var$NonMemoFocusAreaTargetDate = ({ targetDate: targetDate, targetDateType: targetDateType })=>{
    const date = (0, $3Vbz9.toDate)(targetDate);
    let displayedTargetDate = '';
    if (targetDateType === 'DAY') displayedTargetDate = $96a738ca6fc4ac74$var$format(date, (0, $9tcaE.default)(date) ? $96a738ca6fc4ac74$var$SAME_YEAR_FORMAT : $96a738ca6fc4ac74$var$DIFF_YEAR_FORMAT);
    else if (targetDateType === 'MONTH') displayedTargetDate = $96a738ca6fc4ac74$var$format(date, (0, $9tcaE.default)(date) ? $96a738ca6fc4ac74$var$MONTH_ONLY_FORMAT : $96a738ca6fc4ac74$var$MONTH_ONLY_FORMAT_DIFF_YEAR);
    else if (targetDateType === 'QUARTER') displayedTargetDate = `${$96a738ca6fc4ac74$var$format((0, $cPLkE.default)(date), $96a738ca6fc4ac74$var$MONTH_ONLY_FORMAT_SHORT)}-${$96a738ca6fc4ac74$var$format((0, $5eayg.default)(date), (0, $9tcaE.default)(date) ? $96a738ca6fc4ac74$var$MONTH_ONLY_FORMAT_SHORT : $96a738ca6fc4ac74$var$MONTH_ONLY_FORMAT_DIFF_YEAR)}`;
    return displayedTargetDate;
};
const $96a738ca6fc4ac74$export$972b78877af3c6e6 = /*#__PURE__*/ (0, $42omo.memo)($96a738ca6fc4ac74$var$NonMemoFocusAreaTargetDate);


const $66ef7a52ea37745e$export$bb82a6046bad0cd0 = ({ node: node })=>{
    const data = (0, $irOoi.useFragment)((0, $9cc83d995e39230c$export$2e2bcd8739ae039), node);
    const { displayedStatus: displayedStatus, displayedStatusAppearance: displayedStatusAppearance } = (0, $96a738ca6fc4ac74$export$1da174cfafc04271)({
        healthColor: data.focusArea?.health?.color,
        statusKey: data.focusArea?.status?.key,
        statusDisplayName: data.focusArea?.status?.displayName,
        healthDisplayName: data.focusArea?.health?.displayName,
        healthKey: data.focusArea?.health?.key
    });
    if (!displayedStatus) return null;
    const targetDate = data.focusArea?.targetDate?.targetDate;
    const targetDateType = data.focusArea?.targetDate?.targetDateType;
    const displayedTargetDate = targetDate && targetDateType && (0, $cFEpk.default)(new Date(targetDate)) && /*#__PURE__*/ (0, $l998X.jsx)((0, $96a738ca6fc4ac74$export$972b78877af3c6e6), {
        targetDate: targetDate,
        targetDateType: targetDateType
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $66ef7a52ea37745e$var$statusAndTargetDateXcss,
        testId: "search-mercury-focus-area-status-target-date",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                appearance: displayedStatusAppearance,
                children: displayedStatus
            }),
            displayedTargetDate && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    ' ',
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $66ef7a52ea37745e$var$targetDateForXcss,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $0d5628fa3bc0d007$export$defe85febe8b728c).for
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                            alignBlock: "center",
                            space: "space.050",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $01817a1a99cb392d$export$72cad736eff3158c), {}),
                                " ",
                                displayedTargetDate
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
const $66ef7a52ea37745e$var$statusAndTargetDateXcss = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.100'
});
const $66ef7a52ea37745e$var$targetDateForXcss = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtlest'
});


const $1f5c3a9997a89a12$export$462e5965a804bcf5 = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $87a98fce03786246$export$2e2bcd8739ae039), node);
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const title = (0, $42omo.useMemo)(()=>(0, $Y34Hw.enrichExcerpt)(data.title), [
        data.title
    ]);
    const headerMetadataParts = (0, $42omo.useMemo)(()=>[
            [
                'type',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                        type: data.type
                    })
                })
            ],
            [
                'focusAreaType',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    children: data.focusArea?.focusAreaType?.name
                })
            ],
            data.focusArea?.owner?.name ? [
                'owner',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    children: data.focusArea?.owner?.name
                })
            ] : null,
            [
                'last-modified',
                data.lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                        lastModified: data.lastModifiedDate
                    })
                }) : null
            ]
        ], [
        data.type,
        data.focusArea?.focusAreaType?.name,
        data.focusArea?.owner?.name,
        data.lastModifiedDate
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Focus,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: data.url,
        title: title,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.FocusIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        headerMetadataParts: headerMetadataParts,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $66ef7a52ea37745e$export$bb82a6046bad0cd0), {
            node: data
        }),
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $1f5c3a9997a89a12$export$9bcd0683f048ca39 = (node)=>{
    return node?.id?.includes('mercury') && node.__typename === 'SearchResultMercuryFocusArea';
};





/**
 * @generated SignedSource<<0821493078e9985d3b78726efa9086f4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d56ee89a36058074$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "searchMercuryFocusAreaUpdate_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "lastModifiedDate"
                },
                {
                    "concreteType": "MercuryFocusArea",
                    "kind": "LinkedField",
                    "name": "focusArea",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ],
            "type": "SearchResultMercuryFocusAreaStatusUpdate"
        }
    ],
    "type": "SearchResult",
    "abstractKey": "__isSearchResult"
};
$d56ee89a36058074$var$node.hash = "4bedbd663322481df5ab3989c8b87c7c";
var $d56ee89a36058074$export$2e2bcd8739ae039 = $d56ee89a36058074$var$node;










































const $addc29d84a174886$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    statusUpdateTitle: {
        id: "search-page.mercury.focus-area-update.title",
        defaultMessage: "Update for {focusAreaName}"
    }
});


const $aa67e67612c8c517$export$e299cc210f856d0f = ({ node: node, position: position, cloudId: cloudId, searchQuery: searchQuery, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $d56ee89a36058074$export$2e2bcd8739ae039), node);
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const description = (0, $42omo.useMemo)(()=>(0, $92zSJ.getSummarizedAdfContent)(data.description, searchQuery), [
        data.description,
        searchQuery
    ]);
    const headerMetadataParts = (0, $42omo.useMemo)(()=>[
            [
                'type',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                        type: data.type
                    })
                })
            ],
            [
                'last-modified',
                data.lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                        lastModified: data.lastModifiedDate
                    })
                }) : null
            ]
        ], [
        data.type,
        data.lastModifiedDate
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Focus,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: data.url,
        title: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $addc29d84a174886$export$defe85febe8b728c).statusUpdateTitle,
            values: {
                focusAreaName: data.focusArea?.name
            }
        }),
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.FocusIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        headerMetadataParts: headerMetadataParts,
        description: description,
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $aa67e67612c8c517$export$25e56f07edb2e8ac = (node)=>{
    return node?.id?.includes('mercury') && node?.__typename === 'SearchResultMercuryFocusAreaStatusUpdate';
};





/**
 * @generated SignedSource<<809f611d322bd04212871ece6796e565>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c7009a8f44c0d712$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "searchPassionfruitAsk_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "lastModifiedDate"
                }
            ],
            "type": "SearchResultSpfAsk"
        }
    ],
    "type": "SearchResult",
    "abstractKey": "__isSearchResult"
};
$c7009a8f44c0d712$var$node.hash = "ea340fd7f547a65a392f6cf1d36ac266";
var $c7009a8f44c0d712$export$2e2bcd8739ae039 = $c7009a8f44c0d712$var$node;











































const $e1e365f93a6cb640$export$c92f93b41e432091 = ({ node: node, position: position, cloudId: cloudId, searchQuery: searchQuery, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode })=>{
    const data = (0, $irOoi.useFragment)((0, $c7009a8f44c0d712$export$2e2bcd8739ae039), node);
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        const reducedDescription = (0, $bOpS4.truncateTextWithQuery)(data.description, searchQuery);
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(reducedDescription, searchQuery.split(' '));
        if (!highlightedTitle) return reducedDescription;
        return (0, $Y34Hw.processExcerpt)(highlightedTitle);
    }, [
        data.description,
        searchQuery
    ]);
    const title = (0, $42omo.useMemo)(()=>(0, $Y34Hw.enrichExcerpt)(data.title), [
        data.title
    ]);
    const headerMetadataParts = [
        [
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                    type: data.type
                })
            })
        ],
        [
            'last-modified',
            data.lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                    lastModified: data.lastModifiedDate
                })
            }) : null
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Focus,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: data.url,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.FocusIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        title: title,
        headerMetadataParts: headerMetadataParts,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: enrichedDescription
        }),
        cloudId: cloudId,
        position: position,
        appMode: appMode
    });
};
const $e1e365f93a6cb640$export$29b4f3dd85087f82 = (node)=>{
    return node.__typename === 'SearchResultSpfAsk';
};





/**
 * @generated SignedSource<<c1dee5fbe01cb6faeffa357613df464e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2cea3badc71cab2b$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchTalentPosition_AtlassianSearchPage",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "url"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "RadarPosition",
                        "kind": "LinkedField",
                        "name": "position",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "concreteType": "RadarWorker",
                                "kind": "LinkedField",
                                "name": "worker",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "preferredName"
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "picture"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "fieldIdIsIn",
                                        "value": [
                                            "positionId",
                                            "positionStatus",
                                            "positionJobTitle",
                                            "positionPositionTitle",
                                            "positionKey",
                                            "positionExternalPositionKey",
                                            "positionWorker",
                                            "focusArea"
                                        ]
                                    }
                                ],
                                "concreteType": "RadarFieldValueIdPair",
                                "kind": "LinkedField",
                                "name": "fieldValues",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "fieldId"
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "name": "fieldValue",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "alias": "stringValue",
                                                        "kind": "ScalarField",
                                                        "name": "value"
                                                    }
                                                ],
                                                "type": "RadarStringFieldValue"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "value",
                                                        "plural": false,
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "FragmentSpread",
                                                                        "name": "positionFocusArea_AtlassianSearchPage"
                                                                    }
                                                                ],
                                                                "type": "MercuryFocusArea"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "RadarAriFieldValue"
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "fieldValues(fieldIdIsIn:[\"positionId\",\"positionStatus\",\"positionJobTitle\",\"positionPositionTitle\",\"positionKey\",\"positionExternalPositionKey\",\"positionWorker\",\"focusArea\"])"
                            }
                        ]
                    }
                ],
                "type": "SearchResultTalentPosition"
            }
        ],
        "type": "SearchResult",
        "abstractKey": "__isSearchResult"
    };
}();
$2cea3badc71cab2b$var$node.hash = "4b2c420e8a8fe59c29a7e5a6a9af5ed0";
var $2cea3badc71cab2b$export$2e2bcd8739ae039 = $2cea3badc71cab2b$var$node;



























var $cWRpe = parcelRequire("cWRpe");













const $0de0787fb1ebae17$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    positionExternalKey: {
        id: "search_talent_position.external_position_key",
        defaultMessage: "External key {positionExternalKey}"
    },
    positionTitle: {
        id: "search_talent_position.position_title",
        defaultMessage: "{preferredName, select, undefined {{positionKey}} other {{positionKey}: {preferredName}}}"
    }
});





/**
 * @generated SignedSource<<1ee831b5c7aaf0d41e07a043b7c1345f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e52f8f55460571a7$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "key"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "positionFocusArea_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "concreteType": "MercuryFocusAreaStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": v0 /*: any*/ 
            },
            {
                "concreteType": "MercuryFocusAreaHealth",
                "kind": "LinkedField",
                "name": "health",
                "plural": false,
                "selections": v0 /*: any*/ 
            }
        ],
        "type": "MercuryFocusArea"
    };
}();
$e52f8f55460571a7$var$node.hash = "e9b519ecce5fbf8e7515fc87b88d3908";
var $e52f8f55460571a7$export$2e2bcd8739ae039 = $e52f8f55460571a7$var$node;


parcelRequire("42omo");










var $2BDjU = parcelRequire("2BDjU");

const $bfa7c91f92160eaf$export$21327edf61992871 = ({ node: node })=>{
    const data = (0, $irOoi.useFragment)((0, $e52f8f55460571a7$export$2e2bcd8739ae039), node);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $2BDjU.default), {
                status: data?.status?.key,
                health: data?.health?.key
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                size: "medium",
                weight: "regular",
                color: "color.text.subtle",
                children: data?.name
            })
        ]
    });
};


const $7703ce592a2f6397$export$a4810646942f13a2 = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, searchQuery: searchQuery, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const data = (0, $irOoi.useFragment)((0, $2cea3badc71cab2b$export$2e2bcd8739ae039), node);
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const preferredName = data.position?.worker?.preferredName || undefined;
    const [jobTitle, positionExternalKey, focusArea, positionKey] = (0, $42omo.useMemo)(()=>{
        let jobTitle = '';
        let positionExternalKey = '';
        let focusArea = null;
        let positionKey = '';
        data.position?.fieldValues?.forEach((fieldValue)=>{
            if (fieldValue.fieldId === 'positionKey' && fieldValue.fieldValue?.__typename === 'RadarStringFieldValue') positionKey = fieldValue.fieldValue?.stringValue || '';
            if (fieldValue.fieldId === 'positionPositionTitle' && fieldValue.fieldValue?.__typename === 'RadarStringFieldValue') jobTitle = fieldValue.fieldValue?.stringValue || '';
            if (fieldValue.fieldId === 'positionExternalPositionKey' && fieldValue.fieldValue?.__typename === 'RadarStringFieldValue') positionExternalKey = fieldValue.fieldValue?.stringValue || '';
            if (fieldValue.fieldId === 'focusArea' && fieldValue.fieldValue?.__typename === 'RadarAriFieldValue' && fieldValue.fieldValue?.value?.__typename === 'MercuryFocusArea') focusArea = fieldValue.fieldValue?.value;
        });
        return [
            jobTitle,
            positionExternalKey,
            focusArea,
            positionKey
        ];
    }, [
        data.position?.fieldValues
    ]);
    const title = (0, $42omo.useMemo)(()=>{
        const title = formatMessage((0, $0de0787fb1ebae17$export$defe85febe8b728c).positionTitle, {
            positionKey: positionKey,
            preferredName: preferredName
        });
        if (!searchQuery) return (0, $Y34Hw.enrichExcerpt)(title) || title;
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(title, searchQuery.split(' '));
        return !highlightedTitle ? (0, $Y34Hw.enrichExcerpt)(title) : (0, $Y34Hw.enrichExcerpt)(highlightedTitle);
    }, [
        positionKey,
        preferredName,
        formatMessage,
        searchQuery
    ]);
    const headerMetadataParts = (0, $42omo.useMemo)(()=>[
            [
                'type',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                    type: data.type
                })
            ],
            jobTitle ? [
                'positionTitle',
                jobTitle
            ] : null,
            positionExternalKey ? [
                'positionExternalKey',
                formatMessage((0, $0de0787fb1ebae17$export$defe85febe8b728c).positionExternalKey, {
                    positionExternalKey: positionExternalKey
                })
            ] : null
        ], [
        data.type,
        jobTitle,
        positionExternalKey,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        hideSummarizeInChat: true,
        product: (0, $1yEFx.ProductKeys).Talent,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: data.url,
        title: title,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $cWRpe.TalentUserAvatar), {
            src: data.position?.worker?.user?.picture
        }),
        headerMetadataParts: headerMetadataParts,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $bfa7c91f92160eaf$export$21327edf61992871), {
            node: focusArea
        }),
        cloudId: cloudId,
        position: position,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $7703ce592a2f6397$export$6961f06bc751194b = (node)=>{
    return node?.id?.includes('radar') && node.__typename === 'SearchResultTalentPosition';
};





/**
 * @generated SignedSource<<02be0fba6a716cbaf8b5cacc63f058fe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $508a9faa0fdcb277$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "description"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "title"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "ScalarField",
        "name": "url"
    }, v5 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    }, v6 = [
        v5 /*: any*/ 
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchTrello_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            v4 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v6 /*: any*/ ,
                "type": "SearchResultTrelloBoard"
            },
            {
                "kind": "InlineFragment",
                "selections": v6 /*: any*/ ,
                "type": "SearchResultTrelloCard"
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    v4 /*: any*/ ,
                    v3 /*: any*/ ,
                    v0 /*: any*/ ,
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResult",
        "abstractKey": "__isSearchResult"
    };
}();
$508a9faa0fdcb277$var$node.hash = "0d47378928f4dc8252dbb20d4890cfa9";
var $508a9faa0fdcb277$export$2e2bcd8739ae039 = $508a9faa0fdcb277$var$node;










































const $b22a5a74dc96194e$export$6e8065b29de68b35 = ({ node: node, position: position, cloudId: cloudId, searchQuery: searchQuery, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $508a9faa0fdcb277$export$2e2bcd8739ae039), node);
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type === 'issue' ? 'card' : data.type,
            entityType: data.type === 'issue' ? 'card' : data.type,
            contentId: contentId,
            product: product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(data.title, searchQuery.split(' '));
        if (!highlightedTitle) return data.title;
        return (0, $Y34Hw.enrichExcerpt)(highlightedTitle);
    }, [
        data.title,
        searchQuery
    ]);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        const reducedDescription = (0, $bOpS4.truncateTextWithQuery)(data.description, searchQuery);
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(reducedDescription, searchQuery.split(' '));
        if (!highlightedTitle) return reducedDescription;
        return (0, $Y34Hw.processExcerpt)(highlightedTitle);
    }, [
        data.description,
        searchQuery
    ]);
    const headerMetadataParts = [
        [
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                type: metadata.entityType
            })
        ],
        [
            'lastModified',
            data.lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                lastModified: data.lastModifiedDate
            }) : null
        ]
    ];
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const extractedLinksFromText = (0, $514d99dea8b7ae4b$export$a414b3d5a172e15b)(data.description);
    const hasExtractedLinks = extractedLinksFromText && extractedLinksFromText.length > 0;
    const hasRelatedLinks = linkedResults && linkedResults.length > 0 || hasExtractedLinks;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Trello,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: data.url,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.TrelloIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        title: enrichedTitle,
        headerMetadataParts: headerMetadataParts,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: enrichedDescription
        }),
        cloudId: cloudId,
        position: position,
        appMode: appMode,
        hasRelatedLinks: hasRelatedLinks,
        footer: /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$695e5a3ae2478b3), {
            linkedResults: linkedResults || [],
            thirdPartyConfigs: thirdPartyConfigs,
            partial: data,
            url: data.url,
            position: position,
            onResultClicked: onResultClicked,
            onResultContextMenu: onResultCtxMenuClicked,
            isAllProductSelected: !selectedProduct
        }),
        mainContentWidth: mainContentWidth
    });
};
const $b22a5a74dc96194e$export$4a9584fe41dfb37d = (node)=>{
    return node?.__typename === 'SearchResultTrelloBoard' || node?.__typename === 'SearchResultTrelloCard';
};


const $d5fc325798e6b51f$export$705600d20983658a = ({ node: fragmentRef, thirdPartyConfigs: thirdPartyConfigs, compassTeamName: compassTeamName, jiraIssueStatus: jiraIssueStatus, smartAnswersPortalRef: smartAnswersPortalRef, ...props })=>{
    // Casting to `any` to avoid type errors with type guards
    // TODO: Improve type guards to avoid casting
    const node = (0, $irOoi.useFragment)((0, $f2155b61e0619eb7$export$2e2bcd8739ae039), fragmentRef);
    const logException = (0, $f8oYd.useLogException)();
    // Try/catch because AnyAri.parse throws on malformed ARIs
    try {
        if (!node) throw new Error('ResultRecord: node is undefined');
        if ((0, $38a1e03191a959a6$export$4619f000f23ee8d1)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $38a1e03191a959a6$export$f3b885cf8bfefc5f), {
            ...props,
            node: node
        });
        if ((0, $328ff6efa3a7a420$export$c89c057fd480d10c)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $328ff6efa3a7a420$export$1e8aa22a53a15ada), {
            ...props,
            node: node,
            thirdPartyConfigs: thirdPartyConfigs,
            smartAnswersPortalRef: smartAnswersPortalRef
        });
        if ((0, $5b3efb581ea6b58d$export$e232933b3399051b)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $5b3efb581ea6b58d$export$bd12cc2939091aab), {
            ...props,
            node: node
        });
        if ((0, $e69dcf232ee4a7ce$export$eb74eda5abb6ce2f)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $e69dcf232ee4a7ce$export$a77407ffacf1d445), {
            ...props,
            node: node
        });
        if ((0, $e4107ff9b0892e16$export$3ea06079dfb7d39c)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $e4107ff9b0892e16$export$e206de30029925c0), {
            ...props,
            node: node,
            compassTeamName: compassTeamName
        });
        if ((0, $31e547389e3910c7$export$79503cf2fe431c3a)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $31e547389e3910c7$export$14e63e5586bfae9b), {
            ...props,
            node: node
        });
        if ((0, $73404969990abf67$export$b9491ee18011db60)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $73404969990abf67$export$26ac3e97753acb0e), {
            ...props,
            node: node,
            jiraIssueStatus: jiraIssueStatus
        });
        if ((0, $480180c1ff14c088$export$6566c83063a7eefb)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $480180c1ff14c088$export$24f204fc253b9cb5), {
            ...props,
            node: node
        });
        if ((0, $ef85b0f97f42606b$export$1ac32d77bb207897)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $ef85b0f97f42606b$export$4d44dfc3b1a588bc), {
            ...props,
            node: node
        });
        if ((0, $4fc71968c4272f25$export$f78f5f7633f09cb5)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $4fc71968c4272f25$export$7c35d70259168995), {
            ...props,
            node: node
        });
        if ((0, $87cf4eaba3a575c0$export$8fd9ffc22de770d9)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $87cf4eaba3a575c0$export$a5c532a12af1d7c8), {
            ...props,
            node: node
        });
        if ((0, $b22a5a74dc96194e$export$4a9584fe41dfb37d)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $b22a5a74dc96194e$export$6e8065b29de68b35), {
            ...props,
            node: node
        });
        if ((0, $1f5c3a9997a89a12$export$9bcd0683f048ca39)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $1f5c3a9997a89a12$export$462e5965a804bcf5), {
            ...props,
            node: node
        });
        if ((0, $aa67e67612c8c517$export$25e56f07edb2e8ac)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $aa67e67612c8c517$export$e299cc210f856d0f), {
            ...props,
            node: node
        });
        if ((0, $e1e365f93a6cb640$export$29b4f3dd85087f82)(node) && (0, $dh538.fg)('platform_passionfruit_search_onboarding_enabled')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $e1e365f93a6cb640$export$c92f93b41e432091), {
            ...props,
            node: node
        });
        if ((0, $64821cc7b4fbd082$export$59a100e12914442b)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $64821cc7b4fbd082$export$b3f67b85a605a606), {
            ...props,
            node: node,
            thirdPartyConfigs: thirdPartyConfigs
        });
        if ((0, $b28fdd1f3658a84e$export$7b84b51bda14a6a0)(node) && (0, $dh538.fg)('assets_rovo_search_all')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $b28fdd1f3658a84e$export$33645cba5cb4e74d), {
            ...props,
            node: node
        });
        if ((0, $3910a17689cc33ca$export$510b7ec52c081a20)(node) && (0, $dh538.fg)('assets_rovo_search_all')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $3910a17689cc33ca$export$9f67e5fd0627a72b), {
            ...props,
            node: node
        });
        if ((0, $def5c503597c8977$export$4cdaf9794367deaa)(node) && (0, $dh538.fg)('assets_rovo_search_all')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $def5c503597c8977$export$7afb78c1a6844ab6), {
            ...props,
            node: node
        });
        if ((0, $7703ce592a2f6397$export$6961f06bc751194b)(node) && (0, $dh538.fg)('talent_global_search')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $7703ce592a2f6397$export$a4810646942f13a2), {
            ...props,
            node: node
        });
        if (node.id && (0, $9b59a3205d194c41$export$48471e9a17c64a92)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $9b59a3205d194c41$export$e84f7c0bef931609), {
            ...props,
            node: node,
            thirdPartyConfigs: thirdPartyConfigs
        });
        throw new Error(`SearchResultRenderer: unsupported node typename=${node['__typename']}`);
    } catch (e) {
        logException(e);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $d75f7c12f192fdc3$export$7397c326dc16df01), {
            ...props,
            node: node
        });
    }
};


const $bdefbb7f72d12f38$export$b9f6f9f70138c961 = 4;
const $bdefbb7f72d12f38$var$LEAP_QUERY_BANNER_POSITION = 5;
const $bdefbb7f72d12f38$export$a2def421b23768aa = ({ node: node, position: position, thirdPartyConfigs: thirdPartyConfigs, availableProducts: availableProducts, cloudId: cloudId, searchQuery: searchQuery, originalQuery: originalQuery, selectedProduct: selectedProduct, searchSessionId: searchSessionId, primaryProduct: primaryProduct, appMode: appMode, logError: logError, compassTeamName: compassTeamName, jiraIssueStatus: jiraIssueStatus, is3pGroupingEnabled: is3pGroupingEnabled, smartAnswersPortalRef: smartAnswersPortalRef, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $1cc2f6a902ce7bda$export$2e2bcd8739ae039), node);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $7WbA8.useAppContext)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            position === $bdefbb7f72d12f38$export$b9f6f9f70138c961 && /*#__PURE__*/ (0, $l998X.jsx)((0, $14f5a0c0b568e7eb$export$df17046610238203), {
                cloudId: cloudId,
                thirdPartyConfigs: thirdPartyConfigs,
                selectedProduct: selectedProduct,
                availableProducts: availableProducts
            }),
            position === $bdefbb7f72d12f38$var$LEAP_QUERY_BANNER_POSITION && (0, $126976b62166fe6c$export$383dd888028aa640)(appMode, isAdminHubAIEnabled, isRovoLLMEnabled) && /*#__PURE__*/ (0, $l998X.jsx)((0, $c87f95dd2abf5b51$export$9b91afdfe0a13e1a), {
                searchQuery: searchQuery,
                originalQuery: originalQuery,
                primaryProduct: primaryProduct,
                logError: logError
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
                section: "SearchPageResultRecord",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d5fc325798e6b51f$export$705600d20983658a), {
                    node: data,
                    position: position,
                    cloudId: cloudId,
                    searchQuery: searchQuery,
                    searchSessionId: searchSessionId,
                    appMode: appMode,
                    primaryProduct: primaryProduct,
                    selectedProduct: selectedProduct,
                    thirdPartyConfigs: thirdPartyConfigs,
                    compassTeamName: compassTeamName,
                    jiraIssueStatus: jiraIssueStatus,
                    is3pGroupingEnabled: is3pGroupingEnabled,
                    smartAnswersPortalRef: smartAnswersPortalRef,
                    mainContentWidth: mainContentWidth
                }, data.id)
            })
        ]
    });
};













const $d36edf17876c264b$var$canOptimiseResultsRendering = ()=>Boolean(window && window.requestIdleCallback);
const $d36edf17876c264b$export$e8402efe3c056aa3 = ({ bodyRef: bodyRef, edges: edges, maxResultsToShow: maxResultsToShow, setMaxResultsToShow: setMaxResultsToShow, queryReference: queryReference })=>{
    const edgesToDisplay = (0, $42omo.useMemo)(()=>{
        return $d36edf17876c264b$var$canOptimiseResultsRendering() && (0, $2OtFZ.serveSearchPageRenderingOptimisations)() && maxResultsToShow && maxResultsToShow < edges.length ? edges.slice(0, maxResultsToShow) : edges;
    }, [
        edges,
        maxResultsToShow
    ]);
    // We use a layout effect here to ensure the scroll event listener is bound
    // before the first paint of search results.
    (0, $42omo.useLayoutEffect)(()=>{
        if (!$d36edf17876c264b$var$canOptimiseResultsRendering()) return;
        if (!(0, $2OtFZ.serveSearchPageRenderingOptimisations)()) return;
        if (!bodyRef?.current) return;
        // If the user tries to scroll the search results list, render all
        // results immediately
        const unbind = (0, $fFa3V.bind)(bodyRef.current, {
            type: 'scroll',
            listener: ()=>{
                setMaxResultsToShow(undefined);
            },
            options: {
                once: true
            }
        });
        // When the main thread is idle, render the rest of the results
        // eslint-disable-next-line no-restricted-globals -- canOptimiseResultsRendering checks if requestIdleCallback is available
        requestIdleCallback(()=>{
            unbind();
            setMaxResultsToShow(undefined);
        });
        return unbind;
    }, [
        bodyRef,
        setMaxResultsToShow,
        queryReference
    ]);
    return edgesToDisplay;
};










































const $ec36d7d4426f2eb3$export$8554996556b9ba1 = ({ are3pResultsShown: are3pResultsShown, backendExperimentRef: backendExperimentRef, clearReferrer: clearReferrer, cloudId: cloudId, commonAttributes: commonAttributes, edges: edges, experimentConfig: experimentConfig, getSelectedFilters: getSelectedFilters, isLoadingNext: isLoadingNext, isJiraIssueIndexed: isJiraIssueIndexed, isPaginatedQuery: isPaginatedQuery, nonPrivacySafeAttributes: nonPrivacySafeAttributes, productDataRegions: productDataRegions, productEdition: productEdition, productsWithTimeoutsFromErrors: productsWithTimeoutsFromErrors, referrer: referrer, resultsForAnalytics: resultsForAnalytics, resultsShown: resultsShown, searchQuery: searchQuery })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    // Properties related to social signals
    const socialSignalsAttributes = (0, $9df153e29ffddcb7$export$7d33b74a4ce5a7db)(resultsForAnalytics);
    // Properties related to the search results in the result set
    const { searchAndResult: searchAndResult } = (0, $dd52a0ba4dde52e0$export$771e1c85614a020d)(resultsForAnalytics);
    // We store these values in a ref as the references to the properties are not
    // stable we do not want to trigger the analytics events unnecessarily. This
    // allows to narrow down the dependency array of the useEffect hook that fires
    // the analytics events.
    const analyticsProperties = {
        are3pResultsShown: are3pResultsShown,
        clearReferrer: clearReferrer,
        cloudId: cloudId,
        commonAttributes: commonAttributes,
        experimentConfig: experimentConfig,
        fireAnalyticsEvent: fireAnalyticsEvent,
        getSelectedFilters: getSelectedFilters,
        isJiraIssueIndexed: isJiraIssueIndexed,
        isPaginatedQuery: isPaginatedQuery,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes,
        productDataRegions: productDataRegions,
        productEdition: productEdition,
        productsWithTimeoutsFromErrors: productsWithTimeoutsFromErrors,
        referrer: referrer,
        resultsShown: resultsShown,
        searchAndResult: searchAndResult,
        searchQuery: searchQuery,
        socialSignalsAttributes: socialSignalsAttributes
    };
    const analyticsPropertiesRef = (0, $42omo.useRef)(analyticsProperties);
    analyticsPropertiesRef.current = analyticsProperties;
    (0, $42omo.useEffect)(()=>{
        const { are3pResultsShown: are3pResultsShown, clearReferrer: clearReferrer, cloudId: cloudId, commonAttributes: commonAttributesWithoutExtensionData, experimentConfig: experimentConfig, fireAnalyticsEvent: fireAnalyticsEvent, getSelectedFilters: getSelectedFilters, isJiraIssueIndexed: isJiraIssueIndexed, isPaginatedQuery: isPaginatedQuery, nonPrivacySafeAttributes: nonPrivacySafeAttributes, productDataRegions: productDataRegions, productEdition: productEdition, productsWithTimeoutsFromErrors: productsWithTimeoutsFromErrors, referrer: referrer, resultsShown: resultsShown, searchAndResult: searchAndResult, searchQuery: searchQuery, socialSignalsAttributes: socialSignalsAttributes } = analyticsPropertiesRef.current;
        if (isLoadingNext) return;
        const numResults = edges.length;
        const { entities: entities, selectedFilters: selectedFilters } = getSelectedFilters();
        const isBulkConnectBannerShown = (0, $9wmQG.getIsBulkConnectBannerShown)();
        const commonAttributes = {
            ...commonAttributesWithoutExtensionData,
            ...(0, $1ymk3.getExtensionData)(commonAttributesWithoutExtensionData.isCQL)
        };
        /**
		 * When relay_results_analytics_refactor is on:
		 * 	Backend experiment data remapping happens inside onAdvancedSearchResultsShown
		 *
		 * When relay_results_analytics_refactor is off:
		 * 	We need to remap backend experiment data here with additional call on getBackendExperiment
		 */ const requestedBackendExperiment = (0, $dh538.fg)('relay_results_analytics_refactor') ? backendExperimentRef.current ?? undefined // Expect undefined instead of null
         : (0, $8RFAN.getRequestedBackendExperiment)((0, $hm6w9.getBackendExperiment)({
            experimentConfig: experimentConfig,
            entities: entities,
            productEdition: productEdition,
            isHello: (0, $5XpfZ.isHello)(cloudId),
            productDataRegions: productDataRegions,
            experience: (0, $4cq9O.SEARCH_PAGE),
            tenantId: cloudId,
            isJiraIssueIndexed: isJiraIssueIndexed,
            thirdPartyFilters: selectedFilters.thirdPartyFilters
        }));
        fireAnalyticsEvent((0, $0f1906aa6a6024a0$export$4b73689f2f9f3dd3)({
            queryState: searchQuery ? (0, $6yNqK.QueryState).POSTQUERY : (0, $6yNqK.QueryState).PREQUERY,
            numResults: numResults,
            shownCount: numResults,
            are3pResultsShown: are3pResultsShown,
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            socialSignalsAttributes: socialSignalsAttributes,
            resultsShown: resultsShown,
            searchAndResult: searchAndResult,
            requestedBackendExperiments: {
                backendExperiments: requestedBackendExperiment
            },
            referrer: referrer && searchQuery ? referrer : undefined,
            isPaginatedQuery: isPaginatedQuery,
            isBulkConnectBannerShown: isBulkConnectBannerShown,
            productsWithTimeout: (0, $2OtFZ.serveSearchPageTimeoutsUX)() ? productsWithTimeoutsFromErrors || [] : undefined
        }));
        fireAnalyticsEvent((0, $00671a63acd7458c$export$8b03bfde0d56431b)({
            success: true,
            commonAttributes: commonAttributes
        }));
        (0, $bVltF.searchResultsLoadUFOExperienceSuccess)({
            queryLength: commonAttributes.queryLength,
            wordCount: commonAttributes.wordCount
        });
        // Ensure that the referrer attribute is only used once
        clearReferrer();
    }, [
        analyticsPropertiesRef,
        backendExperimentRef,
        edges,
        isLoadingNext
    ]);
};














const $3fc15ba8e0a42a52$var$transformAutoAppliedFilters = (autoAppliedFilters)=>{
    const filters = [];
    const { range: range, participants: participants } = autoAppliedFilters ?? {};
    // Handle lastModified range filter
    const lastUpdated = (0, $dOOW1.convertDateRangeToLastUpdated)(range?.lastModified);
    if (lastUpdated !== 'anytime') filters.push({
        filterId: 'lastUpdated',
        optionChange: [
            {
                value: lastUpdated,
                isSelected: true
            }
        ],
        options: lastUpdated === 'custom' ? {
            customValue: {
                from: range?.lastModified?.gt ?? '',
                to: range?.lastModified?.lt ?? ''
            }
        } : undefined
    });
    // Handle contributor filter from participants
    if (participants?.items && participants.combination) {
        const contributorUserIds = (0, $dOOW1.getContributorsFromParticipants)({
            combination: participants.combination,
            items: participants.items
        });
        if (contributorUserIds.length > 0) filters.push({
            filterId: 'contributor',
            optionChange: contributorUserIds.map((userId)=>({
                    value: userId,
                    isSelected: true
                }))
        });
    }
    return filters;
};
const $3fc15ba8e0a42a52$var$toAnalyticsFormat = (filters)=>{
    return filters.flatMap((filter)=>{
        const optionChanges = Array.isArray(filter.optionChange) ? filter.optionChange : [
            filter.optionChange
        ];
        return optionChanges.map((option)=>({
                filterId: filter.filterId,
                value: option.value
            }));
    });
};
const $3fc15ba8e0a42a52$export$6fae20f21b2ee1d2 = ({ autoAppliedFilters: autoAppliedFilters, isPaginatedQuery: isPaginatedQuery })=>{
    const { setAutoFilters: setAutoFilters } = (0, $djVCD.useSearchActions)();
    const transformedFilters = (0, $42omo.useMemo)(()=>{
        if (!(0, $ci6Zg.serveAutoAppliedFiltersExperiment)({
            fireExperimentExposure: false
        })) return [];
        if (isPaginatedQuery) return [];
        return $3fc15ba8e0a42a52$var$transformAutoAppliedFilters(autoAppliedFilters);
    }, [
        isPaginatedQuery,
        autoAppliedFilters
    ]);
    const autoAppliedFiltersForAnalytics = (0, $42omo.useMemo)(()=>$3fc15ba8e0a42a52$var$toAnalyticsFormat(transformedFilters), [
        transformedFilters
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!(0, $ci6Zg.serveAutoAppliedFiltersExperiment)({
            fireExperimentExposure: true
        })) return;
        if (transformedFilters.length > 0) setAutoFilters(transformedFilters);
    }, [
        setAutoFilters,
        transformedFilters
    ]);
    return {
        autoAppliedFilters: autoAppliedFiltersForAnalytics
    };
};


/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 












const $f393218d2c2b7af2$export$7148f5ed0307d6ed = ({ edges: edges, searchSessionId: searchSessionId })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const vitalStats = (0, $3f9016d1e452d4e9$export$586800522161402)();
    const fullPageSearchTaskId = vitalStats.getUxTaskId();
    const networkRefs = vitalStats.getNetworkRefs();
    const onNetworkSuccess = vitalStats.onNetworkSuccess;
    const vitalStatsEventFiredRef = (0, $42omo.useRef)(false);
    const networkVitalStatsEventFiredRef = (0, $42omo.useRef)(false);
    const fullPageSearchTaskIdRefStable = (0, $42omo.useRef)(fullPageSearchTaskId);
    const searchSessionIdRefStable = (0, $42omo.useRef)(searchSessionId);
    // Keep refs up to date and reset vitalStatsEventFiredRef when task ID changes
    (0, $42omo.useEffect)(()=>{
        const taskIdChanged = fullPageSearchTaskId !== fullPageSearchTaskIdRefStable.current;
        if (taskIdChanged) {
            vitalStatsEventFiredRef.current = false;
            networkVitalStatsEventFiredRef.current = false;
        }
        fullPageSearchTaskIdRefStable.current = fullPageSearchTaskId;
        searchSessionIdRefStable.current = searchSessionId;
    }, [
        fullPageSearchTaskId,
        searchSessionId
    ]);
    // Fire vital stats taskSuccess event when results are successfully rendered (UX)
    (0, $42omo.useEffect)(()=>{
        if (fullPageSearchTaskIdRefStable.current && !vitalStatsEventFiredRef.current && edges.length > 0 && (0, $dh538.fg)('rovo-search-vitalstats-fullpage-search-ux')) {
            vitalStatsEventFiredRef.current = true;
            fireAnalyticsEvent((0, $bQSQw.onTaskSuccess)({
                searchSessionId: searchSessionIdRefStable.current || '',
                taskId: fullPageSearchTaskIdRefStable.current,
                task: (0, $bQSQw.TASK_NAMES).SEARCH_PAGE_FULL_PAGE_SEARCH_RESULTS_UX
            }));
        }
    // Refs (fullPageSearchTaskIdRefStable, searchSessionIdRefStable, vitalStatsEventFiredRef)
    // are intentionally NOT in dependencies - we use refs to read latest values without
    // causing re-runs. fireAnalyticsEvent is stable and doesn't need to be included.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        edges.length,
        fullPageSearchTaskId
    ]);
    // Fire network VitalStats taskSuccess event when results are received
    // Note: Network success fires for zero results too (edges.length === 0 is valid)
    (0, $42omo.useEffect)(()=>{
        if (networkRefs && onNetworkSuccess && !networkVitalStatsEventFiredRef.current && (0, $dh538.fg)('rovo-search-vitalstats-fullpage-search-network')) {
            const state = networkRefs.current.state;
            // Only fire if task is in 'started' state (prevents duplicates)
            if (state.state === 'started' && state.taskId) {
                networkVitalStatsEventFiredRef.current = true;
                onNetworkSuccess(edges.length);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        edges.length,
        fullPageSearchTaskId,
        networkRefs,
        onNetworkSuccess
    ]);
};







async function $145759fcd6783725$export$2716d470ab5d7e10(cloudId, teamIds, nodeIdMap, setTeamNames, logError) {
    if (cloudId && teamIds.length > 0) try {
        const { teams: teams } = await (0, $7YExv.fetchTeamsBulk)({
            siteId: cloudId,
            teamIds: teamIds
        });
        const newTeamNames = {};
        for(let i = 0; i < teams.length; i++){
            const team = teams[i];
            newTeamNames[team.id] = team.displayName;
        }
        setTeamNames((prevTeamNames)=>{
            const updatedTeamNames = {
                ...prevTeamNames
            };
            for (const [nodeId, teamId] of Object.entries(nodeIdMap))updatedTeamNames[nodeId] = teamId ? newTeamNames[teamId] : null;
            return updatedTeamNames;
        });
        return;
    } catch (e) {
        logError(e);
    }
    // If fetching teams fails, we still want to update the team names to null
    setTeamNames((prevTeamNames)=>{
        const updatedTeamNames = {
            ...prevTeamNames
        };
        for (const [nodeId] of Object.entries(nodeIdMap))updatedTeamNames[nodeId] = null;
        return updatedTeamNames;
    });
}
const $145759fcd6783725$export$fb62e1866e8071b1 = async (cloudId, issueKeys, aggAbsoluteUrl, setJiraStatuses, logError)=>{
    if (cloudId && issueKeys.length > 0) try {
        const response = await (0, $6gi58.fetchJiraFieldsQuery)({
            variables: {
                issueKeys: issueKeys,
                cloudId: cloudId
            },
            aggAbsoluteUrl: aggAbsoluteUrl
        });
        const issuesByKey = response.data?.jira?.issuesByKey;
        setJiraStatuses((prevIssueStatuses)=>{
            if (issuesByKey) {
                const issueStatuses = {
                    ...prevIssueStatuses
                };
                // Have seen the issuesByKey have [null] responses
                for (const issue of issuesByKey.filter((issue)=>issue)){
                    const statusName = issue.statusField?.status?.name;
                    const colorName = issue.statusField?.status?.statusCategory?.colorName;
                    if (issue.id && statusName && colorName) issueStatuses[issue.id] = {
                        statusName: statusName,
                        colorName: colorName
                    };
                }
                return issueStatuses;
            }
            return prevIssueStatuses;
        });
        return;
    } catch (e) {
        logError(e);
    }
    // If fetching Jira fields fails, we still want to update the issue statuses to null
    setJiraStatuses((prevIssueStatuses)=>{
        const issueStatuses = {
            ...prevIssueStatuses
        };
        for (const key of issueKeys)issueStatuses[key] = null;
        return issueStatuses;
    });
};
const $145759fcd6783725$export$f047817832ff1021 = (commonAttributes, autoAppliedFilters)=>{
    if (autoAppliedFilters.length === 0) return commonAttributes;
    // Get existing filter IDs to avoid duplicates
    const existingFilterIds = new Set(commonAttributes.filters);
    // Create filter selections for auto-applied filters
    const autoAppliedFilterSelections = autoAppliedFilters.filter((af)=>!existingFilterIds.has(af.filterId)).map((af)=>({
            filterId: af.filterId,
            value: af.value,
            isSmartDefault: false,
            wasAutoApplied: true
        }));
    // Get new filter IDs to add
    const newFilterIds = autoAppliedFilters.filter((af)=>!existingFilterIds.has(af.filterId)).map((af)=>af.filterId);
    return {
        ...commonAttributes,
        filters: [
            ...commonAttributes.filters,
            ...newFilterIds
        ],
        filterSelections: [
            ...commonAttributes.filterSelections,
            ...autoAppliedFilterSelections
        ]
    };
};


const $e283d0740cdc7b40$var$PAGINATION_UNUSED_PAGE_SIZE = 30;
const $e283d0740cdc7b40$export$aee53da69e9839be = ({ searchResultsQuery: searchResultsQuery, aggAbsoluteUrl: aggAbsoluteUrl, cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, searchSessionId: searchSessionId, searchQuery: searchQuery, availableProducts: availableProducts, experimentConfig: experimentConfig, productEdition: productEdition, productDataRegions: productDataRegions, isJiraIssueIndexed: isJiraIssueIndexed, setResultsState: setResultsState, getSelectedFilters: getSelectedFilters, clearFilters: clearFilters, logError: logError, clearReferrer: clearReferrer, referrer: referrer, autoCorrectPortalRef: autoCorrectPortalRef, smartAnswersPortalRef: smartAnswersPortalRef, setFederatedSlackCount: setFederatedSlackCount, setFederatedOutlookMailCount: setFederatedOutlookMailCount, setProductsWithTimeout: setProductsWithTimeout, bodyRef: bodyRef, maxResultsToShow: maxResultsToShow, setMaxResultsToShow: setMaxResultsToShow, mainContentWidth: mainContentWidth, backendExperimentRef: backendExperimentRef })=>{
    const queryData = (0, $irOoi.usePreloadedQuery)((0, $7Ngf7.default), searchResultsQuery);
    // Pagination hasPrevious state (hasPreviousPage from usePaginationFragment does not work with aggregator)
    // See https://hello.atlassian.net/wiki/x/lYYyQQE
    const hasPreviousRef = (0, $42omo.useRef)(false);
    // Note that aggregator doesn't quite match the expected specification here
    // - hasNext is an available prop but will always be false.
    // - loadNext takes (limit: number) to set page size, but aggregator ignores it
    // See https://hello.atlassian.net/wiki/x/lYYyQQE
    const { data: data, loadNext: loadNext, isLoadingNext: isLoadingNext } = (0, $irOoi.usePaginationFragment)((0, $8c8aedab4d13b6fb$export$2e2bcd8739ae039), queryData);
    // It is possible that aggregator returns the same node twice, but then <SearchResult key={edge.node.id} /> breaks
    // So we need to dedup by id
    const edges = (0, $42omo.useMemo)(()=>{
        const seenIds = new Set();
        const edges = data.search?.search?.edges || [];
        return edges.filter((edge)=>{
            const id = edge?.node?.id;
            if (seenIds.has(id)) return false;
            else {
                seenIds.add(id);
                return true;
            }
        });
    }, [
        data.search?.search?.edges
    ]);
    const edgesToDisplay = (0, $d36edf17876c264b$export$e8402efe3c056aa3)({
        bodyRef: bodyRef,
        edges: edges,
        maxResultsToShow: maxResultsToShow,
        setMaxResultsToShow: setMaxResultsToShow,
        queryReference: searchResultsQuery
    });
    const productsWithTimeoutsFromErrors = (0, $42omo.useMemo)(()=>{
        if (!(0, $2OtFZ.serveSearchPageTimeoutsUX)()) return undefined;
        const errors = data.search?.search?.errors || [];
        return errors.filter((e)=>e.statusCode === 408).map((e)=>e.integration ?? e.product).flatMap((s)=>s && (0, $1yEFx.isProductKey)(s) ? [
                s
            ] : []); // Flatmap for better type inference
    }, [
        data.search?.search?.errors
    ]);
    (0, $42omo.useEffect)(()=>{
        // We only want to set products with timeout in all product search
        if (selectedProduct !== undefined) return;
        setProductsWithTimeout?.(productsWithTimeoutsFromErrors);
    }, [
        productsWithTimeoutsFromErrors,
        selectedProduct,
        setProductsWithTimeout
    ]);
    const resultsForAnalytics = (0, $42omo.useMemo)(()=>$e283d0740cdc7b40$var$transformResultsForAnalytics(edges), [
        edges
    ]);
    const resultsLength = edges.length;
    // Set federated Slack count when selectedProduct is Slack
    (0, $42omo.useEffect)(()=>{
        const isSlackFederatedSearchEnabled = (0, $8RFAN.serveFederatedSlackExperiment)(selectedProduct, undefined, {
            fireExperimentExposure: false
        }, thirdPartyConfigs) || (0, $dh538.fg)('ai_3p_slack_federated_search_enabled');
        if (selectedProduct === (0, $1yEFx.ProductKeys).Slack && setFederatedSlackCount && isSlackFederatedSearchEnabled) setFederatedSlackCount(resultsLength);
    }, [
        selectedProduct,
        resultsLength,
        setFederatedSlackCount,
        thirdPartyConfigs
    ]);
    // Set federated Outlook Mail count when selectedProduct is Outlook Mail
    (0, $42omo.useEffect)(()=>{
        if (selectedProduct === (0, $1yEFx.ProductKeys3P).OutlookMail && setFederatedOutlookMailCount) setFederatedOutlookMailCount(resultsLength);
    }, [
        selectedProduct,
        resultsLength,
        setFederatedOutlookMailCount
    ]);
    const is3pGroupingEnabled = (0, $dh538.fg)('fps_3p_grouping_rollout_gate');
    // Records dwell time for search results
    // TODO: refactor this to use props instead of RSS
    (0, $320af85988d7ec69$export$2e2bcd8739ae039)();
    // Compass team names
    const [teamNames, setTeamNames] = (0, $42omo.useState)({});
    const { teamIds: teamIds, nodeIdMap: nodeIdMap } = (0, $42omo.useMemo)(()=>$e283d0740cdc7b40$var$getCompassTeamIds(edges, selectedProduct), [
        edges,
        selectedProduct
    ]);
    (0, $42omo.useEffect)(()=>{
        (0, $145759fcd6783725$export$2716d470ab5d7e10)(cloudId, teamIds, nodeIdMap, setTeamNames, logError);
    }, [
        cloudId,
        teamIds,
        nodeIdMap,
        logError
    ]);
    // Jira issue statuses
    const [issueStatuses, setIssueStatuses] = (0, $42omo.useState)({});
    const issueKeys = (0, $42omo.useMemo)(()=>$e283d0740cdc7b40$var$getJiraIssueKeys(edges), [
        edges
    ]);
    (0, $42omo.useEffect)(()=>{
        (0, $145759fcd6783725$export$fb62e1866e8071b1)(cloudId, issueKeys, aggAbsoluteUrl, setIssueStatuses, logError);
    }, [
        cloudId,
        issueKeys,
        aggAbsoluteUrl,
        setIssueStatuses,
        logError
    ]);
    const are3pResultsShown = (0, $42omo.useMemo)(()=>$e283d0740cdc7b40$export$87d91dbe2c36460b(edges, thirdPartyConfigs), [
        edges,
        thirdPartyConfigs
    ]);
    const resultsShown = (0, $42omo.useMemo)(()=>$e283d0740cdc7b40$export$8841f6f549512fc2(edges, thirdPartyConfigs), [
        edges,
        thirdPartyConfigs
    ]);
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    // These fields are extracted explicitly to satisfy Relay's unused fields lint check.
    // We query for autoAppliedFilters here and not within a separate component because
    // autoAppliedFilters is required for analytics (in useSearchResultsAnalytics) and
    // setting auto filter state (in useSearchResultsAutoFilters). The analytics cannot
    // depend on state since analytics fires before state is updated.
    const autoAppliedFiltersRaw = data.search?.search?.autoAppliedFilters;
    const { commonFilters: commonFilters } = autoAppliedFiltersRaw ?? {};
    const { range: range, participants: participants } = commonFilters ?? {};
    const { lastModified: lastModified } = range ?? {};
    const { gt: gt, lt: lt } = lastModified ?? {};
    const { items: items, combination: participantsCombination } = participants ?? {};
    const autoAppliedFiltersInput = (0, $42omo.useMemo)(()=>{
        const extractedItems = items?.map(({ type: type, users: users, combination: combination })=>({
                type: type,
                users: users,
                combination: combination
            }));
        return {
            range: {
                lastModified: {
                    gt: gt,
                    lt: lt
                }
            },
            participants: participantsCombination !== undefined ? {
                items: extractedItems,
                combination: participantsCombination
            } : undefined
        };
    }, [
        gt,
        lt,
        items,
        participantsCombination
    ]);
    const { autoAppliedFilters: autoAppliedFilters } = (0, $3fc15ba8e0a42a52$export$6fae20f21b2ee1d2)({
        autoAppliedFilters: autoAppliedFiltersInput,
        isPaginatedQuery: hasPreviousRef.current
    });
    // Merge auto-applied filters into commonAttributes for analytics
    const mergedCommonAttributes = (0, $42omo.useMemo)(()=>(0, $145759fcd6783725$export$f047817832ff1021)(commonAttributes, autoAppliedFilters), [
        commonAttributes,
        autoAppliedFilters
    ]);
    (0, $ec36d7d4426f2eb3$export$8554996556b9ba1)({
        are3pResultsShown: are3pResultsShown,
        backendExperimentRef: backendExperimentRef,
        clearReferrer: clearReferrer,
        cloudId: cloudId,
        commonAttributes: mergedCommonAttributes,
        edges: edges,
        experimentConfig: experimentConfig,
        getSelectedFilters: getSelectedFilters,
        isJiraIssueIndexed: isJiraIssueIndexed,
        isLoadingNext: isLoadingNext,
        isPaginatedQuery: hasPreviousRef.current,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes,
        productDataRegions: productDataRegions,
        productEdition: productEdition,
        productsWithTimeoutsFromErrors: productsWithTimeoutsFromErrors,
        referrer: referrer,
        resultsForAnalytics: resultsForAnalytics,
        resultsShown: resultsShown,
        searchQuery: searchQuery
    });
    (0, $f393218d2c2b7af2$export$7148f5ed0307d6ed)({
        edges: edges,
        searchSessionId: searchSessionId
    });
    (0, $42omo.useEffect)(()=>{
        if (isLoadingNext) return;
        if (thirdPartyConfigs?.[(0, $1yEFx.ProductKeys3P).GoogleDrive]?.impersonationEnabled && selectedProduct === undefined) (0, $2OtFZ.triggerExposureForWeakLinkExp)();
    }, [
        isLoadingNext,
        selectedProduct,
        thirdPartyConfigs
    ]);
    // Update if there are no results
    (0, $42omo.useEffect)(()=>{
        setResultsState(edges.length === 0 ? (0, $fZ3l2.ResultsStates).NO_RESULTS : (0, $fZ3l2.ResultsStates).RESULTS);
    }, [
        edges,
        setResultsState
    ]);
    // Pagination
    const cursor = data.search?.search?.pageInfo?.endCursor;
    const fetchNextPage = (0, $42omo.useCallback)((nextCursor)=>{
        // Double check we're fetching with the cursor from our current results
        if (nextCursor === cursor) {
            loadNext($e283d0740cdc7b40$var$PAGINATION_UNUSED_PAGE_SIZE);
            hasPreviousRef.current = true;
        }
    }, [
        loadNext,
        cursor
    ]);
    const queryInfo = data.search?.search?.queryInfo;
    const containsSearchResults = edges.length > 0;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $2cEww.default), {
                dataKey: "wordCount",
                value: commonAttributes.wordCount
            }),
            queryInfo && autoCorrectPortalRef && autoCorrectPortalRef.current && /*#__PURE__*/ (0, $jTxSS.createPortal)(/*#__PURE__*/ (0, $l998X.jsx)((0, $7d957fe130cc1584$export$2e2bcd8739ae039), {
                node: queryInfo,
                appMode: appMode,
                cloudId: cloudId
            }), autoCorrectPortalRef.current, 'search-results-auto-correction'),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $280ef4355050ad69$export$92697b2a267ec7ef), {
                containsSearchResults: containsSearchResults,
                children: [
                    containsSearchResults ? edgesToDisplay.map((edge, position)=>edge?.node && /*#__PURE__*/ (0, $l998X.jsx)((0, $bdefbb7f72d12f38$export$a2def421b23768aa), {
                            node: edge.node,
                            position: position,
                            cloudId: cloudId,
                            appMode: appMode,
                            searchQuery: searchQuery,
                            thirdPartyConfigs: thirdPartyConfigs,
                            selectedProduct: selectedProduct,
                            primaryProduct: primaryProduct,
                            searchSessionId: searchSessionId,
                            originalQuery: queryInfo?.originalQuery,
                            availableProducts: availableProducts,
                            logError: logError,
                            compassTeamName: teamNames[edge.node.id],
                            jiraIssueStatus: issueStatuses[edge.node.id],
                            is3pGroupingEnabled: is3pGroupingEnabled,
                            smartAnswersPortalRef: smartAnswersPortalRef,
                            mainContentWidth: mainContentWidth
                        }, edge.node.id)) : /*#__PURE__*/ (0, $l998X.jsx)((0, $88900765e2dbc6d9$export$f8a5875a19110e65), {
                        filtersEnabled: !!selectedProduct || getSelectedFilters().hasFiltersSelected,
                        clearFilters: clearFilters
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $3d6c58437980e8c0$export$2e2bcd8739ae039), {
                        cursor: cursor,
                        isLoading: isLoadingNext,
                        fetchNextPage: fetchNextPage
                    })
                ]
            })
        ]
    });
};
const $e283d0740cdc7b40$export$87d91dbe2c36460b = (edges, thirdPartyConfigs)=>{
    return !!edges?.some(({ node: node })=>{
        const productKey = (0, $Y34Hw.getProductFromProviderId)(thirdPartyConfigs, node?.providerId) || (0, $Y34Hw.getIntegrationKey)(node?.integrationId);
        if (!productKey) // if no integration id it's a 1p
        return false;
        return (0, $1yEFx.is3pProductKeyForAnalytics)(productKey);
    });
};
function $e283d0740cdc7b40$var$getCompassTeamIds(edges, selectedProduct) {
    if (selectedProduct !== (0, $1yEFx.ProductKeys).Compass && selectedProduct !== undefined) return {
        teamIds: [],
        nodeIdMap: {}
    };
    const nodeIdMap = {};
    const ids = new Set();
    for(let i = 0; i < edges.length; i++){
        const node = edges[i]?.node;
        let ownerId = node?.ownerId;
        if ((0, $e4107ff9b0892e16$export$3ea06079dfb7d39c)(node)) {
            const teamId = (0, $fUcm0.getTeamId)(ownerId);
            if (teamId) {
                nodeIdMap[node.id] = teamId;
                ids.add(teamId);
            } else nodeIdMap[node.id] = null;
        }
    }
    return {
        teamIds: Array.from(ids),
        nodeIdMap: nodeIdMap
    };
}
function $e283d0740cdc7b40$var$getJiraIssueKeys(edges) {
    const issueKeysSet = new Set();
    for(let i = 0; i < edges.length; i++){
        const node = edges[i]?.node;
        if (node?.id && (0, $73404969990abf67$export$b9491ee18011db60)(node)) {
            const issueKey = node.issue?.webUrl?.split('/').at(-1) || node?.url?.split('/').at(-1);
            if (issueKey) issueKeysSet.add(issueKey);
        }
    }
    return Array.from(issueKeysSet);
}
const $e283d0740cdc7b40$export$8841f6f549512fc2 = (edges, thirdPartyConfigs)=>{
    return edges?.map(({ node: node }, index)=>{
        const productKey = (0, $Y34Hw.getProductFromProviderId)(thirdPartyConfigs, node?.providerId) || (0, $Y34Hw.getIntegrationKey)(node?.integrationId);
        const [firstPartyProduct] = (0, $6h3V2.getProductAndIDFromARI)(node?.id || '');
        const resultAri = (0, $k4HRJ.AnyAri).parse(node?.id || '');
        let hasLinkInDescription = false;
        if (resultAri.resourceOwner in (0, $1yEFx.products1P)) {
            const links = (0, $514d99dea8b7ae4b$export$a414b3d5a172e15b)(node?.description ?? '');
            if (links && links.length > 0) hasLinkInDescription = true;
        }
        const shouldShowBoostedLinks = node?.linkedResults ? node?.linkedResults.length > 0 && index <= (0, $b7a5d3c4b4eaddeb$export$f0079efc6806b623) : undefined;
        return {
            id: node?.id,
            position: index,
            product: productKey || firstPartyProduct,
            metadata: {
                connectorType: (0, $kQT7c.getResultConnectorSource)({
                    connectorType: node?.connectorType,
                    resultNodeId: node?.id || '',
                    productKey: productKey,
                    thirdPartyConfigs: thirdPartyConfigs
                }),
                boostedLinksShown: shouldShowBoostedLinks,
                fanoutResultsShown: node?.linkedResults && node?.linkedResults.length > 0 && index <= (0, $b7a5d3c4b4eaddeb$export$f0079efc6806b623) ? node.linkedResults.slice(0, (0, $b7a5d3c4b4eaddeb$export$82bce033e6b355fc)).map((link)=>{
                    let is3P = false;
                    try {
                        is3P = !((0, $k4HRJ.AnyAri).parse(link.id).resourceOwner in (0, $1yEFx.products1P));
                    } catch  {
                        is3P = false;
                    }
                    return {
                        id: link.id,
                        category: link.category,
                        is3P: is3P
                    };
                }) : undefined,
                hasLinkInDescription: hasLinkInDescription
            }
        };
    }) || [];
};
/**
 * Relay and RSS results have different types
 * Shared code (like result analytics) has typing assuming RSS
 * We solve this by building interfaces that accept both, such as IAnalyticsSearchPageResults
 *
 * We likely need a better approach for coalescing RSS and Relay result node typing, for shared code as we migrate away from RSS
 */ const $e283d0740cdc7b40$var$transformResultsForAnalytics = (edges)=>{
    const nodes = edges?.filter((edge)=>!!edge?.node) // drop undefined nodes
    ?.map((edge)=>{
        const node = edge.node;
        return {
            id: node?.id || '',
            __typename: node?.__typename || '',
            integrationId: node?.integrationId || '',
            providerId: node?.providerId || '',
            socialSignal: node?.socialSignal?.signal ? node?.socialSignal : null,
            connectorType: node?.connectorType || null
        };
    }) || [];
    return {
        edges: nodes.map((node)=>{
            return {
                node: node
            };
        })
    };
};





/**
 * @generated SignedSource<<d1852bfb0fe0e570e146416ccf225080>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
/**
 * @generated SignedSource<<5dc82efbac195c8c4ee55c5e0e8b6266>>
 * @relayHash c0137dc6045fd8bc5ac579c0af494372
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 62ce9e2fbf44cfb184a0ee9f8da89b3a89c675f3cb47fe5725e846344017217c
const $ee6baca67a7541ac$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cql"
        },
        {
            "defaultValue": 30,
            "kind": "LocalArgument",
            "name": "first"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v2 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v3 = [
        v1 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "cql",
            "variableName": "cql"
        },
        v2 /*: any*/ 
    ], v4 = {
        "kind": "ScalarField",
        "name": "ari"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SearchResultsCQLPaginationQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "searchResultsCql_AtlassianSearchPage"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SearchResultsCQLPaginationQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "ConfluenceSearchResponse",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "url"
                                        },
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "content",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "type"
                                                },
                                                {
                                                    "concreteType": "Space",
                                                    "kind": "LinkedField",
                                                    "name": "space",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                                                            "kind": "LinkedField",
                                                            "name": "links",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "webui"
                                                                }
                                                            ]
                                                        },
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "excerpt"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastModified"
                                        },
                                        {
                                            "concreteType": "LinksContextBase",
                                            "kind": "LinkedField",
                                            "name": "links",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "base"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "filters": [
                        "cql"
                    ],
                    "handle": "connection",
                    "key": "SearchResultsCQLPagination__confluence_search",
                    "kind": "LinkedHandle",
                    "name": "confluence_search"
                }
            ]
        },
        "params": {
            "id": "62ce9e2fbf44cfb184a0ee9f8da89b3a89c675f3cb47fe5725e846344017217c",
            "metadata": {},
            "name": "SearchResultsCQLPaginationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ee6baca67a7541ac$var$node.hash = "51b24e33621d3475cf8b3ace0b87f653";
var $ee6baca67a7541ac$export$2e2bcd8739ae039 = $ee6baca67a7541ac$var$node;


const $893fbbd3862eadef$var$node = function() {
    var v0 = [
        "confluence_search"
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "cql"
            },
            {
                "defaultValue": 30,
                "kind": "LocalArgument",
                "name": "first"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $ee6baca67a7541ac$export$2e2bcd8739ae039)
            }
        },
        "name": "searchResultsCql_AtlassianSearchPage",
        "selections": [
            {
                "alias": "confluence_search",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "cql",
                        "variableName": "cql"
                    }
                ],
                "concreteType": "ConfluenceSearchConnection",
                "kind": "LinkedField",
                "name": "__SearchResultsCQLPagination__confluence_search_connection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ConfluenceSearchResponseEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "ConfluenceSearchResponse",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "url"
                                    },
                                    {
                                        "concreteType": "Content",
                                        "kind": "LinkedField",
                                        "name": "content",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "ari"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "searchResultCql_AtlassianSearchPage"
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            }
                        ]
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$893fbbd3862eadef$var$node.hash = "51b24e33621d3475cf8b3ace0b87f653";
var $893fbbd3862eadef$export$2e2bcd8739ae039 = $893fbbd3862eadef$var$node;



























/**
 * @generated SignedSource<<1fb4ea18b58920066755e99211a52974>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $69230a8b786d4754$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "searchResultCql_AtlassianSearchPage",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "confluenceSearchResponse_AtlassianSearchPage"
        }
    ],
    "type": "ConfluenceSearchResponse"
};
$69230a8b786d4754$var$node.hash = "cd25c423f4524a66fa1d1282afb1b2aa";
var $69230a8b786d4754$export$2e2bcd8739ae039 = $69230a8b786d4754$var$node;


parcelRequire("42omo");












/**
 * @generated SignedSource<<fbc53bbabd98ee091967714ea96ccf0e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $db143c259e453ad6$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "ari"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "confluenceSearchResponse_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            {
                "kind": "ScalarField",
                "name": "url"
            },
            {
                "kind": "ScalarField",
                "name": "lastModified"
            },
            {
                "concreteType": "LinksContextBase",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "base"
                    }
                ]
            },
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "name"
                            },
                            {
                                "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                                "kind": "LinkedField",
                                "name": "links",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "webui"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "ConfluenceSearchResponse"
    };
}();
$db143c259e453ad6$var$node.hash = "56720713632e89616c1b52d367ff72b8";
var $db143c259e453ad6$export$2e2bcd8739ae039 = $db143c259e453ad6$var$node;































































const $9226716d140bc3a4$export$22448a5b1a6731f4 = ({ node: node, position: position, cloudId: cloudId, searchQuery: query, searchSessionId: searchSessionId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $db143c259e453ad6$export$2e2bcd8739ae039), node);
    const [features] = (0, $4Qo4W.useFeatures)();
    const isSideBySideEnabled = features?.sideBySide?.enabled;
    const { commonAttributes: commonAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const { getFeatureGate: getFeatureGate, isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $7WbA8.useAppContext)();
    const model = (0, $42omo.useMemo)(()=>({
            id: data?.content?.ari || '',
            title: data?.title,
            description: data?.excerpt,
            type: data?.content?.type || '',
            url: `${data?.links?.base}${data?.url}`,
            lastModified: data?.lastModified,
            isVerified: null,
            space: data?.content?.space?.ari && data?.content?.space?.name ? {
                id: data.content.space.ari,
                name: data.content.space.name,
                webUiLink: data.content.space.links?.webui
            } : null,
            socialSignal: null
        }), [
        data
    ]);
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(model.id);
        let containerId = null;
        if (model.space?.id) {
            const [, , , spaceId] = (0, $6h3V2.getProductAndIDFromARI)(model.space.id);
            containerId = spaceId;
        }
        return {
            id: model.id,
            containerId: containerId,
            spaceId: containerId,
            contentType: model.type,
            entityType: model.type,
            contentId: contentId,
            product: product,
            isSideBySideEnabled: isSideBySideEnabled
        };
    }, [
        model,
        isSideBySideEnabled
    ]);
    const searchResultForConversationStarters = (0, $42omo.useMemo)(()=>{
        const { serveExperiment: serveConversationStartersExperiment } = (0, $eUEtI.getSAINLayerFrontendExperiment)({
            abTestId: 'kd_convo_starters_in_search'
        });
        const isConversationStartersEnabled = serveConversationStartersExperiment || getFeatureGate('kd_convo_starters_dogfooding');
        const isPageOrBlogpost = [
            'page',
            'blogpost'
        ].includes(model.type);
        const searchResultForConversationStarters = isPageOrBlogpost && isConversationStartersEnabled && position === 0 && appMode === (0, $9vOy1.ApplicationModes).Rovo && (0, $eb4a02b80e2ab764$export$3afecd2a83596299)(appMode, isAdminHubAIEnabled, isRovoLLMEnabled) ? {
            ari: model.id,
            url: model.url
        } : null;
        return searchResultForConversationStarters;
    }, [
        appMode,
        getFeatureGate,
        isAdminHubAIEnabled,
        isRovoLLMEnabled,
        model.id,
        model.type,
        model.url,
        position
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const metadataParts = [
        [
            'type',
            (0, $kXlQy.getSearchResultType)(model.type)
        ],
        [
            'last-modified',
            model.lastModified && /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                lastModified: model.lastModified
            })
        ]
    ];
    let icon;
    if (model.type && (0, $dh538.fg)('rovo_search_confluence_icons_fps')) icon = (0, $2waBy.getConfluenceEntityIcon)({
        iconUrl: undefined,
        type: model.type,
        size: 'medium'
    });
    else icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.ConfluenceIcon), {
        size: "medium",
        shouldUseNewLogoDesign: true
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: model.id,
        product: (0, $1yEFx.ProductKeys).Confluence,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: (0, $icWhS.getConfluenceUrlWithAnalyticsQueryParams)({
            url: model.url,
            query: query,
            searchSessionId: searchSessionId
        }),
        title: (0, $Y34Hw.enrichExcerpt)(model.title),
        icon: icon,
        headerMetadataParts: metadataParts,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: (0, $Y34Hw.processExcerpt)(model.description)
        }),
        cloudId: cloudId,
        position: position,
        appMode: appMode,
        mainContentWidth: mainContentWidth,
        hideSummarizeInChat: !!searchResultForConversationStarters,
        footer: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            children: cloudId && searchResultForConversationStarters && /*#__PURE__*/ (0, $l998X.jsx)((0, $383edc9b6c74463d$export$10e76ebde8d3ea11), {
                primaryProduct: primaryProduct,
                cloudId: cloudId,
                searchResult: searchResultForConversationStarters,
                analyticsAttributes: {
                    resultMetadata: metadata,
                    ...commonAttributes
                }
            })
        })
    });
};


const $2d6479d83ab325a8$export$d26e7574d0f17b15 = ({ node: node, position: position, cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs, availableProducts: availableProducts, selectedProduct: selectedProduct, searchQuery: searchQuery, searchSessionId: searchSessionId, primaryProduct: primaryProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $69230a8b786d4754$export$2e2bcd8739ae039), node);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            position === (0, $bdefbb7f72d12f38$export$b9f6f9f70138c961) && /*#__PURE__*/ (0, $l998X.jsx)((0, $14f5a0c0b568e7eb$export$df17046610238203), {
                availableProducts: availableProducts,
                cloudId: cloudId,
                selectedProduct: selectedProduct,
                thirdPartyConfigs: thirdPartyConfigs
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
                section: "SearchPageResultRecordCQL",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9226716d140bc3a4$export$22448a5b1a6731f4), {
                    appMode: appMode,
                    cloudId: cloudId,
                    mainContentWidth: mainContentWidth,
                    node: data,
                    position: position,
                    primaryProduct: primaryProduct,
                    searchQuery: searchQuery,
                    searchSessionId: searchSessionId,
                    selectedProduct: selectedProduct
                })
            })
        ]
    });
};





const $29779de3a21de1c2$var$noop = ()=>{};
/**
 * Separated out the results logic and rendering as the relay fragment and pagination
 * adds significant bulk to the component, making it hard to read and test.
 */ const $29779de3a21de1c2$var$SearchResultCQLWithData = ({ availableProducts: availableProducts, backendExperimentRef: backendExperimentRef, bodyRef: bodyRef, clearReferrer: clearReferrer, cloudId: cloudId, edges: edges, experimentConfig: experimentConfig, getSelectedFilters: getSelectedFilters, isLoadingNext: isLoadingNext, isJiraIssueIndexed: isJiraIssueIndexed, isPaginatedQuery: isPaginatedQuery, maxResultsToShow: maxResultsToShow, productDataRegions: productDataRegions, productEdition: productEdition, referrer: referrer, searchQuery: searchQuery, searchResultsCQLQueryReference: searchResultsCQLQueryReference, searchSessionId: searchSessionId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, mainContentWidth: mainContentWidth, setMaxResultsToShow: setMaxResultsToShow, setResultsState: setResultsState, thirdPartyConfigs: thirdPartyConfigs })=>{
    (0, $320af85988d7ec69$export$2e2bcd8739ae039)();
    (0, $42omo.useEffect)(()=>{
        setResultsState(edges.length === 0 ? (0, $fZ3l2.ResultsStates).NO_RESULTS : (0, $fZ3l2.ResultsStates).RESULTS);
    }, [
        edges,
        setResultsState
    ]);
    const edgesToDisplay = (0, $d36edf17876c264b$export$e8402efe3c056aa3)({
        bodyRef: bodyRef,
        edges: edges,
        maxResultsToShow: maxResultsToShow,
        setMaxResultsToShow: setMaxResultsToShow,
        queryReference: searchResultsCQLQueryReference
    });
    (0, $f393218d2c2b7af2$export$7148f5ed0307d6ed)({
        edges: edges,
        searchSessionId: searchSessionId
    });
    const resultsForAnalytics = (0, $42omo.useMemo)(()=>$29779de3a21de1c2$var$transformEdgesToResultsForAnalytics(edges), [
        edges
    ]);
    const resultsShown = (0, $42omo.useMemo)(()=>$29779de3a21de1c2$var$transformEdgesToResultsShown(edges), [
        edges
    ]);
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    (0, $ec36d7d4426f2eb3$export$8554996556b9ba1)({
        are3pResultsShown: false,
        backendExperimentRef: backendExperimentRef,
        clearReferrer: clearReferrer,
        cloudId: cloudId,
        commonAttributes: commonAttributes,
        edges: edges,
        experimentConfig: experimentConfig,
        getSelectedFilters: getSelectedFilters,
        isJiraIssueIndexed: isJiraIssueIndexed,
        isLoadingNext: isLoadingNext,
        isPaginatedQuery: isPaginatedQuery,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes,
        productDataRegions: productDataRegions,
        productEdition: productEdition,
        productsWithTimeoutsFromErrors: undefined,
        referrer: referrer,
        resultsForAnalytics: resultsForAnalytics,
        resultsShown: resultsShown,
        searchQuery: searchQuery
    });
    return edges.length > 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: edgesToDisplay.flatMap((edge)=>edge?.node ? [
                edge.node
            ] : []).map((node, position)=>{
            const key = node.content?.ari || node.url || String(position);
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $2d6479d83ab325a8$export$d26e7574d0f17b15), {
                appMode: appMode,
                availableProducts: availableProducts,
                cloudId: cloudId,
                mainContentWidth: mainContentWidth,
                node: node,
                position: position,
                primaryProduct: primaryProduct,
                searchQuery: searchQuery,
                searchSessionId: searchSessionId,
                selectedProduct: selectedProduct,
                thirdPartyConfigs: thirdPartyConfigs
            }, key);
        })
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $88900765e2dbc6d9$export$f8a5875a19110e65), {
        filtersEnabled: false,
        clearFilters: $29779de3a21de1c2$var$noop
    });
};
const $29779de3a21de1c2$export$41bc27d9d5d29437 = (props)=>{
    const { searchResultsCQLQueryReference: searchResultsCQLQueryReference } = props;
    const preloadedQueryData = (0, $irOoi.usePreloadedQuery)((0, $atY36.default), searchResultsCQLQueryReference);
    // Pagination hasPrevious state (hasPreviousPage from usePaginationFragment does not work with aggregator)
    // See https://hello.atlassian.net/wiki/x/lYYyQQE
    const hasPreviousRef = (0, $42omo.useRef)(false);
    const { data: data, loadNext: loadNext, isLoadingNext: isLoadingNext } = (0, $irOoi.usePaginationFragment)((0, $893fbbd3862eadef$export$2e2bcd8739ae039), preloadedQueryData);
    const cursor = data.confluence_search?.pageInfo?.endCursor;
    const fetchNextPage = (0, $42omo.useCallback)((nextCursor)=>{
        // Double check we're fetching with the cursor from our current results
        if (nextCursor === cursor) {
            loadNext(30);
            hasPreviousRef.current = true;
        }
    }, [
        loadNext,
        cursor
    ]);
    const edges = (0, $42omo.useMemo)(()=>{
        const rawEdges = data.confluence_search?.edges || [];
        return rawEdges.flatMap((edge)=>edge?.node ? [
                {
                    node: edge.node
                }
            ] : []);
    }, [
        data.confluence_search?.edges
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $280ef4355050ad69$export$92697b2a267ec7ef), {
        containsSearchResults: edges.length > 0,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($29779de3a21de1c2$var$SearchResultCQLWithData, {
                ...props,
                edges: edges,
                isLoadingNext: isLoadingNext,
                isPaginatedQuery: hasPreviousRef.current
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3d6c58437980e8c0$export$2e2bcd8739ae039), {
                cursor: cursor,
                isLoading: isLoadingNext,
                fetchNextPage: fetchNextPage
            })
        ]
    });
};
const $29779de3a21de1c2$var$transformEdgesToResultsForAnalytics = (edges)=>{
    return {
        edges: edges.map((edge)=>({
                node: {
                    id: edge.node.content?.ari || '',
                    __typename: edge.node.__typename,
                    integrationId: '',
                    providerId: ''
                }
            }))
    };
};
const $29779de3a21de1c2$var$transformEdgesToResultsShown = (edges)=>{
    return edges.map((edge, index)=>({
            id: edge.node.content?.ari || '',
            product: (0, $1yEFx.ProductKeys).Confluence,
            position: index,
            metadata: {}
        }));
};



const $4fce253db54ab402$var$autoCorrectStyles = {
    root: "_fiawglyw"
};
const $4fce253db54ab402$var$SearchPageBody = ({ aggAbsoluteUrl: aggAbsoluteUrl })=>{
    const [relaySearchResults, loadSearchResultsQuery, disposeSearchResultsQuery] = (0, $irOoi.useQueryLoader)((0, $7Ngf7.default));
    const [relayRightPanel, loadRightPanelQuery, disposeRightPanelQuery] = (0, $irOoi.useQueryLoader)((0, $71b133da64a47244$export$2e2bcd8739ae039));
    const [searchResultsCQLQueryReference, loadSearchResultsCQLQuery, disposeSearchResultsCQLQuery] = (0, $irOoi.useQueryLoader)((0, $atY36.default));
    const [resultsState, setResultsState] = (0, $42omo.useState)((0, $fZ3l2.ResultsStates).INITIAL);
    const { queryParams: queryParams, isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $7WbA8.useAppContext)();
    const { clearAllFilters: clearAllFilters, resetSort: resetSort } = (0, $djVCD.useSearchActions)();
    const { clearReferrer: clearReferrer } = (0, $j4ply.useBootstrapActions)();
    const logError = (0, $f8oYd.useLogException)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    // Local state for bootstrap, search, and selected input filters to update when Relay query resolves
    const [bootstrap, setBootstrap] = (0, $42omo.useState)(()=>(0, $dc3d3be87137607c$export$cfd0a4eecdb5b49d)((0, $aaNIP.initialState)));
    const [search, setSearch] = (0, $42omo.useState)(()=>(0, $dc3d3be87137607c$export$3761754c69bcbfc2)((0, $djVCD.initialState)));
    const [federatedSlackCount, setFederatedSlackCount] = (0, $42omo.useState)(null);
    const [federatedOutlookMailCount, setFederatedOutlookMailCount] = (0, $42omo.useState)(null);
    const [hasRecordedAvailableProducts, setHasRecordedAvailableProducts] = (0, $42omo.useState)(false);
    const [productsWithTimeout, setProductsWithTimeout] = (0, $42omo.useState)();
    const [personalisedProductSections, setPersonalisedProductSections] = (0, $42omo.useState)();
    // Error boundary reset handling - creates a ref to store the reset callback
    // Calling resetErrorBoundary() will invoke the reset on the ErrorBoundary component without a remount
    const errorBoundaryResetCbRef = (0, $42omo.useRef)(undefined);
    const setErrorBoundaryResetCb = (0, $42omo.useCallback)((cb)=>{
        errorBoundaryResetCbRef.current = cb; // undefined acts as a cleanup
    }, []);
    const resetErrorBoundary = (0, $42omo.useCallback)(()=>{
        errorBoundaryResetCbRef.current?.();
    }, []);
    const bodyRef = (0, $42omo.useRef)(null);
    const mainContentRef = (0, $42omo.useRef)(null);
    const [maxResultsToShow, setMaxResultsToShow] = (0, $42omo.useState)(undefined);
    const [mainContentWidth, setMainContentWidth] = (0, $42omo.useState)(undefined);
    const { cloudId: cloudId, primaryProduct: primaryProduct, searchSessionId: searchSessionId, isRovoEnabled: isRovoEnabled, allFilterExcludedProducts: allFilterExcludedProducts, thirdPartyConfigs: thirdPartyConfigs, experimentConfig: experimentConfig, productEdition: productEdition, productDataRegions: productDataRegions, isJiraIssueIndexed: isJiraIssueIndexed, user: maybeUser, nouns: nouns, isNounsAvailable: isNounsAvailable, referrer: referrer } = bootstrap;
    const { searchQuery: searchQuery, filters: filters, jsmIncidentFilterIds: jsmIncidentFilterIds, selectedProducts: selectedProducts, availableProducts: availableProducts, selectedDatasource: rawSelectedDatasource } = search;
    const selectedProduct = selectedProducts[0];
    const selectedDatasource = rawSelectedDatasource ?? undefined;
    const appMode = (0, $NwuTK.getApplicationMode)({
        isRovoEnabled: isRovoEnabled
    });
    const user = (0, $42omo.useMemo)(()=>(0, $NwuTK.getUser)(maybeUser), [
        maybeUser
    ]);
    /**
   * QS-7760
   *
   * Our search page DOM looks like this:
   * - 1. Input
   * - 2. Autocorrect
   * - 3. SAIN
   * - 4. Results list
   *
   * 2 and 4 comes from the search query, which suspends.
   * 3 needs to be rendered immediately to begin the SAIN query (which can show before results return), but also needs to render between 2 and 4 in DOM
   * So we use a portal to insert 2 above 3
   * Otherwise 3 will be within the common suspense parent of 2 and 4, and not render until the query is resolved
   * We also dont want to shw 3 in the suspense fallback, as when suspense finishes a remount is triggered (which flashes the SAIN UI)
   *
   * We considered splitting 2 and 4 but would need to implement `usePreloadedQuery` independently (with all pagination, query vars etc) but decided to take this approach to reduce the risk surface/complexity of the queries changing
   */ const autoCorrectPortalRef = (0, $42omo.useRef)(null);
    const autoCorrectPortal = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $4fce253db54ab402$var$autoCorrectStyles.root,
        ref: autoCorrectPortalRef
    });
    // Ref to the SAIN portal which is used by the Navigational Card that's rendered in the smart answer component
    const smartAnswersPortalRef = (0, $42omo.useRef)(null);
    // Ref for backend experiment data used when fetching search results
    const backendExperimentRef = (0, $42omo.useRef)();
    // Ideally we can refactor filters so that we run this function only when the filters change.
    // This would allow us to have the object in state.
    const getSelectedFilters = (0, $42omo.useMemo)(()=>()=>(0, $4VkIo.getSelectedFilters)({
                filters: filters,
                selectedProducts: selectedProducts,
                availableProducts: availableProducts,
                allFilterExcludedProducts: allFilterExcludedProducts,
                thirdPartyConfigs: thirdPartyConfigs,
                jsmIncidentFilterIds: jsmIncidentFilterIds,
                currentUserId: user?.id
            }), [
        filters,
        selectedProducts,
        availableProducts,
        allFilterExcludedProducts,
        thirdPartyConfigs,
        jsmIncidentFilterIds,
        user?.id
    ]);
    const resultsLoading = /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
        name: "search-page-results-loading",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e0d9e2bc48f29be1$export$18a2402e95ebb069), {
            rowCount: 10
        })
    });
    const resultsConfigLoading = /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
        name: "search-page-results-config-loading",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e0d9e2bc48f29be1$export$18a2402e95ebb069), {
            rowCount: 10
        })
    });
    /**
   * Our use of:
   * 1. Suspense -> RightpanelContainer
   * 2. rightPanelLoading -> Suspense<fallback={rightPanelLoading}>
   * 3. AppFilterSidebarLoading
   *
   * Is so that we get a loading state on counts:
   * - 3 is the skeleton state (during bootstrap, no connectors) - HOLD(seach-page-right-panel-config-loading)
   * - 2 is the suspense state (during search, no counts, has connectors) - HOLD(seach-page-right-panel-counts-loading)
   * - 1 is the end state (counts!)
   *
   * Note that FG(rovo-search-right-rail-personalisation) modifies this to:
   * - 3 is the skeleton state (during bootstrap, no connectors) - HOLD(seach-page-right-panel-config-loading)
   * - 2 is the suspense state (during counts query, no RR rendered) - HOLD(seach-page-right-panel-loading)
   * - 1 is the end state (connectors + counts!)
   *
   * Problem is when we render 1, we throw away 2 which isn't great for performance.
   *
   * https://product-fabric.atlassian.net/browse/QS-7802 for improvement
   */ const rightPanelWithoutResultCounts = /*#__PURE__*/ (0, $l998X.jsx)((0, $7cc050d1a4a09085$export$364a989a35814102), {
        cloudId: cloudId,
        searchQuery: searchQuery,
        primaryProduct: primaryProduct,
        experimentConfig: experimentConfig,
        selectedProducts: selectedProducts,
        user: user,
        appMode: appMode,
        selectedProduct: selectedProduct,
        selectedDatasource: selectedDatasource,
        availableNouns: nouns,
        availableProducts: availableProducts,
        isNounsAvailable: isNounsAvailable,
        thirdPartyConfigs: thirdPartyConfigs,
        personalisedProductSections: personalisedProductSections,
        productsWithTimeout: productsWithTimeout
    });
    const rightPanelWithLoadingResultCounts = /*#__PURE__*/ (0, $l998X.jsx)((0, $7cc050d1a4a09085$export$364a989a35814102), {
        cloudId: cloudId,
        searchQuery: searchQuery,
        primaryProduct: primaryProduct,
        experimentConfig: experimentConfig,
        selectedProducts: selectedProducts,
        user: user,
        appMode: appMode,
        selectedProduct: selectedProduct,
        selectedDatasource: selectedDatasource,
        availableNouns: nouns,
        availableProducts: availableProducts,
        isNounsAvailable: isNounsAvailable,
        thirdPartyConfigs: thirdPartyConfigs,
        personalisedProductSections: personalisedProductSections,
        productsWithTimeout: productsWithTimeout,
        resultCountsLoading: true
    });
    // In this state the RR has connectors but no counts
    const rightPanelWithoutResultCountsLoading = /*#__PURE__*/ (0, $l998X.jsxs)((0, $fwDOR.default), {
        name: "search-page-right-panel-counts-loading",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $f43a1e29196bf274$export$3c6a6c4c70845302), {
                setProductsWithTimeout: setProductsWithTimeout
            }),
            rightPanelWithoutResultCounts
        ]
    });
    // In this state, we're waiting for 1P+3P config to be available
    const rightPanelConfigLoadingSkeleton = /*#__PURE__*/ (0, $l998X.jsxs)((0, $fwDOR.default), {
        name: "search-page-right-panel-config-loading",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $f43a1e29196bf274$export$3c6a6c4c70845302), {
                setProductsWithTimeout: setProductsWithTimeout
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $7cc050d1a4a09085$export$98c4d2ac9cd9730), {})
        ]
    });
    // In this state, we're waiting for the RR to be ready
    const rightPanelLoadingSkeleton = /*#__PURE__*/ (0, $l998X.jsxs)((0, $fwDOR.default), {
        name: "search-page-right-panel-loading",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $f43a1e29196bf274$export$3c6a6c4c70845302), {
                setProductsWithTimeout: setProductsWithTimeout
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $7cc050d1a4a09085$export$98c4d2ac9cd9730), {})
        ]
    });
    // In this state, we're waiting for the RR to be ready, but apps are visible
    const rightPanelLoadingSkeletonWithAppsVisible = /*#__PURE__*/ (0, $l998X.jsxs)((0, $fwDOR.default), {
        name: "search-page-right-panel-counts-loading",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $f43a1e29196bf274$export$3c6a6c4c70845302), {
                setProductsWithTimeout: setProductsWithTimeout
            }),
            rightPanelWithLoadingResultCounts
        ]
    });
    // Log a health metric for accessible products
    (0, $42omo.useEffect)(()=>{
        if ((0, $dh538.fg)('rovo-search-accessible-products-healthmetric')) // When null or empty bootstrap isn't ready. Even failed bootstrap will have primaryProduct in the set
        {
            if (availableProducts && availableProducts.length > 0 && !hasRecordedAvailableProducts) {
                fireAnalyticsEvent((0, $0e1691e3261af771$export$abd5de3aada5ec8b)({
                    availableProducts: availableProducts,
                    searchSessionId: searchSessionId
                }));
                setHasRecordedAvailableProducts(true);
            }
        }
    }, [
        availableProducts,
        hasRecordedAvailableProducts,
        fireAnalyticsEvent,
        searchSessionId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!(0, $2OtFZ.serveSearchPageTimeoutsUX)()) return;
        if (searchQuery.length === 0) setProductsWithTimeout(undefined);
    }, [
        searchQuery
    ]);
    // Clean up on unmount
    (0, $42omo.useEffect)(()=>()=>{
            // Dispose query updated time
            (0, $20r3r.disposeQueryUpdatedTime)();
        }, []);
    const bootstrapReady = availableProducts.length > 0;
    const hasAnyFilterSelected = (0, $42omo.useMemo)(()=>Boolean(selectedProduct) || Object.values(filters).some((filter)=>filter?.hasSelection), [
        selectedProduct,
        filters
    ]);
    // Derive mode from the same local mirror state used for rendering.
    const mode = (0, $42omo.useMemo)(()=>(0, $411ad342376b971d$export$87ba7e4f15231598)({
            bootstrapReady: bootstrapReady,
            availableProducts: availableProducts,
            selectedProduct: selectedProduct,
            searchQuery: searchQuery,
            hasAnyFilterSelected: hasAnyFilterSelected,
            cql: search.cql
        }), [
        bootstrapReady,
        availableProducts,
        selectedProduct,
        searchQuery,
        hasAnyFilterSelected,
        search.cql
    ]);
    const newProductMessageBanner = (0, $42omo.useMemo)(()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $c00f6725a09cf8c9$export$37ce7744bd1ee394), {
            searchQuery: searchQuery,
            selectedProduct: selectedProduct,
            selectedProducts: selectedProducts,
            primaryProduct: primaryProduct,
            cloudId: cloudId,
            experimentConfig: experimentConfig,
            user: user,
            applicationMode: appMode
        }), [
        searchQuery,
        selectedProduct,
        selectedProducts,
        primaryProduct,
        cloudId,
        experimentConfig,
        user,
        appMode
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $522e970424cd3461$export$d152b66e844f2488), {
                loadSearchResultsQuery: loadSearchResultsQuery,
                disposeSearchResultsQuery: disposeSearchResultsQuery,
                loadRightPanelQuery: loadRightPanelQuery,
                disposeRightPanelQuery: disposeRightPanelQuery,
                loadSearchResultsCQLQuery: loadSearchResultsCQLQuery,
                disposeSearchResultsCQLQuery: disposeSearchResultsCQLQuery,
                setBootstrap: setBootstrap,
                setSearch: setSearch,
                setResultsState: setResultsState,
                resetErrorBoundary: resetErrorBoundary,
                bodyRef: bodyRef,
                setMaxResultsToShow: setMaxResultsToShow,
                backendExperimentRef: backendExperimentRef,
                isAdminHubAIEnabled: isAdminHubAIEnabled,
                isRovoLLMEnabled: isRovoLLMEnabled,
                logError: logError
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $f8be7d82aac68e80$export$4b2c32e08f77ff18), {
                bodyRef: bodyRef,
                mainContentRef: mainContentRef,
                setMainContentWidth: setMainContentWidth,
                selectedProduct: selectedProduct,
                primaryProduct: primaryProduct,
                rightPanel: /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
                    section: "SearchPageRelayRightPanel",
                    fallback: rightPanelWithoutResultCounts,
                    children: bootstrapReady ? // In RESULTS mode we suspend on the counts query, otherwise we render the prequery right rail.
                    mode === 'RESULTS' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                        fallback: (0, $dh538.fg)('rovo-search-right-rail-personalisation') ? personalisedProductSections && (0, $2OtFZ.serveSearchPageTimeoutsUX)() ? rightPanelLoadingSkeletonWithAppsVisible : rightPanelLoadingSkeleton : rightPanelWithoutResultCountsLoading,
                        children: relayRightPanel ? /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
                            name: "search-page-right-panel",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7cc050d1a4a09085$export$e37cfb5282d612c2), {
                                cloudId: cloudId,
                                searchQuery: searchQuery,
                                primaryProduct: primaryProduct,
                                experimentConfig: experimentConfig,
                                selectedProducts: queryParams?.product ? [
                                    queryParams.product
                                ] : [],
                                user: user,
                                appMode: appMode,
                                rightPanelQuery: relayRightPanel,
                                selectedProduct: queryParams?.product,
                                selectedDatasource: selectedDatasource,
                                availableNouns: nouns,
                                availableProducts: availableProducts,
                                isNounsAvailable: isNounsAvailable,
                                thirdPartyConfigs: thirdPartyConfigs,
                                federatedSlackCount: federatedSlackCount,
                                federatedOutlookMailCount: federatedOutlookMailCount,
                                personalisedProductSections: personalisedProductSections,
                                setPersonalisedProductSections: setPersonalisedProductSections,
                                productsWithTimeout: productsWithTimeout
                            })
                        }) : rightPanelWithoutResultCountsLoading
                    }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $f43a1e29196bf274$export$3c6a6c4c70845302), {
                                setProductsWithTimeout: setProductsWithTimeout
                            }),
                            rightPanelWithoutResultCounts
                        ]
                    }) : rightPanelConfigLoadingSkeleton
                }),
                children: [
                    autoCorrectPortal,
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
                        name: "search-page-sain",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $524a29b68b6bf0ee$export$2e2bcd8739ae039), {
                            resultsState: resultsState,
                            isRelayEnabled: true,
                            smartAnswersPortalRef: smartAnswersPortalRef
                        })
                    }),
                    primaryProduct === (0, $1yEFx.PrimaryProductKeys).Assets && !(0, $dh538.fg)('assets_rovo_search_all') && /*#__PURE__*/ (0, $l998X.jsx)((0, $d7417ff36c8b22bc$export$8d42f71dae8efa55), {}),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
                        section: "SearchPageRelayResults",
                        setErrorBoundaryResetCb: setErrorBoundaryResetCb,
                        onException: ()=>{
                            (0, $bVltF.searchResultsLoadUFOExperienceError)();
                            setResultsState((0, $fZ3l2.ResultsStates).ERROR);
                        },
                        // Note: Using renderWithErrorInfo instead of fallback to ensure Error component
                        // always receives actual error details (not generic "Error" message).
                        // This enables:
                        // 1. Specific error messages in VitalStats taskFail events (e.g., "NetworkError: Failed to fetch")
                        // 2. Better error tracking and debugging
                        // 3. Single rendering path for consistency
                        renderWithErrorInfo: ({ error: error, errorInfo: errorInfo })=>{
                            // Evaluate feature gate unconditionally to ensure exposure tracking
                            // (required by @atlaskit/platform/no-preconditioning linter rule)
                            const showErrorDetails = (0, $dh538.fg)('result_error_info_in_non_prod');
                            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                children: [
                                    showErrorDetails && false,
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $e0e03289eec21c4f$export$edf27be85e5f6da0), {
                                        fetchResults: ()=>window.location.reload(),
                                        error: error
                                    })
                                ]
                            });
                        },
                        children: mode === 'BOOTSTRAP_LOADING' ? resultsConfigLoading : mode === 'LANDING' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
                            name: "search-page-results-landing",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $448d3451574c04df$export$12449a31c6671d53), {
                                applicationMode: appMode,
                                isAdminHubAIEnabled: isAdminHubAIEnabled,
                                isRovoLLMEnabled: isRovoLLMEnabled
                            })
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                            fallback: resultsLoading,
                            children: mode === 'RESULTS' && relaySearchResults ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $hnvzE.default), {
                                name: "search-page-results",
                                children: [
                                    newProductMessageBanner,
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $e283d0740cdc7b40$export$aee53da69e9839be), {
                                        searchResultsQuery: relaySearchResults,
                                        aggAbsoluteUrl: aggAbsoluteUrl,
                                        autoCorrectPortalRef: autoCorrectPortalRef,
                                        smartAnswersPortalRef: smartAnswersPortalRef,
                                        setResultsState: setResultsState,
                                        searchQuery: searchQuery,
                                        cloudId: cloudId,
                                        primaryProduct: primaryProduct,
                                        selectedProduct: selectedProduct,
                                        thirdPartyConfigs: thirdPartyConfigs,
                                        availableProducts: availableProducts,
                                        searchSessionId: searchSessionId,
                                        experimentConfig: experimentConfig,
                                        productEdition: productEdition,
                                        productDataRegions: productDataRegions,
                                        isJiraIssueIndexed: isJiraIssueIndexed,
                                        appMode: appMode,
                                        getSelectedFilters: getSelectedFilters,
                                        clearFilters: ()=>{
                                            clearAllFilters();
                                            resetSort();
                                        },
                                        clearReferrer: clearReferrer,
                                        referrer: referrer,
                                        logError: logError,
                                        setFederatedSlackCount: setFederatedSlackCount,
                                        setFederatedOutlookMailCount: setFederatedOutlookMailCount,
                                        setProductsWithTimeout: setProductsWithTimeout,
                                        bodyRef: bodyRef,
                                        maxResultsToShow: maxResultsToShow,
                                        setMaxResultsToShow: setMaxResultsToShow,
                                        mainContentWidth: mainContentWidth,
                                        backendExperimentRef: backendExperimentRef
                                    })
                                ]
                            }) : mode === 'CQL_RESULTS' && searchResultsCQLQueryReference ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $hnvzE.default), {
                                name: "search-page-results-cql",
                                children: [
                                    newProductMessageBanner,
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $29779de3a21de1c2$export$41bc27d9d5d29437), {
                                        availableProducts: availableProducts,
                                        backendExperimentRef: backendExperimentRef,
                                        bodyRef: bodyRef,
                                        clearReferrer: clearReferrer,
                                        cloudId: cloudId,
                                        experimentConfig: experimentConfig,
                                        getSelectedFilters: getSelectedFilters,
                                        isJiraIssueIndexed: isJiraIssueIndexed,
                                        maxResultsToShow: maxResultsToShow,
                                        productDataRegions: productDataRegions,
                                        productEdition: productEdition,
                                        referrer: referrer,
                                        searchQuery: searchQuery,
                                        searchResultsCQLQueryReference: searchResultsCQLQueryReference,
                                        searchSessionId: searchSessionId,
                                        selectedProduct: selectedProduct,
                                        primaryProduct: primaryProduct,
                                        appMode: appMode,
                                        mainContentWidth: mainContentWidth,
                                        setMaxResultsToShow: setMaxResultsToShow,
                                        setResultsState: setResultsState,
                                        thirdPartyConfigs: thirdPartyConfigs
                                    })
                                ]
                            }) : resultsLoading
                        })
                    })
                ]
            })
        ]
    });
};
const $4fce253db54ab402$export$c3f0fa3e50c0d1e9 = ({ aggAbsoluteUrl: aggAbsoluteUrl })=>{
    const { isNav4Enabled: isNav4Enabled } = (0, $7WbA8.useAppContext)();
    const { primaryProduct: primaryProduct } = (0, $4Qo4W.useBootstrapState)((0, $dc3d3be87137607c$export$cfd0a4eecdb5b49d));
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $849ee461ff61ea47$export$c84671f46d6a1ca), {
        primaryProduct: primaryProduct,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3867e15ac7e3b5d9$export$8b251419efc915eb), {
                primaryProduct: primaryProduct,
                input: isNav4Enabled ? null : /*#__PURE__*/ (0, $l998X.jsx)((0, $7f479a12f1edc810$export$2e2bcd8739ae039), {}),
                filters: /*#__PURE__*/ (0, $l998X.jsx)((0, $99686144b211a11b$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($4fce253db54ab402$var$SearchPageBody, {
                aggAbsoluteUrl: aggAbsoluteUrl
            }),
            (0, $2OtFZ.serve3PBulkConnectWithoutExposure)() && /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
                section: "SearchPageBulkConnectModal",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $NvPpA.BulkConnectModal), {
                    isOnSearchDialog: false,
                    oAuthSource: (0, $ckkm9.OAuthSource).searchPageBulkConnect
                })
            })
        ]
    });
};










const $9b6053aa72d69c53$export$a54ec244c8863715 = ({ shell: shell, callbacks: callbacks, mapUserIdToProfileUrl: mapUserIdToProfileUrl, generateSearchUrl: generateSearchUrl, onNavigate: onNavigate, onSearchResultsShown: onSearchResultsShown })=>{
    const { queryParams: queryParams, isNav4Enabled: isNav4Enabled, isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = shell;
    const getFrontendExperiment = (0, $42omo.useMemo)(()=>(0, $iA4lt.createFrontendExperimentHandler)(), []);
    const getFrontendGate = (0, $42omo.useMemo)(()=>(0, $iA4lt.createFeatureGateHandler)(undefined), []);
    const [isOnline, _] = (0, $42omo.useState)(navigator.onLine);
    (0, $42omo.useEffect)(()=>{
        (0, $c7e627886411fcb9$export$5e3e5ca9e3ba891b)(isOnline, (0, (/*@__PURE__*/$parcel$interopDefault($6df538e2e254fd26$exports))), (0, $c7e627886411fcb9$export$add61e2630a21f9), (0, (/*@__PURE__*/$parcel$interopDefault($d264f14dd361aa2b$exports))), (0, $c7e627886411fcb9$export$4be43fd067fd9d7f));
    }, [
        isOnline
    ]);
    // hold on to the first function reference passed to the package to
    // avoid excessive re-rendering if the consumer doesn't pass in
    // a stable function
    const mapUserIdToProfileUrlRef = (0, $42omo.useRef)(mapUserIdToProfileUrl);
    // Start capturing extensions for SearchResultsQuery, SearchResultsCqlQuery
    (0, $42omo.useMemo)(()=>{
        (0, $4xBBd.startCapturingExtensions)((0, $7Ngf7.default).operation.name);
        (0, $4xBBd.startCapturingExtensions)((0, $atY36.default).operation.name);
    }, []);
    // Clear extensions for SearchResultsQuery, SearchResultsCqlQuery on unmount
    (0, $42omo.useEffect)(()=>()=>{
            (0, $4xBBd.stopCapturingExtensions)((0, $7Ngf7.default).operation.name);
            (0, $4xBBd.stopCapturingExtensions)((0, $atY36.default).operation.name);
        }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: "search-page-relay",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gWF6I.RelayEnvironmentProvider), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $86ob4.WidthObserverProvider), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6cnUO.default), {
                    blanketIsTinted: false,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2bb9aeea11dbc94b$export$f6a06b563a614935), {
                        ...shell,
                        callbacks: callbacks,
                        searchSessionId: (0, $8ec58c33150c42f9$export$e9ddc0ee913bbcbd).value(),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2lmJQ.default), {
                            experience: (0, $hHl3d.SearchExperience).SEARCH_PAGE,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7WbA8.AppContextProvider), {
                                mapUserIdToProfileUrl: mapUserIdToProfileUrlRef.current,
                                generateSearchUrl: generateSearchUrl,
                                queryParams: queryParams,
                                onNavigate: onNavigate,
                                getFrontendExperiment: getFrontendExperiment,
                                getFeatureGate: getFrontendGate,
                                isNav4Enabled: isNav4Enabled,
                                isAdminHubAIEnabled: isAdminHubAIEnabled,
                                isRovoLLMEnabled: isRovoLLMEnabled,
                                onSearchResultsShown: onSearchResultsShown,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dpPtd.FlagsProvider), {
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7bZ3i.SmartCardProvider), {
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3f9016d1e452d4e9$export$119dcb5621de506f), {
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4fce253db54ab402$export$c3f0fa3e50c0d1e9), {
                                                aggAbsoluteUrl: shell.aggAbsoluteUrl
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};


function $c77fa5848e4f5168$export$a54ec244c8863715(props) {
    return (0, $2OtFZ.serveSearchPageRelayExp)(props.shell.primaryProduct, true, props.shell.queryParams) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9b6053aa72d69c53$export$a54ec244c8863715), {
        ...props
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $976e51335fad9db5$export$a54ec244c8863715), {
        ...props
    });
}
function $c77fa5848e4f5168$export$2194eaf953b87e28({ shell: shell, experiments: experiments, ...props }) {
    const shellWithSideBySide = (0, $42omo.useMemo)(()=>({
            ...shell,
            features: {
                sideBySide: {
                    enabled: true,
                    experiments: experiments
                }
            }
        }), [
        shell,
        experiments
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9b6053aa72d69c53$export$a54ec244c8863715), {
        ...props,
        shell: shellWithSideBySide
    });
}


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $1e2E5 = parcelRequire("1e2E5");


var $dQl1W = parcelRequire("dQl1W");








var $aD1SW = parcelRequire("aD1SW");




var $bomBS = parcelRequire("bomBS");


var $gzsfl = parcelRequire("gzsfl");


var $3sFtD = parcelRequire("3sFtD");
















/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




var $1lhEF = parcelRequire("1lhEF");










/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 

























var $cGtPE = parcelRequire("cGtPE");

var $2SlZp = parcelRequire("2SlZp");
















const $aac8e94998d25d17$export$a5e892786b028f3b = {
    ROVO_COMPARISON_TOOL: 'rovoComparisonTool'
};
const $aac8e94998d25d17$export$76a2e4c433c23bb9 = {
    UI: 'ui',
    TRACK: 'track',
    SCREEN: 'screen',
    OPERATIONAL: 'operational'
};
const $aac8e94998d25d17$export$dce83e8417873763 = {
    SEND_UI_EVENT: 'sendUIEvent',
    SEND_TRACK_EVENT: 'sendTrackEvent',
    SEND_SCREEN_EVENT: 'sendScreenEvent',
    SEND_OPERATIONAL_EVENT: 'sendOperationalEvent'
};
const $aac8e94998d25d17$export$85183a312807388d = 'sideBySide';
const $aac8e94998d25d17$export$32fb395bad9ce8e9 = {
    CLOSED: 'closed',
    CANCELED: 'canceled',
    SUBMITTED: 'submitted'
};


const $ef261723362a4155$var$moreIconStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    marginRight: 'space.100',
    marginTop: 'space.100',
    borderRadius: 'radius.small',
    paddingRight: 'space.050',
    paddingLeft: 'space.050',
    paddingTop: 'space.025',
    paddingBottom: 'space.025',
    display: 'flex',
    justifyContent: 'center',
    ':hover': {
        cursor: 'pointer',
        backgroundColor: 'color.background.neutral.hovered',
        textDecoration: 'inherit',
        transitionDuration: '0s, .15s'
    }
});
const $ef261723362a4155$var$contentStyles = (0, $ecnYn.xcss)({
    padding: 'space.150'
});
const $ef261723362a4155$export$311de03a6653ba1b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [isOverrideComplete, setIsOverrideComplete] = (0, $42omo.useState)(false);
    const [flags, setFlags] = (0, $42omo.useState)([]);
    const handleButtonClick = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'optedOut',
            actionSubject: 'sxsOptionsMenu',
            type: (0, $aac8e94998d25d17$export$dce83e8417873763).SEND_TRACK_EVENT,
            eventType: (0, $aac8e94998d25d17$export$76a2e4c433c23bb9).TRACK,
            source: (0, $aac8e94998d25d17$export$85183a312807388d)
        });
        setFlags([
            'flag'
        ]);
        (0, $c6GJD.default).overrideConfig('rovo-search-compare-results-pass-through-rate', {
            cohort: 'off'
        });
        analyticsEvent.fire((0, $aac8e94998d25d17$export$85183a312807388d));
        setIsOverrideComplete(true);
        setIsOpen(false);
    };
    const handleFlagDismissed = ()=>{
        setFlags(flags.slice(1));
    };
    const handleLinkOnClick = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'opened',
            actionSubject: 'sxsOptionsMenu',
            type: (0, $aac8e94998d25d17$export$dce83e8417873763).SEND_TRACK_EVENT,
            eventType: (0, $aac8e94998d25d17$export$76a2e4c433c23bb9).TRACK,
            source: (0, $aac8e94998d25d17$export$85183a312807388d)
        });
        analyticsEvent.fire((0, $aac8e94998d25d17$export$85183a312807388d));
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
                isOpen: isOpen,
                onClose: ()=>setIsOpen(false),
                placement: "bottom-end",
                content: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $ef261723362a4155$var$contentStyles,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2SlZp.default), {
                            maxWidth: 800,
                            minWidth: 150,
                            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $7rvPL.default), {
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $cGtPE.default), {
                                        href: "https://hello.atlassian.net/wiki/x/Uo838w",
                                        target: "_blank",
                                        onClick: handleLinkOnClick,
                                        children: "Why am I seeing this?"
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                                        onClick: handleButtonClick,
                                        children: "Don\u2019t show this again"
                                    })
                                ]
                            })
                        })
                    }),
                trigger: (triggerProps)=>(0, $dh538.fg)('custom-interactive-elements-not-keyboard-focusable') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
                        xcss: $ef261723362a4155$var$moreIconStyles,
                        ...triggerProps,
                        onClick: ()=>setIsOpen(!isOpen),
                        backgroundColor: "color.background.neutral.subtle",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                            color: "currentColor",
                            spacing: "spacious",
                            label: "more_icon"
                        })
                    }) : // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $ef261723362a4155$var$moreIconStyles,
                        ...triggerProps,
                        onClick: ()=>setIsOpen(!isOpen),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                            color: "currentColor",
                            spacing: "spacious",
                            label: "more_icon"
                        })
                    }),
                shouldRenderToParent: (0, $dh538.fg)('should-render-to-parent-should-be-true-search-data')
            }),
            isOverrideComplete && /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
                onDismissed: ()=>{
                    handleFlagDismissed();
                },
                children: flags.map((flagId)=>{
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aD1SW.default), {
                        appearance: "success",
                        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                            color: "currentColor",
                            spacing: "spacious",
                            label: "Success"
                        }),
                        id: flagId,
                        title: "You have opted out. Please refresh the page."
                    }, flagId);
                })
            })
        ]
    });
};


const $d0d436c022e9270f$var$feedbackSectionStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.information',
    position: 'relative',
    height: 'space.800'
});
const $d0d436c022e9270f$export$660e82a991c8cc3f = ({ showForm: showForm, components: components })=>{
    const { form: form } = components;
    // if comparison feedback is submitted, hide this entire section
    if (!showForm) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6cnUO.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5izcQ.default), {
            name: "new",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1lhEF.Pulse), {
                radius: 3,
                pulse: true,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
                    xcss: $d0d436c022e9270f$var$feedbackSectionStyles,
                    templateColumns: "1fr 42px",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
                            justifyContent: 'center',
                            children: showForm && form
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $ef261723362a4155$export$311de03a6653ba1b), {})
                    ]
                })
            })
        })
    });
};

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 














var $cOrQJ = parcelRequire("cOrQJ");

const $7dbe54a0952e496a$export$ef3638635a03b50 = '//atlassian.glean.com/embedded-search-latest.min.js';


const $8076a088bdaec78d$var$containerStyles = (0, $ecnYn.xcss)({
    height: '100%',
    display: 'grid',
    paddingBottom: 'space.400'
});
const $8076a088bdaec78d$export$18038e881128815 = ({ query: query, testId: testId })=>{
    const elementRef = (0, $42omo.useRef)(null);
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    (0, $42omo.useEffect)(()=>{
        if (window && document) {
            const script = document.createElement('script');
            const body = document.getElementsByTagName('body')[0];
            script.src = (0, $7dbe54a0952e496a$export$ef3638635a03b50);
            body.appendChild(script);
            const unbind = (0, $fFa3V.bind)(script, {
                type: 'load',
                listener: ()=>{
                    if (!elementRef.current) return;
                    window.EmbeddedSearch.renderSearchResults(elementRef.current, {
                        query: query,
                        disableAnalytics: true,
                        themeVariant: colorMode || 'light'
                    });
                },
                options: {
                    once: true
                }
            });
            return unbind;
        }
    }, [
        query,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $8076a088bdaec78d$var$containerStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            "data-testid": testId,
            ref: elementRef
        })
    });
};







const $b23c109aabc2ea72$export$12ccd9fcc934a6ea = [
    'product',
    'type',
    'lastModified',
    'titleMatch',
    'createdBy',
    'contributors',
    'owners',
    'spaces',
    'pageStatus',
    'verified',
    'ancestor',
    'labels',
    'archived',
    'jAssignee',
    'jProject',
    'jReporter',
    'jWatchedByMe',
    'jCommentedByMe',
    'referrer',
    'focusAreaTypes',
    'focusAreaUnder',
    'leftExperiments',
    'rightExperiments',
    'from',
    'to',
    'lastUpdatedBy',
    'status',
    'compassArchived',
    'assetsSchema',
    'assetsType'
];


const $129b1c3506be1083$var$setIframeQueryParams = (queryParams)=>{
    let queryParts = [];
    (0, $b23c109aabc2ea72$export$12ccd9fcc934a6ea).forEach((key)=>{
        const value = queryParams[key];
        if (value === undefined) // Skip keys with undefined values
        return;
        if (Array.isArray(value)) // Handle array values by appending multiple key=value pairs
        value.forEach((item)=>{
            if (item !== undefined) // Check item is not undefined
            queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(item)}`);
        });
        else if (typeof value === 'boolean') // Handle boolean values by converting them to strings
        queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`);
        else // Handle string values directly
        queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    });
    return queryParts.join('&');
};
const $129b1c3506be1083$export$6125ab8c5458510e = ({ queryString: queryString, searchSessionId: searchSessionId, queryParams: queryParams })=>{
    const iframeRef = (0, $42omo.useRef)(null);
    const baseUrl = window.location.href.split('?');
    const filterQueryString = $129b1c3506be1083$var$setIframeQueryParams(queryParams);
    return(// eslint-disable-next-line @atlassian/a11y/iframe-has-title
    /*#__PURE__*/ (0, $l998X.jsx)("iframe", {
        ref: iframeRef,
        src: `${baseUrl[0]}?text=${queryString}&isIFramePage=true&searchSessionId=${searchSessionId}&${filterQueryString}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            border: 'none',
            height: '100%',
            width: '100%',
            marginTop: '-80px'
        }
    }));
};




parcelRequire("42omo");

const $7e0cc0f7a78404ca$var$CustomGlyph = (props)=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0_864_48951)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M23.7347 10.8535C22.0134 8.3462 18.4547 12.0362 11.96 12.7862C9.55538 13.0635 7.38872 15.0715 4.59538 14.8802C3.45005 14.8015 1.85072 11.5062 0.653382 12.0315C0.0373822 12.3022 -0.245284 13.2055 0.388049 13.8842L7.42005 22.2749C7.42005 22.2749 7.77738 22.6869 8.98138 22.4015C9.27805 22.4889 13.738 20.7015 16.3167 17.1235C16.934 16.2669 17.67 15.5535 18.432 14.9575C20.906 13.1282 23.5954 12.4909 23.5954 12.4909C23.9394 12.2069 24.02 11.9049 24.0014 11.6429C24.024 11.2055 23.7347 10.8535 23.7347 10.8535Z",
                        fill: "#5C913B"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M7.65065 6.84923C5.12865 10.3492 0.711987 12.0072 0.711987 12.0072C-0.112013 12.7052 0.583987 13.5279 0.583987 13.5279L7.54265 21.7672C7.54265 21.7672 7.89065 22.1786 9.06265 21.8932C9.06265 21.8932 13.4793 20.2386 16.0007 16.7386C18.6 13.1319 23.2873 11.9932 23.2873 11.9932C24.1107 11.2952 23.4153 10.4712 23.4153 10.4712L16.4567 2.23323C16.4567 2.23323 16.1087 1.82123 14.9367 2.10523C14.9367 2.10523 10.25 3.24123 7.65065 6.84923Z",
                        fill: "#A7D28B"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M14.6667 12.9998C16.6917 12.9998 18.3333 11.3582 18.3333 9.33317C18.3333 7.30813 16.6917 5.6665 14.6667 5.6665C12.6416 5.6665 11 7.30813 11 9.33317C11 11.3582 12.6416 12.9998 14.6667 12.9998Z",
                        fill: "#77B255"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M8.58197 21.2862C7.99463 21.2862 7.7793 21.0676 7.74997 21.0342L1.4773 13.7122C1.4653 13.6982 1.1473 13.3342 1.18597 12.8716C1.2093 12.5909 1.35463 12.3409 1.6173 12.1282L1.6593 12.1029C1.69997 12.0869 5.76797 10.4149 8.04797 7.3929L8.1813 7.4929L8.04797 7.3929C10.46 4.19557 14.6206 2.82357 14.662 2.81023C15.8253 2.53957 16.206 2.92623 16.2466 2.97157L22.4366 10.3342C22.448 10.3462 22.7653 10.7116 22.7266 11.1749C22.7033 11.4549 22.558 11.7049 22.2953 11.9176L22.2293 11.9502C22.1886 11.9602 18.1433 12.9656 15.8 16.0709C13.4673 19.1642 9.3953 21.1656 9.35463 21.1849C9.0453 21.2582 8.79063 21.2862 8.58197 21.2862ZM8.0013 20.8149C8.00197 20.8149 8.30263 21.0922 9.24463 20.8736C9.24997 20.8662 13.2506 18.8989 15.5353 15.8709C17.8266 12.8342 21.6853 11.7496 22.1133 11.6369C22.2846 11.4896 22.3793 11.3262 22.3946 11.1509C22.4226 10.8309 22.1866 10.5556 22.1846 10.5529L15.9946 3.18957C15.9933 3.18957 15.6946 2.9129 14.752 3.13157C14.7246 3.1409 10.662 4.48223 8.31463 7.59357C6.07063 10.5676 2.1553 12.2569 1.8093 12.4022C1.63063 12.5522 1.5333 12.7196 1.51797 12.8989C1.4913 13.2162 1.72597 13.4902 1.72797 13.4929L8.0013 20.8149Z",
                        fill: "#5C913B"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M14.184 14.7773L14.18 18.7373L14.5113 19.1306C15.1573 18.5413 15.778 17.8786 16.3147 17.1333C16.8713 16.3613 17.518 15.7006 18.2 15.1426L17.878 14.7593L14.184 14.7773Z",
                        fill: "#FFAC33"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M17.8653 14.7455L9.52797 4.87012C8.85064 5.42745 8.19997 6.07745 7.64664 6.84612C7.10597 7.59678 6.47664 8.25745 5.8233 8.84012L6.79797 9.99412L6.7973 9.99478L14.1806 18.7374C14.834 18.1541 15.456 17.4868 15.9973 16.7354C16.5506 15.9675 17.2006 15.3181 17.8773 14.7608L17.8646 14.7455H17.8653Z",
                        fill: "#FFE8B6"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M9.65266 15.0365C8.61466 13.8071 6.41733 15.8018 5.79066 15.0598C5.48733 14.7005 5.68266 14.2345 6.08133 13.8985C6.75133 13.3318 7.23466 13.6618 7.53799 13.4051C7.75333 13.2238 7.74199 13.0018 7.61399 12.8491C7.31666 12.4978 6.55666 12.6811 5.96599 13.0225L5.67866 12.6825C5.49933 12.4705 5.18199 12.4431 4.96999 12.6225C4.75799 12.8025 4.73133 13.1185 4.91066 13.3305L5.20799 13.6831C4.75666 14.2818 4.60333 15.0765 5.13733 15.7078C6.13466 16.8878 8.35933 14.9265 9.05933 15.7558C9.30199 16.0438 9.23399 16.5931 8.72333 17.0238C7.95799 17.6711 7.26466 17.3678 6.95333 17.6305C6.80133 17.7578 6.77399 18.0005 6.93599 18.1931C7.19399 18.4978 8.01599 18.4325 8.80599 17.9405C8.80733 17.9418 8.80733 17.9431 8.80733 17.9445L9.13199 18.3285C9.31133 18.5405 9.62933 18.5665 9.84133 18.3885C10.054 18.2085 10.08 17.8911 9.90066 17.6791L9.57599 17.2951C9.57266 17.2911 9.56733 17.2885 9.56333 17.2845C10.096 16.6325 10.276 15.7731 9.65266 15.0365Z",
                        fill: "#5C913B"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M21.6374 21.7253C21.6434 21.72 21.65 21.716 21.656 21.7113C21.7014 21.666 21.7367 21.614 21.7767 21.564C21.8047 21.5293 21.836 21.496 21.862 21.4607C21.8854 21.4273 21.9047 21.3933 21.926 21.3593C22.8727 19.9013 22.2527 17.4293 20.3787 15.5547C18.504 13.68 16.0314 13.06 14.574 14.0073C14.5394 14.028 14.5054 14.0473 14.472 14.0713C14.4367 14.0973 14.4027 14.1287 14.3694 14.156C14.32 14.1967 14.268 14.2313 14.222 14.2773C14.216 14.2833 14.212 14.29 14.2074 14.296C14.2 14.3033 14.1914 14.308 14.1834 14.316L14.1874 14.3193C13.5207 15.0273 13.5127 16.1227 14.1834 16.794C14.8554 17.466 15.95 17.4567 16.6587 16.79L16.666 16.798C16.652 16.8113 16.6367 16.82 16.6234 16.8333C15.9174 17.5393 15.9007 18.6653 16.584 19.35C17.268 20.0333 18.3954 20.0167 19.1007 19.3107C19.114 19.2973 19.1227 19.282 19.136 19.268L19.1434 19.276C18.4767 19.984 18.468 21.0793 19.14 21.7513C19.8114 22.422 20.906 22.414 21.614 21.7473L21.618 21.7513C21.6247 21.742 21.63 21.7333 21.6374 21.7253Z",
                        fill: "#E1E8ED"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M14.1847 16.8208C14.7887 17.4241 15.732 17.4735 16.4313 16.9948C16.724 16.4948 16.808 16.0195 16.808 15.8708C15.3367 16.9681 14.0233 15.8768 13.7293 15.2241C13.6073 15.7881 13.7553 16.3908 14.1847 16.8208ZM19.0507 19.3808C19.2493 19.1015 19.4033 18.8315 19.4753 18.6488C18.5387 19.5075 16.748 18.8788 16.2053 17.5168C15.9667 18.1501 16.0887 18.8795 16.586 19.3768C17.254 20.0448 18.342 20.0395 19.0507 19.3808ZM21.62 21.7775L21.6393 21.7535C21.646 21.7481 21.6527 21.7441 21.658 21.7388C21.704 21.6935 21.7393 21.6415 21.7787 21.5921C21.8073 21.5568 21.838 21.5241 21.864 21.4881C21.888 21.4555 21.9073 21.4208 21.9287 21.3868C21.972 21.3201 21.9953 21.2415 22.032 21.1708C20.3467 21.9248 19.0887 20.6455 18.736 20.0075C18.5393 20.6188 18.6673 21.3035 19.142 21.7788C19.8127 22.4501 20.9073 22.4421 21.616 21.7748L21.62 21.7775Z",
                        fill: "#CCD6DD"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M9.30397 8.33202L9.32264 8.31736C9.36864 8.27202 9.40397 8.22002 9.4433 8.17069C9.4713 8.13602 9.50197 8.10336 9.52797 8.06736C9.55197 8.03402 9.5713 8.00002 9.59264 7.96602C10.5393 6.50802 9.91864 4.03536 8.04464 2.16136C6.16997 0.28669 3.69797 -0.333977 2.23997 0.61269C2.20597 0.634023 2.1713 0.653357 2.13797 0.677357C2.10197 0.703357 2.0693 0.734023 2.03464 0.762023C1.9853 0.802023 1.9333 0.83669 1.88797 0.88269C1.88197 0.88869 1.87797 0.896023 1.8733 0.901357C1.86597 0.908023 1.85664 0.914023 1.8493 0.921357L1.85264 0.92469C1.18597 1.63269 1.17797 2.72802 1.8493 3.39936C2.52064 4.07069 3.61597 4.06269 4.32397 3.39602L4.33131 3.40336C4.31731 3.41602 4.30197 3.42536 4.28864 3.43869C3.58264 4.14469 3.56597 5.27069 4.24997 5.95536C4.93397 6.64002 6.06064 6.62269 6.76664 5.91669C6.77997 5.90336 6.78864 5.88802 6.80197 5.87402L6.8093 5.88136C6.14264 6.58936 6.13397 7.68469 6.80597 8.35602C7.4773 9.02736 8.57197 9.01936 9.27997 8.35202L9.2833 8.35602C9.29064 8.34869 9.29664 8.34002 9.30397 8.33202Z",
                        fill: "#E1E8ED"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M1.84869 3.39976C2.45269 4.00376 3.39602 4.05309 4.09536 3.57309C4.38802 3.07309 4.47136 2.59842 4.47136 2.44976C3.00069 3.54642 1.68669 2.45442 1.39336 1.80176C1.27136 2.36642 1.41936 2.96976 1.84869 3.39976ZM6.71602 5.95842C6.91402 5.67909 7.06802 5.41042 7.13936 5.22776C6.20202 6.08642 4.41136 5.45709 3.86936 4.09509C3.63069 4.72842 3.75269 5.45776 4.24936 5.95509C4.91869 6.62376 6.00736 6.61776 6.71602 5.95842ZM9.28336 8.35642C9.29069 8.34909 9.29669 8.34042 9.30336 8.33242L9.32202 8.31776C9.36802 8.27242 9.40336 8.22042 9.44269 8.17109C9.47069 8.13642 9.50136 8.10376 9.52736 8.06776C9.55136 8.03442 9.57069 8.00042 9.59202 7.96642C9.63536 7.89976 9.65869 7.82042 9.69536 7.74976C8.01002 8.50376 6.75202 7.22509 6.39936 6.58709C6.20269 7.19842 6.33069 7.88309 6.80536 8.35776C7.47669 9.02909 8.57136 9.02109 9.27936 8.35376L9.28336 8.35642Z",
                        fill: "#CCD6DD"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_864_48951",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    });
const $7e0cc0f7a78404ca$export$fb505dcffad77432 = ()=>/*#__PURE__*/ (0, $l998X.jsx)($7e0cc0f7a78404ca$var$CustomGlyph, {
        "aria-label": "flying-money",
        role: "img"
    });

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 





























const $ed03b366b63427d7$export$defe85febe8b728c = {
    searchIconLabel: {
        id: 'input_search_icon_label',
        defaultMessage: 'Search',
        description: 'Label text for search icon'
    },
    clearIconLabel: {
        id: 'input_clear_icon_label',
        defaultMessage: 'Clear',
        description: 'Label text for clear icon'
    },
    inputPlaceholder: {
        id: 'input_placeholder',
        defaultMessage: 'Search or ask anything',
        description: 'Placeholder text in primary search input'
    }
};


const $760b49b77c629beb$var$textFieldBoxStyles = (0, $ecnYn.xcss)({
    justifySelf: 'center',
    marginTop: 'space.200'
});
const $760b49b77c629beb$var$cssOverrideWrapperStyles = null;
const $760b49b77c629beb$var$searchIconWrapperStyles = (0, $ecnYn.xcss)({
    minWidth: 'size.200',
    minHeight: 'size.200',
    marginLeft: 'space.100',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $760b49b77c629beb$var$clearIconStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.100'
});
function $760b49b77c629beb$export$79d13b60110f33be({ testId: testId, width: width, textQueryParam: textQueryParam, updateQueryParameters: updateQueryParameters }) {
    const [localQuery, setLocalQuery] = (0, $42omo.useState)(textQueryParam ?? '');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        setLocalQuery(textQueryParam ?? '');
    }, [
        textQueryParam
    ]);
    const handleOnSubmit = ()=>{
        // update params and trigger a new search
        if (updateQueryParameters) // pass updated text param to callback
        // params for all other filters are handled in updateSearchParams
        updateQueryParameters({
            text: localQuery
        });
    };
    const onChange = (e)=>{
        setLocalQuery(e.currentTarget.value);
    };
    const onKeyPress = (event)=>{
        if (event.key === 'Enter' && localQuery.trim() !== '') {
            handleOnSubmit();
            const searchEvent = createAnalyticsEvent({
                type: (0, $aac8e94998d25d17$export$dce83e8417873763).SEND_TRACK_EVENT,
                eventType: (0, $aac8e94998d25d17$export$76a2e4c433c23bb9).TRACK,
                source: (0, $aac8e94998d25d17$export$85183a312807388d),
                action: 'submitted',
                actionSubject: 'subsequentSearch',
                actionSubjectId: 'searchBar'
            });
            searchEvent.fire((0, $aac8e94998d25d17$export$85183a312807388d));
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $760b49b77c629beb$var$textFieldBoxStyles,
        testId: testId,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            style: {
                width: width
            },
            className: (0, $gMc0m.default)([
                "_zbay1qi0 _1r6fe4h9 _k8em1ylp"
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default), {
                id: "text-query-input",
                testId: "text-query-input",
                value: localQuery,
                onKeyPress: (event)=>onKeyPress(event),
                onChange: onChange,
                autoComplete: "off",
                placeholder: (0, $ed03b366b63427d7$export$defe85febe8b728c).inputPlaceholder.defaultMessage,
                elemBeforeInput: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $760b49b77c629beb$var$searchIconWrapperStyles,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                        color: "currentColor",
                        spacing: "spacious",
                        label: (0, $ed03b366b63427d7$export$defe85febe8b728c).searchIconLabel.defaultMessage
                    })
                }),
                elemAfterInput: localQuery && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $760b49b77c629beb$var$clearIconStyles,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                                ...iconProps,
                                label: (0, $ed03b366b63427d7$export$defe85febe8b728c).clearIconLabel.defaultMessage,
                                color: "currentColor"
                            }),
                        spacing: 'compact',
                        onClick: ()=>setLocalQuery(''),
                        label: (0, $ed03b366b63427d7$export$defe85febe8b728c).clearIconLabel.defaultMessage,
                        appearance: 'subtle'
                    })
                })
            })
        })
    });
}

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 























/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $hArLp = parcelRequire("hArLp");










var $fzqvY = parcelRequire("fzqvY");

var $fb3kw = parcelRequire("fb3kw");

var $kuB2l = parcelRequire("kuB2l");





var $8CZUH = parcelRequire("8CZUH");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");



















const $c92ead14aeae827b$var$gridStyles = (0, $ecnYn.xcss)({
    width: '100%'
});
const $c92ead14aeae827b$var$closeContainerStyles = (0, $ecnYn.xcss)({
    gridArea: 'close'
});
const $c92ead14aeae827b$var$titleContainerStyles = (0, $ecnYn.xcss)({
    gridArea: 'title'
});
const $c92ead14aeae827b$var$options = [
    'It was faster',
    'Results came from trusted sources',
    'AI Answer above search results was better',
    'Result I needed was higher',
    'Results were more personalized',
    'I prefer the visual organization',
    'URL ranking',
    'Answer triggering',
    'Answer quality',
    '3P results',
    'Caption quality'
];
const $c92ead14aeae827b$var$textFieldStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.250'
});
const $c92ead14aeae827b$var$fieldsetStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.negative.050'
});
const $c92ead14aeae827b$var$customFooterStyles = (0, $ecnYn.xcss)({
    padding: 'space.300',
    borderTopColor: 'color.border',
    borderTopStyle: 'solid',
    borderTopWidth: 'border.width',
    marginTop: 'space.300'
});
const $c92ead14aeae827b$var$customBodyStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.negative.150',
    flexGrow: 1,
    flex: '1 1 auto',
    paddingTop: 'space.025',
    paddingBottom: 'space.025',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
/**
 * data is submitted in the form:
 * {'It was faster': undefined, 'Result I needed was higher': true}
 * so this will find keys with a true value and add them to the list
 */ const $c92ead14aeae827b$var$getRatingReasons = (options)=>{
    const selectedOptions = [];
    for (const [key, value] of Object.entries(options))if (!!value) selectedOptions.push(key);
    return selectedOptions;
};
const $c92ead14aeae827b$export$8a75750978c45055 = ({ onSubmitAndClose: onSubmitAndClose })=>{
    const [shouldAttachScreenshot, setShouldAttachScreenshot] = (0, $42omo.useState)(true);
    const handleSubmit = (data)=>{
        const { feedback: feedback, ...rest } = data;
        const ratingReasons = $c92ead14aeae827b$var$getRatingReasons(rest);
        onSubmitAndClose({
            feedback: feedback,
            ratingReasons: ratingReasons,
            action: (0, $aac8e94998d25d17$export$32fb395bad9ce8e9).SUBMITTED,
            shouldAttachScreenshot: shouldAttachScreenshot
        });
    };
    const handleScreenshotCheckbox = ()=>{
        setShouldAttachScreenshot((state)=>!state);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": "search-feedback-modal",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8CZUH.default), {
                width: "large",
                onClose: ()=>onSubmitAndClose({
                        action: (0, $aac8e94998d25d17$export$32fb395bad9ce8e9).CLOSED,
                        ratingReasons: [],
                        shouldAttachScreenshot: false
                    }),
                children: (0, $dh538.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $fzqvY.default), {
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
                                gap: "space.200",
                                templateAreas: [
                                    'title close'
                                ],
                                xcss: $c92ead14aeae827b$var$gridStyles,
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
                                        xcss: $c92ead14aeae827b$var$closeContainerStyles,
                                        justifyContent: "end",
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                            appearance: "subtle",
                                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
                                            label: "Close Modal",
                                            onClick: ()=>onSubmitAndClose({
                                                    action: (0, $aac8e94998d25d17$export$32fb395bad9ce8e9).CLOSED,
                                                    ratingReasons: [],
                                                    shouldAttachScreenshot: false
                                                })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
                                        xcss: $c92ead14aeae827b$var$titleContainerStyles,
                                        justifyContent: "start",
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                                            children: "You're in the raffle! Tell us more"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                            xcss: $c92ead14aeae827b$var$customBodyStyles,
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                                    direction: "column",
                                    gap: "space.200",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                            children: "Every time you rate your search results you\u2019ll be in a fortnightly raffle to win a kudos."
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                            weight: "semibold",
                                            children: "Why do you prefer these search results?"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                    xcss: $c92ead14aeae827b$var$fieldsetStyles,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kuB2l.default), {
                                        children: $c92ead14aeae827b$var$options.map((option, id)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                                name: option,
                                                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $42omo.createElement)((0, $7gpC4.default), {
                                                        ...fieldProps,
                                                        label: option,
                                                        name: option,
                                                        key: `${id}-${option}`
                                                    })
                                            }, `${id}-${option}`))
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                    xcss: $c92ead14aeae827b$var$textFieldStyles,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                        name: "feedback",
                                        label: "Anything else to add?",
                                        children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default), {
                                                ...fieldProps
                                            })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                            justifyContent: "space-between",
                            xcss: $c92ead14aeae827b$var$customFooterStyles,
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                                    isChecked: shouldAttachScreenshot,
                                    label: "Attach and send a screenshot of my search results",
                                    onChange: handleScreenshotCheckbox,
                                    name: "attach-screenshot",
                                    testId: "attach-screenshot"
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $hArLp.default), {
                                    label: "Default button group",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                            appearance: "subtle",
                                            onClick: ()=>onSubmitAndClose({
                                                    action: (0, $aac8e94998d25d17$export$32fb395bad9ce8e9).CANCELED,
                                                    ratingReasons: [],
                                                    shouldAttachScreenshot: false
                                                }),
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                            appearance: "primary",
                                            type: "submit",
                                            children: "Send feedback"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $fzqvY.default), {
                    onSubmit: handleSubmit,
                    children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $l998X.jsxs)("form", {
                            ...formProps,
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
                                        gap: "space.200",
                                        templateAreas: [
                                            'title close'
                                        ],
                                        xcss: $c92ead14aeae827b$var$gridStyles,
                                        children: [
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
                                                xcss: $c92ead14aeae827b$var$closeContainerStyles,
                                                justifyContent: "end",
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                                    appearance: "subtle",
                                                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
                                                    label: "Close Modal",
                                                    onClick: ()=>onSubmitAndClose({
                                                            action: (0, $aac8e94998d25d17$export$32fb395bad9ce8e9).CLOSED,
                                                            ratingReasons: [],
                                                            shouldAttachScreenshot: false
                                                        })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
                                                xcss: $c92ead14aeae827b$var$titleContainerStyles,
                                                justifyContent: "start",
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                                                    children: "You're in the raffle! Tell us more"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                                    xcss: $c92ead14aeae827b$var$customBodyStyles,
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                                            direction: "column",
                                            gap: "space.200",
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                                    children: "Every time you rate your search results you\u2019ll be in a fortnightly raffle to win a kudos."
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                                    weight: "semibold",
                                                    children: "Why do you prefer these search results?"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                            xcss: $c92ead14aeae827b$var$fieldsetStyles,
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kuB2l.default), {
                                                children: $c92ead14aeae827b$var$options.map((option, id)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                                        name: option,
                                                        children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $42omo.createElement)((0, $7gpC4.default), {
                                                                ...fieldProps,
                                                                label: option,
                                                                name: option,
                                                                key: `${id}-${option}`
                                                            })
                                                    }, `${id}-${option}`))
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                            xcss: $c92ead14aeae827b$var$textFieldStyles,
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                                name: "feedback",
                                                label: "Anything else to add?",
                                                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default), {
                                                        ...fieldProps
                                                    })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                                    justifyContent: "space-between",
                                    xcss: $c92ead14aeae827b$var$customFooterStyles,
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                                            isChecked: shouldAttachScreenshot,
                                            label: "Attach and send a screenshot of my search results",
                                            onChange: handleScreenshotCheckbox,
                                            name: "attach-screenshot",
                                            testId: "attach-screenshot"
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $hArLp.default), {
                                            label: "Default button group",
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                                    appearance: "subtle",
                                                    onClick: ()=>onSubmitAndClose({
                                                            action: (0, $aac8e94998d25d17$export$32fb395bad9ce8e9).CANCELED,
                                                            ratingReasons: [],
                                                            shouldAttachScreenshot: false
                                                        }),
                                                    children: "Cancel"
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                                    appearance: "primary",
                                                    type: "submit",
                                                    children: "Send feedback"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                })
            })
        })
    });
};





parcelRequire("42omo");

const $18990f8ddff57d63$export$810c497f8e0a07d = ()=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.1235 8.4126L13.7485 13.9126L15.001 13.0871L11.648 7.99986L15.001 2.9126L13.7485 2.08713L10.1235 7.58713C9.9585 7.83754 9.9585 8.16219 10.1235 8.4126ZM5.62354 8.4126L9.24854 13.9126L10.501 13.0871L7.14801 7.99986L10.501 2.9126L9.24854 2.08713L5.62354 7.58713C5.4585 7.83754 5.4585 8.16219 5.62354 8.4126ZM1.12354 8.4126L4.74854 13.9126L6.00098 13.0871L2.64801 7.99986L6.00098 2.9126L4.74854 2.08713L1.12354 7.58713C0.958497 7.83754 0.958497 8.16219 1.12354 8.4126Z",
            fill: "#44546F"
        })
    });




parcelRequire("42omo");

const $59ee9803c676c077$export$7e37c6d8d8d55c4c = ()=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.87622 7.5874L2.25122 2.0874L0.998779 2.91287L4.35175 8.00014L0.998779 13.0874L2.25122 13.9129L5.87622 8.41287C6.04126 8.16246 6.04126 7.83781 5.87622 7.5874ZM10.3762 7.5874L6.75122 2.0874L5.49878 2.91287L8.85175 8.00014L5.49878 13.0874L6.75122 13.9129L10.3762 8.41287C10.5413 8.16246 10.5413 7.83781 10.3762 7.5874ZM14.8762 7.5874L11.2512 2.0874L9.99878 2.91287L13.3517 8.00014L9.99878 13.0874L11.2512 13.9129L14.8762 8.41287C15.0413 8.16246 15.0413 7.83781 14.8762 7.5874Z",
            fill: "#44546F"
        })
    });




parcelRequire("42omo");

const $c5567244a24bcbe3$export$9a85c5be20b48931 = ()=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.12354 7.5874L8.74854 2.0874L10.001 2.91287L6.64801 8.00014L10.001 13.0874L8.74854 13.9129L5.12354 8.41287C4.9585 8.16246 4.9585 7.83781 5.12354 7.5874Z",
            fill: "#44546F"
        })
    });




parcelRequire("42omo");

const $d3831b05c5809784$export$47905bf9b476a59a = ()=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.8762 8.4126L7.25122 13.9126L5.99878 13.0871L9.35175 7.99986L5.99878 2.9126L7.25122 2.08713L10.8762 7.58713C11.0413 7.83754 11.0413 8.16219 10.8762 8.4126Z",
            fill: "#44546F"
        })
    });


const $b4113244f326b407$var$arrowOptionMap = {
    'best-left': (0, $18990f8ddff57d63$export$810c497f8e0a07d),
    'better-left': (0, $c5567244a24bcbe3$export$9a85c5be20b48931),
    'best-right': (0, $59ee9803c676c077$export$7e37c6d8d8d55c4c),
    'better-right': (0, $d3831b05c5809784$export$47905bf9b476a59a),
    none: undefined
};
const $b4113244f326b407$export$8081465a586297e5 = ({ option: option })=>{
    const glyph = $b4113244f326b407$var$arrowOptionMap[option];
    return glyph;
};


const $4f2c875b59b1ac8d$var$sideAOptions = [
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        value: '1',
        label: 'Left Much Better',
        icon: 'best-left'
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        value: '2',
        label: 'Left Slightly Better',
        icon: 'better-left'
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        value: '3',
        label: 'About the Same',
        icon: 'none'
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        value: '4',
        label: 'Right Slightly Better',
        icon: 'better-right'
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        value: '5',
        label: 'Right Much Better',
        icon: 'best-right'
    }
];
const $4f2c875b59b1ac8d$var$sideBOptions = [
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        value: '5',
        label: 'Left Much Better',
        icon: 'best-left'
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        value: '4',
        label: 'Left Slightly Better',
        icon: 'better-left'
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        value: '3',
        label: 'About the Same',
        icon: 'none'
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        value: '2',
        label: 'Right Slightly Better',
        icon: 'better-right'
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        value: '1',
        label: 'Right Much Better',
        icon: 'best-right'
    }
];
const $4f2c875b59b1ac8d$var$feedbackFormStyles = (0, $ecnYn.xcss)({
    padding: 'space.200',
    display: 'flex',
    flexDirection: 'row'
});
const $4f2c875b59b1ac8d$var$blogStyles = (0, $ecnYn.xcss)({
    font: 'font.body.UNSAFE_small',
    fontWeight: 'font.weight.medium',
    textDecoration: 'none',
    color: 'color.text.accent.blue',
    ':visited': {
        color: 'color.text.accent.blue',
        textDecoration: 'none'
    },
    ':hover': {
        color: 'color.text.accent.blue',
        textDecoration: 'none'
    }
});
const $4f2c875b59b1ac8d$var$textAndAnchorStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column'
});
const $4f2c875b59b1ac8d$export$9c0b60aed40d1233 = ({ isSideAOnLeft: isSideAOnLeft, onSubmit: onSubmit, onRatingClick: onRatingClick })=>{
    const [rating, setRating] = (0, $42omo.useState)('');
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleOnOptionButtonClick = (e, value)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'ratingButton',
            type: (0, $aac8e94998d25d17$export$dce83e8417873763).SEND_UI_EVENT,
            eventType: (0, $aac8e94998d25d17$export$76a2e4c433c23bb9).UI,
            source: (0, $aac8e94998d25d17$export$85183a312807388d),
            attributes: {
                value: value,
                isRedesign: true,
                isSideAOnLeft: isSideAOnLeft
            }
        });
        e.preventDefault();
        setRating(value);
        setIsModalOpen(true);
        onRatingClick();
        analyticsEvent.fire((0, $aac8e94998d25d17$export$85183a312807388d));
    };
    const handleOnSubmitAndClose = ({ feedback: feedback, ratingReasons: ratingReasons, action: action, shouldAttachScreenshot: shouldAttachScreenshot })=>{
        onSubmit({
            feedback: feedback,
            atlassianRating: rating,
            ratingReasons: ratingReasons,
            shouldAttachScreenshot: shouldAttachScreenshot,
            action: action
        });
        setRating('');
        setIsModalOpen(false);
    };
    const isIconAfter = (icon)=>icon === 'best-right' || icon === 'better-right';
    const isIconBefore = (icon)=>icon === 'best-left' || icon === 'better-left';
    const options = isSideAOnLeft ? $4f2c875b59b1ac8d$var$sideAOptions : $4f2c875b59b1ac8d$var$sideBOptions;
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        "data-testid": "search-feedback-form",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                xcss: $4f2c875b59b1ac8d$var$feedbackFormStyles,
                alignItems: "center",
                gap: "space.200",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                        xcss: $4f2c875b59b1ac8d$var$textAndAnchorStyles,
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                weight: "semibold",
                                children: "Which search results do you prefer?"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
                                href: "https://hello.atlassian.net/wiki/x/Uo838w",
                                xcss: $4f2c875b59b1ac8d$var$blogStyles,
                                target: "_blank",
                                children: "Why am I seeing this?"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
                        gap: "space.100",
                        children: options.map((option, id)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                isSelected: option.value === rating,
                                value: option.value,
                                onClick: (e)=>handleOnOptionButtonClick(e, option.value),
                                ...isIconBefore(option.icon) && // @ts-ignore - TS2367 TypeScript 5.9.2 upgrade
                                option.icon !== 'none' && {
                                    iconBefore: (0, $b4113244f326b407$export$8081465a586297e5)({
                                        option: option.icon
                                    })
                                },
                                ...isIconAfter(option.icon) && // @ts-ignore - TS2367 TypeScript 5.9.2 upgrade
                                option.icon !== 'none' && {
                                    iconAfter: (0, $b4113244f326b407$export$8081465a586297e5)({
                                        option: option.icon
                                    })
                                },
                                children: option.label
                            }, `${id}-${option}`))
                    })
                ]
            }),
            isModalOpen && /*#__PURE__*/ (0, $l998X.jsx)((0, $c92ead14aeae827b$export$8a75750978c45055), {
                onSubmitAndClose: handleOnSubmitAndClose
            })
        ]
    });
};




parcelRequire("42omo");


var $3SgTW = parcelRequire("3SgTW");

const $f62272317e407c6f$export$afc032e1a809a5b9 = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3SgTW))), {
        recycle: false,
        gravity: 0.1,
        numberOfPieces: 400
    });









var $a9sR2 = parcelRequire("a9sR2");

var $5DUgU = parcelRequire("5DUgU");


var $kDuN4 = parcelRequire("kDuN4");


const $25d14e15020f60a9$export$3bb03aa5c3d29986 = ({ children: children, tenantId: tenantId, userId: userId, entryPoint: entryPoint })=>{
    const webClient = $25d14e15020f60a9$export$e9ba7ef9458d1a4a({
        hostname: window.location.hostname
    }, {
        product: (0, $aac8e94998d25d17$export$a5e892786b028f3b).ROVO_COMPARISON_TOOL
    });
    if (tenantId) webClient.setTenantInfo((0, $5DUgU.tenantType).CLOUD_ID, tenantId);
    if (userId) webClient.setUserInfo((0, $5DUgU.userType).ATLASSIAN_ACCOUNT, userId);
    const onEvent = (0, $42omo.useCallback)(({ payload: payload })=>{
        webClient.onEvent((0, $aac8e94998d25d17$export$85183a312807388d), {
            ...payload,
            attributes: {
                ...payload?.attributes,
                entryPoint: entryPoint
            }
        });
    }, [
        webClient,
        entryPoint
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kDuN4.default), {
        channel: "sideBySide",
        onEvent: onEvent,
        children: children
    });
};
const $25d14e15020f60a9$var$getAnalyticsEnv = (hostname)=>{
    let env;
    switch(hostname){
        case 'jira-dev.com':
            env = 'staging';
            break;
        case 'localhost':
            env = 'local';
            break;
        default:
            env = 'prod';
    }
    return env;
};
const $25d14e15020f60a9$export$e9ba7ef9458d1a4a = ({ hostname: hostname }, { product: product })=>{
    const client = new (0, $a9sR2.default)({
        product: product,
        env: $25d14e15020f60a9$var$getAnalyticsEnv(hostname || window.location.hostname),
        origin: (0, $5DUgU.originType).WEB
    });
    return client;
};


const $dff88cb6fdb16cba$export$dcae0a9118c1d498 = (experimentsString)=>{
    if (!experimentsString) return [];
    const experimentStrings = experimentsString.split(',');
    return experimentStrings.reduce((experiments, experimentString)=>{
        const [location, type, name, layer] = experimentString.split(':');
        if (!location || !type || !name) return experiments;
        experiments.push({
            location: location,
            type: type,
            name: name,
            layer: layer
        });
        return experiments;
    }, []);
};


var $b813006e474c556f$export$59ec57b58cb20d34 = /*#__PURE__*/ function(FeedbackRating) {
    FeedbackRating["ONE"] = "1";
    FeedbackRating["TWO"] = "2";
    FeedbackRating["THREE"] = "3";
    FeedbackRating["FOUR"] = "4";
    FeedbackRating["FIVE"] = "5";
    return FeedbackRating;
}({});
var $b813006e474c556f$export$b137b440a517886e = /*#__PURE__*/ function(FeedbackProduct) {
    FeedbackProduct["CONFLUENCE"] = "confluence";
    FeedbackProduct["JIRA"] = "jira";
    FeedbackProduct["ATLAS"] = "atlas";
    FeedbackProduct["SHAREPOINT"] = "sharepoint";
    FeedbackProduct["GOOGLE"] = "google";
    FeedbackProduct["OTHER"] = "other";
    return FeedbackProduct;
}({});
const $b813006e474c556f$export$3458981ccaef555c = (formValue)=>{
    const values = Object.values($b813006e474c556f$export$59ec57b58cb20d34);
    const found = values.find((value)=>value === formValue);
    return found;
};
const $b813006e474c556f$export$dcd4fb8a33e7a534 = (type)=>{
    switch(type){
        case 'page':
        case 'space':
        case 'attachment':
        case 'whiteboard':
            return `${type}s`;
        case 'blogpost':
            return 'blog-posts';
        case 'project':
            return 'product'; // this is the value in BE
        default:
            return type;
    }
};
const $b813006e474c556f$export$9c859a933d076df5 = (lastUpdated)=>{
    switch(lastUpdated){
        case 'past7Days':
            return 'past-7-days';
        case 'past30Days':
            return 'past-30-days';
        case 'pastYear':
            return 'past-year';
        default:
            return lastUpdated; // today, yesterday, anytime
    }
};
const $b813006e474c556f$export$1933a9fe712fc1fd = (queryParams)=>{
    const { product: product, type: type, jAssignee: jAssignee, jProject: jProject, lastModified: lastModified, contributors: contributors, spaces: spaces, ancestor: ancestor, titleMatch: titleMatch } = queryParams;
    const filters = {
        ...product ? {
            productTypeFilter: product === 'townsquare' ? 'atlas' : product
        } : {},
        ...type ? {
            typeFilter: $b813006e474c556f$export$dcd4fb8a33e7a534(type)
        } : {},
        ...jAssignee ? {
            assigneeFilter: jAssignee.split(',')
        } : {},
        ...jProject ? {
            projectIdFilter: jProject
        } : {},
        ...lastModified ? {
            lastUpdatedFilter: $b813006e474c556f$export$9c859a933d076df5(lastModified)
        } : {},
        ...contributors ? {
            contributorFilter: contributors.split(',')
        } : {},
        ...spaces ? {
            spaceFilter: spaces.split(',')
        } : {},
        ...ancestor ? {
            contentUnderFilter: ancestor
        } : {},
        ...titleMatch ? {
            titleMatchFilter: titleMatch === 'true'
        } : {}
    };
    return Object.keys(filters).length ? filters : undefined;
};
const $b813006e474c556f$export$602b8fff2ad311ab = (ratingReasons, feedback)=>{
    const formattedReasons = `preset: ${ratingReasons ? ratingReasons.join(', ') : ''}`;
    const formattedFeedback = feedback ? `feedback: ${feedback}` : 'feedback: ';
    if ((!ratingReasons || !ratingReasons.length) && !feedback) return undefined;
    return `${formattedReasons}; ${formattedFeedback}`;
};


/*! FeedbackPlus v1.6.0 | (c) ColonelParrot and other contributors | MIT License */ // This is a library that we're using that doesn't play nice with webpack so it could
// not be installed using yarn/npm. It has been heavily reduced to be more lightweight,
// rewritten to be TS friendly, and only includes necessary functionality.
class $34e7b87fcd67ef0c$var$FeedbackPlus {
    /**
   * Checks whether the base APIs needed are supported
   */ static isSupported() {
        // eslint-disable-next-line compat/compat
        return !!navigator?.mediaDevices?.getDisplayMedia && !!window.HTMLCanvasElement;
    }
    /**
   * Captures a screenshot of the page. Does not fallback to `html2canvas` with this implementation
   * @param {number} timeout - Default `500`ms. Timeout between call & capture. Can be used to wait for animations to finish before capture
   * @returns {Promise<CaptureResult>} promise - A promise that, when resolved, provides an ImageBitmap
   */ async capture(timeout = 500) {
        if ($34e7b87fcd67ef0c$var$FeedbackPlus.isSupported()) return new Promise((resolve, reject)=>{
            // eslint-disable-next-line compat/compat
            navigator.mediaDevices.getDisplayMedia({
                video: true,
                preferCurrentTab: true
            }).then((stream)=>{
                const video = document.createElement('video');
                setTimeout(()=>{
                    video.srcObject = stream;
                    video.onloadedmetadata = ()=>{
                        video.play();
                        video.pause();
                        const canvas = document.createElement('canvas');
                        canvas.width = video.videoWidth;
                        canvas.height = video.videoHeight;
                        const ctx = canvas.getContext('2d');
                        if (ctx) {
                            // This check ensures that ctx is not null
                            ctx.drawImage(video, 0, 0);
                            stream.getVideoTracks().forEach((track)=>track.stop());
                            $34e7b87fcd67ef0c$var$FeedbackPlus.canvasToBitmap(canvas).then((bitmap)=>resolve(bitmap));
                        } else reject(new Error('Unable to get canvas context'));
                    };
                }, timeout);
            }).catch((e)=>reject(e));
        });
        else return Promise.reject(new Error('FeedbackPlus is not supported on this platform.'));
    }
    /**
   * Converts a canvas to an ImageBitmap. Can be called on the canvas returned by {@link showEditDialog()} to redraw on canvas
   * @param {HTMLCanvasElement} canvas - The canvas
   * @returns {Promise} promise - A promise which, when resolved, returns the ImageBitmap
   */ static canvasToBitmap(canvas) {
        return new Promise((resolve, reject)=>{
            const ctx = canvas.getContext('2d');
            if (!ctx) {
                reject(new Error('Unable to get canvas context'));
                return;
            }
            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            createImageBitmap(imageData).then((bitmap)=>{
                resolve({
                    bitmap: bitmap,
                    width: bitmap.width,
                    height: bitmap.height
                });
            }).catch(reject);
        });
    }
}
var $34e7b87fcd67ef0c$export$2e2bcd8739ae039 = $34e7b87fcd67ef0c$var$FeedbackPlus;


const $b27329311405e54a$export$93e5c64e4cc246c8 = ({ width: width, height: height, bitmap: bitmap, canvas: canvas })=>{
    const resizedWidth = width;
    const resizedHeight = height;
    canvas.width = resizedWidth;
    canvas.height = resizedHeight;
    // Draw the bitmap onto the canvas
    const ctx = canvas.getContext('2d');
    if (!ctx) // Return an error message directly if canvas context is not available
    throw new Error('Failed to get canvas context.');
    ctx.drawImage(bitmap, 0, 0, width, height);
    // Convert the canvas to a Base64 string; Using jpeg because it's smaller
    const base64Image = canvas.toDataURL('image/jpeg', 0.8);
    const base64Data = base64Image.split(',')[1];
    // Calculate the size of the Base64 data:
    // Each Base64 character represents 6 bits, so multiply by 3/4 to get the byte count
    const base64DataSizeInBytes = base64Data.length * 3 / 4;
    return {
        imageSize: base64DataSizeInBytes,
        imageData: base64Data
    };
};
const $b27329311405e54a$export$a2abea2f8733e1ac = async ()=>{
    const feedbackPlus = new (0, $34e7b87fcd67ef0c$export$2e2bcd8739ae039)();
    const canvas = document.createElement('canvas');
    try {
        const { bitmap: bitmap, width: width, height: height } = await feedbackPlus.capture();
        let count = 0;
        let currentWidth = width;
        let currentHeight = height;
        const { imageSize: imageSize, imageData: imageData } = $b27329311405e54a$export$93e5c64e4cc246c8({
            width: currentWidth,
            height: currentHeight,
            bitmap: bitmap,
            canvas: canvas
        });
        let finalImageData = imageData;
        let currentImageSize = imageSize;
        const startImageSize = imageSize;
        const widthPercentage = 720 / currentWidth;
        const heightPercentage = 1080 / currentHeight;
        const scale = widthPercentage > heightPercentage ? widthPercentage : heightPercentage;
        while(currentImageSize > 150000 && count <= 5){
            currentWidth = currentWidth * scale;
            currentHeight = currentHeight * scale;
            const { imageSize: imageSize, imageData: imageData } = $b27329311405e54a$export$93e5c64e4cc246c8({
                width: currentWidth,
                height: currentHeight,
                bitmap: bitmap,
                canvas: canvas
            });
            currentImageSize = imageSize;
            finalImageData = imageData;
            count++;
        }
        // last catch just in case.
        // just throw an error
        if (currentImageSize > 150000) return {
            startImageSize: startImageSize,
            imageData: `Image size of ${currentImageSize} bytes exceeds the maximum allowed size of 150 kB.`,
            imageSize: currentImageSize
        };
        return {
            imageData: finalImageData,
            imageSize: currentImageSize,
            startImageSize: startImageSize
        };
    } catch (error) {
        return {
            imageData: `Error: ${error instanceof Error ? error.message : 'Unknown error'}`,
            imageSize: 0,
            startImageSize: 0
        };
    }
};


const $10ee11d11e004dd8$var$searchItemStyles = (0, $ecnYn.xcss)({
    flexBasis: '50%',
    flexGrow: 1,
    height: '1000px',
    maxWidth: '799px',
    overflowX: 'hidden'
});
const $10ee11d11e004dd8$var$iframeSearchResultsStyle = (0, $ecnYn.xcss)({
    marginTop: 'space.300'
});
const $10ee11d11e004dd8$var$rovoSideBySideResultsStyle = (0, $ecnYn.xcss)({
    marginTop: 'space.negative.100',
    overflowY: 'auto'
});
const $10ee11d11e004dd8$var$displayNoneStyle = (0, $ecnYn.xcss)({
    display: 'none'
});
const $10ee11d11e004dd8$var$visibilityHiddenStyle = (0, $ecnYn.xcss)({
    visibility: 'hidden'
});
const $10ee11d11e004dd8$var$searchItemFullWidthStyles = (0, $ecnYn.xcss)({
    flexBasis: 0,
    flexGrow: 1,
    height: '1000px',
    maxWidth: '100%',
    overflowX: 'hidden'
});
const $10ee11d11e004dd8$var$verticalDividerStyles = (0, $ecnYn.xcss)({
    background: `${"var(--ds-border, #0B120E24)"}`,
    minWidth: '2px',
    marginLeft: 'space.500',
    marginRight: 'space.500'
});
const $10ee11d11e004dd8$var$longVerticalDividerStyles = (0, $ecnYn.xcss)({
    height: '1000px'
});
const $10ee11d11e004dd8$var$inlineStyles = (0, $ecnYn.xcss)({
    width: '80vw',
    marginLeft: 'auto',
    marginRight: 'auto'
});
const $10ee11d11e004dd8$var$FEEDBACK_COMPARISON_URL = '/gateway/api/xpsearch-aggregator/feedback/v1/comparison';
const $10ee11d11e004dd8$var$SUCCESS_FLAG = 'feedback-submitted-successfully';
const $10ee11d11e004dd8$var$topSectionStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.150',
    marginBottom: 'space.150',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '80vw'
});
const $10ee11d11e004dd8$var$linkStyles = (0, $ecnYn.xcss)({
    justifyContent: 'center',
    background: 'none',
    alignItems: 'center',
    marginBottom: 'space.075'
});
const $10ee11d11e004dd8$var$iconStyles = (0, $ecnYn.xcss)({
    paddingRight: 'space.075'
});
const $10ee11d11e004dd8$var$expandCollapseButtonsStyles = (0, $ecnYn.xcss)({
    width: '80vw',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'flex',
    justifyContent: 'space-between'
});
const $10ee11d11e004dd8$export$ca4d6504ca148ae4 = (imageData)=>{
    if (!imageData || !imageData.length) return false;
    const base64Regex = /^(?:[A-Za-z0-9+\/]{4})*?(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/;
    return base64Regex.test(imageData);
};
const $10ee11d11e004dd8$export$77c66aac6ab91308 = ({ testId: testId, shell: shell, callbacks: callbacks, mapUserIdToProfileUrl: mapUserIdToProfileUrl, isRovoVsRovo: isRovoVsRovo = true })=>{
    const currentQueryParams = new URLSearchParams(window.location.href);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [searchedAt, setSearchedAt] = (0, $42omo.useState)();
    const [isFeedbackSubmitted, setIsFeedbackSubmitted] = (0, $42omo.useState)(false);
    const [flags, setFlags] = (0, $42omo.useState)([]);
    const [isRated, setIsRated] = (0, $42omo.useState)(false);
    const [searchSessionId, setSearchSessionId] = (0, $42omo.useState)('');
    const { updateQueryParameters: updateQueryParameters } = callbacks;
    const { cloudId: cloudId, activationId: activationId, user: user, queryParams: queryParams } = shell;
    const [textQueryParam, setTextQueryParam] = (0, $42omo.useState)(queryParams?.text);
    const [allQueryParams, setAllQueryParams] = (0, $42omo.useState)(queryParams);
    const [leftExperiments, setLeftExperiments] = (0, $42omo.useState)([]);
    const [rightExperiments, setRightExperiments] = (0, $42omo.useState)([]);
    const [top5ResultsEqual, setTop5ResultsEqual] = (0, $42omo.useState)(false);
    const [leftTop5Links, setLeftTop5Links] = (0, $42omo.useState)([]);
    const [rightTop5Links, setRightTop5Links] = (0, $42omo.useState)([]);
    const [rightQueryText, setRightSideQueryText] = (0, $42omo.useState)();
    const [leftSideExpanded, setLeftSideExpanded] = (0, $42omo.useState)(false);
    const [rightSideExpanded, setRightSideExpanded] = (0, $42omo.useState)(false);
    const workspaceARI = `ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
    const userId = user?.id;
    const isIFramePage = currentQueryParams.get('isIFramePage');
    const querySearchSessionId = currentQueryParams.get('searchSessionId');
    const analyticsEvent = createAnalyticsEvent({
        name: 'viewedComparisonFeedbackScreen',
        type: (0, $aac8e94998d25d17$export$dce83e8417873763).SEND_SCREEN_EVENT,
        eventType: (0, $aac8e94998d25d17$export$76a2e4c433c23bb9).SCREEN,
        source: (0, $aac8e94998d25d17$export$85183a312807388d),
        attributes: {
            isSideAOnLeft: true
        }
    });
    (0, $42omo.useEffect)(()=>{
        const handleMessage = (event)=>{
            const { type: type, queryParams: queryParams, top5LinksFromIframe: top5LinksFromIframe, queryTextFromIframe: queryTextFromIframe } = event.data;
            if (type === 'UPDATE_FILTER') setAllQueryParams(queryParams);
            if (type === 'TOP_5_LINKS') {
                setRightSideQueryText(queryTextFromIframe);
                setRightTop5Links(top5LinksFromIframe);
            }
        };
        const unbind = (0, $fFa3V.bind)(window, {
            type: 'message',
            listener: handleMessage
        });
        return ()=>{
            unbind();
        };
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (textQueryParam) {
            setSearchedAt(new Date().toISOString()); // syncing search session id across the iframe
            if (querySearchSessionId && isIFramePage) setSearchSessionId(querySearchSessionId);
            else // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            setSearchSessionId((0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))());
        }
        setIsFeedbackSubmitted(false);
    }, [
        textQueryParam,
        querySearchSessionId,
        isIFramePage
    ]);
    (0, $42omo.useEffect)(()=>{
        setTextQueryParam(queryParams?.text);
        setAllQueryParams(queryParams);
        if (queryParams?.leftExperiments) setLeftExperiments((0, $dff88cb6fdb16cba$export$dcae0a9118c1d498)(queryParams.leftExperiments));
        if (queryParams?.rightExperiments) setRightExperiments((0, $dff88cb6fdb16cba$export$dcae0a9118c1d498)(queryParams.rightExperiments));
        if (isIFramePage) window.parent.postMessage({
            type: 'UPDATE_FILTER',
            queryParams: queryParams
        });
    }, [
        queryParams,
        isIFramePage
    ]);
    (0, $42omo.useEffect)(()=>{
        analyticsEvent.fire((0, $aac8e94998d25d17$export$85183a312807388d));
    }, [
        analyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isRovoVsRovo) return;
        const handleMutation = ()=>{
            const setLinks = !!isIFramePage ? setRightTop5Links : setLeftTop5Links;
            const selector = '[data-testid="search-page-result-link"]';
            const results = Array.from(document.querySelectorAll(selector));
            if (results.length === 0) setLinks([]);
            else {
                const links = results.slice(0, 5).map((link)=>link.getAttribute('href')).filter(Boolean);
                setLinks(links);
            }
        };
        const observer = new MutationObserver(handleMutation);
        const container = document.querySelector(`[data-testid="${testId}"]`);
        if (!container) return;
        observer.observe(container, {
            childList: true,
            subtree: true
        });
        return ()=>observer.disconnect();
    }, [
        isIFramePage,
        testId,
        isRovoVsRovo
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!(rightTop5Links.length > 0 && !!isIFramePage)) return;
        window.parent.postMessage({
            type: 'TOP_5_LINKS',
            top5LinksFromIframe: rightTop5Links,
            queryTextFromIframe: queryParams?.text
        }, '*');
    }, [
        rightTop5Links,
        isIFramePage,
        queryParams?.text
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!(leftTop5Links?.length > 0 && rightTop5Links?.length > 0)) return;
        const areLinksEqual = leftTop5Links.every((link, index)=>link === rightTop5Links[index]);
        const queryTextEqual = queryParams?.text === rightQueryText;
        if (queryTextEqual && !areLinksEqual) setTop5ResultsEqual(false);
    }, [
        leftTop5Links,
        rightTop5Links,
        queryParams?.text,
        rightQueryText
    ]);
    const submitComparisonForm = async ({ atlassianRating: atlassianRating, ratingReasons: ratingReasons, feedback: feedback, shouldAttachScreenshot: shouldAttachScreenshot, action: action })=>{
        const atlassianRatingEnum = (0, $b813006e474c556f$export$3458981ccaef555c)(atlassianRating);
        if (!cloudId || !userId || !activationId || !atlassianRatingEnum || !queryParams) return;
        let screenshotResult; // Declare screenshotResult outside and above the if block
        if (shouldAttachScreenshot) {
            screenshotResult = await (0, $b27329311405e54a$export$a2abea2f8733e1ac)();
            if (screenshotResult.imageData.includes('Error')) {
                const analyticsEvent = createAnalyticsEvent({
                    action: 'errored',
                    actionSubject: 'comparisonFormScreenshot',
                    type: (0, $aac8e94998d25d17$export$dce83e8417873763).SEND_TRACK_EVENT,
                    eventType: (0, $aac8e94998d25d17$export$76a2e4c433c23bb9).TRACK,
                    source: (0, $aac8e94998d25d17$export$85183a312807388d),
                    attributes: {
                        error: screenshotResult.imageData
                    }
                });
                analyticsEvent.fire((0, $aac8e94998d25d17$export$85183a312807388d));
            }
        } else screenshotResult = {
            imageData: 'declined',
            imageSize: 0,
            startImageSize: 0
        };
        const formattedFeedback = (0, $b813006e474c556f$export$602b8fff2ad311ab)(ratingReasons, feedback);
        const filters = (0, $b813006e474c556f$export$1933a9fe712fc1fd)(queryParams);
        const feedbackPayload = {
            workspace: workspaceARI,
            eventTriggeredBy: user?.id,
            searchQuery: textQueryParam,
            atlassianRating: atlassianRatingEnum,
            gleanRating: (0, $b813006e474c556f$export$59ec57b58cb20d34).ONE,
            // Conditionally include screenshot if screenshotResult has a value
            ...screenshotResult && {
                screenshot: screenshotResult.imageData
            },
            // include text input if it was provided. otherwise, submit only the scale rating
            ...formattedFeedback && {
                feedback: formattedFeedback
            },
            searchedAt: searchedAt,
            searchSessionRef: searchSessionId,
            ...filters && {
                ...filters
            }
        };
        const analyticsEvent = createAnalyticsEvent({
            action: 'submitted',
            actionSubject: 'comparisonRatingForm',
            type: (0, $aac8e94998d25d17$export$dce83e8417873763).SEND_TRACK_EVENT,
            eventType: (0, $aac8e94998d25d17$export$76a2e4c433c23bb9).TRACK,
            source: (0, $aac8e94998d25d17$export$85183a312807388d),
            attributes: {
                rating: atlassianRating,
                isRedesign: true,
                action: action,
                ratingReasons: ratingReasons,
                isSideAOnLeft: true,
                ...screenshotResult && {
                    startImageSize: screenshotResult.startImageSize,
                    finalImageSize: screenshotResult.imageSize
                },
                includesScreenshot: !!screenshotResult && $10ee11d11e004dd8$export$ca4d6504ca148ae4(screenshotResult.imageData)
            }
        });
        const response = await fetch($10ee11d11e004dd8$var$FEEDBACK_COMPARISON_URL, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(feedbackPayload)
        });
        if (!response.ok) {
            const analyticsEvent = createAnalyticsEvent({
                action: 'errored',
                actionSubject: 'comparisonRatingForm',
                type: (0, $aac8e94998d25d17$export$dce83e8417873763).SEND_TRACK_EVENT,
                eventType: (0, $aac8e94998d25d17$export$76a2e4c433c23bb9).TRACK,
                source: (0, $aac8e94998d25d17$export$85183a312807388d),
                attributes: {
                    errorStatus: response.status
                }
            });
            analyticsEvent.fire((0, $aac8e94998d25d17$export$85183a312807388d));
            return;
        }
        if (action === (0, $aac8e94998d25d17$export$32fb395bad9ce8e9).SUBMITTED) setFlags((state)=>[
                $10ee11d11e004dd8$var$SUCCESS_FLAG,
                ...state
            ]);
        analyticsEvent.fire((0, $aac8e94998d25d17$export$85183a312807388d));
        setIsFeedbackSubmitted(true);
    };
    const updateSearchParams = ({ text: text })=>{
        if (updateQueryParameters) {
            // we want to pass all query params to the callback to ensure applied filters persist with new searches,
            // overriding only the text param for new searches
            // (matching the behavior of the regular search page)
            const filteredQueryParams = {
                ...allQueryParams,
                text: text
            };
            updateQueryParameters(filteredQueryParams);
            setIsFeedbackSubmitted(false);
            if (isRovoVsRovo) {
                // Reset sides comparison
                setTop5ResultsEqual(false);
                setLeftTop5Links([]);
                setRightTop5Links([]);
                setLeftSideExpanded(false);
                setRightSideExpanded(false);
            }
        }
    };
    const handleFlagDismissed = ()=>{
        setFlags(flags.slice(1));
    };
    const handleRatingClick = ()=>{
        setIsRated(true);
        setFlags((state)=>[
                ...state,
                'rating-flag'
            ]);
    }; // Match shell with the vanilla SearchPage object
    const shellWithAnalyticsObject = {
        ...shell,
        analyticsAttributes: {
            activationId: shell.activationId
        },
        searchSessionId: searchSessionId
    };
    const sideAResults = /*#__PURE__*/ (0, $l998X.jsx)((0, $c77fa5848e4f5168$export$2194eaf953b87e28), {
        shell: shellWithAnalyticsObject,
        callbacks: callbacks,
        mapUserIdToProfileUrl: mapUserIdToProfileUrl,
        experiments: leftExperiments
    });
    const sideBResults = isRovoVsRovo ? /*#__PURE__*/ (0, $l998X.jsx)((0, $129b1c3506be1083$export$6125ab8c5458510e), {
        queryString: textQueryParam,
        searchSessionId: searchSessionId,
        queryParams: allQueryParams
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $8076a088bdaec78d$export$18038e881128815), {
        query: textQueryParam
    });
    const onExpandCollapseClick = (expandRightSide = false)=>{
        const setExpanded = expandRightSide ? setRightSideExpanded : setLeftSideExpanded;
        const currentState = expandRightSide ? rightSideExpanded : leftSideExpanded;
        setExpanded(!currentState);
    };
    const expandCollapseButtonsProps = [
        {
            hidden: rightSideExpanded,
            expanded: leftSideExpanded,
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            label: 'left side',
            onClick: ()=>onExpandCollapseClick()
        },
        {
            hidden: leftSideExpanded,
            expanded: rightSideExpanded,
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            label: 'right side',
            onClick: ()=>onExpandCollapseClick(true)
        }
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        testId: testId,
        children: !!isIFramePage ? /*#__PURE__*/ (0, $l998X.jsx)((0, $c77fa5848e4f5168$export$2194eaf953b87e28), {
            shell: shellWithAnalyticsObject,
            callbacks: callbacks,
            mapUserIdToProfileUrl: mapUserIdToProfileUrl,
            experiments: rightExperiments
        }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
            children: [
                isFeedbackSubmitted && /*#__PURE__*/ (0, $l998X.jsx)((0, $f62272317e407c6f$export$afc032e1a809a5b9), {}),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                            direction: "column",
                            xcss: $10ee11d11e004dd8$var$topSectionStyles,
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                                    xcss: $10ee11d11e004dd8$var$linkStyles,
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                            xcss: $10ee11d11e004dd8$var$iconStyles,
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7e0cc0f7a78404ca$export$fb505dcffad77432), {})
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                            href: "https://hello.atlassian.net/wiki/spaces/SDE1/blog/2024/10/22/4354842094/Rovo+Search+October+Gold+Rush+Make+more+money+while+you+work",
                                            rel: "noopener noreferrer",
                                            target: "_blank",
                                            children: "Rovo Search October Gold Rush: Make more money while you work!"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $d0d436c022e9270f$export$660e82a991c8cc3f), {
                                    showForm: !isFeedbackSubmitted && !top5ResultsEqual,
                                    components: {
                                        form: /*#__PURE__*/ (0, $l998X.jsx)((0, $4f2c875b59b1ac8d$export$9c0b60aed40d1233), {
                                            isSideAOnLeft: true,
                                            onSubmit: submitComparisonForm,
                                            onRatingClick: handleRatingClick
                                        })
                                    }
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $760b49b77c629beb$export$79d13b60110f33be), {
                                    textQueryParam: textQueryParam,
                                    updateQueryParameters: updateSearchParams
                                })
                            ]
                        }),
                        textQueryParam && /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                            children: [
                                !top5ResultsEqual && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                    xcss: $10ee11d11e004dd8$var$expandCollapseButtonsStyles,
                                    children: !top5ResultsEqual && expandCollapseButtonsProps.map(({ hidden: hidden, expanded: expanded, label: label, onClick: onClick })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                            xcss: hidden && $10ee11d11e004dd8$var$visibilityHiddenStyle,
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                                appearance: "subtle",
                                                icon: expanded ? (0, (/*@__PURE__*/$parcel$interopDefault($bomBS))) : (0, (/*@__PURE__*/$parcel$interopDefault($gzsfl))),
                                                label: `${expanded ? 'Collapse' : 'Expand'} ${label}`,
                                                isTooltipDisabled: false,
                                                onClick: onClick,
                                                testId: `expand-collapse-${label.replace(' ', '-')}-btn`
                                            }, label)
                                        }))
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
                                    grow: "fill",
                                    alignInline: "center",
                                    xcss: $10ee11d11e004dd8$var$inlineStyles,
                                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                                xcss: [
                                                    $10ee11d11e004dd8$var$searchItemStyles,
                                                    $10ee11d11e004dd8$var$rovoSideBySideResultsStyle,
                                                    (top5ResultsEqual || leftSideExpanded) && $10ee11d11e004dd8$var$searchItemFullWidthStyles,
                                                    rightSideExpanded && $10ee11d11e004dd8$var$displayNoneStyle
                                                ],
                                                children: sideAResults
                                            }),
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                                xcss: [
                                                    $10ee11d11e004dd8$var$verticalDividerStyles,
                                                    $10ee11d11e004dd8$var$longVerticalDividerStyles,
                                                    top5ResultsEqual && $10ee11d11e004dd8$var$displayNoneStyle,
                                                    (leftSideExpanded || rightSideExpanded) && $10ee11d11e004dd8$var$displayNoneStyle
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                                xcss: [
                                                    $10ee11d11e004dd8$var$searchItemStyles,
                                                    $10ee11d11e004dd8$var$iframeSearchResultsStyle,
                                                    (top5ResultsEqual || leftSideExpanded) && $10ee11d11e004dd8$var$displayNoneStyle,
                                                    rightSideExpanded && $10ee11d11e004dd8$var$searchItemFullWidthStyles
                                                ],
                                                children: sideBResults
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        (isFeedbackSubmitted || isRated) && // display success flag when comparison feedback is submitted successfully
                        // (auto dismisses after 8 seconds)
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
                            onDismissed: ()=>{
                                handleFlagDismissed();
                            },
                            children: flags.map((flagId)=>{
                                return /*#__PURE__*/ (0, $l998X.jsx)((0, $aD1SW.default), {
                                    appearance: "success",
                                    icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                                        label: "Success",
                                        color: "currentColor",
                                        spacing: "spacious"
                                    }),
                                    id: flagId,
                                    title: flagId === $10ee11d11e004dd8$var$SUCCESS_FLAG ? 'Thanks for making search better.' : 'Thanks! We got your rating.'
                                }, flagId);
                            })
                        })
                    ]
                })
            ]
        })
    });
};
function $10ee11d11e004dd8$export$d856f3183c4e6577(props) {
    const { shell: shell } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $25d14e15020f60a9$export$3bb03aa5c3d29986), {
        userId: shell.user?.id,
        tenantId: shell.cloudId,
        entryPoint: props.entryPoint,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
            locale: "en",
            children: /*#__PURE__*/ (0, $l998X.jsx)($10ee11d11e004dd8$export$77c66aac6ab91308, {
                ...props
            })
        })
    });
}



var $56QzY = parcelRequire("56QzY");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $gz8ZY = parcelRequire("gz8ZY");


var $2Fqwa = parcelRequire("2Fqwa");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $4VJDS = parcelRequire("4VJDS");

parcelRequire("eLV9q");
var $eWzPA = parcelRequire("eWzPA");





var $j1Ss3 = parcelRequire("j1Ss3");


var $eSUdr = parcelRequire("eSUdr");

const $cae6d2e37e31ad91$export$50f68914d42bd134 = ({ setQueryParamsCallback: setQueryParamsCallback, queryParams: queryParams })=>{
    const apolloClient = (0, $j1Ss3.useApolloClient)();
    const getSpaceIdsFromSpaceKeys = (0, $42omo.useCallback)(async (spaceKeys)=>{
        if (spaceKeys.length === 0) return [];
        try {
            // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
            const query = await apolloClient.query({
                query: (0, $eSUdr.default)`query useGetSpaceIdsFromSpaceKeysQuery($spaceKeys:[String]){spaces(spaceKeys:$spaceKeys){nodes{id}}}`,
                variables: {
                    spaceKeys: spaceKeys
                }
            });
            const spaceIds = (query.data.spaces?.nodes ?? []).map((node)=>node?.id).filter((id)=>!!id);
            return spaceIds;
        } catch  {
            // TODO: log error using what Confluence uses in place of Sentry
            //	likely in follow up ticket
            // drop the spaces query param
            setQueryParamsCallback({
                ...queryParams,
                spaces: undefined
            }, true);
        }
        return [];
    }, [
        apolloClient,
        queryParams,
        setQueryParamsCallback
    ]);
    return getSpaceIdsFromSpaceKeys;
};



var $cacu1 = parcelRequire("cacu1");

const $4b3e2e9a6de8db0f$export$12ccd9fcc934a6ea = [
    'product',
    'text',
    'originalQuery',
    // This is used by "Did you mean" search correction feature
    'type',
    'lastModified',
    // "lastModified_lt",
    // "lastModified_gt",
    'titleMatch',
    'createdBy',
    'lastUpdatedBy',
    'contributors',
    'owners',
    'spaces',
    'pageStatus',
    'verified',
    'ancestor',
    'labels',
    'jAssignee',
    'jReporter',
    'jProject',
    'jCommentedByMe',
    'jWatchedByMe',
    'focusAreaTypes',
    'focusAreaUnder',
    'referrer',
    'leftExperiments',
    'rightExperiments',
    'from',
    'to',
    'cql',
    'archived',
    'filterDropdownOpen',
    'datasource',
    'status',
    'compassArchived',
    'assetsSchema',
    'assetsType',
    'positionFocusAreas',
    'positionEmploymentTypes',
    'positionJobFamilies',
    'positionStatuses',
    'positionTeams',
    'isAutoApplied'
];
const $4b3e2e9a6de8db0f$var$containerStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.negative.025'
});
const $4b3e2e9a6de8db0f$var$createSearchQueryParamsHook = (queryParamKeys)=>{
    const queryParamHooks = queryParamKeys.map((paramKey)=>[
            paramKey,
            (0, $dPJCf.createSingleQueryParamHook)(paramKey)
        ]);
    return ()=>{
        const queryParamEntries = queryParamHooks.map(([paramKey, hook])=>[
                paramKey,
                hook()
            ]).filter(([_, paramValue])=>!!paramValue);
        return Object.fromEntries(queryParamEntries);
    };
};
const $4b3e2e9a6de8db0f$var$getSearchQueryParams = $4b3e2e9a6de8db0f$var$createSearchQueryParamsHook($4b3e2e9a6de8db0f$export$12ccd9fcc934a6ea);
const $4b3e2e9a6de8db0f$var$InnerSearchPage = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(26);
    const { userEmail: userEmail } = t0;
    const { cloudId: cloudId, userId: userId, displayName: displayName, orgId: orgId, activationId: activationId, isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const { push: push, setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    let t1;
    if ($[0] !== setQueryParams) {
        t1 = (params, t2)=>{
            const replace = t2 === undefined ? false : t2;
            const filteredQueryParams = $4b3e2e9a6de8db0f$export$12ccd9fcc934a6ea.map((paramKey)=>[
                    paramKey,
                    params[paramKey]
                ]);
            setQueryParams(Object.fromEntries(filteredQueryParams), replace);
        };
        $[0] = setQueryParams;
        $[1] = t1;
    } else t1 = $[1];
    const setQueryParamsCallback = t1;
    let t2;
    if ($[2] !== displayName || $[3] !== userEmail || $[4] !== userId) {
        t2 = {
            id: userId,
            name: displayName,
            email: userEmail
        };
        $[2] = displayName;
        $[3] = userEmail;
        $[4] = userId;
        $[5] = t2;
    } else t2 = $[5];
    const userDetails = t2;
    let t3;
    if ($[6] !== push) {
        t3 = (url)=>push(url);
        $[6] = push;
        $[7] = t3;
    } else t3 = $[7];
    const onNavigate = t3;
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = $4b3e2e9a6de8db0f$var$getSearchQueryParams();
        $[8] = t4;
    } else t4 = $[8];
    const queryParams = t4;
    let t5;
    if ($[9] !== setQueryParamsCallback) {
        t5 = {
            setQueryParamsCallback: setQueryParamsCallback,
            queryParams: queryParams
        };
        $[9] = setQueryParamsCallback;
        $[10] = t5;
    } else t5 = $[10];
    const getSpaceIdsFromSpaceKeys = (0, $cae6d2e37e31ad91$export$50f68914d42bd134)(t5);
    const getNavigateToTeamsApp = (0, $eWzPA.useGetNavigateToTeamsApp)();
    let t6;
    if ($[11] !== getNavigateToTeamsApp) {
        t6 = (id)=>{
            if ((0, $9wGTI.fg)("confluence-adopt-teams-nav-config")) return getNavigateToTeamsApp({
                type: "USER",
                payload: {
                    userId: id
                }
            }).href;
            else return `/wiki/people/${id}`;
        };
        $[11] = getNavigateToTeamsApp;
        $[12] = t6;
    } else t6 = $[12];
    const mapUserIdToProfileUrl = t6;
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    let t7;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $4VJDS.default).getStringList("search_platform_layer_functions", []);
        $[13] = t7;
    } else t7 = $[13];
    const experimentLayers = t7;
    let t8;
    if ($[14] !== activationId || $[15] !== cloudId || $[16] !== getSpaceIdsFromSpaceKeys || $[17] !== isAdminHubAIEnabled || $[18] !== isNav4Enabled || $[19] !== isRovoLLMEnabled || $[20] !== mapUserIdToProfileUrl || $[21] !== onNavigate || $[22] !== orgId || $[23] !== setQueryParamsCallback || $[24] !== userDetails) {
        t8 = ((0, $6mKj3.expValEquals)("rovo-search-compare-results-pass-through-rate", "cohort", "control") || [
            "test",
            "rovo_v_rovo"
        ].includes((0, $6mKj3.expVal)("rovo-search-compare-results-pass-through-rate", "cohort", "off")) && (0, $6mKj3.expVal)("rovo-search-compare-results-pass-through-rate", "percent-rollout", 0) && Math.random() <= (0, $6mKj3.expVal)("rovo-search-compare-results-pass-through-rate", "percent-rollout", 0)) && (0, $9wGTI.fg)("search-compare-results-pass-through-rate") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $4b3e2e9a6de8db0f$var$containerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $10ee11d11e004dd8$export$d856f3183c4e6577), {
            callbacks: {
                updateQueryParameters: setQueryParamsCallback,
                getSpaceIdsFromSpaceKeys: getSpaceIdsFromSpaceKeys
            },
            shell: {
                cloudId: cloudId,
                orgId: orgId,
                activationId: activationId,
                user: userDetails,
                primaryProduct: "confluence",
                queryParams: queryParams,
                isAdminHubAIEnabled: isAdminHubAIEnabled,
                isNav4Enabled: isNav4Enabled
            },
            mapUserIdToProfileUrl: mapUserIdToProfileUrl,
            testId: "enterprise-feedback-comparison",
            isRovoVsRovo: (0, $6mKj3.expValEquals)("rovo-search-compare-results-pass-through-rate", "cohort", "rovo_v_rovo"),
            entryPoint: "confluence"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $4b3e2e9a6de8db0f$var$containerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c77fa5848e4f5168$export$a54ec244c8863715), {
            callbacks: {
                updateQueryParameters: setQueryParamsCallback,
                getSpaceIdsFromSpaceKeys: getSpaceIdsFromSpaceKeys
            },
            shell: {
                cloudId: cloudId,
                orgId: orgId,
                user: userDetails,
                primaryProduct: "confluence",
                analyticsAttributes: {
                    activationId: activationId,
                    navdexPointType: (0, $56QzY.TOUCH)
                },
                queryParams: queryParams,
                isAdminHubAIEnabled: isAdminHubAIEnabled,
                isNav4Enabled: isNav4Enabled,
                experimentLayers: experimentLayers,
                isRovoLLMEnabled: isRovoLLMEnabled
            },
            mapUserIdToProfileUrl: mapUserIdToProfileUrl,
            onNavigate: onNavigate
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cacu1.PageLoadEndEventUnifiedSearch), null));
        $[14] = activationId;
        $[15] = cloudId;
        $[16] = getSpaceIdsFromSpaceKeys;
        $[17] = isAdminHubAIEnabled;
        $[18] = isNav4Enabled;
        $[19] = isRovoLLMEnabled;
        $[20] = mapUserIdToProfileUrl;
        $[21] = onNavigate;
        $[22] = orgId;
        $[23] = setQueryParamsCallback;
        $[24] = userDetails;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
} : ({ userEmail: userEmail })=>{
    const { cloudId: cloudId, userId: userId, displayName: displayName, orgId: orgId, activationId: activationId, isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const { push: push, setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const setQueryParamsCallback = (0, $42omo.useCallback)((params, replace = false)=>{
        const filteredQueryParams = $4b3e2e9a6de8db0f$export$12ccd9fcc934a6ea.map((paramKey)=>[
                paramKey,
                params[paramKey]
            ]);
        setQueryParams(Object.fromEntries(filteredQueryParams), replace);
    }, [
        setQueryParams
    ]);
    const userDetails = (0, $42omo.useMemo)(()=>{
        return {
            id: userId,
            name: displayName,
            email: userEmail
        };
    }, [
        userId,
        displayName,
        userEmail
    ]);
    const onNavigate = (0, $42omo.useCallback)((url)=>push(url), [
        push
    ]);
    const queryParams = $4b3e2e9a6de8db0f$var$getSearchQueryParams();
    const getSpaceIdsFromSpaceKeys = (0, $cae6d2e37e31ad91$export$50f68914d42bd134)({
        setQueryParamsCallback: setQueryParamsCallback,
        queryParams: queryParams
    });
    const getNavigateToTeamsApp = (0, $eWzPA.useGetNavigateToTeamsApp)();
    const mapUserIdToProfileUrl = (id)=>{
        if ((0, $9wGTI.fg)('confluence-adopt-teams-nav-config')) return getNavigateToTeamsApp({
            type: 'USER',
            payload: {
                userId: id
            }
        }).href;
        else return `/wiki/people/${id}`;
    };
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const experimentLayers = (0, $4VJDS.default).getStringList('search_platform_layer_functions', []);
    return ((0, $6mKj3.expValEquals)('rovo-search-compare-results-pass-through-rate', 'cohort', 'control') || [
        'test',
        'rovo_v_rovo'
    ].includes((0, $6mKj3.expVal)('rovo-search-compare-results-pass-through-rate', 'cohort', 'off')) && (0, $6mKj3.expVal)('rovo-search-compare-results-pass-through-rate', 'percent-rollout', 0) && Math.random() <= (0, $6mKj3.expVal)('rovo-search-compare-results-pass-through-rate', 'percent-rollout', 0)) && (0, $9wGTI.fg)('search-compare-results-pass-through-rate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $4b3e2e9a6de8db0f$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $10ee11d11e004dd8$export$d856f3183c4e6577), {
        callbacks: {
            updateQueryParameters: setQueryParamsCallback,
            getSpaceIdsFromSpaceKeys: getSpaceIdsFromSpaceKeys
        },
        shell: {
            cloudId: cloudId,
            orgId: orgId,
            activationId: activationId,
            user: userDetails,
            primaryProduct: 'confluence',
            queryParams: queryParams,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            isNav4Enabled: isNav4Enabled
        },
        mapUserIdToProfileUrl: mapUserIdToProfileUrl,
        testId: "enterprise-feedback-comparison",
        isRovoVsRovo: (0, $6mKj3.expValEquals)('rovo-search-compare-results-pass-through-rate', 'cohort', 'rovo_v_rovo'),
        entryPoint: "confluence"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $4b3e2e9a6de8db0f$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c77fa5848e4f5168$export$a54ec244c8863715), {
        callbacks: {
            updateQueryParameters: setQueryParamsCallback,
            getSpaceIdsFromSpaceKeys: getSpaceIdsFromSpaceKeys
        },
        shell: {
            cloudId: cloudId,
            orgId: orgId,
            user: userDetails,
            primaryProduct: 'confluence',
            analyticsAttributes: {
                activationId: activationId,
                navdexPointType: (0, $56QzY.TOUCH)
            },
            queryParams: queryParams,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            isNav4Enabled: isNav4Enabled,
            experimentLayers: experimentLayers,
            isRovoLLMEnabled: isRovoLLMEnabled
        },
        mapUserIdToProfileUrl: mapUserIdToProfileUrl,
        onNavigate: onNavigate
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cacu1.PageLoadEndEventUnifiedSearch), null));
};
const $4b3e2e9a6de8db0f$export$6035a7da2f047ee = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: "advanced-search-search-page"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fqwa.UserContext), null, $4b3e2e9a6de8db0f$var$_temp));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    // update advanced search page load name (used for UFO)
    (0, $42omo.useMemo)(()=>(0, $054Kg.updatePageloadName)('unified_search'), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "advanced-search-search-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fqwa.UserContext), null, ({ data: data, isLoading: isLoading })=>!isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4b3e2e9a6de8db0f$var$InnerSearchPage, {
            userEmail: data?.email
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
            name: "search-page-user-context-loading"
        })));
};
function $4b3e2e9a6de8db0f$var$_temp(t0) {
    const { data: data, isLoading: isLoading } = t0;
    return !isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4b3e2e9a6de8db0f$var$InnerSearchPage, {
        userEmail: data?.email
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: "search-page-user-context-loading"
    });
}
module.exports["SEARCH_PAGE_QUERY_PARAM_KEYS"] = $4b3e2e9a6de8db0f$export$12ccd9fcc934a6ea;
module.exports["ConfluenceSearchPage"] = $4b3e2e9a6de8db0f$export$6035a7da2f047ee;

});

parcelRegister("2v58P", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29b8fabcbadba6f2330eb5adb719ad2a>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lE8sM = parcelRequire("lE8sM");


var $2qVkt = parcelRequire("2qVkt");


var $kMqyt = parcelRequire("kMqyt");


var $dh538 = parcelRequire("dh538");


var $NepPo = parcelRequire("NepPo");

/**
 * __24px `issue` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $a9dcac4e3b370d82$var$Issue24Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $dh538.fg)('platform_dst_icon_object_to_object') || (0, $dh538.fg)('platform_dst_icon_object_to_object_stage2')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kMqyt.default), {
        label: label,
        testId: testId,
        size: "small"
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lE8sM.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))),
        appearance: "blueBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $l998X.jsx)((0, $NepPo.default), {
            label: label,
            testId: testId
        })
    });
};
$a9dcac4e3b370d82$var$Issue24Icon.displayName = 'Issue24Icon';
var $a9dcac4e3b370d82$export$2e2bcd8739ae039 = $a9dcac4e3b370d82$var$Issue24Icon;
module.exports["default"] = $a9dcac4e3b370d82$export$2e2bcd8739ae039;

});

parcelRegister("kMqyt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $cb2f9539166b293e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::30f3baace5bcd49b8a2c522228cf7a06>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $2qVkt = parcelRequire("2qVkt");


var $fP78j = parcelRequire("fP78j");

function $cb2f9539166b293e$export$2e2bcd8739ae039({ label: label = 'Work Item', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("fP78j", function(module, exports) {
$parcel$export(module.exports, "default", () => $fce53c8d1c9f5417$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $i7jPX = parcelRequire("i7jPX");

function $fce53c8d1c9f5417$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $dRnqM.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $i7jPX.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size,
        children: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            label: label,
            color: color,
            testId: testId,
            // @ts-expect-error - Internal, undocumented prop
            shouldScale: true
        })
    });
}

});

parcelRegister("i7jPX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6421b29072e9fbe0$export$2e2bcd8739ae039);
/* tile.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $6421b29072e9fbe0$var$styles = {
    root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf",
    border: "_189ee4h9 _1dqonqa1 _1h6d1l7x",
    inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
    nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq"
};
const $6421b29072e9fbe0$var$sizeMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
    xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
    small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
    medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
    large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
    xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
const $6421b29072e9fbe0$var$insetSizeMap = {
    xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv _5ile19el _1hdc19el _1pc719el _pkax19el",
    xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf _5ilemccc _1hdcmccc _1pc7mccc _pkaxmccc",
    small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8 _5ilewk7l _1hdcwk7l _1pc7wk7l _pkaxwk7l",
    medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _5ile1gpt _1hdc1gpt _1pc71gpt _pkax1gpt",
    large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf _5ile1txs _1hdc1txs _1pc71txs _pkax1txs",
    xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg _5ilea982 _1hdca982 _1pc7a982 _pkaxa982"
};
const $6421b29072e9fbe0$var$backgroundColorMap = {
    white: "_bfhku67f",
    black: "_bfhkr3uz",
    transparent: "_bfhk1j28",
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.information': "_bfhk19ip",
    'color.background.information.bold': "_bfhkx4w0"
}; /**
    * __Tile__
    *
    * A tile is a rounded square that takes an asset and represents a noun.
    *
    */ 
function $6421b29072e9fbe0$export$2e2bcd8739ae039(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $gMc0m.default)([
            $6421b29072e9fbe0$var$styles.root,
            $6421b29072e9fbe0$var$sizeMap[size],
            isInset ? $6421b29072e9fbe0$var$styles.inset : $6421b29072e9fbe0$var$styles.nonInset,
            isInset && $6421b29072e9fbe0$var$insetSizeMap[size],
            $6421b29072e9fbe0$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $6421b29072e9fbe0$var$styles.border
        ]),
        children: children
    });
}

});

parcelRegister("NepPo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c9917daab99b2b512eb2fa370f489a30>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $id7ja = parcelRequire("id7ja");

const $cd726cc49e57e73c$var$Issue24Icon = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $id7ja.Icon), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m0 8.009v7.982C3 17.098 3.893 18 4.995 18h14.01C20.107 18 21 17.1 21 15.991V8.01A2.004 2.004 0 0 0 19.005 6H4.995C3.893 6 3 6.9 3 8.009m11.293 1.284a1 1 0 0 1 1.414 1.414l-3.5 3.5a1 1 0 0 1-1.415-.001l-1.97-1.978a1 1 0 1 1 1.416-1.411l1.263 1.267zM5 15.99c0 .007 14.005.009 14.005.009C18.999 16 19 8.009 19 8.009 19 8.002 4.995 8 4.995 8 5.001 8 5 15.991 5 15.991"/></svg>`,
        ...props,
        size: "medium"
    });
$cd726cc49e57e73c$var$Issue24Icon.displayName = 'Issue24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cd726cc49e57e73c$export$2e2bcd8739ae039 = $cd726cc49e57e73c$var$Issue24Icon;
module.exports["default"] = $cd726cc49e57e73c$export$2e2bcd8739ae039;

});

parcelRegister("5yCDo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::336ef46e533f814d943c18f17888641f>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lE8sM = parcelRequire("lE8sM");


var $8jHAi = parcelRequire("8jHAi");


var $1R3zJ = parcelRequire("1R3zJ");


var $dh538 = parcelRequire("dh538");


var $6sIiw = parcelRequire("6sIiw");

/**
 * __24px `page` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $7b9784c8c4fb40e3$var$Page24Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $dh538.fg)('platform_dst_icon_object_to_object') || (0, $dh538.fg)('platform_dst_icon_object_to_object_stage2')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1R3zJ.default), {
        label: label,
        testId: testId,
        size: "small"
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lE8sM.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        appearance: "blueBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $l998X.jsx)((0, $6sIiw.default), {
            label: label,
            testId: testId
        })
    });
};
$7b9784c8c4fb40e3$var$Page24Icon.displayName = 'Page24Icon';
var $7b9784c8c4fb40e3$export$2e2bcd8739ae039 = $7b9784c8c4fb40e3$var$Page24Icon;
module.exports["default"] = $7b9784c8c4fb40e3$export$2e2bcd8739ae039;

});

parcelRegister("1R3zJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $e6d73fa950add8a3$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::afa74181baaa67be5e1a2274a7254425>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8jHAi = parcelRequire("8jHAi");


var $fP78j = parcelRequire("fP78j");

function $e6d73fa950add8a3$export$2e2bcd8739ae039({ label: label = 'Page', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("6sIiw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::de51ff68982fa6ca175a05d5c052c322>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $id7ja = parcelRequire("id7ja");

const $f0c99b624de6a1a9$var$Page24Icon = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $id7ja.Icon), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 18c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01c-.54 0-.995.448-.995 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1"/></svg>`,
        ...props,
        size: "medium"
    });
$f0c99b624de6a1a9$var$Page24Icon.displayName = 'Page24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f0c99b624de6a1a9$export$2e2bcd8739ae039 = $f0c99b624de6a1a9$var$Page24Icon;
module.exports["default"] = $f0c99b624de6a1a9$export$2e2bcd8739ae039;

});

parcelRegister("3ro6F", function(module, exports) {
/* breadcrumbs-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");


var $3gadb = parcelRequire("3gadb");


var $5azuv = parcelRequire("5azuv");


var $9VmkK = parcelRequire("9VmkK");


var $F1g0V = parcelRequire("F1g0V");

const $5c3d9d5d7ce5effd$var$itemWrapperStyles = null;
const $5c3d9d5d7ce5effd$var$VAR_STEP_TRUNCATION_WIDTH = '--max-width';
const $5c3d9d5d7ce5effd$var$ICON_WIDTH_ESTIMATE = 24;
const $5c3d9d5d7ce5effd$var$staticItemStyles = null;
const $5c3d9d5d7ce5effd$var$staticItemWithTruncationStyles = null;
const $5c3d9d5d7ce5effd$var$staticItemWithoutTruncationStyles = null;
const $5c3d9d5d7ce5effd$var$BreadcrumbsItem = /*#__PURE__*/ (0, $42omo.memo)(({ analyticsContext: analyticsContext, component: component, href: // `createAnalyticsEvent` should be here, but throws errors on render since
// it ends up being spread on a DOM element at the very end
href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, ref: // This is overridden by the `buttonRef` below
ref, target: target, testId: testId, text: text, truncationWidth: truncationWidth, // I believe there is only `createAnalyticsEvent` left on here, but leaving
// it here to allow this to be a patch and not a major
...rest })=>{
    const stepTextRef = (0, $42omo.useRef)(null); // If icons are provided we include their width in the truncation calculation to ensure we're as accurate as possible.
    // Note: this assumes icons are 24px wide which should be almost always.
    // Not really an issue if the icons are smaller, just that truncation occurs slightly earlier than you may want.
    let iconWidthAllowance = 0;
    if (iconBefore) iconWidthAllowance += $5c3d9d5d7ce5effd$var$ICON_WIDTH_ESTIMATE;
    if (iconAfter) iconWidthAllowance += $5c3d9d5d7ce5effd$var$ICON_WIDTH_ESTIMATE;
    const [hasOverflow, showTooltip] = (0, $F1g0V.default)(truncationWidth, stepTextRef.current, iconWidthAllowance); // This should be a part of staticItemStyles but it requires the !important flag to prevent the padding from being overridden by the button styles
    // compiled treats `${token(xxx)} !important` differently when concat !important in es2019 and esm built files
    // the padding and font weight were not sourced correctly in the esm build
    const buttonOverrideStyles = {
        paddingBlock: "var(--ds-space-025, 2px)",
        fontWeight: "var(--ds-font-weight-regular, 400)"
    }; // Note: cast to `any` is required to type verification - see https://github.com/frenic/csstype#what-should-i-do-when-i-get-type-errors
    const dynamicItemStyles = {
        [$5c3d9d5d7ce5effd$var$VAR_STEP_TRUNCATION_WIDTH]: typeof truncationWidth !== 'undefined' && `${truncationWidth}px`
    };
    const step = !component && (0, $dh538.fg)('platform_dst_breadcrumbs_step_conversion') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $5azuv.default), {
        ref: stepTextRef,
        analyticsContext: analyticsContext,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        target: target,
        testId: testId,
        truncationWidth: truncationWidth,
        children: text
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $9VmkK.default), {
        ...rest,
        analyticsContext: analyticsContext,
        component: component,
        hasOverflow: hasOverflow,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        ref: stepTextRef,
        target: target,
        testId: testId,
        style: truncationWidth ? {
            ...dynamicItemStyles,
            ...buttonOverrideStyles
        } : buttonOverrideStyles,
        className: (0, $gMc0m.default)([
            "_vwz41txs",
            truncationWidth ? "_p12f8zc4" : "_1ul9grf3 _1o9zzg3v"
        ]),
        children: text
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("li", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _2lx2vrvc _ect4ttxp _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsoftgi _toskidpf _15621n76 _191d1h6o"
        ]),
        children: showTooltip ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown,
            children: step
        }) : step
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5c3d9d5d7ce5effd$export$2e2bcd8739ae039 = $5c3d9d5d7ce5effd$var$BreadcrumbsItem;
module.exports["default"] = $5c3d9d5d7ce5effd$export$2e2bcd8739ae039;

});

parcelRegister("5azuv", function(module, exports) {
/* step.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $1Whri = parcelRequire("1Whri");


var $ee7An = parcelRequire("ee7An");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");

var $fVUfS = parcelRequire("fVUfS");

const $bd15777e6f419ea7$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $bd15777e6f419ea7$var$noop = (0, $ee7An.default);
const $bd15777e6f419ea7$var$styles = {
    root: "_11c8fhey _19itglyw _zulp1b66 _2rko12b0 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1rjcv77o _18zrze3t _bfhksm61 _syaz1rpy _1e0c116y _4cvr1h6o _1a3b1r31 _4fprglyw _5goinqa1 _f8pj1rpy _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31rpy _9h8hi7uo",
    rootT26Shape: "_2rkolb4i",
    withoutTruncation: "_1ul9idpf _1o9zkb7n",
    text: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
}; /**
    * __Step__
    *
    * A button that represents a single step in a breadcrumbs component.
    */ 
const $bd15777e6f419ea7$var$Step = /*#__PURE__*/ (0, $42omo.forwardRef)(({ analyticsContext: analyticsContext, href: href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $bd15777e6f419ea7$var$noop, target: target, testId: testId, children: children, truncationWidth: truncationWidth }, ref)=>{
    const handleClick = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$bd15777e6f419ea7$var$analyticsAttributes
    });
    const content = /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            iconBefore,
            /*#__PURE__*/ (0, $l998X.jsx)("span", {
                ref: ref,
                className: (0, $gMc0m.default)([
                    $bd15777e6f419ea7$var$styles.text
                ]),
                children: children
            }),
            iconAfter
        ]
    });
    if (href) return /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
        href: href,
        onClick: handleClick,
        target: target,
        testId: testId,
        xcss: (0, $1Whri.cx)($bd15777e6f419ea7$var$styles.root, !truncationWidth && $bd15777e6f419ea7$var$styles.withoutTruncation, (0, $dh538.fg)('platform-dst-shape-theme-default') && $bd15777e6f419ea7$var$styles.rootT26Shape),
        style: {
            maxWidth: truncationWidth
        },
        children: content
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        onClick: handleClick,
        testId: testId,
        xcss: (0, $1Whri.cx)($bd15777e6f419ea7$var$styles.root, !truncationWidth && $bd15777e6f419ea7$var$styles.withoutTruncation, (0, $dh538.fg)('platform-dst-shape-theme-default') && $bd15777e6f419ea7$var$styles.rootT26Shape),
        style: {
            maxWidth: truncationWidth
        },
        children: content
    });
});
var $bd15777e6f419ea7$export$2e2bcd8739ae039 = $bd15777e6f419ea7$var$Step;
module.exports["default"] = $bd15777e6f419ea7$export$2e2bcd8739ae039;

});

parcelRegister("9VmkK", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $eEA8O = parcelRequire("eEA8O");


var $ee7An = parcelRequire("ee7An");

const $b9cd9c632c3988d9$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $b9cd9c632c3988d9$var$noop = (0, $ee7An.default);
/**
 * __Step__
 *
 * A button that represents a single step in a breadcrumbs component.
 */ const $b9cd9c632c3988d9$var$StepOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ analyticsContext: analyticsContext, component: component, hasOverflow: hasOverflow = true, href: href = '#', iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $b9cd9c632c3988d9$var$noop, target: target, testId: testId, // Button does not take `createAnalyticsEvent`, but it is spread on anyway
...props }, ref)=>{
    const handleClicked = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$b9cd9c632c3988d9$var$analyticsAttributes
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
        ...props,
        appearance: "subtle-link",
        component: component,
        href: href,
        iconAfter: hasOverflow ? undefined : iconAfter,
        iconBefore: hasOverflow ? undefined : iconBefore,
        onClick: handleClicked,
        ref: ref,
        spacing: "none",
        target: target,
        testId: testId
    });
});
var $b9cd9c632c3988d9$export$2e2bcd8739ae039 = $b9cd9c632c3988d9$var$StepOld;
module.exports["default"] = $b9cd9c632c3988d9$export$2e2bcd8739ae039;

});

parcelRegister("F1g0V", function(module, exports) {
$parcel$export(module.exports, "default", () => $7675ee682b2302ec$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $7675ee682b2302ec$export$2e2bcd8739ae039(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
    const shouldCheckWidth = truncationWidth && buttonRefCurrent;
    // Default to true to match hasOverflow = true default in Step component.
    // This should ensure the icon never appears and then quickly disappears
    const [hasOverflow, setOverflow] = (0, $42omo.useState)(Boolean(shouldCheckWidth));
    const [showTooltip, setShowTooltip] = (0, $42omo.useState)(false);
    // Need to recalculate on every render cycle as text/icons/width changing will change the outcome
    (0, $42omo.useEffect)(()=>{
        if (shouldCheckWidth) {
            // Calculate if the button width will be larger than the truncation width after allowing for icon widths.
            // The button having a width greater than the truncationWidth, with icons, indicates the icons should be hidden to avoid going over the width limit
            const shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
            // The button width can already be equal to the truncationWidth which is an indicator that truncation is occurring and a tooltip should be displayed
            const shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
            setOverflow(shouldOverflow);
            setShowTooltip(shouldShowTooltip);
        } else {
            setOverflow(false);
            setShowTooltip(false);
        }
    }, [
        truncationWidth,
        buttonRefCurrent,
        iconWidthAllowance,
        shouldCheckWidth
    ]);
    return [
        hasOverflow,
        showTooltip
    ];
}

});

parcelRegister("kGnTD", function(module, exports) {
/* breadcrumbs.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $3654r = parcelRequire("3654r");


var $ee7An = parcelRequire("ee7An");


var $k7fGo = parcelRequire("k7fGo");


var $3AVDQ = parcelRequire("3AVDQ");

const $bb8be9a617eb3e67$var$defaultMaxItems = 8;
const $bb8be9a617eb3e67$var$defaultBreadcrumbsLabel = 'Breadcrumbs';
const $bb8be9a617eb3e67$var$defaultEllipsisLabel = 'Show more breadcrumbs';
const { toArray: $bb8be9a617eb3e67$var$toArray } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children;
const $bb8be9a617eb3e67$var$analyticsAttributes = {
    componentName: 'breadcrumbs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $bb8be9a617eb3e67$var$noop = (0, $ee7An.default);
const $bb8be9a617eb3e67$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
const $bb8be9a617eb3e67$var$breadcrumbStyles = null;
const $bb8be9a617eb3e67$var$InnerBreadcrumbs = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { defaultExpanded: defaultExpanded = false, isExpanded: isExpanded, maxItems: maxItems = $bb8be9a617eb3e67$var$defaultMaxItems, itemsBeforeCollapse: itemsBeforeCollapse = 1, itemsAfterCollapse: itemsAfterCollapse = 1, children: children = [], testId: testId, onExpand: providedExpanse = $bb8be9a617eb3e67$var$noop, analyticsContext: analyticsContext, label: label = $bb8be9a617eb3e67$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $bb8be9a617eb3e67$var$defaultEllipsisLabel } = props;
    const [expanded, setExpanse] = (0, $42omo.useState)(defaultExpanded);
    const [isClickedBySpace, setExpansionTrigger] = (0, $42omo.useState)(false);
    const wrapperRef = (0, $42omo.useRef)(null);
    const isControlled = typeof isExpanded !== 'undefined';
    const isExpansionHandled = providedExpanse !== $bb8be9a617eb3e67$var$noop;
    const shouldExpand = isControlled ? isExpanded : expanded;
    const focusFirstRevealedMemoized = (0, $42omo.useCallback)(()=>{
        if (wrapperRef.current) {
            const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
            const interactiveElements = listItems.map((li)=>li.querySelector($bb8be9a617eb3e67$var$interactiveElementSelector));
            const elementToFocus = interactiveElements[itemsBeforeCollapse];
            const firstInteractiveElement = interactiveElements[0];
            if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
            else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
            else wrapperRef.current.focus();
        }
        setExpansionTrigger(false);
    }, [
        setExpansionTrigger,
        itemsBeforeCollapse,
        wrapperRef
    ]);
    (0, $3AVDQ.useOnRevealed)(focusFirstRevealedMemoized, {
        isExpanded: shouldExpand,
        isDisabled: !isClickedBySpace
    });
    const handleExpansion = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isControlled) setExpanse((expanded)=>!expanded);
            if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === document.activeElement);
            return providedExpanse(event, analyticsEvent);
        },
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$bb8be9a617eb3e67$var$analyticsAttributes
    });
    const childrenArray = $bb8be9a617eb3e67$var$toArray(children);
    const breadcrumbsArray = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(childrenArray, (child, index)=>{
        //To avoid error if child is a string
        if (typeof child === 'string') return child;
        return childrenArray.length - 1 === index ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, {
            'aria-current': 'page'
        }) : child;
    });
    const renderItemsWithEllipsis = ()=>{
        const allItems = breadcrumbsArray; // This defends against someone passing weird data, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        const beforeItems = allItems.slice(0, itemsBeforeCollapse);
        const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [
            ...beforeItems,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $k7fGo.default), {
                testId: testId && `${testId}--breadcrumb-ellipsis`,
                onClick: handleExpansion,
                label: ellipsisLabel
            }, "ellipsis"),
            ...afterItems
        ];
    };
    const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
    const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
    return /*#__PURE__*/ (0, $l998X.jsx)("nav", {
        "aria-label": label,
        ref: (0, $3654r.default)([
            ref,
            wrapperRef
        ]),
        tabIndex: -1,
        children: /*#__PURE__*/ (0, $l998X.jsx)("ol", {
            "data-testid": testId,
            className: (0, $gMc0m.default)([
                "_1e0c1txw _1n261g80 _syaz1rpy _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
            ]),
            children: breadcrumbsItems
        })
    });
});
const $bb8be9a617eb3e67$var$Breadcrumbs = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(({ analyticsContext: analyticsContext, children: children, createAnalyticsEvent: createAnalyticsEvent, defaultExpanded: defaultExpanded, ellipsisLabel: ellipsisLabel, isExpanded: isExpanded, itemsAfterCollapse: itemsAfterCollapse, itemsBeforeCollapse: itemsBeforeCollapse, label: label, maxItems: maxItems, onExpand: onExpand, testId: testId, ...props }, ref)=>/*#__PURE__*/ (0, $l998X.jsx)($bb8be9a617eb3e67$var$InnerBreadcrumbs, {
        ...props,
        analyticsContext: analyticsContext,
        children: children,
        createAnalyticsEvent: createAnalyticsEvent,
        defaultExpanded: defaultExpanded,
        ellipsisLabel: ellipsisLabel,
        isExpanded: isExpanded,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        label: label,
        maxItems: maxItems,
        onExpand: onExpand,
        ref: ref,
        testId: testId
    }))); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $bb8be9a617eb3e67$export$2e2bcd8739ae039 = $bb8be9a617eb3e67$var$Breadcrumbs;
module.exports["default"] = $bb8be9a617eb3e67$export$2e2bcd8739ae039;

});

parcelRegister("k7fGo", function(module, exports) {
/* ellipsis-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eEA8O = parcelRequire("eEA8O");


var $ee7An = parcelRequire("ee7An");


var $dh538 = parcelRequire("dh538");


var $fVUfS = parcelRequire("fVUfS");

const $7976e3e68603e041$var$noop = (0, $ee7An.default);
const $7976e3e68603e041$var$itemWrapperStyles = null;
const $7976e3e68603e041$var$staticItemStyles = null;
const $7976e3e68603e041$var$styles = {
    root: "_11c8fhey _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _zulp1b66 _2rko12b0 _4bfu1r31 _1hmsglyw _ajmmnqa1 _bfhksm61 _syaz1rpy _1e0c116y _4cvr1h6o _1a3b1r31 _4fprglyw _5goinqa1 _f8pj1rpy _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31rpy _9h8hi7uo"
};
const $7976e3e68603e041$var$EllipsisItem = /*#__PURE__*/ (0, $42omo.memo)(({ label: label, onClick: onClick = $7976e3e68603e041$var$noop, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)("li", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _2lx2vrvc _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsou2gc _toskidpf _15621n76 _191d1h6o"
        ]),
        children: (0, $dh538.fg)('platform_dst_breadcrumbs_step_conversion') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
            "aria-label": label,
            onClick: onClick,
            xcss: $7976e3e68603e041$var$styles.root,
            testId: testId,
            children: "\u2026"
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
            appearance: "subtle-link",
            "aria-label": label,
            onClick: onClick,
            spacing: "none",
            testId: testId,
            className: (0, $gMc0m.default)([
                "_1rjc1tvq _k48p1hhk _vwz41txs"
            ]),
            children: "\u2026"
        })
    })); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $7976e3e68603e041$export$2e2bcd8739ae039 = $7976e3e68603e041$var$EllipsisItem;
module.exports["default"] = $7976e3e68603e041$export$2e2bcd8739ae039;

});

parcelRegister("3AVDQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bzNqF = parcelRequire("bzNqF");

function $bbb20e0fdee82203$export$e9c4922b2ecf808a(callback, { isExpanded: isExpanded, isDisabled: isDisabled }) {
    const prevExtended = (0, $bzNqF.default)(isExpanded);
    (0, $42omo.useEffect)(()=>{
        const hasBeenRevealed = !prevExtended && isExpanded;
        if (!isDisabled && hasBeenRevealed) callback();
    }, [
        isExpanded,
        isDisabled,
        callback,
        prevExtended
    ]);
}
module.exports["useOnRevealed"] = $bbb20e0fdee82203$export$e9c4922b2ecf808a;

});

parcelRegister("1z61g", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");

const $c535aa85cd05bb48$var$operationName = 'AutoSuggestionQuery';
const $c535aa85cd05bb48$var$AutoSuggestionQuery = `
query ${$c535aa85cd05bb48$var$operationName}($query: String, $limit: Int!, $filters: QuerySuggestionFilterInput!) {
  suggest {
    suggest(query: $query, limit: $limit, filters: $filters) {
      nodes {
        title
        type
      }
      totalCount
    }
  }
}
`;
const $c535aa85cd05bb48$export$aa1032c480f72e0d = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl })=>(0, $4qT1X.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: $c535aa85cd05bb48$var$AutoSuggestionQuery,
        operationName: $c535aa85cd05bb48$var$operationName
    });
module.exports["autoSuggestionQuery"] = $c535aa85cd05bb48$export$aa1032c480f72e0d;

});

parcelRegister("1L3gY", function(module, exports) {

var $1NrSh = parcelRequire("1NrSh");

const $1be24a0ae8e76adc$var$fetchUserRecommendations = (request, signal)=>{
    const url = (0, $1NrSh.PRD_CONFIG).getRecommendationServiceUrl(request.baseUrl);
    return fetch(url, {
        signal: signal,
        method: 'POST',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: request.context,
            includeUsers: request.includeUsers,
            includeGroups: request.includeGroups,
            includeTeams: request.includeTeams,
            maxNumberOfResults: request.maxNumberOfResults,
            performSearchQueryOnly: request.performSearchQueryOnly,
            searchQuery: {
                cpusQueryHighlights: {
                    query: request.searchQuery?.cpusQueryHighlights?.query ?? '',
                    field: request.searchQuery?.cpusQueryHighlights?.field ?? ''
                },
                customQuery: request.searchQuery?.customQuery ?? '',
                customerDirectoryId: request.searchQuery?.customerDirectoryId ?? '',
                filter: request.searchQuery?.filter ?? '',
                minimumAccessLevel: request.searchQuery?.minimumAccessLevel ?? 'APPLICATION',
                queryString: request.query,
                restrictTo: {
                    userIds: request.searchQuery?.restrictTo?.userIds ?? [],
                    groupIds: request.searchQuery?.restrictTo?.userIds ?? []
                },
                searchUserbase: request.searchQuery?.searchUserbase ?? false,
                teamSearchFields: request.searchQuery?.teamSearchFields ?? []
            }
        })
    }).then((response)=>{
        if (response.status === 200) return response.json();
        throw new Error(`error calling smart service, statusCode=${response.status}, statusText=${response.statusText}`);
    }).then((response)=>response.recommendedUsers);
};
var $1be24a0ae8e76adc$export$2e2bcd8739ae039 = $1be24a0ae8e76adc$var$fetchUserRecommendations;
module.exports["default"] = $1be24a0ae8e76adc$export$2e2bcd8739ae039;

});

parcelRegister("1NrSh", function(module, exports) {
const $49895188b0a86f3f$export$d4fff2dfff3e2bc1 = {
    getRecommendationServiceUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
    },
    getUsersServiceUrl (productKey) {
        return productKey === 'jira' ? `/rest/api/3/user/bulk` : `/wiki/rest/api/user/bulk`;
    },
    getGraphQLUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
    },
    getTeamsUrl (baseUrl) {
        return baseUrl ? `/${baseUrl}/gateway/api/v3/teams` : `/gateway/api/v3/teams`;
    }
};
module.exports["PRD_CONFIG"] = $49895188b0a86f3f$export$d4fff2dfff3e2bc1;

});

parcelRegister("c5JjN", function(module, exports) {
var $59881ae81e3665ce$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["USER"] = "USER";
    EntityType["TEAM"] = "TEAM";
    EntityType["GROUP"] = "GROUP";
    return EntityType;
}({});
var $59881ae81e3665ce$export$3d32048696128045 = /*#__PURE__*/ function(TeamSearchField) {
    TeamSearchField["NAME"] = "name";
    TeamSearchField["DESCRIPTION"] = "description";
    return TeamSearchField;
}({});
module.exports["EntityType"] = $59881ae81e3665ce$export$8eda7e02f8f033b2;
module.exports["TeamSearchField"] = $59881ae81e3665ce$export$3d32048696128045;

});

parcelRegister("5G9KX", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $c4TO3 = parcelRequire("c4TO3");

const $34a6846e1e43ece9$export$5aa524d86254b4f = (key, value)=>{
    if ((0, $dh538.fg)('search_page_use_browser_storage_controls')) (0, $c4TO3.AtlBrowserStorageLocal).setItem(key, value);
    else localStorage.setItem(key, value);
};
const $34a6846e1e43ece9$export$93d719890ad66653 = (key)=>{
    const item = (0, $dh538.fg)('search_page_use_browser_storage_controls') ? (0, $c4TO3.AtlBrowserStorageLocal).getItem(key) : localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
};
const $34a6846e1e43ece9$export$5df15f289f441790 = (key)=>{
    const item = (0, $dh538.fg)('search_page_use_browser_storage_controls') ? (0, $c4TO3.AtlBrowserStorageLocal).getItem(key) : localStorage.getItem(key);
    return item ? item : null;
};
const $34a6846e1e43ece9$export$baf306891f1b93bd = (key)=>{
    if ((0, $dh538.fg)('search_page_use_browser_storage_controls')) (0, $c4TO3.AtlBrowserStorageLocal).removeItem(key);
    else localStorage.removeItem(key);
};
module.exports["setLocalStorageItem"] = $34a6846e1e43ece9$export$5aa524d86254b4f;
module.exports["getLocalStorageItem"] = $34a6846e1e43ece9$export$93d719890ad66653;
module.exports["getLocalStorageItemAsString"] = $34a6846e1e43ece9$export$5df15f289f441790;
module.exports["removeLocalStorageItem"] = $34a6846e1e43ece9$export$baf306891f1b93bd;

});

parcelRegister("dpPtd", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aD1SW = parcelRequire("aD1SW");


var $eCEXz = parcelRequire("eCEXz");


var $6uGcC = parcelRequire("6uGcC");

const $c997cd3fd9f4ee84$var$FlagContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);
function $c997cd3fd9f4ee84$export$2879604e6aec4ab() {
    const api = (0, $42omo.useContext)($c997cd3fd9f4ee84$var$FlagContext);
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}
const $c997cd3fd9f4ee84$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
function $c997cd3fd9f4ee84$export$a4270ab432ac8a58({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $42omo.useState)([]);
    const removeFlag = (0, $42omo.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $42omo.useMemo)(()=>({
            showFlag: function show(value) {
                const flag = {
                    ...value,
                    id: value.id || $c997cd3fd9f4ee84$var$getUniqueId()
                };
                setFlags((current)=>{
                    const index = current.findIndex((value)=>value.id === flag.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag,
                        ...current
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current
                    ];
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            }
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($c997cd3fd9f4ee84$var$FlagContext.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag;
                    const FlagType = isAutoDismiss ? (0, $aD1SW.default) : (0, $eCEXz.default);
                    return /*#__PURE__*/ (0, $42omo.createElement)(FlagType, {
                        ...restProps,
                        key: flag.id
                    });
                })
            })
        ]
    });
}
const $c997cd3fd9f4ee84$export$7b676815c264eaf3 = (fn)=>/*#__PURE__*/ (0, $l998X.jsx)($c997cd3fd9f4ee84$export$a4270ab432ac8a58, {
        children: fn()
    });
module.exports["useFlags"] = $c997cd3fd9f4ee84$export$2879604e6aec4ab;
module.exports["FlagsProvider"] = $c997cd3fd9f4ee84$export$a4270ab432ac8a58;

});

parcelRegister("bVltF", function(module, exports) {

var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");

const $95b33375becf7c06$var$COMPONENT = 'search-page';
const $95b33375becf7c06$export$a98443e214d7b1fd = new (0, $5aVN7.UFOExperience)('load', {
    type: (0, $9NDUe.ExperienceTypes).Load,
    performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad,
    platform: {
        component: $95b33375becf7c06$var$COMPONENT
    }
});
const $95b33375becf7c06$export$e882a2ec68d19be8 = new (0, $5aVN7.UFOExperience)('search-results-load', {
    type: (0, $9NDUe.ExperienceTypes).Experience,
    performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: $95b33375becf7c06$var$COMPONENT
    },
    timings: [
        {
            key: 'request',
            startMark: 'request_start',
            endMark: 'request_end'
        },
        {
            key: 'render',
            startMark: 'render_start',
            endMark: 'render_end'
        }
    ]
});
const $95b33375becf7c06$export$eda1f56a83aaec73 = async ()=>{
    if (!$95b33375becf7c06$export$e882a2ec68d19be8.state.final) await $95b33375becf7c06$export$e882a2ec68d19be8.abort({
        metadata: {
            reason: 'restarted'
        }
    });
    $95b33375becf7c06$export$e882a2ec68d19be8.start();
};
const $95b33375becf7c06$export$b066085d86746240 = ({ queryLength: queryLength, wordCount: wordCount })=>{
    $95b33375becf7c06$export$e882a2ec68d19be8.success({
        metadata: {
            queryLength: queryLength,
            wordCount: wordCount
        }
    });
};
const $95b33375becf7c06$export$7cc1b457adcf3334 = ()=>{
    $95b33375becf7c06$export$e882a2ec68d19be8.failure();
};
module.exports["searchPageLoadUFOExperience"] = $95b33375becf7c06$export$a98443e214d7b1fd;
module.exports["searchResultsLoadUFOExperience"] = $95b33375becf7c06$export$e882a2ec68d19be8;
module.exports["searchResultsLoadUFOExperienceStart"] = $95b33375becf7c06$export$eda1f56a83aaec73;
module.exports["searchResultsLoadUFOExperienceSuccess"] = $95b33375becf7c06$export$b066085d86746240;
module.exports["searchResultsLoadUFOExperienceError"] = $95b33375becf7c06$export$7cc1b457adcf3334;

});

parcelRegister("2Nwuj", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

const $0412590977f134ac$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $0412590977f134ac$var$iconStyles = null;
const $0412590977f134ac$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $auNCB.default // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $1Whri.cx)($0412590977f134ac$var$styles.base, (0, $dh538.fg)('platform-dst-shape-theme-default') && $0412590977f134ac$var$styles.baseT26Shape, appearance === 'default' && $0412590977f134ac$var$styles.defaultAppearance, appearance === 'subtle' && $0412590977f134ac$var$styles.subtleAppearance, appearance === 'inverse' && $0412590977f134ac$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $0412590977f134ac$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                as: "span",
                xcss: $0412590977f134ac$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $l998X.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $gMc0m.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    });
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $0412590977f134ac$var$Link = /*#__PURE__*/ (0, $42omo.forwardRef)($0412590977f134ac$var$LinkWithoutRef);
var $0412590977f134ac$export$2e2bcd8739ae039 = $0412590977f134ac$var$Link;
module.exports["default"] = $0412590977f134ac$export$2e2bcd8739ae039;

});

parcelRegister("4JDbp", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $i7RGj = parcelRequire("i7RGj");

const $b400565b9de87bc3$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $i7RGj.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $b400565b9de87bc3$export$2e2bcd8739ae039 = $b400565b9de87bc3$export$b2ad68b9bc407b80;
module.exports["WidthObserver"] = $b400565b9de87bc3$export$b2ad68b9bc407b80;

});

parcelRegister("i7RGj", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5EteX = parcelRequire("5EteX");

const $0e043a05e9b77ebf$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $5EteX.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});
module.exports["WidthDetectorObserver"] = $0e043a05e9b77ebf$export$ff983d2a2b6112ea;

});

parcelRegister("5EteX", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $63cd7642b16dfa22$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}
module.exports["useInView"] = $63cd7642b16dfa22$export$2f62ee6831462844;

});

parcelRegister("69PnT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2228fa01b7e8b5ee470ffc60df47923d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47bb7135644f74cd$var$_react = $47bb7135644f74cd$var$_interopRequireDefault((parcelRequire("42omo")));

var $47bb7135644f74cd$var$_baseNew = $47bb7135644f74cd$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $47bb7135644f74cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUpRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $47bb7135644f74cd$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $47bb7135644f74cd$var$_react.default.createElement($47bb7135644f74cd$var$_baseNew.default, Object.assign({
        name: "ArrowUpRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m2.47 12.47 9.75-9.75 1.06 1.06-9.75 9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M12 4H5.75V2.5h7a.75.75 0 0 1 .75.75v7H12z" clip-rule="evenodd"/>`
    }, props));
$47bb7135644f74cd$var$ArrowUpRightIcon.displayName = 'ArrowUpRightIcon';
var $47bb7135644f74cd$var$_default = module.exports.default = $47bb7135644f74cd$var$ArrowUpRightIcon;

});

parcelRegister("gj7hi", function(module, exports) {
$parcel$export(module.exports, "default", () => $df095e8eefdd8265$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $hWSc7 = parcelRequire("hWSc7");


var $cOrQJ = parcelRequire("cOrQJ");

const $df095e8eefdd8265$var$baseImageStyles = null; /**
                               * __Image__
                               *
                               * This component can be used interchangeably with the native `img` element. It includes additional functionality, such as theme support.
                               *
                               * - [Examples](https://atlassian.design/components/image/examples)
                               * - [Code](https://atlassian.design/components/image/code)
                               * - [Usage](https://atlassian.design/components/image/usage)
                               */ 
function $df095e8eefdd8265$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, className: className, ...props }) {
    const imgRef = (0, $42omo.useRef)(null);
    const providedColorMode = (0, $hWSc7.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $cOrQJ.default)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $42omo.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        className: (0, $gMc0m.default)([
            "_p12f1osq _4t3i1wug",
            className
        ]),
        ref: imgRef,
        ...props
    });
}

});

parcelRegister("hWSc7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1aJUB = parcelRequire("1aJUB");

function $89c9339d073609a7$export$ce91654eb9fea460() {
    const value = (0, $42omo.useContext)((0, $1aJUB.ColorModeContext));
    return value;
}
module.exports["UNSAFE_useColorModeForMigration"] = $89c9339d073609a7$export$ce91654eb9fea460;

});

parcelRegister("cOrQJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8z9j5 = parcelRequire("8z9j5");


var $60yhz = parcelRequire("60yhz");

/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ const $3ebd34920f1cc52c$var$useThemeObserver = ()=>{
    const [theme, setTheme] = (0, $42omo.useState)((0, $8z9j5.default)());
    (0, $42omo.useEffect)(()=>{
        const observer = new (0, $60yhz.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
var $3ebd34920f1cc52c$export$2e2bcd8739ae039 = $3ebd34920f1cc52c$var$useThemeObserver;
module.exports["default"] = $3ebd34920f1cc52c$export$2e2bcd8739ae039;

});

parcelRegister("1VCtc", function(module, exports) {

var $l4ilm = parcelRequire("l4ilm");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/platform/integration/manifest.ts
var $1678f4a4c8e50b50$var$platformIntegrationAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $l4ilm.PlatformIntegrationAriResourceOwner),
    resourceType: (0, $l4ilm.PlatformIntegrationAriResourceType),
    resourceIdSlug: "{integrationKey}",
    resourceIdSegmentFormats: {
        integrationKey: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/platform/integration/index.ts
var $1678f4a4c8e50b50$export$2abc7817c3952e61 = class _PlatformIntegrationAri extends (0, $3NXcb.RegisteredAri) {
    get integrationKey() {
        return this._integrationKey;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $1678f4a4c8e50b50$var$platformIntegrationAriStaticOpts.qualifier,
            platformQualifier: $1678f4a4c8e50b50$var$platformIntegrationAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $1678f4a4c8e50b50$var$platformIntegrationAriStaticOpts.resourceOwner,
            resourceType: $1678f4a4c8e50b50$var$platformIntegrationAriStaticOpts.resourceType,
            resourceId: `${opts.integrationKey}`,
            resourceIdSegmentValues: {
                integrationKey: opts.integrationKey
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $1678f4a4c8e50b50$var$platformIntegrationAriStaticOpts);
        return new _PlatformIntegrationAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $1678f4a4c8e50b50$var$platformIntegrationAriStaticOpts);
        return new _PlatformIntegrationAri(opts);
    }
    getVariables() {
        return {
            integrationKey: this.integrationKey
        };
    }
    constructor(opts){
        super(opts), this._integrationKey = opts.resourceIdSegmentValues.integrationKey;
    }
};
module.exports["PlatformIntegrationAri"] = $1678f4a4c8e50b50$export$2abc7817c3952e61;

});

parcelRegister("l4ilm", function(module, exports) {
// src/platform/integration/types.ts
var $f568335bceb35a27$export$e5bef3642d94d161 = "platform", $f568335bceb35a27$export$913c8f7d772fab02 = "integration";
module.exports["PlatformIntegrationAriResourceOwner"] = $f568335bceb35a27$export$e5bef3642d94d161;
module.exports["PlatformIntegrationAriResourceType"] = $f568335bceb35a27$export$913c8f7d772fab02;

});

parcelRegister("6VXu9", function(module, exports) {
module.exports = new URL("landing-dark.4ee27e71.svg", import.meta.url).toString();

});

parcelRegister("hW5DR", function(module, exports) {
module.exports = new URL("landing-light.0988f0a2.svg", import.meta.url).toString();

});

parcelRegister("PGaF8", function(module, exports) {
// @ts-ignore no types for this package :(

var $8M8UO = parcelRequire("8M8UO");


var $epqyT = parcelRequire("epqyT");

const $637e594f574ec048$var$DEFAULT_TIMING = {
    initialPollInterval: 5,
    pollBackoffRate: 2,
    idleTimeout: 30
};
class $637e594f574ec048$export$2e2bcd8739ae039 {
    /**
   * Callback for sending a 'track' analytics event. This callback should either be the
   * 'sendTrackEvent' method on the AnalyticsWebClient, or a method that eventually delegates to it.
   * The data for the dwell event will be passed to this method for sending.
   *
   * @callback trackCallback
   * @param {Object} eventData - the base event data that will be added to the track event.
   */ /**
   * Creates and initialises the DwellTimeHelper.
   *
   * @param {trackCallback} trackCallback - the track callback responsible for actually sending
   * the event.
   * @param {Object} eventData - the base data that will be added to the track event.
   * Additional dwell time attributes will be appended to this data. Note that you don't need to
   * include the 'action' property, as this will be added automatically.
   * @param {?string} searchSessionId - a unique identifier for the related search session.
   * @param {?Object} timingOptions - for the purpose of debugging, you can override the default
   * timing used for measuring dwell time. The following values are possible:
   * - initialPollInterval: how long to wait before the first dwell milestone event
   * is fired (in seconds). Default = 5.
   * - pollBackoffRate: how much to multiply the last poll interval by on each dwell milestone.
   * event. Default = 2.
   * - idleTimeout: how long to wait for no user activity before pausing
   * the dwell timer (in seconds). Default = 30s.
   * @param {?DwellTimeHelperOptions} dwellTimeHelperOptions - options provided to customise behaviour
   * of the helper.
   * - iframeDwell = enable detection of activity in iframes.
   */ constructor(trackCallback, _eventData, _searchSessionId, timingOptions, dwellTimeHelperOptions){
        this.timeMeInitialized = false;
        this._eventData = void 0;
        this._searchSessionId = void 0;
        this._timing = void 0;
        this._trackCallback = void 0;
        this._dwellTimeHelperOptions = void 0;
        /**
     * Starts the dwell timer. This method should be called upon the initial page load.
     */ this.start = ()=>{
            if (this.timeMeInitialized) throw new Error('DwellTimeHelper should only be initialised once per page load.');
            this.timeMeInitialized = true;
            this._initDwellTimeCounterAndPolling();
            if (typeof window !== 'undefined') window.addEventListener('beforeunload', ()=>{
                this.stop();
            });
        };
        /**
     * Stops the dwell timer and sends the final dwell event. Call this method if you wish to
     * finalise a dwell measurement without starting a new one. When switching to a new page in a
     * single-page app, use newPage instead.
     */ this.stop = ()=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).isUserCurrentlyOnPage) this._sendDwellEvent(this._eventData, this._searchSessionId, true);
            (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).stopAllTimers();
            (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).resetAllRecordedPageTimes();
            (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).timeElapsedCallbacks = [];
            this.timeMeInitialized = false;
        };
        /**
     * Send the final dwell event and reinitialise the dwell timer for a new page.
     * This method should be called whenever a new page is switched to in a single-page app context.
     *
     * @param {Object} eventData - the base data that will be added to the track event.
     * @param {?string} searchSessionId - the new search session ID.
     */ this.newPage = (eventData, searchSessionId)=>{
            (0, $epqyT.validateDwellBaseEvent)(eventData);
            this.stop();
            this._eventData = eventData;
            this._searchSessionId = searchSessionId;
            this._initDwellTimeCounterAndPolling();
        };
        /**
     * This is a modified version of timeit's original listForIdleEvents function,
     * which also listens to events inside same-origin iframes (such as Confluence whiteboards and databases).
     * https://github.com/jasonzissman/TimeMe.js/blob/master/timeme.js#L338
     */ this._listForIdleEvents = ()=>{
            document.addEventListener('mousemove', ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).userActivityDetected();
            });
            document.addEventListener('keyup', ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).userActivityDetected();
            });
            document.addEventListener('touchstart', ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).userActivityDetected();
            });
            window.addEventListener('scroll', ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).userActivityDetected();
            });
            /**
       * Find all same origin iframes (same origin allow access to contentWindow.document)
       * and add event listeners to them too.
       */ const iframes = document.getElementsByTagName('iframe');
            for(let i = 0; i < iframes.length; i++){
                const iframe = iframes[i];
                try {
                    iframe?.contentWindow?.document.addEventListener('mousemove', ()=>{
                        (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).userActivityDetected();
                    });
                    iframe?.contentWindow?.document.addEventListener('keyup', ()=>{
                        (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).userActivityDetected();
                    });
                    iframe?.contentWindow?.document.addEventListener('touchstart', ()=>{
                        (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).userActivityDetected();
                    });
                } catch (e) {
                // do nothing: We don't want to listen to cross-origin iframes
                }
            }
            setInterval(()=>{
                if ((0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).isUserCurrentlyIdle !== true) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).checkIdleState();
                    // This ensures the timer continues when switching between the iframe and the rest of the page
                    (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).startTimer();
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).checkIdleStateRateMs);
        };
        this._initDwellTimeCounterAndPolling = ()=>{
            // If iframeDwell is enabled, override the listener for idle events to also listen to events in iframes.
            if (this._dwellTimeHelperOptions?.iframeDwell) (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).listForIdleEvents = this._listForIdleEvents;
            (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).initialize({
                idleTimeoutInSeconds: this._timing.idleTimeout
            });
            this._pollDwellTime(this._timing.initialPollInterval, this._searchSessionId, this._eventData);
        };
        this._pollDwellTime = (pollTime, searchSessionId, eventData)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).callAfterTimeElapsedInSeconds(pollTime, ()=>{
                this._sendDwellEvent(eventData, searchSessionId, false);
                this._pollDwellTime(pollTime * this._timing.pollBackoffRate, searchSessionId, eventData);
            });
        };
        this._sendDwellEvent = (eventData, searchSessionId, isFinalDwellEvent)=>{
            const dwellAttributes = {
                dwellTime: (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).getTimeOnCurrentPageInMilliseconds(),
                searchReferrer: searchSessionId,
                finalDwellEvent: isFinalDwellEvent
            };
            this._trackCallback({
                action: 'dwelled',
                actionSubject: eventData.actionSubject,
                actionSubjectId: eventData.actionSubjectId,
                source: eventData.source,
                containerType: eventData.containerType,
                containerId: eventData.containerId,
                containers: eventData.containers,
                objectType: eventData.objectType,
                objectId: eventData.objectId,
                attributes: {
                    ...dwellAttributes,
                    ...eventData.attributes
                },
                tags: eventData.tags
            });
        };
        if (!trackCallback) throw new Error('trackCallback is required for DwellTimeHelper');
        (0, $epqyT.validateDwellBaseEvent)(_eventData);
        this._trackCallback = trackCallback;
        this._eventData = _eventData;
        this._searchSessionId = _searchSessionId;
        this._timing = {
            ...$637e594f574ec048$var$DEFAULT_TIMING,
            ...timingOptions
        };
        this._dwellTimeHelperOptions = dwellTimeHelperOptions;
    }
}
module.exports["default"] = $637e594f574ec048$export$2e2bcd8739ae039;

});

parcelRegister("8M8UO", function(module, exports) {
/*Copyright (c) 2020 Jason Zissman
Permission is hereby granted, free of charge, to any person obtaining a copy of
this software and associated documentation files (the "Software"), to deal in
the Software without restriction, including without limitation the rights to
use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
the Software, and to permit persons to whom the Software is furnished to do so,
subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/ (()=>{
    ((root, factory)=>{
        if (module.exports) // CommonJS
        return module.exports = factory();
        else if (typeof define === 'function' && define.amd) // AMD
        define([], ()=>{
            return root.TimeMe = factory();
        });
        else // Global Variables
        return root.TimeMe = factory();
    })(module.exports, ()=>{
        let TimeMe = {
            startStopTimes: {},
            idleTimeoutMs: 30000,
            currentIdleTimeMs: 0,
            checkIdleStateRateMs: 250,
            isUserCurrentlyOnPage: true,
            isUserCurrentlyIdle: false,
            currentPageName: "default-page-name",
            timeElapsedCallbacks: [],
            userLeftCallbacks: [],
            userReturnCallbacks: [],
            trackTimeOnElement: (elementId)=>{
                let element = document.getElementById(elementId);
                if (element) {
                    element.addEventListener("mouseover", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                    element.addEventListener("mousemove", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                    element.addEventListener("mouseleave", ()=>{
                        TimeMe.stopTimer(elementId);
                    });
                    element.addEventListener("keypress", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                    element.addEventListener("focus", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                }
            },
            getTimeOnElementInSeconds: (elementId)=>{
                let time = TimeMe.getTimeOnPageInSeconds(elementId);
                if (time) return time;
                else return 0;
            },
            // startTime is optional. If provided, must be of type Date(). By providing
            // startTime, you are overriding the internal timing mechanism and manually
            // indicating the start time.
            startTimer: (pageName, startTime)=>{
                if (!pageName) pageName = TimeMe.currentPageName;
                if (TimeMe.startStopTimes[pageName] === undefined) TimeMe.startStopTimes[pageName] = [];
                else {
                    let arrayOfTimes = TimeMe.startStopTimes[pageName];
                    let latestStartStopEntry = arrayOfTimes[arrayOfTimes.length - 1];
                    if (latestStartStopEntry !== undefined && latestStartStopEntry.stopTime === undefined) // Can't start new timer until previous finishes.
                    return;
                }
                TimeMe.startStopTimes[pageName].push({
                    "startTime": startTime || new Date(),
                    "stopTime": undefined
                });
            },
            stopAllTimers: ()=>{
                let pageNames = Object.keys(TimeMe.startStopTimes);
                for(let i = 0; i < pageNames.length; i++)TimeMe.stopTimer(pageNames[i]);
            },
            // stopTime is optional. If provided, must be of type Date(). By providing
            // stopTime, you are overriding the internal timing mechanism and manually
            // indicating the stop time.
            stopTimer: (pageName, stopTime)=>{
                if (!pageName) pageName = TimeMe.currentPageName;
                let arrayOfTimes = TimeMe.startStopTimes[pageName];
                if (arrayOfTimes === undefined || arrayOfTimes.length === 0) // Can't stop timer before you've started it.
                return;
                if (arrayOfTimes[arrayOfTimes.length - 1].stopTime === undefined) arrayOfTimes[arrayOfTimes.length - 1].stopTime = stopTime || new Date();
            },
            getTimeOnCurrentPageInSeconds: ()=>{
                return TimeMe.getTimeOnPageInSeconds(TimeMe.currentPageName);
            },
            getTimeOnPageInSeconds: (pageName)=>{
                let timeInMs = TimeMe.getTimeOnPageInMilliseconds(pageName);
                if (timeInMs === undefined) return undefined;
                else return timeInMs / 1000;
            },
            getTimeOnCurrentPageInMilliseconds: ()=>{
                return TimeMe.getTimeOnPageInMilliseconds(TimeMe.currentPageName);
            },
            getTimeOnPageInMilliseconds: (pageName)=>{
                let totalTimeOnPage = 0;
                let arrayOfTimes = TimeMe.startStopTimes[pageName];
                if (arrayOfTimes === undefined) // Can't get time on page before you've started the timer.
                return;
                let timeSpentOnPageInSeconds = 0;
                for(let i = 0; i < arrayOfTimes.length; i++){
                    let startTime = arrayOfTimes[i].startTime;
                    let stopTime = arrayOfTimes[i].stopTime;
                    if (stopTime === undefined) stopTime = new Date();
                    let difference = stopTime - startTime;
                    timeSpentOnPageInSeconds += difference;
                }
                totalTimeOnPage = Number(timeSpentOnPageInSeconds);
                return totalTimeOnPage;
            },
            getTimeOnAllPagesInSeconds: ()=>{
                let allTimes = [];
                let pageNames = Object.keys(TimeMe.startStopTimes);
                for(let i = 0; i < pageNames.length; i++){
                    let pageName = pageNames[i];
                    let timeOnPage = TimeMe.getTimeOnPageInSeconds(pageName);
                    allTimes.push({
                        "pageName": pageName,
                        "timeOnPage": timeOnPage
                    });
                }
                return allTimes;
            },
            setIdleDurationInSeconds: (duration)=>{
                let durationFloat = parseFloat(duration);
                if (isNaN(durationFloat) === false) TimeMe.idleTimeoutMs = duration * 1000;
                else throw {
                    name: "InvalidDurationException",
                    message: "An invalid duration time (" + duration + ") was provided."
                };
            },
            setCurrentPageName: (pageName)=>{
                TimeMe.currentPageName = pageName;
            },
            resetRecordedPageTime: (pageName)=>{
                delete TimeMe.startStopTimes[pageName];
            },
            resetAllRecordedPageTimes: ()=>{
                let pageNames = Object.keys(TimeMe.startStopTimes);
                for(let i = 0; i < pageNames.length; i++)TimeMe.resetRecordedPageTime(pageNames[i]);
            },
            userActivityDetected: ()=>{
                if (TimeMe.isUserCurrentlyIdle) TimeMe.triggerUserHasReturned();
                TimeMe.resetIdleCountdown();
            },
            resetIdleCountdown: ()=>{
                TimeMe.isUserCurrentlyIdle = false;
                TimeMe.currentIdleTimeMs = 0;
            },
            callWhenUserLeaves: (callback, numberOfTimesToInvoke)=>{
                TimeMe.userLeftCallbacks.push({
                    callback: callback,
                    numberOfTimesToInvoke: numberOfTimesToInvoke
                });
            },
            callWhenUserReturns: (callback, numberOfTimesToInvoke)=>{
                TimeMe.userReturnCallbacks.push({
                    callback: callback,
                    numberOfTimesToInvoke: numberOfTimesToInvoke
                });
            },
            triggerUserHasReturned: ()=>{
                if (!TimeMe.isUserCurrentlyOnPage) {
                    TimeMe.isUserCurrentlyOnPage = true;
                    TimeMe.resetIdleCountdown();
                    for(let i = 0; i < TimeMe.userReturnCallbacks.length; i++){
                        let userReturnedCallback = TimeMe.userReturnCallbacks[i];
                        let numberTimes = userReturnedCallback.numberOfTimesToInvoke;
                        if (isNaN(numberTimes) || numberTimes === undefined || numberTimes > 0) {
                            userReturnedCallback.numberOfTimesToInvoke -= 1;
                            userReturnedCallback.callback();
                        }
                    }
                }
                TimeMe.startTimer();
            },
            // TODO - we are muddying the waters in between
            // 'user left page' and 'user gone idle'. Really should be
            // two separate concepts entirely. Need to break this into smaller  functions
            // for either scenario.
            triggerUserHasLeftPageOrGoneIdle: ()=>{
                if (TimeMe.isUserCurrentlyOnPage) {
                    TimeMe.isUserCurrentlyOnPage = false;
                    for(let i = 0; i < TimeMe.userLeftCallbacks.length; i++){
                        let userHasLeftCallback = TimeMe.userLeftCallbacks[i];
                        let numberTimes = userHasLeftCallback.numberOfTimesToInvoke;
                        if (isNaN(numberTimes) || numberTimes === undefined || numberTimes > 0) {
                            userHasLeftCallback.numberOfTimesToInvoke -= 1;
                            userHasLeftCallback.callback();
                        }
                    }
                }
                TimeMe.stopAllTimers();
            },
            callAfterTimeElapsedInSeconds: (timeInSeconds, callback)=>{
                TimeMe.timeElapsedCallbacks.push({
                    timeInSeconds: timeInSeconds,
                    callback: callback,
                    pending: true
                });
            },
            checkIdleState: ()=>{
                for(let i = 0; i < TimeMe.timeElapsedCallbacks.length; i++)if (TimeMe.timeElapsedCallbacks[i].pending && TimeMe.getTimeOnCurrentPageInSeconds() > TimeMe.timeElapsedCallbacks[i].timeInSeconds) {
                    TimeMe.timeElapsedCallbacks[i].callback();
                    TimeMe.timeElapsedCallbacks[i].pending = false;
                }
                if (TimeMe.isUserCurrentlyIdle === false && TimeMe.currentIdleTimeMs > TimeMe.idleTimeoutMs) {
                    TimeMe.isUserCurrentlyIdle = true;
                    TimeMe.triggerUserHasLeftPageOrGoneIdle();
                } else TimeMe.currentIdleTimeMs += TimeMe.checkIdleStateRateMs;
            },
            visibilityChangeEventName: undefined,
            hiddenPropName: undefined,
            listenForVisibilityEvents: (trackWhenUserLeavesPage, trackWhenUserGoesIdle)=>{
                if (trackWhenUserLeavesPage) TimeMe.listenForUserLeavesOrReturnsEvents();
                if (trackWhenUserGoesIdle) TimeMe.listForIdleEvents();
            },
            listenForUserLeavesOrReturnsEvents: ()=>{
                if (typeof document.hidden !== "undefined") {
                    TimeMe.hiddenPropName = "hidden";
                    TimeMe.visibilityChangeEventName = "visibilitychange";
                } else if (typeof document.mozHidden !== "undefined") {
                    TimeMe.hiddenPropName = "mozHidden";
                    TimeMe.visibilityChangeEventName = "mozvisibilitychange";
                } else if (typeof document.msHidden !== "undefined") {
                    TimeMe.hiddenPropName = "msHidden";
                    TimeMe.visibilityChangeEventName = "msvisibilitychange";
                } else if (typeof document.webkitHidden !== "undefined") {
                    TimeMe.hiddenPropName = "webkitHidden";
                    TimeMe.visibilityChangeEventName = "webkitvisibilitychange";
                }
                document.addEventListener(TimeMe.visibilityChangeEventName, ()=>{
                    if (document[TimeMe.hiddenPropName]) TimeMe.triggerUserHasLeftPageOrGoneIdle();
                    else TimeMe.triggerUserHasReturned();
                }, false);
                window.addEventListener('blur', ()=>{
                    TimeMe.triggerUserHasLeftPageOrGoneIdle();
                });
                window.addEventListener('focus', ()=>{
                    TimeMe.triggerUserHasReturned();
                });
            },
            listForIdleEvents: ()=>{
                document.addEventListener("mousemove", ()=>{
                    TimeMe.userActivityDetected();
                });
                document.addEventListener("keyup", ()=>{
                    TimeMe.userActivityDetected();
                });
                document.addEventListener("touchstart", ()=>{
                    TimeMe.userActivityDetected();
                });
                window.addEventListener("scroll", ()=>{
                    TimeMe.userActivityDetected();
                });
                setInterval(()=>{
                    if (TimeMe.isUserCurrentlyIdle !== true) TimeMe.checkIdleState();
                }, TimeMe.checkIdleStateRateMs);
            },
            websocket: undefined,
            websocketHost: undefined,
            setUpWebsocket: (websocketOptions)=>{
                if (window.WebSocket && websocketOptions) {
                    let websocketHost = websocketOptions.websocketHost; // "ws://hostname:port"
                    try {
                        TimeMe.websocket = new WebSocket(websocketHost);
                        window.onbeforeunload = ()=>{
                            TimeMe.sendCurrentTime(websocketOptions.appId);
                        };
                        TimeMe.websocket.onopen = ()=>{
                            TimeMe.sendInitWsRequest(websocketOptions.appId);
                        };
                        TimeMe.websocket.onerror = (error)=>{
                            if (console) console.log("Error occurred in websocket connection: " + error);
                        };
                        TimeMe.websocket.onmessage = (event)=>{
                            if (console) console.log(event.data);
                        };
                    } catch (error) {
                        if (console) console.error("Failed to connect to websocket host.  Error:" + error);
                    }
                }
            },
            websocketSend: (data)=>{
                TimeMe.websocket.send(JSON.stringify(data));
            },
            sendCurrentTime: (appId)=>{
                let timeSpentOnPage = TimeMe.getTimeOnCurrentPageInMilliseconds();
                let data = {
                    type: "INSERT_TIME",
                    appId: appId,
                    timeOnPageMs: timeSpentOnPage,
                    pageName: TimeMe.currentPageName
                };
                TimeMe.websocketSend(data);
            },
            sendInitWsRequest: (appId)=>{
                let data = {
                    type: "INIT",
                    appId: appId
                };
                TimeMe.websocketSend(data);
            },
            initialize: (options)=>{
                let idleTimeoutInSeconds = TimeMe.idleTimeoutMs || 30;
                let currentPageName = TimeMe.currentPageName || "default-page-name";
                let websocketOptions = undefined;
                let initialStartTime = undefined;
                let trackWhenUserLeavesPage = true;
                let trackWhenUserGoesIdle = true;
                if (options) {
                    idleTimeoutInSeconds = options.idleTimeoutInSeconds || idleTimeoutInSeconds;
                    currentPageName = options.currentPageName || currentPageName;
                    websocketOptions = options.websocketOptions;
                    initialStartTime = options.initialStartTime;
                    if (options.trackWhenUserLeavesPage === false) trackWhenUserLeavesPage = false;
                    if (options.trackWhenUserGoesIdle === false) trackWhenUserGoesIdle = false;
                }
                TimeMe.setIdleDurationInSeconds(idleTimeoutInSeconds);
                TimeMe.setCurrentPageName(currentPageName);
                TimeMe.setUpWebsocket(websocketOptions);
                TimeMe.listenForVisibilityEvents(trackWhenUserLeavesPage, trackWhenUserGoesIdle);
                // TODO - only do this if page currently visible.
                TimeMe.startTimer(undefined, initialStartTime);
            }
        };
        return TimeMe;
    });
}).call(module.exports);

});

parcelRegister("3paC4", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $jppmC = parcelRequire("jppmC");

const $6b372c322d10f06f$var$MAX_SITES_INITIAL_QUERY = 3;
const $6b372c322d10f06f$var$limitToMaxSiteUsage = (sites = [])=>{
    return sites.slice(0, $6b372c322d10f06f$var$MAX_SITES_INITIAL_QUERY);
};
class $6b372c322d10f06f$var$AggregatorClient {
    async getAutoCorrection({ query: query }) {
        const cloudId = this.cloudId;
        // The language is hardcoded to 'en' as the backend does not support other languages
        // Also the frontend only auto corrects in English locale
        const body = {
            query: query,
            language: 'en',
            cloudId: cloudId
        };
        const response = await this.makePostRequest($6b372c322d10f06f$var$AggregatorClient.AUTO_CORRECT_API_URL, body);
        return response.fullCorrection;
    }
    async search({ query: query, context: context, scopes: scopes, modelParams: modelParams, resultLimit: resultLimit, filters: filters = [], experience: experience, sites: sites = [] }) {
        const cloudId = this.cloudId;
        const cloudIdsToFilterOn = sites.length > 0 ? sites : $6b372c322d10f06f$var$limitToMaxSiteUsage(this.siteMasterList).map((site)=>site.cloudId);
        const body = {
            query: query,
            cloudId: cloudId,
            limit: resultLimit,
            scopes: scopes,
            filters: filters,
            searchSession: context,
            ...modelParams.length > 0 ? {
                modelParams: modelParams
            } : {},
            experience: experience,
            cloudIds: cloudIdsToFilterOn
        };
        const { result: response, durationMs: requestDurationMs } = await (0, $jppmC.timed)(this.makePostRequest($6b372c322d10f06f$var$AggregatorClient.QUICKSEARCH_API_URL, body));
        return {
            response: {
                rawData: response,
                retrieveScope: (scope)=>// @ts-expect-error TS2367: This comparison appears to be unintentional because the types 'Scope' and 'SingleScope' have no overlap
                    response.scopes.find((s)=>s.id === scope) || null
            },
            requestDurationMs: requestDurationMs
        };
    }
    constructor({ url: url, cloudId: cloudId, siteMasterList: siteMasterList }){
        this.serviceConfig = void 0;
        this.cloudId = void 0;
        this.siteMasterList = void 0;
        this.makePostRequest = (path, body)=>{
            const options = {
                path: path,
                requestInit: {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body)
                }
            };
            return (0, $dwp40.utils).requestService(this.serviceConfig, options);
        };
        this.serviceConfig = {
            url: url
        };
        this.cloudId = cloudId;
        this.siteMasterList = siteMasterList;
    }
}
$6b372c322d10f06f$var$AggregatorClient.QUICKSEARCH_API_URL = 'quicksearch/v1';
$6b372c322d10f06f$var$AggregatorClient.AUTO_CORRECT_API_URL = 'autocorrect';
const $6b372c322d10f06f$export$5d730b7aed1a3eb0 = ({ cloudId: cloudId, aggregatorUrl: aggregatorUrl, aggregatorHostName: aggregatorHostName })=>{
    const aggregatorClient = new $6b372c322d10f06f$var$AggregatorClient({
        cloudId: cloudId,
        url: aggregatorUrl || `${aggregatorHostName || ''}/gateway/api/xpsearch-aggregator`,
        siteMasterList: []
    });
    async function getAutoCorrection({ query: query }) {
        return aggregatorClient.getAutoCorrection({
            query: query
        });
    }
    async function search({ query: query, scopes: scopes, resultLimit: resultLimit, analytics: analytics, sites: sites = [] }) {
        return aggregatorClient.search({
            query: query,
            context: {
                sessionId: analytics.sessionId ? analytics.sessionId : 'not-applicable',
                referrerId: null
            },
            scopes: scopes,
            modelParams: [],
            resultLimit: resultLimit,
            filters: [],
            experience: `external-${analytics.identifier}`,
            sites: sites
        });
    }
    return {
        search: search,
        getAutoCorrection: getAutoCorrection
    };
};
module.exports["createClient"] = $6b372c322d10f06f$export$5d730b7aed1a3eb0;

});

parcelRegister("jppmC", function(module, exports) {
const $e3bb250125deb745$export$d35186a762cd39c8 = async (promise)=>{
    const startTime = Date.now();
    const result = await promise;
    const duration = Date.now() - startTime;
    return {
        result: result,
        durationMs: duration
    };
};
module.exports["timed"] = $e3bb250125deb745$export$d35186a762cd39c8;

});

parcelRegister("l5Hqz", function(module, exports) {

var $2qzBQ = parcelRequire("2qzBQ");


var $hw4j5 = parcelRequire("hw4j5");

const $3c85391cc375b41f$var$cache = (0, $hw4j5.inMemoryCache)();
const $3c85391cc375b41f$export$3a4b7d0cd0a11cfc = ({ query: query, product: product })=>{
    const relativeLeapQueryUrl = `/gateway/api/assist/api/ai/v2/ai-feature/leapquery`;
    const body = {
        ai_feature_input: {
            query: query
        }
    };
    return $3c85391cc375b41f$var$cache.inMemoryDecorator((0, $2qzBQ.generateHashFromVariables)({
        query: query
    }), ()=>fetch(relativeLeapQueryUrl, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json',
                'X-Product': product,
                'X-Experience-Id': 'query-suggestion'
            }
        }).then((response)=>{
            if (response.ok) return response.json();
        }).then((data)=>{
            // return empty skeleton response if response is not ok
            // UI will treat this response as no results
            return data?.ai_feature_output || {
                title: 0,
                candidates: []
            };
        }).catch(()=>{
            // return empty skeleton response if response is not ok
            // UI will treat this response as no results
            return {
                title: 0,
                candidates: []
            };
        }));
};
module.exports["getLeapQuery"] = $3c85391cc375b41f$export$3a4b7d0cd0a11cfc;

});

parcelRegister("2qzBQ", function(module, exports) {
/**
 * Simple implementation of djb2 hashing.
 * The reason we have it internally is because at the moment we can't add new
 * dependencies into search-client package as it triggers a deprecated VR test in Editor
 * and it is locked down. So it fails to resolve the new dependency
 */ const $44766eafbe4aebec$export$daf4c137c5f56404 = (query)=>{
    let hash = 5381;
    for(let i = 0; i < query.length; i++){
        const char = query.charCodeAt(i);
        hash = (hash << 5) + hash + char; /* hash * 33 + char */ 
    }
    return hash;
};
const $44766eafbe4aebec$export$5c07a4287a46fa1f = (variables)=>{
    try {
        return $44766eafbe4aebec$export$daf4c137c5f56404(JSON.stringify(variables)).toString();
    } catch (e) {
        return '';
    }
};
module.exports["generateHash"] = $44766eafbe4aebec$export$daf4c137c5f56404;
module.exports["generateHashFromVariables"] = $44766eafbe4aebec$export$5c07a4287a46fa1f;

});

parcelRegister("h4dmn", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $5ce8de2fb4ccbeff$export$fe2cce9cc2f02a10 = (0, $hw4j5.inMemoryCache)();
const $5ce8de2fb4ccbeff$var$OPERATION_NAME = 'SearchPageCQLQuery';
const $5ce8de2fb4ccbeff$var$getConfluenceCQLQuery = ()=>`
query ${$5ce8de2fb4ccbeff$var$OPERATION_NAME}($cql: String!, $first: Int, $after: String) {
  search(cql: $cql, first: $first, after: $after) {
    nodes {
      title
      excerpt
      url
      lastModified
      links {
        base
      }
      content {
        id
        type
        space {
          id
          name
          links {
            webui
          }
        }
      }
    }
    pageInfo {
      endCursor
    }
  }
}
`;
const $5ce8de2fb4ccbeff$var$mapResultNodeToSearchPageEdge = (node, cloudId)=>({
        node: {
            id: `ari:cloud:confluence:${cloudId}:${node.content.type}/${node.content.id}`,
            title: node.title,
            description: node.excerpt,
            type: node.content.type,
            url: `${node.links.base}${node.url}`,
            lastModified: node.lastModified,
            isVerified: null,
            space: node.content.space.id && node.content.space.name ? {
                id: `ari:cloud:confluence:${cloudId}:space/${node.content.space.id}`,
                name: node.content.space.name,
                webUiLink: node.content.space.links?.webui
            } : null,
            socialSignal: null,
            __typename: 'SearchConfluencePageBlogAttachment'
        }
    });
const $5ce8de2fb4ccbeff$var$mapToSearchPageData = (response, cloudId)=>{
    const { data: data, ...rest } = response;
    if (!data) return {
        data: {
            search: {
                results: {
                    edges: [],
                    totalCount: 0,
                    pageInfo: {
                        endCursor: null
                    },
                    abTest: {},
                    totalCounts: []
                }
            }
        },
        ...rest
    };
    const { nodes: nodes, pageInfo: pageInfo } = data.search;
    const edges = nodes.map((node)=>$5ce8de2fb4ccbeff$var$mapResultNodeToSearchPageEdge(node, cloudId));
    const totalCount = nodes.length;
    return {
        data: {
            search: {
                results: {
                    edges: edges,
                    totalCount: // total count is a mandatory field, but for cql case, it's inaccurate as we can't get total count from cql and also it won't be used in the UI
                    totalCount,
                    pageInfo: pageInfo,
                    abTest: {},
                    totalCounts: []
                }
            }
        },
        ...rest
    };
};
const $5ce8de2fb4ccbeff$export$1f8a74b0d98cee30 = ({ cql: cql, first: first, after: after }, cloudId)=>{
    return $5ce8de2fb4ccbeff$export$fe2cce9cc2f02a10.inMemoryDecorator(`${cql}-${first}-${after}`, async ()=>{
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $5ce8de2fb4ccbeff$var$getConfluenceCQLQuery(),
            variables: {
                cql: cql,
                first: first,
                after: after
            },
            operationName: $5ce8de2fb4ccbeff$var$OPERATION_NAME,
            aggAbsoluteUrl: `/gateway/api/ex/confluence/${cloudId}/graphql`
        });
        const mappedResponse = $5ce8de2fb4ccbeff$var$mapToSearchPageData(response, cloudId);
        const hasErrors = mappedResponse.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(mappedResponse);
        return mappedResponse;
    });
};
module.exports["confluenceCQLQuery"] = $5ce8de2fb4ccbeff$export$1f8a74b0d98cee30;

});

parcelRegister("6gi58", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $2qzBQ = parcelRequire("2qzBQ");


var $hw4j5 = parcelRequire("hw4j5");


var $h4mQ0 = parcelRequire("h4mQ0");

const $4858f1196c57a1ec$var$cache = (0, $hw4j5.inMemoryCache)();
const $4858f1196c57a1ec$export$801183f161baaa36 = (variables)=>{
    const keyObj = {
        issueKeys: variables.issueKeys
    };
    return (0, $2qzBQ.generateHashFromVariables)(keyObj);
};
// Expire the cache if there are errors or results are empty
const $4858f1196c57a1ec$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || errors && errors.length > 0) return true;
    return data.jira.issuesByKey.length === 0;
};
const $4858f1196c57a1ec$export$16b4bc84d4d9549f = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl })=>{
    const graphQuery = (0, $h4mQ0.jiraFieldsQueryGenerator)();
    return $4858f1196c57a1ec$var$cache.inMemoryDecorator($4858f1196c57a1ec$export$801183f161baaa36(variables), ()=>(0, $4qT1X.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: graphQuery,
            operationName: 'SearchPageJiraFieldHydration'
        }), $4858f1196c57a1ec$var$expireWhen);
};
module.exports["fetchJiraFieldsQuery"] = $4858f1196c57a1ec$export$16b4bc84d4d9549f;

});

parcelRegister("h4mQ0", function(module, exports) {
const $c59e27924968799d$export$42679f7213a051c = ()=>{
    return `
	query SearchPageJiraFieldHydration (
		$issueKeys: [String!]!
		$cloudId: ID!
	) {
		jira {
			issuesByKey(cloudId: $cloudId, keys: $issueKeys) {
				id
				statusField {
					status {
						name
						statusCategory {
							colorName
						}
					}
				}
			}
		}
	}
	`;
};
module.exports["jiraFieldsQueryGenerator"] = $c59e27924968799d$export$42679f7213a051c;

});

parcelRegister("226KS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::46a94e1addf026bfebe08b8e272a8c2a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17b1021e2b775282$var$_react = $17b1021e2b775282$var$_interopRequireDefault((parcelRequire("42omo")));

var $17b1021e2b775282$var$_baseNew = $17b1021e2b775282$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $17b1021e2b775282$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsSchema".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing schema in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $17b1021e2b775282$var$AssetsSchemaIcon = (props)=>/*#__PURE__*/ $17b1021e2b775282$var$_react.default.createElement($17b1021e2b775282$var$_baseNew.default, Object.assign({
        name: "AssetsSchemaIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.75 11a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m0-8a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5M3 13.5a2 2 0 0 1-2-2V0h1.5v4H8v1.5H2.5v6a.5.5 0 0 0 .5.5h5v1.5zm9.75-4a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5m0-8a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5"/>`
    }, props));
$17b1021e2b775282$var$AssetsSchemaIcon.displayName = 'AssetsSchemaIcon';
var $17b1021e2b775282$var$_default = module.exports.default = $17b1021e2b775282$var$AssetsSchemaIcon;

});

parcelRegister("cVtio", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $f7lNm = parcelRequire("f7lNm");

const $ca77e5059fb214ed$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire((0, $f7lNm.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return [
        fireAnalyticsEvent
    ];
};
module.exports["useAnalytics"] = $ca77e5059fb214ed$export$e955abb82869dc84;

});

parcelRegister("i25hX", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $c5134eb78e10703c$var$ignoredTriggerLatestEvents = new Set([
    'editor-context-payload',
    'agent-changed'
]);
const $c5134eb78e10703c$var$createPubSub = ()=>{
    let subscribedEvents = {};
    let publishQueue = {};
    let wildcardEvents = [];
    let subIdCounter = 0;
    const generateSubId = ()=>{
        subIdCounter += 1;
        return subIdCounter.toString();
    };
    const subscribe = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
        const events = subscribedEvents[topic] ?? [];
        const subId = generateSubId();
        const subExists = events.some(({ id: id })=>id === subId);
        // Push to Topic stack if not already there
        if (!subExists) {
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: [
                    ...events,
                    {
                        callback: callback,
                        id: subId
                    }
                ]
            };
            // If this Topic already has a published event and `triggerLatest` is true, trigger the callback then clear the publishQueue for that Topic
            if (triggerLatest && !!publishQueue[topic]) {
                const payload = publishQueue[topic];
                callback(payload);
                delete publishQueue[topic];
            }
        }
        return ()=>{
            // Remove from Topic stack
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: (subscribedEvents[topic] || []).filter(({ id: id })=>id !== subId)
            };
        };
    };
    const subscribeAll = (callback)=>{
        const subId = wildcardEvents.length.toString();
        wildcardEvents = [
            ...wildcardEvents,
            {
                callback: callback,
                id: subId
            }
        ];
        return ()=>{
            wildcardEvents = wildcardEvents.filter(({ id: id })=>id !== subId);
        };
    };
    const publish = (topic, payload)=>{
        /**
		 * Log that this Topic received a published event, regardless of whether it has subscribers or not.
		 * This ensures new subscribers can trigger their callback if `triggerLatest` is true, and the event hasn't already been triggered.
		 */ // This `ignoredTriggerLatestEvents` is a quick fix to prevent triggering the latest event for certain events
        if (!$c5134eb78e10703c$var$ignoredTriggerLatestEvents.has(payload.type)) publishQueue[topic] = payload;
        // Notify `subscribeAll` subscribers as they are Topic agnostic
        wildcardEvents.forEach(({ callback: callback })=>callback(payload));
        const topicSubs = subscribedEvents[topic] || [];
        // If there are no subscribers for this Topic, nothing to do.
        if (!topicSubs.length) return;
        // Notify all Topic subscribers of this event
        topicSubs.forEach(({ callback: callback })=>callback(payload));
    };
    const flushQueue = ()=>{
        publishQueue = {};
    };
    return {
        subscribe: subscribe,
        subscribeAll: subscribeAll,
        publish: publish,
        flushQueue: flushQueue
    };
};
const $c5134eb78e10703c$var$pubSub = $c5134eb78e10703c$var$createPubSub();
const $c5134eb78e10703c$var$usePubSub = ()=>{
    return $c5134eb78e10703c$var$pubSub;
};
const $c5134eb78e10703c$export$d3d523392640272 = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
    const { subscribe: subscribe } = $c5134eb78e10703c$var$usePubSub();
    const callbackRef = (0, $42omo.useRef)(callback);
    callbackRef.current = callback;
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = subscribe({
            topic: topic,
            triggerLatest: triggerLatest
        }, (...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        topic
    ]);
};
const $c5134eb78e10703c$export$2570c8aa24b6d327 = (callback)=>{
    const { subscribeAll: subscribeAll } = $c5134eb78e10703c$var$usePubSub();
    const callbackRef = (0, $42omo.useRef)(callback);
    callbackRef.current = callback;
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = subscribeAll((...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};
const $c5134eb78e10703c$var$useFlushOnUnmount = (active = false)=>{
    const { flushQueue: flushQueue } = $c5134eb78e10703c$var$usePubSub();
    (0, $42omo.useLayoutEffect)(()=>{
        return ()=>{
            if (active) flushQueue();
        };
    }, [
        active,
        flushQueue
    ]);
};
const $c5134eb78e10703c$export$d55c81786220731c = (topic)=>{
    const { publish: publish } = $c5134eb78e10703c$var$usePubSub();
    const publishFn = (0, $42omo.useCallback)((payload)=>publish(topic, payload), [
        publish,
        topic
    ]);
    return publishFn;
};
const $c5134eb78e10703c$export$60959659b2c22881 = ({ topic: topic, triggerLatest: triggerLatest, onEvent: onEvent, flushQueueOnUnmount: flushQueueOnUnmount })=>{
    $c5134eb78e10703c$export$d3d523392640272({
        topic: topic,
        triggerLatest: triggerLatest
    }, onEvent);
    $c5134eb78e10703c$var$useFlushOnUnmount(flushQueueOnUnmount);
    return null;
};
module.exports["useSubscribe"] = $c5134eb78e10703c$export$d3d523392640272;
module.exports["useSubscribeAll"] = $c5134eb78e10703c$export$2570c8aa24b6d327;
module.exports["usePublish"] = $c5134eb78e10703c$export$d55c81786220731c;
module.exports["Subscriber"] = $c5134eb78e10703c$export$60959659b2c22881;

});

parcelRegister("9M4aB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed0eee459540e5ec28215a3b80df0172>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $71dbd4ce92c1377b$var$_react = $71dbd4ce92c1377b$var$_interopRequireDefault((parcelRequire("42omo")));

var $71dbd4ce92c1377b$var$_baseNew = $71dbd4ce92c1377b$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $71dbd4ce92c1377b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $71dbd4ce92c1377b$var$ShareIcon = (props)=>/*#__PURE__*/ $71dbd4ce92c1377b$var$_react.default.createElement($71dbd4ce92c1377b$var$_baseNew.default, Object.assign({
        name: "ShareIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2.5 1a2.5 2.5 0 1 1 .73 1.765L6.212 7.567a2.5 2.5 0 0 1 0 .866l4.016 2.302a2.5 2.5 0 1 1-.692 1.332L5.521 9.766a2.5 2.5 0 1 1 0-3.53l4.016-2.302A2.5 2.5 0 0 1 9.5 3.5M3.75 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$71dbd4ce92c1377b$var$ShareIcon.displayName = 'ShareIcon';
var $71dbd4ce92c1377b$var$_default = module.exports.default = $71dbd4ce92c1377b$var$ShareIcon;

});

parcelRegister("dS0qJ", function(module, exports) {
const $c4d36ce3018afd80$export$3ea53827ed349b2e = (locale)=>{
    // English locale or starts with 'en-', `en-US`, `en-GB`, etc.
    return locale.toLowerCase().startsWith('en');
};
module.exports["isEnglishLocale"] = $c4d36ce3018afd80$export$3ea53827ed349b2e;

});

parcelRegister("5izcQ", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $QiYCb = parcelRequire("QiYCb");


var $6cnUO = parcelRequire("6cnUO");

/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ const $f788f1551fff696f$var$SpotlightTarget = ({ children: children, name: name })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6cnUO.TargetConsumer), {
        children: (getTargetRef)=>{
            if (typeof children === 'function') return children({
                targetRef: getTargetRef?.(name)
            });
            return getTargetRef ? /*#__PURE__*/ (0, $l998X.jsx)((0, $QiYCb.default), {
                name: name,
                hasNodeResolver: !(0, $dh538.fg)('platform_design_system_team_onboarding_noderesolve'),
                getTargetRef: getTargetRef,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                    children: children
                })
            }) : children;
        }
    });
$f788f1551fff696f$var$SpotlightTarget.displayName = 'SpotlightTarget';
var $f788f1551fff696f$export$2e2bcd8739ae039 = $f788f1551fff696f$var$SpotlightTarget;
module.exports["default"] = $f788f1551fff696f$export$2e2bcd8739ae039;

});

parcelRegister("QiYCb", function(module, exports) {
/* node-resolver-spotlight-target.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $e8Hkv = parcelRequire("e8Hkv");

const $9a3edd35791f2369$var$spanStyles = null; /**
                          * A wrapper component that conditionally applies a NodeResolver to its children.
                          *
                          * Note: NodeResolver should not be used in React 18 concurrent mode. This component
                          * is intended to be removed once the feature flag  is removed.
                          * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
                          * @param {ReactElement} props.children - The child elements to be wrapped.
                          * @param {string} props.name - The name to reference from Spotlight.
                          * @param {ReactElement} props.getTargetRef - Setting up Target Node in Spotlight Manager.
                          * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
                          */ 
const $9a3edd35791f2369$var$NodeResolverSpotlightTarget = ({ hasNodeResolver: hasNodeResolver, children: children, getTargetRef: getTargetRef, name: name })=>{
    const divRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const targetRef = getTargetRef(name);
        if (!hasNodeResolver) targetRef(divRef.current?.firstElementChild);
        return ()=>{
            !hasNodeResolver && targetRef(undefined);
        };
    }, [
        hasNodeResolver,
        name,
        getTargetRef
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e8Hkv))), {
        innerRef: getTargetRef(name),
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ref: divRef,
        className: (0, $gMc0m.default)([
            "_1e0c1bgi"
        ]),
        children: children
    });
};
$9a3edd35791f2369$var$NodeResolverSpotlightTarget.displayName = 'NodeResolverSpotlightTarget';
var $9a3edd35791f2369$export$2e2bcd8739ae039 = $9a3edd35791f2369$var$NodeResolverSpotlightTarget;
module.exports["default"] = $9a3edd35791f2369$export$2e2bcd8739ae039;

});

parcelRegister("i6xGB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::151fe33e88b0ee8f745faaf0f04d86d9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2e2eae372bc9680$var$_react = $d2e2eae372bc9680$var$_interopRequireDefault((parcelRequire("42omo")));

var $d2e2eae372bc9680$var$_baseNew = $d2e2eae372bc9680$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $d2e2eae372bc9680$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Stopwatch".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: timer in Confluence Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d2e2eae372bc9680$var$StopwatchIcon = (props)=>/*#__PURE__*/ $d2e2eae372bc9680$var$_react.default.createElement($d2e2eae372bc9680$var$_baseNew.default, Object.assign({
        name: "StopwatchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 0h6v1.5H8.75v1.543a6.47 6.47 0 0 1 3.06 1.19l1.137-1.24 1.106 1.014-1.137 1.24a6.5 6.5 0 1 1-9.832 0l-1.137-1.24 1.106-1.014 1.137 1.24a6.47 6.47 0 0 1 3.06-1.19V1.5H5zm3 4.5a4.98 4.98 0 0 0-3.378 1.314A5 5 0 1 0 8 4.5m2.842 3.01-2.541 2.75-1.102-1.02 2.542-2.75z" clip-rule="evenodd"/>`
    }, props));
$d2e2eae372bc9680$var$StopwatchIcon.displayName = 'StopwatchIcon';
var $d2e2eae372bc9680$var$_default = module.exports.default = $d2e2eae372bc9680$var$StopwatchIcon;

});

parcelRegister("lvsjl", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa82743632a2ad8f$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $fa82743632a2ad8f$export$2e2bcd8739ae039(callback, delay, options) {
    if (options === void 0) options = {};
    var maxWait = options.maxWait;
    var maxWaitHandler = (0, $42omo.useRef)(null);
    var maxWaitArgs = (0, $42omo.useRef)([]);
    var leading = options.leading;
    var trailing = options.trailing === undefined ? true : options.trailing;
    var leadingCall = (0, $42omo.useRef)(false);
    var functionTimeoutHandler = (0, $42omo.useRef)(null);
    var isComponentUnmounted = (0, $42omo.useRef)(false);
    var debouncedFunction = (0, $42omo.useRef)(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = (0, $42omo.useCallback)(function() {
        clearTimeout(functionTimeoutHandler.current);
        clearTimeout(maxWaitHandler.current);
        maxWaitHandler.current = null;
        maxWaitArgs.current = [];
        functionTimeoutHandler.current = null;
        leadingCall.current = false;
    }, []);
    (0, $42omo.useEffect)(function() {
        // We have to set isComponentUnmounted to be truth, as fast-refresh runs all useEffects
        isComponentUnmounted.current = false;
        return function() {
            // we use flag, as we allow to call callPending outside the hook
            isComponentUnmounted.current = true;
        };
    }, []);
    var debouncedCallback = (0, $42omo.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        maxWaitArgs.current = args;
        clearTimeout(functionTimeoutHandler.current);
        if (leadingCall.current) leadingCall.current = false;
        if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
            debouncedFunction.current.apply(debouncedFunction, args);
            leadingCall.current = true;
        }
        functionTimeoutHandler.current = setTimeout(function() {
            var shouldCallFunction = true;
            if (leading && leadingCall.current) shouldCallFunction = false;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
        }, delay);
        if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
            var args = maxWaitArgs.current;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
        }, maxWait);
    }, [
        maxWait,
        delay,
        cancelDebouncedCallback,
        leading,
        trailing
    ]);
    var callPending = (0, $42omo.useCallback)(function() {
        // Call pending callback only if we have anything in our queue
        if (!functionTimeoutHandler.current) return;
        debouncedFunction.current.apply(null, maxWaitArgs.current);
        cancelDebouncedCallback();
    }, [
        cancelDebouncedCallback
    ]);
    // At the moment, we use 3 args array so that we save backward compatibility
    return [
        debouncedCallback,
        cancelDebouncedCallback,
        callPending
    ];
}

});

parcelRegister("aAJEF", function(module, exports) {

var $i1nCm = parcelRequire("i1nCm");


var $1dvMI = parcelRequire("1dvMI");

const $d15b8950e6ad335c$export$2fda7622441f06c6 = async ({ userId: userId, analyticsCallback: analyticsCallback, degradationCallback: degradationCallback })=>{
    if (!userId) return [];
    const trait = await (0, $1dvMI.fetchUserPersonalizationBySiteUser)({
        userId: userId,
        analyticsCallback: analyticsCallback,
        degradationCallback: degradationCallback,
        cacheKeySuffix: 'right-panel',
        traitName: (0, $i1nCm.RIGHT_PANEL_TRAIT)
    });
    return (0, $1dvMI.parseRecommendations)((0, $i1nCm.RIGHT_PANEL_TRAIT), trait);
};
module.exports["getRightPanelRecommendations"] = $d15b8950e6ad335c$export$2fda7622441f06c6;

});

parcelRegister("i1nCm", function(module, exports) {
const $8a8890853317d663$export$34e8837a1913e572 = 'search-personalization-site-user';
const $8a8890853317d663$export$f80bd7d8a13f050a = 604800000; // 7 days
const $8a8890853317d663$export$18406d9c8318a338 = 86400000; // 1 day
const $8a8890853317d663$export$2383b9b3bc711073 = 3600000; // 1 hour
const $8a8890853317d663$export$d0bbd8e7f2e797 = 'search_user_3p_recommendations_right_panel_v1';
module.exports["SEARCH_PERSONALIZATION_BY_SITE_USER_CACHE_KEY"] = $8a8890853317d663$export$34e8837a1913e572;
module.exports["SEVEN_DAY_MS_TTL"] = $8a8890853317d663$export$f80bd7d8a13f050a;
module.exports["ONE_DAY_MS_TTL"] = $8a8890853317d663$export$18406d9c8318a338;
module.exports["ONE_HOUR_MS_TTL"] = $8a8890853317d663$export$2383b9b3bc711073;
module.exports["RIGHT_PANEL_TRAIT"] = $8a8890853317d663$export$d0bbd8e7f2e797;

});

parcelRegister("1dvMI", function(module, exports) {

var $2qzBQ = parcelRequire("2qzBQ");


var $jnPv4 = parcelRequire("jnPv4");


var $3Tbc2 = parcelRequire("3Tbc2");


var $i1nCm = parcelRequire("i1nCm");

const $fd4dd27e5286221f$export$4699366f3c37153b = (userId)=>`/gateway/api/tap-delivery/api/v3/personalization/user/${userId}`;
const { refreshOnAccessDecorator: $fd4dd27e5286221f$var$refreshOnAccessDecoratorPersonalization, get: $fd4dd27e5286221f$var$getPersonalizationCache, clear: $fd4dd27e5286221f$var$clearPersonalizationCache } = (0, $jnPv4.promiseCache)({
    name: (0, $i1nCm.SEARCH_PERSONALIZATION_BY_SITE_USER_CACHE_KEY),
    expiration: (0, $i1nCm.SEVEN_DAY_MS_TTL)
});
const $fd4dd27e5286221f$export$3207741464bed15e = async (userId)=>{
    const requestUrl = $fd4dd27e5286221f$export$4699366f3c37153b(userId);
    const requestOptions = {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return fetch(requestUrl, requestOptions).then((response)=>{
        if (response.ok) return response.json();
        return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
    });
};
const $fd4dd27e5286221f$export$d2be385a647191c0 = async ({ userId: userId, analyticsCallback: analyticsCallback, cacheKeySuffix: cacheKeySuffix, traitName: traitName, degradationCallback: degradationCallback = ()=>{} })=>{
    const key = (0, $2qzBQ.generateHash)(`${(0, $i1nCm.SEARCH_PERSONALIZATION_BY_SITE_USER_CACHE_KEY)}|${userId}|${cacheKeySuffix}`);
    const supplier = async ()=>{
        const fetchPromise = $fd4dd27e5286221f$export$3207741464bed15e(userId).then((data)=>{
            const { attributes: attributes } = data;
            return attributes?.find((t)=>t.name === traitName);
        }).catch(()=>undefined); // treat non-200 as empty and avoid caching a rejected promise
        const degrader = new (0, $3Tbc2.DegradablePromise)(fetchPromise, degradationCallback, 1000); // 1s degrade threshold
        return degrader.promise().catch(async (e)=>{
            // On degrade/timeout, re-set cache entry to resolved undefined with ONE_HOUR_TTL
            // so callers won't hammer the service for the next hour, but will retry after.
            // Since we're in supplier, we can't directly set here without re-entrant complexity.
            // Instead, throw and let refreshOnAccessDecorator store this rejecting promise; after this call,
            // callers should rely on our external code path to clear or retry as needed.
            throw e;
        });
    };
    const existing = $fd4dd27e5286221f$var$getPersonalizationCache(key.toString());
    // Choose TTL based on outcome:
    // - success (non-empty trait): default SEVEN_DAY_TTL
    // - empty (undefined): ONE_DAY_TTL
    // - degraded (timeout/reject): ONE_HOUR_TTL
    // We cannot know the outcome until supplier resolves/rejects; so we approximate:
    //   if no existing value, we assume empty path (ONE_HOUR_MS_TTL) to avoid hammering
    //   then, within supplier, we adjust by re-setting the cache on rejection with ONE_HOUR_TTL
    const effectiveExpiration = !existing?.storedValue ? (0, $i1nCm.ONE_HOUR_MS_TTL) : undefined;
    const effectiveOnlyRefreshIfExpired = true;
    // Helper to re-write the cached value with a specific TTL without re-fetching
    const writeBackWithTTL = (value, ttl)=>{
        $fd4dd27e5286221f$var$refreshOnAccessDecoratorPersonalization({
            key: key.toString(),
            supplier: async ()=>value,
            returnExpired: false,
            onlyRefreshIfExpired: false,
            expiration: ttl
        });
    };
    return $fd4dd27e5286221f$var$refreshOnAccessDecoratorPersonalization({
        key: key.toString(),
        supplier: async ()=>{
            try {
                const result = await supplier(); // Trait | undefined (no degrade)
                if (result) writeBackWithTTL(result, (0, $i1nCm.SEVEN_DAY_MS_TTL));
                else writeBackWithTTL(undefined, (0, $i1nCm.ONE_DAY_MS_TTL));
                return result;
            } catch (e) {
                // On degrade/timeout, return undefined so promiseCache stores an "empty" value
                // and then write back a short TTL to avoid hammering
                writeBackWithTTL(undefined, (0, $i1nCm.ONE_HOUR_MS_TTL));
                return undefined;
            }
        },
        onlyRefreshIfExpired: effectiveOnlyRefreshIfExpired,
        expiration: effectiveExpiration,
        analyticsCallback: analyticsCallback
    });
};
const $fd4dd27e5286221f$export$5f7b484a4ccacc79 = (key)=>$fd4dd27e5286221f$var$clearPersonalizationCache(key);
const $fd4dd27e5286221f$export$5fd6e6f864665c35 = (traitName, trait)=>{
    if (trait && trait.name === traitName && trait.value && typeof trait.value === 'string') return trait.value.split(',').filter((s)=>s.length > 0);
    return [];
};
module.exports["fetchUserPersonalizationBySiteUser"] = $fd4dd27e5286221f$export$d2be385a647191c0;
module.exports["parseRecommendations"] = $fd4dd27e5286221f$export$5fd6e6f864665c35;

});

parcelRegister("jnPv4", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $5G9KX = parcelRequire("5G9KX");


var $3WVPu = parcelRequire("3WVPu");

const $582af5ffd704fa53$export$e89e805418f4d2c = (args)=>{
    const { name: name } = args;
    let cacheInstance = null;
    // During refresh, the main cache will hold pending promises so we need a way to access the last resolved value
    // This cache can return these values while the refresh is in progress
    const resolvedValueCache = new Map();
    const getCacheInstance = ()=>{
        /**
		 * We lazily create the cache instance to avoid the issue in SSR
		 * where the localStorage isn't available.
		 */ if (!cacheInstance) {
            cacheInstance = (0, $3WVPu.getInstance)(args);
            const persistedState = (0, $5G9KX.getLocalStorageItemAsString)(name);
            if (persistedState) {
                // Populate the resolved value cache with the contents of local storage
                const object = cacheInstance.deserialize(persistedState);
                const serveResolvedDuringRefreshEnabled = (0, $c6GJD.default).getExperimentValue('search_cache_serve_resolved_during_refresh', 'isEnabled', false);
                if (object && serveResolvedDuringRefreshEnabled) Object.entries(object).forEach(([key, entry])=>{
                    if (entry && 'result' in entry) resolvedValueCache.set(key, entry.result);
                });
            }
        }
        return cacheInstance;
    };
    const get = (key, returnExpired)=>{
        const storedValue = getCacheInstance().get(key, returnExpired ?? true); // fetch expired result by default
        const isExpired = getCacheInstance().isExpired(key);
        return {
            storedValue: storedValue,
            isExpired: isExpired
        };
    };
    const set = async (key, result, expiration)=>{
        getCacheInstance().set(key, result, expiration);
        try {
            const serveResolvedDuringRefreshEnabled = (0, $c6GJD.default).getExperimentValue('search_cache_serve_resolved_during_refresh', 'isEnabled', false);
            if (serveResolvedDuringRefreshEnabled) {
                const resolvedValue = await result;
                resolvedValueCache.set(key, resolvedValue);
            }
            const serialized = await getCacheInstance().serialize();
            if (serialized) (0, $5G9KX.setLocalStorageItem)(name, serialized);
        } catch  {
        // noop - an exception in the result promise or serialisation should be ignored so we dont throw unhandled exceptions
        }
    };
    const clear = (key)=>{
        const serveResolvedDuringRefreshEnabled = (0, $c6GJD.default).getExperimentValue('search_cache_serve_resolved_during_refresh', 'isEnabled', false);
        if (serveResolvedDuringRefreshEnabled) {
            if (key) resolvedValueCache.delete(key);
            else resolvedValueCache.clear();
        }
        getCacheInstance().clear(key);
    };
    const refreshOnAccessDecorator = ({ key: key, supplier: supplier, returnExpired: returnExpired, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, analyticsCallback: analyticsCallback, networkCallbacks: networkCallbacks, serveResolvedDuringRefresh: serveResolvedDuringRefresh })=>{
        const { storedValue: storedValue, isExpired: isExpired } = get(key, returnExpired);
        const shouldRefresh = onlyRefreshIfExpired ? isExpired : true;
        const experimentEnabled = (0, $c6GJD.default).getExperimentValue('search_cache_serve_resolved_during_refresh', 'isEnabled', false);
        // Require both experiment to be enabled and the caller to opt in via parameter
        const serveResolvedDuringRefreshEnabled = experimentEnabled && serveResolvedDuringRefresh;
        if (!storedValue || shouldRefresh) {
            // Wrap the supplier to track network calls
            const trackedSupplier = async ()=>{
                networkCallbacks?.onStart();
                try {
                    const result = await supplier();
                    networkCallbacks?.onSuccess();
                    return result;
                } catch (error) {
                    const errorName = error?.name || 'UnknownError';
                    const errorMessage = error?.message || 'An unknown error occurred';
                    networkCallbacks?.onError(errorName, errorMessage);
                    throw error;
                }
            };
            const apiPromise = trackedSupplier();
            set(key, apiPromise, expiration);
            // If there was already a stored value prior to refreshing, return it
            if (storedValue) {
                if (analyticsCallback) analyticsCallback({
                    refreshTriggered: true,
                    hit: true
                });
                // Return resolved value if experiment is enabled and we have it cached
                if (serveResolvedDuringRefreshEnabled) {
                    const resolvedValue = resolvedValueCache.get(key);
                    if (resolvedValue !== undefined) return resolvedValue;
                }
                return storedValue;
            } else {
                if (analyticsCallback) analyticsCallback({
                    refreshTriggered: true,
                    hit: false
                });
                return apiPromise;
            }
        } else {
            if (analyticsCallback) analyticsCallback({
                refreshTriggered: false,
                hit: true
            });
            // Return resolved value if experiment is enabled and we have it cached
            if (serveResolvedDuringRefreshEnabled) {
                const resolvedValue = resolvedValueCache.get(key);
                if (resolvedValue !== undefined) return resolvedValue;
            }
            return storedValue;
        }
    };
    return {
        get: get,
        refreshOnAccessDecorator: refreshOnAccessDecorator,
        clear: clear
    };
};
module.exports["promiseCache"] = $582af5ffd704fa53$export$e89e805418f4d2c;

});

parcelRegister("3WVPu", function(module, exports) {
const $fc16ad90038db0a8$var$DEFAULT_EXPIRATION = 900000; // 15 mins in milliseconds
class $fc16ad90038db0a8$var$Cache {
    get(key, returnExpired = false) {
        const entry = this.map[key];
        if (entry) {
            if (entry.isExpired()) {
                delete this.map[key];
                return returnExpired ? entry.getResult() : undefined;
            } else return entry.getResult();
        }
        return;
    }
    set(key, result, expiration) {
        const entry = new $fc16ad90038db0a8$var$Entry({
            result: result,
            expirationTime: Date.now() + (expiration || this.expiration),
            accessCount: 0
        });
        this.map[key] = entry;
    }
    has(key) {
        return key in this.map;
    }
    clear(key) {
        if (key) delete this.map[key];
        else this.map = {};
    }
    async serialize() {
        const serialized = {};
        const resolvers = Object.entries(this.map).map(([key, entry])=>(async ()=>{
                serialized[key] = {
                    result: await entry.getResult(),
                    expirationTime: entry.getExpirationTime(),
                    accessCount: entry.getAccessCount()
                };
            })());
        await Promise.all(resolvers);
        return JSON.stringify(serialized);
    }
    deserialize(persisted) {
        try {
            const object = JSON.parse(persisted);
            for(const key in object){
                const { result: result, expirationTime: expirationTime, accessCount: accessCount } = object[key];
                this.map[key] = new $fc16ad90038db0a8$var$Entry({
                    result: Promise.resolve(result),
                    expirationTime: expirationTime,
                    accessCount: accessCount
                });
            }
            return object;
        } catch  {
        // TODO: Log error via sentry
        }
        return undefined;
    }
    isExpired(key) {
        const entry = this.map[key];
        return entry ? entry.isExpired() : true;
    }
    constructor(args = {}){
        this.map = void 0;
        this.expiration = void 0;
        const { expiration: expiration = $fc16ad90038db0a8$var$DEFAULT_EXPIRATION } = args;
        this.map = {};
        this.expiration = expiration;
    }
}
class $fc16ad90038db0a8$var$Entry {
    getResult() {
        this.accessCount++;
        return this.result;
    }
    isExpired() {
        return this.expirationTime < Date.now();
    }
    getExpirationTime() {
        return this.expirationTime;
    }
    getAccessCount() {
        return this.accessCount;
    }
    constructor({ result: result, expirationTime: expirationTime, accessCount: accessCount }){
        this.result = void 0;
        this.expirationTime = void 0;
        this.accessCount = void 0;
        this.result = result;
        this.expirationTime = expirationTime;
        this.accessCount = accessCount;
    }
}
const $fc16ad90038db0a8$export$8bedcca5bbd73999 = (args)=>{
    return new $fc16ad90038db0a8$var$Cache(args);
};
module.exports["getInstance"] = $fc16ad90038db0a8$export$8bedcca5bbd73999;

});

parcelRegister("3Tbc2", function(module, exports) {
class $3c05ea8f13f2fd4c$export$85bf8e4fb143676a extends Error {
    constructor(...args){
        super(...args);
        this.isDegraded = true;
    }
}
const $3c05ea8f13f2fd4c$export$ff01cc10d3c607be = 6000; // default timeout
const $3c05ea8f13f2fd4c$var$DEGRADE_ERROR = new $3c05ea8f13f2fd4c$export$85bf8e4fb143676a('Promise is degraded');
class $3c05ea8f13f2fd4c$export$ea6d6e4c9647fa9 {
    static from(wrapped, degradationCallback = ()=>{}, timeoutMs) {
        return new $3c05ea8f13f2fd4c$export$ea6d6e4c9647fa9(wrapped, degradationCallback, timeoutMs ?? $3c05ea8f13f2fd4c$export$ff01cc10d3c607be);
    }
    constructor(wrapped, degradationCallback, timeoutMs = $3c05ea8f13f2fd4c$export$ff01cc10d3c607be){
        this.degradablePromiseInternal = void 0;
        this.degradeTimeout = void 0;
        this.timeoutMs = void 0;
        this.degradeInternal = ()=>{
            // Default throws an error as this should never happen
            throw new Error('Programming error, cancelling promise is not properly rejected');
        };
        this.timeout = ()=>{
            this.degradeInternal();
        };
        this.promise = ()=>this.degradablePromiseInternal;
        const degrader = new Promise((_, reject)=>{
            this.degradeInternal = ()=>{
                reject($3c05ea8f13f2fd4c$var$DEGRADE_ERROR);
                degradationCallback('timeout');
            };
        });
        // Call the degradation callback with 'failed' if the wrapped promise fails, easy way to track metrics at fetch level
        wrapped.catch(()=>{
            degradationCallback('failure');
        });
        // Build a finally chain into the wrapped promise so if it resolves early, we cancel the degradation
        const wrappedFinally = wrapped.finally(()=>{
            if (this.degradeTimeout) clearTimeout(this.degradeTimeout);
        });
        const wrapper = Promise.race([
            wrappedFinally,
            degrader
        ]);
        this.degradablePromiseInternal = wrapper;
        this.timeoutMs = timeoutMs ?? $3c05ea8f13f2fd4c$export$ff01cc10d3c607be;
        this.degradeTimeout = setTimeout(this.timeout, this.timeoutMs);
    }
}
module.exports["DegradablePromise"] = $3c05ea8f13f2fd4c$export$ea6d6e4c9647fa9;

});

parcelRegister("5loD0", function(module, exports) {

var $ll2sR = parcelRequire("ll2sR");


var $4nGsu = parcelRequire("4nGsu");

class $4b61f610720049a6$export$2e2bcd8739ae039 {
    async start(messageId, variationId) {
        if (!(0, $4nGsu.isMessagingEnabled)()) return false;
        return (0, $ll2sR.startMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            variationId: variationId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    async stop(messageId) {
        if (!(0, $4nGsu.isMessagingEnabled)()) return false;
        return (0, $ll2sR.stopMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    constructor(configOrCloudId, stargateUrl){
        this.cloudId = void 0;
        this.stargateUrl = void 0;
        this.orgId = void 0;
        this.workspaceId = void 0;
        this.coordinationOptions = void 0;
        let config;
        if (typeof configOrCloudId === 'string') config = {
            cloudId: configOrCloudId,
            stargateUrl: stargateUrl,
            isFedRAMPEnvironment: false
        };
        else config = configOrCloudId;
        if (!config.cloudId || !config.stargateUrl) throw new Error('Need a valid CloudId and Stargate url');
        this.cloudId = config.cloudId;
        this.stargateUrl = config.stargateUrl;
        this.orgId = config.orgId;
        this.workspaceId = config.workspaceId;
        this.coordinationOptions = config.coordinationOptions;
    }
}
module.exports["default"] = $4b61f610720049a6$export$2e2bcd8739ae039;

});

parcelRegister("aXjWU", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6d6c82fa2f331bd2$var$initialActiveTriggerState = {
    activeTriggerState: {
        activeTriggerId: undefined
    }
};
const $6d6c82fa2f331bd2$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $6d6c82fa2f331bd2$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($6d6c82fa2f331bd2$var$initialActiveTriggerState);
const $6d6c82fa2f331bd2$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($6d6c82fa2f331bd2$var$initialTriggerDispatchState);
const $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [activeTriggerState, setActiveTriggerState] = (0, $42omo.useState)($6d6c82fa2f331bd2$var$initialActiveTriggerState.activeTriggerState);
    const setTriggerState = (0, $42omo.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setActiveTriggerState((current)=>{
            const hasStateChanged = current.activeTriggerId !== triggerId || current.activeTriggerId === triggerId && isActive === false;
            if (!hasStateChanged) return current;
            if (isActive) return {
                activeTriggerId: triggerId
            };
            return {
                activeTriggerId: undefined
            };
        });
    }, []);
    const triggerContextValue = (0, $42omo.useMemo)(()=>({
            activeTriggerState: activeTriggerState
        }), [
        activeTriggerState
    ]);
    const triggerContexDispatchValue = (0, $42omo.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d6c82fa2f331bd2$var$TriggerContext.Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d6c82fa2f331bd2$var$TriggerDispatchContext.Provider, {
        value: triggerContexDispatchValue
    }, children));
};
const $6d6c82fa2f331bd2$export$454c1d7c35958f5e = ()=>(0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerContext);
const $6d6c82fa2f331bd2$export$23cbf084e08bdb93 = ()=>(0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerDispatchContext);
const $6d6c82fa2f331bd2$export$3b196fe93a948c18 = (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $6d6c82fa2f331bd2$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: activeTriggerState.activeTriggerId === triggerId
    } : {
        isActive: undefined
    };
};
const $6d6c82fa2f331bd2$export$83b33e5fe4cce64 = ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $6d6c82fa2f331bd2$export$23cbf084e08bdb93();
    const fireTrigger = (0, $42omo.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $6d6c82fa2f331bd2$export$e45375ff75169f = (messageId)=>{
    // listeners
    const { isActive: hasMessageStarted } = $6d6c82fa2f331bd2$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $42omo.useCallback)(()=>{
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger
    ]);
    const dismissMessage = (0, $42omo.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $42omo.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};
module.exports["TriggerContextProvider"] = $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3;
module.exports["useTrigger"] = $6d6c82fa2f331bd2$export$3b196fe93a948c18;
module.exports["useFirePostOfficeTrigger"] = $6d6c82fa2f331bd2$export$83b33e5fe4cce64;
module.exports["usePostOfficeExernalMessageProxy"] = $6d6c82fa2f331bd2$export$e45375ff75169f;

});

parcelRegister("2cEww", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b04916d9a8148b2$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $9x4nt = parcelRequire("9x4nt");


var $feexy = parcelRequire("feexy");


var $4u5NT = parcelRequire("4u5NT");

function $5b04916d9a8148b2$export$2e2bcd8739ae039({ dataKey: dataKey, value: value }) {
    const interactionContext = (0, $42omo.useContext)((0, $9x4nt.default));
    (0, $42omo.useMemo)(()=>{
        if (!interactionContext) return;
        const interactionId = (0, $feexy.getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        (0, $4u5NT.addCohortingCustomData)(currentInteractionId, dataKey, value);
    }, [
        dataKey,
        value,
        interactionContext
    ]);
    return null;
}
function $5b04916d9a8148b2$export$f9c6890b323d326b(key, value) {
    const interactionId = (0, $feexy.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    (0, $4u5NT.addCohortingCustomData)(currentInteractionId, key, value);
}
module.exports["addUFOCustomCohortData"] = $5b04916d9a8148b2$export$f9c6890b323d326b;

});

parcelRegister("7Zbm6", function(module, exports) {
var $313b937e83fff73c$export$e20550b618a28239 = /*#__PURE__*/ function(NLPSearchResultFormat) {
    NLPSearchResultFormat["PLAINTEXT"] = "PLAIN_TEXT";
    NLPSearchResultFormat["ADF"] = "ADF";
    NLPSearchResultFormat["JSON"] = "JSON";
    NLPSearchResultFormat["MARKDOWN"] = "MARKDOWN";
    return NLPSearchResultFormat;
}({});
var $313b937e83fff73c$export$eae917983a0398aa = /*#__PURE__*/ function(NLPSearchJSONResultFormat) {
    NLPSearchJSONResultFormat["WHO"] = "who";
    NLPSearchJSONResultFormat["WORK"] = "work";
    NLPSearchJSONResultFormat["TEAM"] = "team";
    NLPSearchJSONResultFormat["PERSON"] = "person";
    NLPSearchJSONResultFormat["AGENT"] = "agent";
    return NLPSearchJSONResultFormat;
}({});
var $313b937e83fff73c$export$49d1ac864ca8db3a = /*#__PURE__*/ function(NLPSearchDisclaimerType) {
    NLPSearchDisclaimerType["WhoDisclaimer"] = "WHO_QUESTION";
    return NLPSearchDisclaimerType;
}({});
var $313b937e83fff73c$export$9405d23bea8d0d8b = /*#__PURE__*/ function(NLPSearchErrorState) {
    NLPSearchErrorState["NoAnswer"] = "NO_ANSWER";
    NLPSearchErrorState["NoAnswerKeywords"] = "NO_ANSWER_KEYWORDS";
    NLPSearchErrorState["NoAnswerSearchResults"] = "NO_ANSWER_SEARCH_RESULTS";
    NLPSearchErrorState["NoAnswerHydration"] = "NO_ANSWER_HYDRATION";
    NLPSearchErrorState["NoAnswerRelevantContent"] = "NO_ANSWER_RELEVANT_CONTENT";
    NLPSearchErrorState["NoAnswerOpenAIResponseError"] = "NO_ANSWER_OPEN_AI_RESPONSE_ERR";
    NLPSearchErrorState["NoAnswerOpenAIRateLimitUserAbuse"] = "OPENAI_RATE_LIMIT_USER_ABUSE";
    NLPSearchErrorState["NoAnswerWhoQuestion"] = "NO_ANSWER_WHO_QUESTION";
    NLPSearchErrorState["SubjectiveQuery"] = "SUBJECTIVE_QUERY";
    NLPSearchErrorState["AcceptableUseViolation"] = "ACCEPTABLE_USE_VIOLATIONS";
    NLPSearchErrorState["AIDisabled"] = "AI_DISABLED";
    NLPSearchErrorState["EarlyStop"] = "EARLY_STOP";
    // These values are not returned from the BE and are only used by the FE
    NLPSearchErrorState["Default"] = "DEFAULT";
    // Value at component initialization
    NLPSearchErrorState["NetworkError"] = "NETWORK_ERROR";
    // Value if the network call fails
    NLPSearchErrorState["TimeoutError"] = "TIMEOUT_ERROR";
    // Value if the network call times out
    NLPSearchErrorState["HIPAAError"] = "HIPAA_ERROR";
    return NLPSearchErrorState;
}({});
var $313b937e83fff73c$export$6b1112c70cca65d3 = /*#__PURE__*/ function(NLPSearchErrorCodes) {
    NLPSearchErrorCodes["HIPAA_ENABLED_ERROR"] = "convoai.rest.browsing.product.has.hipaa.enabled";
    return NLPSearchErrorCodes;
}({});
var $313b937e83fff73c$export$7c6c2f9c68de2e45 = /*#__PURE__*/ function(NLPSearchResultContainerDataTypeContainerType) {
    NLPSearchResultContainerDataTypeContainerType["ConfluenceSpace"] = "confluenceSpace";
    NLPSearchResultContainerDataTypeContainerType["JiraProject"] = "jiraProject";
    return NLPSearchResultContainerDataTypeContainerType;
}({});
var $313b937e83fff73c$export$12b805d25b464b8d = /*#__PURE__*/ function(NLPSearchCustomDefinitionType) {
    NLPSearchCustomDefinitionType["CURATED"] = "CURATED";
    NLPSearchCustomDefinitionType["PRECOMPUTED"] = "PRECOMPUTED";
    return NLPSearchCustomDefinitionType;
}({});
var $313b937e83fff73c$export$130eddddf4243f3f = /*#__PURE__*/ function(AIAnswerQueryStreamType) {
    AIAnswerQueryStreamType["AnswerType"] = "ANSWER_TYPE";
    AIAnswerQueryStreamType["GenerationType"] = "ANSWER_GENERATION_TYPE";
    AIAnswerQueryStreamType["AnswerPart"] = "ANSWER_PART";
    AIAnswerQueryStreamType["FinalResponse"] = "FINAL_RESPONSE";
    AIAnswerQueryStreamType["Trace"] = "TRACE";
    AIAnswerQueryStreamType["ErrorStateQuerySuggestions"] = "ERROR_STATE_QUERY_SUGGESTIONS";
    AIAnswerQueryStreamType["DynamicLayoutSubAgentMessage"] = "DL_SUB_AGENT";
    AIAnswerQueryStreamType["EarlyStop"] = "EARLY_STOP";
    return AIAnswerQueryStreamType;
}({});
var $313b937e83fff73c$export$e7b798431c659b80 = /*#__PURE__*/ function(AIAnswerAPIType) {
    AIAnswerAPIType["STREAM"] = "STREAM";
    return AIAnswerAPIType;
}({});
var $313b937e83fff73c$export$c13e418beaf43d1c = /*#__PURE__*/ function(DefinitionAnswerState) {
    DefinitionAnswerState["LOADING"] = "loading";
    DefinitionAnswerState["ANSWERED"] = "answered";
    DefinitionAnswerState["ERRORED"] = "errored";
    return DefinitionAnswerState;
}({});
module.exports["NLPSearchResultFormat"] = $313b937e83fff73c$export$e20550b618a28239;
module.exports["NLPSearchJSONResultFormat"] = $313b937e83fff73c$export$eae917983a0398aa;
module.exports["NLPSearchErrorState"] = $313b937e83fff73c$export$9405d23bea8d0d8b;
module.exports["NLPSearchErrorCodes"] = $313b937e83fff73c$export$6b1112c70cca65d3;
module.exports["NLPSearchResultContainerDataTypeContainerType"] = $313b937e83fff73c$export$7c6c2f9c68de2e45;
module.exports["NLPSearchCustomDefinitionType"] = $313b937e83fff73c$export$12b805d25b464b8d;
module.exports["AIAnswerQueryStreamType"] = $313b937e83fff73c$export$130eddddf4243f3f;
module.exports["AIAnswerAPIType"] = $313b937e83fff73c$export$e7b798431c659b80;

});

parcelRegister("4rtnp", function(module, exports) {
const $b0526d0c1289d064$export$dde7e4d56c9ce174 = (intent)=>intent.__typename === 'KnowledgeDiscoveryJiraIntent';
const $b0526d0c1289d064$export$c0aab31e723dae61 = (intent)=>intent.__typename === 'KnowledgeDiscoveryJobTitleIntent';
const $b0526d0c1289d064$export$7b8826f0986d1f8d = (intent)=>intent.__typename === 'KnowledgeDiscoveryKeywordOrAcronymIntent';
const $b0526d0c1289d064$export$5b6f4228a1086946 = (intent)=>intent.__typename === 'KnowledgeDiscoveryNaturalLanguageIntent';
const $b0526d0c1289d064$export$4f361799dffb63b9 = (intent)=>intent.__typename === 'KnowledgeDiscoveryNoneIntent';
const $b0526d0c1289d064$export$2a104785b08af33a = (intent)=>intent.__typename === 'KnowledgeDiscoveryPersonIntent';
const $b0526d0c1289d064$export$9175ccd34ca92ae9 = (intent)=>intent.__typename === 'KnowledgeDiscoveryTeamIntent';
const $b0526d0c1289d064$export$a2c2990356fc3462 = (intent)=>intent.__typename === 'KnowledgeDiscoveryTopicIntent';
const $b0526d0c1289d064$export$92bb7bcca1963f8b = (intent)=>intent.__typename === 'KnowledgeDiscoveryNavContentIntent';
const $b0526d0c1289d064$export$cd102a4242b3d189 = (intent)=>intent.__typename === 'KnowledgeDiscoveryBookmarkIntent';
const $b0526d0c1289d064$export$a9b89ab41c676da3 = (intent)=>intent.__typename === 'KnowledgeDiscoveryNavigationalIntent';
const $b0526d0c1289d064$export$4415b0f2c2d2aa64 = (intent)=>intent.__typename === 'KnowledgeDiscoveryOrgChartIntent';
module.exports["isNavContentIntent"] = $b0526d0c1289d064$export$92bb7bcca1963f8b;
module.exports["isBookmarkIntent"] = $b0526d0c1289d064$export$cd102a4242b3d189;
module.exports["isNavigationalIntent"] = $b0526d0c1289d064$export$a9b89ab41c676da3;

});

parcelRegister("dxjDr", function(module, exports) {
/* JiraIssueSmartCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $bYRk6 = parcelRequire("bYRk6");


var $7bZ3i = parcelRequire("7bZ3i");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $5TXU5 = parcelRequire("5TXU5");


var $9CM6e = parcelRequire("9CM6e");


var $2Rith = parcelRequire("2Rith");

var $fYQcF = parcelRequire("fYQcF");


var $4xTru = parcelRequire("4xTru");


var $4jIuc = parcelRequire("4jIuc");


var $cVtio = parcelRequire("cVtio");


var $h5V7v = parcelRequire("h5V7v");


var $frwgP = parcelRequire("frwgP");


var $lsDB7 = parcelRequire("lsDB7");


var $f7lNm = parcelRequire("f7lNm");


var $fJBWn = parcelRequire("fJBWn");


var $01aV7 = parcelRequire("01aV7");


var $9lp28 = parcelRequire("9lp28");

const $4c589766ed9a1110$var$styles = {
    root: "_bfhksm61 _otyrv77o _19bvze3t _u5f3ze3t _1bsb1osq"
};
const $4c589766ed9a1110$export$503d0d685bf87c06 = ({ issueKeyQuery: issueKeyQuery, cloudId: cloudId, aiBrand: aiBrand, searchSessionId: searchSessionId, workspaceId: workspaceId, product: product })=>{
    const [issueUrl, setIssueUrl] = (0, $42omo.useState)(null);
    const { trackAIInteractionInit: trackAIInteractionInit } = (0, $fYQcF.useAIEventsInstrumentation)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const cardRef = (0, $42omo.useRef)(null);
    const initialLoadTs = (0, $42omo.useRef)(performance.now()).current;
    const analyticsAttributes = (0, $42omo.useMemo)(()=>({
            searchSessionId: searchSessionId,
            queryHash: (0, $01aV7.sha256Hash)(issueKeyQuery),
            brand: aiBrand,
            source: 'jira_issue_card',
            query: issueKeyQuery,
            answerString: issueUrl || '',
            answerCardType: (0, $f7lNm.AnswerCardType).JIRA_ISSUE
        }), [
        searchSessionId,
        issueKeyQuery,
        aiBrand,
        issueUrl
    ]);
    const analyticsAttributesWithoutUGC = (0, $42omo.useMemo)(()=>({
            searchSessionId: searchSessionId,
            queryHash: (0, $01aV7.sha256Hash)(issueKeyQuery),
            brand: aiBrand,
            source: 'jira_issue_card',
            answerCardType: (0, $f7lNm.AnswerCardType).JIRA_ISSUE
        }), [
        searchSessionId,
        issueKeyQuery,
        aiBrand
    ]);
    const commonAttributes = (0, $42omo.useMemo)(()=>({
            cloudId: cloudId,
            orgId: '',
            // Not available in this component
            source: 'jira_issue_card',
            query: issueKeyQuery,
            queryHash: (0, $01aV7.sha256Hash)(issueKeyQuery),
            baseQueryHash: (0, $01aV7.sha256Hash)(issueKeyQuery),
            searchSessionId: searchSessionId,
            answerString: issueUrl || '',
            answerLength: issueUrl?.length || 0,
            answerWordCount: 0,
            answerFormat: null,
            answerCardType: (0, $f7lNm.AnswerCardType).JIRA_ISSUE,
            sources: [],
            followUps: [],
            errorState: null,
            errorStateSuggestedQueries: [],
            extraAttributes: {
                issueKey: issueKeyQuery
            },
            apiSource: 'xp-knowledge-discovery',
            workspaceId: workspaceId,
            sessionId: searchSessionId,
            brand: aiBrand
        }), [
        cloudId,
        issueKeyQuery,
        searchSessionId,
        issueUrl,
        workspaceId,
        aiBrand
    ]);
    // Dwell tracker for viewport exit detection
    if ((0, $dh538.fg)('kd_add_ssrv3_attributes')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $lsDB7.useDwellTracker)({
        elementRef: cardRef,
        onDwellEnd: (dwellTime)=>{
            fireSAINUsageEvent({
                metCriteria: (0, $4jIuc.SainAction).FMP_RESULT_EXITED,
                dwellTime: dwellTime,
                commonAttributes: commonAttributes
            });
        }
    });
    (0, $42omo.useEffect)(()=>{
        (0, $frwgP.resolveJiraUrl)({
            issueKey: issueKeyQuery,
            cloudId: cloudId,
            workspaceId: workspaceId,
            product: product
        }).then(setIssueUrl);
    }, [
        issueKeyQuery,
        cloudId,
        workspaceId,
        product
    ]);
    (0, $42omo.useEffect)(()=>{
        if (issueUrl) {
            const fmpLoadTime = Math.round(performance.now() - initialLoadTs);
            trackAIInteractionInit();
            // Use enriched commonAttributes when feature flag is enabled, otherwise use basic analyticsAttributes
            const shownEventAttributes = (0, $dh538.fg)('kd_add_ssrv3_attributes') ? {
                ...commonAttributes,
                fmpLoadTime: fmpLoadTime
            } : analyticsAttributes;
            fireAnalyticsEvent((0, $4xTru.onNonGenerativeAIAnswerResultShown)(shownEventAttributes));
            fireSAINUsageEvent({});
        }
    }, [
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        analyticsAttributes,
        commonAttributes,
        issueUrl,
        trackAIInteractionInit,
        initialLoadTs
    ]);
    if (!issueUrl) return null;
    const handleClick = (event)=>{
        // Passing a click handler to the `SmartCardSSR` component requires navigation handling here
        const target = (0, $h5V7v.getLinkTarget)(event);
        window.open(issueUrl, target);
        fireAnalyticsEvent((0, $fJBWn.onNonGenerativeKnowledgeCardLinkClick)(analyticsAttributes));
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                ref: cardRef,
                xcss: $4c589766ed9a1110$var$styles.root,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
                    data: {
                        attributes: {
                            location: (0, $4xTru.SmartLinksAnalyticsContextLocation).SAIN_JIRA_ISSUE_CARD,
                            ...analyticsAttributesWithoutUGC
                        },
                        location: (0, $4xTru.SmartLinksAnalyticsContextLocation).SAIN_JIRA_ISSUE_CARD
                    },
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7bZ3i.SmartCardProvider), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9CM6e.CardSSR), {
                            url: issueUrl,
                            appearance: "block",
                            ui: {
                                size: (0, $5TXU5.SmartLinkSize).Medium
                            },
                            onClick: handleClick
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $9lp28.AIDisclaimerAndFeedback), {
                showFeedbackButtons: true
            })
        ]
    });
};
const $4c589766ed9a1110$export$1a6b6e147aad985 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2Rith.AIEventsInstrumentationProvider), {
        config: {
            product: props.product,
            subproduct: props.subproduct ?? 'unknown',
            aiFeatureName: 'smartAnswers',
            aiExperienceName: (0, $f7lNm.AiExperienceName).JIRA_ISSUE_CARD,
            proactiveGeneratedAI: 0,
            userGeneratedAI: 1,
            isAIFeature: 0,
            source: props.source,
            channel: (0, $f7lNm.DEFAULT_GAS_CHANNEL)
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)($4c589766ed9a1110$export$503d0d685bf87c06, {
            ...props
        })
    });
module.exports["JiraIssueSmartCard"] = $4c589766ed9a1110$export$1a6b6e147aad985;

});

parcelRegister("2Rith", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ifW2H = parcelRequire("ifW2H");


var $8Y3mE = parcelRequire("8Y3mE");


var $j4EkW = parcelRequire("j4EkW");

const $0f73dde994861ed0$var$validateAIEventsConfig = (config)=>{
    if (!config.aiFeatureName.match(/^[a-z][A-Za-z]*$/)) // eslint-disable-next-line no-console
    console.error('[@atlassian/ai-analytics]: please set aiFeatureName in camelCase');
};
const $0f73dde994861ed0$export$b5d4bc85dfbaa4f8 = ({ children: children, config: config })=>{
    const { refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = (0, $j4EkW.useAIInstrumentationSetup)(config.singleInstrumentationID);
    const contextValue = (0, $42omo.useMemo)(()=>{
        $0f73dde994861ed0$var$validateAIEventsConfig(config);
        return {
            config: {
                ...(0, $8Y3mE.defaultAIEventsInstrumentationConfigValues),
                ...config,
                product: config.product.toLowerCase()
            },
            refreshSingleInstrumentationID: refreshSingleInstrumentationID,
            getSingleInstrumentationID: getSingleInstrumentationID,
            setAISessionState: setAISessionState,
            getAISessionState: getAISessionState
        };
    }, [
        config,
        refreshSingleInstrumentationID,
        getSingleInstrumentationID,
        setAISessionState,
        getAISessionState
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ifW2H.AIEventsInstrumentationContext).Provider, {
        value: contextValue,
        children: children
    });
};
module.exports["AIEventsInstrumentationProvider"] = $0f73dde994861ed0$export$b5d4bc85dfbaa4f8;

});

parcelRegister("h5V7v", function(module, exports) {
const $928538791edf5bb0$export$d08a3eab2fc93ae2 = (event)=>$928538791edf5bb0$var$isSpecialEvent(event) ? '_blank' : '_self';
/**
 * All code below this comment block is lifted from Linking Platform to match their smart card link click behavior:
 * https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/238b520ec4308da2c86b01cbdd145f141c75d51b/platform/packages/linking-platform/smart-card/src/utils/index.tsx#lines-11:34
 */ const $928538791edf5bb0$var$isSpecialEvent = (event)=>event.isDefaultPrevented() && ($928538791edf5bb0$var$isIframe() || $928538791edf5bb0$var$isSpecialKey(event) || $928538791edf5bb0$var$isSpecialClick(event));
// Slight change from Linking Platform code to add try/catch here
const $928538791edf5bb0$var$isIframe = ()=>{
    try {
        return window.parent !== window;
    } catch  {
        // cross-origin parent access throws
        return true;
    }
};
/**
 * Meta key = cmd on mac, windows key on windows
 * Ctrl key on mac by default triggers a right click instead of left click
 * Ctrl key on Windows has the same behaviour of cmd key of mac (open in new tab)
 * Shift key is also a "special" key because the default behavior of Chromium-based browsers is to open the
 * link in a new window; Arc browser has custom logic to show links in its "peek" window when shift is held.
 *
 * `isSpecialKey` on a mouse event on mac with default behaviour should be equivalent to opening in new tab
 * On Windows it will be equivalent to opening a new tab, unless its the Window key that is held
 * in which case typically only a standard clickthrough will occur, this is likely a small portion of events
 */ const $928538791edf5bb0$var$isSpecialKey = (event)=>event.metaKey || event.ctrlKey || event.shiftKey;
const $928538791edf5bb0$var$isSpecialClick = (event)=>event.button === 1;
module.exports["getLinkTarget"] = $928538791edf5bb0$export$d08a3eab2fc93ae2;

});

parcelRegister("frwgP", function(module, exports) {

var $6yuru = parcelRequire("6yuru");


var $9EFEY = parcelRequire("9EFEY");


var $6CITI = parcelRequire("6CITI");


var $4Zqgi = parcelRequire("4Zqgi");

/**
 * Attempts to resolve a Jira URL from the local store
 * @param issueKey - The Jira issue key to look up eg PROJ-123
 * @returns The URL if found in local store, null otherwise
 */ const $0d11052e4349eb7f$var$resolveFromLocalStore = (issueKey)=>{
    const storedUrl = (0, $6CITI.localStore).getString('jira-issue-url');
    if (!!storedUrl && new RegExp(issueKey, 'i').test(storedUrl)) return storedUrl;
    return null;
};
/**
 * Attempts to resolve a Jira URL from the quicksearch endpoint
 * @param issueKey - The Jira issue key to look up eg PROJ-123
 * @returns The URL if found in quicksearch results, null otherwise
 */ const $0d11052e4349eb7f$var$resolveFromQuickSearch = async ({ issueKey: issueKey, cloudId: cloudId, workspaceId: workspaceId, product: product })=>{
    try {
        const response = await (0, $9EFEY.fetchAggResponse)({
            graphQuery: `
			query KnowledgeDiscoveryIssueSearch(
				$experience: String!
				$query: String!
				$filters: SearchFilterInput!
				$first: Int
			) {
				search {
					results: search(
						experience: $experience
						query: $query
						filters: $filters
						first: $first
					) {
						edges {
							node {
								type
								id
								title
								url
								iconUrl
								... on SearchResultJiraIssue {
									issue {
										key
									}
								}
							}
						}
					}
				}
			}
			`,
            variables: {
                experience: 'knowledge-discovery.issue-card',
                query: issueKey,
                filters: {
                    entities: [
                        'ati:cloud:jira:issue'
                    ],
                    locations: [
                        `ari:cloud:jira::site/${cloudId}`
                    ]
                },
                first: 1
            },
            operationName: 'KnowledgeDiscoveryIssueSearch',
            headers: (0, $6yuru.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: cloudId,
                product: product
            })
        });
        const results = response.data?.search?.results?.edges ?? [];
        const matchingResult = results.find((result)=>result.node.issue?.key?.toLowerCase() === issueKey.toLowerCase());
        return matchingResult?.node?.url || null;
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'resolveFromQuickSearch'
        });
    }
    return null;
};
const $0d11052e4349eb7f$export$d7c7b957a5608d16 = async ({ issueKey: issueKey, cloudId: cloudId, workspaceId: workspaceId, product: product })=>{
    // Try local store first
    const localStoreUrl = $0d11052e4349eb7f$var$resolveFromLocalStore(issueKey);
    if (!!localStoreUrl) return localStoreUrl;
    // Fall back to quicksearch
    const quickSearchUrl = await $0d11052e4349eb7f$var$resolveFromQuickSearch({
        issueKey: issueKey,
        cloudId: cloudId,
        workspaceId: workspaceId,
        product: product
    });
    return quickSearchUrl;
};
module.exports["resolveJiraUrl"] = $0d11052e4349eb7f$export$d7c7b957a5608d16;

});

parcelRegister("lsDB7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");

const $e9e876f82a3b31d5$export$5335101d48c968c3 = ({ elementRef: elementRef, onDwellEnd: onDwellEnd })=>{
    const [isInViewport, setIsInViewport] = (0, $42omo.useState)(false);
    const [tabHasFocus, setTabHasFocus] = (0, $42omo.useState)(true);
    const dwellStartTimeRef = (0, $42omo.useRef)();
    const isDwellingRef = (0, $42omo.useRef)(false);
    // Track viewport intersection
    (0, $42omo.useEffect)(()=>{
        if (!elementRef.current) return;
        const observer = new IntersectionObserver(([entry])=>{
            setIsInViewport(entry.isIntersecting);
        }, {
            threshold: 1.0
        });
        observer.observe(elementRef.current);
        return ()=>{
            observer.disconnect();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        elementRef.current
    ]);
    // Set up focus and navigation event listeners
    (0, $42omo.useEffect)(()=>{
        const handleVisibilityChange = ()=>{
            setTabHasFocus(!document.hidden);
        };
        const handleFocus = ()=>setTabHasFocus(true);
        const handleBlur = ()=>setTabHasFocus(false);
        const handleNavigation = ()=>{
            if (isDwellingRef.current && dwellStartTimeRef.current) {
                const dwellTime = Date.now() - dwellStartTimeRef.current;
                onDwellEnd?.(dwellTime);
            }
        };
        // Set up all event listeners using bind-event-listener
        const unbindVisibilityChange = (0, $fFa3V.bind)(document, {
            type: 'visibilitychange',
            listener: handleVisibilityChange
        });
        const unbindFocus = (0, $fFa3V.bind)(window, {
            type: 'focus',
            listener: handleFocus
        });
        const unbindBlur = (0, $fFa3V.bind)(window, {
            type: 'blur',
            listener: handleBlur
        });
        const unbindNavigation = (0, $fFa3V.bind)(window, {
            type: 'beforeunload',
            listener: handleNavigation
        });
        return ()=>{
            unbindVisibilityChange();
            unbindFocus();
            unbindBlur();
            unbindNavigation();
            // Fire on unmount if still dwelling
            if (isDwellingRef.current && dwellStartTimeRef.current) {
                const dwellTime = Date.now() - dwellStartTimeRef.current;
                onDwellEnd?.(dwellTime);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Handle dwell start/end logic based on state changes
    (0, $42omo.useEffect)(()=>{
        const shouldDwell = isInViewport && tabHasFocus;
        // Start dwelling
        if (shouldDwell && !isDwellingRef.current) {
            dwellStartTimeRef.current = Date.now();
            isDwellingRef.current = true;
        }
        // End dwelling (viewport exit)
        if (!shouldDwell && isDwellingRef.current && dwellStartTimeRef.current) {
            const dwellTime = Date.now() - dwellStartTimeRef.current;
            onDwellEnd?.(dwellTime);
            isDwellingRef.current = false;
            dwellStartTimeRef.current = undefined;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isInViewport,
        tabHasFocus
    ]);
};
module.exports["useDwellTracker"] = $e9e876f82a3b31d5$export$5335101d48c968c3;

});

parcelRegister("x4n5k", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c07c4c04f9f99a3868a6c26b78654ed8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0636793d229b2435$var$_react = $0636793d229b2435$var$_interopRequireDefault((parcelRequire("42omo")));

var $0636793d229b2435$var$_baseNew = $0636793d229b2435$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $0636793d229b2435$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: None
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0636793d229b2435$var$BookOpenIcon = (props)=>/*#__PURE__*/ $0636793d229b2435$var$_react.default.createElement($0636793d229b2435$var$_baseNew.default, Object.assign({
        name: "BookOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.5 2.25v10H8.75V4.625a2.375 2.375 0 0 1 2.375-2.375zM8 2.333A3.87 3.87 0 0 1 11.125.75h3.501C15.387.75 16 1.367 16 2.125v10.25c0 .76-.616 1.375-1.375 1.375H8.75v1.5h-1.5v-1.5H1.375C.615 13.75 0 13.134 0 12.375V2.125C0 1.366.615.75 1.375.75h3.5A3.87 3.87 0 0 1 8 2.333m-.75 9.917V4.625A2.375 2.375 0 0 0 4.875 2.25H1.5v10zm6-8H10.5v1.5h2.75zm0 2.5H10.5v1.5h2.75z" clip-rule="evenodd"/>`
    }, props));
$0636793d229b2435$var$BookOpenIcon.displayName = 'BookOpenIcon';
var $0636793d229b2435$var$_default = module.exports.default = $0636793d229b2435$var$BookOpenIcon;

});

parcelRegister("7gpC4", function(module, exports) {
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $3654r = parcelRequire("3654r");


var $dh538 = parcelRequire("dh538");


var $6MlG5 = parcelRequire("6MlG5");

var $9wgn8 = parcelRequire("9wgn8");

var $cVrnQ = parcelRequire("cVrnQ");

var $hcDON = parcelRequire("hcDON");

const $1f9fb6b4b3bc4020$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
}; /**
    * Legacy hidden input styles with nested sibling selectors.
    * Used when the `platform-checkbox-atomic-styles` feature gate is disabled.
    * Using `cssMap` to avoid a Compiled bug with the transformed styles.
    * It was using a CSS variable for the outline template string,
    * which broke because of the use of a sibling selector.
    *
    * Related to: https://github.com/atlassian-labs/compiled/pull/1795
    */ 
const $1f9fb6b4b3bc4020$var$checkboxStylesLegacy = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef78r4n _1h6r8r4n _smzgdfik _1dk7dfik _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $1f9fb6b4b3bc4020$var$Checkbox = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $42omo.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $42omo.useRef)(null);
    const mergedRefs = (0, $3654r.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $42omo.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $9wgn8.default), {
        isDisabled: isDisabled,
        isChecked: (0, $dh538.fg)('platform-checkbox-atomic-styles') ? isChecked : undefined,
        isIndeterminate: (0, $dh538.fg)('platform-checkbox-atomic-styles') ? isIndeterminate : undefined,
        isInvalid: (0, $dh538.fg)('platform-checkbox-atomic-styles') ? isInvalid : undefined,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $gMc0m.default)([
                    (0, $dh538.fg)('platform-checkbox-atomic-styles') && $1f9fb6b4b3bc4020$var$checkboxStyles.root,
                    !(0, $dh538.fg)('platform-checkbox-atomic-styles') && $1f9fb6b4b3bc4020$var$checkboxStylesLegacy.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6MlG5.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $l998X.jsxs)((0, $cVrnQ.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $l998X.jsx)((0, $hcDON.default), {})
                ]
            })
        ]
    });
}));
$1f9fb6b4b3bc4020$var$Checkbox.displayName = 'Checkbox';
var $1f9fb6b4b3bc4020$export$2e2bcd8739ae039 = $1f9fb6b4b3bc4020$var$Checkbox;
module.exports["default"] = $1f9fb6b4b3bc4020$export$2e2bcd8739ae039;

});

parcelRegister("6MlG5", function(module, exports) {
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");

const $71feb0a29953fded$var$svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
}; /**
    * Legacy SVG styles.
    * Used when the `platform-checkbox-atomic-styles` feature gate is disabled.
    */ 
const $71feb0a29953fded$var$svgStylesLegacy = null;
function $71feb0a29953fded$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $l998X.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ (0, $l998X.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
     // No icon
    return null;
}
const $71feb0a29953fded$var$CheckboxIcon = /*#__PURE__*/ (0, $42omo.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $42omo.useMemo)(()=>$71feb0a29953fded$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    if ((0, $dh538.fg)('platform-checkbox-atomic-styles')) return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $gMc0m.default)([
            $71feb0a29953fded$var$svgStyles.root
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    className: (0, $gMc0m.default)([
                        $71feb0a29953fded$var$svgStyles.rect
                    ])
                }),
                icon
            ]
        })
    });
     // Legacy rendering with inline style props for CSS variable consumption
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: 'var(--checkbox-background-color)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            fill: 'var(--checkbox-tick-color)'
        },
        role: "presentation",
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }),
                icon
            ]
        })
    });
});
var $71feb0a29953fded$export$2e2bcd8739ae039 = $71feb0a29953fded$var$CheckboxIcon;
module.exports["default"] = $71feb0a29953fded$export$2e2bcd8739ae039;

});

parcelRegister("9wgn8", function(module, exports) {
$parcel$export(module.exports, "default", () => $edf27753e59bf881$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");

const $edf27753e59bf881$var$baseStyles = null;
const $edf27753e59bf881$var$textLabelLayoutStyles = null; // Checked/Indeterminate state
const $edf27753e59bf881$var$checkedStyles = null; // Invalid state - must override hover/active to maintain red border
const $edf27753e59bf881$var$invalidStyles = null; // Disabled state - must override hover/active to maintain disabled appearance
const $edf27753e59bf881$var$disabledStyles = null; // Disabled + Checked/Indeterminate
const $edf27753e59bf881$var$disabledCheckedStyles = null; /**
                                     * Legacy label styles with --local-* CSS custom properties.
                                     * These are consumed by the nested sibling selectors in checkbox.tsx.
                                     */ 
const $edf27753e59bf881$var$legacyBaseStyles = null;
const $edf27753e59bf881$var$legacyTextLabelLayoutStyles = null;
const $edf27753e59bf881$var$legacyDisabledStyles = null;
const $edf27753e59bf881$var$legacyLabelStyles = null;
function $edf27753e59bf881$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss }) {
    if ((0, $dh538.fg)('platform-checkbox-atomic-styles')) return /*#__PURE__*/ (0, $l998X.jsx)("label", {
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            label && "_zulp1nu5 _yv0ey09t",
            (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
            isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
            isDisabled && "_1qwnby5v _f0grby5v _syaz1gmx _80om13gf _1vj5by5v _q29qby5v _dh4gby5v _cz1uby5v _jom5wc43 _1s0718qt _106f18qt",
            isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("label", {
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _syazi7uo _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1gmx _80om13gf",
            "_h5e31j9a _1nzsr01l _1eszjmqp _yp0j1q28 _ay2wby5v _d51ul4ek _phftrsbi _1g1f1l7x _l6wkjmqp _1dik1q28 _1sfg1bqt _fpdjby5v _1yjc1v1w _oaj1rsbi _1j3h1bqt _eawb5w2r _1rda5w2r _18q02sac _13hr1j28",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("cVrnQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0c2060f65a94bd0$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $f0c2060f65a94bd0$var$labelTextStyles = null;
function $f0c2060f65a94bd0$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        className: (0, $gMc0m.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("hcDON", function(module, exports) {
$parcel$export(module.exports, "default", () => $a14852587cdb2524$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $a14852587cdb2524$var$requiredIndicatorStyles = null;
function $a14852587cdb2524$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "aria-hidden": true,
        className: (0, $gMc0m.default)([
            "_syaz1tmw _bozgv77o"
        ]),
        children: "*"
    });
}

});

parcelRegister("6yoZS", function(module, exports) {

let $4c594eef01830b0b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4c594eef01830b0b$var$load("hhss7"),
    $4c594eef01830b0b$var$load("cyGuT")
]).then(()=>parcelRequire('biiXa'));

});

parcelRegister("5w7WU", function(module, exports) {

var $6yuru = parcelRequire("6yuru");


var $9EFEY = parcelRequire("9EFEY");


var $4Zqgi = parcelRequire("4Zqgi");


var $f7lNm = parcelRequire("f7lNm");


var $egAid = parcelRequire("egAid");


var $aruaC = parcelRequire("aruaC");

const $8ad1f7056bd8c98a$export$c16051a8e758ff55 = async ({ query: query, siteId: siteId, locale: locale, metadata: metadata, cloudId: cloudId, orgId: orgId, workspaceId: workspaceId, product: product, setQueryIntent: setQueryIntent, setTransformedQuery: setTransformedQuery, setIntentData: setIntentData, setRequestId: setRequestId, setTraceId: setTraceId, onError: onError })=>{
    const handleError = (error)=>{
        setQueryIntent((0, $f7lNm.QueryIntent).NONE);
        setTransformedQuery('');
        onError?.(error);
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'getQueryIntent: handleError'
        });
    };
    try {
        const frontendQueryIntent = (0, $egAid.getFrontendQueryIntent)(query);
        // Intent from the frontend has a higher priority than the BE
        // Add any experiment and gate exclusion logic in `getFrontendQueryIntent` to prevent messy conditionals in this function
        if (!!frontendQueryIntent) {
            setQueryIntent(frontendQueryIntent.queryIntent);
            setTransformedQuery(frontendQueryIntent.transformedQuery);
            return;
        }
        const aggResponse = await (0, $9EFEY.fetchAggResponse)({
            graphQuery: (0, $aruaC.getIntentDetectionGQLQuery)(),
            variables: {
                query: query,
                siteId: siteId,
                locale: locale,
                orgId: orgId,
                ...metadata ? {
                    metadata: metadata
                } : {}
            },
            operationName: (0, $aruaC.INTENT_DETECTION_OPERATION_NAME),
            // we're using the cache to make sure the number of calls remain the same
            // make sure the cache key format is different from the actual intent detection call
            cache: {
                ttl: 300000,
                key: `shadow-intent-detection-${query}`
            },
            headers: (0, $6yuru.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: cloudId,
                product: product
            })
        });
        const response = aggResponse?.data?.knowledgeDiscovery.intentDetection;
        if (!response || !aggResponse?.data || aggResponse?.errors && aggResponse?.errors.length > 0 || response?.errors && response?.errors.length > 0) {
            // errors show up at the top level or in the response
            let errorMessage = aggResponse?.errors?.[0]?.message;
            if (response?.errors && response?.errors.length > 0) errorMessage = response?.errors?.[0]?.message;
            const error = errorMessage ? new Error(errorMessage) : new Error('getQueryIntent error');
            handleError(error);
            return;
        }
        // Intent from the BE
        setQueryIntent(response.intent?.classification);
        setTransformedQuery(response.intent?.transformedQuery);
        setIntentData?.(response.intent);
        setRequestId(aggResponse?.extensions?.gateway?.request_id ?? 'unknown');
        setTraceId?.(aggResponse?.extensions?.gateway?.trace_id ?? '');
    } catch (error) {
        handleError(error);
    }
};
module.exports["getQueryIntent"] = $8ad1f7056bd8c98a$export$c16051a8e758ff55;

});

parcelRegister("egAid", function(module, exports) {

var $f7lNm = parcelRequire("f7lNm");

function $b48bc080623d26d3$export$7542d9981bb876f9(query) {
    const lowercaseQuery = query.toLowerCase();
    if (/\w+-\d+/.test(lowercaseQuery)) return {
        queryIntent: (0, $f7lNm.QueryIntent).JIRA_ISSUE,
        transformedQuery: query
    };
    if (lowercaseQuery.endsWith(' agent') || lowercaseQuery.endsWith(' agents')) return {
        queryIntent: (0, $f7lNm.QueryIntent).AGENT,
        transformedQuery: query.replace(' agent', '').replace(' Agent', '')
    };
}
module.exports["getFrontendQueryIntent"] = $b48bc080623d26d3$export$7542d9981bb876f9;

});

parcelRegister("aruaC", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $e8b8727e3edb8560$export$6c52de753cb858f8 = 'KnowledgeDiscoveryIntentDetectionQuery';
const $e8b8727e3edb8560$export$12788ba4bf4fbd92 = `
    ... on KnowledgeDiscoveryBookmarkIntent {
        __typename
        bookmark {
            id
            url
            title
            description
            keyPhrase
            bookmarkState
            lastModifierAccountId
            lastModifiedTimestamp
            parentAdminhubBookmarkId
        }
    }
`;
const $e8b8727e3edb8560$export$6f87cad788b6beba = `
	... on KnowledgeDiscoveryPersonIntent {
		__typename
		persons {
			accountId
			name
			email
			picture
			jobTitle
			department
			organization
			location
			zoneInfo
		}
	}
`;
const $e8b8727e3edb8560$export$5cc310960e46a388 = `
	... on KnowledgeDiscoveryNavContentIntent {
		__typename
		url
		title
		createdAt
	}
`;
const $e8b8727e3edb8560$export$8145deeb4e892b30 = ()=>`
	query KnowledgeDiscoveryIntentDetectionQuery(
		$siteId: String!
		$query: String!
		$locale: String!
		$orgId: String!
	) {
		knowledgeDiscovery {
			intentDetection(locale: $locale, orgId: $orgId, query: $query, siteId: $siteId) {
				... on KnowledgeDiscoveryIntentDetectionSuccess {
					__typename
					errors {
						errorType
						statusCode
					}
					detectionMetadata {
						cacheHit
						latencyMs
						method
						model
						timestamp
						entityMetadata {
							entityCount
							entityType
						}
					}
					intent {
						classification
						detectionType
						subTypes
						transformedQuery
						... on KnowledgeDiscoveryJiraIntent {
							__typename
						}
						... on KnowledgeDiscoveryJobTitleIntent {
							__typename
						}
						... on KnowledgeDiscoveryKeywordOrAcronymIntent {
							__typename
						}
						... on KnowledgeDiscoveryNaturalLanguageIntent {
							__typename
						}
						... on KnowledgeDiscoveryNoneIntent {
							__typename
						}
						... on KnowledgeDiscoveryPersonIntent {
							__typename
						}
						... on KnowledgeDiscoveryTeamIntent {
							__typename
						}
						... on KnowledgeDiscoveryTopicIntent {
							__typename
						}
						... on KnowledgeDiscoveryNavigationalIntent {
							__typename
						}
						... on KnowledgeDiscoveryOrgChartIntent {
							__typename
						}
						${(0, $dh538.fg)('kd_enable_sain_hero_nav') ? $e8b8727e3edb8560$export$5cc310960e46a388 : ''}
						${(0, $dh538.fg)('kd_enable_sain_hero_nav') ? $e8b8727e3edb8560$export$12788ba4bf4fbd92 : ''}
						${(0, $dh538.fg)('kd_fe_persons_intent_detection_els') ? $e8b8727e3edb8560$export$6f87cad788b6beba : ''}
					}
				}
			}
		}
	}
`;
module.exports["INTENT_DETECTION_OPERATION_NAME"] = $e8b8727e3edb8560$export$6c52de753cb858f8;
module.exports["getIntentDetectionGQLQuery"] = $e8b8727e3edb8560$export$8145deeb4e892b30;

});

parcelRegister("c2fn3", function(module, exports) {

var $6yuru = parcelRequire("6yuru");


var $9EFEY = parcelRequire("9EFEY");


var $f7lNm = parcelRequire("f7lNm");


var $ca96q = parcelRequire("ca96q");

// temporaray solution for detecting query intent for new smart answers
// TODO: remove this once BE/ML solution is ready for use
function $13e20894b1795bef$var$detectQueryIntent(query, _cloudId) {
    const lowercaseQuery = query.toLowerCase();
    if (/\w+-\d+/.test(lowercaseQuery)) return (0, $f7lNm.QueryIntent).JIRA_ISSUE;
    if (lowercaseQuery.endsWith(' agent') || lowercaseQuery.endsWith(' agents')) return (0, $f7lNm.QueryIntent).AGENT;
    return null;
}
const $13e20894b1795bef$export$af8ff827a7d12c1e = async ({ query: query, siteId: siteId, locale: locale, metadata: metadata, cloudId: cloudId, orgId: orgId, workspaceId: workspaceId, product: product, setQueryIntent: setQueryIntent, setTransformedQuery: setTransformedQuery, onError: onError })=>{
    const handleError = (error)=>{
        setQueryIntent((0, $f7lNm.QueryIntent).NONE);
        setTransformedQuery('');
        onError?.(error);
    };
    try {
        let queryIntent = $13e20894b1795bef$var$detectQueryIntent(query, cloudId);
        if (queryIntent) setQueryIntent(queryIntent);
        const aggResponse = await (0, $9EFEY.fetchAggResponse)({
            graphQuery: (0, $ca96q.KnowledgeDiscoveryAnswerRouteQuery),
            variables: {
                query: query,
                siteId: siteId,
                locale: locale,
                orgId: orgId,
                ...metadata ? {
                    metadata: metadata
                } : {}
            },
            operationName: (0, $ca96q.ANSWER_ROUTE_OPERATION_NAME),
            cache: {
                ttl: 300000,
                key: query
            },
            headers: (0, $6yuru.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: cloudId,
                product: product
            })
        });
        const response = aggResponse?.data?.knowledgeDiscovery.smartAnswersRoute;
        if (!response || response?.__typename === 'QueryError' || Boolean(response?.message)) {
            // If we have a query intent, we can use the original query
            if (queryIntent) {
                if (queryIntent === (0, $f7lNm.QueryIntent).AGENT) {
                    setTransformedQuery(query.replace(' agent', '').replace(' Agent', ''));
                    return;
                }
                setTransformedQuery(query);
                return;
            }
            const error = new Error(response?.message || 'getSmartAnswerRoute error');
            handleError(error);
            return;
        }
        if (!queryIntent) {
            let beQueryIntent = response.route;
            setQueryIntent(beQueryIntent);
        }
        if (queryIntent === (0, $f7lNm.QueryIntent).AGENT) {
            setTransformedQuery(query.replace(' agent', '').replace(' Agent', ''));
            return;
        }
        setTransformedQuery(response.transformedQuery);
    } catch (error) {
        handleError(error);
    }
};
module.exports["getSmartAnswerRoute"] = $13e20894b1795bef$export$af8ff827a7d12c1e;

});

parcelRegister("ca96q", function(module, exports) {
const $b4ee38bbfadb7dbb$export$9b6dcba7f888840b = 'KnowledgeDiscoveryAnswerRoute';
const $b4ee38bbfadb7dbb$export$87415d93715f6028 = `
  query ${$b4ee38bbfadb7dbb$export$9b6dcba7f888840b}(
    $siteId: String!
    $query: String!
    $locale: String!
    $metadata: KnowledgeDiscoveryMetadata
    $orgId: String
  ) {
    knowledgeDiscovery {
      smartAnswersRoute(
        siteId: $siteId
        query: $query
        locale: $locale
				metadata: $metadata
				orgId: $orgId
      ) {
        __typename
        ... on KnowledgeDiscoverySmartAnswersRoute {
          route
          transformedQuery
        }
        ... on QueryError {
          message
          extensions {
            errorType
            statusCode
          }
        }
      }
    }
  }
`;
module.exports["ANSWER_ROUTE_OPERATION_NAME"] = $b4ee38bbfadb7dbb$export$9b6dcba7f888840b;
module.exports["KnowledgeDiscoveryAnswerRouteQuery"] = $b4ee38bbfadb7dbb$export$87415d93715f6028;

});

parcelRegister("2XcmP", function(module, exports) {
//refer to
//https://hello.atlassian.net/wiki/spaces/CASRAQ/pages/2821410030/Spike+Spec+Basic+Question+Detection+Integration+in+the+FE

var $ff9it = parcelRequire("ff9it");

const $35f896f2bbb88bbe$export$f72a6b3071a7b2a5 = ({ query: query, locale: locale })=>{
    const language = locale.split('-')[0].toLowerCase();
    const queryWords = query.split(' ');
    const endsWithAQuestionMark = query.endsWith('?');
    const isLanguageWithSpaces = (0, $ff9it.languagesWithSpaces).includes(language);
    const isLanguageWithoutSpaces = (0, $ff9it.languagesWithoutSpaces).includes(language);
    const isLanguageSupported = isLanguageWithSpaces || isLanguageWithoutSpaces;
    if (isLanguageSupported && endsWithAQuestionMark && queryWords.length > 1) return true;
    if (isLanguageWithSpaces) {
        const languageQuestionWords = (0, $ff9it.questionWords)[language];
        return queryWords.some((queryWord)=>languageQuestionWords.includes(queryWord.toLocaleLowerCase(locale))) && queryWords.length > 1;
    }
    if (isLanguageWithoutSpaces) {
        const languageQuestionWords = language === 'zh' ? (0, $ff9it.questionWords)[locale.toLowerCase()] : (0, $ff9it.questionWords)[language];
        return languageQuestionWords.some((questionWord)=>query.includes(questionWord)) && query.length > 1;
    }
    return false;
};
module.exports["isQuestion"] = $35f896f2bbb88bbe$export$f72a6b3071a7b2a5;

});

parcelRegister("ff9it", function(module, exports) {
const $85a5184734448d8e$export$6f8f84a4a12a6044 = {
    en: [
        'who',
        'what',
        'when',
        'where',
        'why',
        'is',
        'how',
        'which',
        'do',
        'does',
        'are',
        'can',
        'does',
        'would',
        'will',
        'could',
        'should',
        'did',
        'has',
        'have',
        'was'
    ],
    de: [
        'wer',
        'was',
        'wann',
        'wo',
        'warum',
        'wie',
        'welcher',
        'wieviel'
    ],
    ru: [
        "\u0447\u0442\u043E",
        "\u043A\u043E\u0433\u0434\u0430",
        "\u0433\u0434\u0435",
        "\u043F\u043E\u0447\u0435\u043C\u0443",
        "\u043A\u0430\u043A",
        "\u043A\u0430\u043A\u043E\u0432\u0430",
        "\u043A\u0442\u043E",
        "\u043A\u0430\u043A\u043E\u0439",
        "\u0441\u043A\u043E\u043B\u044C\u043A\u043E",
        "\u0437\u0430\u0447\u0435\u043C",
        "\u043E\u0442\u043A\u0443\u0434\u0430",
        "\u043A\u0443\u0434\u0430"
    ],
    fr: [
        'qui',
        'quoi',
        "o\xf9",
        'quand',
        'pourquoi',
        'comment',
        'combien',
        'lequel',
        'quel',
        'quelle',
        'quels',
        'quelles'
    ],
    pt: [
        'que',
        'quem',
        'onde',
        'quando',
        'como',
        'quanto',
        'qual'
    ],
    cs: [
        'kdo',
        'co',
        'kdy',
        'kde',
        "pro\u010D",
        'jak',
        'kolik',
        "kter\xfd"
    ],
    el: [
        "\u03C4\u03B9",
        "\u03C0\u03BF\u03B9\u03BF\u03C2",
        "\u03C0\u03BF\u03B9\u03B1",
        "\u03C0\u03BF\u03B9\u03BF",
        "\u03C0\u03CC\u03C4\u03B5",
        "\u03C0\u03BF\u03CD",
        "\u03C0\u03CE\u03C2",
        "\u03B3\u03B9\u03B1\u03C4\u03AF",
        "\u03C0\u03CC\u03C3\u03BF"
    ],
    'zh-cn': [
        "\u4EC0\u4E48",
        "\u8C01",
        "\u54EA\u91CC",
        "\u4E3A\u4EC0\u4E48",
        "\u4F55\u65F6",
        "\u600E\u4E48",
        "\u54EA",
        "\u591A\u5C11"
    ],
    'zh-sg': [
        "\u4EC0\u4E48",
        "\u8C01",
        "\u54EA\u91CC",
        "\u4E3A\u4EC0\u4E48",
        "\u4F55\u65F6",
        "\u600E\u4E48",
        "\u54EA",
        "\u591A\u5C11"
    ],
    'zh-hk': [
        "\u4EC0\u9EBC",
        "\u70BA\u4EC0\u9EBC",
        "\u5728\u54EA\u88E1",
        "\u4F55\u6642",
        "\u8AB0",
        "\u54EA\u4E00\u500B",
        "\u5982\u4F55",
        "\u591A\u5C11"
    ],
    'zh-mo': [
        "\u4EC0\u9EBC",
        "\u70BA\u4EC0\u9EBC",
        "\u5728\u54EA\u88E1",
        "\u4F55\u6642",
        "\u8AB0",
        "\u54EA\u4E00\u500B",
        "\u5982\u4F55",
        "\u591A\u5C11"
    ],
    'zh-tw': [
        "\u4EC0\u9EBC",
        "\u70BA\u4EC0\u9EBC",
        "\u5728\u54EA\u88E1",
        "\u4F55\u6642",
        "\u8AB0",
        "\u54EA\u4E00\u500B",
        "\u5982\u4F55",
        "\u591A\u5C11"
    ],
    ja: [
        "\u4F55",
        "\u306A\u306B",
        "\u8AB0",
        "\u3060\u308C",
        "\u3069\u3053",
        "\u3069\u3046\u3057\u3066",
        "\u3044\u3064",
        "\u3069\u306E",
        "\u3044\u304F\u3064",
        "\u3069\u308C"
    ],
    ko: [
        "\uBB34\uC5C7",
        "\uBB50",
        "\uC5B4\uB514",
        "\uC5B8\uC81C",
        "\uC65C",
        "\uB204\uAD6C",
        "\uC5B4\uB5BB\uAC8C",
        "\uBA87",
        "\uC5B4\uB290"
    ]
};
const $85a5184734448d8e$export$bd2c824c45156b2b = [
    'en',
    'de',
    'ru',
    'fr',
    'pt',
    'cs',
    'el'
];
const $85a5184734448d8e$export$175fffd27b9ba43e = [
    'zh',
    'ja',
    'ko'
];
module.exports["questionWords"] = $85a5184734448d8e$export$6f8f84a4a12a6044;
module.exports["languagesWithSpaces"] = $85a5184734448d8e$export$bd2c824c45156b2b;
module.exports["languagesWithoutSpaces"] = $85a5184734448d8e$export$175fffd27b9ba43e;

});

parcelRegister("hL7bb", function(module, exports) {
var $cedc651d64f014e0$var$pSlice = Array.prototype.slice;

var $gFqzn = parcelRequire("gFqzn");


var $2EuUq = parcelRequire("2EuUq");

var $cedc651d64f014e0$var$deepEqual = module.exports = function(actual, expected, opts) {
    if (!opts) opts = {};
    // 7.1. All identical values are equivalent, as determined by ===.
    if (actual === expected) return true;
    else if (actual instanceof Date && expected instanceof Date) return actual.getTime() === expected.getTime();
    else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') return opts.strict ? actual === expected : actual == expected;
    else return $cedc651d64f014e0$var$objEquiv(actual, expected, opts);
};
function $cedc651d64f014e0$var$isUndefinedOrNull(value) {
    return value === null || value === undefined;
}
function $cedc651d64f014e0$var$isBuffer(x) {
    if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
    if (typeof x.copy !== 'function' || typeof x.slice !== 'function') return false;
    if (x.length > 0 && typeof x[0] !== 'number') return false;
    return true;
}
function $cedc651d64f014e0$var$objEquiv(a, b, opts) {
    var i, key;
    if ($cedc651d64f014e0$var$isUndefinedOrNull(a) || $cedc651d64f014e0$var$isUndefinedOrNull(b)) return false;
    // an identical 'prototype' property.
    if (a.prototype !== b.prototype) return false;
    //~~~I've managed to break Object.keys through screwy arguments passing.
    //   Converting to array solves the problem.
    if ($2EuUq(a)) {
        if (!$2EuUq(b)) return false;
        a = $cedc651d64f014e0$var$pSlice.call(a);
        b = $cedc651d64f014e0$var$pSlice.call(b);
        return $cedc651d64f014e0$var$deepEqual(a, b, opts);
    }
    if ($cedc651d64f014e0$var$isBuffer(a)) {
        if (!$cedc651d64f014e0$var$isBuffer(b)) return false;
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    try {
        var ka = $gFqzn(a), kb = $gFqzn(b);
    } catch (e) {
        return false;
    }
    // having the same number of owned properties (keys incorporates
    // hasOwnProperty)
    if (ka.length != kb.length) return false;
    //the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    //~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
    }
    //equivalent values for every corresponding key, and
    //~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!$cedc651d64f014e0$var$deepEqual(a[key], b[key], opts)) return false;
    }
    return typeof a === typeof b;
}

});

parcelRegister("gFqzn", function(module, exports) {
exports = module.exports = typeof Object.keys === 'function' ? Object.keys : shim;
exports.shim = shim;
function shim(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
}

});

parcelRegister("2EuUq", function(module, exports) {
var supportsArgumentsClass = function() {
    return Object.prototype.toString.call(arguments);
}() == '[object Arguments]';
exports = module.exports = supportsArgumentsClass ? supported : unsupported;
exports.supported = supported;
function supported(object) {
    return Object.prototype.toString.call(object) == '[object Arguments]';
}
exports.unsupported = unsupported;
function unsupported(object) {
    return object && typeof object == 'object' && typeof object.length == 'number' && Object.prototype.hasOwnProperty.call(object, 'callee') && !Object.prototype.propertyIsEnumerable.call(object, 'callee') || false;
}

});

parcelRegister("2BDjU", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9ff1b999d67869c$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lFkSe = parcelRequire("lFkSe");


var $ncxs7 = parcelRequire("ncxs7");


var $9Phth = parcelRequire("9Phth");

const $b9ff1b999d67869c$export$ba912c88d6fa0f00 = ({ status: status, health: health, customColor: customColor, spacing: spacing, testId: testId, label: label })=>{
    const color = status === 'on_track' || status === 'at_risk' || status === 'off_track' ? (0, $ncxs7.getFocusAreaIconColor)({
        customColor: customColor,
        status: (0, $9Phth.FOCUS_AREA_STATUS_KEYS).IN_PROGRESS,
        health: status
    }) : (0, $ncxs7.getFocusAreaIconColor)({
        customColor: customColor,
        status: status,
        health: health
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lFkSe))), {
        color: color,
        spacing: spacing || 'none',
        label: label || '',
        testId: testId
    });
};
function $b9ff1b999d67869c$export$2e2bcd8739ae039({ status: status, health: health, customColor: customColor, spacing: spacing, testId: testId, label: label }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lFkSe))), {
        color: (0, $ncxs7.getFocusAreaIconColor)({
            customColor: customColor,
            status: status,
            health: health
        }),
        spacing: spacing || 'none',
        label: label || '',
        testId: testId
    });
}

});

parcelRegister("lFkSe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::76102cae83ff84364fe0f8b9a98fb276>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc5d9e69cae7ca27$var$_react = $fc5d9e69cae7ca27$var$_interopRequireDefault((parcelRequire("42omo")));

var $fc5d9e69cae7ca27$var$_baseNew = $fc5d9e69cae7ca27$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $fc5d9e69cae7ca27$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FocusArea".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing Focus Areas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fc5d9e69cae7ca27$var$FocusAreaIcon = (props)=>/*#__PURE__*/ $fc5d9e69cae7ca27$var$_react.default.createElement($fc5d9e69cae7ca27$var$_baseNew.default, Object.assign({
        name: "FocusAreaIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13v-3h1.5v3a.5.5 0 0 0 .5.5h3V15H3a2 2 0 0 1-2-2m12.5 0v-3H15v3a2 2 0 0 1-2 2h-3v-1.5h3a.5.5 0 0 0 .5-.5M9.75 8a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0M1 3a2 2 0 0 1 2-2h3v1.5H3a.5.5 0 0 0-.5.5v3H1zm12.5 0a.5.5 0 0 0-.5-.5h-3V1h3a2 2 0 0 1 2 2v3h-1.5zm-2.25 5a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0"/>`
    }, props));
$fc5d9e69cae7ca27$var$FocusAreaIcon.displayName = 'FocusAreaIcon';
var $fc5d9e69cae7ca27$var$_default = module.exports.default = $fc5d9e69cae7ca27$var$FocusAreaIcon;

});

parcelRegister("ncxs7", function(module, exports) {

var $9Phth = parcelRequire("9Phth");

const $dec905367716080f$export$4ee6399ea9bdb374 = ({ customColor: customColor, status: status, health: health })=>customColor || (0, $9Phth.FOCUS_AREA_DERIVED_STATUS_KEY_TO_COLOR_MAP)[$dec905367716080f$export$dc241ab7a519fd3f({
        status: status,
        health: health
    }).derivedStatusKey];
const $dec905367716080f$export$dc241ab7a519fd3f = ({ status: status, health: health })=>{
    const statusKey = $dec905367716080f$var$getValidStatus(status);
    const healthKey = $dec905367716080f$var$getValidHealth(health);
    const derivedStatusKey = statusKey === (0, $9Phth.FOCUS_AREA_STATUS_KEYS).IN_PROGRESS && healthKey ? healthKey : statusKey;
    return {
        derivedStatusKey: derivedStatusKey,
        derivedStatusLabel: (0, $9Phth.FOCUS_AREA_DERIVED_STATUS_KEY_TO_LABEL_MAP)[derivedStatusKey]
    };
};
const $dec905367716080f$var$getValidStatus = (status)=>status && (0, $9Phth.FOCUS_AREA_STATUS_KEYS_LIST).includes(status) ? status : (0, $9Phth.FOCUS_AREA_STATUS_KEYS).PENDING;
const $dec905367716080f$var$getValidHealth = (health)=>health && (0, $9Phth.FOCUS_AREA_HEALTH_KEYS_LIST).includes(health) ? health : undefined;
module.exports["getFocusAreaIconColor"] = $dec905367716080f$export$4ee6399ea9bdb374;

});

parcelRegister("9Phth", function(module, exports) {
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PENDING = 'pending';
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_IN_PROGRESS = 'in_progress';
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PAUSED = 'paused';
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_COMPLETED = 'completed';
const $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_ON_TRACK = 'on_track';
const $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_AT_RISK = 'at_risk';
const $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_OFF_TRACK = 'off_track';
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_PENDING = 'Pending';
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_IN_PROGRESS = 'In progress';
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_PAUSED = 'Paused';
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_COMPLETED = 'Completed';
const $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_ON_TRACK = 'On track';
const $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_AT_RISK = 'At risk';
const $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_OFF_TRACK = 'Off track';
const $76dba10ec45af105$export$c567f03f9a52e6e = {
    PENDING: $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PENDING,
    IN_PROGRESS: $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_IN_PROGRESS,
    PAUSED: $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PAUSED,
    COMPLETED: $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_COMPLETED
};
const $76dba10ec45af105$export$18c983eb7bb605ee = {
    ON_TRACK: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_ON_TRACK,
    AT_RISK: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_AT_RISK,
    OFF_TRACK: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_OFF_TRACK
};
const $76dba10ec45af105$export$a75c07cb53bf7489 = {
    PENDING: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_PENDING,
    IN_PROGRESS: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_IN_PROGRESS,
    PAUSED: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_PAUSED,
    COMPLETED: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_COMPLETED
};
const $76dba10ec45af105$export$b00cb7f00f2a82c0 = {
    ON_TRACK: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_ON_TRACK,
    AT_RISK: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_AT_RISK,
    OFF_TRACK: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_OFF_TRACK
};
const $76dba10ec45af105$export$8ed017a96b82c456 = [
    $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PENDING,
    $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_IN_PROGRESS,
    $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PAUSED,
    $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_COMPLETED
];
const $76dba10ec45af105$export$91000048f1c8a9ff = [
    $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_ON_TRACK,
    $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_AT_RISK,
    $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_OFF_TRACK
];
const $76dba10ec45af105$export$521c96d8ff090910 = {
    [$76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PENDING]: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_PENDING,
    [$76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_IN_PROGRESS]: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_IN_PROGRESS,
    [$76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PAUSED]: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_PAUSED,
    [$76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_COMPLETED]: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_COMPLETED
};
const $76dba10ec45af105$export$b4e54ea069601d19 = {
    [$76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_ON_TRACK]: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_ON_TRACK,
    [$76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_AT_RISK]: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_AT_RISK,
    [$76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_OFF_TRACK]: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_OFF_TRACK
};
const $76dba10ec45af105$export$357f9a743d453edd = {
    ...$76dba10ec45af105$export$521c96d8ff090910,
    ...$76dba10ec45af105$export$b4e54ea069601d19
};
const $76dba10ec45af105$export$8a9f9b723771f4eb = {
    pending: "var(--ds-icon-accent-gray, #7D818A)",
    in_progress: "var(--ds-icon-accent-gray, #7D818A)",
    on_track: "var(--ds-icon-accent-lime, #6A9A23)",
    at_risk: "var(--ds-icon-warning, #E06C00)",
    off_track: "var(--ds-icon-accent-red, #C9372C)",
    paused: "var(--ds-icon-accent-gray, #7D818A)",
    completed: "var(--ds-icon-accent-gray, #7D818A)"
};
module.exports["FOCUS_AREA_STATUS_KEYS"] = $76dba10ec45af105$export$c567f03f9a52e6e;
module.exports["FOCUS_AREA_STATUS_KEYS_LIST"] = $76dba10ec45af105$export$8ed017a96b82c456;
module.exports["FOCUS_AREA_HEALTH_KEYS_LIST"] = $76dba10ec45af105$export$91000048f1c8a9ff;
module.exports["FOCUS_AREA_DERIVED_STATUS_KEY_TO_LABEL_MAP"] = $76dba10ec45af105$export$357f9a743d453edd;
module.exports["FOCUS_AREA_DERIVED_STATUS_KEY_TO_COLOR_MAP"] = $76dba10ec45af105$export$8a9f9b723771f4eb;

});

parcelRegister("bomBS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a2de3deabb017040488a53969ad0b6f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $84b37978f45b293c$var$_react = $84b37978f45b293c$var$_interopRequireDefault((parcelRequire("42omo")));

var $84b37978f45b293c$var$_baseNew = $84b37978f45b293c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $84b37978f45b293c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CollapseHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for contracting or reducing the width of an element to its smallest size.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $84b37978f45b293c$var$CollapseHorizontalIcon = (props)=>/*#__PURE__*/ $84b37978f45b293c$var$_react.default.createElement($84b37978f45b293c$var$_baseNew.default, Object.assign({
        name: "CollapseHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7.25 0v16h1.5V0zm2.72 7.47a.75.75 0 0 0 0 1.06l3.25 3.25 1.06-1.06-1.97-1.97H16v-1.5h-3.69l1.97-1.97-1.06-1.06zM1.72 5.28l1.97 1.97H0v1.5h3.69l-1.97 1.97 1.06 1.06 3.25-3.25a.75.75 0 0 0 0-1.06L2.78 4.22z"/>`
    }, props));
$84b37978f45b293c$var$CollapseHorizontalIcon.displayName = 'CollapseHorizontalIcon';
var $84b37978f45b293c$var$_default = module.exports.default = $84b37978f45b293c$var$CollapseHorizontalIcon;

});

parcelRegister("eLV9q", function(module, exports) {
$parcel$export(module.exports, "useGetNavigateToTeamsApp", () => (parcelRequire("eWzPA")).useGetNavigateToTeamsApp);

var $eWzPA = parcelRequire("eWzPA");


});

parcelRegister("eWzPA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ay6Zz = parcelRequire("ay6Zz");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");


var $bYUc2 = parcelRequire("bYUc2");

const $8c3fac113683eb0d$export$bb1230c0e6efa9dc = ()=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const getNavigateToTeamsApp = (navActionPayload, shouldOpenInSameTab)=>{
        return (0, $ay6Zz.navigateToTeamsApp)({
            hostProduct: 'confluence',
            orgId: orgId,
            cloudId: cloudId,
            userHasNav4Enabled: (0, $bYUc2.getIsNav4EnabledSafe)(),
            shouldOpenInSameTab: shouldOpenInSameTab,
            ...navActionPayload
        });
    };
    const getNavigateToTeamsAppCallback = (0, $42omo.useCallback)(getNavigateToTeamsApp, [
        cloudId,
        orgId
    ]);
    return (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? getNavigateToTeamsAppCallback : getNavigateToTeamsApp;
};
module.exports["useGetNavigateToTeamsApp"] = $8c3fac113683eb0d$export$bb1230c0e6efa9dc;

});

parcelRegister("cacu1", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ao6k0 = parcelRequire("ao6k0");


var $dmHCt = parcelRequire("dmHCt");

const $94cd8136f02eb351$export$7999a9defd2c3cf4 = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ao6k0.PageLoadEnd), {
            metric: (0, $dmHCt.ADVANCED_SEARCH_PAGE_LOAD)
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ao6k0.PageLoadEnd), {
        metric: (0, $dmHCt.ADVANCED_SEARCH_PAGE_LOAD)
    }));
const $94cd8136f02eb351$export$f397be5efb2fdcd6 = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ao6k0.PageLoadEnd), {
            metric: (0, $dmHCt.UNIFIED_SEARCH_PAGE_LOAD)
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ao6k0.PageLoadEnd), {
        metric: (0, $dmHCt.UNIFIED_SEARCH_PAGE_LOAD)
    }));
module.exports["PageLoadEndEvent"] = $94cd8136f02eb351$export$7999a9defd2c3cf4;
module.exports["PageLoadEndEventUnifiedSearch"] = $94cd8136f02eb351$export$f397be5efb2fdcd6;

});

parcelRegister("ao6k0", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $inPa6 = parcelRequire("inPa6");


var $kmyZQ = parcelRequire("kmyZQ");


var $78QFu = parcelRequire("78QFu");


var $7sK8i = parcelRequire("7sK8i");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $5ZqQS = parcelRequire("5ZqQS");


var $dtDUi = parcelRequire("dtDUi");


var $6mKj3 = parcelRequire("6mKj3");


var $6VdZc = parcelRequire("6VdZc");

var $7fw2E = parcelRequire("7fw2E");

const $3ef4c99d4b0f9884$var$PageLoadEndImpl = /*#__PURE__*/ (0, $42omo.memo)(({ metric: metric, customData: customData = {}, stopTime: stopTime, onComplete: onComplete })=>{
    (0, $42omo.useEffect)(()=>{
        const stopArguments = {
            stopTime: typeof stopTime === 'number' ? stopTime : undefined,
            customData: {
                ...customData,
                previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
                pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
            }
        };
        metric.stop(stopArguments);
        (0, $7fw2E.markBrowserMetricEnd)(metric);
        (0, $7sK8i.resumeLowPriorityEvents)();
        // trigger onComplete regardless of FF - PageLoadEnd can stop the progress bar temporarily,
        // as ProgressBarContainer returns early if the progress bar has already been stopped.
        onComplete();
    // Not adding exhaustive dependencies because we want this to fire only once,
    // despite any changes to `customData` or `stopTime`
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onComplete,
        metric
    ]);
    return null;
});
const $3ef4c99d4b0f9884$var$PageLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)(({ metric: metric, customData: customData, stopTime: stopTime })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    if (window?.__SSR_RENDERED__ && Boolean(window.__HYDRATION_FAILED__)) {
        const { error: errorWithRoute, route: route } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
        const attribution = Boolean(window.__SSR_REACT_STREAMING__) ? 'streaming-hydration' : 'hydration';
        if ((0, $6mKj3.expVal)('confluence_frontend_hydration_failure_reporting', 'isEnabled', false)) createAnalyticsEvent((0, $dtDUi.getHydrationFailureOperationalEvent)({
            source: `PageLoadEnd - ${metric?.key}`,
            route: route,
            errorWithRoute: errorWithRoute,
            isSSRReactStreaming: Boolean(window.__SSR_REACT_STREAMING__)
        })).fire();
        else (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute, {
            attribution: attribution
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $kmyZQ.ProgressBarContainer)
        ]
    }, (progressBar)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3ef4c99d4b0f9884$var$PageLoadEndImpl, {
            metric: metric,
            customData: customData,
            stopTime: stopTime,
            onComplete: progressBar.finish
        }));
});
const $3ef4c99d4b0f9884$export$570dec5b65c6715b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($3ef4c99d4b0f9884$var$PageLoadEndComponent);
module.exports["PageLoadEnd"] = $3ef4c99d4b0f9884$export$570dec5b65c6715b;

});

parcelRegister("aJv6Q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("dtDUi", function(module, exports) {

var $64KID = parcelRequire("64KID");


var $fMEnQ = parcelRequire("fMEnQ");

const $dab54f7f733e6dc2$var$DOC_LINK = 'https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4848884799/Debugging+Hydration+Mismatches';
const $dab54f7f733e6dc2$export$476b9d1d68660527 = [
    {
        matchers: [
            /Hydration failed because the initial UI does not match what was rendered on the server/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /The server could not finish this Suspense boundary, likely due to an error during server rendering/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This root received an early update, before anything was able hydrate. Switched the entire root to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Text content does not match server-rendered HTML./
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating this Suspense boundary. Switched to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    //Production errors
    {
        matchers: [
            /Minified React error #418/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server in production. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #419/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #421/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #422/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #423/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #424/
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #425/
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    }
];
const $dab54f7f733e6dc2$export$5796b97ecb5a412 = (errorString)=>{
    for (const { matchers: matchers, friendlyError: friendlyError, hydrationFailed: hydrationFailed } of $dab54f7f733e6dc2$export$476b9d1d68660527){
        if (matchers.some((matcher)=>matcher.test(errorString))) return {
            ...friendlyError,
            originalString: errorString,
            hydrationFailed: hydrationFailed
        };
    }
    return {
        friendlyMessage: 'An additional error occurred, attached below.',
        docLink: '',
        fallback: true,
        originalString: errorString,
        hydrationFailed: false
    };
};
const $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2 = (url)=>{
    const match = (0, $fMEnQ.Route).matchFirst(Object.values((0, $64KID.namedRoutes)), url);
    return {
        error: new Error(`Hydration failed on route ${match?.name}`),
        route: match?.name || 'unknown'
    };
};
function $dab54f7f733e6dc2$export$260985b5e8a6fce6({ source: source, route: route, errorWithRoute: errorWithRoute, isSSRReactStreaming: isSSRReactStreaming }) {
    const attribution = isSSRReactStreaming ? 'streaming-hydration' : 'hydration';
    const error = $dab54f7f733e6dc2$var$trimTextLength(errorWithRoute.message || String(errorWithRoute), 1000);
    return {
        type: 'sendOperationalEvent',
        data: {
            source: source,
            route: route,
            action: 'failed',
            actionSubject: 'hydration',
            attributes: {
                error: error,
                route: route,
                attribution: attribution,
                isSSRReactStreaming: isSSRReactStreaming
            }
        }
    };
}
function $dab54f7f733e6dc2$var$trimTextLength(text, maxLength) {
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
}
module.exports["matchHydrationError"] = $dab54f7f733e6dc2$export$5796b97ecb5a412;
module.exports["getHydrationErrorWithRoute"] = $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2;
module.exports["getHydrationFailureOperationalEvent"] = $dab54f7f733e6dc2$export$260985b5e8a6fce6;

});

parcelRegister("7fw2E", function(module, exports) {

var $6VdZc = parcelRequire("6VdZc");

const $4bc3b2e76c18c48c$export$94f26401757ac8e7 = (metric)=>{
    let params;
    try {
        if ((0, $6VdZc.isInitial)()) {
            if (metric) {
                const data = metric.getData?.();
                const start = data?.start || 0;
                const stop = data?.stop || 0;
                params = [
                    {
                        duration: stop - start,
                        end: 'browser-metric.end'
                    }
                ];
            } else params = [
                undefined,
                'browser-metric.end'
            ];
        } else params = [
            'browser-metric.start',
            'browser-metric.end'
        ];
        performance.mark('browser-metric.end');
        performance.measure('browser-metric:tti', ...params);
    } catch (e) {
    // Suppress error when performance API failed.
    // Note: in MicrosoftEdge version 18 and prior, performance.measure(name, startMark, endMark) API will throw SyntaxError if startMark is undefined.
    // That's why wrap with try catch statement.
    }
};
module.exports["markBrowserMetricEnd"] = $4bc3b2e76c18c48c$export$94f26401757ac8e7;

});

parcelRegister("dmHCt", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

var $1UCmC = parcelRequire("1UCmC");

const $39eddf90ec2ee1a9$export$a92a425cb9f9c4ac = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.ADVANCED_SEARCH_LOAD_KEY)
});
const $39eddf90ec2ee1a9$export$8c056601d31b4cd5 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY)
});
const $39eddf90ec2ee1a9$export$db955b49fff67969 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY)
});
const $39eddf90ec2ee1a9$export$c9bd41426c856cf1 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY)
});
const $39eddf90ec2ee1a9$export$b390264dd924c8b1 = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.UNIFIED_SEARCH_LOAD_KEY)
});
module.exports["ADVANCED_SEARCH_PAGE_LOAD"] = $39eddf90ec2ee1a9$export$a92a425cb9f9c4ac;
module.exports["ADVANCED_SEARCH_COMPONENT_PAGE_SEGMENT_LOAD"] = $39eddf90ec2ee1a9$export$8c056601d31b4cd5;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_PAGE_SEGMENT_LOAD"] = $39eddf90ec2ee1a9$export$db955b49fff67969;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_PAGE_SEGMENT_LOAD"] = $39eddf90ec2ee1a9$export$c9bd41426c856cf1;
module.exports["UNIFIED_SEARCH_PAGE_LOAD"] = $39eddf90ec2ee1a9$export$b390264dd924c8b1;

});

parcelRegister("lSOAM", function(module, exports) {
$parcel$export(module.exports, "createPageLoadMetric", () => $2a47a9fc48674e91$export$c5aa7fcaede4a84d);
$parcel$export(module.exports, "createCustomMetric", () => $2a47a9fc48674e91$export$19ba7be4fcf34f3d);
$parcel$export(module.exports, "createInteractionMetric", () => $2a47a9fc48674e91$export$36d7a61d0660e29c);
$parcel$export(module.exports, "createPageSegmentLoadMetric", () => $2a47a9fc48674e91$export$34f706592a2f7442);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $3kTfj = parcelRequire("3kTfj");

var $kyiqo = parcelRequire("kyiqo");


var $64KID = parcelRequire("64KID");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    (0, $64KID.namedRoutes).HOME.name,
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $3kTfj.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const { pageLoad: $2a47a9fc48674e91$export$c5aa7fcaede4a84d, custom: $2a47a9fc48674e91$export$19ba7be4fcf34f3d, interaction: $2a47a9fc48674e91$export$36d7a61d0660e29c, pageSegmentLoad: $2a47a9fc48674e91$export$34f706592a2f7442, concurrent: $2a47a9fc48674e91$var$concurrent } = (0, $kyiqo.metrics);
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["isBMPageLoad"] = $2a47a9fc48674e91$export$9dede01b6f349441;
module.exports["hasBMPageLoadStarted"] = $2a47a9fc48674e91$export$cb339d0cd5cc821c;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("kyiqo", function(module, exports) {

var $bCz2F = parcelRequire("bCz2F");


var $bs5rD = parcelRequire("bs5rD");

const $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54 = {
    pageLoad: $bs5rD.pageLoad,
    pageSegmentLoad: $bs5rD.pageSegmentLoad,
    interaction: $bs5rD.interaction,
    custom: $bs5rD.custom,
    concurrent: $bCz2F.concurrent
};
module.exports["metrics"] = $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54;

});

parcelRegister("bCz2F", function(module, exports) {

var $j4jXg = parcelRequire("j4jXg");


var $bs5rD = parcelRequire("bs5rD");

const $bbc3e125622b0c90$var$concurrentMetrics = {};
const $bbc3e125622b0c90$var$getKey = (config, type)=>`${type}--${config.key}`;
const $bbc3e125622b0c90$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $bbc3e125622b0c90$var$ensurePath = (config, type)=>{
    const key = $bbc3e125622b0c90$var$getKey(config, type);
    if (!(key in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[key] = {};
};
const $bbc3e125622b0c90$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $bbc3e125622b0c90$var$getKey(config, type);
    if (concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics && $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $bbc3e125622b0c90$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $bbc3e125622b0c90$var$validateConfig(config);
    $bbc3e125622b0c90$var$ensurePath(config, type);
    const metricFromCache = $bbc3e125622b0c90$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $j4jXg.BMEventsType).INLINE_RESULT ? (0, $bs5rD.interaction) : (0, $bs5rD.custom);
    const metric = metricFactory(config);
    $bbc3e125622b0c90$var$concurrentMetrics[$bbc3e125622b0c90$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $bbc3e125622b0c90$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).CUSTOM)
};
module.exports["concurrent"] = $bbc3e125622b0c90$export$370df09ecc3de059;

});

parcelRegister("bs5rD", function(module, exports) {

var $iuio5 = parcelRequire("iuio5");


var $boXf9 = parcelRequire("boXf9");


var $giQku = parcelRequire("giQku");


var $j4jXg = parcelRequire("j4jXg");

const $d0aae4122f29b5ae$export$791d520f7e8058a5 = (config)=>{
    return new (0, $boXf9.PageLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_LOAD
    });
};
const $d0aae4122f29b5ae$export$94114666844d5f66 = (config)=>{
    return new (0, $giQku.PageSegmentLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $d0aae4122f29b5ae$export$92473e6020ad89b4 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).INLINE_RESULT
    });
};
const $d0aae4122f29b5ae$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).CUSTOM
    });
};
module.exports["pageLoad"] = $d0aae4122f29b5ae$export$791d520f7e8058a5;
module.exports["pageSegmentLoad"] = $d0aae4122f29b5ae$export$94114666844d5f66;
module.exports["interaction"] = $d0aae4122f29b5ae$export$92473e6020ad89b4;
module.exports["custom"] = $d0aae4122f29b5ae$export$4c00f665f0d4b443;

});

parcelRegister("iuio5", function(module, exports) {

var $lH7GJ = parcelRequire("lH7GJ");


var $11Zqj = parcelRequire("11Zqj");


var $4k3LC = parcelRequire("4k3LC");

class $6456fd2c244bded5$export$efdd3e096bc27746 extends (0, $4k3LC.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $lH7GJ.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $11Zqj.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}
module.exports["Metric"] = $6456fd2c244bded5$export$efdd3e096bc27746;

});

parcelRegister("boXf9", function(module, exports) {

var $h6RR2 = parcelRequire("h6RR2");


var $7RgFv = parcelRequire("7RgFv");


var $lH7GJ = parcelRequire("lH7GJ");


var $11Zqj = parcelRequire("11Zqj");


var $j4jXg = parcelRequire("j4jXg");


var $3znwT = parcelRequire("3znwT");


var $69Zr8 = parcelRequire("69Zr8");


var $e9ZCR = parcelRequire("e9ZCR");

class $b4ce8d24635e776a$export$3c51073271a9eac3 extends (0, $3znwT.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $69Zr8.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $69Zr8.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $3znwT.BasePageLoadMetric).FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $69Zr8.pageLoadMetaMetric).markFMP(mark);
            } else (0, $69Zr8.pageLoadMetaMetric).markFMP(this.marks[(0, $3znwT.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $lH7GJ.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $11Zqj.submitter).queue(data);
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $69Zr8.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $69Zr8.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $11Zqj.submitter).config.configChunk;
        if (!configChunk?.[(0, $j4jXg.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $e9ZCR.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $11Zqj.submitter).queue(webVitalMetric.getData());
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}
module.exports["PageLoadMetric"] = $b4ce8d24635e776a$export$3c51073271a9eac3;

});

parcelRegister("e9ZCR", function(module, exports) {

var $j4jXg = parcelRequire("j4jXg");


var $4k3LC = parcelRequire("4k3LC");

class $fd3d2d441d340510$export$dc0d85d4d6503cd7 extends (0, $4k3LC.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $j4jXg.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $4k3LC.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}
module.exports["WebVitalsMetric"] = $fd3d2d441d340510$export$dc0d85d4d6503cd7;

});

parcelRegister("giQku", function(module, exports) {

var $h6RR2 = parcelRequire("h6RR2");


var $j4jXg = parcelRequire("j4jXg");


var $4k3LC = parcelRequire("4k3LC");


var $iuio5 = parcelRequire("iuio5");


var $69Zr8 = parcelRequire("69Zr8");

class $4f83d9bff0211700$export$24c8bfcd77494cc1 extends (0, $iuio5.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $4f83d9bff0211700$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($4f83d9bff0211700$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $j4jXg.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $4k3LC.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $4k3LC.MetricState).STARTED) (0, $69Zr8.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP = 'fmp';
module.exports["PageSegmentLoadMetric"] = $4f83d9bff0211700$export$24c8bfcd77494cc1;

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("3YpC9", function(module, exports) {
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';
module.exports["PAGE_SEGMENT_MARK_PREFIX_START"] = $4dbe182ee19642b3$export$f59b3ea823fcdb3d;
module.exports["PAGE_SEGMENT_MARK_PREFIX_END"] = $4dbe182ee19642b3$export$a217b163593f51a;

});

parcelRegister("jX1qB", function(module, exports) {
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$7416ef7ed24ec47f = 'media';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$fdd1a35fb559480a = 'recap-modal';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';
const $fa0ea3428ec5aa62$export$b64d520f9b37dcd7 = 'comments-panel-open-view';
const $fa0ea3428ec5aa62$export$50553e47471a0f5e = 'comments-panel-unread-view';
const $fa0ea3428ec5aa62$export$40d92ab0c1cc5298 = 'comments-panel-deleted-content-view';
const $fa0ea3428ec5aa62$export$f2a6407ac901fd8d = 'comments-panel-resolved-view';
module.exports["APP_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$9e40500efe28ac9e;
module.exports["BLOG_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$38b273cdbbf56c26;
module.exports["BYLINE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1ac23cd5807df863;
module.exports["READ_TIME_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$5bbb36bee09a5671;
module.exports["CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$a79607497a4a710c;
module.exports["CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c56a99673f1bb7bb;
module.exports["CONTENT_RENDERER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$140a493a9e781fe2;
module.exports["CONTENT_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1285ccb0399c01;
module.exports["FAVOURITE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$eb5bb54418693284;
module.exports["FOCUSED_INLINE_COMMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3fde425dbc74423b;
module.exports["INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6a58cce6529da40e;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$8910bc840e3ee4ce;
module.exports["RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf572571ca036b67;
module.exports["EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$644778267d4a4a82;
module.exports["MEDIA_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7416ef7ed24ec47f;
module.exports["PAGE_COMMENTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e4ff10a0a39a7217;
module.exports["PAGE_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6648c9be174e6923;
module.exports["FEED_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d3d6144128aaee3;
module.exports["PAGE_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499;
module.exports["RESTRICTIONS_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d1dfca9e0eb45581;
module.exports["GLOBAL_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$312db7b759bad970;
module.exports["SPACE_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$cf2a6bf49e73b304;
module.exports["SPACE_APPS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$84f6b5717c3fb962;
module.exports["WATCH_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1a423f2548c46be3;
module.exports["HOME_OVERVIEW_RECENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6426c6941656619;
module.exports["HOME_OVERVIEW_FEED_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$14f30a91623dfcf3;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c6926beb57b60636;
module.exports["HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$687913e127f52cc3;
module.exports["HOME_RECENTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0;
module.exports["HOME_STARRED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$76243e8aa4afaa0b;
module.exports["HOME_DRAFTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1df6f3f29083f48;
module.exports["END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7b32848c9413526a;
module.exports["IN_EDITOR_TEMPLATES_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$58fbb0ba50341103;
module.exports["NCS_CONNECTED_FMP_KEY"] = $fa0ea3428ec5aa62$export$4f481f063369df3c;
module.exports["ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1b9793e009e605;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$90bda069d4bf981b;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f11e1d4269141c0e;
module.exports["DATABASE_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$f0298cbab4a44998;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$cf2f52fec740bdea;
module.exports["OBJECT_HEADER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$52050233077a1838;
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1ab333f0b70b317;
module.exports["WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4;
module.exports["DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b95bd4bfc46932fc;
module.exports["SHARE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf838b84ba2f7b95;
module.exports["VIEW_PAGE_LABELS_METRIC_KEY"] = $fa0ea3428ec5aa62$export$79910402df6be117;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d86af34f7dc194b4;
module.exports["CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb;
module.exports["SPACE_PERMISSIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1939caa7fae28ef5;
module.exports["VIEW_PAGE_CONTAINER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3f06ee123a5ad183;
module.exports["EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$37da6122cd60d332;
module.exports["EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3437c1f145cfce19;
module.exports["EDITOR_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7903037283afbce0;
module.exports["RECAP_MODAL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$fdd1a35fb559480a;
module.exports["OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$31d10d7597db11d3;
module.exports["COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b64d520f9b37dcd7;
module.exports["COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$50553e47471a0f5e;
module.exports["COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$40d92ab0c1cc5298;
module.exports["COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f2a6407ac901fd8d;

});

parcelRegister("1UCmC", function(module, exports) {
const $00aca2e58bbddd9e$export$9ee3c9e81070f140 = 'admin-announcement-banner-setting-page';
const $00aca2e58bbddd9e$export$162462d8f302c50a = 'advanced-search';
const $00aca2e58bbddd9e$export$17e011598d6a739d = 'unified-search';
const $00aca2e58bbddd9e$export$a88513891a2ab6b7 = 'confluence-home';
const $00aca2e58bbddd9e$export$5614199f62986e3b = 'all-drafts';
const $00aca2e58bbddd9e$export$3bbaa81ece500746 = 'recent-pages';
const $00aca2e58bbddd9e$export$b634edee624f5dc2 = 'starred-pages';
const $00aca2e58bbddd9e$export$5946c48030569b81 = 'content-history';
const $00aca2e58bbddd9e$export$1eefb862c6c6ce00 = 'edit-page';
const $00aca2e58bbddd9e$export$e164999ba8681ff6 = 'edit-template';
const $00aca2e58bbddd9e$export$6cdf3f4614ddd679 = 'edit-template-old';
const $00aca2e58bbddd9e$export$8faa34d8ba45e128 = 'embedded-view-page';
const $00aca2e58bbddd9e$export$3fb3338cf2b36704 = 'embedded-edit-page';
const $00aca2e58bbddd9e$export$779fbc1a16a8cb5d = 'global-permissions';
const $00aca2e58bbddd9e$export$9d8c586f3355f180 = 'inaccessible-page';
const $00aca2e58bbddd9e$export$a0c73183bde575ec = 'not-found';
const $00aca2e58bbddd9e$export$6d480c75094dbd7f = 'space-directory';
const $00aca2e58bbddd9e$export$8d0f9920174f22b4 = 'space-overview';
const $00aca2e58bbddd9e$export$228f2841a225e5ad = 'space-pages';
const $00aca2e58bbddd9e$export$fe4f0edc4d6532a8 = 'tasks-home';
const $00aca2e58bbddd9e$export$cc53520b570e0a46 = 'content-manager';
const $00aca2e58bbddd9e$export$bdc26b2b517231a = 'space-manager';
const $00aca2e58bbddd9e$export$b6d237d1e8f12e5d = 'template-gallery';
const $00aca2e58bbddd9e$export$a715ad00b824ec3f = 'view-page';
const $00aca2e58bbddd9e$export$132f38e0c19c02b6 = 'embedded-marketplace';
const $00aca2e58bbddd9e$export$d2dddf4422ad7ae8 = 'create-content';
const $00aca2e58bbddd9e$export$9c7a9f4f853f6fba = 'public-link-shared-page';
const $00aca2e58bbddd9e$export$643b9c181748da38 = 'public-link-site-setting-page';
const $00aca2e58bbddd9e$export$4716363caa82a23b = 'public-links-space-settings-page';
const $00aca2e58bbddd9e$export$75726af5c0ee9402 = 'whiteboard-view-page';
const $00aca2e58bbddd9e$export$afe76b61b3f9aaa8 = 'database-view-page';
const $00aca2e58bbddd9e$export$dd63a13fc6c1ba34 = 'embed-view-page';
const $00aca2e58bbddd9e$export$16aeb03ec0c24b89 = 'live-page';
const $00aca2e58bbddd9e$export$ce4e0f6f3d614d45 = 'live-edit';
const $00aca2e58bbddd9e$export$ecea02b4eaa314f3 = 'team-calendars';
const $00aca2e58bbddd9e$export$726cbfa087a55101 = 'admin-team-calendars';
const $00aca2e58bbddd9e$export$2f245ed7ebaea89 = 'admin-general-configuration';
const $00aca2e58bbddd9e$export$2af60fefae96902b = 'admin-configure-code-macro';
const $00aca2e58bbddd9e$export$fbea00ed02ef2502 = 'admin-default-space-logo-config';
const $00aca2e58bbddd9e$export$6e9c07174668ae36 = 'admin-header-and-footer';
const $00aca2e58bbddd9e$export$51fdddeccf175d74 = 'admin-security-configuration';
const $00aca2e58bbddd9e$export$2d0370cc7d14b72e = 'admin-templates-and-blueprints';
const $00aca2e58bbddd9e$export$a8d02dbd84c83dd = 'admin-import-spaces';
const $00aca2e58bbddd9e$export$1d91ea2ef976728a = 'admin-trashed-spaces';
const $00aca2e58bbddd9e$export$a13bfc71dc6b7924 = 'admin-application-navigator';
const $00aca2e58bbddd9e$export$3ba6335cd90d2e59 = 'admin-themes';
const $00aca2e58bbddd9e$export$cb4b6b707a32ee92 = 'admin-jira-macro-repair';
const $00aca2e58bbddd9e$export$5cb6689cb672a5c0 = 'admin-pdf-export';
const $00aca2e58bbddd9e$export$fff7d33fb1514c44 = 'admin-macro-usage';
const $00aca2e58bbddd9e$export$d4aa60a3ffc18652 = 'admin-user-access';
const $00aca2e58bbddd9e$export$52c0c13179848b50 = 'CONTENT_ANALYTICS';
const $00aca2e58bbddd9e$export$40dab65f060e1231 = 'SPACE_ANALYTICS';
const $00aca2e58bbddd9e$export$b682ed6d6fa429fb = 'INSTANCE_ANALYTICS';
const $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1 = 'space-details';
const $00aca2e58bbddd9e$export$2633c6986b98b723 = 'pdf-export-route';
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9ee3c9e81070f140;
module.exports["ADVANCED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$162462d8f302c50a;
module.exports["UNIFIED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$17e011598d6a739d;
module.exports["CONFLUENCE_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$a88513891a2ab6b7;
module.exports["CONFLUENCE_DRAFTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$5614199f62986e3b;
module.exports["CONFLUENCE_RECENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$3bbaa81ece500746;
module.exports["CONFLUENCE_STARRED_LOAD_KEY"] = $00aca2e58bbddd9e$export$b634edee624f5dc2;
module.exports["CONTENT_HISTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$5946c48030569b81;
module.exports["EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$1eefb862c6c6ce00;
module.exports["EDIT_TEMPLATE_LOAD_KEY"] = $00aca2e58bbddd9e$export$e164999ba8681ff6;
module.exports["EDIT_TEMPLATE_OLD_LOAD_KEY"] = $00aca2e58bbddd9e$export$6cdf3f4614ddd679;
module.exports["EMBEDDED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$8faa34d8ba45e128;
module.exports["EMBEDDED_EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$3fb3338cf2b36704;
module.exports["GLOBAL_PERMISSIONS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$779fbc1a16a8cb5d;
module.exports["INACCESSIBLE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9d8c586f3355f180;
module.exports["NOT_FOUND_LOAD_KEY"] = $00aca2e58bbddd9e$export$a0c73183bde575ec;
module.exports["SPACE_DIRECTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$6d480c75094dbd7f;
module.exports["SPACE_OVERVIEW_LOAD_KEY"] = $00aca2e58bbddd9e$export$8d0f9920174f22b4;
module.exports["SPACE_PAGES_LOAD_KEY"] = $00aca2e58bbddd9e$export$228f2841a225e5ad;
module.exports["TASKS_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$fe4f0edc4d6532a8;
module.exports["CONTENT_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$cc53520b570e0a46;
module.exports["SPACE_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$bdc26b2b517231a;
module.exports["TEMPLATE_GALLERY_LOAD_KEY"] = $00aca2e58bbddd9e$export$b6d237d1e8f12e5d;
module.exports["VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$a715ad00b824ec3f;
module.exports["EMBEDDED_MARKETPLACE_LOAD_KEY"] = $00aca2e58bbddd9e$export$132f38e0c19c02b6;
module.exports["CREATE_CONTENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$d2dddf4422ad7ae8;
module.exports["PUBLIC_LINK_SHARED_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9c7a9f4f853f6fba;
module.exports["PUBLIC_LINK_SITE_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$643b9c181748da38;
module.exports["PUBLIC_LINKS_SPACE_SETTINGS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$4716363caa82a23b;
module.exports["WHITEBOARD_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$75726af5c0ee9402;
module.exports["DATABASE_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$afe76b61b3f9aaa8;
module.exports["EMBED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$dd63a13fc6c1ba34;
module.exports["LIVE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$16aeb03ec0c24b89;
module.exports["LIVE_PAGE_REACT_UFO_LOAD_KEY"] = $00aca2e58bbddd9e$export$ce4e0f6f3d614d45;
module.exports["TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$ecea02b4eaa314f3;
module.exports["ADMIN_TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$726cbfa087a55101;
module.exports["ADMIN_GENERAL_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$2f245ed7ebaea89;
module.exports["ADMIN_CONFIGURE_CODE_MACRO_LOAD_KEY"] = $00aca2e58bbddd9e$export$2af60fefae96902b;
module.exports["ADMIN_DEFAULT_SPACE_LOGO_CONFIG_LOAD_KEY"] = $00aca2e58bbddd9e$export$fbea00ed02ef2502;
module.exports["ADMIN_HEADER_AND_FOOTER_LOAD_KEY"] = $00aca2e58bbddd9e$export$6e9c07174668ae36;
module.exports["ADMIN_SECURITY_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$51fdddeccf175d74;
module.exports["ADMIN_TEMPLATES_AND_BLUEPRINTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$2d0370cc7d14b72e;
module.exports["ADMIN_IMPORT_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$a8d02dbd84c83dd;
module.exports["ADMIN_TRASHED_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$1d91ea2ef976728a;
module.exports["ADMIN_APPLICATION_NAVIGATOR_KEY"] = $00aca2e58bbddd9e$export$a13bfc71dc6b7924;
module.exports["ADMIN_THEMES_LOAD_KEY"] = $00aca2e58bbddd9e$export$3ba6335cd90d2e59;
module.exports["ADMIN_JIRA_MACRO_REPAIR_LOAD_KEY"] = $00aca2e58bbddd9e$export$cb4b6b707a32ee92;
module.exports["ADMIN_PDF_EXPORT_LOAD_KEY"] = $00aca2e58bbddd9e$export$5cb6689cb672a5c0;
module.exports["ADMIN_MACRO_USAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$fff7d33fb1514c44;
module.exports["ADMIN_USER_ACCESS_KEY"] = $00aca2e58bbddd9e$export$d4aa60a3ffc18652;
module.exports["PAGE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$52c0c13179848b50;
module.exports["SPACE_ANALYTICS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$40dab65f060e1231;
module.exports["SITE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$b682ed6d6fa429fb;
module.exports["SPACE_DETAILS_LOAD_KEY"] = $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1;
module.exports["PDF_EXPORT_ROUTE_LOAD_KEY"] = $00aca2e58bbddd9e$export$2633c6986b98b723;

});

parcelRegister("7hGsm", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $54db0de22feedc16$export$99d02219d259eb94);
$parcel$export(module.exports, "Transports", () => (parcelRequire("2UWw0")));

var $hXuPC = parcelRequire("hXuPC");


var $iIf3l = parcelRequire("iIf3l");


var $a5jIU = parcelRequire("a5jIU");


var $fkDf0 = parcelRequire("fkDf0");


var $6yHbi = parcelRequire("6yHbi");


var $2UWw0 = parcelRequire("2UWw0");

var $54db0de22feedc16$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $54db0de22feedc16$var$_window = (0, $fkDf0.getGlobalObject)();
if ($54db0de22feedc16$var$_window.Sentry && $54db0de22feedc16$var$_window.Sentry.Integrations) $54db0de22feedc16$var$windowIntegrations = $54db0de22feedc16$var$_window.Sentry.Integrations;
var $54db0de22feedc16$export$99d02219d259eb94 = (0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, $54db0de22feedc16$var$windowIntegrations), (0, $a5jIU)), $6yHbi);
$parcel$exportWildcard(module.exports, $iIf3l);

});

parcelRegister("iIf3l", function(module, exports) {
$parcel$export(module.exports, "Severity", () => (parcelRequire("cs0rL")).Severity);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("euURg")).addGlobalEventProcessor);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("805AA")).addBreadcrumb);
$parcel$export(module.exports, "captureException", () => (parcelRequire("805AA")).captureException);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("805AA")).captureEvent);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("805AA")).captureMessage);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("805AA")).configureScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("k3i2h")).getHubFromCarrier);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("k3i2h")).getCurrentHub);
$parcel$export(module.exports, "Hub", () => (parcelRequire("k3i2h")).Hub);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("k3i2h")).makeMain);
$parcel$export(module.exports, "Scope", () => (parcelRequire("euURg")).Scope);
$parcel$export(module.exports, "Session", () => (parcelRequire("cSJat")).Session);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("805AA")).startTransaction);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("cTFwF")).SDK_VERSION);
$parcel$export(module.exports, "setContext", () => (parcelRequire("805AA")).setContext);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("805AA")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("805AA")).setExtras);
$parcel$export(module.exports, "setTag", () => (parcelRequire("805AA")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("805AA")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("805AA")).setUser);
$parcel$export(module.exports, "withScope", () => (parcelRequire("805AA")).withScope);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("cW7ac")).BrowserClient);
$parcel$export(module.exports, "injectReportDialog", () => (parcelRequire("1cvC0")).injectReportDialog);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("a7P2i")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("a7P2i")).eventFromMessage);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("ffG6S")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("ffG6S")).forceLoad);
$parcel$export(module.exports, "init", () => (parcelRequire("ffG6S")).init);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("ffG6S")).lastEventId);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("ffG6S")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("ffG6S")).showReportDialog);
$parcel$export(module.exports, "flush", () => (parcelRequire("ffG6S")).flush);
$parcel$export(module.exports, "close", () => (parcelRequire("ffG6S")).close);
$parcel$export(module.exports, "wrap", () => (parcelRequire("ffG6S")).wrap);
$parcel$export(module.exports, "SDK_NAME", () => (parcelRequire("brq4Q")).SDK_NAME);

var $cs0rL = parcelRequire("cs0rL");


var $805AA = parcelRequire("805AA");

var $euURg = parcelRequire("euURg");

var $k3i2h = parcelRequire("k3i2h");

var $cTFwF = parcelRequire("cTFwF");

var $cSJat = parcelRequire("cSJat");


var $cW7ac = parcelRequire("cW7ac");


var $1cvC0 = parcelRequire("1cvC0");


var $a7P2i = parcelRequire("a7P2i");


var $ffG6S = parcelRequire("ffG6S");


var $brq4Q = parcelRequire("brq4Q");


});

parcelRegister("brq4Q", function(module, exports) {
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var $854671b7fcc6622a$export$ca61d37259221480 = 'sentry.javascript.browser';
module.exports["SDK_NAME"] = $854671b7fcc6622a$export$ca61d37259221480;

});

parcelRegister("6yHbi", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("3BsQh")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("lIIKi")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("bISXm")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("63fUW")).LinkedErrors);
$parcel$export(module.exports, "UserAgent", () => (parcelRequire("eLUbA")).UserAgent);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("fCIwr")).Dedupe);

var $3BsQh = parcelRequire("3BsQh");


var $lIIKi = parcelRequire("lIIKi");


var $bISXm = parcelRequire("bISXm");


var $63fUW = parcelRequire("63fUW");


var $eLUbA = parcelRequire("eLUbA");


var $fCIwr = parcelRequire("fCIwr");


});

parcelRegister("2UWw0", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => (parcelRequire("1l2dO")).BaseTransport);
$parcel$export(module.exports, "FetchTransport", () => (parcelRequire("8LVWj")).FetchTransport);
$parcel$export(module.exports, "XHRTransport", () => (parcelRequire("2yXKF")).XHRTransport);
$parcel$export(module.exports, "makeNewFetchTransport", () => (parcelRequire("hB2rb")).makeNewFetchTransport);
$parcel$export(module.exports, "makeNewXHRTransport", () => (parcelRequire("lgAM0")).makeNewXHRTransport);

var $1l2dO = parcelRequire("1l2dO");


var $8LVWj = parcelRequire("8LVWj");


var $2yXKF = parcelRequire("2yXKF");


var $hB2rb = parcelRequire("hB2rb");


var $lgAM0 = parcelRequire("lgAM0");


});

parcelRegister("hQNhB", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $cfed858cac4ecf38$var$noop() {
// No operation performed.
}
module.exports = $cfed858cac4ecf38$var$noop;

});

parcelRegister("6i41U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8x1Q3 = parcelRequire("8x1Q3");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $77954d5459a690cb$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $77954d5459a690cb$export$2e2bcd8739ae039 = $77954d5459a690cb$var$useRouterLink;
module.exports["default"] = $77954d5459a690cb$export$2e2bcd8739ae039;

});

parcelRegister("8x1Q3", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $830764d8fffe9f5a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $42omo.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $830764d8fffe9f5a$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $830764d8fffe9f5a$export$2e2bcd8739ae039 = $830764d8fffe9f5a$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $830764d8fffe9f5a$export$2931e0ee690eee88;
module.exports["default"] = $830764d8fffe9f5a$export$2e2bcd8739ae039;

});

parcelRegister("eWRwJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca4f3d8c1426d3d8$export$2e2bcd8739ae039);
var $ca4f3d8c1426d3d8$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("gHaxX", function(module, exports) {

var $973aB = parcelRequire("973aB");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/identity/user/manifest.ts
var $c278d7dccfa97a86$var$identityUserAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $973aB.IdentityUserAriResourceOwner),
    resourceType: (0, $973aB.IdentityUserAriResourceType),
    resourceIdSlug: "{userId}",
    resourceIdSegmentFormats: {
        userId: /[a-zA-Z0-9_\-\:]{1,128}/
    }
};
// src/identity/user/index.ts
var $c278d7dccfa97a86$export$1e9d09c2be53e55e = class _IdentityUserAri extends (0, $3NXcb.RegisteredAri) {
    get userId() {
        return this._userId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $c278d7dccfa97a86$var$identityUserAriStaticOpts.qualifier,
            platformQualifier: $c278d7dccfa97a86$var$identityUserAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $c278d7dccfa97a86$var$identityUserAriStaticOpts.resourceOwner,
            resourceType: $c278d7dccfa97a86$var$identityUserAriStaticOpts.resourceType,
            resourceId: `${opts.userId}`,
            resourceIdSegmentValues: {
                userId: opts.userId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $c278d7dccfa97a86$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $c278d7dccfa97a86$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(opts);
    }
    getVariables() {
        return {
            userId: this.userId
        };
    }
    constructor(opts){
        super(opts), this._userId = opts.resourceIdSegmentValues.userId;
    }
};
module.exports["IdentityUserAri"] = $c278d7dccfa97a86$export$1e9d09c2be53e55e;

});

parcelRegister("973aB", function(module, exports) {
// src/identity/user/types.ts
var $6a2739fa6e7a2528$export$b4c14c54282a779d = "identity", $6a2739fa6e7a2528$export$e9b50e20f4fbfb71 = "user";
module.exports["IdentityUserAriResourceOwner"] = $6a2739fa6e7a2528$export$b4c14c54282a779d;
module.exports["IdentityUserAriResourceType"] = $6a2739fa6e7a2528$export$e9b50e20f4fbfb71;

});

parcelRegister("6a9Hv", function(module, exports) {

var $hWvFC = parcelRequire("hWvFC");


var $ghltV = parcelRequire("ghltV");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $47cb339bef10f9e0$var$uniqBy(array, iteratee) {
    return array && array.length ? $ghltV(array, $hWvFC(iteratee, 2)) : [];
}
module.exports = $47cb339bef10f9e0$var$uniqBy;

});

parcelRegister("ghltV", function(module, exports) {

var $jcOUW = parcelRequire("jcOUW");


var $7LQYo = parcelRequire("7LQYo");


var $lkNSx = parcelRequire("lkNSx");


var $bcPN2 = parcelRequire("bcPN2");


var $eSSFf = parcelRequire("eSSFf");


var $fTWVK = parcelRequire("fTWVK");

/** Used as the size to enable large array optimizations. */ var $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $bd9ee5aa9be27a90$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $7LQYo, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $lkNSx;
    } else if (length >= $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $eSSFf(array);
        if (set) return $fTWVK(set);
        isCommon = false;
        includes = $bcPN2;
        seen = new $jcOUW;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $bd9ee5aa9be27a90$var$baseUniq;

});

parcelRegister("7LQYo", function(module, exports) {

var $gbGQI = parcelRequire("gbGQI");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $5a8603892d8b8e7a$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $gbGQI(array, value, 0) > -1;
}
module.exports = $5a8603892d8b8e7a$var$arrayIncludes;

});

parcelRegister("gbGQI", function(module, exports) {

var $kQ62s = parcelRequire("kQ62s");


var $4iBhD = parcelRequire("4iBhD");


var $9vdTF = parcelRequire("9vdTF");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bc8ee968e98dba2a$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $9vdTF(array, value, fromIndex) : $kQ62s(array, $4iBhD, fromIndex);
}
module.exports = $bc8ee968e98dba2a$var$baseIndexOf;

});

parcelRegister("kQ62s", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f2bd591dc7dccf33$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $f2bd591dc7dccf33$var$baseFindIndex;

});

parcelRegister("4iBhD", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $3215c39807e7891a$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $3215c39807e7891a$var$baseIsNaN;

});

parcelRegister("9vdTF", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6eb1c9efc79a544d$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $6eb1c9efc79a544d$var$strictIndexOf;

});

parcelRegister("lkNSx", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $f882281822db2c99$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $f882281822db2c99$var$arrayIncludesWith;

});

parcelRegister("eSSFf", function(module, exports) {

var $l57m2 = parcelRequire("l57m2");


var $hQNhB = parcelRequire("hQNhB");


var $fTWVK = parcelRequire("fTWVK");

/** Used as references for various `Number` constants. */ var $ad608304180e5c8a$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $ad608304180e5c8a$var$createSet = !($l57m2 && 1 / $fTWVK(new $l57m2([
    ,
    -0
]))[1] == $ad608304180e5c8a$var$INFINITY) ? $hQNhB : function(values) {
    return new $l57m2(values);
};
module.exports = $ad608304180e5c8a$var$createSet;

});

parcelRegister("lAJUP", function(module, exports) {

var $42omo = parcelRequire("42omo");

'use client';
const $fb8093ab2fb0a0e7$export$b16d9fb1a22de840 = (0, $42omo.createContext)(null);
const $fb8093ab2fb0a0e7$var$initialState = {
    didCatch: false,
    error: null
};
class $fb8093ab2fb0a0e7$export$e926676385687eaf extends (0, $42omo.Component) {
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($fb8093ab2fb0a0e7$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $fb8093ab2fb0a0e7$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($fb8093ab2fb0a0e7$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $42omo.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $42omo.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $42omo.createElement)($fb8093ab2fb0a0e7$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $fb8093ab2fb0a0e7$var$initialState;
    }
}
function $fb8093ab2fb0a0e7$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $fb8093ab2fb0a0e7$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $fb8093ab2fb0a0e7$export$c052f6604b7d51fe() {
    const context = (0, $42omo.useContext)($fb8093ab2fb0a0e7$export$b16d9fb1a22de840);
    $fb8093ab2fb0a0e7$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $42omo.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $42omo.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $fb8093ab2fb0a0e7$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $42omo.forwardRef)((props, ref)=>(0, $42omo.createElement)($fb8093ab2fb0a0e7$export$e926676385687eaf, errorBoundaryProps, (0, $42omo.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}
module.exports["ErrorBoundary"] = $fb8093ab2fb0a0e7$export$e926676385687eaf;
module.exports["withErrorBoundary"] = $fb8093ab2fb0a0e7$export$f0c7a449e0cfaec7;

});

parcelRegister("4ayWZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0eaf91608b1fc1f9ea14632557d8241d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30933503c57ef329$var$_react = $30933503c57ef329$var$_interopRequireDefault((parcelRequire("42omo")));

var $30933503c57ef329$var$_baseNew = $30933503c57ef329$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $30933503c57ef329$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Dashboard".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for dashboards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $30933503c57ef329$var$DashboardIcon = (props)=>/*#__PURE__*/ $30933503c57ef329$var$_react.default.createElement($30933503c57ef329$var$_baseNew.default, Object.assign({
        name: "DashboardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h4.25v-11zm5.75 0v4.75h4.75V3a.5.5 0 0 0-.5-.5zm4.75 6.25H8.75v4.75H13a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$30933503c57ef329$var$DashboardIcon.displayName = 'DashboardIcon';
var $30933503c57ef329$var$_default = module.exports.default = $30933503c57ef329$var$DashboardIcon;

});

parcelRegister("3hoG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b38c95e6dd3d3e2d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $b38c95e6dd3d3e2d$export$2e2bcd8739ae039 = (0, $42omo.forwardRef);

});

parcelRegister("dlSEv", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b87a15bb5e36b12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $9b87a15bb5e36b12$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("fBMbo", function(module, exports) {

var $dNGPK = parcelRequire("dNGPK");


var $7qH1e = parcelRequire("7qH1e");

function $b5cfafc926496f98$export$479d1ccc5f2ab701(target, ...deps) {
    // Read context and grab all the dependencies override Providers in the tree
    const { getDependencies: getDependencies } = // grab value from alt renderer (eg react-test-renderer)
    (0, $dNGPK.Context)._currentRenderer2 && (0, $dNGPK.Context)._currentValue2 || // grab value from default renderer
    (0, $dNGPK.Context)._currentValue || (0, $7qH1e.globalDi);
    return getDependencies(deps, target);
}
module.exports["di"] = $b5cfafc926496f98$export$479d1ccc5f2ab701;

});

parcelRegister("dNGPK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7qH1e = parcelRequire("7qH1e");

const $a0c113d1cdcf525c$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    getDependencies: (0, $7qH1e.globalDi).getDependencies
});
module.exports["Context"] = $a0c113d1cdcf525c$export$841858b892ce1f4c;

});

parcelRegister("7qH1e", function(module, exports) {

var $ipvr6 = parcelRequire("ipvr6");


var $b1tX2 = parcelRequire("b1tX2");

const $568c54c2a75aa99b$var$replacementMap = new Map();
const $568c54c2a75aa99b$export$a775919ebd7dd28a = {
    getDependencies (realDeps, targetChild) {
        if ($568c54c2a75aa99b$var$replacementMap.size) for(let i = 0; i < realDeps.length; i++){
            const replacedInj = (0, $b1tX2.findInjectable)($568c54c2a75aa99b$var$replacementMap, realDeps[i], targetChild);
            if (replacedInj) realDeps[i] = replacedInj.value;
        }
        return realDeps;
    },
    use (injs) {
        if ($568c54c2a75aa99b$var$replacementMap.size) throw new Error(`${(0, $ipvr6.PACKAGE_NAME)} has replacements configured already. ` + `Implicit merging is not supported, so please concatenate injectables. ` + `If this is not expected, please file a bug report`);
        injs.forEach((inj)=>(0, $b1tX2.addInjectableToMap)($568c54c2a75aa99b$var$replacementMap, inj));
    },
    clear () {
        $568c54c2a75aa99b$var$replacementMap.clear();
    },
    _fromProvider (injs, props = {}) {
        injs.forEach((inj)=>{
            if (props.global || (0, $ipvr6.diRegistry).get(inj).global) (0, $b1tX2.addInjectableToMap)($568c54c2a75aa99b$var$replacementMap, inj);
        });
    },
    _remove (injs) {
        injs.forEach((inj)=>(0, $b1tX2.removeInjectableFromMap)($568c54c2a75aa99b$var$replacementMap, inj));
    }
};
function $568c54c2a75aa99b$export$b887ce09d70113f9(thunk, deps) {
    $568c54c2a75aa99b$export$a775919ebd7dd28a.use(deps);
    let result;
    try {
        result = thunk();
        return result;
    } finally{
        // autocleanup dependences if either async or sync
        if (result && typeof result === 'object' && typeof result.then === 'function' && typeof result.finally === 'function') result.finally($568c54c2a75aa99b$export$a775919ebd7dd28a.clear);
        else $568c54c2a75aa99b$export$a775919ebd7dd28a.clear();
    }
}
module.exports["globalDi"] = $568c54c2a75aa99b$export$a775919ebd7dd28a;

});

parcelRegister("ipvr6", function(module, exports) {
const $d672f259068efdcd$export$4203fb010fad9bf0 = new WeakMap();
const $d672f259068efdcd$export$b8b9d90f9e5bd72b = 'react-magnetic-di';
module.exports["diRegistry"] = $d672f259068efdcd$export$4203fb010fad9bf0;
module.exports["PACKAGE_NAME"] = $d672f259068efdcd$export$b8b9d90f9e5bd72b;

});

parcelRegister("b1tX2", function(module, exports) {

var $ipvr6 = parcelRequire("ipvr6");


var $aqxLC = parcelRequire("aqxLC");

let $80670563c880fcd1$var$hasWarned = false;
function $80670563c880fcd1$export$5b28268982f175ba(message) {
    if (!$80670563c880fcd1$var$hasWarned) {
        // eslint-disable-next-line no-console
        console.warn('Warning:', message);
        $80670563c880fcd1$var$hasWarned = true;
    }
}
function $80670563c880fcd1$export$7a7134bdd2f9ae2e(replacementMap, inj) {
    const injObj = (0, $ipvr6.diRegistry).get(inj);
    if (!injObj) throw new Error(`Seems like you are trying to use "${inj}" as injectable, but magnetic-di needs the return value of "injectable()"`);
    if (injObj.track) (0, $aqxLC.stats).set(injObj);
    if (replacementMap.has(injObj.from)) replacementMap.get(injObj.from).add(injObj);
    else replacementMap.set(injObj.from, new Set([
        injObj
    ]));
    return replacementMap;
}
function $80670563c880fcd1$export$8057a2244a849b7b(replacementMap, inj) {
    const injObj = (0, $ipvr6.diRegistry).get(inj);
    const injectables = replacementMap.get(injObj.from) || new Set();
    if (injectables.size === 1) replacementMap.delete(injObj.from);
    else injectables.delete(injObj);
}
function $80670563c880fcd1$export$be63e0664592e141(Comp, wrapper = '') {
    const name = Comp.displayName || Comp.name;
    return !name || !wrapper ? name : `${wrapper}(${name})`;
}
function $80670563c880fcd1$export$1c9f709888824e05(fn) {
    const source = fn.toString();
    const [, args] = source.match(/const \[[^\]]+\] = .*di.*\(\w+[,\s]+([^)]+)/) || [];
    return args;
}
function $80670563c880fcd1$export$7c436e151c3ee289(replacementMap, dep, targetChild) {
    const injectables = replacementMap.get(dep);
    if (!injectables) return null;
    // loop all injectables for the dep, with targeted ones preferred
    let anyCandidate = null;
    let targetCandidate = null;
    for (const inj of injectables){
        var _inj$targets;
        if (!inj.targets) anyCandidate = inj;
        if ((_inj$targets = inj.targets) != null && _inj$targets.has(targetChild)) targetCandidate = inj;
    }
    const candidate = targetCandidate || anyCandidate;
    (0, $aqxLC.stats).track(candidate);
    return candidate;
}
module.exports["addInjectableToMap"] = $80670563c880fcd1$export$7a7134bdd2f9ae2e;
module.exports["removeInjectableFromMap"] = $80670563c880fcd1$export$8057a2244a849b7b;
module.exports["findInjectable"] = $80670563c880fcd1$export$7c436e151c3ee289;

});

parcelRegister("aqxLC", function(module, exports) {
const $79768685dc5c2f62$var$createState = ()=>({
        unused: new Map(),
        used: new Set(),
        provided: new Set()
    });
const $79768685dc5c2f62$export$7804429c45dff272 = {
    state: $79768685dc5c2f62$var$createState(),
    set (injObj) {
        var _injObj$value;
        // allow injectable override without flagging as unused
        for (let unusedInj of this.state.unused.keys())if (unusedInj.from === injObj.from) this.state.unused.delete(unusedInj);
        this.state.unused.set(injObj, new Error(`Unused "di" injectable: ${((_injObj$value = injObj.value) == null ? void 0 : _injObj$value.displayName) || injObj.value}.`, {
            cause: injObj.cause
        }));
        // reset to avoid potential memory leaks via stack traces
        injObj.cause = null;
    },
    track (inj) {
        if (!inj) return;
        this.state.unused.delete(inj);
        this.state.used.add(inj);
        this.state.provided.add(inj.from);
    },
    reset () {
        this.state = $79768685dc5c2f62$var$createState();
    },
    unused () {
        return Array.from(this.state.unused.entries()).map(([inj, error])=>({
                get: ()=>inj.value,
                error: ()=>error
            }));
    }
};
module.exports["stats"] = $79768685dc5c2f62$export$7804429c45dff272;

});

parcelRegister("5mB97", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $3e7bd247c2a15a57$var$_react = $3e7bd247c2a15a57$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $3e7bd247c2a15a57$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3e7bd247c2a15a57$var$Document16Icon = (props)=>/*#__PURE__*/ $3e7bd247c2a15a57$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$3e7bd247c2a15a57$var$Document16Icon.displayName = 'Document16Icon';
var $3e7bd247c2a15a57$var$_default = module.exports.default = $3e7bd247c2a15a57$var$Document16Icon;

});

parcelRegister("i9cac", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d36280b20a14c4f7$var$_react = $d36280b20a14c4f7$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $d36280b20a14c4f7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d36280b20a14c4f7$var$Document24Icon = (props)=>/*#__PURE__*/ $d36280b20a14c4f7$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 18c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01c-.54 0-.995.448-.995 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d36280b20a14c4f7$var$Document24Icon.displayName = 'Document24Icon';
var $d36280b20a14c4f7$var$_default = module.exports.default = $d36280b20a14c4f7$var$Document24Icon;

});

parcelRegister("6iY4P", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0e9f22edb5bbb2a5$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97191d14e335e1cb9997865bd9c31c4d>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $9RVmI = parcelRequire("9RVmI");


var $kXb3C = parcelRequire("kXb3C");

function $0e9f22edb5bbb2a5$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("kXb3C", function(module, exports) {
$parcel$export(module.exports, "default", () => $5412502140f64e3a$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $5412502140f64e3a$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, icon: Icon }) {
    return /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
        label: label,
        size: size === 'medium' ? 'medium' : 'small',
        color: color,
        testId: testId
    });
}

});

parcelRegister("j6GAe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $90028f2cad692a01$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db70e40168178b4ae8431bb0df789052>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $9RVmI = parcelRequire("9RVmI");


var $fP78j = parcelRequire("fP78j");

function $90028f2cad692a01$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("9JsQ8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8DZd1 = parcelRequire("8DZd1");


var $djgQ6 = parcelRequire("djgQ6");


var $chO1Z = parcelRequire("chO1Z");


var $7CgcZ = parcelRequire("7CgcZ");

const $b894277b0121d160$var$FileIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), 'grayBold', (0, $7CgcZ.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($8DZd1))), (0, (/*@__PURE__*/$parcel$interopDefault($djgQ6)))));
$b894277b0121d160$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $b894277b0121d160$export$2e2bcd8739ae039 = $b894277b0121d160$var$FileIconWithColor;
module.exports["default"] = $b894277b0121d160$export$2e2bcd8739ae039;

});

parcelRegister("8DZd1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $64b1721c286de662$var$_react = $64b1721c286de662$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $64b1721c286de662$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $64b1721c286de662$var$Generic16Icon = (props)=>/*#__PURE__*/ $64b1721c286de662$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M8 3H5.333C4.597 3 4 3.617 4 4.378v7.244C4 12.382 4.597 13 5.333 13h5.334c.736 0 1.333-.617 1.333-1.378V8h-1.333v3.622H5.333V4.378H8v1.414c0 .736.597 1.333 1.333 1.333h2.334c.184 0 .333-.15.333-.333v-.903a.33.33 0 0 0-.093-.231l-2.164-2.25A1.33 1.33 0 0 0 8.782 3zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006z"/></svg>`
    }, props, {
        size: 'small'
    }));
$64b1721c286de662$var$Generic16Icon.displayName = 'Generic16Icon';
var $64b1721c286de662$var$_default = module.exports.default = $64b1721c286de662$var$Generic16Icon;

});

parcelRegister("djgQ6", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9b0a1cae716cd1ca$var$_react = $9b0a1cae716cd1ca$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $9b0a1cae716cd1ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9b0a1cae716cd1ca$var$Generic24Icon = (props)=>/*#__PURE__*/ $9b0a1cae716cd1ca$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M12 4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6.995h-2V18H8V6h4v2a2 2 0 0 0 2 2h3.5a.5.5 0 0 0 .5-.5V8.213a.5.5 0 0 0-.145-.352L14.61 4.59A2 2 0 0 0 13.19 4zM3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`
    }, props, {
        size: 'medium'
    }));
$9b0a1cae716cd1ca$var$Generic24Icon.displayName = 'Generic24Icon';
var $9b0a1cae716cd1ca$var$_default = module.exports.default = $9b0a1cae716cd1ca$var$Generic24Icon;

});

parcelRegister("1w5AW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $jKhX7 = parcelRequire("jKhX7");


var $cQbj1 = parcelRequire("cQbj1");


var $1zLiv = parcelRequire("1zLiv");


var $7CgcZ = parcelRequire("7CgcZ");

const $236bd638115a684a$var$ChartBarIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($1zLiv))), 'purpleBold', (0, $7CgcZ.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($jKhX7))), (0, (/*@__PURE__*/$parcel$interopDefault($cQbj1)))));
$236bd638115a684a$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $236bd638115a684a$export$2e2bcd8739ae039 = $236bd638115a684a$var$ChartBarIconWithColor;
module.exports["default"] = $236bd638115a684a$export$2e2bcd8739ae039;

});

parcelRegister("jKhX7", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e6003d2deb1d9822$var$_react = $e6003d2deb1d9822$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $e6003d2deb1d9822$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e6003d2deb1d9822$var$Presentation16Icon = (props)=>/*#__PURE__*/ $e6003d2deb1d9822$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m10 3a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1M8 6a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1M4 9a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'small'
    }));
$e6003d2deb1d9822$var$Presentation16Icon.displayName = 'Presentation16Icon';
var $e6003d2deb1d9822$var$_default = module.exports.default = $e6003d2deb1d9822$var$Presentation16Icon;

});

parcelRegister("cQbj1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $95931c783b128167$var$_react = $95931c783b128167$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $95931c783b128167$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $95931c783b128167$var$Presentation24Icon = (props)=>/*#__PURE__*/ $95931c783b128167$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$95931c783b128167$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $95931c783b128167$var$_default = module.exports.default = $95931c783b128167$var$Presentation24Icon;

});

parcelRegister("h45kr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $lxsNd = parcelRequire("lxsNd");


var $iFCP2 = parcelRequire("iFCP2");


var $cUQMr = parcelRequire("cUQMr");


var $7CgcZ = parcelRequire("7CgcZ");

const $55cc43e42726cbf8$var$ListBulletedIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($cUQMr))), 'greenBold', (0, $7CgcZ.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($lxsNd))), (0, (/*@__PURE__*/$parcel$interopDefault($iFCP2)))));
$55cc43e42726cbf8$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $55cc43e42726cbf8$export$2e2bcd8739ae039 = $55cc43e42726cbf8$var$ListBulletedIconWithColor;
module.exports["default"] = $55cc43e42726cbf8$export$2e2bcd8739ae039;

});

parcelRegister("lxsNd", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $fae303b458ee3eba$var$_react = $fae303b458ee3eba$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $fae303b458ee3eba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fae303b458ee3eba$var$Spreadsheet16Icon = (props)=>/*#__PURE__*/ $fae303b458ee3eba$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 4a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2zm5-8a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$fae303b458ee3eba$var$Spreadsheet16Icon.displayName = 'Spreadsheet16Icon';
var $fae303b458ee3eba$var$_default = module.exports.default = $fae303b458ee3eba$var$Spreadsheet16Icon;

});

parcelRegister("iFCP2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d97a2b9af590931e$var$_react = $d97a2b9af590931e$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $d97a2b9af590931e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d97a2b9af590931e$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $d97a2b9af590931e$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d97a2b9af590931e$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $d97a2b9af590931e$var$_default = module.exports.default = $d97a2b9af590931e$var$Spreadsheet24Icon;

});

parcelRegister("8PFSM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $009878891f6679eb$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d51578aa68f6f1f67b6c4a1d4bb0368>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $iOozU = parcelRequire("iOozU");


var $kXb3C = parcelRequire("kXb3C");

function $009878891f6679eb$export$2e2bcd8739ae039({ label: label = 'Branch', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iOozU))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("iZCav", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0686486f925c9ddd$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5dc8472ed4701f1e18b170a37220fe41>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $fZeLS = parcelRequire("fZeLS");


var $kXb3C = parcelRequire("kXb3C");

function $0686486f925c9ddd$export$2e2bcd8739ae039({ label: label = 'Commit', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fZeLS))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
}

});

parcelRegister("5NrIb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $692c05f58e5d3ef7$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4a46dfaccc0758bf1b71ccf340efb6a>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $7OYaz = parcelRequire("7OYaz");


var $kXb3C = parcelRequire("kXb3C");

function $692c05f58e5d3ef7$export$2e2bcd8739ae039({ label: label = 'Pull Request', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7OYaz))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
}

});

parcelRegister("gV3jM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $2708dfe0209c3c78$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::00550c5037cc26264de6baee26f7399e>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eIlE7 = parcelRequire("eIlE7");


var $kXb3C = parcelRequire("kXb3C");

function $2708dfe0209c3c78$export$2e2bcd8739ae039({ label: label = 'Code', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eIlE7))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
}

});

parcelRegister("1WiZb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $c77f4c6a2336f8ae$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0179ace6db90174fb1e33ede0463bdef>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4BqOc = parcelRequire("4BqOc");


var $kXb3C = parcelRequire("kXb3C");

function $c77f4c6a2336f8ae$export$2e2bcd8739ae039({ label: label = 'Changes', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4BqOc))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
}

});

parcelRegister("kWiYc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $4ce94c9023f0019e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d32d0479ba45c629729cf798e1abfca>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4SWbm = parcelRequire("4SWbm");


var $kXb3C = parcelRequire("kXb3C");

function $4ce94c9023f0019e$export$2e2bcd8739ae039({ label: label = 'Epic', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4SWbm))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
}

});

parcelRegister("cKqka", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $4b99d5ed076c1160$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::46cc2c056bbd3058657958f7f09f6575>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $5LN4K = parcelRequire("5LN4K");


var $kXb3C = parcelRequire("kXb3C");

function $4b99d5ed076c1160$export$2e2bcd8739ae039({ label: label = 'Incident', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5LN4K))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});

parcelRegister("7Jxvl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $ef63a9b3b9aed96b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c6870d6420a4692ac4cdb5a00753f738>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $jz9js = parcelRequire("jz9js");


var $kXb3C = parcelRequire("kXb3C");

function $ef63a9b3b9aed96b$export$2e2bcd8739ae039({ label: label = 'Problem', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jz9js))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});

parcelRegister("4KIbP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $627ab7f82241d2c9$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::08e9485c746db90f5ac9b367aa0dd41e>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $49GPt = parcelRequire("49GPt");


var $kXb3C = parcelRequire("kXb3C");

function $627ab7f82241d2c9$export$2e2bcd8739ae039({ label: label = 'Subtask', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($49GPt))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("e0ycV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f2152e50a3b99db24df80b6d3e591d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a32b99a806197ff2$var$_react = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("42omo")));

var $a32b99a806197ff2$var$_baseNew = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a32b99a806197ff2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a32b99a806197ff2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $a32b99a806197ff2$var$_react.default.createElement($a32b99a806197ff2$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$a32b99a806197ff2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $a32b99a806197ff2$var$_default = module.exports.default = $a32b99a806197ff2$var$PageLiveDocIcon;

});

parcelRegister("66dpz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $893c7e3925139b9a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c9832fbd4a1ca0bae327cc20e7bdf16>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $kXb3C = parcelRequire("kXb3C");

function $893c7e3925139b9a$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
}

});

parcelRegister("fAGae", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0f3b40ffeda05888$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a95f50e5543417b936016ac441fe40a9>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $fP78j = parcelRequire("fP78j");

function $0f3b40ffeda05888$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)",
        backgroundColor: isBold ? 'color.background.accent.magenta.subtle' : undefined
    });
}

});

parcelRegister("6Eovk", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d797c8c4e4c6494$export$2e2bcd8739ae039);
/* eslint-disable import/no-default-export */ /* eslint-disable react/prop-types */ 
var $42omo = parcelRequire("42omo");


var $cMypa = parcelRequire("cMypa");

function $4d797c8c4e4c6494$export$2e2bcd8739ae039(props) {
    // Produce the image tag as is because there is no onLoad event in SSR
    // Also render image tag directly if the page was SSRed because react-render-image always render placeholder first.
    // This will make image flicker
    return props.src && window.__SSR_RENDERED__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.loaded) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cMypa))), props);
}

});

parcelRegister("cMypa", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $94e4a7d853f8088a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $42omo = parcelRequire("42omo");

var $94e4a7d853f8088a$var$React = $94e4a7d853f8088a$var$_interopRequireWildcard($42omo);
function $94e4a7d853f8088a$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $94e4a7d853f8088a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $94e4a7d853f8088a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $94e4a7d853f8088a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $94e4a7d853f8088a$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $94e4a7d853f8088a$var$loaded() {
    return {
        isLoaded: true
    };
}
function $94e4a7d853f8088a$var$errored() {
    return {
        isErrored: true
    };
}
function $94e4a7d853f8088a$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $94e4a7d853f8088a$var$ImageRenderer = function(_React$Component) {
    $94e4a7d853f8088a$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $94e4a7d853f8088a$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $94e4a7d853f8088a$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($94e4a7d853f8088a$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($94e4a7d853f8088a$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $94e4a7d853f8088a$var$_possibleConstructorReturn(_this, _ret);
    }
    $94e4a7d853f8088a$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($94e4a7d853f8088a$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($94e4a7d853f8088a$var$hasPropsChanged(this.props, nextProps)) this.setState($94e4a7d853f8088a$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($94e4a7d853f8088a$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($94e4a7d853f8088a$var$React.Component);
module.exports.default = $94e4a7d853f8088a$var$ImageRenderer;

});

parcelRegister("1Okf1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dDhJe = parcelRequire("dDhJe");

const $6833d9101ef67c08$export$d08617a365fbe694 = (cardClient)=>(0, $42omo.useMemo)(()=>(0, $dDhJe.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);
module.exports["useResolverUrl"] = $6833d9101ef67c08$export$d08617a365fbe694;

});

parcelRegister("6rSJC", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fb3kw = parcelRequire("fb3kw");

/**
 * __Checkbox field__
 *
 * A checkbox field is a form field that lets users select an item. Users can check or uncheck the checkbox.
 *
 * - [Examples] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Code] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Usage] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 */ const $aabc54d8ecf8c9ec$var$CheckboxField = ({ children: children, defaultIsChecked: defaultIsChecked = false, isDisabled: isDisabled, isRequired: isRequired, label: label, name: name, value: value })=>{
    // Maintains a memoised list of the default values
    const defaultValue = (0, $42omo.useCallback)((currentValue = [])=>defaultIsChecked && value !== undefined ? [
            ...currentValue,
            value
        ] : currentValue, [
        value,
        defaultIsChecked
    ]);
    return value !== undefined ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
        defaultValue: defaultValue,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event, currentValue)=>!Array.isArray(event) && event.currentTarget.checked && currentValue ? [
                ...currentValue,
                value
            ] : currentValue.filter((v)=>v !== value),
        children: ({ fieldProps: { value: fieldValue, onChange: onChange, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    // Setting to any because it's typed weirdly at the field level
                    onChange: (v)=>onChange(v),
                    isChecked: !!fieldValue.find((v)=>v === value),
                    value: value
                },
                ...others
            })
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
        defaultValue: defaultIsChecked,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event)=>typeof event === 'boolean' ? event : event.currentTarget.checked,
        children: ({ fieldProps: { value: fieldValue, onChange: onChange, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    // Setting to any because it's typed weirdly at the field level
                    onChange: (v)=>onChange(v),
                    isChecked: fieldValue,
                    value: value
                },
                ...others
            })
    });
};
var $aabc54d8ecf8c9ec$export$2e2bcd8739ae039 = $aabc54d8ecf8c9ec$var$CheckboxField;
module.exports["default"] = $aabc54d8ecf8c9ec$export$2e2bcd8739ae039;

});

parcelRegister("9EtP6", function(module, exports) {
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $dh538 = parcelRequire("dh538");

const $82c18ff824db72a8$var$packageName = "platform-pkg";
const $82c18ff824db72a8$var$packageVersion = "0.0.0-use.local";
const $82c18ff824db72a8$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $82c18ff824db72a8$var$packageName,
    packageVersion: $82c18ff824db72a8$var$packageVersion
};
const $82c18ff824db72a8$var$lineHeightBase = 20;
const $82c18ff824db72a8$var$lineHeightCompact = 16;
const $82c18ff824db72a8$var$compactVerticalPadding = 2;
const $82c18ff824db72a8$var$verticalPadding = 6;
const $82c18ff824db72a8$var$transitionDuration = '0.2s';
const $82c18ff824db72a8$var$borderWidth = 2;
const $82c18ff824db72a8$var$baseStyles = null;
const $82c18ff824db72a8$var$baseStylesT26Shape = null;
const $82c18ff824db72a8$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp82rsbi _1ltx1j9a _1bqsbk0g _z1pvby5v _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _7ba01v6z _1kod1v6z _858u1v1w _jomrr01l _7ehivyy1 _186j1v1w _qu18by5v",
    subtle: "_1dqonqa1 _kp821j28 _1ltx1j28 _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _1kod1v6z _7ba01v6z _858u1v1w _jomrr01l _7ehivyy1",
    none: "_1dqoglyw _kp821j28 _1ltx1j28 _19wt1j28 _12ym1j28 _1l02v77o _daj712x7 _11zpv77o _141f12x7 _olc612x7 _1kod12x7 _14ji12x7 _7ba012x7 _858u1j28 _jomr1j28 _7ehi3sij"
}; // iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textarea uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $82c18ff824db72a8$var$fontStyles = {
    default: "_11c81d4k _1tn2fhey",
    monospace: "_11c81d4k _ect4zzfg _1tn2fhey _14md1vhz"
};
const $82c18ff824db72a8$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $82c18ff824db72a8$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $82c18ff824db72a8$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $82c18ff824db72a8$var$InnerTextArea = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const ourRef = (0, $42omo.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $42omo.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $42omo.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $82c18ff824db72a8$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$82c18ff824db72a8$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$82c18ff824db72a8$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $42omo.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $82c18ff824db72a8$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $l998X.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rkofajl _11c8fhey _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazi7uo _slp31hna _153g1bqt _usy41j9a _1a2sizbr _vbqb1gmx _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra1bqt _ibjdl4ek _6zpvizbr _19k0by5v _1idr1rpy _1lep1gmx _nmhq1fiz _1n388sxn _1luh1v1w _ndzbr01l _1vj0vyy1",
            (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1qi0",
            $82c18ff824db72a8$var$appearanceStyles[appearance],
            $82c18ff824db72a8$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $82c18ff824db72a8$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $7sObp.default)($82c18ff824db72a8$var$lineHeightCompact * minimumRows + $82c18ff824db72a8$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $7sObp.default)($82c18ff824db72a8$var$lineHeightBase * minimumRows + $82c18ff824db72a8$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $82c18ff824db72a8$var$TextArea = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)($82c18ff824db72a8$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$82c18ff824db72a8$var$TextArea.displayName = 'TextArea';
var $82c18ff824db72a8$export$2e2bcd8739ae039 = $82c18ff824db72a8$var$TextArea;
module.exports["default"] = $82c18ff824db72a8$export$2e2bcd8739ae039;

});

parcelRegister("bedQP", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");

const $9aeacd26f36a9957$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $9aeacd26f36a9957$export$cf56d0f54cfcce4;

});

parcelRegister("9JpPs", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $c712b10e1cbb5738$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $c712b10e1cbb5738$export$6e8ea24b15199873;

});

parcelRegister("hcMBV", function(module, exports) {
var $87ac0097385af1df$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    return CardAction;
}({});
module.exports["CardAction"] = $87ac0097385af1df$export$f40b7e0b762b928b;

});

parcelRegister("I1nNR", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");


var $chRg6 = parcelRequire("chRg6");

const $7834fba73424be0b$export$a54013f0d02a8f82 = ({ children: children, locale: incomingLocale = (0, $chRg6.DEFAULT_LOCALE), fetchTranslations: fetchTranslations })=>{
    const [messages, setMessages] = (0, $42omo.useState)();
    const locale = (0, $42omo.useMemo)(()=>(0, $chRg6.normalizeLocale)(incomingLocale), [
        incomingLocale
    ]);
    (0, $42omo.useEffect)(()=>{
        const loadTranslations = async ()=>{
            const localeMessages = await fetchTranslations(locale);
            setMessages(localeMessages);
        };
        loadTranslations();
    }, [
        fetchTranslations,
        locale
    ]);
    if (!messages) return null;
    // Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
    // They will not function correctly due to a lack of I18n context.
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
        locale: locale,
        messages: messages,
        defaultLocale: (0, $chRg6.DEFAULT_LOCALE),
        children: children
    });
};
module.exports["I18nProvider"] = $7834fba73424be0b$export$a54013f0d02a8f82;

});

parcelRegister("chRg6", function(module, exports) {
const $22ba11b592de8836$var$DEFAULT_LANGUAGE = 'en';
const $22ba11b592de8836$var$DEFAULT_REGION = 'US';
const $22ba11b592de8836$export$1af4c7e47ad72f44 = `${$22ba11b592de8836$var$DEFAULT_LANGUAGE}-${$22ba11b592de8836$var$DEFAULT_REGION}`;
const $22ba11b592de8836$var$languageToLongLocaleCode = {
    cs: 'cs-CZ',
    da: 'da-DK',
    de: 'de-DE',
    en: 'en-US',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hu: 'hu-HU',
    it: 'it-IT',
    ja: 'ja-JP',
    ko: 'ko-KR',
    // Both `no` and `nb` language codes refer to Norwegian. Refer both to long locale code as `no-NO`
    no: 'no-NO',
    nb: 'no-NO',
    nl: 'nl-NL',
    pl: 'pl-PL',
    ru: 'ru-RU',
    sv: 'sv-SE',
    th: 'th-TH',
    tr: 'tr-TR',
    uk: 'uk-UA',
    vi: 'vi-VN',
    zh: 'zh-CN'
};
const $22ba11b592de8836$export$dca0327c9b9c6498 = (locale)=>{
    if (!locale) return $22ba11b592de8836$export$1af4c7e47ad72f44;
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from the supplied locale.');
    const [, language, region] = match;
    const normalizedLanguage = (language ?? '').toLowerCase();
    const normalizedRegion = (region ?? '').toUpperCase();
    if (normalizedLanguage && normalizedRegion) return [
        normalizedLanguage,
        normalizedRegion
    ].join('-');
    const longLocaleCode = $22ba11b592de8836$var$languageToLongLocaleCode[normalizedLanguage];
    return longLocaleCode ?? $22ba11b592de8836$export$1af4c7e47ad72f44;
};
module.exports["DEFAULT_LOCALE"] = $22ba11b592de8836$export$1af4c7e47ad72f44;
module.exports["normalizeLocale"] = $22ba11b592de8836$export$dca0327c9b9c6498;

});

parcelRegister("hpNab", function(module, exports) {

var $9tQM5 = parcelRequire("9tQM5");

var $kFwgS = parcelRequire("kFwgS");

var $cfa17a27dec34885$export$241b9888a4d565c9 = /*#__PURE__*/ function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    return ALLOWED_FEATURES_TYPE;
}({});
const $cfa17a27dec34885$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share',
        'enable-redirection',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar',
        'loom-external-open'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        'template-browser',
        'inline-comments',
        'disable-publish-close-buttons',
        'loom-external-open'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $cfa17a27dec34885$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $cfa17a27dec34885$var$pageAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.edit,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.view
};
const $cfa17a27dec34885$var$blogPostAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.edit,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.view
};
const $cfa17a27dec34885$var$whiteboardAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.whiteboard
};
const $cfa17a27dec34885$var$contentTypeAllowedFeatures = {
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $cfa17a27dec34885$var$pageAllowedFeatures,
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $cfa17a27dec34885$var$blogPostAllowedFeatures,
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $cfa17a27dec34885$var$whiteboardAllowedFeatures
};
const $cfa17a27dec34885$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$cfa17a27dec34885$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];
module.exports["ALLOWED_FEATURES"] = $cfa17a27dec34885$export$a3fda3dcee62e1cc;
module.exports["DEFAULT_ALLOWED_FEATURES"] = $cfa17a27dec34885$export$a33327ada3a6ee4a;
module.exports["getAllowedFeatures"] = $cfa17a27dec34885$export$3207c60940c4a9b0;

});

parcelRegister("9tQM5", function(module, exports) {
var $5b5865fbd831eb6d$export$942a5fac9b8c9dc2 = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});
module.exports["EMBEDDED_CONFLUENCE_CONTENT_TYPE"] = $5b5865fbd831eb6d$export$942a5fac9b8c9dc2;

});

parcelRegister("kFwgS", function(module, exports) {
var $b38de1a13d5a6bb8$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
module.exports["EMBEDDED_CONFLUENCE_MODE"] = $b38de1a13d5a6bb8$export$816ef638e478449a;

});

parcelRegister("cGc86", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $diaaX = parcelRequire("diaaX");

const $b9b017651fce2f05$var$UniqueKeyContext = /*#__PURE__*/ (0, $42omo.createContext)({
    uniqueKey: undefined
});
const $b9b017651fce2f05$export$71829d27b87a2006 = ({ children: children })=>{
    const uniqueKey = (0, $42omo.useMemo)(()=>(0, $diaaX.createUniqueKey)(), []);
    return /*#__PURE__*/ (0, $l998X.jsx)($b9b017651fce2f05$var$UniqueKeyContext.Provider, {
        value: {
            uniqueKey: uniqueKey
        },
        children: children
    });
};
const $b9b017651fce2f05$export$cef64a0cfb90e369 = ()=>{
    return (0, $42omo.useContext)($b9b017651fce2f05$var$UniqueKeyContext);
};
module.exports["UniqueKeyProvider"] = $b9b017651fce2f05$export$71829d27b87a2006;
module.exports["useUniqueKey"] = $b9b017651fce2f05$export$cef64a0cfb90e369;

});

parcelRegister("kudeD", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $khmAd = parcelRequire("khmAd");


var $4icDV = parcelRequire("4icDV");

// PerformanceMetricsProvider is only applied to internal EP
// Methods provided by PerformanceMetricsContext are defined by default as () => {}
// This allows instances not wrapped in provider (ie embedded-confluence public) to opperate without errors
const $0a26766864270169$var$PerformanceMetricsContext = /*#__PURE__*/ (0, $42omo.createContext)({
    isInitialized: false,
    cancelIframeLoadMetrics: ()=>{},
    markIframeLoadMetrics: ()=>{},
    setContentType: ()=>{}
});
// calculate timestamp from iframe's performance metric post message
// relative to parent's window.performance.now() adjusted for post message latency
const $0a26766864270169$var$adjustedPerformanceTimestamp = (timestamp)=>typeof timestamp === 'number' ? window.performance.now() - (Date.now() - timestamp) : undefined;
const $0a26766864270169$var$Provider = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const [currentContentType, setCurrentContentType] = (0, $42omo.useState)(contentType);
    const isInitialized = (0, $42omo.useRef)(true);
    const iframeLoadMetrics = (0, $42omo.useRef)();
    const embeddedViewToEditTransitionTimer = (0, $42omo.useRef)();
    (0, $42omo.useLayoutEffect)(()=>{
        // TODO: Currently EP does not work with more that one instance per parent window
        // When this limitation is fixed we will also need to find a way to serialize post messages
        // this is because post message listeners will pick up on all messages coming to the parent window
        // triggering any callback listening to a given data.type message
        // therefore messages will need to be scoped to the particular instance they are intended for
        embeddedViewToEditTransitionTimer.current?.cancel();
        embeddedViewToEditTransitionTimer.current = (0, $khmAd.embeddedViewToEditTransitionMetric)();
        // Setup iframe post message handling
        const handler = (e)=>{
            let uniqueKey;
            try {
                uniqueKey = new URL(window.location.href).searchParams.get('uniqueKey');
            } catch (error) {
                uniqueKey = null;
            }
            // Validate uniqueKey (if it exists) to avoid race condition between multiple embedded confluence instances
            if (!e.data.payload?.customData?.uniqueKey || !uniqueKey || e.data.payload.customData.uniqueKey === uniqueKey) switch(e.data.type){
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_VIEW_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_EDITOR_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    embeddedViewToEditTransitionTimer.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_EDIT_CLICK):
                    embeddedViewToEditTransitionTimer.current?.start({
                        startTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp)
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_IFRAME_CONTENT_INITIALIZED):
                    iframeLoadMetrics.current?.mark('iframe-content-initialized-end', $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp));
                    break;
            }
        };
        window.addEventListener('message', handler);
        const currentTransitionTimer = embeddedViewToEditTransitionTimer.current;
        return ()=>{
            window.removeEventListener('message', handler);
            currentTransitionTimer.cancel();
        };
    }, [
        embeddedViewToEditTransitionTimer,
        sourceComponent
    ]);
    // Set load metric based on content type
    (0, $42omo.useLayoutEffect)(()=>{
        if (currentContentType) {
            // cancel current Embedded Confluence iframe load metric if necessary
            iframeLoadMetrics.current?.cancel();
            iframeLoadMetrics.current = (0, $khmAd.embeddedConfluenceIframeLoadMetrics)(currentContentType);
            // start Embedded Confluence iframe load metric
            iframeLoadMetrics.current?.start();
            iframeLoadMetrics.current?.mark('lazy-load-start');
        }
        return ()=>{
            iframeLoadMetrics.current?.cancel();
        };
    }, [
        currentContentType,
        sourceComponent
    ]);
    const cancelIframeLoadMetrics = (0, $42omo.useCallback)(()=>{
        iframeLoadMetrics.current?.cancel();
    }, []);
    const markIframeLoadMetrics = (0, $42omo.useCallback)((markName)=>{
        iframeLoadMetrics.current?.mark(markName);
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)($0a26766864270169$var$PerformanceMetricsContext.Provider, {
        value: {
            cancelIframeLoadMetrics: cancelIframeLoadMetrics,
            markIframeLoadMetrics: markIframeLoadMetrics,
            isInitialized: isInitialized.current,
            setContentType: setCurrentContentType
        },
        children: children
    });
};
const $0a26766864270169$export$865423e6f8e2e839 = ()=>{
    return (0, $42omo.useContext)($0a26766864270169$var$PerformanceMetricsContext);
};
const $0a26766864270169$export$c6f19d9afc6c86c8 = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const { isInitialized: isInitialized, setContentType: setContentType } = $0a26766864270169$export$865423e6f8e2e839();
    (0, $42omo.useLayoutEffect)(()=>{
        // Update contentType when Page component replaces ViewPage with EditPage or vice versa
        isInitialized && contentType && setContentType(contentType);
    }, [
        isInitialized,
        contentType,
        setContentType
    ]);
    return !isInitialized ? /*#__PURE__*/ (0, $l998X.jsx)($0a26766864270169$var$Provider, {
        contentType: contentType,
        sourceComponent: sourceComponent,
        children: children
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["usePerformanceMetrics"] = $0a26766864270169$export$865423e6f8e2e839;
module.exports["PerformanceMetricsProvider"] = $0a26766864270169$export$c6f19d9afc6c86c8;

});

parcelRegister("khmAd", function(module, exports) {

var $kyiqo = parcelRequire("kyiqo");


var $j4jXg = parcelRequire("j4jXg");

const $078bd495543d458c$export$4de078c3b9971f9b = ()=>(0, $kyiqo.metrics).interaction({
        key: 'embedded-confluence-view-to-edit-transition'
    });
const $078bd495543d458c$var$timings = [
    {
        key: 'lazy-load',
        startMark: 'lazy-load-start',
        endMark: 'lazy-load-end'
    },
    {
        key: 'common-load',
        startMark: 'common-load-start',
        endMark: 'common-load-end'
    },
    {
        key: 'iframe-content-initialized',
        startMark: 'iframe-content-initialized-start',
        endMark: 'iframe-content-initialized-end'
    }
];
const $078bd495543d458c$var$loadingMetricsConfig = {
    viewPage: {
        key: 'embedded-confluence-view-page-iframe',
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $078bd495543d458c$var$timings
    },
    editPage: {
        key: 'embedded-confluence-edit-page-iframe',
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $078bd495543d458c$var$timings
    }
};
const $078bd495543d458c$export$a23245993532c751 = (contentType)=>(0, $kyiqo.metrics).pageSegmentLoad($078bd495543d458c$var$loadingMetricsConfig[contentType]);
module.exports["embeddedViewToEditTransitionMetric"] = $078bd495543d458c$export$4de078c3b9971f9b;
module.exports["embeddedConfluenceIframeLoadMetrics"] = $078bd495543d458c$export$a23245993532c751;

});

parcelRegister("4icDV", function(module, exports) {
const $2c9093170036a8a1$export$ad3f29048eb3061 = 'embedded-confluence-metrics.';
const $2c9093170036a8a1$export$e5b04c2a3cc97ddc = 'embedded-view-tti';
const $2c9093170036a8a1$export$9f8bbf62fac57d48 = 'embedded-editor-tti';
const $2c9093170036a8a1$export$e08d2ab8ef653595 = 'embedded-edit-click';
const $2c9093170036a8a1$export$73b982309451f084 = 'embedded-iframe-content-initialized';
module.exports["EMBEDDED_CONFLUENCE_METRICS_PREFIX"] = $2c9093170036a8a1$export$ad3f29048eb3061;
module.exports["EMBEDDED_VIEW_TTI"] = $2c9093170036a8a1$export$e5b04c2a3cc97ddc;
module.exports["EMBEDDED_EDITOR_TTI"] = $2c9093170036a8a1$export$9f8bbf62fac57d48;
module.exports["EMBEDDED_EDIT_CLICK"] = $2c9093170036a8a1$export$e08d2ab8ef653595;
module.exports["EMBEDDED_IFRAME_CONTENT_INITIALIZED"] = $2c9093170036a8a1$export$73b982309451f084;

});

parcelRegister("3WsBD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j6S25 = parcelRequire("j6S25");


var $dh538 = parcelRequire("dh538");


var $9tQM5 = parcelRequire("9tQM5");

var $kFwgS = parcelRequire("kFwgS");


var $hpNab = parcelRequire("hpNab");


var $8C5kA = parcelRequire("8C5kA");


var $cezNv = parcelRequire("cezNv");


var $cGc86 = parcelRequire("cGc86");

const $5a8d62fce039da42$export$6e43e60d51b79331 = (themeState)=>{
    const themeString = (0, $j6S25.themeObjectToString)(themeState);
    return encodeURIComponent(themeString);
};
const $5a8d62fce039da42$var$STARGATE_CONFLUENCE_PROXY = '/gateway/api/ex/confluence/';
const $5a8d62fce039da42$var$nonAllFeatures = [
    'modern-header',
    'disable-help-button',
    'disable-title-toolbar'
];
const $5a8d62fce039da42$export$305222dff575c4e3 = ({ allowedFeatures: allowedFeatures, contentId: contentId, contentType: contentType, contentConfiguration: contentConfiguration, draftShareId: draftShareId, hash: hash, hostname: hostname, mode: mode, parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, parentProductContentId: parentProductContentId, previewPanels: previewPanels, protocol: protocol, spaceKey: spaceKey, template: template, themeState: themeState, embeddedConfluenceSource: embeddedConfluenceSource })=>{
    const initialAllowedFeaturesRef = (0, $42omo.useRef)(undefined);
    // Keep `initialAllowedFeatures` to only contain the initial allowed feature values for cc-frontend SSR rendering
    // Store this value using `useRef` to avoid the iframe url gets updated when `allowedFeatures` React props updated by parent products.
    // If allowedFeatures is equal to 'all' for view mode it must be converted to an array so that 'edit' can be removed.
    const features = (0, $42omo.useMemo)(()=>allowedFeatures === 'all' ? (0, $hpNab.getAllowedFeatures)({
            contentType: contentType,
            mode: mode
        }) : allowedFeatures, [
        allowedFeatures,
        contentType,
        mode
    ]);
    if (!initialAllowedFeaturesRef.current) initialAllowedFeaturesRef.current = Array.isArray(features) ? features.map((feature)=>{
        if (typeof feature !== 'string') return JSON.stringify(feature);
        else return feature;
    })// 'edit' can not be included as an initialAllowedFeature because it requires the navigation policy, which does not work with SSR.
    // 'enable-redirection' should not be included in initial allowed features unless a parent has passed this in as an allowedFeature in the correct format.
    .filter((feature)=>feature !== 'edit' && feature !== 'enable-redirection')// 'modern-header' should not be included in initial allowed features when allowedFeatures is 'all'
    .filter((feature)=>!$5a8d62fce039da42$var$nonAllFeatures.includes(feature)).join('.') : features;
    // check whether re-direction is enabled
    const enableRedirectionFeature = features && features !== 'all' ? features.find((feature)=>(0, $cezNv.isRedirectionEnabled)(feature)) : undefined;
    const crossSiteTenantId = enableRedirectionFeature ? (0, $cezNv.getCrossSiteTenantIdFromAllowedFeature)(enableRedirectionFeature) : undefined;
    const { locale: locale } = (0, $8C5kA.default)();
    const { uniqueKey: uniqueKey } = (0, $cGc86.useUniqueKey)();
    const queryParams = (0, $42omo.useMemo)(()=>{
        const query = {};
        if (parentProduct) query.parentProduct = parentProduct;
        if (parentProductContentContainerId) query.parentProductContentContainerId = parentProductContentContainerId;
        if (parentProductContentId) query.parentProductContentId = parentProductContentId;
        if (initialAllowedFeaturesRef.current !== undefined) query.initialAllowedFeatures = initialAllowedFeaturesRef.current;
        if (template) query.insertTemplateWithKey = template;
        if (themeState) query.themeState = $5a8d62fce039da42$export$6e43e60d51b79331(themeState);
        if (draftShareId) query.draftShareId = draftShareId;
        if (embeddedConfluenceSource) query.embeddedConfluenceSource = embeddedConfluenceSource;
        if (previewPanels) query.previewPanels = previewPanels;
        if (hostname && hostname !== window.location.host) query.isCrossDomain = true;
        if (uniqueKey && (0, $dh538.fg)('platform_deprecate_lp_cc_embed')) query.uniqueKey = uniqueKey;
        query.locale = locale;
        const { isCrossDomain: isCrossDomain, ...restQuery } = query;
        return `?${new URLSearchParams({
            ...isCrossDomain ? {
                isCrossDomain: `${isCrossDomain}`
            } : {},
            ...restQuery,
            ...contentConfiguration?.queryParams
        }).toString()}`;
    }, [
        contentConfiguration,
        draftShareId,
        locale,
        parentProduct,
        parentProductContentContainerId,
        parentProductContentId,
        previewPanels,
        themeState,
        hostname,
        embeddedConfluenceSource,
        template,
        uniqueKey
    ]);
    return (0, $42omo.useMemo)(()=>({
            ...$5a8d62fce039da42$var$constructUrl(mode, {
                contentId: contentId,
                contentType: contentType,
                hash: hash,
                hostname: hostname,
                protocol: protocol,
                spaceKey: spaceKey,
                queryParams: queryParams,
                crossSiteTenantId: crossSiteTenantId
            })
        }), [
        contentId,
        contentType,
        hash,
        hostname,
        mode,
        protocol,
        spaceKey,
        queryParams,
        crossSiteTenantId
    ]);
};
const $5a8d62fce039da42$var$CONTEXT_PATH = '/wiki/spaces';
const $5a8d62fce039da42$var$invalidUrls = {
    standaloneConfluenceUrl: null,
    embeddedConfluenceUrl: null
};
function $5a8d62fce039da42$var$constructUrl(mode = (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE, { contentId: contentId, contentType: contentType, hash: hash = '', hostname: hostname, protocol: protocol, spaceKey: spaceKey, queryParams: queryParams, crossSiteTenantId: crossSiteTenantId }) {
    if (contentType !== (0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE && !contentId) {
        /* eslint-disable-next-line no-console */ console.error('Content ID is undefined');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    if (!spaceKey) {
        /* eslint-disable-next-line no-console */ console.error('Space key is undefined');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    if (/^\d+$/.test(spaceKey)) /* eslint-disable-next-line no-console */ console.warn('A numeric "spaceKey" is passed into the Embedded Confluence component. Verify that it is the correct "spaceKey" and not the "spaceId." Disregard this warning if it is correct.');
    const prefix = `${protocol || window.location.protocol}//${hostname || window.location.host}${$5a8d62fce039da42$var$CONTEXT_PATH}`;
    const prefixWithStargate = crossSiteTenantId ? `${protocol || window.location.protocol}//${window.location.host //take the parent site because want don't want it to be cross-site EP
    }${$5a8d62fce039da42$var$STARGATE_CONFLUENCE_PROXY}${crossSiteTenantId}${$5a8d62fce039da42$var$CONTEXT_PATH}` : undefined;
    let base;
    const pageUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: contentId ? `${spaceKey}/pages/${contentId}` : `${spaceKey}/overview`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const blogpostUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/pages/${contentId}`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const whiteboardUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/whiteboard/${contentId}`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/whiteboard/${contentId}`
    };
    const contentTypeUrl = {
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: pageUrl,
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: blogpostUrl,
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: whiteboardUrl
    };
    base = contentTypeUrl[contentType]?.[mode];
    if (!base) {
        /* eslint-disable-next-line no-console */ console.error('URL is not yet supported');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    const standaloneConfluenceUrl = `${prefix}/${base}${hash}`;
    const embeddedConfluenceUrl = `${prefixWithStargate ?? prefix}/${base}${queryParams}${hash}`;
    return {
        standaloneConfluenceUrl: standaloneConfluenceUrl,
        embeddedConfluenceUrl: embeddedConfluenceUrl
    };
}
module.exports["themeStateObjectToQueryString"] = $5a8d62fce039da42$export$6e43e60d51b79331;
module.exports["useUrl"] = $5a8d62fce039da42$export$305222dff575c4e3;

});

parcelRegister("cezNv", function(module, exports) {
const $d21a741e0de1277a$export$51abd16148027412 = (feature)=>{
    if (typeof feature === 'object') return 'enable-redirection' in feature;
    if (typeof feature === 'string') try {
        const parsedFeature = JSON.parse(feature);
        return parsedFeature && typeof parsedFeature === 'object' && 'enable-redirection' in parsedFeature;
    } catch (error) {
        return false;
    }
    return false;
};
const $d21a741e0de1277a$export$243fbba563b8aa8e = (feature)=>{
    if (!feature) return undefined;
    if (typeof feature === 'string') try {
        const parsed = JSON.parse(feature);
        return parsed['enable-redirection']?.['cross-site-tenant-id'];
    } catch (error) {
        return undefined;
    }
    return feature['enable-redirection']?.['cross-site-tenant-id'];
};
module.exports["isRedirectionEnabled"] = $d21a741e0de1277a$export$51abd16148027412;
module.exports["getCrossSiteTenantIdFromAllowedFeature"] = $d21a741e0de1277a$export$243fbba563b8aa8e;

});

parcelRegister("6mn0G", function(module, exports) {
function $ef5055edddfff711$export$e88cb5bfb57ce9c4(response) {
    try {
        return response.headers.get('x-trace-id') ?? response.headers.get('atl-traceid') ?? null;
    } catch  {
        return null;
    }
}
module.exports["getTraceId"] = $ef5055edddfff711$export$e88cb5bfb57ce9c4;

});

parcelRegister("keVvA", function(module, exports) {
$parcel$export(module.exports, "default", () => $36f6a30267bec70f$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");


var $e9OZ6 = parcelRequire("e9OZ6");


var $5cR9p = parcelRequire("5cR9p");

function $36f6a30267bec70f$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $5cR9p.useSafeIntl)();
    const messages = (0, $e9OZ6.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the context and pass them downstream
   * This prevents the missing messages error
   */ const mergedMessages = (0, $42omo.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages,
        children: children
    });
}

});

parcelRegister("e9OZ6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hxPth = parcelRequire("hxPth");

const $e1a1ee666860bb23$export$4d17e2d9c5348842 = (locale, loaderFn)=>{
    const [localeState, setLocaleState] = (0, $42omo.useState)((0, $hxPth.DEFAULT_LOCALE_STATE));
    (0, $42omo.useEffect)(()=>{
        if (!localeState.messages || locale !== localeState.locale) {
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            });
            return ()=>{
                current = false;
            };
        }
        return undefined;
    }, [
        loaderFn,
        locale,
        localeState
    ]);
    return localeState.messages;
};
module.exports["useMessages"] = $e1a1ee666860bb23$export$4d17e2d9c5348842;

});

parcelRegister("hxPth", function(module, exports) {
const $b9a0da62d538b640$export$79618bef82c02d4c = {
    locale: 'en',
    messages: {}
};
module.exports["DEFAULT_LOCALE_STATE"] = $b9a0da62d538b640$export$79618bef82c02d4c;

});

parcelRegister("5cR9p", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");

var $fI8ba = parcelRequire("fI8ba");

var $gmMgo = parcelRequire("gmMgo");


var $hxPth = parcelRequire("hxPth");

// Prevents memory leaks
const $1961b540cbe6be26$var$cache = (0, $fI8ba.createIntlCache)();
const $1961b540cbe6be26$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $42omo.useContext)((0, $gmMgo.Context));
    if (!context) return (0, $1e2E5.createIntl)((0, $hxPth.DEFAULT_LOCALE_STATE), $1961b540cbe6be26$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $1961b540cbe6be26$export$f752ac21ea3960a5;

});

parcelRegister("igBZP", function(module, exports) {
'use strict';
/* global setTimeout, clearTimeout */ module.exports = function debounce(fn) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lastCallAt = void 0;
    var deferred = void 0;
    var timer = void 0;
    var pendingArgs = [];
    return function debounced() {
        var currentWait = $d4c731e2a28427e0$var$getWait(wait);
        var currentTime = new Date().getTime();
        var isCold = !lastCallAt || currentTime - lastCallAt > currentWait;
        lastCallAt = currentTime;
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (isCold && options.leading) return options.accumulate ? Promise.resolve(fn.call(this, [
            args
        ])).then(function(result) {
            return result[0];
        }) : Promise.resolve(fn.call.apply(fn, [
            this
        ].concat(args)));
        if (deferred) clearTimeout(timer);
        else deferred = $d4c731e2a28427e0$var$defer();
        pendingArgs.push(args);
        timer = setTimeout(flush.bind(this), currentWait);
        if (options.accumulate) {
            var argsIndex = pendingArgs.length - 1;
            return deferred.promise.then(function(results) {
                return results[argsIndex];
            });
        }
        return deferred.promise;
    };
    function flush() {
        var thisDeferred = deferred;
        clearTimeout(timer);
        Promise.resolve(options.accumulate ? fn.call(this, pendingArgs) : fn.apply(this, pendingArgs[pendingArgs.length - 1])).then(thisDeferred.resolve, thisDeferred.reject);
        pendingArgs = [];
        deferred = null;
    }
};
function $d4c731e2a28427e0$var$getWait(wait) {
    return typeof wait === 'function' ? wait() : wait;
}
function $d4c731e2a28427e0$var$defer() {
    var deferred = {};
    deferred.promise = new Promise(function(resolve, reject) {
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
}

});

parcelRegister("c9mMn", function(module, exports) {
/* input-options.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $621c6a15c091c99d$var$optionStyles = {
    default: "_1e0c1txw _4cvr1h6o _1bsb1osq _uiztglyw _18ql1j7p _vchhusvi _85i51b66 _1q511b66 _bozgpxbi _y4tiutpp _bfhk1j28 _16qs1kw7 _syaz1kw7 _1di6fcek",
    focused: "_bfhk1dpa _16qsgkog _112e5u6v",
    disabled: "_syaz1gmx"
}; // state of the parent option
const $621c6a15c091c99d$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled) return "var(--ds-background-disabled, #17171708)";
    else if (isSelected && isActive) return "var(--ds-background-selected-bold-pressed, #123263)";
    else if (isActive) return "var(--ds-background-selected-pressed, #8FB8F6)";
    else if (isFocused && isSelected) return "var(--ds-background-selected-bold-hovered, #1558BC)";
    else if (isFocused) return "var(--ds-surface, #FFFFFF)";
    else if (isSelected) return "var(--ds-background-selected-bold, #1868DB)";
    return "var(--ds-background-neutral, #0515240F)";
}; // the secondary color represents the radio dot or checkmark
const $621c6a15c091c99d$var$getSecondaryColor = ({ isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return "var(--ds-text-disabled, #080F214A)";
    else if (!isSelected) return 'transparent';
    return "var(--ds-surface, #FFFFFF)";
};
const $621c6a15c091c99d$var$iconStyles = {
    inherit: "_1u9j1r31 _1gqp1r31",
    default: "_1u9j1ihb _1gqp1ihb"
};
const $621c6a15c091c99d$var$baseIconStyles = null;
const $621c6a15c091c99d$var$baseOptionStyles = null;
const $621c6a15c091c99d$var$ControlOption = (props)=>{
    const [isActive, setIsActive] = (0, $42omo.useState)(false);
    const onMouseDown = (0, $42omo.useCallback)(()=>setIsActive(true), []);
    const onMouseUp = (0, $42omo.useCallback)(()=>setIsActive(false), []);
    const { Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, cx: cx, className: className, isDisabled: isDisabled, isSelected: isSelected, isFocused: isFocused } = props;
    const classNames = (0, $42omo.useMemo)(()=>cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className), [
        cx,
        isDisabled,
        isFocused,
        isSelected,
        className
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            $621c6a15c091c99d$var$optionStyles.default,
            isFocused && $621c6a15c091c99d$var$optionStyles.focused,
            isDisabled && $621c6a15c091c99d$var$optionStyles.disabled,
            classNames
        ]),
        ref: innerRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseLeave: onMouseUp,
        ...innerProps,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _4cvr1h6o _1o9zidpf _y4ti1b66 _16cu892t _1xci892t _59qxe4h9 _8y3xe4h9",
                    isSelected || isActive || isDisabled ? $621c6a15c091c99d$var$iconStyles.inherit : $621c6a15c091c99d$var$iconStyles.default
                ]),
                children: !!Icon ? /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                    label: "",
                    primaryColor: $621c6a15c091c99d$var$getPrimaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        isFocused: isFocused,
                        isActive: isActive
                    }),
                    secondaryColor: $621c6a15c091c99d$var$getSecondaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected
                    }),
                    isFacadeDisabled: true
                }) : null
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    "_16jlkb7n _1reo15vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};
const $621c6a15c091c99d$var$svgStyles = null;
const $621c6a15c091c99d$var$CheckboxIcon = (props)=>{
    const { primaryColor: primaryColor, secondaryColor: secondaryColor, label: label } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
};
const $621c6a15c091c99d$var$RadioIcon = (props)=>{
    const { primaryColor: primaryColor, secondaryColor: secondaryColor, label: label } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "6.75",
                    fill: "currentColor",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3",
                    fill: "inherit"
                })
            ]
        })
    });
}; /**
    * __Checkbox option__
    */ 
const $621c6a15c091c99d$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)($621c6a15c091c99d$var$ControlOption, {
        Icon: $621c6a15c091c99d$var$CheckboxIcon,
        ...props
    }); /**
                * __Radio option__
                */ 
const $621c6a15c091c99d$export$82ab7168879267a7 = (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    /*#__PURE__*/ (0, $l998X.jsx)($621c6a15c091c99d$var$ControlOption, {
        Icon: $621c6a15c091c99d$var$RadioIcon,
        ...props
    });
module.exports["CheckboxOption"] = $621c6a15c091c99d$export$d40cc97ecda916f9;
module.exports["RadioOption"] = $621c6a15c091c99d$export$82ab7168879267a7;

});

parcelRegister("4Ldep", function(module, exports) {
$parcel$export(module.exports, "default", () => $3775d0b53e1446a0$export$2e2bcd8739ae039);

var $dhNqt = parcelRequire("dhNqt");


var $b5utg = parcelRequire("b5utg");

function $3775d0b53e1446a0$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b5utg.default)(2, arguments);
    var dateLeftStartOfDay = (0, $dhNqt.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $dhNqt.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

});

parcelRegister("fakaf", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0a76e6973f9e2fd$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $b0a76e6973f9e2fd$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b5utg.default)(2, arguments);
    var dateLeft = (0, $egXhZ.default)(dirtyDateLeft);
    var dateRight = (0, $egXhZ.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}

});

parcelRegister("kiOFr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kSC7A = parcelRequire("kSC7A");


var $f8S0G = parcelRequire("f8S0G");


var $hBNGD = parcelRequire("hBNGD");


var $inPa6 = parcelRequire("inPa6");


var $bZKB2 = parcelRequire("bZKB2");


var $6fCTI = parcelRequire("6fCTI");

const $78f887db99bd3113$var$defaultProducts = [
    (0, $kSC7A.AvailableSitesProductType).WHITEBOARD,
    (0, $kSC7A.AvailableSitesProductType).BEACON,
    (0, $kSC7A.AvailableSitesProductType).COMPASS,
    (0, $kSC7A.AvailableSitesProductType).CONFLUENCE,
    (0, $kSC7A.AvailableSitesProductType).JIRA_BUSINESS,
    (0, $kSC7A.AvailableSitesProductType).JIRA_INCIDENT_MANAGER,
    (0, $kSC7A.AvailableSitesProductType).JIRA_PRODUCT_DISCOVERY,
    (0, $kSC7A.AvailableSitesProductType).JIRA_SERVICE_DESK,
    (0, $kSC7A.AvailableSitesProductType).JIRA_SOFTWARE,
    (0, $kSC7A.AvailableSitesProductType).MERCURY,
    (0, $kSC7A.AvailableSitesProductType).OPSGENIE,
    (0, $kSC7A.AvailableSitesProductType).STATUS_PAGE,
    (0, $kSC7A.AvailableSitesProductType).ATLAS,
    (0, $kSC7A.AvailableSitesProductType).LOOM
];
const $78f887db99bd3113$export$3738ff0cbe469211 = ({ gatewayBaseUrl: gatewayBaseUrl } = {})=>{
    const [state, setState] = (0, $42omo.useState)({
        data: [],
        loading: true
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const fetchSites = async ()=>{
            try {
                const { sites: sites } = await $78f887db99bd3113$var$getAvailableSites({
                    products: $78f887db99bd3113$var$defaultProducts,
                    gatewayBaseUrl: gatewayBaseUrl
                });
                setState({
                    data: sites,
                    loading: false,
                    error: undefined
                });
            } catch (err) {
                createAnalyticsEvent((0, $f8S0G.default)('operational.getAvailableSitesResolve.failed', (0, $6fCTI.getOperationFailedAttributes)(err))).fire((0, $hBNGD.ANALYTICS_CHANNEL));
                const error = err instanceof Error ? err : new Error('unknown error');
                setState({
                    data: [],
                    loading: false,
                    error: error
                });
            }
        };
        fetchSites();
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl
    ]);
    return state;
};
const $78f887db99bd3113$export$bd4055e8b60f8535 = (data)=>{
    const sites = [];
    data.products.forEach((product)=>{
        product.workspaces.forEach((workspace)=>{
            const currentSite = sites.find((site)=>site.cloudId === workspace.cloudId);
            if (currentSite) {
                currentSite.products.push(product.productId);
                return currentSite;
            }
            sites.push({
                avatarUrl: workspace.workspaceAvatarUrl,
                cloudId: workspace.cloudId,
                displayName: workspace.workspaceDisplayName,
                isVertigo: workspace.vortexMode === 'ENABLED',
                products: [
                    product.productId
                ],
                url: workspace.cloudUrl
            });
        });
    });
    return sites;
};
const $78f887db99bd3113$export$3f59b707a86875c4 = ({ gatewayBaseUrl: gatewayBaseUrl })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isMounted = (0, $bZKB2.useIsMounted)();
    const [state, setState] = (0, $42omo.useState)({
        data: [],
        loading: true
    });
    (0, $42omo.useEffect)(()=>{
        const fetchSites = async ()=>{
            try {
                const response = await $78f887db99bd3113$var$getAccessibleProducts({
                    products: $78f887db99bd3113$var$defaultProducts,
                    gatewayBaseUrl: gatewayBaseUrl
                });
                if (isMounted()) setState({
                    data: $78f887db99bd3113$export$bd4055e8b60f8535(response.data),
                    loading: false,
                    error: undefined
                });
            } catch (error) {
                if (isMounted()) setState({
                    data: [],
                    loading: false,
                    error: error
                });
            }
        };
        fetchSites();
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl,
        isMounted
    ]);
    return state;
};
async function $78f887db99bd3113$var$getAvailableSites({ products: products, gatewayBaseUrl: gatewayBaseUrl }) {
    const requestConfig = {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            products: products
        })
    };
    const response = await window.fetch(gatewayBaseUrl ? `${gatewayBaseUrl}/gateway/api/available-sites` : '/gateway/api/available-sites', requestConfig);
    if (response.ok) return response.json();
    throw response;
}
async function $78f887db99bd3113$var$getAccessibleProducts({ products: products, gatewayBaseUrl: gatewayBaseUrl }) {
    const requestConfig = {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            productIds: products,
            permissionIds: []
        })
    };
    const response = await window.fetch(gatewayBaseUrl ? `${gatewayBaseUrl}/gateway/api/v2/accessible-products` : '/gateway/api/v2/accessible-products', requestConfig);
    if (response.ok) return response.json();
    throw response;
}
module.exports["useAvailableSites"] = $78f887db99bd3113$export$3738ff0cbe469211;
module.exports["mapAccessibleProductsToAvailableSites"] = $78f887db99bd3113$export$bd4055e8b60f8535;
module.exports["useAvailableSitesV2"] = $78f887db99bd3113$export$3f59b707a86875c4;

});

parcelRegister("kSC7A", function(module, exports) {
var $2f440bf1e6112d68$export$16bdf84263b17cf0 = /*#__PURE__*/ function(AvailableSitesProductType) {
    AvailableSitesProductType["WHITEBOARD"] = "atlassian-whiteboard";
    AvailableSitesProductType["BEACON"] = "beacon";
    AvailableSitesProductType["COMPASS"] = "compass";
    AvailableSitesProductType["CONFLUENCE"] = "confluence.ondemand";
    AvailableSitesProductType["JIRA_BUSINESS"] = "jira-core.ondemand";
    AvailableSitesProductType["JIRA_INCIDENT_MANAGER"] = "jira-incident-manager.ondemand";
    AvailableSitesProductType["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
    AvailableSitesProductType["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    AvailableSitesProductType["JIRA_SOFTWARE"] = "jira-software.ondemand";
    AvailableSitesProductType["MERCURY"] = "mercury";
    AvailableSitesProductType["OPSGENIE"] = "opsgenie";
    AvailableSitesProductType["STATUS_PAGE"] = "statuspage";
    AvailableSitesProductType["ATLAS"] = "townsquare";
    AvailableSitesProductType["LOOM"] = "loom";
    return AvailableSitesProductType;
}({});
module.exports["AvailableSitesProductType"] = $2f440bf1e6112d68$export$16bdf84263b17cf0;

});

parcelRegister("f8S0G", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::6aeaf735bb1855a8d29ca67bd7a680b4>>
 * @codegenCommand yarn workspace @atlaskit/linking-common run codegen-analytics
 */ function $4a22b51dcbeecd57$var$createEventPayload(eventKey, attributes) {
    const event = eventKey.split('.');
    return {
        eventType: event[0],
        actionSubject: event[1],
        action: event[2],
        actionSubjectId: event[3],
        attributes: attributes
    };
}
var $4a22b51dcbeecd57$export$2e2bcd8739ae039 = $4a22b51dcbeecd57$var$createEventPayload;
module.exports["default"] = $4a22b51dcbeecd57$export$2e2bcd8739ae039;

});

parcelRegister("hBNGD", function(module, exports) {
const $eb5d052cb0327301$export$85183a312807388d = 'media';
const $eb5d052cb0327301$export$60efea3f80310017 = 'wide';
module.exports["ANALYTICS_CHANNEL"] = $eb5d052cb0327301$export$85183a312807388d;
module.exports["DATASOURCE_DEFAULT_LAYOUT"] = $eb5d052cb0327301$export$60efea3f80310017;

});

parcelRegister("bZKB2", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $d79b64f48ff0234f$export$80c2a3957bcb42ea() {
    const isMounted = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, $42omo.useCallback)(()=>isMounted.current, []);
}
module.exports["useIsMounted"] = $d79b64f48ff0234f$export$80c2a3957bcb42ea;

});

parcelRegister("6fCTI", function(module, exports) {

var $6mn0G = parcelRequire("6mn0G");

const $9cbe6bde573cd7a4$var$getUrlPath = (url)=>{
    try {
        return new URL(url).pathname;
    } catch  {
        return 'Failed to parse pathname from url';
    }
};
const $9cbe6bde573cd7a4$export$294520aca64d4e59 = (error)=>{
    if (error instanceof Response) return {
        traceId: (0, $6mn0G.getTraceId)(error),
        status: error.status,
        path: $9cbe6bde573cd7a4$var$getUrlPath(error.url)
    };
    return {
        traceId: null,
        status: null,
        path: null
    };
};
const $9cbe6bde573cd7a4$export$e19f9f08a6d79fd2 = (error)=>{
    if (error instanceof Response) return 'NetworkError';
    if (error instanceof Error) return error.name;
    return typeof error;
};
const $9cbe6bde573cd7a4$export$b2d107ab31565d0b = (err)=>{
    if (err instanceof Response) return {
        error: 'NetworkError',
        errorType: 'NetworkError',
        ...$9cbe6bde573cd7a4$export$294520aca64d4e59(err)
    };
    const error = err instanceof Error ? err : new Error('unknown error');
    return {
        error: error.name,
        errorType: error.name,
        traceId: null,
        status: null,
        path: null
    };
};
module.exports["getOperationFailedAttributes"] = $9cbe6bde573cd7a4$export$b2d107ab31565d0b;

});

parcelRegister("da71s", function(module, exports) {
$parcel$export(module.exports, "default", () => $9951a80eb1f73a12$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");

function $9951a80eb1f73a12$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $b5utg.default)(1, arguments);
    var additionalDigits = (0, $jZ39j.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $9951a80eb1f73a12$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $9951a80eb1f73a12$var$parseYear(dateStrings.date, additionalDigits);
        date = $9951a80eb1f73a12$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $9951a80eb1f73a12$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $9951a80eb1f73a12$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $9951a80eb1f73a12$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $9951a80eb1f73a12$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $9951a80eb1f73a12$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $9951a80eb1f73a12$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $9951a80eb1f73a12$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($9951a80eb1f73a12$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($9951a80eb1f73a12$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($9951a80eb1f73a12$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $9951a80eb1f73a12$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $9951a80eb1f73a12$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $9951a80eb1f73a12$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($9951a80eb1f73a12$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $9951a80eb1f73a12$var$parseDateUnit(captures[1]);
    var month = $9951a80eb1f73a12$var$parseDateUnit(captures[2]) - 1;
    var day = $9951a80eb1f73a12$var$parseDateUnit(captures[3]);
    var week = $9951a80eb1f73a12$var$parseDateUnit(captures[4]);
    var dayOfWeek = $9951a80eb1f73a12$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$9951a80eb1f73a12$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $9951a80eb1f73a12$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$9951a80eb1f73a12$var$validateDate(year, month, day) || !$9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $9951a80eb1f73a12$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $9951a80eb1f73a12$var$parseTime(timeString) {
    var captures = timeString.match($9951a80eb1f73a12$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $9951a80eb1f73a12$var$parseTimeUnit(captures[1]);
    var minutes = $9951a80eb1f73a12$var$parseTimeUnit(captures[2]);
    var seconds = $9951a80eb1f73a12$var$parseTimeUnit(captures[3]);
    if (!$9951a80eb1f73a12$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute) + seconds * 1000;
}
function $9951a80eb1f73a12$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $9951a80eb1f73a12$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($9951a80eb1f73a12$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$9951a80eb1f73a12$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute));
}
function $9951a80eb1f73a12$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $9951a80eb1f73a12$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $9951a80eb1f73a12$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $9951a80eb1f73a12$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($9951a80eb1f73a12$var$daysInMonths[month] || ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 29 : 28));
}
function $9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 366 : 365);
}
function $9951a80eb1f73a12$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $9951a80eb1f73a12$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $9951a80eb1f73a12$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("jx0NF", function(module, exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $e381b83e7c88ee8c$export$dfd9b671c89acc8e = 7;
var $e381b83e7c88ee8c$export$3913210603d8e9ae = 365.2425;
var $e381b83e7c88ee8c$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e381b83e7c88ee8c$export$91246f0b9bd9beff = 60000;
var $e381b83e7c88ee8c$export$7f72910d6dfd237a = 3600000;
var $e381b83e7c88ee8c$export$397c2d5776aa9055 = 1000;
var $e381b83e7c88ee8c$export$4dec998e48f9c246 = -$e381b83e7c88ee8c$export$81caae6e1cc7a622;
var $e381b83e7c88ee8c$export$f2f5ae5a8e2d8f9f = 60;
var $e381b83e7c88ee8c$export$3c58128db900d44e = 3;
var $e381b83e7c88ee8c$export$80d7e435f744f319 = 12;
var $e381b83e7c88ee8c$export$4db7641526e3241f = 4;
var $e381b83e7c88ee8c$export$698aec755e92c695 = 3600;
var $e381b83e7c88ee8c$export$a77c1a7ebebe2a5a = 60;
var $e381b83e7c88ee8c$export$815a9362476d2fe3 = $e381b83e7c88ee8c$export$698aec755e92c695 * 24;
var $e381b83e7c88ee8c$export$34804a017b31e2fe = $e381b83e7c88ee8c$export$815a9362476d2fe3 * 7;
var $e381b83e7c88ee8c$export$7271e9e3478110d1 = $e381b83e7c88ee8c$export$815a9362476d2fe3 * $e381b83e7c88ee8c$export$3913210603d8e9ae;
var $e381b83e7c88ee8c$export$8e6600bbdee7dabb = $e381b83e7c88ee8c$export$7271e9e3478110d1 / 12;
var $e381b83e7c88ee8c$export$be1dccf2de902d31 = $e381b83e7c88ee8c$export$8e6600bbdee7dabb * 3;
module.exports["millisecondsInMinute"] = $e381b83e7c88ee8c$export$91246f0b9bd9beff;
module.exports["millisecondsInHour"] = $e381b83e7c88ee8c$export$7f72910d6dfd237a;
module.exports["millisecondsInSecond"] = $e381b83e7c88ee8c$export$397c2d5776aa9055;

});

parcelRegister("cStGJ", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $9K4OG = parcelRequire("9K4OG");


var $g2YHK = parcelRequire("g2YHK");


var $dStU0 = parcelRequire("dStU0");


var $dmgN7 = parcelRequire("dmgN7");


var $42omo = parcelRequire("42omo");


var $c58zA = parcelRequire("c58zA");

var $96018e9e3b3d2b35$var$isDevelopment = false;
var $96018e9e3b3d2b35$var$testOmitPropsOnStringTag = (0, $c58zA.default);
var $96018e9e3b3d2b35$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $96018e9e3b3d2b35$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $96018e9e3b3d2b35$var$testOmitPropsOnStringTag : $96018e9e3b3d2b35$var$testOmitPropsOnComponent;
};
var $96018e9e3b3d2b35$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $96018e9e3b3d2b35$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $dmgN7.registerStyles)(cache, serialized, isStringTag);
    (0, $dStU0.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $dmgN7.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $96018e9e3b3d2b35$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $96018e9e3b3d2b35$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $96018e9e3b3d2b35$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $9K4OG.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $42omo.useContext((0, $9K4OG.ThemeContext));
            }
            if (typeof props.className === 'string') className = (0, $dmgN7.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $g2YHK.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $96018e9e3b3d2b35$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $42omo.createElement($42omo.Fragment, null, /*#__PURE__*/ $42omo.createElement($96018e9e3b3d2b35$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $42omo.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $96018e9e3b3d2b35$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $7Q5yr.default)({}, options, nextOptions, {
                shouldForwardProp: $96018e9e3b3d2b35$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};
module.exports["default"] = $96018e9e3b3d2b35$export$2e2bcd8739ae039;

});

parcelRegister("dStU0", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $a1a7838157a2757d$var$syncFallback = function syncFallback(create) {
    return create();
};
var $a1a7838157a2757d$var$useInsertionEffect = $42omo.useInsertionEffect ? $42omo.useInsertionEffect : false;
var $a1a7838157a2757d$export$db21c7ffa21794e7 = $a1a7838157a2757d$var$useInsertionEffect || $a1a7838157a2757d$var$syncFallback;
var $a1a7838157a2757d$export$811a713a7276cb9d = $a1a7838157a2757d$var$useInsertionEffect || $42omo.useLayoutEffect;
module.exports["useInsertionEffectAlwaysWithSyncFallback"] = $a1a7838157a2757d$export$db21c7ffa21794e7;

});

parcelRegister("c58zA", function(module, exports) {

var $9bLS2 = parcelRequire("9bLS2");

// eslint-disable-next-line no-undef
var $8cbc9a10962c1be8$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $8cbc9a10962c1be8$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9bLS2.default)(function(prop) {
    return $8cbc9a10962c1be8$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
module.exports["default"] = $8cbc9a10962c1be8$export$2e2bcd8739ae039;

});

parcelRegister("8Yfbq", function(module, exports) {

var $jSnXV = parcelRequire("jSnXV");


var $lc9ud = parcelRequire("lc9ud");

/** Error message constants. */ var $687fb4659a5afde2$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $687fb4659a5afde2$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($687fb4659a5afde2$var$FUNC_ERROR_TEXT);
    if ($lc9ud(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $jSnXV(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
module.exports = $687fb4659a5afde2$var$throttle;

});

parcelRegister("bqMS3", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $6mYMS = parcelRequire("6mYMS");


var $jaPjp = parcelRequire("jaPjp");


var $3jsXx = parcelRequire("3jsXx");


var $jSnXV = parcelRequire("jSnXV");

const $298721003a2aaba7$var$MAX_QUERY_ITEMS = 100;
const $298721003a2aaba7$var$MAX_NOTIFIED_ITEMS = 20;
const $298721003a2aaba7$var$emptySecurityProvider = ()=>{
    return {
        params: {},
        headers: {}
    };
};
class $298721003a2aaba7$export$4529f10aed0950d4 {
    subscribe(key, callback, errCallback, infoCallback, allResultsCallback, analyticsListeners) {
        if (callback) this.changeListeners.set(key, callback);
        if (errCallback) this.errListeners.set(key, errCallback);
        if (infoCallback) this.infoListeners.set(key, infoCallback);
        if (allResultsCallback) this.allResultsListeners.set(key, allResultsCallback);
        if (analyticsListeners) this.analyticsListeners.set(key, analyticsListeners);
    }
    unsubscribe(key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
        this.analyticsListeners.delete(key);
    }
    constructor(){
        this.changeListeners = void 0;
        this.errListeners = void 0;
        this.infoListeners = void 0;
        this.allResultsListeners = void 0;
        this.analyticsListeners = void 0;
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
        this.analyticsListeners = new Map();
    }
}
class $298721003a2aaba7$export$8576ba1ed2760927 extends $298721003a2aaba7$export$4529f10aed0950d4 {
    shouldHighlightMention(_mention) {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    filter(query) {
        throw new Error(`not yet implemented.\nParams: query=${query}`);
    }
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    recordMentionSelection(_mention) {
    // Do nothing
    }
    isFiltering(_query) {
        return false;
    }
    _notifyListeners(mentionsResult, stats) {
        (0, $jaPjp.default)('ak-mention-resource._notifyListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $298721003a2aaba7$var$MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAllResultsListeners(mentionsResult) {
        (0, $jaPjp.default)('ak-mention-resource._notifyAllResultsListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $298721003a2aaba7$var$MAX_NOTIFIED_ITEMS), mentionsResult.query);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyErrorListeners(error, query) {
        this.errListeners.forEach((listener, key)=>{
            try {
                listener(error, query);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyInfoListeners(info) {
        this.infoListeners.forEach((listener, key)=>{
            try {
                listener(info);
            } catch (e) {
                // ignore error fromr listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAnalyticsListeners(event, actionSubject, action, attributes) {
        this.analyticsListeners.forEach((listener, key)=>{
            try {
                listener(event, actionSubject, action, attributes);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $298721003a2aaba7$export$5a4331e3e1c43553 extends $298721003a2aaba7$export$8576ba1ed2760927 {
    shouldHighlightMention(mention) {
        if (this.config.shouldHighlightMention) return this.config.shouldHighlightMention(mention);
        return false;
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        } else {
            const date = new Date(searchTime).toISOString().substr(17, 6);
            (0, $jaPjp.default)('Stale search result, skipping', date, query); // eslint-disable-line no-console, max-len
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
        if (query) this.activeSearches.delete(query);
    }
    async filter(query, contextIdentifier) {
        try {
            const searchTime = Date.now();
            let results;
            if (!query) results = await this.initialState(contextIdentifier);
            else {
                this.activeSearches.add(query);
                const searchResponse = this.search(query, contextIdentifier);
                results = await searchResponse.mentions;
            }
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    resolveMentionName(id) {
        if (!this.config.mentionNameResolver) return {
            id: id,
            name: '',
            status: (0, $6mYMS.MentionNameStatus).UNKNOWN
        };
        return this.config.mentionNameResolver.lookupName(id);
    }
    cacheMentionName(id, mentionName) {
        if (!this.config.mentionNameResolver) return;
        this.config.mentionNameResolver.cacheName(id, mentionName);
    }
    supportsMentionNameResolving() {
        return !!this.config.mentionNameResolver;
    }
    updateActiveSearches(query) {
        this.activeSearches.add(query);
    }
    verifyMentionConfig(config) {
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.securityProvider) config.securityProvider = $298721003a2aaba7$var$emptySecurityProvider;
    }
    initialState(contextIdentifier) {
        return this.remoteInitialState(contextIdentifier);
    }
    /**
   * Clear a context object to generate query params by removing empty
   * strings, `undefined` and empty values.
   *
   * @param contextIdentifier the current context identifier
   * @returns a safe context for query encoding
   */ clearContext(contextIdentifier = {}) {
        return Object.keys(contextIdentifier).filter((key)=>contextIdentifier[key]).reduce((context, key)=>({
                [key]: contextIdentifier[key],
                ...context
            }), {});
    }
    getQueryParams(contextIdentifier) {
        const configParams = {};
        if (this.config.containerId) configParams['containerId'] = this.config.containerId;
        if (this.config.productId) configParams['productIdentifier'] = this.config.productId;
        // if contextParams exist then it will override configParams for containerId
        return {
            ...configParams,
            ...this.clearContext(contextIdentifier)
        };
    }
    /**
   * Returns the initial mention display list before a search is performed for the specified
   * container.
   *
   * @param contextIdentifier
   * @returns Promise
   */ async remoteInitialState(contextIdentifier) {
        const queryParams = this.getQueryParams(contextIdentifier);
        const options = {
            path: 'bootstrap',
            queryParams: queryParams
        };
        try {
            const result = await (0, $dwp40.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).INITIAL_STATE, (0, $6mYMS.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, '');
        } catch (error) {
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).INITIAL_STATE, (0, $6mYMS.Actions).FAILED);
            throw error;
        }
    }
    search(query, contextIdentifier) {
        return {
            mentions: this.remoteSearch(query, contextIdentifier)
        };
    }
    async remoteSearch(query, contextIdentifier) {
        const options = {
            path: 'search',
            queryParams: {
                query: query,
                limit: $298721003a2aaba7$var$MAX_QUERY_ITEMS,
                ...this.getQueryParams(contextIdentifier)
            }
        };
        try {
            const result = await (0, $dwp40.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).SEARCH, (0, $6mYMS.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, query);
        } catch (error) {
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).SEARCH, (0, $6mYMS.Actions).FAILED);
            throw error;
        }
    }
    transformServiceResponse(result, query) {
        const mentions = result.mentions.map((mention)=>{
            let lozenge;
            if ((0, $6mYMS.isAppMention)(mention)) lozenge = mention.userType;
            else if ((0, $6mYMS.isTeamMention)(mention)) lozenge = mention.userType;
            return {
                ...mention,
                lozenge: lozenge,
                query: query
            };
        });
        return {
            ...result,
            mentions: mentions,
            query: result.query || query
        };
    }
    constructor(config){
        super();
        this.config = void 0;
        this.lastReturnedSearch = void 0;
        this.activeSearches = void 0;
        this.productName = void 0;
        this.shouldEnableInvite = void 0;
        this.userRole = void 0;
        this.onInviteItemClick = void 0;
        this.inviteXProductUser = void 0;
        this.verifyMentionConfig(config);
        this.config = config;
        this.lastReturnedSearch = 0;
        this.activeSearches = new Set();
        this.productName = config.productName;
        this.shouldEnableInvite = !!config.shouldEnableInvite;
        this.onInviteItemClick = config.onInviteItemClick;
        this.inviteXProductUser = config.inviteXProductUser;
        this.userRole = config.userRole || 'basic';
        if (this.config.debounceTime) this.filter = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(this.filter, this.config.debounceTime);
    }
}
class $298721003a2aaba7$export$65bd6083489bd8bb {
    constructor(statusCode, statusMessage){
        this.name = void 0;
        this.message = void 0;
        this.statusCode = void 0;
        this.stack = void 0;
        this.statusCode = statusCode;
        this.message = statusMessage;
        this.name = 'HttpError';
        this.stack = new Error().stack;
    }
}
const $298721003a2aaba7$export$ae1fce5f69858ef3 = (p)=>!!(p && p.supportsMentionNameResolving && p.supportsMentionNameResolving());
var $298721003a2aaba7$export$2e2bcd8739ae039 = $298721003a2aaba7$export$5a4331e3e1c43553;
module.exports["AbstractResource"] = $298721003a2aaba7$export$4529f10aed0950d4;
module.exports["AbstractMentionResource"] = $298721003a2aaba7$export$8576ba1ed2760927;
module.exports["isResolvingMentionProvider"] = $298721003a2aaba7$export$ae1fce5f69858ef3;
module.exports["default"] = $298721003a2aaba7$export$2e2bcd8739ae039;

});

parcelRegister("6mYMS", function(module, exports) {
var $4e350b6bba0e5c59$export$2102863a3c660c6b = /*#__PURE__*/ function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    return MentionType;
}({});
var $4e350b6bba0e5c59$export$81124e6148ca5db0 = /*#__PURE__*/ function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    return UserAccessLevel;
}({});
var $4e350b6bba0e5c59$export$8436e53e45ffe15b = /*#__PURE__*/ function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    return UserType;
}({});
var $4e350b6bba0e5c59$export$7afb0727c7d7e8af = /*#__PURE__*/ function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
    return SliNames;
}({});
var $4e350b6bba0e5c59$export$5c42d9dea6d035c1 = /*#__PURE__*/ function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
    return ComponentNames;
}({});
var $4e350b6bba0e5c59$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
    return Actions;
}({});
var $4e350b6bba0e5c59$export$b8fa67dc54502853 = /*#__PURE__*/ function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    return MentionNameStatus;
}({});
function $4e350b6bba0e5c59$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === $4e350b6bba0e5c59$export$81124e6148ca5db0[0];
}
function $4e350b6bba0e5c59$export$37b8dcac6198c514(mention) {
    return !!mention.userType && mention.userType === $4e350b6bba0e5c59$export$8436e53e45ffe15b[1];
}
function $4e350b6bba0e5c59$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === $4e350b6bba0e5c59$export$8436e53e45ffe15b[2];
}
function $4e350b6bba0e5c59$export$803b1379348dbfd5(mention) {
    return mention.userType && mention.userType === $4e350b6bba0e5c59$export$8436e53e45ffe15b[3];
}
function $4e350b6bba0e5c59$export$d13d4f976b36a397(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
const $4e350b6bba0e5c59$export$4369c812aac99591 = (p)=>!!(p && p.then);
module.exports["MentionType"] = $4e350b6bba0e5c59$export$2102863a3c660c6b;
module.exports["UserAccessLevel"] = $4e350b6bba0e5c59$export$81124e6148ca5db0;
module.exports["UserType"] = $4e350b6bba0e5c59$export$8436e53e45ffe15b;
module.exports["SliNames"] = $4e350b6bba0e5c59$export$7afb0727c7d7e8af;
module.exports["ComponentNames"] = $4e350b6bba0e5c59$export$5c42d9dea6d035c1;
module.exports["Actions"] = $4e350b6bba0e5c59$export$b52183d5cfb26dc9;
module.exports["MentionNameStatus"] = $4e350b6bba0e5c59$export$b8fa67dc54502853;
module.exports["isRestricted"] = $4e350b6bba0e5c59$export$dbaa15dc1820b89a;
module.exports["isSpecialMention"] = $4e350b6bba0e5c59$export$37b8dcac6198c514;
module.exports["isAppMention"] = $4e350b6bba0e5c59$export$eb590c844d13454c;
module.exports["isTeamMention"] = $4e350b6bba0e5c59$export$803b1379348dbfd5;
module.exports["isSpecialMentionText"] = $4e350b6bba0e5c59$export$d13d4f976b36a397;
module.exports["isPromise"] = $4e350b6bba0e5c59$export$4369c812aac99591;

});

parcelRegister("jaPjp", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7f0f11694d4a0f0$export$2e2bcd8739ae039);
let $f7f0f11694d4a0f0$var$debugEnabled = false;
let $f7f0f11694d4a0f0$var$stacktracesEnabled = false;
function $f7f0f11694d4a0f0$export$748ada60eaf985cc(enable) {
    $f7f0f11694d4a0f0$var$debugEnabled = enable;
}
function $f7f0f11694d4a0f0$export$4f7017086af31c25(enable) {
    $f7f0f11694d4a0f0$var$stacktracesEnabled = enable;
}
function $f7f0f11694d4a0f0$export$2a858f450a2f66d() {
    if ($f7f0f11694d4a0f0$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $f7f0f11694d4a0f0$export$2e2bcd8739ae039(msg, ...args) {
    if ($f7f0f11694d4a0f0$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("3jsXx", function(module, exports) {

var $7TH2w = parcelRequire("7TH2w");


var $ElsUb = parcelRequire("ElsUb");


var $6mYMS = parcelRequire("6mYMS");

const $43ca455672da960d$var$packageName = "platform-pkg";
const $43ca455672da960d$var$packageVersion = "0.0.0-use.local";
const $43ca455672da960d$export$245097525aef1262 = 'sli';
const $43ca455672da960d$export$c724588856bbfbcf = 'smart';
const $43ca455672da960d$export$a823474ae5cb9e9c = (props)=>(action, duration, userIds = [], query)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $6mYMS.ComponentNames).TYPEAHEAD,
                attributes: {
                    packageName: $43ca455672da960d$var$packageName,
                    packageVersion: $43ca455672da960d$var$packageVersion,
                    componentName: (0, $6mYMS.ComponentNames).MENTION,
                    duration: Math.round(duration),
                    userIds: userIds,
                    queryLength: query ? query.length : 0
                },
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ElsUb.ELEMENTS_CHANNEL));
        }
    };
const $43ca455672da960d$export$44902bc7b3f0b09f = (createEvent)=>(actionSubject, action, text, id, accessLevel)=>{
        const payload = {
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $7TH2w.UI_EVENT_TYPE),
            attributes: {
                packageName: $43ca455672da960d$var$packageName,
                packageVersion: $43ca455672da960d$var$packageVersion,
                componentName: (0, $6mYMS.ComponentNames).MENTION,
                accessLevel: accessLevel,
                isSpecial: (0, $6mYMS.isSpecialMentionText)(text),
                userId: id
            }
        };
        const event = createEvent(payload);
        event.fire((0, $ElsUb.ELEMENTS_CHANNEL));
        return event;
    };
const $43ca455672da960d$export$c8b245b690e10169 = (props)=>(actionSubject, action)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = $43ca455672da960d$export$c357a2872628de7c(actionSubject, action);
            props.createAnalyticsEvent(eventPayload).fire((0, $ElsUb.ELEMENTS_CHANNEL));
        }
    };
const $43ca455672da960d$export$c357a2872628de7c = (actionSubject, action, attributes)=>{
    const eventPayload = {
        action: action,
        actionSubject: actionSubject,
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        attributes: {
            packageName: $43ca455672da960d$var$packageName,
            packageVersion: $43ca455672da960d$var$packageVersion,
            componentName: (0, $6mYMS.ComponentNames).MENTION,
            ...attributes
        }
    };
    return eventPayload;
};
const $43ca455672da960d$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $6mYMS.ComponentNames).MENTION,
                actionSubjectId: 'hydration',
                attributes: {
                    packageName: $43ca455672da960d$var$packageName,
                    packageVersion: $43ca455672da960d$var$packageVersion,
                    componentName: (0, $6mYMS.ComponentNames).MENTION,
                    userId: userId,
                    fromCache: fromCache,
                    duration: Math.round(duration)
                },
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ElsUb.ELEMENTS_CHANNEL));
        }
    };
// OLD Analytics
const $43ca455672da960d$var$MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
const $43ca455672da960d$export$34ac71ce24cddec2 = (firePrivateAnalyticsEvent)=>(eventName, text, accessLevel)=>{
        if (firePrivateAnalyticsEvent) firePrivateAnalyticsEvent(`${$43ca455672da960d$var$MENTION_ANALYTICS_PREFIX}.${eventName}`, {
            accessLevel: accessLevel,
            isSpecial: (0, $6mYMS.isSpecialMentionText)(text)
        });
    };
module.exports["SLI_EVENT_TYPE"] = $43ca455672da960d$export$245097525aef1262;
module.exports["SMART_EVENT_TYPE"] = $43ca455672da960d$export$c724588856bbfbcf;
module.exports["fireAnalyticsMentionTypeaheadEvent"] = $43ca455672da960d$export$a823474ae5cb9e9c;
module.exports["fireAnalyticsMentionEvent"] = $43ca455672da960d$export$44902bc7b3f0b09f;
module.exports["fireSliAnalyticsEvent"] = $43ca455672da960d$export$c8b245b690e10169;
module.exports["fireAnalyticsMentionHydrationEvent"] = $43ca455672da960d$export$91b2fa6a0fe06408;

});

parcelRegister("ElsUb", function(module, exports) {
const $cc0765a5d08d319a$export$d821aa4c8afb384e = 'fabric-elements';
module.exports["ELEMENTS_CHANNEL"] = $cc0765a5d08d319a$export$d821aa4c8afb384e;

});

parcelRegister("i0btU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");

var $8C5kA = parcelRequire("8C5kA");


var $bwC67 = parcelRequire("bwC67");

const $806263e9564ebacc$var$EMPTY = {};
const $806263e9564ebacc$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState($806263e9564ebacc$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        let aborted = false;
        setMessages($806263e9564ebacc$var$EMPTY);
        (0, $bwC67.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $806263e9564ebacc$var$MessagesIntlProvider = (props)=>{
    const { children: children } = props;
    const intl = (0, $8C5kA.default)();
    const messages = $806263e9564ebacc$var$useI18n(intl.locale);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1e2E5.default), {
        ...intl,
        messages: messages
    }, children);
};
var $806263e9564ebacc$export$2e2bcd8739ae039 = $806263e9564ebacc$var$MessagesIntlProvider;
module.exports["default"] = $806263e9564ebacc$export$2e2bcd8739ae039;

});

parcelRegister("bwC67", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $gjAAG = parcelRequire("gjAAG");

const $1cb8431546098045$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
        const { formatMessage: formatMessage } = (0, $8C5kA.default)();
        const message = formatMessage(messageDescriptor, values);
        if (typeof children === 'function') return children(message);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            values: values,
            ...messageDescriptor
        });
    };
const $1cb8431546098045$export$98e06fe7a6174253 = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).unknownUserError);
const $1cb8431546098045$export$58bd5a2057b6b855 = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).noAccessWarning);
const $1cb8431546098045$export$da9f8ce14593162f = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).noAccessLabel);
const $1cb8431546098045$export$4a258ffee7316766 = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).defaultHeadline);
const $1cb8431546098045$export$702321a50d74536e = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).defaultAdvisedAction);
const $1cb8431546098045$export$ed7f16088a93ae9d = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).loginAgain);
const $1cb8431546098045$export$3ab158df56460d1c = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).differentText);































const $1cb8431546098045$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("gc0Sn")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("hcZqU")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("aOvw3")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("5twea")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("6MZNH")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("2Uiuu")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("2uKrW")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("8ZVHr")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("fPG5T")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("2G88k")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("eK5ZS")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("dJ6Pi")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("aWbdl")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("ixJvt")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("cqdNY")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("kue1N")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("i6Vz0")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("5yoki")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("5JAzL")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("eD8co")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("kjxyJ")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("iO2Mq")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("dVKWy")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("4CuhE")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("dct7i")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("cz3Nf")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("9677e")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("lksJj")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("QyjlH")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("bljzq")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $1cb8431546098045$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("5twea")).then((mod)=>mod.default);
            }
    }
};
module.exports["UnknownUserError"] = $1cb8431546098045$export$98e06fe7a6174253;
module.exports["NoAccessWarning"] = $1cb8431546098045$export$58bd5a2057b6b855;
module.exports["NoAccessLabel"] = $1cb8431546098045$export$da9f8ce14593162f;
module.exports["DefaultHeadline"] = $1cb8431546098045$export$4a258ffee7316766;
module.exports["DefaultAdvisedAction"] = $1cb8431546098045$export$702321a50d74536e;
module.exports["LoginAgain"] = $1cb8431546098045$export$ed7f16088a93ae9d;
module.exports["DifferentText"] = $1cb8431546098045$export$3ab158df56460d1c;
module.exports["getMessagesForLocale"] = $1cb8431546098045$export$d0a3169680473b6c;

});

parcelRegister("gjAAG", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $898c0db98da1400a$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    unknownUserError: {
        id: "fabric.mention.unknow.user.error",
        defaultMessage: "Unknown user {userId}"
    },
    noAccessWarning: {
        id: "fabric.mention.noAccess.warning",
        defaultMessage: "{name} won't be notified as they have no access"
    },
    noAccessLabel: {
        id: "fabric.mention.noAccess.label",
        defaultMessage: "No access"
    },
    defaultHeadline: {
        id: "fabric.mention.error.defaultHeadline",
        defaultMessage: "Something went wrong"
    },
    defaultAdvisedAction: {
        id: "fabric.mention.error.defaultAction",
        defaultMessage: "Try again in a few seconds"
    },
    loginAgain: {
        id: "fabric.mention.error.loginAgain",
        defaultMessage: "Try logging out then in again"
    },
    differentText: {
        id: "fabric.mention.error.differentText",
        defaultMessage: "Try entering different text"
    },
    memberCountWithoutYou: {
        id: "fabric.elements.mentions.team.member.count",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}"
    },
    memberCountWithYou: {
        id: "fabric.elements.mentions.team.member.count.including.you",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you"
    },
    plus50MembersWithoutYou: {
        id: "fabric.elements.mentions.team.member.50plus",
        defaultMessage: "Team \u2022 50+ members"
    },
    plus50MembersWithYou: {
        id: "fabric.elements.mentions.team.member.50plus.including.you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    xProductMentionDescription: {
        id: "fabric.elements.mentions.xproduct.mention.description",
        defaultMessage: "Needs access to Confluence"
    }
});
module.exports["messages"] = $898c0db98da1400a$export$defe85febe8b728c;

});

parcelRegister("gc0Sn", function(module, exports) {

let $bc9e725213fc1860$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bc9e725213fc1860$var$load("4Mixi"),
    $bc9e725213fc1860$var$load("1jsQH"),
    $bc9e725213fc1860$var$load("bv8GZ"),
    $bc9e725213fc1860$var$load("i5eMd"),
    $bc9e725213fc1860$var$load("4DYJ5"),
    $bc9e725213fc1860$var$load("gyXEE"),
    $bc9e725213fc1860$var$load("hoPZ9")
]).then(()=>parcelRequire('6Yuab'));

});

parcelRegister("hcZqU", function(module, exports) {

let $c87335f8193b858e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c87335f8193b858e$var$load("cjveN"),
    $c87335f8193b858e$var$load("deyvi"),
    $c87335f8193b858e$var$load("cdeuH"),
    $c87335f8193b858e$var$load("4UPfH"),
    $c87335f8193b858e$var$load("hfFxJ"),
    $c87335f8193b858e$var$load("1Mp9N"),
    $c87335f8193b858e$var$load("2Fu3d")
]).then(()=>parcelRequire('biDFC'));

});

parcelRegister("aOvw3", function(module, exports) {

let $7df705563369f7c9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7df705563369f7c9$var$load("8XGJb"),
    $7df705563369f7c9$var$load("6dERU"),
    $7df705563369f7c9$var$load("7gF8f"),
    $7df705563369f7c9$var$load("gd4qs"),
    $7df705563369f7c9$var$load("gofGr"),
    $7df705563369f7c9$var$load("dBb6q"),
    $7df705563369f7c9$var$load("eJgH8")
]).then(()=>parcelRequire('e7zr1'));

});

parcelRegister("5twea", function(module, exports) {

let $3fc8a8e755b35ba7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3fc8a8e755b35ba7$var$load("2YffH").then(()=>parcelRequire('gbdrY'));

});

parcelRegister("6MZNH", function(module, exports) {

let $4f172a150f653863$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4f172a150f653863$var$load("hdvZr"),
    $4f172a150f653863$var$load("kTurq"),
    $4f172a150f653863$var$load("djb49"),
    $4f172a150f653863$var$load("fviv5"),
    $4f172a150f653863$var$load("2RQvP"),
    $4f172a150f653863$var$load("7Lkvk")
]).then(()=>parcelRequire('4ykQ2'));

});

parcelRegister("2Uiuu", function(module, exports) {

let $21df27994f190a89$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $21df27994f190a89$var$load("4ViGN"),
    $21df27994f190a89$var$load("j0PWv"),
    $21df27994f190a89$var$load("ksTQ6"),
    $21df27994f190a89$var$load("eBoC7"),
    $21df27994f190a89$var$load("7NpX8"),
    $21df27994f190a89$var$load("cukQS"),
    $21df27994f190a89$var$load("5FaEJ")
]).then(()=>parcelRequire('4FRcU'));

});

parcelRegister("2uKrW", function(module, exports) {

let $1d126a0b05e5aec8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1d126a0b05e5aec8$var$load("32vlK"),
    $1d126a0b05e5aec8$var$load("dlmud"),
    $1d126a0b05e5aec8$var$load("5CGnz"),
    $1d126a0b05e5aec8$var$load("bNv64"),
    $1d126a0b05e5aec8$var$load("bFU3Y"),
    $1d126a0b05e5aec8$var$load("3CucM"),
    $1d126a0b05e5aec8$var$load("9yemY")
]).then(()=>parcelRequire('bG4aH'));

});

parcelRegister("8ZVHr", function(module, exports) {

let $68d0c72d3e46e583$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $68d0c72d3e46e583$var$load("7snhF"),
    $68d0c72d3e46e583$var$load("X0Jic"),
    $68d0c72d3e46e583$var$load("bAoKR"),
    $68d0c72d3e46e583$var$load("5IaSN")
]).then(()=>parcelRequire('kVRsY'));

});

parcelRegister("fPG5T", function(module, exports) {

let $b86c45698d9f7cb3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b86c45698d9f7cb3$var$load("bjoGV"),
    $b86c45698d9f7cb3$var$load("cbkj0"),
    $b86c45698d9f7cb3$var$load("9Oxgj"),
    $b86c45698d9f7cb3$var$load("4Afgd"),
    $b86c45698d9f7cb3$var$load("exaJ2"),
    $b86c45698d9f7cb3$var$load("lp8Wm"),
    $b86c45698d9f7cb3$var$load("l2LZP")
]).then(()=>parcelRequire('FrZOj'));

});

parcelRegister("2G88k", function(module, exports) {

let $1f35d0269ed342f5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1f35d0269ed342f5$var$load("8oiz7"),
    $1f35d0269ed342f5$var$load("17m16"),
    $1f35d0269ed342f5$var$load("kAg8V"),
    $1f35d0269ed342f5$var$load("cMubu"),
    $1f35d0269ed342f5$var$load("hcCcg"),
    $1f35d0269ed342f5$var$load("cHWSM"),
    $1f35d0269ed342f5$var$load("35Ssm")
]).then(()=>parcelRequire('225Fx'));

});

parcelRegister("eK5ZS", function(module, exports) {

let $abba03711e07d60b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $abba03711e07d60b$var$load("hFxmj"),
    $abba03711e07d60b$var$load("b4NO6"),
    $abba03711e07d60b$var$load("fM2oh"),
    $abba03711e07d60b$var$load("3fLE9"),
    $abba03711e07d60b$var$load("j9KTb"),
    $abba03711e07d60b$var$load("b37xN"),
    $abba03711e07d60b$var$load("ik6u5")
]).then(()=>parcelRequire('alG1N'));

});

parcelRegister("dJ6Pi", function(module, exports) {

let $9fe4c5e3bbeeb3c3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9fe4c5e3bbeeb3c3$var$load("fModo").then(()=>parcelRequire('lQyzT'));

});

parcelRegister("aWbdl", function(module, exports) {

let $7f68051353093946$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7f68051353093946$var$load("BXOZB"),
    $7f68051353093946$var$load("1K1Fj"),
    $7f68051353093946$var$load("xnqy2"),
    $7f68051353093946$var$load("8hOn0"),
    $7f68051353093946$var$load("3hjAq"),
    $7f68051353093946$var$load("7PjNK"),
    $7f68051353093946$var$load("Vt6S9")
]).then(()=>parcelRequire('gSUUF'));

});

parcelRegister("ixJvt", function(module, exports) {

let $d7fe9bb6f09886dc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d7fe9bb6f09886dc$var$load("9Xiuh"),
    $d7fe9bb6f09886dc$var$load("38sfA"),
    $d7fe9bb6f09886dc$var$load("awkVi"),
    $d7fe9bb6f09886dc$var$load("h4OCL"),
    $d7fe9bb6f09886dc$var$load("2bCHJ"),
    $d7fe9bb6f09886dc$var$load("ktSfi"),
    $d7fe9bb6f09886dc$var$load("9GZ76")
]).then(()=>parcelRequire('cF55v'));

});

parcelRegister("cqdNY", function(module, exports) {

let $90b29f1c573026bb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $90b29f1c573026bb$var$load("7Odo3"),
    $90b29f1c573026bb$var$load("bjmre"),
    $90b29f1c573026bb$var$load("11DLa"),
    $90b29f1c573026bb$var$load("bcQs2"),
    $90b29f1c573026bb$var$load("fdXnq"),
    $90b29f1c573026bb$var$load("iouLY"),
    $90b29f1c573026bb$var$load("4sOIV")
]).then(()=>parcelRequire('4IbNl'));

});

parcelRegister("kue1N", function(module, exports) {

let $eea17da0a05dcf3d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $eea17da0a05dcf3d$var$load("4VkvT"),
    $eea17da0a05dcf3d$var$load("asvK9"),
    $eea17da0a05dcf3d$var$load("barSq"),
    $eea17da0a05dcf3d$var$load("aBa7j"),
    $eea17da0a05dcf3d$var$load("cItJR"),
    $eea17da0a05dcf3d$var$load("hPZE5"),
    $eea17da0a05dcf3d$var$load("QTjdE")
]).then(()=>parcelRequire('jKge3'));

});

parcelRegister("i6Vz0", function(module, exports) {

let $d2f570796bc265af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d2f570796bc265af$var$load("g5qJV"),
    $d2f570796bc265af$var$load("7v6wU"),
    $d2f570796bc265af$var$load("a8heY"),
    $d2f570796bc265af$var$load("b544F"),
    $d2f570796bc265af$var$load("SctKm"),
    $d2f570796bc265af$var$load("dzIm8"),
    $d2f570796bc265af$var$load("hrf1M")
]).then(()=>parcelRequire('lGLcJ'));

});

parcelRegister("5yoki", function(module, exports) {

let $40b2ff6c7676afac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $40b2ff6c7676afac$var$load("dPa6p"),
    $40b2ff6c7676afac$var$load("aEpRh"),
    $40b2ff6c7676afac$var$load("6hlNE"),
    $40b2ff6c7676afac$var$load("K6fhx"),
    $40b2ff6c7676afac$var$load("1fJz1"),
    $40b2ff6c7676afac$var$load("jqwnR"),
    $40b2ff6c7676afac$var$load("lsloj")
]).then(()=>parcelRequire('d7PIu'));

});

parcelRegister("5JAzL", function(module, exports) {

let $42cd86e7efc12666$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $42cd86e7efc12666$var$load("iG4uh"),
    $42cd86e7efc12666$var$load("3fuR9"),
    $42cd86e7efc12666$var$load("2bqSD"),
    $42cd86e7efc12666$var$load("gZU54"),
    $42cd86e7efc12666$var$load("9yA8o"),
    $42cd86e7efc12666$var$load("bGhLc"),
    $42cd86e7efc12666$var$load("iRKhU")
]).then(()=>parcelRequire('jwd3r'));

});

parcelRegister("eD8co", function(module, exports) {

let $aa6b115a311b9fd0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa6b115a311b9fd0$var$load("aGECO").then(()=>parcelRequire('c2Dmg'));

});

parcelRegister("kjxyJ", function(module, exports) {

let $ec9f9d22a0e12245$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ec9f9d22a0e12245$var$load("bSjyK"),
    $ec9f9d22a0e12245$var$load("j6IGj"),
    $ec9f9d22a0e12245$var$load("hlJc4"),
    $ec9f9d22a0e12245$var$load("aOdaf")
]).then(()=>parcelRequire('l9Ug4'));

});

parcelRegister("iO2Mq", function(module, exports) {

let $db0f0d95377eff3a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $db0f0d95377eff3a$var$load("9tVE8"),
    $db0f0d95377eff3a$var$load("fMrUo"),
    $db0f0d95377eff3a$var$load("bJykp"),
    $db0f0d95377eff3a$var$load("4Wdqb"),
    $db0f0d95377eff3a$var$load("448N7"),
    $db0f0d95377eff3a$var$load("9v6ER"),
    $db0f0d95377eff3a$var$load("aEAsN")
]).then(()=>parcelRequire('fkCIe'));

});

parcelRegister("dVKWy", function(module, exports) {

let $a245033a20d44784$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a245033a20d44784$var$load("5WkxF").then(()=>parcelRequire('hW2zm'));

});

parcelRegister("4CuhE", function(module, exports) {

let $35d233bcb00da461$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $35d233bcb00da461$var$load("6UAlo"),
    $35d233bcb00da461$var$load("9eNkX"),
    $35d233bcb00da461$var$load("dh2Er"),
    $35d233bcb00da461$var$load("k10Cs"),
    $35d233bcb00da461$var$load("gBDdh"),
    $35d233bcb00da461$var$load("8Mz40"),
    $35d233bcb00da461$var$load("l6YHr")
]).then(()=>parcelRequire('gR0Ux'));

});

parcelRegister("dct7i", function(module, exports) {

let $99c2fb5138729985$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99c2fb5138729985$var$load("l7PQP").then(()=>parcelRequire('bRxNE'));

});

parcelRegister("cz3Nf", function(module, exports) {

let $925bb22c48477eb2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $925bb22c48477eb2$var$load("9Yw4z"),
    $925bb22c48477eb2$var$load("h0uBE"),
    $925bb22c48477eb2$var$load("eBLgB"),
    $925bb22c48477eb2$var$load("1n8w9"),
    $925bb22c48477eb2$var$load("6NHX3"),
    $925bb22c48477eb2$var$load("77dzh")
]).then(()=>parcelRequire('4dnaM'));

});

parcelRegister("9677e", function(module, exports) {

let $69fa319b49dca515$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $69fa319b49dca515$var$load("fLjHM").then(()=>parcelRequire('2qq54'));

});

parcelRegister("lksJj", function(module, exports) {

let $f871c05e7ad2e071$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f871c05e7ad2e071$var$load("3YGga").then(()=>parcelRequire('7iyzo'));

});

parcelRegister("QyjlH", function(module, exports) {

let $09df78e8bc3317cb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $09df78e8bc3317cb$var$load("ia9y3"),
    $09df78e8bc3317cb$var$load("j9OUx"),
    $09df78e8bc3317cb$var$load("bV8sS"),
    $09df78e8bc3317cb$var$load("l079e"),
    $09df78e8bc3317cb$var$load("ebljE"),
    $09df78e8bc3317cb$var$load("hF4v3"),
    $09df78e8bc3317cb$var$load("afU9w")
]).then(()=>parcelRequire('lRTsu'));

});

parcelRegister("bljzq", function(module, exports) {

let $8420d62759605432$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8420d62759605432$var$load("15ncj"),
    $8420d62759605432$var$load("gDiIK"),
    $8420d62759605432$var$load("eLlpV"),
    $8420d62759605432$var$load("f1B4n"),
    $8420d62759605432$var$load("j4dSZ"),
    $8420d62759605432$var$load("1Tuyb"),
    $8420d62759605432$var$load("7iCpI")
]).then(()=>parcelRequire('jKBtA'));

});

parcelRegister("l2474", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $d23df821b2d2d994$var$AsyncNoAccessTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("gURmQ")).then((module)=>{
        return {
            default: module.NoAccessTooltip
        };
    }));
var $d23df821b2d2d994$export$2e2bcd8739ae039 = $d23df821b2d2d994$var$AsyncNoAccessTooltip;
module.exports["default"] = $d23df821b2d2d994$export$2e2bcd8739ae039;

});

parcelRegister("gURmQ", function(module, exports) {

let $c50b45f90fc6d653$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c50b45f90fc6d653$var$load("2lsX7").then(()=>parcelRequire('5zTqW'));

});

parcelRegister("aCzn4", function(module, exports) {
const $26c671ba196278bc$export$eddcd8a5b7e09991 = (event)=>{
    return !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};
module.exports["isBasicClick"] = $26c671ba196278bc$export$eddcd8a5b7e09991;

});

parcelRegister("ghphD", function(module, exports) {
$parcel$export(module.exports, "default", () => $bda1d8a3686c6d03$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $jZ39j = parcelRequire("jZ39j");


var $b5utg = parcelRequire("b5utg");


var $2h3f7 = parcelRequire("2h3f7");

function $bda1d8a3686c6d03$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $b5utg.default)(1, arguments);
    var defaultOptions = (0, $2h3f7.getDefaultOptions)();
    var weekStartsOn = (0, $jZ39j.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $egXhZ.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("kPml2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f767605c1291541e11ee398674a3c525>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f299e6000fe75318$var$_react = $f299e6000fe75318$var$_interopRequireDefault((parcelRequire("42omo")));

var $f299e6000fe75318$var$_baseNew = $f299e6000fe75318$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f299e6000fe75318$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Location".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: location in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f299e6000fe75318$var$LocationIcon = (props)=>/*#__PURE__*/ $f299e6000fe75318$var$_react.default.createElement($f299e6000fe75318$var$_baseNew.default, Object.assign({
        name: "LocationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5c-3.627 0-5.764 4.07-3.705 7.056L8 13.93l3.705-5.373C13.765 5.57 11.627 1.5 8 1.5M3.06 9.408C.314 5.427 3.164 0 8 0s7.686 5.427 4.94 9.408l-4.323 6.268a.75.75 0 0 1-1.234 0zM8 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M5.5 6a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0" clip-rule="evenodd"/>`
    }, props));
$f299e6000fe75318$var$LocationIcon.displayName = 'LocationIcon';
var $f299e6000fe75318$var$_default = module.exports.default = $f299e6000fe75318$var$LocationIcon;

});

parcelRegister("8nlrk", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");


var $lAwme = parcelRequire("lAwme");


var $bUp2E = parcelRequire("bUp2E");


var $caPHA = parcelRequire("caPHA");

const $6b7f2dce15d051f7$export$62aa48085237e36f = ({ fireAnalytics: fireAnalytics, profileType: profileType })=>{
    (0, $42omo.useEffect)(()=>{
        if (fireAnalytics) fireAnalytics(`ui.${(0, $bUp2E.getActionSubject)(profileType)}.rendered.spinner`, {
            firedAt: Math.round((0, $caPHA.getPageTime)()),
            ...(0, $bUp2E.PACKAGE_META_DATA)
        });
    }, [
        fireAnalytics,
        profileType
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAwme.SpinnerContainer), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {})
    });
};
module.exports["LoadingState"] = $6b7f2dce15d051f7$export$62aa48085237e36f;

});

parcelRegister("7Y4kW", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lDwiy = parcelRequire("lDwiy");

const $eb50cc4a563796fc$export$38f9b635c1c454e7 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lDwiy))), {
        ...props,
        label: ""
    });
module.exports["ChatPillIcon"] = $eb50cc4a563796fc$export$38f9b635c1c454e7;

});

parcelRegister("lBFuf", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8C5kA = parcelRequire("8C5kA");


var $1Whri = parcelRequire("1Whri");


var $hge3g = parcelRequire("hge3g");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");


var $7Y4kW = parcelRequire("7Y4kW");


var $jz7J7 = parcelRequire("jz7J7");

const $204b57ff8caef44c$var$stylesCompiled = {
    pillLineHeight: "_vwz47vkz"
};
const $204b57ff8caef44c$var$styles = {
    button: "_2rko12b0 _11c8fhey _189ee4h9 _1dqonqa1 _1h6d1l7x _syazazsu _ca0q12x7 _u5f3utpp _n3td12x7 _19bvutpp _k48p1wq8 _1bto1l2s _o5721q9c _1o9zkb7n _bfhksm61 _irr31dpa _1di6fcek",
    buttonInline: "_18zrv77o",
    queryText: "_1nmz1hna _y3gn1e5h",
    whiteSpacePreWrap: "_o5721jtm"
};
const $204b57ff8caef44c$export$e33faa86e0996d96 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, whiteSpacePreWrap: whiteSpacePreWrap = true, renderIcon: renderIcon = true, ...props }, ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        ref: ref,
        ...props,
        xcss: $204b57ff8caef44c$var$styles.button,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $204b57ff8caef44c$var$stylesCompiled.pillLineHeight
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.075",
                alignBlock: "baseline",
                children: [
                    renderIcon ? /*#__PURE__*/ (0, $l998X.jsx)((0, $7Y4kW.ChatPillIcon), {}) : null,
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: (0, $1Whri.cx)($204b57ff8caef44c$var$styles.queryText, whiteSpacePreWrap && $204b57ff8caef44c$var$styles.whiteSpacePreWrap),
                        children: children
                    })
                ]
            })
        })
    }));
const $204b57ff8caef44c$export$76b47032dcd9063b = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        ref: ref,
        ...props,
        xcss: $204b57ff8caef44c$var$styles.button,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $204b57ff8caef44c$var$stylesCompiled.pillLineHeight
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.050",
                xcss: $204b57ff8caef44c$var$styles.buttonInline,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hge3g))), {
                        color: "currentColor",
                        label: ""
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $204b57ff8caef44c$var$styles.queryText,
                        children: formatMessage((0, $jz7J7.default).browseAgentsPillLabel)
                    })
                ]
            })
        })
    });
});
module.exports["ChatPill"] = $204b57ff8caef44c$export$e33faa86e0996d96;
module.exports["BrowseAgentsPill"] = $204b57ff8caef44c$export$76b47032dcd9063b;

});

parcelRegister("jz7J7", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fc6573ead9ef7c8$export$2e2bcd8739ae039);

var $cgtv4 = parcelRequire("cgtv4");

var $5fc6573ead9ef7c8$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    browseAgentsPillLabel: {
        id: "ai-mate.rovo-agent-components.browse-agents-pill.label",
        defaultMessage: "Browse Agents"
    }
});

});

parcelRegister("4AkKf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::82ab01af3f80a4391aaf33fbaff15a85>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $356a9dc0786a9256$var$_react = $356a9dc0786a9256$var$_interopRequireDefault((parcelRequire("42omo")));

var $356a9dc0786a9256$var$_baseNew = $356a9dc0786a9256$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $356a9dc0786a9256$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Filter".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for filterting data or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $356a9dc0786a9256$var$FilterIcon = (props)=>/*#__PURE__*/ $356a9dc0786a9256$var$_react.default.createElement($356a9dc0786a9256$var$_baseNew.default, Object.assign({
        name: "FilterIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-2 5.25H3v-1.5h10zM11 14H5v-1.5h6z" clip-rule="evenodd"/>`
    }, props));
$356a9dc0786a9256$var$FilterIcon.displayName = 'FilterIcon';
var $356a9dc0786a9256$var$_default = module.exports.default = $356a9dc0786a9256$var$FilterIcon;

});

parcelRegister("eoZW1", function(module, exports) {
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $639791195d5194df$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $639791195d5194df$export$2e2bcd8739ae039 = $639791195d5194df$export$852ff24d0930c62f;
module.exports["default"] = $639791195d5194df$export$2e2bcd8739ae039;

});

parcelRegister("4rwCt", function(module, exports) {

var $51c7W = parcelRequire("51c7W");


var $JlyMu = parcelRequire("JlyMu");

function $33c2fc9905303660$export$c9058316764c140e(refs) {
    return (0, $JlyMu.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $51c7W.assignRef)(ref, newValue)));
}
module.exports["mergeRefs"] = $33c2fc9905303660$export$c9058316764c140e;

});

parcelRegister("JlyMu", function(module, exports) {
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $0884ed72a8650e84$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}
module.exports["createCallbackRef"] = $0884ed72a8650e84$export$35a19128eb4acba4;

});

parcelRegister("lwNi3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $04e9M = parcelRequire("04e9M");


var $jOtRZ = parcelRequire("jOtRZ");


var $lBR3p = parcelRequire("lBR3p");

const $5efec5cf952678ca$export$ddc368dc94a41e62 = (withChoreographer = true)=>{
    const { cloudId: cloudId, activationId: activationId, environment: environment } = (0, $bQm3c.useSessionData)();
    const workspaceId = (0, $04e9M.getWorkspaceId)(cloudId, activationId);
    const disableEngagementForTests = sessionStorage.getItem('confluence.disable-engagement-for-tests') === 'true';
    const envType = (0, $jOtRZ.useAnalyticsEnvironment)(environment);
    return (0, $42omo.useMemo)(()=>(0, $lBR3p.getCoordinationClient)(disableEngagementForTests, cloudId, workspaceId, withChoreographer, envType), [
        disableEngagementForTests,
        cloudId,
        workspaceId,
        withChoreographer,
        envType
    ]);
};
module.exports["useCoordinationClient"] = $5efec5cf952678ca$export$ddc368dc94a41e62;

});

parcelRegister("lBR3p", function(module, exports) {

var $5loD0 = parcelRequire("5loD0");


var $fw9LG = parcelRequire("fw9LG");

const $b379edbfb382bc54$var$noop = async ()=>false;
const $b379edbfb382bc54$export$a3f969ef7d35205d = (disableEngagementForTests, cloudId, workspaceId, enableChoreographer, environment)=>{
    if (disableEngagementForTests) return {
        start: $b379edbfb382bc54$var$noop,
        stop: $b379edbfb382bc54$var$noop
    };
    else {
        const coordinationOptions = {
            enableChoreographer: enableChoreographer,
            envType: environment,
            additionalData: {
                sourceProductId: (0, $fw9LG.ProductIds).CONFLUENCE
            }
        };
        return new (0, $5loD0.default)({
            cloudId: cloudId,
            stargateUrl: '/gateway/api',
            isFedRAMPEnvironment: false,
            workspaceId: workspaceId,
            coordinationOptions: coordinationOptions
        });
    }
};
module.exports["getCoordinationClient"] = $b379edbfb382bc54$export$a3f969ef7d35205d;

});

parcelRegister("7d2Nc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3kTfj = parcelRequire("3kTfj");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");

const $c2bdb1677e0a2d6c$var$noop = ()=>{};
const $c2bdb1677e0a2d6c$var$PageSegmentLoadStartComponent = /*#__PURE__*/ (0, $42omo.memo)(({ metric: metric, onComplete: onComplete = $c2bdb1677e0a2d6c$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY, isCustomStart: isCustomStart = false })=>{
    const handlePageLoadMetricStart = (0, $42omo.useCallback)(()=>{
        if (metric) {
            (0, $3kTfj.browserMetrics).getPageLoadMetric().mark(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${metric.key}`);
            if (isCustomStart) metric.start();
            else metric.startFromPageLoad();
            onComplete();
        }
    }, [
        metric,
        onComplete,
        isCustomStart
    ]);
    (0, $N1nBh.usePerformanceAction)(handlePageLoadMetricStart, timing);
    return null;
});
const $c2bdb1677e0a2d6c$export$f11db193fdaffcc9 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($c2bdb1677e0a2d6c$var$PageSegmentLoadStartComponent);
module.exports["PageSegmentLoadStart"] = $c2bdb1677e0a2d6c$export$f11db193fdaffcc9;

});

parcelRegister("N1nBh", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
	 * This will perform the given action at a scheduled time after the
	 * component has painted.
	 *
	 * This is the default behavior.
	 */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
	 * This will perform the given action at the next animation frame (after the
	 * component has been painted).
	 */ ActionTiming["PAINT"] = "PAINT";
    /**
	 * This will perform the given action at the moment its render function
	 * fires.
	 *
	 * NOTE: This is called _within_ the render body, making it unpure. The
	 * component is memoized, so it will fire this only once for a given set
	 * of props. Be careful when using this, since it is unsafe.
	 */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $42omo.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $42omo.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};
module.exports["ActionTiming"] = $4fef2d066feab689$export$6a673e74e98cdf55;
module.exports["usePerformanceAction"] = $4fef2d066feab689$export$454639fd58f598bd;

});

parcelRegister("gNXND", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a463dbdb96f5dd0cff6dca797202b246>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3bf9be9856ff4d9$var$_react = $c3bf9be9856ff4d9$var$_interopRequireDefault((parcelRequire("42omo")));

var $c3bf9be9856ff4d9$var$_baseNew = $c3bf9be9856ff4d9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c3bf9be9856ff4d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Rovo".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing Rovo
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3bf9be9856ff4d9$var$RovoIcon = (props)=>/*#__PURE__*/ $c3bf9be9856ff4d9$var$_react.default.createElement($c3bf9be9856ff4d9$var$_baseNew.default, Object.assign({
        name: "RovoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.687.64a2.63 2.63 0 0 1 2.625 0l4.404 2.544a2.63 2.63 0 0 1 1.313 2.273v5.084c0 .938-.5 1.804-1.313 2.274l-4.404 2.542a2.63 2.63 0 0 1-2.625 0l-4.403-2.542A2.63 2.63 0 0 1 .97 10.54V5.457c0-.938.5-1.804 1.313-2.273zM3.034 4.483a1.13 1.13 0 0 0-.563.975v5.084c0 .402.215.774.563.975l4.403 2.543c.348.2.777.2 1.125 0l.688-.398v-1.997L5.896 9.568a1.38 1.38 0 0 1-.646-1.166V3.203zM8.562 1.94a1.13 1.13 0 0 0-1.125 0l-.687.398v1.996l3.354 2.097c.402.251.646.692.646 1.166v5.199l2.216-1.28c.348-.2.563-.572.563-.974V5.457c0-.402-.215-.774-.563-.975zM6.75 8.333l2.5 1.563V7.663l-2.5-1.561z" clip-rule="evenodd"/>`
    }, props));
$c3bf9be9856ff4d9$var$RovoIcon.displayName = 'RovoIcon';
var $c3bf9be9856ff4d9$var$_default = module.exports.default = $c3bf9be9856ff4d9$var$RovoIcon;

});

parcelRegister("iPfZG", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1e26a6c07491d4a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "EngagementSpotlight", () => $d1e26a6c07491d4a$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $2Fndw = parcelRequire("2Fndw");


var $iiBJH = parcelRequire("iiBJH");


var $3Npfo = parcelRequire("3Npfo");


var $k5HOq = parcelRequire("k5HOq");


var $8cBM8 = parcelRequire("8cBM8");

const $d1e26a6c07491d4a$var$SpotlightWithVariables = (0, $iiBJH.default)((0, $8cBM8.default));
const $d1e26a6c07491d4a$export$f57123e11f24bec9 = (0, $3Npfo.default)($d1e26a6c07491d4a$var$SpotlightWithVariables);
const $d1e26a6c07491d4a$var$SpotlightWithMessage = (0, $k5HOq.default)($d1e26a6c07491d4a$export$f57123e11f24bec9, 'spotlight');
function $d1e26a6c07491d4a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d1e26a6c07491d4a$var$SpotlightWithMessage, props));
}

});

parcelRegister("iiBJH", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cfa45347111319c$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $3Sftg = parcelRequire("3Sftg");

function $3cfa45347111319c$export$2e2bcd8739ae039(TargetComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithVariables extends (0, $42omo.Component) {
        render() {
            const props = $3cfa45347111319c$var$runMessagePropsReplacement(this.props);
            if (!props) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(TargetComponent, props);
        }
    }
    WithVariables.displayName = `${TargetComponent.displayName || TargetComponent.name || ''}WithEPVariables`;
    return WithVariables;
}
/**
 * Runs replacement over spotlight message properties.
 * Returns null if replacement fails.
 */ function $3cfa45347111319c$var$runMessagePropsReplacement(props) {
    const { variables: variables, ...otherProps } = props;
    const { title: title, body: body, primaryText: primaryText, primaryAction: primaryAction, secondaryText: secondaryText, secondaryAction: secondaryAction } = props;
    const inputs = {
        title: title,
        body: body,
        primaryText: primaryText,
        primaryActionUrl: primaryAction && primaryAction.data && primaryAction.data.url,
        secondaryText: secondaryText,
        secondaryActionUrl: secondaryAction && secondaryAction.data && secondaryAction.data.url
    };
    const replacedInputs = (0, $3Sftg.runTemplateOnInputs)(variables || {}, inputs);
    if (!replacedInputs) return null;
    const outputProps = {
        ...otherProps,
        title: replacedInputs.title,
        body: replacedInputs.body,
        primaryText: replacedInputs.primaryText,
        secondaryText: replacedInputs.secondaryText
    };
    if (primaryAction) outputProps.primaryAction = (0, $3Sftg.rebuildButtonAction)(replacedInputs.primaryActionUrl, primaryAction);
    if (secondaryAction) outputProps.secondaryAction = (0, $3Sftg.rebuildButtonAction)(replacedInputs.secondaryActionUrl, secondaryAction);
    return outputProps;
}

});

parcelRegister("3Sftg", function(module, exports) {

var $g47C5 = parcelRequire("g47C5");

var $4xewT = parcelRequire("4xewT");

function $e4ebe363c373022b$export$5d0ec4f796aceeb1(replacedUrl, action) {
    return {
        ...action,
        data: action.data && {
            ...action.data,
            url: replacedUrl
        }
    };
}
function $e4ebe363c373022b$export$d808999430a3f186(variables, messageInputs) {
    const keys = Object.keys(messageInputs);
    const output = {};
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const input = messageInputs[key];
        if (input) {
            const isUrl = key === 'primaryActionUrl' || key === 'secondaryActionUrl';
            const replacedInput = isUrl ? (0, $4xewT.runTemplateForUrl)(input, variables) : (0, $4xewT.runTemplateForHtml)(input, variables);
            if (replacedInput.type === (0, $g47C5.REPLACEMENT_ERROR)) return null;
            output[key] = replacedInput.result;
        }
    }
    return output;
}
module.exports["rebuildButtonAction"] = $e4ebe363c373022b$export$5d0ec4f796aceeb1;
module.exports["runTemplateOnInputs"] = $e4ebe363c373022b$export$d808999430a3f186;

});

parcelRegister("g47C5", function(module, exports) {
const $e428a4697dceb24e$export$e26f00bd90899835 = 'success';
const $e428a4697dceb24e$export$edb46161045fece7 = 'error';
module.exports["REPLACEMENT_ERROR"] = $e428a4697dceb24e$export$edb46161045fece7;

});

parcelRegister("4xewT", function(module, exports) {

var $i0lyP = parcelRequire("i0lyP");


var $cpDxi = parcelRequire("cpDxi");


var $g47C5 = parcelRequire("g47C5");


var $cuEWu = parcelRequire("cuEWu");

function $ace38877ac0d85ab$export$5d49303889cd00ad(template) {
    const parsedTemplate = (0, $i0lyP.default)(template);
    return (0, $cuEWu.getRequiredVariablesFromTemplate)(parsedTemplate);
}
function $ace38877ac0d85ab$export$416b2ef51d91ea20(template, variables) {
    const epTemplate = (0, $i0lyP.default)(template);
    return (0, $cpDxi.replaceForUrl)(epTemplate, variables);
}
function $ace38877ac0d85ab$export$5681b97796b74884(template, variables) {
    const epTemplate = (0, $i0lyP.default)(template);
    return (0, $cpDxi.replaceForHtml)(epTemplate, variables);
}
module.exports["runTemplateForUrl"] = $ace38877ac0d85ab$export$416b2ef51d91ea20;
module.exports["runTemplateForHtml"] = $ace38877ac0d85ab$export$5681b97796b74884;

});

parcelRegister("i0lyP", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2be59bfe0ce0113$export$2e2bcd8739ae039);

var $bz2UO = parcelRequire("bz2UO");

/**
 * This is regular expression to parse double and triple bracket variables.
 * We should replace this with an imperative parser or a library if we want to
 * add more functionality, but this is simple enough as it is.
 *
 * The regular expression is:
 *
 * # Try to match triple bracket variables in a capture group:
 * (
 *   {{{ # Start matching on leading "{{{"
 *     (
 *       # Match on 1+ inner characters
 *       (
 *         # Do negative look-ahead for closing brackets '}}}'.
 *         # Then match on any character. What this means is, match on any
 *         # character that isn't a bracket followed by two other brackets.
 *         # So, first check if we're not at the end of the tag, otherwise
 *         # match.
 *         # Negative look-ahead won't collect the character, just fail if it's
 *         # the triple bracket sequence.
 *         (?!}}}).
 *       )+
 *     ) # Finish `UNESCAPED_GROUP_CONTENTS`, which is our UNESCAPED variable
 *       # name capture group
 *   }}}
 * )
 *
 * | # OR try matching the double bracket variables
 *
 * # The logic is the same, throughout
 * (
 *   {{
 *     (
 *       (
 *         (?!}}).
 *       )+
 *     ) # Finish `ESCAPED_GROUP_CONTENTS`, which is our ESCAPED variable name
 *       # capture group
 *   }}
 * )
 *
 * See https://regex101.com/r/Eo26HD/1 too.
 *
 * Group indexes are named bellow.
 */ const $e2be59bfe0ce0113$var$PARSE_VARIABLES_REGEXP = /({{{(((?!}}}).)+)}}})|({{(((?!}}).)+)}})/g;
const $e2be59bfe0ce0113$var$UNESCAPED_MATCH = 1;
const $e2be59bfe0ce0113$var$UNESCAPED_GROUP_CONTENTS = 2;
const $e2be59bfe0ce0113$var$ESCAPED_GROUP_CONTENTS = 5;
function $e2be59bfe0ce0113$export$2e2bcd8739ae039(template) {
    const parts = (0, $bz2UO.regexpParts)(template, $e2be59bfe0ce0113$var$PARSE_VARIABLES_REGEXP);
    return {
        parts: parts.map((regexpPart)=>{
            if (regexpPart.type === 'text') return regexpPart;
            if (regexpPart.match[$e2be59bfe0ce0113$var$UNESCAPED_MATCH]) return {
                type: 'unescaped',
                variableName: regexpPart.match[$e2be59bfe0ce0113$var$UNESCAPED_GROUP_CONTENTS] || ''
            };
            return {
                type: 'escaped',
                variableName: regexpPart.match[$e2be59bfe0ce0113$var$ESCAPED_GROUP_CONTENTS] || ''
            };
        })
    };
}

});

parcelRegister("bz2UO", function(module, exports) {
function $78901a26ed98192e$export$b16d411b3b6d6dff(input, regexp) {
    const allMatches = $78901a26ed98192e$export$1ab25a4faafb1ac3(input, regexp);
    const state = allMatches.reduce((memo, matchResult)=>{
        const leadingIndex = matchResult.index || 0;
        const leading = input.slice(memo.currentPosition, leadingIndex);
        if (leading) memo.result.push({
            type: 'text',
            text: leading
        });
        memo.result.push({
            type: 'match',
            match: matchResult
        });
        return {
            currentPosition: leadingIndex + $78901a26ed98192e$export$3aff5fb0c83cea11(matchResult),
            result: memo.result
        };
    }, {
        currentPosition: 0,
        result: []
    });
    const trailing = input.slice(state.currentPosition, input.length);
    if (trailing) state.result.push({
        type: 'text',
        text: trailing
    });
    return state.result;
}
function $78901a26ed98192e$export$1ab25a4faafb1ac3(input, regexp) {
    const result = [];
    for(let m = regexp.exec(input); m; m = regexp.exec(input))result.push(m);
    return result;
}
function $78901a26ed98192e$export$3aff5fb0c83cea11(matchResult) {
    return matchResult[0] ? matchResult[0].length : 0;
}
module.exports["regexpParts"] = $78901a26ed98192e$export$b16d411b3b6d6dff;

});

parcelRegister("cpDxi", function(module, exports) {

var $cuEWu = parcelRequire("cuEWu");


var $48gB0 = parcelRequire("48gB0");

/**
 * Runs variable validation and if successful calls the provided function and
 * wraps it in a result object, otherwise returns a failure.
 */ function $9d422126fe4600e0$var$withVariableValidation(template, variables, fn) {
    const requiredKeys = (0, $cuEWu.getRequiredVariablesFromTemplate)(template);
    const missingKeys = requiredKeys.filter((variableName)=>!variables[variableName]);
    if (missingKeys.length) return {
        type: 'error',
        errorType: 'missing-variables-error',
        missingVariables: missingKeys
    };
    return {
        type: 'success',
        result: fn(template, variables)
    };
}
/**
 * Replaces variables onto a template, using the provided escaping function.
 */ function $9d422126fe4600e0$var$rawReplaceVariables(template, variables, escapeFn) {
    return template.parts.map((templatePart)=>{
        if (templatePart.type === 'text') return templatePart.text;
        if (templatePart.type === 'escaped') return escapeFn(variables[templatePart.variableName]);
        return variables[templatePart.variableName];
    }).join('');
}
/**
 * Without validation, runs a template with URI escaping.
 */ function $9d422126fe4600e0$var$rawReplaceVariablesForUrl(template, variables) {
    return $9d422126fe4600e0$var$rawReplaceVariables(template, variables, encodeURIComponent);
}
/**
 * Without validation, runs a template with HTML escaping.
 */ function $9d422126fe4600e0$var$rawReplaceVariablesForHtml(template, variables) {
    return $9d422126fe4600e0$var$rawReplaceVariables(template, variables, (0, $48gB0.default));
}
function $9d422126fe4600e0$export$d10ae881b12b8ef2(template, variables) {
    return $9d422126fe4600e0$var$withVariableValidation(template, variables, $9d422126fe4600e0$var$rawReplaceVariablesForUrl);
}
function $9d422126fe4600e0$export$ca536300dbd6350(template, variables) {
    return $9d422126fe4600e0$var$withVariableValidation(template, variables, $9d422126fe4600e0$var$rawReplaceVariablesForHtml);
}
module.exports["replaceForUrl"] = $9d422126fe4600e0$export$d10ae881b12b8ef2;
module.exports["replaceForHtml"] = $9d422126fe4600e0$export$ca536300dbd6350;

});

parcelRegister("cuEWu", function(module, exports) {

var $1rjmQ = parcelRequire("1rjmQ");

function $5e0333abe2221126$export$bf97a83dc861479c(template) {
    const variableParts = template.parts.filter((part)=>part.type === 'escaped' || part.type === 'unescaped');
    return variableParts;
}
function $5e0333abe2221126$export$4a33186abb06007b(template) {
    const variableParts = $5e0333abe2221126$export$bf97a83dc861479c(template);
    const variableNames = variableParts.map((part)=>part.variableName);
    return (0, $1rjmQ.uniqStrings)(variableNames);
}
module.exports["getRequiredVariablesFromTemplate"] = $5e0333abe2221126$export$4a33186abb06007b;

});

parcelRegister("1rjmQ", function(module, exports) {
/**
 * Removes duplicate strings from an array.
 */ function $56c35590cbe5b17a$export$c150c7c1a29f33d8(strings) {
    const ourSet = {};
    for(let i = 0; i < strings.length; i++)ourSet[strings[i]] = null;
    return Object.keys(ourSet);
}
module.exports["uniqStrings"] = $56c35590cbe5b17a$export$c150c7c1a29f33d8;

});

parcelRegister("48gB0", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d527f6527719db2$export$2e2bcd8739ae039);
/**
 * Escapes an HTML string.
 *
 * @param {String} input
 * @return {String}
 */ function $8d527f6527719db2$export$2e2bcd8739ae039(input) {
    return input.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39');
}

});

parcelRegister("3Npfo", function(module, exports) {
$parcel$export(module.exports, "default", () => $924fbb9a636b21af$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $1DWH0 = parcelRequire("1DWH0");

var $924fbb9a636b21af$export$2e2bcd8739ae039 = (InnerComponent)=>{
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class EngagementEventsWrapper extends (0, $42omo.Component) {
        UNSAFE_componentWillMount() {
            this.fireEvent('shown');
        }
        componentWillUnmount() {
            this.fireEvent('hidden');
        }
        fireEvent(action, properties = {}) {
            const { createAnalyticsEvent: createAnalyticsEvent, messageId: messageId, variationId: variationId, componentId: componentId, componentType: componentType, isLast: isLast } = this.props;
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                ...properties
            });
            analyticsEvent.update({
                ekMessageId: messageId,
                ekVariationId: variationId,
                ekComponentId: componentId,
                ekComponentType: componentType,
                ekIsLast: isLast
            });
            analyticsEvent.fire('engagement');
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                ...this.props,
                fireClickEvent: this.fireClickEvent
            });
        }
        constructor(...args){
            super(...args);
            this.fireClickEvent = (clickType)=>{
                this.fireEvent('click', {
                    clickType: clickType
                });
            };
        }
    }
    return (0, $1DWH0.default)()(EngagementEventsWrapper);
};

});

parcelRegister("k5HOq", function(module, exports) {
$parcel$export(module.exports, "default", () => $e47b6edde9367a4f$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");

var $e47b6edde9367a4f$export$2e2bcd8739ae039 = (InnerComponent, componentType)=>{
    function isTargetComponent(message) {
        return message.componentType === componentType;
    }
    function computeNewState(state) {
        const current = state.current;
        if (current && isTargetComponent(current)) {
            let message;
            switch(current.componentType){
                case 'contextualSurvey':
                    message = {
                        ...current,
                        aaid: state.config.aaid,
                        cloudId: state.config.cloudId,
                        stargateUrl: state.config.stargateUrl,
                        product: state.config.product,
                        orgId: state.config.orgId,
                        workspaceId: state.config.workspaceId
                    };
                    break;
                default:
                    message = current;
            }
            return {
                message: message
            };
        }
        return {
            message: null
        };
    }
    function getComponentType() {
        return componentType;
    }
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class StoreWrapper extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(StoreWrapperInner, {
                ...this.props,
                context: this.context
            });
        }
        constructor(...args){
            super(...args);
            this.context = void 0;
        }
    }
    StoreWrapper.contextTypes = {
        subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
        setComponentConfig: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
    };
    const StoreWrapperInner = (allProps)=>{
        const { context: context, ...props } = allProps;
        const { children: children, engagementId: engagementId, messageType: messageType, onMessageDisposition: onMessageDisposition } = props;
        const [message, setMessage] = (0, $42omo.useState)(null);
        const unsubscribeRef = (0, $42omo.useRef)(null);
        const removeConfigRef = (0, $42omo.useRef)(null);
        const canSubscribe = (0, $42omo.useCallback)(()=>{
            return context && !!context?.subscribeEngagementState;
        }, [
            context
        ]);
        const canSetConfig = (0, $42omo.useCallback)(()=>{
            return context && !!context?.setComponentConfig;
        }, [
            context
        ]);
        const onStoreChange = (0, $42omo.useCallback)((state)=>{
            setMessage(computeNewState(state).message);
        }, []);
        const subscribeToStore = (0, $42omo.useCallback)(()=>{
            return context?.subscribeEngagementState?.(onStoreChange);
        }, [
            context,
            onStoreChange
        ]);
        const setChoreographerConfig = (0, $42omo.useCallback)((propsToUse = props)=>{
            return context?.setComponentConfig?.(getComponentType(), {
                messageType: propsToUse.messageType,
                onMessageDisposition: propsToUse.onMessageDisposition
            }, propsToUse.engagementId);
        }, [
            context,
            props
        ]);
        // Handle initial mount (equivalent to UNSAFE_componentWillMount)
        (0, $42omo.useEffect)(()=>{
            if (canSubscribe()) unsubscribeRef.current = subscribeToStore() || null;
            if (canSetConfig()) removeConfigRef.current = setChoreographerConfig() || null;
            return ()=>{
                if (unsubscribeRef.current) unsubscribeRef.current();
                if (removeConfigRef.current) removeConfigRef.current();
            };
        }, [
            canSubscribe,
            canSetConfig,
            subscribeToStore,
            setChoreographerConfig
        ]);
        // Handle prop changes (equivalent to UNSAFE_componentWillReceiveProps)
        const previousEngagementId = (0, $42omo.useRef)(engagementId);
        const previousMessageType = (0, $42omo.useRef)(messageType);
        const previousOnMessageDisposition = (0, $42omo.useRef)(onMessageDisposition);
        (0, $42omo.useEffect)(()=>{
            if (previousEngagementId.current !== engagementId && removeConfigRef.current && canSetConfig()) {
                removeConfigRef.current();
                removeConfigRef.current = setChoreographerConfig(props) || null;
            } else if ((previousMessageType.current !== messageType || previousOnMessageDisposition.current !== onMessageDisposition) && canSetConfig()) setChoreographerConfig(props);
            previousEngagementId.current = engagementId;
            previousMessageType.current = messageType;
            previousOnMessageDisposition.current = onMessageDisposition;
        }, [
            props,
            setChoreographerConfig,
            canSetConfig,
            engagementId,
            messageType,
            onMessageDisposition
        ]);
        if (!message) {
            if (componentType === 'inlineDialog') return children || null;
            return null;
        }
        if (engagementId && message !== null && message.target && engagementId !== message.target) return null;
        const messageKey = `${message.messageId}.${message.variationId}.${message.componentId}`;
        // Key is useful here to make sure that when the currently active
        // messages changes, the old component is unmounted (therefore
        // firing an analytic event for hiding the component) and mounting
        // a new component for the new message (firing a shown event for
        // the new message). Not using key would allow React to apply an
        // optimization that would reuse the current component for a new
        // message which would not call the normal mount and unmount
        // lifecycle methods.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
            key: messageKey,
            ...props,
            ...message
        });
    };
    return StoreWrapper;
};

});

parcelRegister("8cBM8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hQNhB = parcelRequire("hQNhB");


var $5RBJ9 = parcelRequire("5RBJ9");


var $7cTWR = parcelRequire("7cTWR");


var $9A5yV = parcelRequire("9A5yV");

class $86110ead6fe3e8af$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    getButtonClickHandler(buttonType, action) {
        const { fireClickEvent: fireClickEvent } = this.props;
        switch(action.type){
            case (0, $7cTWR.buttonActionTypes).LINK:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                    window.open(action.data.url, action.data.target);
                };
            default:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                };
        }
    }
    getButtonActions() {
        const { primaryAction: primaryAction, primaryText: primaryText, secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
        const actions = [];
        if (secondaryAction && secondaryText) actions.push({
            onClick: this.getButtonClickHandler('secondary', secondaryAction),
            text: secondaryText,
            appearance: secondaryAction.appearance
        });
        if (primaryAction && primaryText) actions.push({
            onClick: this.getButtonClickHandler('primary', primaryAction),
            text: primaryText,
            appearance: primaryAction.appearance,
            autoFocus: true
        });
        return actions;
    }
    render() {
        const { body: body, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth, title: title, image: image, pulse: pulse, target: target, targetBgColor: targetBgColor, targetRadius: targetRadius } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5RBJ9.default), {
            actions: this.getButtonActions(),
            dialogPlacement: dialogPlacement,
            dialogWidth: dialogWidth,
            heading: title,
            image: image,
            pulse: pulse,
            target: target,
            targetBgColor: targetBgColor,
            targetRadius: targetRadius
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9A5yV.default), {
            html: body
        }));
    }
}
$86110ead6fe3e8af$export$2e2bcd8739ae039.defaultProps = {
    fireClickEvent: (0, (/*@__PURE__*/$parcel$interopDefault($hQNhB)))
};
module.exports["default"] = $86110ead6fe3e8af$export$2e2bcd8739ae039;

});

parcelRegister("7cTWR", function(module, exports) {
const $31e3ef3c9b5f37b6$export$e7d79186651244da = {
    LINK: 'link',
    DISMISS: 'dismiss'
};
module.exports["buttonActionTypes"] = $31e3ef3c9b5f37b6$export$e7d79186651244da;

});

parcelRegister("9A5yV", function(module, exports) {

var $42omo = parcelRequire("42omo");

class $8cb2cd879eafccd1$export$2e2bcd8739ae039 extends (0, $42omo.PureComponent) {
    render() {
        const { html: html } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
    }
}
module.exports["default"] = $8cb2cd879eafccd1$export$2e2bcd8739ae039;

});

parcelRegister("7p2SJ", function(module, exports) {

var $9tehW = parcelRequire("9tehW");


var $2KLMV = parcelRequire("2KLMV");

const $9de29032692b3583$var$AsyncSelect = (0, $2KLMV.default)((0, $9tehW.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9de29032692b3583$export$2e2bcd8739ae039 = $9de29032692b3583$var$AsyncSelect;
module.exports["default"] = $9de29032692b3583$export$2e2bcd8739ae039;

});

parcelRegister("iUYhn", function(module, exports) {
/**
 * Instead of enum types for ResultType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $4cce666965dd4176$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["JiraIssue"] = "jira.issue";
    Scope["JiraPlan"] = "jira.plan";
    Scope["JiraDashboard"] = "jira.dashboard";
    Scope["JiraIssueDashboardBoardProjectFilter"] = "jira.issue,dashboard,board,project,filter";
    Scope["JiraBoardProjectFilter"] = "jira.board,project,filter";
    Scope["JiraBoardProjectFilterPlan"] = "jira.board,project,filter,plan";
    Scope["JiraProject"] = "jira.project";
    Scope["People"] = "urs.user-jira";
    return Scope;
}({});
var $4cce666965dd4176$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["JiraIssue"] = "jira-issue";
    ContentType["JiraDashboard"] = "jira-dashboard";
    ContentType["JiraBoard"] = "jira-board";
    ContentType["JiraProject"] = "jira-project";
    ContentType["JiraFilter"] = "jira-filter";
    ContentType["JiraPlan"] = "jira-plan";
    ContentType["JiraPeople"] = "jira-people";
    return ContentType;
}({});
function $4cce666965dd4176$export$b3b8cefe01df28d2(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'url');
}
function $4cce666965dd4176$export$496f9fe01bbac92b(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'urls');
}
var $4cce666965dd4176$export$d31c6c64cddbeeac = /*#__PURE__*/ function(AttributeType) {
    AttributeType["issue"] = "issue";
    AttributeType["dashboard"] = "dashboard";
    AttributeType["board"] = "board";
    AttributeType["project"] = "project";
    AttributeType["filter"] = "filter";
    AttributeType["plan"] = "plan";
    AttributeType["people"] = "people";
    return AttributeType;
}({});
module.exports["Scope"] = $4cce666965dd4176$export$775b6bb06e53a214;

});

parcelRegister("7MEO5", function(module, exports) {
"use strict";
var $5aacab81e886bd11$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
function $5aacab81e886bd11$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dxnq4 = parcelRequire("dxnq4");


$5aacab81e886bd11$var$__export((parcelRequire("3lrmR")));
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ var $5aacab81e886bd11$var$InvalidAriError = /** @class */ function(_super) {
    $5aacab81e886bd11$var$__extends(InvalidAriError, _super);
    /**
   * Construct an InvalidAriError given an error message
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {string|undefined} description - The error message
   */ function InvalidAriError(ariString, description) {
        var _this = _super.call(this, "Invalid ari string: " + ariString + (description ? '. ' + description : '')) || this;
        _this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(_this, InvalidAriError.prototype);
        return _this;
    }
    /**
   * Construct an InvalidAriError given some constraint violations
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
   */ InvalidAriError.withConstraintViolations = function(ariString, violations) {
        return new InvalidAriError(ariString, violations.map(function(v) {
            return v.toString();
        }).join('\n'));
    };
    return InvalidAriError;
}(Error);
module.exports.InvalidAriError = $5aacab81e886bd11$var$InvalidAriError;
function $5aacab81e886bd11$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
var $5aacab81e886bd11$var$basicCharConstraint = $dxnq4.pattern(/^[a-z][a-z.-]*$/);
var $5aacab81e886bd11$var$resourceOwnerConstraints = [
    $dxnq4.lengthBetween(3, 255),
    $5aacab81e886bd11$var$basicCharConstraint
];
var $5aacab81e886bd11$var$resourceTypeConstraints = [
    $dxnq4.lengthBetween(3, 255),
    $5aacab81e886bd11$var$basicCharConstraint
];
var $5aacab81e886bd11$var$cloudIdConstraints = [
    $dxnq4.lengthBetween(36, 255)
];
var $5aacab81e886bd11$var$siteResourceType = 'site';
var $5aacab81e886bd11$var$resourceIdChars = /[\w-._~:@#]/.source;
var $5aacab81e886bd11$var$resourceIdConstraints = [
    $dxnq4.pattern(new RegExp("^" + $5aacab81e886bd11$var$resourceIdChars + "+(/" + $5aacab81e886bd11$var$resourceIdChars + "*)*(;v=" + $5aacab81e886bd11$var$resourceIdChars + "*)*$"))
]; /**
                                                                                                                                                          * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
                                                                                                                                                          * (like those for site wide ARIs) are upgraded to their latest form.
                                                                                                                                                          */ 
function $5aacab81e886bd11$var$upgrade(values) {
    var resourceId = values.resourceId, resourceOwner = values.resourceOwner, cloudId = values.cloudId; // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $5aacab81e886bd11$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
var $5aacab81e886bd11$var$ResourceIdentifier = /** @class */ function() {
    /**
   * Create a new Ari
   *
   * Only the resourceOwner is a required field, any other field can be omitted.
   * Older format types are converted on creation
   *
   * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
   * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
   * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
   * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
   *
   * @throws {InvalidAriError} if the provided segments fail to pass validation
   */ function ResourceIdentifier(values) {
        var _a = $5aacab81e886bd11$var$upgrade(values), resourceId = _a.resourceId, resourceOwner = _a.resourceOwner, resourceType = _a.resourceType, cloudId = _a.cloudId;
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    Object.defineProperty(ResourceIdentifier.prototype, "cloudId", {
        get: function() {
            if (this.resourceType === $5aacab81e886bd11$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
            return this.internalCloudId;
        },
        enumerable: true,
        configurable: true
    });
    /**
  * Parse a string as an Ari
  *
  * @param {string} ariString - the string to parse
  * @returns {Ari} the parsed ari
  * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
  */ ResourceIdentifier.parse = function(ariString) {
        if (!ariString) throw new $5aacab81e886bd11$var$InvalidAriError(ariString);
        var match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $5aacab81e886bd11$var$InvalidAriError(ariString);
        var terms = match.map(function(a) {
            return a && a.length > 0 ? a : undefined;
        });
        var resourceOwner = terms[1];
        if (!resourceOwner) throw new $5aacab81e886bd11$var$InvalidAriError(ariString);
        return new ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    };
    ResourceIdentifier.parseEncoded = function(encodedAriString) {
        return $5aacab81e886bd11$var$parse(decodeURIComponent(encodedAriString));
    }; /**
      * Converts this Ari to a string.
      */ 
    ResourceIdentifier.prototype.toString = function() {
        if (!this.ariString) {
            var resourceId = this.resourceType === $5aacab81e886bd11$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            var resourceType = this.resourceType || '';
            var sanitizedCloudId = this.resourceType === $5aacab81e886bd11$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = "ari:cloud:" + this.resourceOwner + ":" + sanitizedCloudId + ":" + resourceType + "/" + resourceId;
        }
        return this.ariString;
    }; /**
      * Converts this object to its json representation
      */ 
    ResourceIdentifier.prototype.toJSON = function() {
        return this.toString();
    }; /**
      * Checks if this context is the same as another context
      *
      * @param {Ari} other - the other parameter to match with
      * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
      */ 
    ResourceIdentifier.prototype.equals = function(other) {
        return other instanceof ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    }; /**
      * This method checks if the current context contains the other context.
      *
      * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
      * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
      *
      * @param {Ari} other
      * @returns {boolean}
      */ 
    ResourceIdentifier.prototype.contains = function(other) {
        return this.matches(new ResourceIdentifier(other));
    }; /**
      * Checks if this context is the same as or contains the provided context.
      *
      * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
      *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
      *
      * e.g.
      * ```
      * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
      * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
      *
      * @param {Ari} other - the other parameter to match with
      * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
      */ 
    ResourceIdentifier.prototype.matches = function(other) {
        return $5aacab81e886bd11$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $5aacab81e886bd11$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $5aacab81e886bd11$var$siteResourceType && !!other.resourceType || $5aacab81e886bd11$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $5aacab81e886bd11$var$siteResourceType && !!other.resourceType || $5aacab81e886bd11$var$matchesSegment(this.resourceId, other.resourceId));
    };
    ResourceIdentifier.prototype.validateSiteWide = function() {
        var _a = this, resourceType = _a.resourceType, cloudId = _a.cloudId;
        if (resourceType === $5aacab81e886bd11$var$siteResourceType && !cloudId) return new $dxnq4.GeneralValidationError('site wide ARIs must have a cloudId');
    };
    ResourceIdentifier.prototype.validate = function() {
        var constraintViolations = [
            $dxnq4.validateField(this, 'resourceOwner', $5aacab81e886bd11$var$resourceOwnerConstraints),
            $dxnq4.validateField(this, 'resourceType', $5aacab81e886bd11$var$resourceTypeConstraints),
            $dxnq4.validateField(this, 'resourceId', $5aacab81e886bd11$var$resourceIdConstraints),
            $dxnq4.validateField(this, 'cloudId', $5aacab81e886bd11$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter(function(v) {
            return v;
        });
        if (constraintViolations.length > 0) throw $5aacab81e886bd11$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $5aacab81e886bd11$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    };
    ResourceIdentifier.prototype.urlEncode = function() {
        return encodeURIComponent(this.toString());
    };
    ResourceIdentifier.prototype.urlDecode = function() {
        return decodeURIComponent(this.toString());
    };
    return ResourceIdentifier;
}();
module.exports.ResourceIdentifier = $5aacab81e886bd11$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $5aacab81e886bd11$var$parse(ariString) {
    return $5aacab81e886bd11$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $5aacab81e886bd11$var$parse; /**
                        * Parse a URL encoded string as an Ari
                        *
                        * @param {string} encodedAriString - the string to parse
                        * @returns {Ari} the parsed ari
                        * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
                        */ 
function $5aacab81e886bd11$var$parseEncoded(encodedAriString) {
    return $5aacab81e886bd11$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $5aacab81e886bd11$var$parseEncoded;

});

parcelRegister("dxnq4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9db08607176ba86f$var$LengthConstraint = /** @class */ function() {
    function LengthConstraint(min, max) {
        this.min = min;
        this.max = max;
    }
    Object.defineProperty(LengthConstraint.prototype, "description", {
        get: function() {
            return "length must be between " + this.min + " and " + this.max;
        },
        enumerable: true,
        configurable: true
    });
    LengthConstraint.prototype.isValid = function(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    };
    return LengthConstraint;
}();
module.exports.LengthConstraint = $9db08607176ba86f$var$LengthConstraint;
var $9db08607176ba86f$var$RegexConstraint = /** @class */ function() {
    function RegexConstraint(regex) {
        this.regex = regex;
    }
    Object.defineProperty(RegexConstraint.prototype, "description", {
        get: function() {
            return "value must match regex " + this.regex.source;
        },
        enumerable: true,
        configurable: true
    });
    RegexConstraint.prototype.isValid = function(value) {
        return !value || this.regex.test(value);
    };
    return RegexConstraint;
}();
module.exports.RegexConstraint = $9db08607176ba86f$var$RegexConstraint;
var $9db08607176ba86f$var$GeneralValidationError = /** @class */ function() {
    function GeneralValidationError(error) {
        this.error = error;
    }
    GeneralValidationError.prototype.toString = function() {
        return this.error;
    };
    return GeneralValidationError;
}();
module.exports.GeneralValidationError = $9db08607176ba86f$var$GeneralValidationError;
var $9db08607176ba86f$var$ConstraintViolation = /** @class */ function() {
    function ConstraintViolation(fieldName, value, constraints) {
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    ConstraintViolation.prototype.toString = function() {
        var constraintSummary = this.constraints.map(function(c) {
            return "  - " + c.description;
        }).join('\n');
        return "'" + this.value + "' is not a valid value for " + this.fieldName + " as it violates the following constraints:\n" + constraintSummary;
    };
    return ConstraintViolation;
}();
module.exports.ConstraintViolation = $9db08607176ba86f$var$ConstraintViolation;
function $9db08607176ba86f$var$lengthBetween(min, max) {
    return new $9db08607176ba86f$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $9db08607176ba86f$var$lengthBetween;
function $9db08607176ba86f$var$pattern(regex) {
    return new $9db08607176ba86f$var$RegexConstraint(regex);
}
module.exports.pattern = $9db08607176ba86f$var$pattern;
function $9db08607176ba86f$var$validateField(object, fieldName, constraints) {
    var value = object[fieldName];
    var violatedConstraints = constraints.map(function(c) {
        return c.isValid(value) ? undefined : c;
    }).filter(function(c) {
        return c;
    });
    return violatedConstraints.length > 0 ? new $9db08607176ba86f$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $9db08607176ba86f$var$validateField;

});

parcelRegister("3lrmR", function(module, exports) {
"use strict";
var $26f88fee2c23b642$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3uwoy = parcelRequire("3uwoy");

var $26f88fee2c23b642$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($26f88fee2c23b642$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
var $26f88fee2c23b642$var$AppFamilyAriError = /** @class */ function(_super) {
    $26f88fee2c23b642$var$__extends(AppFamilyAriError, _super);
    function AppFamilyAriError(message, cause) {
        var _this = _super.call(this, message) || this;
        _this.cause = cause;
        return _this;
    }
    return AppFamilyAriError;
}(Error);
module.exports.AppFamilyAriError = $26f88fee2c23b642$var$AppFamilyAriError;
var $26f88fee2c23b642$var$NotAppFamilyAriError = /** @class */ function(_super) {
    $26f88fee2c23b642$var$__extends(NotAppFamilyAriError, _super);
    function NotAppFamilyAriError(ari, reason) {
        var _this = _super.call(this, "ari is not a valid App family ari: " + ari.toString() + " as " + reason) || this;
        _this.reason = reason;
        return _this;
    }
    return NotAppFamilyAriError;
}($26f88fee2c23b642$var$AppFamilyAriError);
module.exports.NotAppFamilyAriError = $26f88fee2c23b642$var$NotAppFamilyAriError;
var $26f88fee2c23b642$var$NotExpectedAppFamilyAriTypeError = /** @class */ function(_super) {
    $26f88fee2c23b642$var$__extends(NotExpectedAppFamilyAriTypeError, _super);
    function NotExpectedAppFamilyAriTypeError(type, ari, cause) {
        var _this = _super.call(this, "App family ari (" + ari.toString() + ") is not of expected type: " + type, cause) || this;
        _this.cause = cause;
        return _this;
    }
    return NotExpectedAppFamilyAriTypeError;
}($26f88fee2c23b642$var$AppFamilyAriError);
module.exports.NotExpectedAppFamilyAriTypeError = $26f88fee2c23b642$var$NotExpectedAppFamilyAriTypeError; /**
                                                                              * throws NotAppFamilyAriError if not a valid app family ari
                                                                              */ 
function $26f88fee2c23b642$var$parseAppAri(ari) {
    return $3uwoy.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $26f88fee2c23b642$var$parseAppAri;
function $26f88fee2c23b642$var$createAppAri(json) {
    return new $3uwoy.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $26f88fee2c23b642$var$createAppAri;

});

parcelRegister("3uwoy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3lrmR = parcelRequire("3lrmR");


var $7MEO5 = parcelRequire("7MEO5");

var $28ad4d654e27c81d$var$versionPrefix = ';v=';
var $28ad4d654e27c81d$var$AppFamilyAriImpl = /** @class */ function() {
    function AppFamilyAriImpl(json) {
        this.json = json;
    }
    Object.defineProperty(AppFamilyAriImpl.prototype, "appId", {
        get: function() {
            return this.json.appId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "environmentId", {
        get: function() {
            return this.json.environmentId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "version", {
        get: function() {
            return this.json.version;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "extensionGroupId", {
        get: function() {
            return this.json.extensionGroupId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "extensionKey", {
        get: function() {
            return this.json.extensionKey;
        },
        enumerable: true,
        configurable: true
    });
    AppFamilyAriImpl.prototype.toJSON = function() {
        return this.json;
    };
    AppFamilyAriImpl.parse = function(ari) {
        var resourceOwner = ari.resourceOwner, resourceType = ari.resourceType, resourceId = ari.resourceId;
        if (resourceOwner !== $3lrmR.AppFamilyAri.resourceOwner) throw new $3lrmR.NotAppFamilyAriError(ari, "resourceOwner (" + resourceOwner + ") must be " + $3lrmR.AppFamilyAri.resourceOwner);
        if (!resourceType || $3lrmR.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $3lrmR.NotAppFamilyAriError(ari, "resourceType must be one of " + $3lrmR.AppFamilyAri.appFamilyResourceTypes);
        if (!resourceId) throw new $3lrmR.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        var versionIndex = resourceId.indexOf($28ad4d654e27c81d$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($28ad4d654e27c81d$var$versionPrefix) > versionIndex) throw new $3lrmR.NotAppFamilyAriError(ari, 'can only include one version suffix');
        var _a = resourceId.split($28ad4d654e27c81d$var$versionPrefix), mainResourceId = _a[0], version = _a[1];
        var segments = mainResourceId.split('/').map($28ad4d654e27c81d$var$stripToUndefined);
        if (segments.length > 4) throw new $3lrmR.NotAppFamilyAriError(ari, "no path segments can be added after extensionKey " + segments.slice(4));
        var _b = segments[0], appId = _b === void 0 ? undefined : _b, _c = segments[1], environmentId = _c === void 0 ? undefined : _c, _d = segments[2], providedExtensionGroupId = _d === void 0 ? undefined : _d, _e = segments[3], extensionKey = _e === void 0 ? undefined : _e;
        if (!appId) throw new $3lrmR.NotAppFamilyAriError(ari, 'appId must be included');
        var extensionGroupId = providedExtensionGroupId || (resourceType === $3lrmR.AppFamilyAri.extensionGroupResourceType || resourceType === $3lrmR.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $3lrmR.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $3lrmR.NotAppFamilyAriError(ari, "environmentId, extensionGroupId, extensionKey must all be provided for resourceType " + $3lrmR.AppFamilyAri.extensionResourceType);
        else if (resourceType === $3lrmR.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $3lrmR.NotAppFamilyAriError(ari, "environmentId, extensionGroupId must all be provided for resourceType " + $3lrmR.AppFamilyAri.extensionGroupResourceType);
        else if (resourceType === $3lrmR.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $3lrmR.NotAppFamilyAriError(ari, "environmentId must be provided for resourceType " + $3lrmR.AppFamilyAri.environmentResourceType);
        else if (resourceType === $3lrmR.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $3lrmR.NotAppFamilyAriError(ari, "environmentId must be provided for resourceType " + $3lrmR.AppFamilyAri.environmentResourceType);
        return new AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    };
    AppFamilyAriImpl.prototype.asAppAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isAppAri();
        }, 'app');
    };
    AppFamilyAriImpl.prototype.asAppEnvironmentAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isAppEnvironmentAri();
        }, 'environment');
    };
    AppFamilyAriImpl.prototype.asExtensionGroupAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isExtensionGroupAri();
        }, 'extension-group');
    };
    AppFamilyAriImpl.prototype.asExtensionAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isExtensionAri();
        }, 'extension');
    };
    AppFamilyAriImpl.prototype.isAppAri = function() {
        return !this.isAtLeastAppEnvironmentAri;
    };
    AppFamilyAriImpl.prototype.isAppEnvironmentAri = function() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    };
    AppFamilyAriImpl.prototype.isExtensionGroupAri = function() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    };
    AppFamilyAriImpl.prototype.isExtensionAri = function() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    };
    AppFamilyAriImpl.prototype.returnIf = function(check, type) {
        if (!check()) throw new $3lrmR.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    };
    Object.defineProperty(AppFamilyAriImpl.prototype, "isAtLeastAppEnvironmentAri", {
        get: function() {
            return this.environmentId !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "isAtLeastExtensionGroupAri", {
        get: function() {
            return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    AppFamilyAriImpl.prototype.toAri = function() {
        var resourceOwner = $3lrmR.AppFamilyAri.resourceOwner;
        var _a = this.toJSON(), appId = _a.appId, environmentId = _a.environmentId, extensionGroupId = _a.extensionGroupId, extensionKey = _a.extensionKey, version = _a.version;
        function withVersion(segments) {
            var path = segments.join('/');
            if (!version) return path;
            else return "" + path + $28ad4d654e27c81d$var$versionPrefix + version;
        }
        if (this.isExtensionAri()) return new $7MEO5.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $3lrmR.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $7MEO5.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $3lrmR.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $7MEO5.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $3lrmR.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $7MEO5.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $3lrmR.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    };
    AppFamilyAriImpl.prototype.toString = function() {
        return this.toAri().toString();
    };
    return AppFamilyAriImpl;
}();
module.exports.AppFamilyAriImpl = $28ad4d654e27c81d$var$AppFamilyAriImpl;
function $28ad4d654e27c81d$var$stripToUndefined(str) {
    if (!str) return undefined;
    var trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});

parcelRegister("8hhCV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $02745cd2b6b0665c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c46a68f431db1746de65e15ef846dc14>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8jHAi = parcelRequire("8jHAi");


var $kXb3C = parcelRequire("kXb3C");

function $02745cd2b6b0665c$export$2e2bcd8739ae039({ label: label = 'Page', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("57Wda", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0a57bdd6dcbbb0a3$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::599e4be29a2a39bcbf5cf9b372d0e03e>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $6B0jU = parcelRequire("6B0jU");


var $kXb3C = parcelRequire("kXb3C");

function $0a57bdd6dcbbb0a3$export$2e2bcd8739ae039({ label: label = 'Database', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
}

});

parcelRegister("eQfRp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $26650821103220c8$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a634b13ea98c89a9c27945d37a8a7571>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $ZDq1z = parcelRequire("ZDq1z");


var $kXb3C = parcelRequire("kXb3C");

function $26650821103220c8$export$2e2bcd8739ae039({ label: label = 'Whiteboard', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        color: "var(--ds-icon-accent-teal, #2898BD)"
    });
}

});

parcelRegister("eMqrF", function(module, exports) {

var $02AY0 = parcelRequire("02AY0");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/identity/team/manifest.ts
var $ac2a0fd84662e75e$var$identityTeamAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $02AY0.IdentityTeamAriResourceOwner),
    resourceType: (0, $02AY0.IdentityTeamAriResourceType),
    resourceIdSlug: "{teamId}",
    resourceIdSegmentFormats: {
        teamId: /[a-zA-Z0-9.\-_~]+/
    }
};
// src/identity/team/index.ts
var $ac2a0fd84662e75e$export$33bbb2d79e520118 = class _IdentityTeamAri extends (0, $3NXcb.RegisteredAri) {
    get teamId() {
        return this._teamId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.qualifier,
            platformQualifier: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.resourceOwner,
            resourceType: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.resourceType,
            resourceId: `${opts.teamId}`,
            resourceIdSegmentValues: {
                teamId: opts.teamId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $ac2a0fd84662e75e$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $ac2a0fd84662e75e$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(opts);
    }
    getVariables() {
        return {
            teamId: this.teamId
        };
    }
    constructor(opts){
        super(opts), this._teamId = opts.resourceIdSegmentValues.teamId;
    }
};
module.exports["IdentityTeamAri"] = $ac2a0fd84662e75e$export$33bbb2d79e520118;

});

parcelRegister("02AY0", function(module, exports) {
// src/identity/team/types.ts
var $007cdcdc857abd84$export$49beddf48ffb3f35 = "identity", $007cdcdc857abd84$export$b2079a2a841afe32 = "team";
module.exports["IdentityTeamAriResourceOwner"] = $007cdcdc857abd84$export$49beddf48ffb3f35;
module.exports["IdentityTeamAriResourceType"] = $007cdcdc857abd84$export$b2079a2a841afe32;

});

parcelRegister("b8JCF", function(module, exports) {

var $1VjMI = parcelRequire("1VjMI");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/jira/issue/manifest.ts
var $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1VjMI.JiraIssueAriResourceOwner),
    resourceType: (0, $1VjMI.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $81c3d4c7dce903d7$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
};
module.exports["JiraIssueAri"] = $81c3d4c7dce903d7$export$1da6808e89ee03e;

});

parcelRegister("1VjMI", function(module, exports) {
// src/jira/issue/types.ts
var $166a76280cbc11fa$export$665a39f1b4e29e0a = "jira", $166a76280cbc11fa$export$76beb4d0da177ad4 = "issue";
module.exports["JiraIssueAriResourceOwner"] = $166a76280cbc11fa$export$665a39f1b4e29e0a;
module.exports["JiraIssueAriResourceType"] = $166a76280cbc11fa$export$76beb4d0da177ad4;

});

parcelRegister("5JRMI", function(module, exports) {

var $ehowZ = parcelRequire("ehowZ");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/townsquare/project/manifest.ts
var $01140be010796b0a$var$townsquareProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $ehowZ.TownsquareProjectAriResourceOwner),
    resourceType: (0, $ehowZ.TownsquareProjectAriResourceType),
    resourceIdSlug: "{projectUuid}",
    resourceIdSegmentFormats: {
        projectUuid: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/townsquare/project/index.ts
var $01140be010796b0a$export$41215e8d01921e7d = class _TownsquareProjectAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get projectUuid() {
        return this._projectUuid;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $01140be010796b0a$var$townsquareProjectAriStaticOpts.qualifier,
            platformQualifier: $01140be010796b0a$var$townsquareProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $01140be010796b0a$var$townsquareProjectAriStaticOpts.resourceOwner,
            resourceType: $01140be010796b0a$var$townsquareProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectUuid}`,
            resourceIdSegmentValues: {
                projectUuid: opts.projectUuid
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $01140be010796b0a$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $01140be010796b0a$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectUuid: this.projectUuid
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._projectUuid = opts.resourceIdSegmentValues.projectUuid;
    }
};
module.exports["TownsquareProjectAri"] = $01140be010796b0a$export$41215e8d01921e7d;

});

parcelRegister("ehowZ", function(module, exports) {
// src/townsquare/project/types.ts
var $a655ae9218632ad3$export$a258bc824c789b17 = "townsquare", $a655ae9218632ad3$export$aa8900dadffaa32a = "project";
module.exports["TownsquareProjectAriResourceOwner"] = $a655ae9218632ad3$export$a258bc824c789b17;
module.exports["TownsquareProjectAriResourceType"] = $a655ae9218632ad3$export$aa8900dadffaa32a;

});

parcelRegister("ibFXh", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eyWa4 = parcelRequire("eyWa4");

const $0f4f34a4aa7da555$var$styles = {
    wrapper: "_4t3i1osq _bfhkvuon"
};
const $0f4f34a4aa7da555$export$9520f072db304aa0 = ({ children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
        xcss: $0f4f34a4aa7da555$var$styles.wrapper,
        testId: testId,
        children: children
    });
};
module.exports["PreviewPanel"] = $0f4f34a4aa7da555$export$9520f072db304aa0;

});

parcelRegister("aSy6D", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

const $dd1efdb181d94706$export$cda5e69749e7aeee = ({ children: children, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes, styles: styles })=>{
    (0, $42omo.useEffect)(()=>{
        if (analyticsClient) {
            analyticsClient.sendTrackEvent({
                action: 'viewed',
                actionSubject: 'preview-panel',
                actionSubjectId: 'preview-panel-view',
                source: 'preview-panel',
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType,
                    ...(0, $dh538.fg)('add_capacity_tab_to_the_board_horizontal_nav') ? analyticsAttributes : {}
                }
            });
            // https://developer.atlassian.com/platform/analytics-pipeline/guides/deep-dive/cloud-mau/
            // Fires at most once per hour, per product.
            // Requires tenantInfo and userInfo to be set
            analyticsClient?.startUIViewedEvent();
        }
    }, [
        analyticsClient,
        parentProduct,
        panelType,
        analyticsAttributes
    ]);
    // ignoring the rule as we have so many consumers of this that we need to be able to pass in styles
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)(!!styles && styles),
        children: children
    });
};
module.exports["PreviewPanelBody"] = $dd1efdb181d94706$export$cda5e69749e7aeee;

});

parcelRegister("fZVub", function(module, exports) {
$parcel$export(module.exports, "default", () => $920790d5dac34360$export$2e2bcd8739ae039);

var $cgtv4 = parcelRequire("cgtv4");

var $920790d5dac34360$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    previewPanelCloseButtonLabel: {
        id: "navigation.preview-panel.preview-panel-header.close-button-label",
        defaultMessage: "Close"
    },
    previewPanelExpandActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-expand.expand-action-label",
        defaultMessage: "Expand"
    },
    previewPanelNewTabActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-new-tab.new-tab-action-label",
        defaultMessage: "Open in new tab"
    },
    previewPanelMoreDropdownActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-more-dropdown.more-dropdown-action-label",
        defaultMessage: "More"
    },
    previewPanelOpenInNewWindowLabel: {
        id: "navigation.preview-panel.preview-panel-header.open-in-new-window-label",
        defaultMessage: "Open in new window"
    }
});

});

parcelRegister("2os6v", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");

var $dE1p6 = parcelRequire("dE1p6");

const $ed5d65f9b39936d9$export$a37cb5f447b2cf16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(function PreviewPanelAction({ icon: icon, label: label, onClick: onClick, href: href, testId: testId, analyticsContext: analyticsContext }, ref) {
    return href ? /*#__PURE__*/ (0, $l998X.jsx)((0, $dE1p6.default), {
        icon: icon,
        label: label,
        onClick: onClick,
        href: href,
        testId: testId,
        analyticsContext: analyticsContext,
        appearance: "subtle",
        target: "_blank",
        ref: ref,
        role: "button"
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        icon: icon,
        label: label,
        onClick: onClick,
        testId: testId,
        analyticsContext: analyticsContext,
        appearance: "subtle",
        ref: ref,
        role: "button"
    });
});
module.exports["PreviewPanelAction"] = $ed5d65f9b39936d9$export$a37cb5f447b2cf16;

});

parcelRegister("3ZVni", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $39XmP = parcelRequire("39XmP");


var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $dh538 = parcelRequire("dh538");


var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");


var $fZVub = parcelRequire("fZVub");


var $6CSXv = parcelRequire("6CSXv");

const $ce13ec86664e204c$export$e1ea1fbf111a14fe = (url, paramToRemove)=>{
    try {
        const urlObj = new URL(url);
        urlObj.searchParams.delete(paramToRemove);
        return urlObj.toString();
    } catch  {
        // If URL parsing fails, return the original URL
        return url;
    }
};
const $ce13ec86664e204c$var$styles = {
    header: "_1h6d1l7x _bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi _12ornqa1 _1r62e4h9 _4t3i8vuz",
    childWrapper: "_16jlkb7n"
};
const $ce13ec86664e204c$export$426d4171de44bac0 = ({ children: children, onClose: onClose, onOpenInNewTab: onOpenInNewTab, testId: testId, url: url, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, moreActions: moreActions })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const enableCrossMAUUsage = (0, $dh538.fg)('platform_preview_panels_cross_app_interaction');
    const buildUrlWithAnalyticsParams = (0, $39XmP.default)({
        bridge: 'preview-panels',
        product: parentProduct ?? 'unknown'
    });
    const onPanelClose = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preview-panel-close',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onClose?.();
    };
    const onOpenInNewWindow = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'preview-panel-open-in-new-window',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onOpenInNewTab?.();
        if (url) window.open(enableCrossMAUUsage ? buildUrlWithAnalyticsParams($ce13ec86664e204c$export$e1ea1fbf111a14fe(url, 'previewPanels')) : $ce13ec86664e204c$export$e1ea1fbf111a14fe(url, 'previewPanels'));
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        xcss: $ce13ec86664e204c$var$styles.header,
        testId: testId,
        alignBlock: "center",
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                xcss: $ce13ec86664e204c$var$styles.childWrapper,
                spread: "space-between",
                alignBlock: "center",
                space: "space.100",
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                gap: "space.100",
                children: [
                    url && /*#__PURE__*/ (0, $l998X.jsx)((0, $6CSXv.PreviewPanelNewTabLink), {
                        label: formatMessage((0, $fZVub.default).previewPanelOpenInNewWindowLabel),
                        onClick: onOpenInNewWindow,
                        testId: testId && `${testId}.open-in-new-window-button`
                    }),
                    moreActions,
                    onClose && /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                                ...iconProps,
                                size: "small"
                            }),
                        label: formatMessage((0, $fZVub.default).previewPanelCloseButtonLabel),
                        onClick: onPanelClose,
                        testId: testId && `${testId}.close-button`,
                        role: "button"
                    })
                ]
            })
        ]
    });
};
module.exports["PreviewPanelHeader"] = $ce13ec86664e204c$export$426d4171de44bac0;

});

parcelRegister("39XmP", function(module, exports) {
$parcel$export(module.exports, "default", () => $f84bdce2dbfd750d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $5spQU = parcelRequire("5spQU");


var $fFa3V = parcelRequire("fFa3V");


var $T9xHm = parcelRequire("T9xHm");


var $dh538 = parcelRequire("dh538");


var $a4UIB = parcelRequire("a4UIB");


var $26AWB = parcelRequire("26AWB");


var $5O1V9 = parcelRequire("5O1V9");

function $f84bdce2dbfd750d$export$2e2bcd8739ae039(options) {
    const [interactionSessionId, setInteractionSessionId] = (0, $42omo.useState)('');
    const { bridge: bridge, product: product, subProduct: subProduct } = options;
    const shouldDisable = (0, $dh538.fg)('use_frontend_feature_encoding_sdk_platform') ? !(0, $5spQU.isFeatureEnabled)('atlassian-analytics', 'atlassian-analytics-cross-product-interaction-client') : (0, $T9xHm.isFedrampModerate)();
    const isEnabled = !shouldDisable;
    // Client does not change on re-render - cache with useMemo
    const interactionSessionClient = (0, $42omo.useMemo)(()=>{
        if (isEnabled) return new (0, $a4UIB.default)();
        else return null;
    }, [
        isEnabled
    ]);
    (0, $42omo.useEffect)(()=>{
        if (interactionSessionClient && isEnabled) {
            // Fetch any initial interaction session ID
            const currentSessionId = interactionSessionClient.getCurrentInteractionSessionId();
            currentSessionId && setInteractionSessionId(currentSessionId);
            // Add event listener that subscribes to any future interaction session ID updates
            const unbind = (0, $fFa3V.bind)(document, {
                type: (0, $5O1V9.INTERACTION_SESSION_ID_UPDATED_EVENT),
                listener: ()=>{
                    const currentSessionId = interactionSessionClient.getCurrentInteractionSessionId();
                    currentSessionId && setInteractionSessionId(currentSessionId);
                }
            });
            return unbind;
        }
        return ()=>{};
    }, [
        interactionSessionClient,
        isEnabled
    ]);
    if (!isEnabled) return (url)=>url;
    return (url)=>(0, $26AWB.generateUrlWithParams)(url, bridge, interactionSessionId, product, subProduct);
}

});

parcelRegister("6CSXv", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $8tdj3 = parcelRequire("8tdj3");


var $fZVub = parcelRequire("fZVub");


var $2os6v = parcelRequire("2os6v");

const $4d61e3d7ff65f94b$export$d05dda6f1d91eaad = ({ href: href, label: label, onClick: onClick, testId: testId, analyticsContext: analyticsContext })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2os6v.PreviewPanelAction), {
        label: label || formatMessage((0, $fZVub.default).previewPanelNewTabActionLabel),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
        onClick: onClick,
        href: href,
        testId: testId,
        analyticsContext: analyticsContext
    });
};
module.exports["PreviewPanelNewTabLink"] = $4d61e3d7ff65f94b$export$d05dda6f1d91eaad;

});

parcelRegister("3R2u2", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");

const $237c600fec460668$export$92a58681483f4529 = ({ title: title, icon: icon, color: color })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center",
        children: [
            icon,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                weight: "bold",
                maxLines: 1,
                color: color,
                children: title
            })
        ]
    });
};
module.exports["PreviewPanelTitle"] = $237c600fec460668$export$92a58681483f4529;

});

parcelRegister("fwXBL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::edc088c8e1dff28f4540e843bee097cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4e8151e15b50def$var$_react = $b4e8151e15b50def$var$_interopRequireDefault((parcelRequire("42omo")));

var $b4e8151e15b50def$var$_baseNew = $b4e8151e15b50def$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b4e8151e15b50def$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsObject".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing objects in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b4e8151e15b50def$var$AssetsObjectIcon = (props)=>/*#__PURE__*/ $b4e8151e15b50def$var$_react.default.createElement($b4e8151e15b50def$var$_baseNew.default, Object.assign({
        name: "AssetsObjectIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5h-2.5v3.75a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75V2.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM7 5.5h2v-3H7zm8 7.5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$b4e8151e15b50def$var$AssetsObjectIcon.displayName = 'AssetsObjectIcon';
var $b4e8151e15b50def$var$_default = module.exports.default = $b4e8151e15b50def$var$AssetsObjectIcon;

});

parcelRegister("aH9Q1", function(module, exports) {

var $2xciB = parcelRequire("2xciB");


var $58Nu8 = parcelRequire("58Nu8");


var $56LFI = parcelRequire("56LFI");

const $da1a55ed1292d791$var$cache = (0, $2xciB.createCache)(new Map());
function $da1a55ed1292d791$export$e83743682263315a(loader, opts) {
    return $da1a55ed1292d791$var$cache.get(opts.moduleId, ()=>(0, $58Nu8.PreloadableJSResource)(()=>(0, $56LFI.postTask)(loader, {
                priority: 'user-visible'
            }), opts));
}
module.exports["JSResourceForInteraction"] = $da1a55ed1292d791$export$e83743682263315a;

});

parcelRegister("2xciB", function(module, exports) {
function $148a59911478cb25$export$cf6fa0bbcc94b912(store) {
    return {
        get (key, supplier) {
            const value = store.get(key);
            if (value != null) return value;
            const v = supplier();
            store.set(key, v);
            return v;
        }
    };
}
module.exports["createCache"] = $148a59911478cb25$export$cf6fa0bbcc94b912;

});

parcelRegister("58Nu8", function(module, exports) {

var $2X3nY = parcelRequire("2X3nY");

function $ba332286d251cd41$export$4fe5fba5bb1d3c09(loader, opts) {
    const resource = (0, $2X3nY.JSResource)(loader, opts);
    return Object.assign(resource, {
        preload () {
            const jsModule = resource.getModuleIfRequired();
            if (jsModule != null) return;
            resource.load().catch(()=>{});
        }
    });
}
module.exports["PreloadableJSResource"] = $ba332286d251cd41$export$4fe5fba5bb1d3c09;

});

parcelRegister("2X3nY", function(module, exports) {

var $6hmze = parcelRequire("6hmze");


var $cAXnn = parcelRequire("cAXnn");


var $7Z6yP = parcelRequire("7Z6yP");

function $39dd57c545107221$export$148e45a6d4b4d65(loader, opts) {
    const { moduleId: moduleId, moduleName: moduleName, modulePath: modulePath, priority: priority } = opts;
    const listeners = new Set();
    let promise;
    let state = {
        type: 'init'
    };
    function createOnLoad(event) {
        return (module)=>{
            (0, $cAXnn.eventEmitter).emit('jsresource.load.complete', event);
            state = {
                type: 'module',
                module: module
            };
            for (const listener of listeners)listener.onLoad(module);
        };
    }
    function createOnError(event) {
        return (error)=>{
            (0, $cAXnn.eventEmitter).emit('jsresource.load.error', {
                ...event,
                error: error
            });
            state = {
                type: 'error',
                error: error
            };
            for (const listener of listeners)listener.onError?.(error);
        };
    }
    return {
        getModuleId () {
            return moduleId;
        },
        getModuleName () {
            return moduleName;
        },
        getModulePath () {
            return modulePath;
        },
        getPriority () {
            return priority;
        },
        getModuleIfRequired () {
            if (state.type === 'error') throw state.error;
            return state.type === 'module' ? state.module : null;
        },
        load () {
            if (!promise) {
                const event = {
                    moduleId: moduleId,
                    transactionId: (0, $6hmze.generateId)()
                };
                const onError = createOnError(event);
                const onLoad = createOnLoad(event);
                (0, $cAXnn.eventEmitter).emit('jsresource.load.start', event);
                try {
                    promise = loader().then((result)=>{
                        const module = (0, $7Z6yP.isJSModuleWithDefaultExport)(result) ? result.default : result;
                        onLoad(module);
                        return module;
                    }).catch((error)=>{
                        onError(error);
                        throw error;
                    });
                } catch (error) {
                    if (error instanceof Error) onError(error);
                    promise = Promise.reject(error);
                }
            }
            return promise;
        },
        onComplete (onLoad, onError) {
            if (state.type === 'module') {
                onLoad(state.module);
                return ()=>{};
            }
            if (state.type === 'error') {
                onError?.(state.error);
                return ()=>{};
            }
            const listener = {
                onError: onError,
                onLoad: onLoad
            };
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        }
    };
}
module.exports["JSResource"] = $39dd57c545107221$export$148e45a6d4b4d65;

});

parcelRegister("6hmze", function(module, exports) {
let $546b0d6600b43919$var$id = 100000;
function $546b0d6600b43919$export$567fc7097e064344() {
    $546b0d6600b43919$var$id += 1;
    return $546b0d6600b43919$var$id.toString();
}
module.exports["generateId"] = $546b0d6600b43919$export$567fc7097e064344;

});

parcelRegister("cAXnn", function(module, exports) {
function $df7beae67697fe3a$var$createEventEmitter() {
    const eventSubscribers = new Map();
    return {
        emit (eventName, event) {
            const subscribers = eventSubscribers.get(eventName);
            for (const subscriber of subscribers ?? [])subscriber(event);
        },
        on (eventName, subscriber) {
            if (!eventSubscribers.has(eventName)) eventSubscribers.set(eventName, new Set([
                subscriber
            ]));
            else eventSubscribers.get(eventName).add(subscriber);
            return ()=>{
                const set = eventSubscribers.get(eventName);
                set.delete(subscriber);
                if (set.size === 0) eventSubscribers.delete(eventName);
            };
        }
    };
}
const $df7beae67697fe3a$export$10dc3edfc20c8ff = $df7beae67697fe3a$var$createEventEmitter();
module.exports["eventEmitter"] = $df7beae67697fe3a$export$10dc3edfc20c8ff;

});

parcelRegister("7Z6yP", function(module, exports) {
function $1cfe6d8b66e6a41d$export$3b514faac3ba993c(module) {
    try {
        // This should be replaced with Object.hasOwn once it is more widely supported
        return Object.prototype.hasOwnProperty.call(module, 'default');
    } catch (_) {
        // This fallback will occur when module is undefined, or null after converting to Object.hasOwn
        return false;
    }
}
module.exports["isJSModuleWithDefaultExport"] = $1cfe6d8b66e6a41d$export$3b514faac3ba993c;

});

parcelRegister("56LFI", function(module, exports) {
async function $d3c226111d006051$var$toPromise(callback) {
    return callback();
}
function $d3c226111d006051$var$getScheduler(obj) {
    if ('scheduler' in obj && obj.scheduler !== 'undefined') return obj.scheduler;
}

function $d3c226111d006051$export$13c9d02ca54955a3(callback, options) {
    // Dynamically import the scheduler-polyfill module, so browsers that do support the Prioritized Task Scheduling API
    // do not pay the performance cost (e.g. bundle size, runtime, etc).
    const scheduler = $d3c226111d006051$var$getScheduler(globalThis);
    if (!scheduler) {
        // Only load the polyfill if we are using the background priority
        if (options.priority === 'background') // This polyfill will be removed once the Prioritized Task Scheduling API is more widely supported in browsers.
        // eslint-disable-next-line import/dynamic-import-chunkname
        // @ts-ignore error TS7016: Could not find a declaration file for module 'scheduler-polyfill' seen in Jira Typechecking (Cypress) step
        return (parcelRequire("j5M61")).then(()=>$d3c226111d006051$var$getScheduler(globalThis).postTask(callback, options));
        return $d3c226111d006051$var$toPromise(callback);
    }
    return scheduler.postTask(callback, options);
}
module.exports["postTask"] = $d3c226111d006051$export$13c9d02ca54955a3;

});

parcelRegister("j5M61", function(module, exports) {

let $de63cad6e511e9d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $de63cad6e511e9d7$var$load("5a167").then(()=>parcelRequire('jUuBC'));

});

parcelRegister("cab2i", function(module, exports) {
/* eslint-disable @typescript-eslint/ban-types */ function $991254190d627578$export$fa00dd5c1a75592f(// The param types can only be inferred if the shape of the entrypoint (i.e. root and getPreloadProps) is specified
// within the function definition itself. Using EntryPoint, EntryPointComponent, or a custom EntryPointRepresentation
// in place of this will cause Root to be inferred as an 'unknown' type.
params) {
    return params;
}
module.exports["createEntryPoint"] = $991254190d627578$export$fa00dd5c1a75592f;

});

parcelRegister("4M6GB", function(module, exports) {

var $bniL1 = parcelRequire("bniL1");


var $hnvzE = parcelRequire("hnvzE");

const $a93efc0d5ccefe43$var$DefaultUFOSegmentComponent = (0, $hnvzE.default);
const $a93efc0d5ccefe43$var$entryPointConfig = {
    PlaceholderComponent: (0, $bniL1.default),
    UFOSegmentComponent: $a93efc0d5ccefe43$var$DefaultUFOSegmentComponent,
    ModalErrorFallback: ()=>null
};
function $a93efc0d5ccefe43$export$93a6801f9db838c4(overrides) {
    Object.assign($a93efc0d5ccefe43$var$entryPointConfig, overrides);
    return $a93efc0d5ccefe43$var$entryPointConfig;
}
function $a93efc0d5ccefe43$export$dfa96f26176fa91f() {
    return $a93efc0d5ccefe43$var$entryPointConfig;
}
module.exports["useEntryPointConfig"] = $a93efc0d5ccefe43$export$dfa96f26176fa91f;

});

parcelRegister("48FEk", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $irOoi = parcelRequire("irOoi");


var $eduVw = parcelRequire("eduVw");


var $hNKXO = parcelRequire("hNKXO");


var $4M6GB = parcelRequire("4M6GB");

function $f9885621a7911f5b$var$InternalEntryPointContainerInner({ entryPointReference: entryPointReference, errorFallback: errorFallback, /** Log and track errors */ onError: onErrorLocal, forcedError: forcedError, fallback: /** Loading fallback */ fallback, id: id, placeholderName: placeholderName, runtimeProps: runtimeProps }) {
    const { PlaceholderComponent: PlaceholderComponent } = (0, $4M6GB.useEntryPointConfig)();
    // useUFOReportError needs to be called under correct UFOSegment to work
    const reportErrorUFO = (0, $eduVw.useUFOReportError)();
    const onError = (0, $42omo.useCallback)((error, errorInfo)=>{
        onErrorLocal?.({
            error: error,
            errorInfo: errorInfo
        });
        (0, $hNKXO.reportError)({
            error: error,
            errorInfo: errorInfo,
            interactionId: id
        });
        reportErrorUFO({
            name: id,
            errorMessage: error?.message ?? 'Unknown error',
            errorStack: error?.stack ?? 'Unknown stack',
            forcedError: forcedError
        });
    }, [
        onErrorLocal,
        id,
        reportErrorUFO,
        forcedError
    ]);
    const FallbackComponent = (0, $42omo.useCallback)(({ error: error })=>{
        const onClose = runtimeProps?.onClose ?? (()=>{});
        return errorFallback ? errorFallback({
            error: error,
            onClose: onClose
        }) : null;
    }, [
        errorFallback,
        runtimeProps
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        FallbackComponent: FallbackComponent,
        onError: onError,
        children: /*#__PURE__*/ (0, $l998X.jsx)(PlaceholderComponent, {
            name: placeholderName ?? 'internal-internal-entry-point-container',
            fallback: fallback,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $irOoi.EntryPointContainer), {
                entryPointReference: entryPointReference,
                props: runtimeProps
            })
        })
    });
}
function $f9885621a7911f5b$export$5d4dc37edd8a3adb(props) {
    const { id: id } = props;
    const { UFOSegmentComponent: UFOSegmentComponent } = (0, $4M6GB.useEntryPointConfig)();
    return /*#__PURE__*/ (0, $l998X.jsx)(UFOSegmentComponent, {
        name: id,
        children: /*#__PURE__*/ (0, $l998X.jsx)($f9885621a7911f5b$var$InternalEntryPointContainerInner, {
            ...props
        })
    });
}
module.exports["InternalEntryPointContainer"] = $f9885621a7911f5b$export$5d4dc37edd8a3adb;

});

parcelRegister("hNKXO", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $e5b5ac7e446444f2$var$buffer = [];
let $e5b5ac7e446444f2$var$push = (payload)=>{
    $e5b5ac7e446444f2$var$buffer.push(payload);
};
function $e5b5ac7e446444f2$export$b33b857ad1d9900e(payload) {
    $e5b5ac7e446444f2$var$push(payload);
}
function $e5b5ac7e446444f2$export$abd5747ea77ecab9(handler) {
    if ((0, $dh538.fg)('moving_jira_entry-points_api_under_platform')) {
        $e5b5ac7e446444f2$var$push = handler;
        $e5b5ac7e446444f2$var$buffer.forEach((payload)=>handler(payload));
        $e5b5ac7e446444f2$var$buffer.length = 0;
    }
}
module.exports["reportError"] = $e5b5ac7e446444f2$export$b33b857ad1d9900e;

});

parcelRegister("ksiqf", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee44b6768ad41edb$export$2e2bcd8739ae039);

var $922yL = parcelRequire("922yL");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");

function $ee44b6768ad41edb$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    return (0, $922yL.default)(dirtyDate, -amount);
}

});

parcelRegister("922yL", function(module, exports) {
$parcel$export(module.exports, "default", () => $6936494635ea8bcb$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $6936494635ea8bcb$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("e1kiJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $a350e81639ab5a88$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $922yL = parcelRequire("922yL");


var $b5utg = parcelRequire("b5utg");

function $a350e81639ab5a88$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    var days = amount * 7;
    return (0, $922yL.default)(dirtyDate, days);
}

});

parcelRegister("d6omw", function(module, exports) {
$parcel$export(module.exports, "default", () => $989ebbba3827b0fa$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $62guz = parcelRequire("62guz");


var $b5utg = parcelRequire("b5utg");


var $fls5L = parcelRequire("fls5L");

function $989ebbba3827b0fa$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var diff = (0, $62guz.default)(dateLeft, dateRight) / (0, $jx0NF.millisecondsInMinute);
    return (0, $fls5L.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("6gF1I", function(module, exports) {
$parcel$export(module.exports, "default", () => $49040fbe3dc0e481$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $e1kiJ = parcelRequire("e1kiJ");


var $b5utg = parcelRequire("b5utg");

function $49040fbe3dc0e481$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    return (0, $e1kiJ.default)(dirtyDate, -amount);
}

});

parcelRegister("gVoWJ", function(module, exports) {
// #region Imports

var $bupcf = parcelRequire("bupcf");


var $hEicH = parcelRequire("hEicH");


var $jmHSv = parcelRequire("jmHSv");


var $fi7Vj = parcelRequire("fi7Vj");


var $55skd = parcelRequire("55skd");


var $khxQ7 = parcelRequire("khxQ7");


var $kXH7i = parcelRequire("kXH7i");


var $acwPl = parcelRequire("acwPl");


var $7rj2U = parcelRequire("7rj2U");


var $gyXPd = parcelRequire("gyXPd");


var $kbe7k = parcelRequire("kbe7k");


var $kIhx9 = parcelRequire("kIhx9");


var $4KTOl = parcelRequire("4KTOl");


var $lgjGE = parcelRequire("lgjGE");


var $l7rln = parcelRequire("l7rln");


var $7sK9h = parcelRequire("7sK9h");


var $jS0a0 = parcelRequire("jS0a0");


var $HYzBP = parcelRequire("HYzBP");


var $gATpw = parcelRequire("gATpw");


var $6AqNX = parcelRequire("6AqNX");


var $36iDo = parcelRequire("36iDo");


var $kYgUn = parcelRequire("kYgUn");


var $itirX = parcelRequire("itirX");


var $e6sdP = parcelRequire("e6sdP");


var $bULcr = parcelRequire("bULcr");


var $7nKrc = parcelRequire("7nKrc");


var $6borH = parcelRequire("6borH");


var $5mDFx = parcelRequire("5mDFx");


var $3JBsx = parcelRequire("3JBsx");


var $fMaLE = parcelRequire("fMaLE");


var $kw2eg = parcelRequire("kw2eg");


var $vxKdN = parcelRequire("vxKdN");


var $3O0YV = parcelRequire("3O0YV");


var $fI6T7 = parcelRequire("fI6T7");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $aeAfU = parcelRequire("aeAfU");


var $geLSP = parcelRequire("geLSP");

function $836251edf00fa846$export$4efc99f259929bff(options) {
    const isFullPage = (0, $geLSP.isFullPage)(options.appearance);
    const preset = new (0, $bupcf.EditorPresetBuilder)().add([
        (0, $l7rln.featureFlagsPlugin),
        options.featureFlags || {}
    ]).maybeAdd([
        (0, $jmHSv.analyticsPlugin),
        {
            createAnalyticsEvent: options.createAnalyticsEvent,
            performanceTracking: options.performanceTracking
        }
    ], Boolean(options.allowAnalyticsGASV3)).add((0, $55skd.betterTypeHistoryPlugin)).add([
        (0, $36iDo.pastePlugin),
        {
            ...options?.paste,
            isFullPage: isFullPage
        }
    ]).add((0, $acwPl.default)).add((0, $jS0a0.focusPlugin)).maybeAdd([
        (0, $hEicH.userPreferencesPlugin),
        {
            initialUserPreferences: {
                toolbarDockingPosition: isFullPage ? 'none' : 'top'
            }
        }
    ], ()=>(0, $dh538.fg)('platform_editor_use_preferences_plugin')).maybeAdd((0, $6AqNX.interactionPlugin), Boolean(options?.__livePage) || (0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)).add((0, $gyXPd.compositionPlugin)).add([
        (0, $kbe7k.contextIdentifierPlugin),
        {
            contextIdentifierProvider: options.contextIdentifierProvider
        }
    ]).add([
        (0, $fi7Vj.default),
        options.base
    ]).add((0, $4KTOl.decorationsPlugin)).add([
        (0, $fMaLE.typeAheadPlugin),
        options.typeAhead
    ]).maybeAdd((0, $HYzBP.default), Boolean(options.allowUndoRedoButtons)).maybeAdd((0, $3O0YV.userIntentPlugin), (0, $aeAfU.expValNoExposure)('platform_editor_lovability_user_intent', 'isEnabled', false)).maybeAdd([
        (0, $3JBsx.toolbarPlugin),
        options.toolbar || {}
    ], Boolean(options.toolbar?.enableNewToolbarExperience)).add([
        (0, $itirX.primaryToolbarPlugin),
        {
            contextualFormattingEnabled: isFullPage
        }
    ]).maybeAdd((0, $kw2eg.undoRedoPlugin), Boolean(options.featureFlags?.undoRedoButtons ?? options.allowUndoRedoButtons)).add([
        (0, $khxQ7.blockTypePlugin),
        {
            ...options.blockType,
            includeBlockQuoteAsTextstyleOption: isFullPage
        }
    ]).add((0, $kXH7i.clearMarksOnEmptyDocPlugin)).add([
        (0, $7nKrc.selectionToolbarPlugin),
        {
            preferenceToolbarAboveSelection: !!options.preferenceToolbarAboveSelection,
            contextualFormattingEnabled: isFullPage
        }
    ]).add([
        (0, $gATpw.hyperlinkPlugin),
        {
            ...options.hyperlinkOptions,
            // @ts-ignore Temporary solution to check for Live Page editor.
            __livePage: options.__livePage
        }
    ]).add([
        (0, $5mDFx.textFormattingPlugin),
        options.textFormatting
    ]).add((0, $fI6T7.widthPlugin)).add([
        (0, $e6sdP.quickInsertPlugin),
        options.quickInsert
    ]).add([
        (0, $kYgUn.placeholderPlugin),
        options.placeholder
    ]).add((0, $vxKdN.unsupportedContentPlugin)).add([
        (0, $lgjGE.editorDisabledPlugin),
        {
            initialDisabledState: options.disabled
        }
    ]).add([
        (0, $6borH.submitEditorPlugin),
        options.submitEditor
    ]).add((0, $kIhx9.copyButtonPlugin)).add((0, $7sK9h.floatingToolbarPlugin)).add([
        (0, $bULcr.selectionPlugin),
        {
            ...options.selection,
            __livePage: options.__livePage
        }
    ]).add([
        (0, $7rj2U.default),
        options.codeBlock
    ]);
    return preset;
}
function $836251edf00fa846$export$a3add99b7c13b8f7(props) {
    const preset = $836251edf00fa846$export$4efc99f259929bff(props);
    return [
        preset
    ];
}
module.exports["createDefaultPreset"] = $836251edf00fa846$export$4efc99f259929bff;

});

parcelRegister("4iPjq", function(module, exports) {
$parcel$export(module.exports, "default", () => $74848600c16eb369$export$2e2bcd8739ae039);

var $aqrhZ = parcelRequire("aqrhZ");


var $5wEPK = parcelRequire("5wEPK");


const $74848600c16eb369$var$LazyLinkPickerComponent = (0, $aqrhZ.lazyForPaint)(()=>(parcelRequire("iCGDI")).then(({ LinkPicker: LinkPicker })=>({
            default: LinkPicker
        })));
var // Must be a default export to be able to support prop docs
// eslint-disable-next-line import/no-default-export
$74848600c16eb369$export$2e2bcd8739ae039 = (0, $5wEPK.composeLinkPicker)($74848600c16eb369$var$LazyLinkPickerComponent);

});

parcelRegister("5wEPK", function(module, exports) {
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aqrhZ = parcelRequire("aqrhZ");


var $bYRk6 = parcelRequire("bYRk6");


var $2lNr8 = parcelRequire("2lNr8");


var $knjgj = parcelRequire("knjgj");


var $918lS = parcelRequire("918lS");


var $jrfDA = parcelRequire("jrfDA");


var $lQSkW = parcelRequire("lQSkW");

const $99bf16152ad1d840$export$800daf5fbbe96aff = {
    linkPickerRoot: 'link-picker-root'
};
const $99bf16152ad1d840$export$a2495bb1f182689d = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: (0, $2lNr8.COMPONENT_NAME),
    source: (0, $2lNr8.COMPONENT_NAME)
};
const $99bf16152ad1d840$var$DefaultRootComponent = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": $99bf16152ad1d840$export$800daf5fbbe96aff.linkPickerRoot,
        children: children
    });
};
const $99bf16152ad1d840$var$fixedWidthContainerStyles = null;
const $99bf16152ad1d840$var$FixedWidthContainer = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "dialog",
        "aria-modal": "false",
        "aria-label": "link-picker",
        ...props,
        className: (0, $gMc0m.default)([
            "_1bsb1ubl"
        ])
    });
};
const $99bf16152ad1d840$export$922eb685ceb4a294 = (Component)=>{
    return /*#__PURE__*/ (0, $42omo.memo)((props)=>{
        const { component: component } = props;
        const RootComponent = component ?? $99bf16152ad1d840$var$DefaultRootComponent;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
            data: $99bf16152ad1d840$export$a2495bb1f182689d,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $knjgj.LinkPickerSessionProvider), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lQSkW.MessagesProvider), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        style: {
                            ['--link-picker-width']: props.disableWidth ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            `${0, $2lNr8.LINK_PICKER_WIDTH_IN_PX}px`,
                            ['--link-picker-padding-left']: props.paddingLeft ?? "var(--ds-space-200, 16px)",
                            ['--link-picker-padding-right']: props.paddingRight ?? "var(--ds-space-200, 16px)",
                            ['--link-picker-padding-top']: props.paddingTop ?? "var(--ds-space-200, 16px)",
                            ['--link-picker-padding-bottom']: props.paddingBottom ?? "var(--ds-space-200, 16px)"
                        },
                        children: /*#__PURE__*/ (0, $l998X.jsx)($99bf16152ad1d840$var$FixedWidthContainer, {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $918lS.ErrorBoundary), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aqrhZ.LazySuspense), {
                                    fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $jrfDA.LoaderFallback), {
                                        url: props.url,
                                        hideDisplayText: props.hideDisplayText,
                                        isLoadingPlugins: props.isLoadingPlugins,
                                        plugins: props.plugins
                                    }),
                                    children: /*#__PURE__*/ (0, $l998X.jsx)(RootComponent, {
                                        ...props,
                                        "data-testid": $99bf16152ad1d840$export$800daf5fbbe96aff.linkPickerRoot,
                                        children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                                            ...props
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        });
    });
};
module.exports["composeLinkPicker"] = $99bf16152ad1d840$export$922eb685ceb4a294;

});

parcelRegister("2lNr8", function(module, exports) {
const $7282d690d6f118fb$export$85183a312807388d = 'media';
const $7282d690d6f118fb$export$fc44104665f4d1e5 = 'linkPicker';
const $7282d690d6f118fb$export$452f1062ecf44be7 = 5;
const $7282d690d6f118fb$export$bf31a09f182d5584 = 342;
const $7282d690d6f118fb$export$542fb16962bf430c = '290px';
module.exports["ANALYTICS_CHANNEL"] = $7282d690d6f118fb$export$85183a312807388d;
module.exports["COMPONENT_NAME"] = $7282d690d6f118fb$export$fc44104665f4d1e5;
module.exports["RECENT_SEARCH_LIST_SIZE"] = $7282d690d6f118fb$export$452f1062ecf44be7;
module.exports["LINK_PICKER_WIDTH_IN_PX"] = $7282d690d6f118fb$export$bf31a09f182d5584;
module.exports["LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK"] = $7282d690d6f118fb$export$542fb16962bf430c;

});

parcelRegister("knjgj", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dQl1W = parcelRequire("dQl1W");


var $hzd6s = parcelRequire("hzd6s");

const $56c0565d5892d700$export$c07727f5eddb98f = 'SESSION_UNINITIALIZED';
const $56c0565d5892d700$export$3285420c698bc605 = /*#__PURE__*/ (0, $42omo.createContext)($56c0565d5892d700$export$c07727f5eddb98f);
const $56c0565d5892d700$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $42omo.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $56c0565d5892d700$export$2f19832fd2d620ca = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const { current: sessionId } = (0, $42omo.useRef)((0, $dQl1W.v4)());
    (0, $42omo.useEffect)(()=>{
        return ()=>(0, $hzd6s.abortUfoExperience)((0, $hzd6s.ufoExperience).mounted, sessionId);
    }, [
        sessionId
    ]);
    $56c0565d5892d700$var$useConstructor(()=>(0, $hzd6s.startUfoExperience)((0, $hzd6s.ufoExperience).mounted, sessionId));
    return /*#__PURE__*/ (0, $l998X.jsx)($56c0565d5892d700$export$3285420c698bc605.Provider, {
        value: sessionId,
        children: children
    });
};
const $56c0565d5892d700$export$36ecc935abdc3636 = ()=>(0, $42omo.useContext)($56c0565d5892d700$export$3285420c698bc605);
module.exports["LinkPickerSessionProvider"] = $56c0565d5892d700$export$2f19832fd2d620ca;
module.exports["useLinkPickerSessionId"] = $56c0565d5892d700$export$36ecc935abdc3636;

});

parcelRegister("hzd6s", function(module, exports) {

var $9801n = parcelRequire("9801n");

var $iqaft = parcelRequire("iqaft");

const $f665373313765471$export$f9c7780c574346a2 = {
    mounted: 'component-mounted'
};
const $f665373313765471$var$ufoExperiences = {
    [$f665373313765471$export$f9c7780c574346a2.mounted]: new (0, $9801n.ConcurrentExperience)($f665373313765471$export$f9c7780c574346a2.mounted, {
        type: (0, $iqaft.ExperienceTypes).Load,
        performanceType: (0, $iqaft.ExperiencePerformanceTypes).PageSegmentLoad,
        platform: {
            component: 'link-picker'
        }
    })
};
const $f665373313765471$export$5e9287b6a10f8075 = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (metadata) experience.addMetadata(metadata);
};
const $f665373313765471$export$c5a5cf072c836c0e = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: metadata
    });
};
const $f665373313765471$export$8dda83bafca11b77 = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: metadata
    });
};
const $f665373313765471$export$b1021040eb94cdca = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.abort({
        metadata: metadata
    });
};
module.exports["ufoExperience"] = $f665373313765471$export$f9c7780c574346a2;
module.exports["startUfoExperience"] = $f665373313765471$export$5e9287b6a10f8075;
module.exports["succeedUfoExperience"] = $f665373313765471$export$c5a5cf072c836c0e;
module.exports["failUfoExperience"] = $f665373313765471$export$8dda83bafca11b77;
module.exports["abortUfoExperience"] = $f665373313765471$export$b1021040eb94cdca;

});

parcelRegister("918lS", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $hzd6s = parcelRequire("hzd6s");


var $2lNr8 = parcelRequire("2lNr8");


var $abGcM = parcelRequire("abGcM");


var $knjgj = parcelRequire("knjgj");


var $khavy = parcelRequire("khavy");


var $3blls = parcelRequire("3blls");

function $4548d496336bec74$export$e926676385687eaf({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $knjgj.useLinkPickerSessionId)();
    const handleError = (0, $42omo.useCallback)((error, info)=>{
        // Fire Analytics event
        createAnalyticsEvent((0, $abGcM.default)('ui.linkPicker.unhandledErrorCaught', {
            browserInfo: window?.navigator?.userAgent || 'unknown',
            error: error.toString(),
            componentStack: info?.componentStack ?? ''
        })).fire((0, $2lNr8.ANALYTICS_CHANNEL));
        // Fire UFO failed experience
        (0, $hzd6s.failUfoExperience)((0, $hzd6s.ufoExperience).mounted, linkPickerSessionId);
    }, [
        createAnalyticsEvent,
        linkPickerSessionId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $khavy.BaseErrorBoundary), {
        onError: handleError,
        ErrorComponent: (0, $3blls.ErrorBoundaryFallback),
        children: children
    });
}
module.exports["ErrorBoundary"] = $4548d496336bec74$export$e926676385687eaf;

});

parcelRegister("abGcM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::cd5b926575a5c379425d0d72e5339f12>>
 * @codegenCommand yarn workspace @atlaskit/link-picker run codegen-analytics
 */ function $1d2d80882026b768$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $1d2d80882026b768$export$2e2bcd8739ae039 = $1d2d80882026b768$var$createEventPayload;
module.exports["default"] = $1d2d80882026b768$export$2e2bcd8739ae039;

});

parcelRegister("khavy", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

class $096b317da4a8d9ff$export$688779ac61ee945f extends (0, $42omo.Component) {
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && ErrorComponent) return /*#__PURE__*/ (0, $l998X.jsx)(ErrorComponent, {});
        return children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
module.exports["BaseErrorBoundary"] = $096b317da4a8d9ff$export$688779ac61ee945f;

});

parcelRegister("3blls", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $2lNr8 = parcelRequire("2lNr8");


var $c2ARh = parcelRequire("c2ARh");


var $atwsN = parcelRequire("atwsN");


var $lO9iE = parcelRequire("lO9iE");

const $6fbfcea2b9f5c943$var$errorBoundaryFallbackStyles = null;
const $6fbfcea2b9f5c943$var$messages = (0, $cgtv4.defineMessages)({
    heading: {
        defaultMessage: "Something went wrong!",
        id: "fabric.linkPicker.unhandledError.heading"
    },
    description: {
        defaultMessage: "Try reloading the page.",
        id: "fabric.linkPicker.unhandledError.description"
    }
});
const $6fbfcea2b9f5c943$export$8a28b7e38e4685dd = ()=>{
    const intl = (0, $8C5kA.default)();
    const header = intl.formatMessage($6fbfcea2b9f5c943$var$messages.heading);
    const description = intl.formatMessage($6fbfcea2b9f5c943$var$messages.description);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lO9iE.MinHeightContainer), {
        minHeight: (0, $2lNr8.LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK),
        "data-testid": "link-picker-root-error-boundary-ui",
        className: (0, $gMc0m.default)([
            "_11c8i4vh"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $atwsN.EmptyState), {
            header: header,
            renderImage: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $c2ARh.GenericErrorSVG), {}),
            description: description
        })
    });
};
module.exports["ErrorBoundaryFallback"] = $6fbfcea2b9f5c943$export$8a28b7e38e4685dd;

});

parcelRegister("c2ARh", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $2890d1e9307e8ae4$var$SIZE = 96;
const $2890d1e9307e8ae4$var$genericErrorStyles = null;
const $2890d1e9307e8ae4$export$e54420a1a27457a4 = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        className: (0, $gMc0m.default)([
            "_1bsb16xz _4t3i16xz _1e0c1ule"
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#fff",
                d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#DDDEE1",
                d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#DDDEE1",
                d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#DDDEE1",
                d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#B7B9BE",
                d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#DDDEE1",
                fillRule: "evenodd",
                d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#DDDEE1",
                fillRule: "evenodd",
                d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
                clipRule: "evenodd"
            })
        ]
    });
};
module.exports["GenericErrorSVG"] = $2890d1e9307e8ae4$export$e54420a1a27457a4;

});

parcelRegister("atwsN", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cO1el = parcelRequire("cO1el");


var $1s5hv = parcelRequire("1s5hv");

var $iXCQx = parcelRequire("iXCQx");

const $e8c7333955d8c82e$var$styles = {
    containerV2: "_ca0q1ejb _u5f3oahv _19bvoahv _n3td1jfw _y3gn1h6o"
};
const $e8c7333955d8c82e$export$fddf379e22a74b00 = ({ testId: testId, header: header, description: description, action: action, renderImage: renderImage })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        xcss: $e8c7333955d8c82e$var$styles.containerV2,
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.200",
        children: [
            renderImage?.(),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                size: "small",
                as: "h2",
                children: header
            }),
            description && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                as: "p",
                color: "color.text",
                children: description
            }),
            action && action
        ]
    });
};
module.exports["EmptyState"] = $e8c7333955d8c82e$export$fddf379e22a74b00;

});

parcelRegister("lO9iE", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

const $562443300071d672$var$minHeightComponentStyles = null;
const $562443300071d672$export$42134e2a251518b3 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ className: className, minHeight: minHeight, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: ref,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1fhb _1bah1h6o _1tke16li",
            className
        ]),
        ...props,
        style: {
            ['--link-picker-min-height']: minHeight
        }
    });
});
module.exports["MinHeightContainer"] = $562443300071d672$export$42134e2a251518b3;

});

parcelRegister("jrfDA", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9hlns = parcelRequire("9hlns");


var $lO9iE = parcelRequire("lO9iE");

const $c92e1a3420d5d33f$var$styles = null;
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT = '495px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT = '590px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT = '545px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT = '450px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT = '252px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT = '155px';
const $c92e1a3420d5d33f$var$getEstimatedMinHeight = ({ hideDisplayText: hideDisplayText, isLoadingPlugins: isLoadingPlugins, plugins: plugins, url: url })=>{
    /**
   * "Insert mode" (search results shown initially)
   */ if (!url) {
        /**
     * With tabs
     */ if (plugins && plugins.length > 1 || isLoadingPlugins) return hideDisplayText ? $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT : $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT;
         /**
       * Without tabs
       */ 
        if (plugins?.length === 1) return hideDisplayText ? $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT : $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT;
    }
    return hideDisplayText ? $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT : $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT;
};
const $c92e1a3420d5d33f$export$d96e921133238c41 = (props)=>{
    const minHeight = $c92e1a3420d5d33f$var$getEstimatedMinHeight(props);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lO9iE.MinHeightContainer), {
        minHeight: minHeight,
        "data-testid": "link-picker-root-loader-boundary-ui",
        className: (0, $gMc0m.default)([
            "_4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
            testId: "link-picker.component-loading-indicator",
            interactionName: props.name || 'link-picker-loading',
            size: "medium"
        })
    });
};
module.exports["LoaderFallback"] = $c92e1a3420d5d33f$export$d96e921133238c41;

});

parcelRegister("lQSkW", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $ab7LA = parcelRequire("ab7LA");

const $6958f3d9e68e6f8d$export$54320b51a950d54a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ab7LA.LazyMessagesProvider), {
        children: children
    });
};
module.exports["MessagesProvider"] = $6958f3d9e68e6f8d$export$54320b51a950d54a;

});

parcelRegister("ab7LA", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $keVvA = parcelRequire("keVvA");


var $iaMDd = parcelRequire("iaMDd");


var $3lHRF = parcelRequire("3lHRF");

const $42f9fe6b4d8a0292$export$d013d33430f9fb4b = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $keVvA.default), {
        defaultMessages: (0, $iaMDd.default),
        loaderFn: (0, $3lHRF.fetchMessagesForLocale),
        children: children
    });
};
module.exports["LazyMessagesProvider"] = $42f9fe6b4d8a0292$export$d013d33430f9fb4b;

});

parcelRegister("3lHRF", function(module, exports) {

var $aWYpi = parcelRequire("aWYpi");

const $b1e230aff09883c2$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const localeKey = locale.replace('-', '_');
        if (localeKey in (0, $aWYpi.locales)) {
            const messages = await (0, $aWYpi.locales)[localeKey]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $aWYpi.locales)) {
            const messages = await (0, $aWYpi.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
};
module.exports["fetchMessagesForLocale"] = $b1e230aff09883c2$export$2b153a2030b0feb2;

});

parcelRegister("aWYpi", function(module, exports) {

























const $c4ed7fdc8607c9f9$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("f7ay8")),
    da: ()=>(parcelRequire("b8C5q")),
    de: ()=>(parcelRequire("55goX")),
    en_GB: ()=>(parcelRequire("2Qboj")),
    en_ZZ: ()=>(parcelRequire("hbhqt")),
    en: ()=>Promise.resolve((parcelRequire("iaMDd"))),
    es: ()=>(parcelRequire("0176Z")),
    fi: ()=>(parcelRequire("8EsTm")),
    fr: ()=>(parcelRequire("6Aa8Y")),
    hu: ()=>(parcelRequire("98QWJ")),
    it: ()=>(parcelRequire("axMLV")),
    ja: ()=>(parcelRequire("9iWPv")),
    ko: ()=>(parcelRequire("it5VZ")),
    nb: ()=>(parcelRequire("eMImy")),
    nl: ()=>(parcelRequire("ldo9S")),
    pl: ()=>(parcelRequire("8KXjl")),
    pt_BR: ()=>(parcelRequire("cKLZb")),
    ru: ()=>(parcelRequire("eQGp4")),
    sv: ()=>(parcelRequire("foUuI")),
    th: ()=>(parcelRequire("khF3L")),
    tr: ()=>(parcelRequire("3Shvv")),
    uk: ()=>(parcelRequire("7MpfQ")),
    vi: ()=>(parcelRequire("bbM1s")),
    zh_TW: ()=>(parcelRequire("rmgqA")),
    zh: ()=>(parcelRequire("2d7NW"))
};
module.exports["locales"] = $c4ed7fdc8607c9f9$export$df1c34db1371eeed;

});

parcelRegister("f7ay8", function(module, exports) {

let $b00fb167ccbb4de3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b00fb167ccbb4de3$var$load("4Mixi"),
    $b00fb167ccbb4de3$var$load("1jsQH"),
    $b00fb167ccbb4de3$var$load("bv8GZ"),
    $b00fb167ccbb4de3$var$load("i5eMd"),
    $b00fb167ccbb4de3$var$load("4DYJ5"),
    $b00fb167ccbb4de3$var$load("gyXEE"),
    $b00fb167ccbb4de3$var$load("hoPZ9")
]).then(()=>parcelRequire('k82rV'));

});

parcelRegister("b8C5q", function(module, exports) {

let $81bdfc3e9940061d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $81bdfc3e9940061d$var$load("cjveN"),
    $81bdfc3e9940061d$var$load("deyvi"),
    $81bdfc3e9940061d$var$load("cdeuH"),
    $81bdfc3e9940061d$var$load("4UPfH"),
    $81bdfc3e9940061d$var$load("hfFxJ"),
    $81bdfc3e9940061d$var$load("1Mp9N"),
    $81bdfc3e9940061d$var$load("2Fu3d")
]).then(()=>parcelRequire('5CXR9'));

});

parcelRegister("55goX", function(module, exports) {

let $3b3a245be243f89c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3b3a245be243f89c$var$load("8XGJb"),
    $3b3a245be243f89c$var$load("6dERU"),
    $3b3a245be243f89c$var$load("7gF8f"),
    $3b3a245be243f89c$var$load("gd4qs"),
    $3b3a245be243f89c$var$load("gofGr"),
    $3b3a245be243f89c$var$load("dBb6q"),
    $3b3a245be243f89c$var$load("eJgH8")
]).then(()=>parcelRequire('28QMN'));

});

parcelRegister("2Qboj", function(module, exports) {

let $21194624c4e264ab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $21194624c4e264ab$var$load("hdvZr"),
    $21194624c4e264ab$var$load("kTurq"),
    $21194624c4e264ab$var$load("djb49"),
    $21194624c4e264ab$var$load("fviv5"),
    $21194624c4e264ab$var$load("2RQvP"),
    $21194624c4e264ab$var$load("7Lkvk")
]).then(()=>parcelRequire('b4NXj'));

});

parcelRegister("hbhqt", function(module, exports) {

let $c820fb36586af294$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c820fb36586af294$var$load("4ViGN"),
    $c820fb36586af294$var$load("j0PWv"),
    $c820fb36586af294$var$load("ksTQ6"),
    $c820fb36586af294$var$load("eBoC7"),
    $c820fb36586af294$var$load("7NpX8"),
    $c820fb36586af294$var$load("cukQS"),
    $c820fb36586af294$var$load("5FaEJ")
]).then(()=>parcelRequire('5SuH4'));

});

parcelRegister("0176Z", function(module, exports) {

let $00359c5d50f0804f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $00359c5d50f0804f$var$load("32vlK"),
    $00359c5d50f0804f$var$load("dlmud"),
    $00359c5d50f0804f$var$load("5CGnz"),
    $00359c5d50f0804f$var$load("bNv64"),
    $00359c5d50f0804f$var$load("bFU3Y"),
    $00359c5d50f0804f$var$load("3CucM"),
    $00359c5d50f0804f$var$load("9yemY")
]).then(()=>parcelRequire('7TuuZ'));

});

parcelRegister("8EsTm", function(module, exports) {

let $64c878837647bdf9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $64c878837647bdf9$var$load("bjoGV"),
    $64c878837647bdf9$var$load("cbkj0"),
    $64c878837647bdf9$var$load("9Oxgj"),
    $64c878837647bdf9$var$load("4Afgd"),
    $64c878837647bdf9$var$load("exaJ2"),
    $64c878837647bdf9$var$load("lp8Wm"),
    $64c878837647bdf9$var$load("l2LZP")
]).then(()=>parcelRequire('ezgWl'));

});

parcelRegister("6Aa8Y", function(module, exports) {

let $4cadf92e042c2e65$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4cadf92e042c2e65$var$load("8oiz7"),
    $4cadf92e042c2e65$var$load("17m16"),
    $4cadf92e042c2e65$var$load("kAg8V"),
    $4cadf92e042c2e65$var$load("cMubu"),
    $4cadf92e042c2e65$var$load("hcCcg"),
    $4cadf92e042c2e65$var$load("cHWSM"),
    $4cadf92e042c2e65$var$load("35Ssm")
]).then(()=>parcelRequire('gYv97'));

});

parcelRegister("98QWJ", function(module, exports) {

let $6a7dee6b830696fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6a7dee6b830696fd$var$load("hFxmj"),
    $6a7dee6b830696fd$var$load("b4NO6"),
    $6a7dee6b830696fd$var$load("fM2oh"),
    $6a7dee6b830696fd$var$load("3fLE9"),
    $6a7dee6b830696fd$var$load("j9KTb"),
    $6a7dee6b830696fd$var$load("b37xN"),
    $6a7dee6b830696fd$var$load("ik6u5")
]).then(()=>parcelRequire('bVNwo'));

});

parcelRegister("axMLV", function(module, exports) {

let $7ad2d18c5b7fb3bd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7ad2d18c5b7fb3bd$var$load("BXOZB"),
    $7ad2d18c5b7fb3bd$var$load("1K1Fj"),
    $7ad2d18c5b7fb3bd$var$load("xnqy2"),
    $7ad2d18c5b7fb3bd$var$load("8hOn0"),
    $7ad2d18c5b7fb3bd$var$load("3hjAq"),
    $7ad2d18c5b7fb3bd$var$load("7PjNK"),
    $7ad2d18c5b7fb3bd$var$load("Vt6S9")
]).then(()=>parcelRequire('lxZVf'));

});

parcelRegister("9iWPv", function(module, exports) {

let $6c636dd744267993$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6c636dd744267993$var$load("9Xiuh"),
    $6c636dd744267993$var$load("38sfA"),
    $6c636dd744267993$var$load("awkVi"),
    $6c636dd744267993$var$load("h4OCL"),
    $6c636dd744267993$var$load("2bCHJ"),
    $6c636dd744267993$var$load("ktSfi"),
    $6c636dd744267993$var$load("9GZ76")
]).then(()=>parcelRequire('hflsJ'));

});

parcelRegister("it5VZ", function(module, exports) {

let $d71f89e15ac436bf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d71f89e15ac436bf$var$load("7Odo3"),
    $d71f89e15ac436bf$var$load("bjmre"),
    $d71f89e15ac436bf$var$load("11DLa"),
    $d71f89e15ac436bf$var$load("bcQs2"),
    $d71f89e15ac436bf$var$load("fdXnq"),
    $d71f89e15ac436bf$var$load("iouLY"),
    $d71f89e15ac436bf$var$load("4sOIV")
]).then(()=>parcelRequire('73LWR'));

});

parcelRegister("eMImy", function(module, exports) {

let $ac37f5eeb4137d23$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ac37f5eeb4137d23$var$load("4VkvT"),
    $ac37f5eeb4137d23$var$load("asvK9"),
    $ac37f5eeb4137d23$var$load("barSq"),
    $ac37f5eeb4137d23$var$load("aBa7j"),
    $ac37f5eeb4137d23$var$load("cItJR"),
    $ac37f5eeb4137d23$var$load("hPZE5"),
    $ac37f5eeb4137d23$var$load("QTjdE")
]).then(()=>parcelRequire('h0YR4'));

});

parcelRegister("ldo9S", function(module, exports) {

let $f71d8d3405ac63de$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f71d8d3405ac63de$var$load("g5qJV"),
    $f71d8d3405ac63de$var$load("7v6wU"),
    $f71d8d3405ac63de$var$load("a8heY"),
    $f71d8d3405ac63de$var$load("b544F"),
    $f71d8d3405ac63de$var$load("SctKm"),
    $f71d8d3405ac63de$var$load("dzIm8"),
    $f71d8d3405ac63de$var$load("hrf1M")
]).then(()=>parcelRequire('573SD'));

});

parcelRegister("8KXjl", function(module, exports) {

let $6600a08dfb81ea85$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6600a08dfb81ea85$var$load("dPa6p"),
    $6600a08dfb81ea85$var$load("aEpRh"),
    $6600a08dfb81ea85$var$load("6hlNE"),
    $6600a08dfb81ea85$var$load("K6fhx"),
    $6600a08dfb81ea85$var$load("1fJz1"),
    $6600a08dfb81ea85$var$load("jqwnR"),
    $6600a08dfb81ea85$var$load("lsloj")
]).then(()=>parcelRequire('8sMYh'));

});

parcelRegister("cKLZb", function(module, exports) {

let $948f00e640b5806f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $948f00e640b5806f$var$load("iG4uh"),
    $948f00e640b5806f$var$load("3fuR9"),
    $948f00e640b5806f$var$load("2bqSD"),
    $948f00e640b5806f$var$load("gZU54"),
    $948f00e640b5806f$var$load("9yA8o"),
    $948f00e640b5806f$var$load("bGhLc"),
    $948f00e640b5806f$var$load("iRKhU")
]).then(()=>parcelRequire('lRfBG'));

});

parcelRegister("eQGp4", function(module, exports) {

let $acf6d07201fb1e6d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $acf6d07201fb1e6d$var$load("9tVE8"),
    $acf6d07201fb1e6d$var$load("fMrUo"),
    $acf6d07201fb1e6d$var$load("bJykp"),
    $acf6d07201fb1e6d$var$load("4Wdqb"),
    $acf6d07201fb1e6d$var$load("448N7"),
    $acf6d07201fb1e6d$var$load("9v6ER"),
    $acf6d07201fb1e6d$var$load("aEAsN")
]).then(()=>parcelRequire('hZouV'));

});

parcelRegister("foUuI", function(module, exports) {

let $b364eb80f1c4e250$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b364eb80f1c4e250$var$load("6UAlo"),
    $b364eb80f1c4e250$var$load("9eNkX"),
    $b364eb80f1c4e250$var$load("dh2Er"),
    $b364eb80f1c4e250$var$load("k10Cs"),
    $b364eb80f1c4e250$var$load("gBDdh"),
    $b364eb80f1c4e250$var$load("8Mz40"),
    $b364eb80f1c4e250$var$load("l6YHr")
]).then(()=>parcelRequire('4LH4L'));

});

parcelRegister("khF3L", function(module, exports) {

let $ec453ec2806faba2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ec453ec2806faba2$var$load("jYGxH").then(()=>parcelRequire('hlxQj'));

});

parcelRegister("3Shvv", function(module, exports) {

let $2d23fecbe4644720$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2d23fecbe4644720$var$load("czAFw").then(()=>parcelRequire('gQkbc'));

});

parcelRegister("7MpfQ", function(module, exports) {

let $5aa09b1e53b19903$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5aa09b1e53b19903$var$load("c0Efy").then(()=>parcelRequire('lC9hp'));

});

parcelRegister("bbM1s", function(module, exports) {

let $8255f915989d7a01$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8255f915989d7a01$var$load("dKBuH").then(()=>parcelRequire('fzD7h'));

});

parcelRegister("rmgqA", function(module, exports) {

let $0523cae41db9f363$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0523cae41db9f363$var$load("ia9y3"),
    $0523cae41db9f363$var$load("j9OUx"),
    $0523cae41db9f363$var$load("bV8sS"),
    $0523cae41db9f363$var$load("l079e"),
    $0523cae41db9f363$var$load("ebljE"),
    $0523cae41db9f363$var$load("hF4v3"),
    $0523cae41db9f363$var$load("afU9w")
]).then(()=>parcelRequire('6PXdj'));

});

parcelRegister("2d7NW", function(module, exports) {

let $19c2d97ac60aba4a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $19c2d97ac60aba4a$var$load("15ncj"),
    $19c2d97ac60aba4a$var$load("gDiIK"),
    $19c2d97ac60aba4a$var$load("eLlpV"),
    $19c2d97ac60aba4a$var$load("f1B4n"),
    $19c2d97ac60aba4a$var$load("j4dSZ"),
    $19c2d97ac60aba4a$var$load("1Tuyb"),
    $19c2d97ac60aba4a$var$load("7iCpI")
]).then(()=>parcelRequire('5WXmf'));

});

parcelRegister("iCGDI", function(module, exports) {

let $d8ecd9eb03a60beb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d8ecd9eb03a60beb$var$load("9XYQ9"),
    $d8ecd9eb03a60beb$var$load("6wr18"),
    $d8ecd9eb03a60beb$var$load("7EorR"),
    $d8ecd9eb03a60beb$var$load("ffEVr"),
    $d8ecd9eb03a60beb$var$load("Wowvf"),
    $d8ecd9eb03a60beb$var$load("kHOMt"),
    $d8ecd9eb03a60beb$var$load("hhss7"),
    $d8ecd9eb03a60beb$var$load("3QIea"),
    $d8ecd9eb03a60beb$var$load("k0nPy"),
    $d8ecd9eb03a60beb$var$load("c0JsV")
]).then(()=>parcelRequire('cDSVd'));

});

parcelRegister("io1wY", function(module, exports) {
$parcel$export(module.exports, "default", () => $d62ba7e132800466$export$2e2bcd8739ae039);

var $4Ldep = parcelRequire("4Ldep");


var $ksiqf = parcelRequire("ksiqf");


var $b5utg = parcelRequire("b5utg");

function $d62ba7e132800466$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    return (0, $4Ldep.default)(dirtyDate, (0, $ksiqf.default)(Date.now(), 1));
}

});

parcelRegister("l7fKC", function(module, exports) {
/* Toolbar.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $1oCLl = parcelRequire("1oCLl");


var $8hoW2 = parcelRequire("8hoW2");


var $9jB2n = parcelRequire("9jB2n");


var $12Oyv = parcelRequire("12Oyv");


var $j0UQK = parcelRequire("j0UQK");

const $a3c14e992c9fdb13$var$styles = {
    toolbarBase: "_2rko1qi0 _zulp1b66 _1e0c1txw _4cvr1h6o",
    toolbar: "_bfhk1bhr _4t3i14no _u5f31b66 _19bv1b66 _16qs130s",
    toolbarResponsive: "_195gpxbi",
    primaryToolbar: "_bfhkvuon _1tkezwfg",
    toolbarSeparator: "_1mj714no",
    hiddenSelectors: "_fy9oglyw _18shglyw _ze7rglyw",
    hiddenSelectorsPatch: "_z5m7glyw"
};
const $a3c14e992c9fdb13$export$4c260019440d418f = ({ children: children, label: label, actionSubjectId: actionSubjectId, testId: testId })=>{
    const toolbar = /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($a3c14e992c9fdb13$var$styles.toolbarBase, $a3c14e992c9fdb13$var$styles.toolbar, $a3c14e992c9fdb13$var$styles.toolbarResponsive, $a3c14e992c9fdb13$var$styles.hiddenSelectors, $a3c14e992c9fdb13$var$styles.toolbarSeparator, $a3c14e992c9fdb13$var$styles.hiddenSelectorsPatch),
        role: (0, $1oCLl.expValEquals)('platform_editor_aifc_remove_duplicate_role', 'isEnabled', true) ? undefined : 'toolbar',
        "aria-label": label,
        testId: testId,
        "data-toolbar-type": "inline",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $j0UQK.ViewEventEmitter), {
                actionSubject: (0, $j0UQK.ACTION_SUBJECT).TOOLBAR,
                actionSubjectId: actionSubjectId
            }),
            children
        ]
    });
    let wrappedToolbar = toolbar;
    const { keyboardNavigation: keyboardNavigation } = (0, $8hoW2.useToolbarUI)();
    if (keyboardNavigation) {
        const { childComponentSelector: childComponentSelector, dom: dom, handleEscape: handleEscape, handleFocus: handleFocus, isShortcutToFocusToolbar: isShortcutToFocusToolbar, ariaControls: ariaControls, ariaLabel: ariaLabel } = keyboardNavigation;
        wrappedToolbar = /*#__PURE__*/ (0, $l998X.jsx)((0, $12Oyv.ToolbarKeyboardNavigationProvider), {
            childComponentSelector: childComponentSelector,
            dom: dom,
            isShortcutToFocusToolbar: isShortcutToFocusToolbar,
            handleEscape: handleEscape,
            handleFocus: handleFocus,
            ariaControls: ariaControls,
            ariaLabel: ariaLabel,
            children: toolbar
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9jB2n.ResponsiveWrapper), {
        children: wrappedToolbar
    });
};
const $a3c14e992c9fdb13$export$7469f9986edfc2 = ({ children: children, label: label, breakpointPreset: breakpointPreset })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9jB2n.ResponsiveContainer), {
        breakpointPreset: breakpointPreset,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($a3c14e992c9fdb13$var$styles.toolbarBase, $a3c14e992c9fdb13$var$styles.primaryToolbar, $a3c14e992c9fdb13$var$styles.hiddenSelectors),
            role: (0, $1oCLl.expValEquals)('platform_editor_aifc_remove_duplicate_role', 'isEnabled', true) ? undefined : 'toolbar',
            "aria-label": label,
            "data-toolbar-type": "primary",
            children: children
        })
    });
};
module.exports["Toolbar"] = $a3c14e992c9fdb13$export$4c260019440d418f;
module.exports["PrimaryToolbar"] = $a3c14e992c9fdb13$export$7469f9986edfc2;

});

parcelRegister("9jB2n", function(module, exports) {
/* ResponsiveContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-container-queries */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

const $bc8e1bf6110fb52a$var$styles = {
    responsiveContainer: "_1bsb1osq _7cca15wb _1f38ptqj _1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _1ir3glyw _1vp2glyw _1eadglyw _a6zzglyw",
    responsiveContainerFullPage: "_1bsb1ns9 _1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _1ir3glyw _1vp2glyw _1eadglyw _a6zzglyw",
    fullpage: "_luoiglyw _2ojp1ule _11uvglyw _fj2k1ule _1nqyglyw _jd611ule _syrzglyw _fr6v1ule _1je21ule _1btx1ule _biad1ule _1ana1ule",
    reduced: "_kkyiglyw _1dj81ule _1cg81ule _j3qgglyw _xh1i1ule _oj3l1ule _13s9glyw _4nul1ule _wt211ule _tzm6glyw _ktne1ule _87bn1ule",
    jiraIssue: "_152xglyw _1cn41ule _4cj71ule _afriglyw _ozjb1ule _w81r1ule _1mckglyw _r2nv1ule _1ym01ule _tzm6glyw _ktne1ule _87bn1ule",
    jsmComment: "_s2iiglyw _o4331ule _1jvu1ule _lankglyw _1xpy1ule _1vu31ule _1b07glyw _1meg1ule _1bqk1ule _tzm6glyw _ktne1ule _87bn1ule",
    confluenceComment: "_15nrglyw _cm5a1ule _7qjy1ule _13ioglyw _8urt1ule _cpaf1ule _18zmglyw _1uj01ule _1oqh1ule _tzm6glyw _ktne1ule _87bn1ule",
    responsiveRulesWrapper: "_1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _33p2glyw _1dre1ule _u47mglyw _rut51ule _fj5dglyw _5wt61ule _hmx4glyw _1rrm1ule _ut18glyw _1nwo1ule _19fzglyw _1r831ule"
};
const $bc8e1bf6110fb52a$var$presetStyleMap = {
    fullpage: $bc8e1bf6110fb52a$var$styles.fullpage,
    reduced: $bc8e1bf6110fb52a$var$styles.reduced,
    'jira-issue': $bc8e1bf6110fb52a$var$styles.jiraIssue,
    'jsm-comment': $bc8e1bf6110fb52a$var$styles.jsmComment,
    'confluence-comment': $bc8e1bf6110fb52a$var$styles.confluenceComment
};
const $bc8e1bf6110fb52a$export$e60a4704009a0009 = ({ children: children, breakpointPreset: breakpointPreset })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)(breakpointPreset === 'fullpage' ? $bc8e1bf6110fb52a$var$styles.responsiveContainerFullPage : $bc8e1bf6110fb52a$var$styles.responsiveContainer, $bc8e1bf6110fb52a$var$presetStyleMap[breakpointPreset]),
        children: children
    });
}; /**
    * A wrapper that supports responsiveness with media queries. It needs to used together with Show component
    */ 
const $bc8e1bf6110fb52a$export$fa6e408d6a7d6214 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $bc8e1bf6110fb52a$var$styles.responsiveRulesWrapper,
        children: children
    });
};
module.exports["ResponsiveContainer"] = $bc8e1bf6110fb52a$export$e60a4704009a0009;
module.exports["ResponsiveWrapper"] = $bc8e1bf6110fb52a$export$fa6e408d6a7d6214;

});

parcelRegister("12Oyv", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $hTKp4 = parcelRequire("hTKp4");


var $1oCLl = parcelRequire("1oCLl");

const $b79e6ddf5e0c34a1$export$881345eb2554ea9e = ({ children: children, childComponentSelector: childComponentSelector, dom: dom, isShortcutToFocusToolbar: isShortcutToFocusToolbar, handleFocus: handleFocus, handleEscape: handleEscape, ariaLabel: ariaLabel, ariaControls: ariaControls })=>{
    const wrapperRef = (0, $42omo.useRef)(null);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!wrapperRef.current) return;
        const { current: element } = wrapperRef;
        const getFocusableElements = ()=>{
            if (!element) return [];
            // Find all focusable elements within the toolbar that match the child component selector
            const focusableSelectors = [
                'button:not([disabled])',
                '[role="button"]:not([disabled])',
                '[tabindex]:not([tabindex="-1"])'
            ].join(',');
            const allFocusable = Array.from(element.querySelectorAll(focusableSelectors));
            // Filter to only include elements that are:
            // 1. Within the child component selector
            // 2. Visible (not hidden by display:none on itself or any parent)
            return allFocusable.filter((el)=>{
                if (!el.closest(`${childComponentSelector}`)) return false;
                // Check if the element or any of its parents have display: none
                let currentEl = el;
                while(currentEl && currentEl !== element){
                    const computedStyle = window.getComputedStyle(currentEl);
                    if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden') return false;
                    currentEl = currentEl.parentElement;
                }
                return true;
            });
        };
        const moveFocus = (direction)=>{
            const focusableElements = getFocusableElements();
            if (focusableElements.length === 0) return;
            const doc = (0, $hTKp4.getDocument)();
            const currentIndex = focusableElements.findIndex((el)=>el === doc?.activeElement);
            let nextIndex;
            if (currentIndex === -1) // No element currently focused, focus the first one
            nextIndex = 0;
            else if (direction === 'right') // Move right, wrap to beginning if at end
            nextIndex = (currentIndex + 1) % focusableElements.length;
            else // Move left, wrap to end if at beginning
            nextIndex = currentIndex === 0 ? focusableElements.length - 1 : currentIndex - 1;
            focusableElements[nextIndex]?.focus();
        };
        const handleTab = ()=>{
            const focusableElements = getFocusableElements();
            if (focusableElements.length === 0) return;
            const doc = (0, $hTKp4.getDocument)();
            let index = doc?.activeElement ? focusableElements.findIndex((el)=>el === doc?.activeElement) : 0;
            if (index < 0) index = 0;
            focusableElements.forEach((el)=>el.setAttribute('tabindex', '-1'));
            focusableElements[index].setAttribute('tabindex', '0');
        };
        const handleKeyDown = (event)=>{
            const targetElement = event.target;
            if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
            switch(event.key){
                case 'Escape':
                    handleEscape(event);
                    break;
                case 'ArrowLeft':
                    event.preventDefault();
                    moveFocus('left');
                    break;
                case 'ArrowRight':
                    event.preventDefault();
                    moveFocus('right');
                    break;
                case 'Tab':
                    handleTab();
                    break;
                default:
            }
        };
        const globalKeyDownHandler = (event)=>{
            if (isShortcutToFocusToolbar && isShortcutToFocusToolbar(event)) handleFocus(event);
        };
        // ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleKeyDown);
        // ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        dom?.addEventListener('keydown', globalKeyDownHandler);
        return ()=>{
            // ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleKeyDown);
            // ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            dom?.removeEventListener('keydown', globalKeyDownHandler);
        };
    }, [
        wrapperRef,
        childComponentSelector,
        dom,
        isShortcutToFocusToolbar,
        handleFocus,
        handleEscape
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- ignored via go/DSP-18766
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        role: (0, $1oCLl.expValEquals)('platform_editor_aifc_remove_duplicate_role', 'isEnabled', true) ? 'toolbar' : undefined,
        "aria-label": ariaLabel,
        "aria-controls": ariaControls,
        children: children
    });
};
module.exports["ToolbarKeyboardNavigationProvider"] = $b79e6ddf5e0c34a1$export$881345eb2554ea9e;

});

parcelRegister("j0UQK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8hoW2 = parcelRequire("8hoW2");

const $e7817ef9ea32a2ec$export$7525482b5931e326 = {
    TOOLBAR: 'toolbar',
    TOOLBAR_DROPDOWN_MENU: 'toolbarDropdownMenu'
};
const $e7817ef9ea32a2ec$export$58d0f383acf77599 = ({ actionSubjectId: actionSubjectId, actionSubject: actionSubject })=>{
    const isMountedRef = (0, $42omo.useRef)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $8hoW2.useToolbarUI)();
    (0, $42omo.useEffect)(()=>{
        if (isMountedRef.current) return;
        isMountedRef.current = true;
        const payload = {
            action: 'viewed',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            eventType: 'ui'
        };
        fireAnalyticsEvent && fireAnalyticsEvent(payload);
    }, [
        actionSubjectId,
        actionSubject,
        fireAnalyticsEvent
    ]);
    return null;
};
module.exports["ACTION_SUBJECT"] = $e7817ef9ea32a2ec$export$7525482b5931e326;
module.exports["ViewEventEmitter"] = $e7817ef9ea32a2ec$export$58d0f383acf77599;

});

parcelRegister("l8mxb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c984ce41c65c1282842203d88da9a773>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f62bd32daa0e4ca4$var$_react = $f62bd32daa0e4ca4$var$_interopRequireDefault((parcelRequire("42omo")));

var $f62bd32daa0e4ca4$var$_baseNew = $f62bd32daa0e4ca4$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f62bd32daa0e4ca4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdded".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for a user added to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f62bd32daa0e4ca4$var$PersonAddedIcon = (props)=>/*#__PURE__*/ $f62bd32daa0e4ca4$var$_react.default.createElement($f62bd32daa0e4ca4$var$_baseNew.default, Object.assign({
        name: "PersonAddedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M1 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m14.877 2.03-4 4a.75.75 0 0 1-1.051.01L8.98 8.262l1.04-1.08 1.316 1.267 3.48-3.48zM3.75 10.5a2.25 2.25 0 0 0-2.25 2.25V15H0v-2.25A3.75 3.75 0 0 1 3.75 9h2.52a3.75 3.75 0 0 1 3.75 3.75V15h-1.5v-2.25a2.25 2.25 0 0 0-2.25-2.25z" clip-rule="evenodd"/>`
    }, props));
$f62bd32daa0e4ca4$var$PersonAddedIcon.displayName = 'PersonAddedIcon';
var $f62bd32daa0e4ca4$var$_default = module.exports.default = $f62bd32daa0e4ca4$var$PersonAddedIcon;

});

parcelRegister("fSNb6", function(module, exports) {

var $6g1oe = parcelRequire("6g1oe");


var $kfZYI = parcelRequire("kfZYI");

var $lzcvT = parcelRequire("lzcvT");

var $T9xHm = parcelRequire("T9xHm");


var $4IhTl = parcelRequire("4IhTl");


var $7gB19 = parcelRequire("7gB19");


var $7LErD = parcelRequire("7LErD");

// default configs is also config for production env
const $23c58483533ad0ac$var$productionConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: 'https://team.atlassian.com'
};
const $23c58483533ad0ac$var$devAndStagingConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: 'https://team.stg.atlassian.com'
};
const $23c58483533ad0ac$var$localAndTestConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'http',
        server: 'localhost:3000'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: 'https://team.stg.atlassian.com'
};
const $23c58483533ad0ac$var$isolatedCloudConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    // Note that the env type passed to getUrlForDomainInContext (e.g. prod) doesn't matter
    // in Isolated Cloud, so this will work for staging IC too
    atlassianAccountUrl: (0, $kfZYI.getUrlForDomainInContext)('id', 'prod') ?? 'id.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: `https://team.${(0, $T9xHm.isolatedCloudDomain)() ?? ''}`
};
const $23c58483533ad0ac$var$fedrampConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.atlassian-us-gov-mod.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralDisabled: true
};
const $23c58483533ad0ac$var$EnvOverrideKeys = [
    'adev',
    'stg-east',
    'local',
    'test',
    'fedramp',
    'prod-east'
];
const $23c58483533ad0ac$var$environmentOverrides = {
    'prod-east': $23c58483533ad0ac$var$productionConfig,
    local: {
        ...(0, $7LErD.LOCAL_PRODUCTION_BACKEND) ? $23c58483533ad0ac$var$productionConfig : $23c58483533ad0ac$var$localAndTestConfig,
        analytics: {
            scheme: 'http',
            server: typeof (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))) !== 'undefined' ? `${(0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).location.hostname}:3000` : 'localhost:3000'
        }
    },
    test: {
        ...$23c58483533ad0ac$var$localAndTestConfig
    },
    adev: $23c58483533ad0ac$var$devAndStagingConfig,
    'stg-east': $23c58483533ad0ac$var$devAndStagingConfig,
    fedramp: $23c58483533ad0ac$var$fedrampConfig
};
const $23c58483533ad0ac$var$cachedConfig = {};
function $23c58483533ad0ac$export$634ecc602a6871aa() {
    return (0, $lzcvT.isFedRamp)();
}
function $23c58483533ad0ac$export$44487a86467333c3() {
    const env = $23c58483533ad0ac$export$634ecc602a6871aa() ? 'fedramp' : (0, $7gB19.getEnv)();
    const appName = (0, $4IhTl.getAppName)();
    const key = `${env}_${appName}`;
    if (!$23c58483533ad0ac$var$cachedConfig[key]) {
        if ((0, $T9xHm.isIsolatedCloud)()) $23c58483533ad0ac$var$cachedConfig[key] = $23c58483533ad0ac$var$isolatedCloudConfig;
        else if ($23c58483533ad0ac$var$EnvOverrideKeys.includes(env)) $23c58483533ad0ac$var$cachedConfig[key] = {
            ...$23c58483533ad0ac$var$environmentOverrides[env]
        };
        else // fallback to prod as customers can have custom domains.
        $23c58483533ad0ac$var$cachedConfig[key] = {
            ...$23c58483533ad0ac$var$environmentOverrides['prod-east']
        };
    }
    return $23c58483533ad0ac$var$cachedConfig[key];
}
module.exports["isFedramp"] = $23c58483533ad0ac$export$634ecc602a6871aa;
module.exports["getConfig"] = $23c58483533ad0ac$export$44487a86467333c3;

});

parcelRegister("4IhTl", function(module, exports) {
var $e50b5a5f7ee21567$export$b767e803e7ca9563 = /*#__PURE__*/ function(AppNames) {
    AppNames["EMBEDDABLE_DIRECTORY"] = "embeddableDirectory";
    AppNames["STANDALONE_DIRECTORY"] = "standaloneDirectory";
    return AppNames;
}({});
function $e50b5a5f7ee21567$export$dcecb2dbc7fe753c() {
    // @ts-ignore
    return window.__app_name__ || "embeddableDirectory";
}
module.exports["AppNames"] = $e50b5a5f7ee21567$export$b767e803e7ca9563;
module.exports["getAppName"] = $e50b5a5f7ee21567$export$dcecb2dbc7fe753c;

});

parcelRegister("7gB19", function(module, exports) {

var $6g1oe = parcelRequire("6g1oe");


var $7LErD = parcelRequire("7LErD");

var $c1805fedb6ad58a9$export$e7dfafc24fab792e = /*#__PURE__*/ function(MicrosEnv) {
    MicrosEnv["ADEV"] = "adev";
    MicrosEnv["STG_EAST"] = "stg-east";
    MicrosEnv["PROD_EAST"] = "prod-east";
    return MicrosEnv;
}({});
const $c1805fedb6ad58a9$export$d76bdf9f4281ae1b = {
    local: 'local',
    test: 'test',
    prod: 'prod',
    stg: 'staging',
    ["adev"]: 'staging',
    ["stg-east"]: 'staging',
    ["prod-east"]: 'production'
};
const $c1805fedb6ad58a9$var$SIMPLE_TO_DAMN_COMPLEX_ENV = {
    prod: 'prod-east',
    stg: 'stg-east'
};
let $c1805fedb6ad58a9$var$presetEnv;
const $c1805fedb6ad58a9$export$84bc02d3c7a6b55f = (env)=>{
    const envOverride = $c1805fedb6ad58a9$var$SIMPLE_TO_DAMN_COMPLEX_ENV[env];
    if (envOverride) $c1805fedb6ad58a9$var$presetEnv = envOverride;
};
function $c1805fedb6ad58a9$export$4bd44a2aa29d3d6e() {
    if ($c1805fedb6ad58a9$var$presetEnv) return $c1805fedb6ad58a9$var$presetEnv;
    if (0, $7LErD.DEV) return 'local';
    // @ts-ignore
    return (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).__env__;
}
function $c1805fedb6ad58a9$export$15b8d8b1ba394f55() {
    return $c1805fedb6ad58a9$export$d76bdf9f4281ae1b[$c1805fedb6ad58a9$export$4bd44a2aa29d3d6e()];
}
module.exports["setEnv"] = $c1805fedb6ad58a9$export$84bc02d3c7a6b55f;
module.exports["getEnv"] = $c1805fedb6ad58a9$export$4bd44a2aa29d3d6e;

});

parcelRegister("7LErD", function(module, exports) {
// @ts-ignore
const $015647182f1a27ed$export$404582bc18fe4d9e = typeof __DEV__ !== 'undefined' && __DEV__;
const $015647182f1a27ed$export$771a63345d182ddd = // @ts-ignore
typeof __LOCAL_PRODUCTION_BACKEND__ !== 'undefined' && // @ts-ignore
__LOCAL_PRODUCTION_BACKEND__;
module.exports["DEV"] = $015647182f1a27ed$export$404582bc18fe4d9e;
module.exports["LOCAL_PRODUCTION_BACKEND"] = $015647182f1a27ed$export$771a63345d182ddd;

});

parcelRegister("6aZ5T", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb8521585dee6236$export$2e2bcd8739ae039);
// Do not export TeamProfileCard here as it will break lazy-loading for the team trigger.


var $aZdSX = parcelRequire("aZdSX");

var $bb8521585dee6236$export$2e2bcd8739ae039 = (0, $aZdSX.default);

});

parcelRegister("aZdSX", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b8c19cec0dfc921$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $gmMgo = parcelRequire("gmMgo");


var $iK7QL = parcelRequire("iK7QL");

var $9EUfN = parcelRequire("9EUfN");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $gdv5Z = parcelRequire("gdv5Z");


var $fDXXi = parcelRequire("fDXXi");


var $dTk3A = parcelRequire("dTk3A");


var $81aSu = parcelRequire("81aSu");


var $2qY37 = parcelRequire("2qY37");


var $bUp2E = parcelRequire("bUp2E");


var $aCzn4 = parcelRequire("aCzn4");


var $fVnHQ = parcelRequire("fVnHQ");


var $caPHA = parcelRequire("caPHA");


var $k5hbH = parcelRequire("k5hbH");


var $lIPgo = parcelRequire("lIPgo");


var $2q1np = parcelRequire("2q1np");

class $5b8c19cec0dfc921$export$f811dc569217c959 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentDidMount() {
        this._isMounted = true;
    }
    componentDidUpdate(prevProps) {
        const { orgId: orgId, teamId: teamId, resourceClient: resourceClient } = this.props;
        const { visible: visible } = this.state;
        // just re-fetching data when the card opens
        if (visible && (teamId !== prevProps.teamId || orgId !== prevProps.orgId || resourceClient !== prevProps.resourceClient)) this.setState({
            isLoading: undefined
        }, this.clientFetchProfile);
    }
    componentWillUnmount() {
        this._isMounted = false;
        clearTimeout(this.showTimer);
        clearTimeout(this.hideTimer);
    }
    handleClientSuccess(team, shouldShowGiveKudos, teamCentralBaseUrl) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: false,
            data: team,
            shouldShowGiveKudos: shouldShowGiveKudos,
            teamCentralBaseUrl: teamCentralBaseUrl
        });
    }
    handleClientError(err) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: true,
            error: err
        });
    }
    filterActions() {
        const actions = (0, $81aSu.default)(this.props.actions, this.state.data);
        if (this.state.shouldShowGiveKudos) {
            const kudosAction = {
                label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $2qY37.default).giveKudosButton
                }),
                id: 'give-kudos',
                callback: ()=>{
                    this.openKudosDrawer();
                },
                link: this.kudosUrl()
            };
            return actions.concat([
                kudosAction
            ]);
        }
        return actions;
    }
    renderPopup() {
        if (this.state.renderError) return this.props.children;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $k5hbH.ErrorBoundary), {
            onError: this.onErrorBoundary,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
                isOpen: !!this.state.visible,
                onClose: this.onClose,
                placement: this.props.position,
                content: this.renderProfileCard,
                trigger: (triggerProps)=>this.renderTrigger(triggerProps),
                zIndex: (0, $dTk3A.layers).modal(),
                shouldFlip: true,
                autoFocus: this.props.trigger !== 'hover' && !this.openedByHover,
                shouldRenderToParent: (0, $dh538.fg)('enable_appropriate_reading_order_in_profile_card') && this.props.shouldRenderToParent
            })
        });
    }
    render() {
        if (this.props.children) return this.renderPopup();
        else throw new Error('Component "TeamProfileCardTrigger" must have "children" property');
    }
    constructor(...args){
        super(...args);
        this._isMounted = false;
        this.showTimer = 0;
        this.hideTimer = 0;
        this.openedByHover = false;
        this.openTime = 0;
        this.fireAnalytics = (eventKey, ...attributes)=>{
            // Don't fire any analytics if the component is unmounted
            if (!this._isMounted) return;
            if (this.props.fireEvent) this.props.fireEvent(eventKey, ...attributes);
        };
        this.fireAnalyticsWithDuration = (eventKey, generator)=>{
            const duration = (0, $caPHA.getPageTime)() - this.openTime;
            const attributes = generator(duration);
            this.fireAnalytics(eventKey, attributes);
        };
        this.hideProfilecard = (delay = 0)=>{
            clearTimeout(this.showTimer);
            clearTimeout(this.hideTimer);
            this.hideTimer = window.setTimeout(()=>{
                this.setState({
                    visible: false
                });
            }, delay);
        };
        this.showProfilecard = (delay = 0)=>{
            clearTimeout(this.hideTimer);
            clearTimeout(this.showTimer);
            this.showTimer = window.setTimeout(()=>{
                if (!this.state.visible) {
                    this.clientFetchProfile();
                    this.openTime = (0, $caPHA.getPageTime)();
                    this.setState({
                        visible: true
                    });
                }
            }, delay);
        };
        this.onClick = (event)=>{
            if (this.props.triggerLinkType === 'link') // We want to prevent navigation occurring on basic click, but it's important that
            // cmd+click, ctrl+click, etc. still work as expected.
            {
                if ((0, $aCzn4.isBasicClick)(event)) event.preventDefault();
            }
            if (this.props.triggerLinkType === 'clickable-link') {
                if (this.props.viewProfileOnClick) this.props.viewProfileOnClick(event);
            }
            if (this.props.trigger !== 'hover') {
                this.openedByHover = false;
                this.showProfilecard(0);
                if (!this.state.visible) this.fireAnalytics('ui.teamProfileCard.triggered', {
                    method: 'click',
                    ...(0, $bUp2E.PACKAGE_META_DATA),
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    teamId: this.props.teamId
                });
            }
        };
        this.onMouseEnter = ()=>{
            if (this.props.trigger === 'click') return;
            if (!this.state.visible) {
                this.openedByHover = true;
                this.fireAnalytics('ui.teamProfileCard.triggered', {
                    method: 'hover',
                    ...(0, $bUp2E.PACKAGE_META_DATA),
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    teamId: this.props.teamId
                });
            }
            this.showProfilecard((0, $fVnHQ.DELAY_MS_SHOW));
        };
        this.onMouseLeave = ()=>{
            if (this.props.trigger === 'click') return;
            if (this.openedByHover) this.hideProfilecard((0, $fVnHQ.DELAY_MS_HIDE));
        };
        this.onKeyPress = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.setState({
                    isTriggeredByKeyboard: true
                });
                this.showProfilecard(0);
                if (!this.state.visible) this.fireAnalytics('ui.teamProfileCard.triggered', {
                    method: 'click',
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    teamId: this.props.teamId,
                    ...(0, $bUp2E.PACKAGE_META_DATA)
                });
            }
        };
        this.onClose = ()=>{
            this.hideProfilecard();
            this.setState({
                isTriggeredByKeyboard: false
            });
        };
        this.openKudosDrawer = ()=>{
            this.hideProfilecard((0, $fVnHQ.DELAY_MS_HIDE));
            this.setState({
                kudosDrawerOpen: true
            });
        };
        this.closeKudosDrawer = ()=>{
            this.setState({
                kudosDrawerOpen: false
            });
        };
        this.kudosUrl = ()=>{
            const recipientId = this.props.teamId && `&recipientId=${this.props.teamId}` || '';
            const cloudId = this.props.cloudId && `&cloudId=${this.props.cloudId}` || '';
            return `${this.state.teamCentralBaseUrl}/kudos/give?type=team${recipientId}${cloudId}`;
        };
        this.stopPropagation = (event)=>{
            // We need to stop propagation when users click on the card, so that it
            // doesn't trigger any special effects that occur when clicking the trigger.
            event.stopPropagation();
        };
        this.triggerListeners = {
            onClick: this.onClick,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        };
        this.cardListeners = {
            onClick: this.stopPropagation,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        };
        this.state = {
            visible: false,
            isLoading: undefined,
            hasError: false,
            error: null,
            data: null,
            shouldShowGiveKudos: false,
            teamCentralBaseUrl: undefined,
            kudosDrawerOpen: false,
            isTriggeredByKeyboard: false
        };
        this.clientFetchProfile = ()=>{
            const { orgId: orgId, teamId: teamId } = this.props;
            const { isLoading: isLoading } = this.state;
            if (isLoading === true) // don't fetch data when fetching is in process
            return;
            this.setState({
                isLoading: true,
                data: null
            }, ()=>{
                const requests = Promise.all([
                    this.props.resourceClient.getTeamProfile(teamId, orgId, this.fireAnalytics),
                    this.props.resourceClient.shouldShowGiveKudos(),
                    this.props.resourceClient.getTeamCentralBaseUrl({
                        withOrgContext: true,
                        withSiteContext: true
                    })
                ]);
                requests.then((res)=>this.handleClientSuccess(...res), (err)=>this.handleClientError(err)).catch((err)=>this.handleClientError(err));
            });
        };
        this.onErrorBoundary = ()=>{
            this.fireAnalytics('ui.teamProfileCard.rendered.errorBoundary', {
                ...(0, $bUp2E.PACKAGE_META_DATA),
                firedAt: Math.round((0, $caPHA.getPageTime)()),
                duration: 0
            });
            this.setState({
                renderError: true
            });
        };
        this.renderProfileCard = ()=>{
            const { generateUserLink: generateUserLink, onUserClick: onUserClick, viewingUserId: viewingUserId, viewProfileLink: viewProfileLink, viewProfileOnClick: viewProfileOnClick } = this.props;
            const { data: data, error: error, hasError: hasError, isLoading: isLoading } = this.state;
            const newProps = {
                clientFetchProfile: this.clientFetchProfile,
                actions: this.filterActions(),
                analytics: ()=>{},
                analyticsNext: this.fireAnalyticsWithDuration,
                team: data || undefined,
                generateUserLink: generateUserLink,
                onUserClick: onUserClick,
                viewingUserId: viewingUserId,
                viewProfileLink: viewProfileLink,
                viewProfileOnClick: viewProfileOnClick
            };
            return /*#__PURE__*/ (0, $l998X.jsx)("div", {
                ...this.cardListeners,
                children: this.state.visible && /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                    fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $2q1np.default), {
                        analytics: ()=>{},
                        analyticsNext: this.fireAnalyticsWithDuration
                    }),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lIPgo.TeamProfileCardLazy), {
                        ...newProps,
                        isLoading: isLoading,
                        hasError: hasError,
                        errorType: error,
                        isTriggeredByKeyboard: this.state.isTriggeredByKeyboard
                    })
                })
            });
        };
        this.renderKudosLauncher = ()=>{
            return this.state.shouldShowGiveKudos && /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iK7QL.GiveKudosLauncherLazy), {
                    isOpen: this.state.kudosDrawerOpen,
                    recipient: {
                        type: (0, $9EUfN.KudosType).TEAM,
                        recipientId: this.props.teamId
                    },
                    analyticsSource: "team-profile-card",
                    teamCentralBaseUrl: this.state.teamCentralBaseUrl,
                    cloudId: this.props.cloudId || '',
                    addFlag: this.props.addFlag,
                    onClose: this.closeKudosDrawer
                })
            });
        };
        this.renderTrigger = (triggerProps)=>{
            const { children: children, intl: intl, triggerLinkType: triggerLinkType, viewProfileLink: viewProfileLink } = this.props;
            if (triggerLinkType === 'none') return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    this.renderKudosLauncher(),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        as: "span",
                        role: "button",
                        testId: "team-profilecard-trigger-wrapper",
                        tabIndex: 0,
                        "aria-label": intl.formatMessage((0, $2qY37.default).teamProfileCardAriaLabel),
                        onKeyUp: this.onKeyPress,
                        ...triggerProps,
                        ...this.triggerListeners,
                        children: children
                    })
                ]
            });
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    this.renderKudosLauncher(),
                    /*#__PURE__*/ (0, $l998X.jsx)("a", {
                        "data-testid": "team-profilecard-trigger-wrapper",
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            color: 'initial',
                            textDecoration: 'none'
                        },
                        href: viewProfileLink,
                        ...triggerProps,
                        ref: triggerProps.ref,
                        ...this.triggerListeners,
                        children: children
                    })
                ]
            });
        };
    }
}
$5b8c19cec0dfc921$export$f811dc569217c959.defaultProps = {
    actions: [],
    trigger: 'hover',
    position: 'bottom-start',
    triggerLinkType: 'link',
    shouldRenderToParent: true
};
const $5b8c19cec0dfc921$var$TeamProfileCardTrigger = (props)=>{
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    if ((0, $dh538.fg)('people-teams-deprecate-profilecard-teams')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: props.children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)($5b8c19cec0dfc921$export$f811dc569217c959, {
        ...props,
        fireEvent: fireEvent
    });
};
var /**
 * @deprecated This component is deprecated and provides no functionality.
 * It now simply renders its children without any profile card behavior.
 * Please use `@atlassian/team-profilecard` instead for team profile card functionality.
 */ $5b8c19cec0dfc921$export$2e2bcd8739ae039 = (0, $gmMgo.default)($5b8c19cec0dfc921$var$TeamProfileCardTrigger);

});

parcelRegister("k5hbH", function(module, exports) {

var $42omo = parcelRequire("42omo");

class $2b2ce0b0062a7857$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidCatch() {
        // Failure analytics here too
        this.props.onError();
    }
    render() {
        return this.props.children;
    }
}
var $2b2ce0b0062a7857$export$2e2bcd8739ae039 = $2b2ce0b0062a7857$export$e926676385687eaf;
module.exports["ErrorBoundary"] = $2b2ce0b0062a7857$export$e926676385687eaf;

});

parcelRegister("lIPgo", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $8c4f830abcac73ad$export$82a49d896f41ca78 = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7fS2v")));
module.exports["TeamProfileCardLazy"] = $8c4f830abcac73ad$export$82a49d896f41ca78;

});

parcelRegister("7fS2v", function(module, exports) {

let $5483da36ed8fd628$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5483da36ed8fd628$var$load("eY3St"),
    $5483da36ed8fd628$var$load("bkd4T"),
    $5483da36ed8fd628$var$load("6wr18"),
    $5483da36ed8fd628$var$load("ffEVr"),
    $5483da36ed8fd628$var$load("jnkIk")
]).then(()=>parcelRequire('3PwS1'));

});

parcelRegister("2q1np", function(module, exports) {
$parcel$export(module.exports, "default", () => $08e9a613b6d3c33c$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $9hlns = parcelRequire("9hlns");


var $by9Aj = parcelRequire("by9Aj");


var $bUp2E = parcelRequire("bUp2E");


var $caPHA = parcelRequire("caPHA");

var $08e9a613b6d3c33c$export$2e2bcd8739ae039 = (props)=>{
    const { analytics: analytics, analyticsNext: analyticsNext } = props;
    (0, $42omo.useEffect)(()=>{
        if ((0, $dh538.fg)('ptc-enable-profile-card-analytics-refactor')) analyticsNext('ui.teamProfileCard.rendered.spinner', (duration)=>({
                duration: duration,
                firedAt: Math.round((0, $caPHA.getPageTime)()),
                ...(0, $bUp2E.PACKAGE_META_DATA)
            }));
        else analytics((duration)=>(0, $bUp2E.profileCardRendered)('team', 'spinner', {
                duration: duration
            }));
    }, [
        analytics,
        analyticsNext
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $by9Aj.CardWrapper), {
        testId: "team-profilecard",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $by9Aj.CardHeader), {
                isLoading: true
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $by9Aj.CardContent), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $by9Aj.LoadingWrapper), {
                    testId: "team-profilecard-spinner",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {})
                })
            })
        ]
    });
};

});

parcelRegister("by9Aj", function(module, exports) {
/* TeamTrigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $jv8de = parcelRequire("jv8de");

const $45954f322eeb538a$var$styles = {
    cardtriggerwrapper: "_1e0c1kw7",
    cardwrapper: "_2rko12b0 _1bsbnklw _kqswh2mm",
    cardheader: "_4t3i1qr7 _1bsb1osq",
    cardcontent: "_1e0c1txw _2lx21bp4 _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _1tke1l8a",
    loadingwrapper: "_y3gn1h6o _19pk1jfw _otyr1jfw",
    grayoutImage: "_kdam7g3v"
};
const $45954f322eeb538a$export$a443be8291b92497 = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($45954f322eeb538a$var$styles.cardtriggerwrapper)
    });
const $45954f322eeb538a$export$6aa22a823032b784 = ({ testId: testId, children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($45954f322eeb538a$var$styles.cardwrapper),
        backgroundColor: "elevation.surface.overlay",
        testId: testId,
        children: children
    });
const $45954f322eeb538a$export$5665775b26e26c5d = ({ image: image, isLoading: isLoading, label: label, isDisabled: isDisabled })=>isLoading || !image ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($45954f322eeb538a$var$styles.cardheader, isDisabled && $45954f322eeb538a$var$styles.grayoutImage),
        backgroundColor: "color.background.neutral"
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $jv8de.CoverImage), {
        alt: label || '',
        src: image,
        isDisabled: isDisabled
    });
const $45954f322eeb538a$export$64ef9b8c11710c47 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($45954f322eeb538a$var$styles.cardcontent),
        ...props
    });
const $45954f322eeb538a$export$43a792a870d28db2 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($45954f322eeb538a$var$styles.loadingwrapper),
        ...props
    });
module.exports["CardWrapper"] = $45954f322eeb538a$export$6aa22a823032b784;
module.exports["CardHeader"] = $45954f322eeb538a$export$5665775b26e26c5d;
module.exports["CardContent"] = $45954f322eeb538a$export$64ef9b8c11710c47;
module.exports["LoadingWrapper"] = $45954f322eeb538a$export$43a792a870d28db2;

});

parcelRegister("jv8de", function(module, exports) {
/* CoverImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

const $51d6e29b89f36ec6$var$styles = {
    container: "_1reo15vq _18m915vq _1bsb1osq _4t3i1qr7 _kqswh2mm _13li12b0 _qrwq12b0 _1e0c1txw _1bah1h6o _4cvr1h6o",
    image: "_1bsbnklw _4t3i1wug",
    imageNext: "_4t3i1osq _5ral1dfr",
    grayoutImage: "_kdam7g3v"
};
const $51d6e29b89f36ec6$export$a65e282337ff0f53 = ({ src: src, alt: alt = '', isDisabled: isDisabled })=>{
    const containerRef = (0, $42omo.useRef)(null);
    const imgRef = (0, $42omo.useRef)(null);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        ref: containerRef,
        xcss: $51d6e29b89f36ec6$var$styles.container,
        backgroundColor: "color.background.neutral",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            as: "img",
            ref: imgRef,
            src: src,
            alt: alt,
            xcss: (0, $1Whri.cx)((0, $dh538.fg)('cover-header-image-team-profilecard') ? $51d6e29b89f36ec6$var$styles.imageNext : $51d6e29b89f36ec6$var$styles.image, isDisabled && $51d6e29b89f36ec6$var$styles.grayoutImage)
        })
    });
};
module.exports["CoverImage"] = $51d6e29b89f36ec6$export$a65e282337ff0f53;

});

parcelRegister("4bnNr", function(module, exports) {

var $hdvI3 = parcelRequire("hdvI3");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/jira/project/manifest.ts
var $30baa5fc53208f94$var$jiraProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $hdvI3.JiraProjectAriResourceOwner),
    resourceType: (0, $hdvI3.JiraProjectAriResourceType),
    resourceIdSlug: "{projectId}",
    resourceIdSegmentFormats: {
        projectId: /[0-9]+/
    }
};
// src/jira/project/index.ts
var $30baa5fc53208f94$export$75a0a0a7cb0a58ae = class _JiraProjectAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get projectId() {
        return this._projectId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $30baa5fc53208f94$var$jiraProjectAriStaticOpts.qualifier,
            platformQualifier: $30baa5fc53208f94$var$jiraProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $30baa5fc53208f94$var$jiraProjectAriStaticOpts.resourceOwner,
            resourceType: $30baa5fc53208f94$var$jiraProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectId}`,
            resourceIdSegmentValues: {
                projectId: opts.projectId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $30baa5fc53208f94$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $30baa5fc53208f94$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectId: this.projectId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._projectId = opts.resourceIdSegmentValues.projectId;
    }
};
module.exports["JiraProjectAri"] = $30baa5fc53208f94$export$75a0a0a7cb0a58ae;

});

parcelRegister("hdvI3", function(module, exports) {
// src/jira/project/types.ts
var $c88c3f6e5a62c5c4$export$99d538a3b04916b1 = "jira", $c88c3f6e5a62c5c4$export$736763838d3aa22e = "project";
module.exports["JiraProjectAriResourceOwner"] = $c88c3f6e5a62c5c4$export$99d538a3b04916b1;
module.exports["JiraProjectAriResourceType"] = $c88c3f6e5a62c5c4$export$736763838d3aa22e;

});

parcelRegister("Knzlm", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $asH6r = parcelRequire("asH6r");

var $ecUKi = parcelRequire("ecUKi");

// Private actions:
// It is called by `getPrincipalUserInfo` action
const $3022123db001046f$var$getIsSiteAdmin = (cloudId)=>async ({ setState: setState })=>{
        if (!cloudId) {
            setState({
                isSiteAdmin: false
            });
            return;
        }
        let isSiteAdmin = false;
        try {
            isSiteAdmin = await (0, $asH6r.teamsClient).getIsSiteAdmin(cloudId);
        } catch (e) {
        // do nothing because isSiteAdmin is returned as false
        } finally{
            setState({
                isSiteAdmin: isSiteAdmin
            });
        }
    };
// it is called by `getPrincipalUserInfo` action
const $3022123db001046f$var$getMutability = (userId)=>async ({ setState: setState })=>{
        try {
            const data = await (0, $asH6r.teamsClient).getProfileWithMutability(userId);
            setState({
                mutabilityConstraints: data
            });
        } catch (e) {
        // do nothing because isSiteAdmin is returned as false
        }
    };
const $3022123db001046f$var$getAvatarUploadedStatus = (userId)=>async ({ setState: setState })=>{
        try {
            setState({
                avatarUploaded: {
                    isLoading: true,
                    error: undefined,
                    uploaded: undefined
                }
            });
            const data = await (0, $asH6r.teamsClient).getMyAvatarUploadedStatus(userId);
            setState({
                avatarUploaded: {
                    isLoading: false,
                    uploaded: data.uploaded
                }
            });
        } catch (e) {
            setState({
                avatarUploaded: {
                    isLoading: false,
                    error: e instanceof Error ? e : new Error('Unknown error'),
                    uploaded: undefined
                }
            });
        }
    };
const $3022123db001046f$var$actions = {
    /**
	 * Get user information of current logged-in user.
	 * @param cloudId: If Cloud Id is passed, that means People Directory is rendered in a site and we use Cloud Id to check 'isSiteAdmin' info.
	 * If Cloud Id is not passed, `isSiteAdmin` is false by default.
	 */ getPrincipalUserInfo: (cloudId)=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            // stop fetching when it is already fetched
            if (getState().isFetching || getState().hasLoaded) return;
            setState({
                isFetching: true,
                hasLoaded: false
            });
            try {
                const userBasicData = await (0, $ecUKi.userInfoProvider).get();
                setState({
                    principalUserId: userBasicData.userId,
                    ...userBasicData
                });
                dispatch($3022123db001046f$var$getIsSiteAdmin(cloudId));
                dispatch($3022123db001046f$var$getMutability(userBasicData.userId));
                setState({
                    hasLoaded: true
                });
            } catch (e) {
                setState({
                    hasError: true,
                    hasLoaded: false
                });
            } finally{
                setState({
                    isFetching: false
                });
            }
        },
    getAvatarUploadedStatus: $3022123db001046f$var$getAvatarUploadedStatus,
    setAvatarUploadedStatus: (uploaded)=>({ setState: setState })=>{
            setState({
                avatarUploaded: {
                    uploaded: uploaded,
                    isLoading: false,
                    isDeleting: false
                }
            });
        },
    deleteUserAvatar: ()=>async ({ getState: getState, dispatch: dispatch, setState: setState })=>{
            try {
                setState({
                    avatarUrl: undefined,
                    avatarUploaded: {
                        isDeleting: true,
                        isLoading: true,
                        error: undefined
                    }
                });
                await (0, $asH6r.teamsClient).deleteAvatar(getState().principalUserId);
                dispatch($3022123db001046f$var$actions.fetchAvatarInfo());
            } catch (e) {
                setState({
                    avatarUploaded: {
                        isLoading: false,
                        isDeleting: false,
                        error: e instanceof Error ? e : new Error('Unknown error')
                    }
                });
            } finally{
                setState({
                    avatarUploaded: {
                        isLoading: false,
                        isDeleting: false
                    }
                });
            }
        },
    fetchAvatarInfo: ()=>async ({ getState: getState, setState: setState })=>{
            const avatarInfo = await (0, $asH6r.teamsClient).fetchUserAvatarInfo(getState().principalUserId);
            setState({
                avatarUrl: avatarInfo.url,
                avatarUploaded: {
                    uploaded: avatarInfo.uploaded,
                    isLoading: false
                }
            });
        },
    updateUserAvatar: (userId, fileURI)=>async ({ setState: setState })=>{
            setState({
                avatarUrl: undefined,
                avatarUploaded: {
                    isDeleting: false,
                    isLoading: true,
                    isUploading: true,
                    hasUploadedAvatar: false,
                    error: undefined
                }
            });
            try {
                const avatarUrl = await (0, $asH6r.teamsClient).updateUserAvatar({
                    id: userId,
                    fileURI: fileURI
                });
                setState({
                    avatarUrl: avatarUrl,
                    avatarUploaded: {
                        uploaded: true,
                        isLoading: false,
                        isUploading: false,
                        hasUploadedAvatar: true
                    }
                });
            } catch (error) {
                setState({
                    avatarUploaded: {
                        isLoading: false,
                        isUploading: false,
                        error: error instanceof Error ? error : new Error('Unknown error'),
                        hasUploadedAvatar: undefined
                    }
                });
            }
        },
    setPrincipalUserInfo: (data)=>({ setState: setState })=>{
            setState(data);
        },
    getIsSiteAdmin: $3022123db001046f$var$getIsSiteAdmin,
    setPrincipalUserId: (principalUserId)=>({ setState: setState })=>{
            setState({
                principalUserId: principalUserId
            });
        }
};
const $3022123db001046f$var$initialState = {
    principalUserId: '',
    avatarUrl: '',
    email: '',
    fullName: '',
    title: '',
    isSiteAdmin: false,
    isFetching: false,
    hasError: false,
    hasLoaded: false,
    avatarUploaded: {
        isLoading: false
    }
};
/**
 * Manage states of a site
 */ const $3022123db001046f$var$Store = (0, $1P1Tu.createStore)({
    initialState: $3022123db001046f$var$initialState,
    actions: $3022123db001046f$var$actions,
    name: 'PrincipalUser'
});
const $3022123db001046f$export$33e3bf16c7530dd4 = (0, $9zUhf.createHook)($3022123db001046f$var$Store);
const $3022123db001046f$export$b26d2c7f264f51a8 = (0, $9zUhf.createHook)($3022123db001046f$var$Store, {
    selector: (state)=>state.avatarUploaded
});
module.exports["usePrincipalUser"] = $3022123db001046f$export$33e3bf16c7530dd4;
module.exports["useAvatarUploadedStatus"] = $3022123db001046f$export$b26d2c7f264f51a8;

});

parcelRegister("ecUKi", function(module, exports) {

var $9qOkK = parcelRequire("9qOkK");

// Needs to be declared here to avoid blowing up this earlyInit bundle
class $0c5ce416cf97cf51$var$FetchError extends Error {
    constructor(response){
        super(`Request failed with status ${response.status}`);
        this.name = void 0;
        this.response = void 0;
        this.response = response;
        this.name = this.constructor.name;
    }
}
class $0c5ce416cf97cf51$export$dc10e400a1189789 {
    get(fetchOp = fetch) {
        if (this.promise) return this.promise;
        const getJson = (url)=>fetchOp(url, {
                method: 'GET',
                mode: 'cors',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then((response)=>{
                if (!response.ok) throw new $0c5ce416cf97cf51$var$FetchError(response);
                return response.json();
            });
        this.promise = getJson(`${(0, $9qOkK.DEFAULT_CONFIG).stargateRoot}/me`).then((me)=>{
            return {
                userId: me.account_id,
                locale: me.locale,
                fullName: me.name,
                avatarUrl: me.picture,
                email: me.email,
                title: me.extended_profile?.job_title
            };
        });
        return this.promise;
    }
    constructor(){
        this.promise = void 0;
    }
}
const $0c5ce416cf97cf51$export$30a852ca4cb27370 = new $0c5ce416cf97cf51$export$dc10e400a1189789();
module.exports["userInfoProvider"] = $0c5ce416cf97cf51$export$30a852ca4cb27370;

});

parcelRegister("jYxBx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $g58eM = parcelRequire("g58eM");

const $e8adb0147cc02fce$export$ca1b33377afa620 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    getArtifact: null
});
function $e8adb0147cc02fce$export$56da85ac9d40dbcd({ children: children, product: product, config: config, fallbackArtifacts: fallbackArtifacts }) {
    const flightDeckClient = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        return new (0, $g58eM.default)(product, {
            handlers: {
                captureException: config === null || config === void 0 ? void 0 : config.captureException
            },
            expiryMS: config === null || config === void 0 ? void 0 : config.artifactExpiryMS
        }, fallbackArtifacts);
    }, [
        product,
        config === null || config === void 0 ? void 0 : config.captureException,
        fallbackArtifacts
    ]);
    const getArtifact = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(async (name, dimensions)=>{
        return flightDeckClient.fetchConfigFromFlightDeck({
            name: name,
            dimensions: dimensions
        });
    }, [
        flightDeckClient
    ]);
    const providerValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            getArtifact: getArtifact
        }), [
        getArtifact
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e8adb0147cc02fce$export$ca1b33377afa620.Provider, {
        value: providerValue
    }, children);
}
const $e8adb0147cc02fce$export$73c96350a5e69ec = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($e8adb0147cc02fce$export$ca1b33377afa620);
function $e8adb0147cc02fce$export$3b241cde208d2c5e(key, dimensions) {
    const [artifact, setArtifact] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    const { getArtifact: getArtifact } = $e8adb0147cc02fce$export$73c96350a5e69ec();
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (!getArtifact) throw new Error("Flight Deck Context not provided");
        getArtifact(key, dimensions).then((resp)=>setArtifact(resp))// we don't need to do anything with the error as it is already instrumented in the flightDeckClient
        .catch();
    }, [
        dimensions,
        key,
        getArtifact,
        setArtifact
    ]);
    return artifact;
}
module.exports["FlightDeckProvider"] = $e8adb0147cc02fce$export$56da85ac9d40dbcd;
module.exports["useFlightDeckContext"] = $e8adb0147cc02fce$export$73c96350a5e69ec;
module.exports["useFlightDeckArtifact"] = $e8adb0147cc02fce$export$3b241cde208d2c5e;

});

parcelRegister("e31DP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jYxBx = parcelRequire("jYxBx");


var $h4NLj = parcelRequire("h4NLj");


var $6hu6G = parcelRequire("6hu6G");

const $5e20bb9e4d5269b7$export$6620595b7f837f8f = (version, product, logger, baseUrl)=>{
    const { getArtifact: getArtifact } = (0, $jYxBx.useFlightDeckContext)();
    return (0, $42omo.useMemo)(()=>(0, $6hu6G.createActivityClient)(version, product, logger, baseUrl, // If the rw-client is wrapped in a FD provider, use the provided fetch function
        getArtifact ? ()=>getArtifact((0, $h4NLj.FD_CLIENT_FETCH_PROPS).name, (0, $h4NLj.FD_CLIENT_FETCH_PROPS).dimensions) : undefined), [
        version,
        product,
        logger,
        baseUrl,
        getArtifact
    ]);
};
module.exports["useActivityClient"] = $5e20bb9e4d5269b7$export$6620595b7f837f8f;

});

parcelRegister("9D6Kx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::240d2a2d2ecd17e4d685f807cd1b54f8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $702cfde9ca1d470b$var$_react = $702cfde9ca1d470b$var$_interopRequireDefault((parcelRequire("42omo")));

var $702cfde9ca1d470b$var$_baseNew = $702cfde9ca1d470b$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $702cfde9ca1d470b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookWithBookmark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: knowledge bases, articles, and other representations of books or info.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $702cfde9ca1d470b$var$BookWithBookmarkIcon = (props)=>/*#__PURE__*/ $702cfde9ca1d470b$var$_react.default.createElement($702cfde9ca1d470b$var$_baseNew.default, Object.assign({
        name: "BookWithBookmarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.875A2.875 2.875 0 0 1 4.875 0h8.375a.75.75 0 0 1 .75.75V9.5a.75.75 0 0 1-.75.75V13H14v1.5h-3.5V13h1.25v-2.75H4.875a1.375 1.375 0 1 0 0 2.75H5.5v1.5h-.625A2.875 2.875 0 0 1 2 11.625zM3.5 9.1a2.86 2.86 0 0 1 1.375-.35H12.5V1.5H4.875c-.76 0-1.375.616-1.375 1.375z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.5 15.564V11.5h3v4.064a.25.25 0 0 1-.441.16L8 14.465l-1.059 1.26a.25.25 0 0 1-.441-.16"/>`
    }, props));
$702cfde9ca1d470b$var$BookWithBookmarkIcon.displayName = 'BookWithBookmarkIcon';
var $702cfde9ca1d470b$var$_default = module.exports.default = $702cfde9ca1d470b$var$BookWithBookmarkIcon;

});

parcelRegister("cI0rA", function(module, exports) {
$parcel$export(module.exports, "default", () => $9409f042c788dd08$export$2e2bcd8739ae039);

var $4Ldep = parcelRequire("4Ldep");


var $b5utg = parcelRequire("b5utg");

function $9409f042c788dd08$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    return (0, $4Ldep.default)(dirtyDate, Date.now());
}

});

parcelRegister("eToX6", function(module, exports) {
/**
 * Utility functions for detecting and working with preview panels
 */ // Types for preview panel detection
// Preview panel indicators
const $cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS = {
    EMBEDDED_SOURCE: 'embeddedConfluenceSource',
    PREVIEW_PANELS: 'previewPanels',
    CONFLUENCE_PAGE_PREVIEW: 'confluence-page-preview-panel'
};
/**
 * Gets URL search parameters safely
 */ const $cf00e918e2c1556d$var$getUrlSearchParams = (url)=>{
    try {
        return new URLSearchParams(url);
    } catch  {
        return null;
    }
};
const $cf00e918e2c1556d$export$5c3b154013d00c5f = (searchParams)=>{
    return searchParams.has($cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.PREVIEW_PANELS) || searchParams.get($cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.EMBEDDED_SOURCE) === $cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.CONFLUENCE_PAGE_PREVIEW;
};
const $cf00e918e2c1556d$export$cd88bef28d20da33 = ()=>{
    try {
        const currentSearch = window.location.search;
        if (currentSearch) {
            const currentParams = $cf00e918e2c1556d$var$getUrlSearchParams(currentSearch);
            if (currentParams && $cf00e918e2c1556d$export$5c3b154013d00c5f(currentParams)) return true;
        }
        return false;
    } catch  {
        return false;
    }
};
const $cf00e918e2c1556d$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
module.exports["hasPreviewPanelIndicators"] = $cf00e918e2c1556d$export$5c3b154013d00c5f;
module.exports["isInPreviewPanel"] = $cf00e918e2c1556d$export$cd88bef28d20da33;
module.exports["isInIframe"] = $cf00e918e2c1556d$export$9f140ed41af5108c;

});

parcelRegister("1cfhF", function(module, exports) {
const $bd349f0afc0f2270$export$31048cb2a0753b12 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $bd349f0afc0f2270$export$9d8f18312db80469 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $bd349f0afc0f2270$export$6c053e1694ef181c = {
    prod: $bd349f0afc0f2270$export$31048cb2a0753b12,
    staging: $bd349f0afc0f2270$export$9d8f18312db80469
};
const $bd349f0afc0f2270$export$54e3fc09a2a3347a = {
    products: {
        'confluence.ondemand': '6aab3f4e-cc71-474d-8d28-abef8b057808',
        'jira-software.ondemand': 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
        'jira-servicedesk.ondemand': 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
        'jira-core.ondemand': '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
        opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
        statuspage: '0b8ea1e2-52df-11ea-8d77-2e728ce88125',
        townsquare: '7c917705-866d-4b6b-b266-0fc7633e8342',
        compass: '6bce2ccb-4f57-46f5-812a-9dbf02dc28f2',
        'jira-product-discovery': 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
        beacon: '0a0a31b0-3f5f-4693-b231-9a753bee012e',
        'atlassian-analytics-free': 'f44da23e-5907-4d81-8a78-33bedee10969',
        mercury: 'd16a2ba8-445f-4e83-9c7b-9bcf349ff905',
        'teamwork-collection': '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
        loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
    }
};
module.exports["FIRST_PARTY_CCP_PRODUCT_IDS"] = $bd349f0afc0f2270$export$6c053e1694ef181c;
module.exports["SURFACE_ANALYTICS_PRODUCT_MAP"] = $bd349f0afc0f2270$export$54e3fc09a2a3347a;

});

parcelRegister("lfQiY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $1cfhF = parcelRequire("1cfhF");


var $kfKKN = parcelRequire("kfKKN");

function $d96a3db7fec61911$export$c2095165ae2bdcda() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const firedViewedScreenEventName = (0, $42omo.useRef)();
    const firedViewedUIEventId = (0, $42omo.useRef)();
    const mapToCcpProductKeys = (0, $42omo.useCallback)((recommendedProductIds, targetProductId)=>{
        const ccpProductIds = recommendedProductIds.reduce((acc, curr)=>{
            acc.push((0, $1cfhF.SURFACE_ANALYTICS_PRODUCT_MAP).products[curr] ?? curr);
            return acc;
        }, []);
        const ccpTargetProductId = targetProductId && (0, $1cfhF.SURFACE_ANALYTICS_PRODUCT_MAP).products[targetProductId];
        return {
            recommendedProductIds: ccpProductIds,
            targetProductId: ccpTargetProductId ?? targetProductId
        };
    }, []);
    const fireViewedScreenEvent = (0, $42omo.useCallback)((name, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedScreenEventName.current === name) return;
        const { recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).SCREEN,
            name: name,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
        // Record the screen name so we don't fire it again
        firedViewedScreenEventName.current = name;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireViewedUIEvent = (0, $42omo.useCallback)((event, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedUIEventId.current === event.actionSubjectId) return;
        const { source: source, recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
        firedViewedUIEventId.current = event.actionSubjectId;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireInteractedUIEvent = (0, $42omo.useCallback)((event, commonAttributes, attributes)=>{
        const { source: source, recommendedProductIds: recommendedProductIds, targetProductId: targetProductId, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds, targetProductId: ccpTargetProductId } = mapToCcpProductKeys(recommendedProductIds ?? [], targetProductId);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                targetProductId: ccpTargetProductId,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    return {
        fireViewedScreenEvent: fireViewedScreenEvent,
        fireViewedUIEvent: fireViewedUIEvent,
        fireInteractedUIEvent: fireInteractedUIEvent
    };
}
module.exports["useFireCrossFlowAnalyticsEvents"] = $d96a3db7fec61911$export$c2095165ae2bdcda;

});

parcelRegister("kfKKN", function(module, exports) {
const $f3fd7ff29ab4c819$export$c536a7e29a0739b8 = 'crossFlow';
var $f3fd7ff29ab4c819$export$285f3d0989f9023f = /*#__PURE__*/ function(eventTypes) {
    eventTypes["UI"] = "ui";
    eventTypes["SCREEN"] = "screen";
    return eventTypes;
}({});
module.exports["CROSS_FLOW_CHANNEL"] = $f3fd7ff29ab4c819$export$c536a7e29a0739b8;
module.exports["eventTypes"] = $f3fd7ff29ab4c819$export$285f3d0989f9023f;

});

parcelRegister("bavCP", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $jMyy4 = parcelRequire("jMyy4");

const $86f32d96feea2a1f$export$67f105fad14d18d = (0, $3u0dr.isReactCompilerActiveV2)() ? function QueryInterop(t0) {
    const $ = (0, $frIzR.c)(7);
    let children;
    let props;
    let query;
    if ($[0] !== t0) {
        ({ children: children, query: query, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
        $[3] = query;
    } else {
        children = $[1];
        props = $[2];
        query = $[3];
    }
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    let t1;
    if ($[4] !== children || $[5] !== result) {
        t1 = children(result);
        $[4] = children;
        $[5] = result;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : function QueryInterop({ children: children, query: query, ...props }) {
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    return children(result);
};
module.exports["QueryInterop"] = $86f32d96feea2a1f$export$67f105fad14d18d;

});

parcelRegister("le4yZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $dh538 = parcelRequire("dh538");


var $6yuru = parcelRequire("6yuru");


var $9EFEY = parcelRequire("9EFEY");


var $f7lNm = parcelRequire("f7lNm");


var $9pwVP = parcelRequire("9pwVP");


var $bbPOv = parcelRequire("bbPOv");

var $850e39d8df191904$export$5fc610914b028d97 = /*#__PURE__*/ function(KnowledgeDiscoveryKeyPhraseInputTextFormat) {
    KnowledgeDiscoveryKeyPhraseInputTextFormat["PLAIN"] = "PLAIN";
    KnowledgeDiscoveryKeyPhraseInputTextFormat["ADF"] = "ADF";
    return KnowledgeDiscoveryKeyPhraseInputTextFormat;
}({});
var $850e39d8df191904$export$17a511c5c23509af = /*#__PURE__*/ function(KeyPhraseCategory) {
    KeyPhraseCategory["PROJECT"] = "PROJECT";
    KeyPhraseCategory["TEAM"] = "TEAM";
    KeyPhraseCategory["ACRONYM"] = "ACRONYM";
    KeyPhraseCategory["AUTO"] = "AUTO";
    KeyPhraseCategory["OTHER"] = "OTHER";
    return KeyPhraseCategory;
}({});
const $850e39d8df191904$export$276f56b9dab90860 = 'atlassian.knowledge-discovery.autohighlights';
const $850e39d8df191904$var$escapeRegExp = (regex)=>{
    return regex.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
};
const $850e39d8df191904$export$4a1c1074ca627 = (keyPhrases)=>{
    try {
        if (!keyPhrases.length) return new RegExp('(?!)');
        else return new RegExp(keyPhrases.map((node)=>`\\b${$850e39d8df191904$var$escapeRegExp(node.keyPhrase)}\\b`).join('|'), 'gi');
    } catch  {
        return new RegExp('(?!)');
    }
};
const $850e39d8df191904$var$getKeyphraseCategory = (keyPhrases)=>{
    return keyPhrases.length ? keyPhrases[0].category : "AUTO";
};
const $850e39d8df191904$var$initialState = {
    keyPhrases: [],
    keyPhraseCategory: "AUTO",
    autoHighlightRegex: new RegExp('(?!)'),
    loadAutohighlights: ()=>Promise.resolve([]),
    resetAutohighlights: ()=>{},
    autohighlightsLoading: false,
    error: undefined
};
const $850e39d8df191904$export$52e9ff9bfbb65046 = ({ entityAri: entityAri, workspaceId: workspaceId, product: product, productConfig: productConfig, fieldType: fieldType, cloudId: cloudId })=>{
    const [state, setState] = (0, $42omo.useState)($850e39d8df191904$var$initialState);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire((0, $f7lNm.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    const { jiraReporterAccountId: jiraReporterAccountId, jiraAssigneeAccountId: jiraAssigneeAccountId } = productConfig || {};
    const loadAutohighlights = (0, $42omo.useCallback)(async ({ inputText: inputText })=>{
        try {
            setState({
                ...$850e39d8df191904$var$initialState,
                autohighlightsLoading: true
            });
            const keyPhrasesResult = await (0, $9EFEY.fetchAggResponse)({
                graphQuery: (0, $bbPOv.KeyPhrasesQuery),
                variables: {
                    workspaceId: workspaceId,
                    entityAri: entityAri,
                    ...!!jiraReporterAccountId && {
                        jiraReporterAccountId: jiraReporterAccountId
                    },
                    ...!!jiraAssigneeAccountId && {
                        jiraAssigneeAccountId: jiraAssigneeAccountId
                    },
                    ...!!inputText && {
                        inputText: inputText
                    }
                },
                operationName: (0, $bbPOv.KEY_PHRASES_OPERATION_NAME),
                headers: (0, $6yuru.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: cloudId,
                    product: product
                })
            });
            const keyPhrases = keyPhrasesResult?.data?.knowledgeDiscovery?.keyPhrases?.nodes ? keyPhrasesResult.data.knowledgeDiscovery.keyPhrases.nodes : [];
            if (keyPhrases.length > 0 && (0, $dh538.fg)('kd_definitions_click_and_show_event_product_parity')) fireAnalyticsEvent((0, $9pwVP.onShownAutoDefinitionHighlights)({
                product: product,
                contentId: entityAri,
                keyPhrases: keyPhrases,
                fieldType: fieldType
            }));
            const autoHighlightRegex = $850e39d8df191904$export$4a1c1074ca627(keyPhrases);
            setState({
                ...$850e39d8df191904$var$initialState,
                keyPhraseCategory: $850e39d8df191904$var$getKeyphraseCategory(keyPhrases),
                autoHighlightRegex: autoHighlightRegex,
                keyPhrases: keyPhrases
            });
            return keyPhrases;
        } catch (error) {
            setState({
                ...$850e39d8df191904$var$initialState,
                error: error.message
            });
            return [];
        }
    }, [
        entityAri,
        workspaceId,
        fireAnalyticsEvent,
        product,
        jiraReporterAccountId,
        jiraAssigneeAccountId,
        fieldType,
        cloudId
    ]);
    const resetAutohighlights = (0, $42omo.useCallback)(()=>{
        setState($850e39d8df191904$var$initialState);
    }, []);
    const autoHighlightRegex = (0, $42omo.useMemo)(()=>state.autoHighlightRegex, [
        state.autoHighlightRegex
    ]);
    const autohighlightsLoading = (0, $42omo.useMemo)(()=>state.autohighlightsLoading, [
        state.autohighlightsLoading
    ]);
    const keyPhrases = (0, $42omo.useMemo)(()=>state.keyPhrases, [
        state.keyPhrases
    ]);
    const error = (0, $42omo.useMemo)(()=>state.error, [
        state.error
    ]);
    return {
        keyPhrases: keyPhrases,
        keyPhraseCategory: state.keyPhraseCategory,
        autoHighlightRegex: autoHighlightRegex,
        loadAutohighlights: loadAutohighlights,
        resetAutohighlights: resetAutohighlights,
        autohighlightsLoading: autohighlightsLoading,
        error: error
    };
};
module.exports["KnowledgeDiscoveryKeyPhraseInputTextFormat"] = $850e39d8df191904$export$5fc610914b028d97;
module.exports["KeyPhraseCategory"] = $850e39d8df191904$export$17a511c5c23509af;
module.exports["getHighlightRegex"] = $850e39d8df191904$export$4a1c1074ca627;
module.exports["useAutohighlightSupplier"] = $850e39d8df191904$export$52e9ff9bfbb65046;

});

parcelRegister("9pwVP", function(module, exports) {

var $cqFuK = parcelRequire("cqFuK");


var $le4yZ = parcelRequire("le4yZ");


var $fjzE4 = parcelRequire("fjzE4");

const $135aee7ed4d7fef7$export$ae4ae603f16dcf42 = ({ commonAttributes: commonAttributes, newDefinition: newDefinition, restrictedScope: restrictedScope, sourceSelected: sourceSelected, aiDefinitionEdited: aiDefinitionEdited })=>{
    const { query: keyPhrase, answerString: oldDefinition, extraAttributes: extraAttributes, source: source } = commonAttributes;
    const { contentId: contentId, readingAidsSessionId: readingAidsSessionId } = extraAttributes || {};
    return {
        action: 'clicked',
        actionSubject: 'aiCuratedDefinitionUpdateButton',
        source: source,
        eventType: 'ui',
        attributes: {
            contentId: contentId,
            readingAidsSessionId: readingAidsSessionId,
            restrictedScope: restrictedScope,
            sourceSelected: sourceSelected,
            newDefinitionLength: newDefinition.length,
            aiDefinitionEdited: // whether the user is editing an AI answer or already edited definition
            aiDefinitionEdited
        },
        nonPrivacySafeAttributes: {
            keyPhrase: keyPhrase,
            oldDefinition: oldDefinition,
            newDefinition: newDefinition
        }
    };
};
const $135aee7ed4d7fef7$export$d80f83cdfda72179 = (props)=>{
    const { query: query, answerString: answerString, extraAttributes: extraAttributes, source: source } = props;
    const { contentId: contentId, readingAidsSessionId: readingAidsSessionId } = extraAttributes || {};
    return {
        action: 'clicked',
        actionSubject: 'aiCuratedDefinitionSeeEditHistoryButton',
        source: source,
        eventType: 'ui',
        attributes: {
            contentId: contentId,
            readingAidsSessionId: readingAidsSessionId
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $135aee7ed4d7fef7$export$5b155f527aff26b9 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerLikeButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $135aee7ed4d7fef7$export$c4c8b81ee90e6af2 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerDislikeButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $135aee7ed4d7fef7$export$42897f8f02baa658 = ({ product: product, contentId: contentId, keyPhrases: keyPhrases, fieldType: fieldType })=>({
        action: 'shown',
        actionSubject: 'aiDefinitionsAutohighlights',
        source: 'viewPageScreen',
        eventType: 'track',
        attributes: {
            product: product,
            contentId: contentId,
            numHighlights: keyPhrases.length,
            categories: (0, $fjzE4.getHighlightCategories)(keyPhrases),
            beAcronymsEnabled: true,
            fieldType: fieldType
        }
    });
const $135aee7ed4d7fef7$export$9e6261f08debf93b = ({ contentId: contentId, sessionId: sessionId, keyPhraseCategory: keyPhraseCategory, fieldType: fieldType })=>({
        action: 'clicked',
        actionSubject: 'aiDefinitionsAutohighlights',
        source: 'viewPageScreen',
        eventType: 'ui',
        attributes: {
            contentId: contentId,
            readingAidsSessionId: sessionId,
            keyPhraseCategory: keyPhraseCategory || (0, $le4yZ.KeyPhraseCategory).AUTO,
            fieldType: fieldType
        }
    });
const $135aee7ed4d7fef7$export$bfe6deae035e3ea7 = (props)=>({
        action: 'clicked',
        actionSubject: 'aiDefinitionsDisableDefinition',
        source: 'viewPageScreen',
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        }
    });
module.exports["onCuratedDefinitionUpdateButtonClicked"] = $135aee7ed4d7fef7$export$ae4ae603f16dcf42;
module.exports["onCuratedDefinitionSeeEditHistoryButtonClicked"] = $135aee7ed4d7fef7$export$d80f83cdfda72179;
module.exports["onLikeButtonClick"] = $135aee7ed4d7fef7$export$5b155f527aff26b9;
module.exports["onDislikeButtonClick"] = $135aee7ed4d7fef7$export$c4c8b81ee90e6af2;
module.exports["onShownAutoDefinitionHighlights"] = $135aee7ed4d7fef7$export$42897f8f02baa658;
module.exports["onClickAutoDefinitionHighlights"] = $135aee7ed4d7fef7$export$9e6261f08debf93b;
module.exports["onClickDisableDefinition"] = $135aee7ed4d7fef7$export$bfe6deae035e3ea7;

});

parcelRegister("fjzE4", function(module, exports) {

var $7azCD = parcelRequire("7azCD");

const $f09d80c8646d0453$export$e9131c78c1110376 = (str)=>(0, $7azCD.sha256)(str);
const $f09d80c8646d0453$export$72ebbc2f4d73897b = (sources)=>sources.map((source)=>({
            id: source.ari ?? source.id,
            type: source.type
        }));
const $f09d80c8646d0453$export$f600f3124ea5916b = (nodes)=>{
    const categories = new Map();
    try {
        nodes.forEach((node)=>{
            const curCategoryCount = categories.get(node.category);
            if (!!curCategoryCount) categories.set(node.category, curCategoryCount + 1);
            else categories.set(node.category, 1);
        });
    } catch  {
        return undefined;
    }
    return Object.fromEntries(categories);
};
module.exports["getHighlightCategories"] = $f09d80c8646d0453$export$f600f3124ea5916b;

});

parcelRegister("bbPOv", function(module, exports) {
const $b754f76c2ea6a90a$export$b260340f6ff10d53 = 'PlatformHighlightKeywordsQuery';
const $b754f76c2ea6a90a$export$39b2bc657daf065 = `
	query ${$b754f76c2ea6a90a$export$b260340f6ff10d53}(
		$entityAri: String!
		$workspaceId: String!
		$jiraReporterAccountId: String
		$jiraAssigneeAccountId: String
		$inputText: KnowledgeDiscoveryKeyPhraseInputText
	) {
		knowledgeDiscovery  {
			keyPhrases(entityAri: $entityAri, workspaceId: $workspaceId, jiraReporterAccountId: $jiraReporterAccountId, jiraAssigneeAccountId: $jiraAssigneeAccountId, inputText: $inputText) 
				@optIn(to: "KnowledgeDiscovery Get Key Phrases") {
				__typename
				... on KnowledgeDiscoveryKeyPhraseConnection {
					nodes {
						... on KnowledgeDiscoveryKeyPhrase {
							keyPhrase
							category
						}
					}
				}
				... on QueryError {
					message
				}
			}
		}
	}
`;
module.exports["KEY_PHRASES_OPERATION_NAME"] = $b754f76c2ea6a90a$export$b260340f6ff10d53;
module.exports["KeyPhrasesQuery"] = $b754f76c2ea6a90a$export$39b2bc657daf065;

});

parcelRegister("7DCm4", function(module, exports) {

var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");

const $399439794f928dc1$var$DEFINITIONS_COMPONENT = 'search-ai-definitions';
const $399439794f928dc1$export$5b2a28beea8d66c3 = new (0, $5aVN7.UFOExperience)(`${$399439794f928dc1$var$DEFINITIONS_COMPONENT}-load`, {
    type: (0, $9NDUe.ExperienceTypes).Experience,
    performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: $399439794f928dc1$var$DEFINITIONS_COMPONENT
    }
});
module.exports["aiDefinitionsLoadUFOExperience"] = $399439794f928dc1$export$5b2a28beea8d66c3;

});

parcelRegister("7DA0P", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $2LczZ = parcelRequire("2LczZ");

const $6a1b9fb9a12a7345$export$2aadebb53f6015f6 = ({ children: children, style: style, shouldFillContainer: shouldFillContainer, isExpanded: isExpanded })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2LczZ.SearchDialogWrapper), {
        shouldFillContainer: shouldFillContainer,
        isExpanded: isExpanded,
        "data-test-id": "search-dialog-dialog-wrapper",
        tabIndex: -1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: children
    });
module.exports["SearchDialog"] = $6a1b9fb9a12a7345$export$2aadebb53f6015f6;

});

parcelRegister("2LczZ", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $6fnsQ = parcelRequire("6fnsQ");


var $2azjJ = parcelRequire("2azjJ");


var $cStGJ = parcelRequire("cStGJ");

function $8c3561b25371e474$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8c3561b25371e474$var$SIDEBAR_PANE_WIDTH = 272;
const $8c3561b25371e474$var$resultContainerVerticalPadding = 8;
const $8c3561b25371e474$export$dcefba65c42da69c = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "ee3sr7s8"
})("position:relative;", (props)=>props.shouldFillContainer ? `width: 100%;` : `width: ${0, $2azjJ.dialogWidth};`, " ", (props)=>props.isExpanded && props.shouldFillContainer ? `min-width: ${0, $2azjJ.dialogWidth};` : '', " box-shadow:", `var(--ds-shadow-overlay, ${'0 ' + (0, $2azjJ.grid).multiple(0.5).px + ' ' + (0, $2azjJ.grid).px + ' ' + (0, $6fnsQ.N50A) + ', 0 0 1px ' + (0, $6fnsQ.N60A)})`, ";border-radius:3px;background-color:var(--ds-surface-overlay, #fff);overflow:hidden;margin-top:", (0, $2azjJ.grid).px, ";:focus{outline:none;}display:flex;flex-direction:column;height:100%;@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){min-width:100%;max-width:100%;border-radius:0;margin-top:0;flex:1;overflow:auto;}");
const $8c3561b25371e474$export$d6e44c2a92a613c2 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "ee3sr7s7"
})({
    name: "s8tasg",
    styles: "flex:1;display:flex;flex-direction:column;overflow:hidden;max-width:100%;box-sizing:border-box"
});
const $8c3561b25371e474$export$ab35601bed9ca017 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "ee3sr7s6"
})({
    name: "n94oxe",
    styles: "overflow-x:hidden;overflow-y:auto;flex:1;max-width:100%;box-sizing:border-box"
});
const $8c3561b25371e474$export$34a31057caff1acb = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "ee3sr7s5"
})({
    flex: '1 1 auto',
    overflowX: 'hidden',
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"} 0 ${"var(--ds-space-200, 16px)"}`
});
const $8c3561b25371e474$export$6b8430dd9f61a5c7 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "ee3sr7s4"
})("flex:0 1 auto;width:", $8c3561b25371e474$var$SIDEBAR_PANE_WIDTH, "px;display:flex;flex-direction:column;max-height:100%;padding-bottom:var(--ds-space-200, 16px);@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){display:none;}");
const $8c3561b25371e474$export$33eeaf745b96a17f = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "ee3sr7s3"
})({
    margin: `${"var(--ds-space-200, 16px)"} 0`,
    borderLeft: `${"var(--ds-border-width, 1px)"} solid ${`var(--ds-border, ${(0, $6fnsQ.N30)})`}`
});
const $8c3561b25371e474$export$dc065bf90da5c17d = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "ee3sr7s2"
})({
    padding: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-200, 16px)"} 0 ${"var(--ds-space-200, 16px)"}`,
    flex: '0 0 auto'
});
const $8c3561b25371e474$export$f39f3f768bc98e3d = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($8c3561b25371e474$export$33eeaf745b96a17f, {}),
            /*#__PURE__*/ (0, $l998X.jsx)($8c3561b25371e474$export$6b8430dd9f61a5c7, {
                children: /*#__PURE__*/ (0, $l998X.jsx)($8c3561b25371e474$export$34a31057caff1acb, {
                    children: children
                })
            })
        ]
    });
const $8c3561b25371e474$var$totalDialogHeightPx = 776 + $8c3561b25371e474$var$resultContainerVerticalPadding * 2;
const $8c3561b25371e474$var$footerHeight = 48;
const $8c3561b25371e474$var$belowDialogSpace = 224;
const $8c3561b25371e474$var$aiFullDialogPromptHeight = 64;
const $8c3561b25371e474$export$c9e0e8491f083dd5 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "ee3sr7s1"
})("display:flex;max-height:", (props)=>`calc(100vh - ${$8c3561b25371e474$var$belowDialogSpace - $8c3561b25371e474$var$footerHeight + (props.showAtlassianHomeSearchLink ? $8c3561b25371e474$var$footerHeight : 0) + (props.aiSearchFullDialogEnabled ? $8c3561b25371e474$var$aiFullDialogPromptHeight : 0)}px)`, ";box-sizing:border-box;flex:1;min-height:", (props)=>props.minHeight ? `${props.minHeight}px` : 'auto', ";@media screen and (min-height: ", $8c3561b25371e474$var$totalDialogHeightPx + $8c3561b25371e474$var$belowDialogSpace, "px){max-height:", (props)=>`${$8c3561b25371e474$var$totalDialogHeightPx - $8c3561b25371e474$var$footerHeight - (props.aiSearchFullDialogEnabled ? $8c3561b25371e474$var$aiFullDialogPromptHeight : 0)}px;`, ";}@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){max-height:initial;overflow:auto;}");
const $8c3561b25371e474$export$8644783c0dd52b5e = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "ee3sr7s0"
})("position:relative;display:flex;flex-direction:column;justify-content:space-between;min-height:", (props)=>props.shouldFixMinimumHeight ? `${props.minimumHeight}px` : 'auto', ";@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){flex-grow:1;}");
module.exports["SearchDialogWrapper"] = $8c3561b25371e474$export$dcefba65c42da69c;
module.exports["ResultContainerOuter"] = $8c3561b25371e474$export$d6e44c2a92a613c2;
module.exports["ResultContainer"] = $8c3561b25371e474$export$ab35601bed9ca017;
module.exports["SidebarScrollContainer"] = $8c3561b25371e474$export$34a31057caff1acb;
module.exports["SidebarContainerPane"] = $8c3561b25371e474$export$6b8430dd9f61a5c7;
module.exports["SidebarContainerBorder"] = $8c3561b25371e474$export$33eeaf745b96a17f;
module.exports["SidebarBottomFixedContainer"] = $8c3561b25371e474$export$dc065bf90da5c17d;
module.exports["SearchDialogContent"] = $8c3561b25371e474$export$c9e0e8491f083dd5;
module.exports["ResultRenderWrapper"] = $8c3561b25371e474$export$8644783c0dd52b5e;

});

parcelRegister("2azjJ", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dTk3A = parcelRequire("dTk3A");


var $6fnsQ = parcelRequire("6fnsQ");

function $5648f131343e99e5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5648f131343e99e5$var$AkGrid = (num = 1)=>({
        px: `${num * 8}px`,
        unitless: num * 8,
        multiple: (multiplier)=>$5648f131343e99e5$var$AkGrid(multiplier * num),
        half: ()=>$5648f131343e99e5$var$AkGrid(0.5 * num),
        twice: ()=>$5648f131343e99e5$var$AkGrid(2 * num)
    });
const $5648f131343e99e5$export$56446adcecbeec34 = {
    searchDialog: (0, $dTk3A.layers).dialog()
};
const $5648f131343e99e5$export$85fc379452d91af0 = $5648f131343e99e5$var$AkGrid(1);
const $5648f131343e99e5$export$b9930dabfa4a3a3 = '56px';
const $5648f131343e99e5$export$f6af7620e8789c39 = '200px';
const $5648f131343e99e5$export$64d8573e83b64ff8 = '150px';
const $5648f131343e99e5$export$a3da89b899389ed8 = '780px';
const $5648f131343e99e5$export$ce4512df260a325a = 780;
const $5648f131343e99e5$export$a406031ed42c8e02 = '1130px';
const $5648f131343e99e5$export$e00021bea368c518 = $5648f131343e99e5$export$85fc379452d91af0.multiple(4);
const $5648f131343e99e5$export$30310ee354b45eb0 = $5648f131343e99e5$export$85fc379452d91af0.multiple(6);
const $5648f131343e99e5$export$eeb0307e2964e28d = `var(--ds-text, ${(0, $6fnsQ.N900)})`;
const $5648f131343e99e5$export$7168c0a11fb9ab29 = `var(--ds-text-subtlest, ${(0, $6fnsQ.N300)})`;
const $5648f131343e99e5$export$4ac85ff259fe4fce = `var(--ds-background-neutral-subtle-hovered, ${(0, $6fnsQ.N20)})`;
const $5648f131343e99e5$export$271fb8b1437b1d62 = `var(--ds-link-visited, ${(0, $6fnsQ.P300)})`;
const $5648f131343e99e5$export$b6b16ffe83ef4b56 = {
    name: "sqm42b",
    styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden"
};
module.exports["zIndex"] = $5648f131343e99e5$export$56446adcecbeec34;
module.exports["grid"] = $5648f131343e99e5$export$85fc379452d91af0;
module.exports["atlassianNavigationHeight"] = $5648f131343e99e5$export$b9930dabfa4a3a3;
module.exports["collapsedSearchInputWidth"] = $5648f131343e99e5$export$f6af7620e8789c39;
module.exports["dialogWidth"] = $5648f131343e99e5$export$a3da89b899389ed8;
module.exports["dialogPageTakeoverWidth"] = $5648f131343e99e5$export$ce4512df260a325a;
module.exports["dialogPageCentreWidth"] = $5648f131343e99e5$export$a406031ed42c8e02;
module.exports["inputFieldHeight"] = $5648f131343e99e5$export$e00021bea368c518;
module.exports["enlargedInputFieldHeight"] = $5648f131343e99e5$export$30310ee354b45eb0;
module.exports["primaryTextColour"] = $5648f131343e99e5$export$eeb0307e2964e28d;
module.exports["itemLinkSecondaryColor"] = $5648f131343e99e5$export$7168c0a11fb9ab29;
module.exports["itemHighlightColor"] = $5648f131343e99e5$export$4ac85ff259fe4fce;
module.exports["visitedLinkColor"] = $5648f131343e99e5$export$271fb8b1437b1d62;
module.exports["nowrapEllipsis"] = $5648f131343e99e5$export$b6b16ffe83ef4b56;

});

parcelRegister("bg4YX", function(module, exports) {
/* eslint-disable @repo/internal/react/no-class-components */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

class $e585c5dc5dea28e7$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        this.props.onException(error);
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
    }
    componentWillUnmount() {
        if (this.props.setErrorBoundaryResetCb) this.props.setErrorBoundaryResetCb(undefined);
    }
    render() {
        const { renderWithErrorInfo: RenderWithErrorInfo } = this.props;
        if (RenderWithErrorInfo && this.state.error && this.state.errorInfo) return /*#__PURE__*/ (0, $l998X.jsx)(RenderWithErrorInfo, {
            error: this.state.error,
            errorInfo: this.state.errorInfo
        });
        if (this.state.error) return this.props.fallback !== undefined ? this.props.fallback : null;
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.resetErrorBoundary = ()=>{
            this.setState({
                error: undefined,
                errorInfo: undefined
            });
        };
        this.state = {
            error: undefined,
            errorInfo: undefined
        };
        if (this.props.setErrorBoundaryResetCb) this.props.setErrorBoundaryResetCb(this.resetErrorBoundary);
    }
}
module.exports["ErrorBoundary"] = $e585c5dc5dea28e7$export$e926676385687eaf;

});

parcelRegister("7lL49", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $827bbb02634e926d$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    /**
   * Messages for the AI Answer Component
   */ ai_answer_component_initial_title_text: {
        id: "search_ai.ai_answer_component.initial_title_text",
        defaultMessage: "Ask questions in search and get answers based on the content you have access to"
    },
    ai_answer_component_beta_status_label: {
        id: "search_ai.ai_answer_component.beta_status_label",
        defaultMessage: "Beta"
    },
    ai_answer_component_title_text: {
        id: "search_ai.ai_answer_component.title_text",
        defaultMessage: "Atlassian Intelligence"
    },
    ai_answer_component_title_text_loading: {
        id: "search_ai.ai_answer_component.title_text_loading",
        defaultMessage: "is working..."
    },
    ai_answer_component_title_text_loading_reading_aids: {
        id: "search_ai.ai_answer_component.title_text_loading_reading_aids",
        defaultMessage: "Generating"
    },
    ai_answer_component_title_text_loaded: {
        id: "search_ai.ai_answer_component.title_text_loaded",
        defaultMessage: "Answered by"
    },
    ai_answer_component_button_text: {
        id: "ai_answer_component_button_text",
        defaultMessage: "Ask AI"
    },
    ai_answer_component_result_error_text: {
        id: "search_ai.ai_answer_component.result_error_text",
        defaultMessage: "{brandName} couldn't generate an answer for you. Try rephrasing or explore using filters in {advancedSearchLink}."
    },
    ai_answer_component_result_error_advanced_search_link: {
        id: "search_ai.ai_answer_component.result_error_advanced_search_link",
        defaultMessage: "advanced search"
    },
    ai_answer_component_source_label: {
        id: "search_ai.ai_answer_component.source_label",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: "{numSources, plural, =1 {Source} other {Sources}}"
    },
    ai_answer_component_reference_label: {
        id: "search_ai.ai_answer_component.reference_label",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: "{numSources, plural, =1 {Source} other {Sources}}"
    },
    ai_answer_component_source_page_icon_label: {
        id: "search_ai.ai_answer_component.source_page_icon_label",
        defaultMessage: "Source Page Icon"
    },
    ai_answer_expand_button_label: {
        id: "search_ai.ai_answer_component.expand_button_label",
        defaultMessage: "Show more"
    },
    ai_answer_collapse_button_label: {
        id: "search_ai.ai_answer_component.collapse_button_label",
        defaultMessage: "Show less"
    },
    ai_answer_component_information_icon_tooltip_text: {
        id: "search_ai.ai_answer_component_information_icon_tooltip_text",
        defaultMessage: "Information quality may vary. {informationLink}"
    },
    ai_answer_component_information_icon_tooltip_link: {
        id: "search_ai.ai_answer_component_information_icon_tooltip_link",
        defaultMessage: "Learn why"
    },
    ai_answer_component_feedback_label: {
        id: "search_ai.ai_answer_component_feedback_label",
        defaultMessage: "Was this helpful?"
    },
    ai_answer_component_like_button_tooltip: {
        id: "search_ai.ai_answer_component_like_button_tooltip",
        defaultMessage: "Good response"
    },
    ai_answer_component_dislike_button_tooltip: {
        id: "search_ai.ai_answer_component_dislike_button_tooltip",
        defaultMessage: "Bad response"
    },
    ai_answer_component_report_button: {
        id: "search_ai.ai_answer_component_report_button",
        defaultMessage: "Report this"
    },
    ai_answer_component_report_success_text: {
        id: "search_ai.ai_answer_component_report_success_text",
        defaultMessage: "Report submitted"
    },
    ai_answer_component_report_modal_title: {
        id: "search_ai.ai_answer_component_report_modal_title",
        defaultMessage: "Help us improve {brandName}"
    },
    ai_answer_component_report_summary_label: {
        id: "search_ai.ai_answer_component_report_summary_label",
        defaultMessage: "Was there a problem with the AI response? Let us know what happened."
    },
    ai_answer_component_report_empty_option_label: {
        id: "search_ai.ai_answer_component_report_empty_option_label",
        defaultMessage: "I want to report..."
    },
    ai_answer_component_report_empty_option_share_label: {
        id: "search_ai.ai_answer_component_report_empty_option_share_label",
        defaultMessage: "I want to share..."
    },
    ai_answer_component_report_consent_checkbox_label: {
        id: "search_ai.ai_answer_component_report_consent_checkbox_label",
        defaultMessage: "Include my last prompt and response in the feedback."
    },
    ai_answer_component_topics_not_relevant_checkbox_label: {
        id: "search_ai.ai_answer_component_topics_not_relevant_checkbox_label",
        defaultMessage: "The topics are not relevant to this person."
    },
    ai_answer_component_report_relevance_option_label: {
        id: "search_ai.ai_answer_component_report_relevance_option_label",
        defaultMessage: "This isn\u2019t relevant or isn\u2019t what I expected"
    },
    sac_ai_answer_component_report_relevance_option_label: {
        id: "search_ai.sac_ai_answer_component_report_relevance_option_label",
        defaultMessage: "This isn\u2019t relevant or isn\u2019t accurate"
    },
    ai_answer_component_report_inaccurate_option_label: {
        id: "search_ai.ai_answer_component_report_inaccurate_option_label",
        defaultMessage: "This is inaccurate or misleading"
    },
    ai_answer_component_report_offensive_option_label: {
        id: "search_ai.ai_answer_component_report_offensive_option_label",
        defaultMessage: "This is offensive or harmful"
    },
    sac_ai_answer_component_report_unhelpful_links_option_label: {
        id: "search_ai.sac_ai_answer_component_report_unhelpful_links_option_label",
        defaultMessage: "Unhelpful links"
    },
    sac_ai_answer_component_report_inaccurate_option_label: {
        id: "search_ai.sac_ai_answer_component_report_inaccurate_option_label",
        defaultMessage: "Too slow"
    },
    ai_answer_component_report_other_option_label: {
        id: "search_ai.ai_answer_component_report_other_option_label",
        defaultMessage: "Something else"
    },
    sac_ai_answer_component_report_other_option_label: {
        id: "search_ai.sac_ai_answer_component_report_other_option_label",
        defaultMessage: "Other"
    },
    ai_answer_component_report_details_label: {
        id: "search_ai.ai_answer_component_report_details_label",
        defaultMessage: "Describe the issue"
    },
    ai_answer_component_feedback_flag_description: {
        id: "search_ai.ai_answer_component_feedback_flag_descriptionl",
        defaultMessage: "We appreciate you taking the time to send this feedback"
    },
    ai_answer_component_summary_placeholder_label: {
        id: "search_ai.ai_answer_component_summary_placeholder_label",
        defaultMessage: "Explain the problem you experienced"
    },
    ai_answer_component_followups_label: {
        id: "search_ai.ai_answer_component_followups_label",
        defaultMessage: "Ask a follow up question"
    },
    ai_answer_component_error_state_subjective_query: {
        id: "search_ai.ai_answer_component_error_state_subjective_query",
        defaultMessage: "That seems like a subjective question, so {brandName} can\u2019t answer it for you right now."
    },
    ai_answer_component_error_state_keyword: {
        id: "search_ai.ai_answer_component_error_state_keyword",
        defaultMessage: "{brandName} couldn\u2019t understand your question, possibly because it didn\u2019t include enough details. Try rephrasing your question, or including some more specific details. {learnMoreLink}"
    },
    ai_answer_component_error_state_acceptable_use: {
        id: "search_ai.ai_answer_component_error_state_acceptable_use",
        defaultMessage: "{brandName} can\u2019t provide you with a response, as it might go against {acceptableUseLink}. Please try asking another question."
    },
    ai_answer_component_error_state_acceptable_use_link: {
        id: "search_ai.ai_answer_component_error_state_acceptable_use_link",
        defaultMessage: "Atlassian's acceptable use policy"
    },
    ai_answer_component_error_state_network: {
        id: "search_ai.ai_answer_component_error_state_network",
        defaultMessage: "{brandName} can't provide a response right now. Read more in our {supportLink}."
    },
    ai_answer_component_error_state_hipaa: {
        id: "search_ai.ai_answer_component_error_state_hipaa",
        defaultMessage: "Due to HIPAA compliance, we can\u2019t provide an answer. {supportLink}."
    },
    ai_answer_component_error_state_no_answer: {
        id: "search_ai.ai_answer_component_error_state_no_answer",
        defaultMessage: "{brandName} doesn\u2019t have enough data to provide a response right now. It\u2019s possible that we couldn\u2019t find the relevant information in your company\u2019s knowledge base. Try rephrasing your question, or including some more specific details. {learnMoreLink}"
    },
    ai_answer_component_open_ai_rate_limit_error: {
        id: "search_ai.ai_answer_component_open_ai_rate_limit_error",
        defaultMessage: "Excessive use has been detected with {brandName}. Try again later. Read more in our {supportLink}."
    },
    ai_answer_component_support_link: {
        id: "search_ai.ai_answer_component_support_link",
        defaultMessage: "support documentation"
    },
    ai_answer_component_hipaa_compliance_link: {
        id: "search_ai.ai_answer_component_hipaa_compliance_link",
        defaultMessage: "Find out more about HIPAA"
    },
    ai_answer_component_error_state_no_who_is_answer: {
        id: "search_ai.ai_answer_component_error_state_no_who_is_answer",
        defaultMessage: "{brandName} couldn\u2019t find a match for this person in your organisation. It\u2019s possible that there was a misspelling in your search, this person goes by another name, or that this person doesn\u2019t work here."
    },
    ai_answer_component_disclaimer_who_question: {
        id: "search_ai.ai_answer_component_disclaimer_who_question",
        defaultMessage: "This information is solely based on what\u2019s in your knowledge base and may not always be accurate."
    },
    ai_answer_permission_label: {
        id: "search_ai.ai_answer_permission_label",
        defaultMessage: "Answers may include information from pages that are restricted to others but visible to you."
    },
    ai_answer_dialog_cancel_label: {
        id: "search_ai.ai_answer_dialog_cancel_label",
        defaultMessage: "Dive deeper into the {searchResultsLink}"
    },
    ai_answer_dialog_search_results_label: {
        id: "search_ai.ai_answer_dialog_search_results_label",
        defaultMessage: "search results"
    },
    ai_answer_dialog_teams_not_found_message: {
        id: "search_ai.ai_answer_dialog_teams_not_found_message",
        defaultMessage: "Some teams may not be found on this site due to"
    },
    ai_answer_dialog_teams_not_found_message_link: {
        id: "search_ai.ai_answer_dialog_teams_not_found_message_link",
        defaultMessage: "changes in team visibility."
    },
    ai_answer_onboarding_banner_title: {
        id: "search_ai.ai_answer_onboarding_banner_title",
        defaultMessage: "Try Atlassian Intelligence in search"
    },
    ai_answer_onboarding_banner_v1_info: {
        id: "search_ai.ai_answer_onboarding_banner_v1_info",
        defaultMessage: "<b>Example:</b>How do I submit expenses for reimbursement?"
    },
    ai_answer_onboarding_banner_info: {
        id: "search_ai.ai_answer_onboarding_banner_info",
        defaultMessage: "Ask about a project or topic within your company\u2019s knowledge base. {informationLink}"
    },
    ai_answer_onboarding_banner_tooltip_link: {
        id: "search_ai.ai_answer_onboarding_banner_tooltip_link",
        defaultMessage: "Learn more"
    },
    ai_answer_onboarding_close_button_text: {
        id: "search_ai.ai_answer_onboarding_close_button_text",
        defaultMessage: "Close"
    },
    ai_answer_onboarding_banner_example_query_vacation_policy: {
        id: "search_ai.ai_answer_onboarding_banner_example_query_vacation_policy",
        defaultMessage: "What is the vacation policy?"
    },
    ai_answer_onboarding_banner_example_query_expenses: {
        id: "search_ai.ai_answer_onboarding_banner_example_query_expenses",
        defaultMessage: "How to submit expenses for reimbursement?"
    },
    ai_answer_dialog_loaded_footer_sac: {
        id: "search_ai.ai_answer_dialog_loaded_footer_sac",
        defaultMessage: "Powered by AI"
    },
    ai_answer_dialog_loaded_footer: {
        id: "search_ai.ai_answer_dialog_loaded_footer",
        defaultMessage: "Powered by Atlassian Intelligence"
    },
    ai_answer_dialog_footer_more_options_tooltip: {
        id: "search_ai.ai_answer_dialog_footer_more_options_tooltip",
        defaultMessage: "More options"
    },
    ai_answer_dialog_updated: {
        id: "search_ai.ai_answer_dialog_updated",
        defaultMessage: "Updated"
    },
    ai_answer_who_questions_frequent_locations_header: {
        id: "search_ai.ai_answer_who_questions_frequent_locations_header",
        defaultMessage: "Frequent locations"
    },
    ai_answer_who_questions_frequent_collaborators_header: {
        id: "search_ai.ai_answer_who_questions_frequent_collaborators_header",
        defaultMessage: "Frequent collaborators"
    },
    ai_answer_who_question_team_section_member_count: {
        id: "search_ai.ai_answer_who_question_team_section_member_count",
        defaultMessage: "{count, plural, =0 {No members} one {# member} other {# members}}"
    },
    ai_answer_who_questions_teams_header: {
        id: "search_ai.ai_answer_who_questions_teams_header",
        defaultMessage: "Teams"
    },
    ai_answer_who_questions_view_profile: {
        id: "search_ai.ai_answer_who_questions_view_profile",
        defaultMessage: "View profile"
    },
    ai_answer_who_questions_hover_role_icon: {
        id: "search_ai.ai_answer_who_questions_hover_role_icon",
        defaultMessage: "Role"
    },
    ai_answer_who_questions_hover_department_icon: {
        id: "search_ai.ai_answer_who_questions_hover_department_icon",
        defaultMessage: "Department"
    },
    ai_answer_who_questions_hover_location_icon: {
        id: "search_ai.ai_answer_who_questions_hover_location_icon",
        defaultMessage: "Location"
    },
    ai_answer_who_questions_hover_local_time_icon: {
        id: "search_ai.ai_answer_who_questions_hover_local_time_icon",
        defaultMessage: "Local time"
    },
    ai_answer_who_questions_hover_email_icon: {
        id: "search_ai.ai_answer_who_questions_hover_email_icon",
        defaultMessage: "Email"
    },
    ai_answer_who_questions_footer_header: {
        id: "search_ai.ai_answer_who_questions_footer_header",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: "{numMatches} additional {numMatches, plural, =1 {match} other {matches}}"
    },
    ai_answer_dialog_footer_content_quality_short: {
        id: "search_ai.ai_answer_dialog_footer_content_quality_short",
        defaultMessage: "Uses AI. Verify results."
    },
    ai_answer_dialog_footer_beta_tag: {
        id: "search_ai.ai_answer_dialog_footer_beta_tag",
        defaultMessage: "BETA"
    },
    ai_answer_dialog_footer_content_quality_long: {
        id: "search_ai.ai_answer_dialog_footer_content_quality_long",
        defaultMessage: "Uses AI. Verify results."
    },
    reading_aids_dialog_information_icon_tooltip_link: {
        id: "search_ai.reading_aids_dialog_information_icon_tooltip_link",
        defaultMessage: "Learn more"
    },
    reading_aids_dialog_loaded_footer: {
        id: "search_ai.reading_aids_dialog_loaded_footer",
        defaultMessage: "Powered by Atlassian Intelligence"
    },
    reading_aids_dialog_disclaimer: {
        id: "search_ai.reading_aids_dialog_disclaimer",
        defaultMessage: "Information may vary."
    },
    reading_aids_dialog_disclaimer_link: {
        id: "search_ai.reading_aids_dialog_disclaimer_link",
        defaultMessage: "Learn why"
    },
    reading_aids_defined_by: {
        id: "search_ai.reading_aids_dialog_defined_by",
        defaultMessage: "Defined by"
    },
    reading_aids_see_edit_history: {
        id: "search_ai.reading_aids_dialog_see_edit_history",
        defaultMessage: "See all edit history"
    },
    ai_answer_admin_message: {
        id: "search_ai.ai_answer_admin_message",
        defaultMessage: "Unleash the knowledge in your Confluence by asking questions in search and getting answers from Atlassian Intelligence."
    },
    ai_answer_admin_turn_on_atlassian_intelligence: {
        id: "search_ai.ai_admin_turn_on_atlassian_intelligence",
        defaultMessage: "Turn on Atlassian Intelligence"
    },
    ai_answer_admin_info_popup_header: {
        id: "search_ai.ai_answer_admin_info_popup_header",
        defaultMessage: "Get answers from Atlassian Intelligence in search"
    },
    ai_answer_admin_info_popup_banner_alt_text: {
        id: "search_ai.ai_answer_admin_info_popup_banner_alt_text",
        defaultMessage: "Search input with example query \"What is the vacation policy?\""
    },
    ai_answer_admin_info_popup_link: {
        id: "search_ai.ai_answer_admin_info_popup_link",
        defaultMessage: "Learn more about Atlassian Intelligence"
    },
    ai_answer_admin_info_popup_dismiss: {
        id: "search_ai.ai_answer_admin_info_popup_dismiss",
        defaultMessage: "Dismiss"
    },
    ai_answer_generating_text: {
        id: "search_ai.ai_answer_generating_text",
        defaultMessage: "Generating"
    },
    ai_answer_generating_rovo: {
        id: "ai_answer_generating_rovo",
        defaultMessage: "Generating"
    },
    ai_answer_generating_icon_alt_text: {
        id: "search_ai.ai_answer_generating_icon_alt_text",
        defaultMessage: "Generating icon"
    },
    ai_answer_button_tooltip_message: {
        id: "search_ai_answer_prompt.ask_ai_button.tooltip",
        defaultMessage: "Ask a question in search to get an answer from Atlassian Intelligence"
    },
    ai_answer_reading_aids_banner_header: {
        id: "search_ai.reading_aids.banner_header",
        defaultMessage: "Define any term with AI, not just acronyms"
    },
    ai_answer_reading_aids_banner_description: {
        id: "search_ai.reading_aids.banner_description",
        defaultMessage: "Get definitions for project terms, team names and more. Just highlight the word or phrase, then select <b>Define</b>."
    },
    reading_aids_edited_definition_report_modal_title: {
        id: "search_ai.reading_aids_edited_definition_report_modal_title",
        defaultMessage: "Help us improve Definitions"
    },
    reading_aids_edited_definition_report_label: {
        id: "search_ai.reading_aids_edited_definition_report_label",
        defaultMessage: "Was there a problem with this definition? Let us know what happened."
    },
    knowledge_cards_view_team: {
        id: "search_ai.knowledge_cards.view_team",
        defaultMessage: "View team"
    },
    knowledge_cards_team_subheader: {
        id: "search_ai.knowledge_cards.team_subheader",
        defaultMessage: "Team"
    },
    knowledge_cards_copy_email_address: {
        id: "search_ai.knowledge_cards.copy_email_address",
        defaultMessage: "Copy email address"
    },
    knowledge_cards_recent_work_subheader: {
        id: "search_ai.knowledge_cards.recent_work_subheader",
        defaultMessage: "Recent work"
    },
    knowledge_cards_worked_on_subheader: {
        id: "search_ai.knowledge_cards.worked_on_subheader",
        defaultMessage: "Worked on"
    },
    knowledge_cards_collaborators_subheader: {
        id: "search_ai.knowledge_cards.collaborators_subheader",
        defaultMessage: "Collaborators"
    },
    knowledge_cards_recent_work_empty: {
        id: "search_ai.knowledge_cards.recent_work_empty",
        defaultMessage: "No recent work"
    },
    knowledge_cards_collaborators_empty: {
        id: "search_ai.knowledge_cards.collaborators_empty",
        defaultMessage: "No recent collaborators"
    },
    knowledge_cards_teammembers_empty: {
        id: "search_ai.knowledge_cards.teammembers_empty",
        defaultMessage: "No team members"
    },
    knowledge_cards_view_all_link: {
        id: "search_ai.knowledge_cards.view_all_link",
        defaultMessage: "View all"
    },
    knowledge_cards_team_members_subheader: {
        id: "search_ai.knowledge_cards.team_members_subheader",
        defaultMessage: "Team members"
    },
    knowledge_cards_view_agent: {
        id: "search_ai.knowledge_cards.view_agent",
        defaultMessage: "View agent"
    },
    knowledge_cards_agent_subheader: {
        id: "search_ai.knowledge_cards.agent_subheader",
        defaultMessage: "AI Agent"
    },
    knowledge_cards_rovo_agent_by: {
        id: "search_ai.knowledge_cards.rovo_agent_by",
        defaultMessage: "by"
    },
    knowledge_cards_teams_subheader: {
        id: "search_ai.knowledge_cards.teams_subheader",
        defaultMessage: "Teams"
    },
    knowledge_cards_team_member_count: {
        id: "search_ai.knowledge_cards.team_member_count",
        defaultMessage: "{count} members"
    },
    knowledge_cards_person_hover_profile_link: {
        id: "search_ai.knowledge_cards.person_hover_profile_link",
        defaultMessage: "View profile"
    },
    ai_answer_onboarding_banner_info_galaxia: {
        id: "search_ai.ai_answer_onboarding_banner_info-galaxia",
        defaultMessage: "Ask about a space or topic within your company\u2019s knowledge base. {informationLink}"
    },
    ai_answer_reading_aids_banner_description_galaxia: {
        id: "search_ai.reading_aids.banner_description-galaxia",
        defaultMessage: "Get definitions for space terms, team names and more. Just highlight the word or phrase, then select <b>Define</b>."
    },
    knowledge_cards_person_org_chart_label: {
        id: "search_ai.knowledge_cards_person_org_chart_label",
        defaultMessage: "Reporting line"
    },
    knowledge_cards_person_org_chart_modal_header: {
        id: "search_ai.knowledge_cards_person_org_chart_modal_header",
        defaultMessage: "Reporting Line"
    }
});
module.exports["messages"] = $827bbb02634e926d$export$defe85febe8b728c;

});

parcelRegister("ab1fW", function(module, exports) {
$parcel$export(module.exports, "ChatPill", () => (parcelRequire("lBFuf")).ChatPill);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lBFuf = parcelRequire("lBFuf");


var $kIvLT = parcelRequire("kIvLT");


var $jA9SA = parcelRequire("jA9SA");

const $de70ae3c39f94954$export$668058776bea98f5 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ onClick: onButtonClick, experienceId: experienceId, followUpIndex: followUpIndex, followUpType: followUpType, followUpText: followUpText, ...props }, ref)=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $kIvLT.useAnalytics)();
    const analyticsPropertiesRef = (0, $42omo.useRef)();
    analyticsPropertiesRef.current = {
        followUpIndex: followUpIndex,
        followUpType: followUpType,
        followUpLength: followUpText.length,
        ...experienceId ? {
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).experienceId]: experienceId
        } : {}
    };
    (0, $42omo.useEffect)(()=>{
        sendAnalyticsEvent({
            eventType: 'screen',
            name: 'followUpQueryButton',
            attributes: analyticsPropertiesRef.current
        });
    }, [
        sendAnalyticsEvent
    ]);
    const onClick = (0, $42omo.useCallback)((_, analyticsEvent)=>{
        sendAnalyticsEvent(analyticsEvent.update({
            actionSubjectId: 'followUpQueryButton',
            attributes: {
                ...analyticsEvent.payload.attributes,
                ...analyticsPropertiesRef.current
            }
        }));
        onButtonClick();
    }, [
        onButtonClick,
        sendAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lBFuf.ChatPill), {
        onClick: onClick,
        ...props,
        ref: ref,
        children: followUpText
    });
});
module.exports["FollowUpButton"] = $de70ae3c39f94954$export$668058776bea98f5;

});

parcelRegister("2YIh2", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $esRft = parcelRequire("esRft");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $4JDbp = parcelRequire("4JDbp");


var $g91Ox = parcelRequire("g91Ox");

const $2fb19ef32ab04e83$var$AVATAR_BREAKPOINT = 180;
const $2fb19ef32ab04e83$var$unbouncedStyles = {
    name: "_11c81qyo _1reo15vq _18m915vq _k48p1wq8 _y3gn1h6o _1bto1l2s _1e0ccj1k _sudp1e54 _1yyjcs5v"
};
const $2fb19ef32ab04e83$var$styles = {
    emptyLine: "_4t3igktf"
};
function $2fb19ef32ab04e83$export$4c094c8f61edecb4({ data: { avatarUrl: avatarUrl, id: id, name: name, jobTitle: jobTitle, location: location, localTime: localTime } }) {
    const shouldShowEmptyLine = !jobTitle && !location && !localTime;
    const [width, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(0);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $g91Ox.PersonCardWrapper), {
        id: id,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $4JDbp.WidthObserver), {
                setWidth: setWidth
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                space: "space.150",
                alignInline: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
                        src: avatarUrl,
                        name: name,
                        size: width < $2fb19ef32ab04e83$var$AVATAR_BREAKPOINT ? 'xlarge' : 'xxlarge'
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                        space: "space.050",
                        alignInline: "center",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                as: "h2",
                                xcss: $2fb19ef32ab04e83$var$unbouncedStyles.name,
                                children: name
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                maxLines: 2,
                                size: "small",
                                color: "color.text.subtlest",
                                align: "center",
                                children: jobTitle
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                maxLines: 1,
                                size: "small",
                                color: "color.text.subtlest",
                                align: "center",
                                children: [
                                    location,
                                    localTime
                                ].filter(Boolean).join(' ')
                            }),
                            shouldShowEmptyLine && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $2fb19ef32ab04e83$var$styles.emptyLine
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
module.exports["PersonCard"] = $2fb19ef32ab04e83$export$4c094c8f61edecb4;

});

parcelRegister("g91Ox", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

const $ead1b65abe4e11c5$var$wrapperStyles = {
    root: "_2rko1mok _v564nm7n _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1l7x _1bsb1osq _4t3i1osq _1ul91lit _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _kqswh2mm _9oik1r31 _1bnxglyw _jf4cnqa1 _d0altlke _1s5z1k61 _le1b1cqc _73vx1ytf _1gav5cps"
};
const $ead1b65abe4e11c5$export$a3474cd1dd8e70a = ({ id: id, children: children, testId: testId })=>{
    const [isHovered, setIsHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($ead1b65abe4e11c5$var$wrapperStyles.root),
        backgroundColor: isHovered ? 'elevation.surface.hovered' : 'elevation.surface',
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        testId: testId || `person-card-${id}`,
        children: children
    });
};
module.exports["PersonCardWrapper"] = $ead1b65abe4e11c5$export$a3474cd1dd8e70a;

});

parcelRegister("bvjDB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63af381965cffd1b2653ae2b97232288>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8601d29e65a3bd86$var$_react = $8601d29e65a3bd86$var$_interopRequireDefault((parcelRequire("42omo")));

var $8601d29e65a3bd86$var$_baseNew = $8601d29e65a3bd86$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8601d29e65a3bd86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Minimize".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for minimizing or docking modals to the bottom of the viewport.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8601d29e65a3bd86$var$MinimizeIcon = (props)=>/*#__PURE__*/ $8601d29e65a3bd86$var$_react.default.createElement($8601d29e65a3bd86$var$_baseNew.default, Object.assign({
        name: "MinimizeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 14H2v-1.5h12z" clip-rule="evenodd"/>`
    }, props));
$8601d29e65a3bd86$var$MinimizeIcon.displayName = 'MinimizeIcon';
var $8601d29e65a3bd86$var$_default = module.exports.default = $8601d29e65a3bd86$var$MinimizeIcon;

});

parcelRegister("aUwPP", function(module, exports) {

var $9LRzA = parcelRequire("9LRzA");


var $5abq6 = parcelRequire("5abq6");


var $b9lC3 = parcelRequire("b9lC3");


var $87fJd = parcelRequire("87fJd");

const $8f944f557ac62b40$export$171e576bb7c729fa = ({ api: api })=>({
        name: 'indentation',
        marks () {
            return [
                {
                    name: 'indentation',
                    mark: (0, $9LRzA.indentation)
                }
            ];
        },
        actions: {
            indentParagraphOrHeading: (0, $b9lC3.getIndentCommand)(api?.analytics?.actions),
            outdentParagraphOrHeading: (0, $b9lC3.getOutdentCommand)(api?.analytics?.actions)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const { tr: { selection: selection }, schema: { marks: { indentation: indentation } } } = editorState;
            const node = selection.$from.node();
            const indentationMark = node.marks.find((mark)=>mark.type === indentation);
            return {
                isIndentationAllowed: (0, $b9lC3.isIndentationAllowed)(editorState.schema, node),
                // @ts-ignore - TS2869 TypeScript 5.9.2 upgrade
                indentDisabled: (indentationMark?.attrs.level >= (0, $5abq6.MAX_INDENTATION_LEVEL)) ?? false,
                outdentDisabled: !indentationMark
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'indentationKeymap',
                    plugin: ()=>(0, $87fJd.keymapPlugin)(api?.analytics?.actions)
                }
            ];
        }
    });
module.exports["indentationPlugin"] = $8f944f557ac62b40$export$171e576bb7c729fa;

});

parcelRegister("b9lC3", function(module, exports) {

var $aU3dp = parcelRequire("aU3dp");

var $d925B = parcelRequire("d925B");


var $dhoHU = parcelRequire("dhoHU");


var $5abq6 = parcelRequire("5abq6");


var $kecXX = parcelRequire("kecXX");


var $by9bj = parcelRequire("by9bj");

const $a4290f7701cf1730$export$54db194d337db321 = (schema, node)=>{
    const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = schema;
    if ([
        paragraph,
        heading
    ].indexOf(node.type) > -1) {
        if (alignment) {
            const hasAlignment = node.marks.filter((mark)=>mark.type === alignment)[0];
            return !hasAlignment;
        }
        return true;
    }
    return false;
};
/**
 * Create new indentation command (Either indent or outdent depend of getArgsFn)
 * @param getNewIndentationAttrs Function to handle new indentation level
 */ function $a4290f7701cf1730$var$createIndentationCommand(getNewIndentationAttrs) {
    return (state, dispatch)=>{
        const { indentation: indentation } = state.schema.marks;
        return (0, $dhoHU.toggleBlockMark)(indentation, getNewIndentationAttrs, $a4290f7701cf1730$export$54db194d337db321)(state, dispatch);
    };
}
function $a4290f7701cf1730$var$createIndentationCommandWithAnalytics({ getNewIndentationAttrs: getNewIndentationAttrs, direction: direction, inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI }) {
    // Create a new getAttrs function to record the changes
    const { getAttrs: getAttrs, getAndResetAttrsChanges: getAndResetAttrsChanges } = (0, $kecXX.default)(getNewIndentationAttrs, {
        direction: direction
    });
    // Use new getAttrs wrapper
    const indentationCommand = $a4290f7701cf1730$var$createIndentationCommand(getAttrs);
    // Return a new command where we change dispatch for our analytics dispatch
    return (state, dispatch)=>{
        return indentationCommand(state, (0, $by9bj.createAnalyticsDispatch)({
            getAttrsChanges: getAndResetAttrsChanges,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI,
            state: state,
            dispatch: dispatch
        }));
    };
}
/**
 * Get new level for outdent
 * @param oldAttr Old attributes for the mark, undefined if the mark doesn't exit
 * @returns  - undefined; No change required
 *           - false; Remove the mark
 *           - object; Update attributes
 */ const $a4290f7701cf1730$var$getIndentAttrs = (oldAttr)=>{
    if (!oldAttr) return {
        level: 1
    }; // No mark exist, create a new one with level 1
    const { level: level } = oldAttr;
    if (level >= (0, $5abq6.MAX_INDENTATION_LEVEL)) return undefined; // Max indentation level reached, do nothing.
    return {
        level: level + 1
    }; // Otherwise, increase the level by one
};
const $a4290f7701cf1730$export$b294289254b8cdac = (editorAnalyticsAPI)=>(inputMethod = (0, $d925B.INPUT_METHOD).KEYBOARD)=>$a4290f7701cf1730$var$createIndentationCommandWithAnalytics({
            getNewIndentationAttrs: $a4290f7701cf1730$var$getIndentAttrs,
            direction: (0, $aU3dp.INDENT_DIRECTION).INDENT,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
/**
 * Get new level for outdent
 * @param oldAttr Old attributes for the mark, undefined if the mark doesn't exit
 * @returns  - undefined; No change required
 *           - false; Remove the mark
 *           - object; Update attributes
 */ const $a4290f7701cf1730$var$getOutdentAttrs = (oldAttr)=>{
    if (!oldAttr) return undefined; // Do nothing;
    const { level: level } = oldAttr;
    if (level <= 1) return false; // Remove the mark
    return {
        level: level - 1
    }; // Decrease the level on other cases
};
const $a4290f7701cf1730$export$620b2a1f10eb3a5f = (editorAnalyticsAPI)=>(inputMethod = (0, $d925B.INPUT_METHOD).KEYBOARD)=>$a4290f7701cf1730$var$createIndentationCommandWithAnalytics({
            getNewIndentationAttrs: $a4290f7701cf1730$var$getOutdentAttrs,
            direction: (0, $aU3dp.INDENT_DIRECTION).OUTDENT,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
const $a4290f7701cf1730$export$33ad14ed4b6e7a8e = (state, dispatch)=>(0, $dhoHU.toggleBlockMark)(state.schema.marks.indentation, ()=>false)(state, dispatch);
module.exports["isIndentationAllowed"] = $a4290f7701cf1730$export$54db194d337db321;
module.exports["getIndentCommand"] = $a4290f7701cf1730$export$b294289254b8cdac;
module.exports["getOutdentCommand"] = $a4290f7701cf1730$export$620b2a1f10eb3a5f;

});

parcelRegister("kecXX", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d4de3432317ffe3$export$2e2bcd8739ae039);
function $2d4de3432317ffe3$export$2e2bcd8739ae039(getAttrs, options) {
    let changes = [];
    function getAttrsWithChangesRecorder(prevAttrs, node) {
        const newAttrs = getAttrs(prevAttrs, node);
        changes.push({
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            node: node,
            prevAttrs: prevAttrs,
            newAttrs: newAttrs,
            options: options
        });
        return newAttrs;
    }
    return {
        getAttrs: getAttrsWithChangesRecorder,
        getAndResetAttrsChanges () {
            const oldChanges = changes;
            changes = [];
            return oldChanges;
        }
    };
}

});

parcelRegister("by9bj", function(module, exports) {

var $d925B = parcelRequire("d925B");

var $aU3dp = parcelRequire("aU3dp");

const $a44445544afb543f$var$indentTypes = {
    paragraph: (0, $aU3dp.INDENT_TYPE).PARAGRAPH,
    heading: (0, $aU3dp.INDENT_TYPE).HEADING
};
function $a44445544afb543f$export$c67aac760a384f96(prevAttrs, newAttrs) {
    if (newAttrs === undefined) return $a44445544afb543f$export$697340b93338bcbd(prevAttrs);
    else if (newAttrs === false) return 0;
    return newAttrs.level;
}
function $a44445544afb543f$export$697340b93338bcbd(prevAttrs) {
    if (prevAttrs === undefined) return 0;
    return prevAttrs.level;
}
function $a44445544afb543f$export$4f15b45384b61427({ getAttrsChanges: getAttrsChanges, inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI, state: state, dispatch: dispatch }) {
    return (tr)=>{
        const currentTr = tr;
        const changes = getAttrsChanges(); // Get all attributes changes
        // Add analytics event for each change stored.
        changes.forEach(({ node: node, prevAttrs: prevAttrs, newAttrs: newAttrs, options: { direction: direction } })=>{
            const indentType = $a44445544afb543f$var$indentTypes[node.type.name];
            if (!indentType) return; // If no valid indent type continue
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).FORMATTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_INDENT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: inputMethod,
                    previousIndentationLevel: $a44445544afb543f$export$697340b93338bcbd(prevAttrs),
                    newIndentLevel: $a44445544afb543f$export$c67aac760a384f96(prevAttrs, newAttrs),
                    direction: direction,
                    indentType: indentType
                }
            })(currentTr);
        });
        // Dispatch analytics if exist
        if (dispatch) dispatch(tr);
    };
}
module.exports["createAnalyticsDispatch"] = $a44445544afb543f$export$4f15b45384b61427;

});

parcelRegister("87fJd", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $hgeg8 = parcelRequire("hgeg8");


var $kTbzR = parcelRequire("kTbzR");


var $dus6D = parcelRequire("dus6D");


var $8m4tT = parcelRequire("8m4tT");


var $b9lC3 = parcelRequire("b9lC3");

function $e60d68c782a1a955$export$e832373cff8dec22(editorAnalyticsAPI) {
    const list = {};
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.indent)), (state, dispatch)=>{
        const { blockTaskItem: blockTaskItem, paragraph: paragraph, doc: doc } = state.schema.nodes;
        if (blockTaskItem) {
            let hasBlockTaskItem = false;
            let hasParagraphAtDocLevel = false;
            // Check if the selection contains a blockTaskItem
            state.doc.nodesBetween(state.selection.from, state.selection.to, (node, _pos, parent)=>{
                if (node.type === blockTaskItem) {
                    hasBlockTaskItem = true;
                    return false; // stop iterating
                }
                if (node.type === paragraph && parent?.type === doc) hasParagraphAtDocLevel = true;
            });
            if (hasBlockTaskItem && !hasParagraphAtDocLevel) return false; // let `editor-plugin-tasks-and-decisions` handle indentation
        }
        return (0, $b9lC3.getIndentCommand)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).KEYBOARD)(state, dispatch);
    }, list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.outdent)), (0, $b9lC3.getOutdentCommand)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).KEYBOARD), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.backspace)), (state, dispatch)=>{
        const { selection: selection } = state;
        const { blockTaskItem: blockTaskItem } = state.schema.nodes;
        // Let `editor-plugin-tasks-and-decisions` handle indentation inside blockTaskItems
        if ((0, $kTbzR.isTextSelection)(selection) && selection.$cursor && selection.$cursor.parentOffset === 0 && !(0, $8m4tT.hasParentNodeOfType)([
            blockTaskItem
        ])(selection)) return dispatch ? (0, $b9lC3.getOutdentCommand)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).KEYBOARD)(state, dispatch) : false;
        return false;
    }, list);
    return (0, $dus6D.keymap)(list);
}
var $e60d68c782a1a955$export$2e2bcd8739ae039 = $e60d68c782a1a955$export$e832373cff8dec22;
module.exports["keymapPlugin"] = $e60d68c782a1a955$export$e832373cff8dec22;

});

parcelRegister("eLJ6t", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // want color of icon to be the same for regular/light/dark modes

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $4af0d4a8e674c639$export$eaf821108be3620b = ({ size: size = 'small', greyed: greyed = false })=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: size === 'smaller' ? '16' : size === 'small' ? '18' : size === 'medium' ? '20' : '24',
        height: size === 'smaller' ? '16' : size === 'small' ? '18' : size === 'medium' ? '20' : '24',
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M14.5 15.3L17.5 18.3",
                stroke: "#626F86",
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M9.5 15.3L6.5 18.3",
                stroke: "#626F86",
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M9.5 10.3L6.5 7.30002",
                stroke: "#626F86",
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M14.5 10.3L17.5 7.30002",
                stroke: "#626F86",
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.0001 16.8V19.8",
                stroke: "#626F86",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M8.00012 12.8L5.00012 12.8",
                stroke: "#626F86",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.0001 8.80003L12.0001 5.8",
                stroke: "#626F86",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M16.0002 12.8L19.0002 12.8",
                stroke: "#626F86",
                strokeWidth: "1.5"
            })
        ]
    });
var $4af0d4a8e674c639$export$2e2bcd8739ae039 = $4af0d4a8e674c639$export$eaf821108be3620b;
module.exports["default"] = $4af0d4a8e674c639$export$2e2bcd8739ae039;

});

parcelRegister("eG1e2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b6405c70debcc4f4b2a8d477842ac4ae>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aaf5f0417c8d4f4a$var$_react = $aaf5f0417c8d4f4a$var$_interopRequireDefault((parcelRequire("42omo")));

var $aaf5f0417c8d4f4a$var$_baseNew = $aaf5f0417c8d4f4a$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $aaf5f0417c8d4f4a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FolderOpen".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for open folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aaf5f0417c8d4f4a$var$FolderOpenIcon = (props)=>/*#__PURE__*/ $aaf5f0417c8d4f4a$var$_react.default.createElement($aaf5f0417c8d4f4a$var$_baseNew.default, Object.assign({
        name: "FolderOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v9.473L3.148 6.98c.174-.582.71-.98 1.317-.98H12.5V4.75a.5.5 0 0 0-.5-.5H6.69L4.94 2.5zM14 6h.66c.921 0 1.582.888 1.317 1.77l-1.741 5.805A2 2 0 0 1 12.32 15H1.75A1.75 1.75 0 0 1 0 13.25V3a2 2 0 0 1 2-2h3.56l1.75 1.75H12a2 2 0 0 1 2 2zM2.758 13.5h9.562a.5.5 0 0 0 .479-.356L14.492 7.5H4.558z" clip-rule="evenodd"/>`
    }, props));
$aaf5f0417c8d4f4a$var$FolderOpenIcon.displayName = 'FolderOpenIcon';
var $aaf5f0417c8d4f4a$var$_default = module.exports.default = $aaf5f0417c8d4f4a$var$FolderOpenIcon;

});

parcelRegister("bTdbD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d48827792ad56aec1327e3c5557d624a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a7f0f5cf9a8ca34$var$_react = $8a7f0f5cf9a8ca34$var$_interopRequireDefault((parcelRequire("42omo")));

var $8a7f0f5cf9a8ca34$var$_baseNew = $8a7f0f5cf9a8ca34$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8a7f0f5cf9a8ca34$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pages".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multipe pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8a7f0f5cf9a8ca34$var$PagesIcon = (props)=>/*#__PURE__*/ $8a7f0f5cf9a8ca34$var$_react.default.createElement($8a7f0f5cf9a8ca34$var$_baseNew.default, Object.assign({
        name: "PagesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM4 4h6v1.5H4zm10.5 8.75V6H16v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75M4 7h4.5v1.5H4z" clip-rule="evenodd"/>`
    }, props));
$8a7f0f5cf9a8ca34$var$PagesIcon.displayName = 'PagesIcon';
var $8a7f0f5cf9a8ca34$var$_default = module.exports.default = $8a7f0f5cf9a8ca34$var$PagesIcon;

});

parcelRegister("lM0k7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f9c25083e911723e75d25e884618325>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fd9e54e9a7d9c520$var$_react = $fd9e54e9a7d9c520$var$_interopRequireDefault((parcelRequire("42omo")));

var $fd9e54e9a7d9c520$var$_baseNew = $fd9e54e9a7d9c520$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $fd9e54e9a7d9c520$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known usages: 'Design task' work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fd9e54e9a7d9c520$var$PenIcon = (props)=>/*#__PURE__*/ $fd9e54e9a7d9c520$var$_react.default.createElement($fd9e54e9a7d9c520$var$_baseNew.default, Object.assign({
        name: "PenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.72.72a.75.75 0 0 1 .73-.194l9.167 2.522a2 2 0 0 1 1.461 1.739l.294 3.083a2 2 0 0 1 2.042.483L15.78 9.72a.75.75 0 0 1 0 1.06l-5 5a.75.75 0 0 1-1.06 0l-1.366-1.366a2 2 0 0 1-.484-2.042l-3.083-.294a2 2 0 0 1-1.74-1.46L.528 1.448A.75.75 0 0 1 .72.72m12.634 8.694a.5.5 0 0 0-.707 0l-3.233 3.232a.5.5 0 0 0 0 .707l.836.836 3.94-3.94zM6.636 5.575a1.624 1.624 0 0 1 2.114 1.55 1.625 1.625 0 1 1-3.175-.49l-2.85-2.85 1.77 6.435a.5.5 0 0 0 .435.365l4.04.384 1.999-2-.384-4.04a.5.5 0 0 0-.365-.435l-6.435-1.77z" clip-rule="evenodd"/>`
    }, props));
$fd9e54e9a7d9c520$var$PenIcon.displayName = 'PenIcon';
var $fd9e54e9a7d9c520$var$_default = module.exports.default = $fd9e54e9a7d9c520$var$PenIcon;

});

parcelRegister("iBY5n", function(module, exports) {

var $7Kzu1 = parcelRequire("7Kzu1");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/teams/team/manifest.ts
var $d8ca4a7c870a2bf4$var$teamsTeamAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $7Kzu1.TeamsTeamAriResourceOwner),
    resourceType: (0, $7Kzu1.TeamsTeamAriResourceType),
    resourceIdSlug: "{teamId}",
    resourceIdSegmentFormats: {
        teamId: /[a-zA-Z0-9.\-_~]+/
    }
};
// src/teams/team/index.ts
var $d8ca4a7c870a2bf4$export$e87aab29b355b2fe = class _TeamsTeamAri extends (0, $3NXcb.RegisteredAri) {
    get teamId() {
        return this._teamId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $d8ca4a7c870a2bf4$var$teamsTeamAriStaticOpts.qualifier,
            platformQualifier: $d8ca4a7c870a2bf4$var$teamsTeamAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $d8ca4a7c870a2bf4$var$teamsTeamAriStaticOpts.resourceOwner,
            resourceType: $d8ca4a7c870a2bf4$var$teamsTeamAriStaticOpts.resourceType,
            resourceId: `${opts.teamId}`,
            resourceIdSegmentValues: {
                teamId: opts.teamId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $d8ca4a7c870a2bf4$var$teamsTeamAriStaticOpts);
        return new _TeamsTeamAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $d8ca4a7c870a2bf4$var$teamsTeamAriStaticOpts);
        return new _TeamsTeamAri(opts);
    }
    getVariables() {
        return {
            teamId: this.teamId
        };
    }
    constructor(opts){
        super(opts), this._teamId = opts.resourceIdSegmentValues.teamId;
    }
};
module.exports["TeamsTeamAri"] = $d8ca4a7c870a2bf4$export$e87aab29b355b2fe;

});

parcelRegister("7Kzu1", function(module, exports) {
// src/teams/team/types.ts
var $5a485a86bd8a4d02$export$bea3076d6b75920c = "teams", $5a485a86bd8a4d02$export$439b0a7d78926555 = "team";
module.exports["TeamsTeamAriResourceOwner"] = $5a485a86bd8a4d02$export$bea3076d6b75920c;
module.exports["TeamsTeamAriResourceType"] = $5a485a86bd8a4d02$export$439b0a7d78926555;

});

parcelRegister("5mJ0F", function(module, exports) {
const $5480085a89e48644$var$MS_PER_SECOND = 1e3;
const $5480085a89e48644$var$SECS_PER_MIN = 60;
const $5480085a89e48644$var$SECS_PER_HOUR = $5480085a89e48644$var$SECS_PER_MIN * 60;
const $5480085a89e48644$var$SECS_PER_DAY = $5480085a89e48644$var$SECS_PER_HOUR * 24;
const $5480085a89e48644$var$SECS_PER_WEEK = $5480085a89e48644$var$SECS_PER_DAY * 7;
function $5480085a89e48644$export$b8f7189986dd5395(from, to = Date.now(), thresholds = {}) {
    const resolvedThresholds = {
        ...$5480085a89e48644$export$f4fd60e41371f80d,
        ...thresholds || {}
    };
    const secs = (+from - +to) / $5480085a89e48644$var$MS_PER_SECOND;
    if (Math.abs(secs) < resolvedThresholds.second) return {
        value: Math.round(secs),
        unit: 'second'
    };
    const mins = secs / $5480085a89e48644$var$SECS_PER_MIN;
    if (Math.abs(mins) < resolvedThresholds.minute) return {
        value: Math.round(mins),
        unit: 'minute'
    };
    const hours = secs / $5480085a89e48644$var$SECS_PER_HOUR;
    if (Math.abs(hours) < resolvedThresholds.hour) return {
        value: Math.round(hours),
        unit: 'hour'
    };
    const days = secs / $5480085a89e48644$var$SECS_PER_DAY;
    if (Math.abs(days) < resolvedThresholds.day) return {
        value: Math.round(days),
        unit: 'day'
    };
    const weeks = secs / $5480085a89e48644$var$SECS_PER_WEEK;
    return {
        value: Math.round(weeks),
        unit: 'week'
    };
}
const $5480085a89e48644$export$f4fd60e41371f80d = {
    second: 45,
    minute: 45,
    hour: 22,
    day: 5
};
module.exports["selectUnit"] = $5480085a89e48644$export$b8f7189986dd5395;

});

parcelRegister("Lyrmh", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $4LDfN = parcelRequire("4LDfN");


var $9tLdO = parcelRequire("9tLdO");

const $d58b85df7ca81b3f$export$613b94bf89cb511d = /*#__PURE__*/ (0, $42omo.createContext)({
    eventTypeMessages: (0, $9tLdO.LOCAL_EVENT_TYPE_MESSAGES)
});
function $d58b85df7ca81b3f$export$63b523c1d6b0c2f4({ children: children, locale: locale }) {
    const artifact = (0, $4LDfN.useRecentWorkArtifact)(locale);
    const providerValue = (0, $42omo.useMemo)(()=>({
            eventTypeMessages: (0, $9tLdO.LOCAL_EVENT_TYPE_MESSAGES),
            eventTypeMessagesTranslated: (0, $9tLdO.translatedStringsToMessageDescriptors)(artifact?.localization.eventTypes)
        }), [
        artifact
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($d58b85df7ca81b3f$export$613b94bf89cb511d.Provider, {
        value: providerValue,
        children: children
    });
}
function $d58b85df7ca81b3f$export$779009172d654787({ children: children }) {
    const { locale: locale } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)($d58b85df7ca81b3f$export$63b523c1d6b0c2f4, {
        locale: locale,
        children: children
    });
}
const $d58b85df7ca81b3f$export$ddd7b41a8fb59ad6 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($d58b85df7ca81b3f$export$613b94bf89cb511d);
function $d58b85df7ca81b3f$export$7948ea9187af6c9(eventType, options = {}) {
    const { eventTypeMessages: eventTypeMessages, eventTypeMessagesTranslated: translatedMessagesMap } = $d58b85df7ca81b3f$export$ddd7b41a8fb59ad6();
    return (0, $9tLdO.messageForEventType)(eventType, translatedMessagesMap || eventTypeMessages, options);
}
module.exports["WrappedRecentWorkEventTypeMessagesProvider"] = $d58b85df7ca81b3f$export$779009172d654787;
module.exports["useEventTypeMessage"] = $d58b85df7ca81b3f$export$7948ea9187af6c9;

});

parcelRegister("4LDfN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jYxBx = parcelRequire("jYxBx");


var $h4NLj = parcelRequire("h4NLj");

const $aaf39d5f8aefd1be$export$9c10d80bcd5b4264 = (locale)=>{
    const dimensions = (0, $42omo.useMemo)(()=>({
            ...(0, $h4NLj.FD_CLIENT_FETCH_PROPS).dimensions,
            locale: locale
        }), [
        locale
    ]);
    return (0, $jYxBx.useFlightDeckArtifact)((0, $h4NLj.FD_CLIENT_FETCH_PROPS).name, dimensions);
};
module.exports["useRecentWorkArtifact"] = $aaf39d5f8aefd1be$export$9c10d80bcd5b4264;

});

parcelRegister("9tLdO", function(module, exports) {

var $lJ9dF = parcelRequire("lJ9dF");


var $3mipJ = parcelRequire("3mipJ");

const $58808de4d525e3b4$export$be5e766167e613a9 = {
    commented: (0, $3mipJ.commentedEventTypeMessages),
    created: (0, $3mipJ.createdEventTypeMessages),
    edited: (0, $3mipJ.editedEventTypeMessages),
    published: (0, $3mipJ.publishedEventTypeMessages),
    updated: (0, $3mipJ.updatedEventTypeMessages),
    viewed: (0, $3mipJ.viewedEventTypeMessages),
    'sl-viewed': (0, $3mipJ.viewedEventTypeMessages),
    clicked: (0, $3mipJ.viewedEventTypeMessages)
};
function $58808de4d525e3b4$export$d3dc5798f9d19382(eventType, eventTypeMessages = $58808de4d525e3b4$export$be5e766167e613a9, options = {}) {
    const { isAbsolute: isAbsolute = true, isMyActivityData: isMyActivityData = true, isSimple: isSimple = false } = options;
    const eventTypeMessage = eventTypeMessages.hasOwnProperty(eventType) ? eventTypeMessages[eventType] : eventType === (0, $lJ9dF.VIEWED_EVENT).SMARTLINK_VIEWED ? eventTypeMessages[(0, $lJ9dF.VIEWED_EVENT).VIEWED] : (0, $3mipJ.defaultEventTypeMessages); // defaults to "... worked on ..."
    if (isSimple) {
        if (isMyActivityData) return eventTypeMessage.standalone;
        else return eventTypeMessage.multiStandalone;
    } else {
        if (isMyActivityData && isAbsolute) return eventTypeMessage.absolute;
        else if (isMyActivityData && !isAbsolute) return eventTypeMessage.relative;
        else if (!isMyActivityData && isAbsolute) return eventTypeMessage.multiAbsolute;
        else return eventTypeMessage.multiRelative;
    }
}
function $58808de4d525e3b4$export$ba0d5bdc49112491(translatedStrings) {
    if (!translatedStrings) return undefined;
    return Object.entries(translatedStrings).reduce((acc, [eventType, translatedMessages])=>{
        acc[eventType] = Object.entries(translatedMessages).reduce((eventTypeMessages, [translatedKey, translatedEntry])=>{
            eventTypeMessages[translatedKey] = {
                defaultMessage: translatedEntry,
                id: `recentWork.eventTypeMessage.translated.${translatedKey}.no-translate`
            };
            return eventTypeMessages;
        }, {});
        return acc;
    }, {});
}
module.exports["LOCAL_EVENT_TYPE_MESSAGES"] = $58808de4d525e3b4$export$be5e766167e613a9;
module.exports["messageForEventType"] = $58808de4d525e3b4$export$d3dc5798f9d19382;
module.exports["translatedStringsToMessageDescriptors"] = $58808de4d525e3b4$export$ba0d5bdc49112491;

});

parcelRegister("3mipJ", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $6b5203fd2ce8ee1f$export$29c048cc57fefaf8 = (0, $cgtv4.defineMessages)({
    absolute: {
        defaultMessage: "You commented on {absoluteTime}",
        id: "recentWork.eventTypeMessage.absolute.commented"
    },
    relative: {
        defaultMessage: "You commented {relativeTime}",
        id: "recentWork.eventTypeMessage.relative.commented"
    },
    standalone: {
        defaultMessage: "You commented",
        id: "recentWork.eventTypeMessage.commented"
    },
    multiAbsolute: {
        defaultMessage: "Commented on {absoluteTime}",
        id: "recentWork.eventTypeMessage.multi.absolute.commented"
    },
    multiRelative: {
        defaultMessage: "Commented {relativeTime}",
        id: "recentWork.eventTypeMessage.multi.relative.commented"
    },
    multiStandalone: {
        defaultMessage: "Commented",
        id: "recentWork.eventTypeMessage.multi.commented"
    }
});
const $6b5203fd2ce8ee1f$export$99e7e287b0f1db7 = (0, $cgtv4.defineMessages)({
    absolute: {
        defaultMessage: "You created on {absoluteTime}",
        id: "recentWork.eventTypeMessage.absolute.created"
    },
    relative: {
        defaultMessage: "You created {relativeTime}",
        id: "recentWork.eventTypeMessage.relative.created"
    },
    standalone: {
        defaultMessage: "You created",
        id: "recentWork.eventTypeMessage.created"
    },
    multiAbsolute: {
        defaultMessage: "Created on {absoluteTime}",
        id: "recentWork.eventTypeMessage.multi.absolute.created"
    },
    multiRelative: {
        defaultMessage: "Created {relativeTime}",
        id: "recentWork.eventTypeMessage.multi.relative.created"
    },
    multiStandalone: {
        defaultMessage: "Created",
        id: "recentWork.eventTypeMessage.multi.created"
    }
});
const $6b5203fd2ce8ee1f$export$4d0c20aef6601783 = (0, $cgtv4.defineMessages)({
    absolute: {
        defaultMessage: "You edited on {absoluteTime}",
        id: "recentWork.eventTypeMessage.absolute.edited"
    },
    relative: {
        defaultMessage: "You edited {relativeTime}",
        id: "recentWork.eventTypeMessage.relative.edited"
    },
    standalone: {
        defaultMessage: "You edited",
        id: "recentWork.eventTypeMessage.edited"
    },
    multiAbsolute: {
        defaultMessage: "Edited on {absoluteTime}",
        id: "recentWork.eventTypeMessage.multi.absolute.edited"
    },
    multiRelative: {
        defaultMessage: "Edited {relativeTime}",
        id: "recentWork.eventTypeMessage.multi.relative.edited"
    },
    multiStandalone: {
        defaultMessage: "Edited",
        id: "recentWork.eventTypeMessage.multi.edited"
    }
});
const $6b5203fd2ce8ee1f$export$2cd1ec4decb563bb = (0, $cgtv4.defineMessages)({
    absolute: {
        defaultMessage: "You published on {absoluteTime}",
        id: "recentWork.eventTypeMessage.absolute.published"
    },
    relative: {
        defaultMessage: "You published {relativeTime}",
        id: "recentWork.eventTypeMessage.relative.published"
    },
    standalone: {
        defaultMessage: "You published",
        id: "recentWork.eventTypeMessage.published"
    },
    multiAbsolute: {
        defaultMessage: "Published on {absoluteTime}",
        id: "recentWork.eventTypeMessage.multi.absolute.published"
    },
    multiRelative: {
        defaultMessage: "Published {relativeTime}",
        id: "recentWork.eventTypeMessage.multi.relative.published"
    },
    multiStandalone: {
        defaultMessage: "Published",
        id: "recentWork.eventTypeMessage.multi.published"
    }
});
const $6b5203fd2ce8ee1f$export$3b389551d0b5bf03 = (0, $cgtv4.defineMessages)({
    absolute: {
        defaultMessage: "You updated on {absoluteTime}",
        id: "recentWork.eventTypeMessage.absolute.updated"
    },
    relative: {
        defaultMessage: "You updated {relativeTime}",
        id: "recentWork.eventTypeMessage.relative.updated"
    },
    standalone: {
        defaultMessage: "You updated",
        id: "recentWork.eventTypeMessage.updated"
    },
    multiAbsolute: {
        defaultMessage: "Updated on {absoluteTime}",
        id: "recentWork.eventTypeMessage.multi.absolute.updated"
    },
    multiRelative: {
        defaultMessage: "Updated {relativeTime}",
        id: "recentWork.eventTypeMessage.multi.relative.updated"
    },
    multiStandalone: {
        defaultMessage: "Updated",
        id: "recentWork.eventTypeMessage.multi.updated"
    }
});
const $6b5203fd2ce8ee1f$export$2d3fe6e7f84a868e = (0, $cgtv4.defineMessages)({
    absolute: {
        defaultMessage: "You viewed on {absoluteTime}",
        id: "recentWork.eventTypeMessage.absolute.viewed"
    },
    relative: {
        defaultMessage: "You viewed {relativeTime}",
        id: "recentWork.eventTypeMessage.relative.viewed"
    },
    standalone: {
        defaultMessage: "You viewed",
        id: "recentWork.eventTypeMessage.viewed"
    },
    multiAbsolute: {
        defaultMessage: "Viewed on {absoluteTime}",
        id: "recentWork.eventTypeMessage.multi.absolute.viewed"
    },
    multiRelative: {
        defaultMessage: "Viewed {relativeTime}",
        id: "recentWork.eventTypeMessage.multi.relative.viewed"
    },
    multiStandalone: {
        defaultMessage: "Viewed",
        id: "recentWork.eventTypeMessage.multi.viewed"
    }
});
const $6b5203fd2ce8ee1f$export$9be55d016b768442 = (0, $cgtv4.defineMessages)({
    absolute: {
        defaultMessage: "You worked on {absoluteTime}",
        id: "recentWork.eventTypeMessage.absolute.workedOn"
    },
    relative: {
        defaultMessage: "You worked on {relativeTime}",
        id: "recentWork.eventTypeMessage.absolute.workedOn"
    },
    standalone: {
        defaultMessage: "You worked on",
        id: "recentWork.eventTypeMessage.workedOn"
    },
    multiAbsolute: {
        defaultMessage: "Worked on {absoluteTime}",
        id: "recentWork.eventTypeMessage.multi.absolute.workedOn"
    },
    multiRelative: {
        defaultMessage: "Worked on {relativeTime}",
        id: "recentWork.eventTypeMessage.multi.dateTime.workedOn"
    },
    multiStandalone: {
        defaultMessage: "Worked on",
        id: "recentWork.eventTypeMessage.multi.workedOn"
    }
});
module.exports["commentedEventTypeMessages"] = $6b5203fd2ce8ee1f$export$29c048cc57fefaf8;
module.exports["createdEventTypeMessages"] = $6b5203fd2ce8ee1f$export$99e7e287b0f1db7;
module.exports["editedEventTypeMessages"] = $6b5203fd2ce8ee1f$export$4d0c20aef6601783;
module.exports["publishedEventTypeMessages"] = $6b5203fd2ce8ee1f$export$2cd1ec4decb563bb;
module.exports["updatedEventTypeMessages"] = $6b5203fd2ce8ee1f$export$3b389551d0b5bf03;
module.exports["viewedEventTypeMessages"] = $6b5203fd2ce8ee1f$export$2d3fe6e7f84a868e;
module.exports["defaultEventTypeMessages"] = $6b5203fd2ce8ee1f$export$9be55d016b768442;

});

parcelRegister("hbYDZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3aa391a3d57e28f300b24cee0bba3c43>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c842815f2fb3ef87$var$_react = $c842815f2fb3ef87$var$_interopRequireDefault((parcelRequire("42omo")));

var $c842815f2fb3ef87$var$_baseNew = $c842815f2fb3ef87$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c842815f2fb3ef87$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Spaces".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for use for Jira Projects for now. This will replace the Jira rocket. 

More context: Later, it will eventually replace the Confluence Spaces icon later when Jira Projects -> Jira Spaces. This is a planned phased rollout.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c842815f2fb3ef87$var$SpacesIcon = (props)=>/*#__PURE__*/ $c842815f2fb3ef87$var$_react.default.createElement($c842815f2fb3ef87$var$_baseNew.default, Object.assign({
        name: "SpacesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.809 9.496a5.98 5.98 0 0 1-2.809 3.7 5.98 5.98 0 0 1-4.608.583 29.4 29.4 0 0 0 3.858-1.881 29.4 29.4 0 0 0 3.559-2.402"/><path fill="currentcolor" fill-rule="evenodd" d="M5 2.804a6 6 0 0 1 6.515.333c.859-.264 1.65-.425 2.308-.447.377-.013.751.017 1.083.126.338.11.678.32.888.684.354.613.152 1.297-.107 1.8-.276.538-.736 1.113-1.306 1.688q-.197.196-.413.397a20 20 0 0 1-1.517 1.263 29 29 0 0 1-2.951 1.95 29 29 0 0 1-3.165 1.58c-.65.275-1.272.506-1.85.683h-.003q-.28.087-.548.159c-.783.206-1.511.317-2.116.288-.505-.025-1.114-.162-1.49-.63l-.052-.069-.07-.109-.07-.139a1.6 1.6 0 0 1-.078-.972c.071-.342.231-.681.431-1.001.35-.559.883-1.164 1.541-1.776A6 6 0 0 1 5 2.804m-2.541 7.499c-.302.324-.536.62-.698.879-.147.235-.213.407-.236.515l-.004.046c.048.022.155.056.37.067.329.016.78-.036 1.343-.165a6 6 0 0 1-.775-1.342m8.429-5.756A4.502 4.502 0 0 0 3.52 8.435l.045.34c.089.504.265 1.004.538 1.475.198.344.435.652.702.921 1.181-.43 2.542-1.062 3.945-1.872s2.63-1.672 3.593-2.48a4.5 4.5 0 0 0-1.31-2.146zm2.987-.36a6 6 0 0 0-1.111.166q.233.306.432.647.196.341.342.695c.394-.423.665-.788.816-1.08.098-.192.121-.303.127-.355q-.016-.009-.041-.019a1.7 1.7 0 0 0-.565-.053" clip-rule="evenodd"/>`
    }, props));
$c842815f2fb3ef87$var$SpacesIcon.displayName = 'SpacesIcon';
var $c842815f2fb3ef87$var$_default = module.exports.default = $c842815f2fb3ef87$var$SpacesIcon;

});

parcelRegister("5tnQQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $a932c722f95653b7$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c2e42a5240f58c746dfd1694482fb8c>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8DN9t = parcelRequire("8DN9t");


var $kXb3C = parcelRequire("kXb3C");

function $a932c722f95653b7$export$2e2bcd8739ae039({ label: label = 'Calendar', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});

parcelRegister("6atSO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $73b395c32a9c60f5$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2f9952b2c673a9067b6b4a0ab78aa7db>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $ci7Ox = parcelRequire("ci7Ox");


var $kXb3C = parcelRequire("kXb3C");

function $73b395c32a9c60f5$export$2e2bcd8739ae039({ label: label = 'Question', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
}

});

parcelRegister("f6IRL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5e4ce3568a939e12f8a5f474d8d813cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $affa380c4e32b374$var$_react = $affa380c4e32b374$var$_interopRequireDefault((parcelRequire("42omo")));

var $affa380c4e32b374$var$_baseNew = $affa380c4e32b374$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $affa380c4e32b374$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Roadmap".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $affa380c4e32b374$var$RoadmapIcon = (props)=>/*#__PURE__*/ $affa380c4e32b374$var$_react.default.createElement($affa380c4e32b374$var$_baseNew.default, Object.assign({
        name: "RoadmapIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM3 11a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$affa380c4e32b374$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $affa380c4e32b374$var$_default = module.exports.default = $affa380c4e32b374$var$RoadmapIcon;

});

parcelRegister("gHANe", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $d5213b14145490b2$export$4dfd297558414f12 = (0, $eSUdr.default)`query UserContextQuery{user:confluence_atlassianUser(current:true){id displayName emails{value isPrimary}}}`;
module.exports["UserContextQuery"] = $d5213b14145490b2$export$4dfd297558414f12;

});

parcelRegister("6CCa2", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");


var $dh538 = parcelRequire("dh538");


var $dS0qJ = parcelRequire("dS0qJ");

var $7f54826d8f69d9e8$export$6891b88a23696d = /*#__PURE__*/ function(GhostTextExperimentCohort) {
    GhostTextExperimentCohort["CONTROL"] = "control";
    GhostTextExperimentCohort["THREE_P"] = "3p";
    return GhostTextExperimentCohort;
}({});
const $7f54826d8f69d9e8$export$73fd7fc6fed7f9d9 = 3;
const $7f54826d8f69d9e8$export$4d19f25c7b83dd4a = (0, $gLLcz.z).object({
    /** The placeholder text to display */ text: (0, $gLLcz.z).string(),
    /** Number of times this text has been shown (0-2, resets after 3) */ occurrence: (0, $gLLcz.z).number().optional().default(0)
});
const $7f54826d8f69d9e8$export$9bcc9fe305679f00 = (0, $gLLcz.z).object({
    /** Unique key identifying the current ghost text set */ id: (0, $gLLcz.z).string(),
    /** Locale of the ghost text */ locale: (0, $gLLcz.z).string(),
    /** The placeholder text to display */ text: (0, $gLLcz.z).string(),
    /** Number of times this text has been shown (0-2, resets after 3) */ occurrence: (0, $gLLcz.z).number().optional().default(0)
});
const $7f54826d8f69d9e8$export$b18cd5530389e27a = (data)=>{
    try {
        const result = $7f54826d8f69d9e8$export$9bcc9fe305679f00.safeParse(data);
        return result.success;
    } catch  {
        return false;
    }
};
const $7f54826d8f69d9e8$export$bd8829925eef3cc2 = (customPlaceholder, locale)=>{
    if (!(0, $dh538.fg)('quickfind-ghosttext')) return undefined;
    if (!customPlaceholder) return undefined;
    if (!(0, $dS0qJ.isEnglishLocale)(locale) && !(0, $dh538.fg)('confluence_quick_find_ghost_text_i18n')) return undefined;
    if ((0, $dh538.fg)('confluence_quick_find_ghost_text_i18n')) try {
        const result = $7f54826d8f69d9e8$export$9bcc9fe305679f00.safeParse(JSON.parse(customPlaceholder));
        if (result.success) return result.data;
        return undefined;
    } catch  {
        return undefined;
    }
    try {
        const result = $7f54826d8f69d9e8$export$4d19f25c7b83dd4a.safeParse(JSON.parse(customPlaceholder));
        if (result.success) return result.data;
        return undefined;
    } catch  {
        return undefined;
    }
};
module.exports["GhostTextExperimentCohort"] = $7f54826d8f69d9e8$export$6891b88a23696d;
module.exports["ROTATION_THRESHOLD"] = $7f54826d8f69d9e8$export$73fd7fc6fed7f9d9;
module.exports["isGhostTextDataV2"] = $7f54826d8f69d9e8$export$b18cd5530389e27a;
module.exports["parseGhostTextData"] = $7f54826d8f69d9e8$export$bd8829925eef3cc2;

});

parcelRegister("bHjhd", function(module, exports) {

var $kiOFr = parcelRequire("kiOFr");

const $89598f5ca555d4d3$export$7fa7ed95afa3407a = (cloudId, gatewayBaseUrl)=>{
    const { data: data, loading: loading, error: error } = (0, $kiOFr.useAvailableSites)({
        gatewayBaseUrl: gatewayBaseUrl
    });
    const filterData = data.filter((site)=>site.cloudId === cloudId);
    if (filterData.length > 0) return {
        data: filterData[0].url,
        loading: loading,
        error: error
    };
    return {
        data: undefined,
        loading: loading,
        error: error
    };
};
module.exports["useCloudIdToUrl"] = $89598f5ca555d4d3$export$7fa7ed95afa3407a;

});

parcelRegister("9sNt3", function(module, exports) {
/* bookmark-suggestion-card.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $ccHMk = parcelRequire("ccHMk");


var $gj7hi = parcelRequire("gj7hi");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $2Rith = parcelRequire("2Rith");


var $jLyYG = parcelRequire("jLyYG");


var $cVtio = parcelRequire("cVtio");


var $8s0lk = parcelRequire("8s0lk");


var $14qs9 = parcelRequire("14qs9");


var $f7lNm = parcelRequire("f7lNm");


var $01aV7 = parcelRequire("01aV7");


var $4dSc8 = parcelRequire("4dSc8");


var $8d7Su = parcelRequire("8d7Su");

var $be6b1538bae8f2d8$exports = {};
$be6b1538bae8f2d8$exports = new URL("bookmark-suggestion-search-icon.8ee7ee2d.svg", import.meta.url).toString();



var $3NkqS = parcelRequire("3NkqS");

const $fbd80e6e5492e345$var$styles = {
    bookmarkSuggestionContainer: "_2rko12b0 _zulpu2gc _1rjcv47k _18zrv47k _bfhk1j9a _16qs1nax _1e0c1txw",
    bookmarkSuggestionIconContainer: "_18zrutpp _1e0c1txw _1bah1h6o _4cvr1h6o",
    bookmarkSuggestionContentContainer: "_1bsb1osq"
};
const $fbd80e6e5492e345$var$BookmarkSuggestionCardComponent = /*#__PURE__*/ (0, $42omo.memo)(({ suggestedTerm: suggestedTerm, cloudId: cloudId, orgId: orgId, hasAdminhubAccess: hasAdminhubAccess, workspaceId: workspaceId, product: product, searchSessionId: searchSessionId, userDetails: userDetails, source: source })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const [showAddModal, setShowAddModal] = (0, $42omo.useState)(false);
    const [isDismissed, setIsDismissed] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsEvent((0, $8d7Su.onPopularSearchQuerySuggestionShown)());
    }, [
        fireAnalyticsEvent
    ]);
    const feedbackOptions = (0, $jLyYG.useSmartAnswerCardFeedbackOptions)();
    const feedbackAttributes = {
        searchSessionId: searchSessionId,
        source: source,
        queryHash: (0, $01aV7.sha256Hash)(suggestedTerm),
        cloudId: cloudId
    };
    const onBookmarkCreationSuccess = ()=>{
        setIsDismissed(true);
    };
    const onAddBookmarkClick = ()=>{
        setShowAddModal(true);
        fireAnalyticsEvent((0, $8d7Su.onPopularSearchQueryButtonClicked)());
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $14qs9.ErrorBoundary), {
        children: [
            isDismissed ? null : /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                xcss: $fbd80e6e5492e345$var$styles.bookmarkSuggestionContainer,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $fbd80e6e5492e345$var$styles.bookmarkSuggestionIconContainer,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($be6b1538bae8f2d8$exports))),
                            width: "88",
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $fbd80e6e5492e345$var$styles.bookmarkSuggestionContentContainer,
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                            direction: "column",
                            gap: "space.075",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    size: "large",
                                    weight: "bold",
                                    testId: "bookmark-suggestion-main-message",
                                    children: formatMessage((0, $3NkqS.messages).pinSuggestionMainMessage, {
                                        suggestedTerm: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                            size: "large",
                                            weight: "bold",
                                            color: "color.text.brand",
                                            children: suggestedTerm
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                                    space: "space.250",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                            children: formatMessage((0, $3NkqS.messages).pinSuggestionSubMessage)
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                            alignBlock: "center",
                                            spread: "space-between",
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                                    appearance: "default",
                                                    onClick: onAddBookmarkClick,
                                                    children: formatMessage((0, $3NkqS.messages).add_pin_button_label)
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $8s0lk.AIFeedbackV2), {
                                                    entrypointId: feedbackOptions.entrypointId,
                                                    userDetails: userDetails,
                                                    attributes: feedbackAttributes,
                                                    onLikeButtonClickHandler: feedbackOptions.onLikeButtonClickHandler,
                                                    onDislikeButtonClickHandler: feedbackOptions.onDislikeButtonClickHandler,
                                                    featureTitle: formatMessage((0, $3NkqS.messages).userCreatedBookmarksFeatureTitle)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            showAddModal && /*#__PURE__*/ (0, $l998X.jsx)((0, $4dSc8.AddPinModal), {
                query: suggestedTerm,
                handleClose: ()=>setShowAddModal(false),
                orgId: orgId,
                cloudId: cloudId,
                hasAdminhubAccess: hasAdminhubAccess,
                workspaceId: workspaceId,
                product: product,
                source: "popularSearchQuery",
                onSuccessCallback: onBookmarkCreationSuccess
            })
        ]
    });
});
const $fbd80e6e5492e345$export$a763bcfb4adf736a = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2Rith.AIEventsInstrumentationProvider), {
        config: {
            product: props.product,
            subproduct: 'search-page',
            aiFeatureName: 'smartAnswers',
            aiExperienceName: (0, $f7lNm.AiExperienceName).POPULAR_SEARCH_QUERY_CARD,
            proactiveGeneratedAI: 0,
            userGeneratedAI: 1,
            isAIFeature: 0,
            source: props.source,
            channel: (0, $f7lNm.DEFAULT_GAS_CHANNEL)
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)($fbd80e6e5492e345$var$BookmarkSuggestionCardComponent, {
            ...props
        })
    });
module.exports["BookmarkSuggestionCard"] = $fbd80e6e5492e345$export$a763bcfb4adf736a;

});

parcelRegister("3SgTW", function(module, exports) {

!function(t, e) {
    module.exports = e((parcelRequire("42omo")));
}("undefined" != typeof self ? self : module.exports, function(t) {
    return function(t) {
        var e = {};
        function n(r) {
            if (e[r]) return e[r].exports;
            var i = e[r] = {
                i: r,
                l: !1,
                exports: {}
            };
            return t[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
        }
        return n.m = t, n.c = e, n.d = function(t, e, r) {
            n.o(t, e) || Object.defineProperty(t, e, {
                enumerable: !0,
                get: r
            });
        }, n.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }, n.t = function(t, e) {
            if (1 & e && (t = n(t)), 8 & e) return t;
            if (4 & e && "object" == typeof t && t && t.__esModule) return t;
            var r = Object.create(null);
            if (n.r(r), Object.defineProperty(r, "default", {
                enumerable: !0,
                value: t
            }), 2 & e && "string" != typeof t) for(var i in t)n.d(r, i, (function(e) {
                return t[e];
            }).bind(null, i));
            return r;
        }, n.n = function(t) {
            var e = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return n.d(e, "a", e), e;
        }, n.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }, n.p = "", n(n.s = 2);
    }([
        function(e, n) {
            e.exports = t;
        },
        function(t, e, n) {
            "use strict";
            var r = {
                linear: function(t, e, n, r) {
                    return (n - e) * t / r + e;
                },
                easeInQuad: function(t, e, n, r) {
                    return (n - e) * (t /= r) * t + e;
                },
                easeOutQuad: function(t, e, n, r) {
                    return -(n - e) * (t /= r) * (t - 2) + e;
                },
                easeInOutQuad: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r / 2) < 1 ? i / 2 * t * t + e : -i / 2 * (--t * (t - 2) - 1) + e;
                },
                easeInCubic: function(t, e, n, r) {
                    return (n - e) * (t /= r) * t * t + e;
                },
                easeOutCubic: function(t, e, n, r) {
                    return (n - e) * ((t = t / r - 1) * t * t + 1) + e;
                },
                easeInOutCubic: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r / 2) < 1 ? i / 2 * t * t * t + e : i / 2 * ((t -= 2) * t * t + 2) + e;
                },
                easeInQuart: function(t, e, n, r) {
                    return (n - e) * (t /= r) * t * t * t + e;
                },
                easeOutQuart: function(t, e, n, r) {
                    return -(n - e) * ((t = t / r - 1) * t * t * t - 1) + e;
                },
                easeInOutQuart: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r / 2) < 1 ? i / 2 * t * t * t * t + e : -i / 2 * ((t -= 2) * t * t * t - 2) + e;
                },
                easeInQuint: function(t, e, n, r) {
                    return (n - e) * (t /= r) * t * t * t * t + e;
                },
                easeOutQuint: function(t, e, n, r) {
                    return (n - e) * ((t = t / r - 1) * t * t * t * t + 1) + e;
                },
                easeInOutQuint: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r / 2) < 1 ? i / 2 * t * t * t * t * t + e : i / 2 * ((t -= 2) * t * t * t * t + 2) + e;
                },
                easeInSine: function(t, e, n, r) {
                    var i = n - e;
                    return -i * Math.cos(t / r * (Math.PI / 2)) + i + e;
                },
                easeOutSine: function(t, e, n, r) {
                    return (n - e) * Math.sin(t / r * (Math.PI / 2)) + e;
                },
                easeInOutSine: function(t, e, n, r) {
                    return -(n - e) / 2 * (Math.cos(Math.PI * t / r) - 1) + e;
                },
                easeInExpo: function(t, e, n, r) {
                    return 0 == t ? e : (n - e) * Math.pow(2, 10 * (t / r - 1)) + e;
                },
                easeOutExpo: function(t, e, n, r) {
                    var i = n - e;
                    return t == r ? e + i : i * (1 - Math.pow(2, -10 * t / r)) + e;
                },
                easeInOutExpo: function(t, e, n, r) {
                    var i = n - e;
                    return 0 === t ? e : t === r ? e + i : (t /= r / 2) < 1 ? i / 2 * Math.pow(2, 10 * (t - 1)) + e : i / 2 * (2 - Math.pow(2, -10 * --t)) + e;
                },
                easeInCirc: function(t, e, n, r) {
                    return -(n - e) * (Math.sqrt(1 - (t /= r) * t) - 1) + e;
                },
                easeOutCirc: function(t, e, n, r) {
                    return (n - e) * Math.sqrt(1 - (t = t / r - 1) * t) + e;
                },
                easeInOutCirc: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r / 2) < 1 ? -i / 2 * (Math.sqrt(1 - t * t) - 1) + e : i / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + e;
                },
                easeInElastic: function(t, e, n, r) {
                    var i, o, a, c = n - e;
                    return a = 1.70158, 0 === t ? e : 1 == (t /= r) ? e + c : (o = 0, o = .3 * r, (i = c) < Math.abs(c) ? (i = c, a = o / 4) : a = o / (2 * Math.PI) * Math.asin(c / i), -i * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * r - a) * (2 * Math.PI) / o) + e);
                },
                easeOutElastic: function(t, e, n, r) {
                    var i, o, a, c = n - e;
                    return a = 1.70158, 0 === t ? e : 1 == (t /= r) ? e + c : (o = 0, o = .3 * r, (i = c) < Math.abs(c) ? (i = c, a = o / 4) : a = o / (2 * Math.PI) * Math.asin(c / i), i * Math.pow(2, -10 * t) * Math.sin((t * r - a) * (2 * Math.PI) / o) + c + e);
                },
                easeInOutElastic: function(t, e, n, r) {
                    var i, o, a, c = n - e;
                    return a = 1.70158, 0 === t ? e : 2 == (t /= r / 2) ? e + c : (o = 0, o = r * (.3 * 1.5), (i = c) < Math.abs(c) ? (i = c, a = o / 4) : a = o / (2 * Math.PI) * Math.asin(c / i), t < 1 ? i * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * r - a) * (2 * Math.PI) / o) * -0.5 + e : i * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * r - a) * (2 * Math.PI) / o) * .5 + c + e);
                },
                easeInBack: function(t, e, n, r, i) {
                    return void 0 === i && (i = 1.70158), (n - e) * (t /= r) * t * ((i + 1) * t - i) + e;
                },
                easeOutBack: function(t, e, n, r, i) {
                    return void 0 === i && (i = 1.70158), (n - e) * ((t = t / r - 1) * t * ((i + 1) * t + i) + 1) + e;
                },
                easeInOutBack: function(t, e, n, r, i) {
                    var o = n - e;
                    return void 0 === i && (i = 1.70158), (t /= r / 2) < 1 ? o / 2 * (t * t * ((1 + (i *= 1.525)) * t - i)) + e : o / 2 * ((t -= 2) * t * ((1 + (i *= 1.525)) * t + i) + 2) + e;
                },
                easeInBounce: function(t, e, n, i) {
                    var o = n - e;
                    return o - r.easeOutBounce(i - t, 0, o, i) + e;
                },
                easeOutBounce: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r) < 1 / 2.75 ? i * (7.5625 * t * t) + e : t < 2 / 2.75 ? i * (7.5625 * (t -= 1.5 / 2.75) * t + .75) + e : t < 2.5 / 2.75 ? i * (7.5625 * (t -= 2.25 / 2.75) * t + .9375) + e : i * (7.5625 * (t -= 2.625 / 2.75) * t + .984375) + e;
                },
                easeInOutBounce: function(t, e, n, i) {
                    var o = n - e;
                    return t < i / 2 ? .5 * r.easeInBounce(2 * t, 0, o, i) + e : .5 * r.easeOutBounce(2 * t - i, 0, o, i) + .5 * o + e;
                }
            };
            t.exports = r;
        },
        function(t, e, n) {
            t.exports = n(3);
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "ReactConfetti", function() {
                return Q;
            });
            var r, i, o = n(0), a = n.n(o), c = n(1), s = n.n(c);
            function u(t, e) {
                return t + Math.random() * (e - t);
            }
            function f(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function h(t, e, n) {
                return e in t ? Object.defineProperty(t, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = n, t;
            }
            !function(t) {
                t[t.Circle = 0] = "Circle", t[t.Square = 1] = "Square", t[t.Strip = 2] = "Strip";
            }(r || (r = {})), function(t) {
                t[t.Positive = 1] = "Positive", t[t.Negative = -1] = "Negative";
            }(i || (i = {}));
            var l = function() {
                function t(e, n, r, o) {
                    !function(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, t), h(this, "context", void 0), h(this, "radius", void 0), h(this, "x", void 0), h(this, "y", void 0), h(this, "w", void 0), h(this, "h", void 0), h(this, "vx", void 0), h(this, "vy", void 0), h(this, "shape", void 0), h(this, "angle", void 0), h(this, "angularSpin", void 0), h(this, "color", void 0), h(this, "rotateY", void 0), h(this, "rotationDirection", void 0), h(this, "getOptions", void 0), this.getOptions = n;
                    var a, c, s = this.getOptions(), f = s.colors, l = s.initialVelocityX, p = s.initialVelocityY;
                    this.context = e, this.x = r, this.y = o, this.w = u(5, 20), this.h = u(5, 20), this.radius = u(5, 10), this.vx = "number" == typeof l ? u(-l, l) : u(l.min, l.max), this.vy = "number" == typeof p ? u(-p, 0) : u(p.min, p.max), this.shape = (a = 0, c = 2, Math.floor(a + Math.random() * (c - a + 1))), this.angle = u(0, 360) * Math.PI / 180, this.angularSpin = u(-0.2, .2), this.color = f[Math.floor(Math.random() * f.length)], this.rotateY = u(0, 1), this.rotationDirection = u(0, 1) ? i.Positive : i.Negative;
                }
                var e, n, o;
                return e = t, n = [
                    {
                        key: "update",
                        value: function() {
                            var t = this.getOptions(), e = t.gravity, n = t.wind, o = t.friction, a = t.opacity, c = t.drawShape;
                            this.x += this.vx, this.y += this.vy, this.vy += e, this.vx += n, this.vx *= o, this.vy *= o, this.rotateY >= 1 && this.rotationDirection === i.Positive ? this.rotationDirection = i.Negative : this.rotateY <= -1 && this.rotationDirection === i.Negative && (this.rotationDirection = i.Positive);
                            var s = .1 * this.rotationDirection;
                            if (this.rotateY += s, this.angle += this.angularSpin, this.context.save(), this.context.translate(this.x, this.y), this.context.rotate(this.angle), this.context.scale(1, this.rotateY), this.context.rotate(this.angle), this.context.beginPath(), this.context.fillStyle = this.color, this.context.strokeStyle = this.color, this.context.globalAlpha = a, this.context.lineCap = "round", this.context.lineWidth = 2, c && "function" == typeof c) c.call(this, this.context);
                            else switch(this.shape){
                                case r.Circle:
                                    this.context.beginPath(), this.context.arc(0, 0, this.radius, 0, 2 * Math.PI), this.context.fill();
                                    break;
                                case r.Square:
                                    this.context.fillRect(-this.w / 2, -this.h / 2, this.w, this.h);
                                    break;
                                case r.Strip:
                                    this.context.fillRect(-this.w / 6, -this.h / 2, this.w / 3, this.h);
                            }
                            this.context.closePath(), this.context.restore();
                        }
                    }
                ], f(e.prototype, n), o && f(e, o), t;
            }();
            function p(t, e, n) {
                return e in t ? Object.defineProperty(t, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = n, t;
            }
            var v = function t(e, n) {
                var r = this;
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), p(this, "canvas", void 0), p(this, "context", void 0), p(this, "getOptions", void 0), p(this, "x", 0), p(this, "y", 0), p(this, "w", 0), p(this, "h", 0), p(this, "lastNumberOfPieces", 0), p(this, "tweenInitTime", Date.now()), p(this, "particles", []), p(this, "particlesGenerated", 0), p(this, "removeParticleAt", function(t) {
                    r.particles.splice(t, 1);
                }), p(this, "getParticle", function() {
                    var t = u(r.x, r.w + r.x), e = u(r.y, r.h + r.y);
                    return new l(r.context, r.getOptions, t, e);
                }), p(this, "animate", function() {
                    var t = r.canvas, e = r.context, n = r.particlesGenerated, i = r.lastNumberOfPieces, o = r.getOptions(), a = o.run, c = o.recycle, s = o.numberOfPieces, u = o.debug, f = o.tweenFunction, h = o.tweenDuration;
                    if (!a) return !1;
                    var l = r.particles.length, p = c ? l : n, v = Date.now();
                    if (p < s) {
                        i !== s && (r.tweenInitTime = v, r.lastNumberOfPieces = s);
                        for(var y = r.tweenInitTime, d = f(v - y > h ? h : Math.max(0, v - y), p, s, h), b = Math.round(d - p), g = 0; g < b; g++)r.particles.push(r.getParticle());
                        r.particlesGenerated += b;
                    }
                    return u && (e.font = "12px sans-serif", e.fillStyle = "#333", e.textAlign = "right", e.fillText("Particles: ".concat(l), t.width - 10, t.height - 20)), r.particles.forEach(function(e, n) {
                        e.update(), (e.y > t.height || e.y < -100 || e.x > t.width + 100 || e.x < -100) && (c && p <= s ? r.particles[n] = r.getParticle() : r.removeParticleAt(n));
                    }), l > 0 || p < s;
                }), this.canvas = e;
                var i = this.canvas.getContext("2d");
                if (!i) throw new Error("Could not get canvas context");
                this.context = i, this.getOptions = n;
            };
            function y(t, e) {
                var n = Object.keys(t);
                if (Object.getOwnPropertySymbols) {
                    var r = Object.getOwnPropertySymbols(t);
                    e && (r = r.filter(function(e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                    })), n.push.apply(n, r);
                }
                return n;
            }
            function d(t) {
                for(var e = 1; e < arguments.length; e++){
                    var n = null != arguments[e] ? arguments[e] : {};
                    e % 2 ? y(Object(n), !0).forEach(function(e) {
                        g(t, e, n[e]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : y(Object(n)).forEach(function(e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                    });
                }
                return t;
            }
            function b(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function g(t, e, n) {
                return e in t ? Object.defineProperty(t, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = n, t;
            }
            var O = {
                width: "undefined" != typeof window ? window.innerWidth : 300,
                height: "undefined" != typeof window ? window.innerHeight : 200,
                numberOfPieces: 200,
                friction: .99,
                wind: 0,
                gravity: .1,
                initialVelocityX: 4,
                initialVelocityY: 10,
                colors: [
                    "#f44336",
                    "#e91e63",
                    "#9c27b0",
                    "#673ab7",
                    "#3f51b5",
                    "#2196f3",
                    "#03a9f4",
                    "#00bcd4",
                    "#009688",
                    "#4CAF50",
                    "#8BC34A",
                    "#CDDC39",
                    "#FFEB3B",
                    "#FFC107",
                    "#FF9800",
                    "#FF5722",
                    "#795548"
                ],
                opacity: 1,
                debug: !1,
                tweenFunction: s.a.easeInOutQuad,
                tweenDuration: 5e3,
                recycle: !0,
                run: !0
            }, w = function() {
                function t(e, n) {
                    var r = this;
                    !function(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, t), g(this, "canvas", void 0), g(this, "context", void 0), g(this, "_options", void 0), g(this, "generator", void 0), g(this, "rafId", void 0), g(this, "setOptionsWithDefaults", function(t) {
                        var e = {
                            confettiSource: {
                                x: 0,
                                y: 0,
                                w: r.canvas.width,
                                h: 0
                            }
                        };
                        r._options = d(d(d({}, e), O), t), Object.assign(r, t.confettiSource);
                    }), g(this, "update", function() {
                        var t = r.options, e = t.run, n = t.onConfettiComplete, i = r.canvas, o = r.context;
                        e && (o.fillStyle = "white", o.clearRect(0, 0, i.width, i.height)), r.generator.animate() ? r.rafId = requestAnimationFrame(r.update) : (n && "function" == typeof n && r.generator.particlesGenerated > 0 && n.call(r, r), r._options.run = !1);
                    }), g(this, "reset", function() {
                        r.generator && r.generator.particlesGenerated > 0 && (r.generator.particlesGenerated = 0, r.generator.particles = [], r.generator.lastNumberOfPieces = 0);
                    }), g(this, "stop", function() {
                        r.options = {
                            run: !1
                        }, r.rafId && (cancelAnimationFrame(r.rafId), r.rafId = void 0);
                    }), this.canvas = e;
                    var i = this.canvas.getContext("2d");
                    if (!i) throw new Error("Could not get canvas context");
                    this.context = i, this.generator = new v(this.canvas, function() {
                        return r.options;
                    }), this.options = n, this.update();
                }
                var e, n, r;
                return e = t, n = [
                    {
                        key: "options",
                        get: function() {
                            return this._options;
                        },
                        set: function(t) {
                            var e = this._options && this._options.run, n = this._options && this._options.recycle;
                            this.setOptionsWithDefaults(t), this.generator && (Object.assign(this.generator, this.options.confettiSource), "boolean" == typeof t.recycle && t.recycle && !1 === n && (this.generator.lastNumberOfPieces = this.generator.particles.length)), "boolean" == typeof t.run && t.run && !1 === e && this.update();
                        }
                    }
                ], b(e.prototype, n), r && b(e, r), t;
            }();
            function m(t) {
                return function(t) {
                    if (Array.isArray(t)) return C(t);
                }(t) || function(t) {
                    if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
                }(t) || S(t) || function() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            }
            function x(t) {
                return (x = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                    return typeof t;
                } : function(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            function P() {
                return (P = Object.assign || function(t) {
                    for(var e = 1; e < arguments.length; e++){
                        var n = arguments[e];
                        for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
                    }
                    return t;
                }).apply(this, arguments);
            }
            function j(t, e) {
                var n = Object.keys(t);
                if (Object.getOwnPropertySymbols) {
                    var r = Object.getOwnPropertySymbols(t);
                    e && (r = r.filter(function(e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                    })), n.push.apply(n, r);
                }
                return n;
            }
            function M(t) {
                for(var e = 1; e < arguments.length; e++){
                    var n = null != arguments[e] ? arguments[e] : {};
                    e % 2 ? j(Object(n), !0).forEach(function(e) {
                        T(t, e, n[e]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : j(Object(n)).forEach(function(e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                    });
                }
                return t;
            }
            function I(t, e) {
                return function(t) {
                    if (Array.isArray(t)) return t;
                }(t) || function(t, e) {
                    if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t))) return;
                    var n = [], r = !0, i = !1, o = void 0;
                    try {
                        for(var a, c = t[Symbol.iterator](); !(r = (a = c.next()).done) && (n.push(a.value), !e || n.length !== e); r = !0);
                    } catch (t) {
                        i = !0, o = t;
                    } finally{
                        try {
                            r || null == c.return || c.return();
                        } finally{
                            if (i) throw o;
                        }
                    }
                    return n;
                }(t, e) || S(t, e) || function() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            }
            function S(t, e) {
                if (t) {
                    if ("string" == typeof t) return C(t, e);
                    var n = Object.prototype.toString.call(t).slice(8, -1);
                    return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? C(t, e) : void 0;
                }
            }
            function C(t, e) {
                (null == e || e > t.length) && (e = t.length);
                for(var n = 0, r = new Array(e); n < e; n++)r[n] = t[n];
                return r;
            }
            function D(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            function E(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function _(t, e) {
                return (_ = Object.setPrototypeOf || function(t, e) {
                    return t.__proto__ = e, t;
                })(t, e);
            }
            function R(t) {
                var e = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0;
                    } catch (t) {
                        return !1;
                    }
                }();
                return function() {
                    var n, r = F(t);
                    if (e) {
                        var i = F(this).constructor;
                        n = Reflect.construct(r, arguments, i);
                    } else n = r.apply(this, arguments);
                    return k(this, n);
                };
            }
            function k(t, e) {
                return !e || "object" !== x(e) && "function" != typeof e ? A(t) : e;
            }
            function A(t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            }
            function F(t) {
                return (F = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
                    return t.__proto__ || Object.getPrototypeOf(t);
                })(t);
            }
            function T(t, e, n) {
                return e in t ? Object.defineProperty(t, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = n, t;
            }
            var B = a.a.createRef(), N = function(t) {
                !function(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e && _(t, e);
                }(o, t);
                var e, n, r, i = R(o);
                function o(t) {
                    var e;
                    D(this, o);
                    for(var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), c = 1; c < n; c++)r[c - 1] = arguments[c];
                    return T(A(e = i.call.apply(i, [
                        this,
                        t
                    ].concat(r))), "canvas", a.a.createRef()), T(A(e), "confetti", void 0), e.canvas = t.canvasRef || B, e;
                }
                return e = o, n = [
                    {
                        key: "componentDidMount",
                        value: function() {
                            if (this.canvas.current) {
                                var t = q(this.props)[0];
                                this.confetti = new w(this.canvas.current, t);
                            }
                        }
                    },
                    {
                        key: "componentDidUpdate",
                        value: function() {
                            var t = q(this.props)[0];
                            this.confetti && (this.confetti.options = t);
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function() {
                            this.confetti && this.confetti.stop(), this.confetti = void 0;
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var t = I(q(this.props), 2), e = t[0], n = t[1], r = M({
                                zIndex: 2,
                                position: "absolute",
                                pointerEvents: "none",
                                top: 0,
                                left: 0,
                                bottom: 0,
                                right: 0
                            }, n.style);
                            return a.a.createElement("canvas", P({
                                width: e.width,
                                height: e.height,
                                ref: this.canvas
                            }, n, {
                                style: r
                            }));
                        }
                    }
                ], E(e.prototype, n), r && E(e, r), o;
            }(o.Component);
            function q(t) {
                var e = {}, n = {}, r = [].concat(m(Object.keys(O)), [
                    "confettiSource",
                    "drawShape",
                    "onConfettiComplete"
                ]), i = [
                    "canvasRef"
                ];
                for(var o in t){
                    var a = t[o];
                    r.includes(o) ? e[o] = a : i.includes(o) ? i[o] = a : n[o] = a;
                }
                return [
                    e,
                    n,
                    {}
                ];
            }
            T(N, "defaultProps", M({}, O)), T(N, "displayName", "ReactConfetti");
            var Q = a.a.forwardRef(function(t, e) {
                return a.a.createElement(N, P({
                    canvasRef: e
                }, t));
            });
            e.default = Q;
        }
    ]).default;
});

});

parcelRegister("4dSc8", function(module, exports) {
/* add-pin-modal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $ccHMk = parcelRequire("ccHMk");


var $dpPtd = parcelRequire("dpPtd");


var $ci7Ox = parcelRequire("ci7Ox");


var $a3fRD = parcelRequire("a3fRD");


var $3sFtD = parcelRequire("3sFtD");


var $2Nwuj = parcelRequire("2Nwuj");


var $8CZUH = parcelRequire("8CZUH");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $99qsA = parcelRequire("99qsA");

var $6T8v4 = parcelRequire("6T8v4");


var $3gadb = parcelRequire("3gadb");


var $cVtio = parcelRequire("cVtio");


var $4Zqgi = parcelRequire("4Zqgi");


var $8d7Su = parcelRequire("8d7Su");


var $5JFXt = parcelRequire("5JFXt");


var $03Bft = parcelRequire("03Bft");


var $3NkqS = parcelRequire("3NkqS");


var $eqPcP = parcelRequire("eqPcP");


var $eDDqf = parcelRequire("eDDqf");

const $7b98dae0b13f338b$var$styles = {
    modalBody: "_19bv1ejb _u5f31ejb",
    formFieldsContainer: "_19pk1ejb"
};
const $7b98dae0b13f338b$var$KEY_PHRASE_MAX_LENGTH = 50;
const $7b98dae0b13f338b$var$KEY_PHRASES_LIST_MAX_LENGTH = 5;
const $7b98dae0b13f338b$export$6b6672b81db1fb01 = ({ orgId: orgId, cloudId: cloudId, hasAdminhubAccess: hasAdminhubAccess, handleClose: handleClose, onSuccessCallback: onSuccessCallback, query: query, workspaceId: workspaceId, product: product, existingBookmark: existingBookmark, source: source })=>{
    const { formatList: formatList, formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const isUpdateModal = !!existingBookmark;
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsEvent((0, $8d7Su.onAddPinModalOpen)(isUpdateModal, source)); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [hasGenericError, setHasGenericError] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const [pinTitle, setPinTitle] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(isUpdateModal ? existingBookmark.properties.title : query || '');
    const [pinTitleErr, setPinTitleErr] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const onPinTitleChange = (input, actionMeta)=>{
        if (actionMeta.action === 'input-change') {
            setPinTitleErr(false);
            setPinTitle(input);
        }
    };
    const onPinTitleBlur = ()=>{
        if (!pinTitle) setPinTitleErr(true);
    };
    const [pinUrl, setPinUrl] = (0, $42omo.useState)(isUpdateModal ? existingBookmark.properties.url : '');
    const [pinUrlErr, setPinUrlErr] = (0, $42omo.useState)({
        isError: false
    });
    const onPinUrlChange = (input, actionMeta)=>{
        if (actionMeta.action === 'input-change') {
            setPinUrlErr({
                isError: false
            });
            setPinUrl(input);
        }
    };
    const onPinUrlBlur = ()=>{
        if (!pinUrl) setPinUrlErr({
            isError: true,
            type: 'empty'
        });
        else if (!(0, $eDDqf.isValidHttpUrl)(pinUrl)) setPinUrlErr({
            isError: true,
            type: 'invalid'
        });
    };
    const renderUrlErroredMessage = ()=>{
        if (pinUrlErr.isError && pinUrlErr.type === 'empty') return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $3NkqS.messages).pinModalNoUrlMessage
        });
        if (pinUrlErr.isError && pinUrlErr.type === 'invalid') return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $3NkqS.messages).pinModalInvalidUrlMessage
        });
    };
    const [pinDescription, setPinDescription] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(isUpdateModal ? existingBookmark.properties.description : '');
    const onPinDescriptionChange = (input, actionMeta)=>{
        if (actionMeta.action === 'input-change') setPinDescription(input);
    };
    const [pinKeyPhrases, setPinKeyPhrases] = (0, $42omo.useState)(isUpdateModal ? [
        {
            label: existingBookmark.properties.keyPhrase,
            value: existingBookmark.properties.keyPhrase
        }
    ] : query ? [
        {
            label: query,
            value: query
        }
    ] : []);
    const [keyPhraseErr, setKeyPhraseErr] = (0, $42omo.useState)(undefined);
    const [collidedKeyPhrases, setCollidedKeyPhrases] = (0, $42omo.useState)([]); // key phrase that user has typed in input
    const [typedKeyPhrase, setTypedKeyPhrase] = (0, $42omo.useState)('');
    const onTypedKeyPhraseChange = (inputValue, event)=>{
        if (event?.action === 'input-blur' || event?.action === 'menu-close') return;
        setKeyPhraseErr(undefined);
        setTypedKeyPhrase(inputValue);
    };
    const onPinKeyPhrasesChange = (newPins, _actionMeta)=>{
        setKeyPhraseErr(undefined);
        setPinKeyPhrases(newPins);
    };
    const onPinKeyPhraseSubmit = ()=>{
        const normalizedKeyPhrase = typedKeyPhrase.trim().toLowerCase(); // if nothing has been typed and user clicks tab, tab to button
        if (!normalizedKeyPhrase.length) return false;
        if (normalizedKeyPhrase.length > $7b98dae0b13f338b$var$KEY_PHRASE_MAX_LENGTH) {
            setKeyPhraseErr((0, $eDDqf.SearchPinKeyphraseErrorState).KEY_PHRASE_TOO_LONG);
            return true;
        }
        const specialCharsRegex = new RegExp(/[^\w\s]+|_+/);
        if (specialCharsRegex.test(normalizedKeyPhrase)) {
            setKeyPhraseErr((0, $eDDqf.SearchPinKeyphraseErrorState).KEY_PHRASE_HAS_SPECIAL_CHAR);
            return true;
        }
        const updatedKeyPhrases = (0, $eqPcP.convertToKeyPhraseInputFormat)([
            ...new Set([
                ...pinKeyPhrases.map((keyPhrase)=>keyPhrase.value),
                normalizedKeyPhrase
            ])
        ]);
        if (updatedKeyPhrases.length > $7b98dae0b13f338b$var$KEY_PHRASES_LIST_MAX_LENGTH) {
            setKeyPhraseErr((0, $eDDqf.SearchPinKeyphraseErrorState).KEY_PHRASE_LIST_TOO_LONG);
            setTypedKeyPhrase('');
            return true;
        }
        setPinKeyPhrases(updatedKeyPhrases);
        setTypedKeyPhrase('');
        return true;
    };
    const onPinKeyPhrasesKeyDown = (event)=>{
        if (![
            'Tab',
            'Enter'
        ].includes(event.key)) return;
        const successfulSubmitOrKeyPhraseErr = onPinKeyPhraseSubmit();
        if (successfulSubmitOrKeyPhraseErr) // do not want to tab to button if user still adding key phrases or needs to correct a keyphrase
        event.preventDefault();
    };
    const onPinKeyPhrasesBlur = ()=>{
        // want to show this error only if no key phrase has been added AND user hasn't typed anything yet
        if (!pinKeyPhrases.length && !typedKeyPhrase) {
            setKeyPhraseErr((0, $eDDqf.SearchPinKeyphraseErrorState).KEY_PHRASE_LIST_TOO_SHORT);
            return;
        }
        setKeyPhraseErr(undefined); // add what user has typed so far as a keyphrase; if invalid keyphrase show error message
        if (typedKeyPhrase) onPinKeyPhraseSubmit();
    };
    const onClose = ()=>{
        // reset
        setPinTitle('');
        setPinUrl('');
        setPinDescription('');
        setPinKeyPhrases([]);
        setPinTitleErr(false);
        setPinUrlErr({
            isError: false
        });
        setKeyPhraseErr(undefined);
        handleClose();
    };
    const createSearchPinDisabled = !pinTitle || !(0, $eDDqf.isValidHttpUrl)(pinUrl) || !pinKeyPhrases.length;
    const [createSearchPinLoading, setCreateSearchPinLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const { createBookmark: createBookmark } = (0, $5JFXt.useAddBookmarkMutation)();
    const { updateBookmark: updateBookmark } = (0, $03Bft.useUpdateBookmarkMutation)();
    const onCreateSearchPin = async ()=>{
        try {
            setHasGenericError(false);
            setCreateSearchPinLoading(true);
            const newPin = isUpdateModal ? await updateBookmark({
                cloudId: cloudId,
                orgId: orgId,
                keyPhrases: pinKeyPhrases.map((keyPhrase)=>keyPhrase.value),
                url: pinUrl,
                title: pinTitle,
                description: pinDescription,
                bookmarkAdminhubId: existingBookmark.properties.parentAdminhubBookmarkId ?? ''
            }) : await createBookmark({
                cloudId: cloudId,
                orgId: orgId,
                keyPhrases: pinKeyPhrases.map((keyPhrase)=>keyPhrase.value),
                url: pinUrl,
                title: pinTitle,
                description: pinDescription
            }, workspaceId, product); // check for keyphrase errors from the backend
            if (newPin.errors && newPin.errors.length) {
                const collidedKeyPhrasesList = (0, $eDDqf.getCollidedKeyPhrases)(newPin.errors);
                if (collidedKeyPhrasesList.length) {
                    setKeyPhraseErr((0, $eDDqf.SearchPinKeyphraseErrorState).KEY_PHRASE_COLLISION);
                    setCollidedKeyPhrases(collidedKeyPhrasesList);
                    setCreateSearchPinLoading(false);
                    return;
                }
                throw new Error(newPin.errors[0]?.message ?? 'Generic Error');
            }
            if (isUpdateModal) fireAnalyticsEvent((0, $8d7Su.onUpdatePin)({
                title: pinTitle,
                url: pinUrl,
                keyPhrases: pinKeyPhrases.map((keyPhrase)=>keyPhrase.value),
                description: pinDescription
            }, source ?? 'unknown'));
            else fireAnalyticsEvent((0, $8d7Su.onAddPin)({
                title: pinTitle,
                url: pinUrl,
                keyPhrases: pinKeyPhrases.map((keyPhrase)=>keyPhrase.value),
                description: pinDescription
            }, source ?? 'unknown'));
            showFlag({
                isAutoDismiss: true,
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                    spacing: "spacious",
                    label: "",
                    color: "var(--ds-icon-success, #6A9A23)"
                }),
                id: 'create-search-pin',
                title: isUpdateModal ? formatMessage((0, $3NkqS.messages).bookmarkUpdateSuccessFlagTitle) : formatMessage((0, $3NkqS.messages).pinCreationSuccessFlagTitle),
                description: isUpdateModal ? undefined : formatMessage((0, $3NkqS.messages).pinCreationSuccessFlagMessage)
            });
            onClose();
            onSuccessCallback && onSuccessCallback();
        } catch (error) {
            setHasGenericError(true);
            fireAnalyticsEvent((0, $8d7Su.onBookmarkAddFailed)(isUpdateModal));
            (0, $4Zqgi.logger).error({
                error: error,
                functionName: 'onCreateSearchPin'
            });
        } finally{
            setCreateSearchPinLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $8CZUH.default), {
            onClose: onClose,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                    hasCloseButton: true,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                        children: isUpdateModal ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $3NkqS.messages).bookmarkModalUpdateHeader
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $3NkqS.messages).pinModalAddPinHeader
                        })
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    xcss: $7b98dae0b13f338b$var$styles.modalBody,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                            gap: "space.100",
                            direction: "column",
                            children: hasGenericError ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                space: "space.050",
                                alignBlock: "center",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                                        label: "",
                                        color: "var(--ds-text-danger, #AE2E24)"
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        color: "color.text.danger",
                                        children: isUpdateModal ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                            ...(0, $3NkqS.messages).pinUpdateErrorMessage
                                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                            ...(0, $3NkqS.messages).pinGenericErrorMessage
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                            ...(0, $3NkqS.messages).pinModalSubheaderLine1
                                        })
                                    }),
                                    hasAdminhubAccess && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                            ...(0, $3NkqS.messages).pinModalSubheaderLine2,
                                            values: {
                                                a: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                                        href: (0, $eqPcP.getAdminhubLink)({
                                                            orgId: orgId
                                                        }),
                                                        children: chunks
                                                    })
                                            }
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                            gap: "space.200",
                            direction: "column",
                            xcss: $7b98dae0b13f338b$var$styles.formFieldsContainer,
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                                    gap: "space.100",
                                    direction: "column",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                            weight: "semibold",
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                ...(0, $3NkqS.messages).pinModalPinDetailsHeader
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                ...(0, $3NkqS.messages).pinModalPinDetailsSubHeader
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                                    gap: "space.050",
                                    direction: "column",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                            size: "small",
                                            weight: "medium",
                                            color: "color.text.subtle",
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                ...(0, $3NkqS.messages).pinModalSearchResultTitleHeader
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6T8v4.default), {
                                            components: {
                                                DropdownIndicator: ()=>null,
                                                Menu: ()=>null
                                            },
                                            inputValue: pinTitle,
                                            onInputChange: onPinTitleChange,
                                            onBlur: onPinTitleBlur,
                                            placeholder: formatMessage((0, $3NkqS.messages).pinModalSearchResultTitlePlaceholder)
                                        }),
                                        pinTitleErr && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                            space: "space.050",
                                            alignBlock: "center",
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                                                    label: "",
                                                    color: "var(--ds-text-danger, #AE2E24)"
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                    size: "small",
                                                    color: "color.text.danger",
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                        ...(0, $3NkqS.messages).pinModalNoTitleMessage
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                                    gap: "space.050",
                                    direction: "column",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                            size: "small",
                                            weight: "medium",
                                            color: "color.text.subtle",
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                ...(0, $3NkqS.messages).pinModalUrlHeader
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6T8v4.default), {
                                            components: {
                                                DropdownIndicator: ()=>null,
                                                Menu: ()=>null
                                            },
                                            inputValue: pinUrl,
                                            onInputChange: onPinUrlChange,
                                            onBlur: onPinUrlBlur,
                                            placeholder: formatMessage((0, $3NkqS.messages).pinModalUrlPlaceholder),
                                            testId: "add-pin-modal-url-input"
                                        }),
                                        pinUrlErr.isError && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                            space: "space.050",
                                            alignBlock: "center",
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                                                    label: "",
                                                    color: "var(--ds-text-danger, #AE2E24)"
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                    size: "small",
                                                    color: "color.text.danger",
                                                    children: renderUrlErroredMessage()
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                                    gap: "space.050",
                                    direction: "column",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                            size: "small",
                                            weight: "medium",
                                            color: "color.text.subtle",
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                ...(0, $3NkqS.messages).pinModalDescriptionHeader
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6T8v4.default), {
                                            components: {
                                                DropdownIndicator: ()=>null,
                                                Menu: ()=>null
                                            },
                                            inputValue: pinDescription,
                                            onInputChange: onPinDescriptionChange,
                                            placeholder: formatMessage((0, $3NkqS.messages).pinModalDescriptionPlaceholder)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                                    gap: "space.050",
                                    direction: "column",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                            space: "space.050",
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                    size: "small",
                                                    weight: "medium",
                                                    color: "color.text.subtle",
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                        ...(0, $3NkqS.messages).pinModalSearchForTermsHeader
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                                                    content: formatMessage((0, $3NkqS.messages).pinModalSearchForTermsTooltip),
                                                    position: "bottom-start",
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))), {
                                                        color: "currentColor",
                                                        label: ""
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $99qsA.default), {
                                            components: {
                                                DropdownIndicator: ()=>null,
                                                Menu: ()=>null
                                            },
                                            isMulti: true,
                                            inputValue: typedKeyPhrase,
                                            onInputChange: onTypedKeyPhraseChange,
                                            defaultValue: pinKeyPhrases,
                                            value: pinKeyPhrases,
                                            onKeyDown: onPinKeyPhrasesKeyDown,
                                            onChange: onPinKeyPhrasesChange,
                                            onBlur: onPinKeyPhrasesBlur,
                                            placeholder: formatMessage((0, $3NkqS.messages).pinModalSearchForTermsPlaceholder),
                                            testId: "add-pin-modal-key-phrase-input"
                                        }),
                                        keyPhraseErr && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                            space: "space.050",
                                            alignBlock: "center",
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                                                    label: "",
                                                    color: "var(--ds-text-danger, #AE2E24)"
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                    size: "small",
                                                    color: "color.text.danger",
                                                    children: (0, $eDDqf.getKeyPhraseErrMessage)(keyPhraseErr, formatList(collidedKeyPhrases, {
                                                        style: 'long',
                                                        type: 'conjunction'
                                                    }), collidedKeyPhrases.length)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $8o1lj.default), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            appearance: "subtle",
                            onClick: onClose,
                            testId: "add-search-pin-cancel-button",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $3NkqS.messages).pinModalCancelButton
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            appearance: "primary",
                            isDisabled: createSearchPinDisabled,
                            onClick: onCreateSearchPin,
                            isLoading: createSearchPinLoading,
                            testId: "bookmark-submit-button",
                            children: isUpdateModal ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $3NkqS.messages).bookmarkModalUpdateButton
                            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $3NkqS.messages).pinModalAddButton
                            })
                        })
                    ]
                })
            ]
        })
    });
};
module.exports["AddPinModal"] = $7b98dae0b13f338b$export$6b6672b81db1fb01;

});

parcelRegister("8d7Su", function(module, exports) {

var $cqFuK = parcelRequire("cqFuK");


var $4Zqgi = parcelRequire("4Zqgi");

const $3b558bd6a94accff$export$dccc97e4cadc9724 = (props)=>{
    try {
        const { query: query, queryHash: queryHash, url: url, bookmarkId: bookmarkId } = props;
        return {
            action: 'clicked',
            actionSubject: 'aiSearchBookmarkLink',
            eventType: 'ui',
            attributes: {
                queryHash: queryHash,
                bookmarkId: bookmarkId
            },
            nonPrivacySafeAttributes: {
                query: query,
                url: url
            }
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onLinkClick'
        });
        return {};
    }
};
const $3b558bd6a94accff$export$a9221ddd7247153a = (props)=>{
    try {
        const { query: query, queryHash: queryHash, url: url, bookmarkId: bookmarkId } = props;
        return {
            action: 'shown',
            actionSubject: 'aiSearchBookmark',
            eventType: 'track',
            attributes: {
                queryHash: queryHash,
                bookmarkId: bookmarkId
            },
            nonPrivacySafeAttributes: {
                query: query,
                url: url
            }
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onBookmarkShown'
        });
        return {};
    }
};
const $3b558bd6a94accff$export$7d18122d8e1ee01a = (props)=>{
    try {
        const { query: query } = props;
        return {
            action: 'shown',
            actionSubject: 'aiSearchAddBookmark',
            eventType: 'track',
            nonPrivacySafeAttributes: {
                query: query
            }
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onAddBookmarkShown'
        });
        return {};
    }
};
const $3b558bd6a94accff$export$5c4a25c0b9d2f87d = (isUpdateModal, source)=>{
    try {
        return {
            action: 'shown',
            actionSubject: isUpdateModal ? 'aiSearchBookmarkOpenUpdateModal' : 'aiSearchBookmarkOpenAddModal',
            eventType: 'track',
            source: source
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onAddPinModalOpen'
        });
        return {};
    }
};
const $3b558bd6a94accff$export$4f6bc579055d1a30 = (nonPrivacySafeAttributes, source)=>{
    try {
        return {
            action: 'clicked',
            actionSubject: 'aiSearchBookmarkAddButton',
            eventType: 'ui',
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            source: source
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onAddPin'
        });
        return {};
    }
};
const $3b558bd6a94accff$export$6f152bea48442457 = (nonPrivacySafeAttributes, source)=>{
    try {
        return {
            action: 'clicked',
            actionSubject: 'aiSearchBookmarkUpdateButton',
            eventType: 'ui',
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            source: source
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onUpdatePin'
        });
        return {};
    }
};
const $3b558bd6a94accff$export$77b64c33e6bdaf7c = ()=>{
    try {
        return {
            action: 'clicked',
            actionSubject: 'aiSearchBookmarkAddLearnMore',
            eventType: 'ui'
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onLearnMoreAboutPinsClick'
        });
        return {};
    }
};
const $3b558bd6a94accff$export$a9cdec4c0adbe9c5 = ()=>{
    try {
        return {
            action: 'clicked',
            actionSubject: 'aiSearchBookmarkAddDismiss',
            eventType: 'ui'
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onAddPinDismissClick'
        });
        return {};
    }
};
const $3b558bd6a94accff$export$aa99a9b4b886f8c8 = ()=>{
    try {
        return {
            action: 'failed',
            actionSubject: 'aiSearchBookmarkAddDismiss',
            eventType: 'track'
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onBookmarkFetchFailed'
        });
        return {};
    }
};
const $3b558bd6a94accff$export$e0596a2b847403aa = (isUpdateModal)=>{
    try {
        return {
            action: 'failed',
            actionSubject: isUpdateModal ? 'aiSearchBookmarkUpdate' : 'aiSearchBookmarkAddDismiss',
            eventType: 'track'
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onBookmarkAddFailed'
        });
        return {};
    }
};
const $3b558bd6a94accff$export$6f33f0477537d204 = (props)=>{
    try {
        return {
            action: 'clicked',
            actionSubject: 'aiSearchBookmarkLikeButton',
            eventType: 'ui',
            attributes: {
                ...(0, $cqFuK.filterCommonAttributes)(props)
            },
            nonPrivacySafeAttributes: {
                query: props.query
            }
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onBookmarkLikeButton'
        });
        return {};
    }
};
const $3b558bd6a94accff$export$ebd62c3186e15b97 = (props)=>{
    try {
        return {
            action: 'clicked',
            actionSubject: 'aiSearchBookmarkDislikeButton',
            eventType: 'ui',
            attributes: {
                ...(0, $cqFuK.filterCommonAttributes)(props)
            },
            nonPrivacySafeAttributes: {
                query: props.query
            }
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onBookmarkDislikeButton'
        });
        return {};
    }
};
const $3b558bd6a94accff$export$9883993cbc623aae = ()=>{
    try {
        return {
            action: 'shown',
            actionSubject: 'popularSearchQuerySuggestion',
            eventType: 'track'
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onPopularSearchQuerySuggestionShown'
        });
        return {};
    }
};
const $3b558bd6a94accff$export$941550b6519465df = ()=>{
    try {
        return {
            action: 'clicked',
            actionSubject: 'popularSearchQueryButton',
            eventType: 'ui'
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onPopularSearchQueryButtonClicked'
        });
        return {};
    }
};
module.exports["onAddBookmarkShown"] = $3b558bd6a94accff$export$7d18122d8e1ee01a;
module.exports["onAddPinModalOpen"] = $3b558bd6a94accff$export$5c4a25c0b9d2f87d;
module.exports["onAddPin"] = $3b558bd6a94accff$export$4f6bc579055d1a30;
module.exports["onUpdatePin"] = $3b558bd6a94accff$export$6f152bea48442457;
module.exports["onLearnMoreAboutPinsClick"] = $3b558bd6a94accff$export$77b64c33e6bdaf7c;
module.exports["onAddPinDismissClick"] = $3b558bd6a94accff$export$a9cdec4c0adbe9c5;
module.exports["onBookmarkFetchFailed"] = $3b558bd6a94accff$export$aa99a9b4b886f8c8;
module.exports["onBookmarkAddFailed"] = $3b558bd6a94accff$export$e0596a2b847403aa;
module.exports["onPopularSearchQuerySuggestionShown"] = $3b558bd6a94accff$export$9883993cbc623aae;
module.exports["onPopularSearchQueryButtonClicked"] = $3b558bd6a94accff$export$941550b6519465df;

});

parcelRegister("3NkqS", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $97841560b31a4348$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    pin_title: {
        id: "search_ai.bookmark.title",
        defaultMessage: "Bookmarked by your company"
    },
    pin_title_suggested: {
        id: "search_ai.bookmark.title_suggested",
        defaultMessage: "Bookmark suggested by Rovo"
    },
    pin_icon_label: {
        id: "search_ai.bookmark.icon_label",
        defaultMessage: "Search bookmark icon"
    },
    add_another_pin_button_label: {
        id: "search_ai.bookmark.add_another_pin_button",
        defaultMessage: "Add another bookmark"
    },
    add_pin_button_label: {
        id: "search_ai.bookmark.add_pin_button",
        defaultMessage: "Add bookmark"
    },
    learn_about_pins: {
        id: "search_ai.bookmark.info_link",
        defaultMessage: "Learn more about bookmarks"
    },
    add_pin_card_copy: {
        id: "search_ai.bookmark.add_pin_card_copy",
        defaultMessage: "Add a bookmark so your teammates find things faster"
    },
    dismiss: {
        id: "search_ai.bookmark.add_pin_dismiss",
        defaultMessage: "Dismiss"
    },
    pinModalAddPinHeader: {
        id: "search_ai.bookmark.modal-add-header",
        defaultMessage: "Add a new bookmark"
    },
    pinModalSubheaderLine1: {
        id: "search_ai.bookmark.modal-subheader-line-1",
        defaultMessage: "Bookmarks allow you to show a search result first, based on particular search terms."
    },
    pinModalSubheaderLine2: {
        id: "search_ai.bookmark.modal-subheader-line-2",
        defaultMessage: "You can also create and manage bookmarks from <a>Admin Hub.</a>"
    },
    pinModalPinDetailsHeader: {
        id: "search_ai.bookmark.modal-pin-details",
        defaultMessage: "Bookmark details"
    },
    pinModalPinDetailsSubHeader: {
        id: "search_ai.bookmark.modal-pin-details-subheader",
        defaultMessage: "Everyone in your organization will see this result when they search for the terms."
    },
    pinModalSearchResultTitleHeader: {
        id: "search_ai.bookmark.modal-search-result-title-header",
        defaultMessage: "Search result title"
    },
    pinModalSearchResultTitlePlaceholder: {
        id: "search_ai.bookmark.modal-search-result-title-placeholder",
        defaultMessage: "Enter a title for this bookmark"
    },
    pinModalUrlHeader: {
        id: "search_ai.bookmark.modal-url-header",
        defaultMessage: "URL"
    },
    pinModalUrlPlaceholder: {
        id: "search_ai.bookmark.modal-url-placeholder",
        defaultMessage: "Enter internal or external URL for this bookmark"
    },
    pinModalDescriptionHeader: {
        id: "search_ai.bookmark.modal-description-header",
        defaultMessage: "Description"
    },
    pinModalDescriptionPlaceholder: {
        id: "search_ai.bookmark.modal-description-placeholder",
        defaultMessage: "Enter a short description for this bookmark"
    },
    pinModalSearchForTermsHeader: {
        id: "search_ai.bookmark.modal-search-terms-header",
        defaultMessage: "Search terms"
    },
    pinModalSearchForTermsPlaceholder: {
        id: "search_ai.bookmark.modal-search-terms-placeholder",
        defaultMessage: "Enter up to 5 terms to display this bookmark"
    },
    pinModalSearchForTermsTooltip: {
        id: "search_ai.bookmark.modal-search-terms-tooltip",
        defaultMessage: "Enter up to 5 terms that people can search for to display this bookmark. Terms can have multiple words (\"leave policy\"). Press enter to add a new term."
    },
    pinModalCancelButton: {
        id: "search_ai.bookmark.modal-cancel-button",
        defaultMessage: "Cancel"
    },
    pinModalAddButton: {
        id: "search_ai.bookmark.modal-add-button",
        defaultMessage: "Add"
    },
    pinModalNoTitleMessage: {
        id: "search_ai.bookmark.modal-no-title-msg",
        defaultMessage: "You must add a bookmark title."
    },
    pinModalNoUrlMessage: {
        id: "search_ai.bookmark.modal-no-url-msg",
        defaultMessage: "You must add a bookmark URL."
    },
    pinModalInvalidUrlMessage: {
        id: "search_ai.bookmark.modal-invalid-url-msg",
        defaultMessage: "You must add a valid absolute URL, for example 'http://www.atlassian.com'."
    },
    pinPhraseCollisionErr: {
        id: "search_ai.bookmark.modal-collision-err",
        defaultMessage: "{keyPhrases} {numKeyPhrases, plural, =1 {keyword is already used for another bookmark.} other {keywords are already used for another bookmark.}}"
    },
    pinKeyPhraseTooLongErr: {
        id: "search_ai.bookmark.modal-too-long-err",
        defaultMessage: "A search term can't be more than 50 characters."
    },
    pinKeyPhraseHasSpecialCharErr: {
        id: "search_ai.bookmark.modal-has-special-char-err",
        defaultMessage: "A search term can only contain letters, numbers, or spaces."
    },
    pinKeyPhraseListTooLongErr: {
        id: "search_ai.bookmark.modal-list-too-long-err",
        defaultMessage: "Maximum of 5 search terms per bookmark."
    },
    pinKeyPhraseListTooShortErr: {
        id: "search_ai.bookmark.modal-list-too-short-err",
        defaultMessage: "You must add at least one term."
    },
    pinKeyPhraseListNonUniqueErr: {
        id: "search_ai.bookmark.modal-list-non-unique-err",
        defaultMessage: "Each term must be unique."
    },
    pinExists: {
        id: "search_ai.bookmark.modal-keyphrase-exists-err",
        defaultMessage: "This bookmark already exists."
    },
    pinGenericErrorMessage: {
        id: "search_ai.bookmark.generic-error-msg",
        defaultMessage: "Something went wrong and we couldn't add your bookmark. Wait a few moments and try again."
    },
    pinUpdateErrorMessage: {
        id: "search_ai.bookmark.update-error-msg",
        defaultMessage: "Something went wrong and we couldn't edit your bookmark. Wait a few moments and try again."
    },
    pinCreationSuccessFlagTitle: {
        id: "search_ai.bookmark.pin-creation-success-title",
        defaultMessage: "Search pin was added"
    },
    pinCreationSuccessFlagMessage: {
        id: "search_ai.bookmark.pin-creation-success-message",
        defaultMessage: "People will see it when they search for the terms you added."
    },
    pinSuggestionMainMessage: {
        id: "search_ai.bookmark.pin-suggestion-main-message",
        defaultMessage: "Your teammates are searching for \"{suggestedTerm}\" a lot"
    },
    pinSuggestionSubMessage: {
        id: "search_ai.bookmark.pin-suggestion-sub-message",
        defaultMessage: "Add a bookmarked link so your teammates find things faster."
    },
    pinCompanyAddedTooltip: {
        id: "search_ai.bookmark.pin-company-added-tooltip",
        defaultMessage: "This result was prioritized by your admin to help you quickly find it."
    },
    pinSuggestedTooltip: {
        id: "search_ai.bookmark.pin-suggested-tooltip",
        defaultMessage: "This result was suggested by AI based on your company's content."
    },
    pinCopyUrlTooltip: {
        id: "search_ai.bookmark.pin-copy-url-tooltip",
        defaultMessage: "Copy bookmark URL"
    },
    pinFeedbackSubmittedFlagMessage: {
        id: "search_ai.bookmark.feedback-submitted-flag-message",
        defaultMessage: "We appreciate you taking the time to send this feedback"
    },
    bookmarkEditTooltip: {
        id: "search_ai.bookmark.edit-tooltip",
        defaultMessage: "Edit bookmark"
    },
    bookmarkModalUpdateHeader: {
        id: "search_ai.bookmark.modal-update-header",
        defaultMessage: "Edit bookmark"
    },
    bookmarkModalUpdateButton: {
        id: "search_ai.bookmark.modal-update-button",
        defaultMessage: "Save"
    },
    bookmarkUpdateSuccessFlagTitle: {
        id: "search_ai.bookmark.update-success-title",
        defaultMessage: "Bookmark was updated"
    },
    userCreatedBookmarksFeatureTitle: {
        id: "search_ai.bookmark.user-created-feature-title",
        defaultMessage: "user-created bookmarks"
    }
});
module.exports["messages"] = $97841560b31a4348$export$defe85febe8b728c;

});

parcelRegister("5JFXt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6yuru = parcelRequire("6yuru");


var $9EFEY = parcelRequire("9EFEY");


var $ai2Vq = parcelRequire("ai2Vq");

const $b742b3503a432451$export$903a58c223e37926 = ()=>{
    const createBookmark = (0, $42omo.useCallback)(async (variables, workspaceId, product)=>{
        return (0, $9EFEY.fetchAggResponse)({
            graphQuery: (0, $ai2Vq.CreateBookmarkMutation),
            variables: variables,
            operationName: (0, $ai2Vq.CREATE_BOOKMARK_OPERATION_NAME),
            headers: (0, $6yuru.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: variables.cloudId,
                product: product
            })
        }).then((response)=>{
            if (response?.data?.knowledgeDiscovery.createBookmark) {
                const createBookmarkResponse = response?.data?.knowledgeDiscovery.createBookmark;
                return {
                    success: createBookmarkResponse.success,
                    errors: createBookmarkResponse.errors || []
                };
            } else throw new Error('createBookmark mutation unsuccessful');
        });
    }, []);
    return {
        createBookmark: createBookmark
    };
};
module.exports["useAddBookmarkMutation"] = $b742b3503a432451$export$903a58c223e37926;

});

parcelRegister("03Bft", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9EFEY = parcelRequire("9EFEY");


var $5nsEM = parcelRequire("5nsEM");

const $a30de311e583bce0$export$b0239751d777b2c7 = ()=>{
    const updateBookmark = (0, $42omo.useCallback)(async (variables)=>{
        return (0, $9EFEY.fetchAggResponse)({
            graphQuery: (0, $5nsEM.UpdateBookmarkMutation),
            variables: variables,
            operationName: (0, $5nsEM.UPDATE_BOOKMARK_OPERATION_NAME)
        }).then((response)=>{
            const updateBookmarkResponse = response?.data?.knowledgeDiscovery.updateBookmark;
            if (updateBookmarkResponse) return {
                success: updateBookmarkResponse.success,
                errors: updateBookmarkResponse.errors || [],
                adminhubBookmark: updateBookmarkResponse.adminhubBookmark
            };
            else throw new Error('updateBookmark mutation unsuccessful');
        });
    }, []);
    return {
        updateBookmark: updateBookmark
    };
};
module.exports["useUpdateBookmarkMutation"] = $a30de311e583bce0$export$b0239751d777b2c7;

});

parcelRegister("eqPcP", function(module, exports) {

var $4lrdQ = parcelRequire("4lrdQ");


var $1JvBr = parcelRequire("1JvBr");


var $4Zqgi = parcelRequire("4Zqgi");

const $d86ae07a91ec9535$var$OBJECT_RESOLVER_ENDPOINT = '/gateway/api/object-resolver/resolve/batch';
const $d86ae07a91ec9535$export$ac8106eaa11606a8 = ({ orgId: orgId })=>{
    const env = (0, $1JvBr.getEnvironment)();
    const route = `o/${orgId}/rovo`;
    switch(env){
        case 'development':
        case 'staging':
            return `https://admin.stg.atlassian.com/${route}`;
        default:
            return `https://admin.atlassian.com/${route}`;
    }
};
const $d86ae07a91ec9535$export$602118ec0b4836ea = (keyPhraseValues)=>keyPhraseValues.map((keyPhraseValue)=>({
            label: keyPhraseValue,
            value: keyPhraseValue
        }));
const $d86ae07a91ec9535$export$dbf5cea6f2cf1974 = async (url)=>{
    try {
        const objectResolver = await (0, $4lrdQ.fetchRestResponse)({
            url: $d86ae07a91ec9535$var$OBJECT_RESOLVER_ENDPOINT,
            body: [
                {
                    resourceUrl: url
                }
            ]
        });
        if (!objectResolver || objectResolver[0].status !== 200) {
            (0, $4Zqgi.logger).error({
                error: 'REQUEST ERROR',
                functionName: 'convertToKeyPhraseInputFormat'
            });
            return null;
        }
        return objectResolver[0].body.data;
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'convertToKeyPhraseInputFormat'
        });
        return null;
    }
};
module.exports["getAdminhubLink"] = $d86ae07a91ec9535$export$ac8106eaa11606a8;
module.exports["convertToKeyPhraseInputFormat"] = $d86ae07a91ec9535$export$602118ec0b4836ea;
module.exports["fetchObjectResolver"] = $d86ae07a91ec9535$export$dbf5cea6f2cf1974;

});

parcelRegister("eDDqf", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $3NkqS = parcelRequire("3NkqS");

var $efd7cf01f00f37ea$export$86984fac8e6cbdf2 = /*#__PURE__*/ function(SearchPinKeyphraseErrorState) {
    SearchPinKeyphraseErrorState["KEY_PHRASE_COLLISION"] = "KEY_PHRASE_COLLISION";
    SearchPinKeyphraseErrorState["KEY_PHRASE_TOO_LONG"] = "KEY_PHRASE_TOO_LONG";
    SearchPinKeyphraseErrorState["KEY_PHRASE_HAS_SPECIAL_CHAR"] = "KEY_PHRASE_HAS_SPECIAL_CHAR";
    SearchPinKeyphraseErrorState["KEY_PHRASE_LIST_TOO_LONG"] = "KEY_PHRASE_LIST_TOO_LONG";
    SearchPinKeyphraseErrorState["KEY_PHRASE_LIST_TOO_SHORT"] = "KEY_PHRASE_LIST_TOO_SHORT";
    SearchPinKeyphraseErrorState["KEY_PHRASE_LIST_NON_UNIQUE"] = "KEY_PHRASE_LIST_NON_UNIQUE";
    return SearchPinKeyphraseErrorState;
}({});
const $efd7cf01f00f37ea$export$46c6f0a9bc3dc55e = (keyPhraseErrorState, collidedKeyPhrases, numCollidedKeyPhrases)=>{
    switch(keyPhraseErrorState){
        case "KEY_PHRASE_COLLISION":
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $3NkqS.messages).pinPhraseCollisionErr,
                values: {
                    keyPhrases: collidedKeyPhrases,
                    numKeyPhrases: numCollidedKeyPhrases
                }
            });
        case "KEY_PHRASE_TOO_LONG":
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $3NkqS.messages).pinKeyPhraseTooLongErr
            });
        case "KEY_PHRASE_HAS_SPECIAL_CHAR":
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $3NkqS.messages).pinKeyPhraseHasSpecialCharErr
            });
        case "KEY_PHRASE_LIST_NON_UNIQUE":
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $3NkqS.messages).pinKeyPhraseListNonUniqueErr
            });
        case "KEY_PHRASE_LIST_TOO_LONG":
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $3NkqS.messages).pinKeyPhraseListTooLongErr
            });
        case "KEY_PHRASE_LIST_TOO_SHORT":
        default:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $3NkqS.messages).pinKeyPhraseListTooShortErr
            });
    }
};
const $efd7cf01f00f37ea$export$a8015f8bc7d64b8c = (mutationErrors)=>{
    const collidedKeyPhrases = [];
    mutationErrors.forEach((err)=>{
        if (err.extensions?.bookmarkFailureMetadata && err.extensions.bookmarkFailureMetadata.errorType === "KEY_PHRASE_COLLISION") collidedKeyPhrases.push(err.extensions.bookmarkFailureMetadata.keyPhrase);
    });
    return collidedKeyPhrases;
};
const $efd7cf01f00f37ea$export$fc99885b7e473d08 = (str)=>{
    let givenURL;
    try {
        givenURL = new URL(str);
    } catch (error) {
        return false;
    }
    return givenURL.protocol === 'http:' || givenURL.protocol === 'https:';
};
module.exports["SearchPinKeyphraseErrorState"] = $efd7cf01f00f37ea$export$86984fac8e6cbdf2;
module.exports["getKeyPhraseErrMessage"] = $efd7cf01f00f37ea$export$46c6f0a9bc3dc55e;
module.exports["getCollidedKeyPhrases"] = $efd7cf01f00f37ea$export$a8015f8bc7d64b8c;
module.exports["isValidHttpUrl"] = $efd7cf01f00f37ea$export$fc99885b7e473d08;

});

parcelRegister("ai2Vq", function(module, exports) {
const $e76663b399762183$export$6f8706b02e0c2b69 = 'KnowledgeDiscoveryAdminhubCreateBookmarkMutation';
const $e76663b399762183$export$e1178492acb07f49 = `
mutation ${$e76663b399762183$export$6f8706b02e0c2b69}($cloudId: ID!, $keyPhrases: [String!], $url: String!, $title: String!, $description: String, $orgId: String!) {
	knowledgeDiscovery {
	  createBookmark(
		input: {cloudId: $cloudId, keyPhrases: $keyPhrases, url: $url, title: $title, description: $description, orgId: $orgId}
	  ) @optIn(to: "KnowledgeDiscovery Create bookmarks in AdminHub") {
		... on KnowledgeDiscoveryCreateAdminhubBookmarkPayload {
		  success
		  errors {
			message
			extensions {
			  ... on KnowledgeDiscoveryBookmarkMutationErrorExtension {
				bookmarkFailureMetadata {
				  errorType
				  ... on KnowledgeDiscoveryBookmarkCollisionFailureMetadata {
					keyPhrase
				  }
				  ... on KnowledgeDiscoveryBookmarkValidationFailureMetadata {
					keyPhrase
				  }
				}
			  }
			}
		  }
		}
	  }
	}
}
`;
module.exports["CREATE_BOOKMARK_OPERATION_NAME"] = $e76663b399762183$export$6f8706b02e0c2b69;
module.exports["CreateBookmarkMutation"] = $e76663b399762183$export$e1178492acb07f49;

});

parcelRegister("5nsEM", function(module, exports) {
const $098cea0b1e42c41d$export$c45e6f9e899c207d = 'KnowledgeDiscoveryAdminhubUpdateBookmarkMutation';
const $098cea0b1e42c41d$export$a3374c2b287ba43a = `
	mutation ${$098cea0b1e42c41d$export$c45e6f9e899c207d}(
		$cloudId: ID!, $bookmarkAdminhubId: ID!, $keyPhrases: [String!], $url: String!, $title: String!, $description: String, $orgId: String!
	) {
		knowledgeDiscovery {
			updateBookmark(
				input: {cloudId: $cloudId, bookmarkAdminhubId: $bookmarkAdminhubId, keyPhrases: $keyPhrases, url: $url, title: $title, description: $description, orgId: $orgId}
			) @optIn(to: "KnowledgeDiscovery Update bookmarks in AdminHub") {
				... on KnowledgeDiscoveryUpdateAdminhubBookmarkPayload {
					success
					errors {
						message
						extensions {
								... on KnowledgeDiscoveryBookmarkMutationErrorExtension {
								bookmarkFailureMetadata {
									errorType
									... on KnowledgeDiscoveryBookmarkCollisionFailureMetadata {
									keyPhrase
									}
									... on KnowledgeDiscoveryBookmarkValidationFailureMetadata {
									keyPhrase
									}
								}
							}
						}
					}
					adminhubBookmark {
						id
						properties {
							title
							description
							keyPhrases
							url
						}
        	}
				}
			}
		}
	}
`;
module.exports["UPDATE_BOOKMARK_OPERATION_NAME"] = $098cea0b1e42c41d$export$c45e6f9e899c207d;
module.exports["UpdateBookmarkMutation"] = $098cea0b1e42c41d$export$a3374c2b287ba43a;

});


//# sourceMappingURL=SearchPage.befa5879.js.map
